import { pushScopeId as Q8, popScopeId as K8, defineComponent as wc, nextTick as J8, openBlock as zo, createBlock as Ih, createElementBlock as yd, normalizeClass as Fh, renderSlot as Bv, normalizeProps as Z8, guardReactiveProps as e9, withScopeId as t9, resolveComponent as Hh, normalizeStyle as Dk, withKeys as n9, createElementVNode as go, Fragment as r9, createCommentVNode as b$, withCtx as Vh, createVNode as f4, ref as om, createApp as a9, h as i9, mergeProps as m4, toDisplayString as o9, computed as w$, unref as vd, useSlots as s9, onMounted as l9, watch as u9 } from "vue";
function c9(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const s in r)
        if (s !== "default" && !(s in e)) {
          const f = Object.getOwnPropertyDescriptor(r, s);
          f && Object.defineProperty(e, s, f.get ? f : {
            enumerable: !0,
            get: () => r[s]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function Pc(e) {
  return e.split("-")[0];
}
function Wh(e) {
  return e.split("-")[1];
}
function ig(e) {
  return ["top", "bottom"].includes(Pc(e)) ? "x" : "y";
}
function pS(e) {
  return e === "y" ? "height" : "width";
}
function nE(e) {
  let {
    reference: t,
    floating: n,
    placement: r
  } = e;
  const s = t.x + t.width / 2 - n.width / 2, f = t.y + t.height / 2 - n.height / 2;
  let m;
  switch (Pc(r)) {
    case "top":
      m = {
        x: s,
        y: t.y - n.height
      };
      break;
    case "bottom":
      m = {
        x: s,
        y: t.y + t.height
      };
      break;
    case "right":
      m = {
        x: t.x + t.width,
        y: f
      };
      break;
    case "left":
      m = {
        x: t.x - n.width,
        y: f
      };
      break;
    default:
      m = {
        x: t.x,
        y: t.y
      };
  }
  const p = ig(r), v = pS(p);
  switch (Wh(r)) {
    case "start":
      m[p] = m[p] - (t[v] / 2 - n[v] / 2);
      break;
    case "end":
      m[p] = m[p] + (t[v] / 2 - n[v] / 2);
      break;
  }
  return m;
}
const d9 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: s = "absolute",
    middleware: f = [],
    platform: m
  } = n;
  if (process.env.NODE_ENV !== "production" && (m == null && console.error(["Floating UI: `platform` property was not passed to config. If you", "want to use Floating UI on the web, install @floating-ui/dom", "instead of the /core package. Otherwise, you can create your own", "`platform`: https://floating-ui.com/docs/platform"].join(" ")), f.filter((A) => {
    let {
      name: M
    } = A;
    return M === "autoPlacement" || M === "flip";
  }).length > 1))
    throw new Error(["Floating UI: duplicate `flip` and/or `autoPlacement`", "middleware detected. This will lead to an infinite loop. Ensure only", "one of either has been passed to the `middleware` array."].join(" "));
  let p = await m.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: v,
    y
  } = nE({
    ...p,
    placement: r
  }), w = r, P = {}, x = 0;
  for (let A = 0; A < f.length; A++) {
    if (process.env.NODE_ENV !== "production" && (x++, x > 100))
      throw new Error(["Floating UI: The middleware lifecycle appears to be", "running in an infinite loop. This is usually caused by a `reset`", "continually being returned without a break condition."].join(" "));
    const {
      name: M,
      fn: O
    } = f[A], {
      x: j,
      y: H,
      data: J,
      reset: V
    } = await O({
      x: v,
      y,
      initialPlacement: r,
      placement: w,
      strategy: s,
      middlewareData: P,
      rects: p,
      platform: m,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (v = j ?? v, y = H ?? y, P = {
      ...P,
      [M]: J ?? {}
    }, V) {
      typeof V == "object" && (V.placement && (w = V.placement), V.rects && (p = V.rects === !0 ? await m.getElementRects({
        reference: e,
        floating: t,
        strategy: s
      }) : V.rects), {
        x: v,
        y
      } = nE({
        ...p,
        placement: w
      })), A = -1;
      continue;
    }
  }
  return {
    x: v,
    y,
    placement: w,
    strategy: s,
    middlewareData: P
  };
};
function f9(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function h4(e) {
  return typeof e != "number" ? f9(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function P$(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
async function yw(e, t) {
  t === void 0 && (t = {});
  const {
    x: n,
    y: r,
    platform: s,
    rects: f,
    elements: m,
    strategy: p
  } = e, {
    boundary: v = "clippingParents",
    rootBoundary: y = "viewport",
    elementContext: w = "floating",
    altBoundary: P = !1,
    padding: x = 0
  } = t, A = h4(x), O = m[P ? w === "floating" ? "reference" : "floating" : w], j = await s.getClippingClientRect({
    element: await s.isElement(O) ? O : O.contextElement || await s.getDocumentElement({
      element: m.floating
    }),
    boundary: v,
    rootBoundary: y
  }), H = P$(await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: w === "floating" ? {
      ...f.floating,
      x: n,
      y: r
    } : f.reference,
    offsetParent: await s.getOffsetParent({
      element: m.floating
    }),
    strategy: p
  }));
  return {
    top: j.top - H.top + A.top,
    bottom: H.bottom - j.bottom + A.bottom,
    left: j.left - H.left + A.left,
    right: H.right - j.right + A.right
  };
}
const m9 = Math.min, Zf = Math.max;
function k$(e, t, n) {
  return Zf(e, m9(t, n));
}
const h9 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      element: n,
      padding: r = 0
    } = e ?? {}, {
      x: s,
      y: f,
      placement: m,
      rects: p,
      platform: v
    } = t;
    if (n == null)
      return process.env.NODE_ENV !== "production" && console.warn("Floating UI: No `element` was passed to the `arrow` middleware."), {};
    const y = h4(r), w = {
      x: s,
      y: f
    }, P = Pc(m), x = ig(P), A = pS(x), M = await v.getDimensions({
      element: n
    }), O = x === "y" ? "top" : "left", j = x === "y" ? "bottom" : "right", H = p.reference[A] + p.reference[x] - w[x] - p.floating[A], J = w[x] - p.reference[x], V = await v.getOffsetParent({
      element: n
    }), X = V ? x === "y" ? V.clientHeight || 0 : V.clientWidth || 0 : 0, U = H / 2 - J / 2, K = y[O], ce = X - M[A] - y[j], ue = X / 2 - M[A] / 2 + U, ye = k$(K, ue, ce);
    return {
      data: {
        [x]: ye,
        centerOffset: ue - ye
      }
    };
  }
}), p9 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function r1(e) {
  return e.replace(/left|right|bottom|top/g, (t) => p9[t]);
}
function p4(e, t) {
  const n = Wh(e) === "start", r = ig(e), s = pS(r);
  let f = r === "x" ? n ? "right" : "left" : n ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (f = r1(f)), {
    main: f,
    cross: r1(f)
  };
}
const v9 = {
  start: "end",
  end: "start"
};
function $$(e) {
  return e.replace(/start|end/g, (t) => v9[t]);
}
const g9 = ["top", "right", "bottom", "left"], y9 = /* @__PURE__ */ g9.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
function b9(e, t, n) {
  return (e ? [...n.filter((s) => Wh(s) === e), ...n.filter((s) => Wh(s) !== e)] : n.filter((s) => Pc(s) === s)).filter((s) => e ? Wh(s) === e || (t ? $$(s) !== s : !1) : !0);
}
const w9 = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var n, r, s, f, m, p;
      const {
        x: v,
        y,
        rects: w,
        middlewareData: P,
        placement: x
      } = t, {
        alignment: A = null,
        allowedPlacements: M = y9,
        autoAlignment: O = !0,
        ...j
      } = e;
      if ((n = P.autoPlacement) != null && n.skip)
        return {};
      const H = b9(A, O, M), J = await yw(t, j), V = (r = (s = P.autoPlacement) == null ? void 0 : s.index) != null ? r : 0, X = H[V], {
        main: U,
        cross: K
      } = p4(X, w);
      if (x !== X)
        return {
          x: v,
          y,
          reset: {
            placement: H[0]
          }
        };
      const ce = [J[Pc(X)], J[U], J[K]], ue = [...(f = (m = P.autoPlacement) == null ? void 0 : m.overflows) != null ? f : [], {
        placement: X,
        overflows: ce
      }], ye = H[V + 1];
      if (ye)
        return {
          data: {
            index: V + 1,
            overflows: ue
          },
          reset: {
            placement: ye
          }
        };
      const Oe = ue.slice().sort((Le, Ne) => Le.overflows[0] - Ne.overflows[0]), _e = (p = Oe.find((Le) => {
        let {
          overflows: Ne
        } = Le;
        return Ne.every((nt) => nt <= 0);
      })) == null ? void 0 : p.placement;
      return {
        data: {
          skip: !0
        },
        reset: {
          placement: _e ?? Oe[0].placement
        }
      };
    }
  };
};
function P9(e) {
  const t = r1(e);
  return [$$(e), t, $$(t)];
}
const k9 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: s,
        middlewareData: f,
        rects: m,
        initialPlacement: p
      } = t;
      if ((n = f.flip) != null && n.skip)
        return {};
      const {
        mainAxis: v = !0,
        crossAxis: y = !0,
        fallbackPlacements: w,
        fallbackStrategy: P = "bestFit",
        flipAlignment: x = !0,
        ...A
      } = e, M = Pc(s), j = w || (M === p || !x ? [r1(p)] : P9(p)), H = [p, ...j], J = await yw(t, A), V = [];
      let X = ((r = f.flip) == null ? void 0 : r.overflows) || [];
      if (v && V.push(J[M]), y) {
        const {
          main: ue,
          cross: ye
        } = p4(s, m);
        V.push(J[ue], J[ye]);
      }
      if (X = [...X, {
        placement: s,
        overflows: V
      }], !V.every((ue) => ue <= 0)) {
        var U, K;
        const ue = ((U = (K = f.flip) == null ? void 0 : K.index) != null ? U : 0) + 1, ye = H[ue];
        if (ye)
          return {
            data: {
              index: ue,
              overflows: X
            },
            reset: {
              placement: ye
            }
          };
        let Oe = "bottom";
        switch (P) {
          case "bestFit": {
            var ce;
            const _e = (ce = X.slice().sort((Le, Ne) => Le.overflows.filter((nt) => nt > 0).reduce((nt, Qe) => nt + Qe, 0) - Ne.overflows.filter((nt) => nt > 0).reduce((nt, Qe) => nt + Qe, 0))[0]) == null ? void 0 : ce.placement;
            _e && (Oe = _e);
            break;
          }
          case "initialPlacement":
            Oe = p;
            break;
        }
        return {
          data: {
            skip: !0
          },
          reset: {
            placement: Oe
          }
        };
      }
      return {};
    }
  };
};
function $9(e) {
  let {
    placement: t,
    rects: n,
    value: r
  } = e;
  const s = Pc(t), f = ["left", "top"].includes(s) ? -1 : 1, m = typeof r == "function" ? r({
    ...n,
    placement: t
  }) : r, {
    mainAxis: p,
    crossAxis: v
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0
  } : {
    mainAxis: 0,
    crossAxis: 0,
    ...m
  };
  return ig(s) === "x" ? {
    x: v,
    y: p * f
  } : {
    x: p * f,
    y: v
  };
}
const S9 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: s,
        rects: f
      } = t, m = $9({
        placement: s,
        rects: f,
        value: e
      });
      return {
        x: n + m.x,
        y: r + m.y,
        data: m
      };
    }
  };
};
function x9(e) {
  return e === "x" ? "y" : "x";
}
const C9 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: s
      } = t, {
        mainAxis: f = !0,
        crossAxis: m = !1,
        limiter: p = {
          fn: (j) => {
            let {
              x: H,
              y: J
            } = j;
            return {
              x: H,
              y: J
            };
          }
        },
        ...v
      } = e, y = {
        x: n,
        y: r
      }, w = await yw(t, v), P = ig(Pc(s)), x = x9(P);
      let A = y[P], M = y[x];
      if (f) {
        const j = P === "y" ? "top" : "left", H = P === "y" ? "bottom" : "right", J = A + w[j], V = A - w[H];
        A = k$(J, A, V);
      }
      if (m) {
        const j = x === "y" ? "top" : "left", H = x === "y" ? "bottom" : "right", J = M + w[j], V = M - w[H];
        M = k$(J, M, V);
      }
      const O = p.fn({
        ...t,
        [P]: A,
        [x]: M
      });
      return {
        ...O,
        data: {
          x: O.x - n,
          y: O.y - r
        }
      };
    }
  };
}, M9 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        rects: s,
        middlewareData: f
      } = t, {
        apply: m,
        ...p
      } = e;
      if ((n = f.size) != null && n.skip)
        return {};
      const v = await yw(t, p), y = Pc(r), w = Wh(r) === "end";
      let P, x;
      y === "top" || y === "bottom" ? (P = y, x = w ? "left" : "right") : (x = y, P = w ? "top" : "bottom");
      const A = Zf(v.left, 0), M = Zf(v.right, 0), O = Zf(v.top, 0), j = Zf(v.bottom, 0), H = {
        height: s.floating.height - (["left", "right"].includes(r) ? 2 * (O !== 0 || j !== 0 ? O + j : Zf(v.top, v.bottom)) : v[P]),
        width: s.floating.width - (["top", "bottom"].includes(r) ? 2 * (A !== 0 || M !== 0 ? A + M : Zf(v.left, v.right)) : v[x])
      };
      return m == null || m({
        ...H,
        ...s
      }), {
        data: {
          skip: !0
        },
        reset: {
          rects: !0
        }
      };
    }
  };
};
function vS(e) {
  return (e == null ? void 0 : e.toString()) === "[object Window]";
}
function xd(e) {
  if (e == null)
    return window;
  if (!vS(e)) {
    const t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function bw(e) {
  return xd(e).getComputedStyle(e);
}
function vc(e) {
  return vS(e) ? "" : e ? (e.nodeName || "").toLowerCase() : "";
}
function gc(e) {
  return e instanceof xd(e).HTMLElement;
}
function a1(e) {
  return e instanceof xd(e).Element;
}
function E9(e) {
  return e instanceof xd(e).Node;
}
function v4(e) {
  const t = xd(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function ww(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r
  } = bw(e);
  return /auto|scroll|overlay|hidden/.test(t + r + n);
}
function A9(e) {
  return ["table", "td", "th"].includes(vc(e));
}
function g4(e) {
  const t = navigator.userAgent.toLowerCase().includes("firefox"), n = bw(e);
  return n.transform !== "none" || n.perspective !== "none" || n.contain === "paint" || ["transform", "perspective"].includes(n.willChange) || t && n.willChange === "filter" || t && (n.filter ? n.filter !== "none" : !1);
}
const rE = Math.min, Nv = Math.max, i1 = Math.round;
function Bh(e, t) {
  t === void 0 && (t = !1);
  const n = e.getBoundingClientRect();
  let r = 1, s = 1;
  return t && gc(e) && (r = e.offsetWidth > 0 && i1(n.width) / e.offsetWidth || 1, s = e.offsetHeight > 0 && i1(n.height) / e.offsetHeight || 1), {
    width: n.width / r,
    height: n.height / s,
    top: n.top / s,
    right: n.right / r,
    bottom: n.bottom / s,
    left: n.left / r,
    x: n.left / r,
    y: n.top / s
  };
}
function Cd(e) {
  return ((E9(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Pw(e) {
  return vS(e) ? {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  } : {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function y4(e) {
  return Bh(Cd(e)).left + Pw(e).scrollLeft;
}
function _9(e) {
  const t = Bh(e);
  return i1(t.width) !== e.offsetWidth || i1(t.height) !== e.offsetHeight;
}
function O9(e, t, n) {
  const r = gc(t), s = Cd(t), f = Bh(e, r && _9(t));
  let m = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const p = {
    x: 0,
    y: 0
  };
  if (r || !r && n !== "fixed")
    if ((vc(t) !== "body" || ww(s)) && (m = Pw(t)), gc(t)) {
      const v = Bh(t, !0);
      p.x = v.x + t.clientLeft, p.y = v.y + t.clientTop;
    } else
      s && (p.x = y4(s));
  return {
    x: f.left + m.scrollLeft - p.x,
    y: f.top + m.scrollTop - p.y,
    width: f.width,
    height: f.height
  };
}
function kw(e) {
  return vc(e) === "html" ? e : e.assignedSlot || e.parentNode || (v4(e) ? e.host : null) || Cd(e);
}
function aE(e) {
  return !gc(e) || getComputedStyle(e).position === "fixed" ? null : e.offsetParent;
}
function T9(e) {
  let t = kw(e);
  for (; gc(t) && !["html", "body"].includes(vc(t)); ) {
    if (g4(t))
      return t;
    t = t.parentNode;
  }
  return null;
}
function S$(e) {
  const t = xd(e);
  let n = aE(e);
  for (; n && A9(n) && getComputedStyle(n).position === "static"; )
    n = aE(n);
  return n && (vc(n) === "html" || vc(n) === "body" && getComputedStyle(n).position === "static" && !g4(n)) ? t : n || T9(e) || t;
}
function iE(e) {
  return {
    width: e.offsetWidth,
    height: e.offsetHeight
  };
}
function R9(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const s = gc(n), f = Cd(n);
  if (n === f)
    return t;
  let m = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const p = {
    x: 0,
    y: 0
  };
  if ((s || !s && r !== "fixed") && ((vc(n) !== "body" || ww(f)) && (m = Pw(n)), gc(n))) {
    const v = Bh(n, !0);
    p.x = v.x + n.clientLeft, p.y = v.y + n.clientTop;
  }
  return {
    ...t,
    x: t.x - m.scrollLeft + p.x,
    y: t.y - m.scrollTop + p.y
  };
}
function D9(e) {
  const t = xd(e), n = Cd(e), r = t.visualViewport;
  let s = n.clientWidth, f = n.clientHeight, m = 0, p = 0;
  return r && (s = r.width, f = r.height, Math.abs(t.innerWidth / r.scale - r.width) < 0.01 && (m = r.offsetLeft, p = r.offsetTop)), {
    width: s,
    height: f,
    x: m,
    y: p
  };
}
function N9(e) {
  var t;
  const n = Cd(e), r = Pw(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, f = Nv(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), m = Nv(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0);
  let p = -r.scrollLeft + y4(e);
  const v = -r.scrollTop;
  return bw(s || n).direction === "rtl" && (p += Nv(n.clientWidth, s ? s.clientWidth : 0) - f), {
    width: f,
    height: m,
    x: p,
    y: v
  };
}
function b4(e) {
  return ["html", "body", "#document"].includes(vc(e)) ? e.ownerDocument.body : gc(e) && ww(e) ? e : b4(kw(e));
}
function o1(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = b4(e), s = r === ((n = e.ownerDocument) == null ? void 0 : n.body), f = xd(r), m = s ? [f].concat(f.visualViewport || [], ww(r) ? r : []) : r, p = t.concat(m);
  return s ? p : p.concat(o1(kw(m)));
}
function W9(e, t) {
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && v4(n)) {
    let r = t;
    do {
      if (r && e === r)
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function j9(e) {
  const t = Bh(e), n = t.top + e.clientTop, r = t.left + e.clientLeft;
  return {
    top: n,
    left: r,
    x: r,
    y: n,
    right: r + e.clientWidth,
    bottom: n + e.clientHeight,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function oE(e, t) {
  return t === "viewport" ? P$(D9(e)) : a1(t) ? j9(t) : P$(N9(Cd(e)));
}
function z9(e) {
  const t = o1(kw(e)), r = ["absolute", "fixed"].includes(bw(e).position) && gc(e) ? S$(e) : e;
  return a1(r) ? t.filter((s) => a1(s) && W9(s, r) && vc(s) !== "body") : [];
}
function L9(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r
  } = e;
  const f = [...n === "clippingParents" ? z9(t) : [].concat(n), r], m = f[0], p = f.reduce((v, y) => {
    const w = oE(t, y);
    return v.top = Nv(w.top, v.top), v.right = rE(w.right, v.right), v.bottom = rE(w.bottom, v.bottom), v.left = Nv(w.left, v.left), v;
  }, oE(t, m));
  return p.width = p.right - p.left, p.height = p.bottom - p.top, p.x = p.left, p.y = p.top, p;
}
const I9 = {
  getElementRects: (e) => {
    let {
      reference: t,
      floating: n,
      strategy: r
    } = e;
    return {
      reference: O9(t, S$(n), r),
      floating: {
        ...iE(n),
        x: 0,
        y: 0
      }
    };
  },
  convertOffsetParentRelativeRectToViewportRelativeRect: (e) => R9(e),
  getOffsetParent: (e) => {
    let {
      element: t
    } = e;
    return S$(t);
  },
  isElement: (e) => a1(e),
  getDocumentElement: (e) => {
    let {
      element: t
    } = e;
    return Cd(t);
  },
  getClippingClientRect: (e) => L9(e),
  getDimensions: (e) => {
    let {
      element: t
    } = e;
    return iE(t);
  },
  getClientRects: (e) => {
    let {
      element: t
    } = e;
    return t.getClientRects();
  }
}, F9 = (e, t, n) => d9(e, t, {
  platform: I9,
  ...n
});
var H9 = Object.defineProperty, V9 = Object.defineProperties, B9 = Object.getOwnPropertyDescriptors, sE = Object.getOwnPropertySymbols, U9 = Object.prototype.hasOwnProperty, X9 = Object.prototype.propertyIsEnumerable, lE = (e, t, n) => t in e ? H9(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, cc = (e, t) => {
  for (var n in t || (t = {}))
    U9.call(t, n) && lE(e, n, t[n]);
  if (sE)
    for (var n of sE(t))
      X9.call(t, n) && lE(e, n, t[n]);
  return e;
}, og = (e, t) => V9(e, B9(t));
function w4(e, t) {
  for (const n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (typeof t[n] == "object" && e[n] ? w4(e[n], t[n]) : e[n] = t[n]);
}
const mc = {
  disabled: !1,
  distance: 5,
  skidding: 0,
  container: "body",
  boundary: void 0,
  instantMove: !1,
  disposeTimeout: 5e3,
  popperTriggers: [],
  strategy: "absolute",
  preventOverflow: !0,
  flip: !0,
  shift: !0,
  overflowPadding: 0,
  arrowPadding: 0,
  arrowOverflow: !0,
  themes: {
    tooltip: {
      placement: "top",
      triggers: ["hover", "focus", "touch"],
      hideTriggers: (e) => [...e, "click"],
      delay: {
        show: 200,
        hide: 0
      },
      handleResize: !1,
      html: !1,
      loadingContent: "..."
    },
    dropdown: {
      placement: "bottom",
      triggers: ["click"],
      delay: 0,
      handleResize: !0,
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover", "focus"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function Uh(e, t) {
  let n = mc.themes[e] || {}, r;
  do
    r = n[t], typeof r > "u" ? n.$extend ? n = mc.themes[n.$extend] || {} : (n = null, r = mc[t]) : n = null;
  while (n);
  return r;
}
function q9(e) {
  const t = [e];
  let n = mc.themes[e] || {};
  do
    n.$extend && !n.$resetCss ? (t.push(n.$extend), n = mc.themes[n.$extend] || {}) : n = null;
  while (n);
  return t.map((r) => `v-popper--theme-${r}`);
}
function uE(e) {
  const t = [e];
  let n = mc.themes[e] || {};
  do
    n.$extend ? (t.push(n.$extend), n = mc.themes[n.$extend] || {}) : n = null;
  while (n);
  return t;
}
let lm = !1;
if (typeof window < "u") {
  lm = !1;
  try {
    const e = Object.defineProperty({}, "passive", {
      get() {
        lm = !0;
      }
    });
    window.addEventListener("test", null, e);
  } catch {
  }
}
let P4 = !1;
typeof window < "u" && typeof navigator < "u" && (P4 = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const k4 = ["auto", "top", "bottom", "left", "right"].reduce((e, t) => e.concat([
  t,
  `${t}-start`,
  `${t}-end`
]), []), cE = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart"
}, dE = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend"
};
function fE(e, t) {
  const n = e.indexOf(t);
  n !== -1 && e.splice(n, 1);
}
function Nk() {
  return new Promise((e) => requestAnimationFrame(() => {
    requestAnimationFrame(e);
  }));
}
const wl = [];
let Gf = null;
const mE = {};
function hE(e) {
  let t = mE[e];
  return t || (t = mE[e] = []), t;
}
let x$ = function() {
};
typeof window < "u" && (x$ = window.Element);
function Ln(e) {
  return function(t) {
    return Uh(t.theme, e);
  };
}
const Wk = "__floating-vue__popper";
var $4 = () => wc({
  name: "VPopper",
  provide() {
    return {
      [Wk]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [Wk]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: Ln("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: Ln("positioningDisabled")
    },
    placement: {
      type: String,
      default: Ln("placement"),
      validator: (e) => k4.includes(e)
    },
    delay: {
      type: [String, Number, Object],
      default: Ln("delay")
    },
    distance: {
      type: [Number, String],
      default: Ln("distance")
    },
    skidding: {
      type: [Number, String],
      default: Ln("skidding")
    },
    triggers: {
      type: Array,
      default: Ln("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: Ln("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: Ln("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: Ln("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: Ln("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: Ln("popperHideTriggers")
    },
    container: {
      type: [String, Object, x$, Boolean],
      default: Ln("container")
    },
    boundary: {
      type: [String, x$],
      default: Ln("boundary")
    },
    strategy: {
      type: String,
      validator: (e) => ["absolute", "fixed"].includes(e),
      default: Ln("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: Ln("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: Ln("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: Ln("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: Ln("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: Ln("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: Ln("computeTransformOrigin")
    },
    autoMinSize: {
      type: Boolean,
      default: Ln("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: Ln("autoSize")
    },
    autoMaxSize: {
      type: Boolean,
      default: Ln("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: Ln("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: Ln("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: Ln("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: Ln("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: Ln("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: Ln("flip")
    },
    shift: {
      type: Boolean,
      default: Ln("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: Ln("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: Ln("noAutoFocus")
    }
  },
  emits: [
    "show",
    "hide",
    "update:shown",
    "apply-show",
    "apply-hide",
    "close-group",
    "close-directive",
    "auto-hide",
    "resize",
    "dispose"
  ],
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: og(cc({}, this.classes), {
          popperClass: this.popperClass
        }),
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var e;
      return (e = this[Wk]) == null ? void 0 : e.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var e, t;
      return ((e = this.popperTriggers) == null ? void 0 : e.includes("hover")) || ((t = this.popperShowTriggers) == null ? void 0 : t.includes("hover"));
    }
  },
  watch: cc(cc({
    shown: "$_autoShowHide",
    disabled(e) {
      e ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    }
  }, [
    "triggers",
    "positioningDisabled"
  ].reduce((e, t) => (e[t] = "$_refreshListeners", e), {})), [
    "placement",
    "distance",
    "skidding",
    "boundary",
    "strategy",
    "overflowPadding",
    "arrowPadding",
    "preventOverflow",
    "shift",
    "shiftCrossAxis",
    "flip"
  ].reduce((e, t) => (e[t] = "$_computePosition", e), {})),
  created() {
    this.$_isDisposed = !0, this.randomId = `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join("_")}`, this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: e = null, skipDelay: t = !1, force: n = !1 } = {}) {
      var r, s;
      (r = this.parentPopper) != null && r.lockedChild && this.parentPopper.lockedChild !== this || (this.$_pendingHide = !1, (n || !this.disabled) && (((s = this.parentPopper) == null ? void 0 : s.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(e, t), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: e = null, skipDelay: t = !1 } = {}) {
      var n;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.$_pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: t }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((n = this.parentPopper) == null ? void 0 : n.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_pendingHide = !1, this.$_scheduleHide(e, t), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var e, t;
      this.$_isDisposed && (this.$_isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = (t = (e = this.referenceNode) == null ? void 0 : e.call(this)) != null ? t : this.$el, this.$_targetNodes = this.targetNodes().filter((n) => n.nodeType === n.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.$_isDisposed || (this.$_isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"), this.$emit("dispose"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      var e;
      if (this.$_isDisposed || this.positioningDisabled)
        return;
      const t = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && t.middleware.push(S9({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const n = this.placement.startsWith("auto");
      if (n ? t.middleware.push(w9({
        alignment: (e = this.placement.split("-")[1]) != null ? e : ""
      })) : t.placement = this.placement, this.preventOverflow && (this.shift && t.middleware.push(C9({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !n && this.flip && t.middleware.push(k9({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), t.middleware.push(h9({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && t.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: s, rects: f, middlewareData: m }) => {
          let p;
          const { centerOffset: v } = m.arrow;
          return s.startsWith("top") || s.startsWith("bottom") ? p = Math.abs(v) > f.reference.width / 2 : p = Math.abs(v) > f.reference.height / 2, {
            data: {
              overflow: p
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const s = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        t.middleware.push({
          name: "autoSize",
          fn: ({ rects: f, placement: m, middlewareData: p }) => {
            var v;
            if ((v = p.autoSize) != null && v.skip)
              return {};
            let y, w;
            return m.startsWith("top") || m.startsWith("bottom") ? y = f.reference.width : w = f.reference.height, this.$_innerNode.style[s === "min" ? "minWidth" : s === "max" ? "maxWidth" : "width"] = y != null ? `${y}px` : null, this.$_innerNode.style[s === "min" ? "minHeight" : s === "max" ? "maxHeight" : "height"] = w != null ? `${w}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, t.middleware.push(M9({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ width: s, height: f }) => {
          this.$_innerNode.style.maxWidth = s != null ? `${s}px` : null, this.$_innerNode.style.maxHeight = f != null ? `${f}px` : null;
        }
      })));
      const r = await F9(this.$_referenceNode, this.$_popperNode, t);
      Object.assign(this.result, {
        x: r.x,
        y: r.y,
        placement: r.placement,
        strategy: r.strategy,
        arrow: cc(cc({}, r.middlewareData.arrow), r.middlewareData.arrowOverflow)
      });
    },
    $_scheduleShow(e = null, t = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), Gf && this.instantMove && Gf.instantMove && Gf !== this.parentPopper) {
        Gf.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      t ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(e = null, t = !1) {
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (Gf = this), t ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(e) {
      const t = this.delay;
      return parseInt(t && t[e] || t || 0);
    },
    async $_applyShow(e = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = e, !this.isShown && (this.$_ensureTeleport(), await Nk(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...o1(this.$_referenceNode),
        ...o1(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const t = this.$_referenceNode.getBoundingClientRect(), n = this.$_popperNode.querySelector(".v-popper__wrapper"), r = n.parentNode.getBoundingClientRect(), s = t.x + t.width / 2 - (r.left + n.offsetLeft), f = t.y + t.height / 2 - (r.top + n.offsetTop);
        this.result.transformOrigin = `${s}px ${f}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const e = this.showGroup;
      if (e) {
        let t;
        for (let n = 0; n < wl.length; n++)
          t = wl[n], t.showGroup !== e && (t.hide(), t.$emit("close-group"));
      }
      wl.push(this), document.body.classList.add("v-popper--some-open");
      for (const t of uE(this.theme))
        hE(t).push(this), document.body.classList.add(`v-popper--some-open--${t}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await Nk(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(e = !1) {
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = e, fE(wl, this), wl.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const n of uE(this.theme)) {
        const r = hE(n);
        fE(r, this), r.length === 0 && document.body.classList.remove(`v-popper--some-open--${n}`);
      }
      Gf === this && (Gf = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const t = Uh(this.theme, "disposeTimeout");
      t !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, t)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await Nk(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.$_isDisposed)
        return;
      let e = this.container;
      if (typeof e == "string" ? e = window.document.querySelector(e) : e === !1 && (e = this.$_targetNodes[0].parentNode), !e)
        throw new Error("No container for popover: " + this.container);
      e.contains(this.$_popperNode) || e.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const e = (n) => {
        this.isShown && !this.$_hideInProgress || (n.usedByTooltip = !0, !this.$_preventShow && this.show({ event: n }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, cE, this.triggers, this.showTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], cE, this.popperTriggers, this.popperShowTriggers, e);
      const t = (n) => {
        n.usedByTooltip || this.hide({ event: n });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, dE, this.triggers, this.hideTriggers, t), this.$_registerTriggerListeners([this.$_popperNode], dE, this.popperTriggers, this.popperHideTriggers, t);
    },
    $_registerEventListeners(e, t, n) {
      this.$_events.push({ targetNodes: e, eventType: t, handler: n }), e.forEach((r) => r.addEventListener(t, n, lm ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(e, t, n, r, s) {
      let f = n;
      r != null && (f = typeof r == "function" ? r(f) : r), f.forEach((m) => {
        const p = t[m];
        p && this.$_registerEventListeners(e, p, s);
      });
    },
    $_removeEventListeners(e) {
      const t = [];
      this.$_events.forEach((n) => {
        const { targetNodes: r, eventType: s, handler: f } = n;
        !e || e === s ? r.forEach((m) => m.removeEventListener(s, f)) : t.push(n);
      }), this.$_events = t;
    },
    $_refreshListeners() {
      this.$_isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(e, t = !1) {
      this.$_showFrameLocked || (this.hide({ event: e }), e.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), t && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(e, t) {
      for (const n of this.$_targetNodes) {
        const r = n.getAttribute(e);
        r && (n.removeAttribute(e), n.setAttribute(t, r));
      }
    },
    $_applyAttrsToTarget(e) {
      for (const t of this.$_targetNodes)
        for (const n in e) {
          const r = e[n];
          r == null ? t.removeAttribute(n) : t.setAttribute(n, r);
        }
    },
    $_updateParentShownChildren(e) {
      let t = this.parentPopper;
      for (; t; )
        e ? t.shownChildren.add(this.randomId) : (t.shownChildren.delete(this.randomId), t.$_pendingHide && t.hide()), t = t.parentPopper;
    },
    $_isAimingPopper() {
      const e = this.$_referenceNode.getBoundingClientRect();
      if (Wv >= e.left && Wv <= e.right && jv >= e.top && jv <= e.bottom) {
        const t = this.$_popperNode.getBoundingClientRect(), n = Wv - ud, r = jv - cd, f = t.left + t.width / 2 - ud + (t.top + t.height / 2) - cd + t.width + t.height, m = ud + n * f, p = cd + r * f;
        return yb(ud, cd, m, p, t.left, t.top, t.left, t.bottom) || yb(ud, cd, m, p, t.left, t.top, t.right, t.top) || yb(ud, cd, m, p, t.right, t.top, t.right, t.bottom) || yb(ud, cd, m, p, t.left, t.bottom, t.right, t.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
typeof document < "u" && typeof window < "u" && (P4 ? (document.addEventListener("touchstart", pE, lm ? {
  passive: !0,
  capture: !0
} : !0), document.addEventListener("touchend", G9, lm ? {
  passive: !0,
  capture: !0
} : !0)) : (window.addEventListener("mousedown", pE, !0), window.addEventListener("click", Y9, !0)), window.addEventListener("resize", J9));
function pE(e) {
  for (let t = 0; t < wl.length; t++) {
    const n = wl[t];
    try {
      const r = n.popperNode();
      n.$_mouseDownContains = r.contains(e.target);
    } catch {
    }
  }
}
function Y9(e) {
  S4(e);
}
function G9(e) {
  S4(e, !0);
}
function S4(e, t = !1) {
  const n = {};
  for (let r = wl.length - 1; r >= 0; r--) {
    const s = wl[r];
    try {
      const f = s.$_containsGlobalTarget = Q9(s, e);
      s.$_pendingHide = !1, requestAnimationFrame(() => {
        if (s.$_pendingHide = !1, !n[s.randomId] && vE(s, f, e)) {
          if (s.$_handleGlobalClose(e, t), !e.closeAllPopover && e.closePopover && f) {
            let p = s.parentPopper;
            for (; p; )
              n[p.randomId] = !0, p = p.parentPopper;
            return;
          }
          let m = s.parentPopper;
          for (; m && vE(m, m.$_containsGlobalTarget, e); ) {
            m.$_handleGlobalClose(e, t);
            m = m.parentPopper;
          }
        }
      });
    } catch {
    }
  }
}
function Q9(e, t) {
  const n = e.popperNode();
  return e.$_mouseDownContains || n.contains(t.target);
}
function vE(e, t, n) {
  return n.closeAllPopover || n.closePopover && t || K9(e, n) && !t;
}
function K9(e, t) {
  if (typeof e.autoHide == "function") {
    const n = e.autoHide(t);
    return e.lastAutoHide = n, n;
  }
  return e.autoHide;
}
function J9(e) {
  for (let t = 0; t < wl.length; t++)
    wl[t].$_computePosition(e);
}
let ud = 0, cd = 0, Wv = 0, jv = 0;
typeof window < "u" && window.addEventListener("mousemove", (e) => {
  ud = Wv, cd = jv, Wv = e.clientX, jv = e.clientY;
}, lm ? {
  passive: !0
} : void 0);
function yb(e, t, n, r, s, f, m, p) {
  const v = ((m - s) * (t - f) - (p - f) * (e - s)) / ((p - f) * (n - e) - (m - s) * (r - t)), y = ((n - e) * (t - f) - (r - t) * (e - s)) / ((p - f) * (n - e) - (m - s) * (r - t));
  return v >= 0 && v <= 1 && y >= 0 && y <= 1;
}
var $w = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, s] of t)
    n[r] = s;
  return n;
};
const Z9 = {
  extends: $4()
};
function eL(e, t, n, r, s, f) {
  return zo(), yd("div", {
    ref: "reference",
    class: Fh(["v-popper", {
      "v-popper--shown": e.slotData.isShown
    }])
  }, [
    Bv(e.$slots, "default", Z8(e9(e.slotData)))
  ], 2);
}
var tL = /* @__PURE__ */ $w(Z9, [["render", eL]]);
function nL() {
  var e = window.navigator.userAgent, t = e.indexOf("MSIE ");
  if (t > 0)
    return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
  var n = e.indexOf("Trident/");
  if (n > 0) {
    var r = e.indexOf("rv:");
    return parseInt(e.substring(r + 3, e.indexOf(".", r)), 10);
  }
  var s = e.indexOf("Edge/");
  return s > 0 ? parseInt(e.substring(s + 5, e.indexOf(".", s)), 10) : -1;
}
let Fb;
function C$() {
  C$.init || (C$.init = !0, Fb = nL() !== -1);
}
var Sw = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    C$(), J8(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", Fb && this.$el.appendChild(e), e.data = "about:blank", Fb || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!Fb && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const rL = /* @__PURE__ */ t9("data-v-b329ee4c");
Q8("data-v-b329ee4c");
const aL = {
  class: "resize-observer",
  tabindex: "-1"
};
K8();
const iL = /* @__PURE__ */ rL((e, t, n, r, s, f) => (zo(), Ih("div", aL)));
Sw.render = iL;
Sw.__scopeId = "data-v-b329ee4c";
Sw.__file = "src/components/ResizeObserver.vue";
var x4 = (e = "theme") => ({
  computed: {
    themeClass() {
      return q9(this[e]);
    }
  }
});
const oL = wc({
  name: "VPopperContent",
  components: {
    ResizeObserver: Sw
  },
  mixins: [
    x4()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(e) {
      return e != null && !isNaN(e) ? `${e}px` : null;
    }
  }
}), sL = ["id", "aria-hidden", "tabindex", "data-popper-placement"], lL = {
  ref: "inner",
  class: "v-popper__inner"
}, uL = /* @__PURE__ */ go("div", { class: "v-popper__arrow-outer" }, null, -1), cL = /* @__PURE__ */ go("div", { class: "v-popper__arrow-inner" }, null, -1), dL = [
  uL,
  cL
];
function fL(e, t, n, r, s, f) {
  const m = Hh("ResizeObserver");
  return zo(), yd("div", {
    id: e.popperId,
    ref: "popover",
    class: Fh(["v-popper__popper", [
      e.themeClass,
      e.classes.popperClass,
      {
        "v-popper__popper--shown": e.shown,
        "v-popper__popper--hidden": !e.shown,
        "v-popper__popper--show-from": e.classes.showFrom,
        "v-popper__popper--show-to": e.classes.showTo,
        "v-popper__popper--hide-from": e.classes.hideFrom,
        "v-popper__popper--hide-to": e.classes.hideTo,
        "v-popper__popper--skip-transition": e.skipTransition,
        "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
        "v-popper__popper--no-positioning": !e.result
      }
    ]]),
    style: Dk(e.result ? {
      position: e.result.strategy,
      transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`
    } : void 0),
    "aria-hidden": e.shown ? "false" : "true",
    tabindex: e.autoHide ? 0 : void 0,
    "data-popper-placement": e.result ? e.result.placement : void 0,
    onKeyup: t[2] || (t[2] = n9((p) => e.autoHide && e.$emit("hide"), ["esc"]))
  }, [
    go("div", {
      class: "v-popper__backdrop",
      onClick: t[0] || (t[0] = (p) => e.autoHide && e.$emit("hide"))
    }),
    go("div", {
      class: "v-popper__wrapper",
      style: Dk(e.result ? {
        transformOrigin: e.result.transformOrigin
      } : void 0)
    }, [
      go("div", lL, [
        e.mounted ? (zo(), yd(r9, { key: 0 }, [
          go("div", null, [
            Bv(e.$slots, "default")
          ]),
          e.handleResize ? (zo(), Ih(m, {
            key: 0,
            onNotify: t[1] || (t[1] = (p) => e.$emit("resize", p))
          })) : b$("", !0)
        ], 64)) : b$("", !0)
      ], 512),
      go("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: Dk(e.result ? {
          left: e.toPx(e.result.arrow.x),
          top: e.toPx(e.result.arrow.y)
        } : void 0)
      }, dL, 4)
    ], 4)
  ], 46, sL);
}
var C4 = /* @__PURE__ */ $w(oL, [["render", fL]]), M4 = {
  methods: {
    show(...e) {
      return this.$refs.popper.show(...e);
    },
    hide(...e) {
      return this.$refs.popper.hide(...e);
    },
    dispose(...e) {
      return this.$refs.popper.dispose(...e);
    },
    onResize(...e) {
      return this.$refs.popper.onResize(...e);
    }
  }
};
const mL = wc({
  name: "VPopperWrapper",
  components: {
    Popper: tL,
    PopperContent: C4
  },
  mixins: [
    M4,
    x4("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    }
  },
  computed: {
    finalTheme() {
      var e;
      return (e = this.theme) != null ? e : this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    }
  }
});
function hL(e, t, n, r, s, f) {
  const m = Hh("PopperContent"), p = Hh("Popper");
  return zo(), Ih(p, {
    ref: "popper",
    theme: e.finalTheme,
    "target-nodes": e.getTargetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    class: Fh([
      e.themeClass
    ])
  }, {
    default: Vh(({
      popperId: v,
      isShown: y,
      shouldMountContent: w,
      skipTransition: P,
      autoHide: x,
      show: A,
      hide: M,
      handleResize: O,
      onResize: j,
      classes: H,
      result: J
    }) => [
      Bv(e.$slots, "default", {
        shown: y,
        show: A,
        hide: M
      }),
      f4(m, {
        ref: "popperContent",
        "popper-id": v,
        theme: e.finalTheme,
        shown: y,
        mounted: w,
        "skip-transition": P,
        "auto-hide": x,
        "handle-resize": O,
        classes: H,
        result: J,
        onHide: M,
        onResize: j
      }, {
        default: Vh(() => [
          Bv(e.$slots, "popper", {
            shown: y,
            hide: M
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 8, ["theme", "target-nodes", "popper-node", "class"]);
}
var gS = /* @__PURE__ */ $w(mL, [["render", hL]]);
const pL = wc(og(cc({}, gS), {
  name: "VDropdown",
  vPopperTheme: "dropdown"
})), vL = wc(og(cc({}, gS), {
  name: "VMenu",
  vPopperTheme: "menu"
})), gL = wc(og(cc({}, gS), {
  name: "VTooltip",
  vPopperTheme: "tooltip"
})), yL = wc({
  name: "VTooltipDirective",
  components: {
    Popper: $4(),
    PopperContent: C4
  },
  mixins: [
    M4
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (e) => Uh(e.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (e) => Uh(e.theme, "loadingContent")
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(e) {
      if (typeof this.content == "function" && this.$_isShown && (e || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const t = ++this.$_fetchId, n = this.content(this);
        n.then ? n.then((r) => this.onResult(t, r)) : this.onResult(t, n);
      }
    },
    onResult(e, t) {
      e === this.$_fetchId && (this.$_loading = !1, this.asyncContent = t);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
}), bL = ["innerHTML"], wL = ["textContent"];
function PL(e, t, n, r, s, f) {
  const m = Hh("PopperContent"), p = Hh("Popper");
  return zo(), Ih(p, m4({ ref: "popper" }, e.$attrs, {
    theme: e.theme,
    "popper-node": () => e.$refs.popperContent.$el,
    onApplyShow: e.onShow,
    onApplyHide: e.onHide
  }), {
    default: Vh(({
      popperId: v,
      isShown: y,
      shouldMountContent: w,
      skipTransition: P,
      autoHide: x,
      hide: A,
      handleResize: M,
      onResize: O,
      classes: j,
      result: H
    }) => [
      f4(m, {
        ref: "popperContent",
        class: Fh({
          "v-popper--tooltip-loading": e.loading
        }),
        "popper-id": v,
        theme: e.theme,
        shown: y,
        mounted: w,
        "skip-transition": P,
        "auto-hide": x,
        "handle-resize": M,
        classes: j,
        result: H,
        onHide: A,
        onResize: O
      }, {
        default: Vh(() => [
          e.html ? (zo(), yd("div", {
            key: 0,
            innerHTML: e.finalContent
          }, null, 8, bL)) : (zo(), yd("div", {
            key: 1,
            textContent: o9(e.finalContent)
          }, null, 8, wL))
        ]),
        _: 2
      }, 1032, ["class", "popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 1
  }, 16, ["theme", "popper-node", "onApplyShow", "onApplyHide"]);
}
var kL = /* @__PURE__ */ $w(yL, [["render", PL]]);
const E4 = "v-popper--has-tooltip";
function $L(e, t) {
  let n = e.placement;
  if (!n && t)
    for (const r of k4)
      t[r] && (n = r);
  return n || (n = Uh(e.theme || "tooltip", "placement")), n;
}
function A4(e, t, n) {
  let r;
  const s = typeof t;
  return s === "string" ? r = { content: t } : t && s === "object" ? r = t : r = { content: !1 }, r.placement = $L(r, n), r.targetNodes = () => [e], r.referenceNode = () => e, r;
}
let jk, Uv, SL = 0;
function xL() {
  if (jk)
    return;
  Uv = om([]), jk = a9({
    name: "VTooltipDirectiveApp",
    setup() {
      return {
        directives: Uv
      };
    },
    render() {
      return this.directives.map((t) => i9(kL, og(cc({}, t.options), {
        shown: t.shown || t.options.shown,
        key: t.id
      })));
    },
    devtools: {
      hide: !0
    }
  });
  const e = document.createElement("div");
  document.body.appendChild(e), jk.mount(e);
}
function CL(e, t, n) {
  xL();
  const r = om(A4(e, t, n)), s = om(!1), f = {
    id: SL++,
    options: r,
    shown: s
  };
  return Uv.value.push(f), e.classList && e.classList.add(E4), e.$_popper = {
    options: r,
    item: f,
    show() {
      s.value = !0;
    },
    hide() {
      s.value = !1;
    }
  };
}
function _4(e) {
  if (e.$_popper) {
    const t = Uv.value.indexOf(e.$_popper.item);
    t !== -1 && Uv.value.splice(t, 1), delete e.$_popper, delete e.$_popperOldShown, delete e.$_popperMountTarget;
  }
  e.classList && e.classList.remove(E4);
}
function gE(e, { value: t, modifiers: n }) {
  const r = A4(e, t, n);
  if (!r.content || Uh(r.theme || "tooltip", "disabled"))
    _4(e);
  else {
    let s;
    e.$_popper ? (s = e.$_popper, s.options.value = r) : s = CL(e, t, n), typeof t.shown < "u" && t.shown !== e.$_popperOldShown && (e.$_popperOldShown = t.shown, t.shown ? s.show() : s.hide());
  }
}
var ML = {
  beforeMount: gE,
  updated: gE,
  beforeUnmount(e) {
    _4(e);
  }
};
function yE(e) {
  e.addEventListener("click", O4), e.addEventListener("touchstart", T4, lm ? {
    passive: !0
  } : !1);
}
function bE(e) {
  e.removeEventListener("click", O4), e.removeEventListener("touchstart", T4), e.removeEventListener("touchend", R4), e.removeEventListener("touchcancel", D4);
}
function O4(e) {
  const t = e.currentTarget;
  e.closePopover = !t.$_vclosepopover_touch, e.closeAllPopover = t.$_closePopoverModifiers && !!t.$_closePopoverModifiers.all;
}
function T4(e) {
  if (e.changedTouches.length === 1) {
    const t = e.currentTarget;
    t.$_vclosepopover_touch = !0;
    const n = e.changedTouches[0];
    t.$_vclosepopover_touchPoint = n, t.addEventListener("touchend", R4), t.addEventListener("touchcancel", D4);
  }
}
function R4(e) {
  const t = e.currentTarget;
  if (t.$_vclosepopover_touch = !1, e.changedTouches.length === 1) {
    const n = e.changedTouches[0], r = t.$_vclosepopover_touchPoint;
    e.closePopover = Math.abs(n.screenY - r.screenY) < 20 && Math.abs(n.screenX - r.screenX) < 20, e.closeAllPopover = t.$_closePopoverModifiers && !!t.$_closePopoverModifiers.all;
  }
}
function D4(e) {
  const t = e.currentTarget;
  t.$_vclosepopover_touch = !1;
}
var EL = {
  beforeMount(e, { value: t, modifiers: n }) {
    e.$_closePopoverModifiers = n, (typeof t > "u" || t) && yE(e);
  },
  updated(e, { value: t, oldValue: n, modifiers: r }) {
    e.$_closePopoverModifiers = r, t !== n && (typeof t > "u" || t ? yE(e) : bE(e));
  },
  beforeUnmount(e) {
    bE(e);
  }
};
function AL(e, t = {}) {
  e.$_vTooltipInstalled || (e.$_vTooltipInstalled = !0, w4(mc, t), e.directive("tooltip", ML), e.directive("close-popper", EL), e.component("VTooltip", gL), e.component("VDropdown", pL), e.component("VMenu", vL));
}
const _L = {
  version: "2.0.0-beta.21",
  install: AL,
  options: mc
};
var wE;
(function(e) {
  e.GOOGLE = "google", e.GITHUB = "github";
})(wE || (wE = {}));
var PE;
(function(e) {
  e.USER = "user";
})(PE || (PE = {}));
var kE;
(function(e) {
  e.ADMIN = "admin", e.MEMBER = "member";
})(kE || (kE = {}));
var $E;
(function(e) {
  e.NEW = "new", e.ACTIVE = "active", e.INVITED = "invited";
})($E || ($E = {}));
var SE;
(function(e) {
  e.EVENT = "event";
})(SE || (SE = {}));
var xE;
(function(e) {
  e.CREDENTIALS = "Credentials", e.INTERNAL = "Internal", e.PAYLOAD = "Payload", e.WEBHOOK = "Webhook";
})(xE || (xE = {}));
var CE;
(function(e) {
  e.SUCCESS = "Success", e.WARNING = "Warning", e.FAILED = "Failed", e.PENDING = "Pending", e.QUEUED = "Queued", e.READ_CONFIRMATION = "ReadConfirmation";
})(CE || (CE = {}));
var Xv;
(function(e) {
  e.PRIMARY = "primary", e.SECONDARY = "secondary", e.CLICKED = "clicked";
})(Xv || (Xv = {}));
var qv;
(function(e) {
  e.PENDING = "pending", e.DONE = "done";
})(qv || (qv = {}));
var ME;
(function(e) {
  e.ERROR = "error", e.SUCCESS = "success", e.INFO = "info";
})(ME || (ME = {}));
var EE;
(function(e) {
  e[e.TRIGGER_RECEIVED = 1e3] = "TRIGGER_RECEIVED", e[e.TEMPLATE_NOT_ACTIVE = 1001] = "TEMPLATE_NOT_ACTIVE", e[e.TEMPLATE_NOT_FOUND = 1002] = "TEMPLATE_NOT_FOUND", e[e.SMS_ERROR = 1004] = "SMS_ERROR", e[e.CHAT_ERROR = 1005] = "CHAT_ERROR", e[e.MISSING_SMS_PROVIDER = 1006] = "MISSING_SMS_PROVIDER", e[e.IN_APP_MESSAGE_CREATED = 1007] = "IN_APP_MESSAGE_CREATED", e[e.MAIL_PROVIDER_DELIVERY_ERROR = 1008] = "MAIL_PROVIDER_DELIVERY_ERROR", e[e.TRIGGER_PROCESSED = 1009] = "TRIGGER_PROCESSED", e[e.PUSH_ERROR = 1010] = "PUSH_ERROR", e[e.MISSING_PUSH_PROVIDER = 1011] = "MISSING_PUSH_PROVIDER", e[e.SUBSCRIBER_NOT_FOUND = 3001] = "SUBSCRIBER_NOT_FOUND", e[e.SUBSCRIBER_MISSING_EMAIL = 3002] = "SUBSCRIBER_MISSING_EMAIL", e[e.SUBSCRIBER_MISSING_PHONE = 3003] = "SUBSCRIBER_MISSING_PHONE", e[e.SUBSCRIBER_MISSING_CHAT_CHANNEL_ID = 3006] = "SUBSCRIBER_MISSING_CHAT_CHANNEL_ID", e[e.SUBSCRIBER_ID_MISSING = 3004] = "SUBSCRIBER_ID_MISSING", e[e.MISSING_EMAIL_INTEGRATION = 3005] = "MISSING_EMAIL_INTEGRATION", e[e.MISSING_SMS_INTEGRATION = 3007] = "MISSING_SMS_INTEGRATION", e[e.MISSING_CHAT_INTEGRATION = 3008] = "MISSING_CHAT_INTEGRATION", e[e.MISSING_PUSH_INTEGRATION = 3009] = "MISSING_PUSH_INTEGRATION", e[e.SUBSCRIBER_MISSING_PUSH = 3010] = "SUBSCRIBER_MISSING_PUSH", e[e.MISSING_PAYLOAD_VARIABLE = 3011] = "MISSING_PAYLOAD_VARIABLE", e[e.AVATAR_ACTOR_ERROR = 3012] = "AVATAR_ACTOR_ERROR", e[e.SYNTAX_ERROR_IN_EMAIL_EDITOR = 3013] = "SYNTAX_ERROR_IN_EMAIL_EDITOR", e[e.TOPIC_ERROR = 4001] = "TOPIC_ERROR", e[e.TOPIC_SUBSCRIBERS_ERROR = 4002] = "TOPIC_SUBSCRIBERS_ERROR";
})(EE || (EE = {}));
var AE;
(function(e) {
  e.FEED = "Feed", e.MESSAGE_TEMPLATE = "MessageTemplate", e.LAYOUT = "Layout", e.DEFAULT_LAYOUT = "DefaultLayout", e.NOTIFICATION_TEMPLATE = "NotificationTemplate", e.NOTIFICATION_GROUP = "NotificationGroup";
})(AE || (AE = {}));
var _E;
(function(e) {
  e.SECONDS = "seconds", e.MINUTES = "minutes", e.HOURS = "hours", e.DAYS = "days";
})(_E || (_E = {}));
var OE;
(function(e) {
  e.REGULAR = "regular", e.BACKOFF = "backoff";
})(OE || (OE = {}));
var TE;
(function(e) {
  e.REGULAR = "regular", e.SCHEDULED = "scheduled";
})(TE || (TE = {}));
var RE;
(function(e) {
  e.PENDING = "pending", e.QUEUED = "queued", e.RUNNING = "running", e.COMPLETED = "completed", e.FAILED = "failed", e.DELAYED = "delayed", e.CANCELED = "canceled";
})(RE || (RE = {}));
var em;
(function(e) {
  e.PAYLOAD = "payload", e.SUBSCRIBER = "subscriber", e.WEBHOOK = "webhook", e.IS_ONLINE = "isOnline", e.IS_ONLINE_IN_LAST = "isOnlineInLast";
})(em || (em = {}));
var wn;
(function(e) {
  e.IN_APP = "in_app", e.EMAIL = "email", e.SMS = "sms", e.CHAT = "chat", e.PUSH = "push";
})(wn || (wn = {}));
var tm;
(function(e) {
  e.IN_APP = "in_app", e.EMAIL = "email", e.SMS = "sms", e.CHAT = "chat", e.PUSH = "push", e.DIGEST = "digest", e.TRIGGER = "trigger", e.DELAY = "delay";
})(tm || (tm = {}));
tm.IN_APP, wn.IN_APP, tm.EMAIL, wn.EMAIL, tm.SMS, wn.SMS, tm.CHAT, wn.CHAT, tm.PUSH, wn.PUSH;
var M$;
(function(e) {
  e.REDIRECT = "redirect";
})(M$ || (M$ = {}));
var DE;
(function(e) {
  e.STRING = "String", e.ARRAY = "Array", e.BOOLEAN = "Boolean";
})(DE || (DE = {}));
var jh;
(function(e) {
  e.NONE = "none", e.USER = "user", e.SYSTEM_ICON = "system_icon", e.SYSTEM_CUSTOM = "system_custom";
})(jh || (jh = {}));
var dd;
(function(e) {
  e.WARNING = "warning", e.INFO = "info", e.ERROR = "error", e.SUCCESS = "success", e.UP = "up", e.QUESTION = "question";
})(dd || (dd = {}));
var NE;
(function(e) {
  e.BUTTON = "button", e.TEXT = "text";
})(NE || (NE = {}));
var WE;
(function(e) {
  e.CENTER = "center", e.LEFT = "left", e.RIGHT = "right";
})(WE || (WE = {}));
var jE;
(function(e) {
  e[e.ASC = 1] = "ASC", e[e.DESC = -1] = "DESC";
})(jE || (jE = {}));
var zE;
(function(e) {
  e.WEB = "web", e.CLI = "cli", e.VERCEL = "vercel";
})(zE || (zE = {}));
var LE;
(function(e) {
  e.SUBSCRIBER = "Subscriber", e.TOPIC = "Topic";
})(LE || (LE = {}));
var dt;
(function(e) {
  e.ApiKey = "apiKey", e.User = "user", e.SecretKey = "secretKey", e.Domain = "domain", e.Password = "password", e.Host = "host", e.Port = "port", e.Secure = "secure", e.Region = "region", e.AccountSid = "accountSid", e.MessageProfileId = "messageProfileId", e.Token = "token", e.From = "from", e.SenderName = "senderName", e.ApplicationId = "applicationId", e.ClientId = "clientId", e.ProjectName = "projectName", e.ServiceAccount = "serviceAccount", e.BaseUrl = "baseUrl", e.WebhookUrl = "webhookUrl", e.RequireTls = "requireTls", e.IgnoreTls = "ignoreTls", e.TlsOptions = "tlsOptions";
})(dt || (dt = {}));
var vo;
(function(e) {
  e.EmailJS = "emailjs", e.Mailgun = "mailgun", e.Mailjet = "mailjet", e.Mandrill = "mandrill", e.CustomSMTP = "nodemailer", e.Postmark = "postmark", e.SendGrid = "sendgrid", e.Sendinblue = "sendinblue", e.SES = "ses", e.NetCore = "netcore", e.Infobip = "infobip-email", e.Resend = "resend", e.MailerSend = "mailersend", e.Clickatell = "clickatell", e.Outlook365 = "outlook365", e.Novu = "novu-email";
})(vo || (vo = {}));
var cs;
(function(e) {
  e.Nexmo = "nexmo", e.Plivo = "plivo", e.Sms77 = "sms77", e.SNS = "sns", e.Telnyx = "telnyx", e.Twilio = "twilio", e.Gupshup = "gupshup", e.Firetext = "firetext", e.Infobip = "infobip-sms", e.BurstSms = "burst-sms", e.Clickatell = "clickatell";
})(cs || (cs = {}));
var zv;
(function(e) {
  e.Slack = "slack", e.Discord = "discord", e.MsTeams = "msteams";
})(zv || (zv = {}));
var Lv;
(function(e) {
  e.FCM = "fcm", e.APNS = "apns", e.EXPO = "expo";
})(Lv || (Lv = {}));
var IE;
(function(e) {
  e.Novu = "novu";
})(IE || (IE = {}));
dt.ApiKey, dt.SecretKey, dt.Token, dt.Password, dt.ServiceAccount;
const Io = [
  {
    key: dt.From,
    displayName: "From email address",
    description: "Use the same email address you used to authenticate your delivery provider",
    type: "string",
    required: !0
  },
  {
    key: dt.SenderName,
    displayName: "Sender name",
    type: "string",
    required: !0
  }
], Md = [
  {
    key: dt.From,
    displayName: "From",
    type: "string",
    required: !0
  }
], yS = [];
[
  dt.ApiKey,
  dt.SecretKey,
  ...Io
];
const OL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  {
    key: dt.BaseUrl,
    displayName: "Base URL",
    type: "string",
    required: !1
  },
  {
    key: dt.User,
    displayName: "User name",
    type: "string",
    required: !0
  },
  {
    key: dt.Domain,
    displayName: "Domain",
    type: "string",
    required: !0
  },
  ...Io
], TL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  {
    key: dt.SecretKey,
    displayName: "API Secret",
    type: "string",
    required: !0
  },
  ...Io
], RL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  {
    key: dt.SecretKey,
    displayName: "API secret",
    type: "string",
    required: !0
  },
  ...Md
], DL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  ...Io
], NL = [
  {
    key: dt.User,
    displayName: "User",
    type: "string",
    required: !1
  },
  {
    key: dt.Password,
    displayName: "Password",
    type: "string",
    required: !1
  },
  {
    key: dt.Host,
    displayName: "Host",
    type: "string",
    required: !0
  },
  {
    key: dt.Port,
    displayName: "Port",
    type: "number",
    required: !0
  },
  {
    key: dt.Secure,
    displayName: "Secure",
    type: "boolean",
    required: !1
  },
  {
    key: dt.RequireTls,
    displayName: "Require TLS",
    type: "boolean",
    required: !1
  },
  {
    key: dt.IgnoreTls,
    displayName: "Ignore TLS",
    type: "boolean",
    required: !1
  },
  {
    key: dt.TlsOptions,
    displayName: "TLS options",
    type: "object",
    required: !1
  },
  {
    key: dt.Domain,
    displayName: "DKIM: Domain name",
    type: "string",
    required: !1
  },
  {
    key: dt.SecretKey,
    displayName: "DKIM: Private key",
    type: "string",
    required: !1
  },
  {
    key: dt.AccountSid,
    displayName: "DKIM: Key selector",
    type: "string",
    required: !1
  },
  ...Io
], WL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  ...Io
], jL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  ...Io
], zL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  ...Io
], LL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  ...Io
], IL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  ...Io
], FL = [
  {
    key: dt.ApiKey,
    displayName: "Access key ID",
    type: "string",
    required: !0
  },
  {
    key: dt.SecretKey,
    displayName: "Secret access key",
    type: "string",
    required: !0
  },
  {
    key: dt.Region,
    displayName: "Region",
    type: "string",
    required: !0
  },
  ...Io
], HL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  ...Io
], VL = [
  {
    key: dt.AccountSid,
    displayName: "Account SID",
    type: "string",
    required: !0
  },
  {
    key: dt.Token,
    displayName: "Auth token",
    type: "string",
    required: !0
  },
  ...Md
], BL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  ...Md
];
[
  dt.ApiKey,
  ...Md
];
const UL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  {
    key: dt.SecretKey,
    displayName: "API Secret",
    type: "string",
    required: !0
  }
], XL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  }
], qL = [
  {
    key: dt.ApiKey,
    displayName: "Access key ID",
    type: "string",
    required: !0
  },
  {
    key: dt.SecretKey,
    displayName: "Secret access key",
    type: "string",
    required: !0
  },
  {
    key: dt.Region,
    displayName: "AWS region",
    type: "string",
    required: !0
  }
], YL = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  {
    key: dt.MessageProfileId,
    displayName: "Message profile ID",
    type: "string",
    required: !0
  },
  ...Md
], GL = [
  {
    key: dt.AccountSid,
    displayName: "Account SID",
    type: "string",
    required: !0
  },
  {
    key: dt.Token,
    displayName: "Auth token",
    type: "string",
    required: !0
  },
  ...Md
], QL = [
  {
    key: dt.ClientId,
    displayName: "Client ID",
    type: "string",
    required: !1
  },
  {
    key: dt.SecretKey,
    displayName: "Client Secret",
    type: "string",
    required: !1
  },
  {
    key: dt.ApplicationId,
    displayName: "Application Id",
    type: "string",
    required: !1
  }
], KL = [
  {
    key: dt.ServiceAccount,
    displayName: "Service Account (entire JSON file)",
    type: "text",
    required: !0
  },
  ...yS
], JL = [
  {
    key: dt.ApiKey,
    displayName: "Access Token",
    type: "text",
    required: !0
  },
  ...yS
], ZL = [
  {
    key: dt.SecretKey,
    displayName: "Private Key",
    type: "text",
    required: !0
  },
  {
    key: dt.ApiKey,
    displayName: "Key ID",
    type: "string",
    required: !0
  },
  {
    key: dt.ProjectName,
    displayName: "Team ID",
    type: "string",
    required: !0
  },
  {
    key: dt.ApplicationId,
    displayName: "Bundle ID",
    type: "string",
    required: !0
  },
  {
    key: dt.Secure,
    displayName: "Production",
    type: "switch",
    required: !0
  },
  ...yS
], eI = [
  {
    key: dt.User,
    displayName: "User id",
    type: "string",
    required: !0
  },
  {
    key: dt.Password,
    displayName: "Password",
    type: "string",
    required: !0
  }
], tI = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  ...Md
], nI = [
  {
    key: dt.Password,
    displayName: "Password",
    type: "string",
    required: !0
  },
  ...Io
], rI = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  {
    key: dt.BaseUrl,
    displayName: "Base URL",
    type: "string",
    required: !0
  },
  ...Md
], aI = [
  {
    key: dt.ApiKey,
    displayName: "API Key",
    type: "string",
    required: !0
  },
  {
    key: dt.BaseUrl,
    displayName: "Base URL",
    type: "string",
    required: !0
  },
  ...Io
];
vo.Mailgun, wn.EMAIL, vo.Mailjet, wn.EMAIL, vo.Mandrill, wn.EMAIL, vo.Postmark, wn.EMAIL, vo.SendGrid, wn.EMAIL, vo.Sendinblue, wn.EMAIL, vo.SES, wn.EMAIL, vo.NetCore, wn.EMAIL, vo.CustomSMTP, wn.EMAIL, vo.MailerSend, wn.EMAIL, vo.Outlook365, wn.EMAIL, vo.Infobip, wn.EMAIL, vo.Resend, wn.EMAIL;
cs.Nexmo, wn.SMS, cs.Plivo, wn.SMS, cs.Sms77, wn.SMS, cs.SNS, wn.SMS, cs.Telnyx, wn.SMS, cs.Twilio, wn.SMS, cs.Gupshup, wn.SMS, cs.Firetext, wn.SMS, cs.Infobip, wn.SMS, cs.BurstSms, wn.SMS, cs.Clickatell, wn.SMS;
zv.Slack, wn.CHAT, zv.Discord, wn.CHAT, zv.MsTeams, wn.CHAT;
Lv.FCM, wn.PUSH, Lv.EXPO, wn.PUSH, Lv.APNS, wn.PUSH;
Xv.PRIMARY;
Xv.SECONDARY;
const iI = {
  primary: {
    backGroundColor: "linear-gradient(99deg,#DD2476 0% 0%, #FF512F 100% 100%)",
    fontColor: "#FFFFFF",
    removeCircleColor: "white",
    fontFamily: "Lato"
  },
  secondary: { backGroundColor: "#3D3D4D", fontColor: "#FFFFFF", removeCircleColor: "#525266", fontFamily: "Lato" },
  clicked: { backGroundColor: "white", fontColor: "#FFFFFF", removeCircleColor: "#525266", fontFamily: "Lato" }
}, oI = {
  primary: {
    backGroundColor: "linear-gradient(99deg,#DD2476 0% 0%, #FF512F 100% 100%)",
    fontColor: "#FFFFFF",
    removeCircleColor: "white",
    fontFamily: "Lato"
  },
  secondary: { backGroundColor: "#F5F8FA", fontColor: "#525266", removeCircleColor: "#525266", fontFamily: "Lato" },
  clicked: { backGroundColor: "white", fontColor: "#525266", removeCircleColor: "#525266", fontFamily: "Lato" }
};
var fd;
(function(e) {
  e.EQUALS = "equals", e.TITLECASE = "titlecase", e.UPPERCASE = "uppercase", e.LOWERCASE = "lowercase", e.PLURALIZE = "pluralize", e.DATEFORMAT = "dateFormat";
})(fd || (fd = {}));
fd.EQUALS + "", fd.TITLECASE + "", fd.UPPERCASE + "", fd.LOWERCASE + "", fd.PLURALIZE + "", fd.DATEFORMAT + "";
em.PAYLOAD + "", em.SUBSCRIBER + "", em.WEBHOOK + "", em.IS_ONLINE + "", em.IS_ONLINE_IN_LAST + "";
function N4(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: W4 } = Object.prototype, { getPrototypeOf: bS } = Object, wS = ((e) => (t) => {
  const n = W4.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kc = (e) => (e = e.toLowerCase(), (t) => wS(t) === e), xw = (e) => (t) => typeof t === e, { isArray: Gh } = Array, Yv = xw("undefined");
function sI(e) {
  return e !== null && !Yv(e) && e.constructor !== null && !Yv(e.constructor) && Pd(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const j4 = kc("ArrayBuffer");
function lI(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && j4(e.buffer), t;
}
const uI = xw("string"), Pd = xw("function"), z4 = xw("number"), PS = (e) => e !== null && typeof e == "object", cI = (e) => e === !0 || e === !1, Hb = (e) => {
  if (wS(e) !== "object")
    return !1;
  const t = bS(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, dI = kc("Date"), fI = kc("File"), mI = kc("Blob"), hI = kc("FileList"), pI = (e) => PS(e) && Pd(e.pipe), vI = (e) => {
  const t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || W4.call(e) === t || Pd(e.toString) && e.toString() === t);
}, gI = kc("URLSearchParams"), yI = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function sg(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), Gh(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    const f = n ? Object.getOwnPropertyNames(e) : Object.keys(e), m = f.length;
    let p;
    for (r = 0; r < m; r++)
      p = f[r], t.call(null, e[p], p, e);
  }
}
function L4(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const I4 = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), F4 = (e) => !Yv(e) && e !== I4;
function E$() {
  const { caseless: e } = F4(this) && this || {}, t = {}, n = (r, s) => {
    const f = e && L4(t, s) || s;
    Hb(t[f]) && Hb(r) ? t[f] = E$(t[f], r) : Hb(r) ? t[f] = E$({}, r) : Gh(r) ? t[f] = r.slice() : t[f] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && sg(arguments[r], n);
  return t;
}
const bI = (e, t, n, { allOwnKeys: r } = {}) => (sg(t, (s, f) => {
  n && Pd(s) ? e[f] = N4(s, n) : e[f] = s;
}, { allOwnKeys: r }), e), wI = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), PI = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, kI = (e, t, n, r) => {
  let s, f, m;
  const p = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (s = Object.getOwnPropertyNames(e), f = s.length; f-- > 0; )
      m = s[f], (!r || r(m, e, t)) && !p[m] && (t[m] = e[m], p[m] = !0);
    e = n !== !1 && bS(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, $I = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, SI = (e) => {
  if (!e)
    return null;
  if (Gh(e))
    return e;
  let t = e.length;
  if (!z4(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, xI = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && bS(Uint8Array)), CI = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const f = s.value;
    t.call(e, f[0], f[1]);
  }
}, MI = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, EI = kc("HTMLFormElement"), AI = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), FE = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), _I = kc("RegExp"), H4 = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  sg(n, (s, f) => {
    t(s, f, e) !== !1 && (r[f] = s);
  }), Object.defineProperties(e, r);
}, OI = (e) => {
  H4(e, (t, n) => {
    if (Pd(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Pd(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, TI = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((f) => {
      n[f] = !0;
    });
  };
  return Gh(e) ? r(e) : r(String(e).split(t)), n;
}, RI = () => {
}, DI = (e, t) => (e = +e, Number.isFinite(e) ? e : t), zk = "abcdefghijklmnopqrstuvwxyz", HE = "0123456789", V4 = {
  DIGIT: HE,
  ALPHA: zk,
  ALPHA_DIGIT: zk + zk.toUpperCase() + HE
}, NI = (e = 16, t = V4.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function WI(e) {
  return !!(e && Pd(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const jI = (e) => {
  const t = new Array(10), n = (r, s) => {
    if (PS(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[s] = r;
        const f = Gh(r) ? [] : {};
        return sg(r, (m, p) => {
          const v = n(m, s + 1);
          !Yv(v) && (f[p] = v);
        }), t[s] = void 0, f;
      }
    }
    return r;
  };
  return n(e, 0);
}, De = {
  isArray: Gh,
  isArrayBuffer: j4,
  isBuffer: sI,
  isFormData: vI,
  isArrayBufferView: lI,
  isString: uI,
  isNumber: z4,
  isBoolean: cI,
  isObject: PS,
  isPlainObject: Hb,
  isUndefined: Yv,
  isDate: dI,
  isFile: fI,
  isBlob: mI,
  isRegExp: _I,
  isFunction: Pd,
  isStream: pI,
  isURLSearchParams: gI,
  isTypedArray: xI,
  isFileList: hI,
  forEach: sg,
  merge: E$,
  extend: bI,
  trim: yI,
  stripBOM: wI,
  inherits: PI,
  toFlatObject: kI,
  kindOf: wS,
  kindOfTest: kc,
  endsWith: $I,
  toArray: SI,
  forEachEntry: CI,
  matchAll: MI,
  isHTMLForm: EI,
  hasOwnProperty: FE,
  hasOwnProp: FE,
  reduceDescriptors: H4,
  freezeMethods: OI,
  toObjectSet: TI,
  toCamelCase: AI,
  noop: RI,
  toFiniteNumber: DI,
  findKey: L4,
  global: I4,
  isContextDefined: F4,
  ALPHABET: V4,
  generateString: NI,
  isSpecCompliantForm: WI,
  toJSONObject: jI
};
function In(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s);
}
De.inherits(In, Error, {
  toJSON: function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: De.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const B4 = In.prototype, U4 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
].forEach((e) => {
  U4[e] = { value: e };
});
Object.defineProperties(In, U4);
Object.defineProperty(B4, "isAxiosError", { value: !0 });
In.from = (e, t, n, r, s, f) => {
  const m = Object.create(B4);
  return De.toFlatObject(e, m, function(v) {
    return v !== Error.prototype;
  }, (p) => p !== "isAxiosError"), In.call(m, e.message, t, n, r, s), m.cause = e, m.name = e.name, f && Object.assign(m, f), m;
};
const zI = null;
function A$(e) {
  return De.isPlainObject(e) || De.isArray(e);
}
function X4(e) {
  return De.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function VE(e, t, n) {
  return e ? e.concat(t).map(function(s, f) {
    return s = X4(s), !n && f ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function LI(e) {
  return De.isArray(e) && !e.some(A$);
}
const II = De.toFlatObject(De, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Cw(e, t, n) {
  if (!De.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = De.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(O, j) {
    return !De.isUndefined(j[O]);
  });
  const r = n.metaTokens, s = n.visitor || w, f = n.dots, m = n.indexes, v = (n.Blob || typeof Blob < "u" && Blob) && De.isSpecCompliantForm(t);
  if (!De.isFunction(s))
    throw new TypeError("visitor must be a function");
  function y(M) {
    if (M === null)
      return "";
    if (De.isDate(M))
      return M.toISOString();
    if (!v && De.isBlob(M))
      throw new In("Blob is not supported. Use a Buffer instead.");
    return De.isArrayBuffer(M) || De.isTypedArray(M) ? v && typeof Blob == "function" ? new Blob([M]) : Buffer.from(M) : M;
  }
  function w(M, O, j) {
    let H = M;
    if (M && !j && typeof M == "object") {
      if (De.endsWith(O, "{}"))
        O = r ? O : O.slice(0, -2), M = JSON.stringify(M);
      else if (De.isArray(M) && LI(M) || (De.isFileList(M) || De.endsWith(O, "[]")) && (H = De.toArray(M)))
        return O = X4(O), H.forEach(function(V, X) {
          !(De.isUndefined(V) || V === null) && t.append(
            m === !0 ? VE([O], X, f) : m === null ? O : O + "[]",
            y(V)
          );
        }), !1;
    }
    return A$(M) ? !0 : (t.append(VE(j, O, f), y(M)), !1);
  }
  const P = [], x = Object.assign(II, {
    defaultVisitor: w,
    convertValue: y,
    isVisitable: A$
  });
  function A(M, O) {
    if (!De.isUndefined(M)) {
      if (P.indexOf(M) !== -1)
        throw Error("Circular reference detected in " + O.join("."));
      P.push(M), De.forEach(M, function(H, J) {
        (!(De.isUndefined(H) || H === null) && s.call(
          t,
          H,
          De.isString(J) ? J.trim() : J,
          O,
          x
        )) === !0 && A(H, O ? O.concat(J) : [J]);
      }), P.pop();
    }
  }
  if (!De.isObject(e))
    throw new TypeError("data must be an object");
  return A(e), t;
}
function BE(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function kS(e, t) {
  this._pairs = [], e && Cw(e, this, t);
}
const q4 = kS.prototype;
q4.append = function(t, n) {
  this._pairs.push([t, n]);
};
q4.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, BE);
  } : BE;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function FI(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Y4(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || FI, s = n && n.serialize;
  let f;
  if (s ? f = s(t, n) : f = De.isURLSearchParams(t) ? t.toString() : new kS(t, n).toString(r), f) {
    const m = e.indexOf("#");
    m !== -1 && (e = e.slice(0, m)), e += (e.indexOf("?") === -1 ? "?" : "&") + f;
  }
  return e;
}
class HI {
  constructor() {
    this.handlers = [];
  }
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(t) {
    De.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const UE = HI, G4 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, VI = typeof URLSearchParams < "u" ? URLSearchParams : kS, BI = typeof FormData < "u" ? FormData : null, UI = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), XI = (() => typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), du = {
  isBrowser: !0,
  classes: {
    URLSearchParams: VI,
    FormData: BI,
    Blob
  },
  isStandardBrowserEnv: UI,
  isStandardBrowserWebWorkerEnv: XI,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function qI(e, t) {
  return Cw(e, new du.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, s, f) {
      return du.isNode && De.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : f.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function YI(e) {
  return De.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function GI(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let f;
  for (r = 0; r < s; r++)
    f = n[r], t[f] = e[f];
  return t;
}
function Q4(e) {
  function t(n, r, s, f) {
    let m = n[f++];
    const p = Number.isFinite(+m), v = f >= n.length;
    return m = !m && De.isArray(s) ? s.length : m, v ? (De.hasOwnProp(s, m) ? s[m] = [s[m], r] : s[m] = r, !p) : ((!s[m] || !De.isObject(s[m])) && (s[m] = []), t(n, r, s[m], f) && De.isArray(s[m]) && (s[m] = GI(s[m])), !p);
  }
  if (De.isFormData(e) && De.isFunction(e.entries)) {
    const n = {};
    return De.forEachEntry(e, (r, s) => {
      t(YI(r), s, n, 0);
    }), n;
  }
  return null;
}
const QI = {
  "Content-Type": void 0
};
function KI(e, t, n) {
  if (De.isString(e))
    try {
      return (t || JSON.parse)(e), De.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Mw = {
  transitional: G4,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, f = De.isObject(t);
    if (f && De.isHTMLForm(t) && (t = new FormData(t)), De.isFormData(t))
      return s && s ? JSON.stringify(Q4(t)) : t;
    if (De.isArrayBuffer(t) || De.isBuffer(t) || De.isStream(t) || De.isFile(t) || De.isBlob(t))
      return t;
    if (De.isArrayBufferView(t))
      return t.buffer;
    if (De.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let p;
    if (f) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return qI(t, this.formSerializer).toString();
      if ((p = De.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const v = this.env && this.env.FormData;
        return Cw(
          p ? { "files[]": t } : t,
          v && new v(),
          this.formSerializer
        );
      }
    }
    return f || s ? (n.setContentType("application/json", !1), KI(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Mw.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (t && De.isString(t) && (r && !this.responseType || s)) {
      const m = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (p) {
        if (m)
          throw p.name === "SyntaxError" ? In.from(p, In.ERR_BAD_RESPONSE, this, null, this.response) : p;
      }
    }
    return t;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: du.classes.FormData,
    Blob: du.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
De.forEach(["delete", "get", "head"], function(t) {
  Mw.headers[t] = {};
});
De.forEach(["post", "put", "patch"], function(t) {
  Mw.headers[t] = De.merge(QI);
});
const $S = Mw, JI = De.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ZI = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(m) {
    s = m.indexOf(":"), n = m.substring(0, s).trim().toLowerCase(), r = m.substring(s + 1).trim(), !(!n || t[n] && JI[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, XE = Symbol("internals");
function yv(e) {
  return e && String(e).trim().toLowerCase();
}
function Vb(e) {
  return e === !1 || e == null ? e : De.isArray(e) ? e.map(Vb) : String(e);
}
function eF(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
function tF(e) {
  return /^[-_a-zA-Z]+$/.test(e.trim());
}
function Lk(e, t, n, r, s) {
  if (De.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!De.isString(t)) {
    if (De.isString(r))
      return t.indexOf(r) !== -1;
    if (De.isRegExp(r))
      return r.test(t);
  }
}
function nF(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function rF(e, t) {
  const n = De.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, f, m) {
        return this[r].call(this, t, s, f, m);
      },
      configurable: !0
    });
  });
}
class Ew {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function f(p, v, y) {
      const w = yv(v);
      if (!w)
        throw new Error("header name must be a non-empty string");
      const P = De.findKey(s, w);
      (!P || s[P] === void 0 || y === !0 || y === void 0 && s[P] !== !1) && (s[P || v] = Vb(p));
    }
    const m = (p, v) => De.forEach(p, (y, w) => f(y, w, v));
    return De.isPlainObject(t) || t instanceof this.constructor ? m(t, n) : De.isString(t) && (t = t.trim()) && !tF(t) ? m(ZI(t), n) : t != null && f(n, t, r), this;
  }
  get(t, n) {
    if (t = yv(t), t) {
      const r = De.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return eF(s);
        if (De.isFunction(n))
          return n.call(this, s, r);
        if (De.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = yv(t), t) {
      const r = De.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Lk(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function f(m) {
      if (m = yv(m), m) {
        const p = De.findKey(r, m);
        p && (!n || Lk(r, r[p], p, n)) && (delete r[p], s = !0);
      }
    }
    return De.isArray(t) ? t.forEach(f) : f(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const f = n[r];
      (!t || Lk(this, this[f], f, t, !0)) && (delete this[f], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return De.forEach(this, (s, f) => {
      const m = De.findKey(r, f);
      if (m) {
        n[m] = Vb(s), delete n[f];
        return;
      }
      const p = t ? nF(f) : String(f).trim();
      p !== f && delete n[f], n[p] = Vb(s), r[p] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return De.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && De.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const r = (this[XE] = this[XE] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function f(m) {
      const p = yv(m);
      r[p] || (rF(s, m), r[p] = !0);
    }
    return De.isArray(t) ? t.forEach(f) : f(t), this;
  }
}
Ew.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
De.freezeMethods(Ew.prototype);
De.freezeMethods(Ew);
const hc = Ew;
function Ik(e, t) {
  const n = this || $S, r = t || n, s = hc.from(r.headers);
  let f = r.data;
  return De.forEach(e, function(p) {
    f = p.call(n, f, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), f;
}
function K4(e) {
  return !!(e && e.__CANCEL__);
}
function lg(e, t, n) {
  In.call(this, e ?? "canceled", In.ERR_CANCELED, t, n), this.name = "CanceledError";
}
De.inherits(lg, In, {
  __CANCEL__: !0
});
function aF(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new In(
    "Request failed with status code " + n.status,
    [In.ERR_BAD_REQUEST, In.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const iF = du.isStandardBrowserEnv ? function() {
  return {
    write: function(n, r, s, f, m, p) {
      const v = [];
      v.push(n + "=" + encodeURIComponent(r)), De.isNumber(s) && v.push("expires=" + new Date(s).toGMTString()), De.isString(f) && v.push("path=" + f), De.isString(m) && v.push("domain=" + m), p === !0 && v.push("secure"), document.cookie = v.join("; ");
    },
    read: function(n) {
      const r = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
      return r ? decodeURIComponent(r[3]) : null;
    },
    remove: function(n) {
      this.write(n, "", Date.now() - 864e5);
    }
  };
}() : function() {
  return {
    write: function() {
    },
    read: function() {
      return null;
    },
    remove: function() {
    }
  };
}();
function oF(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function sF(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function J4(e, t) {
  return e && !oF(t) ? sF(e, t) : t;
}
const lF = du.isStandardBrowserEnv ? function() {
  const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
  let r;
  function s(f) {
    let m = f;
    return t && (n.setAttribute("href", m), m = n.href), n.setAttribute("href", m), {
      href: n.href,
      protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
      host: n.host,
      search: n.search ? n.search.replace(/^\?/, "") : "",
      hash: n.hash ? n.hash.replace(/^#/, "") : "",
      hostname: n.hostname,
      port: n.port,
      pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
    };
  }
  return r = s(window.location.href), function(m) {
    const p = De.isString(m) ? s(m) : m;
    return p.protocol === r.protocol && p.host === r.host;
  };
}() : function() {
  return function() {
    return !0;
  };
}();
function uF(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function cF(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, f = 0, m;
  return t = t !== void 0 ? t : 1e3, function(v) {
    const y = Date.now(), w = r[f];
    m || (m = y), n[s] = v, r[s] = y;
    let P = f, x = 0;
    for (; P !== s; )
      x += n[P++], P = P % e;
    if (s = (s + 1) % e, s === f && (f = (f + 1) % e), y - m < t)
      return;
    const A = w && y - w;
    return A ? Math.round(x * 1e3 / A) : void 0;
  };
}
function qE(e, t) {
  let n = 0;
  const r = cF(50, 250);
  return (s) => {
    const f = s.loaded, m = s.lengthComputable ? s.total : void 0, p = f - n, v = r(p), y = f <= m;
    n = f;
    const w = {
      loaded: f,
      total: m,
      progress: m ? f / m : void 0,
      bytes: p,
      rate: v || void 0,
      estimated: v && m && y ? (m - f) / v : void 0,
      event: s
    };
    w[t ? "download" : "upload"] = !0, e(w);
  };
}
const dF = typeof XMLHttpRequest < "u", fF = dF && function(e) {
  return new Promise(function(n, r) {
    let s = e.data;
    const f = hc.from(e.headers).normalize(), m = e.responseType;
    let p;
    function v() {
      e.cancelToken && e.cancelToken.unsubscribe(p), e.signal && e.signal.removeEventListener("abort", p);
    }
    De.isFormData(s) && (du.isStandardBrowserEnv || du.isStandardBrowserWebWorkerEnv) && f.setContentType(!1);
    let y = new XMLHttpRequest();
    if (e.auth) {
      const A = e.auth.username || "", M = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      f.set("Authorization", "Basic " + btoa(A + ":" + M));
    }
    const w = J4(e.baseURL, e.url);
    y.open(e.method.toUpperCase(), Y4(w, e.params, e.paramsSerializer), !0), y.timeout = e.timeout;
    function P() {
      if (!y)
        return;
      const A = hc.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), O = {
        data: !m || m === "text" || m === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: A,
        config: e,
        request: y
      };
      aF(function(H) {
        n(H), v();
      }, function(H) {
        r(H), v();
      }, O), y = null;
    }
    if ("onloadend" in y ? y.onloadend = P : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(P);
    }, y.onabort = function() {
      y && (r(new In("Request aborted", In.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function() {
      r(new In("Network Error", In.ERR_NETWORK, e, y)), y = null;
    }, y.ontimeout = function() {
      let M = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const O = e.transitional || G4;
      e.timeoutErrorMessage && (M = e.timeoutErrorMessage), r(new In(
        M,
        O.clarifyTimeoutError ? In.ETIMEDOUT : In.ECONNABORTED,
        e,
        y
      )), y = null;
    }, du.isStandardBrowserEnv) {
      const A = (e.withCredentials || lF(w)) && e.xsrfCookieName && iF.read(e.xsrfCookieName);
      A && f.set(e.xsrfHeaderName, A);
    }
    s === void 0 && f.setContentType(null), "setRequestHeader" in y && De.forEach(f.toJSON(), function(M, O) {
      y.setRequestHeader(O, M);
    }), De.isUndefined(e.withCredentials) || (y.withCredentials = !!e.withCredentials), m && m !== "json" && (y.responseType = e.responseType), typeof e.onDownloadProgress == "function" && y.addEventListener("progress", qE(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && y.upload && y.upload.addEventListener("progress", qE(e.onUploadProgress)), (e.cancelToken || e.signal) && (p = (A) => {
      y && (r(!A || A.type ? new lg(null, e, y) : A), y.abort(), y = null);
    }, e.cancelToken && e.cancelToken.subscribe(p), e.signal && (e.signal.aborted ? p() : e.signal.addEventListener("abort", p)));
    const x = uF(w);
    if (x && du.protocols.indexOf(x) === -1) {
      r(new In("Unsupported protocol " + x + ":", In.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(s || null);
  });
}, Bb = {
  http: zI,
  xhr: fF
};
De.forEach(Bb, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const mF = {
  getAdapter: (e) => {
    e = De.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    for (let s = 0; s < t && (n = e[s], !(r = De.isString(n) ? Bb[n.toLowerCase()] : n)); s++)
      ;
    if (!r)
      throw r === !1 ? new In(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        De.hasOwnProp(Bb, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!De.isFunction(r))
      throw new TypeError("adapter is not a function");
    return r;
  },
  adapters: Bb
};
function Fk(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new lg(null, e);
}
function YE(e) {
  return Fk(e), e.headers = hc.from(e.headers), e.data = Ik.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), mF.getAdapter(e.adapter || $S.adapter)(e).then(function(r) {
    return Fk(e), r.data = Ik.call(
      e,
      e.transformResponse,
      r
    ), r.headers = hc.from(r.headers), r;
  }, function(r) {
    return K4(r) || (Fk(e), r && r.response && (r.response.data = Ik.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = hc.from(r.response.headers))), Promise.reject(r);
  });
}
const GE = (e) => e instanceof hc ? e.toJSON() : e;
function Xh(e, t) {
  t = t || {};
  const n = {};
  function r(y, w, P) {
    return De.isPlainObject(y) && De.isPlainObject(w) ? De.merge.call({ caseless: P }, y, w) : De.isPlainObject(w) ? De.merge({}, w) : De.isArray(w) ? w.slice() : w;
  }
  function s(y, w, P) {
    if (De.isUndefined(w)) {
      if (!De.isUndefined(y))
        return r(void 0, y, P);
    } else
      return r(y, w, P);
  }
  function f(y, w) {
    if (!De.isUndefined(w))
      return r(void 0, w);
  }
  function m(y, w) {
    if (De.isUndefined(w)) {
      if (!De.isUndefined(y))
        return r(void 0, y);
    } else
      return r(void 0, w);
  }
  function p(y, w, P) {
    if (P in t)
      return r(y, w);
    if (P in e)
      return r(void 0, y);
  }
  const v = {
    url: f,
    method: f,
    data: f,
    baseURL: m,
    transformRequest: m,
    transformResponse: m,
    paramsSerializer: m,
    timeout: m,
    timeoutMessage: m,
    withCredentials: m,
    adapter: m,
    responseType: m,
    xsrfCookieName: m,
    xsrfHeaderName: m,
    onUploadProgress: m,
    onDownloadProgress: m,
    decompress: m,
    maxContentLength: m,
    maxBodyLength: m,
    beforeRedirect: m,
    transport: m,
    httpAgent: m,
    httpsAgent: m,
    cancelToken: m,
    socketPath: m,
    responseEncoding: m,
    validateStatus: p,
    headers: (y, w) => s(GE(y), GE(w), !0)
  };
  return De.forEach(Object.keys(e).concat(Object.keys(t)), function(w) {
    const P = v[w] || s, x = P(e[w], t[w], w);
    De.isUndefined(x) && P !== p || (n[w] = x);
  }), n;
}
const Z4 = "1.3.3", SS = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  SS[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const QE = {};
SS.transitional = function(t, n, r) {
  function s(f, m) {
    return "[Axios v" + Z4 + "] Transitional option '" + f + "'" + m + (r ? ". " + r : "");
  }
  return (f, m, p) => {
    if (t === !1)
      throw new In(
        s(m, " has been removed" + (n ? " in " + n : "")),
        In.ERR_DEPRECATED
      );
    return n && !QE[m] && (QE[m] = !0, console.warn(
      s(
        m,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(f, m, p) : !0;
  };
};
function hF(e, t, n) {
  if (typeof e != "object")
    throw new In("options must be an object", In.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const f = r[s], m = t[f];
    if (m) {
      const p = e[f], v = p === void 0 || m(p, f, e);
      if (v !== !0)
        throw new In("option " + f + " must be " + v, In.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new In("Unknown option " + f, In.ERR_BAD_OPTION);
  }
}
const _$ = {
  assertOptions: hF,
  validators: SS
}, ld = _$.validators;
class s1 {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new UE(),
      response: new UE()
    };
  }
  request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Xh(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: f } = n;
    r !== void 0 && _$.assertOptions(r, {
      silentJSONParsing: ld.transitional(ld.boolean),
      forcedJSONParsing: ld.transitional(ld.boolean),
      clarifyTimeoutError: ld.transitional(ld.boolean)
    }, !1), s !== void 0 && _$.assertOptions(s, {
      encode: ld.function,
      serialize: ld.function
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let m;
    m = f && De.merge(
      f.common,
      f[n.method]
    ), m && De.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (M) => {
        delete f[M];
      }
    ), n.headers = hc.concat(m, f);
    const p = [];
    let v = !0;
    this.interceptors.request.forEach(function(O) {
      typeof O.runWhen == "function" && O.runWhen(n) === !1 || (v = v && O.synchronous, p.unshift(O.fulfilled, O.rejected));
    });
    const y = [];
    this.interceptors.response.forEach(function(O) {
      y.push(O.fulfilled, O.rejected);
    });
    let w, P = 0, x;
    if (!v) {
      const M = [YE.bind(this), void 0];
      for (M.unshift.apply(M, p), M.push.apply(M, y), x = M.length, w = Promise.resolve(n); P < x; )
        w = w.then(M[P++], M[P++]);
      return w;
    }
    x = p.length;
    let A = n;
    for (P = 0; P < x; ) {
      const M = p[P++], O = p[P++];
      try {
        A = M(A);
      } catch (j) {
        O.call(this, j);
        break;
      }
    }
    try {
      w = YE.call(this, A);
    } catch (M) {
      return Promise.reject(M);
    }
    for (P = 0, x = y.length; P < x; )
      w = w.then(y[P++], y[P++]);
    return w;
  }
  getUri(t) {
    t = Xh(this.defaults, t);
    const n = J4(t.baseURL, t.url);
    return Y4(n, t.params, t.paramsSerializer);
  }
}
De.forEach(["delete", "get", "head", "options"], function(t) {
  s1.prototype[t] = function(n, r) {
    return this.request(Xh(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
De.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(f, m, p) {
      return this.request(Xh(p || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: f,
        data: m
      }));
    };
  }
  s1.prototype[t] = n(), s1.prototype[t + "Form"] = n(!0);
});
const Ub = s1;
class xS {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(f) {
      n = f;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners)
        return;
      let f = r._listeners.length;
      for (; f-- > 0; )
        r._listeners[f](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let f;
      const m = new Promise((p) => {
        r.subscribe(p), f = p;
      }).then(s);
      return m.cancel = function() {
        r.unsubscribe(f);
      }, m;
    }, t(function(f, m, p) {
      r.reason || (r.reason = new lg(f, m, p), n(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  static source() {
    let t;
    return {
      token: new xS(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
}
const pF = xS;
function vF(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function gF(e) {
  return De.isObject(e) && e.isAxiosError === !0;
}
const O$ = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(O$).forEach(([e, t]) => {
  O$[t] = e;
});
const yF = O$;
function eR(e) {
  const t = new Ub(e), n = N4(Ub.prototype.request, t);
  return De.extend(n, Ub.prototype, t, { allOwnKeys: !0 }), De.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return eR(Xh(e, s));
  }, n;
}
const Qa = eR($S);
Qa.Axios = Ub;
Qa.CanceledError = lg;
Qa.CancelToken = pF;
Qa.isCancel = K4;
Qa.VERSION = Z4;
Qa.toFormData = Cw;
Qa.AxiosError = In;
Qa.Cancel = Qa.CanceledError;
Qa.all = function(t) {
  return Promise.all(t);
};
Qa.spread = vF;
Qa.isAxiosError = gF;
Qa.mergeConfig = Xh;
Qa.AxiosHeaders = hc;
Qa.formToJSON = (e) => Q4(De.isHTMLForm(e) ? new FormData(e) : e);
Qa.HttpStatusCode = yF;
Qa.default = Qa;
const bF = Qa;
var bv = globalThis && globalThis.__awaiter || function(e, t, n, r) {
  function s(f) {
    return f instanceof n ? f : new n(function(m) {
      m(f);
    });
  }
  return new (n || (n = Promise))(function(f, m) {
    function p(w) {
      try {
        y(r.next(w));
      } catch (P) {
        m(P);
      }
    }
    function v(w) {
      try {
        y(r.throw(w));
      } catch (P) {
        m(P);
      }
    }
    function y(w) {
      w.done ? f(w.value) : s(w.value).then(p, v);
    }
    y((r = r.apply(e, t || [])).next());
  });
};
class wF {
  constructor(t) {
    this.backendUrl = t, this.axiosClient = bF.create({
      baseURL: t + "/v1"
    });
  }
  setAuthorizationToken(t) {
    this.axiosClient.defaults.headers.common.Authorization = `Bearer ${t}`;
  }
  disposeAuthorizationToken() {
    delete this.axiosClient.defaults.headers.common.Authorization;
  }
  getFullResponse(t, n) {
    return bv(this, void 0, void 0, function* () {
      return yield this.axiosClient.get(t, {
        params: n
      }).then((r) => r.data);
    });
  }
  get(t, n) {
    return bv(this, void 0, void 0, function* () {
      return yield this.axiosClient.get(t, {
        params: n
      }).then((r) => r.data.data);
    });
  }
  post(t, n = {}) {
    return bv(this, void 0, void 0, function* () {
      return yield this.axiosClient.post(t, n).then((r) => r.data.data);
    });
  }
  patch(t, n = {}) {
    return bv(this, void 0, void 0, function* () {
      return yield this.axiosClient.patch(t, n).then((r) => r.data.data);
    });
  }
  delete(t, n = {}) {
    return bv(this, void 0, void 0, function* () {
      return yield this.axiosClient.delete(t, n).then((r) => r.data.data);
    });
  }
}
var KE;
(function(e) {
  e[e.WEB = 0] = "WEB", e[e.API = 1] = "API", e[e.WIDGET = 2] = "WIDGET", e[e.WS = 3] = "WS";
})(KE || (KE = {}));
var dc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function tR(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var F = { exports: {} }, Tn = {};
var Hk, JE;
function Aw() {
  if (JE)
    return Hk;
  JE = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(f) {
    if (f == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(f);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var f = new String("abc");
      if (f[5] = "de", Object.getOwnPropertyNames(f)[0] === "5")
        return !1;
      for (var m = {}, p = 0; p < 10; p++)
        m["_" + String.fromCharCode(p)] = p;
      var v = Object.getOwnPropertyNames(m).map(function(w) {
        return m[w];
      });
      if (v.join("") !== "0123456789")
        return !1;
      var y = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(w) {
        y[w] = w;
      }), Object.keys(Object.assign({}, y)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Hk = s() ? Object.assign : function(f, m) {
    for (var p, v = r(f), y, w = 1; w < arguments.length; w++) {
      p = Object(arguments[w]);
      for (var P in p)
        t.call(p, P) && (v[P] = p[P]);
      if (e) {
        y = e(p);
        for (var x = 0; x < y.length; x++)
          n.call(p, y[x]) && (v[y[x]] = p[y[x]]);
      }
    }
    return v;
  }, Hk;
}
var ZE;
function PF() {
  if (ZE)
    return Tn;
  ZE = 1;
  var e = Aw(), t = 60103, n = 60106;
  Tn.Fragment = 60107, Tn.StrictMode = 60108, Tn.Profiler = 60114;
  var r = 60109, s = 60110, f = 60112;
  Tn.Suspense = 60113;
  var m = 60115, p = 60116;
  if (typeof Symbol == "function" && Symbol.for) {
    var v = Symbol.for;
    t = v("react.element"), n = v("react.portal"), Tn.Fragment = v("react.fragment"), Tn.StrictMode = v("react.strict_mode"), Tn.Profiler = v("react.profiler"), r = v("react.provider"), s = v("react.context"), f = v("react.forward_ref"), Tn.Suspense = v("react.suspense"), m = v("react.memo"), p = v("react.lazy");
  }
  var y = typeof Symbol == "function" && Symbol.iterator;
  function w(ie) {
    return ie === null || typeof ie != "object" ? null : (ie = y && ie[y] || ie["@@iterator"], typeof ie == "function" ? ie : null);
  }
  function P(ie) {
    for (var xe = "https://reactjs.org/docs/error-decoder.html?invariant=" + ie, Ye = 1; Ye < arguments.length; Ye++)
      xe += "&args[]=" + encodeURIComponent(arguments[Ye]);
    return "Minified React error #" + ie + "; visit " + xe + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var x = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, A = {};
  function M(ie, xe, Ye) {
    this.props = ie, this.context = xe, this.refs = A, this.updater = Ye || x;
  }
  M.prototype.isReactComponent = {}, M.prototype.setState = function(ie, xe) {
    if (typeof ie != "object" && typeof ie != "function" && ie != null)
      throw Error(P(85));
    this.updater.enqueueSetState(this, ie, xe, "setState");
  }, M.prototype.forceUpdate = function(ie) {
    this.updater.enqueueForceUpdate(this, ie, "forceUpdate");
  };
  function O() {
  }
  O.prototype = M.prototype;
  function j(ie, xe, Ye) {
    this.props = ie, this.context = xe, this.refs = A, this.updater = Ye || x;
  }
  var H = j.prototype = new O();
  H.constructor = j, e(H, M.prototype), H.isPureReactComponent = !0;
  var J = { current: null }, V = Object.prototype.hasOwnProperty, X = { key: !0, ref: !0, __self: !0, __source: !0 };
  function U(ie, xe, Ye) {
    var Be, Ce = {}, Ie = null, $e = null;
    if (xe != null)
      for (Be in xe.ref !== void 0 && ($e = xe.ref), xe.key !== void 0 && (Ie = "" + xe.key), xe)
        V.call(xe, Be) && !X.hasOwnProperty(Be) && (Ce[Be] = xe[Be]);
    var ot = arguments.length - 2;
    if (ot === 1)
      Ce.children = Ye;
    else if (1 < ot) {
      for (var ht = Array(ot), At = 0; At < ot; At++)
        ht[At] = arguments[At + 2];
      Ce.children = ht;
    }
    if (ie && ie.defaultProps)
      for (Be in ot = ie.defaultProps, ot)
        Ce[Be] === void 0 && (Ce[Be] = ot[Be]);
    return { $$typeof: t, type: ie, key: Ie, ref: $e, props: Ce, _owner: J.current };
  }
  function K(ie, xe) {
    return { $$typeof: t, type: ie.type, key: xe, ref: ie.ref, props: ie.props, _owner: ie._owner };
  }
  function ce(ie) {
    return typeof ie == "object" && ie !== null && ie.$$typeof === t;
  }
  function ue(ie) {
    var xe = { "=": "=0", ":": "=2" };
    return "$" + ie.replace(/[=:]/g, function(Ye) {
      return xe[Ye];
    });
  }
  var ye = /\/+/g;
  function Oe(ie, xe) {
    return typeof ie == "object" && ie !== null && ie.key != null ? ue("" + ie.key) : xe.toString(36);
  }
  function _e(ie, xe, Ye, Be, Ce) {
    var Ie = typeof ie;
    (Ie === "undefined" || Ie === "boolean") && (ie = null);
    var $e = !1;
    if (ie === null)
      $e = !0;
    else
      switch (Ie) {
        case "string":
        case "number":
          $e = !0;
          break;
        case "object":
          switch (ie.$$typeof) {
            case t:
            case n:
              $e = !0;
          }
      }
    if ($e)
      return $e = ie, Ce = Ce($e), ie = Be === "" ? "." + Oe($e, 0) : Be, Array.isArray(Ce) ? (Ye = "", ie != null && (Ye = ie.replace(ye, "$&/") + "/"), _e(Ce, xe, Ye, "", function(At) {
        return At;
      })) : Ce != null && (ce(Ce) && (Ce = K(Ce, Ye + (!Ce.key || $e && $e.key === Ce.key ? "" : ("" + Ce.key).replace(ye, "$&/") + "/") + ie)), xe.push(Ce)), 1;
    if ($e = 0, Be = Be === "" ? "." : Be + ":", Array.isArray(ie))
      for (var ot = 0; ot < ie.length; ot++) {
        Ie = ie[ot];
        var ht = Be + Oe(Ie, ot);
        $e += _e(Ie, xe, Ye, ht, Ce);
      }
    else if (ht = w(ie), typeof ht == "function")
      for (ie = ht.call(ie), ot = 0; !(Ie = ie.next()).done; )
        Ie = Ie.value, ht = Be + Oe(Ie, ot++), $e += _e(Ie, xe, Ye, ht, Ce);
    else if (Ie === "object")
      throw xe = "" + ie, Error(P(31, xe === "[object Object]" ? "object with keys {" + Object.keys(ie).join(", ") + "}" : xe));
    return $e;
  }
  function Le(ie, xe, Ye) {
    if (ie == null)
      return ie;
    var Be = [], Ce = 0;
    return _e(ie, Be, "", "", function(Ie) {
      return xe.call(Ye, Ie, Ce++);
    }), Be;
  }
  function Ne(ie) {
    if (ie._status === -1) {
      var xe = ie._result;
      xe = xe(), ie._status = 0, ie._result = xe, xe.then(function(Ye) {
        ie._status === 0 && (Ye = Ye.default, ie._status = 1, ie._result = Ye);
      }, function(Ye) {
        ie._status === 0 && (ie._status = 2, ie._result = Ye);
      });
    }
    if (ie._status === 1)
      return ie._result;
    throw ie._result;
  }
  var nt = { current: null };
  function Qe() {
    var ie = nt.current;
    if (ie === null)
      throw Error(P(321));
    return ie;
  }
  var qe = { ReactCurrentDispatcher: nt, ReactCurrentBatchConfig: { transition: 0 }, ReactCurrentOwner: J, IsSomeRendererActing: { current: !1 }, assign: e };
  return Tn.Children = { map: Le, forEach: function(ie, xe, Ye) {
    Le(ie, function() {
      xe.apply(this, arguments);
    }, Ye);
  }, count: function(ie) {
    var xe = 0;
    return Le(ie, function() {
      xe++;
    }), xe;
  }, toArray: function(ie) {
    return Le(ie, function(xe) {
      return xe;
    }) || [];
  }, only: function(ie) {
    if (!ce(ie))
      throw Error(P(143));
    return ie;
  } }, Tn.Component = M, Tn.PureComponent = j, Tn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = qe, Tn.cloneElement = function(ie, xe, Ye) {
    if (ie == null)
      throw Error(P(267, ie));
    var Be = e({}, ie.props), Ce = ie.key, Ie = ie.ref, $e = ie._owner;
    if (xe != null) {
      if (xe.ref !== void 0 && (Ie = xe.ref, $e = J.current), xe.key !== void 0 && (Ce = "" + xe.key), ie.type && ie.type.defaultProps)
        var ot = ie.type.defaultProps;
      for (ht in xe)
        V.call(xe, ht) && !X.hasOwnProperty(ht) && (Be[ht] = xe[ht] === void 0 && ot !== void 0 ? ot[ht] : xe[ht]);
    }
    var ht = arguments.length - 2;
    if (ht === 1)
      Be.children = Ye;
    else if (1 < ht) {
      ot = Array(ht);
      for (var At = 0; At < ht; At++)
        ot[At] = arguments[At + 2];
      Be.children = ot;
    }
    return {
      $$typeof: t,
      type: ie.type,
      key: Ce,
      ref: Ie,
      props: Be,
      _owner: $e
    };
  }, Tn.createContext = function(ie, xe) {
    return xe === void 0 && (xe = null), ie = { $$typeof: s, _calculateChangedBits: xe, _currentValue: ie, _currentValue2: ie, _threadCount: 0, Provider: null, Consumer: null }, ie.Provider = { $$typeof: r, _context: ie }, ie.Consumer = ie;
  }, Tn.createElement = U, Tn.createFactory = function(ie) {
    var xe = U.bind(null, ie);
    return xe.type = ie, xe;
  }, Tn.createRef = function() {
    return { current: null };
  }, Tn.forwardRef = function(ie) {
    return { $$typeof: f, render: ie };
  }, Tn.isValidElement = ce, Tn.lazy = function(ie) {
    return { $$typeof: p, _payload: { _status: -1, _result: ie }, _init: Ne };
  }, Tn.memo = function(ie, xe) {
    return { $$typeof: m, type: ie, compare: xe === void 0 ? null : xe };
  }, Tn.useCallback = function(ie, xe) {
    return Qe().useCallback(ie, xe);
  }, Tn.useContext = function(ie, xe) {
    return Qe().useContext(ie, xe);
  }, Tn.useDebugValue = function() {
  }, Tn.useEffect = function(ie, xe) {
    return Qe().useEffect(ie, xe);
  }, Tn.useImperativeHandle = function(ie, xe, Ye) {
    return Qe().useImperativeHandle(ie, xe, Ye);
  }, Tn.useLayoutEffect = function(ie, xe) {
    return Qe().useLayoutEffect(ie, xe);
  }, Tn.useMemo = function(ie, xe) {
    return Qe().useMemo(ie, xe);
  }, Tn.useReducer = function(ie, xe, Ye) {
    return Qe().useReducer(ie, xe, Ye);
  }, Tn.useRef = function(ie) {
    return Qe().useRef(ie);
  }, Tn.useState = function(ie) {
    return Qe().useState(ie);
  }, Tn.version = "17.0.2", Tn;
}
var Vk = {};
var eA;
function kF() {
  return eA || (eA = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = Aw(), n = "17.0.2", r = 60103, s = 60106;
      e.Fragment = 60107, e.StrictMode = 60108, e.Profiler = 60114;
      var f = 60109, m = 60110, p = 60112;
      e.Suspense = 60113;
      var v = 60120, y = 60115, w = 60116, P = 60121, x = 60122, A = 60117, M = 60129, O = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var j = Symbol.for;
        r = j("react.element"), s = j("react.portal"), e.Fragment = j("react.fragment"), e.StrictMode = j("react.strict_mode"), e.Profiler = j("react.profiler"), f = j("react.provider"), m = j("react.context"), p = j("react.forward_ref"), e.Suspense = j("react.suspense"), v = j("react.suspense_list"), y = j("react.memo"), w = j("react.lazy"), P = j("react.block"), x = j("react.server.block"), A = j("react.fundamental"), j("react.scope"), j("react.opaque.id"), M = j("react.debug_trace_mode"), j("react.offscreen"), O = j("react.legacy_hidden");
      }
      var H = typeof Symbol == "function" && Symbol.iterator, J = "@@iterator";
      function V(L) {
        if (L === null || typeof L != "object")
          return null;
        var oe = H && L[H] || L[J];
        return typeof oe == "function" ? oe : null;
      }
      var X = {
        current: null
      }, U = {
        transition: 0
      }, K = {
        current: null
      }, ce = {}, ue = null;
      function ye(L) {
        ue = L;
      }
      ce.setExtraStackFrame = function(L) {
        ue = L;
      }, ce.getCurrentStack = null, ce.getStackAddendum = function() {
        var L = "";
        ue && (L += ue);
        var oe = ce.getCurrentStack;
        return oe && (L += oe() || ""), L;
      };
      var Oe = {
        current: !1
      }, _e = {
        ReactCurrentDispatcher: X,
        ReactCurrentBatchConfig: U,
        ReactCurrentOwner: K,
        IsSomeRendererActing: Oe,
        assign: t
      };
      _e.ReactDebugCurrentFrame = ce;
      function Le(L) {
        {
          for (var oe = arguments.length, be = new Array(oe > 1 ? oe - 1 : 0), Ee = 1; Ee < oe; Ee++)
            be[Ee - 1] = arguments[Ee];
          nt("warn", L, be);
        }
      }
      function Ne(L) {
        {
          for (var oe = arguments.length, be = new Array(oe > 1 ? oe - 1 : 0), Ee = 1; Ee < oe; Ee++)
            be[Ee - 1] = arguments[Ee];
          nt("error", L, be);
        }
      }
      function nt(L, oe, be) {
        {
          var Ee = _e.ReactDebugCurrentFrame, Ze = Ee.getStackAddendum();
          Ze !== "" && (oe += "%s", be = be.concat([Ze]));
          var Et = be.map(function(wt) {
            return "" + wt;
          });
          Et.unshift("Warning: " + oe), Function.prototype.apply.call(console[L], console, Et);
        }
      }
      var Qe = {};
      function qe(L, oe) {
        {
          var be = L.constructor, Ee = be && (be.displayName || be.name) || "ReactClass", Ze = Ee + "." + oe;
          if (Qe[Ze])
            return;
          Ne("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", oe, Ee), Qe[Ze] = !0;
        }
      }
      var ie = {
        isMounted: function(L) {
          return !1;
        },
        enqueueForceUpdate: function(L, oe, be) {
          qe(L, "forceUpdate");
        },
        enqueueReplaceState: function(L, oe, be, Ee) {
          qe(L, "replaceState");
        },
        enqueueSetState: function(L, oe, be, Ee) {
          qe(L, "setState");
        }
      }, xe = {};
      Object.freeze(xe);
      function Ye(L, oe, be) {
        this.props = L, this.context = oe, this.refs = xe, this.updater = be || ie;
      }
      Ye.prototype.isReactComponent = {}, Ye.prototype.setState = function(L, oe) {
        if (!(typeof L == "object" || typeof L == "function" || L == null))
          throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, L, oe, "setState");
      }, Ye.prototype.forceUpdate = function(L) {
        this.updater.enqueueForceUpdate(this, L, "forceUpdate");
      };
      {
        var Be = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, Ce = function(L, oe) {
          Object.defineProperty(Ye.prototype, L, {
            get: function() {
              Le("%s(...) is deprecated in plain JavaScript React classes. %s", oe[0], oe[1]);
            }
          });
        };
        for (var Ie in Be)
          Be.hasOwnProperty(Ie) && Ce(Ie, Be[Ie]);
      }
      function $e() {
      }
      $e.prototype = Ye.prototype;
      function ot(L, oe, be) {
        this.props = L, this.context = oe, this.refs = xe, this.updater = be || ie;
      }
      var ht = ot.prototype = new $e();
      ht.constructor = ot, t(ht, Ye.prototype), ht.isPureReactComponent = !0;
      function At() {
        var L = {
          current: null
        };
        return Object.seal(L), L;
      }
      function Sn(L, oe, be) {
        var Ee = oe.displayName || oe.name || "";
        return L.displayName || (Ee !== "" ? be + "(" + Ee + ")" : be);
      }
      function Gt(L) {
        return L.displayName || "Context";
      }
      function Bt(L) {
        if (L == null)
          return null;
        if (typeof L.tag == "number" && Ne("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof L == "function")
          return L.displayName || L.name || null;
        if (typeof L == "string")
          return L;
        switch (L) {
          case e.Fragment:
            return "Fragment";
          case s:
            return "Portal";
          case e.Profiler:
            return "Profiler";
          case e.StrictMode:
            return "StrictMode";
          case e.Suspense:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof L == "object")
          switch (L.$$typeof) {
            case m:
              var oe = L;
              return Gt(oe) + ".Consumer";
            case f:
              var be = L;
              return Gt(be._context) + ".Provider";
            case p:
              return Sn(L, L.render, "ForwardRef");
            case y:
              return Bt(L.type);
            case P:
              return Bt(L._render);
            case w: {
              var Ee = L, Ze = Ee._payload, Et = Ee._init;
              try {
                return Bt(Et(Ze));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Qn = Object.prototype.hasOwnProperty, cn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ge, vr, Fn;
      Fn = {};
      function en(L) {
        if (Qn.call(L, "ref")) {
          var oe = Object.getOwnPropertyDescriptor(L, "ref").get;
          if (oe && oe.isReactWarning)
            return !1;
        }
        return L.ref !== void 0;
      }
      function Gr(L) {
        if (Qn.call(L, "key")) {
          var oe = Object.getOwnPropertyDescriptor(L, "key").get;
          if (oe && oe.isReactWarning)
            return !1;
        }
        return L.key !== void 0;
      }
      function da(L, oe) {
        var be = function() {
          Ge || (Ge = !0, Ne("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", oe));
        };
        be.isReactWarning = !0, Object.defineProperty(L, "key", {
          get: be,
          configurable: !0
        });
      }
      function gr(L, oe) {
        var be = function() {
          vr || (vr = !0, Ne("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", oe));
        };
        be.isReactWarning = !0, Object.defineProperty(L, "ref", {
          get: be,
          configurable: !0
        });
      }
      function qi(L) {
        if (typeof L.ref == "string" && K.current && L.__self && K.current.stateNode !== L.__self) {
          var oe = Bt(K.current.type);
          Fn[oe] || (Ne('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', oe, L.ref), Fn[oe] = !0);
        }
      }
      var Wr = function(L, oe, be, Ee, Ze, Et, wt) {
        var xt = {
          $$typeof: r,
          type: L,
          key: oe,
          ref: be,
          props: wt,
          _owner: Et
        };
        return xt._store = {}, Object.defineProperty(xt._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(xt, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ee
        }), Object.defineProperty(xt, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ze
        }), Object.freeze && (Object.freeze(xt.props), Object.freeze(xt)), xt;
      };
      function fa(L, oe, be) {
        var Ee, Ze = {}, Et = null, wt = null, xt = null, Pt = null;
        if (oe != null) {
          en(oe) && (wt = oe.ref, qi(oe)), Gr(oe) && (Et = "" + oe.key), xt = oe.__self === void 0 ? null : oe.__self, Pt = oe.__source === void 0 ? null : oe.__source;
          for (Ee in oe)
            Qn.call(oe, Ee) && !cn.hasOwnProperty(Ee) && (Ze[Ee] = oe[Ee]);
        }
        var Qt = arguments.length - 2;
        if (Qt === 1)
          Ze.children = be;
        else if (Qt > 1) {
          for (var dn = Array(Qt), Wn = 0; Wn < Qt; Wn++)
            dn[Wn] = arguments[Wn + 2];
          Object.freeze && Object.freeze(dn), Ze.children = dn;
        }
        if (L && L.defaultProps) {
          var Hn = L.defaultProps;
          for (Ee in Hn)
            Ze[Ee] === void 0 && (Ze[Ee] = Hn[Ee]);
        }
        if (Et || wt) {
          var wr = typeof L == "function" ? L.displayName || L.name || "Unknown" : L;
          Et && da(Ze, wr), wt && gr(Ze, wr);
        }
        return Wr(L, Et, wt, xt, Pt, K.current, Ze);
      }
      function xa(L, oe) {
        var be = Wr(L.type, oe, L.ref, L._self, L._source, L._owner, L.props);
        return be;
      }
      function fr(L, oe, be) {
        if (L == null)
          throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + L + ".");
        var Ee, Ze = t({}, L.props), Et = L.key, wt = L.ref, xt = L._self, Pt = L._source, Qt = L._owner;
        if (oe != null) {
          en(oe) && (wt = oe.ref, Qt = K.current), Gr(oe) && (Et = "" + oe.key);
          var dn;
          L.type && L.type.defaultProps && (dn = L.type.defaultProps);
          for (Ee in oe)
            Qn.call(oe, Ee) && !cn.hasOwnProperty(Ee) && (oe[Ee] === void 0 && dn !== void 0 ? Ze[Ee] = dn[Ee] : Ze[Ee] = oe[Ee]);
        }
        var Wn = arguments.length - 2;
        if (Wn === 1)
          Ze.children = be;
        else if (Wn > 1) {
          for (var Hn = Array(Wn), wr = 0; wr < Wn; wr++)
            Hn[wr] = arguments[wr + 2];
          Ze.children = Hn;
        }
        return Wr(L.type, Et, wt, xt, Pt, Qt, Ze);
      }
      function Xn(L) {
        return typeof L == "object" && L !== null && L.$$typeof === r;
      }
      var Hr = ".", Dn = ":";
      function Nn(L) {
        var oe = /[=:]/g, be = {
          "=": "=0",
          ":": "=2"
        }, Ee = L.replace(oe, function(Ze) {
          return be[Ze];
        });
        return "$" + Ee;
      }
      var Ca = !1, Ia = /\/+/g;
      function Fa(L) {
        return L.replace(Ia, "$&/");
      }
      function et(L, oe) {
        return typeof L == "object" && L !== null && L.key != null ? Nn("" + L.key) : oe.toString(36);
      }
      function ft(L, oe, be, Ee, Ze) {
        var Et = typeof L;
        (Et === "undefined" || Et === "boolean") && (L = null);
        var wt = !1;
        if (L === null)
          wt = !0;
        else
          switch (Et) {
            case "string":
            case "number":
              wt = !0;
              break;
            case "object":
              switch (L.$$typeof) {
                case r:
                case s:
                  wt = !0;
              }
          }
        if (wt) {
          var xt = L, Pt = Ze(xt), Qt = Ee === "" ? Hr + et(xt, 0) : Ee;
          if (Array.isArray(Pt)) {
            var dn = "";
            Qt != null && (dn = Fa(Qt) + "/"), ft(Pt, oe, dn, "", function(Ke) {
              return Ke;
            });
          } else
            Pt != null && (Xn(Pt) && (Pt = xa(
              Pt,
              be + (Pt.key && (!xt || xt.key !== Pt.key) ? Fa("" + Pt.key) + "/" : "") + Qt
            )), oe.push(Pt));
          return 1;
        }
        var Wn, Hn, wr = 0, jn = Ee === "" ? Hr : Ee + Dn;
        if (Array.isArray(L))
          for (var ga = 0; ga < L.length; ga++)
            Wn = L[ga], Hn = jn + et(Wn, ga), wr += ft(Wn, oe, be, Hn, Ze);
        else {
          var Di = V(L);
          if (typeof Di == "function") {
            var B = L;
            Di === B.entries && (Ca || Le("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Ca = !0);
            for (var ve = Di.call(B), N, Z = 0; !(N = ve.next()).done; )
              Wn = N.value, Hn = jn + et(Wn, Z++), wr += ft(Wn, oe, be, Hn, Ze);
          } else if (Et === "object") {
            var de = "" + L;
            throw Error("Objects are not valid as a React child (found: " + (de === "[object Object]" ? "object with keys {" + Object.keys(L).join(", ") + "}" : de) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return wr;
      }
      function _t(L, oe, be) {
        if (L == null)
          return L;
        var Ee = [], Ze = 0;
        return ft(L, Ee, "", "", function(Et) {
          return oe.call(be, Et, Ze++);
        }), Ee;
      }
      function an(L) {
        var oe = 0;
        return _t(L, function() {
          oe++;
        }), oe;
      }
      function ir(L, oe, be) {
        _t(L, function() {
          oe.apply(this, arguments);
        }, be);
      }
      function pn(L) {
        return _t(L, function(oe) {
          return oe;
        }) || [];
      }
      function vn(L) {
        if (!Xn(L))
          throw Error("React.Children.only expected to receive a single React element child.");
        return L;
      }
      function Kn(L, oe) {
        oe === void 0 ? oe = null : oe !== null && typeof oe != "function" && Ne("createContext: Expected the optional second argument to be a function. Instead received: %s", oe);
        var be = {
          $$typeof: m,
          _calculateChangedBits: oe,
          _currentValue: L,
          _currentValue2: L,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        };
        be.Provider = {
          $$typeof: f,
          _context: be
        };
        var Ee = !1, Ze = !1, Et = !1;
        {
          var wt = {
            $$typeof: m,
            _context: be,
            _calculateChangedBits: be._calculateChangedBits
          };
          Object.defineProperties(wt, {
            Provider: {
              get: function() {
                return Ze || (Ze = !0, Ne("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), be.Provider;
              },
              set: function(xt) {
                be.Provider = xt;
              }
            },
            _currentValue: {
              get: function() {
                return be._currentValue;
              },
              set: function(xt) {
                be._currentValue = xt;
              }
            },
            _currentValue2: {
              get: function() {
                return be._currentValue2;
              },
              set: function(xt) {
                be._currentValue2 = xt;
              }
            },
            _threadCount: {
              get: function() {
                return be._threadCount;
              },
              set: function(xt) {
                be._threadCount = xt;
              }
            },
            Consumer: {
              get: function() {
                return Ee || (Ee = !0, Ne("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), be.Consumer;
              }
            },
            displayName: {
              get: function() {
                return be.displayName;
              },
              set: function(xt) {
                Et || (Le("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", xt), Et = !0);
              }
            }
          }), be.Consumer = wt;
        }
        return be._currentRenderer = null, be._currentRenderer2 = null, be;
      }
      var Pn = -1, Vr = 0, pi = 1, Ar = 2;
      function Oi(L) {
        if (L._status === Pn) {
          var oe = L._result, be = oe(), Ee = L;
          Ee._status = Vr, Ee._result = be, be.then(function(Ze) {
            if (L._status === Vr) {
              var Et = Ze.default;
              Et === void 0 && Ne(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, Ze);
              var wt = L;
              wt._status = pi, wt._result = Et;
            }
          }, function(Ze) {
            if (L._status === Vr) {
              var Et = L;
              Et._status = Ar, Et._result = Ze;
            }
          });
        }
        if (L._status === pi)
          return L._result;
        throw L._result;
      }
      function Qr(L) {
        var oe = {
          _status: -1,
          _result: L
        }, be = {
          $$typeof: w,
          _payload: oe,
          _init: Oi
        };
        {
          var Ee, Ze;
          Object.defineProperties(be, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return Ee;
              },
              set: function(Et) {
                Ne("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Ee = Et, Object.defineProperty(be, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return Ze;
              },
              set: function(Et) {
                Ne("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Ze = Et, Object.defineProperty(be, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return be;
      }
      function Ha(L) {
        L != null && L.$$typeof === y ? Ne("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof L != "function" ? Ne("forwardRef requires a render function but was given %s.", L === null ? "null" : typeof L) : L.length !== 0 && L.length !== 2 && Ne("forwardRef render functions accept exactly two parameters: props and ref. %s", L.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), L != null && (L.defaultProps != null || L.propTypes != null) && Ne("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var oe = {
          $$typeof: p,
          render: L
        };
        {
          var be;
          Object.defineProperty(oe, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return be;
            },
            set: function(Ee) {
              be = Ee, L.displayName == null && (L.displayName = Ee);
            }
          });
        }
        return oe;
      }
      var ma = !1;
      function Kr(L) {
        return !!(typeof L == "string" || typeof L == "function" || L === e.Fragment || L === e.Profiler || L === M || L === e.StrictMode || L === e.Suspense || L === v || L === O || ma || typeof L == "object" && L !== null && (L.$$typeof === w || L.$$typeof === y || L.$$typeof === f || L.$$typeof === m || L.$$typeof === p || L.$$typeof === A || L.$$typeof === P || L[0] === x));
      }
      function Ka(L, oe) {
        Kr(L) || Ne("memo: The first argument must be a component. Instead received: %s", L === null ? "null" : typeof L);
        var be = {
          $$typeof: y,
          type: L,
          compare: oe === void 0 ? null : oe
        };
        {
          var Ee;
          Object.defineProperty(be, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return Ee;
            },
            set: function(Ze) {
              Ee = Ze, L.displayName == null && (L.displayName = Ze);
            }
          });
        }
        return be;
      }
      function Jn() {
        var L = X.current;
        if (L === null)
          throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
        return L;
      }
      function or(L, oe) {
        var be = Jn();
        if (oe !== void 0 && Ne("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", oe, typeof oe == "number" && Array.isArray(arguments[2]) ? `

Did you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks` : ""), L._context !== void 0) {
          var Ee = L._context;
          Ee.Consumer === L ? Ne("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : Ee.Provider === L && Ne("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return be.useContext(L, oe);
      }
      function yo(L) {
        var oe = Jn();
        return oe.useState(L);
      }
      function Ti(L, oe, be) {
        var Ee = Jn();
        return Ee.useReducer(L, oe, be);
      }
      function Yi(L) {
        var oe = Jn();
        return oe.useRef(L);
      }
      function Gi(L, oe) {
        var be = Jn();
        return be.useEffect(L, oe);
      }
      function Ma(L, oe) {
        var be = Jn();
        return be.useLayoutEffect(L, oe);
      }
      function Zt(L, oe) {
        var be = Jn();
        return be.useCallback(L, oe);
      }
      function gi(L, oe) {
        var be = Jn();
        return be.useMemo(L, oe);
      }
      function qs(L, oe, be) {
        var Ee = Jn();
        return Ee.useImperativeHandle(L, oe, be);
      }
      function Jr(L, oe) {
        {
          var be = Jn();
          return be.useDebugValue(L, oe);
        }
      }
      var ha = 0, yi, Br, Ja, Ri, bi, Qi, bo;
      function Za() {
      }
      Za.__reactDisabledLog = !0;
      function Zr() {
        {
          if (ha === 0) {
            yi = console.log, Br = console.info, Ja = console.warn, Ri = console.error, bi = console.group, Qi = console.groupCollapsed, bo = console.groupEnd;
            var L = {
              configurable: !0,
              enumerable: !0,
              value: Za,
              writable: !0
            };
            Object.defineProperties(console, {
              info: L,
              log: L,
              warn: L,
              error: L,
              group: L,
              groupCollapsed: L,
              groupEnd: L
            });
          }
          ha++;
        }
      }
      function mr() {
        {
          if (ha--, ha === 0) {
            var L = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: t({}, L, {
                value: yi
              }),
              info: t({}, L, {
                value: Br
              }),
              warn: t({}, L, {
                value: Ja
              }),
              error: t({}, L, {
                value: Ri
              }),
              group: t({}, L, {
                value: bi
              }),
              groupCollapsed: t({}, L, {
                value: Qi
              }),
              groupEnd: t({}, L, {
                value: bo
              })
            });
          }
          ha < 0 && Ne("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Va = _e.ReactCurrentDispatcher, ei;
      function pa(L, oe, be) {
        {
          if (ei === void 0)
            try {
              throw Error();
            } catch (Ze) {
              var Ee = Ze.stack.trim().match(/\n( *(at )?)/);
              ei = Ee && Ee[1] || "";
            }
          return `
` + ei + L;
        }
      }
      var Ba = !1, Ea;
      {
        var Ki = typeof WeakMap == "function" ? WeakMap : Map;
        Ea = new Ki();
      }
      function ti(L, oe) {
        if (!L || Ba)
          return "";
        {
          var be = Ea.get(L);
          if (be !== void 0)
            return be;
        }
        var Ee;
        Ba = !0;
        var Ze = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Et;
        Et = Va.current, Va.current = null, Zr();
        try {
          if (oe) {
            var wt = function() {
              throw Error();
            };
            if (Object.defineProperty(wt.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(wt, []);
              } catch (jn) {
                Ee = jn;
              }
              Reflect.construct(L, [], wt);
            } else {
              try {
                wt.call();
              } catch (jn) {
                Ee = jn;
              }
              L.call(wt.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (jn) {
              Ee = jn;
            }
            L();
          }
        } catch (jn) {
          if (jn && Ee && typeof jn.stack == "string") {
            for (var xt = jn.stack.split(`
`), Pt = Ee.stack.split(`
`), Qt = xt.length - 1, dn = Pt.length - 1; Qt >= 1 && dn >= 0 && xt[Qt] !== Pt[dn]; )
              dn--;
            for (; Qt >= 1 && dn >= 0; Qt--, dn--)
              if (xt[Qt] !== Pt[dn]) {
                if (Qt !== 1 || dn !== 1)
                  do
                    if (Qt--, dn--, dn < 0 || xt[Qt] !== Pt[dn]) {
                      var Wn = `
` + xt[Qt].replace(" at new ", " at ");
                      return typeof L == "function" && Ea.set(L, Wn), Wn;
                    }
                  while (Qt >= 1 && dn >= 0);
                break;
              }
          }
        } finally {
          Ba = !1, Va.current = Et, mr(), Error.prepareStackTrace = Ze;
        }
        var Hn = L ? L.displayName || L.name : "", wr = Hn ? pa(Hn) : "";
        return typeof L == "function" && Ea.set(L, wr), wr;
      }
      function Aa(L, oe, be) {
        return ti(L, !1);
      }
      function Ua(L) {
        var oe = L.prototype;
        return !!(oe && oe.isReactComponent);
      }
      function va(L, oe, be) {
        if (L == null)
          return "";
        if (typeof L == "function")
          return ti(L, Ua(L));
        if (typeof L == "string")
          return pa(L);
        switch (L) {
          case e.Suspense:
            return pa("Suspense");
          case v:
            return pa("SuspenseList");
        }
        if (typeof L == "object")
          switch (L.$$typeof) {
            case p:
              return Aa(L.render);
            case y:
              return va(L.type, oe, be);
            case P:
              return Aa(L._render);
            case w: {
              var Ee = L, Ze = Ee._payload, Et = Ee._init;
              try {
                return va(Et(Ze), oe, be);
              } catch {
              }
            }
          }
        return "";
      }
      var Ur = {}, Xa = _e.ReactDebugCurrentFrame;
      function ea(L) {
        if (L) {
          var oe = L._owner, be = va(L.type, L._source, oe ? oe.type : null);
          Xa.setExtraStackFrame(be);
        } else
          Xa.setExtraStackFrame(null);
      }
      function ni(L, oe, be, Ee, Ze) {
        {
          var Et = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var wt in L)
            if (Et(L, wt)) {
              var xt = void 0;
              try {
                if (typeof L[wt] != "function") {
                  var Pt = Error((Ee || "React class") + ": " + be + " type `" + wt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof L[wt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Pt.name = "Invariant Violation", Pt;
                }
                xt = L[wt](oe, wt, Ee, be, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Qt) {
                xt = Qt;
              }
              xt && !(xt instanceof Error) && (ea(Ze), Ne("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ee || "React class", be, wt, typeof xt), ea(null)), xt instanceof Error && !(xt.message in Ur) && (Ur[xt.message] = !0, ea(Ze), Ne("Failed %s type: %s", be, xt.message), ea(null));
            }
        }
      }
      function Xr(L) {
        if (L) {
          var oe = L._owner, be = va(L.type, L._source, oe ? oe.type : null);
          ye(be);
        } else
          ye(null);
      }
      var Je;
      Je = !1;
      function ri() {
        if (K.current) {
          var L = Bt(K.current.type);
          if (L)
            return `

Check the render method of \`` + L + "`.";
        }
        return "";
      }
      function _r(L) {
        if (L !== void 0) {
          var oe = L.fileName.replace(/^.*[\\\/]/, ""), be = L.lineNumber;
          return `

Check your code at ` + oe + ":" + be + ".";
        }
        return "";
      }
      function ai(L) {
        return L != null ? _r(L.__source) : "";
      }
      var _a = {};
      function wi(L) {
        var oe = ri();
        if (!oe) {
          var be = typeof L == "string" ? L : L.displayName || L.name;
          be && (oe = `

Check the top-level render call using <` + be + ">.");
        }
        return oe;
      }
      function yr(L, oe) {
        if (!(!L._store || L._store.validated || L.key != null)) {
          L._store.validated = !0;
          var be = wi(oe);
          if (!_a[be]) {
            _a[be] = !0;
            var Ee = "";
            L && L._owner && L._owner !== K.current && (Ee = " It was passed a child from " + Bt(L._owner.type) + "."), Xr(L), Ne('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', be, Ee), Xr(null);
          }
        }
      }
      function qn(L, oe) {
        if (typeof L == "object") {
          if (Array.isArray(L))
            for (var be = 0; be < L.length; be++) {
              var Ee = L[be];
              Xn(Ee) && yr(Ee, oe);
            }
          else if (Xn(L))
            L._store && (L._store.validated = !0);
          else if (L) {
            var Ze = V(L);
            if (typeof Ze == "function" && Ze !== L.entries)
              for (var Et = Ze.call(L), wt; !(wt = Et.next()).done; )
                Xn(wt.value) && yr(wt.value, oe);
          }
        }
      }
      function Or(L) {
        {
          var oe = L.type;
          if (oe == null || typeof oe == "string")
            return;
          var be;
          if (typeof oe == "function")
            be = oe.propTypes;
          else if (typeof oe == "object" && (oe.$$typeof === p || oe.$$typeof === y))
            be = oe.propTypes;
          else
            return;
          if (be) {
            var Ee = Bt(oe);
            ni(be, L.props, "prop", Ee, L);
          } else if (oe.PropTypes !== void 0 && !Je) {
            Je = !0;
            var Ze = Bt(oe);
            Ne("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ze || "Unknown");
          }
          typeof oe.getDefaultProps == "function" && !oe.getDefaultProps.isReactClassApproved && Ne("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function ms(L) {
        {
          for (var oe = Object.keys(L.props), be = 0; be < oe.length; be++) {
            var Ee = oe[be];
            if (Ee !== "children" && Ee !== "key") {
              Xr(L), Ne("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ee), Xr(null);
              break;
            }
          }
          L.ref !== null && (Xr(L), Ne("Invalid attribute `ref` supplied to `React.Fragment`."), Xr(null));
        }
      }
      function br(L, oe, be) {
        var Ee = Kr(L);
        if (!Ee) {
          var Ze = "";
          (L === void 0 || typeof L == "object" && L !== null && Object.keys(L).length === 0) && (Ze += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Et = ai(oe);
          Et ? Ze += Et : Ze += ri();
          var wt;
          L === null ? wt = "null" : Array.isArray(L) ? wt = "array" : L !== void 0 && L.$$typeof === r ? (wt = "<" + (Bt(L.type) || "Unknown") + " />", Ze = " Did you accidentally export a JSX literal instead of a component?") : wt = typeof L, Ne("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", wt, Ze);
        }
        var xt = fa.apply(this, arguments);
        if (xt == null)
          return xt;
        if (Ee)
          for (var Pt = 2; Pt < arguments.length; Pt++)
            qn(arguments[Pt], L);
        return L === e.Fragment ? ms(xt) : Or(xt), xt;
      }
      var lr = !1;
      function wo(L) {
        var oe = br.bind(null, L);
        return oe.type = L, lr || (lr = !0, Le("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(oe, "type", {
          enumerable: !1,
          get: function() {
            return Le("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: L
            }), L;
          }
        }), oe;
      }
      function ta(L, oe, be) {
        for (var Ee = fr.apply(this, arguments), Ze = 2; Ze < arguments.length; Ze++)
          qn(arguments[Ze], Ee.type);
        return Or(Ee), Ee;
      }
      try {
        var ii = Object.freeze({});
      } catch {
      }
      var Po = br, ko = ta, $o = wo, hs = {
        map: _t,
        forEach: ir,
        count: an,
        toArray: pn,
        only: vn
      };
      e.Children = hs, e.Component = Ye, e.PureComponent = ot, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = _e, e.cloneElement = ko, e.createContext = Kn, e.createElement = Po, e.createFactory = $o, e.createRef = At, e.forwardRef = Ha, e.isValidElement = Xn, e.lazy = Qr, e.memo = Ka, e.useCallback = Zt, e.useContext = or, e.useDebugValue = Jr, e.useEffect = Gi, e.useImperativeHandle = qs, e.useLayoutEffect = Ma, e.useMemo = gi, e.useReducer = Ti, e.useRef = Yi, e.useState = yo, e.version = n;
    }();
  }(Vk)), Vk;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = PF() : e.exports = kF();
})(F);
const T = /* @__PURE__ */ tR(F.exports), Gv = /* @__PURE__ */ c9({
  __proto__: null,
  default: T
}, [F.exports]);
var bt = function() {
  return bt = Object.assign || function(t) {
    for (var n, r = 1, s = arguments.length; r < s; r++) {
      n = arguments[r];
      for (var f in n)
        Object.prototype.hasOwnProperty.call(n, f) && (t[f] = n[f]);
    }
    return t;
  }, bt.apply(this, arguments);
};
function Us(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, r = Object.getOwnPropertySymbols(e); s < r.length; s++)
      t.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[s]) && (n[r[s]] = e[r[s]]);
  return n;
}
function Qv(e, t, n, r) {
  function s(f) {
    return f instanceof n ? f : new n(function(m) {
      m(f);
    });
  }
  return new (n || (n = Promise))(function(f, m) {
    function p(w) {
      try {
        y(r.next(w));
      } catch (P) {
        m(P);
      }
    }
    function v(w) {
      try {
        y(r.throw(w));
      } catch (P) {
        m(P);
      }
    }
    function y(w) {
      w.done ? f(w.value) : s(w.value).then(p, v);
    }
    y((r = r.apply(e, t || [])).next());
  });
}
function Kv(e, t) {
  var n = { label: 0, sent: function() {
    if (f[0] & 1)
      throw f[1];
    return f[1];
  }, trys: [], ops: [] }, r, s, f, m;
  return m = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
    return this;
  }), m;
  function p(y) {
    return function(w) {
      return v([y, w]);
    };
  }
  function v(y) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, s && (f = y[0] & 2 ? s.return : y[0] ? s.throw || ((f = s.return) && f.call(s), 0) : s.next) && !(f = f.call(s, y[1])).done)
          return f;
        switch (s = 0, f && (y = [y[0] & 2, f.value]), y[0]) {
          case 0:
          case 1:
            f = y;
            break;
          case 4:
            return n.label++, { value: y[1], done: !1 };
          case 5:
            n.label++, s = y[1], y = [0];
            continue;
          case 7:
            y = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (f = n.trys, !(f = f.length > 0 && f[f.length - 1]) && (y[0] === 6 || y[0] === 2)) {
              n = 0;
              continue;
            }
            if (y[0] === 3 && (!f || y[1] > f[0] && y[1] < f[3])) {
              n.label = y[1];
              break;
            }
            if (y[0] === 6 && n.label < f[1]) {
              n.label = f[1], f = y;
              break;
            }
            if (f && n.label < f[2]) {
              n.label = f[2], n.ops.push(y);
              break;
            }
            f[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        y = t.call(e, n);
      } catch (w) {
        y = [6, w], s = 0;
      } finally {
        r = f = 0;
      }
    if (y[0] & 5)
      throw y[1];
    return { value: y[0] ? y[1] : void 0, done: !0 };
  }
}
function $F(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Cn(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), s, f = [], m;
  try {
    for (; (t === void 0 || t-- > 0) && !(s = r.next()).done; )
      f.push(s.value);
  } catch (p) {
    m = { error: p };
  } finally {
    try {
      s && !s.done && (n = r.return) && n.call(r);
    } finally {
      if (m)
        throw m.error;
    }
  }
  return f;
}
function Bs(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, s = t.length, f; r < s; r++)
      (f || !(r in t)) && (f || (f = Array.prototype.slice.call(t, 0, r)), f[r] = t[r]);
  return e.concat(f || Array.prototype.slice.call(t));
}
function Yt(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
function Dr() {
  return Dr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dr.apply(this, arguments);
}
function nR(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var SF = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, xF = /* @__PURE__ */ nR(
  function(e) {
    return SF.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
);
function CF(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function MF(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var EF = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(s) {
      var f;
      r.tags.length === 0 ? r.insertionPoint ? f = r.insertionPoint.nextSibling : r.prepend ? f = r.container.firstChild : f = r.before : f = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(s, f), r.tags.push(s);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(MF(this));
    var s = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var f = r.charCodeAt(0) === 64 && r.charCodeAt(1) === 105;
      f && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + r + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !f;
    }
    if (this.isSpeedy) {
      var m = CF(s);
      try {
        m.insertRule(r, m.cssRules.length);
      } catch (p) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(r) && console.error('There was a problem inserting the following rule: "' + r + '"', p);
      }
    } else
      s.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Ui = "-ms-", l1 = "-moz-", Yn = "-webkit-", CS = "comm", MS = "rule", ES = "decl", AF = "@import", rR = "@keyframes", _F = Math.abs, _w = String.fromCharCode, OF = Object.assign;
function TF(e, t) {
  return Ai(e, 0) ^ 45 ? (((t << 2 ^ Ai(e, 0)) << 2 ^ Ai(e, 1)) << 2 ^ Ai(e, 2)) << 2 ^ Ai(e, 3) : 0;
}
function aR(e) {
  return e.trim();
}
function RF(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function ar(e, t, n) {
  return e.replace(t, n);
}
function T$(e, t) {
  return e.indexOf(t);
}
function Ai(e, t) {
  return e.charCodeAt(t) | 0;
}
function Jv(e, t, n) {
  return e.slice(t, n);
}
function cu(e) {
  return e.length;
}
function AS(e) {
  return e.length;
}
function bb(e, t) {
  return t.push(e), e;
}
function DF(e, t) {
  return e.map(t).join("");
}
var Ow = 1, qh = 1, iR = 0, Lo = 0, za = 0, Qh = "";
function Tw(e, t, n, r, s, f, m) {
  return { value: e, root: t, parent: n, type: r, props: s, children: f, line: Ow, column: qh, length: m, return: "" };
}
function wv(e, t) {
  return OF(Tw("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function NF() {
  return za;
}
function WF() {
  return za = Lo > 0 ? Ai(Qh, --Lo) : 0, qh--, za === 10 && (qh = 1, Ow--), za;
}
function ds() {
  return za = Lo < iR ? Ai(Qh, Lo++) : 0, qh++, za === 10 && (qh = 1, Ow++), za;
}
function fu() {
  return Ai(Qh, Lo);
}
function Xb() {
  return Lo;
}
function ug(e, t) {
  return Jv(Qh, e, t);
}
function Zv(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function oR(e) {
  return Ow = qh = 1, iR = cu(Qh = e), Lo = 0, [];
}
function sR(e) {
  return Qh = "", e;
}
function qb(e) {
  return aR(ug(Lo - 1, R$(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function jF(e) {
  for (; (za = fu()) && za < 33; )
    ds();
  return Zv(e) > 2 || Zv(za) > 3 ? "" : " ";
}
function zF(e, t) {
  for (; --t && ds() && !(za < 48 || za > 102 || za > 57 && za < 65 || za > 70 && za < 97); )
    ;
  return ug(e, Xb() + (t < 6 && fu() == 32 && ds() == 32));
}
function R$(e) {
  for (; ds(); )
    switch (za) {
      case e:
        return Lo;
      case 34:
      case 39:
        e !== 34 && e !== 39 && R$(za);
        break;
      case 40:
        e === 41 && R$(e);
        break;
      case 92:
        ds();
        break;
    }
  return Lo;
}
function LF(e, t) {
  for (; ds() && e + za !== 47 + 10; )
    if (e + za === 42 + 42 && fu() === 47)
      break;
  return "/*" + ug(t, Lo - 1) + "*" + _w(e === 47 ? e : ds());
}
function IF(e) {
  for (; !Zv(fu()); )
    ds();
  return ug(e, Lo);
}
function FF(e) {
  return sR(Yb("", null, null, null, [""], e = oR(e), 0, [0], e));
}
function Yb(e, t, n, r, s, f, m, p, v) {
  for (var y = 0, w = 0, P = m, x = 0, A = 0, M = 0, O = 1, j = 1, H = 1, J = 0, V = "", X = s, U = f, K = r, ce = V; j; )
    switch (M = J, J = ds()) {
      case 40:
        if (M != 108 && Ai(ce, P - 1) == 58) {
          T$(ce += ar(qb(J), "&", "&\f"), "&\f") != -1 && (H = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        ce += qb(J);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        ce += jF(M);
        break;
      case 92:
        ce += zF(Xb() - 1, 7);
        continue;
      case 47:
        switch (fu()) {
          case 42:
          case 47:
            bb(HF(LF(ds(), Xb()), t, n), v);
            break;
          default:
            ce += "/";
        }
        break;
      case 123 * O:
        p[y++] = cu(ce) * H;
      case 125 * O:
      case 59:
      case 0:
        switch (J) {
          case 0:
          case 125:
            j = 0;
          case 59 + w:
            A > 0 && cu(ce) - P && bb(A > 32 ? nA(ce + ";", r, n, P - 1) : nA(ar(ce, " ", "") + ";", r, n, P - 2), v);
            break;
          case 59:
            ce += ";";
          default:
            if (bb(K = tA(ce, t, n, y, w, s, p, V, X = [], U = [], P), f), J === 123)
              if (w === 0)
                Yb(ce, t, K, K, X, f, P, p, U);
              else
                switch (x === 99 && Ai(ce, 3) === 110 ? 100 : x) {
                  case 100:
                  case 109:
                  case 115:
                    Yb(e, K, K, r && bb(tA(e, K, K, 0, 0, s, p, V, s, X = [], P), U), s, U, P, p, r ? X : U);
                    break;
                  default:
                    Yb(ce, K, K, K, [""], U, 0, p, U);
                }
        }
        y = w = A = 0, O = H = 1, V = ce = "", P = m;
        break;
      case 58:
        P = 1 + cu(ce), A = M;
      default:
        if (O < 1) {
          if (J == 123)
            --O;
          else if (J == 125 && O++ == 0 && WF() == 125)
            continue;
        }
        switch (ce += _w(J), J * O) {
          case 38:
            H = w > 0 ? 1 : (ce += "\f", -1);
            break;
          case 44:
            p[y++] = (cu(ce) - 1) * H, H = 1;
            break;
          case 64:
            fu() === 45 && (ce += qb(ds())), x = fu(), w = P = cu(V = ce += IF(Xb())), J++;
            break;
          case 45:
            M === 45 && cu(ce) == 2 && (O = 0);
        }
    }
  return f;
}
function tA(e, t, n, r, s, f, m, p, v, y, w) {
  for (var P = s - 1, x = s === 0 ? f : [""], A = AS(x), M = 0, O = 0, j = 0; M < r; ++M)
    for (var H = 0, J = Jv(e, P + 1, P = _F(O = m[M])), V = e; H < A; ++H)
      (V = aR(O > 0 ? x[H] + " " + J : ar(J, /&\f/g, x[H]))) && (v[j++] = V);
  return Tw(e, t, n, s === 0 ? MS : p, v, y, w);
}
function HF(e, t, n) {
  return Tw(e, t, n, CS, _w(NF()), Jv(e, 2, -2), 0);
}
function nA(e, t, n, r) {
  return Tw(e, t, n, ES, Jv(e, 0, r), Jv(e, r + 1, -1), r);
}
function zh(e, t) {
  for (var n = "", r = AS(e), s = 0; s < r; s++)
    n += t(e[s], s, e, t) || "";
  return n;
}
function VF(e, t, n, r) {
  switch (e.type) {
    case AF:
    case ES:
      return e.return = e.return || e.value;
    case CS:
      return "";
    case rR:
      return e.return = e.value + "{" + zh(e.children, r) + "}";
    case MS:
      e.value = e.props.join(",");
  }
  return cu(n = zh(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function BF(e) {
  var t = AS(e);
  return function(n, r, s, f) {
    for (var m = "", p = 0; p < t; p++)
      m += e[p](n, r, s, f) || "";
    return m;
  };
}
function UF(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var rA = function(t) {
  var n = /* @__PURE__ */ new WeakMap();
  return function(r) {
    if (n.has(r))
      return n.get(r);
    var s = t(r);
    return n.set(r, s), s;
  };
};
function XF(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var qF = function(t, n, r) {
  for (var s = 0, f = 0; s = f, f = fu(), s === 38 && f === 12 && (n[r] = 1), !Zv(f); )
    ds();
  return ug(t, Lo);
}, YF = function(t, n) {
  var r = -1, s = 44;
  do
    switch (Zv(s)) {
      case 0:
        s === 38 && fu() === 12 && (n[r] = 1), t[r] += qF(Lo - 1, n, r);
        break;
      case 2:
        t[r] += qb(s);
        break;
      case 4:
        if (s === 44) {
          t[++r] = fu() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += _w(s);
    }
  while (s = ds());
  return t;
}, GF = function(t, n) {
  return sR(YF(oR(t), n));
}, aA = /* @__PURE__ */ new WeakMap(), QF = function(t) {
  if (!(t.type !== "rule" || !t.parent || t.length < 1)) {
    for (var n = t.value, r = t.parent, s = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !aA.get(r)) && !s) {
      aA.set(t, !0);
      for (var f = [], m = GF(n, f), p = r.props, v = 0, y = 0; v < m.length; v++)
        for (var w = 0; w < p.length; w++, y++)
          t.props[y] = f[v] ? m[v].replace(/&\f/g, p[w]) : p[w] + " " + m[v];
    }
  }
}, KF = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    n.charCodeAt(0) === 108 && n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, JF = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", ZF = function(t) {
  return t.type === "comm" && t.children.indexOf(JF) > -1;
}, eH = function(t) {
  return function(n, r, s) {
    if (!(n.type !== "rule" || t.compat)) {
      var f = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (f) {
        for (var m = n.parent === s[0], p = m ? s[0].children : s, v = p.length - 1; v >= 0; v--) {
          var y = p[v];
          if (y.line < n.line)
            break;
          if (y.column < n.column) {
            if (ZF(y))
              return;
            break;
          }
        }
        f.forEach(function(w) {
          console.error('The pseudo class "' + w + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + w.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, lR = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, tH = function(t, n) {
  for (var r = t - 1; r >= 0; r--)
    if (!lR(n[r]))
      return !0;
  return !1;
}, iA = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, nH = function(t, n, r) {
  lR(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), iA(t)) : tH(n, r) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), iA(t)));
};
function uR(e, t) {
  switch (TF(e, t)) {
    case 5103:
      return Yn + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Yn + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Yn + e + l1 + e + Ui + e + e;
    case 6828:
    case 4268:
      return Yn + e + Ui + e + e;
    case 6165:
      return Yn + e + Ui + "flex-" + e + e;
    case 5187:
      return Yn + e + ar(e, /(\w+).+(:[^]+)/, Yn + "box-$1$2" + Ui + "flex-$1$2") + e;
    case 5443:
      return Yn + e + Ui + "flex-item-" + ar(e, /flex-|-self/, "") + e;
    case 4675:
      return Yn + e + Ui + "flex-line-pack" + ar(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Yn + e + Ui + ar(e, "shrink", "negative") + e;
    case 5292:
      return Yn + e + Ui + ar(e, "basis", "preferred-size") + e;
    case 6060:
      return Yn + "box-" + ar(e, "-grow", "") + Yn + e + Ui + ar(e, "grow", "positive") + e;
    case 4554:
      return Yn + ar(e, /([^-])(transform)/g, "$1" + Yn + "$2") + e;
    case 6187:
      return ar(ar(ar(e, /(zoom-|grab)/, Yn + "$1"), /(image-set)/, Yn + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return ar(e, /(image-set\([^]*)/, Yn + "$1$`$1");
    case 4968:
      return ar(ar(e, /(.+:)(flex-)?(.*)/, Yn + "box-pack:$3" + Ui + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Yn + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ar(e, /(.+)-inline(.+)/, Yn + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (cu(e) - 1 - t > 6)
        switch (Ai(e, t + 1)) {
          case 109:
            if (Ai(e, t + 4) !== 45)
              break;
          case 102:
            return ar(e, /(.+:)(.+)-([^]+)/, "$1" + Yn + "$2-$3$1" + l1 + (Ai(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~T$(e, "stretch") ? uR(ar(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (Ai(e, t + 1) !== 115)
        break;
    case 6444:
      switch (Ai(e, cu(e) - 3 - (~T$(e, "!important") && 10))) {
        case 107:
          return ar(e, ":", ":" + Yn) + e;
        case 101:
          return ar(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Yn + (Ai(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Yn + "$2$3$1" + Ui + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Ai(e, t + 11)) {
        case 114:
          return Yn + e + Ui + ar(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Yn + e + Ui + ar(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Yn + e + Ui + ar(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Yn + e + Ui + e + e;
  }
  return e;
}
var rH = function(t, n, r, s) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case ES:
        t.return = uR(t.value, t.length);
        break;
      case rR:
        return zh([wv(t, {
          value: ar(t.value, "@", "@" + Yn)
        })], s);
      case MS:
        if (t.length)
          return DF(t.props, function(f) {
            switch (RF(f, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return zh([wv(t, {
                  props: [ar(f, /:(read-\w+)/, ":" + l1 + "$1")]
                })], s);
              case "::placeholder":
                return zh([wv(t, {
                  props: [ar(f, /:(plac\w+)/, ":" + Yn + "input-$1")]
                }), wv(t, {
                  props: [ar(f, /:(plac\w+)/, ":" + l1 + "$1")]
                }), wv(t, {
                  props: [ar(f, /:(plac\w+)/, Ui + "input-$1")]
                })], s);
            }
            return "";
          });
    }
}, aH = [rH], Rw = function(t) {
  var n = t.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(O) {
      var j = O.getAttribute("data-emotion");
      j.indexOf(" ") !== -1 && (document.head.appendChild(O), O.setAttribute("data-s", ""));
    });
  }
  var s = t.stylisPlugins || aH;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var f = {}, m, p = [];
  m = t.container || document.head, Array.prototype.forEach.call(
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(O) {
      for (var j = O.getAttribute("data-emotion").split(" "), H = 1; H < j.length; H++)
        f[j[H]] = !0;
      p.push(O);
    }
  );
  var v, y = [QF, KF];
  process.env.NODE_ENV !== "production" && y.push(eH({
    get compat() {
      return M.compat;
    }
  }), nH);
  {
    var w, P = [VF, process.env.NODE_ENV !== "production" ? function(O) {
      O.root || (O.return ? w.insert(O.return) : O.value && O.type !== CS && w.insert(O.value + "{}"));
    } : UF(function(O) {
      w.insert(O);
    })], x = BF(y.concat(s, P)), A = function(j) {
      return zh(FF(j), x);
    };
    v = function(j, H, J, V) {
      w = J, process.env.NODE_ENV !== "production" && H.map !== void 0 && (w = {
        insert: function(U) {
          J.insert(U + H.map);
        }
      }), A(j ? j + "{" + H.styles + "}" : H.styles), V && (M.inserted[H.name] = !0);
    };
  }
  var M = {
    key: n,
    sheet: new EF({
      key: n,
      container: m,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: f,
    registered: {},
    insert: v
  };
  return M.sheet.hydrate(p), M;
}, cR = { exports: {} }, nr = {};
var oA;
function iH() {
  if (oA)
    return nr;
  oA = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, f = e ? Symbol.for("react.profiler") : 60114, m = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, v = e ? Symbol.for("react.async_mode") : 60111, y = e ? Symbol.for("react.concurrent_mode") : 60111, w = e ? Symbol.for("react.forward_ref") : 60112, P = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, M = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, j = e ? Symbol.for("react.fundamental") : 60117, H = e ? Symbol.for("react.responder") : 60118, J = e ? Symbol.for("react.scope") : 60119;
  function V(U) {
    if (typeof U == "object" && U !== null) {
      var K = U.$$typeof;
      switch (K) {
        case t:
          switch (U = U.type, U) {
            case v:
            case y:
            case r:
            case f:
            case s:
            case P:
              return U;
            default:
              switch (U = U && U.$$typeof, U) {
                case p:
                case w:
                case M:
                case A:
                case m:
                  return U;
                default:
                  return K;
              }
          }
        case n:
          return K;
      }
    }
  }
  function X(U) {
    return V(U) === y;
  }
  return nr.AsyncMode = v, nr.ConcurrentMode = y, nr.ContextConsumer = p, nr.ContextProvider = m, nr.Element = t, nr.ForwardRef = w, nr.Fragment = r, nr.Lazy = M, nr.Memo = A, nr.Portal = n, nr.Profiler = f, nr.StrictMode = s, nr.Suspense = P, nr.isAsyncMode = function(U) {
    return X(U) || V(U) === v;
  }, nr.isConcurrentMode = X, nr.isContextConsumer = function(U) {
    return V(U) === p;
  }, nr.isContextProvider = function(U) {
    return V(U) === m;
  }, nr.isElement = function(U) {
    return typeof U == "object" && U !== null && U.$$typeof === t;
  }, nr.isForwardRef = function(U) {
    return V(U) === w;
  }, nr.isFragment = function(U) {
    return V(U) === r;
  }, nr.isLazy = function(U) {
    return V(U) === M;
  }, nr.isMemo = function(U) {
    return V(U) === A;
  }, nr.isPortal = function(U) {
    return V(U) === n;
  }, nr.isProfiler = function(U) {
    return V(U) === f;
  }, nr.isStrictMode = function(U) {
    return V(U) === s;
  }, nr.isSuspense = function(U) {
    return V(U) === P;
  }, nr.isValidElementType = function(U) {
    return typeof U == "string" || typeof U == "function" || U === r || U === y || U === f || U === s || U === P || U === x || typeof U == "object" && U !== null && (U.$$typeof === M || U.$$typeof === A || U.$$typeof === m || U.$$typeof === p || U.$$typeof === w || U.$$typeof === j || U.$$typeof === H || U.$$typeof === J || U.$$typeof === O);
  }, nr.typeOf = V, nr;
}
var rr = {};
var sA;
function oH() {
  return sA || (sA = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, f = e ? Symbol.for("react.profiler") : 60114, m = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, v = e ? Symbol.for("react.async_mode") : 60111, y = e ? Symbol.for("react.concurrent_mode") : 60111, w = e ? Symbol.for("react.forward_ref") : 60112, P = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, M = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, j = e ? Symbol.for("react.fundamental") : 60117, H = e ? Symbol.for("react.responder") : 60118, J = e ? Symbol.for("react.scope") : 60119;
    function V(Ge) {
      return typeof Ge == "string" || typeof Ge == "function" || Ge === r || Ge === y || Ge === f || Ge === s || Ge === P || Ge === x || typeof Ge == "object" && Ge !== null && (Ge.$$typeof === M || Ge.$$typeof === A || Ge.$$typeof === m || Ge.$$typeof === p || Ge.$$typeof === w || Ge.$$typeof === j || Ge.$$typeof === H || Ge.$$typeof === J || Ge.$$typeof === O);
    }
    function X(Ge) {
      if (typeof Ge == "object" && Ge !== null) {
        var vr = Ge.$$typeof;
        switch (vr) {
          case t:
            var Fn = Ge.type;
            switch (Fn) {
              case v:
              case y:
              case r:
              case f:
              case s:
              case P:
                return Fn;
              default:
                var en = Fn && Fn.$$typeof;
                switch (en) {
                  case p:
                  case w:
                  case M:
                  case A:
                  case m:
                    return en;
                  default:
                    return vr;
                }
            }
          case n:
            return vr;
        }
      }
    }
    var U = v, K = y, ce = p, ue = m, ye = t, Oe = w, _e = r, Le = M, Ne = A, nt = n, Qe = f, qe = s, ie = P, xe = !1;
    function Ye(Ge) {
      return xe || (xe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Be(Ge) || X(Ge) === v;
    }
    function Be(Ge) {
      return X(Ge) === y;
    }
    function Ce(Ge) {
      return X(Ge) === p;
    }
    function Ie(Ge) {
      return X(Ge) === m;
    }
    function $e(Ge) {
      return typeof Ge == "object" && Ge !== null && Ge.$$typeof === t;
    }
    function ot(Ge) {
      return X(Ge) === w;
    }
    function ht(Ge) {
      return X(Ge) === r;
    }
    function At(Ge) {
      return X(Ge) === M;
    }
    function Sn(Ge) {
      return X(Ge) === A;
    }
    function Gt(Ge) {
      return X(Ge) === n;
    }
    function Bt(Ge) {
      return X(Ge) === f;
    }
    function Qn(Ge) {
      return X(Ge) === s;
    }
    function cn(Ge) {
      return X(Ge) === P;
    }
    rr.AsyncMode = U, rr.ConcurrentMode = K, rr.ContextConsumer = ce, rr.ContextProvider = ue, rr.Element = ye, rr.ForwardRef = Oe, rr.Fragment = _e, rr.Lazy = Le, rr.Memo = Ne, rr.Portal = nt, rr.Profiler = Qe, rr.StrictMode = qe, rr.Suspense = ie, rr.isAsyncMode = Ye, rr.isConcurrentMode = Be, rr.isContextConsumer = Ce, rr.isContextProvider = Ie, rr.isElement = $e, rr.isForwardRef = ot, rr.isFragment = ht, rr.isLazy = At, rr.isMemo = Sn, rr.isPortal = Gt, rr.isProfiler = Bt, rr.isStrictMode = Qn, rr.isSuspense = cn, rr.isValidElementType = V, rr.typeOf = X;
  }()), rr;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = iH() : e.exports = oH();
})(cR);
var dR = cR.exports, sH = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, lH = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, fR = {};
fR[dR.ForwardRef] = sH;
fR[dR.Memo] = lH;
var uH = !0;
function cm(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(s) {
    e[s] !== void 0 ? t.push(e[s] + ";") : r += s + " ";
  }), r;
}
var _S = function(t, n, r) {
  var s = t.key + "-" + n.name;
  (r === !1 || uH === !1) && t.registered[s] === void 0 && (t.registered[s] = n.styles);
}, Kh = function(t, n, r) {
  _S(t, n, r);
  var s = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var f = n;
    do
      t.insert(n === f ? "." + s : "", f, t.sheet, !0), f = f.next;
    while (f !== void 0);
  }
};
function cH(e) {
  for (var t = 0, n, r = 0, s = e.length; s >= 4; ++r, s -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= n >>> 24, t = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (s) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var dH = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, lA = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, fH = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", mH = /[A-Z]|^ms/g, mR = /_EMO_([^_]+?)_([^]*?)_EMO_/g, OS = function(t) {
  return t.charCodeAt(1) === 45;
}, uA = function(t) {
  return t != null && typeof t != "boolean";
}, Bk = /* @__PURE__ */ XF(function(e) {
  return OS(e) ? e : e.replace(mH, "-$&").toLowerCase();
}), u1 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(mR, function(r, s, f) {
          return yl = {
            name: s,
            styles: f,
            next: yl
          }, s;
        });
  }
  return dH[t] !== 1 && !OS(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var hH = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, pH = ["normal", "none", "initial", "inherit", "unset"], vH = u1, gH = /^-ms-/, yH = /-(.)/g, cA = {};
  u1 = function(t, n) {
    if (t === "content" && (typeof n != "string" || pH.indexOf(n) === -1 && !hH.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var r = vH(t, n);
    return r !== "" && !OS(t) && t.indexOf("-") !== -1 && cA[t] === void 0 && (cA[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(gH, "ms-").replace(yH, function(s, f) {
      return f.toUpperCase();
    }) + "?")), r;
  };
}
var hR = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function eg(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(hR);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return yl = {
          name: n.name,
          styles: n.styles,
          next: yl
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            yl = {
              name: r.name,
              styles: r.styles,
              next: yl
            }, r = r.next;
        var s = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (s += n.map), s;
      }
      return bH(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var f = yl, m = n(e);
        return yl = f, eg(e, t, m);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var p = [], v = n.replace(mR, function(w, P, x) {
          var A = "animation" + p.length;
          return p.push("const " + A + " = keyframes`" + x.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + A + "}";
        });
        p.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(p, ["`" + v + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + v + "`"));
      }
      break;
  }
  if (t == null)
    return n;
  var y = t[n];
  return y !== void 0 ? y : n;
}
function bH(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var s = 0; s < n.length; s++)
      r += eg(e, t, n[s]) + ";";
  else
    for (var f in n) {
      var m = n[f];
      if (typeof m != "object")
        t != null && t[m] !== void 0 ? r += f + "{" + t[m] + "}" : uA(m) && (r += Bk(f) + ":" + u1(f, m) + ";");
      else {
        if (f === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(hR);
        if (Array.isArray(m) && typeof m[0] == "string" && (t == null || t[m[0]] === void 0))
          for (var p = 0; p < m.length; p++)
            uA(m[p]) && (r += Bk(f) + ":" + u1(f, m[p]) + ";");
        else {
          var v = eg(e, t, m);
          switch (f) {
            case "animation":
            case "animationName": {
              r += Bk(f) + ":" + v + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && f === "undefined" && console.error(fH), r += f + "{" + v + "}";
          }
        }
      }
    }
  return r;
}
var dA = /label:\s*([^\s;\n{]+)\s*(;|$)/g, pR;
process.env.NODE_ENV !== "production" && (pR = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var yl, kl = function(t, n, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var s = !0, f = "";
  yl = void 0;
  var m = t[0];
  m == null || m.raw === void 0 ? (s = !1, f += eg(r, n, m)) : (process.env.NODE_ENV !== "production" && m[0] === void 0 && console.error(lA), f += m[0]);
  for (var p = 1; p < t.length; p++)
    f += eg(r, n, t[p]), s && (process.env.NODE_ENV !== "production" && m[p] === void 0 && console.error(lA), f += m[p]);
  var v;
  process.env.NODE_ENV !== "production" && (f = f.replace(pR, function(x) {
    return v = x, "";
  })), dA.lastIndex = 0;
  for (var y = "", w; (w = dA.exec(f)) !== null; )
    y += "-" + w[1];
  var P = cH(f) + y;
  return process.env.NODE_ENV !== "production" ? {
    name: P,
    styles: f,
    map: v,
    next: yl,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: P,
    styles: f,
    next: yl
  };
}, wH = function(t) {
  return t();
}, vR = Gv["useInsertionEffect"] ? Gv["useInsertionEffect"] : !1, gR = vR || wH, fA = vR || F.exports.useLayoutEffect, PH = {}.hasOwnProperty, TS = /* @__PURE__ */ F.exports.createContext(
  typeof HTMLElement < "u" ? /* @__PURE__ */ Rw({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (TS.displayName = "EmotionCacheContext");
TS.Provider;
var Dw = function(t) {
  return /* @__PURE__ */ F.exports.forwardRef(function(n, r) {
    var s = F.exports.useContext(TS);
    return t(n, s, r);
  });
}, um = /* @__PURE__ */ F.exports.createContext({});
process.env.NODE_ENV !== "production" && (um.displayName = "EmotionThemeContext");
var kH = function(t, n) {
  if (typeof n == "function") {
    var r = n(t);
    if (process.env.NODE_ENV !== "production" && (r == null || typeof r != "object" || Array.isArray(r)))
      throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");
    return r;
  }
  if (process.env.NODE_ENV !== "production" && (n == null || typeof n != "object" || Array.isArray(n)))
    throw new Error("[ThemeProvider] Please make your theme prop a plain object");
  return Dr({}, t, n);
}, $H = /* @__PURE__ */ rA(function(e) {
  return rA(function(t) {
    return kH(e, t);
  });
}), SH = function(t) {
  var n = F.exports.useContext(um);
  return t.theme !== n && (n = $H(n)(t.theme)), /* @__PURE__ */ F.exports.createElement(um.Provider, {
    value: n
  }, t.children);
}, mA = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", hA = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", xH = function(t) {
  var n = t.cache, r = t.serialized, s = t.isStringTag;
  return _S(n, r, s), gR(function() {
    return Kh(n, r, s);
  }), null;
}, CH = /* @__PURE__ */ Dw(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var s = e[mA], f = [r], m = "";
  typeof e.className == "string" ? m = cm(t.registered, f, e.className) : e.className != null && (m = e.className + " ");
  var p = kl(f, void 0, F.exports.useContext(um));
  if (process.env.NODE_ENV !== "production" && p.name.indexOf("-") === -1) {
    var v = e[hA];
    v && (p = kl([p, "label:" + v + ";"]));
  }
  m += t.key + "-" + p.name;
  var y = {};
  for (var w in e)
    PH.call(e, w) && w !== "css" && w !== mA && (process.env.NODE_ENV === "production" || w !== hA) && (y[w] = e[w]);
  return y.ref = n, y.className = m, /* @__PURE__ */ F.exports.createElement(F.exports.Fragment, null, /* @__PURE__ */ F.exports.createElement(xH, {
    cache: t,
    serialized: p,
    isStringTag: typeof s == "string"
  }), /* @__PURE__ */ F.exports.createElement(s, y));
});
process.env.NODE_ENV !== "production" && (CH.displayName = "EmotionCssPropInternal");
var MH = {
  name: "@emotion/react",
  version: "11.10.5",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": "./macro.js"
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.js",
    "macro.d.ts",
    "macro.js.flow"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.10.5",
    "@emotion/cache": "^11.10.5",
    "@emotion/serialize": "^1.1.1",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
    "@emotion/utils": "^1.2.0",
    "@emotion/weak-memoize": "^0.3.0",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    "@babel/core": "^7.0.0",
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@babel/core": {
      optional: !0
    },
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@babel/core": "^7.18.5",
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.10.5",
    "@emotion/css-prettifier": "1.1.1",
    "@emotion/server": "11.10.0",
    "@emotion/styled": "11.10.5",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
      }
    }
  }
}, pA = !1, cg = /* @__PURE__ */ Dw(function(e, t) {
  process.env.NODE_ENV !== "production" && !pA && (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), pA = !0);
  var n = e.styles, r = kl([n], void 0, F.exports.useContext(um)), s = F.exports.useRef();
  return fA(function() {
    var f = t.key + "-global", m = new t.sheet.constructor({
      key: f,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), p = !1, v = document.querySelector('style[data-emotion="' + f + " " + r.name + '"]');
    return t.sheet.tags.length && (m.before = t.sheet.tags[0]), v !== null && (p = !0, v.setAttribute("data-emotion", f), m.hydrate([v])), s.current = [m, p], function() {
      m.flush();
    };
  }, [t]), fA(function() {
    var f = s.current, m = f[0], p = f[1];
    if (p) {
      f[1] = !1;
      return;
    }
    if (r.next !== void 0 && Kh(t, r.next, !0), m.tags.length) {
      var v = m.tags[m.tags.length - 1].nextElementSibling;
      m.before = v, m.flush();
    }
    t.insert("", r, m, !1);
  }, [t, r.name]), null;
});
process.env.NODE_ENV !== "production" && (cg.displayName = "EmotionGlobal");
var EH = function e(t) {
  for (var n = t.length, r = 0, s = ""; r < n; r++) {
    var f = t[r];
    if (f != null) {
      var m = void 0;
      switch (typeof f) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(f))
            m = e(f);
          else {
            process.env.NODE_ENV !== "production" && f.styles !== void 0 && f.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), m = "";
            for (var p in f)
              f[p] && p && (m && (m += " "), m += p);
          }
          break;
        }
        default:
          m = f;
      }
      m && (s && (s += " "), s += m);
    }
  }
  return s;
};
function AH(e, t, n) {
  var r = [], s = cm(e, r, n);
  return r.length < 2 ? n : s + t(r);
}
var _H = function(t) {
  var n = t.cache, r = t.serializedArr;
  return gR(function() {
    for (var s = 0; s < r.length; s++)
      Kh(n, r[s], !1);
  }), null;
}, OH = /* @__PURE__ */ Dw(function(e, t) {
  var n = !1, r = [], s = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var y = arguments.length, w = new Array(y), P = 0; P < y; P++)
      w[P] = arguments[P];
    var x = kl(w, t.registered);
    return r.push(x), _S(t, x, !1), t.key + "-" + x.name;
  }, f = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var y = arguments.length, w = new Array(y), P = 0; P < y; P++)
      w[P] = arguments[P];
    return AH(t.registered, s, EH(w));
  }, m = {
    css: s,
    cx: f,
    theme: F.exports.useContext(um)
  }, p = e.children(m);
  return n = !0, /* @__PURE__ */ F.exports.createElement(F.exports.Fragment, null, /* @__PURE__ */ F.exports.createElement(_H, {
    cache: t,
    serializedArr: r
  }), p);
});
process.env.NODE_ENV !== "production" && (OH.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var vA = !0, TH = typeof jest < "u" || typeof vi < "u";
  if (vA && !TH) {
    var gA = typeof globalThis < "u" ? globalThis : vA ? window : global, yA = "__EMOTION_REACT_" + MH.version.split(".")[0] + "__";
    gA[yA] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), gA[yA] = !0;
  }
}
var RH = !0;
function DH(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(s) {
    e[s] !== void 0 ? t.push(e[s] + ";") : r += s + " ";
  }), r;
}
var yR = function(t, n, r) {
  var s = t.key + "-" + n.name;
  (r === !1 || RH === !1) && t.registered[s] === void 0 && (t.registered[s] = n.styles);
}, NH = function(t, n, r) {
  yR(t, n, r);
  var s = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var f = n;
    do
      t.insert(n === f ? "." + s : "", f, t.sheet, !0), f = f.next;
    while (f !== void 0);
  }
};
function WH(e) {
  for (var t = 0, n, r = 0, s = e.length; s >= 4; ++r, s -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= n >>> 24, t = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (s) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var jH = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, bA = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, zH = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", LH = /[A-Z]|^ms/g, bR = /_EMO_([^_]+?)_([^]*?)_EMO_/g, RS = function(t) {
  return t.charCodeAt(1) === 45;
}, wA = function(t) {
  return t != null && typeof t != "boolean";
}, Uk = /* @__PURE__ */ nR(function(e) {
  return RS(e) ? e : e.replace(LH, "-$&").toLowerCase();
}), c1 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(bR, function(r, s, f) {
          return bl = {
            name: s,
            styles: f,
            next: bl
          }, s;
        });
  }
  return jH[t] !== 1 && !RS(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var IH = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, FH = ["normal", "none", "initial", "inherit", "unset"], HH = c1, VH = /^-ms-/, BH = /-(.)/g, PA = {};
  c1 = function(t, n) {
    if (t === "content" && (typeof n != "string" || FH.indexOf(n) === -1 && !IH.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var r = HH(t, n);
    return r !== "" && !RS(t) && t.indexOf("-") !== -1 && PA[t] === void 0 && (PA[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(VH, "ms-").replace(BH, function(s, f) {
      return f.toUpperCase();
    }) + "?")), r;
  };
}
function tg(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return bl = {
          name: n.name,
          styles: n.styles,
          next: bl
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            bl = {
              name: r.name,
              styles: r.styles,
              next: bl
            }, r = r.next;
        var s = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (s += n.map), s;
      }
      return UH(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var f = bl, m = n(e);
        return bl = f, tg(e, t, m);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var p = [], v = n.replace(bR, function(w, P, x) {
          var A = "animation" + p.length;
          return p.push("const " + A + " = keyframes`" + x.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + A + "}";
        });
        p.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(p, ["`" + v + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + v + "`"));
      }
      break;
  }
  if (t == null)
    return n;
  var y = t[n];
  return y !== void 0 ? y : n;
}
function UH(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var s = 0; s < n.length; s++)
      r += tg(e, t, n[s]) + ";";
  else
    for (var f in n) {
      var m = n[f];
      if (typeof m != "object")
        t != null && t[m] !== void 0 ? r += f + "{" + t[m] + "}" : wA(m) && (r += Uk(f) + ":" + c1(f, m) + ";");
      else {
        if (f === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
        if (Array.isArray(m) && typeof m[0] == "string" && (t == null || t[m[0]] === void 0))
          for (var p = 0; p < m.length; p++)
            wA(m[p]) && (r += Uk(f) + ":" + c1(f, m[p]) + ";");
        else {
          var v = tg(e, t, m);
          switch (f) {
            case "animation":
            case "animationName": {
              r += Uk(f) + ":" + v + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && f === "undefined" && console.error(zH), r += f + "{" + v + "}";
          }
        }
      }
    }
  return r;
}
var kA = /label:\s*([^\s;\n{]+)\s*(;|$)/g, wR;
process.env.NODE_ENV !== "production" && (wR = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var bl, XH = function(t, n, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var s = !0, f = "";
  bl = void 0;
  var m = t[0];
  m == null || m.raw === void 0 ? (s = !1, f += tg(r, n, m)) : (process.env.NODE_ENV !== "production" && m[0] === void 0 && console.error(bA), f += m[0]);
  for (var p = 1; p < t.length; p++)
    f += tg(r, n, t[p]), s && (process.env.NODE_ENV !== "production" && m[p] === void 0 && console.error(bA), f += m[p]);
  var v;
  process.env.NODE_ENV !== "production" && (f = f.replace(wR, function(x) {
    return v = x, "";
  })), kA.lastIndex = 0;
  for (var y = "", w; (w = kA.exec(f)) !== null; )
    y += "-" + w[1];
  var P = WH(f) + y;
  return process.env.NODE_ENV !== "production" ? {
    name: P,
    styles: f,
    map: v,
    next: bl,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: P,
    styles: f,
    next: bl
  };
}, qH = xF, YH = function(t) {
  return t !== "theme";
}, $A = function(t) {
  return typeof t == "string" && t.charCodeAt(0) > 96 ? qH : YH;
}, SA = function(t, n, r) {
  var s;
  if (n) {
    var f = n.shouldForwardProp;
    s = t.__emotion_forwardProp && f ? function(m) {
      return t.__emotion_forwardProp(m) && f(m);
    } : f;
  }
  return typeof s != "function" && r && (s = t.__emotion_forwardProp), s;
}, GH = Gv["useInsertionEffect"] ? Gv["useInsertionEffect"] : function(t) {
  t();
};
function QH(e) {
  GH(e);
}
var xA = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, KH = function(t) {
  var n = t.cache, r = t.serialized, s = t.isStringTag;
  return yR(n, r, s), QH(function() {
    return NH(n, r, s);
  }), null;
}, JH = function e(t, n) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var r = t.__emotion_real === t, s = r && t.__emotion_base || t, f, m;
  n !== void 0 && (f = n.label, m = n.target);
  var p = SA(t, n, r), v = p || $A(s), y = !v("as");
  return function() {
    var w = arguments, P = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (f !== void 0 && P.push("label:" + f + ";"), w[0] == null || w[0].raw === void 0)
      P.push.apply(P, w);
    else {
      process.env.NODE_ENV !== "production" && w[0][0] === void 0 && console.error(xA), P.push(w[0][0]);
      for (var x = w.length, A = 1; A < x; A++)
        process.env.NODE_ENV !== "production" && w[0][A] === void 0 && console.error(xA), P.push(w[A], w[0][A]);
    }
    var M = Dw(function(O, j, H) {
      var J = y && O.as || s, V = "", X = [], U = O;
      if (O.theme == null) {
        U = {};
        for (var K in O)
          U[K] = O[K];
        U.theme = F.exports.useContext(um);
      }
      typeof O.className == "string" ? V = DH(j.registered, X, O.className) : O.className != null && (V = O.className + " ");
      var ce = XH(P.concat(X), j.registered, U);
      V += j.key + "-" + ce.name, m !== void 0 && (V += " " + m);
      var ue = y && p === void 0 ? $A(J) : v, ye = {};
      for (var Oe in O)
        y && Oe === "as" || ue(Oe) && (ye[Oe] = O[Oe]);
      return ye.className = V, ye.ref = H, /* @__PURE__ */ F.exports.createElement(F.exports.Fragment, null, /* @__PURE__ */ F.exports.createElement(KH, {
        cache: j,
        serialized: ce,
        isStringTag: typeof J == "string"
      }), /* @__PURE__ */ F.exports.createElement(J, ye));
    });
    return M.displayName = f !== void 0 ? f : "Styled(" + (typeof s == "string" ? s : s.displayName || s.name || "Component") + ")", M.defaultProps = t.defaultProps, M.__emotion_real = M, M.__emotion_base = s, M.__emotion_styles = P, M.__emotion_forwardProp = p, Object.defineProperty(M, "toString", {
      value: function() {
        return m === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + m;
      }
    }), M.withComponent = function(O, j) {
      return e(O, Dr({}, n, j, {
        shouldForwardProp: SA(M, j, !0)
      })).apply(void 0, P);
    }, M;
  };
}, ZH = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Mr = JH.bind();
ZH.forEach(function(e) {
  Mr[e] = Mr(e);
});
function CA(e, t) {
  if (e.inserted[t.name] === void 0)
    return e.insert("", t, e.sheet, !0);
}
function MA(e, t, n) {
  var r = [], s = cm(e, r, n);
  return r.length < 2 ? n : s + t(r);
}
var eV = function(t) {
  var n = Rw(t);
  n.sheet.speedy = function(p) {
    if (process.env.NODE_ENV !== "production" && this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = p;
  }, n.compat = !0;
  var r = function() {
    for (var v = arguments.length, y = new Array(v), w = 0; w < v; w++)
      y[w] = arguments[w];
    var P = kl(y, n.registered, void 0);
    return Kh(n, P, !1), n.key + "-" + P.name;
  }, s = function() {
    for (var v = arguments.length, y = new Array(v), w = 0; w < v; w++)
      y[w] = arguments[w];
    var P = kl(y, n.registered), x = "animation-" + P.name;
    return CA(n, {
      name: P.name,
      styles: "@keyframes " + x + "{" + P.styles + "}"
    }), x;
  }, f = function() {
    for (var v = arguments.length, y = new Array(v), w = 0; w < v; w++)
      y[w] = arguments[w];
    var P = kl(y, n.registered);
    CA(n, P);
  }, m = function() {
    for (var v = arguments.length, y = new Array(v), w = 0; w < v; w++)
      y[w] = arguments[w];
    return MA(n.registered, r, tV(y));
  };
  return {
    css: r,
    cx: m,
    injectGlobal: f,
    keyframes: s,
    hydrate: function(v) {
      v.forEach(function(y) {
        n.inserted[y] = !0;
      });
    },
    flush: function() {
      n.registered = {}, n.inserted = {}, n.sheet.flush();
    },
    sheet: n.sheet,
    cache: n,
    getRegisteredStyles: cm.bind(null, n.registered),
    merge: MA.bind(null, n.registered, r)
  };
}, tV = function e(t) {
  for (var n = "", r = 0; r < t.length; r++) {
    var s = t[r];
    if (s != null) {
      var f = void 0;
      switch (typeof s) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(s))
            f = e(s);
          else {
            f = "";
            for (var m in s)
              s[m] && m && (f && (f += " "), f += m);
          }
          break;
        }
        default:
          f = s;
      }
      f && (n && (n += " "), n += f);
    }
  }
  return n;
}, PR = eV({
  key: "css"
}), hn = PR.cx, mt = PR.css;
function d1(e, t) {
  let n = e;
  for (; (n = n.parentElement) && !n.matches(t); )
    ;
  return n;
}
function nV(e, t, n) {
  for (let r = e - 1; r >= 0; r -= 1)
    if (!t[r].disabled)
      return r;
  if (n) {
    for (let r = t.length - 1; r > -1; r -= 1)
      if (!t[r].disabled)
        return r;
  }
  return e;
}
function rV(e, t, n) {
  for (let r = e + 1; r < t.length; r += 1)
    if (!t[r].disabled)
      return r;
  if (n) {
    for (let r = 0; r < t.length; r += 1)
      if (!t[r].disabled)
        return r;
  }
  return e;
}
function aV(e, t, n) {
  return d1(e, n) === d1(t, n);
}
function DS({
  parentSelector: e,
  siblingSelector: t,
  onKeyDown: n,
  loop: r = !0,
  activateOnFocus: s = !1,
  dir: f = "rtl",
  orientation: m
}) {
  return (p) => {
    var v;
    n == null || n(p);
    const y = Array.from(((v = d1(p.currentTarget, e)) == null ? void 0 : v.querySelectorAll(t)) || []).filter((O) => aV(p.currentTarget, O, e)), w = y.findIndex((O) => p.currentTarget === O), P = rV(w, y, r), x = nV(w, y, r), A = f === "rtl" ? x : P, M = f === "rtl" ? P : x;
    switch (p.key) {
      case "ArrowRight": {
        m === "horizontal" && (p.stopPropagation(), p.preventDefault(), y[A].focus(), s && y[A].click());
        break;
      }
      case "ArrowLeft": {
        m === "horizontal" && (p.stopPropagation(), p.preventDefault(), y[M].focus(), s && y[M].click());
        break;
      }
      case "ArrowUp": {
        m === "vertical" && (p.stopPropagation(), p.preventDefault(), y[x].focus(), s && y[x].click());
        break;
      }
      case "ArrowDown": {
        m === "vertical" && (p.stopPropagation(), p.preventDefault(), y[P].focus(), s && y[P].click());
        break;
      }
      case "Home": {
        p.stopPropagation(), p.preventDefault(), !y[0].disabled && y[0].focus();
        break;
      }
      case "End": {
        p.stopPropagation(), p.preventDefault();
        const O = y.length - 1;
        !y[O].disabled && y[O].focus();
        break;
      }
    }
  };
}
function iV(e, t, n) {
  var r;
  return n ? Array.from(((r = d1(n, t)) == null ? void 0 : r.querySelectorAll(e)) || []).findIndex((s) => s === n) : null;
}
function dg(e) {
  const t = F.exports.createContext(null);
  return [({ children: s, value: f }) => /* @__PURE__ */ T.createElement(t.Provider, {
    value: f
  }, s), () => {
    const s = F.exports.useContext(t);
    if (s === null)
      throw new Error(e);
    return s;
  }];
}
function f1(e) {
  return Array.isArray(e) ? e : [e];
}
function m1(e, t) {
  return (n) => {
    if (typeof n != "string" || n.trim().length === 0)
      throw new Error(t);
    return `${e}-${n}`;
  };
}
const oV = () => {
};
function sV(e, t = { active: !0 }) {
  return typeof e != "function" || !t.active ? t.onKeyDown || oV : (n) => {
    var r;
    n.key === "Escape" && (e(n), (r = t.onTrigger) == null || r.call(t));
  };
}
function fc(e, t) {
  return (n) => {
    e == null || e(n), t == null || t(n);
  };
}
function lV() {
  const [e, t] = F.exports.useState(-1);
  return [e, { setHovered: t, resetHovered: () => t(-1) }];
}
function NS(e) {
  return Array.isArray(e) || e === null ? !1 : typeof e == "object" ? e.type !== T.Fragment : !1;
}
function kR(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = kR(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function $R() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = kR(t)) && (r && (r += " "), r += n);
  return r;
}
const SR = {
  dark: [
    "#C1C2C5",
    "#A6A7AB",
    "#909296",
    "#5c5f66",
    "#373A40",
    "#2C2E33",
    "#25262b",
    "#1A1B1E",
    "#141517",
    "#101113"
  ],
  gray: [
    "#f8f9fa",
    "#f1f3f5",
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529"
  ],
  red: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a"
  ],
  pink: [
    "#fff0f6",
    "#ffdeeb",
    "#fcc2d7",
    "#faa2c1",
    "#f783ac",
    "#f06595",
    "#e64980",
    "#d6336c",
    "#c2255c",
    "#a61e4d"
  ],
  grape: [
    "#f8f0fc",
    "#f3d9fa",
    "#eebefa",
    "#e599f7",
    "#da77f2",
    "#cc5de8",
    "#be4bdb",
    "#ae3ec9",
    "#9c36b5",
    "#862e9c"
  ],
  violet: [
    "#f3f0ff",
    "#e5dbff",
    "#d0bfff",
    "#b197fc",
    "#9775fa",
    "#845ef7",
    "#7950f2",
    "#7048e8",
    "#6741d9",
    "#5f3dc4"
  ],
  indigo: [
    "#edf2ff",
    "#dbe4ff",
    "#bac8ff",
    "#91a7ff",
    "#748ffc",
    "#5c7cfa",
    "#4c6ef5",
    "#4263eb",
    "#3b5bdb",
    "#364fc7"
  ],
  blue: [
    "#e7f5ff",
    "#d0ebff",
    "#a5d8ff",
    "#74c0fc",
    "#4dabf7",
    "#339af0",
    "#228be6",
    "#1c7ed6",
    "#1971c2",
    "#1864ab"
  ],
  cyan: [
    "#e3fafc",
    "#c5f6fa",
    "#99e9f2",
    "#66d9e8",
    "#3bc9db",
    "#22b8cf",
    "#15aabf",
    "#1098ad",
    "#0c8599",
    "#0b7285"
  ],
  teal: [
    "#e6fcf5",
    "#c3fae8",
    "#96f2d7",
    "#63e6be",
    "#38d9a9",
    "#20c997",
    "#12b886",
    "#0ca678",
    "#099268",
    "#087f5b"
  ],
  green: [
    "#ebfbee",
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e"
  ],
  lime: [
    "#f4fce3",
    "#e9fac8",
    "#d8f5a2",
    "#c0eb75",
    "#a9e34b",
    "#94d82d",
    "#82c91e",
    "#74b816",
    "#66a80f",
    "#5c940d"
  ],
  yellow: [
    "#fff9db",
    "#fff3bf",
    "#ffec99",
    "#ffe066",
    "#ffd43b",
    "#fcc419",
    "#fab005",
    "#f59f00",
    "#f08c00",
    "#e67700"
  ],
  orange: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f"
  ]
};
function uV(e) {
  return () => ({ fontFamily: e.fontFamily || "sans-serif" });
}
var cV = Object.defineProperty, EA = Object.getOwnPropertySymbols, dV = Object.prototype.hasOwnProperty, fV = Object.prototype.propertyIsEnumerable, AA = (e, t, n) => t in e ? cV(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, _A = (e, t) => {
  for (var n in t || (t = {}))
    dV.call(t, n) && AA(e, n, t[n]);
  if (EA)
    for (var n of EA(t))
      fV.call(t, n) && AA(e, n, t[n]);
  return e;
};
function mV(e) {
  return (t) => ({
    WebkitTapHighlightColor: "transparent",
    [t || "&:focus"]: _A({}, e.focusRing === "always" || e.focusRing === "auto" ? e.focusRingStyles.styles(e) : e.focusRingStyles.resetStyles(e)),
    [t ? t.replace(":focus", ":focus:not(:focus-visible)") : "&:focus:not(:focus-visible)"]: _A({}, e.focusRing === "auto" || e.focusRing === "never" ? e.focusRingStyles.resetStyles(e) : null)
  });
}
function fg(e) {
  return (t) => typeof e.primaryShade == "number" ? e.primaryShade : e.primaryShade[t || e.colorScheme];
}
function WS(e) {
  const t = fg(e);
  return (n, r, s = !0, f = !0) => {
    if (typeof n == "string" && n.includes(".")) {
      const [p, v] = n.split("."), y = parseInt(v, 10);
      if (p in e.colors && y >= 0 && y < 10)
        return e.colors[p][typeof r == "number" && !f ? r : y];
    }
    const m = typeof r == "number" ? r : t();
    return n in e.colors ? e.colors[n][m] : s ? e.colors[e.primaryColor][m] : n;
  };
}
function xR(e) {
  let t = "";
  for (let n = 1; n < e.length - 1; n += 1)
    t += `${e[n]} ${n / (e.length - 1) * 100}%, `;
  return `${e[0]} 0%, ${t}${e[e.length - 1]} 100%`;
}
function hV(e, ...t) {
  return `linear-gradient(${e}deg, ${xR(t)})`;
}
function pV(...e) {
  return `radial-gradient(circle, ${xR(e)})`;
}
function CR(e) {
  const t = WS(e), n = fg(e);
  return (r) => {
    const s = {
      from: (r == null ? void 0 : r.from) || e.defaultGradient.from,
      to: (r == null ? void 0 : r.to) || e.defaultGradient.to,
      deg: (r == null ? void 0 : r.deg) || e.defaultGradient.deg
    };
    return `linear-gradient(${s.deg}deg, ${t(s.from, n(), !1)} 0%, ${t(s.to, n(), !1)} 100%)`;
  };
}
function jS(e) {
  if (typeof e.size == "number")
    return e.size;
  const t = e.sizes[e.size];
  return t !== void 0 ? t : e.size || e.sizes.md;
}
function vV(e) {
  return (t) => `@media (min-width: ${jS({ size: t, sizes: e.breakpoints })}px)`;
}
function gV(e) {
  return (t) => `@media (max-width: ${jS({ size: t, sizes: e.breakpoints }) - 1}px)`;
}
function yV(e) {
  return /^#?([0-9A-F]{3}){1,2}$/i.test(e);
}
function bV(e) {
  let t = e.replace("#", "");
  if (t.length === 3) {
    const m = t.split("");
    t = [
      m[0],
      m[0],
      m[1],
      m[1],
      m[2],
      m[2]
    ].join("");
  }
  const n = parseInt(t, 16), r = n >> 16 & 255, s = n >> 8 & 255, f = n & 255;
  return {
    r,
    g: s,
    b: f,
    a: 1
  };
}
function wV(e) {
  const [t, n, r, s] = e.replace(/[^0-9,.]/g, "").split(",").map(Number);
  return { r: t, g: n, b: r, a: s || 1 };
}
function zS(e) {
  return yV(e) ? bV(e) : e.startsWith("rgb") ? wV(e) : {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}
function _h(e, t) {
  if (typeof e != "string" || t > 1 || t < 0)
    return "rgba(0, 0, 0, 1)";
  const { r: n, g: r, b: s } = zS(e);
  return `rgba(${n}, ${r}, ${s}, ${t})`;
}
function PV(e = 0) {
  return {
    position: "absolute",
    top: e,
    right: e,
    left: e,
    bottom: e
  };
}
function kV(e, t) {
  const { r: n, g: r, b: s, a: f } = zS(e), m = 1 - t, p = (v) => Math.round(v * m);
  return `rgba(${p(n)}, ${p(r)}, ${p(s)}, ${f})`;
}
function $V(e, t) {
  const { r: n, g: r, b: s, a: f } = zS(e), m = (p) => Math.round(p + (255 - p) * t);
  return `rgba(${m(n)}, ${m(r)}, ${m(s)}, ${f})`;
}
function SV(e) {
  return (t) => {
    if (typeof t == "number")
      return t;
    const n = typeof e.defaultRadius == "number" ? e.defaultRadius : e.radius[e.defaultRadius] || e.defaultRadius;
    return e.radius[t] || t || n;
  };
}
function xV(e, t) {
  if (typeof e == "string" && e.includes(".")) {
    const [n, r] = e.split("."), s = parseInt(r, 10);
    if (n in t.colors && s >= 0 && s < 10)
      return { isSplittedColor: !0, key: n, shade: s };
  }
  return { isSplittedColor: !1 };
}
function CV(e) {
  const t = WS(e), n = fg(e), r = CR(e);
  return ({ variant: s, color: f, gradient: m, primaryFallback: p }) => {
    const v = xV(f, e);
    switch (s) {
      case "light":
        return {
          border: "transparent",
          background: _h(t(f, e.colorScheme === "dark" ? 8 : 0, p, !1), e.colorScheme === "dark" ? 0.2 : 1),
          color: f === "dark" ? e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.dark[9] : t(f, e.colorScheme === "dark" ? 2 : n("light")),
          hover: _h(t(f, e.colorScheme === "dark" ? 7 : 1, p, !1), e.colorScheme === "dark" ? 0.25 : 0.65)
        };
      case "subtle":
        return {
          border: "transparent",
          background: "transparent",
          color: f === "dark" ? e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.dark[9] : t(f, e.colorScheme === "dark" ? 2 : n("light")),
          hover: _h(t(f, e.colorScheme === "dark" ? 8 : 0, p, !1), e.colorScheme === "dark" ? 0.2 : 1)
        };
      case "outline":
        return {
          border: t(f, e.colorScheme === "dark" ? 5 : n("light")),
          background: "transparent",
          color: t(f, e.colorScheme === "dark" ? 5 : n("light")),
          hover: e.colorScheme === "dark" ? _h(t(f, 5, p, !1), 0.05) : _h(t(f, 0, p, !1), 0.35)
        };
      case "default":
        return {
          border: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4],
          background: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
          color: e.colorScheme === "dark" ? e.white : e.black,
          hover: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[0]
        };
      case "white":
        return {
          border: "transparent",
          background: e.white,
          color: t(f, n()),
          hover: null
        };
      case "transparent":
        return {
          border: "transparent",
          color: f === "dark" ? e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.dark[9] : t(f, e.colorScheme === "dark" ? 2 : n("light")),
          background: "transparent",
          hover: null
        };
      case "gradient":
        return {
          background: r(m),
          color: e.white,
          border: "transparent",
          hover: null
        };
      default: {
        const y = n(), w = v.isSplittedColor ? v.shade : y, P = v.isSplittedColor ? v.key : f;
        return {
          border: "transparent",
          background: t(P, w, p),
          color: e.white,
          hover: t(P, w === 9 ? 8 : w + 1)
        };
      }
    }
  };
}
function MV(e) {
  return (t) => {
    const n = fg(e)(t);
    return e.colors[e.primaryColor][n];
  };
}
function EV(e) {
  return {
    "@media (hover: hover)": {
      "&:hover": e
    },
    "@media (hover: none)": {
      "&:active": e
    }
  };
}
const hi = {
  fontStyles: uV,
  themeColor: WS,
  focusStyles: mV,
  linearGradient: hV,
  radialGradient: pV,
  smallerThan: gV,
  largerThan: vV,
  rgba: _h,
  size: jS,
  cover: PV,
  darken: kV,
  lighten: $V,
  radius: SV,
  variant: CV,
  primaryShade: fg,
  hover: EV,
  gradient: CR,
  primaryColor: MV
};
var AV = Object.defineProperty, _V = Object.defineProperties, OV = Object.getOwnPropertyDescriptors, OA = Object.getOwnPropertySymbols, TV = Object.prototype.hasOwnProperty, RV = Object.prototype.propertyIsEnumerable, TA = (e, t, n) => t in e ? AV(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, DV = (e, t) => {
  for (var n in t || (t = {}))
    TV.call(t, n) && TA(e, n, t[n]);
  if (OA)
    for (var n of OA(t))
      RV.call(t, n) && TA(e, n, t[n]);
  return e;
}, NV = (e, t) => _V(e, OV(t));
function MR(e) {
  return NV(DV({}, e), {
    fn: {
      fontStyles: hi.fontStyles(e),
      themeColor: hi.themeColor(e),
      focusStyles: hi.focusStyles(e),
      largerThan: hi.largerThan(e),
      smallerThan: hi.smallerThan(e),
      radialGradient: hi.radialGradient,
      linearGradient: hi.linearGradient,
      gradient: hi.gradient(e),
      rgba: hi.rgba,
      size: hi.size,
      cover: hi.cover,
      lighten: hi.lighten,
      darken: hi.darken,
      primaryShade: hi.primaryShade(e),
      radius: hi.radius(e),
      variant: hi.variant(e),
      hover: hi.hover,
      primaryColor: hi.primaryColor(e)
    }
  });
}
Object.keys(SR);
const WV = {
  dir: "ltr",
  primaryShade: {
    light: 6,
    dark: 8
  },
  focusRing: "auto",
  loader: "oval",
  dateFormat: "MMMM D, YYYY",
  colorScheme: "light",
  white: "#fff",
  black: "#000",
  defaultRadius: "sm",
  transitionTimingFunction: "ease",
  colors: SR,
  lineHeight: 1.55,
  fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
  primaryColor: "blue",
  respectReducedMotion: !0,
  cursorType: "default",
  defaultGradient: {
    from: "indigo",
    to: "cyan",
    deg: 45
  },
  shadows: {
    xs: "0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)",
    sm: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 10px 15px -5px, rgba(0, 0, 0, 0.04) 0px 7px 7px -5px",
    md: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
    lg: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 28px 23px -7px, rgba(0, 0, 0, 0.04) 0px 12px 12px -7px",
    xl: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 36px 28px -7px, rgba(0, 0, 0, 0.04) 0px 17px 17px -7px"
  },
  fontSizes: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20
  },
  radius: {
    xs: 2,
    sm: 4,
    md: 8,
    lg: 16,
    xl: 32
  },
  spacing: {
    xs: 10,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24
  },
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1400
  },
  headings: {
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    fontWeight: 700,
    sizes: {
      h1: { fontSize: 34, lineHeight: 1.3, fontWeight: void 0 },
      h2: { fontSize: 26, lineHeight: 1.35, fontWeight: void 0 },
      h3: { fontSize: 22, lineHeight: 1.4, fontWeight: void 0 },
      h4: { fontSize: 18, lineHeight: 1.45, fontWeight: void 0 },
      h5: { fontSize: 16, lineHeight: 1.5, fontWeight: void 0 },
      h6: { fontSize: 14, lineHeight: 1.5, fontWeight: void 0 }
    }
  },
  other: {},
  components: {},
  activeStyles: { transform: "translateY(1px)" },
  datesLocale: "en",
  globalStyles: void 0,
  focusRingStyles: {
    styles: (e) => ({
      outlineOffset: 2,
      outline: `2px solid ${e.colors[e.primaryColor][e.colorScheme === "dark" ? 7 : 5]}`
    }),
    resetStyles: () => ({ outline: "none" }),
    inputStyles: (e) => ({
      outline: "none",
      borderColor: e.colors[e.primaryColor][typeof e.primaryShade == "object" ? e.primaryShade[e.colorScheme] : e.primaryShade]
    })
  }
}, LS = MR(WV);
var jV = Object.defineProperty, zV = Object.defineProperties, LV = Object.getOwnPropertyDescriptors, RA = Object.getOwnPropertySymbols, IV = Object.prototype.hasOwnProperty, FV = Object.prototype.propertyIsEnumerable, DA = (e, t, n) => t in e ? jV(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, HV = (e, t) => {
  for (var n in t || (t = {}))
    IV.call(t, n) && DA(e, n, t[n]);
  if (RA)
    for (var n of RA(t))
      FV.call(t, n) && DA(e, n, t[n]);
  return e;
}, VV = (e, t) => zV(e, LV(t));
function BV({ theme: e }) {
  return /* @__PURE__ */ T.createElement(cg, {
    styles: {
      "*, *::before, *::after": {
        boxSizing: "border-box"
      },
      html: {
        colorScheme: e.colorScheme === "dark" ? "dark" : "light"
      },
      body: VV(HV({}, e.fn.fontStyles()), {
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
        lineHeight: e.lineHeight,
        fontSize: e.fontSizes.md,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale"
      })
    }
  });
}
function wb(e, t, n) {
  Object.keys(t).forEach((r) => {
    e[`--mantine-${n}-${r}`] = typeof t[r] == "number" ? `${t[r]}px` : t[r];
  });
}
function UV({ theme: e }) {
  const t = {
    "--mantine-color-white": e.white,
    "--mantine-color-black": e.black,
    "--mantine-transition-timing-function": e.transitionTimingFunction,
    "--mantine-line-height": `${e.lineHeight}`,
    "--mantine-font-family": e.fontFamily,
    "--mantine-font-family-monospace": e.fontFamilyMonospace,
    "--mantine-font-family-headings": e.headings.fontFamily,
    "--mantine-heading-font-weight": `${e.headings.fontWeight}`
  };
  wb(t, e.shadows, "shadow"), wb(t, e.fontSizes, "font-size"), wb(t, e.radius, "radius"), wb(t, e.spacing, "spacing"), Object.keys(e.colors).forEach((r) => {
    e.colors[r].forEach((s, f) => {
      t[`--mantine-color-${r}-${f}`] = s;
    });
  });
  const n = e.headings.sizes;
  return Object.keys(n).forEach((r) => {
    t[`--mantine-${r}-font-size`] = `${n[r].fontSize}px`, t[`--mantine-${r}-line-height`] = `${n[r].lineHeight}`;
  }), /* @__PURE__ */ T.createElement(cg, {
    styles: {
      ":root": t
    }
  });
}
var XV = Object.defineProperty, qV = Object.defineProperties, YV = Object.getOwnPropertyDescriptors, NA = Object.getOwnPropertySymbols, GV = Object.prototype.hasOwnProperty, QV = Object.prototype.propertyIsEnumerable, WA = (e, t, n) => t in e ? XV(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Qf = (e, t) => {
  for (var n in t || (t = {}))
    GV.call(t, n) && WA(e, n, t[n]);
  if (NA)
    for (var n of NA(t))
      QV.call(t, n) && WA(e, n, t[n]);
  return e;
}, jA = (e, t) => qV(e, YV(t));
function KV(e, t) {
  if (!t)
    return e;
  const n = Object.keys(e).reduce((r, s) => {
    if (s === "headings" && t.headings) {
      const f = t.headings.sizes ? Object.keys(e.headings.sizes).reduce((m, p) => (m[p] = Qf(Qf({}, e.headings.sizes[p]), t.headings.sizes[p]), m), {}) : e.headings.sizes;
      return jA(Qf({}, r), {
        headings: jA(Qf(Qf({}, e.headings), t.headings), {
          sizes: f
        })
      });
    }
    return r[s] = typeof t[s] == "object" ? Qf(Qf({}, e[s]), t[s]) : typeof t[s] == "number" || typeof t[s] == "boolean" || typeof t[s] == "function" ? t[s] : t[s] || e[s], r;
  }, {});
  if (!(n.primaryColor in n.colors))
    throw new Error("MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more – https://mantine.dev/theming/colors/#primary-color");
  return n;
}
function JV(e, t) {
  return MR(KV(e, t));
}
function ER(e) {
  return Object.keys(e).reduce((t, n) => (e[n] !== void 0 && (t[n] = e[n]), t), {});
}
const ZV = {
  html: {
    fontFamily: "sans-serif",
    lineHeight: "1.15",
    textSizeAdjust: "100%"
  },
  body: {
    margin: 0
  },
  "article, aside, footer, header, nav, section, figcaption, figure, main": {
    display: "block"
  },
  h1: {
    fontSize: "2em"
  },
  hr: {
    boxSizing: "content-box",
    height: 0,
    overflow: "visible"
  },
  pre: {
    fontFamily: "monospace, monospace",
    fontSize: "1em"
  },
  a: {
    background: "transparent",
    textDecorationSkip: "objects"
  },
  "a:active, a:hover": {
    outlineWidth: 0
  },
  "abbr[title]": {
    borderBottom: "none",
    textDecoration: "underline"
  },
  "b, strong": {
    fontWeight: "bolder"
  },
  "code, kbp, samp": {
    fontFamily: "monospace, monospace",
    fontSize: "1em"
  },
  dfn: {
    fontStyle: "italic"
  },
  mark: {
    backgroundColor: "#ff0",
    color: "#000"
  },
  small: {
    fontSize: "80%"
  },
  "sub, sup": {
    fontSize: "75%",
    lineHeight: 0,
    position: "relative",
    verticalAlign: "baseline"
  },
  sup: {
    top: "-0.5em"
  },
  sub: {
    bottom: "-0.25em"
  },
  "audio, video": {
    display: "inline-block"
  },
  "audio:not([controls])": {
    display: "none",
    height: 0
  },
  img: {
    borderStyle: "none",
    verticalAlign: "middle"
  },
  "svg:not(:root)": {
    overflow: "hidden"
  },
  "button, input, optgroup, select, textarea": {
    fontFamily: "sans-serif",
    fontSize: "100%",
    lineHeight: "1.15",
    margin: 0
  },
  "button, input": {
    overflow: "visible"
  },
  "button, select": {
    textTransform: "none"
  },
  "button, [type=reset], [type=submit]": {
    WebkitAppearance: "button"
  },
  "button::-moz-focus-inner, [type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner": {
    borderStyle: "none",
    padding: 0
  },
  "button:-moz-focusring, [type=button]:-moz-focusring, [type=reset]:-moz-focusring, [type=submit]:-moz-focusring": {
    outline: "1px dotted ButtonText"
  },
  legend: {
    boxSizing: "border-box",
    color: "inherit",
    display: "table",
    maxWidth: "100%",
    padding: 0,
    whiteSpace: "normal"
  },
  progress: {
    display: "inline-block",
    verticalAlign: "baseline"
  },
  textarea: {
    overflow: "auto"
  },
  "[type=checkbox], [type=radio]": {
    boxSizing: "border-box",
    padding: 0
  },
  "[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button": {
    height: "auto"
  },
  "[type=search]": {
    appearance: "none"
  },
  "[type=search]::-webkit-search-cancel-button, [type=search]::-webkit-search-decoration": {
    appearance: "none"
  },
  "::-webkit-file-upload-button": {
    appearance: "button",
    font: "inherit"
  },
  "details, menu": {
    display: "block"
  },
  summary: {
    display: "list-item"
  },
  canvas: {
    display: "inline-block"
  },
  template: {
    display: "none"
  },
  "[hidden]": {
    display: "none"
  }
};
function eB() {
  return /* @__PURE__ */ T.createElement(cg, {
    styles: ZV
  });
}
var tB = Object.defineProperty, zA = Object.getOwnPropertySymbols, nB = Object.prototype.hasOwnProperty, rB = Object.prototype.propertyIsEnumerable, LA = (e, t, n) => t in e ? tB(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Iv = (e, t) => {
  for (var n in t || (t = {}))
    nB.call(t, n) && LA(e, n, t[n]);
  if (zA)
    for (var n of zA(t))
      rB.call(t, n) && LA(e, n, t[n]);
  return e;
};
const h1 = F.exports.createContext({
  theme: LS
});
function vu() {
  var e;
  return ((e = F.exports.useContext(h1)) == null ? void 0 : e.theme) || LS;
}
function aB(e) {
  const t = vu(), n = (r) => {
    var s, f;
    return {
      styles: ((s = t.components[r]) == null ? void 0 : s.styles) || {},
      classNames: ((f = t.components[r]) == null ? void 0 : f.classNames) || {}
    };
  };
  return Array.isArray(e) ? e.map(n) : [n(e)];
}
function AR() {
  var e;
  return (e = F.exports.useContext(h1)) == null ? void 0 : e.emotionCache;
}
function Er(e, t, n) {
  var r;
  const f = (r = vu().components[e]) == null ? void 0 : r.defaultProps;
  return Iv(Iv(Iv({}, t), f), ER(n));
}
function _R({
  theme: e,
  emotionCache: t,
  withNormalizeCSS: n = !1,
  withGlobalStyles: r = !1,
  withCSSVariables: s = !1,
  inherit: f = !1,
  children: m
}) {
  const p = F.exports.useContext(h1), v = JV(LS, f ? Iv(Iv({}, p.theme), e) : e);
  return /* @__PURE__ */ T.createElement(SH, {
    theme: v
  }, /* @__PURE__ */ T.createElement(h1.Provider, {
    value: { theme: v, emotionCache: t }
  }, n && /* @__PURE__ */ T.createElement(eB, null), r && /* @__PURE__ */ T.createElement(BV, {
    theme: v
  }), s && /* @__PURE__ */ T.createElement(UV, {
    theme: v
  }), typeof v.globalStyles == "function" && /* @__PURE__ */ T.createElement(cg, {
    styles: v.globalStyles(v)
  }), m));
}
_R.displayName = "@mantine/core/MantineProvider";
const OR = F.exports.createContext({
  classNames: {},
  styles: {},
  unstyled: !1
});
function IS({
  children: e,
  classNames: t,
  unstyled: n,
  styles: r,
  staticSelector: s
}) {
  return /* @__PURE__ */ T.createElement(OR.Provider, {
    value: { classNames: t, styles: r, unstyled: n, staticSelector: s }
  }, e);
}
function gu() {
  return F.exports.useContext(OR);
}
const iB = {
  app: 100,
  modal: 200,
  popover: 300,
  overlay: 400,
  max: 9999
};
function FS(e) {
  return iB[e];
}
function oB(e, t) {
  const n = F.exports.useRef();
  return (!n.current || t.length !== n.current.prevDeps.length || n.current.prevDeps.map((r, s) => r === t[s]).indexOf(!1) >= 0) && (n.current = {
    v: e(),
    prevDeps: [...t]
  }), n.current.v;
}
const sB = Rw({ key: "mantine", prepend: !0 });
function lB() {
  return AR() || sB;
}
var uB = Object.defineProperty, IA = Object.getOwnPropertySymbols, cB = Object.prototype.hasOwnProperty, dB = Object.prototype.propertyIsEnumerable, FA = (e, t, n) => t in e ? uB(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, fB = (e, t) => {
  for (var n in t || (t = {}))
    cB.call(t, n) && FA(e, n, t[n]);
  if (IA)
    for (var n of IA(t))
      dB.call(t, n) && FA(e, n, t[n]);
  return e;
};
const Xk = "ref";
function mB(e) {
  let t;
  if (e.length !== 1)
    return { args: e, ref: t };
  const [n] = e;
  if (!(n instanceof Object))
    return { args: e, ref: t };
  if (!(Xk in n))
    return { args: e, ref: t };
  t = n[Xk];
  const r = fB({}, n);
  return delete r[Xk], { args: [r], ref: t };
}
const { cssFactory: hB } = (() => {
  function e(n, r, s) {
    const f = [], m = cm(n, f, s);
    return f.length < 2 ? s : m + r(f);
  }
  function t(n) {
    const { cache: r } = n, s = (...m) => {
      const { ref: p, args: v } = mB(m), y = kl(v, r.registered);
      return Kh(r, y, !1), `${r.key}-${y.name}${p === void 0 ? "" : ` ${p}`}`;
    };
    return { css: s, cx: (...m) => e(r.registered, s, $R(m)) };
  }
  return { cssFactory: t };
})();
function TR() {
  const e = lB();
  return oB(() => hB({ cache: e }), [e]);
}
function pB({
  cx: e,
  classes: t,
  context: n,
  classNames: r,
  name: s,
  cache: f
}) {
  const m = n.reduce((p, v) => (Object.keys(v.classNames).forEach((y) => {
    typeof p[y] != "string" ? p[y] = `${v.classNames[y]}` : p[y] = `${p[y]} ${v.classNames[y]}`;
  }), p), {});
  return Object.keys(t).reduce((p, v) => (p[v] = e(t[v], m[v], r != null && r[v], Array.isArray(s) ? s.filter(Boolean).map((y) => `${(f == null ? void 0 : f.key) || "mantine"}-${y}-${v}`).join(" ") : s ? `${(f == null ? void 0 : f.key) || "mantine"}-${s}-${v}` : null), p), {});
}
var vB = Object.defineProperty, HA = Object.getOwnPropertySymbols, gB = Object.prototype.hasOwnProperty, yB = Object.prototype.propertyIsEnumerable, VA = (e, t, n) => t in e ? vB(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, qk = (e, t) => {
  for (var n in t || (t = {}))
    gB.call(t, n) && VA(e, n, t[n]);
  if (HA)
    for (var n of HA(t))
      yB.call(t, n) && VA(e, n, t[n]);
  return e;
};
function bB(e) {
  return `__mantine-ref-${e || ""}`;
}
function BA(e, t, n) {
  const r = (s) => typeof s == "function" ? s(t, n || {}) : s || {};
  return Array.isArray(e) ? e.map((s) => r(s.styles)).reduce((s, f) => (Object.keys(f).forEach((m) => {
    s[m] ? s[m] = qk(qk({}, s[m]), f[m]) : s[m] = qk({}, f[m]);
  }), s), {}) : r(e);
}
function $n(e) {
  const t = typeof e == "function" ? e : () => e;
  function n(r, s) {
    const f = vu(), m = aB(s == null ? void 0 : s.name), p = AR(), { css: v, cx: y } = TR(), w = t(f, r, bB), P = BA(s == null ? void 0 : s.styles, f, r), x = BA(m, f, r), A = Object.fromEntries(Object.keys(w).map((M) => {
      const O = y({ [v(w[M])]: !(s != null && s.unstyled) }, v(x[M]), v(P[M]));
      return [M, O];
    }));
    return {
      classes: pB({
        cx: y,
        classes: A,
        context: m,
        classNames: s == null ? void 0 : s.classNames,
        name: s == null ? void 0 : s.name,
        cache: p
      }),
      cx: y,
      theme: f
    };
  }
  return n;
}
var wB = Object.defineProperty, PB = Object.defineProperties, kB = Object.getOwnPropertyDescriptors, UA = Object.getOwnPropertySymbols, $B = Object.prototype.hasOwnProperty, SB = Object.prototype.propertyIsEnumerable, XA = (e, t, n) => t in e ? wB(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Pv = (e, t) => {
  for (var n in t || (t = {}))
    $B.call(t, n) && XA(e, n, t[n]);
  if (UA)
    for (var n of UA(t))
      SB.call(t, n) && XA(e, n, t[n]);
  return e;
}, kv = (e, t) => PB(e, kB(t));
const $v = {
  in: { opacity: 1, transform: "scale(1)" },
  out: { opacity: 0, transform: "scale(.9) translateY(10px)" },
  transitionProperty: "transform, opacity"
}, Pb = {
  fade: {
    in: { opacity: 1 },
    out: { opacity: 0 },
    transitionProperty: "opacity"
  },
  scale: {
    in: { opacity: 1, transform: "scale(1)" },
    out: { opacity: 0, transform: "scale(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-y": {
    in: { opacity: 1, transform: "scaleY(1)" },
    out: { opacity: 0, transform: "scaleY(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-x": {
    in: { opacity: 1, transform: "scaleX(1)" },
    out: { opacity: 0, transform: "scaleX(0)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "skew-up": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: "translateY(-20px) skew(-10deg, -5deg)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "skew-down": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: "translateY(20px) skew(-10deg, -5deg)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-left": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: "translateY(20px) rotate(-5deg)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-right": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: "translateY(20px) rotate(5deg)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-down": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(-100%)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-up": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(100%)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "slide-left": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(100%)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "slide-right": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(-100%)" },
    common: { transformOrigin: "right" },
    transitionProperty: "transform, opacity"
  },
  pop: kv(Pv({}, $v), {
    common: { transformOrigin: "center center" }
  }),
  "pop-bottom-left": kv(Pv({}, $v), {
    common: { transformOrigin: "bottom left" }
  }),
  "pop-bottom-right": kv(Pv({}, $v), {
    common: { transformOrigin: "bottom right" }
  }),
  "pop-top-left": kv(Pv({}, $v), {
    common: { transformOrigin: "top left" }
  }),
  "pop-top-right": kv(Pv({}, $v), {
    common: { transformOrigin: "top right" }
  })
}, qA = ["mousedown", "touchstart"];
function xB(e, t, n) {
  const r = F.exports.useRef();
  return F.exports.useEffect(() => {
    const s = (f) => {
      const { target: m } = f ?? {};
      if (Array.isArray(n)) {
        const p = (m == null ? void 0 : m.hasAttribute("data-ignore-outside-clicks")) || !document.body.contains(m);
        n.every((y) => !!y && !y.contains(m)) && !p && e();
      } else
        r.current && !r.current.contains(m) && e();
    };
    return (t || qA).forEach((f) => document.addEventListener(f, s)), () => {
      (t || qA).forEach((f) => document.removeEventListener(f, s));
    };
  }, [r, e, n]), r;
}
function CB(e, t) {
  try {
    return e.addEventListener("change", t), () => e.removeEventListener("change", t);
  } catch {
    return e.addListener(t), () => e.removeListener(t);
  }
}
function MB(e, t) {
  return typeof t == "boolean" ? t : typeof window < "u" && "matchMedia" in window ? window.matchMedia(e).matches : !1;
}
function EB(e, t, { getInitialValueInEffect: n } = {
  getInitialValueInEffect: !0
}) {
  const [r, s] = F.exports.useState(n ? !1 : MB(e, t)), f = F.exports.useRef();
  return F.exports.useEffect(() => {
    if ("matchMedia" in window)
      return f.current = window.matchMedia(e), s(f.current.matches), CB(f.current, (m) => s(m.matches));
  }, [e]), r;
}
const RR = typeof document < "u" ? F.exports.useLayoutEffect : F.exports.useEffect;
function kd(e, t) {
  const n = F.exports.useRef(!1);
  F.exports.useEffect(() => () => {
    n.current = !1;
  }, []), F.exports.useEffect(() => {
    if (n.current)
      return e();
    n.current = !0;
  }, t);
}
function AB({ opened: e, shouldReturnFocus: t = !0 }) {
  const n = F.exports.useRef(), r = () => {
    var s;
    n.current && "focus" in n.current && typeof n.current.focus == "function" && ((s = n.current) == null || s.focus({ preventScroll: !0 }));
  };
  return kd(() => {
    let s = -1;
    const f = (m) => {
      m.key === "Tab" && window.clearTimeout(s);
    };
    return document.addEventListener("keydown", f), e ? n.current = document.activeElement : t && (s = window.setTimeout(r, 10)), () => {
      window.clearTimeout(s), document.removeEventListener("keydown", f);
    };
  }, [e, t]), r;
}
const _B = /input|select|textarea|button|object/, DR = "a, input, select, textarea, button, object, [tabindex]";
function OB(e) {
  return process.env.NODE_ENV === "test" ? !1 : e.style.display === "none";
}
function TB(e) {
  if (e.getAttribute("aria-hidden") || e.getAttribute("hidden") || e.getAttribute("type") === "hidden")
    return !1;
  let n = e;
  for (; n && n !== document.body; ) {
    if (OB(n))
      return !1;
    n = n.parentNode;
  }
  return !0;
}
function NR(e) {
  let t = e.getAttribute("tabindex");
  return t === null && (t = void 0), parseInt(t, 10);
}
function D$(e) {
  const t = e.nodeName.toLowerCase(), n = !Number.isNaN(NR(e));
  return (_B.test(t) && !e.disabled || e instanceof HTMLAnchorElement && e.href || n) && TB(e);
}
function WR(e) {
  const t = NR(e);
  return (Number.isNaN(t) || t >= 0) && D$(e);
}
function RB(e) {
  return Array.from(e.querySelectorAll(DR)).filter(WR);
}
function DB(e, t) {
  const n = RB(e);
  if (!n.length) {
    t.preventDefault();
    return;
  }
  if (!(n[t.shiftKey ? 0 : n.length - 1] === document.activeElement || e === document.activeElement))
    return;
  t.preventDefault();
  const f = n[t.shiftKey ? n.length - 1 : 0];
  f && f.focus();
}
function NB(e, t = "body > :not(script)") {
  const n = Array.from(document.querySelectorAll(t)).map((r) => {
    if (r.contains(e))
      return;
    const s = r.getAttribute("aria-hidden");
    return (s === null || s === "false") && r.setAttribute("aria-hidden", "true"), { node: r, ariaHidden: s };
  });
  return () => {
    n.forEach((r) => {
      r && (r.ariaHidden === null ? r.node.removeAttribute("aria-hidden") : r.node.setAttribute("aria-hidden", r.ariaHidden));
    });
  };
}
function WB(e = !0) {
  const t = F.exports.useRef(), n = F.exports.useRef(null), r = F.exports.useCallback((s) => {
    if (e && s !== null && (n.current = NB(s), t.current !== s))
      if (s) {
        const f = () => {
          let m = s.querySelector("[data-autofocus]");
          if (!m) {
            const p = Array.from(s.querySelectorAll(DR));
            m = p.find(WR) || p.find(D$) || null, !m && D$(s) && (m = s);
          }
          m ? m.focus({ preventScroll: !0 }) : process.env.NODE_ENV === "development" && console.warn("[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node", s);
        };
        setTimeout(() => {
          s.ownerDocument ? f() : process.env.NODE_ENV === "development" && console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", s);
        }), t.current = s;
      } else
        t.current = null;
  }, [e]);
  return F.exports.useEffect(() => {
    if (!e)
      return;
    const s = (f) => {
      f.key === "Tab" && t.current && DB(t.current, f);
    };
    return document.addEventListener("keydown", s), () => {
      document.removeEventListener("keydown", s), n.current && n.current();
    };
  }, [e]), r;
}
const jB = () => `mantine-${Math.random().toString(36).slice(2, 11)}`, zB = T["useId".toString()] || (() => {
});
function LB() {
  const [e, t] = F.exports.useState("");
  return RR(() => {
    t(jB());
  }, []), e;
}
function IB() {
  const e = zB();
  return e ? `mantine-${e.replace(/:/g, "")}` : "";
}
function Nw(e) {
  return typeof e == "string" ? e : IB() || LB();
}
function FB(e, t) {
  typeof e == "function" ? e(t) : typeof e == "object" && e !== null && "current" in e && (e.current = t);
}
function jR(...e) {
  return (t) => {
    e.forEach((n) => FB(n, t));
  };
}
function HS(...e) {
  return F.exports.useCallback(jR(...e), e);
}
function Jh({
  value: e,
  defaultValue: t,
  finalValue: n,
  onChange: r = () => {
  }
}) {
  const [s, f] = F.exports.useState(t !== void 0 ? t : n), m = (p) => {
    f(p), r == null || r(p);
  };
  return e !== void 0 ? [e, r, !0] : [s, m, !1];
}
function zR(e, t) {
  return EB("(prefers-reduced-motion: reduce)", e, t);
}
function HB() {
  const [e, t] = F.exports.useState(!1), n = F.exports.useRef(null), r = F.exports.useCallback(() => t(!0), []), s = F.exports.useCallback(() => t(!1), []);
  return F.exports.useEffect(() => {
    if (n.current)
      return n.current.addEventListener("mouseenter", r), n.current.addEventListener("mouseleave", s), () => {
        var f, m;
        (f = n.current) == null || f.removeEventListener("mouseenter", r), (m = n.current) == null || m.removeEventListener("mouseleave", s);
      };
  }, []), { ref: n, hovered: e };
}
const p1 = {
  context: "Accordion component was not found in the tree",
  itemContext: "Accordion.Item component was not found in the tree",
  value: "Accordion.Item component was rendered with invalid value or without value"
}, [VB, VS] = dg(p1.context);
function BB({
  children: e,
  multiple: t,
  value: n,
  defaultValue: r,
  onChange: s,
  id: f,
  loop: m,
  transitionDuration: p,
  disableChevronRotation: v,
  chevronPosition: y,
  chevronSize: w,
  order: P,
  chevron: x,
  variant: A,
  radius: M
}) {
  const O = Nw(f), [j, H] = Jh({
    value: n,
    defaultValue: r,
    finalValue: t ? [] : null,
    onChange: s
  }), J = (X) => Array.isArray(j) ? j.includes(X) : X === j, V = (X) => {
    const U = Array.isArray(j) ? j.includes(X) ? j.filter((K) => K !== X) : [...j, X] : X === j ? null : X;
    H(U);
  };
  return /* @__PURE__ */ T.createElement(VB, {
    value: {
      isItemActive: J,
      onChange: V,
      getControlId: m1(`${O}-control`, p1.value),
      getRegionId: m1(`${O}-panel`, p1.value),
      transitionDuration: p,
      disableChevronRotation: v,
      chevronPosition: y,
      chevronSize: w,
      order: P,
      chevron: x,
      loop: m,
      variant: A,
      radius: M
    }
  }, e);
}
const [UB, LR] = dg(p1.itemContext);
function XB(e, { variant: t, radius: n }) {
  const r = e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3], s = e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0], f = e.fn.radius(n);
  return t === "default" ? {
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    borderBottom: `1px solid ${r}`
  } : t === "contained" ? {
    border: `1px solid ${r}`,
    transition: "background-color 150ms ease",
    "&[data-active]": {
      backgroundColor: s
    },
    "&:first-of-type": {
      borderTopRightRadius: f,
      borderTopLeftRadius: f,
      "& > [data-accordion-control]": {
        borderTopRightRadius: f,
        borderTopLeftRadius: f
      }
    },
    "&:last-of-type": {
      borderBottomRightRadius: f,
      borderBottomLeftRadius: f,
      "& > [data-accordion-control]": {
        borderBottomRightRadius: f,
        borderBottomLeftRadius: f
      }
    },
    "& + &": {
      borderTop: 0
    }
  } : t === "filled" ? {
    borderRadius: f,
    "&[data-active]": {
      backgroundColor: s
    }
  } : t === "separated" ? {
    borderRadius: f,
    backgroundColor: s,
    border: "1px solid transparent",
    transition: "background-color 150ms ease",
    "& + &": {
      marginTop: e.spacing.md
    },
    "&[data-active]": {
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
      borderColor: r
    }
  } : {};
}
var qB = $n((e, t) => ({
  item: XB(e, t)
}));
const YB = qB;
var YA = Object.getOwnPropertySymbols, GB = Object.prototype.hasOwnProperty, QB = Object.prototype.propertyIsEnumerable, KB = (e, t) => {
  var n = {};
  for (var r in e)
    GB.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && YA)
    for (var r of YA(e))
      t.indexOf(r) < 0 && QB.call(e, r) && (n[r] = e[r]);
  return n;
};
function Ww(e) {
  const t = e, {
    m: n,
    mx: r,
    my: s,
    mt: f,
    mb: m,
    ml: p,
    mr: v,
    p: y,
    px: w,
    py: P,
    pt: x,
    pb: A,
    pl: M,
    pr: O,
    bg: j,
    c: H,
    opacity: J,
    ff: V,
    fz: X,
    fw: U,
    lts: K,
    ta: ce,
    lh: ue,
    fs: ye,
    tt: Oe,
    td: _e,
    w: Le,
    miw: Ne,
    maw: nt,
    h: Qe,
    mih: qe,
    mah: ie,
    bgsz: xe,
    bgp: Ye,
    bgr: Be,
    bga: Ce,
    pos: Ie,
    top: $e,
    left: ot,
    bottom: ht,
    right: At,
    inset: Sn,
    display: Gt
  } = t, Bt = KB(t, [
    "m",
    "mx",
    "my",
    "mt",
    "mb",
    "ml",
    "mr",
    "p",
    "px",
    "py",
    "pt",
    "pb",
    "pl",
    "pr",
    "bg",
    "c",
    "opacity",
    "ff",
    "fz",
    "fw",
    "lts",
    "ta",
    "lh",
    "fs",
    "tt",
    "td",
    "w",
    "miw",
    "maw",
    "h",
    "mih",
    "mah",
    "bgsz",
    "bgp",
    "bgr",
    "bga",
    "pos",
    "top",
    "left",
    "bottom",
    "right",
    "inset",
    "display"
  ]);
  return { systemStyles: ER({
    m: n,
    mx: r,
    my: s,
    mt: f,
    mb: m,
    ml: p,
    mr: v,
    p: y,
    px: w,
    py: P,
    pt: x,
    pb: A,
    pl: M,
    pr: O,
    bg: j,
    c: H,
    opacity: J,
    ff: V,
    fz: X,
    fw: U,
    lts: K,
    ta: ce,
    lh: ue,
    fs: ye,
    tt: Oe,
    td: _e,
    w: Le,
    miw: Ne,
    maw: nt,
    h: Qe,
    mih: qe,
    mah: ie,
    bgsz: xe,
    bgp: Ye,
    bgr: Be,
    bga: Ce,
    pos: Ie,
    top: $e,
    left: ot,
    bottom: ht,
    right: At,
    inset: Sn,
    display: Gt
  }), rest: Bt };
}
function JB(e, t) {
  const n = Object.keys(e).filter((r) => r !== "base").sort((r, s) => t.fn.size({ size: r, sizes: t.breakpoints }) - t.fn.size({ size: s, sizes: t.breakpoints }));
  return "base" in e ? ["base", ...n] : n;
}
function ZB({ value: e, theme: t, getValue: n, property: r }) {
  if (e == null)
    return;
  if (typeof e == "object")
    return JB(e, t).reduce((m, p) => {
      if (p === "base" && e.base !== void 0) {
        const y = n(e.base, t);
        return Array.isArray(r) ? (r.forEach((w) => {
          m[w] = y;
        }), m) : (m[r] = y, m);
      }
      const v = n(e[p], t);
      return Array.isArray(r) ? (m[t.fn.largerThan(p)] = {}, r.forEach((y) => {
        m[t.fn.largerThan(p)][y] = v;
      }), m) : (m[t.fn.largerThan(p)] = {
        [r]: v
      }, m);
    }, {});
  const s = n(e, t);
  return Array.isArray(r) ? r.reduce((f, m) => (f[m] = s, f), {}) : { [r]: s };
}
function eU(e, t) {
  return e === "dimmed" ? t.colorScheme === "dark" ? t.colors.dark[2] : t.colors.gray[6] : t.fn.variant({ variant: "filled", color: e, primaryFallback: !1 }).background;
}
function tU(e) {
  return e;
}
function nU(e, t) {
  return t.fn.size({ size: e, sizes: t.fontSizes });
}
const rU = ["-xs", "-sm", "-md", "-lg", "-xl"];
function aU(e, t) {
  return rU.includes(e) ? t.fn.size({ size: e.replace("-", ""), sizes: t.spacing }) * -1 : t.fn.size({ size: e, sizes: t.spacing });
}
const iU = {
  color: eU,
  default: tU,
  fontSize: nU,
  spacing: aU
}, oU = {
  m: { type: "spacing", property: "margin" },
  mt: { type: "spacing", property: "marginTop" },
  mb: { type: "spacing", property: "marginBottom" },
  ml: { type: "spacing", property: "marginLeft" },
  mr: { type: "spacing", property: "marginRight" },
  mx: { type: "spacing", property: ["marginRight", "marginLeft"] },
  my: { type: "spacing", property: ["marginTop", "marginBottom"] },
  p: { type: "spacing", property: "padding" },
  pt: { type: "spacing", property: "paddingTop" },
  pb: { type: "spacing", property: "paddingBottom" },
  pl: { type: "spacing", property: "paddingLeft" },
  pr: { type: "spacing", property: "paddingRight" },
  px: { type: "spacing", property: ["paddingRight", "paddingLeft"] },
  py: { type: "spacing", property: ["paddingTop", "paddingBottom"] },
  bg: { type: "color", property: "background" },
  c: { type: "color", property: "color" },
  opacity: { type: "default", property: "opacity" },
  ff: { type: "default", property: "fontFamily" },
  fz: { type: "fontSize", property: "fontSize" },
  fw: { type: "default", property: "fontWeight" },
  lts: { type: "default", property: "letterSpacing" },
  ta: { type: "default", property: "textAlign" },
  lh: { type: "default", property: "lineHeight" },
  fs: { type: "default", property: "fontStyle" },
  tt: { type: "default", property: "textTransform" },
  td: { type: "default", property: "textDecoration" },
  w: { type: "default", property: "width" },
  miw: { type: "default", property: "minWidth" },
  maw: { type: "default", property: "maxWidth" },
  h: { type: "default", property: "height" },
  mih: { type: "default", property: "minHeight" },
  mah: { type: "default", property: "maxHeight" },
  bgsz: { type: "default", property: "background-size" },
  bgp: { type: "default", property: "background-position" },
  bgr: { type: "default", property: "background-repeat" },
  bga: { type: "default", property: "background-attachment" },
  pos: { type: "default", property: "position" },
  top: { type: "default", property: "top" },
  left: { type: "default", property: "left" },
  bottom: { type: "default", property: "bottom" },
  right: { type: "default", property: "right" },
  inset: { type: "default", property: "inset" },
  display: { type: "default", property: "display" }
};
var sU = Object.defineProperty, GA = Object.getOwnPropertySymbols, lU = Object.prototype.hasOwnProperty, uU = Object.prototype.propertyIsEnumerable, QA = (e, t, n) => t in e ? sU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, KA = (e, t) => {
  for (var n in t || (t = {}))
    lU.call(t, n) && QA(e, n, t[n]);
  if (GA)
    for (var n of GA(t))
      uU.call(t, n) && QA(e, n, t[n]);
  return e;
};
function JA(e, t, n = oU) {
  return Object.keys(n).reduce((s, f) => (f in e && e[f] !== void 0 && s.push(ZB({
    value: e[f],
    getValue: iU[n[f].type],
    property: n[f].property,
    theme: t
  })), s), []).reduce((s, f) => (Object.keys(f).forEach((m) => {
    typeof f[m] == "object" && f[m] !== null && m in s ? s[m] = KA(KA({}, s[m]), f[m]) : s[m] = f[m];
  }), s), {});
}
function ZA(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function cU(e, t, n) {
  const r = vu(), { css: s, cx: f } = TR();
  return Array.isArray(e) ? f(n, s(JA(t, r)), e.map((m) => s(ZA(m, r)))) : f(n, s(ZA(e, r)), s(JA(t, r)));
}
var dU = Object.defineProperty, v1 = Object.getOwnPropertySymbols, IR = Object.prototype.hasOwnProperty, FR = Object.prototype.propertyIsEnumerable, e_ = (e, t, n) => t in e ? dU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, fU = (e, t) => {
  for (var n in t || (t = {}))
    IR.call(t, n) && e_(e, n, t[n]);
  if (v1)
    for (var n of v1(t))
      FR.call(t, n) && e_(e, n, t[n]);
  return e;
}, mU = (e, t) => {
  var n = {};
  for (var r in e)
    IR.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && v1)
    for (var r of v1(e))
      t.indexOf(r) < 0 && FR.call(e, r) && (n[r] = e[r]);
  return n;
};
const HR = F.exports.forwardRef((e, t) => {
  var n = e, { className: r, component: s, style: f, sx: m } = n, p = mU(n, ["className", "component", "style", "sx"]);
  const { systemStyles: v, rest: y } = Ww(p), w = s || "div";
  return /* @__PURE__ */ T.createElement(w, fU({
    ref: t,
    className: cU(m, v, r),
    style: f
  }, y));
});
HR.displayName = "@mantine/core/Box";
const Gn = HR;
var hU = Object.defineProperty, g1 = Object.getOwnPropertySymbols, VR = Object.prototype.hasOwnProperty, BR = Object.prototype.propertyIsEnumerable, t_ = (e, t, n) => t in e ? hU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, pU = (e, t) => {
  for (var n in t || (t = {}))
    VR.call(t, n) && t_(e, n, t[n]);
  if (g1)
    for (var n of g1(t))
      BR.call(t, n) && t_(e, n, t[n]);
  return e;
}, vU = (e, t) => {
  var n = {};
  for (var r in e)
    VR.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && g1)
    for (var r of g1(e))
      t.indexOf(r) < 0 && BR.call(e, r) && (n[r] = e[r]);
  return n;
};
const UR = F.exports.forwardRef((e, t) => {
  var n = e, { children: r, className: s, value: f } = n, m = vU(n, ["children", "className", "value"]);
  const { classNames: p, styles: v, unstyled: y } = gu(), w = VS(), { classes: P, cx: x } = YB({ variant: w.variant, radius: w.radius }, { name: "Accordion", classNames: p, styles: v, unstyled: y });
  return /* @__PURE__ */ T.createElement(UB, {
    value: { value: f }
  }, /* @__PURE__ */ T.createElement(Gn, pU({
    ref: t,
    className: x(P.item, s),
    "data-active": w.isItemActive(f) || void 0
  }, m), r));
});
UR.displayName = "@mantine/core/AccordionItem";
var gU = Object.defineProperty, yU = Object.defineProperties, bU = Object.getOwnPropertyDescriptors, y1 = Object.getOwnPropertySymbols, XR = Object.prototype.hasOwnProperty, qR = Object.prototype.propertyIsEnumerable, n_ = (e, t, n) => t in e ? gU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, kb = (e, t) => {
  for (var n in t || (t = {}))
    XR.call(t, n) && n_(e, n, t[n]);
  if (y1)
    for (var n of y1(t))
      qR.call(t, n) && n_(e, n, t[n]);
  return e;
}, wU = (e, t) => yU(e, bU(t)), PU = (e, t) => {
  var n = {};
  for (var r in e)
    XR.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && y1)
    for (var r of y1(e))
      t.indexOf(r) < 0 && qR.call(e, r) && (n[r] = e[r]);
  return n;
};
function kU(e, { variant: t }) {
  return t === "default" || t === "contained" ? e.fn.hover({
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0]
  }) : {};
}
var $U = $n((e, t) => {
  var n = t, { transitionDuration: r, chevronPosition: s, chevronSize: f } = n, m = PU(n, ["transitionDuration", "chevronPosition", "chevronSize"]);
  return {
    icon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: s === "left" ? 0 : e.spacing.sm,
      marginLeft: s === "left" ? e.spacing.lg : 0
    },
    chevron: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: `transform ${r}ms ease`,
      marginRight: s === "right" ? 0 : e.spacing.sm,
      marginLeft: s === "right" ? e.spacing.lg : 0,
      width: f,
      minWidth: f,
      "&[data-rotate]": {
        transform: "rotate(180deg)"
      }
    },
    label: {
      color: "inherit",
      fontWeight: 400,
      flex: 1,
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    itemTitle: {
      margin: 0,
      padding: 0
    },
    control: wU(kb(kb(kb({}, e.fn.focusStyles()), e.fn.fontStyles()), kU(e, m)), {
      width: "100%",
      display: "flex",
      alignItems: "center",
      flexDirection: s === "right" ? "row-reverse" : "row",
      padding: `${e.spacing.md}px ${e.spacing.md / 2}px`,
      paddingLeft: s === "right" ? `calc(${e.spacing.sm}px + 4px)` : null,
      textAlign: "left",
      color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
      "&:disabled": kb({
        opacity: 0.4,
        cursor: "not-allowed"
      }, e.fn.hover({ backgroundColor: "transparent" }))
    })
  };
});
const SU = $U;
var xU = Object.defineProperty, CU = Object.defineProperties, MU = Object.getOwnPropertyDescriptors, r_ = Object.getOwnPropertySymbols, EU = Object.prototype.hasOwnProperty, AU = Object.prototype.propertyIsEnumerable, a_ = (e, t, n) => t in e ? xU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, i_ = (e, t) => {
  for (var n in t || (t = {}))
    EU.call(t, n) && a_(e, n, t[n]);
  if (r_)
    for (var n of r_(t))
      AU.call(t, n) && a_(e, n, t[n]);
  return e;
}, _U = (e, t) => CU(e, MU(t)), OU = $n((e) => ({
  root: _U(i_(i_({}, e.fn.focusStyles()), e.fn.fontStyles()), {
    cursor: "pointer",
    border: 0,
    padding: 0,
    appearance: "none",
    fontSize: e.fontSizes.md,
    backgroundColor: "transparent",
    textAlign: "left",
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    textDecoration: "none",
    boxSizing: "border-box"
  })
}));
const TU = OU;
var RU = Object.defineProperty, b1 = Object.getOwnPropertySymbols, YR = Object.prototype.hasOwnProperty, GR = Object.prototype.propertyIsEnumerable, o_ = (e, t, n) => t in e ? RU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, DU = (e, t) => {
  for (var n in t || (t = {}))
    YR.call(t, n) && o_(e, n, t[n]);
  if (b1)
    for (var n of b1(t))
      GR.call(t, n) && o_(e, n, t[n]);
  return e;
}, NU = (e, t) => {
  var n = {};
  for (var r in e)
    YR.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && b1)
    for (var r of b1(e))
      t.indexOf(r) < 0 && GR.call(e, r) && (n[r] = e[r]);
  return n;
};
const QR = F.exports.forwardRef((e, t) => {
  const n = Er("UnstyledButton", {}, e), {
    className: r,
    component: s = "button",
    unstyled: f
  } = n, m = NU(n, [
    "className",
    "component",
    "unstyled"
  ]), { classes: p, cx: v } = TU(null, { name: "UnstyledButton", unstyled: f });
  return /* @__PURE__ */ T.createElement(Gn, DU({
    component: s,
    ref: t,
    className: v(p.root, r),
    type: s === "button" ? "button" : void 0
  }, m));
});
QR.displayName = "@mantine/core/UnstyledButton";
const jw = QR;
var WU = Object.defineProperty, jU = Object.defineProperties, zU = Object.getOwnPropertyDescriptors, w1 = Object.getOwnPropertySymbols, KR = Object.prototype.hasOwnProperty, JR = Object.prototype.propertyIsEnumerable, s_ = (e, t, n) => t in e ? WU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, LU = (e, t) => {
  for (var n in t || (t = {}))
    KR.call(t, n) && s_(e, n, t[n]);
  if (w1)
    for (var n of w1(t))
      JR.call(t, n) && s_(e, n, t[n]);
  return e;
}, IU = (e, t) => jU(e, zU(t)), FU = (e, t) => {
  var n = {};
  for (var r in e)
    KR.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && w1)
    for (var r of w1(e))
      t.indexOf(r) < 0 && JR.call(e, r) && (n[r] = e[r]);
  return n;
};
const ZR = F.exports.forwardRef((e, t) => {
  var n = e, {
    disabled: r,
    onKeyDown: s,
    onClick: f,
    chevron: m,
    children: p,
    className: v,
    icon: y
  } = n, w = FU(n, [
    "disabled",
    "onKeyDown",
    "onClick",
    "chevron",
    "children",
    "className",
    "icon"
  ]);
  const P = VS(), { value: x } = LR(), { classNames: A, styles: M, unstyled: O } = gu(), { classes: j, cx: H } = SU({
    transitionDuration: P.transitionDuration,
    chevronPosition: P.chevronPosition,
    chevronSize: P.chevronSize,
    variant: P.variant,
    radius: P.radius
  }, { name: "Accordion", classNames: A, styles: M, unstyled: O }), J = P.isItemActive(x), V = typeof P.order == "number", X = `h${P.order}`, U = /* @__PURE__ */ T.createElement(jw, IU(LU({}, w), {
    ref: t,
    "data-accordion-control": !0,
    disabled: r,
    className: H(j.control, v),
    onClick: (K) => {
      f == null || f(K), P.onChange(x);
    },
    type: "button",
    "data-active": J || void 0,
    "aria-expanded": J,
    "aria-controls": P.getRegionId(x),
    id: P.getControlId(x),
    unstyled: O,
    onKeyDown: DS({
      siblingSelector: "[data-accordion-control]",
      parentSelector: "[data-accordion]",
      activateOnFocus: !1,
      loop: P.loop,
      orientation: "vertical",
      onKeyDown: s
    })
  }), /* @__PURE__ */ T.createElement("div", {
    className: j.chevron,
    "data-rotate": !P.disableChevronRotation && J || void 0
  }, m || P.chevron), /* @__PURE__ */ T.createElement("div", {
    className: j.label
  }, p), y && /* @__PURE__ */ T.createElement("div", {
    className: j.icon
  }, y));
  return V ? /* @__PURE__ */ T.createElement(X, {
    className: j.itemTitle
  }, U) : U;
});
ZR.displayName = "@mantine/core/AccordionControl";
var HU = Object.defineProperty, VU = Object.defineProperties, BU = Object.getOwnPropertyDescriptors, l_ = Object.getOwnPropertySymbols, UU = Object.prototype.hasOwnProperty, XU = Object.prototype.propertyIsEnumerable, u_ = (e, t, n) => t in e ? HU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, qU = (e, t) => {
  for (var n in t || (t = {}))
    UU.call(t, n) && u_(e, n, t[n]);
  if (l_)
    for (var n of l_(t))
      XU.call(t, n) && u_(e, n, t[n]);
  return e;
}, YU = (e, t) => VU(e, BU(t)), GU = $n((e, t) => ({
  panel: YU(qU({}, e.fn.fontStyles()), {
    wordBreak: "break-word",
    lineHeight: e.lineHeight
  }),
  content: {
    padding: e.spacing.md,
    paddingTop: `calc(${e.spacing.xs}px / 2)`
  }
}));
const QU = GU;
var Zh = { exports: {} }, ss = {}, Yk = { exports: {} }, Gk = {};
var c_;
function KU() {
  return c_ || (c_ = 1, function(e) {
    var t, n, r, s;
    if (typeof performance == "object" && typeof performance.now == "function") {
      var f = performance;
      e.unstable_now = function() {
        return f.now();
      };
    } else {
      var m = Date, p = m.now();
      e.unstable_now = function() {
        return m.now() - p;
      };
    }
    if (typeof window > "u" || typeof MessageChannel != "function") {
      var v = null, y = null, w = function() {
        if (v !== null)
          try {
            var Ce = e.unstable_now();
            v(!0, Ce), v = null;
          } catch (Ie) {
            throw setTimeout(w, 0), Ie;
          }
      };
      t = function(Ce) {
        v !== null ? setTimeout(t, 0, Ce) : (v = Ce, setTimeout(w, 0));
      }, n = function(Ce, Ie) {
        y = setTimeout(Ce, Ie);
      }, r = function() {
        clearTimeout(y);
      }, e.unstable_shouldYield = function() {
        return !1;
      }, s = e.unstable_forceFrameRate = function() {
      };
    } else {
      var P = window.setTimeout, x = window.clearTimeout;
      if (typeof console < "u") {
        var A = window.cancelAnimationFrame;
        typeof window.requestAnimationFrame != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), typeof A != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
      }
      var M = !1, O = null, j = -1, H = 5, J = 0;
      e.unstable_shouldYield = function() {
        return e.unstable_now() >= J;
      }, s = function() {
      }, e.unstable_forceFrameRate = function(Ce) {
        0 > Ce || 125 < Ce ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : H = 0 < Ce ? Math.floor(1e3 / Ce) : 5;
      };
      var V = new MessageChannel(), X = V.port2;
      V.port1.onmessage = function() {
        if (O !== null) {
          var Ce = e.unstable_now();
          J = Ce + H;
          try {
            O(!0, Ce) ? X.postMessage(null) : (M = !1, O = null);
          } catch (Ie) {
            throw X.postMessage(null), Ie;
          }
        } else
          M = !1;
      }, t = function(Ce) {
        O = Ce, M || (M = !0, X.postMessage(null));
      }, n = function(Ce, Ie) {
        j = P(function() {
          Ce(e.unstable_now());
        }, Ie);
      }, r = function() {
        x(j), j = -1;
      };
    }
    function U(Ce, Ie) {
      var $e = Ce.length;
      Ce.push(Ie);
      e:
        for (; ; ) {
          var ot = $e - 1 >>> 1, ht = Ce[ot];
          if (ht !== void 0 && 0 < ue(ht, Ie))
            Ce[ot] = Ie, Ce[$e] = ht, $e = ot;
          else
            break e;
        }
    }
    function K(Ce) {
      return Ce = Ce[0], Ce === void 0 ? null : Ce;
    }
    function ce(Ce) {
      var Ie = Ce[0];
      if (Ie !== void 0) {
        var $e = Ce.pop();
        if ($e !== Ie) {
          Ce[0] = $e;
          e:
            for (var ot = 0, ht = Ce.length; ot < ht; ) {
              var At = 2 * (ot + 1) - 1, Sn = Ce[At], Gt = At + 1, Bt = Ce[Gt];
              if (Sn !== void 0 && 0 > ue(Sn, $e))
                Bt !== void 0 && 0 > ue(Bt, Sn) ? (Ce[ot] = Bt, Ce[Gt] = $e, ot = Gt) : (Ce[ot] = Sn, Ce[At] = $e, ot = At);
              else if (Bt !== void 0 && 0 > ue(Bt, $e))
                Ce[ot] = Bt, Ce[Gt] = $e, ot = Gt;
              else
                break e;
            }
        }
        return Ie;
      }
      return null;
    }
    function ue(Ce, Ie) {
      var $e = Ce.sortIndex - Ie.sortIndex;
      return $e !== 0 ? $e : Ce.id - Ie.id;
    }
    var ye = [], Oe = [], _e = 1, Le = null, Ne = 3, nt = !1, Qe = !1, qe = !1;
    function ie(Ce) {
      for (var Ie = K(Oe); Ie !== null; ) {
        if (Ie.callback === null)
          ce(Oe);
        else if (Ie.startTime <= Ce)
          ce(Oe), Ie.sortIndex = Ie.expirationTime, U(ye, Ie);
        else
          break;
        Ie = K(Oe);
      }
    }
    function xe(Ce) {
      if (qe = !1, ie(Ce), !Qe)
        if (K(ye) !== null)
          Qe = !0, t(Ye);
        else {
          var Ie = K(Oe);
          Ie !== null && n(xe, Ie.startTime - Ce);
        }
    }
    function Ye(Ce, Ie) {
      Qe = !1, qe && (qe = !1, r()), nt = !0;
      var $e = Ne;
      try {
        for (ie(Ie), Le = K(ye); Le !== null && (!(Le.expirationTime > Ie) || Ce && !e.unstable_shouldYield()); ) {
          var ot = Le.callback;
          if (typeof ot == "function") {
            Le.callback = null, Ne = Le.priorityLevel;
            var ht = ot(Le.expirationTime <= Ie);
            Ie = e.unstable_now(), typeof ht == "function" ? Le.callback = ht : Le === K(ye) && ce(ye), ie(Ie);
          } else
            ce(ye);
          Le = K(ye);
        }
        if (Le !== null)
          var At = !0;
        else {
          var Sn = K(Oe);
          Sn !== null && n(xe, Sn.startTime - Ie), At = !1;
        }
        return At;
      } finally {
        Le = null, Ne = $e, nt = !1;
      }
    }
    var Be = s;
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(Ce) {
      Ce.callback = null;
    }, e.unstable_continueExecution = function() {
      Qe || nt || (Qe = !0, t(Ye));
    }, e.unstable_getCurrentPriorityLevel = function() {
      return Ne;
    }, e.unstable_getFirstCallbackNode = function() {
      return K(ye);
    }, e.unstable_next = function(Ce) {
      switch (Ne) {
        case 1:
        case 2:
        case 3:
          var Ie = 3;
          break;
        default:
          Ie = Ne;
      }
      var $e = Ne;
      Ne = Ie;
      try {
        return Ce();
      } finally {
        Ne = $e;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = Be, e.unstable_runWithPriority = function(Ce, Ie) {
      switch (Ce) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          Ce = 3;
      }
      var $e = Ne;
      Ne = Ce;
      try {
        return Ie();
      } finally {
        Ne = $e;
      }
    }, e.unstable_scheduleCallback = function(Ce, Ie, $e) {
      var ot = e.unstable_now();
      switch (typeof $e == "object" && $e !== null ? ($e = $e.delay, $e = typeof $e == "number" && 0 < $e ? ot + $e : ot) : $e = ot, Ce) {
        case 1:
          var ht = -1;
          break;
        case 2:
          ht = 250;
          break;
        case 5:
          ht = 1073741823;
          break;
        case 4:
          ht = 1e4;
          break;
        default:
          ht = 5e3;
      }
      return ht = $e + ht, Ce = { id: _e++, callback: Ie, priorityLevel: Ce, startTime: $e, expirationTime: ht, sortIndex: -1 }, $e > ot ? (Ce.sortIndex = $e, U(Oe, Ce), K(ye) === null && Ce === K(Oe) && (qe ? r() : qe = !0, n(xe, $e - ot))) : (Ce.sortIndex = ht, U(ye, Ce), Qe || nt || (Qe = !0, t(Ye))), Ce;
    }, e.unstable_wrapCallback = function(Ce) {
      var Ie = Ne;
      return function() {
        var $e = Ne;
        Ne = Ie;
        try {
          return Ce.apply(this, arguments);
        } finally {
          Ne = $e;
        }
      };
    };
  }(Gk)), Gk;
}
var Qk = {};
var d_;
function JU() {
  return d_ || (d_ = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = !1, n = !1, r, s, f, m, p = typeof performance == "object" && typeof performance.now == "function";
      if (p) {
        var v = performance;
        e.unstable_now = function() {
          return v.now();
        };
      } else {
        var y = Date, w = y.now();
        e.unstable_now = function() {
          return y.now() - w;
        };
      }
      if (typeof window > "u" || typeof MessageChannel != "function") {
        var P = null, x = null, A = function() {
          if (P !== null)
            try {
              var et = e.unstable_now(), ft = !0;
              P(ft, et), P = null;
            } catch (_t) {
              throw setTimeout(A, 0), _t;
            }
        };
        r = function(et) {
          P !== null ? setTimeout(r, 0, et) : (P = et, setTimeout(A, 0));
        }, s = function(et, ft) {
          x = setTimeout(et, ft);
        }, f = function() {
          clearTimeout(x);
        }, e.unstable_shouldYield = function() {
          return !1;
        }, m = e.unstable_forceFrameRate = function() {
        };
      } else {
        var M = window.setTimeout, O = window.clearTimeout;
        if (typeof console < "u") {
          var j = window.requestAnimationFrame, H = window.cancelAnimationFrame;
          typeof j != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), typeof H != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        }
        var J = !1, V = null, X = -1, U = 5, K = 0;
        e.unstable_shouldYield = function() {
          return e.unstable_now() >= K;
        }, m = function() {
        }, e.unstable_forceFrameRate = function(et) {
          if (et < 0 || et > 125) {
            console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
          }
          et > 0 ? U = Math.floor(1e3 / et) : U = 5;
        };
        var ce = function() {
          if (V !== null) {
            var et = e.unstable_now();
            K = et + U;
            var ft = !0;
            try {
              var _t = V(ft, et);
              _t ? ye.postMessage(null) : (J = !1, V = null);
            } catch (an) {
              throw ye.postMessage(null), an;
            }
          } else
            J = !1;
        }, ue = new MessageChannel(), ye = ue.port2;
        ue.port1.onmessage = ce, r = function(et) {
          V = et, J || (J = !0, ye.postMessage(null));
        }, s = function(et, ft) {
          X = M(function() {
            et(e.unstable_now());
          }, ft);
        }, f = function() {
          O(X), X = -1;
        };
      }
      function Oe(et, ft) {
        var _t = et.length;
        et.push(ft), Ne(et, ft, _t);
      }
      function _e(et) {
        var ft = et[0];
        return ft === void 0 ? null : ft;
      }
      function Le(et) {
        var ft = et[0];
        if (ft !== void 0) {
          var _t = et.pop();
          return _t !== ft && (et[0] = _t, nt(et, _t, 0)), ft;
        } else
          return null;
      }
      function Ne(et, ft, _t) {
        for (var an = _t; ; ) {
          var ir = an - 1 >>> 1, pn = et[ir];
          if (pn !== void 0 && Qe(pn, ft) > 0)
            et[ir] = ft, et[an] = pn, an = ir;
          else
            return;
        }
      }
      function nt(et, ft, _t) {
        for (var an = _t, ir = et.length; an < ir; ) {
          var pn = (an + 1) * 2 - 1, vn = et[pn], Kn = pn + 1, Pn = et[Kn];
          if (vn !== void 0 && Qe(vn, ft) < 0)
            Pn !== void 0 && Qe(Pn, vn) < 0 ? (et[an] = Pn, et[Kn] = ft, an = Kn) : (et[an] = vn, et[pn] = ft, an = pn);
          else if (Pn !== void 0 && Qe(Pn, ft) < 0)
            et[an] = Pn, et[Kn] = ft, an = Kn;
          else
            return;
        }
      }
      function Qe(et, ft) {
        var _t = et.sortIndex - ft.sortIndex;
        return _t !== 0 ? _t : et.id - ft.id;
      }
      var qe = 1, ie = 2, xe = 3, Ye = 4, Be = 5;
      function Ce(et, ft) {
      }
      var Ie = 1073741823, $e = -1, ot = 250, ht = 5e3, At = 1e4, Sn = Ie, Gt = [], Bt = [], Qn = 1, cn = null, Ge = xe, vr = !1, Fn = !1, en = !1;
      function Gr(et) {
        for (var ft = _e(Bt); ft !== null; ) {
          if (ft.callback === null)
            Le(Bt);
          else if (ft.startTime <= et)
            Le(Bt), ft.sortIndex = ft.expirationTime, Oe(Gt, ft);
          else
            return;
          ft = _e(Bt);
        }
      }
      function da(et) {
        if (en = !1, Gr(et), !Fn)
          if (_e(Gt) !== null)
            Fn = !0, r(gr);
          else {
            var ft = _e(Bt);
            ft !== null && s(da, ft.startTime - et);
          }
      }
      function gr(et, ft) {
        Fn = !1, en && (en = !1, f()), vr = !0;
        var _t = Ge;
        try {
          var an;
          if (!n)
            return qi(et, ft);
        } finally {
          cn = null, Ge = _t, vr = !1;
        }
      }
      function qi(et, ft) {
        var _t = ft;
        for (Gr(_t), cn = _e(Gt); cn !== null && !t && !(cn.expirationTime > _t && (!et || e.unstable_shouldYield())); ) {
          var an = cn.callback;
          if (typeof an == "function") {
            cn.callback = null, Ge = cn.priorityLevel;
            var ir = cn.expirationTime <= _t, pn = an(ir);
            _t = e.unstable_now(), typeof pn == "function" ? cn.callback = pn : cn === _e(Gt) && Le(Gt), Gr(_t);
          } else
            Le(Gt);
          cn = _e(Gt);
        }
        if (cn !== null)
          return !0;
        var vn = _e(Bt);
        return vn !== null && s(da, vn.startTime - _t), !1;
      }
      function Wr(et, ft) {
        switch (et) {
          case qe:
          case ie:
          case xe:
          case Ye:
          case Be:
            break;
          default:
            et = xe;
        }
        var _t = Ge;
        Ge = et;
        try {
          return ft();
        } finally {
          Ge = _t;
        }
      }
      function fa(et) {
        var ft;
        switch (Ge) {
          case qe:
          case ie:
          case xe:
            ft = xe;
            break;
          default:
            ft = Ge;
            break;
        }
        var _t = Ge;
        Ge = ft;
        try {
          return et();
        } finally {
          Ge = _t;
        }
      }
      function xa(et) {
        var ft = Ge;
        return function() {
          var _t = Ge;
          Ge = ft;
          try {
            return et.apply(this, arguments);
          } finally {
            Ge = _t;
          }
        };
      }
      function fr(et, ft, _t) {
        var an = e.unstable_now(), ir;
        if (typeof _t == "object" && _t !== null) {
          var pn = _t.delay;
          typeof pn == "number" && pn > 0 ? ir = an + pn : ir = an;
        } else
          ir = an;
        var vn;
        switch (et) {
          case qe:
            vn = $e;
            break;
          case ie:
            vn = ot;
            break;
          case Be:
            vn = Sn;
            break;
          case Ye:
            vn = At;
            break;
          case xe:
          default:
            vn = ht;
            break;
        }
        var Kn = ir + vn, Pn = {
          id: Qn++,
          callback: ft,
          priorityLevel: et,
          startTime: ir,
          expirationTime: Kn,
          sortIndex: -1
        };
        return ir > an ? (Pn.sortIndex = ir, Oe(Bt, Pn), _e(Gt) === null && Pn === _e(Bt) && (en ? f() : en = !0, s(da, ir - an))) : (Pn.sortIndex = Kn, Oe(Gt, Pn), !Fn && !vr && (Fn = !0, r(gr))), Pn;
      }
      function Xn() {
      }
      function Hr() {
        !Fn && !vr && (Fn = !0, r(gr));
      }
      function Dn() {
        return _e(Gt);
      }
      function Nn(et) {
        et.callback = null;
      }
      function Ca() {
        return Ge;
      }
      var Ia = m, Fa = null;
      e.unstable_IdlePriority = Be, e.unstable_ImmediatePriority = qe, e.unstable_LowPriority = Ye, e.unstable_NormalPriority = xe, e.unstable_Profiling = Fa, e.unstable_UserBlockingPriority = ie, e.unstable_cancelCallback = Nn, e.unstable_continueExecution = Hr, e.unstable_getCurrentPriorityLevel = Ca, e.unstable_getFirstCallbackNode = Dn, e.unstable_next = fa, e.unstable_pauseExecution = Xn, e.unstable_requestPaint = Ia, e.unstable_runWithPriority = Wr, e.unstable_scheduleCallback = fr, e.unstable_wrapCallback = xa;
    }();
  }(Qk)), Qk;
}
var f_;
function eD() {
  return f_ || (f_ = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = KU() : e.exports = JU();
  }(Yk)), Yk.exports;
}
var m_;
function ZU() {
  if (m_)
    return ss;
  m_ = 1;
  var e = F.exports, t = Aw(), n = eD();
  function r(o) {
    for (var u = "https://reactjs.org/docs/error-decoder.html?invariant=" + o, d = 1; d < arguments.length; d++)
      u += "&args[]=" + encodeURIComponent(arguments[d]);
    return "Minified React error #" + o + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  if (!e)
    throw Error(r(227));
  var s = /* @__PURE__ */ new Set(), f = {};
  function m(o, u) {
    p(o, u), p(o + "Capture", u);
  }
  function p(o, u) {
    for (f[o] = u, o = 0; o < u.length; o++)
      s.add(u[o]);
  }
  var v = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), y = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, w = Object.prototype.hasOwnProperty, P = {}, x = {};
  function A(o) {
    return w.call(x, o) ? !0 : w.call(P, o) ? !1 : y.test(o) ? x[o] = !0 : (P[o] = !0, !1);
  }
  function M(o, u, d, g) {
    if (d !== null && d.type === 0)
      return !1;
    switch (typeof u) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return g ? !1 : d !== null ? !d.acceptsBooleans : (o = o.toLowerCase().slice(0, 5), o !== "data-" && o !== "aria-");
      default:
        return !1;
    }
  }
  function O(o, u, d, g) {
    if (u === null || typeof u > "u" || M(o, u, d, g))
      return !0;
    if (g)
      return !1;
    if (d !== null)
      switch (d.type) {
        case 3:
          return !u;
        case 4:
          return u === !1;
        case 5:
          return isNaN(u);
        case 6:
          return isNaN(u) || 1 > u;
      }
    return !1;
  }
  function j(o, u, d, g, $, _, I) {
    this.acceptsBooleans = u === 2 || u === 3 || u === 4, this.attributeName = g, this.attributeNamespace = $, this.mustUseProperty = d, this.propertyName = o, this.type = u, this.sanitizeURL = _, this.removeEmptyString = I;
  }
  var H = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(o) {
    H[o] = new j(o, 0, !1, o, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(o) {
    var u = o[0];
    H[u] = new j(u, 1, !1, o[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(o) {
    H[o] = new j(o, 2, !1, o.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(o) {
    H[o] = new j(o, 2, !1, o, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(o) {
    H[o] = new j(o, 3, !1, o.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(o) {
    H[o] = new j(o, 3, !0, o, null, !1, !1);
  }), ["capture", "download"].forEach(function(o) {
    H[o] = new j(o, 4, !1, o, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(o) {
    H[o] = new j(o, 6, !1, o, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(o) {
    H[o] = new j(o, 5, !1, o.toLowerCase(), null, !1, !1);
  });
  var J = /[\-:]([a-z])/g;
  function V(o) {
    return o[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(o) {
    var u = o.replace(
      J,
      V
    );
    H[u] = new j(u, 1, !1, o, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(o) {
    var u = o.replace(J, V);
    H[u] = new j(u, 1, !1, o, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(o) {
    var u = o.replace(J, V);
    H[u] = new j(u, 1, !1, o, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(o) {
    H[o] = new j(o, 1, !1, o.toLowerCase(), null, !1, !1);
  }), H.xlinkHref = new j("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(o) {
    H[o] = new j(o, 1, !1, o.toLowerCase(), null, !0, !0);
  });
  function X(o, u, d, g) {
    var $ = H.hasOwnProperty(u) ? H[u] : null, _ = $ !== null ? $.type === 0 : g ? !1 : !(!(2 < u.length) || u[0] !== "o" && u[0] !== "O" || u[1] !== "n" && u[1] !== "N");
    _ || (O(u, d, $, g) && (d = null), g || $ === null ? A(u) && (d === null ? o.removeAttribute(u) : o.setAttribute(u, "" + d)) : $.mustUseProperty ? o[$.propertyName] = d === null ? $.type === 3 ? !1 : "" : d : (u = $.attributeName, g = $.attributeNamespace, d === null ? o.removeAttribute(u) : ($ = $.type, d = $ === 3 || $ === 4 && d === !0 ? "" : "" + d, g ? o.setAttributeNS(g, u, d) : o.setAttribute(u, d))));
  }
  var U = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, K = 60103, ce = 60106, ue = 60107, ye = 60108, Oe = 60114, _e = 60109, Le = 60110, Ne = 60112, nt = 60113, Qe = 60120, qe = 60115, ie = 60116, xe = 60121, Ye = 60128, Be = 60129, Ce = 60130, Ie = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var $e = Symbol.for;
    K = $e("react.element"), ce = $e("react.portal"), ue = $e("react.fragment"), ye = $e("react.strict_mode"), Oe = $e("react.profiler"), _e = $e("react.provider"), Le = $e("react.context"), Ne = $e("react.forward_ref"), nt = $e("react.suspense"), Qe = $e("react.suspense_list"), qe = $e("react.memo"), ie = $e("react.lazy"), xe = $e("react.block"), $e("react.scope"), Ye = $e("react.opaque.id"), Be = $e("react.debug_trace_mode"), Ce = $e("react.offscreen"), Ie = $e("react.legacy_hidden");
  }
  var ot = typeof Symbol == "function" && Symbol.iterator;
  function ht(o) {
    return o === null || typeof o != "object" ? null : (o = ot && o[ot] || o["@@iterator"], typeof o == "function" ? o : null);
  }
  var At;
  function Sn(o) {
    if (At === void 0)
      try {
        throw Error();
      } catch (d) {
        var u = d.stack.trim().match(/\n( *(at )?)/);
        At = u && u[1] || "";
      }
    return `
` + At + o;
  }
  var Gt = !1;
  function Bt(o, u) {
    if (!o || Gt)
      return "";
    Gt = !0;
    var d = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (u)
        if (u = function() {
          throw Error();
        }, Object.defineProperty(u.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(u, []);
          } catch (re) {
            var g = re;
          }
          Reflect.construct(o, [], u);
        } else {
          try {
            u.call();
          } catch (re) {
            g = re;
          }
          o.call(u.prototype);
        }
      else {
        try {
          throw Error();
        } catch (re) {
          g = re;
        }
        o();
      }
    } catch (re) {
      if (re && g && typeof re.stack == "string") {
        for (var $ = re.stack.split(`
`), _ = g.stack.split(`
`), I = $.length - 1, q = _.length - 1; 1 <= I && 0 <= q && $[I] !== _[q]; )
          q--;
        for (; 1 <= I && 0 <= q; I--, q--)
          if ($[I] !== _[q]) {
            if (I !== 1 || q !== 1)
              do
                if (I--, q--, 0 > q || $[I] !== _[q])
                  return `
` + $[I].replace(" at new ", " at ");
              while (1 <= I && 0 <= q);
            break;
          }
      }
    } finally {
      Gt = !1, Error.prepareStackTrace = d;
    }
    return (o = o ? o.displayName || o.name : "") ? Sn(o) : "";
  }
  function Qn(o) {
    switch (o.tag) {
      case 5:
        return Sn(o.type);
      case 16:
        return Sn("Lazy");
      case 13:
        return Sn("Suspense");
      case 19:
        return Sn("SuspenseList");
      case 0:
      case 2:
      case 15:
        return o = Bt(o.type, !1), o;
      case 11:
        return o = Bt(o.type.render, !1), o;
      case 22:
        return o = Bt(o.type._render, !1), o;
      case 1:
        return o = Bt(o.type, !0), o;
      default:
        return "";
    }
  }
  function cn(o) {
    if (o == null)
      return null;
    if (typeof o == "function")
      return o.displayName || o.name || null;
    if (typeof o == "string")
      return o;
    switch (o) {
      case ue:
        return "Fragment";
      case ce:
        return "Portal";
      case Oe:
        return "Profiler";
      case ye:
        return "StrictMode";
      case nt:
        return "Suspense";
      case Qe:
        return "SuspenseList";
    }
    if (typeof o == "object")
      switch (o.$$typeof) {
        case Le:
          return (o.displayName || "Context") + ".Consumer";
        case _e:
          return (o._context.displayName || "Context") + ".Provider";
        case Ne:
          var u = o.render;
          return u = u.displayName || u.name || "", o.displayName || (u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef");
        case qe:
          return cn(o.type);
        case xe:
          return cn(o._render);
        case ie:
          u = o._payload, o = o._init;
          try {
            return cn(o(u));
          } catch {
          }
      }
    return null;
  }
  function Ge(o) {
    switch (typeof o) {
      case "boolean":
      case "number":
      case "object":
      case "string":
      case "undefined":
        return o;
      default:
        return "";
    }
  }
  function vr(o) {
    var u = o.type;
    return (o = o.nodeName) && o.toLowerCase() === "input" && (u === "checkbox" || u === "radio");
  }
  function Fn(o) {
    var u = vr(o) ? "checked" : "value", d = Object.getOwnPropertyDescriptor(o.constructor.prototype, u), g = "" + o[u];
    if (!o.hasOwnProperty(u) && typeof d < "u" && typeof d.get == "function" && typeof d.set == "function") {
      var $ = d.get, _ = d.set;
      return Object.defineProperty(o, u, { configurable: !0, get: function() {
        return $.call(this);
      }, set: function(I) {
        g = "" + I, _.call(this, I);
      } }), Object.defineProperty(o, u, { enumerable: d.enumerable }), { getValue: function() {
        return g;
      }, setValue: function(I) {
        g = "" + I;
      }, stopTracking: function() {
        o._valueTracker = null, delete o[u];
      } };
    }
  }
  function en(o) {
    o._valueTracker || (o._valueTracker = Fn(o));
  }
  function Gr(o) {
    if (!o)
      return !1;
    var u = o._valueTracker;
    if (!u)
      return !0;
    var d = u.getValue(), g = "";
    return o && (g = vr(o) ? o.checked ? "true" : "false" : o.value), o = g, o !== d ? (u.setValue(o), !0) : !1;
  }
  function da(o) {
    if (o = o || (typeof document < "u" ? document : void 0), typeof o > "u")
      return null;
    try {
      return o.activeElement || o.body;
    } catch {
      return o.body;
    }
  }
  function gr(o, u) {
    var d = u.checked;
    return t({}, u, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: d ?? o._wrapperState.initialChecked });
  }
  function qi(o, u) {
    var d = u.defaultValue == null ? "" : u.defaultValue, g = u.checked != null ? u.checked : u.defaultChecked;
    d = Ge(u.value != null ? u.value : d), o._wrapperState = { initialChecked: g, initialValue: d, controlled: u.type === "checkbox" || u.type === "radio" ? u.checked != null : u.value != null };
  }
  function Wr(o, u) {
    u = u.checked, u != null && X(o, "checked", u, !1);
  }
  function fa(o, u) {
    Wr(o, u);
    var d = Ge(u.value), g = u.type;
    if (d != null)
      g === "number" ? (d === 0 && o.value === "" || o.value != d) && (o.value = "" + d) : o.value !== "" + d && (o.value = "" + d);
    else if (g === "submit" || g === "reset") {
      o.removeAttribute("value");
      return;
    }
    u.hasOwnProperty("value") ? fr(o, u.type, d) : u.hasOwnProperty("defaultValue") && fr(o, u.type, Ge(u.defaultValue)), u.checked == null && u.defaultChecked != null && (o.defaultChecked = !!u.defaultChecked);
  }
  function xa(o, u, d) {
    if (u.hasOwnProperty("value") || u.hasOwnProperty("defaultValue")) {
      var g = u.type;
      if (!(g !== "submit" && g !== "reset" || u.value !== void 0 && u.value !== null))
        return;
      u = "" + o._wrapperState.initialValue, d || u === o.value || (o.value = u), o.defaultValue = u;
    }
    d = o.name, d !== "" && (o.name = ""), o.defaultChecked = !!o._wrapperState.initialChecked, d !== "" && (o.name = d);
  }
  function fr(o, u, d) {
    (u !== "number" || da(o.ownerDocument) !== o) && (d == null ? o.defaultValue = "" + o._wrapperState.initialValue : o.defaultValue !== "" + d && (o.defaultValue = "" + d));
  }
  function Xn(o) {
    var u = "";
    return e.Children.forEach(o, function(d) {
      d != null && (u += d);
    }), u;
  }
  function Hr(o, u) {
    return o = t({ children: void 0 }, u), (u = Xn(u.children)) && (o.children = u), o;
  }
  function Dn(o, u, d, g) {
    if (o = o.options, u) {
      u = {};
      for (var $ = 0; $ < d.length; $++)
        u["$" + d[$]] = !0;
      for (d = 0; d < o.length; d++)
        $ = u.hasOwnProperty("$" + o[d].value), o[d].selected !== $ && (o[d].selected = $), $ && g && (o[d].defaultSelected = !0);
    } else {
      for (d = "" + Ge(d), u = null, $ = 0; $ < o.length; $++) {
        if (o[$].value === d) {
          o[$].selected = !0, g && (o[$].defaultSelected = !0);
          return;
        }
        u !== null || o[$].disabled || (u = o[$]);
      }
      u !== null && (u.selected = !0);
    }
  }
  function Nn(o, u) {
    if (u.dangerouslySetInnerHTML != null)
      throw Error(r(91));
    return t({}, u, { value: void 0, defaultValue: void 0, children: "" + o._wrapperState.initialValue });
  }
  function Ca(o, u) {
    var d = u.value;
    if (d == null) {
      if (d = u.children, u = u.defaultValue, d != null) {
        if (u != null)
          throw Error(r(92));
        if (Array.isArray(d)) {
          if (!(1 >= d.length))
            throw Error(r(93));
          d = d[0];
        }
        u = d;
      }
      u == null && (u = ""), d = u;
    }
    o._wrapperState = { initialValue: Ge(d) };
  }
  function Ia(o, u) {
    var d = Ge(u.value), g = Ge(u.defaultValue);
    d != null && (d = "" + d, d !== o.value && (o.value = d), u.defaultValue == null && o.defaultValue !== d && (o.defaultValue = d)), g != null && (o.defaultValue = "" + g);
  }
  function Fa(o) {
    var u = o.textContent;
    u === o._wrapperState.initialValue && u !== "" && u !== null && (o.value = u);
  }
  var et = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
  function ft(o) {
    switch (o) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function _t(o, u) {
    return o == null || o === "http://www.w3.org/1999/xhtml" ? ft(u) : o === "http://www.w3.org/2000/svg" && u === "foreignObject" ? "http://www.w3.org/1999/xhtml" : o;
  }
  var an, ir = function(o) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(u, d, g, $) {
      MSApp.execUnsafeLocalFunction(function() {
        return o(u, d, g, $);
      });
    } : o;
  }(function(o, u) {
    if (o.namespaceURI !== et.svg || "innerHTML" in o)
      o.innerHTML = u;
    else {
      for (an = an || document.createElement("div"), an.innerHTML = "<svg>" + u.valueOf().toString() + "</svg>", u = an.firstChild; o.firstChild; )
        o.removeChild(o.firstChild);
      for (; u.firstChild; )
        o.appendChild(u.firstChild);
    }
  });
  function pn(o, u) {
    if (u) {
      var d = o.firstChild;
      if (d && d === o.lastChild && d.nodeType === 3) {
        d.nodeValue = u;
        return;
      }
    }
    o.textContent = u;
  }
  var vn = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Kn = ["Webkit", "ms", "Moz", "O"];
  Object.keys(vn).forEach(function(o) {
    Kn.forEach(function(u) {
      u = u + o.charAt(0).toUpperCase() + o.substring(1), vn[u] = vn[o];
    });
  });
  function Pn(o, u, d) {
    return u == null || typeof u == "boolean" || u === "" ? "" : d || typeof u != "number" || u === 0 || vn.hasOwnProperty(o) && vn[o] ? ("" + u).trim() : u + "px";
  }
  function Vr(o, u) {
    o = o.style;
    for (var d in u)
      if (u.hasOwnProperty(d)) {
        var g = d.indexOf("--") === 0, $ = Pn(d, u[d], g);
        d === "float" && (d = "cssFloat"), g ? o.setProperty(d, $) : o[d] = $;
      }
  }
  var pi = t({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Ar(o, u) {
    if (u) {
      if (pi[o] && (u.children != null || u.dangerouslySetInnerHTML != null))
        throw Error(r(137, o));
      if (u.dangerouslySetInnerHTML != null) {
        if (u.children != null)
          throw Error(r(60));
        if (!(typeof u.dangerouslySetInnerHTML == "object" && "__html" in u.dangerouslySetInnerHTML))
          throw Error(r(61));
      }
      if (u.style != null && typeof u.style != "object")
        throw Error(r(62));
    }
  }
  function Oi(o, u) {
    if (o.indexOf("-") === -1)
      return typeof u.is == "string";
    switch (o) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  function Qr(o) {
    return o = o.target || o.srcElement || window, o.correspondingUseElement && (o = o.correspondingUseElement), o.nodeType === 3 ? o.parentNode : o;
  }
  var Ha = null, ma = null, Kr = null;
  function Ka(o) {
    if (o = si(o)) {
      if (typeof Ha != "function")
        throw Error(r(280));
      var u = o.stateNode;
      u && (u = xo(u), Ha(o.stateNode, o.type, u));
    }
  }
  function Jn(o) {
    ma ? Kr ? Kr.push(o) : Kr = [o] : ma = o;
  }
  function or() {
    if (ma) {
      var o = ma, u = Kr;
      if (Kr = ma = null, Ka(o), u)
        for (o = 0; o < u.length; o++)
          Ka(u[o]);
    }
  }
  function yo(o, u) {
    return o(u);
  }
  function Ti(o, u, d, g, $) {
    return o(u, d, g, $);
  }
  function Yi() {
  }
  var Gi = yo, Ma = !1, Zt = !1;
  function gi() {
    (ma !== null || Kr !== null) && (Yi(), or());
  }
  function qs(o, u, d) {
    if (Zt)
      return o(u, d);
    Zt = !0;
    try {
      return Gi(o, u, d);
    } finally {
      Zt = !1, gi();
    }
  }
  function Jr(o, u) {
    var d = o.stateNode;
    if (d === null)
      return null;
    var g = xo(d);
    if (g === null)
      return null;
    d = g[u];
    e:
      switch (u) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (g = !g.disabled) || (o = o.type, g = !(o === "button" || o === "input" || o === "select" || o === "textarea")), o = !g;
          break e;
        default:
          o = !1;
      }
    if (o)
      return null;
    if (d && typeof d != "function")
      throw Error(r(231, u, typeof d));
    return d;
  }
  var ha = !1;
  if (v)
    try {
      var yi = {};
      Object.defineProperty(yi, "passive", { get: function() {
        ha = !0;
      } }), window.addEventListener("test", yi, yi), window.removeEventListener("test", yi, yi);
    } catch {
      ha = !1;
    }
  function Br(o, u, d, g, $, _, I, q, re) {
    var Se = Array.prototype.slice.call(arguments, 3);
    try {
      u.apply(d, Se);
    } catch (ut) {
      this.onError(ut);
    }
  }
  var Ja = !1, Ri = null, bi = !1, Qi = null, bo = { onError: function(o) {
    Ja = !0, Ri = o;
  } };
  function Za(o, u, d, g, $, _, I, q, re) {
    Ja = !1, Ri = null, Br.apply(bo, arguments);
  }
  function Zr(o, u, d, g, $, _, I, q, re) {
    if (Za.apply(this, arguments), Ja) {
      if (Ja) {
        var Se = Ri;
        Ja = !1, Ri = null;
      } else
        throw Error(r(198));
      bi || (bi = !0, Qi = Se);
    }
  }
  function mr(o) {
    var u = o, d = o;
    if (o.alternate)
      for (; u.return; )
        u = u.return;
    else {
      o = u;
      do
        u = o, u.flags & 1026 && (d = u.return), o = u.return;
      while (o);
    }
    return u.tag === 3 ? d : null;
  }
  function Va(o) {
    if (o.tag === 13) {
      var u = o.memoizedState;
      if (u === null && (o = o.alternate, o !== null && (u = o.memoizedState)), u !== null)
        return u.dehydrated;
    }
    return null;
  }
  function ei(o) {
    if (mr(o) !== o)
      throw Error(r(188));
  }
  function pa(o) {
    var u = o.alternate;
    if (!u) {
      if (u = mr(o), u === null)
        throw Error(r(188));
      return u !== o ? null : o;
    }
    for (var d = o, g = u; ; ) {
      var $ = d.return;
      if ($ === null)
        break;
      var _ = $.alternate;
      if (_ === null) {
        if (g = $.return, g !== null) {
          d = g;
          continue;
        }
        break;
      }
      if ($.child === _.child) {
        for (_ = $.child; _; ) {
          if (_ === d)
            return ei($), o;
          if (_ === g)
            return ei($), u;
          _ = _.sibling;
        }
        throw Error(r(188));
      }
      if (d.return !== g.return)
        d = $, g = _;
      else {
        for (var I = !1, q = $.child; q; ) {
          if (q === d) {
            I = !0, d = $, g = _;
            break;
          }
          if (q === g) {
            I = !0, g = $, d = _;
            break;
          }
          q = q.sibling;
        }
        if (!I) {
          for (q = _.child; q; ) {
            if (q === d) {
              I = !0, d = _, g = $;
              break;
            }
            if (q === g) {
              I = !0, g = _, d = $;
              break;
            }
            q = q.sibling;
          }
          if (!I)
            throw Error(r(189));
        }
      }
      if (d.alternate !== g)
        throw Error(r(190));
    }
    if (d.tag !== 3)
      throw Error(r(188));
    return d.stateNode.current === d ? o : u;
  }
  function Ba(o) {
    if (o = pa(o), !o)
      return null;
    for (var u = o; ; ) {
      if (u.tag === 5 || u.tag === 6)
        return u;
      if (u.child)
        u.child.return = u, u = u.child;
      else {
        if (u === o)
          break;
        for (; !u.sibling; ) {
          if (!u.return || u.return === o)
            return null;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
    }
    return null;
  }
  function Ea(o, u) {
    for (var d = o.alternate; u !== null; ) {
      if (u === o || u === d)
        return !0;
      u = u.return;
    }
    return !1;
  }
  var Ki, ti, Aa, Ua, va = !1, Ur = [], Xa = null, ea = null, ni = null, Xr = /* @__PURE__ */ new Map(), Je = /* @__PURE__ */ new Map(), ri = [], _r = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function ai(o, u, d, g, $) {
    return { blockedOn: o, domEventName: u, eventSystemFlags: d | 16, nativeEvent: $, targetContainers: [g] };
  }
  function _a(o, u) {
    switch (o) {
      case "focusin":
      case "focusout":
        Xa = null;
        break;
      case "dragenter":
      case "dragleave":
        ea = null;
        break;
      case "mouseover":
      case "mouseout":
        ni = null;
        break;
      case "pointerover":
      case "pointerout":
        Xr.delete(u.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Je.delete(u.pointerId);
    }
  }
  function wi(o, u, d, g, $, _) {
    return o === null || o.nativeEvent !== _ ? (o = ai(u, d, g, $, _), u !== null && (u = si(u), u !== null && ti(u)), o) : (o.eventSystemFlags |= g, u = o.targetContainers, $ !== null && u.indexOf($) === -1 && u.push($), o);
  }
  function yr(o, u, d, g, $) {
    switch (u) {
      case "focusin":
        return Xa = wi(Xa, o, u, d, g, $), !0;
      case "dragenter":
        return ea = wi(ea, o, u, d, g, $), !0;
      case "mouseover":
        return ni = wi(ni, o, u, d, g, $), !0;
      case "pointerover":
        var _ = $.pointerId;
        return Xr.set(_, wi(Xr.get(_) || null, o, u, d, g, $)), !0;
      case "gotpointercapture":
        return _ = $.pointerId, Je.set(_, wi(Je.get(_) || null, o, u, d, g, $)), !0;
    }
    return !1;
  }
  function qn(o) {
    var u = bs(o.target);
    if (u !== null) {
      var d = mr(u);
      if (d !== null) {
        if (u = d.tag, u === 13) {
          if (u = Va(d), u !== null) {
            o.blockedOn = u, Ua(o.lanePriority, function() {
              n.unstable_runWithPriority(o.priority, function() {
                Aa(d);
              });
            });
            return;
          }
        } else if (u === 3 && d.stateNode.hydrate) {
          o.blockedOn = d.tag === 3 ? d.stateNode.containerInfo : null;
          return;
        }
      }
    }
    o.blockedOn = null;
  }
  function Or(o) {
    if (o.blockedOn !== null)
      return !1;
    for (var u = o.targetContainers; 0 < u.length; ) {
      var d = jr(o.domEventName, o.eventSystemFlags, u[0], o.nativeEvent);
      if (d !== null)
        return u = si(d), u !== null && ti(u), o.blockedOn = d, !1;
      u.shift();
    }
    return !0;
  }
  function ms(o, u, d) {
    Or(o) && d.delete(u);
  }
  function br() {
    for (va = !1; 0 < Ur.length; ) {
      var o = Ur[0];
      if (o.blockedOn !== null) {
        o = si(o.blockedOn), o !== null && Ki(o);
        break;
      }
      for (var u = o.targetContainers; 0 < u.length; ) {
        var d = jr(o.domEventName, o.eventSystemFlags, u[0], o.nativeEvent);
        if (d !== null) {
          o.blockedOn = d;
          break;
        }
        u.shift();
      }
      o.blockedOn === null && Ur.shift();
    }
    Xa !== null && Or(Xa) && (Xa = null), ea !== null && Or(ea) && (ea = null), ni !== null && Or(ni) && (ni = null), Xr.forEach(ms), Je.forEach(ms);
  }
  function lr(o, u) {
    o.blockedOn === u && (o.blockedOn = null, va || (va = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, br)));
  }
  function wo(o) {
    function u($) {
      return lr($, o);
    }
    if (0 < Ur.length) {
      lr(Ur[0], o);
      for (var d = 1; d < Ur.length; d++) {
        var g = Ur[d];
        g.blockedOn === o && (g.blockedOn = null);
      }
    }
    for (Xa !== null && lr(Xa, o), ea !== null && lr(ea, o), ni !== null && lr(ni, o), Xr.forEach(u), Je.forEach(u), d = 0; d < ri.length; d++)
      g = ri[d], g.blockedOn === o && (g.blockedOn = null);
    for (; 0 < ri.length && (d = ri[0], d.blockedOn === null); )
      qn(d), d.blockedOn === null && ri.shift();
  }
  function ta(o, u) {
    var d = {};
    return d[o.toLowerCase()] = u.toLowerCase(), d["Webkit" + o] = "webkit" + u, d["Moz" + o] = "moz" + u, d;
  }
  var ii = { animationend: ta("Animation", "AnimationEnd"), animationiteration: ta("Animation", "AnimationIteration"), animationstart: ta("Animation", "AnimationStart"), transitionend: ta("Transition", "TransitionEnd") }, Po = {}, ko = {};
  v && (ko = document.createElement("div").style, "AnimationEvent" in window || (delete ii.animationend.animation, delete ii.animationiteration.animation, delete ii.animationstart.animation), "TransitionEvent" in window || delete ii.transitionend.transition);
  function $o(o) {
    if (Po[o])
      return Po[o];
    if (!ii[o])
      return o;
    var u = ii[o], d;
    for (d in u)
      if (u.hasOwnProperty(d) && d in ko)
        return Po[o] = u[d];
    return o;
  }
  var hs = $o("animationend"), L = $o("animationiteration"), oe = $o("animationstart"), be = $o("transitionend"), Ee = /* @__PURE__ */ new Map(), Ze = /* @__PURE__ */ new Map(), Et = [
    "abort",
    "abort",
    hs,
    "animationEnd",
    L,
    "animationIteration",
    oe,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    be,
    "transitionEnd",
    "waiting",
    "waiting"
  ];
  function wt(o, u) {
    for (var d = 0; d < o.length; d += 2) {
      var g = o[d], $ = o[d + 1];
      $ = "on" + ($[0].toUpperCase() + $.slice(1)), Ze.set(g, u), Ee.set(g, $), m($, [g]);
    }
  }
  var xt = n.unstable_now;
  xt();
  var Pt = 8;
  function Qt(o) {
    if (1 & o)
      return Pt = 15, 1;
    if (2 & o)
      return Pt = 14, 2;
    if (4 & o)
      return Pt = 13, 4;
    var u = 24 & o;
    return u !== 0 ? (Pt = 12, u) : o & 32 ? (Pt = 11, 32) : (u = 192 & o, u !== 0 ? (Pt = 10, u) : o & 256 ? (Pt = 9, 256) : (u = 3584 & o, u !== 0 ? (Pt = 8, u) : o & 4096 ? (Pt = 7, 4096) : (u = 4186112 & o, u !== 0 ? (Pt = 6, u) : (u = 62914560 & o, u !== 0 ? (Pt = 5, u) : o & 67108864 ? (Pt = 4, 67108864) : o & 134217728 ? (Pt = 3, 134217728) : (u = 805306368 & o, u !== 0 ? (Pt = 2, u) : 1073741824 & o ? (Pt = 1, 1073741824) : (Pt = 8, o))))));
  }
  function dn(o) {
    switch (o) {
      case 99:
        return 15;
      case 98:
        return 10;
      case 97:
      case 96:
        return 8;
      case 95:
        return 2;
      default:
        return 0;
    }
  }
  function Wn(o) {
    switch (o) {
      case 15:
      case 14:
        return 99;
      case 13:
      case 12:
      case 11:
      case 10:
        return 98;
      case 9:
      case 8:
      case 7:
      case 6:
      case 4:
      case 5:
        return 97;
      case 3:
      case 2:
      case 1:
        return 95;
      case 0:
        return 90;
      default:
        throw Error(r(358, o));
    }
  }
  function Hn(o, u) {
    var d = o.pendingLanes;
    if (d === 0)
      return Pt = 0;
    var g = 0, $ = 0, _ = o.expiredLanes, I = o.suspendedLanes, q = o.pingedLanes;
    if (_ !== 0)
      g = _, $ = Pt = 15;
    else if (_ = d & 134217727, _ !== 0) {
      var re = _ & ~I;
      re !== 0 ? (g = Qt(re), $ = Pt) : (q &= _, q !== 0 && (g = Qt(q), $ = Pt));
    } else
      _ = d & ~I, _ !== 0 ? (g = Qt(_), $ = Pt) : q !== 0 && (g = Qt(q), $ = Pt);
    if (g === 0)
      return 0;
    if (g = 31 - ve(g), g = d & ((0 > g ? 0 : 1 << g) << 1) - 1, u !== 0 && u !== g && !(u & I)) {
      if (Qt(u), $ <= Pt)
        return u;
      Pt = $;
    }
    if (u = o.entangledLanes, u !== 0)
      for (o = o.entanglements, u &= g; 0 < u; )
        d = 31 - ve(u), $ = 1 << d, g |= o[d], u &= ~$;
    return g;
  }
  function wr(o) {
    return o = o.pendingLanes & -1073741825, o !== 0 ? o : o & 1073741824 ? 1073741824 : 0;
  }
  function jn(o, u) {
    switch (o) {
      case 15:
        return 1;
      case 14:
        return 2;
      case 12:
        return o = ga(24 & ~u), o === 0 ? jn(10, u) : o;
      case 10:
        return o = ga(192 & ~u), o === 0 ? jn(8, u) : o;
      case 8:
        return o = ga(3584 & ~u), o === 0 && (o = ga(4186112 & ~u), o === 0 && (o = 512)), o;
      case 2:
        return u = ga(805306368 & ~u), u === 0 && (u = 268435456), u;
    }
    throw Error(r(358, o));
  }
  function ga(o) {
    return o & -o;
  }
  function Di(o) {
    for (var u = [], d = 0; 31 > d; d++)
      u.push(o);
    return u;
  }
  function B(o, u, d) {
    o.pendingLanes |= u;
    var g = u - 1;
    o.suspendedLanes &= g, o.pingedLanes &= g, o = o.eventTimes, u = 31 - ve(u), o[u] = d;
  }
  var ve = Math.clz32 ? Math.clz32 : de, N = Math.log, Z = Math.LN2;
  function de(o) {
    return o === 0 ? 32 : 31 - (N(o) / Z | 0) | 0;
  }
  var Ke = n.unstable_UserBlockingPriority, Tt = n.unstable_runWithPriority, Nt = !0;
  function Mn(o, u, d, g) {
    Ma || Yi();
    var $ = yn, _ = Ma;
    Ma = !0;
    try {
      Ti($, o, u, d, g);
    } finally {
      (Ma = _) || gi();
    }
  }
  function Wt(o, u, d, g) {
    Tt(Ke, yn.bind(null, o, u, d, g));
  }
  function yn(o, u, d, g) {
    if (Nt) {
      var $;
      if (($ = (u & 4) === 0) && 0 < Ur.length && -1 < _r.indexOf(o))
        o = ai(null, o, u, d, g), Ur.push(o);
      else {
        var _ = jr(o, u, d, g);
        if (_ === null)
          $ && _a(o, g);
        else {
          if ($) {
            if (-1 < _r.indexOf(o)) {
              o = ai(_, o, u, d, g), Ur.push(o);
              return;
            }
            if (yr(_, o, u, d, g))
              return;
            _a(o, g);
          }
          Rc(o, u, g, null, d);
        }
      }
    }
  }
  function jr(o, u, d, g) {
    var $ = Qr(g);
    if ($ = bs($), $ !== null) {
      var _ = mr($);
      if (_ === null)
        $ = null;
      else {
        var I = _.tag;
        if (I === 13) {
          if ($ = Va(_), $ !== null)
            return $;
          $ = null;
        } else if (I === 3) {
          if (_.stateNode.hydrate)
            return _.tag === 3 ? _.stateNode.containerInfo : null;
          $ = null;
        } else
          _ !== $ && ($ = null);
      }
    }
    return Rc(o, u, g, $, d), null;
  }
  var sr = null, Pi = null, ki = null;
  function Ys() {
    if (ki)
      return ki;
    var o, u = Pi, d = u.length, g, $ = "value" in sr ? sr.value : sr.textContent, _ = $.length;
    for (o = 0; o < d && u[o] === $[o]; o++)
      ;
    var I = d - o;
    for (g = 1; g <= I && u[d - g] === $[_ - g]; g++)
      ;
    return ki = $.slice(o, 1 < g ? 1 - g : void 0);
  }
  function So(o) {
    var u = o.keyCode;
    return "charCode" in o ? (o = o.charCode, o === 0 && u === 13 && (o = 13)) : o = u, o === 10 && (o = 13), 32 <= o || o === 13 ? o : 0;
  }
  function yu() {
    return !0;
  }
  function Td() {
    return !1;
  }
  function oi(o) {
    function u(d, g, $, _, I) {
      this._reactName = d, this._targetInst = $, this.type = g, this.nativeEvent = _, this.target = I, this.currentTarget = null;
      for (var q in o)
        o.hasOwnProperty(q) && (d = o[q], this[q] = d ? d(_) : _[q]);
      return this.isDefaultPrevented = (_.defaultPrevented != null ? _.defaultPrevented : _.returnValue === !1) ? yu : Td, this.isPropagationStopped = Td, this;
    }
    return t(u.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var d = this.nativeEvent;
      d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = yu);
    }, stopPropagation: function() {
      var d = this.nativeEvent;
      d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = yu);
    }, persist: function() {
    }, isPersistent: yu }), u;
  }
  var Sl = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(o) {
    return o.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, xl = oi(Sl), Cl = t({}, Sl, { view: 0, detail: 0 }), Rd = oi(Cl), Cc, bu, Gs, wu = t({}, Cl, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Nd, button: 0, buttons: 0, relatedTarget: function(o) {
    return o.relatedTarget === void 0 ? o.fromElement === o.srcElement ? o.toElement : o.fromElement : o.relatedTarget;
  }, movementX: function(o) {
    return "movementX" in o ? o.movementX : (o !== Gs && (Gs && o.type === "mousemove" ? (Cc = o.screenX - Gs.screenX, bu = o.screenY - Gs.screenY) : bu = Cc = 0, Gs = o), Cc);
  }, movementY: function(o) {
    return "movementY" in o ? o.movementY : bu;
  } }), Pu = oi(wu), pm = t({}, wu, { dataTransfer: 0 }), Ni = oi(pm), Ho = t({}, Cl, { relatedTarget: 0 }), Oa = oi(Ho), ps = t({}, Sl, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), vm = oi(ps), Mc = t({}, Sl, { clipboardData: function(o) {
    return "clipboardData" in o ? o.clipboardData : window.clipboardData;
  } }), ap = oi(Mc), ku = t({}, Sl, { data: 0 }), gm = oi(ku), ym = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Ml = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Dd = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function bm(o) {
    var u = this.nativeEvent;
    return u.getModifierState ? u.getModifierState(o) : (o = Dd[o]) ? !!u[o] : !1;
  }
  function Nd() {
    return bm;
  }
  var Wd = t({}, Cl, { key: function(o) {
    if (o.key) {
      var u = ym[o.key] || o.key;
      if (u !== "Unidentified")
        return u;
    }
    return o.type === "keypress" ? (o = So(o), o === 13 ? "Enter" : String.fromCharCode(o)) : o.type === "keydown" || o.type === "keyup" ? Ml[o.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Nd, charCode: function(o) {
    return o.type === "keypress" ? So(o) : 0;
  }, keyCode: function(o) {
    return o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
  }, which: function(o) {
    return o.type === "keypress" ? So(o) : o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
  } }), ip = oi(Wd), wm = t({}, wu, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Pm = oi(wm), El = t({}, Cl, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Nd }), Al = oi(El), jd = t({}, Sl, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), km = oi(jd), $m = t({}, wu, {
    deltaX: function(o) {
      return "deltaX" in o ? o.deltaX : "wheelDeltaX" in o ? -o.wheelDeltaX : 0;
    },
    deltaY: function(o) {
      return "deltaY" in o ? o.deltaY : "wheelDeltaY" in o ? -o.wheelDeltaY : "wheelDelta" in o ? -o.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), op = oi($m), sp = [9, 13, 27, 32], zd = v && "CompositionEvent" in window, $u = null;
  v && "documentMode" in document && ($u = document.documentMode);
  var lp = v && "TextEvent" in window && !$u, Ld = v && (!zd || $u && 8 < $u && 11 >= $u), Id = String.fromCharCode(32), Sm = !1;
  function Fd(o, u) {
    switch (o) {
      case "keyup":
        return sp.indexOf(u.keyCode) !== -1;
      case "keydown":
        return u.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function xm(o) {
    return o = o.detail, typeof o == "object" && "data" in o ? o.data : null;
  }
  var Vo = !1;
  function Cm(o, u) {
    switch (o) {
      case "compositionend":
        return xm(u);
      case "keypress":
        return u.which !== 32 ? null : (Sm = !0, Id);
      case "textInput":
        return o = u.data, o === Id && Sm ? null : o;
      default:
        return null;
    }
  }
  function Mm(o, u) {
    if (Vo)
      return o === "compositionend" || !zd && Fd(o, u) ? (o = Ys(), ki = Pi = sr = null, Vo = !1, o) : null;
    switch (o) {
      case "paste":
        return null;
      case "keypress":
        if (!(u.ctrlKey || u.altKey || u.metaKey) || u.ctrlKey && u.altKey) {
          if (u.char && 1 < u.char.length)
            return u.char;
          if (u.which)
            return String.fromCharCode(u.which);
        }
        return null;
      case "compositionend":
        return Ld && u.locale !== "ko" ? null : u.data;
      default:
        return null;
    }
  }
  var Em = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Hd(o) {
    var u = o && o.nodeName && o.nodeName.toLowerCase();
    return u === "input" ? !!Em[o.type] : u === "textarea";
  }
  function Qs(o, u, d, g) {
    Jn(g), u = _u(u, "onChange"), 0 < u.length && (d = new xl("onChange", "change", null, d, g), o.push({ event: d, listeners: u }));
  }
  var Ji = null, Bo = null;
  function Am(o) {
    _c(o, 0);
  }
  function Uo(o) {
    var u = Ya(o);
    if (Gr(u))
      return o;
  }
  function up(o, u) {
    if (o === "change")
      return u;
  }
  var _m = !1;
  if (v) {
    var Vd;
    if (v) {
      var Su = "oninput" in document;
      if (!Su) {
        var xu = document.createElement("div");
        xu.setAttribute("oninput", "return;"), Su = typeof xu.oninput == "function";
      }
      Vd = Su;
    } else
      Vd = !1;
    _m = Vd && (!document.documentMode || 9 < document.documentMode);
  }
  function Ec() {
    Ji && (Ji.detachEvent("onpropertychange", Bd), Bo = Ji = null);
  }
  function Bd(o) {
    if (o.propertyName === "value" && Uo(Bo)) {
      var u = [];
      if (Qs(u, Bo, o, Qr(o)), o = Am, Ma)
        o(u);
      else {
        Ma = !0;
        try {
          yo(o, u);
        } finally {
          Ma = !1, gi();
        }
      }
    }
  }
  function cp(o, u, d) {
    o === "focusin" ? (Ec(), Ji = u, Bo = d, Ji.attachEvent("onpropertychange", Bd)) : o === "focusout" && Ec();
  }
  function Ac(o) {
    if (o === "selectionchange" || o === "keyup" || o === "keydown")
      return Uo(Bo);
  }
  function qa(o, u) {
    if (o === "click")
      return Uo(u);
  }
  function dp(o, u) {
    if (o === "input" || o === "change")
      return Uo(u);
  }
  function Om(o, u) {
    return o === u && (o !== 0 || 1 / o === 1 / u) || o !== o && u !== u;
  }
  var $i = typeof Object.is == "function" ? Object.is : Om, Ud = Object.prototype.hasOwnProperty;
  function Cu(o, u) {
    if ($i(o, u))
      return !0;
    if (typeof o != "object" || o === null || typeof u != "object" || u === null)
      return !1;
    var d = Object.keys(o), g = Object.keys(u);
    if (d.length !== g.length)
      return !1;
    for (g = 0; g < d.length; g++)
      if (!Ud.call(u, d[g]) || !$i(o[d[g]], u[d[g]]))
        return !1;
    return !0;
  }
  function Mu(o) {
    for (; o && o.firstChild; )
      o = o.firstChild;
    return o;
  }
  function Tm(o, u) {
    var d = Mu(o);
    o = 0;
    for (var g; d; ) {
      if (d.nodeType === 3) {
        if (g = o + d.textContent.length, o <= u && g >= u)
          return { node: d, offset: u - o };
        o = g;
      }
      e: {
        for (; d; ) {
          if (d.nextSibling) {
            d = d.nextSibling;
            break e;
          }
          d = d.parentNode;
        }
        d = void 0;
      }
      d = Mu(d);
    }
  }
  function Xd(o, u) {
    return o && u ? o === u ? !0 : o && o.nodeType === 3 ? !1 : u && u.nodeType === 3 ? Xd(o, u.parentNode) : "contains" in o ? o.contains(u) : o.compareDocumentPosition ? !!(o.compareDocumentPosition(u) & 16) : !1 : !1;
  }
  function _l() {
    for (var o = window, u = da(); u instanceof o.HTMLIFrameElement; ) {
      try {
        var d = typeof u.contentWindow.location.href == "string";
      } catch {
        d = !1;
      }
      if (d)
        o = u.contentWindow;
      else
        break;
      u = da(o.document);
    }
    return u;
  }
  function Xo(o) {
    var u = o && o.nodeName && o.nodeName.toLowerCase();
    return u && (u === "input" && (o.type === "text" || o.type === "search" || o.type === "tel" || o.type === "url" || o.type === "password") || u === "textarea" || o.contentEditable === "true");
  }
  var Rm = v && "documentMode" in document && 11 >= document.documentMode, Ol = null, Eu = null, vs = null, qo = !1;
  function Ks(o, u, d) {
    var g = d.window === d ? d.document : d.nodeType === 9 ? d : d.ownerDocument;
    qo || Ol == null || Ol !== da(g) || (g = Ol, "selectionStart" in g && Xo(g) ? g = { start: g.selectionStart, end: g.selectionEnd } : (g = (g.ownerDocument && g.ownerDocument.defaultView || window).getSelection(), g = { anchorNode: g.anchorNode, anchorOffset: g.anchorOffset, focusNode: g.focusNode, focusOffset: g.focusOffset }), vs && Cu(vs, g) || (vs = g, g = _u(Eu, "onSelect"), 0 < g.length && (u = new xl("onSelect", "select", null, u, d), o.push({ event: u, listeners: g }), u.target = Ol)));
  }
  wt(
    "cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
    0
  ), wt("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), wt(Et, 2);
  for (var qd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Yd = 0; Yd < qd.length; Yd++)
    Ze.set(qd[Yd], 0);
  p("onMouseEnter", ["mouseout", "mouseover"]), p("onMouseLeave", ["mouseout", "mouseover"]), p("onPointerEnter", ["pointerout", "pointerover"]), p("onPointerLeave", ["pointerout", "pointerover"]), m("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), m("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), m("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), m("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), m("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), m("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Tl = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Dm = new Set("cancel close invalid load scroll toggle".split(" ").concat(Tl));
  function Gd(o, u, d) {
    var g = o.type || "unknown-event";
    o.currentTarget = d, Zr(g, u, void 0, o), o.currentTarget = null;
  }
  function _c(o, u) {
    u = (u & 4) !== 0;
    for (var d = 0; d < o.length; d++) {
      var g = o[d], $ = g.event;
      g = g.listeners;
      e: {
        var _ = void 0;
        if (u)
          for (var I = g.length - 1; 0 <= I; I--) {
            var q = g[I], re = q.instance, Se = q.currentTarget;
            if (q = q.listener, re !== _ && $.isPropagationStopped())
              break e;
            Gd($, q, Se), _ = re;
          }
        else
          for (I = 0; I < g.length; I++) {
            if (q = g[I], re = q.instance, Se = q.currentTarget, q = q.listener, re !== _ && $.isPropagationStopped())
              break e;
            Gd($, q, Se), _ = re;
          }
      }
    }
    if (bi)
      throw o = Qi, bi = !1, Qi = null, o;
  }
  function Zn(o, u) {
    var d = Wc(u), g = o + "__bubble";
    d.has(g) || (Tc(u, o, 2, !1), d.add(g));
  }
  var Oc = "_reactListening" + Math.random().toString(36).slice(2);
  function Qd(o) {
    o[Oc] || (o[Oc] = !0, s.forEach(function(u) {
      Dm.has(u) || Yo(u, !1, o, null), Yo(u, !0, o, null);
    }));
  }
  function Yo(o, u, d, g) {
    var $ = 4 < arguments.length && arguments[4] !== void 0 ? arguments[4] : 0, _ = d;
    if (o === "selectionchange" && d.nodeType !== 9 && (_ = d.ownerDocument), g !== null && !u && Dm.has(o)) {
      if (o !== "scroll")
        return;
      $ |= 2, _ = g;
    }
    var I = Wc(_), q = o + "__" + (u ? "capture" : "bubble");
    I.has(q) || (u && ($ |= 4), Tc(_, o, $, u), I.add(q));
  }
  function Tc(o, u, d, g) {
    var $ = Ze.get(u);
    switch ($ === void 0 ? 2 : $) {
      case 0:
        $ = Mn;
        break;
      case 1:
        $ = Wt;
        break;
      default:
        $ = yn;
    }
    d = $.bind(null, u, d, o), $ = void 0, !ha || u !== "touchstart" && u !== "touchmove" && u !== "wheel" || ($ = !0), g ? $ !== void 0 ? o.addEventListener(u, d, { capture: !0, passive: $ }) : o.addEventListener(u, d, !0) : $ !== void 0 ? o.addEventListener(u, d, { passive: $ }) : o.addEventListener(u, d, !1);
  }
  function Rc(o, u, d, g, $) {
    var _ = g;
    if (!(u & 1) && !(u & 2) && g !== null)
      e:
        for (; ; ) {
          if (g === null)
            return;
          var I = g.tag;
          if (I === 3 || I === 4) {
            var q = g.stateNode.containerInfo;
            if (q === $ || q.nodeType === 8 && q.parentNode === $)
              break;
            if (I === 4)
              for (I = g.return; I !== null; ) {
                var re = I.tag;
                if ((re === 3 || re === 4) && (re = I.stateNode.containerInfo, re === $ || re.nodeType === 8 && re.parentNode === $))
                  return;
                I = I.return;
              }
            for (; q !== null; ) {
              if (I = bs(q), I === null)
                return;
              if (re = I.tag, re === 5 || re === 6) {
                g = _ = I;
                continue e;
              }
              q = q.parentNode;
            }
          }
          g = g.return;
        }
    qs(function() {
      var Se = _, ut = Qr(d), Xt = [];
      e: {
        var Ve = Ee.get(o);
        if (Ve !== void 0) {
          var Mt = xl, Vt = o;
          switch (o) {
            case "keypress":
              if (So(d) === 0)
                break e;
            case "keydown":
            case "keyup":
              Mt = ip;
              break;
            case "focusin":
              Vt = "focus", Mt = Oa;
              break;
            case "focusout":
              Vt = "blur", Mt = Oa;
              break;
            case "beforeblur":
            case "afterblur":
              Mt = Oa;
              break;
            case "click":
              if (d.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Mt = Pu;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Mt = Ni;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Mt = Al;
              break;
            case hs:
            case L:
            case oe:
              Mt = vm;
              break;
            case be:
              Mt = km;
              break;
            case "scroll":
              Mt = Rd;
              break;
            case "wheel":
              Mt = op;
              break;
            case "copy":
            case "cut":
            case "paste":
              Mt = ap;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Mt = Pm;
          }
          var zt = (u & 4) !== 0, ge = !zt && o === "scroll", le = zt ? Ve !== null ? Ve + "Capture" : null : Ve;
          zt = [];
          for (var fe = Se, Re; fe !== null; ) {
            Re = fe;
            var je = Re.stateNode;
            if (Re.tag === 5 && je !== null && (Re = je, le !== null && (je = Jr(fe, le), je != null && zt.push(Au(fe, je, Re)))), ge)
              break;
            fe = fe.return;
          }
          0 < zt.length && (Ve = new Mt(Ve, Vt, null, d, ut), Xt.push({ event: Ve, listeners: zt }));
        }
      }
      if (!(u & 7)) {
        e: {
          if (Ve = o === "mouseover" || o === "pointerover", Mt = o === "mouseout" || o === "pointerout", Ve && !(u & 16) && (Vt = d.relatedTarget || d.fromElement) && (bs(Vt) || Vt[Ta]))
            break e;
          if ((Mt || Ve) && (Ve = ut.window === ut ? ut : (Ve = ut.ownerDocument) ? Ve.defaultView || Ve.parentWindow : window, Mt ? (Vt = d.relatedTarget || d.toElement, Mt = Se, Vt = Vt ? bs(Vt) : null, Vt !== null && (ge = mr(Vt), Vt !== ge || Vt.tag !== 5 && Vt.tag !== 6) && (Vt = null)) : (Mt = null, Vt = Se), Mt !== Vt)) {
            if (zt = Pu, je = "onMouseLeave", le = "onMouseEnter", fe = "mouse", (o === "pointerout" || o === "pointerover") && (zt = Pm, je = "onPointerLeave", le = "onPointerEnter", fe = "pointer"), ge = Mt == null ? Ve : Ya(Mt), Re = Vt == null ? Ve : Ya(Vt), Ve = new zt(je, fe + "leave", Mt, d, ut), Ve.target = ge, Ve.relatedTarget = Re, je = null, bs(ut) === Se && (zt = new zt(le, fe + "enter", Vt, d, ut), zt.target = Re, zt.relatedTarget = ge, je = zt), ge = je, Mt && Vt)
              t: {
                for (zt = Mt, le = Vt, fe = 0, Re = zt; Re; Re = Js(Re))
                  fe++;
                for (Re = 0, je = le; je; je = Js(je))
                  Re++;
                for (; 0 < fe - Re; )
                  zt = Js(zt), fe--;
                for (; 0 < Re - fe; )
                  le = Js(le), Re--;
                for (; fe--; ) {
                  if (zt === le || le !== null && zt === le.alternate)
                    break t;
                  zt = Js(zt), le = Js(le);
                }
                zt = null;
              }
            else
              zt = null;
            Mt !== null && Nm(Xt, Ve, Mt, zt, !1), Vt !== null && ge !== null && Nm(Xt, ge, Vt, zt, !0);
          }
        }
        e: {
          if (Ve = Se ? Ya(Se) : window, Mt = Ve.nodeName && Ve.nodeName.toLowerCase(), Mt === "select" || Mt === "input" && Ve.type === "file")
            var Kt = up;
          else if (Hd(Ve))
            if (_m)
              Kt = dp;
            else {
              Kt = Ac;
              var gt = cp;
            }
          else
            (Mt = Ve.nodeName) && Mt.toLowerCase() === "input" && (Ve.type === "checkbox" || Ve.type === "radio") && (Kt = qa);
          if (Kt && (Kt = Kt(o, Se))) {
            Qs(Xt, Kt, d, ut);
            break e;
          }
          gt && gt(o, Ve, Se), o === "focusout" && (gt = Ve._wrapperState) && gt.controlled && Ve.type === "number" && fr(Ve, "number", Ve.value);
        }
        switch (gt = Se ? Ya(Se) : window, o) {
          case "focusin":
            (Hd(gt) || gt.contentEditable === "true") && (Ol = gt, Eu = Se, vs = null);
            break;
          case "focusout":
            vs = Eu = Ol = null;
            break;
          case "mousedown":
            qo = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            qo = !1, Ks(Xt, d, ut);
            break;
          case "selectionchange":
            if (Rm)
              break;
          case "keydown":
          case "keyup":
            Ks(Xt, d, ut);
        }
        var qt;
        if (zd)
          e: {
            switch (o) {
              case "compositionstart":
                var tn = "onCompositionStart";
                break e;
              case "compositionend":
                tn = "onCompositionEnd";
                break e;
              case "compositionupdate":
                tn = "onCompositionUpdate";
                break e;
            }
            tn = void 0;
          }
        else
          Vo ? Fd(o, d) && (tn = "onCompositionEnd") : o === "keydown" && d.keyCode === 229 && (tn = "onCompositionStart");
        tn && (Ld && d.locale !== "ko" && (Vo || tn !== "onCompositionStart" ? tn === "onCompositionEnd" && Vo && (qt = Ys()) : (sr = ut, Pi = "value" in sr ? sr.value : sr.textContent, Vo = !0)), gt = _u(Se, tn), 0 < gt.length && (tn = new gm(tn, o, null, d, ut), Xt.push({ event: tn, listeners: gt }), qt ? tn.data = qt : (qt = xm(d), qt !== null && (tn.data = qt)))), (qt = lp ? Cm(o, d) : Mm(o, d)) && (Se = _u(Se, "onBeforeInput"), 0 < Se.length && (ut = new gm(
          "onBeforeInput",
          "beforeinput",
          null,
          d,
          ut
        ), Xt.push({ event: ut, listeners: Se }), ut.data = qt));
      }
      _c(Xt, u);
    });
  }
  function Au(o, u, d) {
    return { instance: o, listener: u, currentTarget: d };
  }
  function _u(o, u) {
    for (var d = u + "Capture", g = []; o !== null; ) {
      var $ = o, _ = $.stateNode;
      $.tag === 5 && _ !== null && ($ = _, _ = Jr(o, d), _ != null && g.unshift(Au(o, _, $)), _ = Jr(o, u), _ != null && g.push(Au(o, _, $))), o = o.return;
    }
    return g;
  }
  function Js(o) {
    if (o === null)
      return null;
    do
      o = o.return;
    while (o && o.tag !== 5);
    return o || null;
  }
  function Nm(o, u, d, g, $) {
    for (var _ = u._reactName, I = []; d !== null && d !== g; ) {
      var q = d, re = q.alternate, Se = q.stateNode;
      if (re !== null && re === g)
        break;
      q.tag === 5 && Se !== null && (q = Se, $ ? (re = Jr(d, _), re != null && I.unshift(Au(d, re, q))) : $ || (re = Jr(d, _), re != null && I.push(Au(d, re, q)))), d = d.return;
    }
    I.length !== 0 && o.push({ event: u, listeners: I });
  }
  function Ou() {
  }
  var Kd = null, Jd = null;
  function Wi(o, u) {
    switch (o) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        return !!u.autoFocus;
    }
    return !1;
  }
  function Tu(o, u) {
    return o === "textarea" || o === "option" || o === "noscript" || typeof u.children == "string" || typeof u.children == "number" || typeof u.dangerouslySetInnerHTML == "object" && u.dangerouslySetInnerHTML !== null && u.dangerouslySetInnerHTML.__html != null;
  }
  var Rl = typeof setTimeout == "function" ? setTimeout : void 0, Zs = typeof clearTimeout == "function" ? clearTimeout : void 0;
  function Dc(o) {
    o.nodeType === 1 ? o.textContent = "" : o.nodeType === 9 && (o = o.body, o != null && (o.textContent = ""));
  }
  function gs(o) {
    for (; o != null; o = o.nextSibling) {
      var u = o.nodeType;
      if (u === 1 || u === 3)
        break;
    }
    return o;
  }
  function Wm(o) {
    o = o.previousSibling;
    for (var u = 0; o; ) {
      if (o.nodeType === 8) {
        var d = o.data;
        if (d === "$" || d === "$!" || d === "$?") {
          if (u === 0)
            return o;
          u--;
        } else
          d === "/$" && u++;
      }
      o = o.previousSibling;
    }
    return null;
  }
  var ys = 0;
  function Nc(o) {
    return { $$typeof: Ye, toString: o, valueOf: o };
  }
  var Go = Math.random().toString(36).slice(2), Pr = "__reactFiber$" + Go, Ru = "__reactProps$" + Go, Ta = "__reactContainer$" + Go, Du = "__reactEvents$" + Go;
  function bs(o) {
    var u = o[Pr];
    if (u)
      return u;
    for (var d = o.parentNode; d; ) {
      if (u = d[Ta] || d[Pr]) {
        if (d = u.alternate, u.child !== null || d !== null && d.child !== null)
          for (o = Wm(o); o !== null; ) {
            if (d = o[Pr])
              return d;
            o = Wm(o);
          }
        return u;
      }
      o = d, d = o.parentNode;
    }
    return null;
  }
  function si(o) {
    return o = o[Pr] || o[Ta], !o || o.tag !== 5 && o.tag !== 6 && o.tag !== 13 && o.tag !== 3 ? null : o;
  }
  function Ya(o) {
    if (o.tag === 5 || o.tag === 6)
      return o.stateNode;
    throw Error(r(33));
  }
  function xo(o) {
    return o[Ru] || null;
  }
  function Wc(o) {
    var u = o[Du];
    return u === void 0 && (u = o[Du] = /* @__PURE__ */ new Set()), u;
  }
  var Zd = [], zn = -1;
  function Ra(o) {
    return { current: o };
  }
  function Ht(o) {
    0 > zn || (o.current = Zd[zn], Zd[zn] = null, zn--);
  }
  function Lt(o, u) {
    zn++, Zd[zn] = o.current, o.current = u;
  }
  var ws = {}, er = Ra(ws), kr = Ra(!1), Ps = ws;
  function En(o, u) {
    var d = o.type.contextTypes;
    if (!d)
      return ws;
    var g = o.stateNode;
    if (g && g.__reactInternalMemoizedUnmaskedChildContext === u)
      return g.__reactInternalMemoizedMaskedChildContext;
    var $ = {}, _;
    for (_ in d)
      $[_] = u[_];
    return g && (o = o.stateNode, o.__reactInternalMemoizedUnmaskedChildContext = u, o.__reactInternalMemoizedMaskedChildContext = $), $;
  }
  function ya(o) {
    return o = o.childContextTypes, o != null;
  }
  function Zi() {
    Ht(kr), Ht(er);
  }
  function eo(o, u, d) {
    if (er.current !== ws)
      throw Error(r(168));
    Lt(er, u), Lt(kr, d);
  }
  function Dl(o, u, d) {
    var g = o.stateNode;
    if (o = u.childContextTypes, typeof g.getChildContext != "function")
      return d;
    g = g.getChildContext();
    for (var $ in g)
      if (!($ in o))
        throw Error(r(108, cn(u) || "Unknown", $));
    return t({}, d, g);
  }
  function Si(o) {
    return o = (o = o.stateNode) && o.__reactInternalMemoizedMergedChildContext || ws, Ps = er.current, Lt(er, o), Lt(kr, kr.current), !0;
  }
  function jm(o, u, d) {
    var g = o.stateNode;
    if (!g)
      throw Error(r(169));
    d ? (o = Dl(o, u, Ps), g.__reactInternalMemoizedMergedChildContext = o, Ht(kr), Ht(er), Lt(er, o)) : Ht(kr), Lt(kr, d);
  }
  var ef = null, el = null, Nu = n.unstable_runWithPriority, to = n.unstable_scheduleCallback, Wu = n.unstable_cancelCallback, fp = n.unstable_shouldYield, ks = n.unstable_requestPaint, jc = n.unstable_now, zm = n.unstable_getCurrentPriorityLevel, zc = n.unstable_ImmediatePriority, Lm = n.unstable_UserBlockingPriority, tf = n.unstable_NormalPriority, nf = n.unstable_LowPriority, ju = n.unstable_IdlePriority, rf = {}, Lc = ks !== void 0 ? ks : function() {
  }, ji = null, Nl = null, Wl = !1, af = jc(), ba = 1e4 > af ? jc : function() {
    return jc() - af;
  };
  function jl() {
    switch (zm()) {
      case zc:
        return 99;
      case Lm:
        return 98;
      case tf:
        return 97;
      case nf:
        return 96;
      case ju:
        return 95;
      default:
        throw Error(r(332));
    }
  }
  function of(o) {
    switch (o) {
      case 99:
        return zc;
      case 98:
        return Lm;
      case 97:
        return tf;
      case 96:
        return nf;
      case 95:
        return ju;
      default:
        throw Error(r(332));
    }
  }
  function wa(o, u) {
    return o = of(o), Nu(o, u);
  }
  function zi(o, u, d) {
    return o = of(o), to(o, u, d);
  }
  function na() {
    if (Nl !== null) {
      var o = Nl;
      Nl = null, Wu(o);
    }
    no();
  }
  function no() {
    if (!Wl && ji !== null) {
      Wl = !0;
      var o = 0;
      try {
        var u = ji;
        wa(99, function() {
          for (; o < u.length; o++) {
            var d = u[o];
            do
              d = d(!0);
            while (d !== null);
          }
        }), ji = null;
      } catch (d) {
        throw ji !== null && (ji = ji.slice(o + 1)), to(zc, na), d;
      } finally {
        Wl = !1;
      }
    }
  }
  var $s = U.ReactCurrentBatchConfig;
  function $r(o, u) {
    if (o && o.defaultProps) {
      u = t({}, u), o = o.defaultProps;
      for (var d in o)
        u[d] === void 0 && (u[d] = o[d]);
      return u;
    }
    return u;
  }
  var Ss = Ra(null), xs = null, Co = null, Ic = null;
  function zu() {
    Ic = Co = xs = null;
  }
  function li(o) {
    var u = Ss.current;
    Ht(Ss), o.type._context._currentValue = u;
  }
  function Mo(o, u) {
    for (; o !== null; ) {
      var d = o.alternate;
      if ((o.childLanes & u) === u) {
        if (d === null || (d.childLanes & u) === u)
          break;
        d.childLanes |= u;
      } else
        o.childLanes |= u, d !== null && (d.childLanes |= u);
      o = o.return;
    }
  }
  function ui(o, u) {
    xs = o, Ic = Co = null, o = o.dependencies, o !== null && o.firstContext !== null && (o.lanes & u && (Rt = !0), o.firstContext = null);
  }
  function xi(o, u) {
    if (Ic !== o && u !== !1 && u !== 0)
      if ((typeof u != "number" || u === 1073741823) && (Ic = o, u = 1073741823), u = { context: o, observedBits: u, next: null }, Co === null) {
        if (xs === null)
          throw Error(r(308));
        Co = u, xs.dependencies = { lanes: 0, firstContext: u, responders: null };
      } else
        Co = Co.next = u;
    return o._currentValue;
  }
  var Li = !1;
  function sf(o) {
    o.updateQueue = { baseState: o.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null }, effects: null };
  }
  function Im(o, u) {
    o = o.updateQueue, u.updateQueue === o && (u.updateQueue = { baseState: o.baseState, firstBaseUpdate: o.firstBaseUpdate, lastBaseUpdate: o.lastBaseUpdate, shared: o.shared, effects: o.effects });
  }
  function ro(o, u) {
    return { eventTime: o, lane: u, tag: 0, payload: null, callback: null, next: null };
  }
  function Qo(o, u) {
    if (o = o.updateQueue, o !== null) {
      o = o.shared;
      var d = o.pending;
      d === null ? u.next = u : (u.next = d.next, d.next = u), o.pending = u;
    }
  }
  function Fm(o, u) {
    var d = o.updateQueue, g = o.alternate;
    if (g !== null && (g = g.updateQueue, d === g)) {
      var $ = null, _ = null;
      if (d = d.firstBaseUpdate, d !== null) {
        do {
          var I = { eventTime: d.eventTime, lane: d.lane, tag: d.tag, payload: d.payload, callback: d.callback, next: null };
          _ === null ? $ = _ = I : _ = _.next = I, d = d.next;
        } while (d !== null);
        _ === null ? $ = _ = u : _ = _.next = u;
      } else
        $ = _ = u;
      d = { baseState: g.baseState, firstBaseUpdate: $, lastBaseUpdate: _, shared: g.shared, effects: g.effects }, o.updateQueue = d;
      return;
    }
    o = d.lastBaseUpdate, o === null ? d.firstBaseUpdate = u : o.next = u, d.lastBaseUpdate = u;
  }
  function Ko(o, u, d, g) {
    var $ = o.updateQueue;
    Li = !1;
    var _ = $.firstBaseUpdate, I = $.lastBaseUpdate, q = $.shared.pending;
    if (q !== null) {
      $.shared.pending = null;
      var re = q, Se = re.next;
      re.next = null, I === null ? _ = Se : I.next = Se, I = re;
      var ut = o.alternate;
      if (ut !== null) {
        ut = ut.updateQueue;
        var Xt = ut.lastBaseUpdate;
        Xt !== I && (Xt === null ? ut.firstBaseUpdate = Se : Xt.next = Se, ut.lastBaseUpdate = re);
      }
    }
    if (_ !== null) {
      Xt = $.baseState, I = 0, ut = Se = re = null;
      do {
        q = _.lane;
        var Ve = _.eventTime;
        if ((g & q) === q) {
          ut !== null && (ut = ut.next = {
            eventTime: Ve,
            lane: 0,
            tag: _.tag,
            payload: _.payload,
            callback: _.callback,
            next: null
          });
          e: {
            var Mt = o, Vt = _;
            switch (q = u, Ve = d, Vt.tag) {
              case 1:
                if (Mt = Vt.payload, typeof Mt == "function") {
                  Xt = Mt.call(Ve, Xt, q);
                  break e;
                }
                Xt = Mt;
                break e;
              case 3:
                Mt.flags = Mt.flags & -4097 | 64;
              case 0:
                if (Mt = Vt.payload, q = typeof Mt == "function" ? Mt.call(Ve, Xt, q) : Mt, q == null)
                  break e;
                Xt = t({}, Xt, q);
                break e;
              case 2:
                Li = !0;
            }
          }
          _.callback !== null && (o.flags |= 32, q = $.effects, q === null ? $.effects = [_] : q.push(_));
        } else
          Ve = { eventTime: Ve, lane: q, tag: _.tag, payload: _.payload, callback: _.callback, next: null }, ut === null ? (Se = ut = Ve, re = Xt) : ut = ut.next = Ve, I |= q;
        if (_ = _.next, _ === null) {
          if (q = $.shared.pending, q === null)
            break;
          _ = q.next, q.next = null, $.lastBaseUpdate = q, $.shared.pending = null;
        }
      } while (1);
      ut === null && (re = Xt), $.baseState = re, $.firstBaseUpdate = Se, $.lastBaseUpdate = ut, Yu |= I, o.lanes = I, o.memoizedState = Xt;
    }
  }
  function lf(o, u, d) {
    if (o = u.effects, u.effects = null, o !== null)
      for (u = 0; u < o.length; u++) {
        var g = o[u], $ = g.callback;
        if ($ !== null) {
          if (g.callback = null, g = d, typeof $ != "function")
            throw Error(r(191, $));
          $.call(g);
        }
      }
  }
  var zl = new e.Component().refs;
  function Lu(o, u, d, g) {
    u = o.memoizedState, d = d(g, u), d = d == null ? u : t({}, u, d), o.memoizedState = d, o.lanes === 0 && (o.updateQueue.baseState = d);
  }
  var Ll = { isMounted: function(o) {
    return (o = o._reactInternals) ? mr(o) === o : !1;
  }, enqueueSetState: function(o, u, d) {
    o = o._reactInternals;
    var g = oo(), $ = Ds(o), _ = ro(g, $);
    _.payload = u, d != null && (_.callback = d), Qo(o, _), ql(o, $, g);
  }, enqueueReplaceState: function(o, u, d) {
    o = o._reactInternals;
    var g = oo(), $ = Ds(o), _ = ro(g, $);
    _.tag = 1, _.payload = u, d != null && (_.callback = d), Qo(o, _), ql(o, $, g);
  }, enqueueForceUpdate: function(o, u) {
    o = o._reactInternals;
    var d = oo(), g = Ds(o), $ = ro(d, g);
    $.tag = 2, u != null && ($.callback = u), Qo(o, $), ql(o, g, d);
  } };
  function Iu(o, u, d, g, $, _, I) {
    return o = o.stateNode, typeof o.shouldComponentUpdate == "function" ? o.shouldComponentUpdate(g, _, I) : u.prototype && u.prototype.isPureReactComponent ? !Cu(d, g) || !Cu($, _) : !0;
  }
  function tl(o, u, d) {
    var g = !1, $ = ws, _ = u.contextType;
    return typeof _ == "object" && _ !== null ? _ = xi(_) : ($ = ya(u) ? Ps : er.current, g = u.contextTypes, _ = (g = g != null) ? En(o, $) : ws), u = new u(d, _), o.memoizedState = u.state !== null && u.state !== void 0 ? u.state : null, u.updater = Ll, o.stateNode = u, u._reactInternals = o, g && (o = o.stateNode, o.__reactInternalMemoizedUnmaskedChildContext = $, o.__reactInternalMemoizedMaskedChildContext = _), u;
  }
  function Fc(o, u, d, g) {
    o = u.state, typeof u.componentWillReceiveProps == "function" && u.componentWillReceiveProps(d, g), typeof u.UNSAFE_componentWillReceiveProps == "function" && u.UNSAFE_componentWillReceiveProps(d, g), u.state !== o && Ll.enqueueReplaceState(u, u.state, null);
  }
  function Fu(o, u, d, g) {
    var $ = o.stateNode;
    $.props = d, $.state = o.memoizedState, $.refs = zl, sf(o);
    var _ = u.contextType;
    typeof _ == "object" && _ !== null ? $.context = xi(_) : (_ = ya(u) ? Ps : er.current, $.context = En(o, _)), Ko(o, d, $, g), $.state = o.memoizedState, _ = u.getDerivedStateFromProps, typeof _ == "function" && (Lu(o, u, _, d), $.state = o.memoizedState), typeof u.getDerivedStateFromProps == "function" || typeof $.getSnapshotBeforeUpdate == "function" || typeof $.UNSAFE_componentWillMount != "function" && typeof $.componentWillMount != "function" || (u = $.state, typeof $.componentWillMount == "function" && $.componentWillMount(), typeof $.UNSAFE_componentWillMount == "function" && $.UNSAFE_componentWillMount(), u !== $.state && Ll.enqueueReplaceState($, $.state, null), Ko(o, d, $, g), $.state = o.memoizedState), typeof $.componentDidMount == "function" && (o.flags |= 4);
  }
  var nl = Array.isArray;
  function Il(o, u, d) {
    if (o = d.ref, o !== null && typeof o != "function" && typeof o != "object") {
      if (d._owner) {
        if (d = d._owner, d) {
          if (d.tag !== 1)
            throw Error(r(309));
          var g = d.stateNode;
        }
        if (!g)
          throw Error(r(147, o));
        var $ = "" + o;
        return u !== null && u.ref !== null && typeof u.ref == "function" && u.ref._stringRef === $ ? u.ref : (u = function(_) {
          var I = g.refs;
          I === zl && (I = g.refs = {}), _ === null ? delete I[$] : I[$] = _;
        }, u._stringRef = $, u);
      }
      if (typeof o != "string")
        throw Error(r(284));
      if (!d._owner)
        throw Error(r(290, o));
    }
    return o;
  }
  function Hu(o, u) {
    if (o.type !== "textarea")
      throw Error(r(31, Object.prototype.toString.call(u) === "[object Object]" ? "object with keys {" + Object.keys(u).join(", ") + "}" : u));
  }
  function uf(o) {
    function u(ge, le) {
      if (o) {
        var fe = ge.lastEffect;
        fe !== null ? (fe.nextEffect = le, ge.lastEffect = le) : ge.firstEffect = ge.lastEffect = le, le.nextEffect = null, le.flags = 8;
      }
    }
    function d(ge, le) {
      if (!o)
        return null;
      for (; le !== null; )
        u(ge, le), le = le.sibling;
      return null;
    }
    function g(ge, le) {
      for (ge = /* @__PURE__ */ new Map(); le !== null; )
        le.key !== null ? ge.set(le.key, le) : ge.set(le.index, le), le = le.sibling;
      return ge;
    }
    function $(ge, le) {
      return ge = Kl(ge, le), ge.index = 0, ge.sibling = null, ge;
    }
    function _(ge, le, fe) {
      return ge.index = fe, o ? (fe = ge.alternate, fe !== null ? (fe = fe.index, fe < le ? (ge.flags = 2, le) : fe) : (ge.flags = 2, le)) : le;
    }
    function I(ge) {
      return o && ge.alternate === null && (ge.flags = 2), ge;
    }
    function q(ge, le, fe, Re) {
      return le === null || le.tag !== 6 ? (le = Ep(fe, ge.mode, Re), le.return = ge, le) : (le = $(le, fe), le.return = ge, le);
    }
    function re(ge, le, fe, Re) {
      return le !== null && le.elementType === fe.type ? (Re = $(le, fe.props), Re.ref = Il(ge, le, fe), Re.return = ge, Re) : (Re = xf(fe.type, fe.key, fe.props, null, ge.mode, Re), Re.ref = Il(ge, le, fe), Re.return = ge, Re);
    }
    function Se(ge, le, fe, Re) {
      return le === null || le.tag !== 4 || le.stateNode.containerInfo !== fe.containerInfo || le.stateNode.implementation !== fe.implementation ? (le = Ap(fe, ge.mode, Re), le.return = ge, le) : (le = $(le, fe.children || []), le.return = ge, le);
    }
    function ut(ge, le, fe, Re, je) {
      return le === null || le.tag !== 7 ? (le = Ns(fe, ge.mode, Re, je), le.return = ge, le) : (le = $(le, fe), le.return = ge, le);
    }
    function Xt(ge, le, fe) {
      if (typeof le == "string" || typeof le == "number")
        return le = Ep("" + le, ge.mode, fe), le.return = ge, le;
      if (typeof le == "object" && le !== null) {
        switch (le.$$typeof) {
          case K:
            return fe = xf(le.type, le.key, le.props, null, ge.mode, fe), fe.ref = Il(ge, null, le), fe.return = ge, fe;
          case ce:
            return le = Ap(le, ge.mode, fe), le.return = ge, le;
        }
        if (nl(le) || ht(le))
          return le = Ns(
            le,
            ge.mode,
            fe,
            null
          ), le.return = ge, le;
        Hu(ge, le);
      }
      return null;
    }
    function Ve(ge, le, fe, Re) {
      var je = le !== null ? le.key : null;
      if (typeof fe == "string" || typeof fe == "number")
        return je !== null ? null : q(ge, le, "" + fe, Re);
      if (typeof fe == "object" && fe !== null) {
        switch (fe.$$typeof) {
          case K:
            return fe.key === je ? fe.type === ue ? ut(ge, le, fe.props.children, Re, je) : re(ge, le, fe, Re) : null;
          case ce:
            return fe.key === je ? Se(ge, le, fe, Re) : null;
        }
        if (nl(fe) || ht(fe))
          return je !== null ? null : ut(ge, le, fe, Re, null);
        Hu(ge, fe);
      }
      return null;
    }
    function Mt(ge, le, fe, Re, je) {
      if (typeof Re == "string" || typeof Re == "number")
        return ge = ge.get(fe) || null, q(le, ge, "" + Re, je);
      if (typeof Re == "object" && Re !== null) {
        switch (Re.$$typeof) {
          case K:
            return ge = ge.get(Re.key === null ? fe : Re.key) || null, Re.type === ue ? ut(le, ge, Re.props.children, je, Re.key) : re(le, ge, Re, je);
          case ce:
            return ge = ge.get(Re.key === null ? fe : Re.key) || null, Se(le, ge, Re, je);
        }
        if (nl(Re) || ht(Re))
          return ge = ge.get(fe) || null, ut(le, ge, Re, je, null);
        Hu(le, Re);
      }
      return null;
    }
    function Vt(ge, le, fe, Re) {
      for (var je = null, Kt = null, gt = le, qt = le = 0, tn = null; gt !== null && qt < fe.length; qt++) {
        gt.index > qt ? (tn = gt, gt = null) : tn = gt.sibling;
        var Jt = Ve(ge, gt, fe[qt], Re);
        if (Jt === null) {
          gt === null && (gt = tn);
          break;
        }
        o && gt && Jt.alternate === null && u(ge, gt), le = _(Jt, le, qt), Kt === null ? je = Jt : Kt.sibling = Jt, Kt = Jt, gt = tn;
      }
      if (qt === fe.length)
        return d(ge, gt), je;
      if (gt === null) {
        for (; qt < fe.length; qt++)
          gt = Xt(ge, fe[qt], Re), gt !== null && (le = _(gt, le, qt), Kt === null ? je = gt : Kt.sibling = gt, Kt = gt);
        return je;
      }
      for (gt = g(ge, gt); qt < fe.length; qt++)
        tn = Mt(gt, ge, qt, fe[qt], Re), tn !== null && (o && tn.alternate !== null && gt.delete(tn.key === null ? qt : tn.key), le = _(tn, le, qt), Kt === null ? je = tn : Kt.sibling = tn, Kt = tn);
      return o && gt.forEach(function(Jl) {
        return u(ge, Jl);
      }), je;
    }
    function zt(ge, le, fe, Re) {
      var je = ht(fe);
      if (typeof je != "function")
        throw Error(r(150));
      if (fe = je.call(fe), fe == null)
        throw Error(r(151));
      for (var Kt = je = null, gt = le, qt = le = 0, tn = null, Jt = fe.next(); gt !== null && !Jt.done; qt++, Jt = fe.next()) {
        gt.index > qt ? (tn = gt, gt = null) : tn = gt.sibling;
        var Jl = Ve(ge, gt, Jt.value, Re);
        if (Jl === null) {
          gt === null && (gt = tn);
          break;
        }
        o && gt && Jl.alternate === null && u(ge, gt), le = _(Jl, le, qt), Kt === null ? je = Jl : Kt.sibling = Jl, Kt = Jl, gt = tn;
      }
      if (Jt.done)
        return d(ge, gt), je;
      if (gt === null) {
        for (; !Jt.done; qt++, Jt = fe.next())
          Jt = Xt(ge, Jt.value, Re), Jt !== null && (le = _(Jt, le, qt), Kt === null ? je = Jt : Kt.sibling = Jt, Kt = Jt);
        return je;
      }
      for (gt = g(ge, gt); !Jt.done; qt++, Jt = fe.next())
        Jt = Mt(gt, ge, qt, Jt.value, Re), Jt !== null && (o && Jt.alternate !== null && gt.delete(Jt.key === null ? qt : Jt.key), le = _(Jt, le, qt), Kt === null ? je = Jt : Kt.sibling = Jt, Kt = Jt);
      return o && gt.forEach(function(d0) {
        return u(ge, d0);
      }), je;
    }
    return function(ge, le, fe, Re) {
      var je = typeof fe == "object" && fe !== null && fe.type === ue && fe.key === null;
      je && (fe = fe.props.children);
      var Kt = typeof fe == "object" && fe !== null;
      if (Kt)
        switch (fe.$$typeof) {
          case K:
            e: {
              for (Kt = fe.key, je = le; je !== null; ) {
                if (je.key === Kt) {
                  switch (je.tag) {
                    case 7:
                      if (fe.type === ue) {
                        d(ge, je.sibling), le = $(je, fe.props.children), le.return = ge, ge = le;
                        break e;
                      }
                      break;
                    default:
                      if (je.elementType === fe.type) {
                        d(ge, je.sibling), le = $(je, fe.props), le.ref = Il(ge, je, fe), le.return = ge, ge = le;
                        break e;
                      }
                  }
                  d(ge, je);
                  break;
                } else
                  u(ge, je);
                je = je.sibling;
              }
              fe.type === ue ? (le = Ns(fe.props.children, ge.mode, Re, fe.key), le.return = ge, ge = le) : (Re = xf(fe.type, fe.key, fe.props, null, ge.mode, Re), Re.ref = Il(ge, le, fe), Re.return = ge, ge = Re);
            }
            return I(ge);
          case ce:
            e: {
              for (je = fe.key; le !== null; ) {
                if (le.key === je)
                  if (le.tag === 4 && le.stateNode.containerInfo === fe.containerInfo && le.stateNode.implementation === fe.implementation) {
                    d(ge, le.sibling), le = $(le, fe.children || []), le.return = ge, ge = le;
                    break e;
                  } else {
                    d(ge, le);
                    break;
                  }
                else
                  u(ge, le);
                le = le.sibling;
              }
              le = Ap(fe, ge.mode, Re), le.return = ge, ge = le;
            }
            return I(ge);
        }
      if (typeof fe == "string" || typeof fe == "number")
        return fe = "" + fe, le !== null && le.tag === 6 ? (d(ge, le.sibling), le = $(le, fe), le.return = ge, ge = le) : (d(ge, le), le = Ep(fe, ge.mode, Re), le.return = ge, ge = le), I(ge);
      if (nl(fe))
        return Vt(ge, le, fe, Re);
      if (ht(fe))
        return zt(ge, le, fe, Re);
      if (Kt && Hu(ge, fe), typeof fe > "u" && !je)
        switch (ge.tag) {
          case 1:
          case 22:
          case 0:
          case 11:
          case 15:
            throw Error(r(152, cn(ge.type) || "Component"));
        }
      return d(ge, le);
    };
  }
  var Vu = uf(!0), cf = uf(!1), Jo = {}, ao = Ra(Jo), Bu = Ra(Jo), Uu = Ra(Jo);
  function rl(o) {
    if (o === Jo)
      throw Error(r(174));
    return o;
  }
  function Fl(o, u) {
    switch (Lt(Uu, u), Lt(Bu, o), Lt(ao, Jo), o = u.nodeType, o) {
      case 9:
      case 11:
        u = (u = u.documentElement) ? u.namespaceURI : _t(null, "");
        break;
      default:
        o = o === 8 ? u.parentNode : u, u = o.namespaceURI || null, o = o.tagName, u = _t(u, o);
    }
    Ht(ao), Lt(ao, u);
  }
  function al() {
    Ht(ao), Ht(Bu), Ht(Uu);
  }
  function df(o) {
    rl(Uu.current);
    var u = rl(ao.current), d = _t(u, o.type);
    u !== d && (Lt(Bu, o), Lt(ao, d));
  }
  function Hc(o) {
    Bu.current === o && (Ht(ao), Ht(Bu));
  }
  var Sr = Ra(0);
  function Hl(o) {
    for (var u = o; u !== null; ) {
      if (u.tag === 13) {
        var d = u.memoizedState;
        if (d !== null && (d = d.dehydrated, d === null || d.data === "$?" || d.data === "$!"))
          return u;
      } else if (u.tag === 19 && u.memoizedProps.revealOrder !== void 0) {
        if (u.flags & 64)
          return u;
      } else if (u.child !== null) {
        u.child.return = u, u = u.child;
        continue;
      }
      if (u === o)
        break;
      for (; u.sibling === null; ) {
        if (u.return === null || u.return === o)
          return null;
        u = u.return;
      }
      u.sibling.return = u.return, u = u.sibling;
    }
    return null;
  }
  var ra = null, Vn = null, Eo = !1;
  function ff(o, u) {
    var d = To(5, null, null, 0);
    d.elementType = "DELETED", d.type = "DELETED", d.stateNode = u, d.return = o, d.flags = 8, o.lastEffect !== null ? (o.lastEffect.nextEffect = d, o.lastEffect = d) : o.firstEffect = o.lastEffect = d;
  }
  function mf(o, u) {
    switch (o.tag) {
      case 5:
        var d = o.type;
        return u = u.nodeType !== 1 || d.toLowerCase() !== u.nodeName.toLowerCase() ? null : u, u !== null ? (o.stateNode = u, !0) : !1;
      case 6:
        return u = o.pendingProps === "" || u.nodeType !== 3 ? null : u, u !== null ? (o.stateNode = u, !0) : !1;
      case 13:
        return !1;
      default:
        return !1;
    }
  }
  function Zo(o) {
    if (Eo) {
      var u = Vn;
      if (u) {
        var d = u;
        if (!mf(o, u)) {
          if (u = gs(d.nextSibling), !u || !mf(o, u)) {
            o.flags = o.flags & -1025 | 2, Eo = !1, ra = o;
            return;
          }
          ff(ra, d);
        }
        ra = o, Vn = gs(u.firstChild);
      } else
        o.flags = o.flags & -1025 | 2, Eo = !1, ra = o;
    }
  }
  function Cs(o) {
    for (o = o.return; o !== null && o.tag !== 5 && o.tag !== 3 && o.tag !== 13; )
      o = o.return;
    ra = o;
  }
  function Vl(o) {
    if (o !== ra)
      return !1;
    if (!Eo)
      return Cs(o), Eo = !0, !1;
    var u = o.type;
    if (o.tag !== 5 || u !== "head" && u !== "body" && !Tu(u, o.memoizedProps))
      for (u = Vn; u; )
        ff(o, u), u = gs(u.nextSibling);
    if (Cs(o), o.tag === 13) {
      if (o = o.memoizedState, o = o !== null ? o.dehydrated : null, !o)
        throw Error(r(317));
      e: {
        for (o = o.nextSibling, u = 0; o; ) {
          if (o.nodeType === 8) {
            var d = o.data;
            if (d === "/$") {
              if (u === 0) {
                Vn = gs(o.nextSibling);
                break e;
              }
              u--;
            } else
              d !== "$" && d !== "$!" && d !== "$?" || u++;
          }
          o = o.nextSibling;
        }
        Vn = null;
      }
    } else
      Vn = ra ? gs(o.stateNode.nextSibling) : null;
    return !0;
  }
  function Bl() {
    Vn = ra = null, Eo = !1;
  }
  var Ms = [];
  function Es() {
    for (var o = 0; o < Ms.length; o++)
      Ms[o]._workInProgressVersionPrimary = null;
    Ms.length = 0;
  }
  var il = U.ReactCurrentDispatcher, aa = U.ReactCurrentBatchConfig, Ul = 0, ur = null, qr = null, Yr = null, Xu = !1, io = !1;
  function Pa() {
    throw Error(r(321));
  }
  function Ao(o, u) {
    if (u === null)
      return !1;
    for (var d = 0; d < u.length && d < o.length; d++)
      if (!$i(o[d], u[d]))
        return !1;
    return !0;
  }
  function Vc(o, u, d, g, $, _) {
    if (Ul = _, ur = u, u.memoizedState = null, u.updateQueue = null, u.lanes = 0, il.current = o === null || o.memoizedState === null ? nn : Xe, o = d(g, $), io) {
      _ = 0;
      do {
        if (io = !1, !(25 > _))
          throw Error(r(301));
        _ += 1, Yr = qr = null, u.updateQueue = null, il.current = Ot, o = d(g, $);
      } while (io);
    }
    if (il.current = ka, u = qr !== null && qr.next !== null, Ul = 0, Yr = qr = ur = null, Xu = !1, u)
      throw Error(r(300));
    return o;
  }
  function Te() {
    var o = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Yr === null ? ur.memoizedState = Yr = o : Yr = Yr.next = o, Yr;
  }
  function ln() {
    if (qr === null) {
      var o = ur.alternate;
      o = o !== null ? o.memoizedState : null;
    } else
      o = qr.next;
    var u = Yr === null ? ur.memoizedState : Yr.next;
    if (u !== null)
      Yr = u, qr = o;
    else {
      if (o === null)
        throw Error(r(310));
      qr = o, o = { memoizedState: qr.memoizedState, baseState: qr.baseState, baseQueue: qr.baseQueue, queue: qr.queue, next: null }, Yr === null ? ur.memoizedState = Yr = o : Yr = Yr.next = o;
    }
    return Yr;
  }
  function un(o, u) {
    return typeof u == "function" ? u(o) : u;
  }
  function k(o) {
    var u = ln(), d = u.queue;
    if (d === null)
      throw Error(r(311));
    d.lastRenderedReducer = o;
    var g = qr, $ = g.baseQueue, _ = d.pending;
    if (_ !== null) {
      if ($ !== null) {
        var I = $.next;
        $.next = _.next, _.next = I;
      }
      g.baseQueue = $ = _, d.pending = null;
    }
    if ($ !== null) {
      $ = $.next, g = g.baseState;
      var q = I = _ = null, re = $;
      do {
        var Se = re.lane;
        if ((Ul & Se) === Se)
          q !== null && (q = q.next = { lane: 0, action: re.action, eagerReducer: re.eagerReducer, eagerState: re.eagerState, next: null }), g = re.eagerReducer === o ? re.eagerState : o(g, re.action);
        else {
          var ut = {
            lane: Se,
            action: re.action,
            eagerReducer: re.eagerReducer,
            eagerState: re.eagerState,
            next: null
          };
          q === null ? (I = q = ut, _ = g) : q = q.next = ut, ur.lanes |= Se, Yu |= Se;
        }
        re = re.next;
      } while (re !== null && re !== $);
      q === null ? _ = g : q.next = I, $i(g, u.memoizedState) || (Rt = !0), u.memoizedState = g, u.baseState = _, u.baseQueue = q, d.lastRenderedState = g;
    }
    return [u.memoizedState, d.dispatch];
  }
  function C(o) {
    var u = ln(), d = u.queue;
    if (d === null)
      throw Error(r(311));
    d.lastRenderedReducer = o;
    var g = d.dispatch, $ = d.pending, _ = u.memoizedState;
    if ($ !== null) {
      d.pending = null;
      var I = $ = $.next;
      do
        _ = o(_, I.action), I = I.next;
      while (I !== $);
      $i(_, u.memoizedState) || (Rt = !0), u.memoizedState = _, u.baseQueue === null && (u.baseState = _), d.lastRenderedState = _;
    }
    return [_, g];
  }
  function W(o, u, d) {
    var g = u._getVersion;
    g = g(u._source);
    var $ = u._workInProgressVersionPrimary;
    if ($ !== null ? o = $ === g : (o = o.mutableReadLanes, (o = (Ul & o) === o) && (u._workInProgressVersionPrimary = g, Ms.push(u))), o)
      return d(u._source);
    throw Ms.push(u), Error(r(350));
  }
  function Y(o, u, d, g) {
    var $ = Mi;
    if ($ === null)
      throw Error(r(349));
    var _ = u._getVersion, I = _(u._source), q = il.current, re = q.useState(function() {
      return W($, u, d);
    }), Se = re[1], ut = re[0];
    re = Yr;
    var Xt = o.memoizedState, Ve = Xt.refs, Mt = Ve.getSnapshot, Vt = Xt.source;
    Xt = Xt.subscribe;
    var zt = ur;
    return o.memoizedState = { refs: Ve, source: u, subscribe: g }, q.useEffect(function() {
      Ve.getSnapshot = d, Ve.setSnapshot = Se;
      var ge = _(u._source);
      if (!$i(I, ge)) {
        ge = d(u._source), $i(ut, ge) || (Se(ge), ge = Ds(zt), $.mutableReadLanes |= ge & $.pendingLanes), ge = $.mutableReadLanes, $.entangledLanes |= ge;
        for (var le = $.entanglements, fe = ge; 0 < fe; ) {
          var Re = 31 - ve(fe), je = 1 << Re;
          le[Re] |= ge, fe &= ~je;
        }
      }
    }, [d, u, g]), q.useEffect(function() {
      return g(u._source, function() {
        var ge = Ve.getSnapshot, le = Ve.setSnapshot;
        try {
          le(ge(u._source));
          var fe = Ds(zt);
          $.mutableReadLanes |= fe & $.pendingLanes;
        } catch (Re) {
          le(function() {
            throw Re;
          });
        }
      });
    }, [u, g]), $i(Mt, d) && $i(Vt, u) && $i(Xt, g) || (o = { pending: null, dispatch: null, lastRenderedReducer: un, lastRenderedState: ut }, o.dispatch = Se = zr.bind(null, ur, o), re.queue = o, re.baseQueue = null, ut = W($, u, d), re.memoizedState = re.baseState = ut), ut;
  }
  function ne(o, u, d) {
    var g = ln();
    return Y(g, o, u, d);
  }
  function se(o) {
    var u = Te();
    return typeof o == "function" && (o = o()), u.memoizedState = u.baseState = o, o = u.queue = { pending: null, dispatch: null, lastRenderedReducer: un, lastRenderedState: o }, o = o.dispatch = zr.bind(null, ur, o), [u.memoizedState, o];
  }
  function te(o, u, d, g) {
    return o = { tag: o, create: u, destroy: d, deps: g, next: null }, u = ur.updateQueue, u === null ? (u = { lastEffect: null }, ur.updateQueue = u, u.lastEffect = o.next = o) : (d = u.lastEffect, d === null ? u.lastEffect = o.next = o : (g = d.next, d.next = o, o.next = g, u.lastEffect = o)), o;
  }
  function me(o) {
    var u = Te();
    return o = { current: o }, u.memoizedState = o;
  }
  function he() {
    return ln().memoizedState;
  }
  function Me(o, u, d, g) {
    var $ = Te();
    ur.flags |= o, $.memoizedState = te(1 | u, d, void 0, g === void 0 ? null : g);
  }
  function We(o, u, d, g) {
    var $ = ln();
    g = g === void 0 ? null : g;
    var _ = void 0;
    if (qr !== null) {
      var I = qr.memoizedState;
      if (_ = I.destroy, g !== null && Ao(g, I.deps)) {
        te(u, d, _, g);
        return;
      }
    }
    ur.flags |= o, $.memoizedState = te(1 | u, d, _, g);
  }
  function it(o, u) {
    return Me(516, 4, o, u);
  }
  function He(o, u) {
    return We(516, 4, o, u);
  }
  function pt(o, u) {
    return We(4, 2, o, u);
  }
  function lt(o, u) {
    if (typeof u == "function")
      return o = o(), u(o), function() {
        u(null);
      };
    if (u != null)
      return o = o(), u.current = o, function() {
        u.current = null;
      };
  }
  function jt(o, u, d) {
    return d = d != null ? d.concat([o]) : null, We(4, 2, lt.bind(null, u, o), d);
  }
  function St() {
  }
  function gn(o, u) {
    var d = ln();
    u = u === void 0 ? null : u;
    var g = d.memoizedState;
    return g !== null && u !== null && Ao(u, g[1]) ? g[0] : (d.memoizedState = [o, u], o);
  }
  function Ct(o, u) {
    var d = ln();
    u = u === void 0 ? null : u;
    var g = d.memoizedState;
    return g !== null && u !== null && Ao(u, g[1]) ? g[0] : (o = o(), d.memoizedState = [o, u], o);
  }
  function xr(o, u) {
    var d = jl();
    wa(98 > d ? 98 : d, function() {
      o(!0);
    }), wa(97 < d ? 97 : d, function() {
      var g = aa.transition;
      aa.transition = 1;
      try {
        o(!1), u();
      } finally {
        aa.transition = g;
      }
    });
  }
  function zr(o, u, d) {
    var g = oo(), $ = Ds(o), _ = { lane: $, action: d, eagerReducer: null, eagerState: null, next: null }, I = u.pending;
    if (I === null ? _.next = _ : (_.next = I.next, I.next = _), u.pending = _, I = o.alternate, o === ur || I !== null && I === ur)
      io = Xu = !0;
    else {
      if (o.lanes === 0 && (I === null || I.lanes === 0) && (I = u.lastRenderedReducer, I !== null))
        try {
          var q = u.lastRenderedState, re = I(q, d);
          if (_.eagerReducer = I, _.eagerState = re, $i(re, q))
            return;
        } catch {
        } finally {
        }
      ql(o, $, g);
    }
  }
  var ka = { readContext: xi, useCallback: Pa, useContext: Pa, useEffect: Pa, useImperativeHandle: Pa, useLayoutEffect: Pa, useMemo: Pa, useReducer: Pa, useRef: Pa, useState: Pa, useDebugValue: Pa, useDeferredValue: Pa, useTransition: Pa, useMutableSource: Pa, useOpaqueIdentifier: Pa, unstable_isNewReconciler: !1 }, nn = { readContext: xi, useCallback: function(o, u) {
    return Te().memoizedState = [o, u === void 0 ? null : u], o;
  }, useContext: xi, useEffect: it, useImperativeHandle: function(o, u, d) {
    return d = d != null ? d.concat([o]) : null, Me(4, 2, lt.bind(
      null,
      u,
      o
    ), d);
  }, useLayoutEffect: function(o, u) {
    return Me(4, 2, o, u);
  }, useMemo: function(o, u) {
    var d = Te();
    return u = u === void 0 ? null : u, o = o(), d.memoizedState = [o, u], o;
  }, useReducer: function(o, u, d) {
    var g = Te();
    return u = d !== void 0 ? d(u) : u, g.memoizedState = g.baseState = u, o = g.queue = { pending: null, dispatch: null, lastRenderedReducer: o, lastRenderedState: u }, o = o.dispatch = zr.bind(null, ur, o), [g.memoizedState, o];
  }, useRef: me, useState: se, useDebugValue: St, useDeferredValue: function(o) {
    var u = se(o), d = u[0], g = u[1];
    return it(function() {
      var $ = aa.transition;
      aa.transition = 1;
      try {
        g(o);
      } finally {
        aa.transition = $;
      }
    }, [o]), d;
  }, useTransition: function() {
    var o = se(!1), u = o[0];
    return o = xr.bind(null, o[1]), me(o), [o, u];
  }, useMutableSource: function(o, u, d) {
    var g = Te();
    return g.memoizedState = { refs: { getSnapshot: u, setSnapshot: null }, source: o, subscribe: d }, Y(g, o, u, d);
  }, useOpaqueIdentifier: function() {
    if (Eo) {
      var o = !1, u = Nc(function() {
        throw o || (o = !0, d("r:" + (ys++).toString(36))), Error(r(355));
      }), d = se(u)[1];
      return !(ur.mode & 2) && (ur.flags |= 516, te(
        5,
        function() {
          d("r:" + (ys++).toString(36));
        },
        void 0,
        null
      )), u;
    }
    return u = "r:" + (ys++).toString(36), se(u), u;
  }, unstable_isNewReconciler: !1 }, Xe = { readContext: xi, useCallback: gn, useContext: xi, useEffect: He, useImperativeHandle: jt, useLayoutEffect: pt, useMemo: Ct, useReducer: k, useRef: he, useState: function() {
    return k(un);
  }, useDebugValue: St, useDeferredValue: function(o) {
    var u = k(un), d = u[0], g = u[1];
    return He(function() {
      var $ = aa.transition;
      aa.transition = 1;
      try {
        g(o);
      } finally {
        aa.transition = $;
      }
    }, [o]), d;
  }, useTransition: function() {
    var o = k(un)[0];
    return [
      he().current,
      o
    ];
  }, useMutableSource: ne, useOpaqueIdentifier: function() {
    return k(un)[0];
  }, unstable_isNewReconciler: !1 }, Ot = { readContext: xi, useCallback: gn, useContext: xi, useEffect: He, useImperativeHandle: jt, useLayoutEffect: pt, useMemo: Ct, useReducer: C, useRef: he, useState: function() {
    return C(un);
  }, useDebugValue: St, useDeferredValue: function(o) {
    var u = C(un), d = u[0], g = u[1];
    return He(function() {
      var $ = aa.transition;
      aa.transition = 1;
      try {
        g(o);
      } finally {
        aa.transition = $;
      }
    }, [o]), d;
  }, useTransition: function() {
    var o = C(un)[0];
    return [
      he().current,
      o
    ];
  }, useMutableSource: ne, useOpaqueIdentifier: function() {
    return C(un)[0];
  }, unstable_isNewReconciler: !1 }, on = U.ReactCurrentOwner, Rt = !1;
  function An(o, u, d, g) {
    u.child = o === null ? cf(u, null, d, g) : Vu(u, o.child, d, g);
  }
  function Bn(o, u, d, g, $) {
    d = d.render;
    var _ = u.ref;
    return ui(u, $), g = Vc(o, u, d, g, _, $), o !== null && !Rt ? (u.updateQueue = o.updateQueue, u.flags &= -517, o.lanes &= ~$, sl(o, u, $)) : (u.flags |= 1, An(o, u, g, $), u.child);
  }
  function fn(o, u, d, g, $, _) {
    if (o === null) {
      var I = d.type;
      return typeof I == "function" && !Qm(I) && I.defaultProps === void 0 && d.compare === null && d.defaultProps === void 0 ? (u.tag = 15, u.type = I, xn(o, u, I, g, $, _)) : (o = xf(d.type, null, g, u, u.mode, _), o.ref = u.ref, o.return = u, u.child = o);
    }
    return I = o.child, !($ & _) && ($ = I.memoizedProps, d = d.compare, d = d !== null ? d : Cu, d($, g) && o.ref === u.ref) ? sl(o, u, _) : (u.flags |= 1, o = Kl(I, g), o.ref = u.ref, o.return = u, u.child = o);
  }
  function xn(o, u, d, g, $, _) {
    if (o !== null && Cu(o.memoizedProps, g) && o.ref === u.ref)
      if (Rt = !1, (_ & $) !== 0)
        o.flags & 16384 && (Rt = !0);
      else
        return u.lanes = o.lanes, sl(o, u, _);
    return Ci(o, u, d, g, _);
  }
  function mn(o, u, d) {
    var g = u.pendingProps, $ = g.children, _ = o !== null ? o.memoizedState : null;
    if (g.mode === "hidden" || g.mode === "unstable-defer-without-hiding")
      if (!(u.mode & 4))
        u.memoizedState = { baseLanes: 0 }, Ym(u, d);
      else if (d & 1073741824)
        u.memoizedState = { baseLanes: 0 }, Ym(u, _ !== null ? _.baseLanes : d);
      else
        return o = _ !== null ? _.baseLanes | d : d, u.lanes = u.childLanes = 1073741824, u.memoizedState = { baseLanes: o }, Ym(u, o), null;
    else
      _ !== null ? (g = _.baseLanes | d, u.memoizedState = null) : g = d, Ym(u, g);
    return An(o, u, $, d), u.child;
  }
  function _n(o, u) {
    var d = u.ref;
    (o === null && d !== null || o !== null && o.ref !== d) && (u.flags |= 128);
  }
  function Ci(o, u, d, g, $) {
    var _ = ya(d) ? Ps : er.current;
    return _ = En(u, _), ui(u, $), d = Vc(o, u, d, g, _, $), o !== null && !Rt ? (u.updateQueue = o.updateQueue, u.flags &= -517, o.lanes &= ~$, sl(o, u, $)) : (u.flags |= 1, An(o, u, d, $), u.child);
  }
  function es(o, u, d, g, $) {
    if (ya(d)) {
      var _ = !0;
      Si(u);
    } else
      _ = !1;
    if (ui(u, $), u.stateNode === null)
      o !== null && (o.alternate = null, u.alternate = null, u.flags |= 2), tl(u, d, g), Fu(u, d, g, $), g = !0;
    else if (o === null) {
      var I = u.stateNode, q = u.memoizedProps;
      I.props = q;
      var re = I.context, Se = d.contextType;
      typeof Se == "object" && Se !== null ? Se = xi(Se) : (Se = ya(d) ? Ps : er.current, Se = En(u, Se));
      var ut = d.getDerivedStateFromProps, Xt = typeof ut == "function" || typeof I.getSnapshotBeforeUpdate == "function";
      Xt || typeof I.UNSAFE_componentWillReceiveProps != "function" && typeof I.componentWillReceiveProps != "function" || (q !== g || re !== Se) && Fc(u, I, g, Se), Li = !1;
      var Ve = u.memoizedState;
      I.state = Ve, Ko(u, g, I, $), re = u.memoizedState, q !== g || Ve !== re || kr.current || Li ? (typeof ut == "function" && (Lu(u, d, ut, g), re = u.memoizedState), (q = Li || Iu(u, d, q, g, Ve, re, Se)) ? (Xt || typeof I.UNSAFE_componentWillMount != "function" && typeof I.componentWillMount != "function" || (typeof I.componentWillMount == "function" && I.componentWillMount(), typeof I.UNSAFE_componentWillMount == "function" && I.UNSAFE_componentWillMount()), typeof I.componentDidMount == "function" && (u.flags |= 4)) : (typeof I.componentDidMount == "function" && (u.flags |= 4), u.memoizedProps = g, u.memoizedState = re), I.props = g, I.state = re, I.context = Se, g = q) : (typeof I.componentDidMount == "function" && (u.flags |= 4), g = !1);
    } else {
      I = u.stateNode, Im(o, u), q = u.memoizedProps, Se = u.type === u.elementType ? q : $r(u.type, q), I.props = Se, Xt = u.pendingProps, Ve = I.context, re = d.contextType, typeof re == "object" && re !== null ? re = xi(re) : (re = ya(d) ? Ps : er.current, re = En(u, re));
      var Mt = d.getDerivedStateFromProps;
      (ut = typeof Mt == "function" || typeof I.getSnapshotBeforeUpdate == "function") || typeof I.UNSAFE_componentWillReceiveProps != "function" && typeof I.componentWillReceiveProps != "function" || (q !== Xt || Ve !== re) && Fc(u, I, g, re), Li = !1, Ve = u.memoizedState, I.state = Ve, Ko(u, g, I, $);
      var Vt = u.memoizedState;
      q !== Xt || Ve !== Vt || kr.current || Li ? (typeof Mt == "function" && (Lu(u, d, Mt, g), Vt = u.memoizedState), (Se = Li || Iu(u, d, Se, g, Ve, Vt, re)) ? (ut || typeof I.UNSAFE_componentWillUpdate != "function" && typeof I.componentWillUpdate != "function" || (typeof I.componentWillUpdate == "function" && I.componentWillUpdate(
        g,
        Vt,
        re
      ), typeof I.UNSAFE_componentWillUpdate == "function" && I.UNSAFE_componentWillUpdate(g, Vt, re)), typeof I.componentDidUpdate == "function" && (u.flags |= 4), typeof I.getSnapshotBeforeUpdate == "function" && (u.flags |= 256)) : (typeof I.componentDidUpdate != "function" || q === o.memoizedProps && Ve === o.memoizedState || (u.flags |= 4), typeof I.getSnapshotBeforeUpdate != "function" || q === o.memoizedProps && Ve === o.memoizedState || (u.flags |= 256), u.memoizedProps = g, u.memoizedState = Vt), I.props = g, I.state = Vt, I.context = re, g = Se) : (typeof I.componentDidUpdate != "function" || q === o.memoizedProps && Ve === o.memoizedState || (u.flags |= 4), typeof I.getSnapshotBeforeUpdate != "function" || q === o.memoizedProps && Ve === o.memoizedState || (u.flags |= 256), g = !1);
    }
    return _o(o, u, d, g, _, $);
  }
  function _o(o, u, d, g, $, _) {
    _n(o, u);
    var I = (u.flags & 64) !== 0;
    if (!g && !I)
      return $ && jm(u, d, !1), sl(o, u, _);
    g = u.stateNode, on.current = u;
    var q = I && typeof d.getDerivedStateFromError != "function" ? null : g.render();
    return u.flags |= 1, o !== null && I ? (u.child = Vu(u, o.child, null, _), u.child = Vu(u, null, q, _)) : An(o, u, q, _), u.memoizedState = g.state, $ && jm(u, d, !0), u.child;
  }
  function ol(o) {
    var u = o.stateNode;
    u.pendingContext ? eo(o, u.pendingContext, u.pendingContext !== u.context) : u.context && eo(o, u.context, !1), Fl(o, u.containerInfo);
  }
  var hr = { dehydrated: null, retryLane: 0 };
  function Da(o, u, d) {
    var g = u.pendingProps, $ = Sr.current, _ = !1, I;
    return (I = (u.flags & 64) !== 0) || (I = o !== null && o.memoizedState === null ? !1 : ($ & 2) !== 0), I ? (_ = !0, u.flags &= -65) : o !== null && o.memoizedState === null || g.fallback === void 0 || g.unstable_avoidThisFallback === !0 || ($ |= 1), Lt(Sr, $ & 1), o === null ? (g.fallback !== void 0 && Zo(u), o = g.children, $ = g.fallback, _ ? (o = As(u, o, $, d), u.child.memoizedState = { baseLanes: d }, u.memoizedState = hr, o) : typeof g.unstable_expectedLoadTime == "number" ? (o = As(u, o, $, d), u.child.memoizedState = { baseLanes: d }, u.memoizedState = hr, u.lanes = 33554432, o) : (d = Zu({ mode: "visible", children: o }, u.mode, d, null), d.return = u, u.child = d)) : o.memoizedState !== null ? _ ? (g = ci(o, u, g.children, g.fallback, d), _ = u.child, $ = o.child.memoizedState, _.memoizedState = $ === null ? { baseLanes: d } : { baseLanes: $.baseLanes | d }, _.childLanes = o.childLanes & ~d, u.memoizedState = hr, g) : (d = Tr(o, u, g.children, d), u.memoizedState = null, d) : _ ? (g = ci(o, u, g.children, g.fallback, d), _ = u.child, $ = o.child.memoizedState, _.memoizedState = $ === null ? { baseLanes: d } : { baseLanes: $.baseLanes | d }, _.childLanes = o.childLanes & ~d, u.memoizedState = hr, g) : (d = Tr(o, u, g.children, d), u.memoizedState = null, d);
  }
  function As(o, u, d, g) {
    var $ = o.mode, _ = o.child;
    return u = { mode: "hidden", children: u }, !($ & 2) && _ !== null ? (_.childLanes = 0, _.pendingProps = u) : _ = Zu(u, $, 0, null), d = Ns(d, $, g, null), _.return = o, d.return = o, _.sibling = d, o.child = _, d;
  }
  function Tr(o, u, d, g) {
    var $ = o.child;
    return o = $.sibling, d = Kl($, { mode: "visible", children: d }), !(u.mode & 2) && (d.lanes = g), d.return = u, d.sibling = null, o !== null && (o.nextEffect = null, o.flags = 8, u.firstEffect = u.lastEffect = o), u.child = d;
  }
  function ci(o, u, d, g, $) {
    var _ = u.mode, I = o.child;
    o = I.sibling;
    var q = { mode: "hidden", children: d };
    return !(_ & 2) && u.child !== I ? (d = u.child, d.childLanes = 0, d.pendingProps = q, I = d.lastEffect, I !== null ? (u.firstEffect = d.firstEffect, u.lastEffect = I, I.nextEffect = null) : u.firstEffect = u.lastEffect = null) : d = Kl(I, q), o !== null ? g = Kl(o, g) : (g = Ns(g, _, $, null), g.flags |= 2), g.return = u, d.return = u, d.sibling = g, u.child = d, g;
  }
  function bn(o, u) {
    o.lanes |= u;
    var d = o.alternate;
    d !== null && (d.lanes |= u), Mo(o.return, u);
  }
  function _s(o, u, d, g, $, _) {
    var I = o.memoizedState;
    I === null ? o.memoizedState = { isBackwards: u, rendering: null, renderingStartTime: 0, last: g, tail: d, tailMode: $, lastEffect: _ } : (I.isBackwards = u, I.rendering = null, I.renderingStartTime = 0, I.last = g, I.tail = d, I.tailMode = $, I.lastEffect = _);
  }
  function Gw(o, u, d) {
    var g = u.pendingProps, $ = g.revealOrder, _ = g.tail;
    if (An(o, u, g.children, d), g = Sr.current, g & 2)
      g = g & 1 | 2, u.flags |= 64;
    else {
      if (o !== null && o.flags & 64)
        e:
          for (o = u.child; o !== null; ) {
            if (o.tag === 13)
              o.memoizedState !== null && bn(o, d);
            else if (o.tag === 19)
              bn(o, d);
            else if (o.child !== null) {
              o.child.return = o, o = o.child;
              continue;
            }
            if (o === u)
              break e;
            for (; o.sibling === null; ) {
              if (o.return === null || o.return === u)
                break e;
              o = o.return;
            }
            o.sibling.return = o.return, o = o.sibling;
          }
      g &= 1;
    }
    if (Lt(Sr, g), !(u.mode & 2))
      u.memoizedState = null;
    else
      switch ($) {
        case "forwards":
          for (d = u.child, $ = null; d !== null; )
            o = d.alternate, o !== null && Hl(o) === null && ($ = d), d = d.sibling;
          d = $, d === null ? ($ = u.child, u.child = null) : ($ = d.sibling, d.sibling = null), _s(u, !1, $, d, _, u.lastEffect);
          break;
        case "backwards":
          for (d = null, $ = u.child, u.child = null; $ !== null; ) {
            if (o = $.alternate, o !== null && Hl(o) === null) {
              u.child = $;
              break;
            }
            o = $.sibling, $.sibling = d, d = $, $ = o;
          }
          _s(u, !0, d, null, _, u.lastEffect);
          break;
        case "together":
          _s(u, !1, null, null, void 0, u.lastEffect);
          break;
        default:
          u.memoizedState = null;
      }
    return u.child;
  }
  function sl(o, u, d) {
    if (o !== null && (u.dependencies = o.dependencies), Yu |= u.lanes, d & u.childLanes) {
      if (o !== null && u.child !== o.child)
        throw Error(r(153));
      if (u.child !== null) {
        for (o = u.child, d = Kl(o, o.pendingProps), u.child = d, d.return = u; o.sibling !== null; )
          o = o.sibling, d = d.sibling = Kl(o, o.pendingProps), d.return = u;
        d.sibling = null;
      }
      return u.child;
    }
    return null;
  }
  var Hm, Bc, Pg, mp;
  Hm = function(o, u) {
    for (var d = u.child; d !== null; ) {
      if (d.tag === 5 || d.tag === 6)
        o.appendChild(d.stateNode);
      else if (d.tag !== 4 && d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === u)
        break;
      for (; d.sibling === null; ) {
        if (d.return === null || d.return === u)
          return;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
  }, Bc = function() {
  }, Pg = function(o, u, d, g) {
    var $ = o.memoizedProps;
    if ($ !== g) {
      o = u.stateNode, rl(ao.current);
      var _ = null;
      switch (d) {
        case "input":
          $ = gr(o, $), g = gr(o, g), _ = [];
          break;
        case "option":
          $ = Hr(o, $), g = Hr(o, g), _ = [];
          break;
        case "select":
          $ = t({}, $, { value: void 0 }), g = t({}, g, { value: void 0 }), _ = [];
          break;
        case "textarea":
          $ = Nn(o, $), g = Nn(o, g), _ = [];
          break;
        default:
          typeof $.onClick != "function" && typeof g.onClick == "function" && (o.onclick = Ou);
      }
      Ar(d, g);
      var I;
      d = null;
      for (Se in $)
        if (!g.hasOwnProperty(Se) && $.hasOwnProperty(Se) && $[Se] != null)
          if (Se === "style") {
            var q = $[Se];
            for (I in q)
              q.hasOwnProperty(I) && (d || (d = {}), d[I] = "");
          } else
            Se !== "dangerouslySetInnerHTML" && Se !== "children" && Se !== "suppressContentEditableWarning" && Se !== "suppressHydrationWarning" && Se !== "autoFocus" && (f.hasOwnProperty(Se) ? _ || (_ = []) : (_ = _ || []).push(Se, null));
      for (Se in g) {
        var re = g[Se];
        if (q = $ != null ? $[Se] : void 0, g.hasOwnProperty(Se) && re !== q && (re != null || q != null))
          if (Se === "style")
            if (q) {
              for (I in q)
                !q.hasOwnProperty(I) || re && re.hasOwnProperty(I) || (d || (d = {}), d[I] = "");
              for (I in re)
                re.hasOwnProperty(I) && q[I] !== re[I] && (d || (d = {}), d[I] = re[I]);
            } else
              d || (_ || (_ = []), _.push(Se, d)), d = re;
          else
            Se === "dangerouslySetInnerHTML" ? (re = re ? re.__html : void 0, q = q ? q.__html : void 0, re != null && q !== re && (_ = _ || []).push(Se, re)) : Se === "children" ? typeof re != "string" && typeof re != "number" || (_ = _ || []).push(Se, "" + re) : Se !== "suppressContentEditableWarning" && Se !== "suppressHydrationWarning" && (f.hasOwnProperty(Se) ? (re != null && Se === "onScroll" && Zn("scroll", o), _ || q === re || (_ = [])) : typeof re == "object" && re !== null && re.$$typeof === Ye ? re.toString() : (_ = _ || []).push(Se, re));
      }
      d && (_ = _ || []).push(
        "style",
        d
      );
      var Se = _;
      (u.updateQueue = Se) && (u.flags |= 4);
    }
  }, mp = function(o, u, d, g) {
    d !== g && (u.flags |= 4);
  };
  function hf(o, u) {
    if (!Eo)
      switch (o.tailMode) {
        case "hidden":
          u = o.tail;
          for (var d = null; u !== null; )
            u.alternate !== null && (d = u), u = u.sibling;
          d === null ? o.tail = null : d.sibling = null;
          break;
        case "collapsed":
          d = o.tail;
          for (var g = null; d !== null; )
            d.alternate !== null && (g = d), d = d.sibling;
          g === null ? u || o.tail === null ? o.tail = null : o.tail.sibling = null : g.sibling = null;
      }
  }
  function Qw(o, u, d) {
    var g = u.pendingProps;
    switch (u.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return null;
      case 1:
        return ya(u.type) && Zi(), null;
      case 3:
        return al(), Ht(kr), Ht(er), Es(), g = u.stateNode, g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null), (o === null || o.child === null) && (Vl(u) ? u.flags |= 4 : g.hydrate || (u.flags |= 256)), Bc(u), null;
      case 5:
        Hc(u);
        var $ = rl(Uu.current);
        if (d = u.type, o !== null && u.stateNode != null)
          Pg(o, u, d, g, $), o.ref !== u.ref && (u.flags |= 128);
        else {
          if (!g) {
            if (u.stateNode === null)
              throw Error(r(166));
            return null;
          }
          if (o = rl(ao.current), Vl(u)) {
            g = u.stateNode, d = u.type;
            var _ = u.memoizedProps;
            switch (g[Pr] = u, g[Ru] = _, d) {
              case "dialog":
                Zn("cancel", g), Zn("close", g);
                break;
              case "iframe":
              case "object":
              case "embed":
                Zn("load", g);
                break;
              case "video":
              case "audio":
                for (o = 0; o < Tl.length; o++)
                  Zn(Tl[o], g);
                break;
              case "source":
                Zn("error", g);
                break;
              case "img":
              case "image":
              case "link":
                Zn("error", g), Zn("load", g);
                break;
              case "details":
                Zn("toggle", g);
                break;
              case "input":
                qi(g, _), Zn("invalid", g);
                break;
              case "select":
                g._wrapperState = { wasMultiple: !!_.multiple }, Zn("invalid", g);
                break;
              case "textarea":
                Ca(g, _), Zn("invalid", g);
            }
            Ar(d, _), o = null;
            for (var I in _)
              _.hasOwnProperty(I) && ($ = _[I], I === "children" ? typeof $ == "string" ? g.textContent !== $ && (o = ["children", $]) : typeof $ == "number" && g.textContent !== "" + $ && (o = ["children", "" + $]) : f.hasOwnProperty(I) && $ != null && I === "onScroll" && Zn("scroll", g));
            switch (d) {
              case "input":
                en(g), xa(g, _, !0);
                break;
              case "textarea":
                en(g), Fa(g);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof _.onClick == "function" && (g.onclick = Ou);
            }
            g = o, u.updateQueue = g, g !== null && (u.flags |= 4);
          } else {
            switch (I = $.nodeType === 9 ? $ : $.ownerDocument, o === et.html && (o = ft(d)), o === et.html ? d === "script" ? (o = I.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild)) : typeof g.is == "string" ? o = I.createElement(d, { is: g.is }) : (o = I.createElement(d), d === "select" && (I = o, g.multiple ? I.multiple = !0 : g.size && (I.size = g.size))) : o = I.createElementNS(o, d), o[Pr] = u, o[Ru] = g, Hm(o, u, !1, !1), u.stateNode = o, I = Oi(d, g), d) {
              case "dialog":
                Zn("cancel", o), Zn("close", o), $ = g;
                break;
              case "iframe":
              case "object":
              case "embed":
                Zn("load", o), $ = g;
                break;
              case "video":
              case "audio":
                for ($ = 0; $ < Tl.length; $++)
                  Zn(Tl[$], o);
                $ = g;
                break;
              case "source":
                Zn("error", o), $ = g;
                break;
              case "img":
              case "image":
              case "link":
                Zn("error", o), Zn("load", o), $ = g;
                break;
              case "details":
                Zn("toggle", o), $ = g;
                break;
              case "input":
                qi(o, g), $ = gr(o, g), Zn("invalid", o);
                break;
              case "option":
                $ = Hr(o, g);
                break;
              case "select":
                o._wrapperState = { wasMultiple: !!g.multiple }, $ = t({}, g, { value: void 0 }), Zn("invalid", o);
                break;
              case "textarea":
                Ca(o, g), $ = Nn(o, g), Zn("invalid", o);
                break;
              default:
                $ = g;
            }
            Ar(d, $);
            var q = $;
            for (_ in q)
              if (q.hasOwnProperty(_)) {
                var re = q[_];
                _ === "style" ? Vr(o, re) : _ === "dangerouslySetInnerHTML" ? (re = re ? re.__html : void 0, re != null && ir(o, re)) : _ === "children" ? typeof re == "string" ? (d !== "textarea" || re !== "") && pn(o, re) : typeof re == "number" && pn(o, "" + re) : _ !== "suppressContentEditableWarning" && _ !== "suppressHydrationWarning" && _ !== "autoFocus" && (f.hasOwnProperty(_) ? re != null && _ === "onScroll" && Zn("scroll", o) : re != null && X(o, _, re, I));
              }
            switch (d) {
              case "input":
                en(o), xa(o, g, !1);
                break;
              case "textarea":
                en(o), Fa(o);
                break;
              case "option":
                g.value != null && o.setAttribute("value", "" + Ge(g.value));
                break;
              case "select":
                o.multiple = !!g.multiple, _ = g.value, _ != null ? Dn(o, !!g.multiple, _, !1) : g.defaultValue != null && Dn(o, !!g.multiple, g.defaultValue, !0);
                break;
              default:
                typeof $.onClick == "function" && (o.onclick = Ou);
            }
            Wi(d, g) && (u.flags |= 4);
          }
          u.ref !== null && (u.flags |= 128);
        }
        return null;
      case 6:
        if (o && u.stateNode != null)
          mp(o, u, o.memoizedProps, g);
        else {
          if (typeof g != "string" && u.stateNode === null)
            throw Error(r(166));
          d = rl(Uu.current), rl(ao.current), Vl(u) ? (g = u.stateNode, d = u.memoizedProps, g[Pr] = u, g.nodeValue !== d && (u.flags |= 4)) : (g = (d.nodeType === 9 ? d : d.ownerDocument).createTextNode(g), g[Pr] = u, u.stateNode = g);
        }
        return null;
      case 13:
        return Ht(Sr), g = u.memoizedState, u.flags & 64 ? (u.lanes = d, u) : (g = g !== null, d = !1, o === null ? u.memoizedProps.fallback !== void 0 && Vl(u) : d = o.memoizedState !== null, g && !d && u.mode & 2 && (o === null && u.memoizedProps.unstable_avoidThisFallback !== !0 || Sr.current & 1 ? Na === 0 && (Na = 3) : ((Na === 0 || Na === 3) && (Na = 4), Mi === null || !(Yu & 134217727) && !(Ts & 134217727) || Yc(Mi, Ga))), (g || d) && (u.flags |= 4), null);
      case 4:
        return al(), Bc(u), o === null && Qd(u.stateNode.containerInfo), null;
      case 10:
        return li(u), null;
      case 17:
        return ya(u.type) && Zi(), null;
      case 19:
        if (Ht(Sr), g = u.memoizedState, g === null)
          return null;
        if (_ = (u.flags & 64) !== 0, I = g.rendering, I === null)
          if (_)
            hf(g, !1);
          else {
            if (Na !== 0 || o !== null && o.flags & 64)
              for (o = u.child; o !== null; ) {
                if (I = Hl(o), I !== null) {
                  for (u.flags |= 64, hf(g, !1), _ = I.updateQueue, _ !== null && (u.updateQueue = _, u.flags |= 4), g.lastEffect === null && (u.firstEffect = null), u.lastEffect = g.lastEffect, g = d, d = u.child; d !== null; )
                    _ = d, o = g, _.flags &= 2, _.nextEffect = null, _.firstEffect = null, _.lastEffect = null, I = _.alternate, I === null ? (_.childLanes = 0, _.lanes = o, _.child = null, _.memoizedProps = null, _.memoizedState = null, _.updateQueue = null, _.dependencies = null, _.stateNode = null) : (_.childLanes = I.childLanes, _.lanes = I.lanes, _.child = I.child, _.memoizedProps = I.memoizedProps, _.memoizedState = I.memoizedState, _.updateQueue = I.updateQueue, _.type = I.type, o = I.dependencies, _.dependencies = o === null ? null : { lanes: o.lanes, firstContext: o.firstContext }), d = d.sibling;
                  return Lt(Sr, Sr.current & 1 | 2), u.child;
                }
                o = o.sibling;
              }
            g.tail !== null && ba() > Gu && (u.flags |= 64, _ = !0, hf(g, !1), u.lanes = 33554432);
          }
        else {
          if (!_)
            if (o = Hl(I), o !== null) {
              if (u.flags |= 64, _ = !0, d = o.updateQueue, d !== null && (u.updateQueue = d, u.flags |= 4), hf(g, !0), g.tail === null && g.tailMode === "hidden" && !I.alternate && !Eo)
                return u = u.lastEffect = g.lastEffect, u !== null && (u.nextEffect = null), null;
            } else
              2 * ba() - g.renderingStartTime > Gu && d !== 1073741824 && (u.flags |= 64, _ = !0, hf(g, !1), u.lanes = 33554432);
          g.isBackwards ? (I.sibling = u.child, u.child = I) : (d = g.last, d !== null ? d.sibling = I : u.child = I, g.last = I);
        }
        return g.tail !== null ? (d = g.tail, g.rendering = d, g.tail = d.sibling, g.lastEffect = u.lastEffect, g.renderingStartTime = ba(), d.sibling = null, u = Sr.current, Lt(Sr, _ ? u & 1 | 2 : u & 1), d) : null;
      case 23:
      case 24:
        return xp(), o !== null && o.memoizedState !== null != (u.memoizedState !== null) && g.mode !== "unstable-defer-without-hiding" && (u.flags |= 4), null;
    }
    throw Error(r(156, u.tag));
  }
  function kg(o) {
    switch (o.tag) {
      case 1:
        ya(o.type) && Zi();
        var u = o.flags;
        return u & 4096 ? (o.flags = u & -4097 | 64, o) : null;
      case 3:
        if (al(), Ht(kr), Ht(er), Es(), u = o.flags, u & 64)
          throw Error(r(285));
        return o.flags = u & -4097 | 64, o;
      case 5:
        return Hc(o), null;
      case 13:
        return Ht(Sr), u = o.flags, u & 4096 ? (o.flags = u & -4097 | 64, o) : null;
      case 19:
        return Ht(Sr), null;
      case 4:
        return al(), null;
      case 10:
        return li(o), null;
      case 23:
      case 24:
        return xp(), null;
      default:
        return null;
    }
  }
  function hp(o, u) {
    try {
      var d = "", g = u;
      do
        d += Qn(g), g = g.return;
      while (g);
      var $ = d;
    } catch (_) {
      $ = `
Error generating stack: ` + _.message + `
` + _.stack;
    }
    return { value: o, source: u, stack: $ };
  }
  function pp(o, u) {
    try {
      console.error(u.value);
    } catch (d) {
      setTimeout(function() {
        throw d;
      });
    }
  }
  var $g = typeof WeakMap == "function" ? WeakMap : Map;
  function Sg(o, u, d) {
    d = ro(-1, d), d.tag = 3, d.payload = { element: null };
    var g = u.value;
    return d.callback = function() {
      wf || (wf = !0, wp = g), pp(o, u);
    }, d;
  }
  function xg(o, u, d) {
    d = ro(-1, d), d.tag = 3;
    var g = o.type.getDerivedStateFromError;
    if (typeof g == "function") {
      var $ = u.value;
      d.payload = function() {
        return pp(o, u), g($);
      };
    }
    var _ = o.stateNode;
    return _ !== null && typeof _.componentDidCatch == "function" && (d.callback = function() {
      typeof g != "function" && (Rs === null ? Rs = /* @__PURE__ */ new Set([this]) : Rs.add(this), pp(o, u));
      var I = u.stack;
      this.componentDidCatch(u.value, { componentStack: I !== null ? I : "" });
    }), d;
  }
  var Kw = typeof WeakSet == "function" ? WeakSet : Set;
  function Cg(o) {
    var u = o.ref;
    if (u !== null)
      if (typeof u == "function")
        try {
          u(null);
        } catch (d) {
          Ql(o, d);
        }
      else
        u.current = null;
  }
  function Jw(o, u) {
    switch (u.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        return;
      case 1:
        if (u.flags & 256 && o !== null) {
          var d = o.memoizedProps, g = o.memoizedState;
          o = u.stateNode, u = o.getSnapshotBeforeUpdate(u.elementType === u.type ? d : $r(u.type, d), g), o.__reactInternalSnapshotBeforeUpdate = u;
        }
        return;
      case 3:
        u.flags & 256 && Dc(u.stateNode.containerInfo);
        return;
      case 5:
      case 6:
      case 4:
      case 17:
        return;
    }
    throw Error(r(163));
  }
  function vp(o, u, d) {
    switch (d.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        if (u = d.updateQueue, u = u !== null ? u.lastEffect : null, u !== null) {
          o = u = u.next;
          do {
            if ((o.tag & 3) === 3) {
              var g = o.create;
              o.destroy = g();
            }
            o = o.next;
          } while (o !== u);
        }
        if (u = d.updateQueue, u = u !== null ? u.lastEffect : null, u !== null) {
          o = u = u.next;
          do {
            var $ = o;
            g = $.next, $ = $.tag, $ & 4 && $ & 1 && (Mp(d, o), zg(d, o)), o = g;
          } while (o !== u);
        }
        return;
      case 1:
        o = d.stateNode, d.flags & 4 && (u === null ? o.componentDidMount() : (g = d.elementType === d.type ? u.memoizedProps : $r(d.type, u.memoizedProps), o.componentDidUpdate(
          g,
          u.memoizedState,
          o.__reactInternalSnapshotBeforeUpdate
        ))), u = d.updateQueue, u !== null && lf(d, u, o);
        return;
      case 3:
        if (u = d.updateQueue, u !== null) {
          if (o = null, d.child !== null)
            switch (d.child.tag) {
              case 5:
                o = d.child.stateNode;
                break;
              case 1:
                o = d.child.stateNode;
            }
          lf(d, u, o);
        }
        return;
      case 5:
        o = d.stateNode, u === null && d.flags & 4 && Wi(d.type, d.memoizedProps) && o.focus();
        return;
      case 6:
        return;
      case 4:
        return;
      case 12:
        return;
      case 13:
        d.memoizedState === null && (d = d.alternate, d !== null && (d = d.memoizedState, d !== null && (d = d.dehydrated, d !== null && wo(d))));
        return;
      case 19:
      case 17:
      case 20:
      case 21:
      case 23:
      case 24:
        return;
    }
    throw Error(r(163));
  }
  function gp(o, u) {
    for (var d = o; ; ) {
      if (d.tag === 5) {
        var g = d.stateNode;
        if (u)
          g = g.style, typeof g.setProperty == "function" ? g.setProperty("display", "none", "important") : g.display = "none";
        else {
          g = d.stateNode;
          var $ = d.memoizedProps.style;
          $ = $ != null && $.hasOwnProperty("display") ? $.display : null, g.style.display = Pn("display", $);
        }
      } else if (d.tag === 6)
        d.stateNode.nodeValue = u ? "" : d.memoizedProps;
      else if ((d.tag !== 23 && d.tag !== 24 || d.memoizedState === null || d === o) && d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === o)
        break;
      for (; d.sibling === null; ) {
        if (d.return === null || d.return === o)
          return;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
  }
  function Mg(o, u) {
    if (el && typeof el.onCommitFiberUnmount == "function")
      try {
        el.onCommitFiberUnmount(ef, u);
      } catch {
      }
    switch (u.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        if (o = u.updateQueue, o !== null && (o = o.lastEffect, o !== null)) {
          var d = o = o.next;
          do {
            var g = d, $ = g.destroy;
            if (g = g.tag, $ !== void 0)
              if (g & 4)
                Mp(u, d);
              else {
                g = u;
                try {
                  $();
                } catch (_) {
                  Ql(g, _);
                }
              }
            d = d.next;
          } while (d !== o);
        }
        break;
      case 1:
        if (Cg(u), o = u.stateNode, typeof o.componentWillUnmount == "function")
          try {
            o.props = u.memoizedProps, o.state = u.memoizedState, o.componentWillUnmount();
          } catch (_) {
            Ql(
              u,
              _
            );
          }
        break;
      case 5:
        Cg(u);
        break;
      case 4:
        Og(o, u);
    }
  }
  function Eg(o) {
    o.alternate = null, o.child = null, o.dependencies = null, o.firstEffect = null, o.lastEffect = null, o.memoizedProps = null, o.memoizedState = null, o.pendingProps = null, o.return = null, o.updateQueue = null;
  }
  function Ag(o) {
    return o.tag === 5 || o.tag === 3 || o.tag === 4;
  }
  function _g(o) {
    e: {
      for (var u = o.return; u !== null; ) {
        if (Ag(u))
          break e;
        u = u.return;
      }
      throw Error(r(160));
    }
    var d = u;
    switch (u = d.stateNode, d.tag) {
      case 5:
        var g = !1;
        break;
      case 3:
        u = u.containerInfo, g = !0;
        break;
      case 4:
        u = u.containerInfo, g = !0;
        break;
      default:
        throw Error(r(161));
    }
    d.flags & 16 && (pn(u, ""), d.flags &= -17);
    e:
      t:
        for (d = o; ; ) {
          for (; d.sibling === null; ) {
            if (d.return === null || Ag(d.return)) {
              d = null;
              break e;
            }
            d = d.return;
          }
          for (d.sibling.return = d.return, d = d.sibling; d.tag !== 5 && d.tag !== 6 && d.tag !== 18; ) {
            if (d.flags & 2 || d.child === null || d.tag === 4)
              continue t;
            d.child.return = d, d = d.child;
          }
          if (!(d.flags & 2)) {
            d = d.stateNode;
            break e;
          }
        }
    g ? pf(o, d, u) : vf(o, d, u);
  }
  function pf(o, u, d) {
    var g = o.tag, $ = g === 5 || g === 6;
    if ($)
      o = $ ? o.stateNode : o.stateNode.instance, u ? d.nodeType === 8 ? d.parentNode.insertBefore(o, u) : d.insertBefore(o, u) : (d.nodeType === 8 ? (u = d.parentNode, u.insertBefore(o, d)) : (u = d, u.appendChild(o)), d = d._reactRootContainer, d != null || u.onclick !== null || (u.onclick = Ou));
    else if (g !== 4 && (o = o.child, o !== null))
      for (pf(o, u, d), o = o.sibling; o !== null; )
        pf(o, u, d), o = o.sibling;
  }
  function vf(o, u, d) {
    var g = o.tag, $ = g === 5 || g === 6;
    if ($)
      o = $ ? o.stateNode : o.stateNode.instance, u ? d.insertBefore(o, u) : d.appendChild(o);
    else if (g !== 4 && (o = o.child, o !== null))
      for (vf(o, u, d), o = o.sibling; o !== null; )
        vf(o, u, d), o = o.sibling;
  }
  function Og(o, u) {
    for (var d = u, g = !1, $, _; ; ) {
      if (!g) {
        g = d.return;
        e:
          for (; ; ) {
            if (g === null)
              throw Error(r(160));
            switch ($ = g.stateNode, g.tag) {
              case 5:
                _ = !1;
                break e;
              case 3:
                $ = $.containerInfo, _ = !0;
                break e;
              case 4:
                $ = $.containerInfo, _ = !0;
                break e;
            }
            g = g.return;
          }
        g = !0;
      }
      if (d.tag === 5 || d.tag === 6) {
        e:
          for (var I = o, q = d, re = q; ; )
            if (Mg(I, re), re.child !== null && re.tag !== 4)
              re.child.return = re, re = re.child;
            else {
              if (re === q)
                break e;
              for (; re.sibling === null; ) {
                if (re.return === null || re.return === q)
                  break e;
                re = re.return;
              }
              re.sibling.return = re.return, re = re.sibling;
            }
        _ ? (I = $, q = d.stateNode, I.nodeType === 8 ? I.parentNode.removeChild(q) : I.removeChild(q)) : $.removeChild(d.stateNode);
      } else if (d.tag === 4) {
        if (d.child !== null) {
          $ = d.stateNode.containerInfo, _ = !0, d.child.return = d, d = d.child;
          continue;
        }
      } else if (Mg(o, d), d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === u)
        break;
      for (; d.sibling === null; ) {
        if (d.return === null || d.return === u)
          return;
        d = d.return, d.tag === 4 && (g = !1);
      }
      d.sibling.return = d.return, d = d.sibling;
    }
  }
  function yp(o, u) {
    switch (u.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        var d = u.updateQueue;
        if (d = d !== null ? d.lastEffect : null, d !== null) {
          var g = d = d.next;
          do
            (g.tag & 3) === 3 && (o = g.destroy, g.destroy = void 0, o !== void 0 && o()), g = g.next;
          while (g !== d);
        }
        return;
      case 1:
        return;
      case 5:
        if (d = u.stateNode, d != null) {
          g = u.memoizedProps;
          var $ = o !== null ? o.memoizedProps : g;
          o = u.type;
          var _ = u.updateQueue;
          if (u.updateQueue = null, _ !== null) {
            for (d[Ru] = g, o === "input" && g.type === "radio" && g.name != null && Wr(d, g), Oi(o, $), u = Oi(o, g), $ = 0; $ < _.length; $ += 2) {
              var I = _[$], q = _[$ + 1];
              I === "style" ? Vr(d, q) : I === "dangerouslySetInnerHTML" ? ir(d, q) : I === "children" ? pn(d, q) : X(d, I, q, u);
            }
            switch (o) {
              case "input":
                fa(d, g);
                break;
              case "textarea":
                Ia(d, g);
                break;
              case "select":
                o = d._wrapperState.wasMultiple, d._wrapperState.wasMultiple = !!g.multiple, _ = g.value, _ != null ? Dn(d, !!g.multiple, _, !1) : o !== !!g.multiple && (g.defaultValue != null ? Dn(d, !!g.multiple, g.defaultValue, !0) : Dn(d, !!g.multiple, g.multiple ? [] : "", !1));
            }
          }
        }
        return;
      case 6:
        if (u.stateNode === null)
          throw Error(r(162));
        u.stateNode.nodeValue = u.memoizedProps;
        return;
      case 3:
        d = u.stateNode, d.hydrate && (d.hydrate = !1, wo(d.containerInfo));
        return;
      case 12:
        return;
      case 13:
        u.memoizedState !== null && (bf = ba(), gp(u.child, !0)), Tg(u);
        return;
      case 19:
        Tg(u);
        return;
      case 17:
        return;
      case 23:
      case 24:
        gp(u, u.memoizedState !== null);
        return;
    }
    throw Error(r(163));
  }
  function Tg(o) {
    var u = o.updateQueue;
    if (u !== null) {
      o.updateQueue = null;
      var d = o.stateNode;
      d === null && (d = o.stateNode = new Kw()), u.forEach(function(g) {
        var $ = a0.bind(null, o, g);
        d.has(g) || (d.add(g), g.then($, $));
      });
    }
  }
  function Zw(o, u) {
    return o !== null && (o = o.memoizedState, o === null || o.dehydrated !== null) ? (u = u.memoizedState, u !== null && u.dehydrated === null) : !1;
  }
  var gf = Math.ceil, Uc = U.ReactCurrentDispatcher, qu = U.ReactCurrentOwner, Ut = 0, Mi = null, ia = null, Ga = 0, Os = 0, Xc = Ra(0), Na = 0, di = null, ts = 0, Yu = 0, Ts = 0, bp = 0, yf = null, bf = 0, Gu = 1 / 0;
  function qc() {
    Gu = ba() + 500;
  }
  var vt = null, wf = !1, wp = null, Rs = null, Xl = !1, Qu = null, Pf = 90, Pp = [], kp = [], ll = null, kf = 0, Vm = null, Bm = -1, ul = 0, Um = 0, $f = null, Xm = !1;
  function oo() {
    return Ut & 48 ? ba() : Bm !== -1 ? Bm : Bm = ba();
  }
  function Ds(o) {
    if (o = o.mode, !(o & 2))
      return 1;
    if (!(o & 4))
      return jl() === 99 ? 1 : 2;
    if (ul === 0 && (ul = ts), $s.transition !== 0) {
      Um !== 0 && (Um = yf !== null ? yf.pendingLanes : 0), o = ul;
      var u = 4186112 & ~Um;
      return u &= -u, u === 0 && (o = 4186112 & ~o, u = o & -o, u === 0 && (u = 8192)), u;
    }
    return o = jl(), Ut & 4 && o === 98 ? o = jn(12, ul) : (o = dn(o), o = jn(o, ul)), o;
  }
  function ql(o, u, d) {
    if (50 < kf)
      throw kf = 0, Vm = null, Error(r(185));
    if (o = qm(o, u), o === null)
      return null;
    B(o, u, d), o === Mi && (Ts |= u, Na === 4 && Yc(o, Ga));
    var g = jl();
    u === 1 ? Ut & 8 && !(Ut & 48) ? Sp(o) : (Oo(o, d), Ut === 0 && (qc(), na())) : (!(Ut & 4) || g !== 98 && g !== 99 || (ll === null ? ll = /* @__PURE__ */ new Set([o]) : ll.add(o)), Oo(o, d)), yf = o;
  }
  function qm(o, u) {
    o.lanes |= u;
    var d = o.alternate;
    for (d !== null && (d.lanes |= u), d = o, o = o.return; o !== null; )
      o.childLanes |= u, d = o.alternate, d !== null && (d.childLanes |= u), d = o, o = o.return;
    return d.tag === 3 ? d.stateNode : null;
  }
  function Oo(o, u) {
    for (var d = o.callbackNode, g = o.suspendedLanes, $ = o.pingedLanes, _ = o.expirationTimes, I = o.pendingLanes; 0 < I; ) {
      var q = 31 - ve(I), re = 1 << q, Se = _[q];
      if (Se === -1) {
        if (!(re & g) || re & $) {
          Se = u, Qt(re);
          var ut = Pt;
          _[q] = 10 <= ut ? Se + 250 : 6 <= ut ? Se + 5e3 : -1;
        }
      } else
        Se <= u && (o.expiredLanes |= re);
      I &= ~re;
    }
    if (g = Hn(o, o === Mi ? Ga : 0), u = Pt, g === 0)
      d !== null && (d !== rf && Wu(d), o.callbackNode = null, o.callbackPriority = 0);
    else {
      if (d !== null) {
        if (o.callbackPriority === u)
          return;
        d !== rf && Wu(d);
      }
      u === 15 ? (d = Sp.bind(null, o), ji === null ? (ji = [d], Nl = to(zc, no)) : ji.push(d), d = rf) : u === 14 ? d = zi(99, Sp.bind(null, o)) : (d = Wn(u), d = zi(d, $p.bind(null, o))), o.callbackPriority = u, o.callbackNode = d;
    }
  }
  function $p(o) {
    if (Bm = -1, Um = ul = 0, Ut & 48)
      throw Error(r(327));
    var u = o.callbackNode;
    if (Gl() && o.callbackNode !== u)
      return null;
    var d = Hn(o, o === Mi ? Ga : 0);
    if (d === 0)
      return null;
    var g = d, $ = Ut;
    Ut |= 16;
    var _ = Gc();
    (Mi !== o || Ga !== g) && (qc(), Ku(o, g));
    do
      try {
        Wg();
        break;
      } catch (q) {
        Gm(o, q);
      }
    while (1);
    if (zu(), Uc.current = _, Ut = $, ia !== null ? g = 0 : (Mi = null, Ga = 0, g = Na), ts & Ts)
      Ku(o, 0);
    else if (g !== 0) {
      if (g === 2 && (Ut |= 64, o.hydrate && (o.hydrate = !1, Dc(o.containerInfo)), d = wr(o), d !== 0 && (g = Sf(o, d))), g === 1)
        throw u = di, Ku(o, 0), Yc(o, d), Oo(o, ba()), u;
      switch (o.finishedWork = o.current.alternate, o.finishedLanes = d, g) {
        case 0:
        case 1:
          throw Error(r(345));
        case 2:
          Yl(o);
          break;
        case 3:
          if (Yc(o, d), (d & 62914560) === d && (g = bf + 500 - ba(), 10 < g)) {
            if (Hn(o, 0) !== 0)
              break;
            if ($ = o.suspendedLanes, ($ & d) !== d) {
              oo(), o.pingedLanes |= o.suspendedLanes & $;
              break;
            }
            o.timeoutHandle = Rl(Yl.bind(null, o), g);
            break;
          }
          Yl(o);
          break;
        case 4:
          if (Yc(o, d), (d & 4186112) === d)
            break;
          for (g = o.eventTimes, $ = -1; 0 < d; ) {
            var I = 31 - ve(d);
            _ = 1 << I, I = g[I], I > $ && ($ = I), d &= ~_;
          }
          if (d = $, d = ba() - d, d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3e3 > d ? 3e3 : 4320 > d ? 4320 : 1960 * gf(d / 1960)) - d, 10 < d) {
            o.timeoutHandle = Rl(Yl.bind(null, o), d);
            break;
          }
          Yl(o);
          break;
        case 5:
          Yl(o);
          break;
        default:
          throw Error(r(329));
      }
    }
    return Oo(o, ba()), o.callbackNode === u ? $p.bind(null, o) : null;
  }
  function Yc(o, u) {
    for (u &= ~bp, u &= ~Ts, o.suspendedLanes |= u, o.pingedLanes &= ~u, o = o.expirationTimes; 0 < u; ) {
      var d = 31 - ve(u), g = 1 << d;
      o[d] = -1, u &= ~g;
    }
  }
  function Sp(o) {
    if (Ut & 48)
      throw Error(r(327));
    if (Gl(), o === Mi && o.expiredLanes & Ga) {
      var u = Ga, d = Sf(o, u);
      ts & Ts && (u = Hn(o, u), d = Sf(o, u));
    } else
      u = Hn(o, 0), d = Sf(o, u);
    if (o.tag !== 0 && d === 2 && (Ut |= 64, o.hydrate && (o.hydrate = !1, Dc(o.containerInfo)), u = wr(o), u !== 0 && (d = Sf(o, u))), d === 1)
      throw d = di, Ku(o, 0), Yc(o, u), Oo(o, ba()), d;
    return o.finishedWork = o.current.alternate, o.finishedLanes = u, Yl(o), Oo(o, ba()), null;
  }
  function e0() {
    if (ll !== null) {
      var o = ll;
      ll = null, o.forEach(function(u) {
        u.expiredLanes |= 24 & u.pendingLanes, Oo(u, ba());
      });
    }
    na();
  }
  function Rg(o, u) {
    var d = Ut;
    Ut |= 1;
    try {
      return o(u);
    } finally {
      Ut = d, Ut === 0 && (qc(), na());
    }
  }
  function Dg(o, u) {
    var d = Ut;
    Ut &= -2, Ut |= 8;
    try {
      return o(u);
    } finally {
      Ut = d, Ut === 0 && (qc(), na());
    }
  }
  function Ym(o, u) {
    Lt(Xc, Os), Os |= u, ts |= u;
  }
  function xp() {
    Os = Xc.current, Ht(Xc);
  }
  function Ku(o, u) {
    o.finishedWork = null, o.finishedLanes = 0;
    var d = o.timeoutHandle;
    if (d !== -1 && (o.timeoutHandle = -1, Zs(d)), ia !== null)
      for (d = ia.return; d !== null; ) {
        var g = d;
        switch (g.tag) {
          case 1:
            g = g.type.childContextTypes, g != null && Zi();
            break;
          case 3:
            al(), Ht(kr), Ht(er), Es();
            break;
          case 5:
            Hc(g);
            break;
          case 4:
            al();
            break;
          case 13:
            Ht(Sr);
            break;
          case 19:
            Ht(Sr);
            break;
          case 10:
            li(g);
            break;
          case 23:
          case 24:
            xp();
        }
        d = d.return;
      }
    Mi = o, ia = Kl(o.current, null), Ga = Os = ts = u, Na = 0, di = null, bp = Ts = Yu = 0;
  }
  function Gm(o, u) {
    do {
      var d = ia;
      try {
        if (zu(), il.current = ka, Xu) {
          for (var g = ur.memoizedState; g !== null; ) {
            var $ = g.queue;
            $ !== null && ($.pending = null), g = g.next;
          }
          Xu = !1;
        }
        if (Ul = 0, Yr = qr = ur = null, io = !1, qu.current = null, d === null || d.return === null) {
          Na = 1, di = u, ia = null;
          break;
        }
        e: {
          var _ = o, I = d.return, q = d, re = u;
          if (u = Ga, q.flags |= 2048, q.firstEffect = q.lastEffect = null, re !== null && typeof re == "object" && typeof re.then == "function") {
            var Se = re;
            if (!(q.mode & 2)) {
              var ut = q.alternate;
              ut ? (q.updateQueue = ut.updateQueue, q.memoizedState = ut.memoizedState, q.lanes = ut.lanes) : (q.updateQueue = null, q.memoizedState = null);
            }
            var Xt = (Sr.current & 1) !== 0, Ve = I;
            do {
              var Mt;
              if (Mt = Ve.tag === 13) {
                var Vt = Ve.memoizedState;
                if (Vt !== null)
                  Mt = Vt.dehydrated !== null;
                else {
                  var zt = Ve.memoizedProps;
                  Mt = zt.fallback === void 0 ? !1 : zt.unstable_avoidThisFallback !== !0 ? !0 : !Xt;
                }
              }
              if (Mt) {
                var ge = Ve.updateQueue;
                if (ge === null) {
                  var le = /* @__PURE__ */ new Set();
                  le.add(Se), Ve.updateQueue = le;
                } else
                  ge.add(Se);
                if (!(Ve.mode & 2)) {
                  if (Ve.flags |= 64, q.flags |= 16384, q.flags &= -2981, q.tag === 1)
                    if (q.alternate === null)
                      q.tag = 17;
                    else {
                      var fe = ro(-1, 1);
                      fe.tag = 2, Qo(q, fe);
                    }
                  q.lanes |= 1;
                  break e;
                }
                re = void 0, q = u;
                var Re = _.pingCache;
                if (Re === null ? (Re = _.pingCache = new $g(), re = /* @__PURE__ */ new Set(), Re.set(Se, re)) : (re = Re.get(Se), re === void 0 && (re = /* @__PURE__ */ new Set(), Re.set(Se, re))), !re.has(q)) {
                  re.add(q);
                  var je = r0.bind(null, _, Se, q);
                  Se.then(je, je);
                }
                Ve.flags |= 4096, Ve.lanes = u;
                break e;
              }
              Ve = Ve.return;
            } while (Ve !== null);
            re = Error((cn(q.type) || "A React component") + ` suspended while rendering, but no fallback UI was specified.

Add a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.`);
          }
          Na !== 5 && (Na = 2), re = hp(re, q), Ve = I;
          do {
            switch (Ve.tag) {
              case 3:
                _ = re, Ve.flags |= 4096, u &= -u, Ve.lanes |= u;
                var Kt = Sg(Ve, _, u);
                Fm(Ve, Kt);
                break e;
              case 1:
                _ = re;
                var gt = Ve.type, qt = Ve.stateNode;
                if (!(Ve.flags & 64) && (typeof gt.getDerivedStateFromError == "function" || qt !== null && typeof qt.componentDidCatch == "function" && (Rs === null || !Rs.has(qt)))) {
                  Ve.flags |= 4096, u &= -u, Ve.lanes |= u;
                  var tn = xg(Ve, _, u);
                  Fm(Ve, tn);
                  break e;
                }
            }
            Ve = Ve.return;
          } while (Ve !== null);
        }
        jg(d);
      } catch (Jt) {
        u = Jt, ia === d && d !== null && (ia = d = d.return);
        continue;
      }
      break;
    } while (1);
  }
  function Gc() {
    var o = Uc.current;
    return Uc.current = ka, o === null ? ka : o;
  }
  function Sf(o, u) {
    var d = Ut;
    Ut |= 16;
    var g = Gc();
    Mi === o && Ga === u || Ku(o, u);
    do
      try {
        Ng();
        break;
      } catch ($) {
        Gm(o, $);
      }
    while (1);
    if (zu(), Ut = d, Uc.current = g, ia !== null)
      throw Error(r(261));
    return Mi = null, Ga = 0, Na;
  }
  function Ng() {
    for (; ia !== null; )
      Cp(ia);
  }
  function Wg() {
    for (; ia !== null && !fp(); )
      Cp(ia);
  }
  function Cp(o) {
    var u = Ig(o.alternate, o, Os);
    o.memoizedProps = o.pendingProps, u === null ? jg(o) : ia = u, qu.current = null;
  }
  function jg(o) {
    var u = o;
    do {
      var d = u.alternate;
      if (o = u.return, u.flags & 2048) {
        if (d = kg(u), d !== null) {
          d.flags &= 2047, ia = d;
          return;
        }
        o !== null && (o.firstEffect = o.lastEffect = null, o.flags |= 2048);
      } else {
        if (d = Qw(d, u, Os), d !== null) {
          ia = d;
          return;
        }
        if (d = u, d.tag !== 24 && d.tag !== 23 || d.memoizedState === null || Os & 1073741824 || !(d.mode & 4)) {
          for (var g = 0, $ = d.child; $ !== null; )
            g |= $.lanes | $.childLanes, $ = $.sibling;
          d.childLanes = g;
        }
        o !== null && !(o.flags & 2048) && (o.firstEffect === null && (o.firstEffect = u.firstEffect), u.lastEffect !== null && (o.lastEffect !== null && (o.lastEffect.nextEffect = u.firstEffect), o.lastEffect = u.lastEffect), 1 < u.flags && (o.lastEffect !== null ? o.lastEffect.nextEffect = u : o.firstEffect = u, o.lastEffect = u));
      }
      if (u = u.sibling, u !== null) {
        ia = u;
        return;
      }
      ia = u = o;
    } while (u !== null);
    Na === 0 && (Na = 5);
  }
  function Yl(o) {
    var u = jl();
    return wa(99, t0.bind(null, o, u)), null;
  }
  function t0(o, u) {
    do
      Gl();
    while (Qu !== null);
    if (Ut & 48)
      throw Error(r(327));
    var d = o.finishedWork;
    if (d === null)
      return null;
    if (o.finishedWork = null, o.finishedLanes = 0, d === o.current)
      throw Error(r(177));
    o.callbackNode = null;
    var g = d.lanes | d.childLanes, $ = g, _ = o.pendingLanes & ~$;
    o.pendingLanes = $, o.suspendedLanes = 0, o.pingedLanes = 0, o.expiredLanes &= $, o.mutableReadLanes &= $, o.entangledLanes &= $, $ = o.entanglements;
    for (var I = o.eventTimes, q = o.expirationTimes; 0 < _; ) {
      var re = 31 - ve(_), Se = 1 << re;
      $[re] = 0, I[re] = -1, q[re] = -1, _ &= ~Se;
    }
    if (ll !== null && !(g & 24) && ll.has(o) && ll.delete(o), o === Mi && (ia = Mi = null, Ga = 0), 1 < d.flags ? d.lastEffect !== null ? (d.lastEffect.nextEffect = d, g = d.firstEffect) : g = d : g = d.firstEffect, g !== null) {
      if ($ = Ut, Ut |= 32, qu.current = null, Kd = Nt, I = _l(), Xo(I)) {
        if ("selectionStart" in I)
          q = { start: I.selectionStart, end: I.selectionEnd };
        else
          e:
            if (q = (q = I.ownerDocument) && q.defaultView || window, (Se = q.getSelection && q.getSelection()) && Se.rangeCount !== 0) {
              q = Se.anchorNode, _ = Se.anchorOffset, re = Se.focusNode, Se = Se.focusOffset;
              try {
                q.nodeType, re.nodeType;
              } catch {
                q = null;
                break e;
              }
              var ut = 0, Xt = -1, Ve = -1, Mt = 0, Vt = 0, zt = I, ge = null;
              t:
                for (; ; ) {
                  for (var le; zt !== q || _ !== 0 && zt.nodeType !== 3 || (Xt = ut + _), zt !== re || Se !== 0 && zt.nodeType !== 3 || (Ve = ut + Se), zt.nodeType === 3 && (ut += zt.nodeValue.length), (le = zt.firstChild) !== null; )
                    ge = zt, zt = le;
                  for (; ; ) {
                    if (zt === I)
                      break t;
                    if (ge === q && ++Mt === _ && (Xt = ut), ge === re && ++Vt === Se && (Ve = ut), (le = zt.nextSibling) !== null)
                      break;
                    zt = ge, ge = zt.parentNode;
                  }
                  zt = le;
                }
              q = Xt === -1 || Ve === -1 ? null : { start: Xt, end: Ve };
            } else
              q = null;
        q = q || { start: 0, end: 0 };
      } else
        q = null;
      Jd = { focusedElem: I, selectionRange: q }, Nt = !1, $f = null, Xm = !1, vt = g;
      do
        try {
          n0();
        } catch (Jt) {
          if (vt === null)
            throw Error(r(330));
          Ql(vt, Jt), vt = vt.nextEffect;
        }
      while (vt !== null);
      $f = null, vt = g;
      do
        try {
          for (I = o; vt !== null; ) {
            var fe = vt.flags;
            if (fe & 16 && pn(vt.stateNode, ""), fe & 128) {
              var Re = vt.alternate;
              if (Re !== null) {
                var je = Re.ref;
                je !== null && (typeof je == "function" ? je(null) : je.current = null);
              }
            }
            switch (fe & 1038) {
              case 2:
                _g(vt), vt.flags &= -3;
                break;
              case 6:
                _g(vt), vt.flags &= -3, yp(vt.alternate, vt);
                break;
              case 1024:
                vt.flags &= -1025;
                break;
              case 1028:
                vt.flags &= -1025, yp(vt.alternate, vt);
                break;
              case 4:
                yp(vt.alternate, vt);
                break;
              case 8:
                q = vt, Og(I, q);
                var Kt = q.alternate;
                Eg(q), Kt !== null && Eg(Kt);
            }
            vt = vt.nextEffect;
          }
        } catch (Jt) {
          if (vt === null)
            throw Error(r(330));
          Ql(vt, Jt), vt = vt.nextEffect;
        }
      while (vt !== null);
      if (je = Jd, Re = _l(), fe = je.focusedElem, I = je.selectionRange, Re !== fe && fe && fe.ownerDocument && Xd(fe.ownerDocument.documentElement, fe)) {
        for (I !== null && Xo(fe) && (Re = I.start, je = I.end, je === void 0 && (je = Re), "selectionStart" in fe ? (fe.selectionStart = Re, fe.selectionEnd = Math.min(je, fe.value.length)) : (je = (Re = fe.ownerDocument || document) && Re.defaultView || window, je.getSelection && (je = je.getSelection(), q = fe.textContent.length, Kt = Math.min(I.start, q), I = I.end === void 0 ? Kt : Math.min(I.end, q), !je.extend && Kt > I && (q = I, I = Kt, Kt = q), q = Tm(fe, Kt), _ = Tm(fe, I), q && _ && (je.rangeCount !== 1 || je.anchorNode !== q.node || je.anchorOffset !== q.offset || je.focusNode !== _.node || je.focusOffset !== _.offset) && (Re = Re.createRange(), Re.setStart(q.node, q.offset), je.removeAllRanges(), Kt > I ? (je.addRange(Re), je.extend(_.node, _.offset)) : (Re.setEnd(_.node, _.offset), je.addRange(Re)))))), Re = [], je = fe; je = je.parentNode; )
          je.nodeType === 1 && Re.push({ element: je, left: je.scrollLeft, top: je.scrollTop });
        for (typeof fe.focus == "function" && fe.focus(), fe = 0; fe < Re.length; fe++)
          je = Re[fe], je.element.scrollLeft = je.left, je.element.scrollTop = je.top;
      }
      Nt = !!Kd, Jd = Kd = null, o.current = d, vt = g;
      do
        try {
          for (fe = o; vt !== null; ) {
            var gt = vt.flags;
            if (gt & 36 && vp(fe, vt.alternate, vt), gt & 128) {
              Re = void 0;
              var qt = vt.ref;
              if (qt !== null) {
                var tn = vt.stateNode;
                switch (vt.tag) {
                  case 5:
                    Re = tn;
                    break;
                  default:
                    Re = tn;
                }
                typeof qt == "function" ? qt(Re) : qt.current = Re;
              }
            }
            vt = vt.nextEffect;
          }
        } catch (Jt) {
          if (vt === null)
            throw Error(r(330));
          Ql(vt, Jt), vt = vt.nextEffect;
        }
      while (vt !== null);
      vt = null, Lc(), Ut = $;
    } else
      o.current = d;
    if (Xl)
      Xl = !1, Qu = o, Pf = u;
    else
      for (vt = g; vt !== null; )
        u = vt.nextEffect, vt.nextEffect = null, vt.flags & 8 && (gt = vt, gt.sibling = null, gt.stateNode = null), vt = u;
    if (g = o.pendingLanes, g === 0 && (Rs = null), g === 1 ? o === Vm ? kf++ : (kf = 0, Vm = o) : kf = 0, d = d.stateNode, el && typeof el.onCommitFiberRoot == "function")
      try {
        el.onCommitFiberRoot(ef, d, void 0, (d.current.flags & 64) === 64);
      } catch {
      }
    if (Oo(o, ba()), wf)
      throw wf = !1, o = wp, wp = null, o;
    return Ut & 8 || na(), null;
  }
  function n0() {
    for (; vt !== null; ) {
      var o = vt.alternate;
      Xm || $f === null || (vt.flags & 8 ? Ea(vt, $f) && (Xm = !0) : vt.tag === 13 && Zw(o, vt) && Ea(vt, $f) && (Xm = !0));
      var u = vt.flags;
      u & 256 && Jw(o, vt), !(u & 512) || Xl || (Xl = !0, zi(97, function() {
        return Gl(), null;
      })), vt = vt.nextEffect;
    }
  }
  function Gl() {
    if (Pf !== 90) {
      var o = 97 < Pf ? 97 : Pf;
      return Pf = 90, wa(o, Lg);
    }
    return !1;
  }
  function zg(o, u) {
    Pp.push(u, o), Xl || (Xl = !0, zi(97, function() {
      return Gl(), null;
    }));
  }
  function Mp(o, u) {
    kp.push(u, o), Xl || (Xl = !0, zi(97, function() {
      return Gl(), null;
    }));
  }
  function Lg() {
    if (Qu === null)
      return !1;
    var o = Qu;
    if (Qu = null, Ut & 48)
      throw Error(r(331));
    var u = Ut;
    Ut |= 32;
    var d = kp;
    kp = [];
    for (var g = 0; g < d.length; g += 2) {
      var $ = d[g], _ = d[g + 1], I = $.destroy;
      if ($.destroy = void 0, typeof I == "function")
        try {
          I();
        } catch (re) {
          if (_ === null)
            throw Error(r(330));
          Ql(_, re);
        }
    }
    for (d = Pp, Pp = [], g = 0; g < d.length; g += 2) {
      $ = d[g], _ = d[g + 1];
      try {
        var q = $.create;
        $.destroy = q();
      } catch (re) {
        if (_ === null)
          throw Error(r(330));
        Ql(_, re);
      }
    }
    for (q = o.current.firstEffect; q !== null; )
      o = q.nextEffect, q.nextEffect = null, q.flags & 8 && (q.sibling = null, q.stateNode = null), q = o;
    return Ut = u, na(), !0;
  }
  function Ju(o, u, d) {
    u = hp(d, u), u = Sg(o, u, 1), Qo(o, u), u = oo(), o = qm(o, 1), o !== null && (B(o, 1, u), Oo(o, u));
  }
  function Ql(o, u) {
    if (o.tag === 3)
      Ju(o, o, u);
    else
      for (var d = o.return; d !== null; ) {
        if (d.tag === 3) {
          Ju(d, o, u);
          break;
        } else if (d.tag === 1) {
          var g = d.stateNode;
          if (typeof d.type.getDerivedStateFromError == "function" || typeof g.componentDidCatch == "function" && (Rs === null || !Rs.has(g))) {
            o = hp(u, o);
            var $ = xg(d, o, 1);
            if (Qo(d, $), $ = oo(), d = qm(d, 1), d !== null)
              B(d, 1, $), Oo(d, $);
            else if (typeof g.componentDidCatch == "function" && (Rs === null || !Rs.has(g)))
              try {
                g.componentDidCatch(u, o);
              } catch {
              }
            break;
          }
        }
        d = d.return;
      }
  }
  function r0(o, u, d) {
    var g = o.pingCache;
    g !== null && g.delete(u), u = oo(), o.pingedLanes |= o.suspendedLanes & d, Mi === o && (Ga & d) === d && (Na === 4 || Na === 3 && (Ga & 62914560) === Ga && 500 > ba() - bf ? Ku(o, 0) : bp |= d), Oo(o, u);
  }
  function a0(o, u) {
    var d = o.stateNode;
    d !== null && d.delete(u), u = 0, u === 0 && (u = o.mode, u & 2 ? u & 4 ? (ul === 0 && (ul = ts), u = ga(62914560 & ~ul), u === 0 && (u = 4194304)) : u = jl() === 99 ? 1 : 2 : u = 1), d = oo(), o = qm(o, u), o !== null && (B(o, u, d), Oo(o, d));
  }
  var Ig;
  Ig = function(o, u, d) {
    var g = u.lanes;
    if (o !== null)
      if (o.memoizedProps !== u.pendingProps || kr.current)
        Rt = !0;
      else if (d & g)
        Rt = !!(o.flags & 16384);
      else {
        switch (Rt = !1, u.tag) {
          case 3:
            ol(u), Bl();
            break;
          case 5:
            df(u);
            break;
          case 1:
            ya(u.type) && Si(u);
            break;
          case 4:
            Fl(u, u.stateNode.containerInfo);
            break;
          case 10:
            g = u.memoizedProps.value;
            var $ = u.type._context;
            Lt(Ss, $._currentValue), $._currentValue = g;
            break;
          case 13:
            if (u.memoizedState !== null)
              return d & u.child.childLanes ? Da(o, u, d) : (Lt(Sr, Sr.current & 1), u = sl(o, u, d), u !== null ? u.sibling : null);
            Lt(Sr, Sr.current & 1);
            break;
          case 19:
            if (g = (d & u.childLanes) !== 0, o.flags & 64) {
              if (g)
                return Gw(o, u, d);
              u.flags |= 64;
            }
            if ($ = u.memoizedState, $ !== null && ($.rendering = null, $.tail = null, $.lastEffect = null), Lt(Sr, Sr.current), g)
              break;
            return null;
          case 23:
          case 24:
            return u.lanes = 0, mn(o, u, d);
        }
        return sl(o, u, d);
      }
    else
      Rt = !1;
    switch (u.lanes = 0, u.tag) {
      case 2:
        if (g = u.type, o !== null && (o.alternate = null, u.alternate = null, u.flags |= 2), o = u.pendingProps, $ = En(u, er.current), ui(u, d), $ = Vc(null, u, g, o, $, d), u.flags |= 1, typeof $ == "object" && $ !== null && typeof $.render == "function" && $.$$typeof === void 0) {
          if (u.tag = 1, u.memoizedState = null, u.updateQueue = null, ya(g)) {
            var _ = !0;
            Si(u);
          } else
            _ = !1;
          u.memoizedState = $.state !== null && $.state !== void 0 ? $.state : null, sf(u);
          var I = g.getDerivedStateFromProps;
          typeof I == "function" && Lu(u, g, I, o), $.updater = Ll, u.stateNode = $, $._reactInternals = u, Fu(u, g, o, d), u = _o(null, u, g, !0, _, d);
        } else
          u.tag = 0, An(null, u, $, d), u = u.child;
        return u;
      case 16:
        $ = u.elementType;
        e: {
          switch (o !== null && (o.alternate = null, u.alternate = null, u.flags |= 2), o = u.pendingProps, _ = $._init, $ = _($._payload), u.type = $, _ = u.tag = o0($), o = $r($, o), _) {
            case 0:
              u = Ci(null, u, $, o, d);
              break e;
            case 1:
              u = es(null, u, $, o, d);
              break e;
            case 11:
              u = Bn(null, u, $, o, d);
              break e;
            case 14:
              u = fn(null, u, $, $r($.type, o), g, d);
              break e;
          }
          throw Error(r(306, $, ""));
        }
        return u;
      case 0:
        return g = u.type, $ = u.pendingProps, $ = u.elementType === g ? $ : $r(g, $), Ci(o, u, g, $, d);
      case 1:
        return g = u.type, $ = u.pendingProps, $ = u.elementType === g ? $ : $r(g, $), es(o, u, g, $, d);
      case 3:
        if (ol(u), g = u.updateQueue, o === null || g === null)
          throw Error(r(282));
        if (g = u.pendingProps, $ = u.memoizedState, $ = $ !== null ? $.element : null, Im(o, u), Ko(u, g, null, d), g = u.memoizedState.element, g === $)
          Bl(), u = sl(o, u, d);
        else {
          if ($ = u.stateNode, (_ = $.hydrate) && (Vn = gs(u.stateNode.containerInfo.firstChild), ra = u, _ = Eo = !0), _) {
            if (o = $.mutableSourceEagerHydrationData, o != null)
              for ($ = 0; $ < o.length; $ += 2)
                _ = o[$], _._workInProgressVersionPrimary = o[$ + 1], Ms.push(_);
            for (d = cf(u, null, g, d), u.child = d; d; )
              d.flags = d.flags & -3 | 1024, d = d.sibling;
          } else
            An(o, u, g, d), Bl();
          u = u.child;
        }
        return u;
      case 5:
        return df(u), o === null && Zo(u), g = u.type, $ = u.pendingProps, _ = o !== null ? o.memoizedProps : null, I = $.children, Tu(g, $) ? I = null : _ !== null && Tu(g, _) && (u.flags |= 16), _n(o, u), An(o, u, I, d), u.child;
      case 6:
        return o === null && Zo(u), null;
      case 13:
        return Da(o, u, d);
      case 4:
        return Fl(u, u.stateNode.containerInfo), g = u.pendingProps, o === null ? u.child = Vu(u, null, g, d) : An(o, u, g, d), u.child;
      case 11:
        return g = u.type, $ = u.pendingProps, $ = u.elementType === g ? $ : $r(g, $), Bn(o, u, g, $, d);
      case 7:
        return An(o, u, u.pendingProps, d), u.child;
      case 8:
        return An(
          o,
          u,
          u.pendingProps.children,
          d
        ), u.child;
      case 12:
        return An(o, u, u.pendingProps.children, d), u.child;
      case 10:
        e: {
          g = u.type._context, $ = u.pendingProps, I = u.memoizedProps, _ = $.value;
          var q = u.type._context;
          if (Lt(Ss, q._currentValue), q._currentValue = _, I !== null)
            if (q = I.value, _ = $i(q, _) ? 0 : (typeof g._calculateChangedBits == "function" ? g._calculateChangedBits(q, _) : 1073741823) | 0, _ === 0) {
              if (I.children === $.children && !kr.current) {
                u = sl(o, u, d);
                break e;
              }
            } else
              for (q = u.child, q !== null && (q.return = u); q !== null; ) {
                var re = q.dependencies;
                if (re !== null) {
                  I = q.child;
                  for (var Se = re.firstContext; Se !== null; ) {
                    if (Se.context === g && Se.observedBits & _) {
                      q.tag === 1 && (Se = ro(-1, d & -d), Se.tag = 2, Qo(q, Se)), q.lanes |= d, Se = q.alternate, Se !== null && (Se.lanes |= d), Mo(q.return, d), re.lanes |= d;
                      break;
                    }
                    Se = Se.next;
                  }
                } else
                  I = q.tag === 10 && q.type === u.type ? null : q.child;
                if (I !== null)
                  I.return = q;
                else
                  for (I = q; I !== null; ) {
                    if (I === u) {
                      I = null;
                      break;
                    }
                    if (q = I.sibling, q !== null) {
                      q.return = I.return, I = q;
                      break;
                    }
                    I = I.return;
                  }
                q = I;
              }
          An(o, u, $.children, d), u = u.child;
        }
        return u;
      case 9:
        return $ = u.type, _ = u.pendingProps, g = _.children, ui(u, d), $ = xi(
          $,
          _.unstable_observedBits
        ), g = g($), u.flags |= 1, An(o, u, g, d), u.child;
      case 14:
        return $ = u.type, _ = $r($, u.pendingProps), _ = $r($.type, _), fn(o, u, $, _, g, d);
      case 15:
        return xn(o, u, u.type, u.pendingProps, g, d);
      case 17:
        return g = u.type, $ = u.pendingProps, $ = u.elementType === g ? $ : $r(g, $), o !== null && (o.alternate = null, u.alternate = null, u.flags |= 2), u.tag = 1, ya(g) ? (o = !0, Si(u)) : o = !1, ui(u, d), tl(u, g, $), Fu(u, g, $, d), _o(null, u, g, !0, o, d);
      case 19:
        return Gw(o, u, d);
      case 23:
        return mn(o, u, d);
      case 24:
        return mn(o, u, d);
    }
    throw Error(r(156, u.tag));
  };
  function i0(o, u, d, g) {
    this.tag = o, this.key = d, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = u, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = g, this.flags = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function To(o, u, d, g) {
    return new i0(o, u, d, g);
  }
  function Qm(o) {
    return o = o.prototype, !(!o || !o.isReactComponent);
  }
  function o0(o) {
    if (typeof o == "function")
      return Qm(o) ? 1 : 0;
    if (o != null) {
      if (o = o.$$typeof, o === Ne)
        return 11;
      if (o === qe)
        return 14;
    }
    return 2;
  }
  function Kl(o, u) {
    var d = o.alternate;
    return d === null ? (d = To(o.tag, u, o.key, o.mode), d.elementType = o.elementType, d.type = o.type, d.stateNode = o.stateNode, d.alternate = o, o.alternate = d) : (d.pendingProps = u, d.type = o.type, d.flags = 0, d.nextEffect = null, d.firstEffect = null, d.lastEffect = null), d.childLanes = o.childLanes, d.lanes = o.lanes, d.child = o.child, d.memoizedProps = o.memoizedProps, d.memoizedState = o.memoizedState, d.updateQueue = o.updateQueue, u = o.dependencies, d.dependencies = u === null ? null : { lanes: u.lanes, firstContext: u.firstContext }, d.sibling = o.sibling, d.index = o.index, d.ref = o.ref, d;
  }
  function xf(o, u, d, g, $, _) {
    var I = 2;
    if (g = o, typeof o == "function")
      Qm(o) && (I = 1);
    else if (typeof o == "string")
      I = 5;
    else
      e:
        switch (o) {
          case ue:
            return Ns(d.children, $, _, u);
          case Be:
            I = 8, $ |= 16;
            break;
          case ye:
            I = 8, $ |= 1;
            break;
          case Oe:
            return o = To(12, d, u, $ | 8), o.elementType = Oe, o.type = Oe, o.lanes = _, o;
          case nt:
            return o = To(13, d, u, $), o.type = nt, o.elementType = nt, o.lanes = _, o;
          case Qe:
            return o = To(19, d, u, $), o.elementType = Qe, o.lanes = _, o;
          case Ce:
            return Zu(d, $, _, u);
          case Ie:
            return o = To(24, d, u, $), o.elementType = Ie, o.lanes = _, o;
          default:
            if (typeof o == "object" && o !== null)
              switch (o.$$typeof) {
                case _e:
                  I = 10;
                  break e;
                case Le:
                  I = 9;
                  break e;
                case Ne:
                  I = 11;
                  break e;
                case qe:
                  I = 14;
                  break e;
                case ie:
                  I = 16, g = null;
                  break e;
                case xe:
                  I = 22;
                  break e;
              }
            throw Error(r(130, o == null ? o : typeof o, ""));
        }
    return u = To(I, d, u, $), u.elementType = o, u.type = g, u.lanes = _, u;
  }
  function Ns(o, u, d, g) {
    return o = To(7, o, g, u), o.lanes = d, o;
  }
  function Zu(o, u, d, g) {
    return o = To(23, o, g, u), o.elementType = Ce, o.lanes = d, o;
  }
  function Ep(o, u, d) {
    return o = To(6, o, null, u), o.lanes = d, o;
  }
  function Ap(o, u, d) {
    return u = To(4, o.children !== null ? o.children : [], o.key, u), u.lanes = d, u.stateNode = { containerInfo: o.containerInfo, pendingChildren: null, implementation: o.implementation }, u;
  }
  function s0(o, u, d) {
    this.tag = u, this.containerInfo = o, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = d, this.callbackNode = null, this.callbackPriority = 0, this.eventTimes = Di(0), this.expirationTimes = Di(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Di(0), this.mutableSourceEagerHydrationData = null;
  }
  function Km(o, u, d) {
    var g = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: ce, key: g == null ? null : "" + g, children: o, containerInfo: u, implementation: d };
  }
  function Jm(o, u, d, g) {
    var $ = u.current, _ = oo(), I = Ds($);
    e:
      if (d) {
        d = d._reactInternals;
        t: {
          if (mr(d) !== d || d.tag !== 1)
            throw Error(r(170));
          var q = d;
          do {
            switch (q.tag) {
              case 3:
                q = q.stateNode.context;
                break t;
              case 1:
                if (ya(q.type)) {
                  q = q.stateNode.__reactInternalMemoizedMergedChildContext;
                  break t;
                }
            }
            q = q.return;
          } while (q !== null);
          throw Error(r(171));
        }
        if (d.tag === 1) {
          var re = d.type;
          if (ya(re)) {
            d = Dl(d, re, q);
            break e;
          }
        }
        d = q;
      } else
        d = ws;
    return u.context === null ? u.context = d : u.pendingContext = d, u = ro(_, I), u.payload = { element: o }, g = g === void 0 ? null : g, g !== null && (u.callback = g), Qo($, u), ql($, I, _), I;
  }
  function Zm(o) {
    if (o = o.current, !o.child)
      return null;
    switch (o.child.tag) {
      case 5:
        return o.child.stateNode;
      default:
        return o.child.stateNode;
    }
  }
  function Fg(o, u) {
    if (o = o.memoizedState, o !== null && o.dehydrated !== null) {
      var d = o.retryLane;
      o.retryLane = d !== 0 && d < u ? d : u;
    }
  }
  function eh(o, u) {
    Fg(o, u), (o = o.alternate) && Fg(o, u);
  }
  function Hg() {
    return null;
  }
  function _p(o, u, d) {
    var g = d != null && d.hydrationOptions != null && d.hydrationOptions.mutableSources || null;
    if (d = new s0(o, u, d != null && d.hydrate === !0), u = To(3, null, null, u === 2 ? 7 : u === 1 ? 3 : 0), d.current = u, u.stateNode = d, sf(u), o[Ta] = d.current, Qd(o.nodeType === 8 ? o.parentNode : o), g)
      for (o = 0; o < g.length; o++) {
        u = g[o];
        var $ = u._getVersion;
        $ = $(u._source), d.mutableSourceEagerHydrationData == null ? d.mutableSourceEagerHydrationData = [u, $] : d.mutableSourceEagerHydrationData.push(u, $);
      }
    this._internalRoot = d;
  }
  _p.prototype.render = function(o) {
    Jm(o, this._internalRoot, null, null);
  }, _p.prototype.unmount = function() {
    var o = this._internalRoot, u = o.containerInfo;
    Jm(null, o, null, function() {
      u[Ta] = null;
    });
  };
  function Cf(o) {
    return !(!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11 && (o.nodeType !== 8 || o.nodeValue !== " react-mount-point-unstable "));
  }
  function l0(o, u) {
    if (u || (u = o ? o.nodeType === 9 ? o.documentElement : o.firstChild : null, u = !(!u || u.nodeType !== 1 || !u.hasAttribute("data-reactroot"))), !u)
      for (var d; d = o.lastChild; )
        o.removeChild(d);
    return new _p(o, 0, u ? { hydrate: !0 } : void 0);
  }
  function th(o, u, d, g, $) {
    var _ = d._reactRootContainer;
    if (_) {
      var I = _._internalRoot;
      if (typeof $ == "function") {
        var q = $;
        $ = function() {
          var Se = Zm(I);
          q.call(Se);
        };
      }
      Jm(u, I, o, $);
    } else {
      if (_ = d._reactRootContainer = l0(d, g), I = _._internalRoot, typeof $ == "function") {
        var re = $;
        $ = function() {
          var Se = Zm(I);
          re.call(Se);
        };
      }
      Dg(function() {
        Jm(u, I, o, $);
      });
    }
    return Zm(I);
  }
  Ki = function(o) {
    if (o.tag === 13) {
      var u = oo();
      ql(o, 4, u), eh(o, 4);
    }
  }, ti = function(o) {
    if (o.tag === 13) {
      var u = oo();
      ql(o, 67108864, u), eh(o, 67108864);
    }
  }, Aa = function(o) {
    if (o.tag === 13) {
      var u = oo(), d = Ds(o);
      ql(o, d, u), eh(o, d);
    }
  }, Ua = function(o, u) {
    return u();
  }, Ha = function(o, u, d) {
    switch (u) {
      case "input":
        if (fa(o, d), u = d.name, d.type === "radio" && u != null) {
          for (d = o; d.parentNode; )
            d = d.parentNode;
          for (d = d.querySelectorAll("input[name=" + JSON.stringify("" + u) + '][type="radio"]'), u = 0; u < d.length; u++) {
            var g = d[u];
            if (g !== o && g.form === o.form) {
              var $ = xo(g);
              if (!$)
                throw Error(r(90));
              Gr(g), fa(g, $);
            }
          }
        }
        break;
      case "textarea":
        Ia(o, d);
        break;
      case "select":
        u = d.value, u != null && Dn(o, !!d.multiple, u, !1);
    }
  }, yo = Rg, Ti = function(o, u, d, g, $) {
    var _ = Ut;
    Ut |= 4;
    try {
      return wa(98, o.bind(null, u, d, g, $));
    } finally {
      Ut = _, Ut === 0 && (qc(), na());
    }
  }, Yi = function() {
    !(Ut & 49) && (e0(), Gl());
  }, Gi = function(o, u) {
    var d = Ut;
    Ut |= 2;
    try {
      return o(u);
    } finally {
      Ut = d, Ut === 0 && (qc(), na());
    }
  };
  function Vg(o, u) {
    var d = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Cf(u))
      throw Error(r(200));
    return Km(o, u, null, d);
  }
  var u0 = { Events: [si, Ya, xo, Jn, or, Gl, { current: !1 }] }, Mf = { findFiberByHostInstance: bs, bundleType: 0, version: "17.0.2", rendererPackageName: "react-dom" }, c0 = { bundleType: Mf.bundleType, version: Mf.version, rendererPackageName: Mf.rendererPackageName, rendererConfig: Mf.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: U.ReactCurrentDispatcher, findHostInstanceByFiber: function(o) {
    return o = Ba(o), o === null ? null : o.stateNode;
  }, findFiberByHostInstance: Mf.findFiberByHostInstance || Hg, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var nh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!nh.isDisabled && nh.supportsFiber)
      try {
        ef = nh.inject(c0), el = nh;
      } catch {
      }
  }
  return ss.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = u0, ss.createPortal = Vg, ss.findDOMNode = function(o) {
    if (o == null)
      return null;
    if (o.nodeType === 1)
      return o;
    var u = o._reactInternals;
    if (u === void 0)
      throw typeof o.render == "function" ? Error(r(188)) : Error(r(268, Object.keys(o)));
    return o = Ba(u), o = o === null ? null : o.stateNode, o;
  }, ss.flushSync = function(o, u) {
    var d = Ut;
    if (d & 48)
      return o(u);
    Ut |= 1;
    try {
      if (o)
        return wa(99, o.bind(null, u));
    } finally {
      Ut = d, na();
    }
  }, ss.hydrate = function(o, u, d) {
    if (!Cf(u))
      throw Error(r(200));
    return th(null, o, u, !0, d);
  }, ss.render = function(o, u, d) {
    if (!Cf(u))
      throw Error(r(200));
    return th(null, o, u, !1, d);
  }, ss.unmountComponentAtNode = function(o) {
    if (!Cf(o))
      throw Error(r(40));
    return o._reactRootContainer ? (Dg(function() {
      th(null, null, o, !1, function() {
        o._reactRootContainer = null, o[Ta] = null;
      });
    }), !0) : !1;
  }, ss.unstable_batchedUpdates = Rg, ss.unstable_createPortal = function(o, u) {
    return Vg(o, u, 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null);
  }, ss.unstable_renderSubtreeIntoContainer = function(o, u, d, g) {
    if (!Cf(d))
      throw Error(r(200));
    if (o == null || o._reactInternals === void 0)
      throw Error(r(38));
    return th(o, u, d, !1, g);
  }, ss.version = "17.0.2", ss;
}
var ls = {}, Kk = { exports: {} }, pl = {};
var h_;
function eX() {
  if (h_)
    return pl;
  h_ = 1;
  var e = 0;
  return pl.__interactionsRef = null, pl.__subscriberRef = null, pl.unstable_clear = function(t) {
    return t();
  }, pl.unstable_getCurrent = function() {
    return null;
  }, pl.unstable_getThreadID = function() {
    return ++e;
  }, pl.unstable_subscribe = function() {
  }, pl.unstable_trace = function(t, n, r) {
    return r();
  }, pl.unstable_unsubscribe = function() {
  }, pl.unstable_wrap = function(t) {
    return t;
  }, pl;
}
var Jk = {};
var p_;
function tX() {
  return p_ || (p_ = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = 0, n = 0, r = 0;
      e.__interactionsRef = null, e.__subscriberRef = null, e.__interactionsRef = {
        current: /* @__PURE__ */ new Set()
      }, e.__subscriberRef = {
        current: null
      };
      function s(J) {
        var V = e.__interactionsRef.current;
        e.__interactionsRef.current = /* @__PURE__ */ new Set();
        try {
          return J();
        } finally {
          e.__interactionsRef.current = V;
        }
      }
      function f() {
        return e.__interactionsRef.current;
      }
      function m() {
        return ++r;
      }
      function p(J, V, X) {
        var U = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : t, K = {
          __count: 1,
          id: n++,
          name: J,
          timestamp: V
        }, ce = e.__interactionsRef.current, ue = new Set(ce);
        ue.add(K), e.__interactionsRef.current = ue;
        var ye = e.__subscriberRef.current, Oe;
        try {
          ye !== null && ye.onInteractionTraced(K);
        } finally {
          try {
            ye !== null && ye.onWorkStarted(ue, U);
          } finally {
            try {
              Oe = X();
            } finally {
              e.__interactionsRef.current = ce;
              try {
                ye !== null && ye.onWorkStopped(ue, U);
              } finally {
                K.__count--, ye !== null && K.__count === 0 && ye.onInteractionScheduledWorkCompleted(K);
              }
            }
          }
        }
        return Oe;
      }
      function v(J) {
        var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, X = e.__interactionsRef.current, U = e.__subscriberRef.current;
        U !== null && U.onWorkScheduled(X, V), X.forEach(function(ue) {
          ue.__count++;
        });
        var K = !1;
        function ce() {
          var ue = e.__interactionsRef.current;
          e.__interactionsRef.current = X, U = e.__subscriberRef.current;
          try {
            var ye;
            try {
              U !== null && U.onWorkStarted(X, V);
            } finally {
              try {
                ye = J.apply(void 0, arguments);
              } finally {
                e.__interactionsRef.current = ue, U !== null && U.onWorkStopped(X, V);
              }
            }
            return ye;
          } finally {
            K || (K = !0, X.forEach(function(Oe) {
              Oe.__count--, U !== null && Oe.__count === 0 && U.onInteractionScheduledWorkCompleted(Oe);
            }));
          }
        }
        return ce.cancel = function() {
          U = e.__subscriberRef.current;
          try {
            U !== null && U.onWorkCanceled(X, V);
          } finally {
            X.forEach(function(ye) {
              ye.__count--, U && ye.__count === 0 && U.onInteractionScheduledWorkCompleted(ye);
            });
          }
        }, ce;
      }
      var y = null;
      y = /* @__PURE__ */ new Set();
      function w(J) {
        y.add(J), y.size === 1 && (e.__subscriberRef.current = {
          onInteractionScheduledWorkCompleted: A,
          onInteractionTraced: x,
          onWorkCanceled: H,
          onWorkScheduled: M,
          onWorkStarted: O,
          onWorkStopped: j
        });
      }
      function P(J) {
        y.delete(J), y.size === 0 && (e.__subscriberRef.current = null);
      }
      function x(J) {
        var V = !1, X = null;
        if (y.forEach(function(U) {
          try {
            U.onInteractionTraced(J);
          } catch (K) {
            V || (V = !0, X = K);
          }
        }), V)
          throw X;
      }
      function A(J) {
        var V = !1, X = null;
        if (y.forEach(function(U) {
          try {
            U.onInteractionScheduledWorkCompleted(J);
          } catch (K) {
            V || (V = !0, X = K);
          }
        }), V)
          throw X;
      }
      function M(J, V) {
        var X = !1, U = null;
        if (y.forEach(function(K) {
          try {
            K.onWorkScheduled(J, V);
          } catch (ce) {
            X || (X = !0, U = ce);
          }
        }), X)
          throw U;
      }
      function O(J, V) {
        var X = !1, U = null;
        if (y.forEach(function(K) {
          try {
            K.onWorkStarted(J, V);
          } catch (ce) {
            X || (X = !0, U = ce);
          }
        }), X)
          throw U;
      }
      function j(J, V) {
        var X = !1, U = null;
        if (y.forEach(function(K) {
          try {
            K.onWorkStopped(J, V);
          } catch (ce) {
            X || (X = !0, U = ce);
          }
        }), X)
          throw U;
      }
      function H(J, V) {
        var X = !1, U = null;
        if (y.forEach(function(K) {
          try {
            K.onWorkCanceled(J, V);
          } catch (ce) {
            X || (X = !0, U = ce);
          }
        }), X)
          throw U;
      }
      e.unstable_clear = s, e.unstable_getCurrent = f, e.unstable_getThreadID = m, e.unstable_subscribe = w, e.unstable_trace = p, e.unstable_unsubscribe = P, e.unstable_wrap = v;
    }();
  }(Jk)), Jk;
}
var v_;
function nX() {
  return v_ || (v_ = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = eX() : e.exports = tX();
  }(Kk)), Kk.exports;
}
var g_;
function rX() {
  return g_ || (g_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = F.exports, t = Aw(), n = eD(), r = nX(), s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function f(a) {
      {
        for (var i = arguments.length, l = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
          l[c - 1] = arguments[c];
        p("warn", a, l);
      }
    }
    function m(a) {
      {
        for (var i = arguments.length, l = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
          l[c - 1] = arguments[c];
        p("error", a, l);
      }
    }
    function p(a, i, l) {
      {
        var c = s.ReactDebugCurrentFrame, h = c.getStackAddendum();
        h !== "" && (i += "%s", l = l.concat([h]));
        var b = l.map(function(S) {
          return "" + S;
        });
        b.unshift("Warning: " + i), Function.prototype.apply.call(console[a], console, b);
      }
    }
    if (!e)
      throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
    var v = 0, y = 1, w = 2, P = 3, x = 4, A = 5, M = 6, O = 7, j = 8, H = 9, J = 10, V = 11, X = 12, U = 13, K = 14, ce = 15, ue = 16, ye = 17, Oe = 18, _e = 19, Le = 20, Ne = 21, nt = 22, Qe = 23, qe = 24, ie = !0, xe = !1, Ye = !1, Be = !1, Ce = /* @__PURE__ */ new Set(), Ie = {}, $e = {};
    function ot(a, i) {
      ht(a, i), ht(a + "Capture", i);
    }
    function ht(a, i) {
      Ie[a] && m("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", a), Ie[a] = i;
      {
        var l = a.toLowerCase();
        $e[l] = a, a === "onDoubleClick" && ($e.ondblclick = a);
      }
      for (var c = 0; c < i.length; c++)
        Ce.add(i[c]);
    }
    var At = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Sn = 0, Gt = 1, Bt = 2, Qn = 3, cn = 4, Ge = 5, vr = 6, Fn = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", en = Fn + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Gr = "data-reactroot", da = new RegExp("^[" + Fn + "][" + en + "]*$"), gr = Object.prototype.hasOwnProperty, qi = {}, Wr = {};
    function fa(a) {
      return gr.call(Wr, a) ? !0 : gr.call(qi, a) ? !1 : da.test(a) ? (Wr[a] = !0, !0) : (qi[a] = !0, m("Invalid attribute name: `%s`", a), !1);
    }
    function xa(a, i, l) {
      return i !== null ? i.type === Sn : l ? !1 : a.length > 2 && (a[0] === "o" || a[0] === "O") && (a[1] === "n" || a[1] === "N");
    }
    function fr(a, i, l, c) {
      if (l !== null && l.type === Sn)
        return !1;
      switch (typeof i) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (c)
            return !1;
          if (l !== null)
            return !l.acceptsBooleans;
          var h = a.toLowerCase().slice(0, 5);
          return h !== "data-" && h !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Xn(a, i, l, c) {
      if (i === null || typeof i > "u" || fr(a, i, l, c))
        return !0;
      if (c)
        return !1;
      if (l !== null)
        switch (l.type) {
          case Qn:
            return !i;
          case cn:
            return i === !1;
          case Ge:
            return isNaN(i);
          case vr:
            return isNaN(i) || i < 1;
        }
      return !1;
    }
    function Hr(a) {
      return Nn.hasOwnProperty(a) ? Nn[a] : null;
    }
    function Dn(a, i, l, c, h, b, S) {
      this.acceptsBooleans = i === Bt || i === Qn || i === cn, this.attributeName = c, this.attributeNamespace = h, this.mustUseProperty = l, this.propertyName = a, this.type = i, this.sanitizeURL = b, this.removeEmptyString = S;
    }
    var Nn = {}, Ca = [
      "children",
      "dangerouslySetInnerHTML",
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    Ca.forEach(function(a) {
      Nn[a] = new Dn(
        a,
        Sn,
        !1,
        a,
        null,
        !1,
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
      var i = a[0], l = a[1];
      Nn[i] = new Dn(
        i,
        Gt,
        !1,
        l,
        null,
        !1,
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
      Nn[a] = new Dn(
        a,
        Bt,
        !1,
        a.toLowerCase(),
        null,
        !1,
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
      Nn[a] = new Dn(
        a,
        Bt,
        !1,
        a,
        null,
        !1,
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      "itemScope"
    ].forEach(function(a) {
      Nn[a] = new Dn(
        a,
        Qn,
        !1,
        a.toLowerCase(),
        null,
        !1,
        !1
      );
    }), [
      "checked",
      "multiple",
      "muted",
      "selected"
    ].forEach(function(a) {
      Nn[a] = new Dn(
        a,
        Qn,
        !0,
        a,
        null,
        !1,
        !1
      );
    }), [
      "capture",
      "download"
    ].forEach(function(a) {
      Nn[a] = new Dn(
        a,
        cn,
        !1,
        a,
        null,
        !1,
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
    ].forEach(function(a) {
      Nn[a] = new Dn(
        a,
        vr,
        !1,
        a,
        null,
        !1,
        !1
      );
    }), ["rowSpan", "start"].forEach(function(a) {
      Nn[a] = new Dn(
        a,
        Ge,
        !1,
        a.toLowerCase(),
        null,
        !1,
        !1
      );
    });
    var Ia = /[\-\:]([a-z])/g, Fa = function(a) {
      return a[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
    ].forEach(function(a) {
      var i = a.replace(Ia, Fa);
      Nn[i] = new Dn(
        i,
        Gt,
        !1,
        a,
        null,
        !1,
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
    ].forEach(function(a) {
      var i = a.replace(Ia, Fa);
      Nn[i] = new Dn(
        i,
        Gt,
        !1,
        a,
        "http://www.w3.org/1999/xlink",
        !1,
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
    ].forEach(function(a) {
      var i = a.replace(Ia, Fa);
      Nn[i] = new Dn(
        i,
        Gt,
        !1,
        a,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(a) {
      Nn[a] = new Dn(
        a,
        Gt,
        !1,
        a.toLowerCase(),
        null,
        !1,
        !1
      );
    });
    var et = "xlinkHref";
    Nn[et] = new Dn(
      "xlinkHref",
      Gt,
      !1,
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(a) {
      Nn[a] = new Dn(
        a,
        Gt,
        !1,
        a.toLowerCase(),
        null,
        !0,
        !0
      );
    });
    var ft = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, _t = !1;
    function an(a) {
      !_t && ft.test(a) && (_t = !0, m("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(a)));
    }
    function ir(a, i, l, c) {
      if (c.mustUseProperty) {
        var h = c.propertyName;
        return a[h];
      } else {
        c.sanitizeURL && an("" + l);
        var b = c.attributeName, S = null;
        if (c.type === cn) {
          if (a.hasAttribute(b)) {
            var E = a.getAttribute(b);
            return E === "" ? !0 : Xn(i, l, c, !1) ? E : E === "" + l ? l : E;
          }
        } else if (a.hasAttribute(b)) {
          if (Xn(i, l, c, !1))
            return a.getAttribute(b);
          if (c.type === Qn)
            return l;
          S = a.getAttribute(b);
        }
        return Xn(i, l, c, !1) ? S === null ? l : S : S === "" + l ? l : S;
      }
    }
    function pn(a, i, l) {
      {
        if (!fa(i))
          return;
        if (Pj(l))
          return l;
        if (!a.hasAttribute(i))
          return l === void 0 ? void 0 : null;
        var c = a.getAttribute(i);
        return c === "" + l ? l : c;
      }
    }
    function vn(a, i, l, c) {
      var h = Hr(i);
      if (!xa(i, h, c)) {
        if (Xn(i, l, h, c) && (l = null), c || h === null) {
          if (fa(i)) {
            var b = i;
            l === null ? a.removeAttribute(b) : a.setAttribute(b, "" + l);
          }
          return;
        }
        var S = h.mustUseProperty;
        if (S) {
          var E = h.propertyName;
          if (l === null) {
            var z = h.type;
            a[E] = z === Qn ? !1 : "";
          } else
            a[E] = l;
          return;
        }
        var G = h.attributeName, ee = h.attributeNamespace;
        if (l === null)
          a.removeAttribute(G);
        else {
          var we = h.type, ae;
          we === Qn || we === cn && l === !0 ? ae = "" : (ae = "" + l, h.sanitizeURL && an(ae.toString())), ee ? a.setAttributeNS(ee, G, ae) : a.setAttribute(G, ae);
        }
      }
    }
    var Kn = 60103, Pn = 60106, Vr = 60107, pi = 60108, Ar = 60114, Oi = 60109, Qr = 60110, Ha = 60112, ma = 60113, Kr = 60120, Ka = 60115, Jn = 60116, or = 60121, yo = 60119, Ti = 60128, Yi = 60129, Gi = 60130, Ma = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var Zt = Symbol.for;
      Kn = Zt("react.element"), Pn = Zt("react.portal"), Vr = Zt("react.fragment"), pi = Zt("react.strict_mode"), Ar = Zt("react.profiler"), Oi = Zt("react.provider"), Qr = Zt("react.context"), Ha = Zt("react.forward_ref"), ma = Zt("react.suspense"), Kr = Zt("react.suspense_list"), Ka = Zt("react.memo"), Jn = Zt("react.lazy"), or = Zt("react.block"), Zt("react.server.block"), Zt("react.fundamental"), yo = Zt("react.scope"), Ti = Zt("react.opaque.id"), Yi = Zt("react.debug_trace_mode"), Gi = Zt("react.offscreen"), Ma = Zt("react.legacy_hidden");
    }
    var gi = typeof Symbol == "function" && Symbol.iterator, qs = "@@iterator";
    function Jr(a) {
      if (a === null || typeof a != "object")
        return null;
      var i = gi && a[gi] || a[qs];
      return typeof i == "function" ? i : null;
    }
    var ha = 0, yi, Br, Ja, Ri, bi, Qi, bo;
    function Za() {
    }
    Za.__reactDisabledLog = !0;
    function Zr() {
      {
        if (ha === 0) {
          yi = console.log, Br = console.info, Ja = console.warn, Ri = console.error, bi = console.group, Qi = console.groupCollapsed, bo = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: Za,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        ha++;
      }
    }
    function mr() {
      {
        if (ha--, ha === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: t({}, a, {
              value: yi
            }),
            info: t({}, a, {
              value: Br
            }),
            warn: t({}, a, {
              value: Ja
            }),
            error: t({}, a, {
              value: Ri
            }),
            group: t({}, a, {
              value: bi
            }),
            groupCollapsed: t({}, a, {
              value: Qi
            }),
            groupEnd: t({}, a, {
              value: bo
            })
          });
        }
        ha < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Va = s.ReactCurrentDispatcher, ei;
    function pa(a, i, l) {
      {
        if (ei === void 0)
          try {
            throw Error();
          } catch (h) {
            var c = h.stack.trim().match(/\n( *(at )?)/);
            ei = c && c[1] || "";
          }
        return `
` + ei + a;
      }
    }
    var Ba = !1, Ea;
    {
      var Ki = typeof WeakMap == "function" ? WeakMap : Map;
      Ea = new Ki();
    }
    function ti(a, i) {
      if (!a || Ba)
        return "";
      {
        var l = Ea.get(a);
        if (l !== void 0)
          return l;
      }
      var c;
      Ba = !0;
      var h = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var b;
      b = Va.current, Va.current = null, Zr();
      try {
        if (i) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ze) {
              c = ze;
            }
            Reflect.construct(a, [], S);
          } else {
            try {
              S.call();
            } catch (ze) {
              c = ze;
            }
            a.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ze) {
            c = ze;
          }
          a();
        }
      } catch (ze) {
        if (ze && c && typeof ze.stack == "string") {
          for (var E = ze.stack.split(`
`), z = c.stack.split(`
`), G = E.length - 1, ee = z.length - 1; G >= 1 && ee >= 0 && E[G] !== z[ee]; )
            ee--;
          for (; G >= 1 && ee >= 0; G--, ee--)
            if (E[G] !== z[ee]) {
              if (G !== 1 || ee !== 1)
                do
                  if (G--, ee--, ee < 0 || E[G] !== z[ee]) {
                    var we = `
` + E[G].replace(" at new ", " at ");
                    return typeof a == "function" && Ea.set(a, we), we;
                  }
                while (G >= 1 && ee >= 0);
              break;
            }
        }
      } finally {
        Ba = !1, Va.current = b, mr(), Error.prepareStackTrace = h;
      }
      var ae = a ? a.displayName || a.name : "", ke = ae ? pa(ae) : "";
      return typeof a == "function" && Ea.set(a, ke), ke;
    }
    function Aa(a, i, l) {
      return ti(a, !0);
    }
    function Ua(a, i, l) {
      return ti(a, !1);
    }
    function va(a) {
      var i = a.prototype;
      return !!(i && i.isReactComponent);
    }
    function Ur(a, i, l) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return ti(a, va(a));
      if (typeof a == "string")
        return pa(a);
      switch (a) {
        case ma:
          return pa("Suspense");
        case Kr:
          return pa("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case Ha:
            return Ua(a.render);
          case Ka:
            return Ur(a.type, i, l);
          case or:
            return Ua(a._render);
          case Jn: {
            var c = a, h = c._payload, b = c._init;
            try {
              return Ur(b(h), i, l);
            } catch {
            }
          }
        }
      return "";
    }
    function Xa(a) {
      switch (a._debugOwner && a._debugOwner.type, a._debugSource, a.tag) {
        case A:
          return pa(a.type);
        case ue:
          return pa("Lazy");
        case U:
          return pa("Suspense");
        case _e:
          return pa("SuspenseList");
        case v:
        case w:
        case ce:
          return Ua(a.type);
        case V:
          return Ua(a.type.render);
        case nt:
          return Ua(a.type._render);
        case y:
          return Aa(a.type);
        default:
          return "";
      }
    }
    function ea(a) {
      try {
        var i = "", l = a;
        do
          i += Xa(l), l = l.return;
        while (l);
        return i;
      } catch (c) {
        return `
Error generating stack: ` + c.message + `
` + c.stack;
      }
    }
    function ni(a, i, l) {
      var c = i.displayName || i.name || "";
      return a.displayName || (c !== "" ? l + "(" + c + ")" : l);
    }
    function Xr(a) {
      return a.displayName || "Context";
    }
    function Je(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && m("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case Vr:
          return "Fragment";
        case Pn:
          return "Portal";
        case Ar:
          return "Profiler";
        case pi:
          return "StrictMode";
        case ma:
          return "Suspense";
        case Kr:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case Qr:
            var i = a;
            return Xr(i) + ".Consumer";
          case Oi:
            var l = a;
            return Xr(l._context) + ".Provider";
          case Ha:
            return ni(a, a.render, "ForwardRef");
          case Ka:
            return Je(a.type);
          case or:
            return Je(a._render);
          case Jn: {
            var c = a, h = c._payload, b = c._init;
            try {
              return Je(b(h));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ri = s.ReactDebugCurrentFrame, _r = null, ai = !1;
    function _a() {
      {
        if (_r === null)
          return null;
        var a = _r._debugOwner;
        if (a !== null && typeof a < "u")
          return Je(a.type);
      }
      return null;
    }
    function wi() {
      return _r === null ? "" : ea(_r);
    }
    function yr() {
      ri.getCurrentStack = null, _r = null, ai = !1;
    }
    function qn(a) {
      ri.getCurrentStack = wi, _r = a, ai = !1;
    }
    function Or(a) {
      ai = a;
    }
    function ms() {
      return ai;
    }
    function br(a) {
      return "" + a;
    }
    function lr(a) {
      switch (typeof a) {
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
          return a;
        default:
          return "";
      }
    }
    var wo = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function ta(a, i) {
      wo[i.type] || i.onChange || i.onInput || i.readOnly || i.disabled || i.value == null || m("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), i.onChange || i.readOnly || i.disabled || i.checked == null || m("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function ii(a) {
      var i = a.type, l = a.nodeName;
      return l && l.toLowerCase() === "input" && (i === "checkbox" || i === "radio");
    }
    function Po(a) {
      return a._valueTracker;
    }
    function ko(a) {
      a._valueTracker = null;
    }
    function $o(a) {
      var i = "";
      return a && (ii(a) ? i = a.checked ? "true" : "false" : i = a.value), i;
    }
    function hs(a) {
      var i = ii(a) ? "checked" : "value", l = Object.getOwnPropertyDescriptor(a.constructor.prototype, i), c = "" + a[i];
      if (!(a.hasOwnProperty(i) || typeof l > "u" || typeof l.get != "function" || typeof l.set != "function")) {
        var h = l.get, b = l.set;
        Object.defineProperty(a, i, {
          configurable: !0,
          get: function() {
            return h.call(this);
          },
          set: function(E) {
            c = "" + E, b.call(this, E);
          }
        }), Object.defineProperty(a, i, {
          enumerable: l.enumerable
        });
        var S = {
          getValue: function() {
            return c;
          },
          setValue: function(E) {
            c = "" + E;
          },
          stopTracking: function() {
            ko(a), delete a[i];
          }
        };
        return S;
      }
    }
    function L(a) {
      Po(a) || (a._valueTracker = hs(a));
    }
    function oe(a) {
      if (!a)
        return !1;
      var i = Po(a);
      if (!i)
        return !0;
      var l = i.getValue(), c = $o(a);
      return c !== l ? (i.setValue(c), !0) : !1;
    }
    function be(a) {
      if (a = a || (typeof document < "u" ? document : void 0), typeof a > "u")
        return null;
      try {
        return a.activeElement || a.body;
      } catch {
        return a.body;
      }
    }
    var Ee = !1, Ze = !1, Et = !1, wt = !1;
    function xt(a) {
      var i = a.type === "checkbox" || a.type === "radio";
      return i ? a.checked != null : a.value != null;
    }
    function Pt(a, i) {
      var l = a, c = i.checked, h = t({}, i, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: c ?? l._wrapperState.initialChecked
      });
      return h;
    }
    function Qt(a, i) {
      ta("input", i), i.checked !== void 0 && i.defaultChecked !== void 0 && !Ze && (m("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", _a() || "A component", i.type), Ze = !0), i.value !== void 0 && i.defaultValue !== void 0 && !Ee && (m("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", _a() || "A component", i.type), Ee = !0);
      var l = a, c = i.defaultValue == null ? "" : i.defaultValue;
      l._wrapperState = {
        initialChecked: i.checked != null ? i.checked : i.defaultChecked,
        initialValue: lr(i.value != null ? i.value : c),
        controlled: xt(i)
      };
    }
    function dn(a, i) {
      var l = a, c = i.checked;
      c != null && vn(l, "checked", c, !1);
    }
    function Wn(a, i) {
      var l = a;
      {
        var c = xt(i);
        !l._wrapperState.controlled && c && !wt && (m("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), wt = !0), l._wrapperState.controlled && !c && !Et && (m("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Et = !0);
      }
      dn(a, i);
      var h = lr(i.value), b = i.type;
      if (h != null)
        b === "number" ? (h === 0 && l.value === "" || l.value != h) && (l.value = br(h)) : l.value !== br(h) && (l.value = br(h));
      else if (b === "submit" || b === "reset") {
        l.removeAttribute("value");
        return;
      }
      i.hasOwnProperty("value") ? ga(l, i.type, h) : i.hasOwnProperty("defaultValue") && ga(l, i.type, lr(i.defaultValue)), i.checked == null && i.defaultChecked != null && (l.defaultChecked = !!i.defaultChecked);
    }
    function Hn(a, i, l) {
      var c = a;
      if (i.hasOwnProperty("value") || i.hasOwnProperty("defaultValue")) {
        var h = i.type, b = h === "submit" || h === "reset";
        if (b && (i.value === void 0 || i.value === null))
          return;
        var S = br(c._wrapperState.initialValue);
        l || S !== c.value && (c.value = S), c.defaultValue = S;
      }
      var E = c.name;
      E !== "" && (c.name = ""), c.defaultChecked = !c.defaultChecked, c.defaultChecked = !!c._wrapperState.initialChecked, E !== "" && (c.name = E);
    }
    function wr(a, i) {
      var l = a;
      Wn(l, i), jn(l, i);
    }
    function jn(a, i) {
      var l = i.name;
      if (i.type === "radio" && l != null) {
        for (var c = a; c.parentNode; )
          c = c.parentNode;
        for (var h = c.querySelectorAll("input[name=" + JSON.stringify("" + l) + '][type="radio"]'), b = 0; b < h.length; b++) {
          var S = h[b];
          if (!(S === a || S.form !== a.form)) {
            var E = ty(S);
            if (!E)
              throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            oe(S), Wn(S, E);
          }
        }
      }
    }
    function ga(a, i, l) {
      (i !== "number" || be(a.ownerDocument) !== a) && (l == null ? a.defaultValue = br(a._wrapperState.initialValue) : a.defaultValue !== br(l) && (a.defaultValue = br(l)));
    }
    var Di = !1, B = !1;
    function ve(a) {
      var i = "";
      return e.Children.forEach(a, function(l) {
        l != null && (i += l);
      }), i;
    }
    function N(a, i) {
      typeof i.children == "object" && i.children !== null && e.Children.forEach(i.children, function(l) {
        l != null && (typeof l == "string" || typeof l == "number" || typeof l.type == "string" && (B || (B = !0, m("Only strings and numbers are supported as <option> children."))));
      }), i.selected != null && !Di && (m("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Di = !0);
    }
    function Z(a, i) {
      i.value != null && a.setAttribute("value", br(lr(i.value)));
    }
    function de(a, i) {
      var l = t({
        children: void 0
      }, i), c = ve(i.children);
      return c && (l.children = c), l;
    }
    var Ke;
    Ke = !1;
    function Tt() {
      var a = _a();
      return a ? `

Check the render method of \`` + a + "`." : "";
    }
    var Nt = ["value", "defaultValue"];
    function Mn(a) {
      {
        ta("select", a);
        for (var i = 0; i < Nt.length; i++) {
          var l = Nt[i];
          if (a[l] != null) {
            var c = Array.isArray(a[l]);
            a.multiple && !c ? m("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", l, Tt()) : !a.multiple && c && m("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", l, Tt());
          }
        }
      }
    }
    function Wt(a, i, l, c) {
      var h = a.options;
      if (i) {
        for (var b = l, S = {}, E = 0; E < b.length; E++)
          S["$" + b[E]] = !0;
        for (var z = 0; z < h.length; z++) {
          var G = S.hasOwnProperty("$" + h[z].value);
          h[z].selected !== G && (h[z].selected = G), G && c && (h[z].defaultSelected = !0);
        }
      } else {
        for (var ee = br(lr(l)), we = null, ae = 0; ae < h.length; ae++) {
          if (h[ae].value === ee) {
            h[ae].selected = !0, c && (h[ae].defaultSelected = !0);
            return;
          }
          we === null && !h[ae].disabled && (we = h[ae]);
        }
        we !== null && (we.selected = !0);
      }
    }
    function yn(a, i) {
      return t({}, i, {
        value: void 0
      });
    }
    function jr(a, i) {
      var l = a;
      Mn(i), l._wrapperState = {
        wasMultiple: !!i.multiple
      }, i.value !== void 0 && i.defaultValue !== void 0 && !Ke && (m("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Ke = !0);
    }
    function sr(a, i) {
      var l = a;
      l.multiple = !!i.multiple;
      var c = i.value;
      c != null ? Wt(l, !!i.multiple, c, !1) : i.defaultValue != null && Wt(l, !!i.multiple, i.defaultValue, !0);
    }
    function Pi(a, i) {
      var l = a, c = l._wrapperState.wasMultiple;
      l._wrapperState.wasMultiple = !!i.multiple;
      var h = i.value;
      h != null ? Wt(l, !!i.multiple, h, !1) : c !== !!i.multiple && (i.defaultValue != null ? Wt(l, !!i.multiple, i.defaultValue, !0) : Wt(l, !!i.multiple, i.multiple ? [] : "", !1));
    }
    function ki(a, i) {
      var l = a, c = i.value;
      c != null && Wt(l, !!i.multiple, c, !1);
    }
    var Ys = !1;
    function So(a, i) {
      var l = a;
      if (i.dangerouslySetInnerHTML != null)
        throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var c = t({}, i, {
        value: void 0,
        defaultValue: void 0,
        children: br(l._wrapperState.initialValue)
      });
      return c;
    }
    function yu(a, i) {
      var l = a;
      ta("textarea", i), i.value !== void 0 && i.defaultValue !== void 0 && !Ys && (m("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", _a() || "A component"), Ys = !0);
      var c = i.value;
      if (c == null) {
        var h = i.children, b = i.defaultValue;
        if (h != null) {
          m("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (b != null)
              throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Array.isArray(h)) {
              if (!(h.length <= 1))
                throw Error("<textarea> can only have at most one child.");
              h = h[0];
            }
            b = h;
          }
        }
        b == null && (b = ""), c = b;
      }
      l._wrapperState = {
        initialValue: lr(c)
      };
    }
    function Td(a, i) {
      var l = a, c = lr(i.value), h = lr(i.defaultValue);
      if (c != null) {
        var b = br(c);
        b !== l.value && (l.value = b), i.defaultValue == null && l.defaultValue !== b && (l.defaultValue = b);
      }
      h != null && (l.defaultValue = br(h));
    }
    function oi(a, i) {
      var l = a, c = l.textContent;
      c === l._wrapperState.initialValue && c !== "" && c !== null && (l.value = c);
    }
    function Sl(a, i) {
      Td(a, i);
    }
    var xl = "http://www.w3.org/1999/xhtml", Cl = "http://www.w3.org/1998/Math/MathML", Rd = "http://www.w3.org/2000/svg", Cc = {
      html: xl,
      mathml: Cl,
      svg: Rd
    };
    function bu(a) {
      switch (a) {
        case "svg":
          return Rd;
        case "math":
          return Cl;
        default:
          return xl;
      }
    }
    function Gs(a, i) {
      return a == null || a === xl ? bu(i) : a === Rd && i === "foreignObject" ? xl : a;
    }
    var wu = function(a) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(i, l, c, h) {
        MSApp.execUnsafeLocalFunction(function() {
          return a(i, l, c, h);
        });
      } : a;
    }, Pu, pm = wu(function(a, i) {
      if (a.namespaceURI === Cc.svg && !("innerHTML" in a)) {
        Pu = Pu || document.createElement("div"), Pu.innerHTML = "<svg>" + i.valueOf().toString() + "</svg>";
        for (var l = Pu.firstChild; a.firstChild; )
          a.removeChild(a.firstChild);
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        return;
      }
      a.innerHTML = i;
    }), Ni = 1, Ho = 3, Oa = 8, ps = 9, vm = 11, Mc = function(a, i) {
      if (i) {
        var l = a.firstChild;
        if (l && l === a.lastChild && l.nodeType === Ho) {
          l.nodeValue = i;
          return;
        }
      }
      a.textContent = i;
    }, ap = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, ku = {
      animationIterationCount: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function gm(a, i) {
      return a + i.charAt(0).toUpperCase() + i.substring(1);
    }
    var ym = ["Webkit", "ms", "Moz", "O"];
    Object.keys(ku).forEach(function(a) {
      ym.forEach(function(i) {
        ku[gm(i, a)] = ku[a];
      });
    });
    function Ml(a, i, l) {
      var c = i == null || typeof i == "boolean" || i === "";
      return c ? "" : !l && typeof i == "number" && i !== 0 && !(ku.hasOwnProperty(a) && ku[a]) ? i + "px" : ("" + i).trim();
    }
    var Dd = /([A-Z])/g, bm = /^ms-/;
    function Nd(a) {
      return a.replace(Dd, "-$1").toLowerCase().replace(bm, "-ms-");
    }
    var Wd = function() {
    };
    {
      var ip = /^(?:webkit|moz|o)[A-Z]/, wm = /^-ms-/, Pm = /-(.)/g, El = /;\s*$/, Al = {}, jd = {}, km = !1, $m = !1, op = function(a) {
        return a.replace(Pm, function(i, l) {
          return l.toUpperCase();
        });
      }, sp = function(a) {
        Al.hasOwnProperty(a) && Al[a] || (Al[a] = !0, m(
          "Unsupported style property %s. Did you mean %s?",
          a,
          op(a.replace(wm, "ms-"))
        ));
      }, zd = function(a) {
        Al.hasOwnProperty(a) && Al[a] || (Al[a] = !0, m("Unsupported vendor-prefixed style property %s. Did you mean %s?", a, a.charAt(0).toUpperCase() + a.slice(1)));
      }, $u = function(a, i) {
        jd.hasOwnProperty(i) && jd[i] || (jd[i] = !0, m(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, a, i.replace(El, "")));
      }, lp = function(a, i) {
        km || (km = !0, m("`NaN` is an invalid value for the `%s` css style property.", a));
      }, Ld = function(a, i) {
        $m || ($m = !0, m("`Infinity` is an invalid value for the `%s` css style property.", a));
      };
      Wd = function(a, i) {
        a.indexOf("-") > -1 ? sp(a) : ip.test(a) ? zd(a) : El.test(i) && $u(a, i), typeof i == "number" && (isNaN(i) ? lp(a, i) : isFinite(i) || Ld(a, i));
      };
    }
    var Id = Wd;
    function Sm(a) {
      {
        var i = "", l = "";
        for (var c in a)
          if (a.hasOwnProperty(c)) {
            var h = a[c];
            if (h != null) {
              var b = c.indexOf("--") === 0;
              i += l + (b ? c : Nd(c)) + ":", i += Ml(c, h, b), l = ";";
            }
          }
        return i || null;
      }
    }
    function Fd(a, i) {
      var l = a.style;
      for (var c in i)
        if (i.hasOwnProperty(c)) {
          var h = c.indexOf("--") === 0;
          h || Id(c, i[c]);
          var b = Ml(c, i[c], h);
          c === "float" && (c = "cssFloat"), h ? l.setProperty(c, b) : l[c] = b;
        }
    }
    function xm(a) {
      return a == null || typeof a == "boolean" || a === "";
    }
    function Vo(a) {
      var i = {};
      for (var l in a)
        for (var c = ap[l] || [l], h = 0; h < c.length; h++)
          i[c[h]] = l;
      return i;
    }
    function Cm(a, i) {
      {
        if (!i)
          return;
        var l = Vo(a), c = Vo(i), h = {};
        for (var b in l) {
          var S = l[b], E = c[b];
          if (E && S !== E) {
            var z = S + "," + E;
            if (h[z])
              continue;
            h[z] = !0, m("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", xm(a[S]) ? "Removing" : "Updating", S, E);
          }
        }
      }
    }
    var Mm = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
    }, Em = t({
      menuitem: !0
    }, Mm), Hd = "__html";
    function Qs(a, i) {
      if (i) {
        if (Em[a] && !(i.children == null && i.dangerouslySetInnerHTML == null))
          throw Error(a + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (i.dangerouslySetInnerHTML != null) {
          if (i.children != null)
            throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (!(typeof i.dangerouslySetInnerHTML == "object" && Hd in i.dangerouslySetInnerHTML))
            throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!i.suppressContentEditableWarning && i.contentEditable && i.children != null && m("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), !(i.style == null || typeof i.style == "object"))
          throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Ji(a, i) {
      if (a.indexOf("-") === -1)
        return typeof i.is == "string";
      switch (a) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Bo = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Am = {
      "aria-current": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Uo = {}, up = new RegExp("^(aria)-[" + en + "]*$"), _m = new RegExp("^(aria)[A-Z][" + en + "]*$"), Vd = Object.prototype.hasOwnProperty;
    function Su(a, i) {
      {
        if (Vd.call(Uo, i) && Uo[i])
          return !0;
        if (_m.test(i)) {
          var l = "aria-" + i.slice(4).toLowerCase(), c = Am.hasOwnProperty(l) ? l : null;
          if (c == null)
            return m("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", i), Uo[i] = !0, !0;
          if (i !== c)
            return m("Invalid ARIA attribute `%s`. Did you mean `%s`?", i, c), Uo[i] = !0, !0;
        }
        if (up.test(i)) {
          var h = i.toLowerCase(), b = Am.hasOwnProperty(h) ? h : null;
          if (b == null)
            return Uo[i] = !0, !1;
          if (i !== b)
            return m("Unknown ARIA attribute `%s`. Did you mean `%s`?", i, b), Uo[i] = !0, !0;
        }
      }
      return !0;
    }
    function xu(a, i) {
      {
        var l = [];
        for (var c in i) {
          var h = Su(a, c);
          h || l.push(c);
        }
        var b = l.map(function(S) {
          return "`" + S + "`";
        }).join(", ");
        l.length === 1 ? m("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", b, a) : l.length > 1 && m("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", b, a);
      }
    }
    function Ec(a, i) {
      Ji(a, i) || xu(a, i);
    }
    var Bd = !1;
    function cp(a, i) {
      {
        if (a !== "input" && a !== "textarea" && a !== "select")
          return;
        i != null && i.value === null && !Bd && (Bd = !0, a === "select" && i.multiple ? m("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", a) : m("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", a));
      }
    }
    var Ac = function() {
    };
    {
      var qa = {}, dp = Object.prototype.hasOwnProperty, Om = /^on./, $i = /^on[^A-Z]/, Ud = new RegExp("^(aria)-[" + en + "]*$"), Cu = new RegExp("^(aria)[A-Z][" + en + "]*$");
      Ac = function(a, i, l, c) {
        if (dp.call(qa, i) && qa[i])
          return !0;
        var h = i.toLowerCase();
        if (h === "onfocusin" || h === "onfocusout")
          return m("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), qa[i] = !0, !0;
        if (c != null) {
          var b = c.registrationNameDependencies, S = c.possibleRegistrationNames;
          if (b.hasOwnProperty(i))
            return !0;
          var E = S.hasOwnProperty(h) ? S[h] : null;
          if (E != null)
            return m("Invalid event handler property `%s`. Did you mean `%s`?", i, E), qa[i] = !0, !0;
          if (Om.test(i))
            return m("Unknown event handler property `%s`. It will be ignored.", i), qa[i] = !0, !0;
        } else if (Om.test(i))
          return $i.test(i) && m("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", i), qa[i] = !0, !0;
        if (Ud.test(i) || Cu.test(i))
          return !0;
        if (h === "innerhtml")
          return m("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), qa[i] = !0, !0;
        if (h === "aria")
          return m("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), qa[i] = !0, !0;
        if (h === "is" && l !== null && l !== void 0 && typeof l != "string")
          return m("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof l), qa[i] = !0, !0;
        if (typeof l == "number" && isNaN(l))
          return m("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", i), qa[i] = !0, !0;
        var z = Hr(i), G = z !== null && z.type === Sn;
        if (Bo.hasOwnProperty(h)) {
          var ee = Bo[h];
          if (ee !== i)
            return m("Invalid DOM property `%s`. Did you mean `%s`?", i, ee), qa[i] = !0, !0;
        } else if (!G && i !== h)
          return m("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", i, h), qa[i] = !0, !0;
        return typeof l == "boolean" && fr(i, l, z, !1) ? (l ? m('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', l, i, i, l, i) : m('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', l, i, i, l, i, i, i), qa[i] = !0, !0) : G ? !0 : fr(i, l, z, !1) ? (qa[i] = !0, !1) : ((l === "false" || l === "true") && z !== null && z.type === Qn && (m("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", l, i, l === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', i, l), qa[i] = !0), !0);
      };
    }
    var Mu = function(a, i, l) {
      {
        var c = [];
        for (var h in i) {
          var b = Ac(a, h, i[h], l);
          b || c.push(h);
        }
        var S = c.map(function(E) {
          return "`" + E + "`";
        }).join(", ");
        c.length === 1 ? m("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", S, a) : c.length > 1 && m("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", S, a);
      }
    };
    function Tm(a, i, l) {
      Ji(a, i) || Mu(a, i, l);
    }
    var Xd = 1, _l = 1 << 1, Xo = 1 << 2, Rm = 1 << 4, Ol = Xd | _l | Xo;
    function Eu(a) {
      var i = a.target || a.srcElement || window;
      return i.correspondingUseElement && (i = i.correspondingUseElement), i.nodeType === Ho ? i.parentNode : i;
    }
    var vs = null, qo = null, Ks = null;
    function qd(a) {
      var i = Qc(a);
      if (i) {
        if (typeof vs != "function")
          throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var l = i.stateNode;
        if (l) {
          var c = ty(l);
          vs(i.stateNode, i.type, c);
        }
      }
    }
    function Yd(a) {
      vs = a;
    }
    function Tl(a) {
      qo ? Ks ? Ks.push(a) : Ks = [a] : qo = a;
    }
    function Dm() {
      return qo !== null || Ks !== null;
    }
    function Gd() {
      if (qo) {
        var a = qo, i = Ks;
        if (qo = null, Ks = null, qd(a), i)
          for (var l = 0; l < i.length; l++)
            qd(i[l]);
      }
    }
    var _c = function(a, i) {
      return a(i);
    }, Zn = function(a, i, l, c, h) {
      return a(i, l, c, h);
    }, Oc = function() {
    }, Qd = _c, Yo = !1, Tc = !1;
    function Rc() {
      var a = Dm();
      a && (Oc(), Gd());
    }
    function Au(a, i) {
      if (Yo)
        return a(i);
      Yo = !0;
      try {
        return _c(a, i);
      } finally {
        Yo = !1, Rc();
      }
    }
    function _u(a, i, l) {
      if (Tc)
        return a(i, l);
      Tc = !0;
      try {
        return Qd(a, i, l);
      } finally {
        Tc = !1, Rc();
      }
    }
    function Js(a, i, l, c, h) {
      var b = Yo;
      Yo = !0;
      try {
        return Zn(a, i, l, c, h);
      } finally {
        Yo = b, Yo || Rc();
      }
    }
    function Nm(a) {
      Yo || Oc();
    }
    function Ou(a, i, l, c) {
      _c = a, Zn = i, Oc = l, Qd = c;
    }
    function Kd(a) {
      return a === "button" || a === "input" || a === "select" || a === "textarea";
    }
    function Jd(a, i, l) {
      switch (a) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(l.disabled && Kd(i));
        default:
          return !1;
      }
    }
    function Wi(a, i) {
      var l = a.stateNode;
      if (l === null)
        return null;
      var c = ty(l);
      if (c === null)
        return null;
      var h = c[i];
      if (Jd(i, a.type, c))
        return null;
      if (!(!h || typeof h == "function"))
        throw Error("Expected `" + i + "` listener to be a function, instead got a value of `" + typeof h + "` type.");
      return h;
    }
    var Tu = !1;
    if (At)
      try {
        var Rl = {};
        Object.defineProperty(Rl, "passive", {
          get: function() {
            Tu = !0;
          }
        }), window.addEventListener("test", Rl, Rl), window.removeEventListener("test", Rl, Rl);
      } catch {
        Tu = !1;
      }
    function Zs(a, i, l, c, h, b, S, E, z) {
      var G = Array.prototype.slice.call(arguments, 3);
      try {
        i.apply(l, G);
      } catch (ee) {
        this.onError(ee);
      }
    }
    var Dc = Zs;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var gs = document.createElement("react");
      Dc = function(i, l, c, h, b, S, E, z, G) {
        if (!(typeof document < "u"))
          throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var ee = document.createEvent("Event"), we = !1, ae = !0, ke = window.event, ze = Object.getOwnPropertyDescriptor(window, "event");
        function rt() {
          gs.removeEventListener(Ae, rn, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = ke);
        }
        var Dt = Array.prototype.slice.call(arguments, 3);
        function rn() {
          we = !0, rt(), l.apply(c, Dt), ae = !1;
        }
        var Ft, On = !1, dr = !1;
        function Pe(pe) {
          if (Ft = pe.error, On = !0, Ft === null && pe.colno === 0 && pe.lineno === 0 && (dr = !0), pe.defaultPrevented && Ft != null && typeof Ft == "object")
            try {
              Ft._suppressLogging = !0;
            } catch {
            }
        }
        var Ae = "react-" + (i || "invokeguardedcallback");
        if (window.addEventListener("error", Pe), gs.addEventListener(Ae, rn, !1), ee.initEvent(Ae, !1, !1), gs.dispatchEvent(ee), ze && Object.defineProperty(window, "event", ze), we && ae && (On ? dr && (Ft = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Ft = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Ft)), window.removeEventListener("error", Pe), !we)
          return rt(), Zs.apply(this, arguments);
      };
    }
    var Wm = Dc, ys = !1, Nc = null, Go = !1, Pr = null, Ru = {
      onError: function(a) {
        ys = !0, Nc = a;
      }
    };
    function Ta(a, i, l, c, h, b, S, E, z) {
      ys = !1, Nc = null, Wm.apply(Ru, arguments);
    }
    function Du(a, i, l, c, h, b, S, E, z) {
      if (Ta.apply(this, arguments), ys) {
        var G = Ya();
        Go || (Go = !0, Pr = G);
      }
    }
    function bs() {
      if (Go) {
        var a = Pr;
        throw Go = !1, Pr = null, a;
      }
    }
    function si() {
      return ys;
    }
    function Ya() {
      if (ys) {
        var a = Nc;
        return ys = !1, Nc = null, a;
      } else
        throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function xo(a) {
      return a._reactInternals;
    }
    function Wc(a) {
      return a._reactInternals !== void 0;
    }
    function Zd(a, i) {
      a._reactInternals = i;
    }
    var zn = 0, Ra = 1, Ht = 2, Lt = 4, ws = 6, er = 8, kr = 16, Ps = 32, En = 64, ya = 128, Zi = 256, eo = 512, Dl = 8192, Si = 1024, jm = 1028, ef = 932, el = 2047, Nu = 2048, to = 4096, Wu = 16384, fp = s.ReactCurrentOwner;
    function ks(a) {
      var i = a, l = a;
      if (a.alternate)
        for (; i.return; )
          i = i.return;
      else {
        var c = i;
        do
          i = c, (i.flags & (Ht | Si)) !== zn && (l = i.return), c = i.return;
        while (c);
      }
      return i.tag === P ? l : null;
    }
    function jc(a) {
      if (a.tag === U) {
        var i = a.memoizedState;
        if (i === null) {
          var l = a.alternate;
          l !== null && (i = l.memoizedState);
        }
        if (i !== null)
          return i.dehydrated;
      }
      return null;
    }
    function zm(a) {
      return a.tag === P ? a.stateNode.containerInfo : null;
    }
    function zc(a) {
      return ks(a) === a;
    }
    function Lm(a) {
      {
        var i = fp.current;
        if (i !== null && i.tag === y) {
          var l = i, c = l.stateNode;
          c._warnedAboutRefsInRender || m("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Je(l.type) || "A component"), c._warnedAboutRefsInRender = !0;
        }
      }
      var h = xo(a);
      return h ? ks(h) === h : !1;
    }
    function tf(a) {
      if (ks(a) !== a)
        throw Error("Unable to find node on an unmounted component.");
    }
    function nf(a) {
      var i = a.alternate;
      if (!i) {
        var l = ks(a);
        if (l === null)
          throw Error("Unable to find node on an unmounted component.");
        return l !== a ? null : a;
      }
      for (var c = a, h = i; ; ) {
        var b = c.return;
        if (b === null)
          break;
        var S = b.alternate;
        if (S === null) {
          var E = b.return;
          if (E !== null) {
            c = h = E;
            continue;
          }
          break;
        }
        if (b.child === S.child) {
          for (var z = b.child; z; ) {
            if (z === c)
              return tf(b), a;
            if (z === h)
              return tf(b), i;
            z = z.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (c.return !== h.return)
          c = b, h = S;
        else {
          for (var G = !1, ee = b.child; ee; ) {
            if (ee === c) {
              G = !0, c = b, h = S;
              break;
            }
            if (ee === h) {
              G = !0, h = b, c = S;
              break;
            }
            ee = ee.sibling;
          }
          if (!G) {
            for (ee = S.child; ee; ) {
              if (ee === c) {
                G = !0, c = S, h = b;
                break;
              }
              if (ee === h) {
                G = !0, h = S, c = b;
                break;
              }
              ee = ee.sibling;
            }
            if (!G)
              throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (c.alternate !== h)
          throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (c.tag !== P)
        throw Error("Unable to find node on an unmounted component.");
      return c.stateNode.current === c ? a : i;
    }
    function ju(a) {
      var i = nf(a);
      if (!i)
        return null;
      for (var l = i; ; ) {
        if (l.tag === A || l.tag === M)
          return l;
        if (l.child) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === i)
          return null;
        for (; !l.sibling; ) {
          if (!l.return || l.return === i)
            return null;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return null;
    }
    function rf(a) {
      var i = nf(a);
      if (!i)
        return null;
      for (var l = i; ; ) {
        if (l.tag === A || l.tag === M || xe)
          return l;
        if (l.child && l.tag !== x) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === i)
          return null;
        for (; !l.sibling; ) {
          if (!l.return || l.return === i)
            return null;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return null;
    }
    function Lc(a, i) {
      for (var l = i, c = a.alternate; l !== null; ) {
        if (l === a || l === c)
          return !0;
        l = l.return;
      }
      return !1;
    }
    var ji;
    function Nl(a) {
      ji = a;
    }
    var Wl;
    function af(a) {
      Wl = a;
    }
    var ba;
    function jl(a) {
      ba = a;
    }
    var of;
    function wa(a) {
      of = a;
    }
    var zi = !1, na = [], no = null, $s = null, $r = null, Ss = /* @__PURE__ */ new Map(), xs = /* @__PURE__ */ new Map(), Co = [];
    function Ic() {
      return na.length > 0;
    }
    var zu = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function li(a) {
      return zu.indexOf(a) > -1;
    }
    function Mo(a, i, l, c, h) {
      return {
        blockedOn: a,
        domEventName: i,
        eventSystemFlags: l | Rm,
        nativeEvent: h,
        targetContainers: [c]
      };
    }
    function ui(a, i, l, c, h) {
      var b = Mo(a, i, l, c, h);
      na.push(b);
    }
    function xi(a, i) {
      switch (a) {
        case "focusin":
        case "focusout":
          no = null;
          break;
        case "dragenter":
        case "dragleave":
          $s = null;
          break;
        case "mouseover":
        case "mouseout":
          $r = null;
          break;
        case "pointerover":
        case "pointerout": {
          var l = i.pointerId;
          Ss.delete(l);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var c = i.pointerId;
          xs.delete(c);
          break;
        }
      }
    }
    function Li(a, i, l, c, h, b) {
      if (a === null || a.nativeEvent !== b) {
        var S = Mo(i, l, c, h, b);
        if (i !== null) {
          var E = Qc(i);
          E !== null && Wl(E);
        }
        return S;
      }
      a.eventSystemFlags |= c;
      var z = a.targetContainers;
      return h !== null && z.indexOf(h) === -1 && z.push(h), a;
    }
    function sf(a, i, l, c, h) {
      switch (i) {
        case "focusin": {
          var b = h;
          return no = Li(no, a, i, l, c, b), !0;
        }
        case "dragenter": {
          var S = h;
          return $s = Li($s, a, i, l, c, S), !0;
        }
        case "mouseover": {
          var E = h;
          return $r = Li($r, a, i, l, c, E), !0;
        }
        case "pointerover": {
          var z = h, G = z.pointerId;
          return Ss.set(G, Li(Ss.get(G) || null, a, i, l, c, z)), !0;
        }
        case "gotpointercapture": {
          var ee = h, we = ee.pointerId;
          return xs.set(we, Li(xs.get(we) || null, a, i, l, c, ee)), !0;
        }
      }
      return !1;
    }
    function Im(a) {
      var i = _f(a.target);
      if (i !== null) {
        var l = ks(i);
        if (l !== null) {
          var c = l.tag;
          if (c === U) {
            var h = jc(l);
            if (h !== null) {
              a.blockedOn = h, of(a.lanePriority, function() {
                n.unstable_runWithPriority(a.priority, function() {
                  ba(l);
                });
              });
              return;
            }
          } else if (c === P) {
            var b = l.stateNode;
            if (b.hydrate) {
              a.blockedOn = zm(l);
              return;
            }
          }
        }
      }
      a.blockedOn = null;
    }
    function ro(a) {
      if (a.blockedOn !== null)
        return !1;
      for (var i = a.targetContainers; i.length > 0; ) {
        var l = i[0], c = vf(a.domEventName, a.eventSystemFlags, l, a.nativeEvent);
        if (c !== null) {
          var h = Qc(c);
          return h !== null && Wl(h), a.blockedOn = c, !1;
        }
        i.shift();
      }
      return !0;
    }
    function Qo(a, i, l) {
      ro(a) && l.delete(i);
    }
    function Fm() {
      for (zi = !1; na.length > 0; ) {
        var a = na[0];
        if (a.blockedOn !== null) {
          var i = Qc(a.blockedOn);
          i !== null && ji(i);
          break;
        }
        for (var l = a.targetContainers; l.length > 0; ) {
          var c = l[0], h = vf(a.domEventName, a.eventSystemFlags, c, a.nativeEvent);
          if (h !== null) {
            a.blockedOn = h;
            break;
          }
          l.shift();
        }
        a.blockedOn === null && na.shift();
      }
      no !== null && ro(no) && (no = null), $s !== null && ro($s) && ($s = null), $r !== null && ro($r) && ($r = null), Ss.forEach(Qo), xs.forEach(Qo);
    }
    function Ko(a, i) {
      a.blockedOn === i && (a.blockedOn = null, zi || (zi = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, Fm)));
    }
    function lf(a) {
      if (na.length > 0) {
        Ko(na[0], a);
        for (var i = 1; i < na.length; i++) {
          var l = na[i];
          l.blockedOn === a && (l.blockedOn = null);
        }
      }
      no !== null && Ko(no, a), $s !== null && Ko($s, a), $r !== null && Ko($r, a);
      var c = function(E) {
        return Ko(E, a);
      };
      Ss.forEach(c), xs.forEach(c);
      for (var h = 0; h < Co.length; h++) {
        var b = Co[h];
        b.blockedOn === a && (b.blockedOn = null);
      }
      for (; Co.length > 0; ) {
        var S = Co[0];
        if (S.blockedOn !== null)
          break;
        Im(S), S.blockedOn === null && Co.shift();
      }
    }
    var zl = 0, Lu = 1, Ll = 2;
    function Iu(a, i) {
      var l = {};
      return l[a.toLowerCase()] = i.toLowerCase(), l["Webkit" + a] = "webkit" + i, l["Moz" + a] = "moz" + i, l;
    }
    var tl = {
      animationend: Iu("Animation", "AnimationEnd"),
      animationiteration: Iu("Animation", "AnimationIteration"),
      animationstart: Iu("Animation", "AnimationStart"),
      transitionend: Iu("Transition", "TransitionEnd")
    }, Fc = {}, Fu = {};
    At && (Fu = document.createElement("div").style, "AnimationEvent" in window || (delete tl.animationend.animation, delete tl.animationiteration.animation, delete tl.animationstart.animation), "TransitionEvent" in window || delete tl.transitionend.transition);
    function nl(a) {
      if (Fc[a])
        return Fc[a];
      if (!tl[a])
        return a;
      var i = tl[a];
      for (var l in i)
        if (i.hasOwnProperty(l) && l in Fu)
          return Fc[a] = i[l];
      return a;
    }
    var Il = nl("animationend"), Hu = nl("animationiteration"), uf = nl("animationstart"), Vu = nl("transitionend"), cf = /* @__PURE__ */ new Map(), Jo = /* @__PURE__ */ new Map(), ao = [
      "cancel",
      "cancel",
      "click",
      "click",
      "close",
      "close",
      "contextmenu",
      "contextMenu",
      "copy",
      "copy",
      "cut",
      "cut",
      "auxclick",
      "auxClick",
      "dblclick",
      "doubleClick",
      "dragend",
      "dragEnd",
      "dragstart",
      "dragStart",
      "drop",
      "drop",
      "focusin",
      "focus",
      "focusout",
      "blur",
      "input",
      "input",
      "invalid",
      "invalid",
      "keydown",
      "keyDown",
      "keypress",
      "keyPress",
      "keyup",
      "keyUp",
      "mousedown",
      "mouseDown",
      "mouseup",
      "mouseUp",
      "paste",
      "paste",
      "pause",
      "pause",
      "play",
      "play",
      "pointercancel",
      "pointerCancel",
      "pointerdown",
      "pointerDown",
      "pointerup",
      "pointerUp",
      "ratechange",
      "rateChange",
      "reset",
      "reset",
      "seeked",
      "seeked",
      "submit",
      "submit",
      "touchcancel",
      "touchCancel",
      "touchend",
      "touchEnd",
      "touchstart",
      "touchStart",
      "volumechange",
      "volumeChange"
    ], Bu = ["change", "selectionchange", "textInput", "compositionstart", "compositionend", "compositionupdate"], Uu = ["drag", "drag", "dragenter", "dragEnter", "dragexit", "dragExit", "dragleave", "dragLeave", "dragover", "dragOver", "mousemove", "mouseMove", "mouseout", "mouseOut", "mouseover", "mouseOver", "pointermove", "pointerMove", "pointerout", "pointerOut", "pointerover", "pointerOver", "scroll", "scroll", "toggle", "toggle", "touchmove", "touchMove", "wheel", "wheel"], rl = ["abort", "abort", Il, "animationEnd", Hu, "animationIteration", uf, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", Vu, "transitionEnd", "waiting", "waiting"];
    function Fl(a, i) {
      for (var l = 0; l < a.length; l += 2) {
        var c = a[l], h = a[l + 1], b = h[0].toUpperCase() + h.slice(1), S = "on" + b;
        Jo.set(c, i), cf.set(c, S), ot(S, [c]);
      }
    }
    function al(a, i) {
      for (var l = 0; l < a.length; l++)
        Jo.set(a[l], i);
    }
    function df(a) {
      var i = Jo.get(a);
      return i === void 0 ? Ll : i;
    }
    function Hc() {
      Fl(ao, zl), Fl(Uu, Lu), Fl(rl, Ll), al(Bu, zl);
    }
    var Sr = n.unstable_now;
    if (!(r.__interactionsRef != null && r.__interactionsRef.current != null))
      throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    var Hl = 99, ra = 98, Vn = 97, Eo = 96, ff = 95, mf = 90;
    Sr();
    var Zo = 15, Cs = 14, Vl = 13, Bl = 12, Ms = 11, Es = 10, il = 9, aa = 8, Ul = 7, ur = 6, qr = 5, Yr = 4, Xu = 3, io = 2, Pa = 1, Ao = 0, Vc = 31, Te = 0, ln = 0, un = 1, k = 2, C = 4, W = 24, Y = 32, ne = 192, se = 256, te = 3584, me = 4096, he = 4186112, Me = 62914560, We = 33554432, it = 67108864, He = 134217727, pt = 134217728, lt = 805306368, jt = 1073741824, St = -1;
    function gn(a) {
    }
    var Ct = aa;
    function xr(a) {
      if ((un & a) !== Te)
        return Ct = Zo, un;
      if ((k & a) !== Te)
        return Ct = Cs, k;
      if ((C & a) !== Te)
        return Ct = Vl, C;
      var i = W & a;
      if (i !== Te)
        return Ct = Bl, i;
      if ((a & Y) !== Te)
        return Ct = Ms, Y;
      var l = ne & a;
      if (l !== Te)
        return Ct = Es, l;
      if ((a & se) !== Te)
        return Ct = il, se;
      var c = te & a;
      if (c !== Te)
        return Ct = aa, c;
      if ((a & me) !== Te)
        return Ct = Ul, me;
      var h = he & a;
      if (h !== Te)
        return Ct = ur, h;
      var b = Me & a;
      if (b !== Te)
        return Ct = qr, b;
      if (a & it)
        return Ct = Yr, it;
      if ((a & pt) !== Te)
        return Ct = Xu, pt;
      var S = lt & a;
      return S !== Te ? (Ct = io, S) : (jt & a) !== Te ? (Ct = Pa, jt) : (m("Should have found matching lanes. This is a bug in React."), Ct = aa, a);
    }
    function zr(a) {
      switch (a) {
        case Hl:
          return Zo;
        case ra:
          return Es;
        case Vn:
        case Eo:
          return aa;
        case ff:
          return io;
        default:
          return Ao;
      }
    }
    function ka(a) {
      switch (a) {
        case Zo:
        case Cs:
          return Hl;
        case Vl:
        case Bl:
        case Ms:
        case Es:
          return ra;
        case il:
        case aa:
        case Ul:
        case ur:
        case Yr:
        case qr:
          return Vn;
        case Xu:
        case io:
        case Pa:
          return ff;
        case Ao:
          return mf;
        default:
          throw Error("Invalid update priority: " + a + ". This is a bug in React.");
      }
    }
    function nn(a, i) {
      var l = a.pendingLanes;
      if (l === Te)
        return Ct = Ao, Te;
      var c = Te, h = Ao, b = a.expiredLanes, S = a.suspendedLanes, E = a.pingedLanes;
      if (b !== Te)
        c = b, h = Ct = Zo;
      else {
        var z = l & He;
        if (z !== Te) {
          var G = z & ~S;
          if (G !== Te)
            c = xr(G), h = Ct;
          else {
            var ee = z & E;
            ee !== Te && (c = xr(ee), h = Ct);
          }
        } else {
          var we = l & ~S;
          we !== Te ? (c = xr(we), h = Ct) : E !== Te && (c = xr(E), h = Ct);
        }
      }
      if (c === Te)
        return Te;
      if (c = l & ol(c), i !== Te && i !== c && (i & S) === Te) {
        xr(i);
        var ae = Ct;
        if (h <= ae)
          return i;
        Ct = h;
      }
      var ke = a.entangledLanes;
      if (ke !== Te)
        for (var ze = a.entanglements, rt = c & ke; rt > 0; ) {
          var Dt = Da(rt), rn = 1 << Dt;
          c |= ze[Dt], rt &= ~rn;
        }
      return c;
    }
    function Xe(a, i) {
      for (var l = a.eventTimes, c = St; i > 0; ) {
        var h = Da(i), b = 1 << h, S = l[h];
        S > c && (c = S), i &= ~b;
      }
      return c;
    }
    function Ot(a, i) {
      xr(a);
      var l = Ct;
      return l >= Es ? i + 250 : l >= ur ? i + 5e3 : St;
    }
    function on(a, i) {
      for (var l = a.pendingLanes, c = a.suspendedLanes, h = a.pingedLanes, b = a.expirationTimes, S = l; S > 0; ) {
        var E = Da(S), z = 1 << E, G = b[E];
        G === St ? ((z & c) === Te || (z & h) !== Te) && (b[E] = Ot(z, i)) : G <= i && (a.expiredLanes |= z), S &= ~z;
      }
    }
    function Rt(a) {
      var i = a.pendingLanes & ~jt;
      return i !== Te ? i : i & jt ? jt : Te;
    }
    function An() {
      return Ct;
    }
    function Bn(a) {
      return (a & He) !== Te;
    }
    function fn(a) {
      return (a & Me) === a;
    }
    function xn(a) {
      return (a & he) === a;
    }
    function mn(a, i) {
      switch (a) {
        case Ao:
          break;
        case Zo:
          return un;
        case Cs:
          return k;
        case Bl: {
          var l = hr(W & ~i);
          return l === ln ? mn(Es, i) : l;
        }
        case Es: {
          var c = hr(ne & ~i);
          return c === ln ? mn(aa, i) : c;
        }
        case aa: {
          var h = hr(te & ~i);
          return h === ln && (h = hr(he & ~i), h === ln && (h = hr(te))), h;
        }
        case ur:
        case qr:
          break;
        case io:
          var b = hr(lt & ~i);
          return b === ln && (b = hr(lt)), b;
      }
      throw Error("Invalid update priority: " + a + ". This is a bug in React.");
    }
    function _n(a, i) {
      var l = hr(he & ~i);
      return l === ln && (l = hr(he & ~a), l === ln && (l = hr(he))), l;
    }
    function Ci(a) {
      var i = hr(Me & ~a);
      return i === ln && (i = hr(Me)), i;
    }
    function es(a) {
      return a & -a;
    }
    function _o(a) {
      var i = 31 - $g(a);
      return i < 0 ? Te : 1 << i;
    }
    function ol(a) {
      return (_o(a) << 1) - 1;
    }
    function hr(a) {
      return es(a);
    }
    function Da(a) {
      return 31 - $g(a);
    }
    function As(a) {
      return Da(a);
    }
    function Tr(a, i) {
      return (a & i) !== Te;
    }
    function ci(a, i) {
      return (a & i) === i;
    }
    function bn(a, i) {
      return a | i;
    }
    function _s(a, i) {
      return a & ~i;
    }
    function Gw(a) {
      return a;
    }
    function sl(a, i) {
      return a !== ln && a < i ? a : i;
    }
    function Hm(a) {
      for (var i = [], l = 0; l < Vc; l++)
        i.push(a);
      return i;
    }
    function Bc(a, i, l) {
      a.pendingLanes |= i;
      var c = i - 1;
      a.suspendedLanes &= c, a.pingedLanes &= c;
      var h = a.eventTimes, b = As(i);
      h[b] = l;
    }
    function Pg(a, i) {
      a.suspendedLanes |= i, a.pingedLanes &= ~i;
      for (var l = a.expirationTimes, c = i; c > 0; ) {
        var h = Da(c), b = 1 << h;
        l[h] = St, c &= ~b;
      }
    }
    function mp(a, i, l) {
      a.pingedLanes |= a.suspendedLanes & i;
    }
    function hf(a) {
      a.expiredLanes |= W & a.pendingLanes;
    }
    function Qw(a) {
      return (a & W) !== Te;
    }
    function kg(a, i) {
      a.mutableReadLanes |= i & a.pendingLanes;
    }
    function hp(a, i) {
      var l = a.pendingLanes & ~i;
      a.pendingLanes = i, a.suspendedLanes = 0, a.pingedLanes = 0, a.expiredLanes &= i, a.mutableReadLanes &= i, a.entangledLanes &= i;
      for (var c = a.entanglements, h = a.eventTimes, b = a.expirationTimes, S = l; S > 0; ) {
        var E = Da(S), z = 1 << E;
        c[E] = Te, h[E] = St, b[E] = St, S &= ~z;
      }
    }
    function pp(a, i) {
      a.entangledLanes |= i;
      for (var l = a.entanglements, c = i; c > 0; ) {
        var h = Da(c), b = 1 << h;
        l[h] |= i, c &= ~b;
      }
    }
    var $g = Math.clz32 ? Math.clz32 : Kw, Sg = Math.log, xg = Math.LN2;
    function Kw(a) {
      return a === 0 ? 32 : 31 - (Sg(a) / xg | 0) | 0;
    }
    var Cg = n.unstable_UserBlockingPriority, Jw = n.unstable_runWithPriority, vp = !0;
    function gp(a) {
      vp = !!a;
    }
    function Mg() {
      return vp;
    }
    function Eg(a, i, l) {
      var c = df(i), h;
      switch (c) {
        case zl:
          h = Ag;
          break;
        case Lu:
          h = _g;
          break;
        case Ll:
        default:
          h = pf;
          break;
      }
      return h.bind(null, i, l, a);
    }
    function Ag(a, i, l, c) {
      Nm(c.timeStamp), Js(pf, a, i, l, c);
    }
    function _g(a, i, l, c) {
      Jw(Cg, pf.bind(null, a, i, l, c));
    }
    function pf(a, i, l, c) {
      if (vp) {
        var h = !0;
        if (h = (i & Xo) === 0, h && Ic() && li(a)) {
          ui(
            null,
            a,
            i,
            l,
            c
          );
          return;
        }
        var b = vf(a, i, l, c);
        if (b === null) {
          h && xi(a, c);
          return;
        }
        if (h) {
          if (li(a)) {
            ui(b, a, i, l, c);
            return;
          }
          if (sf(b, a, i, l, c))
            return;
          xi(a, c);
        }
        Nx(a, i, c, null, l);
      }
    }
    function vf(a, i, l, c) {
      var h = Eu(c), b = _f(h);
      if (b !== null) {
        var S = ks(b);
        if (S === null)
          b = null;
        else {
          var E = S.tag;
          if (E === U) {
            var z = jc(S);
            if (z !== null)
              return z;
            b = null;
          } else if (E === P) {
            var G = S.stateNode;
            if (G.hydrate)
              return zm(S);
            b = null;
          } else
            S !== b && (b = null);
        }
      }
      return Nx(a, i, c, b, l), null;
    }
    function Og(a, i, l) {
      return a.addEventListener(i, l, !1), l;
    }
    function yp(a, i, l) {
      return a.addEventListener(i, l, !0), l;
    }
    function Tg(a, i, l, c) {
      return a.addEventListener(i, l, {
        capture: !0,
        passive: c
      }), l;
    }
    function Zw(a, i, l, c) {
      return a.addEventListener(i, l, {
        passive: c
      }), l;
    }
    var gf = null, Uc = null, qu = null;
    function Ut(a) {
      return gf = a, Uc = Ga(), !0;
    }
    function Mi() {
      gf = null, Uc = null, qu = null;
    }
    function ia() {
      if (qu)
        return qu;
      var a, i = Uc, l = i.length, c, h = Ga(), b = h.length;
      for (a = 0; a < l && i[a] === h[a]; a++)
        ;
      var S = l - a;
      for (c = 1; c <= S && i[l - c] === h[b - c]; c++)
        ;
      var E = c > 1 ? 1 - c : void 0;
      return qu = h.slice(a, E), qu;
    }
    function Ga() {
      return "value" in gf ? gf.value : gf.textContent;
    }
    function Os(a) {
      var i, l = a.keyCode;
      return "charCode" in a ? (i = a.charCode, i === 0 && l === 13 && (i = 13)) : i = l, i === 10 && (i = 13), i >= 32 || i === 13 ? i : 0;
    }
    function Xc() {
      return !0;
    }
    function Na() {
      return !1;
    }
    function di(a) {
      function i(l, c, h, b, S) {
        this._reactName = l, this._targetInst = h, this.type = c, this.nativeEvent = b, this.target = S, this.currentTarget = null;
        for (var E in a)
          if (a.hasOwnProperty(E)) {
            var z = a[E];
            z ? this[E] = z(b) : this[E] = b[E];
          }
        var G = b.defaultPrevented != null ? b.defaultPrevented : b.returnValue === !1;
        return G ? this.isDefaultPrevented = Xc : this.isDefaultPrevented = Na, this.isPropagationStopped = Na, this;
      }
      return t(i.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var l = this.nativeEvent;
          l && (l.preventDefault ? l.preventDefault() : typeof l.returnValue != "unknown" && (l.returnValue = !1), this.isDefaultPrevented = Xc);
        },
        stopPropagation: function() {
          var l = this.nativeEvent;
          l && (l.stopPropagation ? l.stopPropagation() : typeof l.cancelBubble != "unknown" && (l.cancelBubble = !0), this.isPropagationStopped = Xc);
        },
        persist: function() {
        },
        isPersistent: Xc
      }), i;
    }
    var ts = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(a) {
        return a.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Yu = di(ts), Ts = t({}, ts, {
      view: 0,
      detail: 0
    }), bp = di(Ts), yf, bf, Gu;
    function qc(a) {
      a !== Gu && (Gu && a.type === "mousemove" ? (yf = a.screenX - Gu.screenX, bf = a.screenY - Gu.screenY) : (yf = 0, bf = 0), Gu = a);
    }
    var vt = t({}, Ts, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Ds,
      button: 0,
      buttons: 0,
      relatedTarget: function(a) {
        return a.relatedTarget === void 0 ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
      },
      movementX: function(a) {
        return "movementX" in a ? a.movementX : (qc(a), yf);
      },
      movementY: function(a) {
        return "movementY" in a ? a.movementY : bf;
      }
    }), wf = di(vt), wp = t({}, vt, {
      dataTransfer: 0
    }), Rs = di(wp), Xl = t({}, Ts, {
      relatedTarget: 0
    }), Qu = di(Xl), Pf = t({}, ts, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Pp = di(Pf), kp = t({}, ts, {
      clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
      }
    }), ll = di(kp), kf = t({}, ts, {
      data: 0
    }), Vm = di(kf), Bm = Vm, ul = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, Um = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function $f(a) {
      if (a.key) {
        var i = ul[a.key] || a.key;
        if (i !== "Unidentified")
          return i;
      }
      if (a.type === "keypress") {
        var l = Os(a);
        return l === 13 ? "Enter" : String.fromCharCode(l);
      }
      return a.type === "keydown" || a.type === "keyup" ? Um[a.keyCode] || "Unidentified" : "";
    }
    var Xm = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function oo(a) {
      var i = this, l = i.nativeEvent;
      if (l.getModifierState)
        return l.getModifierState(a);
      var c = Xm[a];
      return c ? !!l[c] : !1;
    }
    function Ds(a) {
      return oo;
    }
    var ql = t({}, Ts, {
      key: $f,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Ds,
      charCode: function(a) {
        return a.type === "keypress" ? Os(a) : 0;
      },
      keyCode: function(a) {
        return a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
      },
      which: function(a) {
        return a.type === "keypress" ? Os(a) : a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
      }
    }), qm = di(ql), Oo = t({}, vt, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), $p = di(Oo), Yc = t({}, Ts, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Ds
    }), Sp = di(Yc), e0 = t({}, ts, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Rg = di(e0), Dg = t({}, vt, {
      deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
      },
      deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), Ym = di(Dg), xp = [9, 13, 27, 32], Ku = 229, Gm = At && "CompositionEvent" in window, Gc = null;
    At && "documentMode" in document && (Gc = document.documentMode);
    var Sf = At && "TextEvent" in window && !Gc, Ng = At && (!Gm || Gc && Gc > 8 && Gc <= 11), Wg = 32, Cp = String.fromCharCode(Wg);
    function jg() {
      ot("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), ot("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), ot("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), ot("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Yl = !1;
    function t0(a) {
      return (a.ctrlKey || a.altKey || a.metaKey) && !(a.ctrlKey && a.altKey);
    }
    function n0(a) {
      switch (a) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Gl(a, i) {
      return a === "keydown" && i.keyCode === Ku;
    }
    function zg(a, i) {
      switch (a) {
        case "keyup":
          return xp.indexOf(i.keyCode) !== -1;
        case "keydown":
          return i.keyCode !== Ku;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Mp(a) {
      var i = a.detail;
      return typeof i == "object" && "data" in i ? i.data : null;
    }
    function Lg(a) {
      return a.locale === "ko";
    }
    var Ju = !1;
    function Ql(a, i, l, c, h) {
      var b, S;
      if (Gm ? b = n0(i) : Ju ? zg(i, c) && (b = "onCompositionEnd") : Gl(i, c) && (b = "onCompositionStart"), !b)
        return null;
      Ng && !Lg(c) && (!Ju && b === "onCompositionStart" ? Ju = Ut(h) : b === "onCompositionEnd" && Ju && (S = ia()));
      var E = Bg(l, b);
      if (E.length > 0) {
        var z = new Vm(b, i, null, c, h);
        if (a.push({
          event: z,
          listeners: E
        }), S)
          z.data = S;
        else {
          var G = Mp(c);
          G !== null && (z.data = G);
        }
      }
    }
    function r0(a, i) {
      switch (a) {
        case "compositionend":
          return Mp(i);
        case "keypress":
          var l = i.which;
          return l !== Wg ? null : (Yl = !0, Cp);
        case "textInput":
          var c = i.data;
          return c === Cp && Yl ? null : c;
        default:
          return null;
      }
    }
    function a0(a, i) {
      if (Ju) {
        if (a === "compositionend" || !Gm && zg(a, i)) {
          var l = ia();
          return Mi(), Ju = !1, l;
        }
        return null;
      }
      switch (a) {
        case "paste":
          return null;
        case "keypress":
          if (!t0(i)) {
            if (i.char && i.char.length > 1)
              return i.char;
            if (i.which)
              return String.fromCharCode(i.which);
          }
          return null;
        case "compositionend":
          return Ng && !Lg(i) ? null : i.data;
        default:
          return null;
      }
    }
    function Ig(a, i, l, c, h) {
      var b;
      if (Sf ? b = r0(i, c) : b = a0(i, c), !b)
        return null;
      var S = Bg(l, "onBeforeInput");
      if (S.length > 0) {
        var E = new Bm("onBeforeInput", "beforeinput", null, c, h);
        a.push({
          event: E,
          listeners: S
        }), E.data = b;
      }
    }
    function i0(a, i, l, c, h, b, S) {
      Ql(a, i, l, c, h), Ig(a, i, l, c, h);
    }
    var To = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Qm(a) {
      var i = a && a.nodeName && a.nodeName.toLowerCase();
      return i === "input" ? !!To[a.type] : i === "textarea";
    }
    function o0(a) {
      if (!At)
        return !1;
      var i = "on" + a, l = i in document;
      if (!l) {
        var c = document.createElement("div");
        c.setAttribute(i, "return;"), l = typeof c[i] == "function";
      }
      return l;
    }
    function Kl() {
      ot("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function xf(a, i, l, c) {
      Tl(c);
      var h = Bg(i, "onChange");
      if (h.length > 0) {
        var b = new Yu("onChange", "change", null, l, c);
        a.push({
          event: b,
          listeners: h
        });
      }
    }
    var Ns = null, Zu = null;
    function Ep(a) {
      var i = a.nodeName && a.nodeName.toLowerCase();
      return i === "select" || i === "input" && a.type === "file";
    }
    function Ap(a) {
      var i = [];
      xf(i, Zu, a, Eu(a)), Au(s0, i);
    }
    function s0(a) {
      Ax(a, 0);
    }
    function Km(a) {
      var i = oh(a);
      if (oe(i))
        return a;
    }
    function Jm(a, i) {
      if (a === "change")
        return i;
    }
    var Zm = !1;
    At && (Zm = o0("input") && (!document.documentMode || document.documentMode > 9));
    function Fg(a, i) {
      Ns = a, Zu = i, Ns.attachEvent("onpropertychange", Hg);
    }
    function eh() {
      Ns && (Ns.detachEvent("onpropertychange", Hg), Ns = null, Zu = null);
    }
    function Hg(a) {
      a.propertyName === "value" && Km(Zu) && Ap(a);
    }
    function _p(a, i, l) {
      a === "focusin" ? (eh(), Fg(i, l)) : a === "focusout" && eh();
    }
    function Cf(a, i) {
      if (a === "selectionchange" || a === "keyup" || a === "keydown")
        return Km(Zu);
    }
    function l0(a) {
      var i = a.nodeName;
      return i && i.toLowerCase() === "input" && (a.type === "checkbox" || a.type === "radio");
    }
    function th(a, i) {
      if (a === "click")
        return Km(i);
    }
    function Vg(a, i) {
      if (a === "input" || a === "change")
        return Km(i);
    }
    function u0(a) {
      var i = a._wrapperState;
      !i || !i.controlled || a.type !== "number" || ga(a, "number", a.value);
    }
    function Mf(a, i, l, c, h, b, S) {
      var E = l ? oh(l) : window, z, G;
      if (Ep(E) ? z = Jm : Qm(E) ? Zm ? z = Vg : (z = Cf, G = _p) : l0(E) && (z = th), z) {
        var ee = z(i, l);
        if (ee) {
          xf(a, ee, c, h);
          return;
        }
      }
      G && G(i, E, l), i === "focusout" && u0(E);
    }
    function c0() {
      ht("onMouseEnter", ["mouseout", "mouseover"]), ht("onMouseLeave", ["mouseout", "mouseover"]), ht("onPointerEnter", ["pointerout", "pointerover"]), ht("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function nh(a, i, l, c, h, b, S) {
      var E = i === "mouseover" || i === "pointerover", z = i === "mouseout" || i === "pointerout";
      if (E && !(b & Rm)) {
        var G = c.relatedTarget || c.fromElement;
        if (G && (_f(G) || ey(G)))
          return;
      }
      if (!(!z && !E)) {
        var ee;
        if (h.window === h)
          ee = h;
        else {
          var we = h.ownerDocument;
          we ? ee = we.defaultView || we.parentWindow : ee = window;
        }
        var ae, ke;
        if (z) {
          var ze = c.relatedTarget || c.toElement;
          if (ae = l, ke = ze ? _f(ze) : null, ke !== null) {
            var rt = ks(ke);
            (ke !== rt || ke.tag !== A && ke.tag !== M) && (ke = null);
          }
        } else
          ae = null, ke = l;
        if (ae !== ke) {
          var Dt = wf, rn = "onMouseLeave", Ft = "onMouseEnter", On = "mouse";
          (i === "pointerout" || i === "pointerover") && (Dt = $p, rn = "onPointerLeave", Ft = "onPointerEnter", On = "pointer");
          var dr = ae == null ? ee : oh(ae), Pe = ke == null ? ee : oh(ke), Ae = new Dt(rn, On + "leave", ae, c, h);
          Ae.target = dr, Ae.relatedTarget = Pe;
          var pe = null, Ue = _f(h);
          if (Ue === l) {
            var st = new Dt(Ft, On + "enter", ke, c, h);
            st.target = Pe, st.relatedTarget = dr, pe = st;
          }
          d6(a, Ae, pe, ae, ke);
        }
      }
    }
    function o(a, i) {
      return a === i && (a !== 0 || 1 / a === 1 / i) || a !== a && i !== i;
    }
    var u = typeof Object.is == "function" ? Object.is : o, d = Object.prototype.hasOwnProperty;
    function g(a, i) {
      if (u(a, i))
        return !0;
      if (typeof a != "object" || a === null || typeof i != "object" || i === null)
        return !1;
      var l = Object.keys(a), c = Object.keys(i);
      if (l.length !== c.length)
        return !1;
      for (var h = 0; h < l.length; h++)
        if (!d.call(i, l[h]) || !u(a[l[h]], i[l[h]]))
          return !1;
      return !0;
    }
    function $(a) {
      for (; a && a.firstChild; )
        a = a.firstChild;
      return a;
    }
    function _(a) {
      for (; a; ) {
        if (a.nextSibling)
          return a.nextSibling;
        a = a.parentNode;
      }
    }
    function I(a, i) {
      for (var l = $(a), c = 0, h = 0; l; ) {
        if (l.nodeType === Ho) {
          if (h = c + l.textContent.length, c <= i && h >= i)
            return {
              node: l,
              offset: i - c
            };
          c = h;
        }
        l = $(_(l));
      }
    }
    function q(a) {
      var i = a.ownerDocument, l = i && i.defaultView || window, c = l.getSelection && l.getSelection();
      if (!c || c.rangeCount === 0)
        return null;
      var h = c.anchorNode, b = c.anchorOffset, S = c.focusNode, E = c.focusOffset;
      try {
        h.nodeType, S.nodeType;
      } catch {
        return null;
      }
      return re(a, h, b, S, E);
    }
    function re(a, i, l, c, h) {
      var b = 0, S = -1, E = -1, z = 0, G = 0, ee = a, we = null;
      e:
        for (; ; ) {
          for (var ae = null; ee === i && (l === 0 || ee.nodeType === Ho) && (S = b + l), ee === c && (h === 0 || ee.nodeType === Ho) && (E = b + h), ee.nodeType === Ho && (b += ee.nodeValue.length), (ae = ee.firstChild) !== null; )
            we = ee, ee = ae;
          for (; ; ) {
            if (ee === a)
              break e;
            if (we === i && ++z === l && (S = b), we === c && ++G === h && (E = b), (ae = ee.nextSibling) !== null)
              break;
            ee = we, we = ee.parentNode;
          }
          ee = ae;
        }
      return S === -1 || E === -1 ? null : {
        start: S,
        end: E
      };
    }
    function Se(a, i) {
      var l = a.ownerDocument || document, c = l && l.defaultView || window;
      if (c.getSelection) {
        var h = c.getSelection(), b = a.textContent.length, S = Math.min(i.start, b), E = i.end === void 0 ? S : Math.min(i.end, b);
        if (!h.extend && S > E) {
          var z = E;
          E = S, S = z;
        }
        var G = I(a, S), ee = I(a, E);
        if (G && ee) {
          if (h.rangeCount === 1 && h.anchorNode === G.node && h.anchorOffset === G.offset && h.focusNode === ee.node && h.focusOffset === ee.offset)
            return;
          var we = l.createRange();
          we.setStart(G.node, G.offset), h.removeAllRanges(), S > E ? (h.addRange(we), h.extend(ee.node, ee.offset)) : (we.setEnd(ee.node, ee.offset), h.addRange(we));
        }
      }
    }
    function ut(a) {
      return a && a.nodeType === Ho;
    }
    function Xt(a, i) {
      return !a || !i ? !1 : a === i ? !0 : ut(a) ? !1 : ut(i) ? Xt(a, i.parentNode) : "contains" in a ? a.contains(i) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(i) & 16) : !1;
    }
    function Ve(a) {
      return a && a.ownerDocument && Xt(a.ownerDocument.documentElement, a);
    }
    function Mt(a) {
      try {
        return typeof a.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function Vt() {
      for (var a = window, i = be(); i instanceof a.HTMLIFrameElement; ) {
        if (Mt(i))
          a = i.contentWindow;
        else
          return i;
        i = be(a.document);
      }
      return i;
    }
    function zt(a) {
      var i = a && a.nodeName && a.nodeName.toLowerCase();
      return i && (i === "input" && (a.type === "text" || a.type === "search" || a.type === "tel" || a.type === "url" || a.type === "password") || i === "textarea" || a.contentEditable === "true");
    }
    function ge() {
      var a = Vt();
      return {
        focusedElem: a,
        selectionRange: zt(a) ? fe(a) : null
      };
    }
    function le(a) {
      var i = Vt(), l = a.focusedElem, c = a.selectionRange;
      if (i !== l && Ve(l)) {
        c !== null && zt(l) && Re(l, c);
        for (var h = [], b = l; b = b.parentNode; )
          b.nodeType === Ni && h.push({
            element: b,
            left: b.scrollLeft,
            top: b.scrollTop
          });
        typeof l.focus == "function" && l.focus();
        for (var S = 0; S < h.length; S++) {
          var E = h[S];
          E.element.scrollLeft = E.left, E.element.scrollTop = E.top;
        }
      }
    }
    function fe(a) {
      var i;
      return "selectionStart" in a ? i = {
        start: a.selectionStart,
        end: a.selectionEnd
      } : i = q(a), i || {
        start: 0,
        end: 0
      };
    }
    function Re(a, i) {
      var l = i.start, c = i.end;
      c === void 0 && (c = l), "selectionStart" in a ? (a.selectionStart = l, a.selectionEnd = Math.min(c, a.value.length)) : Se(a, i);
    }
    var je = At && "documentMode" in document && document.documentMode <= 11;
    function Kt() {
      ot("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var gt = null, qt = null, tn = null, Jt = !1;
    function Jl(a) {
      if ("selectionStart" in a && zt(a))
        return {
          start: a.selectionStart,
          end: a.selectionEnd
        };
      var i = a.ownerDocument && a.ownerDocument.defaultView || window, l = i.getSelection();
      return {
        anchorNode: l.anchorNode,
        anchorOffset: l.anchorOffset,
        focusNode: l.focusNode,
        focusOffset: l.focusOffset
      };
    }
    function d0(a) {
      return a.window === a ? a.document : a.nodeType === ps ? a : a.ownerDocument;
    }
    function Cx(a, i, l) {
      var c = d0(l);
      if (!(Jt || gt == null || gt !== be(c))) {
        var h = Jl(gt);
        if (!tn || !g(tn, h)) {
          tn = h;
          var b = Bg(qt, "onSelect");
          if (b.length > 0) {
            var S = new Yu("onSelect", "select", null, i, l);
            a.push({
              event: S,
              listeners: b
            }), S.target = gt;
          }
        }
      }
    }
    function a6(a, i, l, c, h, b, S) {
      var E = l ? oh(l) : window;
      switch (i) {
        case "focusin":
          (Qm(E) || E.contentEditable === "true") && (gt = E, qt = l, tn = null);
          break;
        case "focusout":
          gt = null, qt = null, tn = null;
          break;
        case "mousedown":
          Jt = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Jt = !1, Cx(a, c, h);
          break;
        case "selectionchange":
          if (je)
            break;
        case "keydown":
        case "keyup":
          Cx(a, c, h);
      }
    }
    function i6(a, i, l, c, h, b, S) {
      var E = cf.get(i);
      if (E !== void 0) {
        var z = Yu, G = i;
        switch (i) {
          case "keypress":
            if (Os(c) === 0)
              return;
          case "keydown":
          case "keyup":
            z = qm;
            break;
          case "focusin":
            G = "focus", z = Qu;
            break;
          case "focusout":
            G = "blur", z = Qu;
            break;
          case "beforeblur":
          case "afterblur":
            z = Qu;
            break;
          case "click":
            if (c.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            z = wf;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            z = Rs;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            z = Sp;
            break;
          case Il:
          case Hu:
          case uf:
            z = Pp;
            break;
          case Vu:
            z = Rg;
            break;
          case "scroll":
            z = bp;
            break;
          case "wheel":
            z = Ym;
            break;
          case "copy":
          case "cut":
          case "paste":
            z = ll;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            z = $p;
            break;
        }
        var ee = (b & Xo) !== 0;
        {
          var we = !ee && i === "scroll", ae = u6(l, E, c.type, ee, we);
          if (ae.length > 0) {
            var ke = new z(E, G, null, c, h);
            a.push({
              event: ke,
              listeners: ae
            });
          }
        }
      }
    }
    Hc(), c0(), Kl(), Kt(), jg();
    function o6(a, i, l, c, h, b, S) {
      i6(a, i, l, c, h, b);
      var E = (b & Ol) === 0;
      E && (nh(a, i, l, c, h, b), Mf(a, i, l, c, h), a6(a, i, l, c, h), i0(a, i, l, c, h));
    }
    var Op = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], Mx = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Op));
    function Ex(a, i, l) {
      var c = a.type || "unknown-event";
      a.currentTarget = l, Du(c, i, void 0, a), a.currentTarget = null;
    }
    function s6(a, i, l) {
      var c;
      if (l)
        for (var h = i.length - 1; h >= 0; h--) {
          var b = i[h], S = b.instance, E = b.currentTarget, z = b.listener;
          if (S !== c && a.isPropagationStopped())
            return;
          Ex(a, z, E), c = S;
        }
      else
        for (var G = 0; G < i.length; G++) {
          var ee = i[G], we = ee.instance, ae = ee.currentTarget, ke = ee.listener;
          if (we !== c && a.isPropagationStopped())
            return;
          Ex(a, ke, ae), c = we;
        }
    }
    function Ax(a, i) {
      for (var l = (i & Xo) !== 0, c = 0; c < a.length; c++) {
        var h = a[c], b = h.event, S = h.listeners;
        s6(b, S, l);
      }
      bs();
    }
    function l6(a, i, l, c, h) {
      var b = Eu(l), S = [];
      o6(S, a, c, l, b, i), Ax(S, i);
    }
    function Rr(a, i) {
      var l = !1, c = l2(i), h = jx(a, l);
      c.has(h) || (Rx(i, a, _l, l), c.add(h));
    }
    var _x = "_reactListening" + Math.random().toString(36).slice(2);
    function Ox(a) {
      {
        if (a[_x])
          return;
        a[_x] = !0, Ce.forEach(function(i) {
          Mx.has(i) || Tx(i, !1, a, null), Tx(i, !0, a, null);
        });
      }
    }
    function Tx(a, i, l, c) {
      var h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, b = l;
      if (a === "selectionchange" && l.nodeType !== ps && (b = l.ownerDocument), c !== null && !i && Mx.has(a)) {
        if (a !== "scroll")
          return;
        h |= _l, b = c;
      }
      var S = l2(b), E = jx(a, i);
      S.has(E) || (i && (h |= Xo), Rx(b, a, h, i), S.add(E));
    }
    function Rx(a, i, l, c, h) {
      var b = Eg(a, i, l), S = void 0;
      Tu && (i === "touchstart" || i === "touchmove" || i === "wheel") && (S = !0), a = a, c ? S !== void 0 ? Tg(a, i, b, S) : yp(a, i, b) : S !== void 0 ? Zw(a, i, b, S) : Og(a, i, b);
    }
    function Dx(a, i) {
      return a === i || a.nodeType === Oa && a.parentNode === i;
    }
    function Nx(a, i, l, c, h) {
      var b = c;
      if (!(i & Xd) && !(i & _l)) {
        var S = h;
        if (c !== null) {
          var E = c;
          e:
            for (; ; ) {
              if (E === null)
                return;
              var z = E.tag;
              if (z === P || z === x) {
                var G = E.stateNode.containerInfo;
                if (Dx(G, S))
                  break;
                if (z === x)
                  for (var ee = E.return; ee !== null; ) {
                    var we = ee.tag;
                    if (we === P || we === x) {
                      var ae = ee.stateNode.containerInfo;
                      if (Dx(ae, S))
                        return;
                    }
                    ee = ee.return;
                  }
                for (; G !== null; ) {
                  var ke = _f(G);
                  if (ke === null)
                    return;
                  var ze = ke.tag;
                  if (ze === A || ze === M) {
                    E = b = ke;
                    continue e;
                  }
                  G = G.parentNode;
                }
              }
              E = E.return;
            }
        }
      }
      _u(function() {
        return l6(a, i, l, b);
      });
    }
    function Tp(a, i, l) {
      return {
        instance: a,
        listener: i,
        currentTarget: l
      };
    }
    function u6(a, i, l, c, h) {
      for (var b = i !== null ? i + "Capture" : null, S = c ? b : i, E = [], z = a, G = null; z !== null; ) {
        var ee = z, we = ee.stateNode, ae = ee.tag;
        if (ae === A && we !== null && (G = we, S !== null)) {
          var ke = Wi(z, S);
          ke != null && E.push(Tp(z, ke, G));
        }
        if (h)
          break;
        z = z.return;
      }
      return E;
    }
    function Bg(a, i) {
      for (var l = i + "Capture", c = [], h = a; h !== null; ) {
        var b = h, S = b.stateNode, E = b.tag;
        if (E === A && S !== null) {
          var z = S, G = Wi(h, l);
          G != null && c.unshift(Tp(h, G, z));
          var ee = Wi(h, i);
          ee != null && c.push(Tp(h, ee, z));
        }
        h = h.return;
      }
      return c;
    }
    function rh(a) {
      if (a === null)
        return null;
      do
        a = a.return;
      while (a && a.tag !== A);
      return a || null;
    }
    function c6(a, i) {
      for (var l = a, c = i, h = 0, b = l; b; b = rh(b))
        h++;
      for (var S = 0, E = c; E; E = rh(E))
        S++;
      for (; h - S > 0; )
        l = rh(l), h--;
      for (; S - h > 0; )
        c = rh(c), S--;
      for (var z = h; z--; ) {
        if (l === c || c !== null && l === c.alternate)
          return l;
        l = rh(l), c = rh(c);
      }
      return null;
    }
    function Wx(a, i, l, c, h) {
      for (var b = i._reactName, S = [], E = l; E !== null && E !== c; ) {
        var z = E, G = z.alternate, ee = z.stateNode, we = z.tag;
        if (G !== null && G === c)
          break;
        if (we === A && ee !== null) {
          var ae = ee;
          if (h) {
            var ke = Wi(E, b);
            ke != null && S.unshift(Tp(E, ke, ae));
          } else if (!h) {
            var ze = Wi(E, b);
            ze != null && S.push(Tp(E, ze, ae));
          }
        }
        E = E.return;
      }
      S.length !== 0 && a.push({
        event: i,
        listeners: S
      });
    }
    function d6(a, i, l, c, h) {
      var b = c && h ? c6(c, h) : null;
      c !== null && Wx(a, i, c, b, !1), h !== null && l !== null && Wx(a, l, h, b, !0);
    }
    function jx(a, i) {
      return a + "__" + (i ? "capture" : "bubble");
    }
    var Ro = !1, Rp = "dangerouslySetInnerHTML", Ug = "suppressContentEditableWarning", Dp = "suppressHydrationWarning", zx = "autoFocus", Ef = "children", Af = "style", Xg = "__html", ah = Cc.html, f0, Np, qg, Yg, Wp, Lx, Gg, Ix, jp, Fx;
    {
      f0 = {
        dialog: !0,
        webview: !0
      }, qg = function(a, i) {
        Ec(a, i), cp(a, i), Tm(a, i, {
          registrationNameDependencies: Ie,
          possibleRegistrationNames: $e
        });
      }, Ix = At && !document.documentMode;
      var f6 = /\r\n?/g, m6 = /\u0000|\uFFFD/g;
      jp = function(a) {
        var i = typeof a == "string" ? a : "" + a;
        return i.replace(f6, `
`).replace(m6, "");
      }, Yg = function(a, i) {
        if (!Ro) {
          var l = jp(i), c = jp(a);
          c !== l && (Ro = !0, m('Text content did not match. Server: "%s" Client: "%s"', c, l));
        }
      }, Wp = function(a, i, l) {
        if (!Ro) {
          var c = jp(l), h = jp(i);
          h !== c && (Ro = !0, m("Prop `%s` did not match. Server: %s Client: %s", a, JSON.stringify(h), JSON.stringify(c)));
        }
      }, Lx = function(a) {
        if (!Ro) {
          Ro = !0;
          var i = [];
          a.forEach(function(l) {
            i.push(l);
          }), m("Extra attributes from the server: %s", i);
        }
      }, Gg = function(a, i) {
        i === !1 ? m("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", a, a, a) : m("Expected `%s` listener to be a function, instead got a value of `%s` type.", a, typeof i);
      }, Fx = function(a, i) {
        var l = a.namespaceURI === ah ? a.ownerDocument.createElement(a.tagName) : a.ownerDocument.createElementNS(a.namespaceURI, a.tagName);
        return l.innerHTML = i, l.innerHTML;
      };
    }
    function Hx(a) {
      return a.nodeType === ps ? a : a.ownerDocument;
    }
    function h6() {
    }
    function Qg(a) {
      a.onclick = h6;
    }
    function p6(a, i, l, c, h) {
      for (var b in c)
        if (c.hasOwnProperty(b)) {
          var S = c[b];
          if (b === Af)
            S && Object.freeze(S), Fd(i, S);
          else if (b === Rp) {
            var E = S ? S[Xg] : void 0;
            E != null && pm(i, E);
          } else if (b === Ef)
            if (typeof S == "string") {
              var z = a !== "textarea" || S !== "";
              z && Mc(i, S);
            } else
              typeof S == "number" && Mc(i, "" + S);
          else
            b === Ug || b === Dp || b === zx || (Ie.hasOwnProperty(b) ? S != null && (typeof S != "function" && Gg(b, S), b === "onScroll" && Rr("scroll", i)) : S != null && vn(i, b, S, h));
        }
    }
    function v6(a, i, l, c) {
      for (var h = 0; h < i.length; h += 2) {
        var b = i[h], S = i[h + 1];
        b === Af ? Fd(a, S) : b === Rp ? pm(a, S) : b === Ef ? Mc(a, S) : vn(a, b, S, c);
      }
    }
    function g6(a, i, l, c) {
      var h, b = Hx(l), S, E = c;
      if (E === ah && (E = bu(a)), E === ah) {
        if (h = Ji(a, i), !h && a !== a.toLowerCase() && m("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", a), a === "script") {
          var z = b.createElement("div");
          z.innerHTML = "<script><\/script>";
          var G = z.firstChild;
          S = z.removeChild(G);
        } else if (typeof i.is == "string")
          S = b.createElement(a, {
            is: i.is
          });
        else if (S = b.createElement(a), a === "select") {
          var ee = S;
          i.multiple ? ee.multiple = !0 : i.size && (ee.size = i.size);
        }
      } else
        S = b.createElementNS(E, a);
      return E === ah && !h && Object.prototype.toString.call(S) === "[object HTMLUnknownElement]" && !Object.prototype.hasOwnProperty.call(f0, a) && (f0[a] = !0, m("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", a)), S;
    }
    function y6(a, i) {
      return Hx(i).createTextNode(a);
    }
    function b6(a, i, l, c) {
      var h = Ji(i, l);
      qg(i, l);
      var b;
      switch (i) {
        case "dialog":
          Rr("cancel", a), Rr("close", a), b = l;
          break;
        case "iframe":
        case "object":
        case "embed":
          Rr("load", a), b = l;
          break;
        case "video":
        case "audio":
          for (var S = 0; S < Op.length; S++)
            Rr(Op[S], a);
          b = l;
          break;
        case "source":
          Rr("error", a), b = l;
          break;
        case "img":
        case "image":
        case "link":
          Rr("error", a), Rr("load", a), b = l;
          break;
        case "details":
          Rr("toggle", a), b = l;
          break;
        case "input":
          Qt(a, l), b = Pt(a, l), Rr("invalid", a);
          break;
        case "option":
          N(a, l), b = de(a, l);
          break;
        case "select":
          jr(a, l), b = yn(a, l), Rr("invalid", a);
          break;
        case "textarea":
          yu(a, l), b = So(a, l), Rr("invalid", a);
          break;
        default:
          b = l;
      }
      switch (Qs(i, b), p6(i, a, c, b, h), i) {
        case "input":
          L(a), Hn(a, l, !1);
          break;
        case "textarea":
          L(a), oi(a);
          break;
        case "option":
          Z(a, l);
          break;
        case "select":
          sr(a, l);
          break;
        default:
          typeof b.onClick == "function" && Qg(a);
          break;
      }
    }
    function w6(a, i, l, c, h) {
      qg(i, c);
      var b = null, S, E;
      switch (i) {
        case "input":
          S = Pt(a, l), E = Pt(a, c), b = [];
          break;
        case "option":
          S = de(a, l), E = de(a, c), b = [];
          break;
        case "select":
          S = yn(a, l), E = yn(a, c), b = [];
          break;
        case "textarea":
          S = So(a, l), E = So(a, c), b = [];
          break;
        default:
          S = l, E = c, typeof S.onClick != "function" && typeof E.onClick == "function" && Qg(a);
          break;
      }
      Qs(i, E);
      var z, G, ee = null;
      for (z in S)
        if (!(E.hasOwnProperty(z) || !S.hasOwnProperty(z) || S[z] == null))
          if (z === Af) {
            var we = S[z];
            for (G in we)
              we.hasOwnProperty(G) && (ee || (ee = {}), ee[G] = "");
          } else
            z === Rp || z === Ef || z === Ug || z === Dp || z === zx || (Ie.hasOwnProperty(z) ? b || (b = []) : (b = b || []).push(z, null));
      for (z in E) {
        var ae = E[z], ke = S != null ? S[z] : void 0;
        if (!(!E.hasOwnProperty(z) || ae === ke || ae == null && ke == null))
          if (z === Af)
            if (ae && Object.freeze(ae), ke) {
              for (G in ke)
                ke.hasOwnProperty(G) && (!ae || !ae.hasOwnProperty(G)) && (ee || (ee = {}), ee[G] = "");
              for (G in ae)
                ae.hasOwnProperty(G) && ke[G] !== ae[G] && (ee || (ee = {}), ee[G] = ae[G]);
            } else
              ee || (b || (b = []), b.push(z, ee)), ee = ae;
          else if (z === Rp) {
            var ze = ae ? ae[Xg] : void 0, rt = ke ? ke[Xg] : void 0;
            ze != null && rt !== ze && (b = b || []).push(z, ze);
          } else
            z === Ef ? (typeof ae == "string" || typeof ae == "number") && (b = b || []).push(z, "" + ae) : z === Ug || z === Dp || (Ie.hasOwnProperty(z) ? (ae != null && (typeof ae != "function" && Gg(z, ae), z === "onScroll" && Rr("scroll", a)), !b && ke !== ae && (b = [])) : typeof ae == "object" && ae !== null && ae.$$typeof === Ti ? ae.toString() : (b = b || []).push(z, ae));
      }
      return ee && (Cm(ee, E[Af]), (b = b || []).push(Af, ee)), b;
    }
    function P6(a, i, l, c, h) {
      l === "input" && h.type === "radio" && h.name != null && dn(a, h);
      var b = Ji(l, c), S = Ji(l, h);
      switch (v6(a, i, b, S), l) {
        case "input":
          Wn(a, h);
          break;
        case "textarea":
          Td(a, h);
          break;
        case "select":
          Pi(a, h);
          break;
      }
    }
    function k6(a) {
      {
        var i = a.toLowerCase();
        return Bo.hasOwnProperty(i) && Bo[i] || null;
      }
    }
    function $6(a, i, l, c, h) {
      var b, S;
      switch (Np = l[Dp] === !0, b = Ji(i, l), qg(i, l), i) {
        case "dialog":
          Rr("cancel", a), Rr("close", a);
          break;
        case "iframe":
        case "object":
        case "embed":
          Rr("load", a);
          break;
        case "video":
        case "audio":
          for (var E = 0; E < Op.length; E++)
            Rr(Op[E], a);
          break;
        case "source":
          Rr("error", a);
          break;
        case "img":
        case "image":
        case "link":
          Rr("error", a), Rr("load", a);
          break;
        case "details":
          Rr("toggle", a);
          break;
        case "input":
          Qt(a, l), Rr("invalid", a);
          break;
        case "option":
          N(a, l);
          break;
        case "select":
          jr(a, l), Rr("invalid", a);
          break;
        case "textarea":
          yu(a, l), Rr("invalid", a);
          break;
      }
      Qs(i, l);
      {
        S = /* @__PURE__ */ new Set();
        for (var z = a.attributes, G = 0; G < z.length; G++) {
          var ee = z[G].name.toLowerCase();
          switch (ee) {
            case "data-reactroot":
              break;
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              S.add(z[G].name);
          }
        }
      }
      var we = null;
      for (var ae in l)
        if (l.hasOwnProperty(ae)) {
          var ke = l[ae];
          if (ae === Ef)
            typeof ke == "string" ? a.textContent !== ke && (Np || Yg(a.textContent, ke), we = [Ef, ke]) : typeof ke == "number" && a.textContent !== "" + ke && (Np || Yg(a.textContent, ke), we = [Ef, "" + ke]);
          else if (Ie.hasOwnProperty(ae))
            ke != null && (typeof ke != "function" && Gg(ae, ke), ae === "onScroll" && Rr("scroll", a));
          else if (typeof b == "boolean") {
            var ze = void 0, rt = Hr(ae);
            if (!Np) {
              if (!(ae === Ug || ae === Dp || ae === "value" || ae === "checked" || ae === "selected")) {
                if (ae === Rp) {
                  var Dt = a.innerHTML, rn = ke ? ke[Xg] : void 0;
                  if (rn != null) {
                    var Ft = Fx(a, rn);
                    Ft !== Dt && Wp(ae, Dt, Ft);
                  }
                } else if (ae === Af) {
                  if (S.delete(ae), Ix) {
                    var On = Sm(ke);
                    ze = a.getAttribute("style"), On !== ze && Wp(ae, ze, On);
                  }
                } else if (b)
                  S.delete(ae.toLowerCase()), ze = pn(a, ae, ke), ke !== ze && Wp(ae, ze, ke);
                else if (!xa(ae, rt, b) && !Xn(ae, ke, rt, b)) {
                  var dr = !1;
                  if (rt !== null)
                    S.delete(rt.attributeName), ze = ir(a, ae, ke, rt);
                  else {
                    var Pe = c;
                    if (Pe === ah && (Pe = bu(i)), Pe === ah)
                      S.delete(ae.toLowerCase());
                    else {
                      var Ae = k6(ae);
                      Ae !== null && Ae !== ae && (dr = !0, S.delete(Ae)), S.delete(ae);
                    }
                    ze = pn(a, ae, ke);
                  }
                  ke !== ze && !dr && Wp(ae, ze, ke);
                }
              }
            }
          }
        }
      switch (S.size > 0 && !Np && Lx(S), i) {
        case "input":
          L(a), Hn(a, l, !0);
          break;
        case "textarea":
          L(a), oi(a);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof l.onClick == "function" && Qg(a);
          break;
      }
      return we;
    }
    function S6(a, i) {
      var l = a.nodeValue !== i;
      return l;
    }
    function Vx(a, i) {
      Yg(a.nodeValue, i);
    }
    function Bx(a, i) {
      {
        if (Ro)
          return;
        Ro = !0, m("Did not expect server HTML to contain a <%s> in <%s>.", i.nodeName.toLowerCase(), a.nodeName.toLowerCase());
      }
    }
    function Ux(a, i) {
      {
        if (Ro)
          return;
        Ro = !0, m('Did not expect server HTML to contain the text node "%s" in <%s>.', i.nodeValue, a.nodeName.toLowerCase());
      }
    }
    function Xx(a, i, l) {
      {
        if (Ro)
          return;
        Ro = !0, m("Expected server HTML to contain a matching <%s> in <%s>.", i, a.nodeName.toLowerCase());
      }
    }
    function qx(a, i) {
      {
        if (i === "" || Ro)
          return;
        Ro = !0, m('Expected server HTML to contain a matching text node for "%s" in <%s>.', i, a.nodeName.toLowerCase());
      }
    }
    function x6(a, i, l) {
      switch (i) {
        case "input":
          wr(a, l);
          return;
        case "textarea":
          Sl(a, l);
          return;
        case "select":
          ki(a, l);
          return;
      }
    }
    var zp = function() {
    }, Lp = function() {
    };
    {
      var C6 = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], Yx = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        "foreignObject",
        "desc",
        "title"
      ], M6 = Yx.concat(["button"]), E6 = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], Gx = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      Lp = function(a, i) {
        var l = t({}, a || Gx), c = {
          tag: i
        };
        return Yx.indexOf(i) !== -1 && (l.aTagInScope = null, l.buttonTagInScope = null, l.nobrTagInScope = null), M6.indexOf(i) !== -1 && (l.pTagInButtonScope = null), C6.indexOf(i) !== -1 && i !== "address" && i !== "div" && i !== "p" && (l.listItemTagAutoclosing = null, l.dlItemTagAutoclosing = null), l.current = c, i === "form" && (l.formTag = c), i === "a" && (l.aTagInScope = c), i === "button" && (l.buttonTagInScope = c), i === "nobr" && (l.nobrTagInScope = c), i === "p" && (l.pTagInButtonScope = c), i === "li" && (l.listItemTagAutoclosing = c), (i === "dd" || i === "dt") && (l.dlItemTagAutoclosing = c), l;
      };
      var A6 = function(a, i) {
        switch (i) {
          case "select":
            return a === "option" || a === "optgroup" || a === "#text";
          case "optgroup":
            return a === "option" || a === "#text";
          case "option":
            return a === "#text";
          case "tr":
            return a === "th" || a === "td" || a === "style" || a === "script" || a === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return a === "tr" || a === "style" || a === "script" || a === "template";
          case "colgroup":
            return a === "col" || a === "template";
          case "table":
            return a === "caption" || a === "colgroup" || a === "tbody" || a === "tfoot" || a === "thead" || a === "style" || a === "script" || a === "template";
          case "head":
            return a === "base" || a === "basefont" || a === "bgsound" || a === "link" || a === "meta" || a === "title" || a === "noscript" || a === "noframes" || a === "style" || a === "script" || a === "template";
          case "html":
            return a === "head" || a === "body" || a === "frameset";
          case "frameset":
            return a === "frame";
          case "#document":
            return a === "html";
        }
        switch (a) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return i !== "h1" && i !== "h2" && i !== "h3" && i !== "h4" && i !== "h5" && i !== "h6";
          case "rp":
          case "rt":
            return E6.indexOf(i) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return i == null;
        }
        return !0;
      }, _6 = function(a, i) {
        switch (a) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return i.pTagInButtonScope;
          case "form":
            return i.formTag || i.pTagInButtonScope;
          case "li":
            return i.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return i.dlItemTagAutoclosing;
          case "button":
            return i.buttonTagInScope;
          case "a":
            return i.aTagInScope;
          case "nobr":
            return i.nobrTagInScope;
        }
        return null;
      }, Qx = {};
      zp = function(a, i, l) {
        l = l || Gx;
        var c = l.current, h = c && c.tag;
        i != null && (a != null && m("validateDOMNesting: when childText is passed, childTag should be null"), a = "#text");
        var b = A6(a, h) ? null : c, S = b ? null : _6(a, l), E = b || S;
        if (E) {
          var z = E.tag, G = !!b + "|" + a + "|" + z;
          if (!Qx[G]) {
            Qx[G] = !0;
            var ee = a, we = "";
            if (a === "#text" ? /\S/.test(i) ? ee = "Text nodes" : (ee = "Whitespace text nodes", we = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : ee = "<" + a + ">", b) {
              var ae = "";
              z === "table" && a === "tr" && (ae += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), m("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", ee, z, we, ae);
            } else
              m("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", ee, z);
          }
        }
      };
    }
    var ih;
    ih = "suppressHydrationWarning";
    var Kx = "$", Jx = "/$", m0 = "$?", h0 = "$!", O6 = "style", p0 = null, v0 = null;
    function Zx(a, i) {
      switch (a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!i.autoFocus;
      }
      return !1;
    }
    function T6(a) {
      var i, l, c = a.nodeType;
      switch (c) {
        case ps:
        case vm: {
          i = c === ps ? "#document" : "#fragment";
          var h = a.documentElement;
          l = h ? h.namespaceURI : Gs(null, "");
          break;
        }
        default: {
          var b = c === Oa ? a.parentNode : a, S = b.namespaceURI || null;
          i = b.tagName, l = Gs(S, i);
          break;
        }
      }
      {
        var E = i.toLowerCase(), z = Lp(null, E);
        return {
          namespace: l,
          ancestorInfo: z
        };
      }
    }
    function R6(a, i, l) {
      {
        var c = a, h = Gs(c.namespace, i), b = Lp(c.ancestorInfo, i);
        return {
          namespace: h,
          ancestorInfo: b
        };
      }
    }
    function lJe(a) {
      return a;
    }
    function D6(a) {
      p0 = Mg(), v0 = ge();
      var i = null;
      return gp(!1), i;
    }
    function N6(a) {
      le(v0), gp(p0), p0 = null, v0 = null;
    }
    function W6(a, i, l, c, h) {
      var b;
      {
        var S = c;
        if (zp(a, null, S.ancestorInfo), typeof i.children == "string" || typeof i.children == "number") {
          var E = "" + i.children, z = Lp(S.ancestorInfo, a);
          zp(null, E, z);
        }
        b = S.namespace;
      }
      var G = g6(a, i, l, b);
      return Zg(h, G), w0(G, i), G;
    }
    function j6(a, i) {
      a.appendChild(i);
    }
    function z6(a, i, l, c, h) {
      return b6(a, i, l, c), Zx(i, l);
    }
    function L6(a, i, l, c, h, b) {
      {
        var S = b;
        if (typeof c.children != typeof l.children && (typeof c.children == "string" || typeof c.children == "number")) {
          var E = "" + c.children, z = Lp(S.ancestorInfo, i);
          zp(null, E, z);
        }
      }
      return w6(a, i, l, c);
    }
    function g0(a, i) {
      return a === "textarea" || a === "option" || a === "noscript" || typeof i.children == "string" || typeof i.children == "number" || typeof i.dangerouslySetInnerHTML == "object" && i.dangerouslySetInnerHTML !== null && i.dangerouslySetInnerHTML.__html != null;
    }
    function I6(a, i, l, c) {
      {
        var h = l;
        zp(null, a, h.ancestorInfo);
      }
      var b = y6(a, i);
      return Zg(c, b), b;
    }
    var e2 = typeof setTimeout == "function" ? setTimeout : void 0, F6 = typeof clearTimeout == "function" ? clearTimeout : void 0, y0 = -1;
    function H6(a, i, l, c) {
      Zx(i, l) && a.focus();
    }
    function V6(a, i, l, c, h, b) {
      w0(a, h), P6(a, i, l, c, h);
    }
    function t2(a) {
      Mc(a, "");
    }
    function B6(a, i, l) {
      a.nodeValue = l;
    }
    function U6(a, i) {
      a.appendChild(i);
    }
    function X6(a, i) {
      var l;
      a.nodeType === Oa ? (l = a.parentNode, l.insertBefore(i, a)) : (l = a, l.appendChild(i));
      var c = a._reactRootContainer;
      c == null && l.onclick === null && Qg(l);
    }
    function q6(a, i, l) {
      a.insertBefore(i, l);
    }
    function Y6(a, i, l) {
      a.nodeType === Oa ? a.parentNode.insertBefore(i, l) : a.insertBefore(i, l);
    }
    function G6(a, i) {
      a.removeChild(i);
    }
    function Q6(a, i) {
      a.nodeType === Oa ? a.parentNode.removeChild(i) : a.removeChild(i);
    }
    function K6(a) {
      a = a;
      var i = a.style;
      typeof i.setProperty == "function" ? i.setProperty("display", "none", "important") : i.display = "none";
    }
    function J6(a) {
      a.nodeValue = "";
    }
    function Z6(a, i) {
      a = a;
      var l = i[O6], c = l != null && l.hasOwnProperty("display") ? l.display : null;
      a.style.display = Ml("display", c);
    }
    function ej(a, i) {
      a.nodeValue = i;
    }
    function b0(a) {
      if (a.nodeType === Ni)
        a.textContent = "";
      else if (a.nodeType === ps) {
        var i = a.body;
        i != null && (i.textContent = "");
      }
    }
    function tj(a, i, l) {
      return a.nodeType !== Ni || i.toLowerCase() !== a.nodeName.toLowerCase() ? null : a;
    }
    function nj(a, i) {
      return i === "" || a.nodeType !== Ho ? null : a;
    }
    function rj(a) {
      return a.data === m0;
    }
    function aj(a) {
      return a.data === h0;
    }
    function n2(a) {
      for (; a != null; a = a.nextSibling) {
        var i = a.nodeType;
        if (i === Ni || i === Ho)
          break;
      }
      return a;
    }
    function Kg(a) {
      return n2(a.nextSibling);
    }
    function r2(a) {
      return n2(a.firstChild);
    }
    function ij(a, i, l, c, h, b) {
      Zg(b, a), w0(a, l);
      var S;
      {
        var E = h;
        S = E.namespace;
      }
      return $6(a, i, l, S);
    }
    function oj(a, i, l) {
      return Zg(l, a), S6(a, i);
    }
    function sj(a) {
      for (var i = a.nextSibling, l = 0; i; ) {
        if (i.nodeType === Oa) {
          var c = i.data;
          if (c === Jx) {
            if (l === 0)
              return Kg(i);
            l--;
          } else
            (c === Kx || c === h0 || c === m0) && l++;
        }
        i = i.nextSibling;
      }
      return null;
    }
    function a2(a) {
      for (var i = a.previousSibling, l = 0; i; ) {
        if (i.nodeType === Oa) {
          var c = i.data;
          if (c === Kx || c === h0 || c === m0) {
            if (l === 0)
              return i;
            l--;
          } else
            c === Jx && l++;
        }
        i = i.previousSibling;
      }
      return null;
    }
    function lj(a) {
      lf(a);
    }
    function uj(a) {
      lf(a);
    }
    function cj(a, i, l) {
      Vx(i, l);
    }
    function dj(a, i, l, c, h) {
      i[ih] !== !0 && Vx(c, h);
    }
    function fj(a, i) {
      i.nodeType === Ni ? Bx(a, i) : i.nodeType === Oa || Ux(a, i);
    }
    function mj(a, i, l, c) {
      i[ih] !== !0 && (c.nodeType === Ni ? Bx(l, c) : c.nodeType === Oa || Ux(l, c));
    }
    function hj(a, i, l) {
      Xx(a, i);
    }
    function pj(a, i) {
      qx(a, i);
    }
    function vj(a, i, l, c, h) {
      i[ih] !== !0 && Xx(l, c);
    }
    function gj(a, i, l, c) {
      i[ih] !== !0 && qx(l, c);
    }
    function yj(a, i, l) {
      i[ih];
    }
    var bj = 0;
    function wj(a) {
      var i = "r:" + (bj++).toString(36);
      return {
        toString: function() {
          return a(), i;
        },
        valueOf: function() {
          return a(), i;
        }
      };
    }
    function Pj(a) {
      return a !== null && typeof a == "object" && a.$$typeof === Ti;
    }
    function kj(a) {
      return {
        $$typeof: Ti,
        toString: a,
        valueOf: a
      };
    }
    function $j(a) {
      Ox(a);
    }
    var Jg = Math.random().toString(36).slice(2), Ip = "__reactFiber$" + Jg, i2 = "__reactProps$" + Jg, Fp = "__reactContainer$" + Jg, o2 = "__reactEvents$" + Jg;
    function Zg(a, i) {
      i[Ip] = a;
    }
    function Sj(a, i) {
      i[Fp] = a;
    }
    function s2(a) {
      a[Fp] = null;
    }
    function ey(a) {
      return !!a[Fp];
    }
    function _f(a) {
      var i = a[Ip];
      if (i)
        return i;
      for (var l = a.parentNode; l; ) {
        if (i = l[Fp] || l[Ip], i) {
          var c = i.alternate;
          if (i.child !== null || c !== null && c.child !== null)
            for (var h = a2(a); h !== null; ) {
              var b = h[Ip];
              if (b)
                return b;
              h = a2(h);
            }
          return i;
        }
        a = l, l = a.parentNode;
      }
      return null;
    }
    function Qc(a) {
      var i = a[Ip] || a[Fp];
      return i && (i.tag === A || i.tag === M || i.tag === U || i.tag === P) ? i : null;
    }
    function oh(a) {
      if (a.tag === A || a.tag === M)
        return a.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function ty(a) {
      return a[i2] || null;
    }
    function w0(a, i) {
      a[i2] = i;
    }
    function l2(a) {
      var i = a[o2];
      return i === void 0 && (i = a[o2] = /* @__PURE__ */ new Set()), i;
    }
    var u2 = {}, c2 = s.ReactDebugCurrentFrame;
    function ny(a) {
      if (a) {
        var i = a._owner, l = Ur(a.type, a._source, i ? i.type : null);
        c2.setExtraStackFrame(l);
      } else
        c2.setExtraStackFrame(null);
    }
    function cl(a, i, l, c, h) {
      {
        var b = Function.call.bind(Object.prototype.hasOwnProperty);
        for (var S in a)
          if (b(a, S)) {
            var E = void 0;
            try {
              if (typeof a[S] != "function") {
                var z = Error((c || "React class") + ": " + l + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw z.name = "Invariant Violation", z;
              }
              E = a[S](i, S, c, l, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              E = G;
            }
            E && !(E instanceof Error) && (ny(h), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", c || "React class", l, S, typeof E), ny(null)), E instanceof Error && !(E.message in u2) && (u2[E.message] = !0, ny(h), m("Failed %s type: %s", l, E.message), ny(null));
          }
      }
    }
    var P0 = [], ry;
    ry = [];
    var ec = -1;
    function Kc(a) {
      return {
        current: a
      };
    }
    function Ii(a, i) {
      if (ec < 0) {
        m("Unexpected pop.");
        return;
      }
      i !== ry[ec] && m("Unexpected Fiber popped."), a.current = P0[ec], P0[ec] = null, ry[ec] = null, ec--;
    }
    function Fi(a, i, l) {
      ec++, P0[ec] = a.current, ry[ec] = l, a.current = i;
    }
    var k0;
    k0 = {};
    var ns = {};
    Object.freeze(ns);
    var tc = Kc(ns), Zl = Kc(!1), $0 = ns;
    function sh(a, i, l) {
      return l && eu(i) ? $0 : tc.current;
    }
    function d2(a, i, l) {
      {
        var c = a.stateNode;
        c.__reactInternalMemoizedUnmaskedChildContext = i, c.__reactInternalMemoizedMaskedChildContext = l;
      }
    }
    function lh(a, i) {
      {
        var l = a.type, c = l.contextTypes;
        if (!c)
          return ns;
        var h = a.stateNode;
        if (h && h.__reactInternalMemoizedUnmaskedChildContext === i)
          return h.__reactInternalMemoizedMaskedChildContext;
        var b = {};
        for (var S in c)
          b[S] = i[S];
        {
          var E = Je(l) || "Unknown";
          cl(c, b, "context", E);
        }
        return h && d2(a, i, b), b;
      }
    }
    function ay() {
      return Zl.current;
    }
    function eu(a) {
      {
        var i = a.childContextTypes;
        return i != null;
      }
    }
    function iy(a) {
      Ii(Zl, a), Ii(tc, a);
    }
    function S0(a) {
      Ii(Zl, a), Ii(tc, a);
    }
    function f2(a, i, l) {
      {
        if (tc.current !== ns)
          throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Fi(tc, i, a), Fi(Zl, l, a);
      }
    }
    function m2(a, i, l) {
      {
        var c = a.stateNode, h = i.childContextTypes;
        if (typeof c.getChildContext != "function") {
          {
            var b = Je(i) || "Unknown";
            k0[b] || (k0[b] = !0, m("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", b, b));
          }
          return l;
        }
        var S = c.getChildContext();
        for (var E in S)
          if (!(E in h))
            throw Error((Je(i) || "Unknown") + '.getChildContext(): key "' + E + '" is not defined in childContextTypes.');
        {
          var z = Je(i) || "Unknown";
          cl(h, S, "child context", z);
        }
        return t({}, l, S);
      }
    }
    function oy(a) {
      {
        var i = a.stateNode, l = i && i.__reactInternalMemoizedMergedChildContext || ns;
        return $0 = tc.current, Fi(tc, l, a), Fi(Zl, Zl.current, a), !0;
      }
    }
    function h2(a, i, l) {
      {
        var c = a.stateNode;
        if (!c)
          throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (l) {
          var h = m2(a, i, $0);
          c.__reactInternalMemoizedMergedChildContext = h, Ii(Zl, a), Ii(tc, a), Fi(tc, h, a), Fi(Zl, l, a);
        } else
          Ii(Zl, a), Fi(Zl, l, a);
      }
    }
    function xj(a) {
      {
        if (!(zc(a) && a.tag === y))
          throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var i = a;
        do {
          switch (i.tag) {
            case P:
              return i.stateNode.context;
            case y: {
              var l = i.type;
              if (eu(l))
                return i.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          i = i.return;
        } while (i !== null);
        throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var x0 = 0, p2 = 1, v2 = 2, sy = null, tu = null, uh = !1, Cj = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Mj(a) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var i = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (i.isDisabled)
        return !0;
      if (!i.supportsFiber)
        return m("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        sy = i.inject(a), tu = i;
      } catch (l) {
        m("React instrumentation encountered an error: %s.", l);
      }
      return !0;
    }
    function Ej(a, i) {
      if (tu && typeof tu.onScheduleFiberRoot == "function")
        try {
          tu.onScheduleFiberRoot(sy, a, i);
        } catch (l) {
          uh || (uh = !0, m("React instrumentation encountered an error: %s", l));
        }
    }
    function Aj(a, i) {
      if (tu && typeof tu.onCommitFiberRoot == "function")
        try {
          var l = (a.current.flags & En) === En;
          ie && tu.onCommitFiberRoot(sy, a, i, l);
        } catch (c) {
          uh || (uh = !0, m("React instrumentation encountered an error: %s", c));
        }
    }
    function _j(a) {
      if (tu && typeof tu.onCommitFiberUnmount == "function")
        try {
          tu.onCommitFiberUnmount(sy, a);
        } catch (i) {
          uh || (uh = !0, m("React instrumentation encountered an error: %s", i));
        }
    }
    var Oj = n.unstable_runWithPriority, C0 = n.unstable_scheduleCallback, g2 = n.unstable_cancelCallback, Tj = n.unstable_shouldYield, y2 = n.unstable_requestPaint, M0 = n.unstable_now, Rj = n.unstable_getCurrentPriorityLevel, ly = n.unstable_ImmediatePriority, b2 = n.unstable_UserBlockingPriority, w2 = n.unstable_NormalPriority, P2 = n.unstable_LowPriority, k2 = n.unstable_IdlePriority;
    if (!(r.__interactionsRef != null && r.__interactionsRef.current != null))
      throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    var $2 = {}, Ws = 99, Of = 98, nc = 97, S2 = 96, x2 = 95, E0 = 90, Dj = Tj, Nj = y2 !== void 0 ? y2 : function() {
    }, rc = null, uy = null, A0 = !1, C2 = M0(), Hi = C2 < 1e4 ? M0 : function() {
      return M0() - C2;
    };
    function ch() {
      switch (Rj()) {
        case ly:
          return Ws;
        case b2:
          return Of;
        case w2:
          return nc;
        case P2:
          return S2;
        case k2:
          return x2;
        default:
          throw Error("Unknown priority level.");
      }
    }
    function M2(a) {
      switch (a) {
        case Ws:
          return ly;
        case Of:
          return b2;
        case nc:
          return w2;
        case S2:
          return P2;
        case x2:
          return k2;
        default:
          throw Error("Unknown priority level.");
      }
    }
    function Tf(a, i) {
      var l = M2(a);
      return Oj(l, i);
    }
    function Jc(a, i, l) {
      var c = M2(a);
      return C0(c, i, l);
    }
    function Wj(a) {
      return rc === null ? (rc = [a], uy = C0(ly, A2)) : rc.push(a), $2;
    }
    function E2(a) {
      a !== $2 && g2(a);
    }
    function nu() {
      if (uy !== null) {
        var a = uy;
        uy = null, g2(a);
      }
      A2();
    }
    function A2() {
      if (!A0 && rc !== null) {
        A0 = !0;
        var a = 0;
        try {
          var i = !0, l = rc;
          Tf(Ws, function() {
            for (; a < l.length; a++) {
              var c = l[a];
              do
                c = c(i);
              while (c !== null);
            }
          }), rc = null;
        } catch (c) {
          throw rc !== null && (rc = rc.slice(a + 1)), C0(ly, nu), c;
        } finally {
          A0 = !1;
        }
      }
    }
    var _2 = "17.0.2", Lr = 0, oa = 1, Do = 2, Rf = 4, rs = 8, jj = 16, zj = s.ReactCurrentBatchConfig, Lj = 0;
    function Ij() {
      return zj.transition;
    }
    var dl = {
      recordUnsafeLifecycleWarnings: function(a, i) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(a, i) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var Fj = function(a) {
        for (var i = null, l = a; l !== null; )
          l.mode & oa && (i = l), l = l.return;
        return i;
      }, Df = function(a) {
        var i = [];
        return a.forEach(function(l) {
          i.push(l);
        }), i.sort().join(", ");
      }, Hp = [], Vp = [], Bp = [], Up = [], Xp = [], qp = [], Nf = /* @__PURE__ */ new Set();
      dl.recordUnsafeLifecycleWarnings = function(a, i) {
        Nf.has(a.type) || (typeof i.componentWillMount == "function" && i.componentWillMount.__suppressDeprecationWarning !== !0 && Hp.push(a), a.mode & oa && typeof i.UNSAFE_componentWillMount == "function" && Vp.push(a), typeof i.componentWillReceiveProps == "function" && i.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Bp.push(a), a.mode & oa && typeof i.UNSAFE_componentWillReceiveProps == "function" && Up.push(a), typeof i.componentWillUpdate == "function" && i.componentWillUpdate.__suppressDeprecationWarning !== !0 && Xp.push(a), a.mode & oa && typeof i.UNSAFE_componentWillUpdate == "function" && qp.push(a));
      }, dl.flushPendingUnsafeLifecycleWarnings = function() {
        var a = /* @__PURE__ */ new Set();
        Hp.length > 0 && (Hp.forEach(function(ae) {
          a.add(Je(ae.type) || "Component"), Nf.add(ae.type);
        }), Hp = []);
        var i = /* @__PURE__ */ new Set();
        Vp.length > 0 && (Vp.forEach(function(ae) {
          i.add(Je(ae.type) || "Component"), Nf.add(ae.type);
        }), Vp = []);
        var l = /* @__PURE__ */ new Set();
        Bp.length > 0 && (Bp.forEach(function(ae) {
          l.add(Je(ae.type) || "Component"), Nf.add(ae.type);
        }), Bp = []);
        var c = /* @__PURE__ */ new Set();
        Up.length > 0 && (Up.forEach(function(ae) {
          c.add(Je(ae.type) || "Component"), Nf.add(ae.type);
        }), Up = []);
        var h = /* @__PURE__ */ new Set();
        Xp.length > 0 && (Xp.forEach(function(ae) {
          h.add(Je(ae.type) || "Component"), Nf.add(ae.type);
        }), Xp = []);
        var b = /* @__PURE__ */ new Set();
        if (qp.length > 0 && (qp.forEach(function(ae) {
          b.add(Je(ae.type) || "Component"), Nf.add(ae.type);
        }), qp = []), i.size > 0) {
          var S = Df(i);
          m(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, S);
        }
        if (c.size > 0) {
          var E = Df(c);
          m(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, E);
        }
        if (b.size > 0) {
          var z = Df(b);
          m(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, z);
        }
        if (a.size > 0) {
          var G = Df(a);
          f(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, G);
        }
        if (l.size > 0) {
          var ee = Df(l);
          f(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ee);
        }
        if (h.size > 0) {
          var we = Df(h);
          f(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, we);
        }
      };
      var cy = /* @__PURE__ */ new Map(), O2 = /* @__PURE__ */ new Set();
      dl.recordLegacyContextWarning = function(a, i) {
        var l = Fj(a);
        if (l === null) {
          m("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!O2.has(a.type)) {
          var c = cy.get(l);
          (a.type.contextTypes != null || a.type.childContextTypes != null || i !== null && typeof i.getChildContext == "function") && (c === void 0 && (c = [], cy.set(l, c)), c.push(a));
        }
      }, dl.flushLegacyContextWarning = function() {
        cy.forEach(function(a, i) {
          if (a.length !== 0) {
            var l = a[0], c = /* @__PURE__ */ new Set();
            a.forEach(function(b) {
              c.add(Je(b.type) || "Component"), O2.add(b.type);
            });
            var h = Df(c);
            try {
              qn(l), m(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, h);
            } finally {
              yr();
            }
          }
        });
      }, dl.discardPendingWarnings = function() {
        Hp = [], Vp = [], Bp = [], Up = [], Xp = [], qp = [], cy = /* @__PURE__ */ new Map();
      };
    }
    function fl(a, i) {
      if (a && a.defaultProps) {
        var l = t({}, i), c = a.defaultProps;
        for (var h in c)
          l[h] === void 0 && (l[h] = c[h]);
        return l;
      }
      return i;
    }
    var dy = 1073741823, _0 = Kc(null), O0;
    O0 = {};
    var fy = null, dh = null, my = null, hy = !1;
    function py() {
      fy = null, dh = null, my = null, hy = !1;
    }
    function T2() {
      hy = !0;
    }
    function R2() {
      hy = !1;
    }
    function D2(a, i) {
      var l = a.type._context;
      Fi(_0, l._currentValue, a), l._currentValue = i, l._currentRenderer !== void 0 && l._currentRenderer !== null && l._currentRenderer !== O0 && m("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), l._currentRenderer = O0;
    }
    function T0(a) {
      var i = _0.current;
      Ii(_0, a);
      var l = a.type._context;
      l._currentValue = i;
    }
    function Hj(a, i, l) {
      if (u(l, i))
        return 0;
      var c = typeof a._calculateChangedBits == "function" ? a._calculateChangedBits(l, i) : dy;
      return (c & dy) !== c && m("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", c), c | 0;
    }
    function N2(a, i) {
      for (var l = a; l !== null; ) {
        var c = l.alternate;
        if (!ci(l.childLanes, i))
          l.childLanes = bn(l.childLanes, i), c !== null && (c.childLanes = bn(c.childLanes, i));
        else if (c !== null && !ci(c.childLanes, i))
          c.childLanes = bn(c.childLanes, i);
        else
          break;
        l = l.return;
      }
    }
    function Vj(a, i, l, c) {
      var h = a.child;
      for (h !== null && (h.return = a); h !== null; ) {
        var b = void 0, S = h.dependencies;
        if (S !== null) {
          b = h.child;
          for (var E = S.firstContext; E !== null; ) {
            if (E.context === i && E.observedBits & l) {
              if (h.tag === y) {
                var z = Zc(St, hr(c));
                z.tag = vy, ed(h, z);
              }
              h.lanes = bn(h.lanes, c);
              var G = h.alternate;
              G !== null && (G.lanes = bn(G.lanes, c)), N2(h.return, c), S.lanes = bn(S.lanes, c);
              break;
            }
            E = E.next;
          }
        } else
          h.tag === J ? b = h.type === a.type ? null : h.child : b = h.child;
        if (b !== null)
          b.return = h;
        else
          for (b = h; b !== null; ) {
            if (b === a) {
              b = null;
              break;
            }
            var ee = b.sibling;
            if (ee !== null) {
              ee.return = b.return, b = ee;
              break;
            }
            b = b.return;
          }
        h = b;
      }
    }
    function fh(a, i) {
      fy = a, dh = null, my = null;
      var l = a.dependencies;
      if (l !== null) {
        var c = l.firstContext;
        c !== null && (Tr(l.lanes, i) && IP(), l.firstContext = null);
      }
    }
    function Wa(a, i) {
      if (hy && m("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), my !== a) {
        if (!(i === !1 || i === 0)) {
          var l;
          typeof i != "number" || i === dy ? (my = a, l = dy) : l = i;
          var c = {
            context: a,
            observedBits: l,
            next: null
          };
          if (dh === null) {
            if (fy === null)
              throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            dh = c, fy.dependencies = {
              lanes: Te,
              firstContext: c,
              responders: null
            };
          } else
            dh = dh.next = c;
        }
      }
      return a._currentValue;
    }
    var W2 = 0, j2 = 1, vy = 2, R0 = 3, gy = !1, D0, yy;
    D0 = !1, yy = null;
    function N0(a) {
      var i = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null
        },
        effects: null
      };
      a.updateQueue = i;
    }
    function z2(a, i) {
      var l = i.updateQueue, c = a.updateQueue;
      if (l === c) {
        var h = {
          baseState: c.baseState,
          firstBaseUpdate: c.firstBaseUpdate,
          lastBaseUpdate: c.lastBaseUpdate,
          shared: c.shared,
          effects: c.effects
        };
        i.updateQueue = h;
      }
    }
    function Zc(a, i) {
      var l = {
        eventTime: a,
        lane: i,
        tag: W2,
        payload: null,
        callback: null,
        next: null
      };
      return l;
    }
    function ed(a, i) {
      var l = a.updateQueue;
      if (l !== null) {
        var c = l.shared, h = c.pending;
        h === null ? i.next = i : (i.next = h.next, h.next = i), c.pending = i, yy === c && !D0 && (m("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), D0 = !0);
      }
    }
    function L2(a, i) {
      var l = a.updateQueue, c = a.alternate;
      if (c !== null) {
        var h = c.updateQueue;
        if (l === h) {
          var b = null, S = null, E = l.firstBaseUpdate;
          if (E !== null) {
            var z = E;
            do {
              var G = {
                eventTime: z.eventTime,
                lane: z.lane,
                tag: z.tag,
                payload: z.payload,
                callback: z.callback,
                next: null
              };
              S === null ? b = S = G : (S.next = G, S = G), z = z.next;
            } while (z !== null);
            S === null ? b = S = i : (S.next = i, S = i);
          } else
            b = S = i;
          l = {
            baseState: h.baseState,
            firstBaseUpdate: b,
            lastBaseUpdate: S,
            shared: h.shared,
            effects: h.effects
          }, a.updateQueue = l;
          return;
        }
      }
      var ee = l.lastBaseUpdate;
      ee === null ? l.firstBaseUpdate = i : ee.next = i, l.lastBaseUpdate = i;
    }
    function Bj(a, i, l, c, h, b) {
      switch (l.tag) {
        case j2: {
          var S = l.payload;
          if (typeof S == "function") {
            T2();
            var E = S.call(b, c, h);
            {
              if (a.mode & oa) {
                Zr();
                try {
                  S.call(b, c, h);
                } finally {
                  mr();
                }
              }
              R2();
            }
            return E;
          }
          return S;
        }
        case R0:
          a.flags = a.flags & ~to | En;
        case W2: {
          var z = l.payload, G;
          if (typeof z == "function") {
            T2(), G = z.call(b, c, h);
            {
              if (a.mode & oa) {
                Zr();
                try {
                  z.call(b, c, h);
                } finally {
                  mr();
                }
              }
              R2();
            }
          } else
            G = z;
          return G == null ? c : t({}, c, G);
        }
        case vy:
          return gy = !0, c;
      }
      return c;
    }
    function Yp(a, i, l, c) {
      var h = a.updateQueue;
      gy = !1, yy = h.shared;
      var b = h.firstBaseUpdate, S = h.lastBaseUpdate, E = h.shared.pending;
      if (E !== null) {
        h.shared.pending = null;
        var z = E, G = z.next;
        z.next = null, S === null ? b = G : S.next = G, S = z;
        var ee = a.alternate;
        if (ee !== null) {
          var we = ee.updateQueue, ae = we.lastBaseUpdate;
          ae !== S && (ae === null ? we.firstBaseUpdate = G : ae.next = G, we.lastBaseUpdate = z);
        }
      }
      if (b !== null) {
        var ke = h.baseState, ze = Te, rt = null, Dt = null, rn = null, Ft = b;
        do {
          var On = Ft.lane, dr = Ft.eventTime;
          if (ci(c, On)) {
            if (rn !== null) {
              var Ae = {
                eventTime: dr,
                lane: ln,
                tag: Ft.tag,
                payload: Ft.payload,
                callback: Ft.callback,
                next: null
              };
              rn = rn.next = Ae;
            }
            ke = Bj(a, h, Ft, ke, i, l);
            var pe = Ft.callback;
            if (pe !== null) {
              a.flags |= Ps;
              var Ue = h.effects;
              Ue === null ? h.effects = [Ft] : Ue.push(Ft);
            }
          } else {
            var Pe = {
              eventTime: dr,
              lane: On,
              tag: Ft.tag,
              payload: Ft.payload,
              callback: Ft.callback,
              next: null
            };
            rn === null ? (Dt = rn = Pe, rt = ke) : rn = rn.next = Pe, ze = bn(ze, On);
          }
          if (Ft = Ft.next, Ft === null) {
            if (E = h.shared.pending, E === null)
              break;
            var st = E, $t = st.next;
            st.next = null, Ft = $t, h.lastBaseUpdate = st, h.shared.pending = null;
          }
        } while (!0);
        rn === null && (rt = ke), h.baseState = rt, h.firstBaseUpdate = Dt, h.lastBaseUpdate = rn, dk(ze), a.lanes = ze, a.memoizedState = ke;
      }
      yy = null;
    }
    function Uj(a, i) {
      if (typeof a != "function")
        throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + a);
      a.call(i);
    }
    function I2() {
      gy = !1;
    }
    function by() {
      return gy;
    }
    function F2(a, i, l) {
      var c = i.effects;
      if (i.effects = null, c !== null)
        for (var h = 0; h < c.length; h++) {
          var b = c[h], S = b.callback;
          S !== null && (b.callback = null, Uj(S, l));
        }
    }
    var W0 = {}, Xj = Array.isArray, H2 = new e.Component().refs, j0, z0, L0, I0, F0, V2, wy, H0, V0, B0;
    {
      j0 = /* @__PURE__ */ new Set(), z0 = /* @__PURE__ */ new Set(), L0 = /* @__PURE__ */ new Set(), I0 = /* @__PURE__ */ new Set(), H0 = /* @__PURE__ */ new Set(), F0 = /* @__PURE__ */ new Set(), V0 = /* @__PURE__ */ new Set(), B0 = /* @__PURE__ */ new Set();
      var B2 = /* @__PURE__ */ new Set();
      wy = function(a, i) {
        if (!(a === null || typeof a == "function")) {
          var l = i + "_" + a;
          B2.has(l) || (B2.add(l), m("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", i, a));
        }
      }, V2 = function(a, i) {
        if (i === void 0) {
          var l = Je(a) || "Component";
          F0.has(l) || (F0.add(l), m("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", l));
        }
      }, Object.defineProperty(W0, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(W0);
    }
    function Py(a, i, l, c) {
      var h = a.memoizedState;
      if (a.mode & oa) {
        Zr();
        try {
          l(c, h);
        } finally {
          mr();
        }
      }
      var b = l(c, h);
      V2(i, b);
      var S = b == null ? h : t({}, h, b);
      if (a.memoizedState = S, a.lanes === Te) {
        var E = a.updateQueue;
        E.baseState = S;
      }
    }
    var U0 = {
      isMounted: Lm,
      enqueueSetState: function(a, i, l) {
        var c = xo(a), h = is(), b = ad(c), S = Zc(h, b);
        S.payload = i, l != null && (wy(l, "setState"), S.callback = l), ed(c, S), Bi(c, b, h);
      },
      enqueueReplaceState: function(a, i, l) {
        var c = xo(a), h = is(), b = ad(c), S = Zc(h, b);
        S.tag = j2, S.payload = i, l != null && (wy(l, "replaceState"), S.callback = l), ed(c, S), Bi(c, b, h);
      },
      enqueueForceUpdate: function(a, i) {
        var l = xo(a), c = is(), h = ad(l), b = Zc(c, h);
        b.tag = vy, i != null && (wy(i, "forceUpdate"), b.callback = i), ed(l, b), Bi(l, h, c);
      }
    };
    function U2(a, i, l, c, h, b, S) {
      var E = a.stateNode;
      if (typeof E.shouldComponentUpdate == "function") {
        if (a.mode & oa) {
          Zr();
          try {
            E.shouldComponentUpdate(c, b, S);
          } finally {
            mr();
          }
        }
        var z = E.shouldComponentUpdate(c, b, S);
        return z === void 0 && m("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Je(i) || "Component"), z;
      }
      return i.prototype && i.prototype.isPureReactComponent ? !g(l, c) || !g(h, b) : !0;
    }
    function qj(a, i, l) {
      var c = a.stateNode;
      {
        var h = Je(i) || "Component", b = c.render;
        b || (i.prototype && typeof i.prototype.render == "function" ? m("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", h) : m("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", h)), c.getInitialState && !c.getInitialState.isReactClassApproved && !c.state && m("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", h), c.getDefaultProps && !c.getDefaultProps.isReactClassApproved && m("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", h), c.propTypes && m("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", h), c.contextType && m("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", h), c.contextTypes && m("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", h), i.contextType && i.contextTypes && !V0.has(i) && (V0.add(i), m("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", h)), typeof c.componentShouldUpdate == "function" && m("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", h), i.prototype && i.prototype.isPureReactComponent && typeof c.shouldComponentUpdate < "u" && m("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Je(i) || "A pure component"), typeof c.componentDidUnmount == "function" && m("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", h), typeof c.componentDidReceiveProps == "function" && m("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", h), typeof c.componentWillRecieveProps == "function" && m("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", h), typeof c.UNSAFE_componentWillRecieveProps == "function" && m("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", h);
        var S = c.props !== l;
        c.props !== void 0 && S && m("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", h, h), c.defaultProps && m("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", h, h), typeof c.getSnapshotBeforeUpdate == "function" && typeof c.componentDidUpdate != "function" && !L0.has(i) && (L0.add(i), m("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Je(i))), typeof c.getDerivedStateFromProps == "function" && m("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", h), typeof c.getDerivedStateFromError == "function" && m("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", h), typeof i.getSnapshotBeforeUpdate == "function" && m("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", h);
        var E = c.state;
        E && (typeof E != "object" || Xj(E)) && m("%s.state: must be set to an object or null", h), typeof c.getChildContext == "function" && typeof i.childContextTypes != "object" && m("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", h);
      }
    }
    function X2(a, i) {
      i.updater = U0, a.stateNode = i, Zd(i, a), i._reactInternalInstance = W0;
    }
    function q2(a, i, l) {
      var c = !1, h = ns, b = ns, S = i.contextType;
      if ("contextType" in i) {
        var E = S === null || S !== void 0 && S.$$typeof === Qr && S._context === void 0;
        if (!E && !B0.has(i)) {
          B0.add(i);
          var z = "";
          S === void 0 ? z = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof S != "object" ? z = " However, it is set to a " + typeof S + "." : S.$$typeof === Oi ? z = " Did you accidentally pass the Context.Provider instead?" : S._context !== void 0 ? z = " Did you accidentally pass the Context.Consumer instead?" : z = " However, it is set to an object with keys {" + Object.keys(S).join(", ") + "}.", m("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Je(i) || "Component", z);
        }
      }
      if (typeof S == "object" && S !== null)
        b = Wa(S);
      else {
        h = sh(a, i, !0);
        var G = i.contextTypes;
        c = G != null, b = c ? lh(a, h) : ns;
      }
      if (a.mode & oa) {
        Zr();
        try {
          new i(l, b);
        } finally {
          mr();
        }
      }
      var ee = new i(l, b), we = a.memoizedState = ee.state !== null && ee.state !== void 0 ? ee.state : null;
      X2(a, ee);
      {
        if (typeof i.getDerivedStateFromProps == "function" && we === null) {
          var ae = Je(i) || "Component";
          z0.has(ae) || (z0.add(ae), m("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", ae, ee.state === null ? "null" : "undefined", ae));
        }
        if (typeof i.getDerivedStateFromProps == "function" || typeof ee.getSnapshotBeforeUpdate == "function") {
          var ke = null, ze = null, rt = null;
          if (typeof ee.componentWillMount == "function" && ee.componentWillMount.__suppressDeprecationWarning !== !0 ? ke = "componentWillMount" : typeof ee.UNSAFE_componentWillMount == "function" && (ke = "UNSAFE_componentWillMount"), typeof ee.componentWillReceiveProps == "function" && ee.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? ze = "componentWillReceiveProps" : typeof ee.UNSAFE_componentWillReceiveProps == "function" && (ze = "UNSAFE_componentWillReceiveProps"), typeof ee.componentWillUpdate == "function" && ee.componentWillUpdate.__suppressDeprecationWarning !== !0 ? rt = "componentWillUpdate" : typeof ee.UNSAFE_componentWillUpdate == "function" && (rt = "UNSAFE_componentWillUpdate"), ke !== null || ze !== null || rt !== null) {
            var Dt = Je(i) || "Component", rn = typeof i.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            I0.has(Dt) || (I0.add(Dt), m(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Dt, rn, ke !== null ? `
  ` + ke : "", ze !== null ? `
  ` + ze : "", rt !== null ? `
  ` + rt : ""));
          }
        }
      }
      return c && d2(a, h, b), ee;
    }
    function Yj(a, i) {
      var l = i.state;
      typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(), l !== i.state && (m("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Je(a.type) || "Component"), U0.enqueueReplaceState(i, i.state, null));
    }
    function Y2(a, i, l, c) {
      var h = i.state;
      if (typeof i.componentWillReceiveProps == "function" && i.componentWillReceiveProps(l, c), typeof i.UNSAFE_componentWillReceiveProps == "function" && i.UNSAFE_componentWillReceiveProps(l, c), i.state !== h) {
        {
          var b = Je(a.type) || "Component";
          j0.has(b) || (j0.add(b), m("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", b));
        }
        U0.enqueueReplaceState(i, i.state, null);
      }
    }
    function X0(a, i, l, c) {
      qj(a, i, l);
      var h = a.stateNode;
      h.props = l, h.state = a.memoizedState, h.refs = H2, N0(a);
      var b = i.contextType;
      if (typeof b == "object" && b !== null)
        h.context = Wa(b);
      else {
        var S = sh(a, i, !0);
        h.context = lh(a, S);
      }
      {
        if (h.state === l) {
          var E = Je(i) || "Component";
          H0.has(E) || (H0.add(E), m("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", E));
        }
        a.mode & oa && dl.recordLegacyContextWarning(a, h), dl.recordUnsafeLifecycleWarnings(a, h);
      }
      Yp(a, l, h, c), h.state = a.memoizedState;
      var z = i.getDerivedStateFromProps;
      typeof z == "function" && (Py(a, i, z, l), h.state = a.memoizedState), typeof i.getDerivedStateFromProps != "function" && typeof h.getSnapshotBeforeUpdate != "function" && (typeof h.UNSAFE_componentWillMount == "function" || typeof h.componentWillMount == "function") && (Yj(a, h), Yp(a, l, h, c), h.state = a.memoizedState), typeof h.componentDidMount == "function" && (a.flags |= Lt);
    }
    function Gj(a, i, l, c) {
      var h = a.stateNode, b = a.memoizedProps;
      h.props = b;
      var S = h.context, E = i.contextType, z = ns;
      if (typeof E == "object" && E !== null)
        z = Wa(E);
      else {
        var G = sh(a, i, !0);
        z = lh(a, G);
      }
      var ee = i.getDerivedStateFromProps, we = typeof ee == "function" || typeof h.getSnapshotBeforeUpdate == "function";
      !we && (typeof h.UNSAFE_componentWillReceiveProps == "function" || typeof h.componentWillReceiveProps == "function") && (b !== l || S !== z) && Y2(a, h, l, z), I2();
      var ae = a.memoizedState, ke = h.state = ae;
      if (Yp(a, l, h, c), ke = a.memoizedState, b === l && ae === ke && !ay() && !by())
        return typeof h.componentDidMount == "function" && (a.flags |= Lt), !1;
      typeof ee == "function" && (Py(a, i, ee, l), ke = a.memoizedState);
      var ze = by() || U2(a, i, b, l, ae, ke, z);
      return ze ? (!we && (typeof h.UNSAFE_componentWillMount == "function" || typeof h.componentWillMount == "function") && (typeof h.componentWillMount == "function" && h.componentWillMount(), typeof h.UNSAFE_componentWillMount == "function" && h.UNSAFE_componentWillMount()), typeof h.componentDidMount == "function" && (a.flags |= Lt)) : (typeof h.componentDidMount == "function" && (a.flags |= Lt), a.memoizedProps = l, a.memoizedState = ke), h.props = l, h.state = ke, h.context = z, ze;
    }
    function Qj(a, i, l, c, h) {
      var b = i.stateNode;
      z2(a, i);
      var S = i.memoizedProps, E = i.type === i.elementType ? S : fl(i.type, S);
      b.props = E;
      var z = i.pendingProps, G = b.context, ee = l.contextType, we = ns;
      if (typeof ee == "object" && ee !== null)
        we = Wa(ee);
      else {
        var ae = sh(i, l, !0);
        we = lh(i, ae);
      }
      var ke = l.getDerivedStateFromProps, ze = typeof ke == "function" || typeof b.getSnapshotBeforeUpdate == "function";
      !ze && (typeof b.UNSAFE_componentWillReceiveProps == "function" || typeof b.componentWillReceiveProps == "function") && (S !== z || G !== we) && Y2(i, b, c, we), I2();
      var rt = i.memoizedState, Dt = b.state = rt;
      if (Yp(i, c, b, h), Dt = i.memoizedState, S === z && rt === Dt && !ay() && !by())
        return typeof b.componentDidUpdate == "function" && (S !== a.memoizedProps || rt !== a.memoizedState) && (i.flags |= Lt), typeof b.getSnapshotBeforeUpdate == "function" && (S !== a.memoizedProps || rt !== a.memoizedState) && (i.flags |= Zi), !1;
      typeof ke == "function" && (Py(i, l, ke, c), Dt = i.memoizedState);
      var rn = by() || U2(i, l, E, c, rt, Dt, we);
      return rn ? (!ze && (typeof b.UNSAFE_componentWillUpdate == "function" || typeof b.componentWillUpdate == "function") && (typeof b.componentWillUpdate == "function" && b.componentWillUpdate(c, Dt, we), typeof b.UNSAFE_componentWillUpdate == "function" && b.UNSAFE_componentWillUpdate(c, Dt, we)), typeof b.componentDidUpdate == "function" && (i.flags |= Lt), typeof b.getSnapshotBeforeUpdate == "function" && (i.flags |= Zi)) : (typeof b.componentDidUpdate == "function" && (S !== a.memoizedProps || rt !== a.memoizedState) && (i.flags |= Lt), typeof b.getSnapshotBeforeUpdate == "function" && (S !== a.memoizedProps || rt !== a.memoizedState) && (i.flags |= Zi), i.memoizedProps = c, i.memoizedState = Dt), b.props = c, b.state = Dt, b.context = we, rn;
    }
    var q0, Y0, G0, Q0, K0, G2 = function(a, i) {
    };
    q0 = !1, Y0 = !1, G0 = {}, Q0 = {}, K0 = {}, G2 = function(a, i) {
      if (!(a === null || typeof a != "object") && !(!a._store || a._store.validated || a.key != null)) {
        if (typeof a._store != "object")
          throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        a._store.validated = !0;
        var l = Je(i.type) || "Component";
        Q0[l] || (Q0[l] = !0, m('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    var ky = Array.isArray;
    function Gp(a, i, l) {
      var c = l.ref;
      if (c !== null && typeof c != "function" && typeof c != "object") {
        if ((a.mode & oa || Be) && !(l._owner && l._self && l._owner.stateNode !== l._self)) {
          var h = Je(a.type) || "Component";
          G0[h] || (m('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', c), G0[h] = !0);
        }
        if (l._owner) {
          var b = l._owner, S;
          if (b) {
            var E = b;
            if (E.tag !== y)
              throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            S = E.stateNode;
          }
          if (!S)
            throw Error("Missing owner for string ref " + c + ". This error is likely caused by a bug in React. Please file an issue.");
          var z = "" + c;
          if (i !== null && i.ref !== null && typeof i.ref == "function" && i.ref._stringRef === z)
            return i.ref;
          var G = function(ee) {
            var we = S.refs;
            we === H2 && (we = S.refs = {}), ee === null ? delete we[z] : we[z] = ee;
          };
          return G._stringRef = z, G;
        } else {
          if (typeof c != "string")
            throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!l._owner)
            throw Error("Element ref was specified as a string (" + c + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return c;
    }
    function $y(a, i) {
      if (a.type !== "textarea")
        throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(i) === "[object Object]" ? "object with keys {" + Object.keys(i).join(", ") + "}" : i) + "). If you meant to render a collection of children, use an array instead.");
    }
    function Sy(a) {
      {
        var i = Je(a.type) || "Component";
        if (K0[i])
          return;
        K0[i] = !0, m("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function Q2(a) {
      function i(Pe, Ae) {
        if (a) {
          var pe = Pe.lastEffect;
          pe !== null ? (pe.nextEffect = Ae, Pe.lastEffect = Ae) : Pe.firstEffect = Pe.lastEffect = Ae, Ae.nextEffect = null, Ae.flags = er;
        }
      }
      function l(Pe, Ae) {
        if (!a)
          return null;
        for (var pe = Ae; pe !== null; )
          i(Pe, pe), pe = pe.sibling;
        return null;
      }
      function c(Pe, Ae) {
        for (var pe = /* @__PURE__ */ new Map(), Ue = Ae; Ue !== null; )
          Ue.key !== null ? pe.set(Ue.key, Ue) : pe.set(Ue.index, Ue), Ue = Ue.sibling;
        return pe;
      }
      function h(Pe, Ae) {
        var pe = Xf(Pe, Ae);
        return pe.index = 0, pe.sibling = null, pe;
      }
      function b(Pe, Ae, pe) {
        if (Pe.index = pe, !a)
          return Ae;
        var Ue = Pe.alternate;
        if (Ue !== null) {
          var st = Ue.index;
          return st < Ae ? (Pe.flags = Ht, Ae) : st;
        } else
          return Pe.flags = Ht, Ae;
      }
      function S(Pe) {
        return a && Pe.alternate === null && (Pe.flags = Ht), Pe;
      }
      function E(Pe, Ae, pe, Ue) {
        if (Ae === null || Ae.tag !== M) {
          var st = xk(pe, Pe.mode, Ue);
          return st.return = Pe, st;
        } else {
          var $t = h(Ae, pe);
          return $t.return = Pe, $t;
        }
      }
      function z(Pe, Ae, pe, Ue) {
        if (Ae !== null && (Ae.elementType === pe.type || _M(Ae, pe))) {
          var st = h(Ae, pe.props);
          return st.ref = Gp(Pe, Ae, pe), st.return = Pe, st._debugSource = pe._source, st._debugOwner = pe._owner, st;
        }
        var $t = $k(pe, Pe.mode, Ue);
        return $t.ref = Gp(Pe, Ae, pe), $t.return = Pe, $t;
      }
      function G(Pe, Ae, pe, Ue) {
        if (Ae === null || Ae.tag !== x || Ae.stateNode.containerInfo !== pe.containerInfo || Ae.stateNode.implementation !== pe.implementation) {
          var st = Ck(pe, Pe.mode, Ue);
          return st.return = Pe, st;
        } else {
          var $t = h(Ae, pe.children || []);
          return $t.return = Pe, $t;
        }
      }
      function ee(Pe, Ae, pe, Ue, st) {
        if (Ae === null || Ae.tag !== O) {
          var $t = qf(pe, Pe.mode, Ue, st);
          return $t.return = Pe, $t;
        } else {
          var kn = h(Ae, pe);
          return kn.return = Pe, kn;
        }
      }
      function we(Pe, Ae, pe) {
        if (typeof Ae == "string" || typeof Ae == "number") {
          var Ue = xk("" + Ae, Pe.mode, pe);
          return Ue.return = Pe, Ue;
        }
        if (typeof Ae == "object" && Ae !== null) {
          switch (Ae.$$typeof) {
            case Kn: {
              var st = $k(Ae, Pe.mode, pe);
              return st.ref = Gp(Pe, null, Ae), st.return = Pe, st;
            }
            case Pn: {
              var $t = Ck(Ae, Pe.mode, pe);
              return $t.return = Pe, $t;
            }
          }
          if (ky(Ae) || Jr(Ae)) {
            var kn = qf(Ae, Pe.mode, pe, null);
            return kn.return = Pe, kn;
          }
          $y(Pe, Ae);
        }
        return typeof Ae == "function" && Sy(Pe), null;
      }
      function ae(Pe, Ae, pe, Ue) {
        var st = Ae !== null ? Ae.key : null;
        if (typeof pe == "string" || typeof pe == "number")
          return st !== null ? null : E(Pe, Ae, "" + pe, Ue);
        if (typeof pe == "object" && pe !== null) {
          switch (pe.$$typeof) {
            case Kn:
              return pe.key === st ? pe.type === Vr ? ee(Pe, Ae, pe.props.children, Ue, st) : z(Pe, Ae, pe, Ue) : null;
            case Pn:
              return pe.key === st ? G(Pe, Ae, pe, Ue) : null;
          }
          if (ky(pe) || Jr(pe))
            return st !== null ? null : ee(Pe, Ae, pe, Ue, null);
          $y(Pe, pe);
        }
        return typeof pe == "function" && Sy(Pe), null;
      }
      function ke(Pe, Ae, pe, Ue, st) {
        if (typeof Ue == "string" || typeof Ue == "number") {
          var $t = Pe.get(pe) || null;
          return E(Ae, $t, "" + Ue, st);
        }
        if (typeof Ue == "object" && Ue !== null) {
          switch (Ue.$$typeof) {
            case Kn: {
              var kn = Pe.get(Ue.key === null ? pe : Ue.key) || null;
              return Ue.type === Vr ? ee(Ae, kn, Ue.props.children, st, Ue.key) : z(Ae, kn, Ue, st);
            }
            case Pn: {
              var Cr = Pe.get(Ue.key === null ? pe : Ue.key) || null;
              return G(Ae, Cr, Ue, st);
            }
          }
          if (ky(Ue) || Jr(Ue)) {
            var Ir = Pe.get(pe) || null;
            return ee(Ae, Ir, Ue, st, null);
          }
          $y(Ae, Ue);
        }
        return typeof Ue == "function" && Sy(Ae), null;
      }
      function ze(Pe, Ae, pe) {
        {
          if (typeof Pe != "object" || Pe === null)
            return Ae;
          switch (Pe.$$typeof) {
            case Kn:
            case Pn:
              G2(Pe, pe);
              var Ue = Pe.key;
              if (typeof Ue != "string")
                break;
              if (Ae === null) {
                Ae = /* @__PURE__ */ new Set(), Ae.add(Ue);
                break;
              }
              if (!Ae.has(Ue)) {
                Ae.add(Ue);
                break;
              }
              m("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", Ue);
              break;
          }
        }
        return Ae;
      }
      function rt(Pe, Ae, pe, Ue) {
        for (var st = null, $t = 0; $t < pe.length; $t++) {
          var kn = pe[$t];
          st = ze(kn, st, Pe);
        }
        for (var Cr = null, Ir = null, tr = Ae, ja = 0, Un = 0, Fr = null; tr !== null && Un < pe.length; Un++) {
          tr.index > Un ? (Fr = tr, tr = null) : Fr = tr.sibling;
          var mi = ae(Pe, tr, pe[Un], Ue);
          if (mi === null) {
            tr === null && (tr = Fr);
            break;
          }
          a && tr && mi.alternate === null && i(Pe, tr), ja = b(mi, ja, Un), Ir === null ? Cr = mi : Ir.sibling = mi, Ir = mi, tr = Fr;
        }
        if (Un === pe.length)
          return l(Pe, tr), Cr;
        if (tr === null) {
          for (; Un < pe.length; Un++) {
            var $a = we(Pe, pe[Un], Ue);
            $a !== null && (ja = b($a, ja, Un), Ir === null ? Cr = $a : Ir.sibling = $a, Ir = $a);
          }
          return Cr;
        }
        for (var lu = c(Pe, tr); Un < pe.length; Un++) {
          var Sa = ke(lu, Pe, Un, pe[Un], Ue);
          Sa !== null && (a && Sa.alternate !== null && lu.delete(Sa.key === null ? Un : Sa.key), ja = b(Sa, ja, Un), Ir === null ? Cr = Sa : Ir.sibling = Sa, Ir = Sa);
        }
        return a && lu.forEach(function(uu) {
          return i(Pe, uu);
        }), Cr;
      }
      function Dt(Pe, Ae, pe, Ue) {
        var st = Jr(pe);
        if (typeof st != "function")
          throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && pe[Symbol.toStringTag] === "Generator" && (Y0 || m("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), Y0 = !0), pe.entries === st && (q0 || m("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), q0 = !0);
          var $t = st.call(pe);
          if ($t)
            for (var kn = null, Cr = $t.next(); !Cr.done; Cr = $t.next()) {
              var Ir = Cr.value;
              kn = ze(Ir, kn, Pe);
            }
        }
        var tr = st.call(pe);
        if (tr == null)
          throw Error("An iterable object provided no iterator.");
        for (var ja = null, Un = null, Fr = Ae, mi = 0, $a = 0, lu = null, Sa = tr.next(); Fr !== null && !Sa.done; $a++, Sa = tr.next()) {
          Fr.index > $a ? (lu = Fr, Fr = null) : lu = Fr.sibling;
          var uu = ae(Pe, Fr, Sa.value, Ue);
          if (uu === null) {
            Fr === null && (Fr = lu);
            break;
          }
          a && Fr && uu.alternate === null && i(Pe, Fr), mi = b(uu, mi, $a), Un === null ? ja = uu : Un.sibling = uu, Un = uu, Fr = lu;
        }
        if (Sa.done)
          return l(Pe, Fr), ja;
        if (Fr === null) {
          for (; !Sa.done; $a++, Sa = tr.next()) {
            var Yf = we(Pe, Sa.value, Ue);
            Yf !== null && (mi = b(Yf, mi, $a), Un === null ? ja = Yf : Un.sibling = Yf, Un = Yf);
          }
          return ja;
        }
        for (var Rk = c(Pe, Fr); !Sa.done; $a++, Sa = tr.next()) {
          var sd = ke(Rk, Pe, $a, Sa.value, Ue);
          sd !== null && (a && sd.alternate !== null && Rk.delete(sd.key === null ? $a : sd.key), mi = b(sd, mi, $a), Un === null ? ja = sd : Un.sibling = sd, Un = sd);
        }
        return a && Rk.forEach(function(G8) {
          return i(Pe, G8);
        }), ja;
      }
      function rn(Pe, Ae, pe, Ue) {
        if (Ae !== null && Ae.tag === M) {
          l(Pe, Ae.sibling);
          var st = h(Ae, pe);
          return st.return = Pe, st;
        }
        l(Pe, Ae);
        var $t = xk(pe, Pe.mode, Ue);
        return $t.return = Pe, $t;
      }
      function Ft(Pe, Ae, pe, Ue) {
        for (var st = pe.key, $t = Ae; $t !== null; ) {
          if ($t.key === st) {
            switch ($t.tag) {
              case O: {
                if (pe.type === Vr) {
                  l(Pe, $t.sibling);
                  var kn = h($t, pe.props.children);
                  return kn.return = Pe, kn._debugSource = pe._source, kn._debugOwner = pe._owner, kn;
                }
                break;
              }
              case nt:
              default: {
                if ($t.elementType === pe.type || _M($t, pe)) {
                  l(Pe, $t.sibling);
                  var Cr = h($t, pe.props);
                  return Cr.ref = Gp(Pe, $t, pe), Cr.return = Pe, Cr._debugSource = pe._source, Cr._debugOwner = pe._owner, Cr;
                }
                break;
              }
            }
            l(Pe, $t);
            break;
          } else
            i(Pe, $t);
          $t = $t.sibling;
        }
        if (pe.type === Vr) {
          var Ir = qf(pe.props.children, Pe.mode, Ue, pe.key);
          return Ir.return = Pe, Ir;
        } else {
          var tr = $k(pe, Pe.mode, Ue);
          return tr.ref = Gp(Pe, Ae, pe), tr.return = Pe, tr;
        }
      }
      function On(Pe, Ae, pe, Ue) {
        for (var st = pe.key, $t = Ae; $t !== null; ) {
          if ($t.key === st)
            if ($t.tag === x && $t.stateNode.containerInfo === pe.containerInfo && $t.stateNode.implementation === pe.implementation) {
              l(Pe, $t.sibling);
              var kn = h($t, pe.children || []);
              return kn.return = Pe, kn;
            } else {
              l(Pe, $t);
              break;
            }
          else
            i(Pe, $t);
          $t = $t.sibling;
        }
        var Cr = Ck(pe, Pe.mode, Ue);
        return Cr.return = Pe, Cr;
      }
      function dr(Pe, Ae, pe, Ue) {
        var st = typeof pe == "object" && pe !== null && pe.type === Vr && pe.key === null;
        st && (pe = pe.props.children);
        var $t = typeof pe == "object" && pe !== null;
        if ($t)
          switch (pe.$$typeof) {
            case Kn:
              return S(Ft(Pe, Ae, pe, Ue));
            case Pn:
              return S(On(Pe, Ae, pe, Ue));
          }
        if (typeof pe == "string" || typeof pe == "number")
          return S(rn(Pe, Ae, "" + pe, Ue));
        if (ky(pe))
          return rt(Pe, Ae, pe, Ue);
        if (Jr(pe))
          return Dt(Pe, Ae, pe, Ue);
        if ($t && $y(Pe, pe), typeof pe == "function" && Sy(Pe), typeof pe > "u" && !st)
          switch (Pe.tag) {
            case y: {
              var kn = Pe.stateNode;
              if (kn.render._isMockFunction)
                break;
            }
            case nt:
            case v:
            case V:
            case ce:
              throw Error((Je(Pe.type) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
          }
        return l(Pe, Ae);
      }
      return dr;
    }
    var xy = Q2(!0), K2 = Q2(!1);
    function Kj(a, i) {
      if (!(a === null || i.child === a.child))
        throw Error("Resuming work not yet implemented.");
      if (i.child !== null) {
        var l = i.child, c = Xf(l, l.pendingProps);
        for (i.child = c, c.return = i; l.sibling !== null; )
          l = l.sibling, c = c.sibling = Xf(l, l.pendingProps), c.return = i;
        c.sibling = null;
      }
    }
    function Jj(a, i) {
      for (var l = a.child; l !== null; )
        d8(l, i), l = l.sibling;
    }
    var Qp = {}, td = Kc(Qp), Kp = Kc(Qp), Cy = Kc(Qp);
    function My(a) {
      if (a === Qp)
        throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return a;
    }
    function J2() {
      var a = My(Cy.current);
      return a;
    }
    function J0(a, i) {
      Fi(Cy, i, a), Fi(Kp, a, a), Fi(td, Qp, a);
      var l = T6(i);
      Ii(td, a), Fi(td, l, a);
    }
    function mh(a) {
      Ii(td, a), Ii(Kp, a), Ii(Cy, a);
    }
    function Z0() {
      var a = My(td.current);
      return a;
    }
    function Z2(a) {
      My(Cy.current);
      var i = My(td.current), l = R6(i, a.type);
      i !== l && (Fi(Kp, a, a), Fi(td, l, a));
    }
    function eP(a) {
      Kp.current === a && (Ii(td, a), Ii(Kp, a));
    }
    var Zj = 0, eC = 1, tP = 1, Jp = 2, ml = Kc(Zj);
    function Ey(a, i) {
      return (a & i) !== 0;
    }
    function Zp(a) {
      return a & eC;
    }
    function nP(a, i) {
      return a & eC | i;
    }
    function ez(a, i) {
      return a | i;
    }
    function Wf(a, i) {
      Fi(ml, i, a);
    }
    function hh(a) {
      Ii(ml, a);
    }
    function tz(a, i) {
      var l = a.memoizedState;
      if (l !== null)
        return l.dehydrated !== null;
      var c = a.memoizedProps;
      return c.fallback === void 0 ? !1 : c.unstable_avoidThisFallback !== !0 ? !0 : !i;
    }
    function Ay(a) {
      for (var i = a; i !== null; ) {
        if (i.tag === U) {
          var l = i.memoizedState;
          if (l !== null) {
            var c = l.dehydrated;
            if (c === null || rj(c) || aj(c))
              return i;
          }
        } else if (i.tag === _e && i.memoizedProps.revealOrder !== void 0) {
          var h = (i.flags & En) !== zn;
          if (h)
            return i;
        } else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === a)
          return null;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === a)
            return null;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
      return null;
    }
    var rP = 0, ph = 1, vh = 2, ev = 4, js = null, jf = null, nd = !1;
    function nz(a) {
      var i = a.stateNode.containerInfo;
      return jf = r2(i), js = a, nd = !0, !0;
    }
    function tC(a, i) {
      switch (a.tag) {
        case P:
          fj(a.stateNode.containerInfo, i);
          break;
        case A:
          mj(a.type, a.memoizedProps, a.stateNode, i);
          break;
      }
      var l = g8();
      l.stateNode = i, l.return = a, l.flags = er, a.lastEffect !== null ? (a.lastEffect.nextEffect = l, a.lastEffect = l) : a.firstEffect = a.lastEffect = l;
    }
    function nC(a, i) {
      switch (i.flags = i.flags & ~Si | Ht, a.tag) {
        case P: {
          var l = a.stateNode.containerInfo;
          switch (i.tag) {
            case A:
              var c = i.type;
              i.pendingProps, hj(l, c);
              break;
            case M:
              var h = i.pendingProps;
              pj(l, h);
              break;
          }
          break;
        }
        case A: {
          var b = a.type, S = a.memoizedProps, E = a.stateNode;
          switch (i.tag) {
            case A:
              var z = i.type;
              i.pendingProps, vj(b, S, E, z);
              break;
            case M:
              var G = i.pendingProps;
              gj(b, S, E, G);
              break;
            case U:
              yj(b, S);
              break;
          }
          break;
        }
        default:
          return;
      }
    }
    function rC(a, i) {
      switch (a.tag) {
        case A: {
          var l = a.type;
          a.pendingProps;
          var c = tj(i, l);
          return c !== null ? (a.stateNode = c, !0) : !1;
        }
        case M: {
          var h = a.pendingProps, b = nj(i, h);
          return b !== null ? (a.stateNode = b, !0) : !1;
        }
        case U:
          return !1;
        default:
          return !1;
      }
    }
    function aP(a) {
      if (nd) {
        var i = jf;
        if (!i) {
          nC(js, a), nd = !1, js = a;
          return;
        }
        var l = i;
        if (!rC(a, i)) {
          if (i = Kg(l), !i || !rC(a, i)) {
            nC(js, a), nd = !1, js = a;
            return;
          }
          tC(js, l);
        }
        js = a, jf = r2(i);
      }
    }
    function rz(a, i, l) {
      var c = a.stateNode, h = ij(c, a.type, a.memoizedProps, i, l, a);
      return a.updateQueue = h, h !== null;
    }
    function az(a) {
      var i = a.stateNode, l = a.memoizedProps, c = oj(i, l, a);
      if (c) {
        var h = js;
        if (h !== null)
          switch (h.tag) {
            case P: {
              var b = h.stateNode.containerInfo;
              cj(b, i, l);
              break;
            }
            case A: {
              var S = h.type, E = h.memoizedProps, z = h.stateNode;
              dj(S, E, z, i, l);
              break;
            }
          }
      }
      return c;
    }
    function iz(a) {
      var i = a.memoizedState, l = i !== null ? i.dehydrated : null;
      if (!l)
        throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return sj(l);
    }
    function aC(a) {
      for (var i = a.return; i !== null && i.tag !== A && i.tag !== P && i.tag !== U; )
        i = i.return;
      js = i;
    }
    function _y(a) {
      if (a !== js)
        return !1;
      if (!nd)
        return aC(a), nd = !0, !1;
      var i = a.type;
      if (a.tag !== A || i !== "head" && i !== "body" && !g0(i, a.memoizedProps))
        for (var l = jf; l; )
          tC(a, l), l = Kg(l);
      return aC(a), a.tag === U ? jf = iz(a) : jf = js ? Kg(a.stateNode) : null, !0;
    }
    function iP() {
      js = null, jf = null, nd = !1;
    }
    function oP() {
      return nd;
    }
    var tv = [], sP;
    sP = {};
    function oz(a) {
      tv.push(a);
    }
    function lP() {
      for (var a = 0; a < tv.length; a++) {
        var i = tv[a];
        i._workInProgressVersionPrimary = null;
      }
      tv.length = 0;
    }
    function sz(a) {
      return a._workInProgressVersionPrimary;
    }
    function iC(a, i) {
      a._workInProgressVersionPrimary = i, tv.push(a);
    }
    function lz(a) {
      a._currentPrimaryRenderer == null ? a._currentPrimaryRenderer = sP : a._currentPrimaryRenderer !== sP && m("Detected multiple renderers concurrently rendering the same mutable source. This is currently unsupported.");
    }
    var ct = s.ReactCurrentDispatcher, zs = s.ReactCurrentBatchConfig, uP, cP;
    cP = {}, uP = /* @__PURE__ */ new Set();
    var nv = Te, pr = null, Vi = null, fi = null, Oy = !1, rv = !1, uz = 25, Fe = null, Ls = null, rd = -1, dP = !1;
    function cr() {
      {
        var a = Fe;
        Ls === null ? Ls = [a] : Ls.push(a);
      }
    }
    function yt() {
      {
        var a = Fe;
        Ls !== null && (rd++, Ls[rd] !== a && cz(a));
      }
    }
    function av(a) {
      a != null && !Array.isArray(a) && m("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Fe, typeof a);
    }
    function cz(a) {
      {
        var i = Je(pr.type);
        if (!uP.has(i) && (uP.add(i), Ls !== null)) {
          for (var l = "", c = 30, h = 0; h <= rd; h++) {
            for (var b = Ls[h], S = h === rd ? a : b, E = h + 1 + ". " + b; E.length < c; )
              E += " ";
            E += S + `
`, l += E;
          }
          m(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, i, l);
        }
      }
    }
    function No() {
      throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function fP(a, i) {
      if (dP)
        return !1;
      if (i === null)
        return m("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Fe), !1;
      a.length !== i.length && m(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Fe, "[" + i.join(", ") + "]", "[" + a.join(", ") + "]");
      for (var l = 0; l < i.length && l < a.length; l++)
        if (!u(a[l], i[l]))
          return !1;
      return !0;
    }
    function gh(a, i, l, c, h, b) {
      nv = b, pr = i, Ls = a !== null ? a._debugHookTypes : null, rd = -1, dP = a !== null && a.type !== i.type, i.memoizedState = null, i.updateQueue = null, i.lanes = Te, a !== null && a.memoizedState !== null ? ct.current = wC : Ls !== null ? ct.current = bC : ct.current = yC;
      var S = l(c, h);
      if (rv) {
        var E = 0;
        do {
          if (rv = !1, !(E < uz))
            throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          E += 1, dP = !1, Vi = null, fi = null, i.updateQueue = null, rd = -1, ct.current = PC, S = l(c, h);
        } while (rv);
      }
      ct.current = Vy, i._debugHookTypes = Ls;
      var z = Vi !== null && Vi.next !== null;
      if (nv = Te, pr = null, Vi = null, fi = null, Fe = null, Ls = null, rd = -1, Oy = !1, z)
        throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return S;
    }
    function oC(a, i, l) {
      i.updateQueue = a.updateQueue, i.flags &= ~(eo | Lt), a.lanes = _s(a.lanes, l);
    }
    function sC() {
      if (ct.current = Vy, Oy) {
        for (var a = pr.memoizedState; a !== null; ) {
          var i = a.queue;
          i !== null && (i.pending = null), a = a.next;
        }
        Oy = !1;
      }
      nv = Te, pr = null, Vi = null, fi = null, Ls = null, rd = -1, Fe = null, Hy = !1, rv = !1;
    }
    function zf() {
      var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return fi === null ? pr.memoizedState = fi = a : fi = fi.next = a, fi;
    }
    function Lf() {
      var a;
      if (Vi === null) {
        var i = pr.alternate;
        i !== null ? a = i.memoizedState : a = null;
      } else
        a = Vi.next;
      var l;
      if (fi === null ? l = pr.memoizedState : l = fi.next, l !== null)
        fi = l, l = fi.next, Vi = a;
      else {
        if (a === null)
          throw Error("Rendered more hooks than during the previous render.");
        Vi = a;
        var c = {
          memoizedState: Vi.memoizedState,
          baseState: Vi.baseState,
          baseQueue: Vi.baseQueue,
          queue: Vi.queue,
          next: null
        };
        fi === null ? pr.memoizedState = fi = c : fi = fi.next = c;
      }
      return fi;
    }
    function dz() {
      return {
        lastEffect: null
      };
    }
    function Ty(a, i) {
      return typeof i == "function" ? i(a) : i;
    }
    function mP(a, i, l) {
      var c = zf(), h;
      l !== void 0 ? h = l(i) : h = i, c.memoizedState = c.baseState = h;
      var b = c.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: a,
        lastRenderedState: h
      }, S = b.dispatch = CP.bind(null, pr, b);
      return [c.memoizedState, S];
    }
    function hP(a, i, l) {
      var c = Lf(), h = c.queue;
      if (h === null)
        throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      h.lastRenderedReducer = a;
      var b = Vi, S = b.baseQueue, E = h.pending;
      if (E !== null) {
        if (S !== null) {
          var z = S.next, G = E.next;
          S.next = G, E.next = z;
        }
        b.baseQueue !== S && m("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), b.baseQueue = S = E, h.pending = null;
      }
      if (S !== null) {
        var ee = S.next, we = b.baseState, ae = null, ke = null, ze = null, rt = ee;
        do {
          var Dt = rt.lane;
          if (ci(nv, Dt)) {
            if (ze !== null) {
              var Ft = {
                lane: ln,
                action: rt.action,
                eagerReducer: rt.eagerReducer,
                eagerState: rt.eagerState,
                next: null
              };
              ze = ze.next = Ft;
            }
            if (rt.eagerReducer === a)
              we = rt.eagerState;
            else {
              var On = rt.action;
              we = a(we, On);
            }
          } else {
            var rn = {
              lane: Dt,
              action: rt.action,
              eagerReducer: rt.eagerReducer,
              eagerState: rt.eagerState,
              next: null
            };
            ze === null ? (ke = ze = rn, ae = we) : ze = ze.next = rn, pr.lanes = bn(pr.lanes, Dt), dk(Dt);
          }
          rt = rt.next;
        } while (rt !== null && rt !== ee);
        ze === null ? ae = we : ze.next = ke, u(we, c.memoizedState) || IP(), c.memoizedState = we, c.baseState = ae, c.baseQueue = ze, h.lastRenderedState = we;
      }
      var dr = h.dispatch;
      return [c.memoizedState, dr];
    }
    function pP(a, i, l) {
      var c = Lf(), h = c.queue;
      if (h === null)
        throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      h.lastRenderedReducer = a;
      var b = h.dispatch, S = h.pending, E = c.memoizedState;
      if (S !== null) {
        h.pending = null;
        var z = S.next, G = z;
        do {
          var ee = G.action;
          E = a(E, ee), G = G.next;
        } while (G !== z);
        u(E, c.memoizedState) || IP(), c.memoizedState = E, c.baseQueue === null && (c.baseState = E), h.lastRenderedState = E;
      }
      return [E, b];
    }
    function lC(a, i, l) {
      lz(i);
      var c = i._getVersion, h = c(i._source), b = !1, S = sz(i);
      if (S !== null ? b = S === h : (b = ci(nv, a.mutableReadLanes), b && iC(i, h)), b) {
        var E = l(i._source);
        return typeof E == "function" && m("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing."), E;
      } else
        throw oz(i), Error("Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue.");
    }
    function uC(a, i, l, c) {
      var h = p7();
      if (h === null)
        throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
      var b = i._getVersion, S = b(i._source), E = ct.current, z = E.useState(function() {
        return lC(h, i, l);
      }), G = z[0], ee = z[1], we = G, ae = fi, ke = a.memoizedState, ze = ke.refs, rt = ze.getSnapshot, Dt = ke.source, rn = ke.subscribe, Ft = pr;
      if (a.memoizedState = {
        refs: ze,
        source: i,
        subscribe: c
      }, E.useEffect(function() {
        ze.getSnapshot = l, ze.setSnapshot = ee;
        var dr = b(i._source);
        if (!u(S, dr)) {
          var Pe = l(i._source);
          if (typeof Pe == "function" && m("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing."), !u(we, Pe)) {
            ee(Pe);
            var Ae = ad(Ft);
            kg(h, Ae);
          }
          pp(h, h.mutableReadLanes);
        }
      }, [l, i, c]), E.useEffect(function() {
        var dr = function() {
          var Ae = ze.getSnapshot, pe = ze.setSnapshot;
          try {
            pe(Ae(i._source));
            var Ue = ad(Ft);
            kg(h, Ue);
          } catch (st) {
            pe(function() {
              throw st;
            });
          }
        }, Pe = c(i._source, dr);
        return typeof Pe != "function" && m("Mutable source subscribe function must return an unsubscribe function."), Pe;
      }, [i, c]), !u(rt, l) || !u(Dt, i) || !u(rn, c)) {
        var On = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: Ty,
          lastRenderedState: we
        };
        On.dispatch = ee = CP.bind(null, pr, On), ae.queue = On, ae.baseQueue = null, we = lC(h, i, l), ae.memoizedState = ae.baseState = we;
      }
      return we;
    }
    function vP(a, i, l) {
      var c = zf();
      return c.memoizedState = {
        refs: {
          getSnapshot: i,
          setSnapshot: null
        },
        source: a,
        subscribe: l
      }, uC(c, a, i, l);
    }
    function Ry(a, i, l) {
      var c = Lf();
      return uC(c, a, i, l);
    }
    function If(a) {
      var i = zf();
      typeof a == "function" && (a = a()), i.memoizedState = i.baseState = a;
      var l = i.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Ty,
        lastRenderedState: a
      }, c = l.dispatch = CP.bind(null, pr, l);
      return [i.memoizedState, c];
    }
    function iv(a) {
      return hP(Ty);
    }
    function ov(a) {
      return pP(Ty);
    }
    function Dy(a, i, l, c) {
      var h = {
        tag: a,
        create: i,
        destroy: l,
        deps: c,
        next: null
      }, b = pr.updateQueue;
      if (b === null)
        b = dz(), pr.updateQueue = b, b.lastEffect = h.next = h;
      else {
        var S = b.lastEffect;
        if (S === null)
          b.lastEffect = h.next = h;
        else {
          var E = S.next;
          S.next = h, h.next = E, b.lastEffect = h;
        }
      }
      return h;
    }
    function Ny(a) {
      var i = zf(), l = {
        current: a
      };
      return Object.seal(l), i.memoizedState = l, l;
    }
    function yh(a) {
      var i = Lf();
      return i.memoizedState;
    }
    function gP(a, i, l, c) {
      var h = zf(), b = c === void 0 ? null : c;
      pr.flags |= a, h.memoizedState = Dy(ph | i, l, void 0, b);
    }
    function yP(a, i, l, c) {
      var h = Lf(), b = c === void 0 ? null : c, S = void 0;
      if (Vi !== null) {
        var E = Vi.memoizedState;
        if (S = E.destroy, b !== null) {
          var z = E.deps;
          if (fP(b, z)) {
            Dy(i, l, S, b);
            return;
          }
        }
      }
      pr.flags |= a, h.memoizedState = Dy(ph | i, l, S, b);
    }
    function Wy(a, i) {
      return typeof jest < "u" && SM(pr), gP(Lt | eo, ev, a, i);
    }
    function bh(a, i) {
      return typeof jest < "u" && SM(pr), yP(Lt | eo, ev, a, i);
    }
    function bP(a, i) {
      return gP(Lt, vh, a, i);
    }
    function jy(a, i) {
      return yP(Lt, vh, a, i);
    }
    function cC(a, i) {
      if (typeof i == "function") {
        var l = i, c = a();
        return l(c), function() {
          l(null);
        };
      } else if (i != null) {
        var h = i;
        h.hasOwnProperty("current") || m("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(h).join(", ") + "}");
        var b = a();
        return h.current = b, function() {
          h.current = null;
        };
      }
    }
    function wP(a, i, l) {
      typeof i != "function" && m("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", i !== null ? typeof i : "null");
      var c = l != null ? l.concat([a]) : null;
      return gP(Lt, vh, cC.bind(null, i, a), c);
    }
    function zy(a, i, l) {
      typeof i != "function" && m("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", i !== null ? typeof i : "null");
      var c = l != null ? l.concat([a]) : null;
      return yP(Lt, vh, cC.bind(null, i, a), c);
    }
    function fz(a, i) {
    }
    var Ly = fz;
    function PP(a, i) {
      var l = zf(), c = i === void 0 ? null : i;
      return l.memoizedState = [a, c], a;
    }
    function Iy(a, i) {
      var l = Lf(), c = i === void 0 ? null : i, h = l.memoizedState;
      if (h !== null && c !== null) {
        var b = h[1];
        if (fP(c, b))
          return h[0];
      }
      return l.memoizedState = [a, c], a;
    }
    function kP(a, i) {
      var l = zf(), c = i === void 0 ? null : i, h = a();
      return l.memoizedState = [h, c], h;
    }
    function Fy(a, i) {
      var l = Lf(), c = i === void 0 ? null : i, h = l.memoizedState;
      if (h !== null && c !== null) {
        var b = h[1];
        if (fP(c, b))
          return h[0];
      }
      var S = a();
      return l.memoizedState = [S, c], S;
    }
    function $P(a) {
      var i = If(a), l = i[0], c = i[1];
      return Wy(function() {
        var h = zs.transition;
        zs.transition = 1;
        try {
          c(a);
        } finally {
          zs.transition = h;
        }
      }, [a]), l;
    }
    function dC(a) {
      var i = iv(), l = i[0], c = i[1];
      return bh(function() {
        var h = zs.transition;
        zs.transition = 1;
        try {
          c(a);
        } finally {
          zs.transition = h;
        }
      }, [a]), l;
    }
    function fC(a) {
      var i = ov(), l = i[0], c = i[1];
      return bh(function() {
        var h = zs.transition;
        zs.transition = 1;
        try {
          c(a);
        } finally {
          zs.transition = h;
        }
      }, [a]), l;
    }
    function mz(a, i) {
      var l = ch();
      Tf(l < Of ? Of : l, function() {
        a(!0);
      }), Tf(l > nc ? nc : l, function() {
        var c = zs.transition;
        zs.transition = 1;
        try {
          a(!1), i();
        } finally {
          zs.transition = c;
        }
      });
    }
    function SP() {
      var a = If(!1), i = a[0], l = a[1], c = mz.bind(null, l);
      return Ny(c), [c, i];
    }
    function mC() {
      var a = iv(), i = a[0], l = yh(), c = l.current;
      return [c, i];
    }
    function hC() {
      var a = ov(), i = a[0], l = yh(), c = l.current;
      return [c, i];
    }
    var Hy = !1;
    function hz() {
      return Hy;
    }
    function pC(a) {
      {
        var i = Je(a.type) || "Unknown";
        ms() && !cP[i] && (m("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly."), cP[i] = !0);
      }
    }
    function xP() {
      var a = wj.bind(null, pC.bind(null, pr));
      if (oP()) {
        var i = !1, l = pr, c = function() {
          throw i || (i = !0, Hy = !0, b(a()), Hy = !1, pC(l)), Error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
        }, h = kj(c), b = If(h)[1];
        return (pr.mode & Do) === Lr && (pr.flags |= Lt | eo, Dy(ph | ev, function() {
          b(a());
        }, void 0, null)), h;
      } else {
        var S = a();
        return If(S), S;
      }
    }
    function vC() {
      var a = iv()[0];
      return a;
    }
    function gC() {
      var a = ov()[0];
      return a;
    }
    function CP(a, i, l) {
      typeof arguments[3] == "function" && m("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var c = is(), h = ad(a), b = {
        lane: h,
        action: l,
        eagerReducer: null,
        eagerState: null,
        next: null
      }, S = i.pending;
      S === null ? b.next = b : (b.next = S.next, S.next = b), i.pending = b;
      var E = a.alternate;
      if (a === pr || E !== null && E === pr)
        rv = Oy = !0;
      else {
        if (a.lanes === Te && (E === null || E.lanes === Te)) {
          var z = i.lastRenderedReducer;
          if (z !== null) {
            var G;
            G = ct.current, ct.current = hl;
            try {
              var ee = i.lastRenderedState, we = z(ee, l);
              if (b.eagerReducer = z, b.eagerState = we, u(we, ee))
                return;
            } catch {
            } finally {
              ct.current = G;
            }
          }
        }
        typeof jest < "u" && ($M(a), K7(a)), Bi(a, h, c);
      }
    }
    var Vy = {
      readContext: Wa,
      useCallback: No,
      useContext: No,
      useEffect: No,
      useImperativeHandle: No,
      useLayoutEffect: No,
      useMemo: No,
      useReducer: No,
      useRef: No,
      useState: No,
      useDebugValue: No,
      useDeferredValue: No,
      useTransition: No,
      useMutableSource: No,
      useOpaqueIdentifier: No,
      unstable_isNewReconciler: Ye
    }, yC = null, bC = null, wC = null, PC = null, ru = null, hl = null, By = null;
    {
      var MP = function() {
        m("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, sn = function() {
        m("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      yC = {
        readContext: function(a, i) {
          return Wa(a, i);
        },
        useCallback: function(a, i) {
          return Fe = "useCallback", cr(), av(i), PP(a, i);
        },
        useContext: function(a, i) {
          return Fe = "useContext", cr(), Wa(a, i);
        },
        useEffect: function(a, i) {
          return Fe = "useEffect", cr(), av(i), Wy(a, i);
        },
        useImperativeHandle: function(a, i, l) {
          return Fe = "useImperativeHandle", cr(), av(l), wP(a, i, l);
        },
        useLayoutEffect: function(a, i) {
          return Fe = "useLayoutEffect", cr(), av(i), bP(a, i);
        },
        useMemo: function(a, i) {
          Fe = "useMemo", cr(), av(i);
          var l = ct.current;
          ct.current = ru;
          try {
            return kP(a, i);
          } finally {
            ct.current = l;
          }
        },
        useReducer: function(a, i, l) {
          Fe = "useReducer", cr();
          var c = ct.current;
          ct.current = ru;
          try {
            return mP(a, i, l);
          } finally {
            ct.current = c;
          }
        },
        useRef: function(a) {
          return Fe = "useRef", cr(), Ny(a);
        },
        useState: function(a) {
          Fe = "useState", cr();
          var i = ct.current;
          ct.current = ru;
          try {
            return If(a);
          } finally {
            ct.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Fe = "useDebugValue", cr(), void 0;
        },
        useDeferredValue: function(a) {
          return Fe = "useDeferredValue", cr(), $P(a);
        },
        useTransition: function() {
          return Fe = "useTransition", cr(), SP();
        },
        useMutableSource: function(a, i, l) {
          return Fe = "useMutableSource", cr(), vP(a, i, l);
        },
        useOpaqueIdentifier: function() {
          return Fe = "useOpaqueIdentifier", cr(), xP();
        },
        unstable_isNewReconciler: Ye
      }, bC = {
        readContext: function(a, i) {
          return Wa(a, i);
        },
        useCallback: function(a, i) {
          return Fe = "useCallback", yt(), PP(a, i);
        },
        useContext: function(a, i) {
          return Fe = "useContext", yt(), Wa(a, i);
        },
        useEffect: function(a, i) {
          return Fe = "useEffect", yt(), Wy(a, i);
        },
        useImperativeHandle: function(a, i, l) {
          return Fe = "useImperativeHandle", yt(), wP(a, i, l);
        },
        useLayoutEffect: function(a, i) {
          return Fe = "useLayoutEffect", yt(), bP(a, i);
        },
        useMemo: function(a, i) {
          Fe = "useMemo", yt();
          var l = ct.current;
          ct.current = ru;
          try {
            return kP(a, i);
          } finally {
            ct.current = l;
          }
        },
        useReducer: function(a, i, l) {
          Fe = "useReducer", yt();
          var c = ct.current;
          ct.current = ru;
          try {
            return mP(a, i, l);
          } finally {
            ct.current = c;
          }
        },
        useRef: function(a) {
          return Fe = "useRef", yt(), Ny(a);
        },
        useState: function(a) {
          Fe = "useState", yt();
          var i = ct.current;
          ct.current = ru;
          try {
            return If(a);
          } finally {
            ct.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Fe = "useDebugValue", yt(), void 0;
        },
        useDeferredValue: function(a) {
          return Fe = "useDeferredValue", yt(), $P(a);
        },
        useTransition: function() {
          return Fe = "useTransition", yt(), SP();
        },
        useMutableSource: function(a, i, l) {
          return Fe = "useMutableSource", yt(), vP(a, i, l);
        },
        useOpaqueIdentifier: function() {
          return Fe = "useOpaqueIdentifier", yt(), xP();
        },
        unstable_isNewReconciler: Ye
      }, wC = {
        readContext: function(a, i) {
          return Wa(a, i);
        },
        useCallback: function(a, i) {
          return Fe = "useCallback", yt(), Iy(a, i);
        },
        useContext: function(a, i) {
          return Fe = "useContext", yt(), Wa(a, i);
        },
        useEffect: function(a, i) {
          return Fe = "useEffect", yt(), bh(a, i);
        },
        useImperativeHandle: function(a, i, l) {
          return Fe = "useImperativeHandle", yt(), zy(a, i, l);
        },
        useLayoutEffect: function(a, i) {
          return Fe = "useLayoutEffect", yt(), jy(a, i);
        },
        useMemo: function(a, i) {
          Fe = "useMemo", yt();
          var l = ct.current;
          ct.current = hl;
          try {
            return Fy(a, i);
          } finally {
            ct.current = l;
          }
        },
        useReducer: function(a, i, l) {
          Fe = "useReducer", yt();
          var c = ct.current;
          ct.current = hl;
          try {
            return hP(a, i, l);
          } finally {
            ct.current = c;
          }
        },
        useRef: function(a) {
          return Fe = "useRef", yt(), yh();
        },
        useState: function(a) {
          Fe = "useState", yt();
          var i = ct.current;
          ct.current = hl;
          try {
            return iv(a);
          } finally {
            ct.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Fe = "useDebugValue", yt(), Ly();
        },
        useDeferredValue: function(a) {
          return Fe = "useDeferredValue", yt(), dC(a);
        },
        useTransition: function() {
          return Fe = "useTransition", yt(), mC();
        },
        useMutableSource: function(a, i, l) {
          return Fe = "useMutableSource", yt(), Ry(a, i, l);
        },
        useOpaqueIdentifier: function() {
          return Fe = "useOpaqueIdentifier", yt(), vC();
        },
        unstable_isNewReconciler: Ye
      }, PC = {
        readContext: function(a, i) {
          return Wa(a, i);
        },
        useCallback: function(a, i) {
          return Fe = "useCallback", yt(), Iy(a, i);
        },
        useContext: function(a, i) {
          return Fe = "useContext", yt(), Wa(a, i);
        },
        useEffect: function(a, i) {
          return Fe = "useEffect", yt(), bh(a, i);
        },
        useImperativeHandle: function(a, i, l) {
          return Fe = "useImperativeHandle", yt(), zy(a, i, l);
        },
        useLayoutEffect: function(a, i) {
          return Fe = "useLayoutEffect", yt(), jy(a, i);
        },
        useMemo: function(a, i) {
          Fe = "useMemo", yt();
          var l = ct.current;
          ct.current = By;
          try {
            return Fy(a, i);
          } finally {
            ct.current = l;
          }
        },
        useReducer: function(a, i, l) {
          Fe = "useReducer", yt();
          var c = ct.current;
          ct.current = By;
          try {
            return pP(a, i, l);
          } finally {
            ct.current = c;
          }
        },
        useRef: function(a) {
          return Fe = "useRef", yt(), yh();
        },
        useState: function(a) {
          Fe = "useState", yt();
          var i = ct.current;
          ct.current = By;
          try {
            return ov(a);
          } finally {
            ct.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Fe = "useDebugValue", yt(), Ly();
        },
        useDeferredValue: function(a) {
          return Fe = "useDeferredValue", yt(), fC(a);
        },
        useTransition: function() {
          return Fe = "useTransition", yt(), hC();
        },
        useMutableSource: function(a, i, l) {
          return Fe = "useMutableSource", yt(), Ry(a, i, l);
        },
        useOpaqueIdentifier: function() {
          return Fe = "useOpaqueIdentifier", yt(), gC();
        },
        unstable_isNewReconciler: Ye
      }, ru = {
        readContext: function(a, i) {
          return MP(), Wa(a, i);
        },
        useCallback: function(a, i) {
          return Fe = "useCallback", sn(), cr(), PP(a, i);
        },
        useContext: function(a, i) {
          return Fe = "useContext", sn(), cr(), Wa(a, i);
        },
        useEffect: function(a, i) {
          return Fe = "useEffect", sn(), cr(), Wy(a, i);
        },
        useImperativeHandle: function(a, i, l) {
          return Fe = "useImperativeHandle", sn(), cr(), wP(a, i, l);
        },
        useLayoutEffect: function(a, i) {
          return Fe = "useLayoutEffect", sn(), cr(), bP(a, i);
        },
        useMemo: function(a, i) {
          Fe = "useMemo", sn(), cr();
          var l = ct.current;
          ct.current = ru;
          try {
            return kP(a, i);
          } finally {
            ct.current = l;
          }
        },
        useReducer: function(a, i, l) {
          Fe = "useReducer", sn(), cr();
          var c = ct.current;
          ct.current = ru;
          try {
            return mP(a, i, l);
          } finally {
            ct.current = c;
          }
        },
        useRef: function(a) {
          return Fe = "useRef", sn(), cr(), Ny(a);
        },
        useState: function(a) {
          Fe = "useState", sn(), cr();
          var i = ct.current;
          ct.current = ru;
          try {
            return If(a);
          } finally {
            ct.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Fe = "useDebugValue", sn(), cr(), void 0;
        },
        useDeferredValue: function(a) {
          return Fe = "useDeferredValue", sn(), cr(), $P(a);
        },
        useTransition: function() {
          return Fe = "useTransition", sn(), cr(), SP();
        },
        useMutableSource: function(a, i, l) {
          return Fe = "useMutableSource", sn(), cr(), vP(a, i, l);
        },
        useOpaqueIdentifier: function() {
          return Fe = "useOpaqueIdentifier", sn(), cr(), xP();
        },
        unstable_isNewReconciler: Ye
      }, hl = {
        readContext: function(a, i) {
          return MP(), Wa(a, i);
        },
        useCallback: function(a, i) {
          return Fe = "useCallback", sn(), yt(), Iy(a, i);
        },
        useContext: function(a, i) {
          return Fe = "useContext", sn(), yt(), Wa(a, i);
        },
        useEffect: function(a, i) {
          return Fe = "useEffect", sn(), yt(), bh(a, i);
        },
        useImperativeHandle: function(a, i, l) {
          return Fe = "useImperativeHandle", sn(), yt(), zy(a, i, l);
        },
        useLayoutEffect: function(a, i) {
          return Fe = "useLayoutEffect", sn(), yt(), jy(a, i);
        },
        useMemo: function(a, i) {
          Fe = "useMemo", sn(), yt();
          var l = ct.current;
          ct.current = hl;
          try {
            return Fy(a, i);
          } finally {
            ct.current = l;
          }
        },
        useReducer: function(a, i, l) {
          Fe = "useReducer", sn(), yt();
          var c = ct.current;
          ct.current = hl;
          try {
            return hP(a, i, l);
          } finally {
            ct.current = c;
          }
        },
        useRef: function(a) {
          return Fe = "useRef", sn(), yt(), yh();
        },
        useState: function(a) {
          Fe = "useState", sn(), yt();
          var i = ct.current;
          ct.current = hl;
          try {
            return iv(a);
          } finally {
            ct.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Fe = "useDebugValue", sn(), yt(), Ly();
        },
        useDeferredValue: function(a) {
          return Fe = "useDeferredValue", sn(), yt(), dC(a);
        },
        useTransition: function() {
          return Fe = "useTransition", sn(), yt(), mC();
        },
        useMutableSource: function(a, i, l) {
          return Fe = "useMutableSource", sn(), yt(), Ry(a, i, l);
        },
        useOpaqueIdentifier: function() {
          return Fe = "useOpaqueIdentifier", sn(), yt(), vC();
        },
        unstable_isNewReconciler: Ye
      }, By = {
        readContext: function(a, i) {
          return MP(), Wa(a, i);
        },
        useCallback: function(a, i) {
          return Fe = "useCallback", sn(), yt(), Iy(a, i);
        },
        useContext: function(a, i) {
          return Fe = "useContext", sn(), yt(), Wa(a, i);
        },
        useEffect: function(a, i) {
          return Fe = "useEffect", sn(), yt(), bh(a, i);
        },
        useImperativeHandle: function(a, i, l) {
          return Fe = "useImperativeHandle", sn(), yt(), zy(a, i, l);
        },
        useLayoutEffect: function(a, i) {
          return Fe = "useLayoutEffect", sn(), yt(), jy(a, i);
        },
        useMemo: function(a, i) {
          Fe = "useMemo", sn(), yt();
          var l = ct.current;
          ct.current = hl;
          try {
            return Fy(a, i);
          } finally {
            ct.current = l;
          }
        },
        useReducer: function(a, i, l) {
          Fe = "useReducer", sn(), yt();
          var c = ct.current;
          ct.current = hl;
          try {
            return pP(a, i, l);
          } finally {
            ct.current = c;
          }
        },
        useRef: function(a) {
          return Fe = "useRef", sn(), yt(), yh();
        },
        useState: function(a) {
          Fe = "useState", sn(), yt();
          var i = ct.current;
          ct.current = hl;
          try {
            return ov(a);
          } finally {
            ct.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Fe = "useDebugValue", sn(), yt(), Ly();
        },
        useDeferredValue: function(a) {
          return Fe = "useDeferredValue", sn(), yt(), fC(a);
        },
        useTransition: function() {
          return Fe = "useTransition", sn(), yt(), hC();
        },
        useMutableSource: function(a, i, l) {
          return Fe = "useMutableSource", sn(), yt(), Ry(a, i, l);
        },
        useOpaqueIdentifier: function() {
          return Fe = "useOpaqueIdentifier", sn(), yt(), gC();
        },
        unstable_isNewReconciler: Ye
      };
    }
    var Uy = n.unstable_now, kC = 0, sv = -1;
    function pz() {
      return kC;
    }
    function $C() {
      kC = Uy();
    }
    function EP(a) {
      sv = Uy(), a.actualStartTime < 0 && (a.actualStartTime = Uy());
    }
    function SC(a) {
      sv = -1;
    }
    function Xy(a, i) {
      if (sv >= 0) {
        var l = Uy() - sv;
        a.actualDuration += l, i && (a.selfBaseDuration = l), sv = -1;
      }
    }
    function AP(a) {
      for (var i = a.child; i; )
        a.actualDuration += i.actualDuration, i = i.sibling;
    }
    var lv = s.ReactCurrentOwner, au = !1, _P, uv, OP, TP, RP, Ff, DP, qy;
    _P = {}, uv = {}, OP = {}, TP = {}, RP = {}, Ff = !1, DP = {}, qy = {};
    function Wo(a, i, l, c) {
      a === null ? i.child = K2(i, null, l, c) : i.child = xy(i, a.child, l, c);
    }
    function vz(a, i, l, c) {
      i.child = xy(i, a.child, null, c), i.child = xy(i, null, l, c);
    }
    function xC(a, i, l, c, h) {
      if (i.type !== i.elementType) {
        var b = l.propTypes;
        b && cl(
          b,
          c,
          "prop",
          Je(l)
        );
      }
      var S = l.render, E = i.ref, z;
      fh(i, h);
      {
        if (lv.current = i, Or(!0), z = gh(a, i, S, c, E, h), i.mode & oa) {
          Zr();
          try {
            z = gh(a, i, S, c, E, h);
          } finally {
            mr();
          }
        }
        Or(!1);
      }
      return a !== null && !au ? (oC(a, i, h), ac(a, i, h)) : (i.flags |= Ra, Wo(a, i, z, h), i.child);
    }
    function CC(a, i, l, c, h, b) {
      if (a === null) {
        var S = l.type;
        if (u8(S) && l.compare === null && l.defaultProps === void 0) {
          var E = S;
          return E = Mh(S), i.tag = ce, i.type = E, zP(i, S), MC(a, i, E, c, h, b);
        }
        {
          var z = S.propTypes;
          z && cl(
            z,
            c,
            "prop",
            Je(S)
          );
        }
        var G = kk(l.type, null, c, i, i.mode, b);
        return G.ref = i.ref, G.return = i, i.child = G, G;
      }
      {
        var ee = l.type, we = ee.propTypes;
        we && cl(
          we,
          c,
          "prop",
          Je(ee)
        );
      }
      var ae = a.child;
      if (!Tr(h, b)) {
        var ke = ae.memoizedProps, ze = l.compare;
        if (ze = ze !== null ? ze : g, ze(ke, c) && a.ref === i.ref)
          return ac(a, i, b);
      }
      i.flags |= Ra;
      var rt = Xf(ae, c);
      return rt.ref = i.ref, rt.return = i, i.child = rt, rt;
    }
    function MC(a, i, l, c, h, b) {
      if (i.type !== i.elementType) {
        var S = i.elementType;
        if (S.$$typeof === Jn) {
          var E = S, z = E._payload, G = E._init;
          try {
            S = G(z);
          } catch {
            S = null;
          }
          var ee = S && S.propTypes;
          ee && cl(
            ee,
            c,
            "prop",
            Je(S)
          );
        }
      }
      if (a !== null) {
        var we = a.memoizedProps;
        if (g(we, c) && a.ref === i.ref && i.type === a.type)
          if (au = !1, Tr(b, h))
            (a.flags & Wu) !== zn && (au = !0);
          else
            return i.lanes = a.lanes, ac(a, i, b);
      }
      return WP(a, i, l, c, b);
    }
    function NP(a, i, l) {
      var c = i.pendingProps, h = c.children, b = a !== null ? a.memoizedState : null;
      if (c.mode === "hidden" || c.mode === "unstable-defer-without-hiding")
        if ((i.mode & Rf) === Lr) {
          var S = {
            baseLanes: Te
          };
          i.memoizedState = S, ub(i, l);
        } else if (Tr(l, jt)) {
          var ee = {
            baseLanes: Te
          };
          i.memoizedState = ee;
          var we = b !== null ? b.baseLanes : l;
          ub(i, we);
        } else {
          var E;
          if (b !== null) {
            var z = b.baseLanes;
            E = bn(z, l);
          } else
            E = l;
          pb(jt), i.lanes = i.childLanes = jt;
          var G = {
            baseLanes: E
          };
          return i.memoizedState = G, ub(i, E), null;
        }
      else {
        var ae;
        b !== null ? (ae = bn(b.baseLanes, l), i.memoizedState = null) : ae = l, ub(i, ae);
      }
      return Wo(a, i, h, l), i.child;
    }
    var gz = NP;
    function yz(a, i, l) {
      var c = i.pendingProps;
      return Wo(a, i, c, l), i.child;
    }
    function bz(a, i, l) {
      var c = i.pendingProps.children;
      return Wo(a, i, c, l), i.child;
    }
    function wz(a, i, l) {
      {
        i.flags |= Lt;
        var c = i.stateNode;
        c.effectDuration = 0, c.passiveEffectDuration = 0;
      }
      var h = i.pendingProps, b = h.children;
      return Wo(a, i, b, l), i.child;
    }
    function EC(a, i) {
      var l = i.ref;
      (a === null && l !== null || a !== null && a.ref !== l) && (i.flags |= ya);
    }
    function WP(a, i, l, c, h) {
      if (i.type !== i.elementType) {
        var b = l.propTypes;
        b && cl(
          b,
          c,
          "prop",
          Je(l)
        );
      }
      var S;
      {
        var E = sh(i, l, !0);
        S = lh(i, E);
      }
      var z;
      fh(i, h);
      {
        if (lv.current = i, Or(!0), z = gh(a, i, l, c, S, h), i.mode & oa) {
          Zr();
          try {
            z = gh(a, i, l, c, S, h);
          } finally {
            mr();
          }
        }
        Or(!1);
      }
      return a !== null && !au ? (oC(a, i, h), ac(a, i, h)) : (i.flags |= Ra, Wo(a, i, z, h), i.child);
    }
    function AC(a, i, l, c, h) {
      if (i.type !== i.elementType) {
        var b = l.propTypes;
        b && cl(
          b,
          c,
          "prop",
          Je(l)
        );
      }
      var S;
      eu(l) ? (S = !0, oy(i)) : S = !1, fh(i, h);
      var E = i.stateNode, z;
      E === null ? (a !== null && (a.alternate = null, i.alternate = null, i.flags |= Ht), q2(i, l, c), X0(i, l, c, h), z = !0) : a === null ? z = Gj(i, l, c, h) : z = Qj(a, i, l, c, h);
      var G = jP(a, i, l, z, S, h);
      {
        var ee = i.stateNode;
        z && ee.props !== c && (Ff || m("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Je(i.type) || "a component"), Ff = !0);
      }
      return G;
    }
    function jP(a, i, l, c, h, b) {
      EC(a, i);
      var S = (i.flags & En) !== zn;
      if (!c && !S)
        return h && h2(i, l, !1), ac(a, i, b);
      var E = i.stateNode;
      lv.current = i;
      var z;
      if (S && typeof l.getDerivedStateFromError != "function")
        z = null, SC();
      else {
        if (Or(!0), z = E.render(), i.mode & oa) {
          Zr();
          try {
            E.render();
          } finally {
            mr();
          }
        }
        Or(!1);
      }
      return i.flags |= Ra, a !== null && S ? vz(a, i, z, b) : Wo(a, i, z, b), i.memoizedState = E.state, h && h2(i, l, !0), i.child;
    }
    function _C(a) {
      var i = a.stateNode;
      i.pendingContext ? f2(a, i.pendingContext, i.pendingContext !== i.context) : i.context && f2(a, i.context, !1), J0(a, i.containerInfo);
    }
    function Pz(a, i, l) {
      _C(i);
      var c = i.updateQueue;
      if (!(a !== null && c !== null))
        throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
      var h = i.pendingProps, b = i.memoizedState, S = b !== null ? b.element : null;
      z2(a, i), Yp(i, h, null, l);
      var E = i.memoizedState, z = E.element;
      if (z === S)
        return iP(), ac(a, i, l);
      var G = i.stateNode;
      if (G.hydrate && nz(i)) {
        {
          var ee = G.mutableSourceEagerHydrationData;
          if (ee != null)
            for (var we = 0; we < ee.length; we += 2) {
              var ae = ee[we], ke = ee[we + 1];
              iC(ae, ke);
            }
        }
        var ze = K2(i, null, z, l);
        i.child = ze;
        for (var rt = ze; rt; )
          rt.flags = rt.flags & ~Ht | Si, rt = rt.sibling;
      } else
        Wo(a, i, z, l), iP();
      return i.child;
    }
    function kz(a, i, l) {
      Z2(i), a === null && aP(i);
      var c = i.type, h = i.pendingProps, b = a !== null ? a.memoizedProps : null, S = h.children, E = g0(c, h);
      return E ? S = null : b !== null && g0(c, b) && (i.flags |= kr), EC(a, i), Wo(a, i, S, l), i.child;
    }
    function $z(a, i) {
      return a === null && aP(i), null;
    }
    function Sz(a, i, l, c, h) {
      a !== null && (a.alternate = null, i.alternate = null, i.flags |= Ht);
      var b = i.pendingProps, S = l, E = S._payload, z = S._init, G = z(E);
      i.type = G;
      var ee = i.tag = c8(G), we = fl(G, b), ae;
      switch (ee) {
        case v:
          return zP(i, G), i.type = G = Mh(G), ae = WP(null, i, G, we, h), ae;
        case y:
          return i.type = G = vk(G), ae = AC(null, i, G, we, h), ae;
        case V:
          return i.type = G = gk(G), ae = xC(null, i, G, we, h), ae;
        case K: {
          if (i.type !== i.elementType) {
            var ke = G.propTypes;
            ke && cl(
              ke,
              we,
              "prop",
              Je(G)
            );
          }
          return ae = CC(
            null,
            i,
            G,
            fl(G.type, we),
            c,
            h
          ), ae;
        }
      }
      var ze = "";
      throw G !== null && typeof G == "object" && G.$$typeof === Jn && (ze = " Did you wrap a component in React.lazy() more than once?"), Error("Element type is invalid. Received a promise that resolves to: " + G + ". Lazy element type must resolve to a class or function." + ze);
    }
    function xz(a, i, l, c, h) {
      a !== null && (a.alternate = null, i.alternate = null, i.flags |= Ht), i.tag = y;
      var b;
      return eu(l) ? (b = !0, oy(i)) : b = !1, fh(i, h), q2(i, l, c), X0(i, l, c, h), jP(null, i, l, !0, b, h);
    }
    function Cz(a, i, l, c) {
      a !== null && (a.alternate = null, i.alternate = null, i.flags |= Ht);
      var h = i.pendingProps, b;
      {
        var S = sh(i, l, !1);
        b = lh(i, S);
      }
      fh(i, c);
      var E;
      {
        if (l.prototype && typeof l.prototype.render == "function") {
          var z = Je(l) || "Unknown";
          _P[z] || (m("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", z, z), _P[z] = !0);
        }
        i.mode & oa && dl.recordLegacyContextWarning(i, null), Or(!0), lv.current = i, E = gh(null, i, l, h, b, c), Or(!1);
      }
      if (i.flags |= Ra, typeof E == "object" && E !== null && typeof E.render == "function" && E.$$typeof === void 0) {
        var G = Je(l) || "Unknown";
        uv[G] || (m("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", G, G, G), uv[G] = !0);
      }
      if (typeof E == "object" && E !== null && typeof E.render == "function" && E.$$typeof === void 0) {
        {
          var ee = Je(l) || "Unknown";
          uv[ee] || (m("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ee, ee, ee), uv[ee] = !0);
        }
        i.tag = y, i.memoizedState = null, i.updateQueue = null;
        var we = !1;
        eu(l) ? (we = !0, oy(i)) : we = !1, i.memoizedState = E.state !== null && E.state !== void 0 ? E.state : null, N0(i);
        var ae = l.getDerivedStateFromProps;
        return typeof ae == "function" && Py(i, l, ae, h), X2(i, E), X0(i, l, h, c), jP(null, i, l, !0, we, c);
      } else {
        if (i.tag = v, i.mode & oa) {
          Zr();
          try {
            E = gh(null, i, l, h, b, c);
          } finally {
            mr();
          }
        }
        return Wo(null, i, E, c), zP(i, l), i.child;
      }
    }
    function zP(a, i) {
      {
        if (i && i.childContextTypes && m("%s(...): childContextTypes cannot be defined on a function component.", i.displayName || i.name || "Component"), a.ref !== null) {
          var l = "", c = _a();
          c && (l += `

Check the render method of \`` + c + "`.");
          var h = c || a._debugID || "", b = a._debugSource;
          b && (h = b.fileName + ":" + b.lineNumber), RP[h] || (RP[h] = !0, m("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", l));
        }
        if (typeof i.getDerivedStateFromProps == "function") {
          var S = Je(i) || "Unknown";
          TP[S] || (m("%s: Function components do not support getDerivedStateFromProps.", S), TP[S] = !0);
        }
        if (typeof i.contextType == "object" && i.contextType !== null) {
          var E = Je(i) || "Unknown";
          OP[E] || (m("%s: Function components do not support contextType.", E), OP[E] = !0);
        }
      }
    }
    var Yy = {
      dehydrated: null,
      retryLane: ln
    };
    function Gy(a) {
      return {
        baseLanes: a
      };
    }
    function OC(a, i) {
      return {
        baseLanes: bn(a.baseLanes, i)
      };
    }
    function Mz(a, i, l, c) {
      if (i !== null) {
        var h = i.memoizedState;
        if (h === null)
          return !1;
      }
      return Ey(a, Jp);
    }
    function TC(a, i) {
      return _s(a.childLanes, i);
    }
    function RC(a, i, l) {
      var c = i.pendingProps;
      A8(i) && (i.flags |= En);
      var h = ml.current, b = !1, S = (i.flags & En) !== zn;
      if (S || Mz(h, a) ? (b = !0, i.flags &= ~En) : (a === null || a.memoizedState !== null) && c.fallback !== void 0 && c.unstable_avoidThisFallback !== !0 && (h = ez(h, tP)), h = Zp(h), Wf(i, h), a === null) {
        c.fallback !== void 0 && aP(i);
        var E = c.children, z = c.fallback;
        if (b) {
          var G = DC(i, E, z, l), ee = i.child;
          return ee.memoizedState = Gy(l), i.memoizedState = Yy, G;
        } else if (typeof c.unstable_expectedLoadTime == "number") {
          var we = DC(i, E, z, l), ae = i.child;
          return ae.memoizedState = Gy(l), i.memoizedState = Yy, i.lanes = We, pb(We), we;
        } else
          return Ez(i, E, l);
      } else {
        var ke = a.memoizedState;
        if (ke !== null)
          if (b) {
            var ze = c.fallback, rt = c.children, Dt = jC(a, i, rt, ze, l), rn = i.child, Ft = a.child.memoizedState;
            return rn.memoizedState = Ft === null ? Gy(l) : OC(Ft, l), rn.childLanes = TC(a, l), i.memoizedState = Yy, Dt;
          } else {
            var On = c.children, dr = WC(a, i, On, l);
            return i.memoizedState = null, dr;
          }
        else if (b) {
          var Pe = c.fallback, Ae = c.children, pe = jC(a, i, Ae, Pe, l), Ue = i.child, st = a.child.memoizedState;
          return Ue.memoizedState = st === null ? Gy(l) : OC(st, l), Ue.childLanes = TC(a, l), i.memoizedState = Yy, pe;
        } else {
          var $t = c.children, kn = WC(a, i, $t, l);
          return i.memoizedState = null, kn;
        }
      }
    }
    function Ez(a, i, l) {
      var c = a.mode, h = {
        mode: "visible",
        children: i
      }, b = Sk(h, c, l, null);
      return b.return = a, a.child = b, b;
    }
    function DC(a, i, l, c) {
      var h = a.mode, b = a.child, S = {
        mode: "hidden",
        children: i
      }, E, z;
      return (h & Do) === Lr && b !== null ? (E = b, E.childLanes = Te, E.pendingProps = S, a.mode & rs && (E.actualDuration = 0, E.actualStartTime = -1, E.selfBaseDuration = 0, E.treeBaseDuration = 0), z = qf(l, h, c, null)) : (E = Sk(S, h, Te, null), z = qf(l, h, c, null)), E.return = a, z.return = a, E.sibling = z, a.child = E, z;
    }
    function NC(a, i) {
      return Xf(a, i);
    }
    function WC(a, i, l, c) {
      var h = a.child, b = h.sibling, S = NC(h, {
        mode: "visible",
        children: l
      });
      return (i.mode & Do) === Lr && (S.lanes = c), S.return = i, S.sibling = null, b !== null && (b.nextEffect = null, b.flags = er, i.firstEffect = i.lastEffect = b), i.child = S, S;
    }
    function jC(a, i, l, c, h) {
      var b = i.mode, S = a.child, E = S.sibling, z = {
        mode: "hidden",
        children: l
      }, G;
      if ((b & Do) === Lr && i.child !== S) {
        var ee = i.child;
        G = ee, G.childLanes = Te, G.pendingProps = z, i.mode & rs && (G.actualDuration = 0, G.actualStartTime = -1, G.selfBaseDuration = S.selfBaseDuration, G.treeBaseDuration = S.treeBaseDuration);
        var we = G.lastEffect;
        we !== null ? (i.firstEffect = G.firstEffect, i.lastEffect = we, we.nextEffect = null) : i.firstEffect = i.lastEffect = null;
      } else
        G = NC(S, z);
      var ae;
      return E !== null ? ae = Xf(E, c) : (ae = qf(c, b, h, null), ae.flags |= Ht), ae.return = i, G.return = i, G.sibling = ae, i.child = G, ae;
    }
    function zC(a, i) {
      a.lanes = bn(a.lanes, i);
      var l = a.alternate;
      l !== null && (l.lanes = bn(l.lanes, i)), N2(a.return, i);
    }
    function Az(a, i, l) {
      for (var c = i; c !== null; ) {
        if (c.tag === U) {
          var h = c.memoizedState;
          h !== null && zC(c, l);
        } else if (c.tag === _e)
          zC(c, l);
        else if (c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === a)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === a)
            return;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }
    function _z(a) {
      for (var i = a, l = null; i !== null; ) {
        var c = i.alternate;
        c !== null && Ay(c) === null && (l = i), i = i.sibling;
      }
      return l;
    }
    function Oz(a) {
      if (a !== void 0 && a !== "forwards" && a !== "backwards" && a !== "together" && !DP[a])
        if (DP[a] = !0, typeof a == "string")
          switch (a.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              m('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', a, a.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              m('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', a, a.toLowerCase());
              break;
            }
            default:
              m('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', a);
              break;
          }
        else
          m('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', a);
    }
    function Tz(a, i) {
      a !== void 0 && !qy[a] && (a !== "collapsed" && a !== "hidden" ? (qy[a] = !0, m('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', a)) : i !== "forwards" && i !== "backwards" && (qy[a] = !0, m('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', a)));
    }
    function LC(a, i) {
      {
        var l = Array.isArray(a), c = !l && typeof Jr(a) == "function";
        if (l || c) {
          var h = l ? "array" : "iterable";
          return m("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", h, i, h), !1;
        }
      }
      return !0;
    }
    function Rz(a, i) {
      if ((i === "forwards" || i === "backwards") && a !== void 0 && a !== null && a !== !1)
        if (Array.isArray(a)) {
          for (var l = 0; l < a.length; l++)
            if (!LC(a[l], l))
              return;
        } else {
          var c = Jr(a);
          if (typeof c == "function") {
            var h = c.call(a);
            if (h)
              for (var b = h.next(), S = 0; !b.done; b = h.next()) {
                if (!LC(b.value, S))
                  return;
                S++;
              }
          } else
            m('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', i);
        }
    }
    function LP(a, i, l, c, h, b) {
      var S = a.memoizedState;
      S === null ? a.memoizedState = {
        isBackwards: i,
        rendering: null,
        renderingStartTime: 0,
        last: c,
        tail: l,
        tailMode: h,
        lastEffect: b
      } : (S.isBackwards = i, S.rendering = null, S.renderingStartTime = 0, S.last = c, S.tail = l, S.tailMode = h, S.lastEffect = b);
    }
    function IC(a, i, l) {
      var c = i.pendingProps, h = c.revealOrder, b = c.tail, S = c.children;
      Oz(h), Tz(b, h), Rz(S, h), Wo(a, i, S, l);
      var E = ml.current, z = Ey(E, Jp);
      if (z)
        E = nP(E, Jp), i.flags |= En;
      else {
        var G = a !== null && (a.flags & En) !== zn;
        G && Az(i, i.child, l), E = Zp(E);
      }
      if (Wf(i, E), (i.mode & Do) === Lr)
        i.memoizedState = null;
      else
        switch (h) {
          case "forwards": {
            var ee = _z(i.child), we;
            ee === null ? (we = i.child, i.child = null) : (we = ee.sibling, ee.sibling = null), LP(
              i,
              !1,
              we,
              ee,
              b,
              i.lastEffect
            );
            break;
          }
          case "backwards": {
            var ae = null, ke = i.child;
            for (i.child = null; ke !== null; ) {
              var ze = ke.alternate;
              if (ze !== null && Ay(ze) === null) {
                i.child = ke;
                break;
              }
              var rt = ke.sibling;
              ke.sibling = ae, ae = ke, ke = rt;
            }
            LP(
              i,
              !0,
              ae,
              null,
              b,
              i.lastEffect
            );
            break;
          }
          case "together": {
            LP(
              i,
              !1,
              null,
              null,
              void 0,
              i.lastEffect
            );
            break;
          }
          default:
            i.memoizedState = null;
        }
      return i.child;
    }
    function Dz(a, i, l) {
      J0(i, i.stateNode.containerInfo);
      var c = i.pendingProps;
      return a === null ? i.child = xy(i, null, c, l) : Wo(a, i, c, l), i.child;
    }
    var FC = !1;
    function Nz(a, i, l) {
      var c = i.type, h = c._context, b = i.pendingProps, S = i.memoizedProps, E = b.value;
      {
        "value" in b || FC || (FC = !0, m("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var z = i.type.propTypes;
        z && cl(z, b, "prop", "Context.Provider");
      }
      if (D2(i, E), S !== null) {
        var G = S.value, ee = Hj(h, E, G);
        if (ee === 0) {
          if (S.children === b.children && !ay())
            return ac(a, i, l);
        } else
          Vj(i, h, ee, l);
      }
      var we = b.children;
      return Wo(a, i, we, l), i.child;
    }
    var HC = !1;
    function Wz(a, i, l) {
      var c = i.type;
      c._context === void 0 ? c !== c.Consumer && (HC || (HC = !0, m("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : c = c._context;
      var h = i.pendingProps, b = h.children;
      typeof b != "function" && m("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), fh(i, l);
      var S = Wa(c, h.unstable_observedBits), E;
      return lv.current = i, Or(!0), E = b(S), Or(!1), i.flags |= Ra, Wo(a, i, E, l), i.child;
    }
    function IP() {
      au = !0;
    }
    function ac(a, i, l) {
      return a !== null && (i.dependencies = a.dependencies), SC(), dk(i.lanes), Tr(l, i.childLanes) ? (Kj(a, i), i.child) : null;
    }
    function jz(a, i, l) {
      {
        var c = i.return;
        if (c === null)
          throw new Error("Cannot swap the root fiber.");
        if (a.alternate = null, i.alternate = null, l.index = i.index, l.sibling = i.sibling, l.return = i.return, l.ref = i.ref, i === c.child)
          c.child = l;
        else {
          var h = c.child;
          if (h === null)
            throw new Error("Expected parent to have a child.");
          for (; h.sibling !== i; )
            if (h = h.sibling, h === null)
              throw new Error("Expected to find the previous sibling.");
          h.sibling = l;
        }
        var b = c.lastEffect;
        return b !== null ? (b.nextEffect = a, c.lastEffect = a) : c.firstEffect = c.lastEffect = a, a.nextEffect = null, a.flags = er, l.flags |= Ht, l;
      }
    }
    function VC(a, i, l) {
      var c = i.lanes;
      if (i._debugNeedsRemount && a !== null)
        return jz(a, i, kk(i.type, i.key, i.pendingProps, i._debugOwner || null, i.mode, i.lanes));
      if (a !== null) {
        var h = a.memoizedProps, b = i.pendingProps;
        if (h !== b || ay() || i.type !== a.type)
          au = !0;
        else if (Tr(l, c))
          (a.flags & Wu) !== zn ? au = !0 : au = !1;
        else {
          switch (au = !1, i.tag) {
            case P:
              _C(i), iP();
              break;
            case A:
              Z2(i);
              break;
            case y: {
              var S = i.type;
              eu(S) && oy(i);
              break;
            }
            case x:
              J0(i, i.stateNode.containerInfo);
              break;
            case J: {
              var E = i.memoizedProps.value;
              D2(i, E);
              break;
            }
            case X:
              {
                var z = Tr(l, i.childLanes);
                z && (i.flags |= Lt);
                var G = i.stateNode;
                G.effectDuration = 0, G.passiveEffectDuration = 0;
              }
              break;
            case U: {
              var ee = i.memoizedState;
              if (ee !== null) {
                var we = i.child, ae = we.childLanes;
                if (Tr(l, ae))
                  return RC(a, i, l);
                Wf(i, Zp(ml.current));
                var ke = ac(a, i, l);
                return ke !== null ? ke.sibling : null;
              } else
                Wf(i, Zp(ml.current));
              break;
            }
            case _e: {
              var ze = (a.flags & En) !== zn, rt = Tr(l, i.childLanes);
              if (ze) {
                if (rt)
                  return IC(a, i, l);
                i.flags |= En;
              }
              var Dt = i.memoizedState;
              if (Dt !== null && (Dt.rendering = null, Dt.tail = null, Dt.lastEffect = null), Wf(i, ml.current), rt)
                break;
              return null;
            }
            case Qe:
            case qe:
              return i.lanes = Te, NP(a, i, l);
          }
          return ac(a, i, l);
        }
      } else
        au = !1;
      switch (i.lanes = Te, i.tag) {
        case w:
          return Cz(a, i, i.type, l);
        case ue: {
          var rn = i.elementType;
          return Sz(a, i, rn, c, l);
        }
        case v: {
          var Ft = i.type, On = i.pendingProps, dr = i.elementType === Ft ? On : fl(Ft, On);
          return WP(a, i, Ft, dr, l);
        }
        case y: {
          var Pe = i.type, Ae = i.pendingProps, pe = i.elementType === Pe ? Ae : fl(Pe, Ae);
          return AC(a, i, Pe, pe, l);
        }
        case P:
          return Pz(a, i, l);
        case A:
          return kz(a, i, l);
        case M:
          return $z(a, i);
        case U:
          return RC(a, i, l);
        case x:
          return Dz(a, i, l);
        case V: {
          var Ue = i.type, st = i.pendingProps, $t = i.elementType === Ue ? st : fl(Ue, st);
          return xC(a, i, Ue, $t, l);
        }
        case O:
          return yz(a, i, l);
        case j:
          return bz(a, i, l);
        case X:
          return wz(a, i, l);
        case J:
          return Nz(a, i, l);
        case H:
          return Wz(a, i, l);
        case K: {
          var kn = i.type, Cr = i.pendingProps, Ir = fl(kn, Cr);
          if (i.type !== i.elementType) {
            var tr = kn.propTypes;
            tr && cl(
              tr,
              Ir,
              "prop",
              Je(kn)
            );
          }
          return Ir = fl(kn.type, Ir), CC(a, i, kn, Ir, c, l);
        }
        case ce:
          return MC(a, i, i.type, i.pendingProps, c, l);
        case ye: {
          var ja = i.type, Un = i.pendingProps, Fr = i.elementType === ja ? Un : fl(ja, Un);
          return xz(a, i, ja, Fr, l);
        }
        case _e:
          return IC(a, i, l);
        case Le:
          break;
        case Ne:
          break;
        case nt:
          break;
        case Qe:
          return NP(a, i, l);
        case qe:
          return gz(a, i, l);
      }
      throw Error("Unknown unit of work tag (" + i.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function wh(a) {
      a.flags |= Lt;
    }
    function BC(a) {
      a.flags |= ya;
    }
    var UC, FP, XC, qC;
    UC = function(a, i, l, c) {
      for (var h = i.child; h !== null; ) {
        if (h.tag === A || h.tag === M)
          j6(a, h.stateNode);
        else if (h.tag !== x) {
          if (h.child !== null) {
            h.child.return = h, h = h.child;
            continue;
          }
        }
        if (h === i)
          return;
        for (; h.sibling === null; ) {
          if (h.return === null || h.return === i)
            return;
          h = h.return;
        }
        h.sibling.return = h.return, h = h.sibling;
      }
    }, FP = function(a) {
    }, XC = function(a, i, l, c, h) {
      var b = a.memoizedProps;
      if (b !== c) {
        var S = i.stateNode, E = Z0(), z = L6(S, l, b, c, h, E);
        i.updateQueue = z, z && wh(i);
      }
    }, qC = function(a, i, l, c) {
      l !== c && wh(i);
    };
    function cv(a, i) {
      if (!oP())
        switch (a.tailMode) {
          case "hidden": {
            for (var l = a.tail, c = null; l !== null; )
              l.alternate !== null && (c = l), l = l.sibling;
            c === null ? a.tail = null : c.sibling = null;
            break;
          }
          case "collapsed": {
            for (var h = a.tail, b = null; h !== null; )
              h.alternate !== null && (b = h), h = h.sibling;
            b === null ? !i && a.tail !== null ? a.tail.sibling = null : a.tail = null : b.sibling = null;
            break;
          }
        }
    }
    function YC(a, i, l) {
      var c = i.pendingProps;
      switch (i.tag) {
        case w:
        case ue:
        case ce:
        case v:
        case V:
        case O:
        case j:
        case X:
        case H:
        case K:
          return null;
        case y: {
          var h = i.type;
          return eu(h) && iy(i), null;
        }
        case P: {
          mh(i), S0(i), lP();
          var b = i.stateNode;
          if (b.pendingContext && (b.context = b.pendingContext, b.pendingContext = null), a === null || a.child === null) {
            var S = _y(i);
            S ? wh(i) : b.hydrate || (i.flags |= Zi);
          }
          return FP(i), null;
        }
        case A: {
          eP(i);
          var E = J2(), z = i.type;
          if (a !== null && i.stateNode != null)
            XC(a, i, z, c, E), a.ref !== i.ref && BC(i);
          else {
            if (!c) {
              if (i.stateNode === null)
                throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return null;
            }
            var G = Z0(), ee = _y(i);
            if (ee)
              rz(i, E, G) && wh(i);
            else {
              var we = W6(z, c, E, G, i);
              UC(we, i, !1, !1), i.stateNode = we, z6(we, z, c, E) && wh(i);
            }
            i.ref !== null && BC(i);
          }
          return null;
        }
        case M: {
          var ae = c;
          if (a && i.stateNode != null) {
            var ke = a.memoizedProps;
            qC(a, i, ke, ae);
          } else {
            if (typeof ae != "string" && i.stateNode === null)
              throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var ze = J2(), rt = Z0(), Dt = _y(i);
            Dt ? az(i) && wh(i) : i.stateNode = I6(ae, ze, rt, i);
          }
          return null;
        }
        case U: {
          hh(i);
          var rn = i.memoizedState;
          if ((i.flags & En) !== zn)
            return i.lanes = l, (i.mode & rs) !== Lr && AP(i), i;
          var Ft = rn !== null, On = !1;
          if (a === null)
            i.memoizedProps.fallback !== void 0 && _y(i);
          else {
            var dr = a.memoizedState;
            On = dr !== null;
          }
          if (Ft && !On && (i.mode & Do) !== Lr) {
            var Pe = a === null && i.memoizedProps.unstable_avoidThisFallback !== !0;
            Pe || Ey(ml.current, tP) ? $7() : S7();
          }
          return (Ft || On) && (i.flags |= Lt), null;
        }
        case x:
          return mh(i), FP(i), a === null && $j(i.stateNode.containerInfo), null;
        case J:
          return T0(i), null;
        case ye: {
          var Ae = i.type;
          return eu(Ae) && iy(i), null;
        }
        case _e: {
          hh(i);
          var pe = i.memoizedState;
          if (pe === null)
            return null;
          var Ue = (i.flags & En) !== zn, st = pe.rendering;
          if (st === null)
            if (Ue)
              cv(pe, !1);
            else {
              var $t = C7() && (a === null || (a.flags & En) === zn);
              if (!$t)
                for (var kn = i.child; kn !== null; ) {
                  var Cr = Ay(kn);
                  if (Cr !== null) {
                    Ue = !0, i.flags |= En, cv(pe, !1);
                    var Ir = Cr.updateQueue;
                    return Ir !== null && (i.updateQueue = Ir, i.flags |= Lt), pe.lastEffect === null && (i.firstEffect = null), i.lastEffect = pe.lastEffect, Jj(i, l), Wf(i, nP(ml.current, Jp)), i.child;
                  }
                  kn = kn.sibling;
                }
              pe.tail !== null && Hi() > cM() && (i.flags |= En, Ue = !0, cv(pe, !1), i.lanes = We, pb(We));
            }
          else {
            if (!Ue) {
              var tr = Ay(st);
              if (tr !== null) {
                i.flags |= En, Ue = !0;
                var ja = tr.updateQueue;
                if (ja !== null && (i.updateQueue = ja, i.flags |= Lt), cv(pe, !0), pe.tail === null && pe.tailMode === "hidden" && !st.alternate && !oP()) {
                  var Un = i.lastEffect = pe.lastEffect;
                  return Un !== null && (Un.nextEffect = null), null;
                }
              } else
                Hi() * 2 - pe.renderingStartTime > cM() && l !== jt && (i.flags |= En, Ue = !0, cv(pe, !1), i.lanes = We, pb(We));
            }
            if (pe.isBackwards)
              st.sibling = i.child, i.child = st;
            else {
              var Fr = pe.last;
              Fr !== null ? Fr.sibling = st : i.child = st, pe.last = st;
            }
          }
          if (pe.tail !== null) {
            var mi = pe.tail;
            pe.rendering = mi, pe.tail = mi.sibling, pe.lastEffect = i.lastEffect, pe.renderingStartTime = Hi(), mi.sibling = null;
            var $a = ml.current;
            return Ue ? $a = nP($a, Jp) : $a = Zp($a), Wf(i, $a), mi;
          }
          return null;
        }
        case Le:
          break;
        case Ne:
          break;
        case nt:
          break;
        case Qe:
        case qe: {
          if (ck(i), a !== null) {
            var lu = i.memoizedState, Sa = a.memoizedState, uu = Sa !== null, Yf = lu !== null;
            uu !== Yf && c.mode !== "unstable-defer-without-hiding" && (i.flags |= Lt);
          }
          return null;
        }
      }
      throw Error("Unknown unit of work tag (" + i.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function zz(a, i) {
      switch (a.tag) {
        case y: {
          var l = a.type;
          eu(l) && iy(a);
          var c = a.flags;
          return c & to ? (a.flags = c & ~to | En, (a.mode & rs) !== Lr && AP(a), a) : null;
        }
        case P: {
          mh(a), S0(a), lP();
          var h = a.flags;
          if ((h & En) !== zn)
            throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
          return a.flags = h & ~to | En, a;
        }
        case A:
          return eP(a), null;
        case U: {
          hh(a);
          var b = a.flags;
          return b & to ? (a.flags = b & ~to | En, (a.mode & rs) !== Lr && AP(a), a) : null;
        }
        case _e:
          return hh(a), null;
        case x:
          return mh(a), null;
        case J:
          return T0(a), null;
        case Qe:
        case qe:
          return ck(a), null;
        default:
          return null;
      }
    }
    function GC(a) {
      switch (a.tag) {
        case y: {
          var i = a.type.childContextTypes;
          i != null && iy(a);
          break;
        }
        case P: {
          mh(a), S0(a), lP();
          break;
        }
        case A: {
          eP(a);
          break;
        }
        case x:
          mh(a);
          break;
        case U:
          hh(a);
          break;
        case _e:
          hh(a);
          break;
        case J:
          T0(a);
          break;
        case Qe:
        case qe:
          ck(a);
          break;
      }
    }
    function HP(a, i) {
      return {
        value: a,
        source: i,
        stack: ea(i)
      };
    }
    function Lz(a, i) {
      return !0;
    }
    function VP(a, i) {
      try {
        var l = Lz(a, i);
        if (l === !1)
          return;
        var c = i.value, h = i.source, b = i.stack, S = b !== null ? b : "";
        if (c != null && c._suppressLogging) {
          if (a.tag === y)
            return;
          console.error(c);
        }
        var E = h ? Je(h.type) : null, z = E ? "The above error occurred in the <" + E + "> component:" : "The above error occurred in one of your React components:", G, ee = Je(a.type);
        ee ? G = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + ee + ".") : G = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        var we = z + `
` + S + `

` + ("" + G);
        console.error(we);
      } catch (ae) {
        setTimeout(function() {
          throw ae;
        });
      }
    }
    var Iz = typeof WeakMap == "function" ? WeakMap : Map;
    function QC(a, i, l) {
      var c = Zc(St, l);
      c.tag = R0, c.payload = {
        element: null
      };
      var h = i.value;
      return c.callback = function() {
        I7(h), VP(a, i);
      }, c;
    }
    function KC(a, i, l) {
      var c = Zc(St, l);
      c.tag = R0;
      var h = a.type.getDerivedStateFromError;
      if (typeof h == "function") {
        var b = i.value;
        c.payload = function() {
          return VP(a, i), h(b);
        };
      }
      var S = a.stateNode;
      return S !== null && typeof S.componentDidCatch == "function" ? c.callback = function() {
        OM(a), typeof h != "function" && (z7(this), VP(a, i));
        var z = i.value, G = i.stack;
        this.componentDidCatch(z, {
          componentStack: G !== null ? G : ""
        }), typeof h != "function" && (Tr(a.lanes, un) || m("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Je(a.type) || "Unknown"));
      } : c.callback = function() {
        OM(a);
      }, c;
    }
    function Fz(a, i, l) {
      var c = a.pingCache, h;
      if (c === null ? (c = a.pingCache = new Iz(), h = /* @__PURE__ */ new Set(), c.set(i, h)) : (h = c.get(i), h === void 0 && (h = /* @__PURE__ */ new Set(), c.set(i, h))), !h.has(l)) {
        h.add(l);
        var b = F7.bind(null, a, i, l);
        i.then(b, b);
      }
    }
    function Hz(a, i, l, c, h) {
      if (l.flags |= Nu, l.firstEffect = l.lastEffect = null, c !== null && typeof c == "object" && typeof c.then == "function") {
        var b = c;
        if ((l.mode & Do) === Lr) {
          var S = l.alternate;
          S ? (l.updateQueue = S.updateQueue, l.memoizedState = S.memoizedState, l.lanes = S.lanes) : (l.updateQueue = null, l.memoizedState = null);
        }
        var E = Ey(ml.current, tP), z = i;
        do {
          if (z.tag === U && tz(z, E)) {
            var G = z.updateQueue;
            if (G === null) {
              var ee = /* @__PURE__ */ new Set();
              ee.add(b), z.updateQueue = ee;
            } else
              G.add(b);
            if ((z.mode & Do) === Lr) {
              if (z.flags |= En, l.flags |= Wu, l.flags &= ~(ef | Nu), l.tag === y) {
                var we = l.alternate;
                if (we === null)
                  l.tag = ye;
                else {
                  var ae = Zc(St, un);
                  ae.tag = vy, ed(l, ae);
                }
              }
              l.lanes = bn(l.lanes, un);
              return;
            }
            Fz(a, b, h), z.flags |= to, z.lanes = h;
            return;
          }
          z = z.return;
        } while (z !== null);
        c = new Error((Je(l.type) || "A React component") + ` suspended while rendering, but no fallback UI was specified.

Add a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.`);
      }
      x7(), c = HP(c, l);
      var ke = i;
      do {
        switch (ke.tag) {
          case P: {
            var ze = c;
            ke.flags |= to;
            var rt = hr(h);
            ke.lanes = bn(ke.lanes, rt);
            var Dt = QC(ke, ze, rt);
            L2(ke, Dt);
            return;
          }
          case y:
            var rn = c, Ft = ke.type, On = ke.stateNode;
            if ((ke.flags & En) === zn && (typeof Ft.getDerivedStateFromError == "function" || On !== null && typeof On.componentDidCatch == "function" && !fk(On))) {
              ke.flags |= to;
              var dr = hr(h);
              ke.lanes = bn(ke.lanes, dr);
              var Pe = KC(ke, rn, dr);
              L2(ke, Pe);
              return;
            }
            break;
        }
        ke = ke.return;
      } while (ke !== null);
    }
    var JC = null;
    JC = /* @__PURE__ */ new Set();
    var Vz = typeof WeakSet == "function" ? WeakSet : Set, Bz = function(a, i) {
      i.props = a.memoizedProps, i.state = a.memoizedState, i.componentWillUnmount();
    };
    function Uz(a, i) {
      if (Ta(null, Bz, null, a, i), si()) {
        var l = Ya();
        id(a, l);
      }
    }
    function ZC(a) {
      var i = a.ref;
      if (i !== null)
        if (typeof i == "function") {
          if (Ta(null, i, null, null), si()) {
            var l = Ya();
            id(a, l);
          }
        } else
          i.current = null;
    }
    function Xz(a, i) {
      if (Ta(null, i, null), si()) {
        var l = Ya();
        id(a, l);
      }
    }
    function qz(a, i) {
      switch (i.tag) {
        case v:
        case V:
        case ce:
        case nt:
          return;
        case y: {
          if (i.flags & Zi && a !== null) {
            var l = a.memoizedProps, c = a.memoizedState, h = i.stateNode;
            i.type === i.elementType && !Ff && (h.props !== i.memoizedProps && m("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Je(i.type) || "instance"), h.state !== i.memoizedState && m("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Je(i.type) || "instance"));
            var b = h.getSnapshotBeforeUpdate(i.elementType === i.type ? l : fl(i.type, l), c);
            {
              var S = JC;
              b === void 0 && !S.has(i.type) && (S.add(i.type), m("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Je(i.type)));
            }
            h.__reactInternalSnapshotBeforeUpdate = b;
          }
          return;
        }
        case P: {
          if (i.flags & Zi) {
            var E = i.stateNode;
            b0(E.containerInfo);
          }
          return;
        }
        case A:
        case M:
        case x:
        case ye:
          return;
      }
      throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Yz(a, i) {
      var l = i.updateQueue, c = l !== null ? l.lastEffect : null;
      if (c !== null) {
        var h = c.next, b = h;
        do {
          if ((b.tag & a) === a) {
            var S = b.destroy;
            b.destroy = void 0, S !== void 0 && S();
          }
          b = b.next;
        } while (b !== h);
      }
    }
    function Gz(a, i) {
      var l = i.updateQueue, c = l !== null ? l.lastEffect : null;
      if (c !== null) {
        var h = c.next, b = h;
        do {
          if ((b.tag & a) === a) {
            var S = b.create;
            b.destroy = S();
            {
              var E = b.destroy;
              if (E !== void 0 && typeof E != "function") {
                var z = void 0;
                E === null ? z = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof E.then == "function" ? z = `

It looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

useEffect(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : z = " You returned: " + E, m("An effect function must not return anything besides a function, which is used for clean-up.%s", z);
              }
            }
          }
          b = b.next;
        } while (b !== h);
      }
    }
    function Qz(a) {
      var i = a.updateQueue, l = i !== null ? i.lastEffect : null;
      if (l !== null) {
        var c = l.next, h = c;
        do {
          var b = h, S = b.next, E = b.tag;
          (E & ev) !== rP && (E & ph) !== rP && (bM(a, h), N7(a, h)), h = S;
        } while (h !== c);
      }
    }
    function Kz(a, i, l, c) {
      switch (l.tag) {
        case v:
        case V:
        case ce:
        case nt: {
          Gz(vh | ph, l), Qz(l);
          return;
        }
        case y: {
          var h = l.stateNode;
          if (l.flags & Lt)
            if (i === null)
              l.type === l.elementType && !Ff && (h.props !== l.memoizedProps && m("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Je(l.type) || "instance"), h.state !== l.memoizedState && m("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Je(l.type) || "instance")), h.componentDidMount();
            else {
              var b = l.elementType === l.type ? i.memoizedProps : fl(l.type, i.memoizedProps), S = i.memoizedState;
              l.type === l.elementType && !Ff && (h.props !== l.memoizedProps && m("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Je(l.type) || "instance"), h.state !== l.memoizedState && m("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Je(l.type) || "instance")), h.componentDidUpdate(b, S, h.__reactInternalSnapshotBeforeUpdate);
            }
          var E = l.updateQueue;
          E !== null && (l.type === l.elementType && !Ff && (h.props !== l.memoizedProps && m("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Je(l.type) || "instance"), h.state !== l.memoizedState && m("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Je(l.type) || "instance")), F2(l, E, h));
          return;
        }
        case P: {
          var z = l.updateQueue;
          if (z !== null) {
            var G = null;
            if (l.child !== null)
              switch (l.child.tag) {
                case A:
                  G = l.child.stateNode;
                  break;
                case y:
                  G = l.child.stateNode;
                  break;
              }
            F2(l, z, G);
          }
          return;
        }
        case A: {
          var ee = l.stateNode;
          if (i === null && l.flags & Lt) {
            var we = l.type, ae = l.memoizedProps;
            H6(ee, we, ae);
          }
          return;
        }
        case M:
          return;
        case x:
          return;
        case X: {
          {
            var ke = l.memoizedProps;
            ke.onCommit;
            var ze = ke.onRender;
            l.stateNode.effectDuration;
            var rt = pz();
            typeof ze == "function" && ze(l.memoizedProps.id, i === null ? "mount" : "update", l.actualDuration, l.treeBaseDuration, l.actualStartTime, rt, a.memoizedInteractions);
          }
          return;
        }
        case U: {
          i7(a, l);
          return;
        }
        case _e:
        case ye:
        case Le:
        case Ne:
        case Qe:
        case qe:
          return;
      }
      throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function eM(a, i) {
      for (var l = a; ; ) {
        if (l.tag === A) {
          var c = l.stateNode;
          i ? K6(c) : Z6(l.stateNode, l.memoizedProps);
        } else if (l.tag === M) {
          var h = l.stateNode;
          i ? J6(h) : ej(h, l.memoizedProps);
        } else if (!((l.tag === Qe || l.tag === qe) && l.memoizedState !== null && l !== a)) {
          if (l.child !== null) {
            l.child.return = l, l = l.child;
            continue;
          }
        }
        if (l === a)
          return;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === a)
            return;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    }
    function Jz(a) {
      var i = a.ref;
      if (i !== null) {
        var l = a.stateNode, c;
        switch (a.tag) {
          case A:
            c = l;
            break;
          default:
            c = l;
        }
        typeof i == "function" ? i(c) : (i.hasOwnProperty("current") || m("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Je(a.type)), i.current = c);
      }
    }
    function Zz(a) {
      var i = a.ref;
      i !== null && (typeof i == "function" ? i(null) : i.current = null);
    }
    function tM(a, i, l) {
      switch (_j(i), i.tag) {
        case v:
        case V:
        case K:
        case ce:
        case nt: {
          var c = i.updateQueue;
          if (c !== null) {
            var h = c.lastEffect;
            if (h !== null) {
              var b = h.next, S = b;
              do {
                var E = S, z = E.destroy, G = E.tag;
                z !== void 0 && ((G & ev) !== rP ? bM(i, S) : Xz(i, z)), S = S.next;
              } while (S !== b);
            }
          }
          return;
        }
        case y: {
          ZC(i);
          var ee = i.stateNode;
          typeof ee.componentWillUnmount == "function" && Uz(i, ee);
          return;
        }
        case A: {
          ZC(i);
          return;
        }
        case x: {
          iM(a, i);
          return;
        }
        case Le:
          return;
        case Oe:
          return;
        case Ne:
          return;
      }
    }
    function e7(a, i, l) {
      for (var c = i; ; ) {
        if (tM(a, c), c.child !== null && c.tag !== x) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === i)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === i)
            return;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }
    function nM(a) {
      a.alternate = null, a.child = null, a.dependencies = null, a.firstEffect = null, a.lastEffect = null, a.memoizedProps = null, a.memoizedState = null, a.pendingProps = null, a.return = null, a.updateQueue = null, a._debugOwner = null;
    }
    function t7(a) {
      for (var i = a.return; i !== null; ) {
        if (rM(i))
          return i;
        i = i.return;
      }
      throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function rM(a) {
      return a.tag === A || a.tag === P || a.tag === x;
    }
    function n7(a) {
      var i = a;
      e:
        for (; ; ) {
          for (; i.sibling === null; ) {
            if (i.return === null || rM(i.return))
              return null;
            i = i.return;
          }
          for (i.sibling.return = i.return, i = i.sibling; i.tag !== A && i.tag !== M && i.tag !== Oe; ) {
            if (i.flags & Ht || i.child === null || i.tag === x)
              continue e;
            i.child.return = i, i = i.child;
          }
          if (!(i.flags & Ht))
            return i.stateNode;
        }
    }
    function aM(a) {
      var i = t7(a), l, c, h = i.stateNode;
      switch (i.tag) {
        case A:
          l = h, c = !1;
          break;
        case P:
          l = h.containerInfo, c = !0;
          break;
        case x:
          l = h.containerInfo, c = !0;
          break;
        case Le:
        default:
          throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
      i.flags & kr && (t2(l), i.flags &= ~kr);
      var b = n7(a);
      c ? BP(a, b, l) : UP(a, b, l);
    }
    function BP(a, i, l) {
      var c = a.tag, h = c === A || c === M;
      if (h || xe) {
        var b = h ? a.stateNode : a.stateNode.instance;
        i ? Y6(l, b, i) : X6(l, b);
      } else if (c !== x) {
        var S = a.child;
        if (S !== null) {
          BP(S, i, l);
          for (var E = S.sibling; E !== null; )
            BP(E, i, l), E = E.sibling;
        }
      }
    }
    function UP(a, i, l) {
      var c = a.tag, h = c === A || c === M;
      if (h || xe) {
        var b = h ? a.stateNode : a.stateNode.instance;
        i ? q6(l, b, i) : U6(l, b);
      } else if (c !== x) {
        var S = a.child;
        if (S !== null) {
          UP(S, i, l);
          for (var E = S.sibling; E !== null; )
            UP(E, i, l), E = E.sibling;
        }
      }
    }
    function iM(a, i, l) {
      for (var c = i, h = !1, b, S; ; ) {
        if (!h) {
          var E = c.return;
          e:
            for (; ; ) {
              if (E === null)
                throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
              var z = E.stateNode;
              switch (E.tag) {
                case A:
                  b = z, S = !1;
                  break e;
                case P:
                  b = z.containerInfo, S = !0;
                  break e;
                case x:
                  b = z.containerInfo, S = !0;
                  break e;
              }
              E = E.return;
            }
          h = !0;
        }
        if (c.tag === A || c.tag === M)
          e7(a, c), S ? Q6(b, c.stateNode) : G6(b, c.stateNode);
        else if (c.tag === x) {
          if (c.child !== null) {
            b = c.stateNode.containerInfo, S = !0, c.child.return = c, c = c.child;
            continue;
          }
        } else if (tM(a, c), c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === i)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === i)
            return;
          c = c.return, c.tag === x && (h = !1);
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }
    function r7(a, i, l) {
      iM(a, i);
      var c = i.alternate;
      nM(i), c !== null && nM(c);
    }
    function XP(a, i) {
      switch (i.tag) {
        case v:
        case V:
        case K:
        case ce:
        case nt: {
          Yz(vh | ph, i);
          return;
        }
        case y:
          return;
        case A: {
          var l = i.stateNode;
          if (l != null) {
            var c = i.memoizedProps, h = a !== null ? a.memoizedProps : c, b = i.type, S = i.updateQueue;
            i.updateQueue = null, S !== null && V6(l, S, b, h, c);
          }
          return;
        }
        case M: {
          if (i.stateNode === null)
            throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
          var E = i.stateNode, z = i.memoizedProps, G = a !== null ? a.memoizedProps : z;
          B6(E, G, z);
          return;
        }
        case P: {
          {
            var ee = i.stateNode;
            ee.hydrate && (ee.hydrate = !1, lj(ee.containerInfo));
          }
          return;
        }
        case X:
          return;
        case U: {
          a7(i), oM(i);
          return;
        }
        case _e: {
          oM(i);
          return;
        }
        case ye:
          return;
        case Le:
          break;
        case Ne:
          break;
        case Qe:
        case qe: {
          var we = i.memoizedState, ae = we !== null;
          eM(i, ae);
          return;
        }
      }
      throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function a7(a) {
      var i = a.memoizedState;
      if (i !== null) {
        k7();
        {
          var l = a.child;
          eM(l, !0);
        }
      }
    }
    function i7(a, i) {
      var l = i.memoizedState;
      if (l === null) {
        var c = i.alternate;
        if (c !== null) {
          var h = c.memoizedState;
          if (h !== null) {
            var b = h.dehydrated;
            b !== null && uj(b);
          }
        }
      }
    }
    function oM(a) {
      var i = a.updateQueue;
      if (i !== null) {
        a.updateQueue = null;
        var l = a.stateNode;
        l === null && (l = a.stateNode = new Vz()), i.forEach(function(c) {
          var h = V7.bind(null, a, c);
          l.has(c) || (c.__reactDoNotTraceInteractions !== !0 && (h = r.unstable_wrap(h)), l.add(c), c.then(h, h));
        });
      }
    }
    function o7(a, i) {
      if (a !== null) {
        var l = a.memoizedState;
        if (l === null || l.dehydrated !== null) {
          var c = i.memoizedState;
          return c !== null && c.dehydrated === null;
        }
      }
      return !1;
    }
    function s7(a) {
      t2(a.stateNode);
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var dv = Symbol.for;
      dv("selector.component"), dv("selector.has_pseudo_class"), dv("selector.role"), dv("selector.test_id"), dv("selector.text");
    }
    var l7 = [];
    function u7() {
      l7.forEach(function(a) {
        return a();
      });
    }
    var c7 = Math.ceil, qP = s.ReactCurrentDispatcher, YP = s.ReactCurrentOwner, GP = s.IsSomeRendererActing, sa = 0, Qy = 1, d7 = 2, QP = 4, KP = 8, as = 16, iu = 32, sM = 64, ic = 0, Ky = 1, Jy = 2, Zy = 3, eb = 4, JP = 5, It = sa, so = null, la = null, lo = Te, ou = Te, ZP = Kc(Te), Ei = ic, tb = null, Hf = Te, nb = Te, Vf = Te, rb = Te, ek = null, tk = 0, lM = 500, uM = 1 / 0, f7 = 500;
    function Ph() {
      uM = Hi() + f7;
    }
    function cM() {
      return uM;
    }
    var kt = null, ab = !1, nk = null, kh = null, oc = !1, $h = null, fv = E0, rk = Te, ak = [], ik = [], sc = null, m7 = 50, mv = 0, ok = null, h7 = 50, ib = 0, Bf = null, hv = St, lc = Te, ob = Te, sk = !1, pv = null, sb = !1;
    function p7() {
      return so;
    }
    function is() {
      return (It & (as | iu)) !== sa ? Hi() : (hv !== St || (hv = Hi()), hv);
    }
    function ad(a) {
      var i = a.mode;
      if ((i & Do) === Lr)
        return un;
      if ((i & Rf) === Lr)
        return ch() === Ws ? un : k;
      lc === Te && (lc = Hf);
      var l = Ij() !== Lj;
      if (l)
        return ob !== Te && (ob = ek !== null ? ek.pendingLanes : Te), _n(lc, ob);
      var c = ch(), h;
      if ((It & QP) !== sa && c === Of)
        h = mn(Bl, lc);
      else {
        var b = zr(c);
        h = mn(b, lc);
      }
      return h;
    }
    function v7(a) {
      var i = a.mode;
      return (i & Do) === Lr ? un : (i & Rf) === Lr ? ch() === Ws ? un : k : (lc === Te && (lc = Hf), Ci(lc));
    }
    function Bi(a, i, l) {
      U7(), G7(a);
      var c = lb(a, i);
      if (c === null)
        return q7(a), null;
      Bc(c, i, l), c === so && (Vf = bn(Vf, i), Ei === eb && Sh(c, lo));
      var h = ch();
      i === un ? (It & KP) !== sa && (It & (as | iu)) === sa ? (od(c, i), lk(c)) : (Is(c, l), od(c, i), It === sa && (Ph(), nu())) : ((It & QP) !== sa && (h === Of || h === Ws) && (sc === null ? sc = /* @__PURE__ */ new Set([c]) : sc.add(c)), Is(c, l), od(c, i)), ek = c;
    }
    function lb(a, i) {
      a.lanes = bn(a.lanes, i);
      var l = a.alternate;
      l !== null && (l.lanes = bn(l.lanes, i)), l === null && (a.flags & (Ht | Si)) !== zn && PM(a);
      for (var c = a, h = a.return; h !== null; )
        h.childLanes = bn(h.childLanes, i), l = h.alternate, l !== null ? l.childLanes = bn(l.childLanes, i) : (h.flags & (Ht | Si)) !== zn && PM(a), c = h, h = h.return;
      if (c.tag === P) {
        var b = c.stateNode;
        return b;
      } else
        return null;
    }
    function Is(a, i) {
      var l = a.callbackNode;
      on(a, i);
      var c = nn(a, a === so ? lo : Te), h = An();
      if (c === Te) {
        l !== null && (E2(l), a.callbackNode = null, a.callbackPriority = Ao);
        return;
      }
      if (l !== null) {
        var b = a.callbackPriority;
        if (b === h)
          return;
        E2(l);
      }
      var S;
      if (h === Zo)
        S = Wj(lk.bind(null, a));
      else if (h === Cs)
        S = Jc(Ws, lk.bind(null, a));
      else {
        var E = ka(h);
        S = Jc(E, dM.bind(null, a));
      }
      a.callbackPriority = h, a.callbackNode = S;
    }
    function dM(a) {
      if (hv = St, lc = Te, ob = Te, (It & (as | iu)) !== sa)
        throw Error("Should not already be working.");
      var i = a.callbackNode, l = su();
      if (l && a.callbackNode !== i)
        return null;
      var c = nn(a, a === so ? lo : Te);
      if (c === Te)
        return null;
      var h = E7(a, c);
      if (Tr(Hf, Vf))
        xh(a, Te);
      else if (h !== ic) {
        if (h === Jy && (It |= sM, a.hydrate && (a.hydrate = !1, b0(a.containerInfo)), c = Rt(a), c !== Te && (h = vv(a, c))), h === Ky) {
          var b = tb;
          throw xh(a, Te), Sh(a, c), Is(a, Hi()), b;
        }
        var S = a.current.alternate;
        a.finishedWork = S, a.finishedLanes = c, g7(a, h, c);
      }
      return Is(a, Hi()), a.callbackNode === i ? dM.bind(null, a) : null;
    }
    function g7(a, i, l) {
      switch (i) {
        case ic:
        case Ky:
          throw Error("Root did not complete. This is a bug in React.");
        case Jy: {
          Uf(a);
          break;
        }
        case Zy: {
          if (Sh(a, l), fn(l) && !Z7()) {
            var c = tk + lM - Hi();
            if (c > 10) {
              var h = nn(a, Te);
              if (h !== Te)
                break;
              var b = a.suspendedLanes;
              if (!ci(b, l)) {
                is(), mp(a, b);
                break;
              }
              a.timeoutHandle = e2(Uf.bind(null, a), c);
              break;
            }
          }
          Uf(a);
          break;
        }
        case eb: {
          if (Sh(a, l), xn(l))
            break;
          {
            var S = Xe(a, l), E = S, z = Hi() - E, G = B7(z) - z;
            if (G > 10) {
              a.timeoutHandle = e2(Uf.bind(null, a), G);
              break;
            }
          }
          Uf(a);
          break;
        }
        case JP: {
          Uf(a);
          break;
        }
        default:
          throw Error("Unknown root exit status.");
      }
    }
    function Sh(a, i) {
      i = _s(i, rb), i = _s(i, Vf), Pg(a, i);
    }
    function lk(a) {
      if ((It & (as | iu)) !== sa)
        throw Error("Should not already be working.");
      su();
      var i, l;
      if (a === so && Tr(a.expiredLanes, lo) ? (i = lo, l = vv(a, i), Tr(Hf, Vf) && (i = nn(a, i), l = vv(a, i))) : (i = nn(a, Te), l = vv(a, i)), a.tag !== x0 && l === Jy && (It |= sM, a.hydrate && (a.hydrate = !1, b0(a.containerInfo)), i = Rt(a), i !== Te && (l = vv(a, i))), l === Ky) {
        var c = tb;
        throw xh(a, Te), Sh(a, i), Is(a, Hi()), c;
      }
      var h = a.current.alternate;
      return a.finishedWork = h, a.finishedLanes = i, Uf(a), Is(a, Hi()), null;
    }
    function y7() {
      if ((It & (Qy | as | iu)) !== sa) {
        (It & as) !== sa && m("unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
        return;
      }
      b7(), su();
    }
    function b7() {
      if (sc !== null) {
        var a = sc;
        sc = null, a.forEach(function(i) {
          hf(i), Is(i, Hi());
        });
      }
      nu();
    }
    function fM(a, i) {
      var l = It;
      It |= Qy;
      try {
        return a(i);
      } finally {
        It = l, It === sa && (Ph(), nu());
      }
    }
    function w7(a, i) {
      var l = It;
      It |= d7;
      try {
        return a(i);
      } finally {
        It = l, It === sa && (Ph(), nu());
      }
    }
    function P7(a, i, l, c, h) {
      var b = It;
      It |= QP;
      try {
        return Tf(Of, a.bind(null, i, l, c, h));
      } finally {
        It = b, It === sa && (Ph(), nu());
      }
    }
    function mM(a, i) {
      var l = It;
      It &= ~Qy, It |= KP;
      try {
        return a(i);
      } finally {
        It = l, It === sa && (Ph(), nu());
      }
    }
    function uk(a, i) {
      var l = It;
      if ((l & (as | iu)) !== sa)
        return m("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), a(i);
      It |= Qy;
      try {
        return a ? Tf(Ws, a.bind(null, i)) : void 0;
      } finally {
        It = l, nu();
      }
    }
    function ub(a, i) {
      Fi(ZP, ou, a), ou = bn(ou, i), Hf = bn(Hf, i);
    }
    function ck(a) {
      ou = ZP.current, Ii(ZP, a);
    }
    function xh(a, i) {
      a.finishedWork = null, a.finishedLanes = Te;
      var l = a.timeoutHandle;
      if (l !== y0 && (a.timeoutHandle = y0, F6(l)), la !== null)
        for (var c = la.return; c !== null; )
          GC(c), c = c.return;
      so = a, la = Xf(a.current, null), lo = ou = Hf = i, Ei = ic, tb = null, nb = Te, Vf = Te, rb = Te, Bf = null, dl.discardPendingWarnings();
    }
    function hM(a, i) {
      do {
        var l = la;
        try {
          if (py(), sC(), yr(), YP.current = null, l === null || l.return === null) {
            Ei = Ky, tb = i, la = null;
            return;
          }
          ie && l.mode & rs && Xy(l, !0), Hz(a, l.return, l, i, lo), yM(l);
        } catch (c) {
          i = c, la === l && l !== null ? (l = l.return, la = l) : l = la;
          continue;
        }
        return;
      } while (!0);
    }
    function pM() {
      var a = qP.current;
      return qP.current = Vy, a === null ? Vy : a;
    }
    function vM(a) {
      qP.current = a;
    }
    function cb(a) {
      {
        var i = r.__interactionsRef.current;
        return r.__interactionsRef.current = a.memoizedInteractions, i;
      }
    }
    function db(a) {
      r.__interactionsRef.current = a;
    }
    function k7() {
      tk = Hi();
    }
    function dk(a) {
      nb = bn(a, nb);
    }
    function $7() {
      Ei === ic && (Ei = Zy);
    }
    function S7() {
      (Ei === ic || Ei === Zy) && (Ei = eb), so !== null && (Bn(nb) || Bn(Vf)) && Sh(so, lo);
    }
    function x7() {
      Ei !== JP && (Ei = Jy);
    }
    function C7() {
      return Ei === ic;
    }
    function vv(a, i) {
      var l = It;
      It |= as;
      var c = pM();
      (so !== a || lo !== i) && (xh(a, i), MM(a, i));
      var h = cb(a);
      do
        try {
          M7();
          break;
        } catch (b) {
          hM(a, b);
        }
      while (!0);
      if (py(), db(h), It = l, vM(c), la !== null)
        throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return so = null, lo = Te, Ei;
    }
    function M7() {
      for (; la !== null; )
        gM(la);
    }
    function E7(a, i) {
      var l = It;
      It |= as;
      var c = pM();
      (so !== a || lo !== i) && (Ph(), xh(a, i), MM(a, i));
      var h = cb(a);
      do
        try {
          A7();
          break;
        } catch (b) {
          hM(a, b);
        }
      while (!0);
      return py(), db(h), vM(c), It = l, la !== null ? ic : (so = null, lo = Te, Ei);
    }
    function A7() {
      for (; la !== null && !Dj(); )
        gM(la);
    }
    function gM(a) {
      var i = a.alternate;
      qn(a);
      var l;
      (a.mode & rs) !== Lr ? (EP(a), l = mk(i, a, ou), Xy(a, !0)) : l = mk(i, a, ou), yr(), a.memoizedProps = a.pendingProps, l === null ? yM(a) : la = l, YP.current = null;
    }
    function yM(a) {
      var i = a;
      do {
        var l = i.alternate, c = i.return;
        if ((i.flags & Nu) === zn) {
          qn(i);
          var h = void 0;
          if ((i.mode & rs) === Lr ? h = YC(l, i, ou) : (EP(i), h = YC(l, i, ou), Xy(i, !1)), yr(), h !== null) {
            la = h;
            return;
          }
          if (_7(i), c !== null && (c.flags & Nu) === zn) {
            c.firstEffect === null && (c.firstEffect = i.firstEffect), i.lastEffect !== null && (c.lastEffect !== null && (c.lastEffect.nextEffect = i.firstEffect), c.lastEffect = i.lastEffect);
            var b = i.flags;
            b > Ra && (c.lastEffect !== null ? c.lastEffect.nextEffect = i : c.firstEffect = i, c.lastEffect = i);
          }
        } else {
          var S = zz(i);
          if (S !== null) {
            S.flags &= el, la = S;
            return;
          }
          if ((i.mode & rs) !== Lr) {
            Xy(i, !1);
            for (var E = i.actualDuration, z = i.child; z !== null; )
              E += z.actualDuration, z = z.sibling;
            i.actualDuration = E;
          }
          c !== null && (c.firstEffect = c.lastEffect = null, c.flags |= Nu);
        }
        var G = i.sibling;
        if (G !== null) {
          la = G;
          return;
        }
        i = c, la = i;
      } while (i !== null);
      Ei === ic && (Ei = JP);
    }
    function _7(a) {
      if (!((a.tag === qe || a.tag === Qe) && a.memoizedState !== null && !Tr(ou, jt) && (a.mode & Rf) !== Te)) {
        var i = Te;
        if ((a.mode & rs) !== Lr) {
          for (var l = a.actualDuration, c = a.selfBaseDuration, h = a.alternate === null || a.child !== a.alternate.child, b = a.child; b !== null; )
            i = bn(i, bn(b.lanes, b.childLanes)), h && (l += b.actualDuration), c += b.treeBaseDuration, b = b.sibling;
          var S = a.tag === U && a.memoizedState !== null;
          if (S) {
            var E = a.child;
            E !== null && (c -= E.treeBaseDuration);
          }
          a.actualDuration = l, a.treeBaseDuration = c;
        } else
          for (var z = a.child; z !== null; )
            i = bn(i, bn(z.lanes, z.childLanes)), z = z.sibling;
        a.childLanes = i;
      }
    }
    function Uf(a) {
      var i = ch();
      return Tf(Ws, O7.bind(null, a, i)), null;
    }
    function O7(a, i) {
      do
        su();
      while ($h !== null);
      if (X7(), (It & (as | iu)) !== sa)
        throw Error("Should not already be working.");
      var l = a.finishedWork, c = a.finishedLanes;
      if (l === null)
        return null;
      if (a.finishedWork = null, a.finishedLanes = Te, l === a.current)
        throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      a.callbackNode = null;
      var h = bn(l.lanes, l.childLanes);
      hp(a, h), sc !== null && !Qw(h) && sc.has(a) && sc.delete(a), a === so && (so = null, la = null, lo = Te);
      var b;
      if (l.flags > Ra ? l.lastEffect !== null ? (l.lastEffect.nextEffect = l, b = l.firstEffect) : b = l : b = l.firstEffect, b !== null) {
        var S = It;
        It |= iu;
        var E = cb(a);
        YP.current = null, pv = D6(a.containerInfo), sb = !1, kt = b;
        do
          if (Ta(null, T7, null), si()) {
            if (kt === null)
              throw Error("Should be working on an effect.");
            var z = Ya();
            id(kt, z), kt = kt.nextEffect;
          }
        while (kt !== null);
        pv = null, $C(), kt = b;
        do
          if (Ta(null, R7, null, a, i), si()) {
            if (kt === null)
              throw Error("Should be working on an effect.");
            var G = Ya();
            id(kt, G), kt = kt.nextEffect;
          }
        while (kt !== null);
        N6(a.containerInfo), a.current = l, kt = b;
        do
          if (Ta(null, D7, null, a, c), si()) {
            if (kt === null)
              throw Error("Should be working on an effect.");
            var ee = Ya();
            id(kt, ee), kt = kt.nextEffect;
          }
        while (kt !== null);
        kt = null, Nj(), db(E), It = S;
      } else
        a.current = l, $C();
      var we = oc;
      if (oc)
        oc = !1, $h = a, rk = c, fv = i;
      else
        for (kt = b; kt !== null; ) {
          var ae = kt.nextEffect;
          kt.nextEffect = null, kt.flags & er && AM(kt), kt = ae;
        }
      if (h = a.pendingLanes, h !== Te) {
        if (Bf !== null) {
          var ke = Bf;
          Bf = null;
          for (var ze = 0; ze < ke.length; ze++)
            CM(a, ke[ze], a.memoizedInteractions);
        }
        od(a, h);
      } else
        kh = null;
      if (we || EM(a, c), h === un ? a === ok ? mv++ : (mv = 0, ok = a) : mv = 0, Aj(l.stateNode, i), u7(), Is(a, Hi()), ab) {
        ab = !1;
        var rt = nk;
        throw nk = null, rt;
      }
      return (It & KP) !== sa || nu(), null;
    }
    function T7() {
      for (; kt !== null; ) {
        var a = kt.alternate;
        !sb && pv !== null && ((kt.flags & er) !== zn ? Lc(kt, pv) && (sb = !0) : kt.tag === U && o7(a, kt) && Lc(kt, pv) && (sb = !0));
        var i = kt.flags;
        (i & Zi) !== zn && (qn(kt), qz(a, kt), yr()), (i & eo) !== zn && (oc || (oc = !0, Jc(nc, function() {
          return su(), null;
        }))), kt = kt.nextEffect;
      }
    }
    function R7(a, i) {
      for (; kt !== null; ) {
        qn(kt);
        var l = kt.flags;
        if (l & kr && s7(kt), l & ya) {
          var c = kt.alternate;
          c !== null && Zz(c);
        }
        var h = l & (Ht | Lt | er | Si);
        switch (h) {
          case Ht: {
            aM(kt), kt.flags &= ~Ht;
            break;
          }
          case ws: {
            aM(kt), kt.flags &= ~Ht;
            var b = kt.alternate;
            XP(b, kt);
            break;
          }
          case Si: {
            kt.flags &= ~Si;
            break;
          }
          case jm: {
            kt.flags &= ~Si;
            var S = kt.alternate;
            XP(S, kt);
            break;
          }
          case Lt: {
            var E = kt.alternate;
            XP(E, kt);
            break;
          }
          case er: {
            r7(a, kt);
            break;
          }
        }
        yr(), kt = kt.nextEffect;
      }
    }
    function D7(a, i) {
      for (; kt !== null; ) {
        qn(kt);
        var l = kt.flags;
        if (l & (Lt | Ps)) {
          var c = kt.alternate;
          Kz(a, c, kt);
        }
        l & ya && Jz(kt), yr(), kt = kt.nextEffect;
      }
    }
    function su() {
      if (fv !== E0) {
        var a = fv > nc ? nc : fv;
        return fv = E0, Tf(a, j7);
      }
      return !1;
    }
    function N7(a, i) {
      ak.push(i, a), oc || (oc = !0, Jc(nc, function() {
        return su(), null;
      }));
    }
    function bM(a, i) {
      ik.push(i, a);
      {
        a.flags |= Dl;
        var l = a.alternate;
        l !== null && (l.flags |= Dl);
      }
      oc || (oc = !0, Jc(nc, function() {
        return su(), null;
      }));
    }
    function W7(a) {
      var i = a.create;
      a.destroy = i();
    }
    function j7() {
      if ($h === null)
        return !1;
      var a = $h, i = rk;
      if ($h = null, rk = Te, (It & (as | iu)) !== sa)
        throw Error("Cannot flush passive effects while already rendering.");
      sk = !0;
      var l = It;
      It |= iu;
      var c = cb(a), h = ik;
      ik = [];
      for (var b = 0; b < h.length; b += 2) {
        var S = h[b], E = h[b + 1], z = S.destroy;
        S.destroy = void 0;
        {
          E.flags &= ~Dl;
          var G = E.alternate;
          G !== null && (G.flags &= ~Dl);
        }
        if (typeof z == "function") {
          if (qn(E), Ta(null, z, null), si()) {
            if (E === null)
              throw Error("Should be working on an effect.");
            var ee = Ya();
            id(E, ee);
          }
          yr();
        }
      }
      var we = ak;
      ak = [];
      for (var ae = 0; ae < we.length; ae += 2) {
        var ke = we[ae], ze = we[ae + 1];
        {
          if (qn(ze), Ta(null, W7, null, ke), si()) {
            if (ze === null)
              throw Error("Should be working on an effect.");
            var rt = Ya();
            id(ze, rt);
          }
          yr();
        }
      }
      for (var Dt = a.current.firstEffect; Dt !== null; ) {
        var rn = Dt.nextEffect;
        Dt.nextEffect = null, Dt.flags & er && AM(Dt), Dt = rn;
      }
      return db(c), EM(a, i), sk = !1, It = l, nu(), ib = $h === null ? 0 : ib + 1, !0;
    }
    function fk(a) {
      return kh !== null && kh.has(a);
    }
    function z7(a) {
      kh === null ? kh = /* @__PURE__ */ new Set([a]) : kh.add(a);
    }
    function L7(a) {
      ab || (ab = !0, nk = a);
    }
    var I7 = L7;
    function wM(a, i, l) {
      var c = HP(l, i), h = QC(a, c, un);
      ed(a, h);
      var b = is(), S = lb(a, un);
      S !== null && (Bc(S, un, b), Is(S, b), od(S, un));
    }
    function id(a, i) {
      if (a.tag === P) {
        wM(a, a, i);
        return;
      }
      for (var l = a.return; l !== null; ) {
        if (l.tag === P) {
          wM(l, a, i);
          return;
        } else if (l.tag === y) {
          var c = l.type, h = l.stateNode;
          if (typeof c.getDerivedStateFromError == "function" || typeof h.componentDidCatch == "function" && !fk(h)) {
            var b = HP(i, a), S = KC(l, b, un);
            ed(l, S);
            var E = is(), z = lb(l, un);
            if (z !== null)
              Bc(z, un, E), Is(z, E), od(z, un);
            else if (typeof h.componentDidCatch == "function" && !fk(h))
              try {
                h.componentDidCatch(i, b);
              } catch {
              }
            return;
          }
        }
        l = l.return;
      }
    }
    function F7(a, i, l) {
      var c = a.pingCache;
      c !== null && c.delete(i);
      var h = is();
      mp(a, l), so === a && ci(lo, l) && (Ei === eb || Ei === Zy && fn(lo) && Hi() - tk < lM ? xh(a, Te) : rb = bn(rb, l)), Is(a, h), od(a, l);
    }
    function H7(a, i) {
      i === ln && (i = v7(a));
      var l = is(), c = lb(a, i);
      c !== null && (Bc(c, i, l), Is(c, l), od(c, i));
    }
    function V7(a, i) {
      var l = ln, c;
      c = a.stateNode, c !== null && c.delete(i), H7(a, l);
    }
    function B7(a) {
      return a < 120 ? 120 : a < 480 ? 480 : a < 1080 ? 1080 : a < 1920 ? 1920 : a < 3e3 ? 3e3 : a < 4320 ? 4320 : c7(a / 1960) * 1960;
    }
    function U7() {
      if (mv > m7)
        throw mv = 0, ok = null, Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      ib > h7 && (ib = 0, m("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function X7() {
      dl.flushLegacyContextWarning(), dl.flushPendingUnsafeLifecycleWarnings();
    }
    var fb = null;
    function PM(a) {
      {
        if ((It & as) !== sa || !(a.mode & (Do | Rf)))
          return;
        var i = a.tag;
        if (i !== w && i !== P && i !== y && i !== v && i !== V && i !== K && i !== ce && i !== nt)
          return;
        var l = Je(a.type) || "ReactComponent";
        if (fb !== null) {
          if (fb.has(l))
            return;
          fb.add(l);
        } else
          fb = /* @__PURE__ */ new Set([l]);
        var c = _r;
        try {
          qn(a), m("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          c ? qn(a) : yr();
        }
      }
    }
    var mb = null;
    function q7(a) {
      {
        var i = a.tag;
        if (i !== P && i !== y && i !== v && i !== V && i !== K && i !== ce && i !== nt || (a.flags & Dl) !== zn)
          return;
        var l = Je(a.type) || "ReactComponent";
        if (mb !== null) {
          if (mb.has(l))
            return;
          mb.add(l);
        } else
          mb = /* @__PURE__ */ new Set([l]);
        if (!sk) {
          var c = _r;
          try {
            qn(a), m("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.", i === y ? "the componentWillUnmount method" : "a useEffect cleanup function");
          } finally {
            c ? qn(a) : yr();
          }
        }
      }
    }
    var mk;
    {
      var Y7 = null;
      mk = function(a, i, l) {
        var c = RM(Y7, i);
        try {
          return VC(a, i, l);
        } catch (b) {
          if (b !== null && typeof b == "object" && typeof b.then == "function")
            throw b;
          if (py(), sC(), GC(i), RM(i, c), i.mode & rs && EP(i), Ta(null, VC, null, a, i, l), si()) {
            var h = Ya();
            throw h;
          } else
            throw b;
        }
      };
    }
    var kM = !1, hk;
    hk = /* @__PURE__ */ new Set();
    function G7(a) {
      if (ai && (It & as) !== sa && !hz())
        switch (a.tag) {
          case v:
          case V:
          case ce: {
            var i = la && Je(la.type) || "Unknown", l = i;
            if (!hk.has(l)) {
              hk.add(l);
              var c = Je(a.type) || "Unknown";
              m("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", c, i, i);
            }
            break;
          }
          case y: {
            kM || (m("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), kM = !0);
            break;
          }
        }
    }
    var hb = {
      current: !1
    };
    function $M(a) {
      if (GP.current === !0 && hb.current !== !0) {
        var i = _r;
        try {
          qn(a), m(`It looks like you're using the wrong act() around your test interactions.
Be sure to use the matching version of act() corresponding to your renderer:

// for react-dom:
import {act} from 'react-dom/test-utils';
// ...
act(() => ...);

// for react-test-renderer:
import TestRenderer from react-test-renderer';
const {act} = TestRenderer;
// ...
act(() => ...);`);
        } finally {
          i ? qn(a) : yr();
        }
      }
    }
    function SM(a) {
      (a.mode & oa) !== Lr && GP.current === !1 && hb.current === !1 && m(`An update to %s ran an effect, but was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Je(a.type));
    }
    function Q7(a) {
      if (It === sa && GP.current === !1 && hb.current === !1) {
        var i = _r;
        try {
          qn(a), m(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Je(a.type));
        } finally {
          i ? qn(a) : yr();
        }
      }
    }
    var K7 = Q7, xM = !1;
    function J7(a) {
      xM === !1 && n.unstable_flushAllWithoutAsserting === void 0 && (a.mode & Do || a.mode & Rf) && (xM = !0, m(`In Concurrent or Sync modes, the "scheduler" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: 
jest.mock('scheduler', () => require('scheduler/unstable_mock'));

For more info, visit https://reactjs.org/link/mock-scheduler`));
    }
    function pk(a, i) {
      return i * 1e3 + a.interactionThreadID;
    }
    function pb(a) {
      Bf === null ? Bf = [a] : Bf.push(a);
    }
    function CM(a, i, l) {
      if (l.size > 0) {
        var c = a.pendingInteractionMap, h = c.get(i);
        h != null ? l.forEach(function(E) {
          h.has(E) || E.__count++, h.add(E);
        }) : (c.set(i, new Set(l)), l.forEach(function(E) {
          E.__count++;
        }));
        var b = r.__subscriberRef.current;
        if (b !== null) {
          var S = pk(a, i);
          b.onWorkScheduled(l, S);
        }
      }
    }
    function od(a, i) {
      CM(a, i, r.__interactionsRef.current);
    }
    function MM(a, i) {
      var l = /* @__PURE__ */ new Set();
      if (a.pendingInteractionMap.forEach(function(b, S) {
        Tr(i, S) && b.forEach(function(E) {
          return l.add(E);
        });
      }), a.memoizedInteractions = l, l.size > 0) {
        var c = r.__subscriberRef.current;
        if (c !== null) {
          var h = pk(a, i);
          try {
            c.onWorkStarted(l, h);
          } catch (b) {
            Jc(Ws, function() {
              throw b;
            });
          }
        }
      }
    }
    function EM(a, i) {
      var l = a.pendingLanes, c;
      try {
        if (c = r.__subscriberRef.current, c !== null && a.memoizedInteractions.size > 0) {
          var h = pk(a, i);
          c.onWorkStopped(a.memoizedInteractions, h);
        }
      } catch (S) {
        Jc(Ws, function() {
          throw S;
        });
      } finally {
        var b = a.pendingInteractionMap;
        b.forEach(function(S, E) {
          Tr(l, E) || (b.delete(E), S.forEach(function(z) {
            if (z.__count--, c !== null && z.__count === 0)
              try {
                c.onInteractionScheduledWorkCompleted(z);
              } catch (G) {
                Jc(Ws, function() {
                  throw G;
                });
              }
          }));
        });
      }
    }
    function Z7() {
      return e8 > 0;
    }
    var e8 = 0;
    function AM(a) {
      a.sibling = null, a.stateNode = null;
    }
    var Fs = null, Ch = null, t8 = function(a) {
      Fs = a;
    };
    function Mh(a) {
      {
        if (Fs === null)
          return a;
        var i = Fs(a);
        return i === void 0 ? a : i.current;
      }
    }
    function vk(a) {
      return Mh(a);
    }
    function gk(a) {
      {
        if (Fs === null)
          return a;
        var i = Fs(a);
        if (i === void 0) {
          if (a != null && typeof a.render == "function") {
            var l = Mh(a.render);
            if (a.render !== l) {
              var c = {
                $$typeof: Ha,
                render: l
              };
              return a.displayName !== void 0 && (c.displayName = a.displayName), c;
            }
          }
          return a;
        }
        return i.current;
      }
    }
    function _M(a, i) {
      {
        if (Fs === null)
          return !1;
        var l = a.elementType, c = i.type, h = !1, b = typeof c == "object" && c !== null ? c.$$typeof : null;
        switch (a.tag) {
          case y: {
            typeof c == "function" && (h = !0);
            break;
          }
          case v: {
            (typeof c == "function" || b === Jn) && (h = !0);
            break;
          }
          case V: {
            (b === Ha || b === Jn) && (h = !0);
            break;
          }
          case K:
          case ce: {
            (b === Ka || b === Jn) && (h = !0);
            break;
          }
          default:
            return !1;
        }
        if (h) {
          var S = Fs(l);
          if (S !== void 0 && S === Fs(c))
            return !0;
        }
        return !1;
      }
    }
    function OM(a) {
      {
        if (Fs === null || typeof WeakSet != "function")
          return;
        Ch === null && (Ch = /* @__PURE__ */ new WeakSet()), Ch.add(a);
      }
    }
    var n8 = function(a, i) {
      {
        if (Fs === null)
          return;
        var l = i.staleFamilies, c = i.updatedFamilies;
        su(), uk(function() {
          yk(a.current, c, l);
        });
      }
    }, r8 = function(a, i) {
      {
        if (a.context !== ns)
          return;
        su(), uk(function() {
          gv(i, a, null, null);
        });
      }
    };
    function yk(a, i, l) {
      {
        var c = a.alternate, h = a.child, b = a.sibling, S = a.tag, E = a.type, z = null;
        switch (S) {
          case v:
          case ce:
          case y:
            z = E;
            break;
          case V:
            z = E.render;
            break;
        }
        if (Fs === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var G = !1, ee = !1;
        if (z !== null) {
          var we = Fs(z);
          we !== void 0 && (l.has(we) ? ee = !0 : i.has(we) && (S === y ? ee = !0 : G = !0));
        }
        Ch !== null && (Ch.has(a) || c !== null && Ch.has(c)) && (ee = !0), ee && (a._debugNeedsRemount = !0), (ee || G) && Bi(a, un, St), h !== null && !ee && yk(h, i, l), b !== null && yk(b, i, l);
      }
    }
    var a8 = function(a, i) {
      {
        var l = /* @__PURE__ */ new Set(), c = new Set(i.map(function(h) {
          return h.current;
        }));
        return bk(a.current, c, l), l;
      }
    };
    function bk(a, i, l) {
      {
        var c = a.child, h = a.sibling, b = a.tag, S = a.type, E = null;
        switch (b) {
          case v:
          case ce:
          case y:
            E = S;
            break;
          case V:
            E = S.render;
            break;
        }
        var z = !1;
        E !== null && i.has(E) && (z = !0), z ? i8(a, l) : c !== null && bk(c, i, l), h !== null && bk(h, i, l);
      }
    }
    function i8(a, i) {
      {
        var l = o8(a, i);
        if (l)
          return;
        for (var c = a; ; ) {
          switch (c.tag) {
            case A:
              i.add(c.stateNode);
              return;
            case x:
              i.add(c.stateNode.containerInfo);
              return;
            case P:
              i.add(c.stateNode.containerInfo);
              return;
          }
          if (c.return === null)
            throw new Error("Expected to reach root first.");
          c = c.return;
        }
      }
    }
    function o8(a, i) {
      for (var l = a, c = !1; ; ) {
        if (l.tag === A)
          c = !0, i.add(l.stateNode);
        else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === a)
          return c;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === a)
            return c;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return !1;
    }
    var wk;
    {
      wk = !1;
      try {
        var TM = Object.preventExtensions({});
      } catch {
        wk = !0;
      }
    }
    var s8 = 1;
    function l8(a, i, l, c) {
      this.tag = a, this.key = l, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = i, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = c, this.flags = zn, this.nextEffect = null, this.firstEffect = null, this.lastEffect = null, this.lanes = Te, this.childLanes = Te, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugID = s8++, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !wk && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var os = function(a, i, l, c) {
      return new l8(a, i, l, c);
    };
    function Pk(a) {
      var i = a.prototype;
      return !!(i && i.isReactComponent);
    }
    function u8(a) {
      return typeof a == "function" && !Pk(a) && a.defaultProps === void 0;
    }
    function c8(a) {
      if (typeof a == "function")
        return Pk(a) ? y : v;
      if (a != null) {
        var i = a.$$typeof;
        if (i === Ha)
          return V;
        if (i === Ka)
          return K;
      }
      return w;
    }
    function Xf(a, i) {
      var l = a.alternate;
      l === null ? (l = os(a.tag, i, a.key, a.mode), l.elementType = a.elementType, l.type = a.type, l.stateNode = a.stateNode, l._debugID = a._debugID, l._debugSource = a._debugSource, l._debugOwner = a._debugOwner, l._debugHookTypes = a._debugHookTypes, l.alternate = a, a.alternate = l) : (l.pendingProps = i, l.type = a.type, l.flags = zn, l.nextEffect = null, l.firstEffect = null, l.lastEffect = null, l.actualDuration = 0, l.actualStartTime = -1), l.childLanes = a.childLanes, l.lanes = a.lanes, l.child = a.child, l.memoizedProps = a.memoizedProps, l.memoizedState = a.memoizedState, l.updateQueue = a.updateQueue;
      var c = a.dependencies;
      switch (l.dependencies = c === null ? null : {
        lanes: c.lanes,
        firstContext: c.firstContext
      }, l.sibling = a.sibling, l.index = a.index, l.ref = a.ref, l.selfBaseDuration = a.selfBaseDuration, l.treeBaseDuration = a.treeBaseDuration, l._debugNeedsRemount = a._debugNeedsRemount, l.tag) {
        case w:
        case v:
        case ce:
          l.type = Mh(a.type);
          break;
        case y:
          l.type = vk(a.type);
          break;
        case V:
          l.type = gk(a.type);
          break;
      }
      return l;
    }
    function d8(a, i) {
      a.flags &= Ht, a.nextEffect = null, a.firstEffect = null, a.lastEffect = null;
      var l = a.alternate;
      if (l === null)
        a.childLanes = Te, a.lanes = i, a.child = null, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.stateNode = null, a.selfBaseDuration = 0, a.treeBaseDuration = 0;
      else {
        a.childLanes = l.childLanes, a.lanes = l.lanes, a.child = l.child, a.memoizedProps = l.memoizedProps, a.memoizedState = l.memoizedState, a.updateQueue = l.updateQueue, a.type = l.type;
        var c = l.dependencies;
        a.dependencies = c === null ? null : {
          lanes: c.lanes,
          firstContext: c.firstContext
        }, a.selfBaseDuration = l.selfBaseDuration, a.treeBaseDuration = l.treeBaseDuration;
      }
      return a;
    }
    function f8(a) {
      var i;
      return a === v2 ? i = Rf | Do | oa : a === p2 ? i = Do | oa : i = Lr, Cj && (i |= rs), os(P, null, null, i);
    }
    function kk(a, i, l, c, h, b) {
      var S = w, E = a;
      if (typeof a == "function")
        Pk(a) ? (S = y, E = vk(E)) : E = Mh(E);
      else if (typeof a == "string")
        S = A;
      else {
        e:
          switch (a) {
            case Vr:
              return qf(l.children, h, b, i);
            case Yi:
              S = j, h |= jj;
              break;
            case pi:
              S = j, h |= oa;
              break;
            case Ar:
              return m8(l, h, b, i);
            case ma:
              return h8(l, h, b, i);
            case Kr:
              return p8(l, h, b, i);
            case Gi:
              return Sk(l, h, b, i);
            case Ma:
              return v8(l, h, b, i);
            case yo:
            default: {
              if (typeof a == "object" && a !== null)
                switch (a.$$typeof) {
                  case Oi:
                    S = J;
                    break e;
                  case Qr:
                    S = H;
                    break e;
                  case Ha:
                    S = V, E = gk(E);
                    break e;
                  case Ka:
                    S = K;
                    break e;
                  case Jn:
                    S = ue, E = null;
                    break e;
                  case or:
                    S = nt;
                    break e;
                }
              var z = "";
              {
                (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var G = c ? Je(c.type) : null;
                G && (z += `

Check the render method of \`` + G + "`.");
              }
              throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (a == null ? a : typeof a) + "." + z);
            }
          }
      }
      var ee = os(S, l, i, h);
      return ee.elementType = a, ee.type = E, ee.lanes = b, ee._debugOwner = c, ee;
    }
    function $k(a, i, l) {
      var c = null;
      c = a._owner;
      var h = a.type, b = a.key, S = a.props, E = kk(h, b, S, c, i, l);
      return E._debugSource = a._source, E._debugOwner = a._owner, E;
    }
    function qf(a, i, l, c) {
      var h = os(O, a, c, i);
      return h.lanes = l, h;
    }
    function m8(a, i, l, c) {
      typeof a.id != "string" && m('Profiler must specify an "id" as a prop');
      var h = os(X, a, c, i | rs);
      return h.elementType = Ar, h.type = Ar, h.lanes = l, h.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, h;
    }
    function h8(a, i, l, c) {
      var h = os(U, a, c, i);
      return h.type = ma, h.elementType = ma, h.lanes = l, h;
    }
    function p8(a, i, l, c) {
      var h = os(_e, a, c, i);
      return h.type = Kr, h.elementType = Kr, h.lanes = l, h;
    }
    function Sk(a, i, l, c) {
      var h = os(Qe, a, c, i);
      return h.type = Gi, h.elementType = Gi, h.lanes = l, h;
    }
    function v8(a, i, l, c) {
      var h = os(qe, a, c, i);
      return h.type = Ma, h.elementType = Ma, h.lanes = l, h;
    }
    function xk(a, i, l) {
      var c = os(M, a, null, i);
      return c.lanes = l, c;
    }
    function g8() {
      var a = os(A, null, null, Lr);
      return a.elementType = "DELETED", a.type = "DELETED", a;
    }
    function Ck(a, i, l) {
      var c = a.children !== null ? a.children : [], h = os(x, c, a.key, i);
      return h.lanes = l, h.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
      }, h;
    }
    function RM(a, i) {
      return a === null && (a = os(w, null, null, Lr)), a.tag = i.tag, a.key = i.key, a.elementType = i.elementType, a.type = i.type, a.stateNode = i.stateNode, a.return = i.return, a.child = i.child, a.sibling = i.sibling, a.index = i.index, a.ref = i.ref, a.pendingProps = i.pendingProps, a.memoizedProps = i.memoizedProps, a.updateQueue = i.updateQueue, a.memoizedState = i.memoizedState, a.dependencies = i.dependencies, a.mode = i.mode, a.flags = i.flags, a.nextEffect = i.nextEffect, a.firstEffect = i.firstEffect, a.lastEffect = i.lastEffect, a.lanes = i.lanes, a.childLanes = i.childLanes, a.alternate = i.alternate, a.actualDuration = i.actualDuration, a.actualStartTime = i.actualStartTime, a.selfBaseDuration = i.selfBaseDuration, a.treeBaseDuration = i.treeBaseDuration, a._debugID = i._debugID, a._debugSource = i._debugSource, a._debugOwner = i._debugOwner, a._debugNeedsRemount = i._debugNeedsRemount, a._debugHookTypes = i._debugHookTypes, a;
    }
    function y8(a, i, l) {
      switch (this.tag = i, this.containerInfo = a, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = y0, this.context = null, this.pendingContext = null, this.hydrate = l, this.callbackNode = null, this.callbackPriority = Ao, this.eventTimes = Hm(Te), this.expirationTimes = Hm(St), this.pendingLanes = Te, this.suspendedLanes = Te, this.pingedLanes = Te, this.expiredLanes = Te, this.mutableReadLanes = Te, this.finishedLanes = Te, this.entangledLanes = Te, this.entanglements = Hm(Te), this.mutableSourceEagerHydrationData = null, this.interactionThreadID = r.unstable_getThreadID(), this.memoizedInteractions = /* @__PURE__ */ new Set(), this.pendingInteractionMap = /* @__PURE__ */ new Map(), i) {
        case p2:
          this._debugRootType = "createBlockingRoot()";
          break;
        case v2:
          this._debugRootType = "createRoot()";
          break;
        case x0:
          this._debugRootType = "createLegacyRoot()";
          break;
      }
    }
    function b8(a, i, l, c) {
      var h = new y8(a, i, l), b = f8(i);
      return h.current = b, b.stateNode = h, N0(b), h;
    }
    function w8(a, i) {
      var l = i._getVersion, c = l(i._source);
      a.mutableSourceEagerHydrationData == null ? a.mutableSourceEagerHydrationData = [i, c] : a.mutableSourceEagerHydrationData.push(i, c);
    }
    function P8(a, i, l) {
      var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return {
        $$typeof: Pn,
        key: c == null ? null : "" + c,
        children: a,
        containerInfo: i,
        implementation: l
      };
    }
    var Mk, Ek;
    Mk = !1, Ek = {};
    function k8(a) {
      if (!a)
        return ns;
      var i = xo(a), l = xj(i);
      if (i.tag === y) {
        var c = i.type;
        if (eu(c))
          return m2(i, c, l);
      }
      return l;
    }
    function $8(a, i) {
      {
        var l = xo(a);
        if (l === void 0)
          throw typeof a.render == "function" ? Error("Unable to find node on an unmounted component.") : Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(a));
        var c = ju(l);
        if (c === null)
          return null;
        if (c.mode & oa) {
          var h = Je(l.type) || "Component";
          if (!Ek[h]) {
            Ek[h] = !0;
            var b = _r;
            try {
              qn(c), l.mode & oa ? m("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", i, i, h) : m("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", i, i, h);
            } finally {
              b ? qn(b) : yr();
            }
          }
        }
        return c.stateNode;
      }
    }
    function S8(a, i, l, c) {
      return b8(a, i, l);
    }
    function gv(a, i, l, c) {
      Ej(i, a);
      var h = i.current, b = is();
      typeof jest < "u" && (J7(h), $M(h));
      var S = ad(h), E = k8(l);
      i.context === null ? i.context = E : i.pendingContext = E, ai && _r !== null && !Mk && (Mk = !0, m(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Je(_r.type) || "Unknown"));
      var z = Zc(b, S);
      return z.payload = {
        element: a
      }, c = c === void 0 ? null : c, c !== null && (typeof c != "function" && m("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", c), z.callback = c), ed(h, z), Bi(h, S, b), S;
    }
    function Ak(a) {
      var i = a.current;
      if (!i.child)
        return null;
      switch (i.child.tag) {
        case A:
          return i.child.stateNode;
        default:
          return i.child.stateNode;
      }
    }
    function DM(a, i) {
      var l = a.memoizedState;
      l !== null && l.dehydrated !== null && (l.retryLane = sl(l.retryLane, i));
    }
    function _k(a, i) {
      DM(a, i);
      var l = a.alternate;
      l && DM(l, i);
    }
    function x8(a) {
      if (a.tag === U) {
        var i = is(), l = C;
        Bi(a, l, i), _k(a, l);
      }
    }
    function C8(a) {
      if (a.tag === U) {
        var i = is(), l = it;
        Bi(a, l, i), _k(a, l);
      }
    }
    function M8(a) {
      if (a.tag === U) {
        var i = is(), l = ad(a);
        Bi(a, l, i), _k(a, l);
      }
    }
    function E8(a, i) {
      try {
        return i();
      } finally {
      }
    }
    function NM(a) {
      var i = rf(a);
      return i === null ? null : i.tag === Le ? i.stateNode.instance : i.stateNode;
    }
    var WM = function(a) {
      return !1;
    };
    function A8(a) {
      return WM(a);
    }
    var jM = null, zM = null, LM = null, IM = null, FM = null, HM = null, VM = null, BM = null;
    {
      var UM = function(a, i, l) {
        var c = i[l], h = Array.isArray(a) ? a.slice() : t({}, a);
        return l + 1 === i.length ? (Array.isArray(h) ? h.splice(c, 1) : delete h[c], h) : (h[c] = UM(a[c], i, l + 1), h);
      }, XM = function(a, i) {
        return UM(a, i, 0);
      }, qM = function(a, i, l, c) {
        var h = i[c], b = Array.isArray(a) ? a.slice() : t({}, a);
        if (c + 1 === i.length) {
          var S = l[c];
          b[S] = b[h], Array.isArray(b) ? b.splice(h, 1) : delete b[h];
        } else
          b[h] = qM(
            a[h],
            i,
            l,
            c + 1
          );
        return b;
      }, YM = function(a, i, l) {
        if (i.length !== l.length) {
          f("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var c = 0; c < l.length - 1; c++)
            if (i[c] !== l[c]) {
              f("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return qM(a, i, l, 0);
      }, GM = function(a, i, l, c) {
        if (l >= i.length)
          return c;
        var h = i[l], b = Array.isArray(a) ? a.slice() : t({}, a);
        return b[h] = GM(a[h], i, l + 1, c), b;
      }, QM = function(a, i, l) {
        return GM(a, i, 0, l);
      }, Ok = function(a, i) {
        for (var l = a.memoizedState; l !== null && i > 0; )
          l = l.next, i--;
        return l;
      };
      jM = function(a, i, l, c) {
        var h = Ok(a, i);
        if (h !== null) {
          var b = QM(h.memoizedState, l, c);
          h.memoizedState = b, h.baseState = b, a.memoizedProps = t({}, a.memoizedProps), Bi(a, un, St);
        }
      }, zM = function(a, i, l) {
        var c = Ok(a, i);
        if (c !== null) {
          var h = XM(c.memoizedState, l);
          c.memoizedState = h, c.baseState = h, a.memoizedProps = t({}, a.memoizedProps), Bi(a, un, St);
        }
      }, LM = function(a, i, l, c) {
        var h = Ok(a, i);
        if (h !== null) {
          var b = YM(h.memoizedState, l, c);
          h.memoizedState = b, h.baseState = b, a.memoizedProps = t({}, a.memoizedProps), Bi(a, un, St);
        }
      }, IM = function(a, i, l) {
        a.pendingProps = QM(a.memoizedProps, i, l), a.alternate && (a.alternate.pendingProps = a.pendingProps), Bi(a, un, St);
      }, FM = function(a, i) {
        a.pendingProps = XM(a.memoizedProps, i), a.alternate && (a.alternate.pendingProps = a.pendingProps), Bi(a, un, St);
      }, HM = function(a, i, l) {
        a.pendingProps = YM(a.memoizedProps, i, l), a.alternate && (a.alternate.pendingProps = a.pendingProps), Bi(a, un, St);
      }, VM = function(a) {
        Bi(a, un, St);
      }, BM = function(a) {
        WM = a;
      };
    }
    function _8(a) {
      var i = ju(a);
      return i === null ? null : i.stateNode;
    }
    function O8(a) {
      return null;
    }
    function T8() {
      return _r;
    }
    function R8(a) {
      var i = a.findFiberByHostInstance, l = s.ReactCurrentDispatcher;
      return Mj({
        bundleType: a.bundleType,
        version: a.version,
        rendererPackageName: a.rendererPackageName,
        rendererConfig: a.rendererConfig,
        overrideHookState: jM,
        overrideHookStateDeletePath: zM,
        overrideHookStateRenamePath: LM,
        overrideProps: IM,
        overridePropsDeletePath: FM,
        overridePropsRenamePath: HM,
        setSuspenseHandler: BM,
        scheduleUpdate: VM,
        currentDispatcherRef: l,
        findHostInstanceByFiber: _8,
        findFiberByHostInstance: i || O8,
        findHostInstancesForRefresh: a8,
        scheduleRefresh: n8,
        scheduleRoot: r8,
        setRefreshHandler: t8,
        getCurrentFiber: T8
      });
    }
    function Tk(a, i, l) {
      this._internalRoot = D8(a, i, l);
    }
    Tk.prototype.render = function(a) {
      var i = this._internalRoot;
      {
        typeof arguments[1] == "function" && m("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var l = i.containerInfo;
        if (l.nodeType !== Oa) {
          var c = NM(i.current);
          c && c.parentNode !== l && m("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      gv(a, i, null, null);
    }, Tk.prototype.unmount = function() {
      typeof arguments[0] == "function" && m("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var a = this._internalRoot, i = a.containerInfo;
      gv(null, a, null, function() {
        s2(i);
      });
    };
    function D8(a, i, l) {
      var c = l != null && l.hydrate === !0;
      l != null && l.hydrationOptions;
      var h = l != null && l.hydrationOptions != null && l.hydrationOptions.mutableSources || null, b = S8(a, i, c);
      Sj(b.current, a), a.nodeType;
      {
        var S = a.nodeType === Oa ? a.parentNode : a;
        Ox(S);
      }
      if (h)
        for (var E = 0; E < h.length; E++) {
          var z = h[E];
          w8(b, z);
        }
      return b;
    }
    function N8(a, i) {
      return new Tk(a, x0, i);
    }
    function Eh(a) {
      return !!(a && (a.nodeType === Ni || a.nodeType === ps || a.nodeType === vm || a.nodeType === Oa && a.nodeValue === " react-mount-point-unstable "));
    }
    var W8 = s.ReactCurrentOwner, KM, JM = !1;
    KM = function(a) {
      if (a._reactRootContainer && a.nodeType !== Oa) {
        var i = NM(a._reactRootContainer._internalRoot.current);
        i && i.parentNode !== a && m("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var l = !!a._reactRootContainer, c = vb(a), h = !!(c && Qc(c));
      h && !l && m("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), a.nodeType === Ni && a.tagName && a.tagName.toUpperCase() === "BODY" && m("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function vb(a) {
      return a ? a.nodeType === ps ? a.documentElement : a.firstChild : null;
    }
    function j8(a) {
      var i = vb(a);
      return !!(i && i.nodeType === Ni && i.hasAttribute(Gr));
    }
    function z8(a, i) {
      var l = i || j8(a);
      if (!l)
        for (var c = !1, h; h = a.lastChild; )
          !c && h.nodeType === Ni && h.hasAttribute(Gr) && (c = !0, m("render(): Target node has markup rendered by React, but there are unrelated nodes as well. This is most commonly caused by white-space inserted around server-rendered markup.")), a.removeChild(h);
      return l && !i && !JM && (JM = !0, f("render(): Calling ReactDOM.render() to hydrate server-rendered markup will stop working in React v18. Replace the ReactDOM.render() call with ReactDOM.hydrate() if you want React to attach to the server HTML.")), N8(a, l ? {
        hydrate: !0
      } : void 0);
    }
    function L8(a, i) {
      a !== null && typeof a != "function" && m("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", i, a);
    }
    function gb(a, i, l, c, h) {
      KM(l), L8(h === void 0 ? null : h, "render");
      var b = l._reactRootContainer, S;
      if (b) {
        if (S = b._internalRoot, typeof h == "function") {
          var z = h;
          h = function() {
            var G = Ak(S);
            z.call(G);
          };
        }
        gv(i, S, a, h);
      } else {
        if (b = l._reactRootContainer = z8(l, c), S = b._internalRoot, typeof h == "function") {
          var E = h;
          h = function() {
            var G = Ak(S);
            E.call(G);
          };
        }
        mM(function() {
          gv(i, S, a, h);
        });
      }
      return Ak(S);
    }
    function I8(a) {
      {
        var i = W8.current;
        if (i !== null && i.stateNode !== null) {
          var l = i.stateNode._warnedAboutRefsInRender;
          l || m("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Je(i.type) || "A component"), i.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return a == null ? null : a.nodeType === Ni ? a : $8(a, "findDOMNode");
    }
    function F8(a, i, l) {
      if (!Eh(i))
        throw Error("Target container is not a DOM element.");
      {
        var c = ey(i) && i._reactRootContainer === void 0;
        c && m("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call createRoot(container, {hydrate: true}).render(element)?");
      }
      return gb(null, a, i, !0, l);
    }
    function H8(a, i, l) {
      if (!Eh(i))
        throw Error("Target container is not a DOM element.");
      {
        var c = ey(i) && i._reactRootContainer === void 0;
        c && m("You are calling ReactDOM.render() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return gb(null, a, i, !1, l);
    }
    function V8(a, i, l, c) {
      if (!Eh(l))
        throw Error("Target container is not a DOM element.");
      if (!(a != null && Wc(a)))
        throw Error("parentComponent must be a valid React Component");
      return gb(a, i, l, !1, c);
    }
    function B8(a) {
      if (!Eh(a))
        throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var i = ey(a) && a._reactRootContainer === void 0;
        i && m("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (a._reactRootContainer) {
        {
          var l = vb(a), c = l && !Qc(l);
          c && m("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return mM(function() {
          gb(null, null, a, !1, function() {
            a._reactRootContainer = null, s2(a);
          });
        }), !0;
      } else {
        {
          var h = vb(a), b = !!(h && Qc(h)), S = a.nodeType === Ni && Eh(a.parentNode) && !!a.parentNode._reactRootContainer;
          b && m("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", S ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Nl(x8), af(C8), jl(M8), wa(E8);
    var ZM = !1;
    (typeof Map != "function" || Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && m("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Yd(x6), Ou(fM, P7, y7, w7);
    function eE(a, i) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Eh(i))
        throw Error("Target container is not a DOM element.");
      return P8(a, i, null, l);
    }
    function U8(a, i, l, c) {
      return V8(a, i, l, c);
    }
    function X8(a, i) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      return ZM || (ZM = !0, f('The ReactDOM.unstable_createPortal() alias has been deprecated, and will be removed in React 18+. Update your code to use ReactDOM.createPortal() instead. It has the exact same API, but without the "unstable_" prefix.')), eE(a, i, l);
    }
    var q8 = {
      Events: [
        Qc,
        oh,
        ty,
        Tl,
        Gd,
        su,
        hb
      ]
    }, Y8 = R8({
      findFiberByHostInstance: _f,
      bundleType: 1,
      version: _2,
      rendererPackageName: "react-dom"
    });
    if (!Y8 && At && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var tE = window.location.protocol;
      /^(https?|file):$/.test(tE) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (tE === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    ls.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = q8, ls.createPortal = eE, ls.findDOMNode = I8, ls.flushSync = uk, ls.hydrate = F8, ls.render = H8, ls.unmountComponentAtNode = B8, ls.unstable_batchedUpdates = fM, ls.unstable_createPortal = X8, ls.unstable_renderSubtreeIntoContainer = U8, ls.version = _2;
  }()), ls;
}
(function(e) {
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (n) {
        console.error(n);
      }
    }
  }
  process.env.NODE_ENV === "production" ? (t(), e.exports = ZU()) : e.exports = rX();
})(Zh);
const Sv = /* @__PURE__ */ tR(Zh.exports);
var aX = Object.defineProperty, iX = Object.defineProperties, oX = Object.getOwnPropertyDescriptors, P1 = Object.getOwnPropertySymbols, tD = Object.prototype.hasOwnProperty, nD = Object.prototype.propertyIsEnumerable, y_ = (e, t, n) => t in e ? aX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, vl = (e, t) => {
  for (var n in t || (t = {}))
    tD.call(t, n) && y_(e, n, t[n]);
  if (P1)
    for (var n of P1(t))
      nD.call(t, n) && y_(e, n, t[n]);
  return e;
}, xv = (e, t) => iX(e, oX(t)), sX = (e, t) => {
  var n = {};
  for (var r in e)
    tD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && P1)
    for (var r of P1(e))
      t.indexOf(r) < 0 && nD.call(e, r) && (n[r] = e[r]);
  return n;
};
function lX(e) {
  if (!e || typeof e == "string")
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function Zk(e) {
  return e != null && e.current ? e.current.scrollHeight : "auto";
}
function uX(e) {
  return e != null && e.current ? e.current.scrollWidth : "auto";
}
const uc = typeof window < "u" && window.requestAnimationFrame;
function cX({
  transitionDuration: e,
  transitionTimingFunction: t = "ease",
  onTransitionEnd: n = () => {
  },
  opened: r,
  axis: s
}) {
  const f = F.exports.useRef(null), m = "0px", [p, v] = F.exports.useState({}), y = (j) => {
    Zh.exports.flushSync(() => v(j));
  }, w = (j) => {
    y((H) => vl(vl({}, H), j));
  };
  function P(j) {
    const H = e || lX(j);
    return {
      transitionProperty: `${s === "x" ? "width" : "height"}`,
      transitionDuration: `${H}ms`,
      transitionTimingFunction: `${t}`
    };
  }
  const x = () => {
    const j = p;
    y({});
    const H = { width: uX(f), height: Zk(f) };
    return y(j), H;
  }, A = () => {
    const { height: j } = x();
    return {
      x: { height: j, width: "0px", overflow: "hidden" },
      y: { display: "none", height: "0px", overflow: "hidden" }
    };
  };
  F.exports.useEffect(() => {
    uc(() => {
      const { x: j, y: H } = A();
      s === "x" && !r ? y(vl({}, j)) : s === "y" && !r && y(vl({}, H));
    });
  }, []), kd(() => {
    s !== "x" && uc(r ? () => {
      w({ willChange: "height", display: "block", overflow: "hidden" }), uc(() => {
        const j = Zk(f);
        w(xv(vl({}, P(j)), { height: j }));
      });
    } : () => {
      const j = Zk(f);
      w(xv(vl({}, P(j)), { willChange: "height", height: j })), uc(() => w({ height: m, overflow: "hidden" }));
    });
  }, [r]), kd(() => {
    s !== "y" && uc(r ? () => {
      const { width: j } = x();
      w({
        display: "block",
        overflow: "hidden",
        willChange: "width",
        flexShrink: 0
      }), uc(() => {
        w(xv(vl({}, P(j)), { width: j }));
      });
    } : () => {
      const { width: j, height: H } = x();
      w(xv(vl({}, P(j)), {
        flexShrink: 0,
        willChange: "width",
        width: j,
        height: H
      })), uc(() => w({ width: "0px", overflow: "hidden" }));
    });
  }, [r]);
  const M = (j) => {
    if (!(j.target !== f.current || !(j.propertyName === "width" || "height")))
      if (n(), r)
        y({});
      else {
        const { x: H, y: J } = A();
        y(s === "x" ? H : J);
      }
  };
  function O(j = {}) {
    var H = j, { style: J = {}, refKey: V = "ref" } = H, X = sX(H, ["style", "refKey"]);
    const U = X[V];
    return xv(vl({
      "aria-hidden": !r
    }, X), {
      [V]: jR(f, U),
      onTransitionEnd: M,
      style: vl(vl({ boxSizing: "border-box" }, J), p)
    });
  }
  return O;
}
var dX = Object.defineProperty, k1 = Object.getOwnPropertySymbols, rD = Object.prototype.hasOwnProperty, aD = Object.prototype.propertyIsEnumerable, b_ = (e, t, n) => t in e ? dX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, $b = (e, t) => {
  for (var n in t || (t = {}))
    rD.call(t, n) && b_(e, n, t[n]);
  if (k1)
    for (var n of k1(t))
      aD.call(t, n) && b_(e, n, t[n]);
  return e;
}, fX = (e, t) => {
  var n = {};
  for (var r in e)
    rD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && k1)
    for (var r of k1(e))
      t.indexOf(r) < 0 && aD.call(e, r) && (n[r] = e[r]);
  return n;
};
const mX = {
  transitionDuration: 200,
  transitionTimingFunction: "ease",
  animateOpacity: !0,
  axis: "y"
}, iD = F.exports.forwardRef((e, t) => {
  const n = Er("Collapse", mX, e), {
    children: r,
    in: s,
    transitionDuration: f,
    transitionTimingFunction: m,
    style: p,
    onTransitionEnd: v,
    animateOpacity: y,
    axis: w
  } = n, P = fX(n, [
    "children",
    "in",
    "transitionDuration",
    "transitionTimingFunction",
    "style",
    "onTransitionEnd",
    "animateOpacity",
    "axis"
  ]), x = vu(), A = zR(), O = (x.respectReducedMotion ? A : !1) ? 0 : f, { systemStyles: j, rest: H } = Ww(P), J = cX({
    opened: s,
    transitionDuration: O,
    transitionTimingFunction: m,
    onTransitionEnd: v,
    axis: w
  });
  return O === 0 ? s ? /* @__PURE__ */ T.createElement(Gn, $b({}, H), r) : null : /* @__PURE__ */ T.createElement(Gn, $b({}, J($b($b({ style: p, ref: t }, H), j))), /* @__PURE__ */ T.createElement("div", {
    style: {
      opacity: s || !y ? 1 : 0,
      transition: y ? `opacity ${O}ms ${m}` : "none"
    }
  }, r));
});
iD.displayName = "@mantine/core/Collapse";
var hX = Object.defineProperty, pX = Object.defineProperties, vX = Object.getOwnPropertyDescriptors, $1 = Object.getOwnPropertySymbols, oD = Object.prototype.hasOwnProperty, sD = Object.prototype.propertyIsEnumerable, w_ = (e, t, n) => t in e ? hX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, gX = (e, t) => {
  for (var n in t || (t = {}))
    oD.call(t, n) && w_(e, n, t[n]);
  if ($1)
    for (var n of $1(t))
      sD.call(t, n) && w_(e, n, t[n]);
  return e;
}, yX = (e, t) => pX(e, vX(t)), bX = (e, t) => {
  var n = {};
  for (var r in e)
    oD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && $1)
    for (var r of $1(e))
      t.indexOf(r) < 0 && sD.call(e, r) && (n[r] = e[r]);
  return n;
};
function lD(e) {
  var t = e, { children: n, className: r } = t, s = bX(t, ["children", "className"]);
  const f = VS(), { value: m } = LR(), { classNames: p, styles: v, unstyled: y } = gu(), { classes: w, cx: P } = QU({ variant: f.variant, radius: f.radius }, { name: "Accordion", classNames: p, styles: v, unstyled: y });
  return /* @__PURE__ */ T.createElement(iD, yX(gX({}, s), {
    className: P(w.panel, r),
    in: f.isItemActive(m),
    transitionDuration: f.transitionDuration,
    role: "region",
    id: f.getRegionId(m),
    "aria-labelledby": f.getControlId(m)
  }), /* @__PURE__ */ T.createElement("div", {
    className: w.content
  }, n));
}
lD.displayName = "@mantine/core/AccordionPanel";
var wX = Object.defineProperty, P_ = Object.getOwnPropertySymbols, PX = Object.prototype.hasOwnProperty, kX = Object.prototype.propertyIsEnumerable, k_ = (e, t, n) => t in e ? wX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, $X = (e, t) => {
  for (var n in t || (t = {}))
    PX.call(t, n) && k_(e, n, t[n]);
  if (P_)
    for (var n of P_(t))
      kX.call(t, n) && k_(e, n, t[n]);
  return e;
};
function SX(e) {
  return /* @__PURE__ */ T.createElement("svg", $X({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, e), /* @__PURE__ */ T.createElement("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var xX = Object.defineProperty, CX = Object.defineProperties, MX = Object.getOwnPropertyDescriptors, S1 = Object.getOwnPropertySymbols, uD = Object.prototype.hasOwnProperty, cD = Object.prototype.propertyIsEnumerable, $_ = (e, t, n) => t in e ? xX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, EX = (e, t) => {
  for (var n in t || (t = {}))
    uD.call(t, n) && $_(e, n, t[n]);
  if (S1)
    for (var n of S1(t))
      cD.call(t, n) && $_(e, n, t[n]);
  return e;
}, AX = (e, t) => CX(e, MX(t)), _X = (e, t) => {
  var n = {};
  for (var r in e)
    uD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && S1)
    for (var r of S1(e))
      t.indexOf(r) < 0 && cD.call(e, r) && (n[r] = e[r]);
  return n;
};
const OX = {
  multiple: !1,
  disableChevronRotation: !1,
  transitionDuration: 200,
  chevronPosition: "right",
  variant: "default",
  chevronSize: 24,
  chevron: /* @__PURE__ */ T.createElement(SX, null)
};
function bd(e) {
  const t = Er("Accordion", OX, e), {
    id: n,
    loop: r,
    children: s,
    multiple: f,
    value: m,
    defaultValue: p,
    onChange: v,
    transitionDuration: y,
    disableChevronRotation: w,
    chevronPosition: P,
    chevronSize: x,
    order: A,
    chevron: M,
    classNames: O,
    styles: j,
    unstyled: H,
    variant: J,
    radius: V
  } = t, X = _X(t, [
    "id",
    "loop",
    "children",
    "multiple",
    "value",
    "defaultValue",
    "onChange",
    "transitionDuration",
    "disableChevronRotation",
    "chevronPosition",
    "chevronSize",
    "order",
    "chevron",
    "classNames",
    "styles",
    "unstyled",
    "variant",
    "radius"
  ]);
  return /* @__PURE__ */ T.createElement(BB, {
    id: n,
    multiple: f,
    value: m,
    defaultValue: p,
    onChange: v,
    loop: r,
    transitionDuration: y,
    disableChevronRotation: w,
    chevronPosition: P,
    chevronSize: x,
    order: A,
    chevron: M,
    variant: J,
    radius: V
  }, /* @__PURE__ */ T.createElement(IS, {
    classNames: O,
    styles: j,
    unstyled: H
  }, /* @__PURE__ */ T.createElement(Gn, AX(EX({}, X), {
    "data-accordion": !0
  }), s)));
}
bd.Item = UR;
bd.Control = ZR;
bd.Panel = lD;
bd.displayName = "@mantine/core/Accordion";
var TX = Object.defineProperty, RX = Object.defineProperties, DX = Object.getOwnPropertyDescriptors, S_ = Object.getOwnPropertySymbols, NX = Object.prototype.hasOwnProperty, WX = Object.prototype.propertyIsEnumerable, x_ = (e, t, n) => t in e ? TX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, dD = (e, t) => {
  for (var n in t || (t = {}))
    NX.call(t, n) && x_(e, n, t[n]);
  if (S_)
    for (var n of S_(t))
      WX.call(t, n) && x_(e, n, t[n]);
  return e;
}, jX = (e, t) => RX(e, DX(t));
const Rv = {
  xs: 18,
  sm: 22,
  md: 28,
  lg: 34,
  xl: 44
};
function zX({ variant: e, theme: t, color: n, gradient: r }) {
  const s = t.fn.variant({ color: n, variant: e, gradient: r });
  return e === "gradient" ? {
    border: 0,
    backgroundImage: s.background,
    color: s.color,
    "&:hover": t.fn.hover({
      backgroundSize: "200%"
    })
  } : dD({
    border: `1px solid ${s.border}`,
    backgroundColor: s.background,
    color: s.color
  }, t.fn.hover({
    backgroundColor: s.hover
  }));
}
var LX = $n((e, { color: t, size: n, radius: r, variant: s, gradient: f }) => ({
  root: jX(dD({}, zX({ variant: s, theme: e, color: t, gradient: f })), {
    position: "relative",
    height: e.fn.size({ size: n, sizes: Rv }),
    minHeight: e.fn.size({ size: n, sizes: Rv }),
    width: e.fn.size({ size: n, sizes: Rv }),
    minWidth: e.fn.size({ size: n, sizes: Rv }),
    borderRadius: e.fn.radius(r),
    padding: 0,
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:active": e.activeStyles,
    "&:disabled, &[data-disabled]": {
      color: e.colors.gray[e.colorScheme === "dark" ? 6 : 4],
      cursor: "not-allowed",
      backgroundColor: s === "transparent" ? void 0 : e.fn.themeColor("gray", e.colorScheme === "dark" ? 8 : 1),
      borderColor: s === "transparent" ? void 0 : e.fn.themeColor("gray", e.colorScheme === "dark" ? 8 : 1),
      backgroundImage: "none",
      pointerEvents: "none",
      "&:active": {
        transform: "none"
      }
    },
    "&[data-loading]": {
      pointerEvents: "none",
      "&::before": {
        content: '""',
        position: "absolute",
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: e.colorScheme === "dark" ? e.fn.rgba(e.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
        borderRadius: e.fn.radius(r),
        cursor: "not-allowed"
      }
    }
  })
}));
const IX = LX;
var FX = Object.defineProperty, x1 = Object.getOwnPropertySymbols, fD = Object.prototype.hasOwnProperty, mD = Object.prototype.propertyIsEnumerable, C_ = (e, t, n) => t in e ? FX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, HX = (e, t) => {
  for (var n in t || (t = {}))
    fD.call(t, n) && C_(e, n, t[n]);
  if (x1)
    for (var n of x1(t))
      mD.call(t, n) && C_(e, n, t[n]);
  return e;
}, VX = (e, t) => {
  var n = {};
  for (var r in e)
    fD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && x1)
    for (var r of x1(e))
      t.indexOf(r) < 0 && mD.call(e, r) && (n[r] = e[r]);
  return n;
};
function BX(e) {
  var t = e, { size: n, color: r } = t, s = VX(t, ["size", "color"]);
  return /* @__PURE__ */ T.createElement("svg", HX({
    viewBox: "0 0 135 140",
    xmlns: "http://www.w3.org/2000/svg",
    fill: r,
    width: `${n}px`
  }, s), /* @__PURE__ */ T.createElement("rect", {
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ T.createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ T.createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ T.createElement("rect", {
    x: "30",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ T.createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ T.createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ T.createElement("rect", {
    x: "60",
    width: "15",
    height: "140",
    rx: "6"
  }, /* @__PURE__ */ T.createElement("animate", {
    attributeName: "height",
    begin: "0s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ T.createElement("animate", {
    attributeName: "y",
    begin: "0s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ T.createElement("rect", {
    x: "90",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ T.createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ T.createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ T.createElement("rect", {
    x: "120",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ T.createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ T.createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}
var UX = Object.defineProperty, C1 = Object.getOwnPropertySymbols, hD = Object.prototype.hasOwnProperty, pD = Object.prototype.propertyIsEnumerable, M_ = (e, t, n) => t in e ? UX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, XX = (e, t) => {
  for (var n in t || (t = {}))
    hD.call(t, n) && M_(e, n, t[n]);
  if (C1)
    for (var n of C1(t))
      pD.call(t, n) && M_(e, n, t[n]);
  return e;
}, qX = (e, t) => {
  var n = {};
  for (var r in e)
    hD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && C1)
    for (var r of C1(e))
      t.indexOf(r) < 0 && pD.call(e, r) && (n[r] = e[r]);
  return n;
};
function YX(e) {
  var t = e, { size: n, color: r } = t, s = qX(t, ["size", "color"]);
  return /* @__PURE__ */ T.createElement("svg", XX({
    width: `${n}px`,
    height: `${n}px`,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: r
  }, s), /* @__PURE__ */ T.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ T.createElement("g", {
    transform: "translate(2.5 2.5)",
    strokeWidth: "5"
  }, /* @__PURE__ */ T.createElement("circle", {
    strokeOpacity: ".5",
    cx: "16",
    cy: "16",
    r: "16"
  }), /* @__PURE__ */ T.createElement("path", {
    d: "M32 16c0-9.94-8.06-16-16-16"
  }, /* @__PURE__ */ T.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 16 16",
    to: "360 16 16",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
}
var GX = Object.defineProperty, M1 = Object.getOwnPropertySymbols, vD = Object.prototype.hasOwnProperty, gD = Object.prototype.propertyIsEnumerable, E_ = (e, t, n) => t in e ? GX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, QX = (e, t) => {
  for (var n in t || (t = {}))
    vD.call(t, n) && E_(e, n, t[n]);
  if (M1)
    for (var n of M1(t))
      gD.call(t, n) && E_(e, n, t[n]);
  return e;
}, KX = (e, t) => {
  var n = {};
  for (var r in e)
    vD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && M1)
    for (var r of M1(e))
      t.indexOf(r) < 0 && gD.call(e, r) && (n[r] = e[r]);
  return n;
};
function JX(e) {
  var t = e, { size: n, color: r } = t, s = KX(t, ["size", "color"]);
  return /* @__PURE__ */ T.createElement("svg", QX({
    width: `${n}px`,
    height: `${n / 4}px`,
    viewBox: "0 0 120 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: r
  }, s), /* @__PURE__ */ T.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }, /* @__PURE__ */ T.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ T.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ T.createElement("circle", {
    cx: "60",
    cy: "15",
    r: "9",
    fillOpacity: "0.3"
  }, /* @__PURE__ */ T.createElement("animate", {
    attributeName: "r",
    from: "9",
    to: "9",
    begin: "0s",
    dur: "0.8s",
    values: "9;15;9",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ T.createElement("animate", {
    attributeName: "fill-opacity",
    from: "0.5",
    to: "0.5",
    begin: "0s",
    dur: "0.8s",
    values: ".5;1;.5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ T.createElement("circle", {
    cx: "105",
    cy: "15",
    r: "15"
  }, /* @__PURE__ */ T.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ T.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}
var ZX = Object.defineProperty, E1 = Object.getOwnPropertySymbols, yD = Object.prototype.hasOwnProperty, bD = Object.prototype.propertyIsEnumerable, A_ = (e, t, n) => t in e ? ZX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, eq = (e, t) => {
  for (var n in t || (t = {}))
    yD.call(t, n) && A_(e, n, t[n]);
  if (E1)
    for (var n of E1(t))
      bD.call(t, n) && A_(e, n, t[n]);
  return e;
}, tq = (e, t) => {
  var n = {};
  for (var r in e)
    yD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && E1)
    for (var r of E1(e))
      t.indexOf(r) < 0 && bD.call(e, r) && (n[r] = e[r]);
  return n;
};
const e$ = {
  bars: BX,
  oval: YX,
  dots: JX
}, nq = {
  xs: 18,
  sm: 22,
  md: 36,
  lg: 44,
  xl: 58
}, rq = {
  size: "md"
};
function mg(e) {
  const t = Er("Loader", rq, e), { size: n, color: r, variant: s } = t, f = tq(t, ["size", "color", "variant"]), m = vu(), p = s in e$ ? s : m.loader;
  return /* @__PURE__ */ T.createElement(Gn, eq({
    role: "presentation",
    component: e$[p] || e$.bars,
    size: m.fn.size({ size: n, sizes: nq }),
    color: m.fn.variant({
      variant: "filled",
      primaryFallback: !1,
      color: r || m.primaryColor
    }).background
  }, f));
}
mg.displayName = "@mantine/core/Loader";
var aq = Object.defineProperty, A1 = Object.getOwnPropertySymbols, wD = Object.prototype.hasOwnProperty, PD = Object.prototype.propertyIsEnumerable, __ = (e, t, n) => t in e ? aq(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, O_ = (e, t) => {
  for (var n in t || (t = {}))
    wD.call(t, n) && __(e, n, t[n]);
  if (A1)
    for (var n of A1(t))
      PD.call(t, n) && __(e, n, t[n]);
  return e;
}, iq = (e, t) => {
  var n = {};
  for (var r in e)
    wD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && A1)
    for (var r of A1(e))
      t.indexOf(r) < 0 && PD.call(e, r) && (n[r] = e[r]);
  return n;
};
const oq = {
  color: "gray",
  size: "md",
  variant: "subtle",
  loading: !1
}, kD = F.exports.forwardRef((e, t) => {
  const n = Er("ActionIcon", oq, e), {
    className: r,
    color: s,
    children: f,
    radius: m,
    size: p,
    variant: v,
    gradient: y,
    disabled: w,
    loaderProps: P,
    loading: x,
    unstyled: A
  } = n, M = iq(n, [
    "className",
    "color",
    "children",
    "radius",
    "size",
    "variant",
    "gradient",
    "disabled",
    "loaderProps",
    "loading",
    "unstyled"
  ]), { classes: O, cx: j, theme: H } = IX({ size: p, radius: m, color: s, variant: v, gradient: y }, { name: "ActionIcon", unstyled: A }), J = H.fn.variant({ color: s, variant: v }), V = /* @__PURE__ */ T.createElement(mg, O_({
    color: J.color,
    size: H.fn.size({ size: p, sizes: Rv }) - 12
  }, P));
  return /* @__PURE__ */ T.createElement(jw, O_({
    className: j(O.root, r),
    ref: t,
    disabled: w,
    "data-disabled": w || void 0,
    "data-loading": x || void 0,
    unstyled: A
  }, M), x ? V : f);
});
kD.displayName = "@mantine/core/ActionIcon";
const zw = kD;
function $D(e) {
  const { children: t, target: n, className: r } = Er("Portal", {}, e), s = vu(), [f, m] = F.exports.useState(!1), p = F.exports.useRef();
  return RR(() => (m(!0), p.current = n ? typeof n == "string" ? document.querySelector(n) : n : document.createElement("div"), n || document.body.appendChild(p.current), () => {
    !n && document.body.removeChild(p.current);
  }), [n]), f ? Zh.exports.createPortal(/* @__PURE__ */ T.createElement("div", {
    className: r,
    dir: s.dir
  }, t), p.current) : null;
}
$D.displayName = "@mantine/core/Portal";
var sq = Object.defineProperty, _1 = Object.getOwnPropertySymbols, SD = Object.prototype.hasOwnProperty, xD = Object.prototype.propertyIsEnumerable, T_ = (e, t, n) => t in e ? sq(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, lq = (e, t) => {
  for (var n in t || (t = {}))
    SD.call(t, n) && T_(e, n, t[n]);
  if (_1)
    for (var n of _1(t))
      xD.call(t, n) && T_(e, n, t[n]);
  return e;
}, uq = (e, t) => {
  var n = {};
  for (var r in e)
    SD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && _1)
    for (var r of _1(e))
      t.indexOf(r) < 0 && xD.call(e, r) && (n[r] = e[r]);
  return n;
};
function CD(e) {
  var t = e, { withinPortal: n = !0, children: r } = t, s = uq(t, ["withinPortal", "children"]);
  return n ? /* @__PURE__ */ T.createElement($D, lq({}, s), r) : /* @__PURE__ */ T.createElement(T.Fragment, null, r);
}
CD.displayName = "@mantine/core/OptionalPortal";
var cq = Object.defineProperty, dq = Object.defineProperties, fq = Object.getOwnPropertyDescriptors, R_ = Object.getOwnPropertySymbols, mq = Object.prototype.hasOwnProperty, hq = Object.prototype.propertyIsEnumerable, D_ = (e, t, n) => t in e ? cq(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Sb = (e, t) => {
  for (var n in t || (t = {}))
    mq.call(t, n) && D_(e, n, t[n]);
  if (R_)
    for (var n of R_(t))
      hq.call(t, n) && D_(e, n, t[n]);
  return e;
}, pq = (e, t) => dq(e, fq(t));
function vq({
  underline: e,
  strikethrough: t
}) {
  const n = [];
  return e && n.push("underline"), t && n.push("line-through"), n.length > 0 ? n.join(" ") : "none";
}
function gq({ theme: e, color: t, variant: n }) {
  return t === "dimmed" ? e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6] : typeof t == "string" && (t in e.colors || t.split(".")[0] in e.colors) ? e.fn.variant({ variant: "filled", color: t }).background : n === "link" ? e.colors[e.primaryColor][e.colorScheme === "dark" ? 4 : 7] : t || "inherit";
}
function yq(e) {
  return typeof e == "number" ? {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: e,
    WebkitBoxOrient: "vertical"
  } : null;
}
var bq = $n((e, {
  color: t,
  variant: n,
  size: r,
  lineClamp: s,
  inline: f,
  inherit: m,
  underline: p,
  gradient: v,
  weight: y,
  transform: w,
  align: P,
  strikethrough: x,
  italic: A
}) => {
  const M = e.fn.variant({ variant: "gradient", gradient: v });
  return {
    root: Sb(pq(Sb(Sb(Sb({}, e.fn.fontStyles()), e.fn.focusStyles()), yq(s)), {
      color: gq({ color: t, theme: e, variant: n }),
      fontFamily: m ? "inherit" : e.fontFamily,
      fontSize: m || r === void 0 ? "inherit" : e.fn.size({ size: r, sizes: e.fontSizes }),
      lineHeight: m ? "inherit" : f ? 1 : e.lineHeight,
      textDecoration: vq({ underline: p, strikethrough: x }),
      WebkitTapHighlightColor: "transparent",
      fontWeight: m ? "inherit" : y,
      textTransform: w,
      textAlign: P,
      fontStyle: A ? "italic" : void 0
    }), e.fn.hover(n === "link" && p === void 0 ? {
      textDecoration: "underline"
    } : void 0)),
    gradient: {
      backgroundImage: M.background,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    }
  };
});
const wq = bq;
var Pq = Object.defineProperty, O1 = Object.getOwnPropertySymbols, MD = Object.prototype.hasOwnProperty, ED = Object.prototype.propertyIsEnumerable, N_ = (e, t, n) => t in e ? Pq(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, kq = (e, t) => {
  for (var n in t || (t = {}))
    MD.call(t, n) && N_(e, n, t[n]);
  if (O1)
    for (var n of O1(t))
      ED.call(t, n) && N_(e, n, t[n]);
  return e;
}, $q = (e, t) => {
  var n = {};
  for (var r in e)
    MD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && O1)
    for (var r of O1(e))
      t.indexOf(r) < 0 && ED.call(e, r) && (n[r] = e[r]);
  return n;
};
const Sq = {
  variant: "text"
}, AD = F.exports.forwardRef((e, t) => {
  const n = Er("Text", Sq, e), {
    className: r,
    size: s,
    weight: f,
    transform: m,
    color: p,
    align: v,
    variant: y,
    lineClamp: w,
    gradient: P,
    inline: x,
    inherit: A,
    underline: M,
    strikethrough: O,
    italic: j,
    classNames: H,
    styles: J,
    unstyled: V,
    span: X
  } = n, U = $q(n, [
    "className",
    "size",
    "weight",
    "transform",
    "color",
    "align",
    "variant",
    "lineClamp",
    "gradient",
    "inline",
    "inherit",
    "underline",
    "strikethrough",
    "italic",
    "classNames",
    "styles",
    "unstyled",
    "span"
  ]), { classes: K, cx: ce } = wq({
    variant: y,
    color: p,
    size: s,
    lineClamp: w,
    inline: x,
    inherit: A,
    underline: M,
    strikethrough: O,
    italic: j,
    weight: f,
    transform: m,
    align: v,
    gradient: P
  }, { unstyled: V, name: "Text" });
  return /* @__PURE__ */ T.createElement(Gn, kq({
    ref: t,
    className: ce(K.root, { [K.gradient]: y === "gradient" }, r),
    component: X ? "span" : "div"
  }, U));
});
AD.displayName = "@mantine/core/Text";
const Lw = AD, xb = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5
};
function Cb(e, t) {
  const n = e.fn.variant({ variant: "outline", color: t }).border;
  return typeof t == "string" && (t in e.colors || t.split(".")[0] in e.colors) ? n : t === void 0 ? e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4] : t;
}
var xq = $n((e, { size: t, variant: n, color: r }) => ({
  root: {},
  withLabel: {
    borderTop: "0 !important"
  },
  left: {
    "&::before": {
      display: "none"
    }
  },
  right: {
    "&::after": {
      display: "none"
    }
  },
  label: {
    display: "flex",
    alignItems: "center",
    "&::before": {
      content: '""',
      flex: 1,
      height: 1,
      borderTop: `${e.fn.size({ size: t, sizes: xb })}px ${n} ${Cb(e, r)}`,
      marginRight: e.spacing.xs
    },
    "&::after": {
      content: '""',
      flex: 1,
      borderTop: `${e.fn.size({ size: t, sizes: xb })}px ${n} ${Cb(e, r)}`,
      marginLeft: e.spacing.xs
    }
  },
  labelDefaultStyles: {
    color: r === "dark" ? e.colors.dark[1] : e.fn.themeColor(r, e.colorScheme === "dark" ? 5 : e.fn.primaryShade(), !1)
  },
  horizontal: {
    border: 0,
    borderTopWidth: e.fn.size({ size: t, sizes: xb }),
    borderTopColor: Cb(e, r),
    borderTopStyle: n,
    margin: 0
  },
  vertical: {
    border: 0,
    alignSelf: "stretch",
    height: "auto",
    borderLeftWidth: e.fn.size({ size: t, sizes: xb }),
    borderLeftColor: Cb(e, r),
    borderLeftStyle: n
  }
}));
const Cq = xq;
var Mq = Object.defineProperty, Eq = Object.defineProperties, Aq = Object.getOwnPropertyDescriptors, T1 = Object.getOwnPropertySymbols, _D = Object.prototype.hasOwnProperty, OD = Object.prototype.propertyIsEnumerable, W_ = (e, t, n) => t in e ? Mq(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, j_ = (e, t) => {
  for (var n in t || (t = {}))
    _D.call(t, n) && W_(e, n, t[n]);
  if (T1)
    for (var n of T1(t))
      OD.call(t, n) && W_(e, n, t[n]);
  return e;
}, _q = (e, t) => Eq(e, Aq(t)), Oq = (e, t) => {
  var n = {};
  for (var r in e)
    _D.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && T1)
    for (var r of T1(e))
      t.indexOf(r) < 0 && OD.call(e, r) && (n[r] = e[r]);
  return n;
};
const Tq = {
  orientation: "horizontal",
  size: "xs",
  labelPosition: "left",
  variant: "solid"
}, TD = F.exports.forwardRef((e, t) => {
  const n = Er("Divider", Tq, e), {
    className: r,
    color: s,
    orientation: f,
    size: m,
    label: p,
    labelPosition: v,
    labelProps: y,
    variant: w,
    styles: P,
    classNames: x,
    unstyled: A
  } = n, M = Oq(n, [
    "className",
    "color",
    "orientation",
    "size",
    "label",
    "labelPosition",
    "labelProps",
    "variant",
    "styles",
    "classNames",
    "unstyled"
  ]), { classes: O, cx: j } = Cq({ color: s, size: m, variant: w }, { classNames: x, styles: P, unstyled: A, name: "Divider" }), H = f === "vertical", J = f === "horizontal", V = !!p && J, X = !(y != null && y.color);
  return /* @__PURE__ */ T.createElement(Gn, j_({
    ref: t,
    className: j(O.root, {
      [O.vertical]: H,
      [O.horizontal]: J,
      [O.withLabel]: V
    }, r),
    role: "separator"
  }, M), V && /* @__PURE__ */ T.createElement(Lw, _q(j_({}, y), {
    size: (y == null ? void 0 : y.size) || "xs",
    sx: { marginTop: 2 },
    className: j(O.label, O[v], {
      [O.labelDefaultStyles]: X
    })
  }), p));
});
TD.displayName = "@mantine/core/Divider";
function Rq(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function RD(...e) {
  return (t) => e.forEach(
    (n) => Rq(n, t)
  );
}
function dm(...e) {
  return F.exports.useCallback(RD(...e), e);
}
const DD = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { children: n, ...r } = e, s = F.exports.Children.toArray(n), f = s.find(Nq);
  if (f) {
    const m = f.props.children, p = s.map((v) => v === f ? F.exports.Children.count(m) > 1 ? F.exports.Children.only(null) : /* @__PURE__ */ F.exports.isValidElement(m) ? m.props.children : null : v);
    return /* @__PURE__ */ F.exports.createElement(N$, Dr({}, r, {
      ref: t
    }), /* @__PURE__ */ F.exports.isValidElement(m) ? /* @__PURE__ */ F.exports.cloneElement(m, void 0, p) : null);
  }
  return /* @__PURE__ */ F.exports.createElement(N$, Dr({}, r, {
    ref: t
  }), n);
});
DD.displayName = "Slot";
const N$ = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ F.exports.isValidElement(n) ? /* @__PURE__ */ F.exports.cloneElement(n, {
    ...Wq(r, n.props),
    ref: RD(t, n.ref)
  }) : F.exports.Children.count(n) > 1 ? F.exports.Children.only(null) : null;
});
N$.displayName = "SlotClone";
const Dq = ({ children: e }) => /* @__PURE__ */ F.exports.createElement(F.exports.Fragment, null, e);
function Nq(e) {
  return /* @__PURE__ */ F.exports.isValidElement(e) && e.type === Dq;
}
function Wq(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const s = e[r], f = t[r];
    /^on[A-Z]/.test(r) ? n[r] = (...p) => {
      f == null || f(...p), s == null || s(...p);
    } : r === "style" ? n[r] = {
      ...s,
      ...f
    } : r === "className" && (n[r] = [
      s,
      f
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const jq = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], hg = jq.reduce((e, t) => {
  const n = /* @__PURE__ */ F.exports.forwardRef((r, s) => {
    const { asChild: f, ...m } = r, p = f ? DD : t;
    return F.exports.useEffect(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ F.exports.createElement(p, Dr({}, m, {
      ref: s
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {}), W$ = Boolean(globalThis == null ? void 0 : globalThis.document) ? F.exports.useLayoutEffect : () => {
};
function zq(e, t) {
  return F.exports.useReducer((n, r) => {
    const s = t[n][r];
    return s ?? n;
  }, e);
}
const pg = (e) => {
  const { present: t, children: n } = e, r = Lq(t), s = typeof n == "function" ? n({
    present: r.isPresent
  }) : F.exports.Children.only(n), f = dm(r.ref, s.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ F.exports.cloneElement(s, {
    ref: f
  }) : null;
};
pg.displayName = "Presence";
function Lq(e) {
  const [t, n] = F.exports.useState(), r = F.exports.useRef({}), s = F.exports.useRef(e), f = F.exports.useRef("none"), m = e ? "mounted" : "unmounted", [p, v] = zq(m, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return F.exports.useEffect(() => {
    const y = Mb(r.current);
    f.current = p === "mounted" ? y : "none";
  }, [
    p
  ]), W$(() => {
    const y = r.current, w = s.current;
    if (w !== e) {
      const x = f.current, A = Mb(y);
      e ? v("MOUNT") : A === "none" || (y == null ? void 0 : y.display) === "none" ? v("UNMOUNT") : v(w && x !== A ? "ANIMATION_OUT" : "UNMOUNT"), s.current = e;
    }
  }, [
    e,
    v
  ]), W$(() => {
    if (t) {
      const y = (P) => {
        const A = Mb(r.current).includes(P.animationName);
        P.target === t && A && Zh.exports.flushSync(
          () => v("ANIMATION_END")
        );
      }, w = (P) => {
        P.target === t && (f.current = Mb(r.current));
      };
      return t.addEventListener("animationstart", w), t.addEventListener("animationcancel", y), t.addEventListener("animationend", y), () => {
        t.removeEventListener("animationstart", w), t.removeEventListener("animationcancel", y), t.removeEventListener("animationend", y);
      };
    } else
      v("ANIMATION_END");
  }, [
    t,
    v
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(p),
    ref: F.exports.useCallback((y) => {
      y && (r.current = getComputedStyle(y)), n(y);
    }, [])
  };
}
function Mb(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Iq(e, t = []) {
  let n = [];
  function r(f, m) {
    const p = /* @__PURE__ */ F.exports.createContext(m), v = n.length;
    n = [
      ...n,
      m
    ];
    function y(P) {
      const { scope: x, children: A, ...M } = P, O = (x == null ? void 0 : x[e][v]) || p, j = F.exports.useMemo(
        () => M,
        Object.values(M)
      );
      return /* @__PURE__ */ F.exports.createElement(O.Provider, {
        value: j
      }, A);
    }
    function w(P, x) {
      const A = (x == null ? void 0 : x[e][v]) || p, M = F.exports.useContext(A);
      if (M)
        return M;
      if (m !== void 0)
        return m;
      throw new Error(`\`${P}\` must be used within \`${f}\``);
    }
    return y.displayName = f + "Provider", [
      y,
      w
    ];
  }
  const s = () => {
    const f = n.map((m) => /* @__PURE__ */ F.exports.createContext(m));
    return function(p) {
      const v = (p == null ? void 0 : p[e]) || f;
      return F.exports.useMemo(
        () => ({
          [`__scope${e}`]: {
            ...p,
            [e]: v
          }
        }),
        [
          p,
          v
        ]
      );
    };
  };
  return s.scopeName = e, [
    r,
    Fq(s, ...t)
  ];
}
function Fq(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (s) => ({
        useScope: s(),
        scopeName: s.scopeName
      })
    );
    return function(f) {
      const m = r.reduce((p, { useScope: v, scopeName: y }) => {
        const P = v(f)[`__scope${y}`];
        return {
          ...p,
          ...P
        };
      }, {});
      return F.exports.useMemo(
        () => ({
          [`__scope${t.scopeName}`]: m
        }),
        [
          m
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function nm(e) {
  const t = F.exports.useRef(e);
  return F.exports.useEffect(() => {
    t.current = e;
  }), F.exports.useMemo(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
const Hq = /* @__PURE__ */ F.exports.createContext(void 0);
function Vq(e) {
  const t = F.exports.useContext(Hq);
  return e || t || "ltr";
}
function Bq(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function sm(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(s) {
    if (e == null || e(s), n === !1 || !s.defaultPrevented)
      return t == null ? void 0 : t(s);
  };
}
function Uq(e, t) {
  return F.exports.useReducer((n, r) => {
    const s = t[n][r];
    return s ?? n;
  }, e);
}
const ND = "ScrollArea", [WD, cJe] = Iq(ND), [Xq, Xs] = WD(ND), qq = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { __scopeScrollArea: n, type: r = "hover", dir: s, scrollHideDelay: f = 600, ...m } = e, [p, v] = F.exports.useState(null), [y, w] = F.exports.useState(null), [P, x] = F.exports.useState(null), [A, M] = F.exports.useState(null), [O, j] = F.exports.useState(null), [H, J] = F.exports.useState(0), [V, X] = F.exports.useState(0), [U, K] = F.exports.useState(!1), [ce, ue] = F.exports.useState(!1), ye = dm(
    t,
    (_e) => v(_e)
  ), Oe = Vq(s);
  return /* @__PURE__ */ F.exports.createElement(Xq, {
    scope: n,
    type: r,
    dir: Oe,
    scrollHideDelay: f,
    scrollArea: p,
    viewport: y,
    onViewportChange: w,
    content: P,
    onContentChange: x,
    scrollbarX: A,
    onScrollbarXChange: M,
    scrollbarXEnabled: U,
    onScrollbarXEnabledChange: K,
    scrollbarY: O,
    onScrollbarYChange: j,
    scrollbarYEnabled: ce,
    onScrollbarYEnabledChange: ue,
    onCornerWidthChange: J,
    onCornerHeightChange: X
  }, /* @__PURE__ */ F.exports.createElement(hg.div, Dr({
    dir: Oe
  }, m, {
    ref: ye,
    style: {
      position: "relative",
      ["--radix-scroll-area-corner-width"]: H + "px",
      ["--radix-scroll-area-corner-height"]: V + "px",
      ...e.style
    }
  })));
}), Yq = "ScrollAreaViewport", Gq = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { __scopeScrollArea: n, children: r, ...s } = e, f = Xs(Yq, n), m = F.exports.useRef(null), p = dm(t, m, f.onViewportChange);
  return /* @__PURE__ */ F.exports.createElement(F.exports.Fragment, null, /* @__PURE__ */ F.exports.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ F.exports.createElement(hg.div, Dr({
    "data-radix-scroll-area-viewport": ""
  }, s, {
    ref: p,
    style: {
      overflowX: f.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: f.scrollbarYEnabled ? "scroll" : "hidden",
      ...e.style
    }
  }), /* @__PURE__ */ F.exports.createElement("div", {
    ref: f.onContentChange,
    style: {
      minWidth: "100%",
      display: "table"
    }
  }, r)));
}), $c = "ScrollAreaScrollbar", Qq = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, s = Xs($c, e.__scopeScrollArea), { onScrollbarXEnabledChange: f, onScrollbarYEnabledChange: m } = s, p = e.orientation === "horizontal";
  return F.exports.useEffect(() => (p ? f(!0) : m(!0), () => {
    p ? f(!1) : m(!1);
  }), [
    p,
    f,
    m
  ]), s.type === "hover" ? /* @__PURE__ */ F.exports.createElement(Kq, Dr({}, r, {
    ref: t,
    forceMount: n
  })) : s.type === "scroll" ? /* @__PURE__ */ F.exports.createElement(Jq, Dr({}, r, {
    ref: t,
    forceMount: n
  })) : s.type === "auto" ? /* @__PURE__ */ F.exports.createElement(jD, Dr({}, r, {
    ref: t,
    forceMount: n
  })) : s.type === "always" ? /* @__PURE__ */ F.exports.createElement(BS, Dr({}, r, {
    ref: t
  })) : null;
}), Kq = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, s = Xs($c, e.__scopeScrollArea), [f, m] = F.exports.useState(!1);
  return F.exports.useEffect(() => {
    const p = s.scrollArea;
    let v = 0;
    if (p) {
      const y = () => {
        window.clearTimeout(v), m(!0);
      }, w = () => {
        v = window.setTimeout(
          () => m(!1),
          s.scrollHideDelay
        );
      };
      return p.addEventListener("pointerenter", y), p.addEventListener("pointerleave", w), () => {
        window.clearTimeout(v), p.removeEventListener("pointerenter", y), p.removeEventListener("pointerleave", w);
      };
    }
  }, [
    s.scrollArea,
    s.scrollHideDelay
  ]), /* @__PURE__ */ F.exports.createElement(pg, {
    present: n || f
  }, /* @__PURE__ */ F.exports.createElement(jD, Dr({
    "data-state": f ? "visible" : "hidden"
  }, r, {
    ref: t
  })));
}), Jq = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, s = Xs($c, e.__scopeScrollArea), f = e.orientation === "horizontal", m = Fw(
    () => v("SCROLL_END"),
    100
  ), [p, v] = Uq("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return F.exports.useEffect(() => {
    if (p === "idle") {
      const y = window.setTimeout(
        () => v("HIDE"),
        s.scrollHideDelay
      );
      return () => window.clearTimeout(y);
    }
  }, [
    p,
    s.scrollHideDelay,
    v
  ]), F.exports.useEffect(() => {
    const y = s.viewport, w = f ? "scrollLeft" : "scrollTop";
    if (y) {
      let P = y[w];
      const x = () => {
        const A = y[w];
        P !== A && (v("SCROLL"), m()), P = A;
      };
      return y.addEventListener("scroll", x), () => y.removeEventListener("scroll", x);
    }
  }, [
    s.viewport,
    f,
    v,
    m
  ]), /* @__PURE__ */ F.exports.createElement(pg, {
    present: n || p !== "hidden"
  }, /* @__PURE__ */ F.exports.createElement(BS, Dr({
    "data-state": p === "hidden" ? "hidden" : "visible"
  }, r, {
    ref: t,
    onPointerEnter: sm(
      e.onPointerEnter,
      () => v("POINTER_ENTER")
    ),
    onPointerLeave: sm(
      e.onPointerLeave,
      () => v("POINTER_LEAVE")
    )
  })));
}), jD = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const n = Xs($c, e.__scopeScrollArea), { forceMount: r, ...s } = e, [f, m] = F.exports.useState(!1), p = e.orientation === "horizontal", v = Fw(() => {
    if (n.viewport) {
      const y = n.viewport.offsetWidth < n.viewport.scrollWidth, w = n.viewport.offsetHeight < n.viewport.scrollHeight;
      m(p ? y : w);
    }
  }, 10);
  return Yh(n.viewport, v), Yh(n.content, v), /* @__PURE__ */ F.exports.createElement(pg, {
    present: r || f
  }, /* @__PURE__ */ F.exports.createElement(BS, Dr({
    "data-state": f ? "visible" : "hidden"
  }, s, {
    ref: t
  })));
}), BS = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, s = Xs($c, e.__scopeScrollArea), f = F.exports.useRef(null), m = F.exports.useRef(0), [p, v] = F.exports.useState({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }), y = FD(p.viewport, p.content), w = {
    ...r,
    sizes: p,
    onSizesChange: v,
    hasThumb: Boolean(y > 0 && y < 1),
    onThumbChange: (x) => f.current = x,
    onThumbPointerUp: () => m.current = 0,
    onThumbPointerDown: (x) => m.current = x
  };
  function P(x, A) {
    return oY(x, m.current, p, A);
  }
  return n === "horizontal" ? /* @__PURE__ */ F.exports.createElement(Zq, Dr({}, w, {
    ref: t,
    onThumbPositionChange: () => {
      if (s.viewport && f.current) {
        const x = s.viewport.scrollLeft, A = z_(x, p, s.dir);
        f.current.style.transform = `translate3d(${A}px, 0, 0)`;
      }
    },
    onWheelScroll: (x) => {
      s.viewport && (s.viewport.scrollLeft = x);
    },
    onDragScroll: (x) => {
      s.viewport && (s.viewport.scrollLeft = P(x, s.dir));
    }
  })) : n === "vertical" ? /* @__PURE__ */ F.exports.createElement(eY, Dr({}, w, {
    ref: t,
    onThumbPositionChange: () => {
      if (s.viewport && f.current) {
        const x = s.viewport.scrollTop, A = z_(x, p);
        f.current.style.transform = `translate3d(0, ${A}px, 0)`;
      }
    },
    onWheelScroll: (x) => {
      s.viewport && (s.viewport.scrollTop = x);
    },
    onDragScroll: (x) => {
      s.viewport && (s.viewport.scrollTop = P(x));
    }
  })) : null;
}), Zq = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...s } = e, f = Xs($c, e.__scopeScrollArea), [m, p] = F.exports.useState(), v = F.exports.useRef(null), y = dm(t, v, f.onScrollbarXChange);
  return F.exports.useEffect(() => {
    v.current && p(getComputedStyle(v.current));
  }, [
    v
  ]), /* @__PURE__ */ F.exports.createElement(LD, Dr({
    "data-orientation": "horizontal"
  }, s, {
    ref: y,
    sizes: n,
    style: {
      bottom: 0,
      left: f.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
      right: f.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
      ["--radix-scroll-area-thumb-width"]: Iw(n) + "px",
      ...e.style
    },
    onThumbPointerDown: (w) => e.onThumbPointerDown(w.x),
    onDragScroll: (w) => e.onDragScroll(w.x),
    onWheelScroll: (w, P) => {
      if (f.viewport) {
        const x = f.viewport.scrollLeft + w.deltaX;
        e.onWheelScroll(x), VD(x, P) && w.preventDefault();
      }
    },
    onResize: () => {
      v.current && f.viewport && m && r({
        content: f.viewport.scrollWidth,
        viewport: f.viewport.offsetWidth,
        scrollbar: {
          size: v.current.clientWidth,
          paddingStart: R1(m.paddingLeft),
          paddingEnd: R1(m.paddingRight)
        }
      });
    }
  }));
}), eY = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...s } = e, f = Xs($c, e.__scopeScrollArea), [m, p] = F.exports.useState(), v = F.exports.useRef(null), y = dm(t, v, f.onScrollbarYChange);
  return F.exports.useEffect(() => {
    v.current && p(getComputedStyle(v.current));
  }, [
    v
  ]), /* @__PURE__ */ F.exports.createElement(LD, Dr({
    "data-orientation": "vertical"
  }, s, {
    ref: y,
    sizes: n,
    style: {
      top: 0,
      right: f.dir === "ltr" ? 0 : void 0,
      left: f.dir === "rtl" ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      ["--radix-scroll-area-thumb-height"]: Iw(n) + "px",
      ...e.style
    },
    onThumbPointerDown: (w) => e.onThumbPointerDown(w.y),
    onDragScroll: (w) => e.onDragScroll(w.y),
    onWheelScroll: (w, P) => {
      if (f.viewport) {
        const x = f.viewport.scrollTop + w.deltaY;
        e.onWheelScroll(x), VD(x, P) && w.preventDefault();
      }
    },
    onResize: () => {
      v.current && f.viewport && m && r({
        content: f.viewport.scrollHeight,
        viewport: f.viewport.offsetHeight,
        scrollbar: {
          size: v.current.clientHeight,
          paddingStart: R1(m.paddingTop),
          paddingEnd: R1(m.paddingBottom)
        }
      });
    }
  }));
}), [tY, zD] = WD($c), LD = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { __scopeScrollArea: n, sizes: r, hasThumb: s, onThumbChange: f, onThumbPointerUp: m, onThumbPointerDown: p, onThumbPositionChange: v, onDragScroll: y, onWheelScroll: w, onResize: P, ...x } = e, A = Xs($c, n), [M, O] = F.exports.useState(null), j = dm(
    t,
    (ye) => O(ye)
  ), H = F.exports.useRef(null), J = F.exports.useRef(""), V = A.viewport, X = r.content - r.viewport, U = nm(w), K = nm(v), ce = Fw(P, 10);
  function ue(ye) {
    if (H.current) {
      const Oe = ye.clientX - H.current.left, _e = ye.clientY - H.current.top;
      y({
        x: Oe,
        y: _e
      });
    }
  }
  return F.exports.useEffect(() => {
    const ye = (Oe) => {
      const _e = Oe.target;
      (M == null ? void 0 : M.contains(_e)) && U(Oe, X);
    };
    return document.addEventListener("wheel", ye, {
      passive: !1
    }), () => document.removeEventListener("wheel", ye, {
      passive: !1
    });
  }, [
    V,
    M,
    X,
    U
  ]), F.exports.useEffect(K, [
    r,
    K
  ]), Yh(M, ce), Yh(A.content, ce), /* @__PURE__ */ F.exports.createElement(tY, {
    scope: n,
    scrollbar: M,
    hasThumb: s,
    onThumbChange: nm(f),
    onThumbPointerUp: nm(m),
    onThumbPositionChange: K,
    onThumbPointerDown: nm(p)
  }, /* @__PURE__ */ F.exports.createElement(hg.div, Dr({}, x, {
    ref: j,
    style: {
      position: "absolute",
      ...x.style
    },
    onPointerDown: sm(e.onPointerDown, (ye) => {
      ye.button === 0 && (ye.target.setPointerCapture(ye.pointerId), H.current = M.getBoundingClientRect(), J.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", ue(ye));
    }),
    onPointerMove: sm(e.onPointerMove, ue),
    onPointerUp: sm(e.onPointerUp, (ye) => {
      ye.target.releasePointerCapture(ye.pointerId), document.body.style.webkitUserSelect = J.current, H.current = null;
    })
  })));
}), j$ = "ScrollAreaThumb", nY = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, s = zD(j$, e.__scopeScrollArea);
  return /* @__PURE__ */ F.exports.createElement(pg, {
    present: n || s.hasThumb
  }, /* @__PURE__ */ F.exports.createElement(rY, Dr({
    ref: t
  }, r)));
}), rY = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { __scopeScrollArea: n, style: r, ...s } = e, f = Xs(j$, n), m = zD(j$, n), { onThumbPositionChange: p } = m, v = dm(
    t,
    (P) => m.onThumbChange(P)
  ), y = F.exports.useRef(), w = Fw(() => {
    y.current && (y.current(), y.current = void 0);
  }, 100);
  return F.exports.useEffect(() => {
    const P = f.viewport;
    if (P) {
      const x = () => {
        if (w(), !y.current) {
          const A = sY(P, p);
          y.current = A, p();
        }
      };
      return p(), P.addEventListener("scroll", x), () => P.removeEventListener("scroll", x);
    }
  }, [
    f.viewport,
    w,
    p
  ]), /* @__PURE__ */ F.exports.createElement(hg.div, Dr({
    "data-state": m.hasThumb ? "visible" : "hidden"
  }, s, {
    ref: v,
    style: {
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)",
      ...r
    },
    onPointerDownCapture: sm(e.onPointerDownCapture, (P) => {
      const A = P.target.getBoundingClientRect(), M = P.clientX - A.left, O = P.clientY - A.top;
      m.onThumbPointerDown({
        x: M,
        y: O
      });
    }),
    onPointerUp: sm(e.onPointerUp, m.onThumbPointerUp)
  }));
}), ID = "ScrollAreaCorner", aY = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const n = Xs(ID, e.__scopeScrollArea), r = Boolean(n.scrollbarX && n.scrollbarY);
  return n.type !== "scroll" && r ? /* @__PURE__ */ F.exports.createElement(iY, Dr({}, e, {
    ref: t
  })) : null;
}), iY = /* @__PURE__ */ F.exports.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, s = Xs(ID, n), [f, m] = F.exports.useState(0), [p, v] = F.exports.useState(0), y = Boolean(f && p);
  return Yh(s.scrollbarX, () => {
    var w;
    const P = ((w = s.scrollbarX) === null || w === void 0 ? void 0 : w.offsetHeight) || 0;
    s.onCornerHeightChange(P), v(P);
  }), Yh(s.scrollbarY, () => {
    var w;
    const P = ((w = s.scrollbarY) === null || w === void 0 ? void 0 : w.offsetWidth) || 0;
    s.onCornerWidthChange(P), m(P);
  }), y ? /* @__PURE__ */ F.exports.createElement(hg.div, Dr({}, r, {
    ref: t,
    style: {
      width: f,
      height: p,
      position: "absolute",
      right: s.dir === "ltr" ? 0 : void 0,
      left: s.dir === "rtl" ? 0 : void 0,
      bottom: 0,
      ...e.style
    }
  })) : null;
});
function R1(e) {
  return e ? parseInt(e, 10) : 0;
}
function FD(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Iw(e) {
  const t = FD(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function oY(e, t, n, r = "ltr") {
  const s = Iw(n), f = s / 2, m = t || f, p = s - m, v = n.scrollbar.paddingStart + m, y = n.scrollbar.size - n.scrollbar.paddingEnd - p, w = n.content - n.viewport, P = r === "ltr" ? [
    0,
    w
  ] : [
    w * -1,
    0
  ];
  return HD([
    v,
    y
  ], P)(e);
}
function z_(e, t, n = "ltr") {
  const r = Iw(t), s = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, f = t.scrollbar.size - s, m = t.content - t.viewport, p = f - r, v = n === "ltr" ? [
    0,
    m
  ] : [
    m * -1,
    0
  ], y = Bq(e, v);
  return HD([
    0,
    m
  ], [
    0,
    p
  ])(y);
}
function HD(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function VD(e, t) {
  return e > 0 && e < t;
}
const sY = (e, t = () => {
}) => {
  let n = {
    left: e.scrollLeft,
    top: e.scrollTop
  }, r = 0;
  return function s() {
    const f = {
      left: e.scrollLeft,
      top: e.scrollTop
    }, m = n.left !== f.left, p = n.top !== f.top;
    (m || p) && t(), n = f, r = window.requestAnimationFrame(s);
  }(), () => window.cancelAnimationFrame(r);
};
function Fw(e, t) {
  const n = nm(e), r = F.exports.useRef(0);
  return F.exports.useEffect(
    () => () => window.clearTimeout(r.current),
    []
  ), F.exports.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [
    n,
    t
  ]);
}
function Yh(e, t) {
  const n = nm(t);
  W$(() => {
    let r = 0;
    if (e) {
      const s = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return s.observe(e), () => {
        window.cancelAnimationFrame(r), s.unobserve(e);
      };
    }
  }, [
    e,
    n
  ]);
}
const lY = qq, uY = Gq, L_ = Qq, I_ = nY, cY = aY;
var dY = $n((e, { scrollbarSize: t, offsetScrollbars: n, scrollbarHovered: r, hidden: s }, f) => ({
  root: {
    overflow: "hidden"
  },
  viewport: {
    width: "100%",
    height: "100%",
    paddingRight: n ? t : void 0,
    paddingBottom: n ? t : void 0
  },
  scrollbar: {
    display: s ? "none" : "flex",
    userSelect: "none",
    touchAction: "none",
    boxSizing: "border-box",
    padding: t / 5,
    transition: "background-color 150ms ease, opacity 150ms ease",
    "&:hover": {
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[8] : e.colors.gray[0],
      [`& .${f("thumb")}`]: {
        backgroundColor: e.colorScheme === "dark" ? e.fn.rgba(e.white, 0.5) : e.fn.rgba(e.black, 0.5)
      }
    },
    '&[data-orientation="vertical"]': {
      width: t
    },
    '&[data-orientation="horizontal"]': {
      flexDirection: "column",
      height: t
    },
    '&[data-state="hidden"]': {
      display: "none",
      opacity: 0
    }
  },
  thumb: {
    ref: f("thumb"),
    flex: 1,
    backgroundColor: e.colorScheme === "dark" ? e.fn.rgba(e.white, 0.4) : e.fn.rgba(e.black, 0.4),
    borderRadius: t,
    position: "relative",
    transition: "background-color 150ms ease",
    display: s ? "none" : void 0,
    "&::before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      height: "100%"
    }
  },
  corner: {
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0],
    transition: "opacity 150ms ease",
    opacity: r ? 1 : 0,
    display: s ? "none" : void 0
  }
}));
const fY = dY;
var mY = Object.defineProperty, hY = Object.defineProperties, pY = Object.getOwnPropertyDescriptors, D1 = Object.getOwnPropertySymbols, BD = Object.prototype.hasOwnProperty, UD = Object.prototype.propertyIsEnumerable, F_ = (e, t, n) => t in e ? mY(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, XD = (e, t) => {
  for (var n in t || (t = {}))
    BD.call(t, n) && F_(e, n, t[n]);
  if (D1)
    for (var n of D1(t))
      UD.call(t, n) && F_(e, n, t[n]);
  return e;
}, vY = (e, t) => hY(e, pY(t)), qD = (e, t) => {
  var n = {};
  for (var r in e)
    BD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && D1)
    for (var r of D1(e))
      t.indexOf(r) < 0 && UD.call(e, r) && (n[r] = e[r]);
  return n;
};
const YD = {
  scrollbarSize: 12,
  scrollHideDelay: 1e3,
  type: "hover",
  offsetScrollbars: !1
}, Hw = F.exports.forwardRef((e, t) => {
  const n = Er("ScrollArea", YD, e), {
    children: r,
    className: s,
    classNames: f,
    styles: m,
    scrollbarSize: p,
    scrollHideDelay: v,
    type: y,
    dir: w,
    offsetScrollbars: P,
    viewportRef: x,
    onScrollPositionChange: A,
    unstyled: M
  } = n, O = qD(n, [
    "children",
    "className",
    "classNames",
    "styles",
    "scrollbarSize",
    "scrollHideDelay",
    "type",
    "dir",
    "offsetScrollbars",
    "viewportRef",
    "onScrollPositionChange",
    "unstyled"
  ]), [j, H] = F.exports.useState(!1), J = vu(), { classes: V, cx: X } = fY({ scrollbarSize: p, offsetScrollbars: P, scrollbarHovered: j, hidden: y === "never" }, { name: "ScrollArea", classNames: f, styles: m, unstyled: M });
  return /* @__PURE__ */ T.createElement(lY, {
    type: y === "never" ? "always" : y,
    scrollHideDelay: v,
    dir: w || J.dir,
    ref: t,
    asChild: !0
  }, /* @__PURE__ */ T.createElement(Gn, XD({
    className: X(V.root, s)
  }, O), /* @__PURE__ */ T.createElement(uY, {
    className: V.viewport,
    ref: x,
    onScroll: typeof A == "function" ? ({ currentTarget: U }) => A({
      x: U.scrollLeft,
      y: U.scrollTop
    }) : void 0
  }, r), /* @__PURE__ */ T.createElement(L_, {
    orientation: "horizontal",
    className: V.scrollbar,
    forceMount: !0,
    onMouseEnter: () => H(!0),
    onMouseLeave: () => H(!1)
  }, /* @__PURE__ */ T.createElement(I_, {
    className: V.thumb
  })), /* @__PURE__ */ T.createElement(L_, {
    orientation: "vertical",
    className: V.scrollbar,
    forceMount: !0,
    onMouseEnter: () => H(!0),
    onMouseLeave: () => H(!1)
  }, /* @__PURE__ */ T.createElement(I_, {
    className: V.thumb
  })), /* @__PURE__ */ T.createElement(cY, {
    className: V.corner
  })));
}), GD = F.exports.forwardRef((e, t) => {
  const n = Er("ScrollAreaAutosize", YD, e), {
    maxHeight: r,
    children: s,
    classNames: f,
    styles: m,
    scrollbarSize: p,
    scrollHideDelay: v,
    type: y,
    dir: w,
    offsetScrollbars: P,
    viewportRef: x,
    onScrollPositionChange: A,
    unstyled: M,
    sx: O
  } = n, j = qD(n, [
    "maxHeight",
    "children",
    "classNames",
    "styles",
    "scrollbarSize",
    "scrollHideDelay",
    "type",
    "dir",
    "offsetScrollbars",
    "viewportRef",
    "onScrollPositionChange",
    "unstyled",
    "sx"
  ]);
  return /* @__PURE__ */ T.createElement(Gn, vY(XD({}, j), {
    ref: t,
    sx: [{ display: "flex", maxHeight: r }, ...f1(O)]
  }), /* @__PURE__ */ T.createElement(Gn, {
    sx: { display: "flex", flexDirection: "column", flex: 1 }
  }, /* @__PURE__ */ T.createElement(Hw, {
    classNames: f,
    styles: m,
    scrollHideDelay: v,
    scrollbarSize: p,
    type: y,
    dir: w,
    offsetScrollbars: P,
    viewportRef: x,
    onScrollPositionChange: A,
    unstyled: M
  }, s)));
});
GD.displayName = "@mantine/core/ScrollAreaAutosize";
Hw.displayName = "@mantine/core/ScrollArea";
Hw.Autosize = GD;
const gY = Hw;
function yc(e) {
  return e.split("-")[0];
}
function vg(e) {
  return e.split("-")[1];
}
function fm(e) {
  return ["top", "bottom"].includes(yc(e)) ? "x" : "y";
}
function US(e) {
  return e === "y" ? "height" : "width";
}
function H_(e, t, n) {
  let {
    reference: r,
    floating: s
  } = e;
  const f = r.x + r.width / 2 - s.width / 2, m = r.y + r.height / 2 - s.height / 2, p = fm(t), v = US(p), y = r[v] / 2 - s[v] / 2, w = yc(t), P = p === "x";
  let x;
  switch (w) {
    case "top":
      x = {
        x: f,
        y: r.y - s.height
      };
      break;
    case "bottom":
      x = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      x = {
        x: r.x + r.width,
        y: m
      };
      break;
    case "left":
      x = {
        x: r.x - s.width,
        y: m
      };
      break;
    default:
      x = {
        x: r.x,
        y: r.y
      };
  }
  switch (vg(t)) {
    case "start":
      x[p] -= y * (n && P ? -1 : 1);
      break;
    case "end":
      x[p] += y * (n && P ? -1 : 1);
      break;
  }
  return x;
}
const yY = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: s = "absolute",
    middleware: f = [],
    platform: m
  } = n, p = await (m.isRTL == null ? void 0 : m.isRTL(t));
  if (process.env.NODE_ENV !== "production" && (m == null && console.error(["Floating UI: `platform` property was not passed to config. If you", "want to use Floating UI on the web, install @floating-ui/dom", "instead of the /core package. Otherwise, you can create your own", "`platform`: https://floating-ui.com/docs/platform"].join(" ")), f.filter((M) => {
    let {
      name: O
    } = M;
    return O === "autoPlacement" || O === "flip";
  }).length > 1))
    throw new Error(["Floating UI: duplicate `flip` and/or `autoPlacement`", "middleware detected. This will lead to an infinite loop. Ensure only", "one of either has been passed to the `middleware` array."].join(" "));
  let v = await m.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: y,
    y: w
  } = H_(v, r, p), P = r, x = {}, A = 0;
  for (let M = 0; M < f.length; M++) {
    const {
      name: O,
      fn: j
    } = f[M], {
      x: H,
      y: J,
      data: V,
      reset: X
    } = await j({
      x: y,
      y: w,
      initialPlacement: r,
      placement: P,
      strategy: s,
      middlewareData: x,
      rects: v,
      platform: m,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (y = H ?? y, w = J ?? w, x = {
      ...x,
      [O]: {
        ...x[O],
        ...V
      }
    }, process.env.NODE_ENV !== "production" && A > 50 && console.warn(["Floating UI: The middleware lifecycle appears to be running in an", "infinite loop. This is usually caused by a `reset` continually", "being returned without a break condition."].join(" ")), X && A <= 50) {
      A++, typeof X == "object" && (X.placement && (P = X.placement), X.rects && (v = X.rects === !0 ? await m.getElementRects({
        reference: e,
        floating: t,
        strategy: s
      }) : X.rects), {
        x: y,
        y: w
      } = H_(v, P, p)), M = -1;
      continue;
    }
  }
  return {
    x: y,
    y: w,
    placement: P,
    strategy: s,
    middlewareData: x
  };
};
function bY(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function XS(e) {
  return typeof e != "number" ? bY(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ng(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
async function qS(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: s,
    platform: f,
    rects: m,
    elements: p,
    strategy: v
  } = e, {
    boundary: y = "clippingAncestors",
    rootBoundary: w = "viewport",
    elementContext: P = "floating",
    altBoundary: x = !1,
    padding: A = 0
  } = t, M = XS(A), j = p[x ? P === "floating" ? "reference" : "floating" : P], H = ng(await f.getClippingRect({
    element: (n = await (f.isElement == null ? void 0 : f.isElement(j))) == null || n ? j : j.contextElement || await (f.getDocumentElement == null ? void 0 : f.getDocumentElement(p.floating)),
    boundary: y,
    rootBoundary: w,
    strategy: v
  })), J = ng(f.convertOffsetParentRelativeRectToViewportRelativeRect ? await f.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: P === "floating" ? {
      ...m.floating,
      x: r,
      y: s
    } : m.reference,
    offsetParent: await (f.getOffsetParent == null ? void 0 : f.getOffsetParent(p.floating)),
    strategy: v
  }) : m[P]);
  return {
    top: H.top - J.top + M.top,
    bottom: J.bottom - H.bottom + M.bottom,
    left: H.left - J.left + M.left,
    right: J.right - H.right + M.right
  };
}
const QD = Math.min, md = Math.max;
function z$(e, t, n) {
  return md(e, QD(t, n));
}
const V_ = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      element: n,
      padding: r = 0
    } = e ?? {}, {
      x: s,
      y: f,
      placement: m,
      rects: p,
      platform: v
    } = t;
    if (n == null)
      return process.env.NODE_ENV !== "production" && console.warn("Floating UI: No `element` was passed to the `arrow` middleware."), {};
    const y = XS(r), w = {
      x: s,
      y: f
    }, P = fm(m), x = vg(m), A = US(P), M = await v.getDimensions(n), O = P === "y" ? "top" : "left", j = P === "y" ? "bottom" : "right", H = p.reference[A] + p.reference[P] - w[P] - p.floating[A], J = w[P] - p.reference[P], V = await (v.getOffsetParent == null ? void 0 : v.getOffsetParent(n));
    let X = V ? P === "y" ? V.clientHeight || 0 : V.clientWidth || 0 : 0;
    X === 0 && (X = p.floating[A]);
    const U = H / 2 - J / 2, K = y[O], ce = X - M[A] - y[j], ue = X / 2 - M[A] / 2 + U, ye = z$(K, ue, ce), Le = (x === "start" ? y[O] : y[j]) > 0 && ue !== ye && p.reference[A] <= p.floating[A] ? ue < K ? K - ue : ce - ue : 0;
    return {
      [P]: w[P] - Le,
      data: {
        [P]: ye,
        centerOffset: ue - ye
      }
    };
  }
}), wY = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function N1(e) {
  return e.replace(/left|right|bottom|top/g, (t) => wY[t]);
}
function PY(e, t, n) {
  n === void 0 && (n = !1);
  const r = vg(e), s = fm(e), f = US(s);
  let m = s === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[f] > t.floating[f] && (m = N1(m)), {
    main: m,
    cross: N1(m)
  };
}
const kY = {
  start: "end",
  end: "start"
};
function B_(e) {
  return e.replace(/start|end/g, (t) => kY[t]);
}
function $Y(e) {
  const t = N1(e);
  return [B_(e), t, B_(t)];
}
const SY = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: s,
        rects: f,
        initialPlacement: m,
        platform: p,
        elements: v
      } = t, {
        mainAxis: y = !0,
        crossAxis: w = !0,
        fallbackPlacements: P,
        fallbackStrategy: x = "bestFit",
        flipAlignment: A = !0,
        ...M
      } = e, O = yc(r), H = P || (O === m || !A ? [N1(m)] : $Y(m)), J = [m, ...H], V = await qS(t, M), X = [];
      let U = ((n = s.flip) == null ? void 0 : n.overflows) || [];
      if (y && X.push(V[O]), w) {
        const {
          main: ye,
          cross: Oe
        } = PY(r, f, await (p.isRTL == null ? void 0 : p.isRTL(v.floating)));
        X.push(V[ye], V[Oe]);
      }
      if (U = [...U, {
        placement: r,
        overflows: X
      }], !X.every((ye) => ye <= 0)) {
        var K, ce;
        const ye = ((K = (ce = s.flip) == null ? void 0 : ce.index) != null ? K : 0) + 1, Oe = J[ye];
        if (Oe)
          return {
            data: {
              index: ye,
              overflows: U
            },
            reset: {
              placement: Oe
            }
          };
        let _e = "bottom";
        switch (x) {
          case "bestFit": {
            var ue;
            const Le = (ue = U.map((Ne) => [Ne, Ne.overflows.filter((nt) => nt > 0).reduce((nt, Qe) => nt + Qe, 0)]).sort((Ne, nt) => Ne[1] - nt[1])[0]) == null ? void 0 : ue[0].placement;
            Le && (_e = Le);
            break;
          }
          case "initialPlacement":
            _e = m;
            break;
        }
        if (r !== _e)
          return {
            reset: {
              placement: _e
            }
          };
      }
      return {};
    }
  };
};
async function xY(e, t) {
  const {
    placement: n,
    platform: r,
    elements: s
  } = e, f = await (r.isRTL == null ? void 0 : r.isRTL(s.floating)), m = yc(n), p = vg(n), v = fm(n) === "x", y = ["left", "top"].includes(m) ? -1 : 1, w = f && v ? -1 : 1, P = typeof t == "function" ? t(e) : t;
  let {
    mainAxis: x,
    crossAxis: A,
    alignmentAxis: M
  } = typeof P == "number" ? {
    mainAxis: P,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...P
  };
  return p && typeof M == "number" && (A = p === "end" ? M * -1 : M), v ? {
    x: A * w,
    y: x * y
  } : {
    x: x * y,
    y: A * w
  };
}
const CY = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, s = await xY(t, e);
      return {
        x: n + s.x,
        y: r + s.y,
        data: s
      };
    }
  };
};
function KD(e) {
  return e === "x" ? "y" : "x";
}
const MY = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: s
      } = t, {
        mainAxis: f = !0,
        crossAxis: m = !1,
        limiter: p = {
          fn: (j) => {
            let {
              x: H,
              y: J
            } = j;
            return {
              x: H,
              y: J
            };
          }
        },
        ...v
      } = e, y = {
        x: n,
        y: r
      }, w = await qS(t, v), P = fm(yc(s)), x = KD(P);
      let A = y[P], M = y[x];
      if (f) {
        const j = P === "y" ? "top" : "left", H = P === "y" ? "bottom" : "right", J = A + w[j], V = A - w[H];
        A = z$(J, A, V);
      }
      if (m) {
        const j = x === "y" ? "top" : "left", H = x === "y" ? "bottom" : "right", J = M + w[j], V = M - w[H];
        M = z$(J, M, V);
      }
      const O = p.fn({
        ...t,
        [P]: A,
        [x]: M
      });
      return {
        ...O,
        data: {
          x: O.x - n,
          y: O.y - r
        }
      };
    }
  };
}, EY = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: s,
        rects: f,
        middlewareData: m
      } = t, {
        offset: p = 0,
        mainAxis: v = !0,
        crossAxis: y = !0
      } = e, w = {
        x: n,
        y: r
      }, P = fm(s), x = KD(P);
      let A = w[P], M = w[x];
      const O = typeof p == "function" ? p(t) : p, j = typeof O == "number" ? {
        mainAxis: O,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...O
      };
      if (v) {
        const U = P === "y" ? "height" : "width", K = f.reference[P] - f.floating[U] + j.mainAxis, ce = f.reference[P] + f.reference[U] - j.mainAxis;
        A < K ? A = K : A > ce && (A = ce);
      }
      if (y) {
        var H, J, V, X;
        const U = P === "y" ? "width" : "height", K = ["top", "left"].includes(yc(s)), ce = f.reference[x] - f.floating[U] + (K && (H = (J = m.offset) == null ? void 0 : J[x]) != null ? H : 0) + (K ? 0 : j.crossAxis), ue = f.reference[x] + f.reference[U] + (K ? 0 : (V = (X = m.offset) == null ? void 0 : X[x]) != null ? V : 0) - (K ? j.crossAxis : 0);
        M < ce ? M = ce : M > ue && (M = ue);
      }
      return {
        [P]: A,
        [x]: M
      };
    }
  };
}, AY = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: s,
        elements: f
      } = t, {
        apply: m = () => {
        },
        ...p
      } = e, v = await qS(t, p), y = yc(n), w = vg(n);
      let P, x;
      y === "top" || y === "bottom" ? (P = y, x = w === (await (s.isRTL == null ? void 0 : s.isRTL(f.floating)) ? "start" : "end") ? "left" : "right") : (x = y, P = w === "end" ? "top" : "bottom");
      const A = md(v.left, 0), M = md(v.right, 0), O = md(v.top, 0), j = md(v.bottom, 0), H = {
        availableHeight: r.floating.height - (["left", "right"].includes(n) ? 2 * (O !== 0 || j !== 0 ? O + j : md(v.top, v.bottom)) : v[P]),
        availableWidth: r.floating.width - (["top", "bottom"].includes(n) ? 2 * (A !== 0 || M !== 0 ? A + M : md(v.left, v.right)) : v[x])
      };
      await m({
        ...t,
        ...H
      });
      const J = await s.getDimensions(f.floating);
      return r.floating.width !== J.width || r.floating.height !== J.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
}, _Y = function(e) {
  return e === void 0 && (e = {}), {
    name: "inline",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        elements: s,
        rects: f,
        platform: m,
        strategy: p
      } = t, {
        padding: v = 2,
        x: y,
        y: w
      } = e, P = ng(m.convertOffsetParentRelativeRectToViewportRelativeRect ? await m.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: f.reference,
        offsetParent: await (m.getOffsetParent == null ? void 0 : m.getOffsetParent(s.floating)),
        strategy: p
      }) : f.reference), x = (n = await (m.getClientRects == null ? void 0 : m.getClientRects(s.reference))) != null ? n : [], A = XS(v);
      function M() {
        if (x.length === 2 && x[0].left > x[1].right && y != null && w != null) {
          var j;
          return (j = x.find((H) => y > H.left - A.left && y < H.right + A.right && w > H.top - A.top && w < H.bottom + A.bottom)) != null ? j : P;
        }
        if (x.length >= 2) {
          if (fm(r) === "x") {
            const _e = x[0], Le = x[x.length - 1], Ne = yc(r) === "top", nt = _e.top, Qe = Le.bottom, qe = Ne ? _e.left : Le.left, ie = Ne ? _e.right : Le.right, xe = ie - qe, Ye = Qe - nt;
            return {
              top: nt,
              bottom: Qe,
              left: qe,
              right: ie,
              width: xe,
              height: Ye,
              x: qe,
              y: nt
            };
          }
          const H = yc(r) === "left", J = md(...x.map((_e) => _e.right)), V = QD(...x.map((_e) => _e.left)), X = x.filter((_e) => H ? _e.left === V : _e.right === J), U = X[0].top, K = X[X.length - 1].bottom, ce = V, ue = J, ye = ue - ce, Oe = K - U;
          return {
            top: U,
            bottom: K,
            left: ce,
            right: ue,
            width: ye,
            height: Oe,
            x: ce,
            y: U
          };
        }
        return P;
      }
      const O = await m.getElementRects({
        reference: {
          getBoundingClientRect: M
        },
        floating: s.floating,
        strategy: p
      });
      return f.reference.x !== O.reference.x || f.reference.y !== O.reference.y || f.reference.width !== O.reference.width || f.reference.height !== O.reference.height ? {
        reset: {
          rects: O
        }
      } : {};
    }
  };
};
function JD(e) {
  return e && e.document && e.location && e.alert && e.setInterval;
}
function Sc(e) {
  if (e == null)
    return window;
  if (!JD(e)) {
    const t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function $d(e) {
  return Sc(e).getComputedStyle(e);
}
function Sd(e) {
  return JD(e) ? "" : e ? (e.nodeName || "").toLowerCase() : "";
}
function ZD() {
  const e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map((t) => t.brand + "/" + t.version).join(" ") : navigator.userAgent;
}
function $l(e) {
  return e instanceof Sc(e).HTMLElement;
}
function mu(e) {
  return e instanceof Sc(e).Element;
}
function OY(e) {
  return e instanceof Sc(e).Node;
}
function rg(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  const t = Sc(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function gg(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: s
  } = $d(e);
  return /auto|scroll|overlay|hidden/.test(t + r + n) && !["inline", "contents"].includes(s);
}
function TY(e) {
  return ["table", "td", "th"].includes(Sd(e));
}
function eN(e) {
  const t = /firefox/i.test(ZD()), n = $d(e);
  return n.transform !== "none" || n.perspective !== "none" || t && n.willChange === "filter" || t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective"].some((r) => n.willChange.includes(r)) || ["paint", "layout", "strict", "content"].some(
    (r) => {
      const s = n.contain;
      return s != null ? s.includes(r) : !1;
    }
  );
}
function tN() {
  return !/^((?!chrome|android).)*safari/i.test(ZD());
}
function YS(e) {
  return ["html", "body", "#document"].includes(Sd(e));
}
const U_ = Math.min, Fv = Math.max, W1 = Math.round;
function bc(e, t, n) {
  var r, s, f, m;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const p = e.getBoundingClientRect();
  let v = 1, y = 1;
  t && $l(e) && (v = e.offsetWidth > 0 && W1(p.width) / e.offsetWidth || 1, y = e.offsetHeight > 0 && W1(p.height) / e.offsetHeight || 1);
  const w = mu(e) ? Sc(e) : window, P = !tN() && n, x = (p.left + (P && (r = (s = w.visualViewport) == null ? void 0 : s.offsetLeft) != null ? r : 0)) / v, A = (p.top + (P && (f = (m = w.visualViewport) == null ? void 0 : m.offsetTop) != null ? f : 0)) / y, M = p.width / v, O = p.height / y;
  return {
    width: M,
    height: O,
    top: A,
    right: x + M,
    bottom: A + O,
    left: x,
    x,
    y: A
  };
}
function Ed(e) {
  return ((OY(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Vw(e) {
  return mu(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function nN(e) {
  return bc(Ed(e)).left + Vw(e).scrollLeft;
}
function RY(e) {
  const t = bc(e);
  return W1(t.width) !== e.offsetWidth || W1(t.height) !== e.offsetHeight;
}
function DY(e, t, n) {
  const r = $l(t), s = Ed(t), f = bc(
    e,
    r && RY(t),
    n === "fixed"
  );
  let m = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const p = {
    x: 0,
    y: 0
  };
  if (r || !r && n !== "fixed")
    if ((Sd(t) !== "body" || gg(s)) && (m = Vw(t)), $l(t)) {
      const v = bc(t, !0);
      p.x = v.x + t.clientLeft, p.y = v.y + t.clientTop;
    } else
      s && (p.x = nN(s));
  return {
    x: f.left + m.scrollLeft - p.x,
    y: f.top + m.scrollTop - p.y,
    width: f.width,
    height: f.height
  };
}
function GS(e) {
  return Sd(e) === "html" ? e : e.assignedSlot || e.parentNode || (rg(e) ? e.host : null) || Ed(e);
}
function X_(e) {
  return !$l(e) || $d(e).position === "fixed" ? null : e.offsetParent;
}
function NY(e) {
  let t = GS(e);
  for (rg(t) && (t = t.host); $l(t) && !YS(t); ) {
    if (eN(t))
      return t;
    {
      const n = t.parentNode;
      t = rg(n) ? n.host : n;
    }
  }
  return null;
}
function L$(e) {
  const t = Sc(e);
  let n = X_(e);
  for (; n && TY(n) && $d(n).position === "static"; )
    n = X_(n);
  return n && (Sd(n) === "html" || Sd(n) === "body" && $d(n).position === "static" && !eN(n)) ? t : n || NY(e) || t;
}
function q_(e) {
  if ($l(e))
    return {
      width: e.offsetWidth,
      height: e.offsetHeight
    };
  const t = bc(e);
  return {
    width: t.width,
    height: t.height
  };
}
function WY(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const s = $l(n), f = Ed(n);
  if (n === f)
    return t;
  let m = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const p = {
    x: 0,
    y: 0
  };
  if ((s || !s && r !== "fixed") && ((Sd(n) !== "body" || gg(f)) && (m = Vw(n)), $l(n))) {
    const v = bc(n, !0);
    p.x = v.x + n.clientLeft, p.y = v.y + n.clientTop;
  }
  return {
    ...t,
    x: t.x - m.scrollLeft + p.x,
    y: t.y - m.scrollTop + p.y
  };
}
function jY(e, t) {
  const n = Sc(e), r = Ed(e), s = n.visualViewport;
  let f = r.clientWidth, m = r.clientHeight, p = 0, v = 0;
  if (s) {
    f = s.width, m = s.height;
    const y = tN();
    (y || !y && t === "fixed") && (p = s.offsetLeft, v = s.offsetTop);
  }
  return {
    width: f,
    height: m,
    x: p,
    y: v
  };
}
function zY(e) {
  var t;
  const n = Ed(e), r = Vw(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, f = Fv(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), m = Fv(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0);
  let p = -r.scrollLeft + nN(e);
  const v = -r.scrollTop;
  return $d(s || n).direction === "rtl" && (p += Fv(n.clientWidth, s ? s.clientWidth : 0) - f), {
    width: f,
    height: m,
    x: p,
    y: v
  };
}
function rN(e) {
  const t = GS(e);
  return YS(t) ? e.ownerDocument.body : $l(t) && gg(t) ? t : rN(t);
}
function Hv(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = rN(e), s = r === ((n = e.ownerDocument) == null ? void 0 : n.body), f = Sc(r), m = s ? [f].concat(f.visualViewport || [], gg(r) ? r : []) : r, p = t.concat(m);
  return s ? p : p.concat(Hv(m));
}
function LY(e, t) {
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && rg(n)) {
    let r = t;
    do {
      if (r && e === r)
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function IY(e, t) {
  let n = e;
  for (; n && !YS(n) && !t.includes(n) && !(mu(n) && ["absolute", "fixed"].includes($d(n).position)); ) {
    const r = GS(n);
    n = rg(r) ? r.host : r;
  }
  return n;
}
function FY(e, t) {
  const n = bc(e, !1, t === "fixed"), r = n.top + e.clientTop, s = n.left + e.clientLeft;
  return {
    top: r,
    left: s,
    x: s,
    y: r,
    right: s + e.clientWidth,
    bottom: r + e.clientHeight,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function Y_(e, t, n) {
  return t === "viewport" ? ng(jY(e, n)) : mu(t) ? FY(t, n) : ng(zY(Ed(e)));
}
function HY(e) {
  const t = Hv(e), n = IY(e, t);
  let r = null;
  if (n && $l(n)) {
    const s = L$(n);
    gg(n) ? r = n : $l(s) && (r = s);
  }
  return mu(r) ? t.filter((s) => r && mu(s) && LY(s, r) && Sd(s) !== "body") : [];
}
function VY(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: s
  } = e;
  const m = [...n === "clippingAncestors" ? HY(t) : [].concat(n), r], p = m[0], v = m.reduce((y, w) => {
    const P = Y_(t, w, s);
    return y.top = Fv(P.top, y.top), y.right = U_(P.right, y.right), y.bottom = U_(P.bottom, y.bottom), y.left = Fv(P.left, y.left), y;
  }, Y_(t, p, s));
  return {
    width: v.right - v.left,
    height: v.bottom - v.top,
    x: v.left,
    y: v.top
  };
}
const BY = {
  getClippingRect: VY,
  convertOffsetParentRelativeRectToViewportRelativeRect: WY,
  isElement: mu,
  getDimensions: q_,
  getOffsetParent: L$,
  getDocumentElement: Ed,
  getElementRects: (e) => {
    let {
      reference: t,
      floating: n,
      strategy: r
    } = e;
    return {
      reference: DY(t, L$(n), r),
      floating: {
        ...q_(n),
        x: 0,
        y: 0
      }
    };
  },
  getClientRects: (e) => Array.from(e.getClientRects()),
  isRTL: (e) => $d(e).direction === "rtl"
};
function UY(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: f = !0,
    elementResize: m = !0,
    animationFrame: p = !1
  } = r, v = s && !p, y = v || f ? [...mu(e) ? Hv(e) : e.contextElement ? Hv(e.contextElement) : [], ...Hv(t)] : [];
  y.forEach((M) => {
    v && M.addEventListener("scroll", n, {
      passive: !0
    }), f && M.addEventListener("resize", n);
  });
  let w = null;
  if (m) {
    let M = !0;
    w = new ResizeObserver(() => {
      M || n(), M = !1;
    }), mu(e) && !p && w.observe(e), !mu(e) && e.contextElement && !p && w.observe(e.contextElement), w.observe(t);
  }
  let P, x = p ? bc(e) : null;
  p && A();
  function A() {
    const M = bc(e);
    x && (M.x !== x.x || M.y !== x.y || M.width !== x.width || M.height !== x.height) && n(), x = M, P = requestAnimationFrame(A);
  }
  return n(), () => {
    var M;
    y.forEach((O) => {
      v && O.removeEventListener("scroll", n), f && O.removeEventListener("resize", n);
    }), (M = w) == null || M.disconnect(), w = null, p && cancelAnimationFrame(P);
  };
}
const XY = (e, t, n) => yY(e, t, {
  platform: BY,
  ...n
});
var I$ = typeof document < "u" ? F.exports.useLayoutEffect : F.exports.useEffect;
function j1(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, s;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!j1(e[r], t[r]))
          return !1;
      return !0;
    }
    if (s = Object.keys(e), n = s.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, s[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const f = s[r];
      if (!(f === "_owner" && e.$$typeof) && !j1(e[f], t[f]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function qY(e) {
  const t = F.exports.useRef(e);
  return I$(() => {
    t.current = e;
  }), t;
}
function YY(e) {
  let {
    middleware: t,
    placement: n = "bottom",
    strategy: r = "absolute",
    whileElementsMounted: s
  } = e === void 0 ? {} : e;
  const [f, m] = F.exports.useState({
    x: null,
    y: null,
    strategy: r,
    placement: n,
    middlewareData: {}
  }), [p, v] = F.exports.useState(t);
  j1(p == null ? void 0 : p.map((X) => {
    let {
      name: U,
      options: K
    } = X;
    return {
      name: U,
      options: K
    };
  }), t == null ? void 0 : t.map((X) => {
    let {
      name: U,
      options: K
    } = X;
    return {
      name: U,
      options: K
    };
  })) || v(t);
  const y = F.exports.useRef(null), w = F.exports.useRef(null), P = F.exports.useRef(null), x = F.exports.useRef(f), A = qY(s), M = F.exports.useCallback(() => {
    !y.current || !w.current || XY(y.current, w.current, {
      middleware: p,
      placement: n,
      strategy: r
    }).then((X) => {
      O.current && !j1(x.current, X) && (x.current = X, Zh.exports.flushSync(() => {
        m(X);
      }));
    });
  }, [p, n, r]);
  I$(() => {
    O.current && M();
  }, [M]);
  const O = F.exports.useRef(!1);
  I$(() => (O.current = !0, () => {
    O.current = !1;
  }), []);
  const j = F.exports.useCallback(() => {
    if (typeof P.current == "function" && (P.current(), P.current = null), y.current && w.current)
      if (A.current) {
        const X = A.current(y.current, w.current, M);
        P.current = X;
      } else
        M();
  }, [M, A]), H = F.exports.useCallback((X) => {
    y.current = X, j();
  }, [j]), J = F.exports.useCallback((X) => {
    w.current = X, j();
  }, [j]), V = F.exports.useMemo(() => ({
    reference: y,
    floating: w
  }), []);
  return F.exports.useMemo(() => ({
    ...f,
    update: M,
    refs: V,
    reference: H,
    floating: J
  }), [f, M, V, H, J]);
}
const GY = (e) => {
  const {
    element: t,
    padding: n
  } = e;
  function r(s) {
    return Object.prototype.hasOwnProperty.call(s, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(s) {
      return r(t) ? t.current != null ? V_({
        element: t.current,
        padding: n
      }).fn(s) : {} : t ? V_({
        element: t,
        padding: n
      }).fn(s) : {};
    }
  };
};
var QY = typeof document < "u" ? F.exports.useLayoutEffect : F.exports.useEffect;
function KY() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((s) => s(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      e.set(t, (e.get(t) || []).filter((r) => r !== n));
    }
  };
}
const JY = /* @__PURE__ */ F.exports.createContext(null), ZY = () => F.exports.useContext(JY);
function eG(e) {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) != null ? t : document;
}
function tG(e) {
  var t;
  return (t = eG(e).defaultView) != null ? t : window;
}
function nG(e) {
  return e ? e instanceof tG(e).Element : !1;
}
const G_ = Gv[/* @__PURE__ */ "useInsertionEffect".toString()];
function rG(e) {
  const t = F.exports.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return G_ ? G_(() => {
    t.current = e;
  }) : t.current = e, F.exports.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), s = 0; s < n; s++)
      r[s] = arguments[s];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function aG(e) {
  let {
    open: t = !1,
    onOpenChange: n,
    whileElementsMounted: r,
    placement: s,
    middleware: f,
    strategy: m,
    nodeId: p
  } = e === void 0 ? {} : e;
  const [v, y] = F.exports.useState(null), w = ZY(), P = F.exports.useRef(null), x = F.exports.useRef({}), A = F.exports.useState(() => KY())[0], M = YY({
    placement: s,
    middleware: f,
    strategy: m,
    whileElementsMounted: r
  }), O = rG(n), j = F.exports.useMemo(() => ({
    ...M.refs,
    domReference: P
  }), [M.refs]), H = F.exports.useMemo(() => ({
    ...M,
    refs: j,
    dataRef: x,
    nodeId: p,
    events: A,
    open: t,
    onOpenChange: O,
    _: {
      domReference: v
    }
  }), [M, p, A, t, O, j, v]);
  QY(() => {
    const X = w == null ? void 0 : w.nodesRef.current.find((U) => U.id === p);
    X && (X.context = H);
  });
  const {
    reference: J
  } = M, V = F.exports.useCallback((X) => {
    (nG(X) || X === null) && (H.refs.domReference.current = X, y(X)), J(X);
  }, [J, H.refs]);
  return F.exports.useMemo(() => ({
    ...M,
    context: H,
    refs: j,
    reference: V
  }), [M, j, H, V]);
}
function iG({ opened: e, floating: t, positionDependencies: n }) {
  const [r, s] = F.exports.useState(0);
  F.exports.useEffect(() => {
    if (t.refs.reference.current && t.refs.floating.current)
      return UY(t.refs.reference.current, t.refs.floating.current, t.update);
  }, [t.refs.reference, t.refs.floating, e, r]), kd(() => {
    t.update();
  }, n), kd(() => {
    s((f) => f + 1);
  }, [e]);
}
function oG(e) {
  const t = [CY(e.offset)];
  return e.middlewares.shift && t.push(MY({ limiter: EY() })), e.middlewares.flip && t.push(SY()), e.middlewares.inline && t.push(_Y()), t.push(GY({ element: e.arrowRef, padding: e.arrowOffset })), t;
}
function sG(e) {
  const [t, n] = Jh({
    value: e.opened,
    defaultValue: e.defaultOpened,
    finalValue: !1,
    onChange: e.onChange
  }), r = () => {
    var m;
    (m = e.onClose) == null || m.call(e), n(!1);
  }, s = () => {
    var m, p;
    t ? ((m = e.onClose) == null || m.call(e), n(!1)) : ((p = e.onOpen) == null || p.call(e), n(!0));
  }, f = aG({
    placement: e.position,
    middleware: [
      ...oG(e),
      ...e.width === "target" ? [
        AY({
          apply({ rects: m }) {
            var p, v;
            Object.assign((v = (p = f.refs.floating.current) == null ? void 0 : p.style) != null ? v : {}, {
              width: `${m.reference.width}px`
            });
          }
        })
      ] : []
    ]
  });
  return iG({
    opened: e.opened,
    positionDependencies: e.positionDependencies,
    floating: f
  }), kd(() => {
    var m;
    (m = e.onPositionChange) == null || m.call(e, f.placement);
  }, [f.placement]), {
    floating: f,
    controlled: typeof e.opened == "boolean",
    opened: t,
    onClose: r,
    onToggle: s
  };
}
const aN = {
  context: "Popover component was not found in the tree",
  children: "Popover.Target component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
}, [lG, iN] = dg(aN.context);
var uG = Object.defineProperty, cG = Object.defineProperties, dG = Object.getOwnPropertyDescriptors, z1 = Object.getOwnPropertySymbols, oN = Object.prototype.hasOwnProperty, sN = Object.prototype.propertyIsEnumerable, Q_ = (e, t, n) => t in e ? uG(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Eb = (e, t) => {
  for (var n in t || (t = {}))
    oN.call(t, n) && Q_(e, n, t[n]);
  if (z1)
    for (var n of z1(t))
      sN.call(t, n) && Q_(e, n, t[n]);
  return e;
}, fG = (e, t) => cG(e, dG(t)), mG = (e, t) => {
  var n = {};
  for (var r in e)
    oN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && z1)
    for (var r of z1(e))
      t.indexOf(r) < 0 && sN.call(e, r) && (n[r] = e[r]);
  return n;
};
const lN = F.exports.forwardRef((e, t) => {
  var n = e, { children: r, refProp: s = "ref", popupType: f = "dialog" } = n, m = mG(n, ["children", "refProp", "popupType"]);
  if (!NS(r))
    throw new Error(aN.children);
  const p = m, v = iN(), y = HS(v.reference, r.ref, t), w = v.withRoles ? {
    "aria-haspopup": f,
    "aria-expanded": v.opened,
    "aria-controls": v.getDropdownId(),
    id: v.getTargetId()
  } : {};
  return F.exports.cloneElement(r, Eb(fG(Eb(Eb(Eb({}, p), w), v.targetProps), {
    className: $R(v.targetProps.className, p.className, r.props.className),
    [s]: y
  }), v.controlled ? null : { onClick: v.onToggle }));
});
lN.displayName = "@mantine/core/PopoverTarget";
var hG = $n((e, { radius: t, shadow: n }) => ({
  dropdown: {
    position: "absolute",
    backgroundColor: e.white,
    background: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
    border: `1px solid ${e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2]}`,
    padding: `${e.spacing.sm}px ${e.spacing.md}px`,
    boxShadow: e.shadows[n] || n || "none",
    borderRadius: e.fn.radius(t),
    "&:focus": {
      outline: 0
    }
  },
  arrow: {
    backgroundColor: "inherit",
    border: `1px solid ${e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2]}`,
    zIndex: 1
  }
}));
const pG = hG;
var vG = Object.defineProperty, K_ = Object.getOwnPropertySymbols, gG = Object.prototype.hasOwnProperty, yG = Object.prototype.propertyIsEnumerable, J_ = (e, t, n) => t in e ? vG(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ah = (e, t) => {
  for (var n in t || (t = {}))
    gG.call(t, n) && J_(e, n, t[n]);
  if (K_)
    for (var n of K_(t))
      yG.call(t, n) && J_(e, n, t[n]);
  return e;
};
const Z_ = {
  entering: "in",
  entered: "in",
  exiting: "out",
  exited: "out",
  "pre-exiting": "out",
  "pre-entering": "out"
};
function bG({
  transition: e,
  state: t,
  duration: n,
  timingFunction: r
}) {
  const s = {
    transitionDuration: `${n}ms`,
    transitionTimingFunction: r
  };
  return typeof e == "string" ? e in Pb ? Ah(Ah(Ah({
    transitionProperty: Pb[e].transitionProperty
  }, s), Pb[e].common), Pb[e][Z_[t]]) : null : Ah(Ah(Ah({
    transitionProperty: e.transitionProperty
  }, s), e.common), e[Z_[t]]);
}
function wG({
  duration: e,
  exitDuration: t,
  timingFunction: n,
  mounted: r,
  onEnter: s,
  onExit: f,
  onEntered: m,
  onExited: p
}) {
  const v = vu(), y = zR(), w = v.respectReducedMotion ? y : !1, [P, x] = F.exports.useState(r ? "entered" : "exited");
  let A = w ? 0 : e;
  const M = F.exports.useRef(-1), O = (j) => {
    const H = j ? s : f, J = j ? m : p;
    if (x(j ? "pre-entering" : "pre-exiting"), window.clearTimeout(M.current), A = w ? 0 : j ? e : t, A === 0)
      typeof H == "function" && H(), typeof J == "function" && J(), x(j ? "entered" : "exited");
    else {
      const V = window.setTimeout(() => {
        typeof H == "function" && H(), x(j ? "entering" : "exiting");
      }, 10);
      M.current = window.setTimeout(() => {
        window.clearTimeout(V), typeof J == "function" && J(), x(j ? "entered" : "exited");
      }, A);
    }
  };
  return kd(() => {
    O(r);
  }, [r]), F.exports.useEffect(() => () => window.clearTimeout(M.current), []), {
    transitionDuration: A,
    transitionStatus: P,
    transitionTimingFunction: n || v.transitionTimingFunction
  };
}
function QS({
  transition: e,
  duration: t = 250,
  exitDuration: n = t,
  mounted: r,
  children: s,
  timingFunction: f,
  onExit: m,
  onEntered: p,
  onEnter: v,
  onExited: y
}) {
  const { transitionDuration: w, transitionStatus: P, transitionTimingFunction: x } = wG({
    mounted: r,
    exitDuration: n,
    duration: t,
    timingFunction: f,
    onExit: m,
    onEntered: p,
    onEnter: v,
    onExited: y
  });
  return w === 0 ? r ? /* @__PURE__ */ T.createElement(T.Fragment, null, s({})) : null : P === "exited" ? null : /* @__PURE__ */ T.createElement(T.Fragment, null, s(bG({
    transition: e,
    duration: w,
    state: P,
    timingFunction: x
  })));
}
QS.displayName = "@mantine/core/Transition";
function uN({
  children: e,
  active: t = !0,
  refProp: n = "ref"
}) {
  const r = WB(t), s = HS(r, e == null ? void 0 : e.ref);
  return NS(e) ? F.exports.cloneElement(e, { [n]: s }) : e;
}
uN.displayName = "@mantine/core/FocusTrap";
var PG = Object.defineProperty, kG = Object.defineProperties, $G = Object.getOwnPropertyDescriptors, e3 = Object.getOwnPropertySymbols, SG = Object.prototype.hasOwnProperty, xG = Object.prototype.propertyIsEnumerable, t3 = (e, t, n) => t in e ? PG(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ab = (e, t) => {
  for (var n in t || (t = {}))
    SG.call(t, n) && t3(e, n, t[n]);
  if (e3)
    for (var n of e3(t))
      xG.call(t, n) && t3(e, n, t[n]);
  return e;
}, _b = (e, t) => kG(e, $G(t));
const CG = {
  bottom: "borderTopLeftRadius",
  left: "borderTopRightRadius",
  right: "borderBottomLeftRadius",
  top: "borderBottomRightRadius"
};
function MG({
  position: e,
  withBorder: t,
  arrowSize: n,
  arrowRadius: r,
  arrowX: s,
  arrowY: f
}) {
  const [m] = e.split("-"), p = {
    width: n,
    height: n,
    transform: "rotate(45deg)",
    position: "absolute",
    [CG[m]]: r
  }, v = t ? -n / 2 - 1 : -n / 2;
  return m === "left" ? _b(Ab({}, p), {
    top: f,
    right: v,
    borderLeft: 0,
    borderBottom: 0
  }) : m === "right" ? _b(Ab({}, p), {
    top: f,
    left: v,
    borderRight: 0,
    borderTop: 0
  }) : m === "top" ? _b(Ab({}, p), {
    left: s,
    bottom: v,
    borderTop: 0,
    borderLeft: 0
  }) : m === "bottom" ? _b(Ab({}, p), {
    left: s,
    top: v,
    borderBottom: 0,
    borderRight: 0
  }) : {};
}
var EG = Object.defineProperty, AG = Object.defineProperties, _G = Object.getOwnPropertyDescriptors, L1 = Object.getOwnPropertySymbols, cN = Object.prototype.hasOwnProperty, dN = Object.prototype.propertyIsEnumerable, n3 = (e, t, n) => t in e ? EG(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, OG = (e, t) => {
  for (var n in t || (t = {}))
    cN.call(t, n) && n3(e, n, t[n]);
  if (L1)
    for (var n of L1(t))
      dN.call(t, n) && n3(e, n, t[n]);
  return e;
}, TG = (e, t) => AG(e, _G(t)), RG = (e, t) => {
  var n = {};
  for (var r in e)
    cN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && L1)
    for (var r of L1(e))
      t.indexOf(r) < 0 && dN.call(e, r) && (n[r] = e[r]);
  return n;
};
const fN = F.exports.forwardRef((e, t) => {
  var n = e, { withBorder: r, position: s, arrowSize: f, arrowRadius: m, visible: p, arrowX: v, arrowY: y } = n, w = RG(n, ["withBorder", "position", "arrowSize", "arrowRadius", "visible", "arrowX", "arrowY"]);
  return p ? /* @__PURE__ */ T.createElement("div", TG(OG({}, w), {
    ref: t,
    style: MG({
      withBorder: r,
      position: s,
      arrowSize: f,
      arrowRadius: m,
      arrowX: v,
      arrowY: y
    })
  })) : null;
});
fN.displayName = "@mantine/core/FloatingArrow";
var DG = Object.defineProperty, NG = Object.defineProperties, WG = Object.getOwnPropertyDescriptors, I1 = Object.getOwnPropertySymbols, mN = Object.prototype.hasOwnProperty, hN = Object.prototype.propertyIsEnumerable, r3 = (e, t, n) => t in e ? DG(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ob = (e, t) => {
  for (var n in t || (t = {}))
    mN.call(t, n) && r3(e, n, t[n]);
  if (I1)
    for (var n of I1(t))
      hN.call(t, n) && r3(e, n, t[n]);
  return e;
}, a3 = (e, t) => NG(e, WG(t)), jG = (e, t) => {
  var n = {};
  for (var r in e)
    mN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && I1)
    for (var r of I1(e))
      t.indexOf(r) < 0 && hN.call(e, r) && (n[r] = e[r]);
  return n;
};
function pN(e) {
  var t = e, {
    style: n,
    className: r,
    children: s,
    onKeyDownCapture: f
  } = t, m = jG(t, [
    "style",
    "className",
    "children",
    "onKeyDownCapture"
  ]);
  const { classNames: p, styles: v, unstyled: y, staticSelector: w } = gu(), P = iN(), { classes: x, cx: A } = pG({ radius: P.radius, shadow: P.shadow }, { name: w, classNames: p, styles: v, unstyled: y }), M = AB({
    opened: P.opened,
    shouldReturnFocus: P.returnFocus
  }), O = P.withRoles ? {
    "aria-labelledby": P.getTargetId(),
    id: P.getDropdownId(),
    role: "dialog"
  } : {};
  return P.disabled ? null : /* @__PURE__ */ T.createElement(CD, {
    withinPortal: P.withinPortal
  }, /* @__PURE__ */ T.createElement(QS, {
    mounted: P.opened,
    transition: P.transition,
    duration: P.transitionDuration,
    exitDuration: typeof P.exitTransitionDuration == "number" ? P.exitTransitionDuration : P.transitionDuration
  }, (j) => {
    var H, J;
    return /* @__PURE__ */ T.createElement(uN, {
      active: P.trapFocus
    }, /* @__PURE__ */ T.createElement(Gn, Ob(a3(Ob({}, O), {
      tabIndex: -1,
      key: P.placement,
      ref: P.floating,
      style: a3(Ob(Ob({}, n), j), {
        zIndex: P.zIndex,
        top: (H = P.y) != null ? H : 0,
        left: (J = P.x) != null ? J : 0,
        width: P.width === "target" ? void 0 : P.width
      }),
      className: A(x.dropdown, r),
      onKeyDownCapture: sV(P.onClose, {
        active: P.closeOnEscape,
        onTrigger: M,
        onKeyDown: f
      }),
      "data-position": P.placement
    }), m), s, /* @__PURE__ */ T.createElement(fN, {
      ref: P.arrowRef,
      arrowX: P.arrowX,
      arrowY: P.arrowY,
      visible: P.withArrow,
      withBorder: !0,
      position: P.placement,
      arrowSize: P.arrowSize,
      arrowRadius: P.arrowRadius,
      className: x.arrow
    })));
  }));
}
pN.displayName = "@mantine/core/PopoverDropdown";
function zG(e, t) {
  if (e === "rtl" && (t.includes("right") || t.includes("left"))) {
    const [n, r] = t.split("-"), s = n === "right" ? "left" : "right";
    return r === void 0 ? s : `${s}-${r}`;
  }
  return t;
}
var i3 = Object.getOwnPropertySymbols, LG = Object.prototype.hasOwnProperty, IG = Object.prototype.propertyIsEnumerable, FG = (e, t) => {
  var n = {};
  for (var r in e)
    LG.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && i3)
    for (var r of i3(e))
      t.indexOf(r) < 0 && IG.call(e, r) && (n[r] = e[r]);
  return n;
};
const HG = {
  position: "bottom",
  offset: 8,
  positionDependencies: [],
  transition: "fade",
  transitionDuration: 150,
  middlewares: { flip: !0, shift: !0, inline: !1 },
  arrowSize: 7,
  arrowOffset: 5,
  arrowRadius: 0,
  closeOnClickOutside: !0,
  withinPortal: !1,
  closeOnEscape: !0,
  trapFocus: !1,
  withRoles: !0,
  returnFocus: !1,
  clickOutsideEvents: ["mousedown", "touchstart"],
  zIndex: FS("popover"),
  __staticSelector: "Popover",
  width: "max-content"
};
function pc(e) {
  var t, n, r, s, f, m;
  const p = F.exports.useRef(null), v = Er("Popover", HG, e), {
    children: y,
    position: w,
    offset: P,
    onPositionChange: x,
    positionDependencies: A,
    opened: M,
    transition: O,
    transitionDuration: j,
    width: H,
    middlewares: J,
    withArrow: V,
    arrowSize: X,
    arrowOffset: U,
    arrowRadius: K,
    unstyled: ce,
    classNames: ue,
    styles: ye,
    closeOnClickOutside: Oe,
    withinPortal: _e,
    closeOnEscape: Le,
    clickOutsideEvents: Ne,
    trapFocus: nt,
    onClose: Qe,
    onOpen: qe,
    onChange: ie,
    zIndex: xe,
    radius: Ye,
    shadow: Be,
    id: Ce,
    defaultOpened: Ie,
    exitTransitionDuration: $e,
    __staticSelector: ot,
    withRoles: ht,
    disabled: At,
    returnFocus: Sn
  } = v, Gt = FG(v, [
    "children",
    "position",
    "offset",
    "onPositionChange",
    "positionDependencies",
    "opened",
    "transition",
    "transitionDuration",
    "width",
    "middlewares",
    "withArrow",
    "arrowSize",
    "arrowOffset",
    "arrowRadius",
    "unstyled",
    "classNames",
    "styles",
    "closeOnClickOutside",
    "withinPortal",
    "closeOnEscape",
    "clickOutsideEvents",
    "trapFocus",
    "onClose",
    "onOpen",
    "onChange",
    "zIndex",
    "radius",
    "shadow",
    "id",
    "defaultOpened",
    "exitTransitionDuration",
    "__staticSelector",
    "withRoles",
    "disabled",
    "returnFocus"
  ]), [Bt, Qn] = F.exports.useState(null), [cn, Ge] = F.exports.useState(null), vr = Nw(Ce), Fn = vu(), en = sG({
    middlewares: J,
    width: H,
    position: zG(Fn.dir, w),
    offset: P + (V ? X / 2 : 0),
    arrowRef: p,
    arrowOffset: U,
    onPositionChange: x,
    positionDependencies: A,
    opened: M,
    defaultOpened: Ie,
    onChange: ie,
    onOpen: qe,
    onClose: Qe
  });
  xB(() => Oe && en.onClose(), Ne, [
    Bt,
    cn
  ]);
  const Gr = F.exports.useCallback((gr) => {
    Qn(gr), en.floating.reference(gr);
  }, [en.floating.reference]), da = F.exports.useCallback((gr) => {
    Ge(gr), en.floating.floating(gr);
  }, [en.floating.floating]);
  return /* @__PURE__ */ T.createElement(IS, {
    classNames: ue,
    styles: ye,
    unstyled: ce,
    staticSelector: ot
  }, /* @__PURE__ */ T.createElement(lG, {
    value: {
      returnFocus: Sn,
      disabled: At,
      controlled: en.controlled,
      reference: Gr,
      floating: da,
      x: en.floating.x,
      y: en.floating.y,
      arrowX: (r = (n = (t = en.floating) == null ? void 0 : t.middlewareData) == null ? void 0 : n.arrow) == null ? void 0 : r.x,
      arrowY: (m = (f = (s = en.floating) == null ? void 0 : s.middlewareData) == null ? void 0 : f.arrow) == null ? void 0 : m.y,
      opened: en.opened,
      arrowRef: p,
      transition: O,
      transitionDuration: j,
      exitTransitionDuration: $e,
      width: H,
      withArrow: V,
      arrowSize: X,
      arrowRadius: K,
      placement: en.floating.placement,
      trapFocus: nt,
      withinPortal: _e,
      zIndex: xe,
      radius: Ye,
      shadow: Be,
      closeOnEscape: Le,
      onClose: en.onClose,
      onToggle: en.onToggle,
      getTargetId: () => `${vr}-target`,
      getDropdownId: () => `${vr}-dropdown`,
      withRoles: ht,
      targetProps: Gt
    }
  }, y));
}
pc.Target = lN;
pc.Dropdown = pN;
pc.displayName = "@mantine/core/Popover";
var VG = $n((e, { size: t }) => ({
  label: {
    display: "inline-block",
    fontSize: e.fn.size({ size: t, sizes: e.fontSizes }),
    fontWeight: 500,
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.gray[9],
    wordBreak: "break-word",
    cursor: "default",
    WebkitTapHighlightColor: "transparent"
  },
  required: {
    color: e.fn.variant({ variant: "filled", color: "red" }).background
  }
}));
const BG = VG;
var UG = Object.defineProperty, F1 = Object.getOwnPropertySymbols, vN = Object.prototype.hasOwnProperty, gN = Object.prototype.propertyIsEnumerable, o3 = (e, t, n) => t in e ? UG(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, XG = (e, t) => {
  for (var n in t || (t = {}))
    vN.call(t, n) && o3(e, n, t[n]);
  if (F1)
    for (var n of F1(t))
      gN.call(t, n) && o3(e, n, t[n]);
  return e;
}, qG = (e, t) => {
  var n = {};
  for (var r in e)
    vN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && F1)
    for (var r of F1(e))
      t.indexOf(r) < 0 && gN.call(e, r) && (n[r] = e[r]);
  return n;
};
const KS = F.exports.forwardRef((e, t) => {
  var n = e, {
    labelElement: r = "label",
    children: s,
    required: f,
    size: m = "sm",
    classNames: p,
    styles: v,
    unstyled: y,
    className: w,
    htmlFor: P,
    __staticSelector: x
  } = n, A = qG(n, [
    "labelElement",
    "children",
    "required",
    "size",
    "classNames",
    "styles",
    "unstyled",
    "className",
    "htmlFor",
    "__staticSelector"
  ]);
  const { classes: M, cx: O } = BG({ size: m }, { name: ["InputWrapper", x], classNames: p, styles: v, unstyled: y });
  return /* @__PURE__ */ T.createElement(Gn, XG({
    component: r,
    ref: t,
    className: O(M.label, w),
    htmlFor: r === "label" ? P : void 0
  }, A), s, f && /* @__PURE__ */ T.createElement("span", {
    className: M.required,
    "aria-hidden": !0
  }, " *"));
});
KS.displayName = "@mantine/core/InputLabel";
var YG = $n((e, { size: t }) => ({
  error: {
    wordBreak: "break-word",
    color: e.fn.variant({ variant: "filled", color: "red" }).background,
    fontSize: e.fn.size({ size: t, sizes: e.fontSizes }) - 2,
    lineHeight: 1.2,
    display: "block"
  }
}));
const GG = YG;
var QG = Object.defineProperty, H1 = Object.getOwnPropertySymbols, yN = Object.prototype.hasOwnProperty, bN = Object.prototype.propertyIsEnumerable, s3 = (e, t, n) => t in e ? QG(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, KG = (e, t) => {
  for (var n in t || (t = {}))
    yN.call(t, n) && s3(e, n, t[n]);
  if (H1)
    for (var n of H1(t))
      bN.call(t, n) && s3(e, n, t[n]);
  return e;
}, JG = (e, t) => {
  var n = {};
  for (var r in e)
    yN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && H1)
    for (var r of H1(e))
      t.indexOf(r) < 0 && bN.call(e, r) && (n[r] = e[r]);
  return n;
};
const JS = F.exports.forwardRef((e, t) => {
  var n = e, { children: r, className: s, classNames: f, styles: m, unstyled: p, size: v = "sm", __staticSelector: y } = n, w = JG(n, ["children", "className", "classNames", "styles", "unstyled", "size", "__staticSelector"]);
  const { classes: P, cx: x } = GG({ size: v }, { name: ["InputWrapper", y], classNames: f, styles: m, unstyled: p });
  return /* @__PURE__ */ T.createElement(Lw, KG({
    className: x(P.error, s),
    ref: t,
    role: "alert"
  }, w), r);
});
JS.displayName = "@mantine/core/InputError";
var ZG = $n((e, { size: t }) => ({
  description: {
    wordBreak: "break-word",
    color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6],
    fontSize: e.fn.size({ size: t, sizes: e.fontSizes }) - 2,
    lineHeight: 1.2,
    display: "block"
  }
}));
const eQ = ZG;
var tQ = Object.defineProperty, V1 = Object.getOwnPropertySymbols, wN = Object.prototype.hasOwnProperty, PN = Object.prototype.propertyIsEnumerable, l3 = (e, t, n) => t in e ? tQ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, nQ = (e, t) => {
  for (var n in t || (t = {}))
    wN.call(t, n) && l3(e, n, t[n]);
  if (V1)
    for (var n of V1(t))
      PN.call(t, n) && l3(e, n, t[n]);
  return e;
}, rQ = (e, t) => {
  var n = {};
  for (var r in e)
    wN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && V1)
    for (var r of V1(e))
      t.indexOf(r) < 0 && PN.call(e, r) && (n[r] = e[r]);
  return n;
};
const ZS = F.exports.forwardRef((e, t) => {
  var n = e, { children: r, className: s, classNames: f, styles: m, unstyled: p, size: v = "sm", __staticSelector: y } = n, w = rQ(n, ["children", "className", "classNames", "styles", "unstyled", "size", "__staticSelector"]);
  const { classes: P, cx: x } = eQ({ size: v }, { name: ["InputWrapper", y], classNames: f, styles: m, unstyled: p });
  return /* @__PURE__ */ T.createElement(Lw, nQ({
    color: "dimmed",
    className: x(P.description, s),
    ref: t,
    unstyled: p
  }, w), r);
});
ZS.displayName = "@mantine/core/InputDescription";
const kN = F.exports.createContext({
  offsetBottom: !1,
  offsetTop: !1
}), aQ = kN.Provider, iQ = () => F.exports.useContext(kN);
function oQ(e, { hasDescription: t, hasError: n }) {
  const r = e.findIndex((v) => v === "input"), s = e[r - 1], f = e[r + 1];
  return { offsetBottom: t && f === "description" || n && f === "error", offsetTop: t && s === "description" || n && s === "error" };
}
var sQ = Object.defineProperty, lQ = Object.defineProperties, uQ = Object.getOwnPropertyDescriptors, u3 = Object.getOwnPropertySymbols, cQ = Object.prototype.hasOwnProperty, dQ = Object.prototype.propertyIsEnumerable, c3 = (e, t, n) => t in e ? sQ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, fQ = (e, t) => {
  for (var n in t || (t = {}))
    cQ.call(t, n) && c3(e, n, t[n]);
  if (u3)
    for (var n of u3(t))
      dQ.call(t, n) && c3(e, n, t[n]);
  return e;
}, mQ = (e, t) => lQ(e, uQ(t)), hQ = $n((e) => ({
  root: mQ(fQ({}, e.fn.fontStyles()), {
    lineHeight: e.lineHeight
  })
}));
const pQ = hQ;
var vQ = Object.defineProperty, gQ = Object.defineProperties, yQ = Object.getOwnPropertyDescriptors, B1 = Object.getOwnPropertySymbols, $N = Object.prototype.hasOwnProperty, SN = Object.prototype.propertyIsEnumerable, d3 = (e, t, n) => t in e ? vQ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Kf = (e, t) => {
  for (var n in t || (t = {}))
    $N.call(t, n) && d3(e, n, t[n]);
  if (B1)
    for (var n of B1(t))
      SN.call(t, n) && d3(e, n, t[n]);
  return e;
}, f3 = (e, t) => gQ(e, yQ(t)), bQ = (e, t) => {
  var n = {};
  for (var r in e)
    $N.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && B1)
    for (var r of B1(e))
      t.indexOf(r) < 0 && SN.call(e, r) && (n[r] = e[r]);
  return n;
};
const wQ = {
  labelElement: "label",
  size: "sm",
  inputContainer: (e) => e,
  inputWrapperOrder: ["label", "description", "input", "error"]
}, xN = F.exports.forwardRef((e, t) => {
  const n = Er("InputWrapper", wQ, e), {
    className: r,
    label: s,
    children: f,
    required: m,
    id: p,
    error: v,
    description: y,
    labelElement: w,
    labelProps: P,
    descriptionProps: x,
    errorProps: A,
    classNames: M,
    styles: O,
    size: j,
    inputContainer: H,
    __staticSelector: J,
    unstyled: V,
    inputWrapperOrder: X,
    withAsterisk: U
  } = n, K = bQ(n, [
    "className",
    "label",
    "children",
    "required",
    "id",
    "error",
    "description",
    "labelElement",
    "labelProps",
    "descriptionProps",
    "errorProps",
    "classNames",
    "styles",
    "size",
    "inputContainer",
    "__staticSelector",
    "unstyled",
    "inputWrapperOrder",
    "withAsterisk"
  ]), { classes: ce, cx: ue } = pQ(null, {
    classNames: M,
    styles: O,
    name: ["InputWrapper", J],
    unstyled: V
  }), ye = {
    classNames: M,
    styles: O,
    unstyled: V,
    size: j,
    __staticSelector: J
  }, Oe = typeof U == "boolean" ? U : m, _e = s && /* @__PURE__ */ T.createElement(KS, Kf(Kf({
    key: "label",
    labelElement: w,
    id: p ? `${p}-label` : void 0,
    htmlFor: p,
    required: Oe
  }, ye), P), s), Le = y && /* @__PURE__ */ T.createElement(ZS, f3(Kf(Kf({
    key: "description"
  }, x), ye), {
    size: (x == null ? void 0 : x.size) || ye.size
  }), y), Ne = /* @__PURE__ */ T.createElement(F.exports.Fragment, {
    key: "input"
  }, H(f)), nt = typeof v != "boolean" && v && /* @__PURE__ */ T.createElement(JS, f3(Kf(Kf({}, A), ye), {
    size: (A == null ? void 0 : A.size) || ye.size,
    key: "error"
  }), v), Qe = X.map((qe) => {
    switch (qe) {
      case "label":
        return _e;
      case "input":
        return Ne;
      case "description":
        return Le;
      case "error":
        return nt;
      default:
        return null;
    }
  });
  return /* @__PURE__ */ T.createElement(aQ, {
    value: oQ(X, {
      hasDescription: !!Le,
      hasError: !!nt
    })
  }, /* @__PURE__ */ T.createElement(Gn, Kf({
    className: ue(ce.root, r),
    ref: t
  }, K), Qe));
});
xN.displayName = "@mantine/core/InputWrapper";
var PQ = Object.defineProperty, kQ = Object.defineProperties, $Q = Object.getOwnPropertyDescriptors, m3 = Object.getOwnPropertySymbols, SQ = Object.prototype.hasOwnProperty, xQ = Object.prototype.propertyIsEnumerable, h3 = (e, t, n) => t in e ? PQ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, t$ = (e, t) => {
  for (var n in t || (t = {}))
    SQ.call(t, n) && h3(e, n, t[n]);
  if (m3)
    for (var n of m3(t))
      xQ.call(t, n) && h3(e, n, t[n]);
  return e;
}, p3 = (e, t) => kQ(e, $Q(t));
const Vs = {
  xs: 30,
  sm: 36,
  md: 42,
  lg: 50,
  xl: 60
};
function CQ({ theme: e, variant: t }) {
  return t === "default" ? {
    border: `1px solid ${e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4]}`,
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
    transition: "border-color 100ms ease",
    "&:focus, &:focus-within": e.focusRingStyles.inputStyles(e)
  } : t === "filled" ? {
    border: "1px solid transparent",
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[1],
    "&:focus, &:focus-within": e.focusRingStyles.inputStyles(e)
  } : {
    borderWidth: 0,
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    backgroundColor: "transparent",
    minHeight: 28,
    outline: 0,
    "&:focus, &:focus-within": {
      outline: "none",
      borderColor: "transparent"
    },
    "&:disabled": {
      backgroundColor: "transparent",
      "&:focus, &:focus-within": {
        outline: "none",
        borderColor: "transparent"
      }
    }
  };
}
var MQ = $n((e, {
  size: t,
  multiline: n,
  radius: r,
  variant: s,
  invalid: f,
  rightSectionWidth: m,
  withRightSection: p,
  iconWidth: v,
  offsetBottom: y,
  offsetTop: w,
  pointer: P
}) => {
  const x = e.fn.variant({ variant: "filled", color: "red" }).background, A = s === "default" || s === "filled" ? {
    minHeight: e.fn.size({ size: t, sizes: Vs }),
    paddingLeft: e.fn.size({ size: t, sizes: Vs }) / 3,
    paddingRight: p ? m : e.fn.size({ size: t, sizes: Vs }) / 3,
    borderRadius: e.fn.radius(r)
  } : null;
  return {
    wrapper: {
      position: "relative",
      marginTop: w ? `calc(${e.spacing.xs}px / 2)` : void 0,
      marginBottom: y ? `calc(${e.spacing.xs}px / 2)` : void 0
    },
    input: t$(p3(t$(p3(t$({}, e.fn.fontStyles()), {
      height: n ? s === "unstyled" ? void 0 : "auto" : e.fn.size({ size: t, sizes: Vs }),
      WebkitTapHighlightColor: "transparent",
      lineHeight: n ? e.lineHeight : `${e.fn.size({ size: t, sizes: Vs }) - 2}px`,
      appearance: "none",
      resize: "none",
      boxSizing: "border-box",
      fontSize: e.fn.size({ size: t, sizes: e.fontSizes }),
      width: "100%",
      color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
      display: "block",
      textAlign: "left",
      cursor: P ? "pointer" : void 0
    }), A), {
      "&:disabled": {
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[1],
        color: e.colors.dark[2],
        opacity: 0.6,
        cursor: "not-allowed",
        "&::placeholder": {
          color: e.colors.dark[2]
        }
      },
      "&::placeholder": {
        opacity: 1,
        userSelect: "none",
        color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[5]
      },
      "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button, &::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration": {
        appearance: "none"
      },
      "&[type=number]": {
        MozAppearance: "textfield"
      }
    }), CQ({ theme: e, variant: s })),
    withIcon: {
      paddingLeft: typeof v == "number" ? v : e.fn.size({ size: t, sizes: Vs })
    },
    invalid: {
      color: x,
      borderColor: x,
      "&::placeholder": {
        opacity: 1,
        color: x
      }
    },
    disabled: {
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[1],
      color: e.colors.dark[2],
      opacity: 0.6,
      cursor: "not-allowed",
      "&::placeholder": {
        color: e.colors.dark[2]
      }
    },
    icon: {
      pointerEvents: "none",
      position: "absolute",
      zIndex: 1,
      left: 0,
      top: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: typeof v == "number" ? v : e.fn.size({ size: t, sizes: Vs }),
      color: f ? e.colors.red[e.colorScheme === "dark" ? 6 : 7] : e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[5]
    },
    rightSection: {
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: m
    }
  };
});
const EQ = MQ;
var AQ = Object.defineProperty, _Q = Object.defineProperties, OQ = Object.getOwnPropertyDescriptors, U1 = Object.getOwnPropertySymbols, CN = Object.prototype.hasOwnProperty, MN = Object.prototype.propertyIsEnumerable, v3 = (e, t, n) => t in e ? AQ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Tb = (e, t) => {
  for (var n in t || (t = {}))
    CN.call(t, n) && v3(e, n, t[n]);
  if (U1)
    for (var n of U1(t))
      MN.call(t, n) && v3(e, n, t[n]);
  return e;
}, g3 = (e, t) => _Q(e, OQ(t)), TQ = (e, t) => {
  var n = {};
  for (var r in e)
    CN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && U1)
    for (var r of U1(e))
      t.indexOf(r) < 0 && MN.call(e, r) && (n[r] = e[r]);
  return n;
};
const RQ = {
  rightSectionWidth: 36,
  size: "sm",
  variant: "default"
}, ep = F.exports.forwardRef((e, t) => {
  const n = Er("Input", RQ, e), {
    className: r,
    invalid: s,
    required: f,
    disabled: m,
    variant: p,
    icon: v,
    style: y,
    rightSectionWidth: w,
    iconWidth: P,
    rightSection: x,
    rightSectionProps: A,
    radius: M,
    size: O,
    wrapperProps: j,
    classNames: H,
    styles: J,
    __staticSelector: V,
    multiline: X,
    sx: U,
    unstyled: K,
    pointer: ce
  } = n, ue = TQ(n, [
    "className",
    "invalid",
    "required",
    "disabled",
    "variant",
    "icon",
    "style",
    "rightSectionWidth",
    "iconWidth",
    "rightSection",
    "rightSectionProps",
    "radius",
    "size",
    "wrapperProps",
    "classNames",
    "styles",
    "__staticSelector",
    "multiline",
    "sx",
    "unstyled",
    "pointer"
  ]), { offsetBottom: ye, offsetTop: Oe } = iQ(), { classes: _e, cx: Le } = EQ({
    radius: M,
    size: O,
    multiline: X,
    variant: p,
    invalid: s,
    rightSectionWidth: w,
    iconWidth: P,
    withRightSection: !!x,
    offsetBottom: ye,
    offsetTop: Oe,
    pointer: ce
  }, { classNames: H, styles: J, name: ["Input", V], unstyled: K }), { systemStyles: Ne, rest: nt } = Ww(ue);
  return /* @__PURE__ */ T.createElement(Gn, Tb(Tb({
    className: Le(_e.wrapper, r),
    sx: U,
    style: y
  }, Ne), j), v && /* @__PURE__ */ T.createElement("div", {
    className: _e.icon
  }, v), /* @__PURE__ */ T.createElement(Gn, g3(Tb({
    component: "input"
  }, nt), {
    ref: t,
    required: f,
    "aria-invalid": s,
    disabled: m,
    className: Le(_e[`${p}Variant`], _e.input, {
      [_e.withIcon]: v,
      [_e.invalid]: s,
      [_e.disabled]: m
    })
  })), x && /* @__PURE__ */ T.createElement("div", g3(Tb({}, A), {
    className: _e.rightSection
  }), x));
});
ep.displayName = "@mantine/core/Input";
ep.Wrapper = xN;
ep.Label = KS;
ep.Description = ZS;
ep.Error = JS;
const F$ = ep;
var DQ = Object.defineProperty, NQ = Object.defineProperties, WQ = Object.getOwnPropertyDescriptors, y3 = Object.getOwnPropertySymbols, jQ = Object.prototype.hasOwnProperty, zQ = Object.prototype.propertyIsEnumerable, b3 = (e, t, n) => t in e ? DQ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, LQ = (e, t) => {
  for (var n in t || (t = {}))
    jQ.call(t, n) && b3(e, n, t[n]);
  if (y3)
    for (var n of y3(t))
      zQ.call(t, n) && b3(e, n, t[n]);
  return e;
}, IQ = (e, t) => NQ(e, WQ(t));
function FQ(e) {
  return /* @__PURE__ */ T.createElement("svg", IQ(LQ({}, e), {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /* @__PURE__ */ T.createElement("path", {
    d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var HQ = Object.defineProperty, VQ = Object.defineProperties, BQ = Object.getOwnPropertyDescriptors, w3 = Object.getOwnPropertySymbols, UQ = Object.prototype.hasOwnProperty, XQ = Object.prototype.propertyIsEnumerable, P3 = (e, t, n) => t in e ? HQ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, qQ = (e, t) => {
  for (var n in t || (t = {}))
    UQ.call(t, n) && P3(e, n, t[n]);
  if (w3)
    for (var n of w3(t))
      XQ.call(t, n) && P3(e, n, t[n]);
  return e;
}, YQ = (e, t) => VQ(e, BQ(t));
const EN = F.exports.createContext(null);
function GQ({ spacing: e, children: t }) {
  return /* @__PURE__ */ T.createElement(EN.Provider, {
    value: { spacing: e }
  }, t);
}
function QQ() {
  const e = F.exports.useContext(EN);
  return e ? YQ(qQ({}, e), { withinGroup: !0 }) : { spacing: null, withinGroup: !1 };
}
var KQ = $n((e, { spacing: t }) => ({
  root: {
    display: "flex",
    paddingLeft: e.fn.size({ size: t, sizes: e.spacing })
  }
}));
const JQ = KQ;
var ZQ = Object.defineProperty, X1 = Object.getOwnPropertySymbols, AN = Object.prototype.hasOwnProperty, _N = Object.prototype.propertyIsEnumerable, k3 = (e, t, n) => t in e ? ZQ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, eK = (e, t) => {
  for (var n in t || (t = {}))
    AN.call(t, n) && k3(e, n, t[n]);
  if (X1)
    for (var n of X1(t))
      _N.call(t, n) && k3(e, n, t[n]);
  return e;
}, tK = (e, t) => {
  var n = {};
  for (var r in e)
    AN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && X1)
    for (var r of X1(e))
      t.indexOf(r) < 0 && _N.call(e, r) && (n[r] = e[r]);
  return n;
};
const nK = {}, ON = F.exports.forwardRef((e, t) => {
  const n = Er("AvatarGroup", nK, e), {
    children: r,
    spacing: s = "sm",
    unstyled: f,
    className: m
  } = n, p = tK(n, [
    "children",
    "spacing",
    "unstyled",
    "className"
  ]), { classes: v, cx: y } = JQ({ spacing: s }, { name: "AvatarGroup", unstyled: f });
  return /* @__PURE__ */ T.createElement(GQ, {
    spacing: s
  }, /* @__PURE__ */ T.createElement(Gn, eK({
    ref: t,
    className: y(v.root, m)
  }, p), r));
});
ON.displayName = "@mantine/core/AvatarGroup";
var rK = Object.defineProperty, aK = Object.defineProperties, iK = Object.getOwnPropertyDescriptors, $3 = Object.getOwnPropertySymbols, oK = Object.prototype.hasOwnProperty, sK = Object.prototype.propertyIsEnumerable, S3 = (e, t, n) => t in e ? rK(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, n$ = (e, t) => {
  for (var n in t || (t = {}))
    oK.call(t, n) && S3(e, n, t[n]);
  if ($3)
    for (var n of $3(t))
      sK.call(t, n) && S3(e, n, t[n]);
  return e;
}, x3 = (e, t) => aK(e, iK(t));
const Rb = {
  xs: 16,
  sm: 26,
  md: 38,
  lg: 56,
  xl: 84
};
function lK({ withinGroup: e, spacing: t, theme: n }) {
  return e ? {
    marginLeft: -n.fn.size({ size: t, sizes: n.spacing }),
    backgroundColor: `${n.colorScheme === "dark" ? n.colors.dark[7] : n.white}`,
    border: `2px solid ${n.colorScheme === "dark" ? n.colors.dark[7] : n.white}`
  } : null;
}
var uK = $n((e, { size: t, radius: n, color: r, withinGroup: s, spacing: f, variant: m, gradient: p }) => {
  const v = e.fn.variant({ variant: m, color: r, gradient: p });
  return {
    root: n$(x3(n$({}, e.fn.focusStyles()), {
      WebkitTapHighlightColor: "transparent",
      boxSizing: "border-box",
      position: "relative",
      display: "block",
      userSelect: "none",
      overflow: "hidden",
      width: e.fn.size({ size: t, sizes: Rb }),
      minWidth: e.fn.size({ size: t, sizes: Rb }),
      height: e.fn.size({ size: t, sizes: Rb }),
      borderRadius: e.fn.radius(n),
      textDecoration: "none",
      border: 0,
      backgroundColor: "transparent",
      padding: 0
    }), lK({ withinGroup: s, spacing: f, theme: e })),
    image: {
      objectFit: "cover",
      width: "100%",
      height: "100%",
      display: "block"
    },
    placeholder: x3(n$({}, e.fn.fontStyles()), {
      fontSize: e.fn.size({ size: t, sizes: Rb }) / 2.5,
      color: v.color,
      fontWeight: 700,
      backgroundColor: v.background,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      userSelect: "none",
      backgroundImage: m === "gradient" ? v.background : void 0,
      border: `${m === "gradient" ? 0 : 1}px solid ${v.border}`,
      borderRadius: e.fn.radius(n)
    }),
    placeholderIcon: {
      width: "70%",
      height: "70%",
      color: v.color
    }
  };
});
const cK = uK;
var dK = Object.defineProperty, fK = Object.defineProperties, mK = Object.getOwnPropertyDescriptors, q1 = Object.getOwnPropertySymbols, TN = Object.prototype.hasOwnProperty, RN = Object.prototype.propertyIsEnumerable, C3 = (e, t, n) => t in e ? dK(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, M3 = (e, t) => {
  for (var n in t || (t = {}))
    TN.call(t, n) && C3(e, n, t[n]);
  if (q1)
    for (var n of q1(t))
      RN.call(t, n) && C3(e, n, t[n]);
  return e;
}, hK = (e, t) => fK(e, mK(t)), pK = (e, t) => {
  var n = {};
  for (var r in e)
    TN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && q1)
    for (var r of q1(e))
      t.indexOf(r) < 0 && RN.call(e, r) && (n[r] = e[r]);
  return n;
};
const vK = {
  size: "md",
  color: "gray",
  variant: "light"
}, ex = F.exports.forwardRef((e, t) => {
  const n = Er("Avatar", vK, e), {
    className: r,
    size: s,
    src: f,
    alt: m,
    radius: p,
    children: v,
    color: y,
    variant: w,
    gradient: P,
    classNames: x,
    styles: A,
    imageProps: M,
    unstyled: O
  } = n, j = pK(n, [
    "className",
    "size",
    "src",
    "alt",
    "radius",
    "children",
    "color",
    "variant",
    "gradient",
    "classNames",
    "styles",
    "imageProps",
    "unstyled"
  ]), H = QQ(), [J, V] = F.exports.useState(!f), { classes: X, cx: U } = cK({ color: y, radius: p, size: s, withinGroup: H.withinGroup, spacing: H.spacing, variant: w, gradient: P }, { classNames: x, styles: A, unstyled: O, name: "Avatar" });
  return F.exports.useEffect(() => {
    V(!f);
  }, [f]), /* @__PURE__ */ T.createElement(Gn, M3({
    component: "div",
    className: U(X.root, r),
    ref: t
  }, j), J ? /* @__PURE__ */ T.createElement("div", {
    className: X.placeholder,
    title: m
  }, v || /* @__PURE__ */ T.createElement(FQ, {
    className: X.placeholderIcon
  })) : /* @__PURE__ */ T.createElement("img", hK(M3({}, M), {
    className: X.image,
    src: f,
    alt: m,
    onError: () => V(!0)
  })));
});
ex.displayName = "@mantine/core/Avatar";
ex.Group = ON;
const gK = ex;
var yK = Object.defineProperty, bK = Object.defineProperties, wK = Object.getOwnPropertyDescriptors, E3 = Object.getOwnPropertySymbols, PK = Object.prototype.hasOwnProperty, kK = Object.prototype.propertyIsEnumerable, A3 = (e, t, n) => t in e ? yK(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, r$ = (e, t) => {
  for (var n in t || (t = {}))
    PK.call(t, n) && A3(e, n, t[n]);
  if (E3)
    for (var n of E3(t))
      kK.call(t, n) && A3(e, n, t[n]);
  return e;
}, $K = (e, t) => bK(e, wK(t));
const a$ = {
  xs: { fontSize: 9, height: 16 },
  sm: { fontSize: 10, height: 18 },
  md: { fontSize: 11, height: 20 },
  lg: { fontSize: 13, height: 26 },
  xl: { fontSize: 16, height: 32 }
}, SK = {
  xs: 4,
  sm: 4,
  md: 6,
  lg: 8,
  xl: 10
};
function xK({ theme: e, variant: t, color: n, size: r, gradient: s }) {
  if (t === "dot") {
    const m = e.fn.size({ size: r, sizes: SK });
    return {
      backgroundColor: "transparent",
      color: e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.gray[7],
      border: `1px solid ${e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[3]}`,
      paddingLeft: e.fn.size({ size: r, sizes: e.spacing }) / 1.5 - m / 2,
      "&::before": {
        content: '""',
        display: "block",
        width: m,
        height: m,
        borderRadius: m,
        backgroundColor: e.fn.themeColor(n, e.colorScheme === "dark" ? 4 : e.fn.primaryShade("light"), !0),
        marginRight: m
      }
    };
  }
  const f = e.fn.variant({ color: n, variant: t, gradient: s });
  return {
    background: f.background,
    color: f.color,
    border: `${t === "gradient" ? 0 : 1}px solid ${f.border}`
  };
}
var CK = $n((e, { color: t, size: n, radius: r, gradient: s, fullWidth: f, variant: m }) => {
  const { fontSize: p, height: v } = n in a$ ? a$[n] : a$.md;
  return {
    leftSection: {
      marginRight: `calc(${e.spacing.xs}px / 2)`
    },
    rightSection: {
      marginLeft: `calc(${e.spacing.xs}px / 2)`
    },
    inner: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    root: r$($K(r$(r$({}, e.fn.focusStyles()), e.fn.fontStyles()), {
      fontSize: p,
      height: v,
      WebkitTapHighlightColor: "transparent",
      lineHeight: `${v - 2}px`,
      textDecoration: "none",
      padding: `0 ${e.fn.size({ size: n, sizes: e.spacing }) / 1.5}px`,
      boxSizing: "border-box",
      display: f ? "flex" : "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: f ? "100%" : "auto",
      textTransform: "uppercase",
      borderRadius: e.fn.radius(r),
      fontWeight: 700,
      letterSpacing: 0.25,
      cursor: "inherit",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }), xK({ theme: e, variant: m, color: t, size: n, gradient: s }))
  };
});
const MK = CK;
var EK = Object.defineProperty, Y1 = Object.getOwnPropertySymbols, DN = Object.prototype.hasOwnProperty, NN = Object.prototype.propertyIsEnumerable, _3 = (e, t, n) => t in e ? EK(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, AK = (e, t) => {
  for (var n in t || (t = {}))
    DN.call(t, n) && _3(e, n, t[n]);
  if (Y1)
    for (var n of Y1(t))
      NN.call(t, n) && _3(e, n, t[n]);
  return e;
}, _K = (e, t) => {
  var n = {};
  for (var r in e)
    DN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Y1)
    for (var r of Y1(e))
      t.indexOf(r) < 0 && NN.call(e, r) && (n[r] = e[r]);
  return n;
};
const OK = {
  variant: "light",
  size: "md",
  radius: "xl"
}, WN = F.exports.forwardRef((e, t) => {
  const n = Er("Badge", OK, e), {
    className: r,
    color: s,
    variant: f,
    fullWidth: m,
    children: p,
    size: v,
    leftSection: y,
    rightSection: w,
    radius: P,
    gradient: x,
    classNames: A,
    styles: M,
    unstyled: O
  } = n, j = _K(n, [
    "className",
    "color",
    "variant",
    "fullWidth",
    "children",
    "size",
    "leftSection",
    "rightSection",
    "radius",
    "gradient",
    "classNames",
    "styles",
    "unstyled"
  ]), { classes: H, cx: J } = MK({
    size: v,
    fullWidth: m,
    color: s,
    radius: P,
    variant: f,
    gradient: x
  }, { classNames: A, styles: M, name: "Badge", unstyled: O });
  return /* @__PURE__ */ T.createElement(Gn, AK({
    className: J(H.root, r),
    ref: t
  }, j), y && /* @__PURE__ */ T.createElement("span", {
    className: H.leftSection
  }, y), /* @__PURE__ */ T.createElement("span", {
    className: H.inner
  }, p), w && /* @__PURE__ */ T.createElement("span", {
    className: H.rightSection
  }, w));
});
WN.displayName = "@mantine/core/Badge";
const TK = WN;
var RK = $n((e, { orientation: t, buttonBorderWidth: n }) => ({
  root: {
    display: "flex",
    flexDirection: t === "vertical" ? "column" : "row",
    "& [data-button]": {
      "&:first-of-type": {
        borderBottomRightRadius: 0,
        [t === "vertical" ? "borderBottomLeftRadius" : "borderTopRightRadius"]: 0,
        [t === "vertical" ? "borderBottomWidth" : "borderRightWidth"]: n / 2
      },
      "&:last-of-type": {
        borderTopLeftRadius: 0,
        [t === "vertical" ? "borderTopRightRadius" : "borderBottomLeftRadius"]: 0,
        [t === "vertical" ? "borderTopWidth" : "borderLeftWidth"]: n / 2
      },
      "&:not(:first-of-type):not(:last-of-type)": {
        borderRadius: 0,
        [t === "vertical" ? "borderTopWidth" : "borderLeftWidth"]: n / 2,
        [t === "vertical" ? "borderBottomWidth" : "borderRightWidth"]: n / 2
      },
      "& + [data-button]": {
        [t === "vertical" ? "marginTop" : "marginLeft"]: -n,
        "@media (min-resolution: 192dpi)": {
          [t === "vertical" ? "marginTop" : "marginLeft"]: 0
        }
      }
    }
  }
}));
const DK = RK;
var NK = Object.defineProperty, G1 = Object.getOwnPropertySymbols, jN = Object.prototype.hasOwnProperty, zN = Object.prototype.propertyIsEnumerable, O3 = (e, t, n) => t in e ? NK(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, WK = (e, t) => {
  for (var n in t || (t = {}))
    jN.call(t, n) && O3(e, n, t[n]);
  if (G1)
    for (var n of G1(t))
      zN.call(t, n) && O3(e, n, t[n]);
  return e;
}, jK = (e, t) => {
  var n = {};
  for (var r in e)
    jN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && G1)
    for (var r of G1(e))
      t.indexOf(r) < 0 && zN.call(e, r) && (n[r] = e[r]);
  return n;
};
const zK = {
  orientation: "horizontal",
  buttonBorderWidth: 1
}, LN = F.exports.forwardRef((e, t) => {
  const n = Er("ButtonGroup", zK, e), { className: r, orientation: s, buttonBorderWidth: f, unstyled: m } = n, p = jK(n, ["className", "orientation", "buttonBorderWidth", "unstyled"]), { classes: v, cx: y } = DK({ orientation: s, buttonBorderWidth: f }, { name: "ButtonGroup", unstyled: m });
  return /* @__PURE__ */ T.createElement(Gn, WK({
    className: y(v.root, r),
    ref: t
  }, p));
});
LN.displayName = "@mantine/core/ButtonGroup";
var LK = Object.defineProperty, IK = Object.defineProperties, FK = Object.getOwnPropertyDescriptors, T3 = Object.getOwnPropertySymbols, HK = Object.prototype.hasOwnProperty, VK = Object.prototype.propertyIsEnumerable, R3 = (e, t, n) => t in e ? LK(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, rm = (e, t) => {
  for (var n in t || (t = {}))
    HK.call(t, n) && R3(e, n, t[n]);
  if (T3)
    for (var n of T3(t))
      VK.call(t, n) && R3(e, n, t[n]);
  return e;
}, H$ = (e, t) => IK(e, FK(t));
const V$ = {
  xs: { height: Vs.xs, paddingLeft: 14, paddingRight: 14 },
  sm: { height: Vs.sm, paddingLeft: 18, paddingRight: 18 },
  md: { height: Vs.md, paddingLeft: 22, paddingRight: 22 },
  lg: { height: Vs.lg, paddingLeft: 26, paddingRight: 26 },
  xl: { height: Vs.xl, paddingLeft: 32, paddingRight: 32 },
  "compact-xs": { height: 22, paddingLeft: 7, paddingRight: 7 },
  "compact-sm": { height: 26, paddingLeft: 8, paddingRight: 8 },
  "compact-md": { height: 30, paddingLeft: 10, paddingRight: 10 },
  "compact-lg": { height: 34, paddingLeft: 12, paddingRight: 12 },
  "compact-xl": { height: 40, paddingLeft: 14, paddingRight: 14 }
};
function BK({ compact: e, size: t, withLeftIcon: n, withRightIcon: r }) {
  if (e)
    return V$[`compact-${t}`];
  const s = V$[t];
  return H$(rm({}, s), {
    paddingLeft: n ? s.paddingLeft / 1.5 : s.paddingLeft,
    paddingRight: r ? s.paddingRight / 1.5 : s.paddingRight
  });
}
const UK = (e) => ({
  display: e ? "block" : "inline-block",
  width: e ? "100%" : "auto"
});
function XK({ variant: e, theme: t, color: n, gradient: r }) {
  const s = t.fn.variant({ color: n, variant: e, gradient: r });
  return e === "gradient" ? {
    border: 0,
    backgroundImage: s.background,
    color: s.color,
    "&:hover": t.fn.hover({
      backgroundSize: "200%"
    })
  } : rm({
    border: `1px solid ${s.border}`,
    backgroundColor: s.background,
    color: s.color
  }, t.fn.hover({
    backgroundColor: s.hover
  }));
}
var qK = $n((e, {
  color: t,
  size: n,
  radius: r,
  fullWidth: s,
  compact: f,
  gradient: m,
  variant: p,
  withLeftIcon: v,
  withRightIcon: y
}) => ({
  root: H$(rm(H$(rm(rm(rm(rm({}, BK({ compact: f, size: n, withLeftIcon: v, withRightIcon: y })), e.fn.fontStyles()), e.fn.focusStyles()), UK(s)), {
    borderRadius: e.fn.radius(r),
    fontWeight: 600,
    position: "relative",
    lineHeight: 1,
    fontSize: e.fn.size({ size: n, sizes: e.fontSizes }),
    userSelect: "none",
    cursor: "pointer"
  }), XK({ variant: p, theme: e, color: t, gradient: m })), {
    "&:active": e.activeStyles,
    "&:disabled, &[data-disabled]": {
      borderColor: "transparent",
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2],
      color: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[5],
      cursor: "not-allowed",
      backgroundImage: "none",
      pointerEvents: "none",
      "&:active": {
        transform: "none"
      }
    },
    "&[data-loading]": {
      pointerEvents: "none",
      "&::before": {
        content: '""',
        position: "absolute",
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: e.colorScheme === "dark" ? e.fn.rgba(e.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
        borderRadius: e.fn.radius(r),
        cursor: "not-allowed"
      }
    }
  }),
  icon: {
    display: "flex",
    alignItems: "center"
  },
  leftIcon: {
    marginRight: 10
  },
  rightIcon: {
    marginLeft: 10
  },
  centerLoader: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    opacity: 0.5
  },
  inner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    overflow: "visible"
  },
  label: {
    whiteSpace: "nowrap",
    height: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center"
  }
}));
const YK = qK;
var GK = Object.defineProperty, Q1 = Object.getOwnPropertySymbols, IN = Object.prototype.hasOwnProperty, FN = Object.prototype.propertyIsEnumerable, D3 = (e, t, n) => t in e ? GK(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, N3 = (e, t) => {
  for (var n in t || (t = {}))
    IN.call(t, n) && D3(e, n, t[n]);
  if (Q1)
    for (var n of Q1(t))
      FN.call(t, n) && D3(e, n, t[n]);
  return e;
}, QK = (e, t) => {
  var n = {};
  for (var r in e)
    IN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Q1)
    for (var r of Q1(e))
      t.indexOf(r) < 0 && FN.call(e, r) && (n[r] = e[r]);
  return n;
};
const KK = {
  size: "sm",
  type: "button",
  variant: "filled",
  loaderPosition: "left"
}, tx = F.exports.forwardRef((e, t) => {
  const n = Er("Button", KK, e), {
    className: r,
    size: s,
    color: f,
    type: m,
    disabled: p,
    children: v,
    leftIcon: y,
    rightIcon: w,
    fullWidth: P,
    variant: x,
    radius: A,
    uppercase: M,
    compact: O,
    loading: j,
    loaderPosition: H,
    loaderProps: J,
    gradient: V,
    classNames: X,
    styles: U,
    unstyled: K
  } = n, ce = QK(n, [
    "className",
    "size",
    "color",
    "type",
    "disabled",
    "children",
    "leftIcon",
    "rightIcon",
    "fullWidth",
    "variant",
    "radius",
    "uppercase",
    "compact",
    "loading",
    "loaderPosition",
    "loaderProps",
    "gradient",
    "classNames",
    "styles",
    "unstyled"
  ]), { classes: ue, cx: ye, theme: Oe } = YK({
    radius: A,
    color: f,
    size: s,
    fullWidth: P,
    compact: O,
    gradient: V,
    variant: x,
    withLeftIcon: !!y,
    withRightIcon: !!w
  }, { name: "Button", unstyled: K, classNames: X, styles: U }), _e = Oe.fn.variant({ color: f, variant: x }), Le = /* @__PURE__ */ T.createElement(mg, N3({
    color: _e.color,
    size: Oe.fn.size({ size: s, sizes: V$ }).height / 2
  }, J));
  return /* @__PURE__ */ T.createElement(jw, N3({
    className: ye(ue.root, r),
    type: m,
    disabled: p,
    "data-button": !0,
    "data-disabled": p || void 0,
    "data-loading": j || void 0,
    ref: t,
    unstyled: K
  }, ce), /* @__PURE__ */ T.createElement("div", {
    className: ue.inner
  }, (y || j && H === "left") && /* @__PURE__ */ T.createElement("span", {
    className: ye(ue.icon, ue.leftIcon)
  }, j && H === "left" ? Le : y), j && H === "center" && /* @__PURE__ */ T.createElement("span", {
    className: ue.centerLoader
  }, Le), /* @__PURE__ */ T.createElement("span", {
    className: ue.label,
    style: { textTransform: M ? "uppercase" : void 0 }
  }, v), (w || j && H === "right") && /* @__PURE__ */ T.createElement("span", {
    className: ye(ue.icon, ue.rightIcon)
  }, j && H === "right" ? Le : w)));
});
tx.displayName = "@mantine/core/Button";
tx.Group = LN;
const JK = tx;
function ZK(e) {
  return F.exports.Children.toArray(e).filter(Boolean);
}
const HN = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
  apart: "space-between"
};
var eJ = $n((e, { spacing: t, position: n, noWrap: r, grow: s, align: f, count: m }) => ({
  root: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: f || "center",
    flexWrap: r ? "nowrap" : "wrap",
    justifyContent: HN[n],
    gap: e.fn.size({ size: t, sizes: e.spacing }),
    "& > *": {
      boxSizing: "border-box",
      maxWidth: s ? `calc(${100 / m}% - ${e.fn.size({ size: t, sizes: e.spacing }) - e.fn.size({ size: t, sizes: e.spacing }) / m}px)` : void 0,
      flexGrow: s ? 1 : 0
    }
  }
})), tJ = Object.defineProperty, K1 = Object.getOwnPropertySymbols, VN = Object.prototype.hasOwnProperty, BN = Object.prototype.propertyIsEnumerable, W3 = (e, t, n) => t in e ? tJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, nJ = (e, t) => {
  for (var n in t || (t = {}))
    VN.call(t, n) && W3(e, n, t[n]);
  if (K1)
    for (var n of K1(t))
      BN.call(t, n) && W3(e, n, t[n]);
  return e;
}, rJ = (e, t) => {
  var n = {};
  for (var r in e)
    VN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && K1)
    for (var r of K1(e))
      t.indexOf(r) < 0 && BN.call(e, r) && (n[r] = e[r]);
  return n;
};
const aJ = {
  position: "left",
  spacing: "md"
}, UN = F.exports.forwardRef((e, t) => {
  const n = Er("Group", aJ, e), { className: r, position: s, align: f, children: m, noWrap: p, grow: v, spacing: y, unstyled: w } = n, P = rJ(n, ["className", "position", "align", "children", "noWrap", "grow", "spacing", "unstyled"]), x = ZK(m), { classes: A, cx: M } = eJ({
    align: f,
    grow: v,
    noWrap: p,
    spacing: y,
    position: s,
    count: x.length
  }, { unstyled: w, name: "Group" });
  return /* @__PURE__ */ T.createElement(Gn, nJ({
    className: M(A.root, r),
    ref: t
  }, P), x);
});
UN.displayName = "@mantine/core/Group";
var iJ = $n((e, { spacing: t, align: n, justify: r }) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: n,
    justifyContent: r,
    gap: e.fn.size({ size: t, sizes: e.spacing })
  }
}));
const oJ = iJ;
var sJ = Object.defineProperty, J1 = Object.getOwnPropertySymbols, XN = Object.prototype.hasOwnProperty, qN = Object.prototype.propertyIsEnumerable, j3 = (e, t, n) => t in e ? sJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, lJ = (e, t) => {
  for (var n in t || (t = {}))
    XN.call(t, n) && j3(e, n, t[n]);
  if (J1)
    for (var n of J1(t))
      qN.call(t, n) && j3(e, n, t[n]);
  return e;
}, uJ = (e, t) => {
  var n = {};
  for (var r in e)
    XN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && J1)
    for (var r of J1(e))
      t.indexOf(r) < 0 && qN.call(e, r) && (n[r] = e[r]);
  return n;
};
const cJ = {
  spacing: "md",
  align: "stretch",
  justify: "top"
}, YN = F.exports.forwardRef((e, t) => {
  const n = Er("Stack", cJ, e), { spacing: r, className: s, align: f, justify: m, unstyled: p } = n, v = uJ(n, ["spacing", "className", "align", "justify", "unstyled"]), { classes: y, cx: w } = oJ({ spacing: r, align: f, justify: m }, { name: "Stack", unstyled: p });
  return /* @__PURE__ */ T.createElement(Gn, lJ({
    className: w(y.root, s),
    ref: t
  }, v));
});
YN.displayName = "@mantine/core/Stack";
function dJ({
  spacing: e,
  offset: t,
  orientation: n,
  children: r,
  role: s,
  unstyled: f
}) {
  return n === "horizontal" ? /* @__PURE__ */ T.createElement(UN, {
    pt: t,
    spacing: e,
    role: s,
    unstyled: f
  }, r) : /* @__PURE__ */ T.createElement(YN, {
    pt: t,
    spacing: e,
    role: s,
    unstyled: f
  }, r);
}
var fJ = Object.defineProperty, mJ = Object.defineProperties, hJ = Object.getOwnPropertyDescriptors, z3 = Object.getOwnPropertySymbols, pJ = Object.prototype.hasOwnProperty, vJ = Object.prototype.propertyIsEnumerable, L3 = (e, t, n) => t in e ? fJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, gJ = (e, t) => {
  for (var n in t || (t = {}))
    pJ.call(t, n) && L3(e, n, t[n]);
  if (z3)
    for (var n of z3(t))
      vJ.call(t, n) && L3(e, n, t[n]);
  return e;
}, yJ = (e, t) => mJ(e, hJ(t));
const bJ = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 30,
  xl: 36
};
var wJ = $n((e, { labelPosition: t, size: n }) => ({
  root: {},
  body: {
    display: "inline-flex"
  },
  labelWrapper: yJ(gJ({}, e.fn.fontStyles()), {
    display: "inline-flex",
    flexDirection: "column",
    WebkitTapHighlightColor: "transparent",
    fontSize: e.fn.size({ size: n, sizes: e.fontSizes }),
    lineHeight: `${e.fn.size({ size: n, sizes: bJ })}px`,
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    cursor: e.cursorType,
    order: t === "left" ? 1 : 2
  }),
  description: {
    marginTop: `calc(${e.spacing.xs}px / 2)`,
    [t === "left" ? "paddingRight" : "paddingLeft"]: e.spacing.sm
  },
  error: {
    marginTop: `calc(${e.spacing.xs}px / 2)`,
    [t === "left" ? "paddingRight" : "paddingLeft"]: e.spacing.sm
  },
  label: {
    cursor: e.cursorType,
    [t === "left" ? "paddingRight" : "paddingLeft"]: e.spacing.sm,
    "&[data-disabled]": {
      color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[5]
    }
  }
}));
const PJ = wJ;
var kJ = Object.defineProperty, Z1 = Object.getOwnPropertySymbols, GN = Object.prototype.hasOwnProperty, QN = Object.prototype.propertyIsEnumerable, I3 = (e, t, n) => t in e ? kJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, $J = (e, t) => {
  for (var n in t || (t = {}))
    GN.call(t, n) && I3(e, n, t[n]);
  if (Z1)
    for (var n of Z1(t))
      QN.call(t, n) && I3(e, n, t[n]);
  return e;
}, SJ = (e, t) => {
  var n = {};
  for (var r in e)
    GN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Z1)
    for (var r of Z1(e))
      t.indexOf(r) < 0 && QN.call(e, r) && (n[r] = e[r]);
  return n;
};
function KN(e) {
  var t = e, {
    __staticSelector: n,
    className: r,
    classNames: s,
    styles: f,
    unstyled: m,
    children: p,
    label: v,
    description: y,
    id: w,
    disabled: P,
    error: x,
    size: A,
    labelPosition: M
  } = t, O = SJ(t, [
    "__staticSelector",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "children",
    "label",
    "description",
    "id",
    "disabled",
    "error",
    "size",
    "labelPosition"
  ]);
  const { classes: j, cx: H } = PJ({ size: A, labelPosition: M }, { name: n, styles: f, classNames: s, unstyled: m });
  return /* @__PURE__ */ T.createElement(Gn, $J({
    className: H(j.root, r)
  }, O), /* @__PURE__ */ T.createElement("div", {
    className: H(j.body)
  }, p, /* @__PURE__ */ T.createElement("div", {
    className: j.labelWrapper
  }, v && /* @__PURE__ */ T.createElement("label", {
    className: j.label,
    "data-disabled": P || void 0,
    htmlFor: w
  }, v), y && /* @__PURE__ */ T.createElement(F$.Description, {
    className: j.description
  }, y), x && x !== "boolean" && /* @__PURE__ */ T.createElement(F$.Error, {
    className: j.error
  }, x))));
}
KN.displayName = "@mantine/core/InlineInput";
var xJ = $n((e, { zIndex: t }) => ({
  root: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: t
  }
}));
const CJ = xJ;
var MJ = Object.defineProperty, EJ = Object.defineProperties, AJ = Object.getOwnPropertyDescriptors, ew = Object.getOwnPropertySymbols, JN = Object.prototype.hasOwnProperty, ZN = Object.prototype.propertyIsEnumerable, F3 = (e, t, n) => t in e ? MJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, i$ = (e, t) => {
  for (var n in t || (t = {}))
    JN.call(t, n) && F3(e, n, t[n]);
  if (ew)
    for (var n of ew(t))
      ZN.call(t, n) && F3(e, n, t[n]);
  return e;
}, _J = (e, t) => EJ(e, AJ(t)), OJ = (e, t) => {
  var n = {};
  for (var r in e)
    JN.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && ew)
    for (var r of ew(e))
      t.indexOf(r) < 0 && ZN.call(e, r) && (n[r] = e[r]);
  return n;
};
const TJ = {
  opacity: 0.6,
  color: "#fff",
  zIndex: FS("modal"),
  radius: 0,
  blur: 0
}, e5 = F.exports.forwardRef((e, t) => {
  const n = Er("Overlay", TJ, e), { opacity: r, blur: s, color: f, gradient: m, zIndex: p, radius: v, sx: y, unstyled: w, className: P } = n, x = OJ(n, ["opacity", "blur", "color", "gradient", "zIndex", "radius", "sx", "unstyled", "className"]), { classes: A, cx: M } = CJ({ zIndex: p }, { name: "Overlay", unstyled: w }), O = m ? { backgroundImage: m } : { backgroundColor: f }, j = (H) => /* @__PURE__ */ T.createElement(Gn, i$({
    ref: t,
    className: M(A.root, P),
    sx: [
      (J) => _J(i$({}, O), {
        opacity: r,
        borderRadius: J.fn.size({ size: v, sizes: J.radius })
      }),
      ...f1(y)
    ]
  }, H));
  return s ? /* @__PURE__ */ T.createElement(Gn, i$({
    className: M(A.root, P),
    sx: [{ backdropFilter: `blur(${s}px)` }, ...f1(y)]
  }, x), j()) : j(x);
});
e5.displayName = "@mantine/core/Overlay";
const RJ = e5;
function DJ({ open: e, close: t, openDelay: n, closeDelay: r }) {
  const s = F.exports.useRef(-1), f = F.exports.useRef(-1), m = () => {
    window.clearTimeout(s.current), window.clearTimeout(f.current);
  }, p = () => {
    m(), n === 0 ? e() : s.current = window.setTimeout(e, n);
  }, v = () => {
    m(), r === 0 ? t() : f.current = window.setTimeout(t, r);
  };
  return F.exports.useEffect(() => m, []), { openDropdown: p, closeDropdown: v };
}
var NJ = $n({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden"
  }
});
const WJ = NJ;
var jJ = Object.defineProperty, zJ = Object.defineProperties, LJ = Object.getOwnPropertyDescriptors, tw = Object.getOwnPropertySymbols, t5 = Object.prototype.hasOwnProperty, n5 = Object.prototype.propertyIsEnumerable, H3 = (e, t, n) => t in e ? jJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Db = (e, t) => {
  for (var n in t || (t = {}))
    t5.call(t, n) && H3(e, n, t[n]);
  if (tw)
    for (var n of tw(t))
      n5.call(t, n) && H3(e, n, t[n]);
  return e;
}, IJ = (e, t) => zJ(e, LJ(t)), FJ = (e, t) => {
  var n = {};
  for (var r in e)
    t5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && tw)
    for (var r of tw(e))
      t.indexOf(r) < 0 && n5.call(e, r) && (n[r] = e[r]);
  return n;
};
const HJ = {
  overlayOpacity: 0.75,
  transitionDuration: 0,
  zIndex: FS("overlay")
}, r5 = F.exports.forwardRef((e, t) => {
  const n = Er("LoadingOverlay", HJ, e), {
    className: r,
    visible: s,
    loaderProps: f,
    overlayOpacity: m,
    overlayColor: p,
    transitionDuration: v,
    exitTransitionDuration: y,
    zIndex: w,
    style: P,
    loader: x,
    radius: A,
    overlayBlur: M,
    unstyled: O
  } = n, j = FJ(n, [
    "className",
    "visible",
    "loaderProps",
    "overlayOpacity",
    "overlayColor",
    "transitionDuration",
    "exitTransitionDuration",
    "zIndex",
    "style",
    "loader",
    "radius",
    "overlayBlur",
    "unstyled"
  ]), { classes: H, cx: J, theme: V } = WJ(null, { name: "LoadingOverlay", unstyled: O }), X = `calc(${w} + 1)`;
  return /* @__PURE__ */ T.createElement(QS, {
    duration: v,
    exitDuration: y,
    mounted: s,
    transition: "fade"
  }, (U) => /* @__PURE__ */ T.createElement(Gn, Db({
    className: J(H.root, r),
    style: IJ(Db(Db({}, U), P), { zIndex: w }),
    ref: t
  }, j), x ? /* @__PURE__ */ T.createElement("div", {
    style: { zIndex: X }
  }, x) : /* @__PURE__ */ T.createElement(mg, Db({
    style: { zIndex: X }
  }, f)), /* @__PURE__ */ T.createElement(RJ, {
    opacity: m,
    zIndex: w,
    radius: A,
    blur: M,
    unstyled: O,
    color: p || (V.colorScheme === "dark" ? V.colors.dark[5] : V.white)
  })));
});
r5.displayName = "@mantine/core/LoadingOverlay";
var VJ = $n((e) => ({
  divider: {
    margin: `calc(${e.spacing.xs}px / 2) -5px`,
    borderTop: `1px solid ${e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2]}`
  }
}));
const BJ = VJ;
var UJ = Object.defineProperty, nw = Object.getOwnPropertySymbols, a5 = Object.prototype.hasOwnProperty, i5 = Object.prototype.propertyIsEnumerable, V3 = (e, t, n) => t in e ? UJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, XJ = (e, t) => {
  for (var n in t || (t = {}))
    a5.call(t, n) && V3(e, n, t[n]);
  if (nw)
    for (var n of nw(t))
      i5.call(t, n) && V3(e, n, t[n]);
  return e;
}, qJ = (e, t) => {
  var n = {};
  for (var r in e)
    a5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && nw)
    for (var r of nw(e))
      t.indexOf(r) < 0 && i5.call(e, r) && (n[r] = e[r]);
  return n;
};
function o5(e) {
  var t = e, { children: n, className: r } = t, s = qJ(t, ["children", "className"]);
  const { classNames: f, styles: m, unstyled: p } = gu(), { classes: v, cx: y } = BJ(null, { name: "Menu", classNames: f, styles: m, unstyled: p });
  return /* @__PURE__ */ T.createElement(Gn, XJ({
    className: y(v.divider, r)
  }, s));
}
o5.displayName = "@mantine/core/MenuDivider";
const s5 = {
  context: "Menu component was not found in the tree",
  children: "Menu.Target component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
}, [YJ, nx] = dg(s5.context);
var GJ = Object.defineProperty, rw = Object.getOwnPropertySymbols, l5 = Object.prototype.hasOwnProperty, u5 = Object.prototype.propertyIsEnumerable, B3 = (e, t, n) => t in e ? GJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, QJ = (e, t) => {
  for (var n in t || (t = {}))
    l5.call(t, n) && B3(e, n, t[n]);
  if (rw)
    for (var n of rw(t))
      u5.call(t, n) && B3(e, n, t[n]);
  return e;
}, KJ = (e, t) => {
  var n = {};
  for (var r in e)
    l5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && rw)
    for (var r of rw(e))
      t.indexOf(r) < 0 && u5.call(e, r) && (n[r] = e[r]);
  return n;
};
function c5(e) {
  var t = e, {
    children: n,
    onMouseEnter: r,
    onMouseLeave: s
  } = t, f = KJ(t, [
    "children",
    "onMouseEnter",
    "onMouseLeave"
  ]);
  const m = F.exports.useRef(), p = nx(), v = (P) => {
    (P.key === "ArrowUp" || P.key === "ArrowDown") && (P.preventDefault(), m.current.querySelectorAll("[data-menu-item]")[0].focus());
  }, y = fc(r, () => p.trigger === "hover" && p.openDropdown()), w = fc(s, () => p.trigger === "hover" && p.closeDropdown());
  return /* @__PURE__ */ T.createElement(pc.Dropdown, QJ({
    onMouseEnter: y,
    onMouseLeave: w,
    role: "menu",
    "aria-orientation": "vertical"
  }, f), /* @__PURE__ */ T.createElement("div", {
    tabIndex: -1,
    "data-menu-dropdown": !0,
    "data-autofocus": !0,
    onKeyDown: v,
    ref: m,
    style: { outline: 0 }
  }, n));
}
c5.displayName = "@mantine/core/MenuDropdown";
var JJ = Object.defineProperty, ZJ = Object.defineProperties, eZ = Object.getOwnPropertyDescriptors, U3 = Object.getOwnPropertySymbols, tZ = Object.prototype.hasOwnProperty, nZ = Object.prototype.propertyIsEnumerable, X3 = (e, t, n) => t in e ? JJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, rZ = (e, t) => {
  for (var n in t || (t = {}))
    tZ.call(t, n) && X3(e, n, t[n]);
  if (U3)
    for (var n of U3(t))
      nZ.call(t, n) && X3(e, n, t[n]);
  return e;
}, aZ = (e, t) => ZJ(e, eZ(t)), iZ = $n((e, { color: t, radius: n }) => ({
  item: aZ(rZ({}, e.fn.fontStyles()), {
    WebkitTapHighlightColor: "transparent",
    fontSize: e.fontSizes.sm,
    border: 0,
    backgroundColor: "transparent",
    outline: 0,
    width: "100%",
    textAlign: "left",
    textDecoration: "none",
    boxSizing: "border-box",
    padding: `${e.spacing.xs}px ${e.spacing.sm}px`,
    cursor: "pointer",
    borderRadius: e.fn.radius(n),
    color: t ? e.fn.variant({ variant: "filled", primaryFallback: !1, color: t }).background : e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    display: "flex",
    alignItems: "center",
    "&:disabled": {
      color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[5],
      pointerEvents: "none",
      userSelect: "none"
    },
    "&[data-hovered]": {
      backgroundColor: t ? e.fn.variant({ variant: "light", color: t }).background : e.colorScheme === "dark" ? e.fn.rgba(e.colors.dark[3], 0.35) : e.colors.gray[0]
    }
  }),
  itemLabel: {
    flex: 1
  },
  itemIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: e.spacing.xs
  },
  itemRightSection: {}
}));
const oZ = iZ;
var sZ = Object.defineProperty, lZ = Object.defineProperties, uZ = Object.getOwnPropertyDescriptors, aw = Object.getOwnPropertySymbols, d5 = Object.prototype.hasOwnProperty, f5 = Object.prototype.propertyIsEnumerable, q3 = (e, t, n) => t in e ? sZ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, cZ = (e, t) => {
  for (var n in t || (t = {}))
    d5.call(t, n) && q3(e, n, t[n]);
  if (aw)
    for (var n of aw(t))
      f5.call(t, n) && q3(e, n, t[n]);
  return e;
}, dZ = (e, t) => lZ(e, uZ(t)), fZ = (e, t) => {
  var n = {};
  for (var r in e)
    d5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && aw)
    for (var r of aw(e))
      t.indexOf(r) < 0 && f5.call(e, r) && (n[r] = e[r]);
  return n;
};
const m5 = F.exports.forwardRef((e, t) => {
  var n = e, { children: r, className: s, color: f, closeMenuOnClick: m, icon: p, rightSection: v } = n, y = fZ(n, ["children", "className", "color", "closeMenuOnClick", "icon", "rightSection"]);
  const w = nx(), { classNames: P, styles: x, unstyled: A } = gu(), { classes: M, cx: O, theme: j } = oZ({ radius: w.radius, color: f }, { name: "Menu", classNames: P, styles: x, unstyled: A }), H = F.exports.useRef(), J = w.getItemIndex(H.current), V = y, X = fc(V.onMouseLeave, () => w.setHovered(-1)), U = fc(V.onMouseEnter, () => w.setHovered(w.getItemIndex(H.current))), K = fc(V.onClick, () => {
    typeof m == "boolean" ? m && w.closeDropdownImmediately() : w.closeOnItemClick && w.closeDropdownImmediately();
  }), ce = fc(V.onFocus, () => w.setHovered(w.getItemIndex(H.current)));
  return /* @__PURE__ */ T.createElement(Gn, dZ(cZ({
    component: "button",
    type: "button"
  }, y), {
    tabIndex: -1,
    onFocus: ce,
    className: O(M.item, s),
    ref: HS(H, t),
    role: "menuitem",
    "data-menu-item": !0,
    "data-hovered": w.hovered === J ? !0 : void 0,
    onMouseEnter: U,
    onMouseLeave: X,
    onClick: K,
    onKeyDown: DS({
      siblingSelector: "[data-menu-item]",
      parentSelector: "[data-menu-dropdown]",
      activateOnFocus: !1,
      loop: w.loop,
      dir: j.dir,
      orientation: "vertical",
      onKeyDown: V.onKeydown
    })
  }), p && /* @__PURE__ */ T.createElement("div", {
    className: M.itemIcon
  }, p), r && /* @__PURE__ */ T.createElement("div", {
    className: M.itemLabel
  }, r), v && /* @__PURE__ */ T.createElement("div", {
    className: M.itemRightSection
  }, v));
});
m5.displayName = "@mantine/core/MenuItem";
const mZ = m5;
var hZ = $n((e) => ({
  label: {
    color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6],
    fontWeight: 500,
    fontSize: e.fontSizes.xs,
    padding: `calc(${e.spacing.xs}px / 2) ${e.spacing.sm}px`,
    cursor: "default"
  }
}));
const pZ = hZ;
var vZ = Object.defineProperty, iw = Object.getOwnPropertySymbols, h5 = Object.prototype.hasOwnProperty, p5 = Object.prototype.propertyIsEnumerable, Y3 = (e, t, n) => t in e ? vZ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, gZ = (e, t) => {
  for (var n in t || (t = {}))
    h5.call(t, n) && Y3(e, n, t[n]);
  if (iw)
    for (var n of iw(t))
      p5.call(t, n) && Y3(e, n, t[n]);
  return e;
}, yZ = (e, t) => {
  var n = {};
  for (var r in e)
    h5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && iw)
    for (var r of iw(e))
      t.indexOf(r) < 0 && p5.call(e, r) && (n[r] = e[r]);
  return n;
};
function v5(e) {
  var t = e, { children: n, className: r } = t, s = yZ(t, ["children", "className"]);
  const { classNames: f, styles: m, unstyled: p } = gu(), { classes: v, cx: y } = pZ(null, { name: "Menu", classNames: f, styles: m, unstyled: p });
  return /* @__PURE__ */ T.createElement(Lw, gZ({
    className: y(v.label, r)
  }, s), n);
}
v5.displayName = "@mantine/core/MenuLabel";
var bZ = Object.defineProperty, ow = Object.getOwnPropertySymbols, g5 = Object.prototype.hasOwnProperty, y5 = Object.prototype.propertyIsEnumerable, G3 = (e, t, n) => t in e ? bZ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, wZ = (e, t) => {
  for (var n in t || (t = {}))
    g5.call(t, n) && G3(e, n, t[n]);
  if (ow)
    for (var n of ow(t))
      y5.call(t, n) && G3(e, n, t[n]);
  return e;
}, PZ = (e, t) => {
  var n = {};
  for (var r in e)
    g5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && ow)
    for (var r of ow(e))
      t.indexOf(r) < 0 && y5.call(e, r) && (n[r] = e[r]);
  return n;
};
const b5 = F.exports.forwardRef((e, t) => {
  var n = e, { children: r, refProp: s = "ref" } = n, f = PZ(n, ["children", "refProp"]);
  if (!NS(r))
    throw new Error(s5.children);
  const m = nx(), p = fc(r.props.onClick, () => m.trigger === "click" && m.toggleDropdown()), v = fc(r.props.onMouseEnter, () => m.trigger === "hover" && m.openDropdown()), y = fc(r.props.onMouseLeave, () => m.trigger === "hover" && m.closeDropdown());
  return /* @__PURE__ */ T.createElement(pc.Target, wZ({
    refProp: s,
    popupType: "menu",
    ref: t
  }, f), F.exports.cloneElement(r, {
    onClick: p,
    onMouseEnter: v,
    onMouseLeave: y,
    "data-expanded": m.opened ? !0 : void 0
  }));
});
b5.displayName = "@mantine/core/MenuTarget";
var kZ = $n({
  dropdown: { padding: 4 }
});
const $Z = kZ;
var SZ = Object.defineProperty, xZ = Object.defineProperties, CZ = Object.getOwnPropertyDescriptors, sw = Object.getOwnPropertySymbols, w5 = Object.prototype.hasOwnProperty, P5 = Object.prototype.propertyIsEnumerable, Q3 = (e, t, n) => t in e ? SZ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, K3 = (e, t) => {
  for (var n in t || (t = {}))
    w5.call(t, n) && Q3(e, n, t[n]);
  if (sw)
    for (var n of sw(t))
      P5.call(t, n) && Q3(e, n, t[n]);
  return e;
}, J3 = (e, t) => xZ(e, CZ(t)), MZ = (e, t) => {
  var n = {};
  for (var r in e)
    w5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && sw)
    for (var r of sw(e))
      t.indexOf(r) < 0 && P5.call(e, r) && (n[r] = e[r]);
  return n;
};
const EZ = {
  closeOnItemClick: !0,
  loop: !0,
  trigger: "click",
  openDelay: 0,
  closeDelay: 100
};
function Pl(e) {
  const t = Er("Menu", EZ, e), {
    children: n,
    onOpen: r,
    onClose: s,
    opened: f,
    defaultOpened: m,
    onChange: p,
    closeOnItemClick: v,
    loop: y,
    closeOnEscape: w,
    trigger: P,
    openDelay: x,
    closeDelay: A,
    classNames: M,
    styles: O,
    unstyled: j,
    radius: H
  } = t, J = MZ(t, [
    "children",
    "onOpen",
    "onClose",
    "opened",
    "defaultOpened",
    "onChange",
    "closeOnItemClick",
    "loop",
    "closeOnEscape",
    "trigger",
    "openDelay",
    "closeDelay",
    "classNames",
    "styles",
    "unstyled",
    "radius"
  ]), { classes: V, cx: X } = $Z(), [U, { setHovered: K, resetHovered: ce }] = lV(), [ue, ye] = Jh({
    value: f,
    defaultValue: m,
    finalValue: !1,
    onChange: p
  }), Oe = () => {
    ye(!1), ue && (s == null || s());
  }, _e = () => {
    ye(!0), !ue && (r == null || r());
  }, Le = () => ue ? Oe() : _e(), { openDropdown: Ne, closeDropdown: nt } = DJ({ open: _e, close: Oe, closeDelay: A, openDelay: x }), Qe = (qe) => iV("[data-menu-item]", "[data-menu-dropdown]", qe);
  return kd(() => {
    ce();
  }, [ue]), /* @__PURE__ */ T.createElement(YJ, {
    value: {
      opened: ue,
      toggleDropdown: Le,
      getItemIndex: Qe,
      hovered: U,
      setHovered: K,
      closeOnItemClick: v,
      closeDropdown: P === "click" ? Oe : nt,
      openDropdown: P === "click" ? _e : Ne,
      closeDropdownImmediately: Oe,
      loop: y,
      trigger: P,
      radius: H
    }
  }, /* @__PURE__ */ T.createElement(pc, J3(K3({}, J), {
    radius: H,
    opened: ue,
    onChange: ye,
    defaultOpened: m,
    trapFocus: P === "click",
    closeOnEscape: w && P === "click",
    __staticSelector: "Menu",
    classNames: J3(K3({}, M), { dropdown: X(V.dropdown, M == null ? void 0 : M.dropdown) }),
    styles: O,
    unstyled: j,
    onClose: Oe,
    onOpen: _e
  }), n));
}
Pl.displayName = "@mantine/core/Menu";
Pl.Item = mZ;
Pl.Label = v5;
Pl.Dropdown = c5;
Pl.Target = b5;
Pl.Divider = o5;
const k5 = F.exports.createContext(null), AZ = k5.Provider, _Z = () => F.exports.useContext(k5);
var OZ = Object.defineProperty, lw = Object.getOwnPropertySymbols, $5 = Object.prototype.hasOwnProperty, S5 = Object.prototype.propertyIsEnumerable, Z3 = (e, t, n) => t in e ? OZ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, eO = (e, t) => {
  for (var n in t || (t = {}))
    $5.call(t, n) && Z3(e, n, t[n]);
  if (lw)
    for (var n of lw(t))
      S5.call(t, n) && Z3(e, n, t[n]);
  return e;
}, TZ = (e, t) => {
  var n = {};
  for (var r in e)
    $5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && lw)
    for (var r of lw(e))
      t.indexOf(r) < 0 && S5.call(e, r) && (n[r] = e[r]);
  return n;
};
const RZ = {
  orientation: "horizontal",
  spacing: "lg",
  size: "sm",
  offset: "xs"
}, x5 = F.exports.forwardRef((e, t) => {
  const n = Er("SwitchGroup", RZ, e), {
    children: r,
    value: s,
    defaultValue: f,
    onChange: m,
    orientation: p,
    spacing: v,
    size: y,
    wrapperProps: w,
    offset: P
  } = n, x = TZ(n, [
    "children",
    "value",
    "defaultValue",
    "onChange",
    "orientation",
    "spacing",
    "size",
    "wrapperProps",
    "offset"
  ]), [A, M] = Jh({
    value: s,
    defaultValue: f,
    finalValue: [],
    onChange: m
  }), O = (j) => {
    const H = j.currentTarget.value;
    M(A.includes(H) ? A.filter((J) => J !== H) : [...A, H]);
  };
  return /* @__PURE__ */ T.createElement(AZ, {
    value: { value: A, onChange: O, size: y }
  }, /* @__PURE__ */ T.createElement(F$.Wrapper, eO(eO({
    labelElement: "div",
    size: y,
    __staticSelector: "SwitchGroup",
    ref: t
  }, w), x), /* @__PURE__ */ T.createElement(dJ, {
    spacing: v,
    orientation: p,
    offset: P
  }, r)));
});
x5.displayName = "@mantine/core/SwitchGroup";
var DZ = Object.defineProperty, NZ = Object.defineProperties, WZ = Object.getOwnPropertyDescriptors, tO = Object.getOwnPropertySymbols, jZ = Object.prototype.hasOwnProperty, zZ = Object.prototype.propertyIsEnumerable, nO = (e, t, n) => t in e ? DZ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, LZ = (e, t) => {
  for (var n in t || (t = {}))
    jZ.call(t, n) && nO(e, n, t[n]);
  if (tO)
    for (var n of tO(t))
      zZ.call(t, n) && nO(e, n, t[n]);
  return e;
}, IZ = (e, t) => NZ(e, WZ(t));
const FZ = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 30,
  xl: 36
}, HZ = {
  xs: 32,
  sm: 38,
  md: 46,
  lg: 56,
  xl: 72
}, VZ = {
  xs: 12,
  sm: 14,
  md: 18,
  lg: 22,
  xl: 28
}, BZ = {
  xs: 5,
  sm: 6,
  md: 7,
  lg: 9,
  xl: 11
}, UZ = {
  xs: 4,
  sm: 5,
  md: 6,
  lg: 8,
  xl: 10
};
var XZ = $n((e, { size: t, radius: n, color: r, labelPosition: s, error: f }) => {
  const m = e.fn.size({ size: t, sizes: VZ }), p = e.fn.size({ size: n, sizes: e.radius }), v = e.fn.variant({ variant: "filled", color: r }), y = e.fn.size({ size: t, sizes: HZ }), w = t === "xs" ? 1 : 2, P = e.fn.variant({ variant: "filled", color: "red" }).background;
  return {
    input: {
      clip: "rect(1px, 1px, 1px, 1px)",
      height: "1px",
      overflow: "hidden",
      width: "1px",
      whiteSpace: "nowrap",
      padding: "0",
      WebkitClipPath: "inset(50%)",
      clipPath: "inset(50%)"
    },
    track: IZ(LZ({}, e.fn.focusStyles("input:focus + &")), {
      cursor: e.cursorType,
      overflow: "hidden",
      WebkitTapHighlightColor: "transparent",
      position: "relative",
      borderRadius: p,
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[2],
      border: `1px solid ${f ? P : e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3]}`,
      height: e.fn.size({ size: t, sizes: FZ }),
      minWidth: y,
      margin: 0,
      transitionProperty: "background-color, border-color",
      transitionTimingFunction: e.transitionTimingFunction,
      transitionDuration: "150ms",
      boxSizing: "border-box",
      appearance: "none",
      display: "flex",
      alignItems: "center",
      fontSize: e.fn.size({ size: t, sizes: BZ }),
      fontWeight: 600,
      order: s === "left" ? 2 : 1,
      userSelect: "none",
      MozUserSelect: "none",
      WebkitUserSelect: "none",
      MsUserSelect: "none",
      zIndex: 0,
      lineHeight: 0,
      color: e.colorScheme === "dark" ? e.colors.dark[1] : e.colors.gray[6],
      transition: `color 150ms ${e.transitionTimingFunction}`,
      "input:checked + &": {
        backgroundColor: v.background,
        borderColor: v.background,
        color: e.white,
        transition: `color 150ms ${e.transitionTimingFunction}`
      },
      "input:disabled + &": {
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2],
        borderColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2],
        cursor: "not-allowed"
      }
    }),
    thumb: {
      position: "absolute",
      zIndex: 1,
      borderRadius: p,
      boxSizing: "border-box",
      display: "flex",
      backgroundColor: e.white,
      height: m,
      width: m,
      border: `1px solid ${e.colorScheme === "dark" ? e.white : e.colors.gray[3]}`,
      left: `${w}px`,
      transition: `left 150ms ${e.transitionTimingFunction}`,
      "& > *": {
        margin: "auto"
      },
      "@media (prefers-reduced-motion)": {
        transitionDuration: e.respectReducedMotion ? "0ms" : ""
      },
      "input:checked + * > &": {
        left: `calc(100% - ${m}px - ${w}px)`,
        borderColor: e.white
      },
      "input:disabled + * > &": {
        borderColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2],
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[0]
      }
    },
    trackLabel: {
      height: "100%",
      display: "grid",
      placeContent: "center",
      minWidth: y - m,
      paddingInline: e.fn.size({ size: t, sizes: UZ }),
      margin: `0 0 0 ${m + w}px`,
      transition: `margin 150ms ${e.transitionTimingFunction}`,
      "input:checked + * > &": {
        margin: `0 ${m + w}px 0 0`
      }
    }
  };
});
const qZ = XZ;
var YZ = Object.defineProperty, GZ = Object.defineProperties, QZ = Object.getOwnPropertyDescriptors, uw = Object.getOwnPropertySymbols, C5 = Object.prototype.hasOwnProperty, M5 = Object.prototype.propertyIsEnumerable, rO = (e, t, n) => t in e ? YZ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, o$ = (e, t) => {
  for (var n in t || (t = {}))
    C5.call(t, n) && rO(e, n, t[n]);
  if (uw)
    for (var n of uw(t))
      M5.call(t, n) && rO(e, n, t[n]);
  return e;
}, KZ = (e, t) => GZ(e, QZ(t)), JZ = (e, t) => {
  var n = {};
  for (var r in e)
    C5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && uw)
    for (var r of uw(e))
      t.indexOf(r) < 0 && M5.call(e, r) && (n[r] = e[r]);
  return n;
};
const ZZ = {
  offLabel: "",
  onLabel: "",
  size: "sm",
  radius: "xl",
  error: !1
}, rx = F.exports.forwardRef((e, t) => {
  var n;
  const r = Er("Switch", ZZ, e), {
    className: s,
    color: f,
    label: m,
    offLabel: p,
    onLabel: v,
    id: y,
    style: w,
    size: P,
    radius: x,
    wrapperProps: A,
    children: M,
    unstyled: O,
    styles: j,
    classNames: H,
    thumbIcon: J,
    sx: V,
    checked: X,
    defaultChecked: U,
    onChange: K,
    labelPosition: ce,
    description: ue,
    error: ye,
    disabled: Oe
  } = r, _e = JZ(r, [
    "className",
    "color",
    "label",
    "offLabel",
    "onLabel",
    "id",
    "style",
    "size",
    "radius",
    "wrapperProps",
    "children",
    "unstyled",
    "styles",
    "classNames",
    "thumbIcon",
    "sx",
    "checked",
    "defaultChecked",
    "onChange",
    "labelPosition",
    "description",
    "error",
    "disabled"
  ]), Le = _Z(), { classes: Ne } = qZ({ size: (Le == null ? void 0 : Le.size) || P, color: f, radius: x, labelPosition: ce, error: !!ye }, { unstyled: O, styles: j, classNames: H, name: "Switch" }), { systemStyles: nt, rest: Qe } = Ww(_e), qe = Nw(y), ie = Le ? {
    checked: Le.value.includes(Qe.value),
    onChange: Le.onChange
  } : {}, [xe, Ye] = Jh({
    value: (n = ie.checked) != null ? n : X,
    defaultValue: U,
    finalValue: !1
  });
  return /* @__PURE__ */ T.createElement(KN, o$(o$({
    className: s,
    sx: V,
    style: w,
    id: qe,
    size: (Le == null ? void 0 : Le.size) || P,
    labelPosition: ce,
    label: m,
    description: ue,
    error: ye,
    disabled: Oe,
    __staticSelector: "Switch",
    classNames: H,
    styles: j,
    unstyled: O,
    "data-checked": ie.checked || void 0
  }, nt), A), /* @__PURE__ */ T.createElement("input", KZ(o$({}, Qe), {
    disabled: Oe,
    checked: xe,
    onChange: (Be) => {
      Le ? ie.onChange(Be) : K == null || K(Be), Ye(Be.currentTarget.checked);
    },
    id: qe,
    ref: t,
    type: "checkbox",
    className: Ne.input
  })), /* @__PURE__ */ T.createElement("label", {
    htmlFor: qe,
    className: Ne.track
  }, /* @__PURE__ */ T.createElement("div", {
    className: Ne.thumb
  }, J), /* @__PURE__ */ T.createElement("div", {
    className: Ne.trackLabel
  }, xe ? v : p)));
});
rx.displayName = "@mantine/core/Switch";
rx.Group = x5;
const B$ = {
  context: "Tabs component was not found in the tree",
  value: "Tabs.Tab or Tabs.Panel component was rendered with invalid value or without value"
}, [eee, ax] = dg(B$.context);
var tee = Object.defineProperty, aO = Object.getOwnPropertySymbols, nee = Object.prototype.hasOwnProperty, ree = Object.prototype.propertyIsEnumerable, iO = (e, t, n) => t in e ? tee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, aee = (e, t) => {
  for (var n in t || (t = {}))
    nee.call(t, n) && iO(e, n, t[n]);
  if (aO)
    for (var n of aO(t))
      ree.call(t, n) && iO(e, n, t[n]);
  return e;
};
function iee({ variant: e, orientation: t, inverted: n, placement: r }, s) {
  const f = t === "vertical";
  return e === "default" ? {
    [f ? r === "left" ? "borderRight" : "borderLeft" : n ? "borderTop" : "borderBottom"]: `2px solid ${s.colorScheme === "dark" ? s.colors.dark[4] : s.colors.gray[3]}`
  } : e === "outline" ? {
    [f ? r === "left" ? "borderRight" : "borderLeft" : n ? "borderTop" : "borderBottom"]: `1px solid ${s.colorScheme === "dark" ? s.colors.dark[4] : s.colors.gray[3]}`
  } : e === "pills" ? {
    gap: `calc(${s.spacing.sm}px / 2)`
  } : {};
}
var oee = $n((e, t) => {
  const n = t.orientation === "vertical";
  return {
    tabsList: aee({
      display: "flex",
      flexWrap: "wrap",
      flexDirection: n ? "column" : "row",
      justifyContent: HN[t.position],
      '& [role="tab"]': {
        flex: t.grow ? 1 : void 0
      }
    }, iee(t, e))
  };
});
const see = oee;
var lee = Object.defineProperty, uee = Object.defineProperties, cee = Object.getOwnPropertyDescriptors, cw = Object.getOwnPropertySymbols, E5 = Object.prototype.hasOwnProperty, A5 = Object.prototype.propertyIsEnumerable, oO = (e, t, n) => t in e ? lee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, dee = (e, t) => {
  for (var n in t || (t = {}))
    E5.call(t, n) && oO(e, n, t[n]);
  if (cw)
    for (var n of cw(t))
      A5.call(t, n) && oO(e, n, t[n]);
  return e;
}, fee = (e, t) => uee(e, cee(t)), mee = (e, t) => {
  var n = {};
  for (var r in e)
    E5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && cw)
    for (var r of cw(e))
      t.indexOf(r) < 0 && A5.call(e, r) && (n[r] = e[r]);
  return n;
};
const _5 = F.exports.forwardRef((e, t) => {
  var n = e, { children: r, className: s, grow: f = !1, position: m = "left" } = n, p = mee(n, ["children", "className", "grow", "position"]);
  const { orientation: v, variant: y, color: w, radius: P, inverted: x, placement: A } = ax(), { classNames: M, styles: O, unstyled: j } = gu(), { classes: H, cx: J } = see({ orientation: v, grow: f, variant: y, color: w, position: m, radius: P, inverted: x, placement: A }, { name: "Tabs", unstyled: j, classNames: M, styles: O });
  return /* @__PURE__ */ T.createElement(Gn, fee(dee({}, p), {
    className: J(H.tabsList, s),
    ref: t,
    role: "tablist",
    "aria-orientation": v
  }), r);
});
_5.displayName = "@mantine/core/TabsList";
var hee = $n((e, { orientation: t }) => ({
  panel: {
    flex: t === "vertical" ? 1 : void 0
  }
}));
const pee = hee;
var vee = Object.defineProperty, gee = Object.defineProperties, yee = Object.getOwnPropertyDescriptors, dw = Object.getOwnPropertySymbols, O5 = Object.prototype.hasOwnProperty, T5 = Object.prototype.propertyIsEnumerable, sO = (e, t, n) => t in e ? vee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, bee = (e, t) => {
  for (var n in t || (t = {}))
    O5.call(t, n) && sO(e, n, t[n]);
  if (dw)
    for (var n of dw(t))
      T5.call(t, n) && sO(e, n, t[n]);
  return e;
}, wee = (e, t) => gee(e, yee(t)), Pee = (e, t) => {
  var n = {};
  for (var r in e)
    O5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && dw)
    for (var r of dw(e))
      t.indexOf(r) < 0 && T5.call(e, r) && (n[r] = e[r]);
  return n;
};
const R5 = F.exports.forwardRef((e, t) => {
  var n = e, { value: r, children: s, sx: f, className: m } = n, p = Pee(n, ["value", "children", "sx", "className"]);
  const v = ax(), { classNames: y, styles: w, unstyled: P } = gu(), { classes: x, cx: A } = pee({
    orientation: v.orientation,
    variant: v.variant,
    color: v.color,
    radius: v.radius,
    inverted: v.inverted,
    placement: v.placement
  }, { name: "Tabs", unstyled: P, classNames: y, styles: w }), M = v.value === r, O = v.keepMounted || M ? s : null;
  return /* @__PURE__ */ T.createElement(Gn, wee(bee({}, p), {
    ref: t,
    sx: [{ display: M ? void 0 : "none" }, ...f1(f)],
    className: A(x.panel, m),
    role: "tabpanel",
    id: v.getPanelId(r),
    "aria-labelledby": v.getTabId(r)
  }), O);
});
R5.displayName = "@mantine/core/TabsPanel";
var kee = Object.defineProperty, $ee = Object.defineProperties, See = Object.getOwnPropertyDescriptors, lO = Object.getOwnPropertySymbols, xee = Object.prototype.hasOwnProperty, Cee = Object.prototype.propertyIsEnumerable, uO = (e, t, n) => t in e ? kee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Th = (e, t) => {
  for (var n in t || (t = {}))
    xee.call(t, n) && uO(e, n, t[n]);
  if (lO)
    for (var n of lO(t))
      Cee.call(t, n) && uO(e, n, t[n]);
  return e;
}, cO = (e, t) => $ee(e, See(t));
function Mee(e, { variant: t, orientation: n, color: r, radius: s, inverted: f, placement: m }) {
  const p = n === "vertical", v = e.fn.variant({ color: r, variant: "filled" }), y = e.fn.radius(s), w = n === "vertical" ? m === "left" ? `${y}px 0 0 ${y}px` : ` 0 ${y}px ${y}px 0` : f ? `0 0 ${y}px ${y}px` : `${y}px ${y}px 0 0`;
  return t === "default" ? cO(Th({
    [p ? m === "left" ? "borderRight" : "borderLeft" : f ? "borderTop" : "borderBottom"]: "2px solid transparent",
    [p ? m === "left" ? "marginRight" : "marginLeft" : f ? "marginTop" : "marginBottom"]: -2,
    borderRadius: w
  }, e.fn.hover({
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0],
    borderColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3]
  })), {
    "&[data-active]": Th({
      borderColor: v.background,
      color: e.colorScheme === "dark" ? e.white : e.black
    }, e.fn.hover({ borderColor: v.background }))
  }) : t === "outline" ? {
    borderRadius: w,
    border: "1px solid transparent",
    [p ? m === "left" ? "borderRight" : "borderLeft" : f ? "borderTop" : "borderBottom"]: "none",
    "&[data-active]": {
      borderColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3],
      "&::before": {
        content: '""',
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
        position: "absolute",
        bottom: p ? 0 : f ? "unset" : -1,
        top: p ? 0 : f ? -1 : "unset",
        [p ? "width" : "height"]: 1,
        right: p ? m === "left" ? -1 : "unset" : 0,
        left: p ? m === "left" ? "unset" : -1 : 0
      }
    }
  } : t === "pills" ? cO(Th({
    borderRadius: e.fn.radius(s)
  }, e.fn.hover({
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0]
  })), {
    "&[data-active]": Th({
      backgroundColor: v.background,
      color: e.white
    }, e.fn.hover({ backgroundColor: v.background }))
  }) : {};
}
var Eee = $n((e, t) => ({
  tabLabel: {},
  tab: Th({
    position: "relative",
    padding: `${e.spacing.xs}px ${e.spacing.md}px`,
    paddingLeft: t.withIcon ? e.spacing.xs : void 0,
    paddingRight: t.withRightSection ? e.spacing.xs : void 0,
    fontSize: e.fontSizes.sm,
    whiteSpace: "nowrap",
    zIndex: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: t.orientation === "horizontal" ? "center" : void 0,
    lineHeight: 1,
    "&:disabled": Th({
      opacity: 0.5,
      cursor: "not-allowed"
    }, e.fn.hover({ backgroundColor: "transparent" })),
    "&:focus": {
      zIndex: 1
    }
  }, Mee(e, t)),
  tabRightSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:not(:only-child)": {
      marginLeft: 7
    }
  },
  tabIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:not(:only-child)": {
      marginRight: 7
    }
  }
}));
const Aee = Eee;
var _ee = Object.defineProperty, Oee = Object.defineProperties, Tee = Object.getOwnPropertyDescriptors, fw = Object.getOwnPropertySymbols, D5 = Object.prototype.hasOwnProperty, N5 = Object.prototype.propertyIsEnumerable, dO = (e, t, n) => t in e ? _ee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ree = (e, t) => {
  for (var n in t || (t = {}))
    D5.call(t, n) && dO(e, n, t[n]);
  if (fw)
    for (var n of fw(t))
      N5.call(t, n) && dO(e, n, t[n]);
  return e;
}, Dee = (e, t) => Oee(e, Tee(t)), Nee = (e, t) => {
  var n = {};
  for (var r in e)
    D5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && fw)
    for (var r of fw(e))
      t.indexOf(r) < 0 && N5.call(e, r) && (n[r] = e[r]);
  return n;
};
const W5 = F.exports.forwardRef((e, t) => {
  var n = e, { value: r, children: s, onKeyDown: f, onClick: m, className: p, icon: v, rightSection: y, color: w } = n, P = Nee(n, ["value", "children", "onKeyDown", "onClick", "className", "icon", "rightSection", "color"]);
  const x = ax(), { classNames: A, styles: M, unstyled: O } = gu(), j = !!v, H = !!y, { theme: J, classes: V, cx: X } = Aee({
    withIcon: j || H && !s,
    withRightSection: H || j && !s,
    orientation: x.orientation,
    color: w || x.color,
    variant: x.variant,
    radius: x.radius,
    inverted: x.inverted,
    placement: x.placement
  }, { name: "Tabs", unstyled: O, classNames: A, styles: M }), U = r === x.value, K = (ce) => {
    x.onTabChange(x.allowTabDeactivation && r === x.value ? null : r), m == null || m(ce);
  };
  return /* @__PURE__ */ T.createElement(jw, Dee(Ree({}, P), {
    unstyled: O,
    className: X(V.tab, p),
    "data-active": U || void 0,
    ref: t,
    type: "button",
    role: "tab",
    id: x.getTabId(r),
    "aria-selected": U,
    tabIndex: U || x.value === null ? 0 : -1,
    "aria-controls": x.getPanelId(r),
    onClick: K,
    onKeyDown: DS({
      siblingSelector: '[role="tab"]',
      parentSelector: '[role="tablist"]',
      activateOnFocus: x.activateTabWithKeyboard,
      loop: x.loop,
      dir: J.dir,
      orientation: x.orientation,
      onKeyDown: f
    })
  }), v && /* @__PURE__ */ T.createElement("div", {
    className: V.tabIcon
  }, v), s && /* @__PURE__ */ T.createElement("div", {
    className: V.tabLabel
  }, s), y && /* @__PURE__ */ T.createElement("div", {
    className: V.tabRightSection
  }, y));
});
W5.displayName = "@mantine/core/Tab";
function j5({
  defaultValue: e,
  value: t,
  onTabChange: n,
  orientation: r,
  children: s,
  loop: f,
  id: m,
  activateTabWithKeyboard: p,
  allowTabDeactivation: v,
  variant: y,
  color: w,
  radius: P,
  inverted: x,
  placement: A,
  keepMounted: M = !0
}) {
  const O = Nw(m), [j, H] = Jh({
    value: t,
    defaultValue: e,
    finalValue: null,
    onChange: n
  });
  return /* @__PURE__ */ T.createElement(eee, {
    value: {
      placement: A,
      value: j,
      orientation: r,
      id: O,
      loop: f,
      activateTabWithKeyboard: p,
      getTabId: m1(`${O}-tab`, B$.value),
      getPanelId: m1(`${O}-panel`, B$.value),
      onTabChange: H,
      allowTabDeactivation: v,
      variant: y,
      color: w,
      radius: P,
      inverted: x,
      keepMounted: M
    }
  }, s);
}
j5.displayName = "@mantine/core/TabsProvider";
var Wee = $n((e, { orientation: t, placement: n }) => ({
  root: {
    display: t === "vertical" ? "flex" : void 0,
    flexDirection: n === "right" ? "row-reverse" : "row"
  }
}));
const jee = Wee;
var zee = Object.defineProperty, Lee = Object.defineProperties, Iee = Object.getOwnPropertyDescriptors, mw = Object.getOwnPropertySymbols, z5 = Object.prototype.hasOwnProperty, L5 = Object.prototype.propertyIsEnumerable, fO = (e, t, n) => t in e ? zee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Fee = (e, t) => {
  for (var n in t || (t = {}))
    z5.call(t, n) && fO(e, n, t[n]);
  if (mw)
    for (var n of mw(t))
      L5.call(t, n) && fO(e, n, t[n]);
  return e;
}, Hee = (e, t) => Lee(e, Iee(t)), Vee = (e, t) => {
  var n = {};
  for (var r in e)
    z5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && mw)
    for (var r of mw(e))
      t.indexOf(r) < 0 && L5.call(e, r) && (n[r] = e[r]);
  return n;
};
const Bee = {
  orientation: "horizontal",
  loop: !0,
  activateTabWithKeyboard: !0,
  allowTabDeactivation: !1,
  unstyled: !1,
  inverted: !1,
  variant: "default",
  placement: "left"
}, wd = F.exports.forwardRef((e, t) => {
  const n = Er("Tabs", Bee, e), {
    defaultValue: r,
    value: s,
    orientation: f,
    loop: m,
    activateTabWithKeyboard: p,
    allowTabDeactivation: v,
    children: y,
    id: w,
    onTabChange: P,
    variant: x,
    color: A,
    className: M,
    unstyled: O,
    classNames: j,
    styles: H,
    radius: J,
    inverted: V,
    keepMounted: X,
    placement: U
  } = n, K = Vee(n, [
    "defaultValue",
    "value",
    "orientation",
    "loop",
    "activateTabWithKeyboard",
    "allowTabDeactivation",
    "children",
    "id",
    "onTabChange",
    "variant",
    "color",
    "className",
    "unstyled",
    "classNames",
    "styles",
    "radius",
    "inverted",
    "keepMounted",
    "placement"
  ]), { classes: ce, cx: ue } = jee({ orientation: f, color: A, variant: x, radius: J, inverted: V, placement: U }, { unstyled: O, name: "Tabs", classNames: j, styles: H });
  return /* @__PURE__ */ T.createElement(IS, {
    classNames: j,
    styles: H,
    unstyled: O
  }, /* @__PURE__ */ T.createElement(j5, {
    activateTabWithKeyboard: p,
    defaultValue: r,
    orientation: f,
    onTabChange: P,
    value: s,
    id: w,
    loop: m,
    allowTabDeactivation: v,
    color: A,
    variant: x,
    radius: J,
    inverted: V,
    keepMounted: X,
    placement: U
  }, /* @__PURE__ */ T.createElement(Gn, Hee(Fee({}, K), {
    className: ue(ce.root, M),
    id: w,
    ref: t
  }), y)));
});
wd.List = _5;
wd.Tab = W5;
wd.Panel = R5;
wd.displayName = "@mantine/core/Tabs";
var I5 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(dc, function() {
    for (var n = function(k, C, W) {
      return C === void 0 && (C = 0), W === void 0 && (W = 1), k < C ? C : k > W ? W : k;
    }, r = n, s = function(k) {
      k._clipped = !1, k._unclipped = k.slice(0);
      for (var C = 0; C <= 3; C++)
        C < 3 ? ((k[C] < 0 || k[C] > 255) && (k._clipped = !0), k[C] = r(k[C], 0, 255)) : C === 3 && (k[C] = r(k[C], 0, 1));
      return k;
    }, f = {}, m = 0, p = ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp", "Undefined", "Null"]; m < p.length; m += 1) {
      var v = p[m];
      f["[object " + v + "]"] = v.toLowerCase();
    }
    var y = function(k) {
      return f[Object.prototype.toString.call(k)] || "object";
    }, w = y, P = function(k, C) {
      return C === void 0 && (C = null), k.length >= 3 ? Array.prototype.slice.call(k) : w(k[0]) == "object" && C ? C.split("").filter(function(W) {
        return k[0][W] !== void 0;
      }).map(function(W) {
        return k[0][W];
      }) : k[0];
    }, x = y, A = function(k) {
      if (k.length < 2)
        return null;
      var C = k.length - 1;
      return x(k[C]) == "string" ? k[C].toLowerCase() : null;
    }, M = Math.PI, O = {
      clip_rgb: s,
      limit: n,
      type: y,
      unpack: P,
      last: A,
      PI: M,
      TWOPI: M * 2,
      PITHIRD: M / 3,
      DEG2RAD: M / 180,
      RAD2DEG: 180 / M
    }, j = {
      format: {},
      autodetect: []
    }, H = O.last, J = O.clip_rgb, V = O.type, X = j, U = function() {
      for (var C = [], W = arguments.length; W--; )
        C[W] = arguments[W];
      var Y = this;
      if (V(C[0]) === "object" && C[0].constructor && C[0].constructor === this.constructor)
        return C[0];
      var ne = H(C), se = !1;
      if (!ne) {
        se = !0, X.sorted || (X.autodetect = X.autodetect.sort(function(We, it) {
          return it.p - We.p;
        }), X.sorted = !0);
        for (var te = 0, me = X.autodetect; te < me.length; te += 1) {
          var he = me[te];
          if (ne = he.test.apply(he, C), ne)
            break;
        }
      }
      if (X.format[ne]) {
        var Me = X.format[ne].apply(null, se ? C : C.slice(0, -1));
        Y._rgb = J(Me);
      } else
        throw new Error("unknown format: " + C);
      Y._rgb.length === 3 && Y._rgb.push(1);
    };
    U.prototype.toString = function() {
      return V(this.hex) == "function" ? this.hex() : "[" + this._rgb.join(",") + "]";
    };
    var K = U, ce = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(ce.Color, [null].concat(k)))();
    };
    ce.Color = K, ce.version = "2.4.2";
    var ue = ce, ye = O.unpack, Oe = Math.max, _e = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = ye(k, "rgb"), Y = W[0], ne = W[1], se = W[2];
      Y = Y / 255, ne = ne / 255, se = se / 255;
      var te = 1 - Oe(Y, Oe(ne, se)), me = te < 1 ? 1 / (1 - te) : 0, he = (1 - Y - te) * me, Me = (1 - ne - te) * me, We = (1 - se - te) * me;
      return [he, Me, We, te];
    }, Le = _e, Ne = O.unpack, nt = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      k = Ne(k, "cmyk");
      var W = k[0], Y = k[1], ne = k[2], se = k[3], te = k.length > 4 ? k[4] : 1;
      return se === 1 ? [0, 0, 0, te] : [
        W >= 1 ? 0 : 255 * (1 - W) * (1 - se),
        Y >= 1 ? 0 : 255 * (1 - Y) * (1 - se),
        ne >= 1 ? 0 : 255 * (1 - ne) * (1 - se),
        te
      ];
    }, Qe = nt, qe = ue, ie = K, xe = j, Ye = O.unpack, Be = O.type, Ce = Le;
    ie.prototype.cmyk = function() {
      return Ce(this._rgb);
    }, qe.cmyk = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(ie, [null].concat(k, ["cmyk"])))();
    }, xe.format.cmyk = Qe, xe.autodetect.push({
      p: 2,
      test: function() {
        for (var k = [], C = arguments.length; C--; )
          k[C] = arguments[C];
        if (k = Ye(k, "cmyk"), Be(k) === "array" && k.length === 4)
          return "cmyk";
      }
    });
    var Ie = O.unpack, $e = O.last, ot = function(k) {
      return Math.round(k * 100) / 100;
    }, ht = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = Ie(k, "hsla"), Y = $e(k) || "lsa";
      return W[0] = ot(W[0] || 0), W[1] = ot(W[1] * 100) + "%", W[2] = ot(W[2] * 100) + "%", Y === "hsla" || W.length > 3 && W[3] < 1 ? (W[3] = W.length > 3 ? W[3] : 1, Y = "hsla") : W.length = 3, Y + "(" + W.join(",") + ")";
    }, At = ht, Sn = O.unpack, Gt = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      k = Sn(k, "rgba");
      var W = k[0], Y = k[1], ne = k[2];
      W /= 255, Y /= 255, ne /= 255;
      var se = Math.min(W, Y, ne), te = Math.max(W, Y, ne), me = (te + se) / 2, he, Me;
      return te === se ? (he = 0, Me = Number.NaN) : he = me < 0.5 ? (te - se) / (te + se) : (te - se) / (2 - te - se), W == te ? Me = (Y - ne) / (te - se) : Y == te ? Me = 2 + (ne - W) / (te - se) : ne == te && (Me = 4 + (W - Y) / (te - se)), Me *= 60, Me < 0 && (Me += 360), k.length > 3 && k[3] !== void 0 ? [Me, he, me, k[3]] : [Me, he, me];
    }, Bt = Gt, Qn = O.unpack, cn = O.last, Ge = At, vr = Bt, Fn = Math.round, en = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = Qn(k, "rgba"), Y = cn(k) || "rgb";
      return Y.substr(0, 3) == "hsl" ? Ge(vr(W), Y) : (W[0] = Fn(W[0]), W[1] = Fn(W[1]), W[2] = Fn(W[2]), (Y === "rgba" || W.length > 3 && W[3] < 1) && (W[3] = W.length > 3 ? W[3] : 1, Y = "rgba"), Y + "(" + W.slice(0, Y === "rgb" ? 3 : 4).join(",") + ")");
    }, Gr = en, da = O.unpack, gr = Math.round, qi = function() {
      for (var k, C = [], W = arguments.length; W--; )
        C[W] = arguments[W];
      C = da(C, "hsl");
      var Y = C[0], ne = C[1], se = C[2], te, me, he;
      if (ne === 0)
        te = me = he = se * 255;
      else {
        var Me = [0, 0, 0], We = [0, 0, 0], it = se < 0.5 ? se * (1 + ne) : se + ne - se * ne, He = 2 * se - it, pt = Y / 360;
        Me[0] = pt + 1 / 3, Me[1] = pt, Me[2] = pt - 1 / 3;
        for (var lt = 0; lt < 3; lt++)
          Me[lt] < 0 && (Me[lt] += 1), Me[lt] > 1 && (Me[lt] -= 1), 6 * Me[lt] < 1 ? We[lt] = He + (it - He) * 6 * Me[lt] : 2 * Me[lt] < 1 ? We[lt] = it : 3 * Me[lt] < 2 ? We[lt] = He + (it - He) * (2 / 3 - Me[lt]) * 6 : We[lt] = He;
        k = [gr(We[0] * 255), gr(We[1] * 255), gr(We[2] * 255)], te = k[0], me = k[1], he = k[2];
      }
      return C.length > 3 ? [te, me, he, C[3]] : [te, me, he, 1];
    }, Wr = qi, fa = Wr, xa = j, fr = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/, Xn = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/, Hr = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/, Dn = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/, Nn = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/, Ca = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/, Ia = Math.round, Fa = function(k) {
      k = k.toLowerCase().trim();
      var C;
      if (xa.format.named)
        try {
          return xa.format.named(k);
        } catch {
        }
      if (C = k.match(fr)) {
        for (var W = C.slice(1, 4), Y = 0; Y < 3; Y++)
          W[Y] = +W[Y];
        return W[3] = 1, W;
      }
      if (C = k.match(Xn)) {
        for (var ne = C.slice(1, 5), se = 0; se < 4; se++)
          ne[se] = +ne[se];
        return ne;
      }
      if (C = k.match(Hr)) {
        for (var te = C.slice(1, 4), me = 0; me < 3; me++)
          te[me] = Ia(te[me] * 2.55);
        return te[3] = 1, te;
      }
      if (C = k.match(Dn)) {
        for (var he = C.slice(1, 5), Me = 0; Me < 3; Me++)
          he[Me] = Ia(he[Me] * 2.55);
        return he[3] = +he[3], he;
      }
      if (C = k.match(Nn)) {
        var We = C.slice(1, 4);
        We[1] *= 0.01, We[2] *= 0.01;
        var it = fa(We);
        return it[3] = 1, it;
      }
      if (C = k.match(Ca)) {
        var He = C.slice(1, 4);
        He[1] *= 0.01, He[2] *= 0.01;
        var pt = fa(He);
        return pt[3] = +C[4], pt;
      }
    };
    Fa.test = function(k) {
      return fr.test(k) || Xn.test(k) || Hr.test(k) || Dn.test(k) || Nn.test(k) || Ca.test(k);
    };
    var et = Fa, ft = ue, _t = K, an = j, ir = O.type, pn = Gr, vn = et;
    _t.prototype.css = function(k) {
      return pn(this._rgb, k);
    }, ft.css = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(_t, [null].concat(k, ["css"])))();
    }, an.format.css = vn, an.autodetect.push({
      p: 5,
      test: function(k) {
        for (var C = [], W = arguments.length - 1; W-- > 0; )
          C[W] = arguments[W + 1];
        if (!C.length && ir(k) === "string" && vn.test(k))
          return "css";
      }
    });
    var Kn = K, Pn = ue, Vr = j, pi = O.unpack;
    Vr.format.gl = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = pi(k, "rgba");
      return W[0] *= 255, W[1] *= 255, W[2] *= 255, W;
    }, Pn.gl = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(Kn, [null].concat(k, ["gl"])))();
    }, Kn.prototype.gl = function() {
      var k = this._rgb;
      return [k[0] / 255, k[1] / 255, k[2] / 255, k[3]];
    };
    var Ar = O.unpack, Oi = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = Ar(k, "rgb"), Y = W[0], ne = W[1], se = W[2], te = Math.min(Y, ne, se), me = Math.max(Y, ne, se), he = me - te, Me = he * 100 / 255, We = te / (255 - he) * 100, it;
      return he === 0 ? it = Number.NaN : (Y === me && (it = (ne - se) / he), ne === me && (it = 2 + (se - Y) / he), se === me && (it = 4 + (Y - ne) / he), it *= 60, it < 0 && (it += 360)), [it, Me, We];
    }, Qr = Oi, Ha = O.unpack, ma = Math.floor, Kr = function() {
      for (var k, C, W, Y, ne, se, te = [], me = arguments.length; me--; )
        te[me] = arguments[me];
      te = Ha(te, "hcg");
      var he = te[0], Me = te[1], We = te[2], it, He, pt;
      We = We * 255;
      var lt = Me * 255;
      if (Me === 0)
        it = He = pt = We;
      else {
        he === 360 && (he = 0), he > 360 && (he -= 360), he < 0 && (he += 360), he /= 60;
        var jt = ma(he), St = he - jt, gn = We * (1 - Me), Ct = gn + lt * (1 - St), xr = gn + lt * St, zr = gn + lt;
        switch (jt) {
          case 0:
            k = [zr, xr, gn], it = k[0], He = k[1], pt = k[2];
            break;
          case 1:
            C = [Ct, zr, gn], it = C[0], He = C[1], pt = C[2];
            break;
          case 2:
            W = [gn, zr, xr], it = W[0], He = W[1], pt = W[2];
            break;
          case 3:
            Y = [gn, Ct, zr], it = Y[0], He = Y[1], pt = Y[2];
            break;
          case 4:
            ne = [xr, gn, zr], it = ne[0], He = ne[1], pt = ne[2];
            break;
          case 5:
            se = [zr, gn, Ct], it = se[0], He = se[1], pt = se[2];
            break;
        }
      }
      return [it, He, pt, te.length > 3 ? te[3] : 1];
    }, Ka = Kr, Jn = O.unpack, or = O.type, yo = ue, Ti = K, Yi = j, Gi = Qr;
    Ti.prototype.hcg = function() {
      return Gi(this._rgb);
    }, yo.hcg = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(Ti, [null].concat(k, ["hcg"])))();
    }, Yi.format.hcg = Ka, Yi.autodetect.push({
      p: 1,
      test: function() {
        for (var k = [], C = arguments.length; C--; )
          k[C] = arguments[C];
        if (k = Jn(k, "hcg"), or(k) === "array" && k.length === 3)
          return "hcg";
      }
    });
    var Ma = O.unpack, Zt = O.last, gi = Math.round, qs = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = Ma(k, "rgba"), Y = W[0], ne = W[1], se = W[2], te = W[3], me = Zt(k) || "auto";
      te === void 0 && (te = 1), me === "auto" && (me = te < 1 ? "rgba" : "rgb"), Y = gi(Y), ne = gi(ne), se = gi(se);
      var he = Y << 16 | ne << 8 | se, Me = "000000" + he.toString(16);
      Me = Me.substr(Me.length - 6);
      var We = "0" + gi(te * 255).toString(16);
      switch (We = We.substr(We.length - 2), me.toLowerCase()) {
        case "rgba":
          return "#" + Me + We;
        case "argb":
          return "#" + We + Me;
        default:
          return "#" + Me;
      }
    }, Jr = qs, ha = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, yi = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/, Br = function(k) {
      if (k.match(ha)) {
        (k.length === 4 || k.length === 7) && (k = k.substr(1)), k.length === 3 && (k = k.split(""), k = k[0] + k[0] + k[1] + k[1] + k[2] + k[2]);
        var C = parseInt(k, 16), W = C >> 16, Y = C >> 8 & 255, ne = C & 255;
        return [W, Y, ne, 1];
      }
      if (k.match(yi)) {
        (k.length === 5 || k.length === 9) && (k = k.substr(1)), k.length === 4 && (k = k.split(""), k = k[0] + k[0] + k[1] + k[1] + k[2] + k[2] + k[3] + k[3]);
        var se = parseInt(k, 16), te = se >> 24 & 255, me = se >> 16 & 255, he = se >> 8 & 255, Me = Math.round((se & 255) / 255 * 100) / 100;
        return [te, me, he, Me];
      }
      throw new Error("unknown hex color: " + k);
    }, Ja = Br, Ri = ue, bi = K, Qi = O.type, bo = j, Za = Jr;
    bi.prototype.hex = function(k) {
      return Za(this._rgb, k);
    }, Ri.hex = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(bi, [null].concat(k, ["hex"])))();
    }, bo.format.hex = Ja, bo.autodetect.push({
      p: 4,
      test: function(k) {
        for (var C = [], W = arguments.length - 1; W-- > 0; )
          C[W] = arguments[W + 1];
        if (!C.length && Qi(k) === "string" && [3, 4, 5, 6, 7, 8, 9].indexOf(k.length) >= 0)
          return "hex";
      }
    });
    var Zr = O.unpack, mr = O.TWOPI, Va = Math.min, ei = Math.sqrt, pa = Math.acos, Ba = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = Zr(k, "rgb"), Y = W[0], ne = W[1], se = W[2];
      Y /= 255, ne /= 255, se /= 255;
      var te, me = Va(Y, ne, se), he = (Y + ne + se) / 3, Me = he > 0 ? 1 - me / he : 0;
      return Me === 0 ? te = NaN : (te = (Y - ne + (Y - se)) / 2, te /= ei((Y - ne) * (Y - ne) + (Y - se) * (ne - se)), te = pa(te), se > ne && (te = mr - te), te /= mr), [te * 360, Me, he];
    }, Ea = Ba, Ki = O.unpack, ti = O.limit, Aa = O.TWOPI, Ua = O.PITHIRD, va = Math.cos, Ur = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      k = Ki(k, "hsi");
      var W = k[0], Y = k[1], ne = k[2], se, te, me;
      return isNaN(W) && (W = 0), isNaN(Y) && (Y = 0), W > 360 && (W -= 360), W < 0 && (W += 360), W /= 360, W < 1 / 3 ? (me = (1 - Y) / 3, se = (1 + Y * va(Aa * W) / va(Ua - Aa * W)) / 3, te = 1 - (me + se)) : W < 2 / 3 ? (W -= 1 / 3, se = (1 - Y) / 3, te = (1 + Y * va(Aa * W) / va(Ua - Aa * W)) / 3, me = 1 - (se + te)) : (W -= 2 / 3, te = (1 - Y) / 3, me = (1 + Y * va(Aa * W) / va(Ua - Aa * W)) / 3, se = 1 - (te + me)), se = ti(ne * se * 3), te = ti(ne * te * 3), me = ti(ne * me * 3), [se * 255, te * 255, me * 255, k.length > 3 ? k[3] : 1];
    }, Xa = Ur, ea = O.unpack, ni = O.type, Xr = ue, Je = K, ri = j, _r = Ea;
    Je.prototype.hsi = function() {
      return _r(this._rgb);
    }, Xr.hsi = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(Je, [null].concat(k, ["hsi"])))();
    }, ri.format.hsi = Xa, ri.autodetect.push({
      p: 2,
      test: function() {
        for (var k = [], C = arguments.length; C--; )
          k[C] = arguments[C];
        if (k = ea(k, "hsi"), ni(k) === "array" && k.length === 3)
          return "hsi";
      }
    });
    var ai = O.unpack, _a = O.type, wi = ue, yr = K, qn = j, Or = Bt;
    yr.prototype.hsl = function() {
      return Or(this._rgb);
    }, wi.hsl = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(yr, [null].concat(k, ["hsl"])))();
    }, qn.format.hsl = Wr, qn.autodetect.push({
      p: 2,
      test: function() {
        for (var k = [], C = arguments.length; C--; )
          k[C] = arguments[C];
        if (k = ai(k, "hsl"), _a(k) === "array" && k.length === 3)
          return "hsl";
      }
    });
    var ms = O.unpack, br = Math.min, lr = Math.max, wo = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      k = ms(k, "rgb");
      var W = k[0], Y = k[1], ne = k[2], se = br(W, Y, ne), te = lr(W, Y, ne), me = te - se, he, Me, We;
      return We = te / 255, te === 0 ? (he = Number.NaN, Me = 0) : (Me = me / te, W === te && (he = (Y - ne) / me), Y === te && (he = 2 + (ne - W) / me), ne === te && (he = 4 + (W - Y) / me), he *= 60, he < 0 && (he += 360)), [he, Me, We];
    }, ta = wo, ii = O.unpack, Po = Math.floor, ko = function() {
      for (var k, C, W, Y, ne, se, te = [], me = arguments.length; me--; )
        te[me] = arguments[me];
      te = ii(te, "hsv");
      var he = te[0], Me = te[1], We = te[2], it, He, pt;
      if (We *= 255, Me === 0)
        it = He = pt = We;
      else {
        he === 360 && (he = 0), he > 360 && (he -= 360), he < 0 && (he += 360), he /= 60;
        var lt = Po(he), jt = he - lt, St = We * (1 - Me), gn = We * (1 - Me * jt), Ct = We * (1 - Me * (1 - jt));
        switch (lt) {
          case 0:
            k = [We, Ct, St], it = k[0], He = k[1], pt = k[2];
            break;
          case 1:
            C = [gn, We, St], it = C[0], He = C[1], pt = C[2];
            break;
          case 2:
            W = [St, We, Ct], it = W[0], He = W[1], pt = W[2];
            break;
          case 3:
            Y = [St, gn, We], it = Y[0], He = Y[1], pt = Y[2];
            break;
          case 4:
            ne = [Ct, St, We], it = ne[0], He = ne[1], pt = ne[2];
            break;
          case 5:
            se = [We, St, gn], it = se[0], He = se[1], pt = se[2];
            break;
        }
      }
      return [it, He, pt, te.length > 3 ? te[3] : 1];
    }, $o = ko, hs = O.unpack, L = O.type, oe = ue, be = K, Ee = j, Ze = ta;
    be.prototype.hsv = function() {
      return Ze(this._rgb);
    }, oe.hsv = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(be, [null].concat(k, ["hsv"])))();
    }, Ee.format.hsv = $o, Ee.autodetect.push({
      p: 2,
      test: function() {
        for (var k = [], C = arguments.length; C--; )
          k[C] = arguments[C];
        if (k = hs(k, "hsv"), L(k) === "array" && k.length === 3)
          return "hsv";
      }
    });
    var Et = {
      Kn: 18,
      Xn: 0.95047,
      Yn: 1,
      Zn: 1.08883,
      t0: 0.137931034,
      t1: 0.206896552,
      t2: 0.12841855,
      t3: 8856452e-9
    }, wt = Et, xt = O.unpack, Pt = Math.pow, Qt = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = xt(k, "rgb"), Y = W[0], ne = W[1], se = W[2], te = Hn(Y, ne, se), me = te[0], he = te[1], Me = te[2], We = 116 * he - 16;
      return [We < 0 ? 0 : We, 500 * (me - he), 200 * (he - Me)];
    }, dn = function(k) {
      return (k /= 255) <= 0.04045 ? k / 12.92 : Pt((k + 0.055) / 1.055, 2.4);
    }, Wn = function(k) {
      return k > wt.t3 ? Pt(k, 1 / 3) : k / wt.t2 + wt.t0;
    }, Hn = function(k, C, W) {
      k = dn(k), C = dn(C), W = dn(W);
      var Y = Wn((0.4124564 * k + 0.3575761 * C + 0.1804375 * W) / wt.Xn), ne = Wn((0.2126729 * k + 0.7151522 * C + 0.072175 * W) / wt.Yn), se = Wn((0.0193339 * k + 0.119192 * C + 0.9503041 * W) / wt.Zn);
      return [Y, ne, se];
    }, wr = Qt, jn = Et, ga = O.unpack, Di = Math.pow, B = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      k = ga(k, "lab");
      var W = k[0], Y = k[1], ne = k[2], se, te, me, he, Me, We;
      return te = (W + 16) / 116, se = isNaN(Y) ? te : te + Y / 500, me = isNaN(ne) ? te : te - ne / 200, te = jn.Yn * N(te), se = jn.Xn * N(se), me = jn.Zn * N(me), he = ve(3.2404542 * se - 1.5371385 * te - 0.4985314 * me), Me = ve(-0.969266 * se + 1.8760108 * te + 0.041556 * me), We = ve(0.0556434 * se - 0.2040259 * te + 1.0572252 * me), [he, Me, We, k.length > 3 ? k[3] : 1];
    }, ve = function(k) {
      return 255 * (k <= 304e-5 ? 12.92 * k : 1.055 * Di(k, 1 / 2.4) - 0.055);
    }, N = function(k) {
      return k > jn.t1 ? k * k * k : jn.t2 * (k - jn.t0);
    }, Z = B, de = O.unpack, Ke = O.type, Tt = ue, Nt = K, Mn = j, Wt = wr;
    Nt.prototype.lab = function() {
      return Wt(this._rgb);
    }, Tt.lab = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(Nt, [null].concat(k, ["lab"])))();
    }, Mn.format.lab = Z, Mn.autodetect.push({
      p: 2,
      test: function() {
        for (var k = [], C = arguments.length; C--; )
          k[C] = arguments[C];
        if (k = de(k, "lab"), Ke(k) === "array" && k.length === 3)
          return "lab";
      }
    });
    var yn = O.unpack, jr = O.RAD2DEG, sr = Math.sqrt, Pi = Math.atan2, ki = Math.round, Ys = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = yn(k, "lab"), Y = W[0], ne = W[1], se = W[2], te = sr(ne * ne + se * se), me = (Pi(se, ne) * jr + 360) % 360;
      return ki(te * 1e4) === 0 && (me = Number.NaN), [Y, te, me];
    }, So = Ys, yu = O.unpack, Td = wr, oi = So, Sl = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = yu(k, "rgb"), Y = W[0], ne = W[1], se = W[2], te = Td(Y, ne, se), me = te[0], he = te[1], Me = te[2];
      return oi(me, he, Me);
    }, xl = Sl, Cl = O.unpack, Rd = O.DEG2RAD, Cc = Math.sin, bu = Math.cos, Gs = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = Cl(k, "lch"), Y = W[0], ne = W[1], se = W[2];
      return isNaN(se) && (se = 0), se = se * Rd, [Y, bu(se) * ne, Cc(se) * ne];
    }, wu = Gs, Pu = O.unpack, pm = wu, Ni = Z, Ho = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      k = Pu(k, "lch");
      var W = k[0], Y = k[1], ne = k[2], se = pm(W, Y, ne), te = se[0], me = se[1], he = se[2], Me = Ni(te, me, he), We = Me[0], it = Me[1], He = Me[2];
      return [We, it, He, k.length > 3 ? k[3] : 1];
    }, Oa = Ho, ps = O.unpack, vm = Oa, Mc = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = ps(k, "hcl").reverse();
      return vm.apply(void 0, W);
    }, ap = Mc, ku = O.unpack, gm = O.type, ym = ue, Ml = K, Dd = j, bm = xl;
    Ml.prototype.lch = function() {
      return bm(this._rgb);
    }, Ml.prototype.hcl = function() {
      return bm(this._rgb).reverse();
    }, ym.lch = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(Ml, [null].concat(k, ["lch"])))();
    }, ym.hcl = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(Ml, [null].concat(k, ["hcl"])))();
    }, Dd.format.lch = Oa, Dd.format.hcl = ap, ["lch", "hcl"].forEach(function(k) {
      return Dd.autodetect.push({
        p: 2,
        test: function() {
          for (var C = [], W = arguments.length; W--; )
            C[W] = arguments[W];
          if (C = ku(C, k), gm(C) === "array" && C.length === 3)
            return k;
        }
      });
    });
    var Nd = {
      aliceblue: "#f0f8ff",
      antiquewhite: "#faebd7",
      aqua: "#00ffff",
      aquamarine: "#7fffd4",
      azure: "#f0ffff",
      beige: "#f5f5dc",
      bisque: "#ffe4c4",
      black: "#000000",
      blanchedalmond: "#ffebcd",
      blue: "#0000ff",
      blueviolet: "#8a2be2",
      brown: "#a52a2a",
      burlywood: "#deb887",
      cadetblue: "#5f9ea0",
      chartreuse: "#7fff00",
      chocolate: "#d2691e",
      coral: "#ff7f50",
      cornflower: "#6495ed",
      cornflowerblue: "#6495ed",
      cornsilk: "#fff8dc",
      crimson: "#dc143c",
      cyan: "#00ffff",
      darkblue: "#00008b",
      darkcyan: "#008b8b",
      darkgoldenrod: "#b8860b",
      darkgray: "#a9a9a9",
      darkgreen: "#006400",
      darkgrey: "#a9a9a9",
      darkkhaki: "#bdb76b",
      darkmagenta: "#8b008b",
      darkolivegreen: "#556b2f",
      darkorange: "#ff8c00",
      darkorchid: "#9932cc",
      darkred: "#8b0000",
      darksalmon: "#e9967a",
      darkseagreen: "#8fbc8f",
      darkslateblue: "#483d8b",
      darkslategray: "#2f4f4f",
      darkslategrey: "#2f4f4f",
      darkturquoise: "#00ced1",
      darkviolet: "#9400d3",
      deeppink: "#ff1493",
      deepskyblue: "#00bfff",
      dimgray: "#696969",
      dimgrey: "#696969",
      dodgerblue: "#1e90ff",
      firebrick: "#b22222",
      floralwhite: "#fffaf0",
      forestgreen: "#228b22",
      fuchsia: "#ff00ff",
      gainsboro: "#dcdcdc",
      ghostwhite: "#f8f8ff",
      gold: "#ffd700",
      goldenrod: "#daa520",
      gray: "#808080",
      green: "#008000",
      greenyellow: "#adff2f",
      grey: "#808080",
      honeydew: "#f0fff0",
      hotpink: "#ff69b4",
      indianred: "#cd5c5c",
      indigo: "#4b0082",
      ivory: "#fffff0",
      khaki: "#f0e68c",
      laserlemon: "#ffff54",
      lavender: "#e6e6fa",
      lavenderblush: "#fff0f5",
      lawngreen: "#7cfc00",
      lemonchiffon: "#fffacd",
      lightblue: "#add8e6",
      lightcoral: "#f08080",
      lightcyan: "#e0ffff",
      lightgoldenrod: "#fafad2",
      lightgoldenrodyellow: "#fafad2",
      lightgray: "#d3d3d3",
      lightgreen: "#90ee90",
      lightgrey: "#d3d3d3",
      lightpink: "#ffb6c1",
      lightsalmon: "#ffa07a",
      lightseagreen: "#20b2aa",
      lightskyblue: "#87cefa",
      lightslategray: "#778899",
      lightslategrey: "#778899",
      lightsteelblue: "#b0c4de",
      lightyellow: "#ffffe0",
      lime: "#00ff00",
      limegreen: "#32cd32",
      linen: "#faf0e6",
      magenta: "#ff00ff",
      maroon: "#800000",
      maroon2: "#7f0000",
      maroon3: "#b03060",
      mediumaquamarine: "#66cdaa",
      mediumblue: "#0000cd",
      mediumorchid: "#ba55d3",
      mediumpurple: "#9370db",
      mediumseagreen: "#3cb371",
      mediumslateblue: "#7b68ee",
      mediumspringgreen: "#00fa9a",
      mediumturquoise: "#48d1cc",
      mediumvioletred: "#c71585",
      midnightblue: "#191970",
      mintcream: "#f5fffa",
      mistyrose: "#ffe4e1",
      moccasin: "#ffe4b5",
      navajowhite: "#ffdead",
      navy: "#000080",
      oldlace: "#fdf5e6",
      olive: "#808000",
      olivedrab: "#6b8e23",
      orange: "#ffa500",
      orangered: "#ff4500",
      orchid: "#da70d6",
      palegoldenrod: "#eee8aa",
      palegreen: "#98fb98",
      paleturquoise: "#afeeee",
      palevioletred: "#db7093",
      papayawhip: "#ffefd5",
      peachpuff: "#ffdab9",
      peru: "#cd853f",
      pink: "#ffc0cb",
      plum: "#dda0dd",
      powderblue: "#b0e0e6",
      purple: "#800080",
      purple2: "#7f007f",
      purple3: "#a020f0",
      rebeccapurple: "#663399",
      red: "#ff0000",
      rosybrown: "#bc8f8f",
      royalblue: "#4169e1",
      saddlebrown: "#8b4513",
      salmon: "#fa8072",
      sandybrown: "#f4a460",
      seagreen: "#2e8b57",
      seashell: "#fff5ee",
      sienna: "#a0522d",
      silver: "#c0c0c0",
      skyblue: "#87ceeb",
      slateblue: "#6a5acd",
      slategray: "#708090",
      slategrey: "#708090",
      snow: "#fffafa",
      springgreen: "#00ff7f",
      steelblue: "#4682b4",
      tan: "#d2b48c",
      teal: "#008080",
      thistle: "#d8bfd8",
      tomato: "#ff6347",
      turquoise: "#40e0d0",
      violet: "#ee82ee",
      wheat: "#f5deb3",
      white: "#ffffff",
      whitesmoke: "#f5f5f5",
      yellow: "#ffff00",
      yellowgreen: "#9acd32"
    }, Wd = Nd, ip = K, wm = j, Pm = O.type, El = Wd, Al = Ja, jd = Jr;
    ip.prototype.name = function() {
      for (var k = jd(this._rgb, "rgb"), C = 0, W = Object.keys(El); C < W.length; C += 1) {
        var Y = W[C];
        if (El[Y] === k)
          return Y.toLowerCase();
      }
      return k;
    }, wm.format.named = function(k) {
      if (k = k.toLowerCase(), El[k])
        return Al(El[k]);
      throw new Error("unknown color name: " + k);
    }, wm.autodetect.push({
      p: 5,
      test: function(k) {
        for (var C = [], W = arguments.length - 1; W-- > 0; )
          C[W] = arguments[W + 1];
        if (!C.length && Pm(k) === "string" && El[k.toLowerCase()])
          return "named";
      }
    });
    var km = O.unpack, $m = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = km(k, "rgb"), Y = W[0], ne = W[1], se = W[2];
      return (Y << 16) + (ne << 8) + se;
    }, op = $m, sp = O.type, zd = function(k) {
      if (sp(k) == "number" && k >= 0 && k <= 16777215) {
        var C = k >> 16, W = k >> 8 & 255, Y = k & 255;
        return [C, W, Y, 1];
      }
      throw new Error("unknown num color: " + k);
    }, $u = zd, lp = ue, Ld = K, Id = j, Sm = O.type, Fd = op;
    Ld.prototype.num = function() {
      return Fd(this._rgb);
    }, lp.num = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(Ld, [null].concat(k, ["num"])))();
    }, Id.format.num = $u, Id.autodetect.push({
      p: 5,
      test: function() {
        for (var k = [], C = arguments.length; C--; )
          k[C] = arguments[C];
        if (k.length === 1 && Sm(k[0]) === "number" && k[0] >= 0 && k[0] <= 16777215)
          return "num";
      }
    });
    var xm = ue, Vo = K, Cm = j, Mm = O.unpack, Em = O.type, Hd = Math.round;
    Vo.prototype.rgb = function(k) {
      return k === void 0 && (k = !0), k === !1 ? this._rgb.slice(0, 3) : this._rgb.slice(0, 3).map(Hd);
    }, Vo.prototype.rgba = function(k) {
      return k === void 0 && (k = !0), this._rgb.slice(0, 4).map(function(C, W) {
        return W < 3 ? k === !1 ? C : Hd(C) : C;
      });
    }, xm.rgb = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(Vo, [null].concat(k, ["rgb"])))();
    }, Cm.format.rgb = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = Mm(k, "rgba");
      return W[3] === void 0 && (W[3] = 1), W;
    }, Cm.autodetect.push({
      p: 3,
      test: function() {
        for (var k = [], C = arguments.length; C--; )
          k[C] = arguments[C];
        if (k = Mm(k, "rgba"), Em(k) === "array" && (k.length === 3 || k.length === 4 && Em(k[3]) == "number" && k[3] >= 0 && k[3] <= 1))
          return "rgb";
      }
    });
    var Qs = Math.log, Ji = function(k) {
      var C = k / 100, W, Y, ne;
      return C < 66 ? (W = 255, Y = C < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (Y = C - 2) + 104.49216199393888 * Qs(Y), ne = C < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (ne = C - 10) + 115.67994401066147 * Qs(ne)) : (W = 351.97690566805693 + 0.114206453784165 * (W = C - 55) - 40.25366309332127 * Qs(W), Y = 325.4494125711974 + 0.07943456536662342 * (Y = C - 50) - 28.0852963507957 * Qs(Y), ne = 255), [W, Y, ne, 1];
    }, Bo = Ji, Am = Bo, Uo = O.unpack, up = Math.round, _m = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      for (var W = Uo(k, "rgb"), Y = W[0], ne = W[2], se = 1e3, te = 4e4, me = 0.4, he; te - se > me; ) {
        he = (te + se) * 0.5;
        var Me = Am(he);
        Me[2] / Me[0] >= ne / Y ? te = he : se = he;
      }
      return up(he);
    }, Vd = _m, Su = ue, xu = K, Ec = j, Bd = Vd;
    xu.prototype.temp = xu.prototype.kelvin = xu.prototype.temperature = function() {
      return Bd(this._rgb);
    }, Su.temp = Su.kelvin = Su.temperature = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(xu, [null].concat(k, ["temp"])))();
    }, Ec.format.temp = Ec.format.kelvin = Ec.format.temperature = Bo;
    var cp = O.unpack, Ac = Math.cbrt, qa = Math.pow, dp = Math.sign, Om = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = cp(k, "rgb"), Y = W[0], ne = W[1], se = W[2], te = [Ud(Y / 255), Ud(ne / 255), Ud(se / 255)], me = te[0], he = te[1], Me = te[2], We = Ac(0.4122214708 * me + 0.5363325363 * he + 0.0514459929 * Me), it = Ac(0.2119034982 * me + 0.6806995451 * he + 0.1073969566 * Me), He = Ac(0.0883024619 * me + 0.2817188376 * he + 0.6299787005 * Me);
      return [
        0.2104542553 * We + 0.793617785 * it - 0.0040720468 * He,
        1.9779984951 * We - 2.428592205 * it + 0.4505937099 * He,
        0.0259040371 * We + 0.7827717662 * it - 0.808675766 * He
      ];
    }, $i = Om;
    function Ud(k) {
      var C = Math.abs(k);
      return C < 0.04045 ? k / 12.92 : (dp(k) || 1) * qa((C + 0.055) / 1.055, 2.4);
    }
    var Cu = O.unpack, Mu = Math.pow, Tm = Math.sign, Xd = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      k = Cu(k, "lab");
      var W = k[0], Y = k[1], ne = k[2], se = Mu(W + 0.3963377774 * Y + 0.2158037573 * ne, 3), te = Mu(W - 0.1055613458 * Y - 0.0638541728 * ne, 3), me = Mu(W - 0.0894841775 * Y - 1.291485548 * ne, 3);
      return [
        255 * Xo(4.0767416621 * se - 3.3077115913 * te + 0.2309699292 * me),
        255 * Xo(-1.2684380046 * se + 2.6097574011 * te - 0.3413193965 * me),
        255 * Xo(-0.0041960863 * se - 0.7034186147 * te + 1.707614701 * me),
        k.length > 3 ? k[3] : 1
      ];
    }, _l = Xd;
    function Xo(k) {
      var C = Math.abs(k);
      return C > 31308e-7 ? (Tm(k) || 1) * (1.055 * Mu(C, 1 / 2.4) - 0.055) : k * 12.92;
    }
    var Rm = O.unpack, Ol = O.type, Eu = ue, vs = K, qo = j, Ks = $i;
    vs.prototype.oklab = function() {
      return Ks(this._rgb);
    }, Eu.oklab = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(vs, [null].concat(k, ["oklab"])))();
    }, qo.format.oklab = _l, qo.autodetect.push({
      p: 3,
      test: function() {
        for (var k = [], C = arguments.length; C--; )
          k[C] = arguments[C];
        if (k = Rm(k, "oklab"), Ol(k) === "array" && k.length === 3)
          return "oklab";
      }
    });
    var qd = O.unpack, Yd = $i, Tl = So, Dm = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      var W = qd(k, "rgb"), Y = W[0], ne = W[1], se = W[2], te = Yd(Y, ne, se), me = te[0], he = te[1], Me = te[2];
      return Tl(me, he, Me);
    }, Gd = Dm, _c = O.unpack, Zn = wu, Oc = _l, Qd = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      k = _c(k, "lch");
      var W = k[0], Y = k[1], ne = k[2], se = Zn(W, Y, ne), te = se[0], me = se[1], he = se[2], Me = Oc(te, me, he), We = Me[0], it = Me[1], He = Me[2];
      return [We, it, He, k.length > 3 ? k[3] : 1];
    }, Yo = Qd, Tc = O.unpack, Rc = O.type, Au = ue, _u = K, Js = j, Nm = Gd;
    _u.prototype.oklch = function() {
      return Nm(this._rgb);
    }, Au.oklch = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      return new (Function.prototype.bind.apply(_u, [null].concat(k, ["oklch"])))();
    }, Js.format.oklch = Yo, Js.autodetect.push({
      p: 3,
      test: function() {
        for (var k = [], C = arguments.length; C--; )
          k[C] = arguments[C];
        if (k = Tc(k, "oklch"), Rc(k) === "array" && k.length === 3)
          return "oklch";
      }
    });
    var Ou = K, Kd = O.type;
    Ou.prototype.alpha = function(k, C) {
      return C === void 0 && (C = !1), k !== void 0 && Kd(k) === "number" ? C ? (this._rgb[3] = k, this) : new Ou([this._rgb[0], this._rgb[1], this._rgb[2], k], "rgb") : this._rgb[3];
    };
    var Jd = K;
    Jd.prototype.clipped = function() {
      return this._rgb._clipped || !1;
    };
    var Wi = K, Tu = Et;
    Wi.prototype.darken = function(k) {
      k === void 0 && (k = 1);
      var C = this, W = C.lab();
      return W[0] -= Tu.Kn * k, new Wi(W, "lab").alpha(C.alpha(), !0);
    }, Wi.prototype.brighten = function(k) {
      return k === void 0 && (k = 1), this.darken(-k);
    }, Wi.prototype.darker = Wi.prototype.darken, Wi.prototype.brighter = Wi.prototype.brighten;
    var Rl = K;
    Rl.prototype.get = function(k) {
      var C = k.split("."), W = C[0], Y = C[1], ne = this[W]();
      if (Y) {
        var se = W.indexOf(Y) - (W.substr(0, 2) === "ok" ? 2 : 0);
        if (se > -1)
          return ne[se];
        throw new Error("unknown channel " + Y + " in mode " + W);
      } else
        return ne;
    };
    var Zs = K, Dc = O.type, gs = Math.pow, Wm = 1e-7, ys = 20;
    Zs.prototype.luminance = function(k) {
      if (k !== void 0 && Dc(k) === "number") {
        if (k === 0)
          return new Zs([0, 0, 0, this._rgb[3]], "rgb");
        if (k === 1)
          return new Zs([255, 255, 255, this._rgb[3]], "rgb");
        var C = this.luminance(), W = "rgb", Y = ys, ne = function(te, me) {
          var he = te.interpolate(me, 0.5, W), Me = he.luminance();
          return Math.abs(k - Me) < Wm || !Y-- ? he : Me > k ? ne(te, he) : ne(he, me);
        }, se = (C > k ? ne(new Zs([0, 0, 0]), this) : ne(this, new Zs([255, 255, 255]))).rgb();
        return new Zs(se.concat([this._rgb[3]]));
      }
      return Nc.apply(void 0, this._rgb.slice(0, 3));
    };
    var Nc = function(k, C, W) {
      return k = Go(k), C = Go(C), W = Go(W), 0.2126 * k + 0.7152 * C + 0.0722 * W;
    }, Go = function(k) {
      return k /= 255, k <= 0.03928 ? k / 12.92 : gs((k + 0.055) / 1.055, 2.4);
    }, Pr = {}, Ru = K, Ta = O.type, Du = Pr, bs = function(k, C, W) {
      W === void 0 && (W = 0.5);
      for (var Y = [], ne = arguments.length - 3; ne-- > 0; )
        Y[ne] = arguments[ne + 3];
      var se = Y[0] || "lrgb";
      if (!Du[se] && !Y.length && (se = Object.keys(Du)[0]), !Du[se])
        throw new Error("interpolation mode " + se + " is not defined");
      return Ta(k) !== "object" && (k = new Ru(k)), Ta(C) !== "object" && (C = new Ru(C)), Du[se](k, C, W).alpha(k.alpha() + W * (C.alpha() - k.alpha()));
    }, si = K, Ya = bs;
    si.prototype.mix = si.prototype.interpolate = function(k, C) {
      C === void 0 && (C = 0.5);
      for (var W = [], Y = arguments.length - 2; Y-- > 0; )
        W[Y] = arguments[Y + 2];
      return Ya.apply(void 0, [this, k, C].concat(W));
    };
    var xo = K;
    xo.prototype.premultiply = function(k) {
      k === void 0 && (k = !1);
      var C = this._rgb, W = C[3];
      return k ? (this._rgb = [C[0] * W, C[1] * W, C[2] * W, W], this) : new xo([C[0] * W, C[1] * W, C[2] * W, W], "rgb");
    };
    var Wc = K, Zd = Et;
    Wc.prototype.saturate = function(k) {
      k === void 0 && (k = 1);
      var C = this, W = C.lch();
      return W[1] += Zd.Kn * k, W[1] < 0 && (W[1] = 0), new Wc(W, "lch").alpha(C.alpha(), !0);
    }, Wc.prototype.desaturate = function(k) {
      return k === void 0 && (k = 1), this.saturate(-k);
    };
    var zn = K, Ra = O.type;
    zn.prototype.set = function(k, C, W) {
      W === void 0 && (W = !1);
      var Y = k.split("."), ne = Y[0], se = Y[1], te = this[ne]();
      if (se) {
        var me = ne.indexOf(se) - (ne.substr(0, 2) === "ok" ? 2 : 0);
        if (me > -1) {
          if (Ra(C) == "string")
            switch (C.charAt(0)) {
              case "+":
                te[me] += +C;
                break;
              case "-":
                te[me] += +C;
                break;
              case "*":
                te[me] *= +C.substr(1);
                break;
              case "/":
                te[me] /= +C.substr(1);
                break;
              default:
                te[me] = +C;
            }
          else if (Ra(C) === "number")
            te[me] = C;
          else
            throw new Error("unsupported value for Color.set");
          var he = new zn(te, ne);
          return W ? (this._rgb = he._rgb, this) : he;
        }
        throw new Error("unknown channel " + se + " in mode " + ne);
      } else
        return te;
    };
    var Ht = K, Lt = function(k, C, W) {
      var Y = k._rgb, ne = C._rgb;
      return new Ht(
        Y[0] + W * (ne[0] - Y[0]),
        Y[1] + W * (ne[1] - Y[1]),
        Y[2] + W * (ne[2] - Y[2]),
        "rgb"
      );
    };
    Pr.rgb = Lt;
    var ws = K, er = Math.sqrt, kr = Math.pow, Ps = function(k, C, W) {
      var Y = k._rgb, ne = Y[0], se = Y[1], te = Y[2], me = C._rgb, he = me[0], Me = me[1], We = me[2];
      return new ws(
        er(kr(ne, 2) * (1 - W) + kr(he, 2) * W),
        er(kr(se, 2) * (1 - W) + kr(Me, 2) * W),
        er(kr(te, 2) * (1 - W) + kr(We, 2) * W),
        "rgb"
      );
    };
    Pr.lrgb = Ps;
    var En = K, ya = function(k, C, W) {
      var Y = k.lab(), ne = C.lab();
      return new En(
        Y[0] + W * (ne[0] - Y[0]),
        Y[1] + W * (ne[1] - Y[1]),
        Y[2] + W * (ne[2] - Y[2]),
        "lab"
      );
    };
    Pr.lab = ya;
    var Zi = K, eo = function(k, C, W, Y) {
      var ne, se, te, me;
      Y === "hsl" ? (te = k.hsl(), me = C.hsl()) : Y === "hsv" ? (te = k.hsv(), me = C.hsv()) : Y === "hcg" ? (te = k.hcg(), me = C.hcg()) : Y === "hsi" ? (te = k.hsi(), me = C.hsi()) : Y === "lch" || Y === "hcl" ? (Y = "hcl", te = k.hcl(), me = C.hcl()) : Y === "oklch" && (te = k.oklch().reverse(), me = C.oklch().reverse());
      var he, Me, We, it, He, pt;
      (Y.substr(0, 1) === "h" || Y === "oklch") && (ne = te, he = ne[0], We = ne[1], He = ne[2], se = me, Me = se[0], it = se[1], pt = se[2]);
      var lt, jt, St, gn;
      return !isNaN(he) && !isNaN(Me) ? (Me > he && Me - he > 180 ? gn = Me - (he + 360) : Me < he && he - Me > 180 ? gn = Me + 360 - he : gn = Me - he, jt = he + W * gn) : isNaN(he) ? isNaN(Me) ? jt = Number.NaN : (jt = Me, (He == 1 || He == 0) && Y != "hsv" && (lt = it)) : (jt = he, (pt == 1 || pt == 0) && Y != "hsv" && (lt = We)), lt === void 0 && (lt = We + W * (it - We)), St = He + W * (pt - He), Y === "oklch" ? new Zi([St, lt, jt], Y) : new Zi([jt, lt, St], Y);
    }, Dl = eo, Si = function(k, C, W) {
      return Dl(k, C, W, "lch");
    };
    Pr.lch = Si, Pr.hcl = Si;
    var jm = K, ef = function(k, C, W) {
      var Y = k.num(), ne = C.num();
      return new jm(Y + W * (ne - Y), "num");
    };
    Pr.num = ef;
    var el = eo, Nu = function(k, C, W) {
      return el(k, C, W, "hcg");
    };
    Pr.hcg = Nu;
    var to = eo, Wu = function(k, C, W) {
      return to(k, C, W, "hsi");
    };
    Pr.hsi = Wu;
    var fp = eo, ks = function(k, C, W) {
      return fp(k, C, W, "hsl");
    };
    Pr.hsl = ks;
    var jc = eo, zm = function(k, C, W) {
      return jc(k, C, W, "hsv");
    };
    Pr.hsv = zm;
    var zc = K, Lm = function(k, C, W) {
      var Y = k.oklab(), ne = C.oklab();
      return new zc(
        Y[0] + W * (ne[0] - Y[0]),
        Y[1] + W * (ne[1] - Y[1]),
        Y[2] + W * (ne[2] - Y[2]),
        "oklab"
      );
    };
    Pr.oklab = Lm;
    var tf = eo, nf = function(k, C, W) {
      return tf(k, C, W, "oklch");
    };
    Pr.oklch = nf;
    var ju = K, rf = O.clip_rgb, Lc = Math.pow, ji = Math.sqrt, Nl = Math.PI, Wl = Math.cos, af = Math.sin, ba = Math.atan2, jl = function(k, C, W) {
      C === void 0 && (C = "lrgb"), W === void 0 && (W = null);
      var Y = k.length;
      W || (W = Array.from(new Array(Y)).map(function() {
        return 1;
      }));
      var ne = Y / W.reduce(function(jt, St) {
        return jt + St;
      });
      if (W.forEach(function(jt, St) {
        W[St] *= ne;
      }), k = k.map(function(jt) {
        return new ju(jt);
      }), C === "lrgb")
        return of(k, W);
      for (var se = k.shift(), te = se.get(C), me = [], he = 0, Me = 0, We = 0; We < te.length; We++)
        if (te[We] = (te[We] || 0) * W[0], me.push(isNaN(te[We]) ? 0 : W[0]), C.charAt(We) === "h" && !isNaN(te[We])) {
          var it = te[We] / 180 * Nl;
          he += Wl(it) * W[0], Me += af(it) * W[0];
        }
      var He = se.alpha() * W[0];
      k.forEach(function(jt, St) {
        var gn = jt.get(C);
        He += jt.alpha() * W[St + 1];
        for (var Ct = 0; Ct < te.length; Ct++)
          if (!isNaN(gn[Ct]))
            if (me[Ct] += W[St + 1], C.charAt(Ct) === "h") {
              var xr = gn[Ct] / 180 * Nl;
              he += Wl(xr) * W[St + 1], Me += af(xr) * W[St + 1];
            } else
              te[Ct] += gn[Ct] * W[St + 1];
      });
      for (var pt = 0; pt < te.length; pt++)
        if (C.charAt(pt) === "h") {
          for (var lt = ba(Me / me[pt], he / me[pt]) / Nl * 180; lt < 0; )
            lt += 360;
          for (; lt >= 360; )
            lt -= 360;
          te[pt] = lt;
        } else
          te[pt] = te[pt] / me[pt];
      return He /= Y, new ju(te, C).alpha(He > 0.99999 ? 1 : He, !0);
    }, of = function(k, C) {
      for (var W = k.length, Y = [0, 0, 0, 0], ne = 0; ne < k.length; ne++) {
        var se = k[ne], te = C[ne] / W, me = se._rgb;
        Y[0] += Lc(me[0], 2) * te, Y[1] += Lc(me[1], 2) * te, Y[2] += Lc(me[2], 2) * te, Y[3] += me[3] * te;
      }
      return Y[0] = ji(Y[0]), Y[1] = ji(Y[1]), Y[2] = ji(Y[2]), Y[3] > 0.9999999 && (Y[3] = 1), new ju(rf(Y));
    }, wa = ue, zi = O.type, na = Math.pow, no = function(k) {
      var C = "rgb", W = wa("#ccc"), Y = 0, ne = [0, 1], se = [], te = [0, 0], me = !1, he = [], Me = !1, We = 0, it = 1, He = !1, pt = {}, lt = !0, jt = 1, St = function(Xe) {
        if (Xe = Xe || ["#fff", "#000"], Xe && zi(Xe) === "string" && wa.brewer && wa.brewer[Xe.toLowerCase()] && (Xe = wa.brewer[Xe.toLowerCase()]), zi(Xe) === "array") {
          Xe.length === 1 && (Xe = [Xe[0], Xe[0]]), Xe = Xe.slice(0);
          for (var Ot = 0; Ot < Xe.length; Ot++)
            Xe[Ot] = wa(Xe[Ot]);
          se.length = 0;
          for (var on = 0; on < Xe.length; on++)
            se.push(on / (Xe.length - 1));
        }
        return ka(), he = Xe;
      }, gn = function(Xe) {
        if (me != null) {
          for (var Ot = me.length - 1, on = 0; on < Ot && Xe >= me[on]; )
            on++;
          return on - 1;
        }
        return 0;
      }, Ct = function(Xe) {
        return Xe;
      }, xr = function(Xe) {
        return Xe;
      }, zr = function(Xe, Ot) {
        var on, Rt;
        if (Ot == null && (Ot = !1), isNaN(Xe) || Xe === null)
          return W;
        if (Ot)
          Rt = Xe;
        else if (me && me.length > 2) {
          var An = gn(Xe);
          Rt = An / (me.length - 2);
        } else
          it !== We ? Rt = (Xe - We) / (it - We) : Rt = 1;
        Rt = xr(Rt), Ot || (Rt = Ct(Rt)), jt !== 1 && (Rt = na(Rt, jt)), Rt = te[0] + Rt * (1 - te[0] - te[1]), Rt = Math.min(1, Math.max(0, Rt));
        var Bn = Math.floor(Rt * 1e4);
        if (lt && pt[Bn])
          on = pt[Bn];
        else {
          if (zi(he) === "array")
            for (var fn = 0; fn < se.length; fn++) {
              var xn = se[fn];
              if (Rt <= xn) {
                on = he[fn];
                break;
              }
              if (Rt >= xn && fn === se.length - 1) {
                on = he[fn];
                break;
              }
              if (Rt > xn && Rt < se[fn + 1]) {
                Rt = (Rt - xn) / (se[fn + 1] - xn), on = wa.interpolate(he[fn], he[fn + 1], Rt, C);
                break;
              }
            }
          else
            zi(he) === "function" && (on = he(Rt));
          lt && (pt[Bn] = on);
        }
        return on;
      }, ka = function() {
        return pt = {};
      };
      St(k);
      var nn = function(Xe) {
        var Ot = wa(zr(Xe));
        return Me && Ot[Me] ? Ot[Me]() : Ot;
      };
      return nn.classes = function(Xe) {
        if (Xe != null) {
          if (zi(Xe) === "array")
            me = Xe, ne = [Xe[0], Xe[Xe.length - 1]];
          else {
            var Ot = wa.analyze(ne);
            Xe === 0 ? me = [Ot.min, Ot.max] : me = wa.limits(Ot, "e", Xe);
          }
          return nn;
        }
        return me;
      }, nn.domain = function(Xe) {
        if (!arguments.length)
          return ne;
        We = Xe[0], it = Xe[Xe.length - 1], se = [];
        var Ot = he.length;
        if (Xe.length === Ot && We !== it)
          for (var on = 0, Rt = Array.from(Xe); on < Rt.length; on += 1) {
            var An = Rt[on];
            se.push((An - We) / (it - We));
          }
        else {
          for (var Bn = 0; Bn < Ot; Bn++)
            se.push(Bn / (Ot - 1));
          if (Xe.length > 2) {
            var fn = Xe.map(function(mn, _n) {
              return _n / (Xe.length - 1);
            }), xn = Xe.map(function(mn) {
              return (mn - We) / (it - We);
            });
            xn.every(function(mn, _n) {
              return fn[_n] === mn;
            }) || (xr = function(mn) {
              if (mn <= 0 || mn >= 1)
                return mn;
              for (var _n = 0; mn >= xn[_n + 1]; )
                _n++;
              var Ci = (mn - xn[_n]) / (xn[_n + 1] - xn[_n]), es = fn[_n] + Ci * (fn[_n + 1] - fn[_n]);
              return es;
            });
          }
        }
        return ne = [We, it], nn;
      }, nn.mode = function(Xe) {
        return arguments.length ? (C = Xe, ka(), nn) : C;
      }, nn.range = function(Xe, Ot) {
        return St(Xe), nn;
      }, nn.out = function(Xe) {
        return Me = Xe, nn;
      }, nn.spread = function(Xe) {
        return arguments.length ? (Y = Xe, nn) : Y;
      }, nn.correctLightness = function(Xe) {
        return Xe == null && (Xe = !0), He = Xe, ka(), He ? Ct = function(Ot) {
          for (var on = zr(0, !0).lab()[0], Rt = zr(1, !0).lab()[0], An = on > Rt, Bn = zr(Ot, !0).lab()[0], fn = on + (Rt - on) * Ot, xn = Bn - fn, mn = 0, _n = 1, Ci = 20; Math.abs(xn) > 0.01 && Ci-- > 0; )
            (function() {
              return An && (xn *= -1), xn < 0 ? (mn = Ot, Ot += (_n - Ot) * 0.5) : (_n = Ot, Ot += (mn - Ot) * 0.5), Bn = zr(Ot, !0).lab()[0], xn = Bn - fn;
            })();
          return Ot;
        } : Ct = function(Ot) {
          return Ot;
        }, nn;
      }, nn.padding = function(Xe) {
        return Xe != null ? (zi(Xe) === "number" && (Xe = [Xe, Xe]), te = Xe, nn) : te;
      }, nn.colors = function(Xe, Ot) {
        arguments.length < 2 && (Ot = "hex");
        var on = [];
        if (arguments.length === 0)
          on = he.slice(0);
        else if (Xe === 1)
          on = [nn(0.5)];
        else if (Xe > 1) {
          var Rt = ne[0], An = ne[1] - Rt;
          on = $s(0, Xe, !1).map(function(_n) {
            return nn(Rt + _n / (Xe - 1) * An);
          });
        } else {
          k = [];
          var Bn = [];
          if (me && me.length > 2)
            for (var fn = 1, xn = me.length, mn = 1 <= xn; mn ? fn < xn : fn > xn; mn ? fn++ : fn--)
              Bn.push((me[fn - 1] + me[fn]) * 0.5);
          else
            Bn = ne;
          on = Bn.map(function(_n) {
            return nn(_n);
          });
        }
        return wa[Ot] && (on = on.map(function(_n) {
          return _n[Ot]();
        })), on;
      }, nn.cache = function(Xe) {
        return Xe != null ? (lt = Xe, nn) : lt;
      }, nn.gamma = function(Xe) {
        return Xe != null ? (jt = Xe, nn) : jt;
      }, nn.nodata = function(Xe) {
        return Xe != null ? (W = wa(Xe), nn) : W;
      }, nn;
    };
    function $s(k, C, W) {
      for (var Y = [], ne = k < C, se = W ? ne ? C + 1 : C - 1 : C, te = k; ne ? te < se : te > se; ne ? te++ : te--)
        Y.push(te);
      return Y;
    }
    var $r = K, Ss = no, xs = function(k) {
      for (var C = [1, 1], W = 1; W < k; W++) {
        for (var Y = [1], ne = 1; ne <= C.length; ne++)
          Y[ne] = (C[ne] || 0) + C[ne - 1];
        C = Y;
      }
      return C;
    }, Co = function(k) {
      var C, W, Y, ne, se, te, me;
      if (k = k.map(function(He) {
        return new $r(He);
      }), k.length === 2)
        C = k.map(function(He) {
          return He.lab();
        }), se = C[0], te = C[1], ne = function(He) {
          var pt = [0, 1, 2].map(function(lt) {
            return se[lt] + He * (te[lt] - se[lt]);
          });
          return new $r(pt, "lab");
        };
      else if (k.length === 3)
        W = k.map(function(He) {
          return He.lab();
        }), se = W[0], te = W[1], me = W[2], ne = function(He) {
          var pt = [0, 1, 2].map(function(lt) {
            return (1 - He) * (1 - He) * se[lt] + 2 * (1 - He) * He * te[lt] + He * He * me[lt];
          });
          return new $r(pt, "lab");
        };
      else if (k.length === 4) {
        var he;
        Y = k.map(function(He) {
          return He.lab();
        }), se = Y[0], te = Y[1], me = Y[2], he = Y[3], ne = function(He) {
          var pt = [0, 1, 2].map(function(lt) {
            return (1 - He) * (1 - He) * (1 - He) * se[lt] + 3 * (1 - He) * (1 - He) * He * te[lt] + 3 * (1 - He) * He * He * me[lt] + He * He * He * he[lt];
          });
          return new $r(pt, "lab");
        };
      } else if (k.length >= 5) {
        var Me, We, it;
        Me = k.map(function(He) {
          return He.lab();
        }), it = k.length - 1, We = xs(it), ne = function(He) {
          var pt = 1 - He, lt = [0, 1, 2].map(function(jt) {
            return Me.reduce(function(St, gn, Ct) {
              return St + We[Ct] * Math.pow(pt, it - Ct) * Math.pow(He, Ct) * gn[jt];
            }, 0);
          });
          return new $r(lt, "lab");
        };
      } else
        throw new RangeError("No point in running bezier with only one color.");
      return ne;
    }, Ic = function(k) {
      var C = Co(k);
      return C.scale = function() {
        return Ss(C);
      }, C;
    }, zu = ue, li = function(k, C, W) {
      if (!li[W])
        throw new Error("unknown blend mode " + W);
      return li[W](k, C);
    }, Mo = function(k) {
      return function(C, W) {
        var Y = zu(W).rgb(), ne = zu(C).rgb();
        return zu.rgb(k(Y, ne));
      };
    }, ui = function(k) {
      return function(C, W) {
        var Y = [];
        return Y[0] = k(C[0], W[0]), Y[1] = k(C[1], W[1]), Y[2] = k(C[2], W[2]), Y;
      };
    }, xi = function(k) {
      return k;
    }, Li = function(k, C) {
      return k * C / 255;
    }, sf = function(k, C) {
      return k > C ? C : k;
    }, Im = function(k, C) {
      return k > C ? k : C;
    }, ro = function(k, C) {
      return 255 * (1 - (1 - k / 255) * (1 - C / 255));
    }, Qo = function(k, C) {
      return C < 128 ? 2 * k * C / 255 : 255 * (1 - 2 * (1 - k / 255) * (1 - C / 255));
    }, Fm = function(k, C) {
      return 255 * (1 - (1 - C / 255) / (k / 255));
    }, Ko = function(k, C) {
      return k === 255 ? 255 : (k = 255 * (C / 255) / (1 - k / 255), k > 255 ? 255 : k);
    };
    li.normal = Mo(ui(xi)), li.multiply = Mo(ui(Li)), li.screen = Mo(ui(ro)), li.overlay = Mo(ui(Qo)), li.darken = Mo(ui(sf)), li.lighten = Mo(ui(Im)), li.dodge = Mo(ui(Ko)), li.burn = Mo(ui(Fm));
    for (var lf = li, zl = O.type, Lu = O.clip_rgb, Ll = O.TWOPI, Iu = Math.pow, tl = Math.sin, Fc = Math.cos, Fu = ue, nl = function(k, C, W, Y, ne) {
      k === void 0 && (k = 300), C === void 0 && (C = -1.5), W === void 0 && (W = 1), Y === void 0 && (Y = 1), ne === void 0 && (ne = [0, 1]);
      var se = 0, te;
      zl(ne) === "array" ? te = ne[1] - ne[0] : (te = 0, ne = [ne, ne]);
      var me = function(he) {
        var Me = Ll * ((k + 120) / 360 + C * he), We = Iu(ne[0] + te * he, Y), it = se !== 0 ? W[0] + he * se : W, He = it * We * (1 - We) / 2, pt = Fc(Me), lt = tl(Me), jt = We + He * (-0.14861 * pt + 1.78277 * lt), St = We + He * (-0.29227 * pt - 0.90649 * lt), gn = We + He * (1.97294 * pt);
        return Fu(Lu([jt * 255, St * 255, gn * 255, 1]));
      };
      return me.start = function(he) {
        return he == null ? k : (k = he, me);
      }, me.rotations = function(he) {
        return he == null ? C : (C = he, me);
      }, me.gamma = function(he) {
        return he == null ? Y : (Y = he, me);
      }, me.hue = function(he) {
        return he == null ? W : (W = he, zl(W) === "array" ? (se = W[1] - W[0], se === 0 && (W = W[1])) : se = 0, me);
      }, me.lightness = function(he) {
        return he == null ? ne : (zl(he) === "array" ? (ne = he, te = he[1] - he[0]) : (ne = [he, he], te = 0), me);
      }, me.scale = function() {
        return Fu.scale(me);
      }, me.hue(W), me;
    }, Il = K, Hu = "0123456789abcdef", uf = Math.floor, Vu = Math.random, cf = function() {
      for (var k = "#", C = 0; C < 6; C++)
        k += Hu.charAt(uf(Vu() * 16));
      return new Il(k, "hex");
    }, Jo = y, ao = Math.log, Bu = Math.pow, Uu = Math.floor, rl = Math.abs, Fl = function(k, C) {
      C === void 0 && (C = null);
      var W = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
      };
      return Jo(k) === "object" && (k = Object.values(k)), k.forEach(function(Y) {
        C && Jo(Y) === "object" && (Y = Y[C]), Y != null && !isNaN(Y) && (W.values.push(Y), W.sum += Y, Y < W.min && (W.min = Y), Y > W.max && (W.max = Y), W.count += 1);
      }), W.domain = [W.min, W.max], W.limits = function(Y, ne) {
        return al(W, Y, ne);
      }, W;
    }, al = function(k, C, W) {
      C === void 0 && (C = "equal"), W === void 0 && (W = 7), Jo(k) == "array" && (k = Fl(k));
      var Y = k.min, ne = k.max, se = k.values.sort(function(bn, _s) {
        return bn - _s;
      });
      if (W === 1)
        return [Y, ne];
      var te = [];
      if (C.substr(0, 1) === "c" && (te.push(Y), te.push(ne)), C.substr(0, 1) === "e") {
        te.push(Y);
        for (var me = 1; me < W; me++)
          te.push(Y + me / W * (ne - Y));
        te.push(ne);
      } else if (C.substr(0, 1) === "l") {
        if (Y <= 0)
          throw new Error("Logarithmic scales are only possible for values > 0");
        var he = Math.LOG10E * ao(Y), Me = Math.LOG10E * ao(ne);
        te.push(Y);
        for (var We = 1; We < W; We++)
          te.push(Bu(10, he + We / W * (Me - he)));
        te.push(ne);
      } else if (C.substr(0, 1) === "q") {
        te.push(Y);
        for (var it = 1; it < W; it++) {
          var He = (se.length - 1) * it / W, pt = Uu(He);
          if (pt === He)
            te.push(se[pt]);
          else {
            var lt = He - pt;
            te.push(se[pt] * (1 - lt) + se[pt + 1] * lt);
          }
        }
        te.push(ne);
      } else if (C.substr(0, 1) === "k") {
        var jt, St = se.length, gn = new Array(St), Ct = new Array(W), xr = !0, zr = 0, ka = null;
        ka = [], ka.push(Y);
        for (var nn = 1; nn < W; nn++)
          ka.push(Y + nn / W * (ne - Y));
        for (ka.push(ne); xr; ) {
          for (var Xe = 0; Xe < W; Xe++)
            Ct[Xe] = 0;
          for (var Ot = 0; Ot < St; Ot++)
            for (var on = se[Ot], Rt = Number.MAX_VALUE, An = void 0, Bn = 0; Bn < W; Bn++) {
              var fn = rl(ka[Bn] - on);
              fn < Rt && (Rt = fn, An = Bn), Ct[An]++, gn[Ot] = An;
            }
          for (var xn = new Array(W), mn = 0; mn < W; mn++)
            xn[mn] = null;
          for (var _n = 0; _n < St; _n++)
            jt = gn[_n], xn[jt] === null ? xn[jt] = se[_n] : xn[jt] += se[_n];
          for (var Ci = 0; Ci < W; Ci++)
            xn[Ci] *= 1 / Ct[Ci];
          xr = !1;
          for (var es = 0; es < W; es++)
            if (xn[es] !== ka[es]) {
              xr = !0;
              break;
            }
          ka = xn, zr++, zr > 200 && (xr = !1);
        }
        for (var _o = {}, ol = 0; ol < W; ol++)
          _o[ol] = [];
        for (var hr = 0; hr < St; hr++)
          jt = gn[hr], _o[jt].push(se[hr]);
        for (var Da = [], As = 0; As < W; As++)
          Da.push(_o[As][0]), Da.push(_o[As][_o[As].length - 1]);
        Da = Da.sort(function(bn, _s) {
          return bn - _s;
        }), te.push(Da[0]);
        for (var Tr = 1; Tr < Da.length; Tr += 2) {
          var ci = Da[Tr];
          !isNaN(ci) && te.indexOf(ci) === -1 && te.push(ci);
        }
      }
      return te;
    }, df = { analyze: Fl, limits: al }, Hc = K, Sr = function(k, C) {
      k = new Hc(k), C = new Hc(C);
      var W = k.luminance(), Y = C.luminance();
      return W > Y ? (W + 0.05) / (Y + 0.05) : (Y + 0.05) / (W + 0.05);
    }, Hl = K, ra = Math.sqrt, Vn = Math.pow, Eo = Math.min, ff = Math.max, mf = Math.atan2, Zo = Math.abs, Cs = Math.cos, Vl = Math.sin, Bl = Math.exp, Ms = Math.PI, Es = function(k, C, W, Y, ne) {
      W === void 0 && (W = 1), Y === void 0 && (Y = 1), ne === void 0 && (ne = 1);
      var se = function(ci) {
        return 360 * ci / (2 * Ms);
      }, te = function(ci) {
        return 2 * Ms * ci / 360;
      };
      k = new Hl(k), C = new Hl(C);
      var me = Array.from(k.lab()), he = me[0], Me = me[1], We = me[2], it = Array.from(C.lab()), He = it[0], pt = it[1], lt = it[2], jt = (he + He) / 2, St = ra(Vn(Me, 2) + Vn(We, 2)), gn = ra(Vn(pt, 2) + Vn(lt, 2)), Ct = (St + gn) / 2, xr = 0.5 * (1 - ra(Vn(Ct, 7) / (Vn(Ct, 7) + Vn(25, 7)))), zr = Me * (1 + xr), ka = pt * (1 + xr), nn = ra(Vn(zr, 2) + Vn(We, 2)), Xe = ra(Vn(ka, 2) + Vn(lt, 2)), Ot = (nn + Xe) / 2, on = se(mf(We, zr)), Rt = se(mf(lt, ka)), An = on >= 0 ? on : on + 360, Bn = Rt >= 0 ? Rt : Rt + 360, fn = Zo(An - Bn) > 180 ? (An + Bn + 360) / 2 : (An + Bn) / 2, xn = 1 - 0.17 * Cs(te(fn - 30)) + 0.24 * Cs(te(2 * fn)) + 0.32 * Cs(te(3 * fn + 6)) - 0.2 * Cs(te(4 * fn - 63)), mn = Bn - An;
      mn = Zo(mn) <= 180 ? mn : Bn <= An ? mn + 360 : mn - 360, mn = 2 * ra(nn * Xe) * Vl(te(mn) / 2);
      var _n = He - he, Ci = Xe - nn, es = 1 + 0.015 * Vn(jt - 50, 2) / ra(20 + Vn(jt - 50, 2)), _o = 1 + 0.045 * Ot, ol = 1 + 0.015 * Ot * xn, hr = 30 * Bl(-Vn((fn - 275) / 25, 2)), Da = 2 * ra(Vn(Ot, 7) / (Vn(Ot, 7) + Vn(25, 7))), As = -Da * Vl(2 * te(hr)), Tr = ra(Vn(_n / (W * es), 2) + Vn(Ci / (Y * _o), 2) + Vn(mn / (ne * ol), 2) + As * (Ci / (Y * _o)) * (mn / (ne * ol)));
      return ff(0, Eo(100, Tr));
    }, il = K, aa = function(k, C, W) {
      W === void 0 && (W = "lab"), k = new il(k), C = new il(C);
      var Y = k.get(W), ne = C.get(W), se = 0;
      for (var te in Y) {
        var me = (Y[te] || 0) - (ne[te] || 0);
        se += me * me;
      }
      return Math.sqrt(se);
    }, Ul = K, ur = function() {
      for (var k = [], C = arguments.length; C--; )
        k[C] = arguments[C];
      try {
        return new (Function.prototype.bind.apply(Ul, [null].concat(k)))(), !0;
      } catch {
        return !1;
      }
    }, qr = ue, Yr = no, Xu = {
      cool: function() {
        return Yr([qr.hsl(180, 1, 0.9), qr.hsl(250, 0.7, 0.4)]);
      },
      hot: function() {
        return Yr(["#000", "#f00", "#ff0", "#fff"]).mode("rgb");
      }
    }, io = {
      OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
      PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
      BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
      Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
      BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
      YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
      YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
      Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
      RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
      Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
      YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
      Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
      GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
      Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
      YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
      PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
      Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
      PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
      Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
      Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
      RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
      RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
      PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
      PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
      RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
      BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
      RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
      PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
      Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
      Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
      Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
      Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
      Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
      Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
      Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
      Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
    }, Pa = 0, Ao = Object.keys(io); Pa < Ao.length; Pa += 1) {
      var Vc = Ao[Pa];
      io[Vc.toLowerCase()] = io[Vc];
    }
    var Te = io, ln = ue;
    ln.average = jl, ln.bezier = Ic, ln.blend = lf, ln.cubehelix = nl, ln.mix = ln.interpolate = bs, ln.random = cf, ln.scale = no, ln.analyze = df.analyze, ln.contrast = Sr, ln.deltaE = Es, ln.distance = aa, ln.limits = df.limits, ln.valid = ur, ln.scales = Xu, ln.colors = Wd, ln.brewer = Te;
    var un = ln;
    return un;
  });
})(I5);
const F5 = I5.exports;
class tp {
  constructor() {
    this.listeners = [], this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    return this.listeners.push(t), this.onSubscribe(), () => {
      this.listeners = this.listeners.filter((n) => n !== t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.length > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const ag = typeof window > "u" || "Deno" in window;
function Hs() {
}
function Uee(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function U$(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function H5(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function Rh(e, t, n) {
  return yg(e) ? typeof t == "function" ? {
    ...n,
    queryKey: e,
    queryFn: t
  } : {
    ...t,
    queryKey: e
  } : e;
}
function Xee(e, t, n) {
  return yg(e) ? typeof t == "function" ? {
    ...n,
    mutationKey: e,
    mutationFn: t
  } : {
    ...t,
    mutationKey: e
  } : typeof e == "function" ? {
    ...t,
    mutationFn: e
  } : {
    ...e
  };
}
function hd(e, t, n) {
  return yg(e) ? [{
    ...t,
    queryKey: e
  }, n] : [e || {}, t];
}
function mO(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: s,
    predicate: f,
    queryKey: m,
    stale: p
  } = e;
  if (yg(m)) {
    if (r) {
      if (t.queryHash !== ix(m, t.options))
        return !1;
    } else if (!Dh(t.queryKey, m))
      return !1;
  }
  if (n !== "all") {
    const v = t.isActive();
    if (n === "active" && !v || n === "inactive" && v)
      return !1;
  }
  return !(typeof p == "boolean" && t.isStale() !== p || typeof s < "u" && s !== t.state.fetchStatus || f && !f(t));
}
function hO(e, t) {
  const {
    exact: n,
    fetching: r,
    predicate: s,
    mutationKey: f
  } = e;
  if (yg(f)) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (im(t.options.mutationKey) !== im(f))
        return !1;
    } else if (!Dh(t.options.mutationKey, f))
      return !1;
  }
  return !(typeof r == "boolean" && t.state.status === "loading" !== r || s && !s(t));
}
function ix(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || im)(e);
}
function im(e) {
  return JSON.stringify(e, (t, n) => q$(n) ? Object.keys(n).sort().reduce((r, s) => (r[s] = n[s], r), {}) : n);
}
function Dh(e, t) {
  return V5(e, t);
}
function V5(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !V5(e[n], t[n])) : !1;
}
function B5(e, t) {
  if (e === t)
    return e;
  const n = pO(e) && pO(t);
  if (n || q$(e) && q$(t)) {
    const r = n ? e.length : Object.keys(e).length, s = n ? t : Object.keys(t), f = s.length, m = n ? [] : {};
    let p = 0;
    for (let v = 0; v < f; v++) {
      const y = n ? v : s[v];
      m[y] = B5(e[y], t[y]), m[y] === e[y] && p++;
    }
    return r === f && p === r ? e : m;
  }
  return t;
}
function X$(e, t) {
  if (e && !t || t && !e)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function pO(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function q$(e) {
  if (!vO(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const n = t.prototype;
  return !(!vO(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function vO(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function yg(e) {
  return Array.isArray(e);
}
function U5(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function gO(e) {
  U5(0).then(e);
}
function qee() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function Y$(e, t, n) {
  return n.isDataEqual != null && n.isDataEqual(e, t) ? e : typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? B5(e, t) : t;
}
class Yee extends tp {
  constructor() {
    super(), this.setup = (t) => {
      if (!ag && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), window.addEventListener("focus", n, !1), () => {
          window.removeEventListener("visibilitychange", n), window.removeEventListener("focus", n);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var n;
    this.setup = t, (n = this.cleanup) == null || n.call(this), this.cleanup = t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    });
  }
  setFocused(t) {
    this.focused = t, t && this.onFocus();
  }
  onFocus() {
    this.listeners.forEach((t) => {
      t();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const hw = new Yee();
class Gee extends tp {
  constructor() {
    super(), this.setup = (t) => {
      if (!ag && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("online", n, !1), window.addEventListener("offline", n, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", n);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var n;
    this.setup = t, (n = this.cleanup) == null || n.call(this), this.cleanup = t((r) => {
      typeof r == "boolean" ? this.setOnline(r) : this.onOnline();
    });
  }
  setOnline(t) {
    this.online = t, t && this.onOnline();
  }
  onOnline() {
    this.listeners.forEach((t) => {
      t();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const pw = new Gee();
function Qee(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function Bw(e) {
  return (e ?? "online") === "online" ? pw.isOnline() : !0;
}
class X5 {
  constructor(t) {
    this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
}
function Gb(e) {
  return e instanceof X5;
}
function q5(e) {
  let t = !1, n = 0, r = !1, s, f, m;
  const p = new Promise((j, H) => {
    f = j, m = H;
  }), v = (j) => {
    r || (A(new X5(j)), e.abort == null || e.abort());
  }, y = () => {
    t = !0;
  }, w = () => {
    t = !1;
  }, P = () => !hw.isFocused() || e.networkMode !== "always" && !pw.isOnline(), x = (j) => {
    r || (r = !0, e.onSuccess == null || e.onSuccess(j), s == null || s(), f(j));
  }, A = (j) => {
    r || (r = !0, e.onError == null || e.onError(j), s == null || s(), m(j));
  }, M = () => new Promise((j) => {
    s = (H) => {
      if (r || !P())
        return j(H);
    }, e.onPause == null || e.onPause();
  }).then(() => {
    s = void 0, r || e.onContinue == null || e.onContinue();
  }), O = () => {
    if (r)
      return;
    let j;
    try {
      j = e.fn();
    } catch (H) {
      j = Promise.reject(H);
    }
    Promise.resolve(j).then(x).catch((H) => {
      var J, V;
      if (r)
        return;
      const X = (J = e.retry) != null ? J : 3, U = (V = e.retryDelay) != null ? V : Qee, K = typeof U == "function" ? U(n, H) : U, ce = X === !0 || typeof X == "number" && n < X || typeof X == "function" && X(n, H);
      if (t || !ce) {
        A(H);
        return;
      }
      n++, e.onFail == null || e.onFail(n, H), U5(K).then(() => {
        if (P())
          return M();
      }).then(() => {
        t ? A(H) : O();
      });
    });
  };
  return Bw(e.networkMode) ? O() : M().then(O), {
    promise: p,
    cancel: v,
    continue: () => {
      s == null || s();
    },
    cancelRetry: y,
    continueRetry: w
  };
}
const ox = console;
function Kee() {
  let e = [], t = 0, n = (w) => {
    w();
  }, r = (w) => {
    w();
  };
  const s = (w) => {
    let P;
    t++;
    try {
      P = w();
    } finally {
      t--, t || p();
    }
    return P;
  }, f = (w) => {
    t ? e.push(w) : gO(() => {
      n(w);
    });
  }, m = (w) => (...P) => {
    f(() => {
      w(...P);
    });
  }, p = () => {
    const w = e;
    e = [], w.length && gO(() => {
      r(() => {
        w.forEach((P) => {
          n(P);
        });
      });
    });
  };
  return {
    batch: s,
    batchCalls: m,
    schedule: f,
    setNotifyFunction: (w) => {
      n = w;
    },
    setBatchNotifyFunction: (w) => {
      r = w;
    }
  };
}
const ua = Kee();
class Y5 {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), U$(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(t) {
    this.cacheTime = Math.max(this.cacheTime || 0, t ?? (ag ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class Jee extends Y5 {
  constructor(t) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = t.defaultOptions, this.setOptions(t.options), this.observers = [], this.cache = t.cache, this.logger = t.logger || ox, this.queryKey = t.queryKey, this.queryHash = t.queryHash, this.initialState = t.state || Zee(this.options), this.state = this.initialState;
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(t) {
    this.options = {
      ...this.defaultOptions,
      ...t
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(t, n) {
    const r = Y$(this.state.data, t, this.options);
    return this.dispatch({
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(t, n) {
    this.dispatch({
      type: "setState",
      state: t,
      setStateOptions: n
    });
  }
  cancel(t) {
    var n;
    const r = this.promise;
    return (n = this.retryer) == null || n.cancel(t), r ? r.then(Hs).catch(Hs) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((t) => t.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((t) => t.getCurrentResult().isStale);
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !H5(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var t;
    const n = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    n && n.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  onOnline() {
    var t;
    const n = this.observers.find((r) => r.shouldFetchOnReconnect());
    n && n.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  addObserver(t) {
    this.observers.indexOf(t) === -1 && (this.observers.push(t), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers.indexOf(t) !== -1 && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: t
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(t, n) {
    var r, s;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && n != null && n.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var f;
        return (f = this.retryer) == null || f.continueRetry(), this.promise;
      }
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const A = this.observers.find((M) => M.options.queryFn);
      A && this.setOptions(A.options);
    }
    Array.isArray(this.options.queryKey) || process.env.NODE_ENV !== "production" && this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
    const m = qee(), p = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, v = (A) => {
      Object.defineProperty(A, "signal", {
        enumerable: !0,
        get: () => {
          if (m)
            return this.abortSignalConsumed = !0, m.signal;
        }
      });
    };
    v(p);
    const y = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(p)) : Promise.reject("Missing queryFn"), w = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: y
    };
    if (v(w), (r = this.options.behavior) == null || r.onFetch(w), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((s = w.fetchOptions) == null ? void 0 : s.meta)) {
      var P;
      this.dispatch({
        type: "fetch",
        meta: (P = w.fetchOptions) == null ? void 0 : P.meta
      });
    }
    const x = (A) => {
      if (Gb(A) && A.silent || this.dispatch({
        type: "error",
        error: A
      }), !Gb(A)) {
        var M, O;
        (M = (O = this.cache.config).onError) == null || M.call(O, A, this), process.env.NODE_ENV !== "production" && this.logger.error(A);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = q5({
      fn: w.fetchFn,
      abort: m == null ? void 0 : m.abort.bind(m),
      onSuccess: (A) => {
        var M, O;
        if (typeof A > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), x(new Error("undefined"));
          return;
        }
        this.setData(A), (M = (O = this.cache.config).onSuccess) == null || M.call(O, A, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: x,
      onFail: (A, M) => {
        this.dispatch({
          type: "failed",
          failureCount: A,
          error: M
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: w.options.retry,
      retryDelay: w.options.retryDelay,
      networkMode: w.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(t) {
    const n = (r) => {
      var s, f;
      switch (t.type) {
        case "failed":
          return {
            ...r,
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error
          };
        case "pause":
          return {
            ...r,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...r,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...r,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (s = t.meta) != null ? s : null,
            fetchStatus: Bw(this.options.networkMode) ? "fetching" : "paused",
            ...!r.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...r,
            data: t.data,
            dataUpdateCount: r.dataUpdateCount + 1,
            dataUpdatedAt: (f = t.dataUpdatedAt) != null ? f : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!t.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const m = t.error;
          return Gb(m) && m.revert && this.revertState ? {
            ...this.revertState
          } : {
            ...r,
            error: m,
            errorUpdateCount: r.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: r.fetchFailureCount + 1,
            fetchFailureReason: m,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...r,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...r,
            ...t.state
          };
      }
    };
    this.state = n(this.state), ua.batch(() => {
      this.observers.forEach((r) => {
        r.onQueryUpdate(t);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: t
      });
    });
  }
}
function Zee(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = typeof t < "u", r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class ete extends tp {
  constructor(t) {
    super(), this.config = t || {}, this.queries = [], this.queriesMap = {};
  }
  build(t, n, r) {
    var s;
    const f = n.queryKey, m = (s = n.queryHash) != null ? s : ix(f, n);
    let p = this.get(m);
    return p || (p = new Jee({
      cache: this,
      logger: t.getLogger(),
      queryKey: f,
      queryHash: m,
      options: t.defaultQueryOptions(n),
      state: r,
      defaultOptions: t.getQueryDefaults(f)
    }), this.add(p)), p;
  }
  add(t) {
    this.queriesMap[t.queryHash] || (this.queriesMap[t.queryHash] = t, this.queries.push(t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = this.queriesMap[t.queryHash];
    n && (t.destroy(), this.queries = this.queries.filter((r) => r !== t), n === t && delete this.queriesMap[t.queryHash], this.notify({
      type: "removed",
      query: t
    }));
  }
  clear() {
    ua.batch(() => {
      this.queries.forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return this.queriesMap[t];
  }
  getAll() {
    return this.queries;
  }
  find(t, n) {
    const [r] = hd(t, n);
    return typeof r.exact > "u" && (r.exact = !0), this.queries.find((s) => mO(r, s));
  }
  findAll(t, n) {
    const [r] = hd(t, n);
    return Object.keys(r).length > 0 ? this.queries.filter((s) => mO(r, s)) : this.queries;
  }
  notify(t) {
    ua.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  onFocus() {
    ua.batch(() => {
      this.queries.forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    ua.batch(() => {
      this.queries.forEach((t) => {
        t.onOnline();
      });
    });
  }
}
class tte extends Y5 {
  constructor(t) {
    super(), this.options = {
      ...t.defaultOptions,
      ...t.options
    }, this.mutationId = t.mutationId, this.mutationCache = t.mutationCache, this.logger = t.logger || ox, this.observers = [], this.state = t.state || G5(), this.updateCacheTime(this.options.cacheTime), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setState(t) {
    this.dispatch({
      type: "setState",
      state: t
    });
  }
  addObserver(t) {
    this.observers.indexOf(t) === -1 && (this.observers.push(t), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers = this.observers.filter((n) => n !== t), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    return this.retryer ? (this.retryer.continue(), this.retryer.promise) : this.execute();
  }
  async execute() {
    const t = () => {
      var V;
      return this.retryer = q5({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (X, U) => {
          this.dispatch({
            type: "failed",
            failureCount: X,
            error: U
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (V = this.options.retry) != null ? V : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, n = this.state.status === "loading";
    try {
      var r, s, f, m, p, v;
      if (!n) {
        var y, w, P, x;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((y = (w = this.mutationCache.config).onMutate) == null ? void 0 : y.call(w, this.state.variables, this));
        const X = await ((P = (x = this.options).onMutate) == null ? void 0 : P.call(x, this.state.variables));
        X !== this.state.context && this.dispatch({
          type: "loading",
          context: X,
          variables: this.state.variables
        });
      }
      const V = await t();
      return await ((r = (s = this.mutationCache.config).onSuccess) == null ? void 0 : r.call(s, V, this.state.variables, this.state.context, this)), await ((f = (m = this.options).onSuccess) == null ? void 0 : f.call(m, V, this.state.variables, this.state.context)), await ((p = (v = this.options).onSettled) == null ? void 0 : p.call(v, V, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: V
      }), V;
    } catch (V) {
      try {
        var A, M, O, j, H, J;
        throw await ((A = (M = this.mutationCache.config).onError) == null ? void 0 : A.call(M, V, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(V), await ((O = (j = this.options).onError) == null ? void 0 : O.call(j, V, this.state.variables, this.state.context)), await ((H = (J = this.options).onSettled) == null ? void 0 : H.call(J, void 0, V, this.state.variables, this.state.context)), V;
      } finally {
        this.dispatch({
          type: "error",
          error: V
        });
      }
    }
  }
  dispatch(t) {
    const n = (r) => {
      switch (t.type) {
        case "failed":
          return {
            ...r,
            failureCount: t.failureCount,
            failureReason: t.error
          };
        case "pause":
          return {
            ...r,
            isPaused: !0
          };
        case "continue":
          return {
            ...r,
            isPaused: !1
          };
        case "loading":
          return {
            ...r,
            context: t.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !Bw(this.options.networkMode),
            status: "loading",
            variables: t.variables
          };
        case "success":
          return {
            ...r,
            data: t.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...r,
            data: void 0,
            error: t.error,
            failureCount: r.failureCount + 1,
            failureReason: t.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...r,
            ...t.state
          };
      }
    };
    this.state = n(this.state), ua.batch(() => {
      this.observers.forEach((r) => {
        r.onMutationUpdate(t);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: t
      });
    });
  }
}
function G5() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class nte extends tp {
  constructor(t) {
    super(), this.config = t || {}, this.mutations = [], this.mutationId = 0;
  }
  build(t, n, r) {
    const s = new tte({
      mutationCache: this,
      logger: t.getLogger(),
      mutationId: ++this.mutationId,
      options: t.defaultMutationOptions(n),
      state: r,
      defaultOptions: n.mutationKey ? t.getMutationDefaults(n.mutationKey) : void 0
    });
    return this.add(s), s;
  }
  add(t) {
    this.mutations.push(t), this.notify({
      type: "added",
      mutation: t
    });
  }
  remove(t) {
    this.mutations = this.mutations.filter((n) => n !== t), this.notify({
      type: "removed",
      mutation: t
    });
  }
  clear() {
    ua.batch(() => {
      this.mutations.forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(t) {
    return typeof t.exact > "u" && (t.exact = !0), this.mutations.find((n) => hO(t, n));
  }
  findAll(t) {
    return this.mutations.filter((n) => hO(t, n));
  }
  notify(t) {
    ua.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.mutations.filter((n) => n.state.isPaused);
    return ua.batch(() => t.reduce((n, r) => n.then(() => r.continue().catch(Hs)), Promise.resolve()));
  }
}
function G$() {
  return {
    onFetch: (e) => {
      e.fetchFn = () => {
        var t, n, r, s, f, m;
        const p = (t = e.fetchOptions) == null || (n = t.meta) == null ? void 0 : n.refetchPage, v = (r = e.fetchOptions) == null || (s = r.meta) == null ? void 0 : s.fetchMore, y = v == null ? void 0 : v.pageParam, w = (v == null ? void 0 : v.direction) === "forward", P = (v == null ? void 0 : v.direction) === "backward", x = ((f = e.state.data) == null ? void 0 : f.pages) || [], A = ((m = e.state.data) == null ? void 0 : m.pageParams) || [];
        let M = A, O = !1;
        const j = (K) => {
          Object.defineProperty(K, "signal", {
            enumerable: !0,
            get: () => {
              var ce;
              if ((ce = e.signal) != null && ce.aborted)
                O = !0;
              else {
                var ue;
                (ue = e.signal) == null || ue.addEventListener("abort", () => {
                  O = !0;
                });
              }
              return e.signal;
            }
          });
        }, H = e.options.queryFn || (() => Promise.reject("Missing queryFn")), J = (K, ce, ue, ye) => (M = ye ? [ce, ...M] : [...M, ce], ye ? [ue, ...K] : [...K, ue]), V = (K, ce, ue, ye) => {
          if (O)
            return Promise.reject("Cancelled");
          if (typeof ue > "u" && !ce && K.length)
            return Promise.resolve(K);
          const Oe = {
            queryKey: e.queryKey,
            pageParam: ue,
            meta: e.options.meta
          };
          j(Oe);
          const _e = H(Oe);
          return Promise.resolve(_e).then((Ne) => J(K, ue, Ne, ye));
        };
        let X;
        if (!x.length)
          X = V([]);
        else if (w) {
          const K = typeof y < "u", ce = K ? y : Q$(e.options, x);
          X = V(x, K, ce);
        } else if (P) {
          const K = typeof y < "u", ce = K ? y : Q5(e.options, x);
          X = V(x, K, ce, !0);
        } else {
          M = [];
          const K = typeof e.options.getNextPageParam > "u";
          X = (p && x[0] ? p(x[0], 0, x) : !0) ? V([], K, A[0]) : Promise.resolve(J([], A[0], x[0]));
          for (let ue = 1; ue < x.length; ue++)
            X = X.then((ye) => {
              if (p && x[ue] ? p(x[ue], ue, x) : !0) {
                const _e = K ? A[ue] : Q$(e.options, ye);
                return V(ye, K, _e);
              }
              return Promise.resolve(J(ye, A[ue], x[ue]));
            });
        }
        return X.then((K) => ({
          pages: K,
          pageParams: M
        }));
      };
    }
  };
}
function Q$(e, t) {
  return e.getNextPageParam == null ? void 0 : e.getNextPageParam(t[t.length - 1], t);
}
function Q5(e, t) {
  return e.getPreviousPageParam == null ? void 0 : e.getPreviousPageParam(t[0], t);
}
function rte(e, t) {
  if (e.getNextPageParam && Array.isArray(t)) {
    const n = Q$(e, t);
    return typeof n < "u" && n !== null && n !== !1;
  }
}
function ate(e, t) {
  if (e.getPreviousPageParam && Array.isArray(t)) {
    const n = Q5(e, t);
    return typeof n < "u" && n !== null && n !== !1;
  }
}
class ite {
  constructor(t = {}) {
    this.queryCache = t.queryCache || new ete(), this.mutationCache = t.mutationCache || new nte(), this.logger = t.logger || ox, this.defaultOptions = t.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], process.env.NODE_ENV !== "production" && t.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.unsubscribeFocus = hw.subscribe(() => {
      hw.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = pw.subscribe(() => {
      pw.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    });
  }
  unmount() {
    var t, n;
    (t = this.unsubscribeFocus) == null || t.call(this), (n = this.unsubscribeOnline) == null || n.call(this);
  }
  isFetching(t, n) {
    const [r] = hd(t, n);
    return r.fetchStatus = "fetching", this.queryCache.findAll(r).length;
  }
  isMutating(t) {
    return this.mutationCache.findAll({
      ...t,
      fetching: !0
    }).length;
  }
  getQueryData(t, n) {
    var r;
    return (r = this.queryCache.find(t, n)) == null ? void 0 : r.state.data;
  }
  ensureQueryData(t, n, r) {
    const s = Rh(t, n, r), f = this.getQueryData(s.queryKey);
    return f ? Promise.resolve(f) : this.fetchQuery(s);
  }
  getQueriesData(t) {
    return this.getQueryCache().findAll(t).map(({
      queryKey: n,
      state: r
    }) => {
      const s = r.data;
      return [n, s];
    });
  }
  setQueryData(t, n, r) {
    const s = this.queryCache.find(t), f = s == null ? void 0 : s.state.data, m = Uee(n, f);
    if (typeof m > "u")
      return;
    const p = Rh(t), v = this.defaultQueryOptions(p);
    return this.queryCache.build(this, v).setData(m, {
      ...r,
      manual: !0
    });
  }
  setQueriesData(t, n, r) {
    return ua.batch(() => this.getQueryCache().findAll(t).map(({
      queryKey: s
    }) => [s, this.setQueryData(s, n, r)]));
  }
  getQueryState(t, n) {
    var r;
    return (r = this.queryCache.find(t, n)) == null ? void 0 : r.state;
  }
  removeQueries(t, n) {
    const [r] = hd(t, n), s = this.queryCache;
    ua.batch(() => {
      s.findAll(r).forEach((f) => {
        s.remove(f);
      });
    });
  }
  resetQueries(t, n, r) {
    const [s, f] = hd(t, n, r), m = this.queryCache, p = {
      type: "active",
      ...s
    };
    return ua.batch(() => (m.findAll(s).forEach((v) => {
      v.reset();
    }), this.refetchQueries(p, f)));
  }
  cancelQueries(t, n, r) {
    const [s, f = {}] = hd(t, n, r);
    typeof f.revert > "u" && (f.revert = !0);
    const m = ua.batch(() => this.queryCache.findAll(s).map((p) => p.cancel(f)));
    return Promise.all(m).then(Hs).catch(Hs);
  }
  invalidateQueries(t, n, r) {
    const [s, f] = hd(t, n, r);
    return ua.batch(() => {
      var m, p;
      if (this.queryCache.findAll(s).forEach((y) => {
        y.invalidate();
      }), s.refetchType === "none")
        return Promise.resolve();
      const v = {
        ...s,
        type: (m = (p = s.refetchType) != null ? p : s.type) != null ? m : "active"
      };
      return this.refetchQueries(v, f);
    });
  }
  refetchQueries(t, n, r) {
    const [s, f] = hd(t, n, r), m = ua.batch(() => this.queryCache.findAll(s).filter((v) => !v.isDisabled()).map((v) => {
      var y;
      return v.fetch(void 0, {
        ...f,
        cancelRefetch: (y = f == null ? void 0 : f.cancelRefetch) != null ? y : !0,
        meta: {
          refetchPage: s.refetchPage
        }
      });
    }));
    let p = Promise.all(m).then(Hs);
    return f != null && f.throwOnError || (p = p.catch(Hs)), p;
  }
  fetchQuery(t, n, r) {
    const s = Rh(t, n, r), f = this.defaultQueryOptions(s);
    typeof f.retry > "u" && (f.retry = !1);
    const m = this.queryCache.build(this, f);
    return m.isStaleByTime(f.staleTime) ? m.fetch(f) : Promise.resolve(m.state.data);
  }
  prefetchQuery(t, n, r) {
    return this.fetchQuery(t, n, r).then(Hs).catch(Hs);
  }
  fetchInfiniteQuery(t, n, r) {
    const s = Rh(t, n, r);
    return s.behavior = G$(), this.fetchQuery(s);
  }
  prefetchInfiniteQuery(t, n, r) {
    return this.fetchInfiniteQuery(t, n, r).then(Hs).catch(Hs);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(t) {
    this.defaultOptions = t;
  }
  setQueryDefaults(t, n) {
    const r = this.queryDefaults.find((s) => im(t) === im(s.queryKey));
    r ? r.defaultOptions = n : this.queryDefaults.push({
      queryKey: t,
      defaultOptions: n
    });
  }
  getQueryDefaults(t) {
    if (!t)
      return;
    const n = this.queryDefaults.find((r) => Dh(t, r.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((s) => Dh(t, s.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(t) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), n == null ? void 0 : n.defaultOptions;
  }
  setMutationDefaults(t, n) {
    const r = this.mutationDefaults.find((s) => im(t) === im(s.mutationKey));
    r ? r.defaultOptions = n : this.mutationDefaults.push({
      mutationKey: t,
      defaultOptions: n
    });
  }
  getMutationDefaults(t) {
    if (!t)
      return;
    const n = this.mutationDefaults.find((r) => Dh(t, r.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((s) => Dh(t, s.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(t) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), n == null ? void 0 : n.defaultOptions;
  }
  defaultQueryOptions(t) {
    if (t != null && t._defaulted)
      return t;
    const n = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(t == null ? void 0 : t.queryKey),
      ...t,
      _defaulted: !0
    };
    return !n.queryHash && n.queryKey && (n.queryHash = ix(n.queryKey, n)), typeof n.refetchOnReconnect > "u" && (n.refetchOnReconnect = n.networkMode !== "always"), typeof n.useErrorBoundary > "u" && (n.useErrorBoundary = !!n.suspense), n;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(t == null ? void 0 : t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class K5 extends tp {
  constructor(t, n) {
    super(), this.client = t, this.options = n, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.length === 1 && (this.currentQuery.addObserver(this), yO(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.listeners.length || this.destroy();
  }
  shouldFetchOnReconnect() {
    return K$(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return K$(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = [], this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(t, n) {
    const r = this.options, s = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(t), process.env.NODE_ENV !== "production" && typeof (t == null ? void 0 : t.isDataEqual) < "u" && this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option"), X$(r, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = r.queryKey), this.updateQuery();
    const f = this.hasListeners();
    f && bO(this.currentQuery, s, this.options, r) && this.executeFetch(), this.updateResult(n), f && (this.currentQuery !== s || this.options.enabled !== r.enabled || this.options.staleTime !== r.staleTime) && this.updateStaleTimeout();
    const m = this.computeRefetchInterval();
    f && (this.currentQuery !== s || this.options.enabled !== r.enabled || m !== this.currentRefetchInterval) && this.updateRefetchInterval(m);
  }
  getOptimisticResult(t) {
    const n = this.client.getQueryCache().build(this.client, t);
    return this.createResult(n, t);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(t) {
    const n = {};
    return Object.keys(t).forEach((r) => {
      Object.defineProperty(n, r, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(r), t[r])
      });
    }), n;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: t,
    ...n
  } = {}) {
    return this.fetch({
      ...n,
      meta: {
        refetchPage: t
      }
    });
  }
  fetchOptimistic(t) {
    const n = this.client.defaultQueryOptions(t), r = this.client.getQueryCache().build(this.client, n);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, n));
  }
  fetch(t) {
    var n;
    return this.executeFetch({
      ...t,
      cancelRefetch: (n = t.cancelRefetch) != null ? n : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(t) {
    this.updateQuery();
    let n = this.currentQuery.fetch(this.options, t);
    return t != null && t.throwOnError || (n = n.catch(Hs)), n;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), ag || this.currentResult.isStale || !U$(this.options.staleTime))
      return;
    const n = H5(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, n);
  }
  computeRefetchInterval() {
    var t;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (t = this.options.refetchInterval) != null ? t : !1;
  }
  updateRefetchInterval(t) {
    this.clearRefetchInterval(), this.currentRefetchInterval = t, !(ag || this.options.enabled === !1 || !U$(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || hw.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(t, n) {
    const r = this.currentQuery, s = this.options, f = this.currentResult, m = this.currentResultState, p = this.currentResultOptions, v = t !== r, y = v ? t.state : this.currentQueryInitialState, w = v ? this.currentResult : this.previousQueryResult, {
      state: P
    } = t;
    let {
      dataUpdatedAt: x,
      error: A,
      errorUpdatedAt: M,
      fetchStatus: O,
      status: j
    } = P, H = !1, J = !1, V;
    if (n._optimisticResults) {
      const ue = this.hasListeners(), ye = !ue && yO(t, n), Oe = ue && bO(t, r, n, s);
      (ye || Oe) && (O = Bw(t.options.networkMode) ? "fetching" : "paused", x || (j = "loading")), n._optimisticResults === "isRestoring" && (O = "idle");
    }
    if (n.keepPreviousData && !P.dataUpdatedAt && w != null && w.isSuccess && j !== "error")
      V = w.data, x = w.dataUpdatedAt, j = w.status, H = !0;
    else if (n.select && typeof P.data < "u")
      if (f && P.data === (m == null ? void 0 : m.data) && n.select === this.selectFn)
        V = this.selectResult;
      else
        try {
          this.selectFn = n.select, V = n.select(P.data), V = Y$(f == null ? void 0 : f.data, V, n), this.selectResult = V, this.selectError = null;
        } catch (ue) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(ue), this.selectError = ue;
        }
    else
      V = P.data;
    if (typeof n.placeholderData < "u" && typeof V > "u" && j === "loading") {
      let ue;
      if (f != null && f.isPlaceholderData && n.placeholderData === (p == null ? void 0 : p.placeholderData))
        ue = f.data;
      else if (ue = typeof n.placeholderData == "function" ? n.placeholderData() : n.placeholderData, n.select && typeof ue < "u")
        try {
          ue = n.select(ue), this.selectError = null;
        } catch (ye) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(ye), this.selectError = ye;
        }
      typeof ue < "u" && (j = "success", V = Y$(f == null ? void 0 : f.data, ue, n), J = !0);
    }
    this.selectError && (A = this.selectError, V = this.selectResult, M = Date.now(), j = "error");
    const X = O === "fetching", U = j === "loading", K = j === "error";
    return {
      status: j,
      fetchStatus: O,
      isLoading: U,
      isSuccess: j === "success",
      isError: K,
      isInitialLoading: U && X,
      data: V,
      dataUpdatedAt: x,
      error: A,
      errorUpdatedAt: M,
      failureCount: P.fetchFailureCount,
      failureReason: P.fetchFailureReason,
      errorUpdateCount: P.errorUpdateCount,
      isFetched: P.dataUpdateCount > 0 || P.errorUpdateCount > 0,
      isFetchedAfterMount: P.dataUpdateCount > y.dataUpdateCount || P.errorUpdateCount > y.errorUpdateCount,
      isFetching: X,
      isRefetching: X && !U,
      isLoadingError: K && P.dataUpdatedAt === 0,
      isPaused: O === "paused",
      isPlaceholderData: J,
      isPreviousData: H,
      isRefetchError: K && P.dataUpdatedAt !== 0,
      isStale: sx(t, n),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(t) {
    const n = this.currentResult, r = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, X$(r, n))
      return;
    this.currentResult = r;
    const s = {
      cache: !0
    }, f = () => {
      if (!n)
        return !0;
      const {
        notifyOnChangeProps: m
      } = this.options;
      if (m === "all" || !m && !this.trackedProps.size)
        return !0;
      const p = new Set(m ?? this.trackedProps);
      return this.options.useErrorBoundary && p.add("error"), Object.keys(this.currentResult).some((v) => {
        const y = v;
        return this.currentResult[y] !== n[y] && p.has(y);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && f() && (s.listeners = !0), this.notify({
      ...s,
      ...t
    });
  }
  updateQuery() {
    const t = this.client.getQueryCache().build(this.client, this.options);
    if (t === this.currentQuery)
      return;
    const n = this.currentQuery;
    this.currentQuery = t, this.currentQueryInitialState = t.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
  }
  onQueryUpdate(t) {
    const n = {};
    t.type === "success" ? n.onSuccess = !t.manual : t.type === "error" && !Gb(t.error) && (n.onError = !0), this.updateResult(n), this.hasListeners() && this.updateTimers();
  }
  notify(t) {
    ua.batch(() => {
      if (t.onSuccess) {
        var n, r, s, f;
        (n = (r = this.options).onSuccess) == null || n.call(r, this.currentResult.data), (s = (f = this.options).onSettled) == null || s.call(f, this.currentResult.data, null);
      } else if (t.onError) {
        var m, p, v, y;
        (m = (p = this.options).onError) == null || m.call(p, this.currentResult.error), (v = (y = this.options).onSettled) == null || v.call(y, void 0, this.currentResult.error);
      }
      t.listeners && this.listeners.forEach((w) => {
        w(this.currentResult);
      }), t.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function ote(e, t) {
  return t.enabled !== !1 && !e.state.dataUpdatedAt && !(e.state.status === "error" && t.retryOnMount === !1);
}
function yO(e, t) {
  return ote(e, t) || e.state.dataUpdatedAt > 0 && K$(e, t, t.refetchOnMount);
}
function K$(e, t, n) {
  if (t.enabled !== !1) {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && sx(e, t);
  }
  return !1;
}
function bO(e, t, n, r) {
  return n.enabled !== !1 && (e !== t || r.enabled === !1) && (!n.suspense || e.state.status !== "error") && sx(e, n);
}
function sx(e, t) {
  return e.isStaleByTime(t.staleTime);
}
class ste extends K5 {
  constructor(t, n) {
    super(t, n);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(t, n) {
    super.setOptions({
      ...t,
      behavior: G$()
    }, n);
  }
  getOptimisticResult(t) {
    return t.behavior = G$(), super.getOptimisticResult(t);
  }
  fetchNextPage({
    pageParam: t,
    ...n
  } = {}) {
    return this.fetch({
      ...n,
      meta: {
        fetchMore: {
          direction: "forward",
          pageParam: t
        }
      }
    });
  }
  fetchPreviousPage({
    pageParam: t,
    ...n
  } = {}) {
    return this.fetch({
      ...n,
      meta: {
        fetchMore: {
          direction: "backward",
          pageParam: t
        }
      }
    });
  }
  createResult(t, n) {
    var r, s, f, m, p, v;
    const {
      state: y
    } = t, w = super.createResult(t, n), {
      isFetching: P,
      isRefetching: x
    } = w, A = P && ((r = y.fetchMeta) == null || (s = r.fetchMore) == null ? void 0 : s.direction) === "forward", M = P && ((f = y.fetchMeta) == null || (m = f.fetchMore) == null ? void 0 : m.direction) === "backward";
    return {
      ...w,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: rte(n, (p = y.data) == null ? void 0 : p.pages),
      hasPreviousPage: ate(n, (v = y.data) == null ? void 0 : v.pages),
      isFetchingNextPage: A,
      isFetchingPreviousPage: M,
      isRefetching: x && !A && !M
    };
  }
}
class lte extends tp {
  constructor(t, n) {
    super(), this.client = t, this.setOptions(n), this.bindMethods(), this.updateResult();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(t) {
    const n = this.options;
    this.options = this.client.defaultMutationOptions(t), X$(n, this.options) || this.client.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.currentMutation,
      observer: this
    });
  }
  onUnsubscribe() {
    if (!this.listeners.length) {
      var t;
      (t = this.currentMutation) == null || t.removeObserver(this);
    }
  }
  onMutationUpdate(t) {
    this.updateResult();
    const n = {
      listeners: !0
    };
    t.type === "success" ? n.onSuccess = !0 : t.type === "error" && (n.onError = !0), this.notify(n);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  reset() {
    this.currentMutation = void 0, this.updateResult(), this.notify({
      listeners: !0
    });
  }
  mutate(t, n) {
    return this.mutateOptions = n, this.currentMutation && this.currentMutation.removeObserver(this), this.currentMutation = this.client.getMutationCache().build(this.client, {
      ...this.options,
      variables: typeof t < "u" ? t : this.options.variables
    }), this.currentMutation.addObserver(this), this.currentMutation.execute();
  }
  updateResult() {
    const t = this.currentMutation ? this.currentMutation.state : G5(), n = {
      ...t,
      isLoading: t.status === "loading",
      isSuccess: t.status === "success",
      isError: t.status === "error",
      isIdle: t.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = n;
  }
  notify(t) {
    ua.batch(() => {
      if (this.mutateOptions) {
        if (t.onSuccess) {
          var n, r, s, f;
          (n = (r = this.mutateOptions).onSuccess) == null || n.call(r, this.currentResult.data, this.currentResult.variables, this.currentResult.context), (s = (f = this.mutateOptions).onSettled) == null || s.call(f, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (t.onError) {
          var m, p, v, y;
          (m = (p = this.mutateOptions).onError) == null || m.call(p, this.currentResult.error, this.currentResult.variables, this.currentResult.context), (v = (y = this.mutateOptions).onSettled) == null || v.call(y, void 0, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      }
      t.listeners && this.listeners.forEach((w) => {
        w(this.currentResult);
      });
    });
  }
}
var J5 = { exports: {} }, s$ = {};
var wO;
function ute() {
  if (wO)
    return s$;
  wO = 1;
  var e = F.exports;
  function t(P, x) {
    return P === x && (P !== 0 || 1 / P === 1 / x) || P !== P && x !== x;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, s = e.useEffect, f = e.useLayoutEffect, m = e.useDebugValue;
  function p(P, x) {
    var A = x(), M = r({ inst: { value: A, getSnapshot: x } }), O = M[0].inst, j = M[1];
    return f(function() {
      O.value = A, O.getSnapshot = x, v(O) && j({ inst: O });
    }, [P, A, x]), s(function() {
      return v(O) && j({ inst: O }), P(function() {
        v(O) && j({ inst: O });
      });
    }, [P]), m(A), A;
  }
  function v(P) {
    var x = P.getSnapshot;
    P = P.value;
    try {
      var A = x();
      return !n(P, A);
    } catch {
      return !0;
    }
  }
  function y(P, x) {
    return x();
  }
  var w = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? y : p;
  return s$.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : w, s$;
}
var l$ = {};
var PO;
function cte() {
  return PO || (PO = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = F.exports, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(V) {
      {
        for (var X = arguments.length, U = new Array(X > 1 ? X - 1 : 0), K = 1; K < X; K++)
          U[K - 1] = arguments[K];
        r("error", V, U);
      }
    }
    function r(V, X, U) {
      {
        var K = t.ReactDebugCurrentFrame, ce = K.getStackAddendum();
        ce !== "" && (X += "%s", U = U.concat([ce]));
        var ue = U.map(function(ye) {
          return String(ye);
        });
        ue.unshift("Warning: " + X), Function.prototype.apply.call(console[V], console, ue);
      }
    }
    function s(V, X) {
      return V === X && (V !== 0 || 1 / V === 1 / X) || V !== V && X !== X;
    }
    var f = typeof Object.is == "function" ? Object.is : s, m = e.useState, p = e.useEffect, v = e.useLayoutEffect, y = e.useDebugValue, w = !1, P = !1;
    function x(V, X, U) {
      w || e.startTransition !== void 0 && (w = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var K = X();
      if (!P) {
        var ce = X();
        f(K, ce) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), P = !0);
      }
      var ue = m({
        inst: {
          value: K,
          getSnapshot: X
        }
      }), ye = ue[0].inst, Oe = ue[1];
      return v(function() {
        ye.value = K, ye.getSnapshot = X, A(ye) && Oe({
          inst: ye
        });
      }, [V, K, X]), p(function() {
        A(ye) && Oe({
          inst: ye
        });
        var _e = function() {
          A(ye) && Oe({
            inst: ye
          });
        };
        return V(_e);
      }, [V]), y(K), K;
    }
    function A(V) {
      var X = V.getSnapshot, U = V.value;
      try {
        var K = X();
        return !f(U, K);
      } catch {
        return !0;
      }
    }
    function M(V, X, U) {
      return X();
    }
    var O = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", j = !O, H = j ? M : x, J = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : H;
    l$.useSyncExternalStore = J, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), l$;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = ute() : e.exports = cte();
})(J5);
const Z5 = J5.exports.useSyncExternalStore, kO = /* @__PURE__ */ F.exports.createContext(void 0), eW = /* @__PURE__ */ F.exports.createContext(!1);
function tW(e, t) {
  return e || (t && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = kO), window.ReactQueryClientContext) : kO);
}
const mm = ({
  context: e
} = {}) => {
  const t = F.exports.useContext(tW(e, F.exports.useContext(eW)));
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, dte = ({
  client: e,
  children: t,
  context: n,
  contextSharing: r = !1
}) => {
  F.exports.useEffect(() => (e.mount(), () => {
    e.unmount();
  }), [e]), process.env.NODE_ENV !== "production" && r && e.getLogger().error("The contextSharing option has been deprecated and will be removed in the next major version");
  const s = tW(n, r);
  return /* @__PURE__ */ F.exports.createElement(eW.Provider, {
    value: !n && r
  }, /* @__PURE__ */ F.exports.createElement(s.Provider, {
    value: e
  }, t));
}, nW = /* @__PURE__ */ F.exports.createContext(!1), fte = () => F.exports.useContext(nW);
nW.Provider;
function mte() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
const hte = /* @__PURE__ */ F.exports.createContext(mte()), pte = () => F.exports.useContext(hte);
function rW(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
const vte = (e, t) => {
  (e.suspense || e.useErrorBoundary) && (t.isReset() || (e.retryOnMount = !1));
}, gte = (e) => {
  F.exports.useEffect(() => {
    e.clearReset();
  }, [e]);
}, yte = ({
  result: e,
  errorResetBoundary: t,
  useErrorBoundary: n,
  query: r
}) => e.isError && !t.isReset() && !e.isFetching && rW(n, [e.error, r]), bte = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, wte = (e, t) => e.isLoading && e.isFetching && !t, Pte = (e, t, n) => (e == null ? void 0 : e.suspense) && wte(t, n), kte = (e, t, n) => t.fetchOptimistic(e).then(({
  data: r
}) => {
  e.onSuccess == null || e.onSuccess(r), e.onSettled == null || e.onSettled(r, null);
}).catch((r) => {
  n.clearReset(), e.onError == null || e.onError(r), e.onSettled == null || e.onSettled(void 0, r);
});
function aW(e, t) {
  const n = mm({
    context: e.context
  }), r = fte(), s = pte(), f = n.defaultQueryOptions(e);
  f._optimisticResults = r ? "isRestoring" : "optimistic", f.onError && (f.onError = ua.batchCalls(f.onError)), f.onSuccess && (f.onSuccess = ua.batchCalls(f.onSuccess)), f.onSettled && (f.onSettled = ua.batchCalls(f.onSettled)), bte(f), vte(f, s), gte(s);
  const [m] = F.exports.useState(() => new t(n, f)), p = m.getOptimisticResult(f);
  if (Z5(F.exports.useCallback((v) => r ? () => {
  } : m.subscribe(ua.batchCalls(v)), [m, r]), () => m.getCurrentResult(), () => m.getCurrentResult()), F.exports.useEffect(() => {
    m.setOptions(f, {
      listeners: !1
    });
  }, [f, m]), Pte(f, p, r))
    throw kte(f, m, s);
  if (yte({
    result: p,
    errorResetBoundary: s,
    useErrorBoundary: f.useErrorBoundary,
    query: m.getCurrentQuery()
  }))
    throw p.error;
  return f.notifyOnChangeProps ? p : m.trackResult(p);
}
function bg(e, t, n) {
  const r = Rh(e, t, n);
  return aW(r, K5);
}
function Uw(e, t, n) {
  const r = Xee(e, t, n), s = mm({
    context: r.context
  }), [f] = F.exports.useState(() => new lte(s, r));
  F.exports.useEffect(() => {
    f.setOptions(r);
  }, [f, r]);
  const m = Z5(F.exports.useCallback((v) => f.subscribe(ua.batchCalls(v)), [f]), () => f.getCurrentResult(), () => f.getCurrentResult()), p = F.exports.useCallback((v, y) => {
    f.mutate(v, y).catch($te);
  }, [f]);
  if (m.error && rW(f.options.useErrorBoundary, [m.error]))
    throw m.error;
  return {
    ...m,
    mutate: p,
    mutateAsync: m.mutate
  };
}
function $te() {
}
function Ste(e, t, n) {
  const r = Rh(e, t, n);
  return aW(r, ste);
}
var xte = {
  lessThanXSeconds: {
    one: "minder as 'n sekonde",
    other: "minder as {{count}} sekondes"
  },
  xSeconds: {
    one: "1 sekonde",
    other: "{{count}} sekondes"
  },
  halfAMinute: "'n halwe minuut",
  lessThanXMinutes: {
    one: "minder as 'n minuut",
    other: "minder as {{count}} minute"
  },
  xMinutes: {
    one: "'n minuut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} ure"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} ure"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dae"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weke"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weke"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maande"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maande"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer as 1 jaar",
    other: "meer as {{count}} jaar"
  },
  almostXYears: {
    one: "byna 1 jaar",
    other: "byna {{count}} jaar"
  }
}, Cte = function(e, t, n) {
  var r, s = xte[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "oor " + r : r + " gelede" : r;
};
const Mte = Cte;
function Q(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var Ete = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "yyyy/MM/dd"
}, Ate = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, _te = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ote = {
  date: Q({
    formats: Ete,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Ate,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: _te,
    defaultWidth: "full"
  })
};
const Tte = Ote;
var Rte = {
  lastWeek: "'verlede' eeee 'om' p",
  yesterday: "'gister om' p",
  today: "'vandag om' p",
  tomorrow: "'môre om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, Dte = function(e, t, n, r) {
  return Rte[e];
};
const Nte = Dte;
function R(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", s;
    if (r === "formatting" && e.formattingValues) {
      var f = e.defaultFormattingWidth || e.defaultWidth, m = n != null && n.width ? String(n.width) : f;
      s = e.formattingValues[m] || e.formattingValues[f];
    } else {
      var p = e.defaultWidth, v = n != null && n.width ? String(n.width) : e.defaultWidth;
      s = e.values[v] || e.values[p];
    }
    var y = e.argumentCallback ? e.argumentCallback(t) : t;
    return s[y];
  };
}
var Wte = {
  narrow: ["vC", "nC"],
  abbreviated: ["vC", "nC"],
  wide: ["voor Christus", "na Christus"]
}, jte = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1ste kwartaal", "2de kwartaal", "3de kwartaal", "4de kwartaal"]
}, zte = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
  wide: ["Januarie", "Februarie", "Maart", "April", "Mei", "Junie", "Julie", "Augustus", "September", "Oktober", "November", "Desember"]
}, Lte = {
  narrow: ["S", "M", "D", "W", "D", "V", "S"],
  short: ["So", "Ma", "Di", "Wo", "Do", "Vr", "Sa"],
  abbreviated: ["Son", "Maa", "Din", "Woe", "Don", "Vry", "Sat"],
  wide: ["Sondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrydag", "Saterdag"]
}, Ite = {
  narrow: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  },
  abbreviated: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  },
  wide: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  }
}, Fte = {
  narrow: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  },
  abbreviated: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  },
  wide: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  }
}, Hte = function(e) {
  var t = Number(e), n = t % 100;
  if (n < 20)
    switch (n) {
      case 1:
      case 8:
        return t + "ste";
      default:
        return t + "de";
    }
  return t + "ste";
}, Vte = {
  ordinalNumber: Hte,
  era: R({
    values: Wte,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: jte,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: zte,
    defaultWidth: "wide"
  }),
  day: R({
    values: Lte,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Ite,
    defaultWidth: "wide",
    formattingValues: Fte,
    defaultFormattingWidth: "wide"
  })
};
const Bte = Vte;
function D(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, s = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], f = t.match(s);
    if (!f)
      return null;
    var m = f[0], p = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], v = Array.isArray(p) ? Xte(p, function(P) {
      return P.test(m);
    }) : Ute(p, function(P) {
      return P.test(m);
    }), y;
    y = e.valueCallback ? e.valueCallback(v) : v, y = n.valueCallback ? n.valueCallback(y) : y;
    var w = t.slice(m.length);
    return {
      value: y,
      rest: w
    };
  };
}
function Ute(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function Xte(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function at(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var s = r[0], f = t.match(e.parsePattern);
    if (!f)
      return null;
    var m = e.valueCallback ? e.valueCallback(f[0]) : f[0];
    m = n.valueCallback ? n.valueCallback(m) : m;
    var p = t.slice(s.length);
    return {
      value: m,
      rest: p
    };
  };
}
var qte = /^(\d+)(ste|de)?/i, Yte = /\d+/i, Gte = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?C\.?)/,
  wide: /^((voor|na) Christus)/
}, Qte = {
  any: [/^v/, /^n/]
}, Kte = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](st|d)e kwartaal/i
}, Jte = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zte = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
  wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
}, ene = {
  narrow: [/^J/i, /^F/i, /^M/i, /^A/i, /^M/i, /^J/i, /^J/i, /^A/i, /^S/i, /^O/i, /^N/i, /^D/i],
  any: [/^Jan/i, /^Feb/i, /^Mrt/i, /^Apr/i, /^Mei/i, /^Jun/i, /^Jul/i, /^Aug/i, /^Sep/i, /^Okt/i, /^Nov/i, /^Dec/i]
}, tne = {
  narrow: /^[smdwv]/i,
  short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
  abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
  wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
}, nne = {
  narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
  any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i]
}, rne = {
  any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
}, ane = {
  any: {
    am: /^vm/i,
    pm: /^nm/i,
    midnight: /^middernag/i,
    noon: /^middaguur/i,
    morning: /oggend/i,
    afternoon: /middag/i,
    evening: /laat middag/i,
    night: /aand/i
  }
}, ine = {
  ordinalNumber: at({
    matchPattern: qte,
    parsePattern: Yte,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Gte,
    defaultMatchWidth: "wide",
    parsePatterns: Qte,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Kte,
    defaultMatchWidth: "wide",
    parsePatterns: Jte,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Zte,
    defaultMatchWidth: "wide",
    parsePatterns: ene,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: tne,
    defaultMatchWidth: "wide",
    parsePatterns: nne,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: rne,
    defaultMatchWidth: "any",
    parsePatterns: ane,
    defaultParseWidth: "any"
  })
};
const one = ine;
var sne = {
  code: "af",
  formatDistance: Mte,
  formatLong: Tte,
  formatRelative: Nte,
  localize: Bte,
  match: one,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const lne = sne;
var une = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من ثانيتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانيتان",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتان",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريبا",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتان",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومان",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريبا",
    two: "أسبوعين تقريبا",
    threeToTen: "{{count}} أسابيع تقريبا",
    other: "{{count}} أسبوعا تقريبا"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعان",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوعا"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريبا",
    threeToTen: "{{count}} أشهر تقريبا",
    other: "{{count}} شهرا تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهران",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهرا"
  },
  aboutXYears: {
    one: "سنة واحدة تقريباً",
    two: "سنتين تقريبا",
    threeToTen: "{{count}} سنوات تقريباً",
    other: "{{count}} سنة تقريباً"
  },
  xYears: {
    one: "سنة واحد",
    two: "سنتان",
    threeToTen: "{{count}} سنوات",
    other: "{{count}} سنة"
  },
  overXYears: {
    one: "أكثر من سنة",
    two: "أكثر من سنتين",
    threeToTen: "أكثر من {{count}} سنوات",
    other: "أكثر من {{count}} سنة"
  },
  almostXYears: {
    one: "ما يقارب سنة واحدة",
    two: "ما يقارب سنتين",
    threeToTen: "ما يقارب {{count}} سنوات",
    other: "ما يقارب {{count}} سنة"
  }
}, cne = function(e, t, n) {
  var r = une[e], s;
  return typeof r == "string" ? s = r : t === 1 ? s = r.one : t === 2 ? s = r.two : t <= 10 ? s = r.threeToTen.replace("{{count}}", String(t)) : s = r.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "خلال " + s : "منذ " + s : s;
};
const dne = cne;
var fne = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, mne = {
  full: "HH:mm:ss",
  long: "HH:mm:ss",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, hne = {
  full: "{{date}} 'عند الساعة' {{time}}",
  long: "{{date}} 'عند الساعة' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, pne = {
  date: Q({
    formats: fne,
    defaultWidth: "full"
  }),
  time: Q({
    formats: mne,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: hne,
    defaultWidth: "full"
  })
};
const vne = pne;
var gne = {
  lastWeek: "eeee 'الماضي عند الساعة' p",
  yesterday: "'الأمس عند الساعة' p",
  today: "'اليوم عند الساعة' p",
  tomorrow: "'غدا عند الساعة' p",
  nextWeek: "eeee 'القادم عند الساعة' p",
  other: "P"
}, yne = function(e) {
  return gne[e];
};
const bne = yne;
var wne = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, Pne = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, kne = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  wide: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
}, $ne = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  wide: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"]
}, Sne = {
  narrow: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  }
}, xne = {
  narrow: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  }
}, Cne = function(e) {
  return String(e);
}, Mne = {
  ordinalNumber: Cne,
  era: R({
    values: wne,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Pne,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: kne,
    defaultWidth: "wide"
  }),
  day: R({
    values: $ne,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Sne,
    defaultWidth: "wide",
    formattingValues: xne,
    defaultFormattingWidth: "wide"
  })
};
const Ene = Mne;
var Ane = /^(\d+)(th|st|nd|rd)?/i, _ne = /\d+/i, One = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/
}, Tne = {
  any: [/قبل/, /بعد/]
}, Rne = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
}, Dne = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nne = {
  narrow: /^[أيفمسند]/,
  abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
}, Wne = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^يناير/i, /^فبراير/i, /^مارس/i, /^أبريل/i, /^مايو/i, /^يونيو/i, /^يوليو/i, /^أغسطس/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
}, jne = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, zne = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, Lne = {
  narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
  any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
}, Ine = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /منتصف الليل/,
    noon: /الظهر/,
    afternoon: /بعد الظهر/,
    morning: /في الصباح/,
    evening: /في المساء/,
    night: /في الليل/
  }
}, Fne = {
  ordinalNumber: at({
    matchPattern: Ane,
    parsePattern: _ne,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: One,
    defaultMatchWidth: "wide",
    parsePatterns: Tne,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Rne,
    defaultMatchWidth: "wide",
    parsePatterns: Dne,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Nne,
    defaultMatchWidth: "wide",
    parsePatterns: Wne,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: jne,
    defaultMatchWidth: "wide",
    parsePatterns: zne,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Lne,
    defaultMatchWidth: "any",
    parsePatterns: Ine,
    defaultParseWidth: "any"
  })
};
const Hne = Fne;
var Vne = {
  code: "ar",
  formatDistance: dne,
  formatLong: vne,
  formatRelative: bne,
  localize: Ene,
  match: Hne,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
};
const Bne = Vne;
var Une = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, Xne = function(e, t, n) {
  n = n || {};
  var r = Une[e], s;
  return typeof r == "string" ? s = r : t === 1 ? s = r.one : t === 2 ? s = r.two : t <= 10 ? s = r.threeToTen.replace("{{count}}", String(t)) : s = r.other.replace("{{count}}", String(t)), n.addSuffix ? n.comparison && n.comparison > 0 ? "في خلال " + s : "منذ " + s : s;
};
const qne = Xne;
var Yne = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Gne = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Qne = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Kne = {
  date: Q({
    formats: Yne,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Gne,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Qne,
    defaultWidth: "full"
  })
};
const Jne = Kne;
var Zne = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, ere = function(e, t, n, r) {
  return Zne[e];
};
const tre = ere;
var nre = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, rre = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, are = {
  narrow: ["ج", "ف", "م", "أ", "م", "ج", "ج", "أ", "س", "أ", "ن", "د"],
  abbreviated: ["جانـ", "فيفـ", "مارس", "أفريل", "مايـ", "جوانـ", "جويـ", "أوت", "سبتـ", "أكتـ", "نوفـ", "ديسـ"],
  wide: ["جانفي", "فيفري", "مارس", "أفريل", "ماي", "جوان", "جويلية", "أوت", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
}, ire = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"]
}, ore = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, sre = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, lre = function(e) {
  return String(e);
}, ure = {
  ordinalNumber: lre,
  era: R({
    values: nre,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: rre,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return Number(e) - 1;
    }
  }),
  month: R({
    values: are,
    defaultWidth: "wide"
  }),
  day: R({
    values: ire,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: ore,
    defaultWidth: "wide",
    formattingValues: sre,
    defaultFormattingWidth: "wide"
  })
};
const cre = ure;
var dre = /^(\d+)(th|st|nd|rd)?/i, fre = /\d+/i, mre = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, hre = {
  any: [/^قبل/i, /^بعد/i]
}, pre = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, vre = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gre = {
  narrow: /^[جفمأسند]/i,
  abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
}, yre = {
  narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^جان/i, /^فيف/i, /^مار/i, /^أفر/i, /^ماي/i, /^جوا/i, /^جوي/i, /^أوت/i, /^سبت/i, /^أكت/i, /^نوف/i, /^ديس/i]
}, bre = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, wre = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, Pre = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, kre = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, $re = {
  ordinalNumber: at({
    matchPattern: dre,
    parsePattern: fre,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: mre,
    defaultMatchWidth: "wide",
    parsePatterns: hre,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: pre,
    defaultMatchWidth: "wide",
    parsePatterns: vre,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return Number(e) + 1;
    }
  }),
  month: D({
    matchPatterns: gre,
    defaultMatchWidth: "wide",
    parsePatterns: yre,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: bre,
    defaultMatchWidth: "wide",
    parsePatterns: wre,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Pre,
    defaultMatchWidth: "any",
    parsePatterns: kre,
    defaultParseWidth: "any"
  })
};
const Sre = $re;
var xre = {
  code: "ar-DZ",
  formatDistance: qne,
  formatLong: Jne,
  formatRelative: tre,
  localize: cre,
  match: Sre,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Cre = xre;
var Mre = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من ثانيتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية",
    two: "ثانيتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نص دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقايق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقايق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "حوالي ساعة",
    two: "حوالي ساعتين",
    threeToTen: "حوالي {{count}} ساعات",
    other: "حوالي {{count}} ساعة"
  },
  xHours: {
    one: "ساعة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "حوالي أسبوع",
    two: "حوالي أسبوعين",
    threeToTen: "حوالي {{count}} أسابيع",
    other: "حوالي {{count}} أسبوع"
  },
  xWeeks: {
    one: "أسبوع",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "حوالي شهر",
    two: "حوالي شهرين",
    threeToTen: "حوالي {{count}} أشهر",
    other: "حوالي {{count}} شهر"
  },
  xMonths: {
    one: "شهر",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "حوالي سنة",
    two: "حوالي سنتين",
    threeToTen: "حوالي {{count}} سنين",
    other: "حوالي {{count}} سنة"
  },
  xYears: {
    one: "عام",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من سنة",
    two: "أكثر من سنتين",
    threeToTen: "أكثر من {{count}} سنين",
    other: "أكثر من {{count}} سنة"
  },
  almostXYears: {
    one: "عام تقريبًا",
    two: "عامين تقريبًا",
    threeToTen: "{{count}} أعوام تقريبًا",
    other: "{{count}} عام تقريبًا"
  }
}, Ere = function(e, t, n) {
  var r, s = Mre[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : t === 2 ? r = s.two : t <= 10 ? r = s.threeToTen.replace("{{count}}", String(t)) : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "في خلال ".concat(r) : "منذ ".concat(r) : r;
};
const Are = Ere;
var _re = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "dd/MMM/y",
  short: "d/MM/y"
}, Ore = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Tre = {
  full: "{{date}} 'الساعة' {{time}}",
  long: "{{date}} 'الساعة' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Rre = {
  date: Q({
    formats: _re,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Ore,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Tre,
    defaultWidth: "full"
  })
};
const Dre = Rre;
var Nre = {
  lastWeek: "eeee 'اللي جاي الساعة' p",
  yesterday: "'إمبارح الساعة' p",
  today: "'النهاردة الساعة' p",
  tomorrow: "'بكرة الساعة' p",
  nextWeek: "eeee 'الساعة' p",
  other: "P"
}, Wre = function(e, t, n, r) {
  return Nre[e];
};
const jre = Wre;
var zre = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م", "ب.م"],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, Lre = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, Ire = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: ["ينا", "فبر", "مارس", "أبريل", "مايو", "يونـ", "يولـ", "أغسـ", "سبتـ", "أكتـ", "نوفـ", "ديسـ"],
  wide: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
}, Fre = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  wide: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"]
}, Hre = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً"
  }
}, Vre = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    morning: "في الصباح",
    noon: "ظهراً",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, Bre = function(e, t) {
  return String(e);
}, Ure = {
  ordinalNumber: Bre,
  era: R({
    values: zre,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Lre,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Ire,
    defaultWidth: "wide"
  }),
  day: R({
    values: Fre,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Hre,
    defaultWidth: "wide",
    formattingValues: Vre,
    defaultFormattingWidth: "wide"
  })
};
const Xre = Ure;
var qre = /^(\d+)/, Yre = /\d+/i, Gre = {
  narrow: /^(ق|ب)/g,
  abbreviated: /^(ق.م|ب.م)/g,
  wide: /^(قبل الميلاد|بعد الميلاد)/g
}, Qre = {
  any: [/^ق/g, /^ب/g]
}, Kre = {
  narrow: /^[1234]/,
  abbreviated: /^ر[1234]/,
  wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
}, Jre = {
  wide: [/الربع الأول/, /الربع الثاني/, /الربع الثالث/, /الربع الرابع/],
  any: [/1/, /2/, /3/, /4/]
}, Zre = {
  narrow: /^(ي|ف|م|أ|س|ن|د)/,
  abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
}, eae = {
  narrow: [/^ي/, /^ف/, /^م/, /^أ/, /^م/, /^ي/, /^ي/, /^أ/, /^س/, /^أ/, /^ن/, /^د/],
  any: [/^ينا/, /^فبر/, /^مارس/, /^أبريل/, /^مايو/, /^يون/, /^يول/, /^أغس/, /^سبت/, /^أكت/, /^نوف/, /^ديس/]
}, tae = {
  narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
}, nae = {
  narrow: [/^ح/, /^ن/, /^ث/, /^ر/, /^خ/, /^ج/, /^س/],
  any: [/أحد/, /اثنين/, /ثلاثاء/, /أربعاء/, /خميس/, /جمعة/, /سبت/]
}, rae = {
  narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
  abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
  wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
  any: /^(ص|م|صباح|ظهر|مساء|ليل)/
}, aae = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /^ن/,
    noon: /^ظ/,
    morning: /^ص/,
    afternoon: /^بعد/,
    evening: /^م/,
    night: /^ل/
  }
}, iae = {
  ordinalNumber: at({
    matchPattern: qre,
    parsePattern: Yre,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Gre,
    defaultMatchWidth: "wide",
    parsePatterns: Qre,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Kre,
    defaultMatchWidth: "wide",
    parsePatterns: Jre,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Zre,
    defaultMatchWidth: "wide",
    parsePatterns: eae,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: tae,
    defaultMatchWidth: "wide",
    parsePatterns: nae,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: rae,
    defaultMatchWidth: "any",
    parsePatterns: aae,
    defaultParseWidth: "any"
  })
};
const oae = iae;
var sae = {
  code: "ar-EG",
  formatDistance: Are,
  formatLong: Dre,
  formatRelative: jre,
  localize: Xre,
  match: oae,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const lae = sae;
var uae = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, cae = function(e, t, n) {
  n = n || {};
  var r = uae[e], s;
  return typeof r == "string" ? s = r : t === 1 ? s = r.one : t === 2 ? s = r.two : t <= 10 ? s = r.threeToTen.replace("{{count}}", String(t)) : s = r.other.replace("{{count}}", String(t)), n.addSuffix ? n.comparison && n.comparison > 0 ? "في خلال " + s : "منذ " + s : s;
};
const dae = cae;
var fae = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, mae = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, hae = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, pae = {
  date: Q({
    formats: fae,
    defaultWidth: "full"
  }),
  time: Q({
    formats: mae,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: hae,
    defaultWidth: "full"
  })
};
const vae = pae;
var gae = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, yae = function(e, t, n, r) {
  return gae[e];
};
const bae = yae;
var wae = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, Pae = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, kae = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "غ", "ش", "أ", "ن", "د"],
  abbreviated: ["ينا", "فبر", "مارس", "أبريل", "ماي", "يونـ", "يولـ", "غشت", "شتنـ", "أكتـ", "نونـ", "دجنـ"],
  wide: ["يناير", "فبراير", "مارس", "أبريل", "ماي", "يونيو", "يوليوز", "غشت", "شتنبر", "أكتوبر", "نونبر", "دجنبر"]
}, $ae = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: ["الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"]
}, Sae = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, xae = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, Cae = function(e) {
  return String(e);
}, Mae = {
  ordinalNumber: Cae,
  era: R({
    values: wae,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Pae,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return Number(e) - 1;
    }
  }),
  month: R({
    values: kae,
    defaultWidth: "wide"
  }),
  day: R({
    values: $ae,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Sae,
    defaultWidth: "wide",
    formattingValues: xae,
    defaultFormattingWidth: "wide"
  })
};
const Eae = Mae;
var Aae = /^(\d+)(th|st|nd|rd)?/i, _ae = /\d+/i, Oae = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, Tae = {
  any: [/^قبل/i, /^بعد/i]
}, Rae = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, Dae = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nae = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
}, Wae = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^غ/i, /^ش/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^ين/i, /^فب/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^غشت/i, /^ش/i, /^أك/i, /^ن/i, /^د/i]
}, jae = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, zae = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الإثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, Lae = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Iae = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Fae = {
  ordinalNumber: at({
    matchPattern: Aae,
    parsePattern: _ae,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Oae,
    defaultMatchWidth: "wide",
    parsePatterns: Tae,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Rae,
    defaultMatchWidth: "wide",
    parsePatterns: Dae,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return Number(e) + 1;
    }
  }),
  month: D({
    matchPatterns: Nae,
    defaultMatchWidth: "wide",
    parsePatterns: Wae,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: jae,
    defaultMatchWidth: "wide",
    parsePatterns: zae,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Lae,
    defaultMatchWidth: "any",
    parsePatterns: Iae,
    defaultParseWidth: "any"
  })
};
const Hae = Fae;
var Vae = {
  code: "ar-MA",
  formatDistance: dae,
  formatLong: vae,
  formatRelative: bae,
  localize: Eae,
  match: Hae,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Bae = Vae;
var Uae = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, Xae = function(e, t, n) {
  var r, s = Uae[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : t === 2 ? r = s.two : t <= 10 ? r = s.threeToTen.replace("{{count}}", String(t)) : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "في خلال " + r : "منذ " + r : r;
};
const qae = Xae;
var Yae = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Gae = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Qae = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Kae = {
  date: Q({
    formats: Yae,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Gae,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Qae,
    defaultWidth: "full"
  })
};
const Jae = Kae;
var Zae = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, eie = function(e, t, n, r) {
  return Zae[e];
};
const tie = eie;
var nie = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, rie = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, aie = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: ["ينا", "فبر", "مارس", "أبريل", "مايو", "يونـ", "يولـ", "أغسـ", "سبتـ", "أكتـ", "نوفـ", "ديسـ"],
  wide: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
}, iie = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"]
}, oie = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, sie = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, lie = function(e) {
  return String(e);
}, uie = {
  ordinalNumber: lie,
  era: R({
    values: nie,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: rie,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: aie,
    defaultWidth: "wide"
  }),
  day: R({
    values: iie,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: oie,
    defaultWidth: "wide",
    formattingValues: sie,
    defaultFormattingWidth: "wide"
  })
};
const cie = uie;
var die = /^(\d+)(th|st|nd|rd)?/i, fie = /\d+/i, mie = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, hie = {
  any: [/^قبل/i, /^بعد/i]
}, pie = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, vie = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gie = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
}, yie = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^ين/i, /^ف/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^أغ/i, /^س/i, /^أك/i, /^ن/i, /^د/i]
}, bie = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, wie = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, Pie = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, kie = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, $ie = {
  ordinalNumber: at({
    matchPattern: die,
    parsePattern: fie,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: mie,
    defaultMatchWidth: "wide",
    parsePatterns: hie,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: pie,
    defaultMatchWidth: "wide",
    parsePatterns: vie,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: gie,
    defaultMatchWidth: "wide",
    parsePatterns: yie,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: bie,
    defaultMatchWidth: "wide",
    parsePatterns: wie,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Pie,
    defaultMatchWidth: "any",
    parsePatterns: kie,
    defaultParseWidth: "any"
  })
};
const Sie = $ie;
var xie = {
  code: "ar-SA",
  formatDistance: qae,
  formatLong: Jae,
  formatRelative: tie,
  localize: cie,
  match: Sie,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Cie = xie;
var Mie = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من زوز ثواني",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية",
    two: "زوز ثواني",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نص دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقايق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقايق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة تقريب",
    two: "ساعتين تقريب",
    threeToTen: "{{count}} سوايع تقريب",
    other: "{{count}} ساعة تقريب"
  },
  xHours: {
    one: "ساعة",
    two: "ساعتين",
    threeToTen: "{{count}} سوايع",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "نهار",
    two: "نهارين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "جمعة تقريب",
    two: "جمعتين تقريب",
    threeToTen: "{{count}} جماع تقريب",
    other: "{{count}} جمعة تقريب"
  },
  xWeeks: {
    one: "جمعة",
    two: "جمعتين",
    threeToTen: "{{count}} جماع",
    other: "{{count}} جمعة"
  },
  aboutXMonths: {
    one: "شهر تقريب",
    two: "شهرين تقريب",
    threeToTen: "{{count}} أشهرة تقريب",
    other: "{{count}} شهر تقريب"
  },
  xMonths: {
    one: "شهر",
    two: "شهرين",
    threeToTen: "{{count}} أشهرة",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام تقريب",
    two: "عامين تقريب",
    threeToTen: "{{count}} أعوام تقريب",
    other: "{{count}} عام تقريب"
  },
  xYears: {
    one: "عام",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام تقريب",
    two: "عامين تقريب",
    threeToTen: "{{count}} أعوام تقريب",
    other: "{{count}} عام تقريب"
  }
}, Eie = function(e, t, n) {
  var r = Mie[e], s;
  return typeof r == "string" ? s = r : t === 1 ? s = r.one : t === 2 ? s = r.two : t <= 10 ? s = r.threeToTen.replace("{{count}}", String(t)) : s = r.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "في " + s : "عندو " + s : s;
};
const Aie = Eie;
var _ie = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, Oie = {
  full: "HH:mm:ss",
  long: "HH:mm:ss",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Tie = {
  full: "{{date}} 'مع' {{time}}",
  long: "{{date}} 'مع' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Rie = {
  date: Q({
    formats: _ie,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Oie,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Tie,
    defaultWidth: "full"
  })
};
const Die = Rie;
var Nie = {
  lastWeek: "eeee 'إلي فات مع' p",
  yesterday: "'البارح مع' p",
  today: "'اليوم مع' p",
  tomorrow: "'غدوة مع' p",
  nextWeek: "eeee 'الجمعة الجاية مع' p 'نهار'",
  other: "P"
}, Wie = function(e) {
  return Nie[e];
};
const jie = Wie;
var zie = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, Lie = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, Iie = {
  narrow: ["د", "ن", "أ", "س", "أ", "ج", "ج", "م", "أ", "م", "ف", "ج"],
  abbreviated: ["جانفي", "فيفري", "مارس", "أفريل", "ماي", "جوان", "جويلية", "أوت", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  wide: ["جانفي", "فيفري", "مارس", "أفريل", "ماي", "جوان", "جويلية", "أوت", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
}, Fie = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  wide: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"]
}, Hie = {
  narrow: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل"
  },
  wide: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل"
  }
}, Vie = {
  narrow: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل"
  },
  wide: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل"
  }
}, Bie = function(e) {
  return String(e);
}, Uie = {
  ordinalNumber: Bie,
  era: R({
    values: zie,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Lie,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Iie,
    defaultWidth: "wide"
  }),
  day: R({
    values: Fie,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Hie,
    defaultWidth: "wide",
    formattingValues: Vie,
    defaultFormattingWidth: "wide"
  })
};
const Xie = Uie;
var qie = /^(\d+)(th|st|nd|rd)?/i, Yie = /\d+/i, Gie = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/
}, Qie = {
  any: [/قبل/, /بعد/]
}, Kie = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
}, Jie = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zie = {
  narrow: /^[جفمأسند]/,
  abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
}, eoe = {
  narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^جانفي/i, /^فيفري/i, /^مارس/i, /^أفريل/i, /^ماي/i, /^جوان/i, /^جويلية/i, /^أوت/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
}, toe = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, noe = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, roe = {
  narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
  any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
}, aoe = {
  any: {
    am: /^ص/,
    pm: /^ع/,
    midnight: /نص الليل/,
    noon: /قايلة/,
    afternoon: /بعد القايلة/,
    morning: /صباح/,
    evening: /عشية/,
    night: /ليل/
  }
}, ioe = {
  ordinalNumber: at({
    matchPattern: qie,
    parsePattern: Yie,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Gie,
    defaultMatchWidth: "wide",
    parsePatterns: Qie,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Kie,
    defaultMatchWidth: "wide",
    parsePatterns: Jie,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Zie,
    defaultMatchWidth: "wide",
    parsePatterns: eoe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: toe,
    defaultMatchWidth: "wide",
    parsePatterns: noe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: roe,
    defaultMatchWidth: "any",
    parsePatterns: aoe,
    defaultParseWidth: "any"
  })
};
const ooe = ioe;
var soe = {
  code: "ar-TN",
  formatDistance: Aie,
  formatLong: Die,
  formatRelative: jie,
  localize: Xie,
  match: ooe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const loe = soe;
var uoe = {
  lessThanXSeconds: {
    one: "bir saniyədən az",
    other: "{{count}} bir saniyədən az"
  },
  xSeconds: {
    one: "1 saniyə",
    other: "{{count}} saniyə"
  },
  halfAMinute: "yarım dəqiqə",
  lessThanXMinutes: {
    one: "bir dəqiqədən az",
    other: "{{count}} bir dəqiqədən az"
  },
  xMinutes: {
    one: "bir dəqiqə",
    other: "{{count}} dəqiqə"
  },
  aboutXHours: {
    one: "təxminən 1 saat",
    other: "təxminən {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "təxminən 1 həftə",
    other: "təxminən {{count}} həftə"
  },
  xWeeks: {
    one: "1 həftə",
    other: "{{count}} həftə"
  },
  aboutXMonths: {
    one: "təxminən 1 ay",
    other: "təxminən {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "təxminən 1 il",
    other: "təxminən {{count}} il"
  },
  xYears: {
    one: "1 il",
    other: "{{count}} il"
  },
  overXYears: {
    one: "1 ildən çox",
    other: "{{count}} ildən çox"
  },
  almostXYears: {
    one: "demək olar ki 1 il",
    other: "demək olar ki {{count}} il"
  }
}, coe = function(e, t, n) {
  var r, s = uoe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " sonra" : r + " əvvəl" : r;
};
const doe = coe;
var foe = {
  full: "EEEE, do MMMM y 'il'",
  long: "do MMMM y 'il'",
  medium: "d MMM y 'il'",
  short: "dd.MM.yyyy"
}, moe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, hoe = {
  full: "{{date}} {{time}} - 'də'",
  long: "{{date}} {{time}} - 'də'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, poe = {
  date: Q({
    formats: foe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: moe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: hoe,
    defaultWidth: "full"
  })
};
const voe = poe;
var goe = {
  lastWeek: "'sonuncu' eeee p -'də'",
  yesterday: "'dünən' p -'də'",
  today: "'bugün' p -'də'",
  tomorrow: "'sabah' p -'də'",
  nextWeek: "eeee p -'də'",
  other: "P"
}, yoe = function(e, t, n, r) {
  return goe[e];
};
const boe = yoe;
var woe = {
  narrow: ["e.ə", "b.e"],
  abbreviated: ["e.ə", "b.e"],
  wide: ["eramızdan əvvəl", "bizim era"]
}, Poe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1ci kvartal", "2ci kvartal", "3cü kvartal", "4cü kvartal"]
}, koe = {
  narrow: ["Y", "F", "M", "A", "M", "İ", "İ", "A", "S", "O", "N", "D"],
  abbreviated: ["Yan", "Fev", "Mar", "Apr", "May", "İyun", "İyul", "Avq", "Sen", "Okt", "Noy", "Dek"],
  wide: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "İyun", "İyul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"]
}, $oe = {
  narrow: ["B.", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş."],
  short: ["B.", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş."],
  abbreviated: ["Baz", "Baz.e", "Çər.a", "Çər", "Cüm.a", "Cüm", "Şə"],
  wide: ["Bazar", "Bazar ertəsi", "Çərşənbə axşamı", "Çərşənbə", "Cümə axşamı", "Cümə", "Şənbə"]
}, Soe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  }
}, xoe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  }
}, Cv = {
  1: "-inci",
  5: "-inci",
  8: "-inci",
  70: "-inci",
  80: "-inci",
  2: "-nci",
  7: "-nci",
  20: "-nci",
  50: "-nci",
  3: "-üncü",
  4: "-üncü",
  100: "-üncü",
  6: "-ncı",
  9: "-uncu",
  10: "-uncu",
  30: "-uncu",
  60: "-ıncı",
  90: "-ıncı"
}, Coe = function(e) {
  if (e === 0)
    return e + "-ıncı";
  var t = e % 10, n = e % 100 - t, r = e >= 100 ? 100 : null;
  return Cv[t] ? Cv[t] : Cv[n] ? Cv[n] : r !== null ? Cv[r] : "";
}, Moe = function(e, t) {
  var n = Number(e), r = Coe(n);
  return n + r;
}, Eoe = {
  ordinalNumber: Moe,
  era: R({
    values: woe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Poe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: koe,
    defaultWidth: "wide"
  }),
  day: R({
    values: $oe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Soe,
    defaultWidth: "wide",
    formattingValues: xoe,
    defaultFormattingWidth: "wide"
  })
};
const Aoe = Eoe;
var _oe = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i, Ooe = /\d+/i, Toe = {
  narrow: /^(b|a)$/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
  wide: /^(bizim eradan əvvəl|bizim era)$/i
}, Roe = {
  any: [/^b$/i, /^(a|c)$/i]
}, Doe = {
  narrow: /^[1234]$/i,
  abbreviated: /^K[1234]$/i,
  wide: /^[1234](ci)? kvartal$/i
}, Noe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Woe = {
  narrow: /^[(?-i)yfmaisond]$/i,
  abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
  wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
}, joe = {
  narrow: [/^[(?-i)y]$/i, /^[(?-i)f]$/i, /^[(?-i)m]$/i, /^[(?-i)a]$/i, /^[(?-i)m]$/i, /^[(?-i)i]$/i, /^[(?-i)i]$/i, /^[(?-i)a]$/i, /^[(?-i)s]$/i, /^[(?-i)o]$/i, /^[(?-i)n]$/i, /^[(?-i)d]$/i],
  abbreviated: [/^Yan$/i, /^Fev$/i, /^Mar$/i, /^Apr$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avg$/i, /^Sen$/i, /^Okt$/i, /^Noy$/i, /^Dek$/i],
  wide: [/^Yanvar$/i, /^Fevral$/i, /^Mart$/i, /^Aprel$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avgust$/i, /^Sentyabr$/i, /^Oktyabr$/i, /^Noyabr$/i, /^Dekabr$/i]
}, zoe = {
  narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
  wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
}, Loe = {
  narrow: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i],
  abbreviated: [/^Baz$/i, /^Baz\.e$/i, /^Çər\.a$/i, /^Çər$/i, /^Cüm\.a$/i, /^Cüm$/i, /^Şə$/i],
  wide: [/^Bazar$/i, /^Bazar ertəsi$/i, /^Çərşənbə axşamı$/i, /^Çərşənbə$/i, /^Cümə axşamı$/i, /^Cümə$/i, /^Şənbə$/i],
  any: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i]
}, Ioe = {
  narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
  any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
}, Foe = {
  any: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /^gecəyarı$/i,
    noon: /^gün$/i,
    morning: /səhər$/i,
    afternoon: /gündüz$/i,
    evening: /axşam$/i,
    night: /gecə$/i
  }
}, Hoe = {
  ordinalNumber: at({
    matchPattern: _oe,
    parsePattern: Ooe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Toe,
    defaultMatchWidth: "wide",
    parsePatterns: Roe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Doe,
    defaultMatchWidth: "wide",
    parsePatterns: Noe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Woe,
    defaultMatchWidth: "wide",
    parsePatterns: joe,
    defaultParseWidth: "narrow"
  }),
  day: D({
    matchPatterns: zoe,
    defaultMatchWidth: "wide",
    parsePatterns: Loe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Ioe,
    defaultMatchWidth: "any",
    parsePatterns: Foe,
    defaultParseWidth: "any"
  })
};
const Voe = Hoe;
var Boe = {
  code: "az",
  formatDistance: doe,
  formatLong: voe,
  formatRelative: boe,
  localize: Aoe,
  match: Voe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Uoe = Boe;
function Mv(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  var n = t % 10, r = t % 100;
  return n === 1 && r !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function uo(e) {
  return function(t, n) {
    return n && n.addSuffix ? n.comparison && n.comparison > 0 ? e.future ? Mv(e.future, t) : "праз " + Mv(e.regular, t) : e.past ? Mv(e.past, t) : Mv(e.regular, t) + " таму" : Mv(e.regular, t);
  };
}
var Xoe = function(e, t) {
  return t && t.addSuffix ? t.comparison && t.comparison > 0 ? "праз паўхвіліны" : "паўхвіліны таму" : "паўхвіліны";
}, qoe = {
  lessThanXSeconds: uo({
    regular: {
      one: "менш за секунду",
      singularNominative: "менш за {{count}} секунду",
      singularGenitive: "менш за {{count}} секунды",
      pluralGenitive: "менш за {{count}} секунд"
    },
    future: {
      one: "менш, чым праз секунду",
      singularNominative: "менш, чым праз {{count}} секунду",
      singularGenitive: "менш, чым праз {{count}} секунды",
      pluralGenitive: "менш, чым праз {{count}} секунд"
    }
  }),
  xSeconds: uo({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду таму",
      singularGenitive: "{{count}} секунды таму",
      pluralGenitive: "{{count}} секунд таму"
    },
    future: {
      singularNominative: "праз {{count}} секунду",
      singularGenitive: "праз {{count}} секунды",
      pluralGenitive: "праз {{count}} секунд"
    }
  }),
  halfAMinute: Xoe,
  lessThanXMinutes: uo({
    regular: {
      one: "менш за хвіліну",
      singularNominative: "менш за {{count}} хвіліну",
      singularGenitive: "менш за {{count}} хвіліны",
      pluralGenitive: "менш за {{count}} хвілін"
    },
    future: {
      one: "менш, чым праз хвіліну",
      singularNominative: "менш, чым праз {{count}} хвіліну",
      singularGenitive: "менш, чым праз {{count}} хвіліны",
      pluralGenitive: "менш, чым праз {{count}} хвілін"
    }
  }),
  xMinutes: uo({
    regular: {
      singularNominative: "{{count}} хвіліна",
      singularGenitive: "{{count}} хвіліны",
      pluralGenitive: "{{count}} хвілін"
    },
    past: {
      singularNominative: "{{count}} хвіліну таму",
      singularGenitive: "{{count}} хвіліны таму",
      pluralGenitive: "{{count}} хвілін таму"
    },
    future: {
      singularNominative: "праз {{count}} хвіліну",
      singularGenitive: "праз {{count}} хвіліны",
      pluralGenitive: "праз {{count}} хвілін"
    }
  }),
  aboutXHours: uo({
    regular: {
      singularNominative: "каля {{count}} гадзіны",
      singularGenitive: "каля {{count}} гадзін",
      pluralGenitive: "каля {{count}} гадзін"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} гадзіну",
      singularGenitive: "прыблізна праз {{count}} гадзіны",
      pluralGenitive: "прыблізна праз {{count}} гадзін"
    }
  }),
  xHours: uo({
    regular: {
      singularNominative: "{{count}} гадзіна",
      singularGenitive: "{{count}} гадзіны",
      pluralGenitive: "{{count}} гадзін"
    },
    past: {
      singularNominative: "{{count}} гадзіну таму",
      singularGenitive: "{{count}} гадзіны таму",
      pluralGenitive: "{{count}} гадзін таму"
    },
    future: {
      singularNominative: "праз {{count}} гадзіну",
      singularGenitive: "праз {{count}} гадзіны",
      pluralGenitive: "праз {{count}} гадзін"
    }
  }),
  xDays: uo({
    regular: {
      singularNominative: "{{count}} дзень",
      singularGenitive: "{{count}} дні",
      pluralGenitive: "{{count}} дзён"
    }
  }),
  aboutXWeeks: uo({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў"
    }
  }),
  xWeeks: uo({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў"
    }
  }),
  aboutXMonths: uo({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў"
    }
  }),
  xMonths: uo({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў"
    }
  }),
  aboutXYears: uo({
    regular: {
      singularNominative: "каля {{count}} года",
      singularGenitive: "каля {{count}} гадоў",
      pluralGenitive: "каля {{count}} гадоў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} год",
      singularGenitive: "прыблізна праз {{count}} гады",
      pluralGenitive: "прыблізна праз {{count}} гадоў"
    }
  }),
  xYears: uo({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} гады",
      pluralGenitive: "{{count}} гадоў"
    }
  }),
  overXYears: uo({
    regular: {
      singularNominative: "больш за {{count}} год",
      singularGenitive: "больш за {{count}} гады",
      pluralGenitive: "больш за {{count}} гадоў"
    },
    future: {
      singularNominative: "больш, чым праз {{count}} год",
      singularGenitive: "больш, чым праз {{count}} гады",
      pluralGenitive: "больш, чым праз {{count}} гадоў"
    }
  }),
  almostXYears: uo({
    regular: {
      singularNominative: "амаль {{count}} год",
      singularGenitive: "амаль {{count}} гады",
      pluralGenitive: "амаль {{count}} гадоў"
    },
    future: {
      singularNominative: "амаль праз {{count}} год",
      singularGenitive: "амаль праз {{count}} гады",
      pluralGenitive: "амаль праз {{count}} гадоў"
    }
  })
}, Yoe = function(e, t, n) {
  return n = n || {}, qoe[e](t, n);
};
const Goe = Yoe;
var Qoe = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, Koe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Joe = {
  any: "{{date}}, {{time}}"
}, Zoe = {
  date: Q({
    formats: Qoe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Koe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Joe,
    defaultWidth: "any"
  })
};
const ese = Zoe;
function tse(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function fs(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Nr(e) {
  fs(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
}
var nse = {};
function iW() {
  return nse;
}
function $O(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Qb(e, t) {
  fs(2, arguments);
  var n = Nr(e), r = Nr(t), s = n.getTime() - r.getTime();
  return s < 0 ? -1 : s > 0 ? 1 : s;
}
function rse(e, t) {
  fs(2, arguments);
  var n = Nr(e), r = Nr(t), s = n.getFullYear() - r.getFullYear(), f = n.getMonth() - r.getMonth();
  return s * 12 + f;
}
function ase(e, t) {
  return fs(2, arguments), Nr(e).getTime() - Nr(t).getTime();
}
var SO = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
  }
}, ise = "trunc";
function ose(e) {
  return e ? SO[e] : SO[ise];
}
function sse(e) {
  fs(1, arguments);
  var t = Nr(e);
  return t.setHours(23, 59, 59, 999), t;
}
function lse(e) {
  fs(1, arguments);
  var t = Nr(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function use(e) {
  fs(1, arguments);
  var t = Nr(e);
  return sse(t).getTime() === lse(t).getTime();
}
function cse(e, t) {
  fs(2, arguments);
  var n = Nr(e), r = Nr(t), s = Qb(n, r), f = Math.abs(rse(n, r)), m;
  if (f < 1)
    m = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - s * f);
    var p = Qb(n, r) === -s;
    use(Nr(e)) && f === 1 && Qb(e, r) === 1 && (p = !1), m = s * (f - Number(p));
  }
  return m === 0 ? 0 : m;
}
function dse(e, t, n) {
  fs(2, arguments);
  var r = ase(e, t) / 1e3;
  return ose(n == null ? void 0 : n.roundingMethod)(r);
}
function xO(e, t) {
  var n, r, s, f, m, p, v, y;
  fs(1, arguments);
  var w = iW(), P = tse((n = (r = (s = (f = t == null ? void 0 : t.weekStartsOn) !== null && f !== void 0 ? f : t == null || (m = t.locale) === null || m === void 0 || (p = m.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && s !== void 0 ? s : w.weekStartsOn) !== null && r !== void 0 ? r : (v = w.locale) === null || v === void 0 || (y = v.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(P >= 0 && P <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var x = Nr(e), A = x.getUTCDay(), M = (A < P ? 7 : 0) + A - P;
  return x.setUTCDate(x.getUTCDate() - M), x.setUTCHours(0, 0, 0, 0), x;
}
var fse = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, mse = function(e, t, n) {
  var r, s = fse[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
const hm = mse;
var hse = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, pse = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, vse = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, gse = {
  date: Q({
    formats: hse,
    defaultWidth: "full"
  }),
  time: Q({
    formats: pse,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: vse,
    defaultWidth: "full"
  })
};
const yse = gse;
var bse = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, wse = function(e, t, n, r) {
  return bse[e];
};
const Ad = wse;
var Pse = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, kse = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, $se = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Sse = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, xse = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Cse = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Mse = function(e, t) {
  var n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Ese = {
  ordinalNumber: Mse,
  era: R({
    values: Pse,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: kse,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: $se,
    defaultWidth: "wide"
  }),
  day: R({
    values: Sse,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: xse,
    defaultWidth: "wide",
    formattingValues: Cse,
    defaultFormattingWidth: "wide"
  })
};
const _d = Ese;
var Ase = /^(\d+)(th|st|nd|rd)?/i, _se = /\d+/i, Ose = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Tse = {
  any: [/^b/i, /^(a|c)/i]
}, Rse = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Dse = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nse = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Wse = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, jse = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, zse = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Lse = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ise = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Fse = {
  ordinalNumber: at({
    matchPattern: Ase,
    parsePattern: _se,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Ose,
    defaultMatchWidth: "wide",
    parsePatterns: Tse,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Rse,
    defaultMatchWidth: "wide",
    parsePatterns: Dse,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Nse,
    defaultMatchWidth: "wide",
    parsePatterns: Wse,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: jse,
    defaultMatchWidth: "wide",
    parsePatterns: zse,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Lse,
    defaultMatchWidth: "any",
    parsePatterns: Ise,
    defaultParseWidth: "any"
  })
};
const Od = Fse;
var Hse = {
  code: "en-US",
  formatDistance: hm,
  formatLong: yse,
  formatRelative: Ad,
  localize: _d,
  match: Od,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const lx = Hse;
function oW(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function Vse(e) {
  return oW({}, e);
}
var CO = 1440, Bse = 2520, u$ = 43200, Use = 86400;
function Xse(e, t, n) {
  var r, s;
  fs(2, arguments);
  var f = iW(), m = (r = (s = n == null ? void 0 : n.locale) !== null && s !== void 0 ? s : f.locale) !== null && r !== void 0 ? r : lx;
  if (!m.formatDistance)
    throw new RangeError("locale must contain formatDistance property");
  var p = Qb(e, t);
  if (isNaN(p))
    throw new RangeError("Invalid time value");
  var v = oW(Vse(n), {
    addSuffix: Boolean(n == null ? void 0 : n.addSuffix),
    comparison: p
  }), y, w;
  p > 0 ? (y = Nr(t), w = Nr(e)) : (y = Nr(e), w = Nr(t));
  var P = dse(w, y), x = ($O(w) - $O(y)) / 1e3, A = Math.round((P - x) / 60), M;
  if (A < 2)
    return n != null && n.includeSeconds ? P < 5 ? m.formatDistance("lessThanXSeconds", 5, v) : P < 10 ? m.formatDistance("lessThanXSeconds", 10, v) : P < 20 ? m.formatDistance("lessThanXSeconds", 20, v) : P < 40 ? m.formatDistance("halfAMinute", 0, v) : P < 60 ? m.formatDistance("lessThanXMinutes", 1, v) : m.formatDistance("xMinutes", 1, v) : A === 0 ? m.formatDistance("lessThanXMinutes", 1, v) : m.formatDistance("xMinutes", A, v);
  if (A < 45)
    return m.formatDistance("xMinutes", A, v);
  if (A < 90)
    return m.formatDistance("aboutXHours", 1, v);
  if (A < CO) {
    var O = Math.round(A / 60);
    return m.formatDistance("aboutXHours", O, v);
  } else {
    if (A < Bse)
      return m.formatDistance("xDays", 1, v);
    if (A < u$) {
      var j = Math.round(A / CO);
      return m.formatDistance("xDays", j, v);
    } else if (A < Use)
      return M = Math.round(A / u$), m.formatDistance("aboutXMonths", M, v);
  }
  if (M = cse(w, y), M < 12) {
    var H = Math.round(A / u$);
    return m.formatDistance("xMonths", H, v);
  } else {
    var J = M % 12, V = Math.floor(M / 12);
    return J < 3 ? m.formatDistance("aboutXYears", V, v) : J < 9 ? m.formatDistance("overXYears", V, v) : m.formatDistance("almostXYears", V + 1, v);
  }
}
function qse(e, t) {
  return fs(1, arguments), Xse(e, Date.now(), t);
}
function ca(e, t, n) {
  fs(2, arguments);
  var r = xO(e, n), s = xO(t, n);
  return r.getTime() === s.getTime();
}
var ux = ["нядзелю", "панядзелак", "аўторак", "сераду", "чацвер", "пятніцу", "суботу"];
function Yse(e) {
  var t = ux[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у мінулую " + t + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у мінулы " + t + " а' p";
  }
}
function sW(e) {
  var t = ux[e];
  return "'у " + t + " а' p";
}
function Gse(e) {
  var t = ux[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступную " + t + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у наступны " + t + " а' p";
  }
}
var Qse = function(e, t, n) {
  var r = Nr(e), s = r.getUTCDay();
  return ca(r, t, n) ? sW(s) : Yse(s);
}, Kse = function(e, t, n) {
  var r = Nr(e), s = r.getUTCDay();
  return ca(r, t, n) ? sW(s) : Gse(s);
}, Jse = {
  lastWeek: Qse,
  yesterday: "'учора а' p",
  today: "'сёння а' p",
  tomorrow: "'заўтра а' p",
  nextWeek: Kse,
  other: "P"
}, Zse = function(e, t, n, r) {
  var s = Jse[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const ele = Zse;
var tle = {
  narrow: ["да н.э.", "н.э."],
  abbreviated: ["да н. э.", "н. э."],
  wide: ["да нашай эры", "нашай эры"]
}, nle = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ы кв.", "2-і кв.", "3-і кв.", "4-ы кв."],
  wide: ["1-ы квартал", "2-і квартал", "3-і квартал", "4-ы квартал"]
}, rle = {
  narrow: ["С", "Л", "С", "К", "М", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: ["студз.", "лют.", "сак.", "крас.", "май", "чэрв.", "ліп.", "жн.", "вер.", "кастр.", "ліст.", "снеж."],
  wide: ["студзень", "люты", "сакавік", "красавік", "май", "чэрвень", "ліпень", "жнівень", "верасень", "кастрычнік", "лістапад", "снежань"]
}, ale = {
  narrow: ["С", "Л", "С", "К", "М", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: ["студз.", "лют.", "сак.", "крас.", "мая", "чэрв.", "ліп.", "жн.", "вер.", "кастр.", "ліст.", "снеж."],
  wide: ["студзеня", "лютага", "сакавіка", "красавіка", "мая", "чэрвеня", "ліпеня", "жніўня", "верасня", "кастрычніка", "лістапада", "снежня"]
}, ile = {
  narrow: ["Н", "П", "А", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "аў", "ср", "чц", "пт", "сб"],
  abbreviated: ["нядз", "пан", "аўт", "сер", "чац", "пят", "суб"],
  wide: ["нядзеля", "панядзелак", "аўторак", "серада", "чацвер", "пятніца", "субота"]
}, ole = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніца",
    afternoon: "дзень",
    evening: "вечар",
    night: "ноч"
  }
}, sle = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніцы",
    afternoon: "дня",
    evening: "вечара",
    night: "ночы"
  }
}, lle = function(e, t) {
  var n = String(t == null ? void 0 : t.unit), r = Number(e), s;
  return n === "date" ? s = "-га" : n === "hour" || n === "minute" || n === "second" ? s = "-я" : s = (r % 10 === 2 || r % 10 === 3) && r % 100 !== 12 && r % 100 !== 13 ? "-і" : "-ы", r + s;
}, ule = {
  ordinalNumber: lle,
  era: R({
    values: tle,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: nle,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: rle,
    defaultWidth: "wide",
    formattingValues: ale,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: ile,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: ole,
    defaultWidth: "any",
    formattingValues: sle,
    defaultFormattingWidth: "wide"
  })
};
const cle = ule;
var dle = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i, fle = /\d+/i, mle = {
  narrow: /^((да )?н\.?\s?э\.?)/i,
  abbreviated: /^((да )?н\.?\s?э\.?)/i,
  wide: /^(да нашай эры|нашай эры|наша эра)/i
}, hle = {
  any: [/^д/i, /^н/i]
}, ple = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
  wide: /^[1234](-?[ыі]?)? квартал/i
}, vle = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gle = {
  narrow: /^[слкмчжв]/i,
  abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
}, yle = {
  narrow: [/^с/i, /^л/i, /^с/i, /^к/i, /^м/i, /^ч/i, /^л/i, /^ж/i, /^в/i, /^к/i, /^л/i, /^с/i],
  any: [/^ст/i, /^лю/i, /^са/i, /^кр/i, /^ма/i, /^ч/i, /^ліп/i, /^ж/i, /^в/i, /^ка/i, /^ліс/i, /^сн/i]
}, ble = {
  narrow: /^[нпасч]/i,
  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
}, wle = {
  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, Ple = {
  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
}, kle = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^поўн/i,
    noon: /^поўд/i,
    morning: /^р/i,
    afternoon: /^д[зн]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, $le = {
  ordinalNumber: at({
    matchPattern: dle,
    parsePattern: fle,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: mle,
    defaultMatchWidth: "wide",
    parsePatterns: hle,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: ple,
    defaultMatchWidth: "wide",
    parsePatterns: vle,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: gle,
    defaultMatchWidth: "wide",
    parsePatterns: yle,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: ble,
    defaultMatchWidth: "wide",
    parsePatterns: wle,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Ple,
    defaultMatchWidth: "wide",
    parsePatterns: kle,
    defaultParseWidth: "any"
  })
};
const Sle = $le;
var xle = {
  code: "be",
  formatDistance: Goe,
  formatLong: ese,
  formatRelative: ele,
  localize: cle,
  match: Sle,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Cle = xle;
function Ev(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  var n = t % 10, r = t % 100;
  return n === 1 && r !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function co(e) {
  return function(t, n) {
    return n && n.addSuffix ? n.comparison && n.comparison > 0 ? e.future ? Ev(e.future, t) : "праз " + Ev(e.regular, t) : e.past ? Ev(e.past, t) : Ev(e.regular, t) + " таму" : Ev(e.regular, t);
  };
}
var Mle = function(e, t) {
  return t && t.addSuffix ? t.comparison && t.comparison > 0 ? "праз паўхвіліны" : "паўхвіліны таму" : "паўхвіліны";
}, Ele = {
  lessThanXSeconds: co({
    regular: {
      one: "менш за секунду",
      singularNominative: "менш за {{count}} секунду",
      singularGenitive: "менш за {{count}} секунды",
      pluralGenitive: "менш за {{count}} секунд"
    },
    future: {
      one: "менш, чым праз секунду",
      singularNominative: "менш, чым праз {{count}} секунду",
      singularGenitive: "менш, чым праз {{count}} секунды",
      pluralGenitive: "менш, чым праз {{count}} секунд"
    }
  }),
  xSeconds: co({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду таму",
      singularGenitive: "{{count}} секунды таму",
      pluralGenitive: "{{count}} секунд таму"
    },
    future: {
      singularNominative: "праз {{count}} секунду",
      singularGenitive: "праз {{count}} секунды",
      pluralGenitive: "праз {{count}} секунд"
    }
  }),
  halfAMinute: Mle,
  lessThanXMinutes: co({
    regular: {
      one: "менш за хвіліну",
      singularNominative: "менш за {{count}} хвіліну",
      singularGenitive: "менш за {{count}} хвіліны",
      pluralGenitive: "менш за {{count}} хвілін"
    },
    future: {
      one: "менш, чым праз хвіліну",
      singularNominative: "менш, чым праз {{count}} хвіліну",
      singularGenitive: "менш, чым праз {{count}} хвіліны",
      pluralGenitive: "менш, чым праз {{count}} хвілін"
    }
  }),
  xMinutes: co({
    regular: {
      singularNominative: "{{count}} хвіліна",
      singularGenitive: "{{count}} хвіліны",
      pluralGenitive: "{{count}} хвілін"
    },
    past: {
      singularNominative: "{{count}} хвіліну таму",
      singularGenitive: "{{count}} хвіліны таму",
      pluralGenitive: "{{count}} хвілін таму"
    },
    future: {
      singularNominative: "праз {{count}} хвіліну",
      singularGenitive: "праз {{count}} хвіліны",
      pluralGenitive: "праз {{count}} хвілін"
    }
  }),
  aboutXHours: co({
    regular: {
      singularNominative: "каля {{count}} гадзіны",
      singularGenitive: "каля {{count}} гадзін",
      pluralGenitive: "каля {{count}} гадзін"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} гадзіну",
      singularGenitive: "прыблізна праз {{count}} гадзіны",
      pluralGenitive: "прыблізна праз {{count}} гадзін"
    }
  }),
  xHours: co({
    regular: {
      singularNominative: "{{count}} гадзіна",
      singularGenitive: "{{count}} гадзіны",
      pluralGenitive: "{{count}} гадзін"
    },
    past: {
      singularNominative: "{{count}} гадзіну таму",
      singularGenitive: "{{count}} гадзіны таму",
      pluralGenitive: "{{count}} гадзін таму"
    },
    future: {
      singularNominative: "праз {{count}} гадзіну",
      singularGenitive: "праз {{count}} гадзіны",
      pluralGenitive: "праз {{count}} гадзін"
    }
  }),
  xDays: co({
    regular: {
      singularNominative: "{{count}} дзень",
      singularGenitive: "{{count}} дні",
      pluralGenitive: "{{count}} дзён"
    }
  }),
  aboutXWeeks: co({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў"
    }
  }),
  xWeeks: co({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў"
    }
  }),
  aboutXMonths: co({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў"
    }
  }),
  xMonths: co({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў"
    }
  }),
  aboutXYears: co({
    regular: {
      singularNominative: "каля {{count}} года",
      singularGenitive: "каля {{count}} гадоў",
      pluralGenitive: "каля {{count}} гадоў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} год",
      singularGenitive: "прыблізна праз {{count}} гады",
      pluralGenitive: "прыблізна праз {{count}} гадоў"
    }
  }),
  xYears: co({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} гады",
      pluralGenitive: "{{count}} гадоў"
    }
  }),
  overXYears: co({
    regular: {
      singularNominative: "больш за {{count}} год",
      singularGenitive: "больш за {{count}} гады",
      pluralGenitive: "больш за {{count}} гадоў"
    },
    future: {
      singularNominative: "больш, чым праз {{count}} год",
      singularGenitive: "больш, чым праз {{count}} гады",
      pluralGenitive: "больш, чым праз {{count}} гадоў"
    }
  }),
  almostXYears: co({
    regular: {
      singularNominative: "амаль {{count}} год",
      singularGenitive: "амаль {{count}} гады",
      pluralGenitive: "амаль {{count}} гадоў"
    },
    future: {
      singularNominative: "амаль праз {{count}} год",
      singularGenitive: "амаль праз {{count}} гады",
      pluralGenitive: "амаль праз {{count}} гадоў"
    }
  })
}, Ale = function(e, t, n) {
  return n = n || {}, Ele[e](t, n);
};
const _le = Ale;
var Ole = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, Tle = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Rle = {
  any: "{{date}}, {{time}}"
}, Dle = {
  date: Q({
    formats: Ole,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Tle,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Rle,
    defaultWidth: "any"
  })
};
const Nle = Dle;
var cx = ["нядзелю", "панядзелак", "аўторак", "сераду", "чацьвер", "пятніцу", "суботу"];
function Wle(e) {
  var t = cx[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у мінулую " + t + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у мінулы " + t + " а' p";
  }
}
function lW(e) {
  var t = cx[e];
  return "'у " + t + " а' p";
}
function jle(e) {
  var t = cx[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступную " + t + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у наступны " + t + " а' p";
  }
}
var zle = function(e, t, n) {
  var r = Nr(e), s = r.getUTCDay();
  return ca(r, t, n) ? lW(s) : Wle(s);
}, Lle = function(e, t, n) {
  var r = Nr(e), s = r.getUTCDay();
  return ca(r, t, n) ? lW(s) : jle(s);
}, Ile = {
  lastWeek: zle,
  yesterday: "'учора а' p",
  today: "'сёньня а' p",
  tomorrow: "'заўтра а' p",
  nextWeek: Lle,
  other: "P"
}, Fle = function(e, t, n, r) {
  var s = Ile[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const Hle = Fle;
var Vle = {
  narrow: ["да н.э.", "н.э."],
  abbreviated: ["да н. э.", "н. э."],
  wide: ["да нашай эры", "нашай эры"]
}, Ble = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ы кв.", "2-і кв.", "3-і кв.", "4-ы кв."],
  wide: ["1-ы квартал", "2-і квартал", "3-і квартал", "4-ы квартал"]
}, Ule = {
  narrow: ["С", "Л", "С", "К", "Т", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: ["студз.", "лют.", "сак.", "крас.", "трав.", "чэрв.", "ліп.", "жн.", "вер.", "кастр.", "ліст.", "сьнеж."],
  wide: ["студзень", "люты", "сакавік", "красавік", "травень", "чэрвень", "ліпень", "жнівень", "верасень", "кастрычнік", "лістапад", "сьнежань"]
}, Xle = {
  narrow: ["С", "Л", "С", "К", "Т", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: ["студз.", "лют.", "сак.", "крас.", "трав.", "чэрв.", "ліп.", "жн.", "вер.", "кастр.", "ліст.", "сьнеж."],
  wide: ["студзеня", "лютага", "сакавіка", "красавіка", "траўня", "чэрвеня", "ліпеня", "жніўня", "верасня", "кастрычніка", "лістапада", "сьнежня"]
}, qle = {
  narrow: ["Н", "П", "А", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "аў", "ср", "чц", "пт", "сб"],
  abbreviated: ["нядз", "пан", "аўт", "сер", "чац", "пят", "суб"],
  wide: ["нядзеля", "панядзелак", "аўторак", "серада", "чацьвер", "пятніца", "субота"]
}, Yle = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніца",
    afternoon: "дзень",
    evening: "вечар",
    night: "ноч"
  }
}, Gle = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніцы",
    afternoon: "дня",
    evening: "вечара",
    night: "ночы"
  }
}, Qle = function(e, t) {
  var n = String(t == null ? void 0 : t.unit), r = Number(e), s;
  return n === "date" ? s = "-га" : n === "hour" || n === "minute" || n === "second" ? s = "-я" : s = (r % 10 === 2 || r % 10 === 3) && r % 100 !== 12 && r % 100 !== 13 ? "-і" : "-ы", r + s;
}, Kle = {
  ordinalNumber: Qle,
  era: R({
    values: Vle,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Ble,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Ule,
    defaultWidth: "wide",
    formattingValues: Xle,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: qle,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Yle,
    defaultWidth: "any",
    formattingValues: Gle,
    defaultFormattingWidth: "wide"
  })
};
const Jle = Kle;
var Zle = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i, eue = /\d+/i, tue = {
  narrow: /^((да )?н\.?\s?э\.?)/i,
  abbreviated: /^((да )?н\.?\s?э\.?)/i,
  wide: /^(да нашай эры|нашай эры|наша эра)/i
}, nue = {
  any: [/^д/i, /^н/i]
}, rue = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
  wide: /^[1234](-?[ыі]?)? квартал/i
}, aue = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, iue = {
  narrow: /^[слкмчжв]/i,
  abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
}, oue = {
  narrow: [/^с/i, /^л/i, /^с/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^ж/i, /^в/i, /^к/i, /^л/i, /^с/i],
  any: [/^ст/i, /^лю/i, /^са/i, /^кр/i, /^тр/i, /^ч/i, /^ліп/i, /^ж/i, /^в/i, /^ка/i, /^ліс/i, /^сн/i]
}, sue = {
  narrow: /^[нпасч]/i,
  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чац|птн|пят|суб).?/i,
  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
}, lue = {
  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, uue = {
  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
}, cue = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^поўн/i,
    noon: /^поўд/i,
    morning: /^р/i,
    afternoon: /^д[зн]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, due = {
  ordinalNumber: at({
    matchPattern: Zle,
    parsePattern: eue,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: tue,
    defaultMatchWidth: "wide",
    parsePatterns: nue,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: rue,
    defaultMatchWidth: "wide",
    parsePatterns: aue,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: iue,
    defaultMatchWidth: "wide",
    parsePatterns: oue,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: sue,
    defaultMatchWidth: "wide",
    parsePatterns: lue,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: uue,
    defaultMatchWidth: "wide",
    parsePatterns: cue,
    defaultParseWidth: "any"
  })
};
const fue = due;
var mue = {
  code: "be-tarask",
  formatDistance: _le,
  formatLong: Nle,
  formatRelative: Hle,
  localize: Jle,
  match: fue,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const hue = mue;
var pue = {
  lessThanXSeconds: {
    one: "по-малко от секунда",
    other: "по-малко от {{count}} секунди"
  },
  xSeconds: {
    one: "1 секунда",
    other: "{{count}} секунди"
  },
  halfAMinute: "половин минута",
  lessThanXMinutes: {
    one: "по-малко от минута",
    other: "по-малко от {{count}} минути"
  },
  xMinutes: {
    one: "1 минута",
    other: "{{count}} минути"
  },
  aboutXHours: {
    one: "около час",
    other: "около {{count}} часа"
  },
  xHours: {
    one: "1 час",
    other: "{{count}} часа"
  },
  xDays: {
    one: "1 ден",
    other: "{{count}} дни"
  },
  aboutXWeeks: {
    one: "около седмица",
    other: "около {{count}} седмици"
  },
  xWeeks: {
    one: "1 седмица",
    other: "{{count}} седмици"
  },
  aboutXMonths: {
    one: "около месец",
    other: "около {{count}} месеца"
  },
  xMonths: {
    one: "1 месец",
    other: "{{count}} месеца"
  },
  aboutXYears: {
    one: "около година",
    other: "около {{count}} години"
  },
  xYears: {
    one: "1 година",
    other: "{{count}} години"
  },
  overXYears: {
    one: "над година",
    other: "над {{count}} години"
  },
  almostXYears: {
    one: "почти година",
    other: "почти {{count}} години"
  }
}, vue = function(e, t, n) {
  var r, s = pue[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "след " + r : "преди " + r : r;
};
const gue = vue;
var yue = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy"
}, bue = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
}, wue = {
  any: "{{date}} {{time}}"
}, Pue = {
  date: Q({
    formats: yue,
    defaultWidth: "full"
  }),
  time: Q({
    formats: bue,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: wue,
    defaultWidth: "any"
  })
};
const kue = Pue;
var dx = ["неделя", "понеделник", "вторник", "сряда", "четвъртък", "петък", "събота"];
function $ue(e) {
  var t = dx[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'миналата " + t + " в' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'миналия " + t + " в' p";
  }
}
function uW(e) {
  var t = dx[e];
  return e === 2 ? "'във " + t + " в' p" : "'в " + t + " в' p";
}
function Sue(e) {
  var t = dx[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'следващата " + t + " в' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'следващия " + t + " в' p";
  }
}
var xue = function(e, t, n) {
  var r = Nr(e), s = r.getUTCDay();
  return ca(r, t, n) ? uW(s) : $ue(s);
}, Cue = function(e, t, n) {
  var r = Nr(e), s = r.getUTCDay();
  return ca(r, t, n) ? uW(s) : Sue(s);
}, Mue = {
  lastWeek: xue,
  yesterday: "'вчера в' p",
  today: "'днес в' p",
  tomorrow: "'утре в' p",
  nextWeek: Cue,
  other: "P"
}, Eue = function(e, t, n, r) {
  var s = Mue[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const Aue = Eue;
var _ue = {
  narrow: ["пр.н.е.", "н.е."],
  abbreviated: ["преди н. е.", "н. е."],
  wide: ["преди новата ера", "новата ера"]
}, Oue = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-во тримес.", "2-ро тримес.", "3-то тримес.", "4-то тримес."],
  wide: ["1-во тримесечие", "2-ро тримесечие", "3-то тримесечие", "4-то тримесечие"]
}, Tue = {
  abbreviated: ["яну", "фев", "мар", "апр", "май", "юни", "юли", "авг", "сеп", "окт", "ное", "дек"],
  wide: ["януари", "февруари", "март", "април", "май", "юни", "юли", "август", "септември", "октомври", "ноември", "декември"]
}, Rue = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вто", "сря", "чет", "пет", "съб"],
  wide: ["неделя", "понеделник", "вторник", "сряда", "четвъртък", "петък", "събота"]
}, Due = {
  wide: {
    am: "преди обяд",
    pm: "след обяд",
    midnight: "в полунощ",
    noon: "на обяд",
    morning: "сутринта",
    afternoon: "следобед",
    evening: "вечерта",
    night: "през нощта"
  }
};
function Nue(e) {
  return e === "year" || e === "week" || e === "minute" || e === "second";
}
function Wue(e) {
  return e === "quarter";
}
function Jf(e, t, n, r, s) {
  var f = Wue(t) ? s : Nue(t) ? r : n;
  return e + "-" + f;
}
var jue = function(e, t) {
  var n = Number(e), r = t == null ? void 0 : t.unit;
  if (n === 0)
    return Jf(0, r, "ев", "ева", "ево");
  if (n % 1e3 === 0)
    return Jf(n, r, "ен", "на", "но");
  if (n % 100 === 0)
    return Jf(n, r, "тен", "тна", "тно");
  var s = n % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return Jf(n, r, "ви", "ва", "во");
      case 2:
        return Jf(n, r, "ри", "ра", "ро");
      case 7:
      case 8:
        return Jf(n, r, "ми", "ма", "мо");
    }
  return Jf(n, r, "ти", "та", "то");
}, zue = {
  ordinalNumber: jue,
  era: R({
    values: _ue,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Oue,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Tue,
    defaultWidth: "wide"
  }),
  day: R({
    values: Rue,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Due,
    defaultWidth: "wide"
  })
};
const Lue = zue;
var Iue = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i, Fue = /\d+/i, Hue = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(преди новата ера|новата ера|нова ера)/i
}, Vue = {
  any: [/^п/i, /^н/i]
}, Bue = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
  wide: /^[1234](-?[врт]?о?)? тримесечие/i
}, Uue = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Xue = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
}, que = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
}, Yue = {
  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
}, Gue = {
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
}, Que = {
  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
}, Kue = {
  any: {
    am: /^преди о/i,
    pm: /^след о/i,
    midnight: /^в пол/i,
    noon: /^на об/i,
    morning: /^сут/i,
    afternoon: /^следо/i,
    evening: /^веч/i,
    night: /^през н/i
  }
}, Jue = {
  ordinalNumber: at({
    matchPattern: Iue,
    parsePattern: Fue,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Hue,
    defaultMatchWidth: "wide",
    parsePatterns: Vue,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Bue,
    defaultMatchWidth: "wide",
    parsePatterns: Uue,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Yue,
    defaultMatchWidth: "wide",
    parsePatterns: Gue,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Xue,
    defaultMatchWidth: "wide",
    parsePatterns: que,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Que,
    defaultMatchWidth: "any",
    parsePatterns: Kue,
    defaultParseWidth: "any"
  })
};
const Zue = Jue;
var ece = {
  code: "bg",
  formatDistance: gue,
  formatLong: kue,
  formatRelative: Aue,
  localize: Lue,
  match: Zue,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const tce = ece;
var nce = {
  locale: {
    1: "১",
    2: "২",
    3: "৩",
    4: "৪",
    5: "৫",
    6: "৬",
    7: "৭",
    8: "৮",
    9: "৯",
    0: "০"
  },
  number: {
    "১": "1",
    "২": "2",
    "৩": "3",
    "৪": "4",
    "৫": "5",
    "৬": "6",
    "৭": "7",
    "৮": "8",
    "৯": "9",
    "০": "0"
  }
}, rce = {
  narrow: ["খ্রিঃপূঃ", "খ্রিঃ"],
  abbreviated: ["খ্রিঃপূর্ব", "খ্রিঃ"],
  wide: ["খ্রিস্টপূর্ব", "খ্রিস্টাব্দ"]
}, ace = {
  narrow: ["১", "২", "৩", "৪"],
  abbreviated: ["১ত্রৈ", "২ত্রৈ", "৩ত্রৈ", "৪ত্রৈ"],
  wide: ["১ম ত্রৈমাসিক", "২য় ত্রৈমাসিক", "৩য় ত্রৈমাসিক", "৪র্থ ত্রৈমাসিক"]
}, ice = {
  narrow: ["জানু", "ফেব্রু", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্ট", "অক্টো", "নভে", "ডিসে"],
  abbreviated: ["জানু", "ফেব্রু", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্ট", "অক্টো", "নভে", "ডিসে"],
  wide: ["জানুয়ারি", "ফেব্রুয়ারি", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্টেম্বর", "অক্টোবর", "নভেম্বর", "ডিসেম্বর"]
}, oce = {
  narrow: ["র", "সো", "ম", "বু", "বৃ", "শু", "শ"],
  short: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহ", "শুক্র", "শনি"],
  abbreviated: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহ", "শুক্র", "শনি"],
  wide: ["রবিবার", "সোমবার", "মঙ্গলবার", "বুধবার", "বৃহস্পতিবার ", "শুক্রবার", "শনিবার"]
}, sce = {
  narrow: {
    am: "পূ",
    pm: "অপ",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  abbreviated: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  wide: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  }
}, lce = {
  narrow: {
    am: "পূ",
    pm: "অপ",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  abbreviated: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  wide: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  }
};
function uce(e, t) {
  if (e > 18 && e <= 31)
    return t + "শে";
  switch (e) {
    case 1:
      return t + "লা";
    case 2:
    case 3:
      return t + "রা";
    case 4:
      return t + "ঠা";
    default:
      return t + "ই";
  }
}
var cce = function(e, t) {
  var n = Number(e), r = cW(n), s = t == null ? void 0 : t.unit;
  if (s === "date")
    return uce(n, r);
  if (n > 10 || n === 0)
    return r + "তম";
  var f = n % 10;
  switch (f) {
    case 2:
    case 3:
      return r + "য়";
    case 4:
      return r + "র্থ";
    case 6:
      return r + "ষ্ঠ";
    default:
      return r + "ম";
  }
};
function cW(e) {
  return e.toString().replace(/\d/g, function(t) {
    return nce.locale[t];
  });
}
var dce = {
  ordinalNumber: cce,
  era: R({
    values: rce,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: ace,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: ice,
    defaultWidth: "wide"
  }),
  day: R({
    values: oce,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: sce,
    defaultWidth: "wide",
    formattingValues: lce,
    defaultFormattingWidth: "wide"
  })
};
const fce = dce;
var mce = {
  lessThanXSeconds: {
    one: "প্রায় ১ সেকেন্ড",
    other: "প্রায় {{count}} সেকেন্ড"
  },
  xSeconds: {
    one: "১ সেকেন্ড",
    other: "{{count}} সেকেন্ড"
  },
  halfAMinute: "আধ মিনিট",
  lessThanXMinutes: {
    one: "প্রায় ১ মিনিট",
    other: "প্রায় {{count}} মিনিট"
  },
  xMinutes: {
    one: "১ মিনিট",
    other: "{{count}} মিনিট"
  },
  aboutXHours: {
    one: "প্রায় ১ ঘন্টা",
    other: "প্রায় {{count}} ঘন্টা"
  },
  xHours: {
    one: "১ ঘন্টা",
    other: "{{count}} ঘন্টা"
  },
  xDays: {
    one: "১ দিন",
    other: "{{count}} দিন"
  },
  aboutXWeeks: {
    one: "প্রায় ১ সপ্তাহ",
    other: "প্রায় {{count}} সপ্তাহ"
  },
  xWeeks: {
    one: "১ সপ্তাহ",
    other: "{{count}} সপ্তাহ"
  },
  aboutXMonths: {
    one: "প্রায় ১ মাস",
    other: "প্রায় {{count}} মাস"
  },
  xMonths: {
    one: "১ মাস",
    other: "{{count}} মাস"
  },
  aboutXYears: {
    one: "প্রায় ১ বছর",
    other: "প্রায় {{count}} বছর"
  },
  xYears: {
    one: "১ বছর",
    other: "{{count}} বছর"
  },
  overXYears: {
    one: "১ বছরের বেশি",
    other: "{{count}} বছরের বেশি"
  },
  almostXYears: {
    one: "প্রায় ১ বছর",
    other: "প্রায় {{count}} বছর"
  }
}, hce = function(e, t, n) {
  var r, s = mce[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", cW(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " এর মধ্যে" : r + " আগে" : r;
};
const pce = hce;
var vce = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, gce = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, yce = {
  full: "{{date}} {{time}} 'সময়'",
  long: "{{date}} {{time}} 'সময়'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, bce = {
  date: Q({
    formats: vce,
    defaultWidth: "full"
  }),
  time: Q({
    formats: gce,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: yce,
    defaultWidth: "full"
  })
};
const wce = bce;
var Pce = {
  lastWeek: "'গত' eeee 'সময়' p",
  yesterday: "'গতকাল' 'সময়' p",
  today: "'আজ' 'সময়' p",
  tomorrow: "'আগামীকাল' 'সময়' p",
  nextWeek: "eeee 'সময়' p",
  other: "P"
}, kce = function(e, t, n, r) {
  return Pce[e];
};
const $ce = kce;
var Sce = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i, xce = /\d+/i, Cce = {
  narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
  abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
  wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
}, Mce = {
  narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
  abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
  wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i]
}, Ece = {
  narrow: /^[১২৩৪]/i,
  abbreviated: /^[১২৩৪]ত্রৈ/i,
  wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
}, Ace = {
  any: [/১/i, /২/i, /৩/i, /৪/i]
}, _ce = {
  narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
}, Oce = {
  any: [/^জানু/i, /^ফেব্রু/i, /^মার্চ/i, /^এপ্রিল/i, /^মে/i, /^জুন/i, /^জুলাই/i, /^আগস্ট/i, /^সেপ্ট/i, /^অক্টো/i, /^নভে/i, /^ডিসে/i]
}, Tce = {
  narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
  short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
}, Rce = {
  narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
  short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
  abbreviated: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
  wide: [/^রবিবার/i, /^সোমবার/i, /^মঙ্গলবার/i, /^বুধবার/i, /^বৃহস্পতিবার /i, /^শুক্রবার/i, /^শনিবার/i]
}, Dce = {
  narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
}, Nce = {
  any: {
    am: /^পূ/i,
    pm: /^অপ/i,
    midnight: /^মধ্যরাত/i,
    noon: /^মধ্যাহ্ন/i,
    morning: /সকাল/i,
    afternoon: /বিকাল/i,
    evening: /সন্ধ্যা/i,
    night: /রাত/i
  }
}, Wce = {
  ordinalNumber: at({
    matchPattern: Sce,
    parsePattern: xce,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Cce,
    defaultMatchWidth: "wide",
    parsePatterns: Mce,
    defaultParseWidth: "wide"
  }),
  quarter: D({
    matchPatterns: Ece,
    defaultMatchWidth: "wide",
    parsePatterns: Ace,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: _ce,
    defaultMatchWidth: "wide",
    parsePatterns: Oce,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Tce,
    defaultMatchWidth: "wide",
    parsePatterns: Rce,
    defaultParseWidth: "wide"
  }),
  dayPeriod: D({
    matchPatterns: Dce,
    defaultMatchWidth: "wide",
    parsePatterns: Nce,
    defaultParseWidth: "any"
  })
};
const jce = Wce;
var zce = {
  code: "bn",
  formatDistance: pce,
  formatLong: wce,
  formatRelative: $ce,
  localize: fce,
  match: jce,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Lce = zce;
var Ice = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 sedmicu",
      withPrepositionAgo: "oko 1 sedmicu",
      withPrepositionIn: "oko 1 sedmicu"
    },
    dual: "oko {{count}} sedmice",
    other: "oko {{count}} sedmice"
  },
  xWeeks: {
    one: {
      standalone: "1 sedmicu",
      withPrepositionAgo: "1 sedmicu",
      withPrepositionIn: "1 sedmicu"
    },
    dual: "{{count}} sedmice",
    other: "{{count}} sedmice"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mjesec",
      withPrepositionAgo: "oko 1 mjesec",
      withPrepositionIn: "oko 1 mjesec"
    },
    dual: "oko {{count}} mjeseca",
    other: "oko {{count}} mjeseci"
  },
  xMonths: {
    one: {
      standalone: "1 mjesec",
      withPrepositionAgo: "1 mjesec",
      withPrepositionIn: "1 mjesec"
    },
    dual: "{{count}} mjeseca",
    other: "{{count}} mjeseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, Fce = function(e, t, n) {
  var r, s = Ice[e];
  return typeof s == "string" ? r = s : t === 1 ? n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r = s.one.withPrepositionIn : r = s.one.withPrepositionAgo : r = s.one.standalone : t % 10 > 1 && t % 10 < 5 && String(t).substr(-2, 1) !== "1" ? r = s.dual.replace("{{count}}", String(t)) : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "za " + r : "prije " + r : r;
};
const Hce = Fce;
var Vce = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, Bce = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Uce = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Xce = {
  date: Q({
    formats: Vce,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Bce,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Uce,
    defaultWidth: "full"
  })
};
const qce = Xce;
var Yce = {
  lastWeek: function(e) {
    switch (e.getUTCDay()) {
      case 0:
        return "'prošle nedjelje u' p";
      case 3:
        return "'prošle srijede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function(e) {
    switch (e.getUTCDay()) {
      case 0:
        return "'sljedeće nedjelje u' p";
      case 3:
        return "'sljedeću srijedu u' p";
      case 6:
        return "'sljedeću subotu u' p";
      default:
        return "'sljedeći' EEEE 'u' p";
    }
  },
  other: "P"
}, Gce = function(e, t, n, r) {
  var s = Yce[e];
  return typeof s == "function" ? s(t) : s;
};
const Qce = Gce;
var Kce = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Prije Hrista", "Poslije Hrista"]
}, Jce = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Zce = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "juni", "juli", "avgust", "septembar", "oktobar", "novembar", "decembar"]
}, ede = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "juni", "juli", "avgust", "septembar", "oktobar", "novembar", "decembar"]
}, tde = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: ["nedjelja", "ponedjeljak", "utorak", "srijeda", "četvrtak", "petak", "subota"]
}, nde = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "poslije podne",
    evening: "uveče",
    night: "noću"
  }
}, rde = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "poslije podne",
    evening: "uveče",
    night: "noću"
  }
}, ade = function(e, t) {
  var n = Number(e);
  return String(n) + ".";
}, ide = {
  ordinalNumber: ade,
  era: R({
    values: Kce,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Jce,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Zce,
    defaultWidth: "wide",
    formattingValues: ede,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: tde,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: nde,
    defaultWidth: "wide",
    formattingValues: rde,
    defaultFormattingWidth: "wide"
  })
};
const ode = ide;
var sde = /^(\d+)\./i, lde = /\d+/i, ude = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
}, cde = {
  any: [/^pr/i, /^(po|nova)/i]
}, dde = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, fde = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, mde = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
}, hde = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, pde = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
}, vde = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, gde = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
}, yde = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
}, bde = {
  ordinalNumber: at({
    matchPattern: sde,
    parsePattern: lde,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: ude,
    defaultMatchWidth: "wide",
    parsePatterns: cde,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: dde,
    defaultMatchWidth: "wide",
    parsePatterns: fde,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: mde,
    defaultMatchWidth: "wide",
    parsePatterns: hde,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: pde,
    defaultMatchWidth: "wide",
    parsePatterns: vde,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: gde,
    defaultMatchWidth: "any",
    parsePatterns: yde,
    defaultParseWidth: "any"
  })
};
const wde = bde;
var Pde = {
  code: "bs",
  formatDistance: Hce,
  formatLong: qce,
  formatRelative: Qce,
  localize: ode,
  match: wde,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const kde = Pde;
var $de = {
  lessThanXSeconds: {
    one: "menys d'un segon",
    eleven: "menys d'onze segons",
    other: "menys de {{count}} segons"
  },
  xSeconds: {
    one: "1 segon",
    other: "{{count}} segons"
  },
  halfAMinute: "mig minut",
  lessThanXMinutes: {
    one: "menys d'un minut",
    eleven: "menys d'onze minuts",
    other: "menys de {{count}} minuts"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minuts"
  },
  aboutXHours: {
    one: "aproximadament una hora",
    other: "aproximadament {{count}} hores"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} hores"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dies"
  },
  aboutXWeeks: {
    one: "aproximadament una setmana",
    other: "aproximadament {{count}} setmanes"
  },
  xWeeks: {
    one: "1 setmana",
    other: "{{count}} setmanes"
  },
  aboutXMonths: {
    one: "aproximadament un mes",
    other: "aproximadament {{count}} mesos"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} mesos"
  },
  aboutXYears: {
    one: "aproximadament un any",
    other: "aproximadament {{count}} anys"
  },
  xYears: {
    one: "1 any",
    other: "{{count}} anys"
  },
  overXYears: {
    one: "més d'un any",
    eleven: "més d'onze anys",
    other: "més de {{count}} anys"
  },
  almostXYears: {
    one: "gairebé un any",
    other: "gairebé {{count}} anys"
  }
}, Sde = function(e, t, n) {
  var r, s = $de[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : t === 11 && s.eleven ? r = s.eleven : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + r : "fa " + r : r;
};
const xde = Sde;
var Cde = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Mde = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Ede = {
  full: "{{date}} 'a les' {{time}}",
  long: "{{date}} 'a les' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ade = {
  date: Q({
    formats: Cde,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Mde,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Ede,
    defaultWidth: "full"
  })
};
const _de = Ade;
var Ode = {
  lastWeek: "'el' eeee 'passat a la' LT",
  yesterday: "'ahir a la' p",
  today: "'avui a la' p",
  tomorrow: "'demà a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, Tde = {
  lastWeek: "'el' eeee 'passat a les' p",
  yesterday: "'ahir a les' p",
  today: "'avui a les' p",
  tomorrow: "'demà a les' p",
  nextWeek: "eeee 'a les' p",
  other: "P"
}, Rde = function(e, t, n, r) {
  return t.getUTCHours() !== 1 ? Tde[e] : Ode[e];
};
const Dde = Rde;
var Nde = {
  narrow: ["aC", "dC"],
  abbreviated: ["a. de C.", "d. de C."],
  wide: ["abans de Crist", "després de Crist"]
}, Wde = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1r trimestre", "2n trimestre", "3r trimestre", "4t trimestre"]
}, jde = {
  narrow: ["GN", "FB", "MÇ", "AB", "MG", "JN", "JL", "AG", "ST", "OC", "NV", "DS"],
  abbreviated: ["gen.", "febr.", "març", "abr.", "maig", "juny", "jul.", "ag.", "set.", "oct.", "nov.", "des."],
  wide: ["gener", "febrer", "març", "abril", "maig", "juny", "juliol", "agost", "setembre", "octubre", "novembre", "desembre"]
}, zde = {
  narrow: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  short: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  abbreviated: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  wide: ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"]
}, Lde = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  }
}, Ide = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  }
}, Fde = function(e, t) {
  var n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "r";
      case 2:
        return n + "n";
      case 3:
        return n + "r";
      case 4:
        return n + "t";
    }
  return n + "è";
}, Hde = {
  ordinalNumber: Fde,
  era: R({
    values: Nde,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Wde,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: jde,
    defaultWidth: "wide"
  }),
  day: R({
    values: zde,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Lde,
    defaultWidth: "wide",
    formattingValues: Ide,
    defaultFormattingWidth: "wide"
  })
};
const Vde = Hde;
var Bde = /^(\d+)(è|r|n|r|t)?/i, Ude = /\d+/i, Xde = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a. de C.|d. de C.)/i,
  wide: /^(abans de Crist|despr[eé]s de Crist)/i
}, qde = {
  narrow: [/^aC/i, /^dC/i],
  abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
  wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i]
}, Yde = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](è|r|n|r|t)? trimestre/i
}, Gde = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Qde = {
  narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
  abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
  wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
}, Kde = {
  narrow: [/^GN/i, /^FB/i, /^MÇ/i, /^AB/i, /^MG/i, /^JN/i, /^JL/i, /^AG/i, /^ST/i, /^OC/i, /^NV/i, /^DS/i],
  abbreviated: [/^gen./i, /^febr./i, /^març/i, /^abr./i, /^maig/i, /^juny/i, /^jul./i, /^ag./i, /^set./i, /^oct./i, /^nov./i, /^des./i],
  wide: [/^gener/i, /^febrer/i, /^març/i, /^abril/i, /^maig/i, /^juny/i, /^juliol/i, /^agost/i, /^setembre/i, /^octubre/i, /^novembre/i, /^desembre/i]
}, Jde = {
  narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
}, Zde = {
  narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
  abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
  wide: [/^diumenge/i, /^dilluns/i, /^dimarts/i, /^dimecres/i, /^dijous/i, /^divendres/i, /^disssabte/i]
}, efe = {
  narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
  abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
  wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
}, tfe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mitjanit/i,
    noon: /^migdia/i,
    morning: /matí/i,
    afternoon: /tarda/i,
    evening: /vespre/i,
    night: /nit/i
  }
}, nfe = {
  ordinalNumber: at({
    matchPattern: Bde,
    parsePattern: Ude,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Xde,
    defaultMatchWidth: "wide",
    parsePatterns: qde,
    defaultParseWidth: "wide"
  }),
  quarter: D({
    matchPatterns: Yde,
    defaultMatchWidth: "wide",
    parsePatterns: Gde,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Qde,
    defaultMatchWidth: "wide",
    parsePatterns: Kde,
    defaultParseWidth: "wide"
  }),
  day: D({
    matchPatterns: Jde,
    defaultMatchWidth: "wide",
    parsePatterns: Zde,
    defaultParseWidth: "wide"
  }),
  dayPeriod: D({
    matchPatterns: efe,
    defaultMatchWidth: "wide",
    parsePatterns: tfe,
    defaultParseWidth: "any"
  })
};
const rfe = nfe;
var afe = {
  code: "ca",
  formatDistance: xde,
  formatLong: _de,
  formatRelative: Dde,
  localize: Vde,
  match: rfe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const ife = afe;
var ofe = {
  lessThanXSeconds: {
    one: {
      regular: "méně než sekunda",
      past: "před méně než sekundou",
      future: "za méně než sekundu"
    },
    few: {
      regular: "méně než {{count}} sekundy",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekundy"
    },
    many: {
      regular: "méně než {{count}} sekund",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekund"
    }
  },
  xSeconds: {
    one: {
      regular: "sekunda",
      past: "před sekundou",
      future: "za sekundu"
    },
    few: {
      regular: "{{count}} sekundy",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekundy"
    },
    many: {
      regular: "{{count}} sekund",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekund"
    }
  },
  halfAMinute: {
    type: "other",
    other: {
      regular: "půl minuty",
      past: "před půl minutou",
      future: "za půl minuty"
    }
  },
  lessThanXMinutes: {
    one: {
      regular: "méně než minuta",
      past: "před méně než minutou",
      future: "za méně než minutu"
    },
    few: {
      regular: "méně než {{count}} minuty",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minuty"
    },
    many: {
      regular: "méně než {{count}} minut",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minut"
    }
  },
  xMinutes: {
    one: {
      regular: "minuta",
      past: "před minutou",
      future: "za minutu"
    },
    few: {
      regular: "{{count}} minuty",
      past: "před {{count}} minutami",
      future: "za {{count}} minuty"
    },
    many: {
      regular: "{{count}} minut",
      past: "před {{count}} minutami",
      future: "za {{count}} minut"
    }
  },
  aboutXHours: {
    one: {
      regular: "přibližně hodina",
      past: "přibližně před hodinou",
      future: "přibližně za hodinu"
    },
    few: {
      regular: "přibližně {{count}} hodiny",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodiny"
    },
    many: {
      regular: "přibližně {{count}} hodin",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodin"
    }
  },
  xHours: {
    one: {
      regular: "hodina",
      past: "před hodinou",
      future: "za hodinu"
    },
    few: {
      regular: "{{count}} hodiny",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodiny"
    },
    many: {
      regular: "{{count}} hodin",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodin"
    }
  },
  xDays: {
    one: {
      regular: "den",
      past: "před dnem",
      future: "za den"
    },
    few: {
      regular: "{{count}} dny",
      past: "před {{count}} dny",
      future: "za {{count}} dny"
    },
    many: {
      regular: "{{count}} dní",
      past: "před {{count}} dny",
      future: "za {{count}} dní"
    }
  },
  aboutXWeeks: {
    one: {
      regular: "přibližně týden",
      past: "přibližně před týdnem",
      future: "přibližně za týden"
    },
    few: {
      regular: "přibližně {{count}} týdny",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdny"
    },
    many: {
      regular: "přibližně {{count}} týdnů",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdnů"
    }
  },
  xWeeks: {
    one: {
      regular: "týden",
      past: "před týdnem",
      future: "za týden"
    },
    few: {
      regular: "{{count}} týdny",
      past: "před {{count}} týdny",
      future: "za {{count}} týdny"
    },
    many: {
      regular: "{{count}} týdnů",
      past: "před {{count}} týdny",
      future: "za {{count}} týdnů"
    }
  },
  aboutXMonths: {
    one: {
      regular: "přibližně měsíc",
      past: "přibližně před měsícem",
      future: "přibližně za měsíc"
    },
    few: {
      regular: "přibližně {{count}} měsíce",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíce"
    },
    many: {
      regular: "přibližně {{count}} měsíců",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíců"
    }
  },
  xMonths: {
    one: {
      regular: "měsíc",
      past: "před měsícem",
      future: "za měsíc"
    },
    few: {
      regular: "{{count}} měsíce",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíce"
    },
    many: {
      regular: "{{count}} měsíců",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíců"
    }
  },
  aboutXYears: {
    one: {
      regular: "přibližně rok",
      past: "přibližně před rokem",
      future: "přibližně za rok"
    },
    few: {
      regular: "přibližně {{count}} roky",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roky"
    },
    many: {
      regular: "přibližně {{count}} roků",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roků"
    }
  },
  xYears: {
    one: {
      regular: "rok",
      past: "před rokem",
      future: "za rok"
    },
    few: {
      regular: "{{count}} roky",
      past: "před {{count}} roky",
      future: "za {{count}} roky"
    },
    many: {
      regular: "{{count}} roků",
      past: "před {{count}} roky",
      future: "za {{count}} roků"
    }
  },
  overXYears: {
    one: {
      regular: "více než rok",
      past: "před více než rokem",
      future: "za více než rok"
    },
    few: {
      regular: "více než {{count}} roky",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roky"
    },
    many: {
      regular: "více než {{count}} roků",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roků"
    }
  },
  almostXYears: {
    one: {
      regular: "skoro rok",
      past: "skoro před rokem",
      future: "skoro za rok"
    },
    few: {
      regular: "skoro {{count}} roky",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roky"
    },
    many: {
      regular: "skoro {{count}} roků",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roků"
    }
  }
}, sfe = function(e, t, n) {
  var r, s = ofe[e];
  s.type === "other" ? r = s.other : t === 1 ? r = s.one : t > 1 && t < 5 ? r = s.few : r = s.many;
  var f = (n == null ? void 0 : n.addSuffix) === !0, m = n == null ? void 0 : n.comparison, p;
  return f && m === -1 ? p = r.past : f && m === 1 ? p = r.future : p = r.regular, p.replace("{{count}}", String(t));
};
const lfe = sfe;
var ufe = {
  full: "EEEE, d. MMMM yyyy",
  long: "d. MMMM yyyy",
  medium: "d. M. yyyy",
  short: "dd.MM.yyyy"
}, cfe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, dfe = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ffe = {
  date: Q({
    formats: ufe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: cfe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: dfe,
    defaultWidth: "full"
  })
};
const mfe = ffe;
var hfe = ["neděli", "pondělí", "úterý", "středu", "čtvrtek", "pátek", "sobotu"], pfe = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: function(e) {
    var t = e.getUTCDay();
    return "'v " + hfe[t] + " o' p";
  },
  other: "P"
}, vfe = function(e, t) {
  var n = pfe[e];
  return typeof n == "function" ? n(t) : n;
};
const gfe = vfe;
var yfe = {
  narrow: ["př. n. l.", "n. l."],
  abbreviated: ["př. n. l.", "n. l."],
  wide: ["před naším letopočtem", "našeho letopočtu"]
}, bfe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"],
  wide: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"]
}, wfe = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: ["led", "úno", "bře", "dub", "kvě", "čvn", "čvc", "srp", "zář", "říj", "lis", "pro"],
  wide: ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"]
}, Pfe = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: ["led", "úno", "bře", "dub", "kvě", "čvn", "čvc", "srp", "zář", "říj", "lis", "pro"],
  wide: ["ledna", "února", "března", "dubna", "května", "června", "července", "srpna", "září", "října", "listopadu", "prosince"]
}, kfe = {
  narrow: ["ne", "po", "út", "st", "čt", "pá", "so"],
  short: ["ne", "po", "út", "st", "čt", "pá", "so"],
  abbreviated: ["ned", "pon", "úte", "stř", "čtv", "pát", "sob"],
  wide: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"]
}, $fe = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, Sfe = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, xfe = function(e, t) {
  var n = Number(e);
  return n + ".";
}, Cfe = {
  ordinalNumber: xfe,
  era: R({
    values: yfe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: bfe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: wfe,
    defaultWidth: "wide",
    formattingValues: Pfe,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: kfe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: $fe,
    defaultWidth: "wide",
    formattingValues: Sfe,
    defaultFormattingWidth: "wide"
  })
};
const Mfe = Cfe;
var Efe = /^(\d+)\.?/i, Afe = /\d+/i, _fe = {
  narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
}, Ofe = {
  any: [/^p[řr]/i, /^(po|n)/i]
}, Tfe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
}, Rfe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Dfe = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
}, Nfe = {
  narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
  any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
}, Wfe = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
}, jfe = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i]
}, zfe = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
}, Lfe = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
}, Ife = {
  ordinalNumber: at({
    matchPattern: Efe,
    parsePattern: Afe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: _fe,
    defaultMatchWidth: "wide",
    parsePatterns: Ofe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Tfe,
    defaultMatchWidth: "wide",
    parsePatterns: Rfe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Dfe,
    defaultMatchWidth: "wide",
    parsePatterns: Nfe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Wfe,
    defaultMatchWidth: "wide",
    parsePatterns: jfe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: zfe,
    defaultMatchWidth: "any",
    parsePatterns: Lfe,
    defaultParseWidth: "any"
  })
};
const Ffe = Ife;
var Hfe = {
  code: "cs",
  formatDistance: lfe,
  formatLong: mfe,
  formatRelative: gfe,
  localize: Mfe,
  match: Ffe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Vfe = Hfe;
var Bfe = {
  lessThanXSeconds: {
    one: "llai na eiliad",
    other: "llai na {{count}} eiliad"
  },
  xSeconds: {
    one: "1 eiliad",
    other: "{{count}} eiliad"
  },
  halfAMinute: "hanner munud",
  lessThanXMinutes: {
    one: "llai na munud",
    two: "llai na 2 funud",
    other: "llai na {{count}} munud"
  },
  xMinutes: {
    one: "1 munud",
    two: "2 funud",
    other: "{{count}} munud"
  },
  aboutXHours: {
    one: "tua 1 awr",
    other: "tua {{count}} awr"
  },
  xHours: {
    one: "1 awr",
    other: "{{count}} awr"
  },
  xDays: {
    one: "1 diwrnod",
    two: "2 ddiwrnod",
    other: "{{count}} diwrnod"
  },
  aboutXWeeks: {
    one: "tua 1 wythnos",
    two: "tua pythefnos",
    other: "tua {{count}} wythnos"
  },
  xWeeks: {
    one: "1 wythnos",
    two: "pythefnos",
    other: "{{count}} wythnos"
  },
  aboutXMonths: {
    one: "tua 1 mis",
    two: "tua 2 fis",
    other: "tua {{count}} mis"
  },
  xMonths: {
    one: "1 mis",
    two: "2 fis",
    other: "{{count}} mis"
  },
  aboutXYears: {
    one: "tua 1 flwyddyn",
    two: "tua 2 flynedd",
    other: "tua {{count}} mlynedd"
  },
  xYears: {
    one: "1 flwyddyn",
    two: "2 flynedd",
    other: "{{count}} mlynedd"
  },
  overXYears: {
    one: "dros 1 flwyddyn",
    two: "dros 2 flynedd",
    other: "dros {{count}} mlynedd"
  },
  almostXYears: {
    one: "bron 1 flwyddyn",
    two: "bron 2 flynedd",
    other: "bron {{count}} mlynedd"
  }
}, Ufe = function(e, t, n) {
  var r, s = Bfe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : t === 2 && s.two ? r = s.two : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "mewn " + r : r + " yn ôl" : r;
};
const Xfe = Ufe;
var qfe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Yfe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Gfe = {
  full: "{{date}} 'am' {{time}}",
  long: "{{date}} 'am' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Qfe = {
  date: Q({
    formats: qfe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Yfe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Gfe,
    defaultWidth: "full"
  })
};
const Kfe = Qfe;
var Jfe = {
  lastWeek: "eeee 'diwethaf am' p",
  yesterday: "'ddoe am' p",
  today: "'heddiw am' p",
  tomorrow: "'yfory am' p",
  nextWeek: "eeee 'am' p",
  other: "P"
}, Zfe = function(e, t, n, r) {
  return Jfe[e];
};
const eme = Zfe;
var tme = {
  narrow: ["C", "O"],
  abbreviated: ["CC", "OC"],
  wide: ["Cyn Crist", "Ar ôl Crist"]
}, nme = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Ch1", "Ch2", "Ch3", "Ch4"],
  wide: ["Chwarter 1af", "2ail chwarter", "3ydd chwarter", "4ydd chwarter"]
}, rme = {
  narrow: ["I", "Ch", "Ma", "E", "Mi", "Me", "G", "A", "Md", "H", "T", "Rh"],
  abbreviated: ["Ion", "Chwe", "Maw", "Ebr", "Mai", "Meh", "Gor", "Aws", "Med", "Hyd", "Tach", "Rhag"],
  wide: ["Ionawr", "Chwefror", "Mawrth", "Ebrill", "Mai", "Mehefin", "Gorffennaf", "Awst", "Medi", "Hydref", "Tachwedd", "Rhagfyr"]
}, ame = {
  narrow: ["S", "Ll", "M", "M", "I", "G", "S"],
  short: ["Su", "Ll", "Ma", "Me", "Ia", "Gw", "Sa"],
  abbreviated: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
  wide: ["dydd Sul", "dydd Llun", "dydd Mawrth", "dydd Mercher", "dydd Iau", "dydd Gwener", "dydd Sadwrn"]
}, ime = {
  narrow: {
    am: "b",
    pm: "h",
    midnight: "hn",
    noon: "hd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  },
  abbreviated: {
    am: "yb",
    pm: "yh",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  },
  wide: {
    am: "y.b.",
    pm: "y.h.",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  }
}, ome = {
  narrow: {
    am: "b",
    pm: "h",
    midnight: "hn",
    noon: "hd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  },
  abbreviated: {
    am: "yb",
    pm: "yh",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  },
  wide: {
    am: "y.b.",
    pm: "y.h.",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  }
}, sme = function(e, t) {
  var n = Number(e);
  if (n < 20)
    switch (n) {
      case 0:
        return n + "fed";
      case 1:
        return n + "af";
      case 2:
        return n + "ail";
      case 3:
      case 4:
        return n + "ydd";
      case 5:
      case 6:
        return n + "ed";
      case 7:
      case 8:
      case 9:
      case 10:
      case 12:
      case 15:
      case 18:
        return n + "fed";
      case 11:
      case 13:
      case 14:
      case 16:
      case 17:
      case 19:
        return n + "eg";
    }
  else if (n >= 50 && n <= 60 || n === 80 || n >= 100)
    return n + "fed";
  return n + "ain";
}, lme = {
  ordinalNumber: sme,
  era: R({
    values: tme,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: nme,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: rme,
    defaultWidth: "wide"
  }),
  day: R({
    values: ame,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: ime,
    defaultWidth: "wide",
    formattingValues: ome,
    defaultFormattingWidth: "wide"
  })
};
const ume = lme;
var cme = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i, dme = /\d+/i, fme = {
  narrow: /^(c|o)/i,
  abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
  wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
}, mme = {
  wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
  any: [/^c/i, /^o/i]
}, hme = {
  narrow: /^[1234]/i,
  abbreviated: /^ch[1234]/i,
  wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
}, pme = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, vme = {
  narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
  abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
  wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
}, gme = {
  narrow: [/^i/i, /^ch/i, /^m/i, /^e/i, /^m/i, /^m/i, /^g/i, /^a/i, /^m/i, /^h/i, /^t/i, /^rh/i],
  any: [/^io/i, /^ch/i, /^maw/i, /^e/i, /^mai/i, /^meh/i, /^g/i, /^a/i, /^med/i, /^h/i, /^t/i, /^rh/i]
}, yme = {
  narrow: /^(s|ll|m|i|g)/i,
  short: /^(su|ll|ma|me|ia|gw|sa)/i,
  abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
  wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
}, bme = {
  narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
  wide: [/^dydd su/i, /^dydd ll/i, /^dydd ma/i, /^dydd me/i, /^dydd i/i, /^dydd g/i, /^dydd sa/i],
  any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i]
}, wme = {
  narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
  any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
}, Pme = {
  any: {
    am: /^b|(y\.?\s?b\.?)/i,
    pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
    midnight: /^hn|hanner nos/i,
    noon: /^hd|hanner dydd/i,
    morning: /bore/i,
    afternoon: /prynhawn/i,
    evening: /^gyda'r nos$/i,
    night: /blah/i
  }
}, kme = {
  ordinalNumber: at({
    matchPattern: cme,
    parsePattern: dme,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: fme,
    defaultMatchWidth: "wide",
    parsePatterns: mme,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: hme,
    defaultMatchWidth: "wide",
    parsePatterns: pme,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: vme,
    defaultMatchWidth: "wide",
    parsePatterns: gme,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: yme,
    defaultMatchWidth: "wide",
    parsePatterns: bme,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: wme,
    defaultMatchWidth: "any",
    parsePatterns: Pme,
    defaultParseWidth: "any"
  })
};
const $me = kme;
var Sme = {
  code: "cy",
  formatDistance: Xfe,
  formatLong: Kfe,
  formatRelative: eme,
  localize: ume,
  match: $me,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const xme = Sme;
var Cme = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, Mme = function(e, t, n) {
  var r, s = Cme[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "om " + r : r + " siden" : r;
};
const Eme = Mme;
var Ame = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, _me = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Ome = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Tme = {
  date: Q({
    formats: Ame,
    defaultWidth: "full"
  }),
  time: Q({
    formats: _me,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Ome,
    defaultWidth: "full"
  })
};
const Rme = Tme;
var Dme = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, Nme = function(e, t, n, r) {
  return Dme[e];
};
const Wme = Nme;
var jme = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, zme = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Lme = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
}, Ime = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, Fme = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, Hme = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, Vme = function(e, t) {
  var n = Number(e);
  return n + ".";
}, Bme = {
  ordinalNumber: Vme,
  era: R({
    values: jme,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: zme,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Lme,
    defaultWidth: "wide"
  }),
  day: R({
    values: Ime,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Fme,
    defaultWidth: "wide",
    formattingValues: Hme,
    defaultFormattingWidth: "wide"
  })
};
const Ume = Bme;
var Xme = /^(\d+)(\.)?/i, qme = /\d+/i, Yme = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, Gme = {
  any: [/^f/i, /^(v|e)/i]
}, Qme = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, Kme = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Jme = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, Zme = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, ehe = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, the = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, nhe = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, rhe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, ahe = {
  ordinalNumber: at({
    matchPattern: Xme,
    parsePattern: qme,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Yme,
    defaultMatchWidth: "wide",
    parsePatterns: Gme,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Qme,
    defaultMatchWidth: "wide",
    parsePatterns: Kme,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Jme,
    defaultMatchWidth: "wide",
    parsePatterns: Zme,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: ehe,
    defaultMatchWidth: "wide",
    parsePatterns: the,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: nhe,
    defaultMatchWidth: "any",
    parsePatterns: rhe,
    defaultParseWidth: "any"
  })
};
const ihe = ahe;
var ohe = {
  code: "da",
  formatDistance: Eme,
  formatLong: Rme,
  formatRelative: Wme,
  localize: Ume,
  match: ihe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const she = ohe;
var MO = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, lhe = function(e, t, n) {
  var r, s = n != null && n.addSuffix ? MO[e].withPreposition : MO[e].standalone;
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : "vor " + r : r;
};
const dW = lhe;
var uhe = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
}, che = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, dhe = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, fhe = {
  date: Q({
    formats: uhe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: che,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: dhe,
    defaultWidth: "full"
  })
};
const fW = fhe;
var mhe = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, hhe = function(e, t, n, r) {
  return mhe[e];
};
const mW = hhe;
var phe = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, vhe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, J$ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, ghe = {
  narrow: J$.narrow,
  abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: J$.wide
}, yhe = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, bhe = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, whe = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, Phe = function(e) {
  var t = Number(e);
  return t + ".";
}, khe = {
  ordinalNumber: Phe,
  era: R({
    values: phe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: vhe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: J$,
    formattingValues: ghe,
    defaultWidth: "wide"
  }),
  day: R({
    values: yhe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: bhe,
    defaultWidth: "wide",
    formattingValues: whe,
    defaultFormattingWidth: "wide"
  })
};
const $he = khe;
var She = /^(\d+)(\.)?/i, xhe = /\d+/i, Che = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, Mhe = {
  any: [/^v/i, /^n/i]
}, Ehe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, Ahe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _he = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, Ohe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, The = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, Rhe = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, Dhe = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, Nhe = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    evening: /abends/i,
    night: /nachts/i
  }
}, Whe = {
  ordinalNumber: at({
    matchPattern: She,
    parsePattern: xhe,
    valueCallback: function(e) {
      return parseInt(e);
    }
  }),
  era: D({
    matchPatterns: Che,
    defaultMatchWidth: "wide",
    parsePatterns: Mhe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Ehe,
    defaultMatchWidth: "wide",
    parsePatterns: Ahe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: _he,
    defaultMatchWidth: "wide",
    parsePatterns: Ohe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: The,
    defaultMatchWidth: "wide",
    parsePatterns: Rhe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Dhe,
    defaultMatchWidth: "wide",
    parsePatterns: Nhe,
    defaultParseWidth: "any"
  })
};
const hW = Whe;
var jhe = {
  code: "de",
  formatDistance: dW,
  formatLong: fW,
  formatRelative: mW,
  localize: $he,
  match: hW,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const zhe = jhe;
var Lhe = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, Ihe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, Z$ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jän", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Jänner", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, Fhe = {
  narrow: Z$.narrow,
  abbreviated: ["Jän.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: Z$.wide
}, Hhe = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, Vhe = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, Bhe = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, Uhe = function(e) {
  var t = Number(e);
  return t + ".";
}, Xhe = {
  ordinalNumber: Uhe,
  era: R({
    values: Lhe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Ihe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Z$,
    formattingValues: Fhe,
    defaultWidth: "wide"
  }),
  day: R({
    values: Hhe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Vhe,
    defaultWidth: "wide",
    formattingValues: Bhe,
    defaultFormattingWidth: "wide"
  })
};
const qhe = Xhe;
var Yhe = {
  code: "de-AT",
  formatDistance: dW,
  formatLong: fW,
  formatRelative: mW,
  localize: qhe,
  match: hW,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Ghe = Yhe;
var Qhe = {
  lessThanXSeconds: {
    one: "λιγότερο από ένα δευτερόλεπτο",
    other: "λιγότερο από {{count}} δευτερόλεπτα"
  },
  xSeconds: {
    one: "1 δευτερόλεπτο",
    other: "{{count}} δευτερόλεπτα"
  },
  halfAMinute: "μισό λεπτό",
  lessThanXMinutes: {
    one: "λιγότερο από ένα λεπτό",
    other: "λιγότερο από {{count}} λεπτά"
  },
  xMinutes: {
    one: "1 λεπτό",
    other: "{{count}} λεπτά"
  },
  aboutXHours: {
    one: "περίπου 1 ώρα",
    other: "περίπου {{count}} ώρες"
  },
  xHours: {
    one: "1 ώρα",
    other: "{{count}} ώρες"
  },
  xDays: {
    one: "1 ημέρα",
    other: "{{count}} ημέρες"
  },
  aboutXWeeks: {
    one: "περίπου 1 εβδομάδα",
    other: "περίπου {{count}} εβδομάδες"
  },
  xWeeks: {
    one: "1 εβδομάδα",
    other: "{{count}} εβδομάδες"
  },
  aboutXMonths: {
    one: "περίπου 1 μήνας",
    other: "περίπου {{count}} μήνες"
  },
  xMonths: {
    one: "1 μήνας",
    other: "{{count}} μήνες"
  },
  aboutXYears: {
    one: "περίπου 1 χρόνο",
    other: "περίπου {{count}} χρόνια"
  },
  xYears: {
    one: "1 χρόνο",
    other: "{{count}} χρόνια"
  },
  overXYears: {
    one: "πάνω από 1 χρόνο",
    other: "πάνω από {{count}} χρόνια"
  },
  almostXYears: {
    one: "περίπου 1 χρόνο",
    other: "περίπου {{count}} χρόνια"
  }
}, Khe = function(e, t, n) {
  var r, s = Qhe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "σε " + r : r + " πριν" : r;
};
const Jhe = Khe;
var Zhe = {
  full: "EEEE, d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "d/M/yy"
}, epe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, tpe = {
  full: "{{date}} - {{time}}",
  long: "{{date}} - {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, npe = {
  date: Q({
    formats: Zhe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: epe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: tpe,
    defaultWidth: "full"
  })
};
const rpe = npe;
var ape = {
  lastWeek: function(e) {
    switch (e.getUTCDay()) {
      case 6:
        return "'το προηγούμενο' eeee 'στις' p";
      default:
        return "'την προηγούμενη' eeee 'στις' p";
    }
  },
  yesterday: "'χθες στις' p",
  today: "'σήμερα στις' p",
  tomorrow: "'αύριο στις' p",
  nextWeek: "eeee 'στις' p",
  other: "P"
}, ipe = function(e, t) {
  var n = ape[e];
  return typeof n == "function" ? n(t) : n;
};
const ope = ipe;
var spe = {
  narrow: ["πΧ", "μΧ"],
  abbreviated: ["π.Χ.", "μ.Χ."],
  wide: ["προ Χριστού", "μετά Χριστόν"]
}, lpe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Τ1", "Τ2", "Τ3", "Τ4"],
  wide: ["1ο τρίμηνο", "2ο τρίμηνο", "3ο τρίμηνο", "4ο τρίμηνο"]
}, upe = {
  narrow: ["Ι", "Φ", "Μ", "Α", "Μ", "Ι", "Ι", "Α", "Σ", "Ο", "Ν", "Δ"],
  abbreviated: ["Ιαν", "Φεβ", "Μάρ", "Απρ", "Μάι", "Ιούν", "Ιούλ", "Αύγ", "Σεπ", "Οκτ", "Νοέ", "Δεκ"],
  wide: ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"]
}, cpe = {
  narrow: ["Ι", "Φ", "Μ", "Α", "Μ", "Ι", "Ι", "Α", "Σ", "Ο", "Ν", "Δ"],
  abbreviated: ["Ιαν", "Φεβ", "Μαρ", "Απρ", "Μαΐ", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"],
  wide: ["Ιανουαρίου", "Φεβρουαρίου", "Μαρτίου", "Απριλίου", "Μαΐου", "Ιουνίου", "Ιουλίου", "Αυγούστου", "Σεπτεμβρίου", "Οκτωβρίου", "Νοεμβρίου", "Δεκεμβρίου"]
}, dpe = {
  narrow: ["Κ", "Δ", "T", "Τ", "Π", "Π", "Σ"],
  short: ["Κυ", "Δε", "Τρ", "Τε", "Πέ", "Πα", "Σά"],
  abbreviated: ["Κυρ", "Δευ", "Τρί", "Τετ", "Πέμ", "Παρ", "Σάβ"],
  wide: ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"]
}, fpe = {
  narrow: {
    am: "πμ",
    pm: "μμ",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  },
  abbreviated: {
    am: "π.μ.",
    pm: "μ.μ.",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  },
  wide: {
    am: "π.μ.",
    pm: "μ.μ.",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  }
}, mpe = function(e, t) {
  var n = Number(e), r = t == null ? void 0 : t.unit, s;
  return r === "year" || r === "month" ? s = "ος" : r === "week" || r === "dayOfYear" || r === "day" || r === "hour" || r === "date" ? s = "η" : s = "ο", n + s;
}, hpe = {
  ordinalNumber: mpe,
  era: R({
    values: spe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: lpe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: upe,
    defaultWidth: "wide",
    formattingValues: cpe,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: dpe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: fpe,
    defaultWidth: "wide"
  })
};
const ppe = hpe;
var vpe = /^(\d+)(ος|η|ο)?/i, gpe = /\d+/i, ype = {
  narrow: /^(πΧ|μΧ)/i,
  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
}, bpe = {
  any: [/^π/i, /^(μ|κ)/i]
}, wpe = {
  narrow: /^[1234]/i,
  abbreviated: /^τ[1234]/i,
  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
}, Ppe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kpe = {
  narrow: /^[ιφμαμιιασονδ]/i,
  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
}, $pe = {
  narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
  any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
}, Spe = {
  narrow: /^[κδτπσ]/i,
  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
}, xpe = {
  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
}, Cpe = {
  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
}, Mpe = {
  any: {
    am: /^πμ|π\.\s?μ\./i,
    pm: /^μμ|μ\.\s?μ\./i,
    midnight: /^μεσάν/i,
    noon: /^μεσημ(έ|ε)/i,
    morning: /πρω(ί|ι)/i,
    afternoon: /απ(ό|ο)γευμα/i,
    evening: /βρ(ά|α)δυ/i,
    night: /ν(ύ|υ)χτα/i
  }
}, Epe = {
  ordinalNumber: at({
    matchPattern: vpe,
    parsePattern: gpe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: ype,
    defaultMatchWidth: "wide",
    parsePatterns: bpe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: wpe,
    defaultMatchWidth: "wide",
    parsePatterns: Ppe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: kpe,
    defaultMatchWidth: "wide",
    parsePatterns: $pe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Spe,
    defaultMatchWidth: "wide",
    parsePatterns: xpe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Cpe,
    defaultMatchWidth: "any",
    parsePatterns: Mpe,
    defaultParseWidth: "any"
  })
};
const Ape = Epe;
var _pe = {
  code: "el",
  formatDistance: Jhe,
  formatLong: rpe,
  formatRelative: ope,
  localize: ppe,
  match: Ape,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Ope = _pe;
var Tpe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Rpe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Dpe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Npe = {
  date: Q({
    formats: Tpe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Rpe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Dpe,
    defaultWidth: "full"
  })
};
const Wpe = Npe;
var jpe = {
  code: "en-AU",
  formatDistance: hm,
  formatLong: Wpe,
  formatRelative: Ad,
  localize: _d,
  match: Od,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const zpe = jpe;
var Lpe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "a second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "a minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about an hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "an hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "a day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about a week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "a week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about a month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "a month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about a year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "a year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over a year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost a year",
    other: "almost {{count}} years"
  }
}, Ipe = function(e, t, n) {
  var r, s = Lpe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
const Fpe = Ipe;
var Hpe = {
  full: "EEEE, MMMM do, yyyy",
  long: "MMMM do, yyyy",
  medium: "MMM d, yyyy",
  short: "yyyy-MM-dd"
}, Vpe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Bpe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Upe = {
  date: Q({
    formats: Hpe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Vpe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Bpe,
    defaultWidth: "full"
  })
};
const Xpe = Upe;
var qpe = {
  code: "en-CA",
  formatDistance: Fpe,
  formatLong: Xpe,
  formatRelative: Ad,
  localize: _d,
  match: Od,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Ype = qpe;
var Gpe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Qpe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Kpe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Jpe = {
  date: Q({
    formats: Gpe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Qpe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Kpe,
    defaultWidth: "full"
  })
};
const pW = Jpe;
var Zpe = {
  code: "en-GB",
  formatDistance: hm,
  formatLong: pW,
  formatRelative: Ad,
  localize: _d,
  match: Od,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const eve = Zpe;
var tve = {
  code: "en-IE",
  formatDistance: hm,
  formatLong: pW,
  formatRelative: Ad,
  localize: _d,
  match: Od,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const nve = tve;
var rve = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM, yyyy",
  medium: "d MMM, yyyy",
  short: "dd/MM/yyyy"
}, ave = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ive = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ove = {
  date: Q({
    formats: rve,
    defaultWidth: "full"
  }),
  time: Q({
    formats: ave,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: ive,
    defaultWidth: "full"
  })
};
const sve = ove;
var lve = {
  code: "en-IN",
  formatDistance: hm,
  formatLong: sve,
  formatRelative: Ad,
  localize: _d,
  match: Od,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const uve = lve;
var cve = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, dve = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, fve = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, mve = {
  date: Q({
    formats: cve,
    defaultWidth: "full"
  }),
  time: Q({
    formats: dve,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: fve,
    defaultWidth: "full"
  })
};
const hve = mve;
var pve = {
  code: "en-NZ",
  formatDistance: hm,
  formatLong: hve,
  formatRelative: Ad,
  localize: _d,
  match: Od,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const vve = pve;
var gve = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "yyyy/MM/dd"
}, yve = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, bve = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, wve = {
  date: Q({
    formats: gve,
    defaultWidth: "full"
  }),
  time: Q({
    formats: yve,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: bve,
    defaultWidth: "full"
  })
};
const Pve = wve;
var kve = {
  code: "en-ZA",
  formatDistance: hm,
  formatLong: Pve,
  formatRelative: Ad,
  localize: _d,
  match: Od,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const $ve = kve;
var Sve = {
  lessThanXSeconds: {
    one: "malpli ol sekundo",
    other: "malpli ol {{count}} sekundoj"
  },
  xSeconds: {
    one: "1 sekundo",
    other: "{{count}} sekundoj"
  },
  halfAMinute: "duonminuto",
  lessThanXMinutes: {
    one: "malpli ol minuto",
    other: "malpli ol {{count}} minutoj"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutoj"
  },
  aboutXHours: {
    one: "proksimume 1 horo",
    other: "proksimume {{count}} horoj"
  },
  xHours: {
    one: "1 horo",
    other: "{{count}} horoj"
  },
  xDays: {
    one: "1 tago",
    other: "{{count}} tagoj"
  },
  aboutXMonths: {
    one: "proksimume 1 monato",
    other: "proksimume {{count}} monatoj"
  },
  xWeeks: {
    one: "1 semajno",
    other: "{{count}} semajnoj"
  },
  aboutXWeeks: {
    one: "proksimume 1 semajno",
    other: "proksimume {{count}} semajnoj"
  },
  xMonths: {
    one: "1 monato",
    other: "{{count}} monatoj"
  },
  aboutXYears: {
    one: "proksimume 1 jaro",
    other: "proksimume {{count}} jaroj"
  },
  xYears: {
    one: "1 jaro",
    other: "{{count}} jaroj"
  },
  overXYears: {
    one: "pli ol 1 jaro",
    other: "pli ol {{count}} jaroj"
  },
  almostXYears: {
    one: "preskaŭ 1 jaro",
    other: "preskaŭ {{count}} jaroj"
  }
}, xve = function(e, t, n) {
  var r, s = Sve[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n != null && n.comparison && n.comparison > 0 ? "post " + r : "antaŭ " + r : r;
};
const Cve = xve;
var Mve = {
  full: "EEEE, do 'de' MMMM y",
  long: "y-MMMM-dd",
  medium: "y-MMM-dd",
  short: "yyyy-MM-dd"
}, Eve = {
  full: "Ho 'horo kaj' m:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Ave = {
  any: "{{date}} {{time}}"
}, _ve = {
  date: Q({
    formats: Mve,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Eve,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Ave,
    defaultWidth: "any"
  })
};
const Ove = _ve;
var Tve = {
  lastWeek: "'pasinta' eeee 'je' p",
  yesterday: "'hieraŭ je' p",
  today: "'hodiaŭ je' p",
  tomorrow: "'morgaŭ je' p",
  nextWeek: "eeee 'je' p",
  other: "P"
}, Rve = function(e, t, n, r) {
  return Tve[e];
};
const Dve = Rve;
var Nve = {
  narrow: ["aK", "pK"],
  abbreviated: ["a.K.E.", "p.K.E."],
  wide: ["antaŭ Komuna Erao", "Komuna Erao"]
}, Wve = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1-a kvaronjaro", "2-a kvaronjaro", "3-a kvaronjaro", "4-a kvaronjaro"]
}, jve = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aŭg", "sep", "okt", "nov", "dec"],
  wide: ["januaro", "februaro", "marto", "aprilo", "majo", "junio", "julio", "aŭgusto", "septembro", "oktobro", "novembro", "decembro"]
}, zve = {
  narrow: ["D", "L", "M", "M", "Ĵ", "V", "S"],
  short: ["di", "lu", "ma", "me", "ĵa", "ve", "sa"],
  abbreviated: ["dim", "lun", "mar", "mer", "ĵaŭ", "ven", "sab"],
  wide: ["dimanĉo", "lundo", "mardo", "merkredo", "ĵaŭdo", "vendredo", "sabato"]
}, Lve = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  },
  abbreviated: {
    am: "a.t.m.",
    pm: "p.t.m.",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  },
  wide: {
    am: "antaŭtagmeze",
    pm: "posttagmeze",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  }
}, Ive = function(e) {
  var t = Number(e);
  return t + "-a";
}, Fve = {
  ordinalNumber: Ive,
  era: R({
    values: Nve,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Wve,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return Number(e) - 1;
    }
  }),
  month: R({
    values: jve,
    defaultWidth: "wide"
  }),
  day: R({
    values: zve,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Lve,
    defaultWidth: "wide"
  })
};
const Hve = Fve;
var Vve = /^(\d+)(-?a)?/i, Bve = /\d+/i, Uve = {
  narrow: /^([ap]k)/i,
  abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
  wide: /^((antaǔ |post )?komuna erao)/i
}, Xve = {
  any: [/^a/i, /^[kp]/i]
}, qve = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](-?a)? kvaronjaro/i
}, Yve = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Gve = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
  wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
}, Qve = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^a(u|ŭ)/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Kve = {
  narrow: /^[dlmĵjvs]/i,
  short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
  wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
}, Jve = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i]
}, Zve = {
  narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
}, ege = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^noktom/i,
    noon: /^t/i,
    morning: /^m/i,
    afternoon: /^posttagmeze/i,
    evening: /^v/i,
    night: /^n/i
  }
}, tge = {
  ordinalNumber: at({
    matchPattern: Vve,
    parsePattern: Bve,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Uve,
    defaultMatchWidth: "wide",
    parsePatterns: Xve,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: qve,
    defaultMatchWidth: "wide",
    parsePatterns: Yve,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Gve,
    defaultMatchWidth: "wide",
    parsePatterns: Qve,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Kve,
    defaultMatchWidth: "wide",
    parsePatterns: Jve,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Zve,
    defaultMatchWidth: "wide",
    parsePatterns: ege,
    defaultParseWidth: "any"
  })
};
const nge = tge;
var rge = {
  code: "eo",
  formatDistance: Cve,
  formatLong: Ove,
  formatRelative: Dve,
  localize: Hve,
  match: nge,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const age = rge;
var ige = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, oge = function(e, t, n) {
  var r, s = ige[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + r : "hace " + r : r;
};
const sge = oge;
var lge = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, uge = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, cge = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dge = {
  date: Q({
    formats: lge,
    defaultWidth: "full"
  }),
  time: Q({
    formats: uge,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: cge,
    defaultWidth: "full"
  })
};
const fge = dge;
var mge = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, hge = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, pge = function(e, t, n, r) {
  return t.getUTCHours() !== 1 ? hge[e] : mge[e];
};
const vge = pge;
var gge = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, yge = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, bge = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
}, wge = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
}, Pge = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, kge = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, $ge = function(e, t) {
  var n = Number(e);
  return n + "º";
}, Sge = {
  ordinalNumber: $ge,
  era: R({
    values: gge,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: yge,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return Number(e) - 1;
    }
  }),
  month: R({
    values: bge,
    defaultWidth: "wide"
  }),
  day: R({
    values: wge,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Pge,
    defaultWidth: "wide",
    formattingValues: kge,
    defaultFormattingWidth: "wide"
  })
};
const xge = Sge;
var Cge = /^(\d+)(º)?/i, Mge = /\d+/i, Ege = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, Age = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
}, _ge = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Oge = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Tge = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, Rge = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
}, Dge = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, Nge = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, Wge = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, jge = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, zge = {
  ordinalNumber: at({
    matchPattern: Cge,
    parsePattern: Mge,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Ege,
    defaultMatchWidth: "wide",
    parsePatterns: Age,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: _ge,
    defaultMatchWidth: "wide",
    parsePatterns: Oge,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Tge,
    defaultMatchWidth: "wide",
    parsePatterns: Rge,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Dge,
    defaultMatchWidth: "wide",
    parsePatterns: Nge,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Wge,
    defaultMatchWidth: "any",
    parsePatterns: jge,
    defaultParseWidth: "any"
  })
};
const Lge = zge;
var Ige = {
  code: "es",
  formatDistance: sge,
  formatLong: fge,
  formatRelative: vge,
  localize: xge,
  match: Lge,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Fge = Ige;
var EO = {
  lessThanXSeconds: {
    standalone: {
      one: "vähem kui üks sekund",
      other: "vähem kui {{count}} sekundit"
    },
    withPreposition: {
      one: "vähem kui ühe sekundi",
      other: "vähem kui {{count}} sekundi"
    }
  },
  xSeconds: {
    standalone: {
      one: "üks sekund",
      other: "{{count}} sekundit"
    },
    withPreposition: {
      one: "ühe sekundi",
      other: "{{count}} sekundi"
    }
  },
  halfAMinute: {
    standalone: "pool minutit",
    withPreposition: "poole minuti"
  },
  lessThanXMinutes: {
    standalone: {
      one: "vähem kui üks minut",
      other: "vähem kui {{count}} minutit"
    },
    withPreposition: {
      one: "vähem kui ühe minuti",
      other: "vähem kui {{count}} minuti"
    }
  },
  xMinutes: {
    standalone: {
      one: "üks minut",
      other: "{{count}} minutit"
    },
    withPreposition: {
      one: "ühe minuti",
      other: "{{count}} minuti"
    }
  },
  aboutXHours: {
    standalone: {
      one: "umbes üks tund",
      other: "umbes {{count}} tundi"
    },
    withPreposition: {
      one: "umbes ühe tunni",
      other: "umbes {{count}} tunni"
    }
  },
  xHours: {
    standalone: {
      one: "üks tund",
      other: "{{count}} tundi"
    },
    withPreposition: {
      one: "ühe tunni",
      other: "{{count}} tunni"
    }
  },
  xDays: {
    standalone: {
      one: "üks päev",
      other: "{{count}} päeva"
    },
    withPreposition: {
      one: "ühe päeva",
      other: "{{count}} päeva"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "umbes üks nädal",
      other: "umbes {{count}} nädalat"
    },
    withPreposition: {
      one: "umbes ühe nädala",
      other: "umbes {{count}} nädala"
    }
  },
  xWeeks: {
    standalone: {
      one: "üks nädal",
      other: "{{count}} nädalat"
    },
    withPreposition: {
      one: "ühe nädala",
      other: "{{count}} nädala"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "umbes üks kuu",
      other: "umbes {{count}} kuud"
    },
    withPreposition: {
      one: "umbes ühe kuu",
      other: "umbes {{count}} kuu"
    }
  },
  xMonths: {
    standalone: {
      one: "üks kuu",
      other: "{{count}} kuud"
    },
    withPreposition: {
      one: "ühe kuu",
      other: "{{count}} kuu"
    }
  },
  aboutXYears: {
    standalone: {
      one: "umbes üks aasta",
      other: "umbes {{count}} aastat"
    },
    withPreposition: {
      one: "umbes ühe aasta",
      other: "umbes {{count}} aasta"
    }
  },
  xYears: {
    standalone: {
      one: "üks aasta",
      other: "{{count}} aastat"
    },
    withPreposition: {
      one: "ühe aasta",
      other: "{{count}} aasta"
    }
  },
  overXYears: {
    standalone: {
      one: "rohkem kui üks aasta",
      other: "rohkem kui {{count}} aastat"
    },
    withPreposition: {
      one: "rohkem kui ühe aasta",
      other: "rohkem kui {{count}} aasta"
    }
  },
  almostXYears: {
    standalone: {
      one: "peaaegu üks aasta",
      other: "peaaegu {{count}} aastat"
    },
    withPreposition: {
      one: "peaaegu ühe aasta",
      other: "peaaegu {{count}} aasta"
    }
  }
}, Hge = function(e, t, n) {
  var r = n != null && n.addSuffix ? EO[e].withPreposition : EO[e].standalone, s;
  return typeof r == "string" ? s = r : t === 1 ? s = r.one : s = r.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? s + " pärast" : s + " eest" : s;
};
const Vge = Hge;
var Bge = {
  full: "EEEE, d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, Uge = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Xge = {
  full: "{{date}} 'kell' {{time}}",
  long: "{{date}} 'kell' {{time}}",
  medium: "{{date}}. {{time}}",
  short: "{{date}}. {{time}}"
}, qge = {
  date: Q({
    formats: Bge,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Uge,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Xge,
    defaultWidth: "full"
  })
};
const Yge = qge;
var Gge = {
  lastWeek: "'eelmine' eeee 'kell' p",
  yesterday: "'eile kell' p",
  today: "'täna kell' p",
  tomorrow: "'homme kell' p",
  nextWeek: "'järgmine' eeee 'kell' p",
  other: "P"
}, Qge = function(e, t, n, r) {
  return Gge[e];
};
const Kge = Qge;
var Jge = {
  narrow: ["e.m.a", "m.a.j"],
  abbreviated: ["e.m.a", "m.a.j"],
  wide: ["enne meie ajaarvamist", "meie ajaarvamise järgi"]
}, Zge = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, AO = {
  narrow: ["J", "V", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jaan", "veebr", "märts", "apr", "mai", "juuni", "juuli", "aug", "sept", "okt", "nov", "dets"],
  wide: ["jaanuar", "veebruar", "märts", "aprill", "mai", "juuni", "juuli", "august", "september", "oktoober", "november", "detsember"]
}, _O = {
  narrow: ["P", "E", "T", "K", "N", "R", "L"],
  short: ["P", "E", "T", "K", "N", "R", "L"],
  abbreviated: ["pühap.", "esmasp.", "teisip.", "kolmap.", "neljap.", "reede.", "laup."],
  wide: ["pühapäev", "esmaspäev", "teisipäev", "kolmapäev", "neljapäev", "reede", "laupäev"]
}, eye = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  }
}, tye = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  }
}, nye = function(e, t) {
  var n = Number(e);
  return n + ".";
}, rye = {
  ordinalNumber: nye,
  era: R({
    values: Jge,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Zge,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: AO,
    defaultWidth: "wide",
    formattingValues: AO,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: _O,
    defaultWidth: "wide",
    formattingValues: _O,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: R({
    values: eye,
    defaultWidth: "wide",
    formattingValues: tye,
    defaultFormattingWidth: "wide"
  })
};
const aye = rye;
var iye = /^\d+\./i, oye = /\d+/i, sye = {
  narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
}, lye = {
  any: [/^e/i, /^(m|p)/i]
}, uye = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, cye = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, dye = {
  narrow: /^[jvmasond]/i,
  abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
  wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
}, fye = {
  narrow: [/^j/i, /^v/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^v/i, /^mär/i, /^ap/i, /^mai/i, /^juun/i, /^juul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, mye = {
  narrow: /^[petknrl]/i,
  short: /^[petknrl]/i,
  abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
  wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
}, hye = {
  any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
}, pye = {
  any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
}, vye = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^keskö/i,
    noon: /^keskp/i,
    morning: /hommik/i,
    afternoon: /pärastlõuna/i,
    evening: /õhtu/i,
    night: /öö/i
  }
}, gye = {
  ordinalNumber: at({
    matchPattern: iye,
    parsePattern: oye,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: sye,
    defaultMatchWidth: "wide",
    parsePatterns: lye,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: uye,
    defaultMatchWidth: "wide",
    parsePatterns: cye,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: dye,
    defaultMatchWidth: "wide",
    parsePatterns: fye,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: mye,
    defaultMatchWidth: "wide",
    parsePatterns: hye,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: pye,
    defaultMatchWidth: "any",
    parsePatterns: vye,
    defaultParseWidth: "any"
  })
};
const yye = gye;
var bye = {
  code: "et",
  formatDistance: Vge,
  formatLong: Yge,
  formatRelative: Kge,
  localize: aye,
  match: yye,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const wye = bye;
var Pye = {
  lessThanXSeconds: {
    one: "segundo bat baino gutxiago",
    other: "{{count}} segundo baino gutxiago"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundo"
  },
  halfAMinute: "minutu erdi",
  lessThanXMinutes: {
    one: "minutu bat baino gutxiago",
    other: "{{count}} minutu baino gutxiago"
  },
  xMinutes: {
    one: "1 minutu",
    other: "{{count}} minutu"
  },
  aboutXHours: {
    one: "1 ordu gutxi gorabehera",
    other: "{{count}} ordu gutxi gorabehera"
  },
  xHours: {
    one: "1 ordu",
    other: "{{count}} ordu"
  },
  xDays: {
    one: "1 egun",
    other: "{{count}} egun"
  },
  aboutXWeeks: {
    one: "aste 1 inguru",
    other: "{{count}} aste inguru"
  },
  xWeeks: {
    one: "1 aste",
    other: "{{count}} astean"
  },
  aboutXMonths: {
    one: "1 hilabete gutxi gorabehera",
    other: "{{count}} hilabete gutxi gorabehera"
  },
  xMonths: {
    one: "1 hilabete",
    other: "{{count}} hilabete"
  },
  aboutXYears: {
    one: "1 urte gutxi gorabehera",
    other: "{{count}} urte gutxi gorabehera"
  },
  xYears: {
    one: "1 urte",
    other: "{{count}} urte"
  },
  overXYears: {
    one: "1 urte baino gehiago",
    other: "{{count}} urte baino gehiago"
  },
  almostXYears: {
    one: "ia 1 urte",
    other: "ia {{count}} urte"
  }
}, kye = function(e, t, n) {
  var r, s = Pye[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + r : "duela " + r : r;
};
const $ye = kye;
var Sye = {
  full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
  long: "y'ko' MMMM'ren' d'a'",
  medium: "y MMM d",
  short: "yy/MM/dd"
}, xye = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Cye = {
  full: "{{date}} 'tan' {{time}}",
  long: "{{date}} 'tan' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Mye = {
  date: Q({
    formats: Sye,
    defaultWidth: "full"
  }),
  time: Q({
    formats: xye,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Cye,
    defaultWidth: "full"
  })
};
const Eye = Mye;
var Aye = {
  lastWeek: "'joan den' eeee, LT",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: "eeee, p",
  other: "P"
}, _ye = {
  lastWeek: "'joan den' eeee, p",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: "eeee, p",
  other: "P"
}, Oye = function(e, t) {
  return t.getUTCHours() !== 1 ? _ye[e] : Aye[e];
};
const Tye = Oye;
var Rye = {
  narrow: ["k.a.", "k.o."],
  abbreviated: ["k.a.", "k.o."],
  wide: ["kristo aurretik", "kristo ondoren"]
}, Dye = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1H", "2H", "3H", "4H"],
  wide: ["1. hiruhilekoa", "2. hiruhilekoa", "3. hiruhilekoa", "4. hiruhilekoa"]
}, Nye = {
  narrow: ["u", "o", "m", "a", "m", "e", "u", "a", "i", "u", "a", "a"],
  abbreviated: ["urt", "ots", "mar", "api", "mai", "eka", "uzt", "abu", "ira", "urr", "aza", "abe"],
  wide: ["urtarrila", "otsaila", "martxoa", "apirila", "maiatza", "ekaina", "uztaila", "abuztua", "iraila", "urria", "azaroa", "abendua"]
}, Wye = {
  narrow: ["i", "a", "a", "a", "o", "o", "l"],
  short: ["ig", "al", "as", "az", "og", "or", "lr"],
  abbreviated: ["iga", "ast", "ast", "ast", "ost", "ost", "lar"],
  wide: ["igandea", "astelehena", "asteartea", "asteazkena", "osteguna", "ostirala", "larunbata"]
}, jye = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "ge",
    noon: "eg",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  }
}, zye = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "ge",
    noon: "eg",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  }
}, Lye = function(e, t) {
  var n = Number(e);
  return n + ".";
}, Iye = {
  ordinalNumber: Lye,
  era: R({
    values: Rye,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Dye,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Nye,
    defaultWidth: "wide"
  }),
  day: R({
    values: Wye,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: jye,
    defaultWidth: "wide",
    formattingValues: zye,
    defaultFormattingWidth: "wide"
  })
};
const Fye = Iye;
var Hye = /^(\d+)(.)?/i, Vye = /\d+/i, Bye = {
  narrow: /^(k.a.|k.o.)/i,
  abbreviated: /^(k.a.|k.o.)/i,
  wide: /^(kristo aurretik|kristo ondoren)/i
}, Uye = {
  narrow: [/^k.a./i, /^k.o./i],
  abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
  wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i]
}, Xye = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]H/i,
  wide: /^[1234](.)? hiruhilekoa/i
}, qye = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Yye = {
  narrow: /^[uomaei]/i,
  abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
  wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
}, Gye = {
  narrow: [/^u/i, /^o/i, /^m/i, /^a/i, /^m/i, /^e/i, /^u/i, /^a/i, /^i/i, /^u/i, /^a/i, /^a/i],
  any: [/^urt/i, /^ots/i, /^mar/i, /^api/i, /^mai/i, /^eka/i, /^uzt/i, /^abu/i, /^ira/i, /^urr/i, /^aza/i, /^abe/i]
}, Qye = {
  narrow: /^[iaol]/i,
  short: /^(ig|al|as|az|og|or|lr)/i,
  abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
  wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
}, Kye = {
  narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
  short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
  abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],
  wide: [/^igandea/i, /^astelehena/i, /^asteartea/i, /^asteazkena/i, /^osteguna/i, /^ostirala/i, /^larunbata/i]
}, Jye = {
  narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
  any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
}, Zye = {
  narrow: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^ge/i,
    noon: /^eg/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i
  },
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^gauerdia/i,
    noon: /^eguerdia/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i
  }
}, ebe = {
  ordinalNumber: at({
    matchPattern: Hye,
    parsePattern: Vye,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Bye,
    defaultMatchWidth: "wide",
    parsePatterns: Uye,
    defaultParseWidth: "wide"
  }),
  quarter: D({
    matchPatterns: Xye,
    defaultMatchWidth: "wide",
    parsePatterns: qye,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Yye,
    defaultMatchWidth: "wide",
    parsePatterns: Gye,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Qye,
    defaultMatchWidth: "wide",
    parsePatterns: Kye,
    defaultParseWidth: "wide"
  }),
  dayPeriod: D({
    matchPatterns: Jye,
    defaultMatchWidth: "any",
    parsePatterns: Zye,
    defaultParseWidth: "any"
  })
};
const tbe = ebe;
var nbe = {
  code: "eu",
  formatDistance: $ye,
  formatLong: Eye,
  formatRelative: Tye,
  localize: Fye,
  match: tbe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const rbe = nbe;
var abe = {
  lessThanXSeconds: {
    one: "کمتر از یک ثانیه",
    other: "کمتر از {{count}} ثانیه"
  },
  xSeconds: {
    one: "1 ثانیه",
    other: "{{count}} ثانیه"
  },
  halfAMinute: "نیم دقیقه",
  lessThanXMinutes: {
    one: "کمتر از یک دقیقه",
    other: "کمتر از {{count}} دقیقه"
  },
  xMinutes: {
    one: "1 دقیقه",
    other: "{{count}} دقیقه"
  },
  aboutXHours: {
    one: "حدود 1 ساعت",
    other: "حدود {{count}} ساعت"
  },
  xHours: {
    one: "1 ساعت",
    other: "{{count}} ساعت"
  },
  xDays: {
    one: "1 روز",
    other: "{{count}} روز"
  },
  aboutXWeeks: {
    one: "حدود 1 هفته",
    other: "حدود {{count}} هفته"
  },
  xWeeks: {
    one: "1 هفته",
    other: "{{count}} هفته"
  },
  aboutXMonths: {
    one: "حدود 1 ماه",
    other: "حدود {{count}} ماه"
  },
  xMonths: {
    one: "1 ماه",
    other: "{{count}} ماه"
  },
  aboutXYears: {
    one: "حدود 1 سال",
    other: "حدود {{count}} سال"
  },
  xYears: {
    one: "1 سال",
    other: "{{count}} سال"
  },
  overXYears: {
    one: "بیشتر از 1 سال",
    other: "بیشتر از {{count}} سال"
  },
  almostXYears: {
    one: "نزدیک 1 سال",
    other: "نزدیک {{count}} سال"
  }
}, ibe = function(e, t, n) {
  var r, s = abe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "در " + r : r + " قبل" : r;
};
const obe = ibe;
var sbe = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "yyyy/MM/dd"
}, lbe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ube = {
  full: "{{date}} 'در' {{time}}",
  long: "{{date}} 'در' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, cbe = {
  date: Q({
    formats: sbe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: lbe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: ube,
    defaultWidth: "full"
  })
};
const dbe = cbe;
var fbe = {
  lastWeek: "eeee 'گذشته در' p",
  yesterday: "'دیروز در' p",
  today: "'امروز در' p",
  tomorrow: "'فردا در' p",
  nextWeek: "eeee 'در' p",
  other: "P"
}, mbe = function(e, t, n, r) {
  return fbe[e];
};
const hbe = mbe;
var pbe = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل از میلاد", "بعد از میلاد"]
}, vbe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["س‌م1", "س‌م2", "س‌م3", "س‌م4"],
  wide: ["سه‌ماهه 1", "سه‌ماهه 2", "سه‌ماهه 3", "سه‌ماهه 4"]
}, gbe = {
  narrow: ["ژ", "ف", "م", "آ", "م", "ج", "ج", "آ", "س", "ا", "ن", "د"],
  abbreviated: ["ژانـ", "فور", "مارس", "آپر", "می", "جون", "جولـ", "آگو", "سپتـ", "اکتـ", "نوامـ", "دسامـ"],
  wide: ["ژانویه", "فوریه", "مارس", "آپریل", "می", "جون", "جولای", "آگوست", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"]
}, ybe = {
  narrow: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
  short: ["1ش", "2ش", "3ش", "4ش", "5ش", "ج", "ش"],
  abbreviated: ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"],
  wide: ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"]
}, bbe = {
  narrow: {
    am: "ق",
    pm: "ب",
    midnight: "ن",
    noon: "ظ",
    morning: "ص",
    afternoon: "ب.ظ.",
    evening: "ع",
    night: "ش"
  },
  abbreviated: {
    am: "ق.ظ.",
    pm: "ب.ظ.",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  },
  wide: {
    am: "قبل‌ازظهر",
    pm: "بعدازظهر",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  }
}, wbe = {
  narrow: {
    am: "ق",
    pm: "ب",
    midnight: "ن",
    noon: "ظ",
    morning: "ص",
    afternoon: "ب.ظ.",
    evening: "ع",
    night: "ش"
  },
  abbreviated: {
    am: "ق.ظ.",
    pm: "ب.ظ.",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  },
  wide: {
    am: "قبل‌ازظهر",
    pm: "بعدازظهر",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  }
}, Pbe = function(e, t) {
  return String(e);
}, kbe = {
  ordinalNumber: Pbe,
  era: R({
    values: pbe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: vbe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: gbe,
    defaultWidth: "wide"
  }),
  day: R({
    values: ybe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: bbe,
    defaultWidth: "wide",
    formattingValues: wbe,
    defaultFormattingWidth: "wide"
  })
};
const $be = kbe;
var Sbe = /^(\d+)(th|st|nd|rd)?/i, xbe = /\d+/i, Cbe = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
  wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
}, Mbe = {
  any: [/^قبل/i, /^بعد/i]
}, Ebe = {
  narrow: /^[1234]/i,
  abbreviated: /^س‌م[1234]/i,
  wide: /^سه‌ماهه [1234]/i
}, Abe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _be = {
  narrow: /^[جژفمآاماسند]/i,
  abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
  wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
}, Obe = {
  narrow: [/^(ژ|ج)/i, /^ف/i, /^م/i, /^(آ|ا)/i, /^م/i, /^(ژ|ج)/i, /^(ج|ژ)/i, /^(آ|ا)/i, /^س/i, /^ا/i, /^ن/i, /^د/i],
  any: [/^ژا/i, /^ف/i, /^ما/i, /^آپ/i, /^(می|مه)/i, /^(ژوئن|جون)/i, /^(ژوئی|جول)/i, /^(اوت|آگ)/i, /^س/i, /^(اوک|اک)/i, /^ن/i, /^د/i]
}, Tbe = {
  narrow: /^[شیدسچپج]/i,
  short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
  abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
  wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
}, Rbe = {
  narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [/^(ی|1ش|یکشنبه)/i, /^(د|2ش|دوشنبه)/i, /^(س|3ش|سه‌شنبه)/i, /^(چ|4ش|چهارشنبه)/i, /^(پ|5ش|پنجشنبه)/i, /^(ج|جمعه)/i, /^(ش|شنبه)/i]
}, Dbe = {
  narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
  abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
  wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
}, Nbe = {
  any: {
    am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
    pm: /^(ب|ب.ظ.|بعدازظهر)/i,
    midnight: /^(‌نیمه‌شب|ن)/i,
    noon: /^(ظ|ظهر)/i,
    morning: /(ص|صبح)/i,
    afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
    evening: /(ع|عصر)/i,
    night: /(ش|شب)/i
  }
}, Wbe = {
  ordinalNumber: at({
    matchPattern: Sbe,
    parsePattern: xbe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Cbe,
    defaultMatchWidth: "wide",
    parsePatterns: Mbe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Ebe,
    defaultMatchWidth: "wide",
    parsePatterns: Abe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: _be,
    defaultMatchWidth: "wide",
    parsePatterns: Obe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Tbe,
    defaultMatchWidth: "wide",
    parsePatterns: Rbe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Dbe,
    defaultMatchWidth: "wide",
    parsePatterns: Nbe,
    defaultParseWidth: "any"
  })
};
const jbe = Wbe;
var zbe = {
  code: "fa-IR",
  formatDistance: obe,
  formatLong: dbe,
  formatRelative: hbe,
  localize: $be,
  match: jbe,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
};
const Lbe = zbe;
function OO(e) {
  return e.replace(/sekuntia?/, "sekunnin");
}
function TO(e) {
  return e.replace(/minuuttia?/, "minuutin");
}
function RO(e) {
  return e.replace(/tuntia?/, "tunnin");
}
function Ibe(e) {
  return e.replace(/päivää?/, "päivän");
}
function DO(e) {
  return e.replace(/(viikko|viikkoa)/, "viikon");
}
function NO(e) {
  return e.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function Nb(e) {
  return e.replace(/(vuosi|vuotta)/, "vuoden");
}
var Fbe = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: OO
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: OO
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: function(e) {
      return "puolen minuutin";
    }
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: TO
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: TO
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: RO
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: RO
  },
  xDays: {
    one: "päivä",
    other: "{{count}} päivää",
    futureTense: Ibe
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: DO
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: DO
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: NO
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: NO
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: Nb
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: Nb
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: Nb
  },
  almostXYears: {
    one: "lähes vuosi",
    other: "lähes {{count}} vuotta",
    futureTense: Nb
  }
}, Hbe = function(e, t, n) {
  var r = Fbe[e], s = t === 1 ? r.one : r.other.replace("{{count}}", String(t));
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r.futureTense(s) + " kuluttua" : s + " sitten" : s;
};
const Vbe = Hbe;
var Bbe = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y"
}, Ube = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm"
}, Xbe = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, qbe = {
  date: Q({
    formats: Bbe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Ube,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Xbe,
    defaultWidth: "full"
  })
};
const Ybe = qbe;
var Gbe = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'tänään klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P"
}, Qbe = function(e, t, n, r) {
  return Gbe[e];
};
const Kbe = Qbe;
var Jbe = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "jälkeen ajanlaskun alun"]
}, Zbe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
}, eS = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kesä", "heinä", "elo", "syys", "loka", "marras", "joulu"],
  wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
}, e1e = {
  narrow: eS.narrow,
  abbreviated: eS.abbreviated,
  wide: ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kesäkuuta", "heinäkuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"]
}, Kb = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
  wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
}, t1e = {
  narrow: Kb.narrow,
  short: Kb.short,
  abbreviated: Kb.abbreviated,
  wide: ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"]
}, n1e = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyöllä",
    noon: "keskipäivällä",
    morning: "aamupäivällä",
    afternoon: "iltapäivällä",
    evening: "illalla",
    night: "yöllä"
  }
}, r1e = function(e, t) {
  var n = Number(e);
  return n + ".";
}, a1e = {
  ordinalNumber: r1e,
  era: R({
    values: Jbe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Zbe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: eS,
    defaultWidth: "wide",
    formattingValues: e1e,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: Kb,
    defaultWidth: "wide",
    formattingValues: t1e,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: R({
    values: n1e,
    defaultWidth: "wide"
  })
};
const i1e = a1e;
var o1e = /^(\d+)(\.)/i, s1e = /\d+/i, l1e = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
}, u1e = {
  any: [/^e/i, /^j/i]
}, c1e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
}, d1e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, f1e = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
}, m1e = {
  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
}, h1e = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
}, p1e = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
}, v1e = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
}, g1e = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
}, y1e = {
  ordinalNumber: at({
    matchPattern: o1e,
    parsePattern: s1e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: l1e,
    defaultMatchWidth: "wide",
    parsePatterns: u1e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: c1e,
    defaultMatchWidth: "wide",
    parsePatterns: d1e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: f1e,
    defaultMatchWidth: "wide",
    parsePatterns: m1e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: h1e,
    defaultMatchWidth: "wide",
    parsePatterns: p1e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: v1e,
    defaultMatchWidth: "any",
    parsePatterns: g1e,
    defaultParseWidth: "any"
  })
};
const b1e = y1e;
var w1e = {
  code: "fi",
  formatDistance: Vbe,
  formatLong: Ybe,
  formatRelative: Kbe,
  localize: i1e,
  match: b1e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const P1e = w1e;
var k1e = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, $1e = function(e, t, n) {
  var r, s = k1e[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "dans " + r : "il y a " + r : r;
};
const fx = $1e;
var S1e = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, x1e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, C1e = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, M1e = {
  date: Q({
    formats: S1e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: x1e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: C1e,
    defaultWidth: "full"
  })
};
const E1e = M1e;
var A1e = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, _1e = function(e, t, n, r) {
  return A1e[e];
};
const vW = _1e;
var O1e = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, T1e = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, R1e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
}, D1e = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
}, N1e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, W1e = function(e, t) {
  var n = Number(e), r = t == null ? void 0 : t.unit;
  if (n === 0)
    return "0";
  var s = ["year", "week", "hour", "minute", "second"], f;
  return n === 1 ? f = r && s.includes(r) ? "ère" : "er" : f = "ème", n + f;
}, j1e = {
  ordinalNumber: W1e,
  era: R({
    values: O1e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: T1e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: R1e,
    defaultWidth: "wide"
  }),
  day: R({
    values: D1e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: N1e,
    defaultWidth: "wide"
  })
};
const mx = j1e;
var z1e = /^(\d+)(ième|ère|ème|er|e)?/i, L1e = /\d+/i, I1e = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, F1e = {
  any: [/^av/i, /^ap/i]
}, H1e = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, V1e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, B1e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, U1e = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, X1e = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, q1e = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, Y1e = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, G1e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, Q1e = {
  ordinalNumber: at({
    matchPattern: z1e,
    parsePattern: L1e,
    valueCallback: function(e) {
      return parseInt(e);
    }
  }),
  era: D({
    matchPatterns: I1e,
    defaultMatchWidth: "wide",
    parsePatterns: F1e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: H1e,
    defaultMatchWidth: "wide",
    parsePatterns: V1e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: B1e,
    defaultMatchWidth: "wide",
    parsePatterns: U1e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: X1e,
    defaultMatchWidth: "wide",
    parsePatterns: q1e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Y1e,
    defaultMatchWidth: "any",
    parsePatterns: G1e,
    defaultParseWidth: "any"
  })
};
const hx = Q1e;
var K1e = {
  code: "fr",
  formatDistance: fx,
  formatLong: E1e,
  formatRelative: vW,
  localize: mx,
  match: hx,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const J1e = K1e;
var Z1e = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "yy-MM-dd"
}, ewe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, twe = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, nwe = {
  date: Q({
    formats: Z1e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: ewe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: twe,
    defaultWidth: "full"
  })
};
const rwe = nwe;
var awe = {
  code: "fr-CA",
  formatDistance: fx,
  formatLong: rwe,
  formatRelative: vW,
  localize: mx,
  match: hx,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const iwe = awe;
var owe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, swe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, lwe = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, uwe = {
  date: Q({
    formats: owe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: swe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: lwe,
    defaultWidth: "full"
  })
};
const cwe = uwe;
var dwe = {
  lastWeek: "eeee 'la semaine dernière à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'la semaine prochaine à' p",
  other: "P"
}, fwe = function(e, t, n, r) {
  return dwe[e];
};
const mwe = fwe;
var hwe = {
  code: "fr-CH",
  formatDistance: fx,
  formatLong: cwe,
  formatRelative: mwe,
  localize: mx,
  match: hx,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const pwe = hwe;
var vwe = {
  lessThanXSeconds: {
    one: "minder as 1 sekonde",
    other: "minder as {{count}} sekonden"
  },
  xSeconds: {
    one: "1 sekonde",
    other: "{{count}} sekonden"
  },
  halfAMinute: "oardel minút",
  lessThanXMinutes: {
    one: "minder as 1 minút",
    other: "minder as {{count}} minuten"
  },
  xMinutes: {
    one: "1 minút",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "sawat 1 oere",
    other: "sawat {{count}} oere"
  },
  xHours: {
    one: "1 oere",
    other: "{{count}} oere"
  },
  xDays: {
    one: "1 dei",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "sawat 1 wike",
    other: "sawat {{count}} wiken"
  },
  xWeeks: {
    one: "1 wike",
    other: "{{count}} wiken"
  },
  aboutXMonths: {
    one: "sawat 1 moanne",
    other: "sawat {{count}} moannen"
  },
  xMonths: {
    one: "1 moanne",
    other: "{{count}} moannen"
  },
  aboutXYears: {
    one: "sawat 1 jier",
    other: "sawat {{count}} jier"
  },
  xYears: {
    one: "1 jier",
    other: "{{count}} jier"
  },
  overXYears: {
    one: "mear as 1 jier",
    other: "mear as {{count}}s jier"
  },
  almostXYears: {
    one: "hast 1 jier",
    other: "hast {{count}} jier"
  }
}, gwe = function(e, t, n) {
  var r, s = vwe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "oer " + r : r + " lyn" : r;
};
const ywe = gwe;
var bwe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, wwe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Pwe = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, kwe = {
  date: Q({
    formats: bwe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: wwe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Pwe,
    defaultWidth: "full"
  })
};
const $we = kwe;
var Swe = {
  lastWeek: "'ôfrûne' eeee 'om' p",
  yesterday: "'juster om' p",
  today: "'hjoed om' p",
  tomorrow: "'moarn om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, xwe = function(e, t, n, r) {
  return Swe[e];
};
const Cwe = xwe;
var Mwe = {
  narrow: ["f.K.", "n.K."],
  abbreviated: ["f.Kr.", "n.Kr."],
  wide: ["foar Kristus", "nei Kristus"]
}, Ewe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e fearnsjier", "2e fearnsjier", "3e fearnsjier", "4e fearnsjier"]
}, Awe = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mai.", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["jannewaris", "febrewaris", "maart", "april", "maaie", "juny", "july", "augustus", "septimber", "oktober", "novimber", "desimber"]
}, _we = {
  narrow: ["s", "m", "t", "w", "t", "f", "s"],
  short: ["si", "mo", "ti", "wo", "to", "fr", "so"],
  abbreviated: ["snein", "moa", "tii", "woa", "ton", "fre", "sneon"],
  wide: ["snein", "moandei", "tiisdei", "woansdei", "tongersdei", "freed", "sneon"]
}, Owe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts"
  }
}, Twe = function(e, t) {
  var n = Number(e);
  return n + "e";
}, Rwe = {
  ordinalNumber: Twe,
  era: R({
    values: Mwe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Ewe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Awe,
    defaultWidth: "wide"
  }),
  day: R({
    values: _we,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Owe,
    defaultWidth: "wide"
  })
};
const Dwe = Rwe;
var Nwe = /^(\d+)e?/i, Wwe = /\d+/i, jwe = {
  narrow: /^([fn]\.? ?K\.?)/,
  abbreviated: /^([fn]\. ?Kr\.?)/,
  wide: /^((foar|nei) Kristus)/
}, zwe = {
  any: [/^f/, /^n/]
}, Lwe = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e fearnsjier/i
}, Iwe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Fwe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
  wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
}, Hwe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^des/i]
}, Vwe = {
  narrow: /^[smtwf]/i,
  short: /^(si|mo|ti|wo|to|fr|so)/i,
  abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
  wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
}, Bwe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^sn/i, /^mo/i, /^ti/i, /^wo/i, /^to/i, /^fr/i, /^sn/i]
}, Uwe = {
  any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
}, Xwe = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^middei/i,
    morning: /moarns/i,
    afternoon: /^middeis/i,
    evening: /jûns/i,
    night: /nachts/i
  }
}, qwe = {
  ordinalNumber: at({
    matchPattern: Nwe,
    parsePattern: Wwe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: jwe,
    defaultMatchWidth: "wide",
    parsePatterns: zwe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Lwe,
    defaultMatchWidth: "wide",
    parsePatterns: Iwe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Fwe,
    defaultMatchWidth: "wide",
    parsePatterns: Hwe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Vwe,
    defaultMatchWidth: "wide",
    parsePatterns: Bwe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Uwe,
    defaultMatchWidth: "any",
    parsePatterns: Xwe,
    defaultParseWidth: "any"
  })
};
const Ywe = qwe;
var Gwe = {
  code: "fy",
  formatDistance: ywe,
  formatLong: $we,
  formatRelative: Cwe,
  localize: Dwe,
  match: Ywe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Qwe = Gwe;
var Kwe = {
  lessThanXSeconds: {
    one: "nas lugha na diog",
    other: "nas lugha na {{count}} diogan"
  },
  xSeconds: {
    one: "1 diog",
    two: "2 dhiog",
    twenty: "20 diog",
    other: "{{count}} diogan"
  },
  halfAMinute: "leth mhionaid",
  lessThanXMinutes: {
    one: "nas lugha na mionaid",
    other: "nas lugha na {{count}} mionaidean"
  },
  xMinutes: {
    one: "1 mionaid",
    two: "2 mhionaid",
    twenty: "20 mionaid",
    other: "{{count}} mionaidean"
  },
  aboutXHours: {
    one: "mu uair de thìde",
    other: "mu {{count}} uairean de thìde"
  },
  xHours: {
    one: "1 uair de thìde",
    two: "2 uair de thìde",
    twenty: "20 uair de thìde",
    other: "{{count}} uairean de thìde"
  },
  xDays: {
    one: "1 là",
    other: "{{count}} là"
  },
  aboutXWeeks: {
    one: "mu 1 seachdain",
    other: "mu {{count}} seachdainean"
  },
  xWeeks: {
    one: "1 seachdain",
    other: "{{count}} seachdainean"
  },
  aboutXMonths: {
    one: "mu mhìos",
    other: "mu {{count}} mìosan"
  },
  xMonths: {
    one: "1 mìos",
    other: "{{count}} mìosan"
  },
  aboutXYears: {
    one: "mu bhliadhna",
    other: "mu {{count}} bliadhnaichean"
  },
  xYears: {
    one: "1 bhliadhna",
    other: "{{count}} bliadhna"
  },
  overXYears: {
    one: "còrr is bliadhna",
    other: "còrr is {{count}} bliadhnaichean"
  },
  almostXYears: {
    one: "cha mhòr bliadhna",
    other: "cha mhòr {{count}} bliadhnaichean"
  }
}, Jwe = function(e, t, n) {
  var r, s = Kwe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : t === 2 && s.two ? r = s.two : t === 20 && s.twenty ? r = s.twenty : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "ann an " + r : "o chionn " + r : r;
};
const Zwe = Jwe;
var e0e = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, t0e = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, n0e = {
  full: "{{date}} 'aig' {{time}}",
  long: "{{date}} 'aig' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, r0e = {
  date: Q({
    formats: e0e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: t0e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: n0e,
    defaultWidth: "full"
  })
};
const a0e = r0e;
var i0e = {
  lastWeek: "'mu dheireadh' eeee 'aig' p",
  yesterday: "'an-dè aig' p",
  today: "'an-diugh aig' p",
  tomorrow: "'a-màireach aig' p",
  nextWeek: "eeee 'aig' p",
  other: "P"
}, o0e = function(e, t, n, r) {
  return i0e[e];
};
const s0e = o0e;
var l0e = {
  narrow: ["R", "A"],
  abbreviated: ["RC", "AD"],
  wide: ["ro Chrìosta", "anno domini"]
}, u0e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["C1", "C2", "C3", "C4"],
  wide: ["a' chiad chairteal", "an dàrna cairteal", "an treas cairteal", "an ceathramh cairteal"]
}, c0e = {
  narrow: ["F", "G", "M", "G", "C", "Ò", "I", "L", "S", "D", "S", "D"],
  abbreviated: ["Faoi", "Gear", "Màrt", "Gibl", "Cèit", "Ògmh", "Iuch", "Lùn", "Sult", "Dàmh", "Samh", "Dùbh"],
  wide: ["Am Faoilleach", "An Gearran", "Am Màrt", "An Giblean", "An Cèitean", "An t-Ògmhios", "An t-Iuchar", "An Lùnastal", "An t-Sultain", "An Dàmhair", "An t-Samhain", "An Dùbhlachd"]
}, d0e = {
  narrow: ["D", "L", "M", "C", "A", "H", "S"],
  short: ["Dò", "Lu", "Mà", "Ci", "Ar", "Ha", "Sa"],
  abbreviated: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
  wide: ["Didòmhnaich", "Diluain", "Dimàirt", "Diciadain", "Diardaoin", "Dihaoine", "Disathairne"]
}, f0e = {
  narrow: {
    am: "m",
    pm: "f",
    midnight: "m.o.",
    noon: "m.l.",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche"
  },
  abbreviated: {
    am: "M.",
    pm: "F.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche"
  },
  wide: {
    am: "m.",
    pm: "f.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche"
  }
}, m0e = {
  narrow: {
    am: "m",
    pm: "f",
    midnight: "m.o.",
    noon: "m.l.",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche"
  },
  abbreviated: {
    am: "M.",
    pm: "F.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche"
  },
  wide: {
    am: "m.",
    pm: "f.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche"
  }
}, h0e = function(e) {
  var t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "d";
      case 2:
        return t + "na";
    }
  return n === 12 ? t + "na" : t + "mh";
}, p0e = {
  ordinalNumber: h0e,
  era: R({
    values: l0e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: u0e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: c0e,
    defaultWidth: "wide"
  }),
  day: R({
    values: d0e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: f0e,
    defaultWidth: "wide",
    formattingValues: m0e,
    defaultFormattingWidth: "wide"
  })
};
const v0e = p0e;
var g0e = /^(\d+)(d|na|tr|mh)?/i, y0e = /\d+/i, b0e = {
  narrow: /^(r|a)/i,
  abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
  wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
}, w0e = {
  any: [/^b/i, /^(a|c)/i]
}, P0e = {
  narrow: /^[1234]/i,
  abbreviated: /^c[1234]/i,
  wide: /^[1234](cd|na|tr|mh)? cairteal/i
}, k0e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $0e = {
  narrow: /^[fgmcòilsd]/i,
  abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
  wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
}, S0e = {
  narrow: [/^f/i, /^g/i, /^m/i, /^g/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^s/i, /^d/i, /^s/i, /^d/i],
  any: [/^fa/i, /^ge/i, /^mà/i, /^gi/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^su/i, /^d/i, /^sa/i, /^d/i]
}, x0e = {
  narrow: /^[dlmcahs]/i,
  short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
  abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
  wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
}, C0e = {
  narrow: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
  any: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i]
}, M0e = {
  narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
  any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
}, E0e = {
  any: {
    am: /^m/i,
    pm: /^f/i,
    midnight: /^meadhan oidhche/i,
    noon: /^meadhan là/i,
    morning: /sa mhadainn/i,
    afternoon: /feasgar/i,
    evening: /feasgar/i,
    night: /air an oidhche/i
  }
}, A0e = {
  ordinalNumber: at({
    matchPattern: g0e,
    parsePattern: y0e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: b0e,
    defaultMatchWidth: "wide",
    parsePatterns: w0e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: P0e,
    defaultMatchWidth: "wide",
    parsePatterns: k0e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: $0e,
    defaultMatchWidth: "wide",
    parsePatterns: S0e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: x0e,
    defaultMatchWidth: "wide",
    parsePatterns: C0e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: M0e,
    defaultMatchWidth: "any",
    parsePatterns: E0e,
    defaultParseWidth: "any"
  })
};
const _0e = A0e;
var O0e = {
  code: "gd",
  formatDistance: Zwe,
  formatLong: a0e,
  formatRelative: s0e,
  localize: v0e,
  match: _0e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const T0e = O0e;
var R0e = {
  lessThanXSeconds: {
    one: "menos dun segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos dun minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "arredor dunha hora",
    other: "arredor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "arredor dunha semana",
    other: "arredor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "arredor de 1 mes",
    other: "arredor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "arredor dun ano",
    other: "arredor de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "máis dun ano",
    other: "máis de {{count}} anos"
  },
  almostXYears: {
    one: "case un ano",
    other: "case {{count}} anos"
  }
}, D0e = function(e, t, n) {
  var r, s = R0e[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + r : "hai " + r : r;
};
const N0e = D0e;
var W0e = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, j0e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, z0e = {
  full: "{{date}} 'ás' {{time}}",
  long: "{{date}} 'ás' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, L0e = {
  date: Q({
    formats: W0e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: j0e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: z0e,
    defaultWidth: "full"
  })
};
const I0e = L0e;
var F0e = {
  lastWeek: "'o' eeee 'pasado á' LT",
  yesterday: "'onte á' p",
  today: "'hoxe á' p",
  tomorrow: "'mañá á' p",
  nextWeek: "eeee 'á' p",
  other: "P"
}, H0e = {
  lastWeek: "'o' eeee 'pasado ás' p",
  yesterday: "'onte ás' p",
  today: "'hoxe ás' p",
  tomorrow: "'mañá ás' p",
  nextWeek: "eeee 'ás' p",
  other: "P"
}, V0e = function(e, t, n, r) {
  return t.getUTCHours() !== 1 ? H0e[e] : F0e[e];
};
const B0e = V0e;
var U0e = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "despois de cristo"]
}, X0e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, q0e = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["xan", "feb", "mar", "abr", "mai", "xun", "xul", "ago", "set", "out", "nov", "dec"],
  wide: ["xaneiro", "febreiro", "marzo", "abril", "maio", "xuño", "xullo", "agosto", "setembro", "outubro", "novembro", "decembro"]
}, Y0e = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "me", "xo", "ve", "sa"],
  abbreviated: ["dom", "lun", "mar", "mer", "xov", "ven", "sab"],
  wide: ["domingo", "luns", "martes", "mércores", "xoves", "venres", "sábado"]
}, G0e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tardiña",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tardiña",
    night: "noite"
  }
}, Q0e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  }
}, K0e = function(e, t) {
  var n = Number(e);
  return n + "º";
}, J0e = {
  ordinalNumber: K0e,
  era: R({
    values: U0e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: X0e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: q0e,
    defaultWidth: "wide"
  }),
  day: R({
    values: Y0e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: G0e,
    defaultWidth: "wide",
    formattingValues: Q0e,
    defaultFormattingWidth: "wide"
  })
};
const Z0e = J0e;
var ePe = /^(\d+)(º)?/i, tPe = /\d+/i, nPe = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
}, rPe = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era com[uú]n)/i, /^(despois de cristo|era com[uú]n)/i]
}, aPe = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, iPe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, oPe = {
  narrow: /^[xfmasond]/i,
  abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
  wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
}, sPe = {
  narrow: [/^x/i, /^f/i, /^m/i, /^a/i, /^m/i, /^x/i, /^x/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^xan/i, /^feb/i, /^mar/i, /^abr/i, /^mai/i, /^xun/i, /^xul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dec/i]
}, lPe = {
  narrow: /^[dlmxvs]/i,
  short: /^(do|lu|ma|me|xo|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
  wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
}, uPe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i]
}, cPe = {
  narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
}, dPe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañ[aá]/i,
    afternoon: /tarde/i,
    evening: /tardiña/i,
    night: /noite/i
  }
}, fPe = {
  ordinalNumber: at({
    matchPattern: ePe,
    parsePattern: tPe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: nPe,
    defaultMatchWidth: "wide",
    parsePatterns: rPe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: aPe,
    defaultMatchWidth: "wide",
    parsePatterns: iPe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: oPe,
    defaultMatchWidth: "wide",
    parsePatterns: sPe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: lPe,
    defaultMatchWidth: "wide",
    parsePatterns: uPe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: cPe,
    defaultMatchWidth: "any",
    parsePatterns: dPe,
    defaultParseWidth: "any"
  })
};
const mPe = fPe;
var hPe = {
  code: "gl",
  formatDistance: N0e,
  formatLong: I0e,
  formatRelative: B0e,
  localize: Z0e,
  match: mPe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const pPe = hPe;
var vPe = {
  lessThanXSeconds: {
    one: "હમણાં",
    other: "​આશરે {{count}} સેકંડ"
  },
  xSeconds: {
    one: "1 સેકંડ",
    other: "{{count}} સેકંડ"
  },
  halfAMinute: "અડધી મિનિટ",
  lessThanXMinutes: {
    one: "આ મિનિટ",
    other: "​આશરે {{count}} મિનિટ"
  },
  xMinutes: {
    one: "1 મિનિટ",
    other: "{{count}} મિનિટ"
  },
  aboutXHours: {
    one: "​આશરે 1 કલાક",
    other: "​આશરે {{count}} કલાક"
  },
  xHours: {
    one: "1 કલાક",
    other: "{{count}} કલાક"
  },
  xDays: {
    one: "1 દિવસ",
    other: "{{count}} દિવસ"
  },
  aboutXWeeks: {
    one: "આશરે 1 અઠવાડિયું",
    other: "આશરે {{count}} અઠવાડિયા"
  },
  xWeeks: {
    one: "1 અઠવાડિયું",
    other: "{{count}} અઠવાડિયા"
  },
  aboutXMonths: {
    one: "આશરે 1 મહિનો",
    other: "આશરે {{count}} મહિના"
  },
  xMonths: {
    one: "1 મહિનો",
    other: "{{count}} મહિના"
  },
  aboutXYears: {
    one: "આશરે 1 વર્ષ",
    other: "આશરે {{count}} વર્ષ"
  },
  xYears: {
    one: "1 વર્ષ",
    other: "{{count}} વર્ષ"
  },
  overXYears: {
    one: "1 વર્ષથી વધુ",
    other: "{{count}} વર્ષથી વધુ"
  },
  almostXYears: {
    one: "લગભગ 1 વર્ષ",
    other: "લગભગ {{count}} વર્ષ"
  }
}, gPe = function(e, t, n) {
  var r, s = vPe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + "માં" : r + " પહેલાં" : r;
};
const yPe = gPe;
var bPe = {
  full: "EEEE, d MMMM, y",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "d/M/yy"
}, wPe = {
  full: "hh:mm:ss a zzzz",
  long: "hh:mm:ss a z",
  medium: "hh:mm:ss a",
  short: "hh:mm a"
}, PPe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, kPe = {
  date: Q({
    formats: bPe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: wPe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: PPe,
    defaultWidth: "full"
  })
};
const $Pe = kPe;
var SPe = {
  lastWeek: "'પાછલા' eeee p",
  yesterday: "'ગઈકાલે' p",
  today: "'આજે' p",
  tomorrow: "'આવતીકાલે' p",
  nextWeek: "eeee p",
  other: "P"
}, xPe = function(e, t, n, r) {
  return SPe[e];
};
const CPe = xPe;
var MPe = {
  narrow: ["ઈસપૂ", "ઈસ"],
  abbreviated: ["ઈ.સ.પૂર્વે", "ઈ.સ."],
  wide: ["ઈસવીસન પૂર્વે", "ઈસવીસન"]
}, EPe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1લો ત્રિમાસ", "2જો ત્રિમાસ", "3જો ત્રિમાસ", "4થો ત્રિમાસ"]
}, APe = {
  narrow: ["જા", "ફે", "મા", "એ", "મે", "જૂ", "જુ", "ઓ", "સ", "ઓ", "ન", "ડિ"],
  abbreviated: ["જાન્યુ", "ફેબ્રુ", "માર્ચ", "એપ્રિલ", "મે", "જૂન", "જુલાઈ", "ઑગસ્ટ", "સપ્ટે", "ઓક્ટો", "નવે", "ડિસે"],
  wide: ["જાન્યુઆરી", "ફેબ્રુઆરી", "માર્ચ", "એપ્રિલ", "મે", "જૂન", "જુલાઇ", "ઓગસ્ટ", "સપ્ટેમ્બર", "ઓક્ટોબર", "નવેમ્બર", "ડિસેમ્બર"]
}, _Pe = {
  narrow: ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"],
  short: ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"],
  abbreviated: ["રવિ", "સોમ", "મંગળ", "બુધ", "ગુરુ", "શુક્ર", "શનિ"],
  wide: [
    "રવિવાર",
    "સોમવાર",
    "મંગળવાર",
    "બુધવાર",
    "ગુરુવાર",
    "શુક્રવાર",
    "શનિવાર"
  ]
}, OPe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "મ.રાત્રિ",
    noon: "બ.",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  }
}, TPe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "મ.રાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  }
}, RPe = function(e, t) {
  return String(e);
}, DPe = {
  ordinalNumber: RPe,
  era: R({
    values: MPe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: EPe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: APe,
    defaultWidth: "wide"
  }),
  day: R({
    values: _Pe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: OPe,
    defaultWidth: "wide",
    formattingValues: TPe,
    defaultFormattingWidth: "wide"
  })
};
const NPe = DPe;
var WPe = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i, jPe = /\d+/i, zPe = {
  narrow: /^(ઈસપૂ|ઈસ)/i,
  abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
  wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
}, LPe = {
  any: [/^ઈસપૂ/i, /^ઈસ/i]
}, IPe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
}, FPe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, HPe = {
  narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
  abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
  wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
}, VPe = {
  narrow: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i],
  any: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i]
}, BPe = {
  narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
  wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
}, UPe = {
  narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
  any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i]
}, XPe = {
  narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
  any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
}, qPe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^મ\.?/i,
    noon: /^બ/i,
    morning: /સ/i,
    afternoon: /બ/i,
    evening: /સાં/i,
    night: /રા/i
  }
}, YPe = {
  ordinalNumber: at({
    matchPattern: WPe,
    parsePattern: jPe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: zPe,
    defaultMatchWidth: "wide",
    parsePatterns: LPe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: IPe,
    defaultMatchWidth: "wide",
    parsePatterns: FPe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: HPe,
    defaultMatchWidth: "wide",
    parsePatterns: VPe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: BPe,
    defaultMatchWidth: "wide",
    parsePatterns: UPe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: XPe,
    defaultMatchWidth: "any",
    parsePatterns: qPe,
    defaultParseWidth: "any"
  })
};
const GPe = YPe;
var QPe = {
  code: "gu",
  formatDistance: yPe,
  formatLong: $Pe,
  formatRelative: CPe,
  localize: NPe,
  match: GPe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const KPe = QPe;
var JPe = {
  lessThanXSeconds: {
    one: "פחות משנייה",
    two: "פחות משתי שניות",
    other: "פחות מ־{{count}} שניות"
  },
  xSeconds: {
    one: "שנייה",
    two: "שתי שניות",
    other: "{{count}} שניות"
  },
  halfAMinute: "חצי דקה",
  lessThanXMinutes: {
    one: "פחות מדקה",
    two: "פחות משתי דקות",
    other: "פחות מ־{{count}} דקות"
  },
  xMinutes: {
    one: "דקה",
    two: "שתי דקות",
    other: "{{count}} דקות"
  },
  aboutXHours: {
    one: "כשעה",
    two: "כשעתיים",
    other: "כ־{{count}} שעות"
  },
  xHours: {
    one: "שעה",
    two: "שעתיים",
    other: "{{count}} שעות"
  },
  xDays: {
    one: "יום",
    two: "יומיים",
    other: "{{count}} ימים"
  },
  aboutXWeeks: {
    one: "כשבוע",
    two: "כשבועיים",
    other: "כ־{{count}} שבועות"
  },
  xWeeks: {
    one: "שבוע",
    two: "שבועיים",
    other: "{{count}} שבועות"
  },
  aboutXMonths: {
    one: "כחודש",
    two: "כחודשיים",
    other: "כ־{{count}} חודשים"
  },
  xMonths: {
    one: "חודש",
    two: "חודשיים",
    other: "{{count}} חודשים"
  },
  aboutXYears: {
    one: "כשנה",
    two: "כשנתיים",
    other: "כ־{{count}} שנים"
  },
  xYears: {
    one: "שנה",
    two: "שנתיים",
    other: "{{count}} שנים"
  },
  overXYears: {
    one: "יותר משנה",
    two: "יותר משנתיים",
    other: "יותר מ־{{count}} שנים"
  },
  almostXYears: {
    one: "כמעט שנה",
    two: "כמעט שנתיים",
    other: "כמעט {{count}} שנים"
  }
}, ZPe = function(e, t, n) {
  if (e === "xDays" && n !== null && n !== void 0 && n.addSuffix && t <= 2)
    return n.comparison && n.comparison > 0 ? t === 1 ? "מחר" : "מחרתיים" : t === 1 ? "אתמול" : "שלשום";
  var r, s = JPe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : t === 2 ? r = s.two : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "בעוד " + r : "לפני " + r : r;
};
const eke = ZPe;
var tke = {
  full: "EEEE, d בMMMM y",
  long: "d בMMMM y",
  medium: "d בMMM y",
  short: "d.M.y"
}, nke = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, rke = {
  full: "{{date}} 'בשעה' {{time}}",
  long: "{{date}} 'בשעה' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ake = {
  date: Q({
    formats: tke,
    defaultWidth: "full"
  }),
  time: Q({
    formats: nke,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: rke,
    defaultWidth: "full"
  })
};
const ike = ake;
var oke = {
  lastWeek: "eeee 'שעבר בשעה' p",
  yesterday: "'אתמול בשעה' p",
  today: "'היום בשעה' p",
  tomorrow: "'מחר בשעה' p",
  nextWeek: "eeee 'בשעה' p",
  other: "P"
}, ske = function(e, t, n, r) {
  return oke[e];
};
const lke = ske;
var uke = {
  narrow: ["לפנה״ס", "לספירה"],
  abbreviated: ["לפנה״ס", "לספירה"],
  wide: ["לפני הספירה", "לספירה"]
}, cke = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["רבעון 1", "רבעון 2", "רבעון 3", "רבעון 4"]
}, dke = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["ינו׳", "פבר׳", "מרץ", "אפר׳", "מאי", "יוני", "יולי", "אוג׳", "ספט׳", "אוק׳", "נוב׳", "דצמ׳"],
  wide: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"]
}, fke = {
  narrow: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
  short: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
  abbreviated: ["יום א׳", "יום ב׳", "יום ג׳", "יום ד׳", "יום ה׳", "יום ו׳", "שבת"],
  wide: ["יום ראשון", "יום שני", "יום שלישי", "יום רביעי", "יום חמישי", "יום שישי", "יום שבת"]
}, mke = {
  narrow: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  },
  abbreviated: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  },
  wide: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  }
}, hke = {
  narrow: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "בצהריים",
    evening: "בערב",
    night: "בלילה"
  },
  abbreviated: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "אחר הצהריים",
    evening: "בערב",
    night: "בלילה"
  },
  wide: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "אחר הצהריים",
    evening: "בערב",
    night: "בלילה"
  }
}, pke = function(e, t) {
  var n = Number(e);
  if (n <= 0 || n > 10)
    return String(n);
  var r = String(t == null ? void 0 : t.unit), s = ["year", "hour", "minute", "second"].indexOf(r) >= 0, f = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שביעי", "שמיני", "תשיעי", "עשירי"], m = ["ראשונה", "שנייה", "שלישית", "רביעית", "חמישית", "שישית", "שביעית", "שמינית", "תשיעית", "עשירית"], p = n - 1;
  return s ? m[p] : f[p];
}, vke = {
  ordinalNumber: pke,
  era: R({
    values: uke,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: cke,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: dke,
    defaultWidth: "wide"
  }),
  day: R({
    values: fke,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: mke,
    defaultWidth: "wide",
    formattingValues: hke,
    defaultFormattingWidth: "wide"
  })
};
const gke = vke;
var yke = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i, bke = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i, wke = {
  narrow: /^ל(ספירה|פנה״ס)/i,
  abbreviated: /^ל(ספירה|פנה״ס)/i,
  wide: /^ל(פני ה)?ספירה/i
}, Pke = {
  any: [/^לפ/i, /^לס/i]
}, kke = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^רבעון [1234]/i
}, $ke = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ske = {
  narrow: /^\d+/i,
  abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
  wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
}, xke = {
  narrow: [/^1$/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ינ/i, /^פ/i, /^מר/i, /^אפ/i, /^מא/i, /^יונ/i, /^יול/i, /^אוג/i, /^ס/i, /^אוק/i, /^נ/i, /^ד/i]
}, Cke = {
  narrow: /^[אבגדהוש]׳/i,
  short: /^[אבגדהוש]׳/i,
  abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
  wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
}, Mke = {
  abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
  wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
  any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i]
}, Eke = {
  any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
}, Ake = {
  any: {
    am: /^לפ/i,
    pm: /^אחה/i,
    midnight: /^ח/i,
    noon: /^צ/i,
    morning: /בוקר/i,
    afternoon: /בצ|אחר/i,
    evening: /ערב/i,
    night: /לילה/i
  }
}, _ke = ["רא", "שנ", "של", "רב", "ח", "שי", "שב", "שמ", "ת", "ע"], Oke = {
  ordinalNumber: at({
    matchPattern: yke,
    parsePattern: bke,
    valueCallback: function(e) {
      var t = parseInt(e, 10);
      return isNaN(t) ? _ke.indexOf(e) + 1 : t;
    }
  }),
  era: D({
    matchPatterns: wke,
    defaultMatchWidth: "wide",
    parsePatterns: Pke,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: kke,
    defaultMatchWidth: "wide",
    parsePatterns: $ke,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Ske,
    defaultMatchWidth: "wide",
    parsePatterns: xke,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Cke,
    defaultMatchWidth: "wide",
    parsePatterns: Mke,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Eke,
    defaultMatchWidth: "any",
    parsePatterns: Ake,
    defaultParseWidth: "any"
  })
};
const Tke = Oke;
var Rke = {
  code: "he",
  formatDistance: eke,
  formatLong: ike,
  formatRelative: lke,
  localize: gke,
  match: Tke,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Dke = Rke;
var gW = {
  locale: {
    1: "१",
    2: "२",
    3: "३",
    4: "४",
    5: "५",
    6: "६",
    7: "७",
    8: "८",
    9: "९",
    0: "०"
  },
  number: {
    "१": "1",
    "२": "2",
    "३": "3",
    "४": "4",
    "५": "5",
    "६": "6",
    "७": "7",
    "८": "8",
    "९": "9",
    "०": "0"
  }
}, Nke = {
  narrow: ["ईसा-पूर्व", "ईस्वी"],
  abbreviated: ["ईसा-पूर्व", "ईस्वी"],
  wide: ["ईसा-पूर्व", "ईसवी सन"]
}, Wke = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ति1", "ति2", "ति3", "ति4"],
  wide: ["पहली तिमाही", "दूसरी तिमाही", "तीसरी तिमाही", "चौथी तिमाही"]
}, jke = {
  narrow: ["ज", "फ़", "मा", "अ", "मई", "जू", "जु", "अग", "सि", "अक्टू", "न", "दि"],
  abbreviated: ["जन", "फ़र", "मार्च", "अप्रैल", "मई", "जून", "जुल", "अग", "सित", "अक्टू", "नव", "दिस"],
  wide: ["जनवरी", "फ़रवरी", "मार्च", "अप्रैल", "मई", "जून", "जुलाई", "अगस्त", "सितंबर", "अक्टूबर", "नवंबर", "दिसंबर"]
}, zke = {
  narrow: ["र", "सो", "मं", "बु", "गु", "शु", "श"],
  short: ["र", "सो", "मं", "बु", "गु", "शु", "श"],
  abbreviated: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
  wide: ["रविवार", "सोमवार", "मंगलवार", "बुधवार", "गुरुवार", "शुक्रवार", "शनिवार"]
}, Lke = {
  narrow: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  abbreviated: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  wide: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  }
}, Ike = {
  narrow: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  abbreviated: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  wide: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  }
}, Fke = function(e, t) {
  var n = Number(e);
  return yW(n);
};
function Hke(e) {
  var t = e.toString().replace(/[१२३४५६७८९०]/g, function(n) {
    return gW.number[n];
  });
  return Number(t);
}
function yW(e) {
  return e.toString().replace(/\d/g, function(t) {
    return gW.locale[t];
  });
}
var Vke = {
  ordinalNumber: Fke,
  era: R({
    values: Nke,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Wke,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: jke,
    defaultWidth: "wide"
  }),
  day: R({
    values: zke,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Lke,
    defaultWidth: "wide",
    formattingValues: Ike,
    defaultFormattingWidth: "wide"
  })
};
const Bke = Vke;
var Uke = {
  lessThanXSeconds: {
    one: "१ सेकंड से कम",
    other: "{{count}} सेकंड से कम"
  },
  xSeconds: {
    one: "१ सेकंड",
    other: "{{count}} सेकंड"
  },
  halfAMinute: "आधा मिनट",
  lessThanXMinutes: {
    one: "१ मिनट से कम",
    other: "{{count}} मिनट से कम"
  },
  xMinutes: {
    one: "१ मिनट",
    other: "{{count}} मिनट"
  },
  aboutXHours: {
    one: "लगभग १ घंटा",
    other: "लगभग {{count}} घंटे"
  },
  xHours: {
    one: "१ घंटा",
    other: "{{count}} घंटे"
  },
  xDays: {
    one: "१ दिन",
    other: "{{count}} दिन"
  },
  aboutXWeeks: {
    one: "लगभग १ सप्ताह",
    other: "लगभग {{count}} सप्ताह"
  },
  xWeeks: {
    one: "१ सप्ताह",
    other: "{{count}} सप्ताह"
  },
  aboutXMonths: {
    one: "लगभग १ महीना",
    other: "लगभग {{count}} महीने"
  },
  xMonths: {
    one: "१ महीना",
    other: "{{count}} महीने"
  },
  aboutXYears: {
    one: "लगभग १ वर्ष",
    other: "लगभग {{count}} वर्ष"
  },
  xYears: {
    one: "१ वर्ष",
    other: "{{count}} वर्ष"
  },
  overXYears: {
    one: "१ वर्ष से अधिक",
    other: "{{count}} वर्ष से अधिक"
  },
  almostXYears: {
    one: "लगभग १ वर्ष",
    other: "लगभग {{count}} वर्ष"
  }
}, Xke = function(e, t, n) {
  var r, s = Uke[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", yW(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + "मे " : r + " पहले" : r;
};
const qke = Xke;
var Yke = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy"
}, Gke = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Qke = {
  full: "{{date}} 'को' {{time}}",
  long: "{{date}} 'को' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Kke = {
  date: Q({
    formats: Yke,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Gke,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Qke,
    defaultWidth: "full"
  })
};
const Jke = Kke;
var Zke = {
  lastWeek: "'पिछले' eeee p",
  yesterday: "'कल' p",
  today: "'आज' p",
  tomorrow: "'कल' p",
  nextWeek: "eeee 'को' p",
  other: "P"
}, e$e = function(e, t, n, r) {
  return Zke[e];
};
const t$e = e$e;
var n$e = /^[०१२३४५६७८९]+/i, r$e = /^[०१२३४५६७८९]+/i, a$e = {
  narrow: /^(ईसा-पूर्व|ईस्वी)/i,
  abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
  wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
}, i$e = {
  any: [/^b/i, /^(a|c)/i]
}, o$e = {
  narrow: /^[1234]/i,
  abbreviated: /^ति[1234]/i,
  wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
}, s$e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, l$e = {
  narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
  abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
  wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
}, u$e = {
  narrow: [/^ज/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^न/i, /^दि/i],
  any: [/^जन/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^नव/i, /^दिस/i]
}, c$e = {
  narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
  short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
}, d$e = {
  narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
  any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
}, f$e = {
  narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
  any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
}, m$e = {
  any: {
    am: /^पूर्वाह्न/i,
    pm: /^अपराह्न/i,
    midnight: /^मध्य/i,
    noon: /^दो/i,
    morning: /सु/i,
    afternoon: /दो/i,
    evening: /शा/i,
    night: /रा/i
  }
}, h$e = {
  ordinalNumber: at({
    matchPattern: n$e,
    parsePattern: r$e,
    valueCallback: Hke
  }),
  era: D({
    matchPatterns: a$e,
    defaultMatchWidth: "wide",
    parsePatterns: i$e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: o$e,
    defaultMatchWidth: "wide",
    parsePatterns: s$e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: l$e,
    defaultMatchWidth: "wide",
    parsePatterns: u$e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: c$e,
    defaultMatchWidth: "wide",
    parsePatterns: d$e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: f$e,
    defaultMatchWidth: "any",
    parsePatterns: m$e,
    defaultParseWidth: "any"
  })
};
const p$e = h$e;
var v$e = {
  code: "hi",
  formatDistance: qke,
  formatLong: Jke,
  formatRelative: t$e,
  localize: Bke,
  match: p$e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 4
  }
};
const g$e = v$e;
var y$e = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 tjedan",
      withPrepositionAgo: "oko 1 tjedan",
      withPrepositionIn: "oko 1 tjedan"
    },
    dual: "oko {{count}} tjedna",
    other: "oko {{count}} tjedana"
  },
  xWeeks: {
    one: {
      standalone: "1 tjedan",
      withPrepositionAgo: "1 tjedan",
      withPrepositionIn: "1 tjedan"
    },
    dual: "{{count}} tjedna",
    other: "{{count}} tjedana"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mjesec",
      withPrepositionAgo: "oko 1 mjesec",
      withPrepositionIn: "oko 1 mjesec"
    },
    dual: "oko {{count}} mjeseca",
    other: "oko {{count}} mjeseci"
  },
  xMonths: {
    one: {
      standalone: "1 mjesec",
      withPrepositionAgo: "1 mjesec",
      withPrepositionIn: "1 mjesec"
    },
    dual: "{{count}} mjeseca",
    other: "{{count}} mjeseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, b$e = function(e, t, n) {
  var r, s = y$e[e];
  return typeof s == "string" ? r = s : t === 1 ? n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r = s.one.withPrepositionIn : r = s.one.withPrepositionAgo : r = s.one.standalone : t % 10 > 1 && t % 10 < 5 && String(t).substr(-2, 1) !== "1" ? r = s.dual.replace("{{count}}", String(t)) : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "za " + r : "prije " + r : r;
};
const w$e = b$e;
var P$e = {
  full: "EEEE, d. MMMM y.",
  long: "d. MMMM y.",
  medium: "d. MMM y.",
  short: "dd. MM. y."
}, k$e = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, $$e = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, S$e = {
  date: Q({
    formats: P$e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: k$e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: $$e,
    defaultWidth: "full"
  })
};
const x$e = S$e;
var C$e = {
  lastWeek: function(e) {
    switch (e.getUTCDay()) {
      case 0:
        return "'prošlu nedjelju u' p";
      case 3:
        return "'prošlu srijedu u' p";
      case 6:
        return "'prošlu subotu u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'jučer u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function(e) {
    switch (e.getUTCDay()) {
      case 0:
        return "'iduću nedjelju u' p";
      case 3:
        return "'iduću srijedu u' p";
      case 6:
        return "'iduću subotu u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  other: "P"
}, M$e = function(e, t, n, r) {
  var s = C$e[e];
  return typeof s == "function" ? s(t) : s;
};
const E$e = M$e;
var A$e = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Kr.", "po. Kr."],
  wide: ["Prije Krista", "Poslije Krista"]
}, _$e = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, O$e = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["sij", "velj", "ožu", "tra", "svi", "lip", "srp", "kol", "ruj", "lis", "stu", "pro"],
  wide: ["siječanj", "veljača", "ožujak", "travanj", "svibanj", "lipanj", "srpanj", "kolovoz", "rujan", "listopad", "studeni", "prosinac"]
}, T$e = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["sij", "velj", "ožu", "tra", "svi", "lip", "srp", "kol", "ruj", "lis", "stu", "pro"],
  wide: ["siječnja", "veljače", "ožujka", "travnja", "svibnja", "lipnja", "srpnja", "kolovoza", "rujna", "listopada", "studenog", "prosinca"]
}, R$e = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
  wide: ["nedjelja", "ponedjeljak", "utorak", "srijeda", "četvrtak", "petak", "subota"]
}, D$e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "poslije podne",
    evening: "navečer",
    night: "noću"
  }
}, N$e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "poslije podne",
    evening: "navečer",
    night: "noću"
  }
}, W$e = function(e, t) {
  var n = Number(e);
  return n + ".";
}, j$e = {
  ordinalNumber: W$e,
  era: R({
    values: A$e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: _$e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: O$e,
    defaultWidth: "wide",
    formattingValues: T$e,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: R$e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: N$e,
    defaultWidth: "wide",
    formattingValues: D$e,
    defaultFormattingWidth: "wide"
  })
};
const z$e = j$e;
var L$e = /^(\d+)\./i, I$e = /\d+/i, F$e = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
  wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
}, H$e = {
  any: [/^pr/i, /^(po|nova)/i]
}, V$e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, B$e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, U$e = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
  wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
}, X$e = {
  narrow: [/1/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i, /8/i, /9/i, /10/i, /11/i, /12/i],
  abbreviated: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i],
  wide: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i]
}, q$e = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
}, Y$e = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, G$e = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
}, Q$e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(navece|naveče)/i,
    night: /(nocu|noću)/i
  }
}, K$e = {
  ordinalNumber: at({
    matchPattern: L$e,
    parsePattern: I$e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: F$e,
    defaultMatchWidth: "wide",
    parsePatterns: H$e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: V$e,
    defaultMatchWidth: "wide",
    parsePatterns: B$e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: U$e,
    defaultMatchWidth: "wide",
    parsePatterns: X$e,
    defaultParseWidth: "wide"
  }),
  day: D({
    matchPatterns: q$e,
    defaultMatchWidth: "wide",
    parsePatterns: Y$e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: G$e,
    defaultMatchWidth: "any",
    parsePatterns: Q$e,
    defaultParseWidth: "any"
  })
};
const J$e = K$e;
var Z$e = {
  code: "hr",
  formatDistance: w$e,
  formatLong: x$e,
  formatRelative: E$e,
  localize: z$e,
  match: J$e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const eSe = Z$e;
var tSe = {
  lessThanXSeconds: {
    one: "mwens pase yon segond",
    other: "mwens pase {{count}} segond"
  },
  xSeconds: {
    one: "1 segond",
    other: "{{count}} segond"
  },
  halfAMinute: "30 segond",
  lessThanXMinutes: {
    one: "mwens pase yon minit",
    other: "mwens pase {{count}} minit"
  },
  xMinutes: {
    one: "1 minit",
    other: "{{count}} minit"
  },
  aboutXHours: {
    one: "anviwon inè",
    other: "anviwon {{count}} è"
  },
  xHours: {
    one: "1 lè",
    other: "{{count}} lè"
  },
  xDays: {
    one: "1 jou",
    other: "{{count}} jou"
  },
  aboutXWeeks: {
    one: "anviwon 1 semèn",
    other: "anviwon {{count}} semèn"
  },
  xWeeks: {
    one: "1 semèn",
    other: "{{count}} semèn"
  },
  aboutXMonths: {
    one: "anviwon 1 mwa",
    other: "anviwon {{count}} mwa"
  },
  xMonths: {
    one: "1 mwa",
    other: "{{count}} mwa"
  },
  aboutXYears: {
    one: "anviwon 1 an",
    other: "anviwon {{count}} an"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} an"
  },
  overXYears: {
    one: "plis pase 1 an",
    other: "plis pase {{count}} an"
  },
  almostXYears: {
    one: "prèske 1 an",
    other: "prèske {{count}} an"
  }
}, nSe = function(e, t, n) {
  var r, s = tSe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "nan " + r : "sa fè " + r : r;
};
const rSe = nSe;
var aSe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, iSe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, oSe = {
  full: "{{date}} 'nan lè' {{time}}",
  long: "{{date}} 'nan lè' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, sSe = {
  date: Q({
    formats: aSe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: iSe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: oSe,
    defaultWidth: "full"
  })
};
const lSe = sSe;
var uSe = {
  lastWeek: "eeee 'pase nan lè' p",
  yesterday: "'yè nan lè' p",
  today: "'jodi a' p",
  tomorrow: "'demen nan lè' p'",
  nextWeek: "eeee 'pwochen nan lè' p",
  other: "P"
}, cSe = function(e, t, n, r) {
  return uSe[e];
};
const dSe = cSe;
var fSe = {
  narrow: ["av. J.-K", "ap. J.-K"],
  abbreviated: ["av. J.-K", "ap. J.-K"],
  wide: ["anvan Jezi Kris", "apre Jezi Kris"]
}, mSe = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1ye trim.", "2yèm trim.", "3yèm trim.", "4yèm trim."],
  wide: ["1ye trimès", "2yèm trimès", "3yèm trimès", "4yèm trimès"]
}, hSe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
  abbreviated: ["janv.", "fevr.", "mas", "avr.", "me", "jen", "jiyè", "out", "sept.", "okt.", "nov.", "des."],
  wide: ["janvye", "fevrye", "mas", "avril", "me", "jen", "jiyè", "out", "septanm", "oktòb", "novanm", "desanm"]
}, pSe = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "le", "ma", "mè", "je", "va", "sa"],
  abbreviated: ["dim.", "len.", "mad.", "mèk.", "jed.", "van.", "sam."],
  wide: ["dimanch", "lendi", "madi", "mèkredi", "jedi", "vandredi", "samdi"]
}, vSe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "swa",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "maten",
    afternoon: "aprèmidi",
    evening: "swa",
    night: "maten"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "nan maten",
    afternoon: "nan aprèmidi",
    evening: "nan aswè",
    night: "nan maten"
  }
}, gSe = function(e, t) {
  var n = Number(e);
  if (n === 0)
    return String(n);
  var r = n === 1 ? "ye" : "yèm";
  return n + r;
}, ySe = {
  ordinalNumber: gSe,
  era: R({
    values: fSe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: mSe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: hSe,
    defaultWidth: "wide"
  }),
  day: R({
    values: pSe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: vSe,
    defaultWidth: "wide"
  })
};
const bSe = ySe;
var wSe = /^(\d+)(ye|yèm)?/i, PSe = /\d+/i, kSe = {
  narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
  abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
  wide: /^(avan Jezi Kris|apre Jezi Kris)/i
}, $Se = {
  any: [/^av/i, /^ap/i]
}, SSe = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](ye|yèm)? trimès/i
}, xSe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, CSe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
  wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
}, MSe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^ma/i, /^av/i, /^me/i, /^je/i, /^ji/i, /^ou/i, /^s/i, /^ok/i, /^n/i, /^d/i]
}, ESe = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|le|ma|me|je|va|sa)/i,
  abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
  wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
}, ASe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^le/i, /^ma/i, /^mè/i, /^je/i, /^va/i, /^sa/i]
}, _Se = {
  narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
  any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
}, OSe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /sw/i,
    night: /nwit/i
  }
}, TSe = {
  ordinalNumber: at({
    matchPattern: wSe,
    parsePattern: PSe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: kSe,
    defaultMatchWidth: "wide",
    parsePatterns: $Se,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: SSe,
    defaultMatchWidth: "wide",
    parsePatterns: xSe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: CSe,
    defaultMatchWidth: "wide",
    parsePatterns: MSe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: ESe,
    defaultMatchWidth: "wide",
    parsePatterns: ASe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: _Se,
    defaultMatchWidth: "any",
    parsePatterns: OSe,
    defaultParseWidth: "any"
  })
};
const RSe = TSe;
var DSe = {
  code: "ht",
  formatDistance: rSe,
  formatLong: lSe,
  formatRelative: dSe,
  localize: bSe,
  match: RSe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const NSe = DSe;
var WSe = {
  about: "körülbelül",
  over: "több mint",
  almost: "majdnem",
  lessthan: "kevesebb mint"
}, jSe = {
  xseconds: " másodperc",
  halfaminute: "fél perc",
  xminutes: " perc",
  xhours: " óra",
  xdays: " nap",
  xweeks: " hét",
  xmonths: " hónap",
  xyears: " év"
}, zSe = {
  xseconds: {
    "-1": " másodperccel ezelőtt",
    1: " másodperc múlva",
    0: " másodperce"
  },
  halfaminute: {
    "-1": "fél perccel ezelőtt",
    1: "fél perc múlva",
    0: "fél perce"
  },
  xminutes: {
    "-1": " perccel ezelőtt",
    1: " perc múlva",
    0: " perce"
  },
  xhours: {
    "-1": " órával ezelőtt",
    1: " óra múlva",
    0: " órája"
  },
  xdays: {
    "-1": " nappal ezelőtt",
    1: " nap múlva",
    0: " napja"
  },
  xweeks: {
    "-1": " héttel ezelőtt",
    1: " hét múlva",
    0: " hete"
  },
  xmonths: {
    "-1": " hónappal ezelőtt",
    1: " hónap múlva",
    0: " hónapja"
  },
  xyears: {
    "-1": " évvel ezelőtt",
    1: " év múlva",
    0: " éve"
  }
}, LSe = function(e, t, n) {
  var r = e.match(/about|over|almost|lessthan/i), s = r ? e.replace(r[0], "") : e, f = (n == null ? void 0 : n.addSuffix) === !0, m = s.toLowerCase(), p = (n == null ? void 0 : n.comparison) || 0, v = f ? zSe[m][p] : jSe[m], y = m === "halfaminute" ? v : t + v;
  if (r) {
    var w = r[0].toLowerCase();
    y = WSe[w] + " " + y;
  }
  return y;
};
const ISe = LSe;
var FSe = {
  full: "y. MMMM d., EEEE",
  long: "y. MMMM d.",
  medium: "y. MMM d.",
  short: "y. MM. dd."
}, HSe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, VSe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, BSe = {
  date: Q({
    formats: FSe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: HSe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: VSe,
    defaultWidth: "full"
  })
};
const USe = BSe;
var XSe = ["vasárnap", "hétfőn", "kedden", "szerdán", "csütörtökön", "pénteken", "szombaton"];
function WO(e) {
  return function(t) {
    var n = XSe[t.getUTCDay()], r = e ? "" : "'múlt' ";
    return "".concat(r, "'").concat(n, "' p'-kor'");
  };
}
var qSe = {
  lastWeek: WO(!1),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: WO(!0),
  other: "P"
}, YSe = function(e, t) {
  var n = qSe[e];
  return typeof n == "function" ? n(t) : n;
};
const GSe = YSe;
var QSe = {
  narrow: ["ie.", "isz."],
  abbreviated: ["i. e.", "i. sz."],
  wide: ["Krisztus előtt", "időszámításunk szerint"]
}, KSe = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. n.év", "2. n.év", "3. n.év", "4. n.év"],
  wide: ["1. negyedév", "2. negyedév", "3. negyedév", "4. negyedév"]
}, JSe = {
  narrow: ["I.", "II.", "III.", "IV."],
  abbreviated: ["I. n.év", "II. n.év", "III. n.év", "IV. n.év"],
  wide: ["I. negyedév", "II. negyedév", "III. negyedév", "IV. negyedév"]
}, ZSe = {
  narrow: ["J", "F", "M", "Á", "M", "J", "J", "A", "Sz", "O", "N", "D"],
  abbreviated: ["jan.", "febr.", "márc.", "ápr.", "máj.", "jún.", "júl.", "aug.", "szept.", "okt.", "nov.", "dec."],
  wide: ["január", "február", "március", "április", "május", "június", "július", "augusztus", "szeptember", "október", "november", "december"]
}, exe = {
  narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  wide: ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"]
}, txe = {
  narrow: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  abbreviated: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  wide: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "délután",
    evening: "este",
    night: "éjjel"
  }
}, nxe = function(e, t) {
  var n = Number(e);
  return n + ".";
}, rxe = {
  ordinalNumber: nxe,
  era: R({
    values: QSe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: KSe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    },
    formattingValues: JSe,
    defaultFormattingWidth: "wide"
  }),
  month: R({
    values: ZSe,
    defaultWidth: "wide"
  }),
  day: R({
    values: exe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: txe,
    defaultWidth: "wide"
  })
};
const axe = rxe;
var ixe = /^(\d+)\.?/i, oxe = /\d+/i, sxe = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
}, lxe = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i]
}, uxe = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
}, cxe = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
}, dxe = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
}, fxe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, mxe = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
}, hxe = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
}, pxe = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
}, vxe = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i
  }
}, gxe = {
  ordinalNumber: at({
    matchPattern: ixe,
    parsePattern: oxe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: sxe,
    defaultMatchWidth: "wide",
    parsePatterns: lxe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: uxe,
    defaultMatchWidth: "wide",
    parsePatterns: cxe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: dxe,
    defaultMatchWidth: "wide",
    parsePatterns: fxe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: mxe,
    defaultMatchWidth: "wide",
    parsePatterns: hxe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: pxe,
    defaultMatchWidth: "any",
    parsePatterns: vxe,
    defaultParseWidth: "any"
  })
};
const yxe = gxe;
var bxe = {
  code: "hu",
  formatDistance: ISe,
  formatLong: USe,
  formatRelative: GSe,
  localize: axe,
  match: yxe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const wxe = bxe;
var Pxe = {
  lessThanXSeconds: {
    one: "ավելի քիչ քան 1 վայրկյան",
    other: "ավելի քիչ քան {{count}} վայրկյան"
  },
  xSeconds: {
    one: "1 վայրկյան",
    other: "{{count}} վայրկյան"
  },
  halfAMinute: "կես րոպե",
  lessThanXMinutes: {
    one: "ավելի քիչ քան 1 րոպե",
    other: "ավելի քիչ քան {{count}} րոպե"
  },
  xMinutes: {
    one: "1 րոպե",
    other: "{{count}} րոպե"
  },
  aboutXHours: {
    one: "մոտ 1 ժամ",
    other: "մոտ {{count}} ժամ"
  },
  xHours: {
    one: "1 ժամ",
    other: "{{count}} ժամ"
  },
  xDays: {
    one: "1 օր",
    other: "{{count}} օր"
  },
  aboutXWeeks: {
    one: "մոտ 1 շաբաթ",
    other: "մոտ {{count}} շաբաթ"
  },
  xWeeks: {
    one: "1 շաբաթ",
    other: "{{count}} շաբաթ"
  },
  aboutXMonths: {
    one: "մոտ 1 ամիս",
    other: "մոտ {{count}} ամիս"
  },
  xMonths: {
    one: "1 ամիս",
    other: "{{count}} ամիս"
  },
  aboutXYears: {
    one: "մոտ 1 տարի",
    other: "մոտ {{count}} տարի"
  },
  xYears: {
    one: "1 տարի",
    other: "{{count}} տարի"
  },
  overXYears: {
    one: "ավելի քան 1 տարի",
    other: "ավելի քան {{count}} տարի"
  },
  almostXYears: {
    one: "համարյա 1 տարի",
    other: "համարյա {{count}} տարի"
  }
}, kxe = function(e, t, n) {
  var r, s = Pxe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " հետո" : r + " առաջ" : r;
};
const $xe = kxe;
var Sxe = {
  full: "d MMMM, y, EEEE",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "dd.MM.yyyy"
}, xxe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Cxe = {
  full: "{{date}} 'ժ․'{{time}}",
  long: "{{date}} 'ժ․'{{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Mxe = {
  date: Q({
    formats: Sxe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: xxe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Cxe,
    defaultWidth: "full"
  })
};
const Exe = Mxe;
var Axe = {
  lastWeek: "'նախորդ' eeee p'֊ին'",
  yesterday: "'երեկ' p'֊ին'",
  today: "'այսօր' p'֊ին'",
  tomorrow: "'վաղը' p'֊ին'",
  nextWeek: "'հաջորդ' eeee p'֊ին'",
  other: "P"
}, _xe = function(e, t, n, r) {
  return Axe[e];
};
const Oxe = _xe;
var Txe = {
  narrow: ["Ք", "Մ"],
  abbreviated: ["ՔԱ", "ՄԹ"],
  wide: ["Քրիստոսից առաջ", "Մեր թվարկության"]
}, Rxe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Ք1", "Ք2", "Ք3", "Ք4"],
  wide: ["1֊ին քառորդ", "2֊րդ քառորդ", "3֊րդ քառորդ", "4֊րդ քառորդ"]
}, Dxe = {
  narrow: ["Հ", "Փ", "Մ", "Ա", "Մ", "Հ", "Հ", "Օ", "Ս", "Հ", "Ն", "Դ"],
  abbreviated: ["հուն", "փետ", "մար", "ապր", "մայ", "հուն", "հուլ", "օգս", "սեպ", "հոկ", "նոյ", "դեկ"],
  wide: ["հունվար", "փետրվար", "մարտ", "ապրիլ", "մայիս", "հունիս", "հուլիս", "օգոստոս", "սեպտեմբեր", "հոկտեմբեր", "նոյեմբեր", "դեկտեմբեր"]
}, Nxe = {
  narrow: ["Կ", "Ե", "Ե", "Չ", "Հ", "Ո", "Շ"],
  short: ["կր", "եր", "եք", "չք", "հգ", "ուր", "շբ"],
  abbreviated: ["կիր", "երկ", "երք", "չոր", "հնգ", "ուրբ", "շաբ"],
  wide: ["կիրակի", "երկուշաբթի", "երեքշաբթի", "չորեքշաբթի", "հինգշաբթի", "ուրբաթ", "շաբաթ"]
}, Wxe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "կեսգշ",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "կեսգիշեր",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "կեսգիշեր",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  }
}, jxe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "կեսգշ",
    noon: "կեսօր",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "կեսգիշերին",
    noon: "կեսօրին",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "կեսգիշերին",
    noon: "կեսօրին",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  }
}, zxe = function(e, t) {
  var n = Number(e), r = n % 100;
  return r < 10 && r % 10 === 1 ? n + "֊ին" : n + "֊րդ";
}, Lxe = {
  ordinalNumber: zxe,
  era: R({
    values: Txe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Rxe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Dxe,
    defaultWidth: "wide"
  }),
  day: R({
    values: Nxe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Wxe,
    defaultWidth: "wide",
    formattingValues: jxe,
    defaultFormattingWidth: "wide"
  })
};
const Ixe = Lxe;
var Fxe = /^(\d+)((-|֊)?(ին|րդ))?/i, Hxe = /\d+/i, Vxe = {
  narrow: /^(Ք|Մ)/i,
  abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
  wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
}, Bxe = {
  any: [/^ք/i, /^մ/i]
}, Uxe = {
  narrow: /^[1234]/i,
  abbreviated: /^ք[1234]/i,
  wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
}, Xxe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, qxe = {
  narrow: /^[հփմաօսնդ]/i,
  abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
  wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
}, Yxe = {
  narrow: [/^հ/i, /^փ/i, /^մ/i, /^ա/i, /^մ/i, /^հ/i, /^հ/i, /^օ/i, /^ս/i, /^հ/i, /^ն/i, /^դ/i],
  any: [/^հու/i, /^փ/i, /^մար/i, /^ա/i, /^մայ/i, /^հուն/i, /^հուլ/i, /^օ/i, /^ս/i, /^հոկ/i, /^ն/i, /^դ/i]
}, Gxe = {
  narrow: /^[եչհոշկ]/i,
  short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
  abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
  wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
}, Qxe = {
  narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i]
}, Kxe = {
  narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
  any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
}, Jxe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /կեսգիշեր/i,
    noon: /կեսօր/i,
    morning: /առավոտ/i,
    afternoon: /ցերեկ/i,
    evening: /երեկո/i,
    night: /գիշեր/i
  }
}, Zxe = {
  ordinalNumber: at({
    matchPattern: Fxe,
    parsePattern: Hxe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Vxe,
    defaultMatchWidth: "wide",
    parsePatterns: Bxe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Uxe,
    defaultMatchWidth: "wide",
    parsePatterns: Xxe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: qxe,
    defaultMatchWidth: "wide",
    parsePatterns: Yxe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: Gxe,
    defaultMatchWidth: "wide",
    parsePatterns: Qxe,
    defaultParseWidth: "wide"
  }),
  dayPeriod: D({
    matchPatterns: Kxe,
    defaultMatchWidth: "any",
    parsePatterns: Jxe,
    defaultParseWidth: "any"
  })
};
const e2e = Zxe;
var t2e = {
  code: "hy",
  formatDistance: $xe,
  formatLong: Exe,
  formatRelative: Oxe,
  localize: Ixe,
  match: e2e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const n2e = t2e;
var r2e = {
  lessThanXSeconds: {
    one: "kurang dari 1 detik",
    other: "kurang dari {{count}} detik"
  },
  xSeconds: {
    one: "1 detik",
    other: "{{count}} detik"
  },
  halfAMinute: "setengah menit",
  lessThanXMinutes: {
    one: "kurang dari 1 menit",
    other: "kurang dari {{count}} menit"
  },
  xMinutes: {
    one: "1 menit",
    other: "{{count}} menit"
  },
  aboutXHours: {
    one: "sekitar 1 jam",
    other: "sekitar {{count}} jam"
  },
  xHours: {
    one: "1 jam",
    other: "{{count}} jam"
  },
  xDays: {
    one: "1 hari",
    other: "{{count}} hari"
  },
  aboutXWeeks: {
    one: "sekitar 1 minggu",
    other: "sekitar {{count}} minggu"
  },
  xWeeks: {
    one: "1 minggu",
    other: "{{count}} minggu"
  },
  aboutXMonths: {
    one: "sekitar 1 bulan",
    other: "sekitar {{count}} bulan"
  },
  xMonths: {
    one: "1 bulan",
    other: "{{count}} bulan"
  },
  aboutXYears: {
    one: "sekitar 1 tahun",
    other: "sekitar {{count}} tahun"
  },
  xYears: {
    one: "1 tahun",
    other: "{{count}} tahun"
  },
  overXYears: {
    one: "lebih dari 1 tahun",
    other: "lebih dari {{count}} tahun"
  },
  almostXYears: {
    one: "hampir 1 tahun",
    other: "hampir {{count}} tahun"
  }
}, a2e = function(e, t, n) {
  var r, s = r2e[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "dalam waktu " + r : r + " yang lalu" : r;
};
const i2e = a2e;
var o2e = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/M/yyyy"
}, s2e = {
  full: "HH.mm.ss",
  long: "HH.mm.ss",
  medium: "HH.mm",
  short: "HH.mm"
}, l2e = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, u2e = {
  date: Q({
    formats: o2e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: s2e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: l2e,
    defaultWidth: "full"
  })
};
const c2e = u2e;
var d2e = {
  lastWeek: "eeee 'lalu pukul' p",
  yesterday: "'Kemarin pukul' p",
  today: "'Hari ini pukul' p",
  tomorrow: "'Besok pukul' p",
  nextWeek: "eeee 'pukul' p",
  other: "P"
}, f2e = function(e, t, n, r) {
  return d2e[e];
};
const m2e = f2e;
var h2e = {
  narrow: ["SM", "M"],
  abbreviated: ["SM", "M"],
  wide: ["Sebelum Masehi", "Masehi"]
}, p2e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["Kuartal ke-1", "Kuartal ke-2", "Kuartal ke-3", "Kuartal ke-4"]
}, v2e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agt", "Sep", "Okt", "Nov", "Des"],
  wide: ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
}, g2e = {
  narrow: ["M", "S", "S", "R", "K", "J", "S"],
  short: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  abbreviated: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  wide: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
}, y2e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  }
}, b2e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  }
}, w2e = function(e, t) {
  var n = Number(e);
  return "ke-" + n;
}, P2e = {
  ordinalNumber: w2e,
  era: R({
    values: h2e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: p2e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: v2e,
    defaultWidth: "wide"
  }),
  day: R({
    values: g2e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: y2e,
    defaultWidth: "wide",
    formattingValues: b2e,
    defaultFormattingWidth: "wide"
  })
};
const k2e = P2e;
var $2e = /^ke-(\d+)?/i, S2e = /\d+/i, x2e = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
  wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
}, C2e = {
  any: [/^s/i, /^(m|e)/i]
}, M2e = {
  narrow: /^[1234]/i,
  abbreviated: /^K-?\s[1234]/i,
  wide: /^Kuartal ke-?\s?[1234]/i
}, E2e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, A2e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
  wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
}, _2e = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, O2e = {
  narrow: /^[srkjm]/i,
  short: /^(min|sen|sel|rab|kam|jum|sab)/i,
  abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
  wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
}, T2e = {
  narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i]
}, R2e = {
  narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
}, D2e = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pagi/i,
    afternoon: /siang/i,
    evening: /sore/i,
    night: /malam/i
  }
}, N2e = {
  ordinalNumber: at({
    matchPattern: $2e,
    parsePattern: S2e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: x2e,
    defaultMatchWidth: "wide",
    parsePatterns: C2e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: M2e,
    defaultMatchWidth: "wide",
    parsePatterns: E2e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: A2e,
    defaultMatchWidth: "wide",
    parsePatterns: _2e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: O2e,
    defaultMatchWidth: "wide",
    parsePatterns: T2e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: R2e,
    defaultMatchWidth: "any",
    parsePatterns: D2e,
    defaultParseWidth: "any"
  })
};
const W2e = N2e;
var j2e = {
  code: "id",
  formatDistance: i2e,
  formatLong: c2e,
  formatRelative: m2e,
  localize: k2e,
  match: W2e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const z2e = j2e;
var L2e = {
  lessThanXSeconds: {
    one: "minna en 1 sekúnda",
    other: "minna en {{count}} sekúndur"
  },
  xSeconds: {
    one: "1 sekúnda",
    other: "{{count}} sekúndur"
  },
  halfAMinute: "hálf mínúta",
  lessThanXMinutes: {
    one: "minna en 1 mínúta",
    other: "minna en {{count}} mínútur"
  },
  xMinutes: {
    one: "1 mínúta",
    other: "{{count}} mínútur"
  },
  aboutXHours: {
    one: "u.þ.b. 1 klukkustund",
    other: "u.þ.b. {{count}} klukkustundir"
  },
  xHours: {
    one: "1 klukkustund",
    other: "{{count}} klukkustundir"
  },
  xDays: {
    one: "1 dagur",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "um viku",
    other: "um {{count}} vikur"
  },
  xWeeks: {
    one: "1 viku",
    other: "{{count}} vikur"
  },
  aboutXMonths: {
    one: "u.þ.b. 1 mánuður",
    other: "u.þ.b. {{count}} mánuðir"
  },
  xMonths: {
    one: "1 mánuður",
    other: "{{count}} mánuðir"
  },
  aboutXYears: {
    one: "u.þ.b. 1 ár",
    other: "u.þ.b. {{count}} ár"
  },
  xYears: {
    one: "1 ár",
    other: "{{count}} ár"
  },
  overXYears: {
    one: "meira en 1 ár",
    other: "meira en {{count}} ár"
  },
  almostXYears: {
    one: "næstum 1 ár",
    other: "næstum {{count}} ár"
  }
}, I2e = function(e, t, n) {
  var r, s = L2e[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "í " + r : r + " síðan" : r;
};
const F2e = I2e;
var H2e = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "d.MM.y"
}, V2e = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, B2e = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, U2e = {
  date: Q({
    formats: H2e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: V2e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: B2e,
    defaultWidth: "full"
  })
};
const X2e = U2e;
var q2e = {
  lastWeek: "'síðasta' dddd 'kl.' p",
  yesterday: "'í gær kl.' p",
  today: "'í dag kl.' p",
  tomorrow: "'á morgun kl.' p",
  nextWeek: "dddd 'kl.' p",
  other: "P"
}, Y2e = function(e, t, n, r) {
  return q2e[e];
};
const G2e = Y2e;
var Q2e = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["fyrir Krist", "eftir Krist"]
}, K2e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1F", "2F", "3F", "4F"],
  wide: ["1. fjórðungur", "2. fjórðungur", "3. fjórðungur", "4. fjórðungur"]
}, J2e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "Á", "S", "Ó", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apríl", "maí", "júní", "júlí", "ágúst", "sept.", "okt.", "nóv.", "des."],
  wide: ["janúar", "febrúar", "mars", "apríl", "maí", "júní", "júlí", "ágúst", "september", "október", "nóvember", "desember"]
}, Z2e = {
  narrow: ["S", "M", "Þ", "M", "F", "F", "L"],
  short: ["Su", "Má", "Þr", "Mi", "Fi", "Fö", "La"],
  abbreviated: ["sun.", "mán.", "þri.", "mið.", "fim.", "fös.", "lau."],
  wide: ["sunnudagur", "mánudagur", "þriðjudagur", "miðvikudagur", "fimmtudagur", "föstudagur", "laugardagur"]
}, eCe = {
  narrow: {
    am: "f",
    pm: "e",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  },
  abbreviated: {
    am: "f.h.",
    pm: "e.h.",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  },
  wide: {
    am: "fyrir hádegi",
    pm: "eftir hádegi",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  }
}, tCe = {
  narrow: {
    am: "f",
    pm: "e",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  },
  abbreviated: {
    am: "f.h.",
    pm: "e.h.",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  },
  wide: {
    am: "fyrir hádegi",
    pm: "eftir hádegi",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  }
}, nCe = function(e, t) {
  var n = Number(e);
  return n + ".";
}, rCe = {
  ordinalNumber: nCe,
  era: R({
    values: Q2e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: K2e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: J2e,
    defaultWidth: "wide"
  }),
  day: R({
    values: Z2e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: eCe,
    defaultWidth: "wide",
    formattingValues: tCe,
    defaultFormattingWidth: "wide"
  })
};
const aCe = rCe;
var iCe = /^(\d+)(\.)?/i, oCe = /\d+(\.)?/i, sCe = {
  narrow: /^(f\.Kr\.|e\.Kr\.)/i,
  abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
  wide: /^(fyrir Krist|eftir Krist)/i
}, lCe = {
  any: [/^(f\.Kr\.)/i, /^(e\.Kr\.)/i]
}, uCe = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^q[1234]\.?/i,
  wide: /^[1234]\.? fjórðungur/i
}, cCe = {
  any: [/1\.?/i, /2\.?/i, /3\.?/i, /4\.?/i]
}, dCe = {
  narrow: /^[jfmásónd]/i,
  abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
  wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
}, fCe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^á/i, /^s/i, /^ó/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maí/i, /^jún/i, /^júl/i, /^áu/i, /^s/i, /^ó/i, /^n/i, /^d/i]
}, mCe = {
  narrow: /^[smtwf]/i,
  short: /^(su|má|þr|mi|fi|fö|la)/i,
  abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
  wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
}, hCe = {
  narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
  any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i]
}, pCe = {
  narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
  any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
}, vCe = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^mi/i,
    noon: /^há/i,
    morning: /morgunn/i,
    afternoon: /síðdegi/i,
    evening: /kvöld/i,
    night: /nótt/i
  }
}, gCe = {
  ordinalNumber: at({
    matchPattern: iCe,
    parsePattern: oCe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: sCe,
    defaultMatchWidth: "wide",
    parsePatterns: lCe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: uCe,
    defaultMatchWidth: "wide",
    parsePatterns: cCe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: dCe,
    defaultMatchWidth: "wide",
    parsePatterns: fCe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: mCe,
    defaultMatchWidth: "wide",
    parsePatterns: hCe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: pCe,
    defaultMatchWidth: "any",
    parsePatterns: vCe,
    defaultParseWidth: "any"
  })
};
const yCe = gCe;
var bCe = {
  code: "is",
  formatDistance: F2e,
  formatLong: X2e,
  formatRelative: G2e,
  localize: aCe,
  match: yCe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const wCe = bCe;
var PCe = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, kCe = function(e, t, n) {
  var r, s = PCe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "tra " + r : r + " fa" : r;
};
const bW = kCe;
var $Ce = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, SCe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, xCe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, CCe = {
  date: Q({
    formats: $Ce,
    defaultWidth: "full"
  }),
  time: Q({
    formats: SCe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: xCe,
    defaultWidth: "full"
  })
};
const MCe = CCe;
var px = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
function ECe(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + px[e] + " scorso alle' p";
  }
}
function jO(e) {
  return "'" + px[e] + " alle' p";
}
function ACe(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + px[e] + " prossimo alle' p";
  }
}
var _Ce = {
  lastWeek: function(e, t, n) {
    var r = e.getUTCDay();
    return ca(e, t, n) ? jO(r) : ECe(r);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function(e, t, n) {
    var r = e.getUTCDay();
    return ca(e, t, n) ? jO(r) : ACe(r);
  },
  other: "P"
}, OCe = function(e, t, n, r) {
  var s = _Ce[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const wW = OCe;
var TCe = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, RCe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, DCe = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
}, NCe = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
}, WCe = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, jCe = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, zCe = function(e, t) {
  var n = Number(e);
  return String(n);
}, LCe = {
  ordinalNumber: zCe,
  era: R({
    values: TCe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: RCe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: DCe,
    defaultWidth: "wide"
  }),
  day: R({
    values: NCe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: WCe,
    defaultWidth: "wide",
    formattingValues: jCe,
    defaultFormattingWidth: "wide"
  })
};
const PW = LCe;
var ICe = /^(\d+)(º)?/i, FCe = /\d+/i, HCe = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, VCe = {
  any: [/^a/i, /^(d|e)/i]
}, BCe = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, UCe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, XCe = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, qCe = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, YCe = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, GCe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, QCe = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, KCe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, JCe = {
  ordinalNumber: at({
    matchPattern: ICe,
    parsePattern: FCe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: HCe,
    defaultMatchWidth: "wide",
    parsePatterns: VCe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: BCe,
    defaultMatchWidth: "wide",
    parsePatterns: UCe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: XCe,
    defaultMatchWidth: "wide",
    parsePatterns: qCe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: YCe,
    defaultMatchWidth: "wide",
    parsePatterns: GCe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: QCe,
    defaultMatchWidth: "any",
    parsePatterns: KCe,
    defaultParseWidth: "any"
  })
};
const kW = JCe;
var ZCe = {
  code: "it",
  formatDistance: bW,
  formatLong: MCe,
  formatRelative: wW,
  localize: PW,
  match: kW,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const eMe = ZCe;
var tMe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, nMe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, rMe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, aMe = {
  date: Q({
    formats: tMe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: nMe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: rMe,
    defaultWidth: "full"
  })
};
const iMe = aMe;
var oMe = {
  code: "it-CH",
  formatDistance: bW,
  formatLong: iMe,
  formatRelative: wW,
  localize: PW,
  match: kW,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const sMe = oMe;
var lMe = {
  lessThanXSeconds: {
    one: "1秒未満",
    other: "{{count}}秒未満",
    oneWithSuffix: "約1秒",
    otherWithSuffix: "約{{count}}秒"
  },
  xSeconds: {
    one: "1秒",
    other: "{{count}}秒"
  },
  halfAMinute: "30秒",
  lessThanXMinutes: {
    one: "1分未満",
    other: "{{count}}分未満",
    oneWithSuffix: "約1分",
    otherWithSuffix: "約{{count}}分"
  },
  xMinutes: {
    one: "1分",
    other: "{{count}}分"
  },
  aboutXHours: {
    one: "約1時間",
    other: "約{{count}}時間"
  },
  xHours: {
    one: "1時間",
    other: "{{count}}時間"
  },
  xDays: {
    one: "1日",
    other: "{{count}}日"
  },
  aboutXWeeks: {
    one: "約1週間",
    other: "約{{count}}週間"
  },
  xWeeks: {
    one: "1週間",
    other: "{{count}}週間"
  },
  aboutXMonths: {
    one: "約1か月",
    other: "約{{count}}か月"
  },
  xMonths: {
    one: "1か月",
    other: "{{count}}か月"
  },
  aboutXYears: {
    one: "約1年",
    other: "約{{count}}年"
  },
  xYears: {
    one: "1年",
    other: "{{count}}年"
  },
  overXYears: {
    one: "1年以上",
    other: "{{count}}年以上"
  },
  almostXYears: {
    one: "1年近く",
    other: "{{count}}年近く"
  }
}, uMe = function(e, t, n) {
  n = n || {};
  var r, s = lMe[e];
  return typeof s == "string" ? r = s : t === 1 ? n.addSuffix && s.oneWithSuffix ? r = s.oneWithSuffix : r = s.one : n.addSuffix && s.otherWithSuffix ? r = s.otherWithSuffix.replace("{{count}}", String(t)) : r = s.other.replace("{{count}}", String(t)), n.addSuffix ? n.comparison && n.comparison > 0 ? r + "後" : r + "前" : r;
};
const cMe = uMe;
var dMe = {
  full: "y年M月d日EEEE",
  long: "y年M月d日",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, fMe = {
  full: "H時mm分ss秒 zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, mMe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, hMe = {
  date: Q({
    formats: dMe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: fMe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: mMe,
    defaultWidth: "full"
  })
};
const pMe = hMe;
var vMe = {
  lastWeek: "先週のeeeeのp",
  yesterday: "昨日のp",
  today: "今日のp",
  tomorrow: "明日のp",
  nextWeek: "翌週のeeeeのp",
  other: "P"
}, gMe = function(e, t, n, r) {
  return vMe[e];
};
const yMe = gMe;
var bMe = {
  narrow: ["BC", "AC"],
  abbreviated: ["紀元前", "西暦"],
  wide: ["紀元前", "西暦"]
}, wMe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["第1四半期", "第2四半期", "第3四半期", "第4四半期"]
}, PMe = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  wide: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
}, kMe = {
  narrow: ["日", "月", "火", "水", "木", "金", "土"],
  short: ["日", "月", "火", "水", "木", "金", "土"],
  abbreviated: ["日", "月", "火", "水", "木", "金", "土"],
  wide: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]
}, $Me = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, SMe = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, xMe = function(e, t) {
  var n = Number(e), r = String(t == null ? void 0 : t.unit);
  switch (r) {
    case "year":
      return "".concat(n, "年");
    case "quarter":
      return "第".concat(n, "四半期");
    case "month":
      return "".concat(n, "月");
    case "week":
      return "第".concat(n, "週");
    case "date":
      return "".concat(n, "日");
    case "hour":
      return "".concat(n, "時");
    case "minute":
      return "".concat(n, "分");
    case "second":
      return "".concat(n, "秒");
    default:
      return "".concat(n);
  }
}, CMe = {
  ordinalNumber: xMe,
  era: R({
    values: bMe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: wMe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return Number(e) - 1;
    }
  }),
  month: R({
    values: PMe,
    defaultWidth: "wide"
  }),
  day: R({
    values: kMe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: $Me,
    defaultWidth: "wide",
    formattingValues: SMe,
    defaultFormattingWidth: "wide"
  })
};
const MMe = CMe;
var EMe = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i, AMe = /\d+/i, _Me = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(紀元[前後]|西暦)/i,
  wide: /^(紀元[前後]|西暦)/i
}, OMe = {
  narrow: [/^B/i, /^A/i],
  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
}, TMe = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^第[1234一二三四１２３４]四半期/i
}, RMe = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, DMe = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])月/i,
  wide: /^([123456789]|1[012])月/i
}, NMe = {
  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
}, WMe = {
  narrow: /^[日月火水木金土]/,
  short: /^[日月火水木金土]/,
  abbreviated: /^[日月火水木金土]/,
  wide: /^[日月火水木金土]曜日/
}, jMe = {
  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
}, zMe = {
  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
}, LMe = {
  any: {
    am: /^(A|午前)/i,
    pm: /^(P|午後)/i,
    midnight: /^深夜|真夜中/i,
    noon: /^正午/i,
    morning: /^朝/i,
    afternoon: /^午後/i,
    evening: /^夜/i,
    night: /^深夜/i
  }
}, IMe = {
  ordinalNumber: at({
    matchPattern: EMe,
    parsePattern: AMe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: _Me,
    defaultMatchWidth: "wide",
    parsePatterns: OMe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: TMe,
    defaultMatchWidth: "wide",
    parsePatterns: RMe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: DMe,
    defaultMatchWidth: "wide",
    parsePatterns: NMe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: WMe,
    defaultMatchWidth: "wide",
    parsePatterns: jMe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: zMe,
    defaultMatchWidth: "any",
    parsePatterns: LMe,
    defaultParseWidth: "any"
  })
};
const FMe = IMe;
var HMe = {
  code: "ja",
  formatDistance: cMe,
  formatLong: pMe,
  formatRelative: yMe,
  localize: MMe,
  match: FMe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const VMe = HMe;
var BMe = {
  lessThanXSeconds: {
    one: "1びょうみまん",
    other: "{{count}}びょうみまん",
    oneWithSuffix: "やく1びょう",
    otherWithSuffix: "やく{{count}}びょう"
  },
  xSeconds: {
    one: "1びょう",
    other: "{{count}}びょう"
  },
  halfAMinute: "30びょう",
  lessThanXMinutes: {
    one: "1ぷんみまん",
    other: "{{count}}ふんみまん",
    oneWithSuffix: "やく1ぷん",
    otherWithSuffix: "やく{{count}}ふん"
  },
  xMinutes: {
    one: "1ぷん",
    other: "{{count}}ふん"
  },
  aboutXHours: {
    one: "やく1じかん",
    other: "やく{{count}}じかん"
  },
  xHours: {
    one: "1じかん",
    other: "{{count}}じかん"
  },
  xDays: {
    one: "1にち",
    other: "{{count}}にち"
  },
  aboutXWeeks: {
    one: "やく1しゅうかん",
    other: "やく{{count}}しゅうかん"
  },
  xWeeks: {
    one: "1しゅうかん",
    other: "{{count}}しゅうかん"
  },
  aboutXMonths: {
    one: "やく1かげつ",
    other: "やく{{count}}かげつ"
  },
  xMonths: {
    one: "1かげつ",
    other: "{{count}}かげつ"
  },
  aboutXYears: {
    one: "やく1ねん",
    other: "やく{{count}}ねん"
  },
  xYears: {
    one: "1ねん",
    other: "{{count}}ねん"
  },
  overXYears: {
    one: "1ねんいじょう",
    other: "{{count}}ねんいじょう"
  },
  almostXYears: {
    one: "1ねんちかく",
    other: "{{count}}ねんちかく"
  }
}, UMe = function(e, t, n) {
  n = n || {};
  var r, s = BMe[e];
  return typeof s == "string" ? r = s : t === 1 ? n.addSuffix && s.oneWithSuffix ? r = s.oneWithSuffix : r = s.one : n.addSuffix && s.otherWithSuffix ? r = s.otherWithSuffix.replace("{{count}}", String(t)) : r = s.other.replace("{{count}}", String(t)), n.addSuffix ? n.comparison && n.comparison > 0 ? r + "あと" : r + "まえ" : r;
};
const XMe = UMe;
var qMe = {
  full: "yねんMがつdにちEEEE",
  long: "yねんMがつdにち",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, YMe = {
  full: "Hじmmふんssびょう zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, GMe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, QMe = {
  date: Q({
    formats: qMe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: YMe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: GMe,
    defaultWidth: "full"
  })
};
const KMe = QMe;
var JMe = {
  lastWeek: "せんしゅうのeeeeのp",
  yesterday: "きのうのp",
  today: "きょうのp",
  tomorrow: "あしたのp",
  nextWeek: "よくしゅうのeeeeのp",
  other: "P"
}, ZMe = function(e, t, n, r) {
  return JMe[e];
};
const eEe = ZMe;
var tEe = {
  narrow: ["BC", "AC"],
  abbreviated: ["きげんぜん", "せいれき"],
  wide: ["きげんぜん", "せいれき"]
}, nEe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["だい1しはんき", "だい2しはんき", "だい3しはんき", "だい4しはんき"]
}, rEe = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["1がつ", "2がつ", "3がつ", "4がつ", "5がつ", "6がつ", "7がつ", "8がつ", "9がつ", "10がつ", "11がつ", "12がつ"],
  wide: ["1がつ", "2がつ", "3がつ", "4がつ", "5がつ", "6がつ", "7がつ", "8がつ", "9がつ", "10がつ", "11がつ", "12がつ"]
}, aEe = {
  narrow: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  short: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  abbreviated: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  wide: ["にちようび", "げつようび", "かようび", "すいようび", "もくようび", "きんようび", "どようび"]
}, iEe = {
  narrow: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  abbreviated: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  wide: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  }
}, oEe = {
  narrow: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  abbreviated: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  wide: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  }
}, sEe = function(e, t) {
  var n = Number(e), r = String(t == null ? void 0 : t.unit);
  switch (r) {
    case "year":
      return "".concat(n, "ねん");
    case "quarter":
      return "だい".concat(n, "しはんき");
    case "month":
      return "".concat(n, "がつ");
    case "week":
      return "だい".concat(n, "しゅう");
    case "date":
      return "".concat(n, "にち");
    case "hour":
      return "".concat(n, "じ");
    case "minute":
      return "".concat(n, "ふん");
    case "second":
      return "".concat(n, "びょう");
    default:
      return "".concat(n);
  }
}, lEe = {
  ordinalNumber: sEe,
  era: R({
    values: tEe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: nEe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return Number(e) - 1;
    }
  }),
  month: R({
    values: rEe,
    defaultWidth: "wide"
  }),
  day: R({
    values: aEe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: iEe,
    defaultWidth: "wide",
    formattingValues: oEe,
    defaultFormattingWidth: "wide"
  })
};
const uEe = lEe;
var cEe = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i, dEe = /\d+/i, fEe = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(きげん[前後]|せいれき)/i,
  wide: /^(きげん[前後]|せいれき)/i
}, mEe = {
  narrow: [/^B/i, /^A/i],
  any: [/^(きげんぜん)/i, /^(せいれき|きげんご)/i]
}, hEe = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^だい[1234一二三四１２３４]しはんき/i
}, pEe = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, vEe = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])がつ/i,
  wide: /^([123456789]|1[012])がつ/i
}, gEe = {
  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
}, yEe = {
  narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
  short: /^(にち|げつ|か|すい|もく|きん|ど)/,
  abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
  wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
}, bEe = {
  any: [/^にち/, /^げつ/, /^か/, /^すい/, /^もく/, /^きん/, /^ど/]
}, wEe = {
  any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
}, PEe = {
  any: {
    am: /^(A|ごぜん)/i,
    pm: /^(P|ごご)/i,
    midnight: /^しんや|まよなか/i,
    noon: /^しょうご/i,
    morning: /^あさ/i,
    afternoon: /^ごご/i,
    evening: /^よる/i,
    night: /^しんや/i
  }
}, kEe = {
  ordinalNumber: at({
    matchPattern: cEe,
    parsePattern: dEe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: fEe,
    defaultMatchWidth: "wide",
    parsePatterns: mEe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: hEe,
    defaultMatchWidth: "wide",
    parsePatterns: pEe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: vEe,
    defaultMatchWidth: "wide",
    parsePatterns: gEe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: yEe,
    defaultMatchWidth: "wide",
    parsePatterns: bEe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: wEe,
    defaultMatchWidth: "any",
    parsePatterns: PEe,
    defaultParseWidth: "any"
  })
};
const $Ee = kEe;
var SEe = {
  code: "ja-Hira",
  formatDistance: XMe,
  formatLong: KMe,
  formatRelative: eEe,
  localize: uEe,
  match: $Ee,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const xEe = SEe;
var CEe = {
  lessThanXSeconds: {
    past: "{{count}} წამზე ნაკლები ხნის წინ",
    present: "{{count}} წამზე ნაკლები",
    future: "{{count}} წამზე ნაკლებში"
  },
  xSeconds: {
    past: "{{count}} წამის წინ",
    present: "{{count}} წამი",
    future: "{{count}} წამში"
  },
  halfAMinute: {
    past: "ნახევარი წუთის წინ",
    present: "ნახევარი წუთი",
    future: "ნახევარი წუთში"
  },
  lessThanXMinutes: {
    past: "{{count}} წუთზე ნაკლები ხნის წინ",
    present: "{{count}} წუთზე ნაკლები",
    future: "{{count}} წუთზე ნაკლებში"
  },
  xMinutes: {
    past: "{{count}} წუთის წინ",
    present: "{{count}} წუთი",
    future: "{{count}} წუთში"
  },
  aboutXHours: {
    past: "დაახლოებით {{count}} საათის წინ",
    present: "დაახლოებით {{count}} საათი",
    future: "დაახლოებით {{count}} საათში"
  },
  xHours: {
    past: "{{count}} საათის წინ",
    present: "{{count}} საათი",
    future: "{{count}} საათში"
  },
  xDays: {
    past: "{{count}} დღის წინ",
    present: "{{count}} დღე",
    future: "{{count}} დღეში"
  },
  aboutXWeeks: {
    past: "დაახლოებით {{count}} კვირას წინ",
    present: "დაახლოებით {{count}} კვირა",
    future: "დაახლოებით {{count}} კვირაში"
  },
  xWeeks: {
    past: "{{count}} კვირას კვირა",
    present: "{{count}} კვირა",
    future: "{{count}} კვირაში"
  },
  aboutXMonths: {
    past: "დაახლოებით {{count}} თვის წინ",
    present: "დაახლოებით {{count}} თვე",
    future: "დაახლოებით {{count}} თვეში"
  },
  xMonths: {
    past: "{{count}} თვის წინ",
    present: "{{count}} თვე",
    future: "{{count}} თვეში"
  },
  aboutXYears: {
    past: "დაახლოებით {{count}} წლის წინ",
    present: "დაახლოებით {{count}} წელი",
    future: "დაახლოებით {{count}} წელში"
  },
  xYears: {
    past: "{{count}} წლის წინ",
    present: "{{count}} წელი",
    future: "{{count}} წელში"
  },
  overXYears: {
    past: "{{count}} წელზე მეტი ხნის წინ",
    present: "{{count}} წელზე მეტი",
    future: "{{count}} წელზე მეტი ხნის შემდეგ"
  },
  almostXYears: {
    past: "თითქმის {{count}} წლის წინ",
    present: "თითქმის {{count}} წელი",
    future: "თითქმის {{count}} წელში"
  }
}, MEe = function(e, t, n) {
  var r, s = CEe[e];
  return typeof s == "string" ? r = s : n != null && n.addSuffix && n.comparison && n.comparison > 0 ? r = s.future.replace("{{count}}", String(t)) : n != null && n.addSuffix ? r = s.past.replace("{{count}}", String(t)) : r = s.present.replace("{{count}}", String(t)), r;
};
const EEe = MEe;
var AEe = {
  full: "EEEE, do MMMM, y",
  long: "do, MMMM, y",
  medium: "d, MMM, y",
  short: "dd/MM/yyyy"
}, _Ee = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, OEe = {
  full: "{{date}} {{time}}'-ზე'",
  long: "{{date}} {{time}}'-ზე'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, TEe = {
  date: Q({
    formats: AEe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: _Ee,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: OEe,
    defaultWidth: "full"
  })
};
const REe = TEe;
var DEe = {
  lastWeek: "'წინა' eeee p'-ზე'",
  yesterday: "'გუშინ' p'-ზე'",
  today: "'დღეს' p'-ზე'",
  tomorrow: "'ხვალ' p'-ზე'",
  nextWeek: "'შემდეგი' eeee p'-ზე'",
  other: "P"
}, NEe = function(e, t, n, r) {
  return DEe[e];
};
const WEe = NEe;
var jEe = {
  narrow: ["ჩ.წ-მდე", "ჩ.წ"],
  abbreviated: ["ჩვ.წ-მდე", "ჩვ.წ"],
  wide: ["ჩვენს წელთაღრიცხვამდე", "ჩვენი წელთაღრიცხვით"]
}, zEe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ლი კვ", "2-ე კვ", "3-ე კვ", "4-ე კვ"],
  wide: ["1-ლი კვარტალი", "2-ე კვარტალი", "3-ე კვარტალი", "4-ე კვარტალი"]
}, LEe = {
  narrow: ["ია", "თე", "მა", "აპ", "მს", "ვნ", "ვლ", "აგ", "სე", "ოქ", "ნო", "დე"],
  abbreviated: ["იან", "თებ", "მარ", "აპრ", "მაი", "ივნ", "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"],
  wide: ["იანვარი", "თებერვალი", "მარტი", "აპრილი", "მაისი", "ივნისი", "ივლისი", "აგვისტო", "სექტემბერი", "ოქტომბერი", "ნოემბერი", "დეკემბერი"]
}, IEe = {
  narrow: ["კვ", "ორ", "სა", "ოთ", "ხუ", "პა", "შა"],
  short: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
  abbreviated: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
  wide: ["კვირა", "ორშაბათი", "სამშაბათი", "ოთხშაბათი", "ხუთშაბათი", "პარასკევი", "შაბათი"]
}, FEe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  }
}, HEe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  }
}, VEe = function(e) {
  var t = Number(e);
  return t === 1 ? t + "-ლი" : t + "-ე";
}, BEe = {
  ordinalNumber: VEe,
  era: R({
    values: jEe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: zEe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: LEe,
    defaultWidth: "wide"
  }),
  day: R({
    values: IEe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: FEe,
    defaultWidth: "wide",
    formattingValues: HEe,
    defaultFormattingWidth: "wide"
  })
};
const UEe = BEe;
var XEe = /^(\d+)(-ლი|-ე)?/i, qEe = /\d+/i, YEe = {
  narrow: /^(ჩვ?\.წ)/i,
  abbreviated: /^(ჩვ?\.წ)/i,
  wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
}, GEe = {
  any: [/^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i, /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i]
}, QEe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-(ლი|ე)? კვ/i,
  wide: /^[1234]-(ლი|ე)? კვარტალი/i
}, KEe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, JEe = {
  any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
}, ZEe = {
  any: [/^ია/i, /^თ/i, /^მარ/i, /^აპ/i, /^მაი/i, /^ი?ვნ/i, /^ი?ვლ/i, /^აგ/i, /^ს/i, /^ო/i, /^ნ/i, /^დ/i]
}, eAe = {
  narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
  short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
  wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
}, tAe = {
  any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i]
}, nAe = {
  any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
}, rAe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^შუაღ/i,
    noon: /^შუადღ/i,
    morning: /^დილ/i,
    afternoon: /ნაშუადღევს/i,
    evening: /საღამო/i,
    night: /ღამ/i
  }
}, aAe = {
  ordinalNumber: at({
    matchPattern: XEe,
    parsePattern: qEe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: YEe,
    defaultMatchWidth: "wide",
    parsePatterns: GEe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: QEe,
    defaultMatchWidth: "wide",
    parsePatterns: KEe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: JEe,
    defaultMatchWidth: "any",
    parsePatterns: ZEe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: eAe,
    defaultMatchWidth: "wide",
    parsePatterns: tAe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: nAe,
    defaultMatchWidth: "any",
    parsePatterns: rAe,
    defaultParseWidth: "any"
  })
};
const iAe = aAe;
var oAe = {
  code: "ka",
  formatDistance: EEe,
  formatLong: REe,
  formatRelative: WEe,
  localize: UEe,
  match: iAe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const sAe = oAe;
var lAe = {
  lessThanXSeconds: {
    regular: {
      one: "1 секундтан аз",
      singularNominative: "{{count}} секундтан аз",
      singularGenitive: "{{count}} секундтан аз",
      pluralGenitive: "{{count}} секундтан аз"
    },
    future: {
      one: "бір секундтан кейін",
      singularNominative: "{{count}} секундтан кейін",
      singularGenitive: "{{count}} секундтан кейін",
      pluralGenitive: "{{count}} секундтан кейін"
    }
  },
  xSeconds: {
    regular: {
      singularNominative: "{{count}} секунд",
      singularGenitive: "{{count}} секунд",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунд бұрын",
      singularGenitive: "{{count}} секунд бұрын",
      pluralGenitive: "{{count}} секунд бұрын"
    },
    future: {
      singularNominative: "{{count}} секундтан кейін",
      singularGenitive: "{{count}} секундтан кейін",
      pluralGenitive: "{{count}} секундтан кейін"
    }
  },
  halfAMinute: function(e) {
    return e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "жарты минут ішінде" : "жарты минут бұрын" : "жарты минут";
  },
  lessThanXMinutes: {
    regular: {
      one: "1 минуттан аз",
      singularNominative: "{{count}} минуттан аз",
      singularGenitive: "{{count}} минуттан аз",
      pluralGenitive: "{{count}} минуттан аз"
    },
    future: {
      one: "минуттан кем ",
      singularNominative: "{{count}} минуттан кем",
      singularGenitive: "{{count}} минуттан кем",
      pluralGenitive: "{{count}} минуттан кем"
    }
  },
  xMinutes: {
    regular: {
      singularNominative: "{{count}} минут",
      singularGenitive: "{{count}} минут",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минут бұрын",
      singularGenitive: "{{count}} минут бұрын",
      pluralGenitive: "{{count}} минут бұрын"
    },
    future: {
      singularNominative: "{{count}} минуттан кейін",
      singularGenitive: "{{count}} минуттан кейін",
      pluralGenitive: "{{count}} минуттан кейін"
    }
  },
  aboutXHours: {
    regular: {
      singularNominative: "шамамен {{count}} сағат",
      singularGenitive: "шамамен {{count}} сағат",
      pluralGenitive: "шамамен {{count}} сағат"
    },
    future: {
      singularNominative: "шамамен {{count}} сағаттан кейін",
      singularGenitive: "шамамен {{count}} сағаттан кейін",
      pluralGenitive: "шамамен {{count}} сағаттан кейін"
    }
  },
  xHours: {
    regular: {
      singularNominative: "{{count}} сағат",
      singularGenitive: "{{count}} сағат",
      pluralGenitive: "{{count}} сағат"
    }
  },
  xDays: {
    regular: {
      singularNominative: "{{count}} күн",
      singularGenitive: "{{count}} күн",
      pluralGenitive: "{{count}} күн"
    },
    future: {
      singularNominative: "{{count}} күннен кейін",
      singularGenitive: "{{count}} күннен кейін",
      pluralGenitive: "{{count}} күннен кейін"
    }
  },
  aboutXWeeks: {
    type: "weeks",
    one: "шамамен 1 апта",
    other: "шамамен {{count}} апта"
  },
  xWeeks: {
    type: "weeks",
    one: "1 апта",
    other: "{{count}} апта"
  },
  aboutXMonths: {
    regular: {
      singularNominative: "шамамен {{count}} ай",
      singularGenitive: "шамамен {{count}} ай",
      pluralGenitive: "шамамен {{count}} ай"
    },
    future: {
      singularNominative: "шамамен {{count}} айдан кейін",
      singularGenitive: "шамамен {{count}} айдан кейін",
      pluralGenitive: "шамамен {{count}} айдан кейін"
    }
  },
  xMonths: {
    regular: {
      singularNominative: "{{count}} ай",
      singularGenitive: "{{count}} ай",
      pluralGenitive: "{{count}} ай"
    }
  },
  aboutXYears: {
    regular: {
      singularNominative: "шамамен {{count}} жыл",
      singularGenitive: "шамамен {{count}} жыл",
      pluralGenitive: "шамамен {{count}} жыл"
    },
    future: {
      singularNominative: "шамамен {{count}} жылдан кейін",
      singularGenitive: "шамамен {{count}} жылдан кейін",
      pluralGenitive: "шамамен {{count}} жылдан кейін"
    }
  },
  xYears: {
    regular: {
      singularNominative: "{{count}} жыл",
      singularGenitive: "{{count}} жыл",
      pluralGenitive: "{{count}} жыл"
    },
    future: {
      singularNominative: "{{count}} жылдан кейін",
      singularGenitive: "{{count}} жылдан кейін",
      pluralGenitive: "{{count}} жылдан кейін"
    }
  },
  overXYears: {
    regular: {
      singularNominative: "{{count}} жылдан астам",
      singularGenitive: "{{count}} жылдан астам",
      pluralGenitive: "{{count}} жылдан астам"
    },
    future: {
      singularNominative: "{{count}} жылдан астам",
      singularGenitive: "{{count}} жылдан астам",
      pluralGenitive: "{{count}} жылдан астам"
    }
  },
  almostXYears: {
    regular: {
      singularNominative: "{{count}} жылға жақын",
      singularGenitive: "{{count}} жылға жақын",
      pluralGenitive: "{{count}} жылға жақын"
    },
    future: {
      singularNominative: "{{count}} жылдан кейін",
      singularGenitive: "{{count}} жылдан кейін",
      pluralGenitive: "{{count}} жылдан кейін"
    }
  }
};
function Av(e, t) {
  if (e.one && t === 1)
    return e.one;
  var n = t % 10, r = t % 100;
  return n === 1 && r !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
var uAe = function(e, t, n) {
  var r = lAe[e];
  return typeof r == "function" ? r(n) : r.type === "weeks" ? t === 1 ? r.one : r.other.replace("{{count}}", String(t)) : n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r.future ? Av(r.future, t) : Av(r.regular, t) + " кейін" : r.past ? Av(r.past, t) : Av(r.regular, t) + " бұрын" : Av(r.regular, t);
};
const cAe = uAe;
var dAe = {
  full: "EEEE, do MMMM y 'ж.'",
  long: "do MMMM y 'ж.'",
  medium: "d MMM y 'ж.'",
  short: "dd.MM.yyyy"
}, fAe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, mAe = {
  any: "{{date}}, {{time}}"
}, hAe = {
  date: Q({
    formats: dAe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: fAe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: mAe,
    defaultWidth: "any"
  })
};
const pAe = hAe;
var vx = ["жексенбіде", "дүйсенбіде", "сейсенбіде", "сәрсенбіде", "бейсенбіде", "жұмада", "сенбіде"];
function vAe(e) {
  var t = vx[e];
  return "'өткен " + t + " сағат' p'-де'";
}
function zO(e) {
  var t = vx[e];
  return "'" + t + " сағат' p'-де'";
}
function gAe(e) {
  var t = vx[e];
  return "'келесі " + t + " сағат' p'-де'";
}
var yAe = {
  lastWeek: function(e, t, n) {
    var r = e.getUTCDay();
    return ca(e, t, n) ? zO(r) : vAe(r);
  },
  yesterday: "'кеше сағат' p'-де'",
  today: "'бүгін сағат' p'-де'",
  tomorrow: "'ертең сағат' p'-де'",
  nextWeek: function(e, t, n) {
    var r = e.getUTCDay();
    return ca(e, t, n) ? zO(r) : gAe(r);
  },
  other: "P"
}, bAe = function(e, t, n, r) {
  var s = yAe[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const wAe = bAe;
var PAe = {
  narrow: ["б.з.д.", "б.з."],
  abbreviated: ["б.з.д.", "б.з."],
  wide: ["біздің заманымызға дейін", "біздің заманымыз"]
}, kAe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ші тоқ.", "2-ші тоқ.", "3-ші тоқ.", "4-ші тоқ."],
  wide: ["1-ші тоқсан", "2-ші тоқсан", "3-ші тоқсан", "4-ші тоқсан"]
}, $Ae = {
  narrow: ["Қ", "А", "Н", "С", "М", "М", "Ш", "Т", "Қ", "Қ", "Қ", "Ж"],
  abbreviated: ["қаң", "ақп", "нау", "сәу", "мам", "мау", "шіл", "там", "қыр", "қаз", "қар", "жел"],
  wide: ["қаңтар", "ақпан", "наурыз", "сәуір", "мамыр", "маусым", "шілде", "тамыз", "қыркүйек", "қазан", "қараша", "желтоқсан"]
}, SAe = {
  narrow: ["Қ", "А", "Н", "С", "М", "М", "Ш", "Т", "Қ", "Қ", "Қ", "Ж"],
  abbreviated: ["қаң", "ақп", "нау", "сәу", "мам", "мау", "шіл", "там", "қыр", "қаз", "қар", "жел"],
  wide: ["қаңтар", "ақпан", "наурыз", "сәуір", "мамыр", "маусым", "шілде", "тамыз", "қыркүйек", "қазан", "қараша", "желтоқсан"]
}, xAe = {
  narrow: ["Ж", "Д", "С", "С", "Б", "Ж", "С"],
  short: ["жс", "дс", "сс", "ср", "бс", "жм", "сб"],
  abbreviated: ["жс", "дс", "сс", "ср", "бс", "жм", "сб"],
  wide: ["жексенбі", "дүйсенбі", "сейсенбі", "сәрсенбі", "бейсенбі", "жұма", "сенбі"]
}, CAe = {
  narrow: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасы",
    noon: "түс",
    morning: "таң",
    afternoon: "күндіз",
    evening: "кеш",
    night: "түн"
  },
  wide: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасы",
    noon: "түс",
    morning: "таң",
    afternoon: "күндіз",
    evening: "кеш",
    night: "түн"
  }
}, MAe = {
  narrow: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасында",
    noon: "түс",
    morning: "таң",
    afternoon: "күн",
    evening: "кеш",
    night: "түн"
  },
  wide: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасында",
    noon: "түсте",
    morning: "таңертең",
    afternoon: "күндіз",
    evening: "кеште",
    night: "түнде"
  }
}, c$ = {
  0: "-ші",
  1: "-ші",
  2: "-ші",
  3: "-ші",
  4: "-ші",
  5: "-ші",
  6: "-шы",
  7: "-ші",
  8: "-ші",
  9: "-шы",
  10: "-шы",
  20: "-шы",
  30: "-шы",
  40: "-шы",
  50: "-ші",
  60: "-шы",
  70: "-ші",
  80: "-ші",
  90: "-шы",
  100: "-ші"
}, EAe = function(e, t) {
  var n = Number(e), r = n % 10, s = n >= 100 ? 100 : null, f = c$[n] || c$[r] || s && c$[s] || "";
  return n + f;
}, AAe = {
  ordinalNumber: EAe,
  era: R({
    values: PAe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: kAe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: $Ae,
    defaultWidth: "wide",
    formattingValues: SAe,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: xAe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: CAe,
    defaultWidth: "any",
    formattingValues: MAe,
    defaultFormattingWidth: "wide"
  })
};
const _Ae = AAe;
var OAe = /^(\d+)(-?(ші|шы))?/i, TAe = /\d+/i, RAe = {
  narrow: /^((б )?з\.?\s?д\.?)/i,
  abbreviated: /^((б )?з\.?\s?д\.?)/i,
  wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
}, DAe = {
  any: [/^б/i, /^з/i]
}, NAe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?ші)? тоқ.?/i,
  wide: /^[1234](-?ші)? тоқсан/i
}, WAe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jAe = {
  narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
  abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
  wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
}, zAe = {
  narrow: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i],
  abbreviated: [/^қаң/i, /^ақп/i, /^нау/i, /^сәу/i, /^мам/i, /^мау/i, /^шіл/i, /^там/i, /^қыр/i, /^қаз/i, /^қар/i, /^жел/i],
  any: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i]
}, LAe = {
  narrow: /^(ж|д|с|с|б|ж|с)/i,
  short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
  wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
}, IAe = {
  narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
  short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
  any: [/^ж[ек]/i, /^д[үй]/i, /^сe[й]/i, /^сә[р]/i, /^б[ей]/i, /^ж[ұм]/i, /^се[н]/i]
}, FAe = {
  narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
}, HAe = {
  any: {
    am: /^ТД/i,
    pm: /^ТК/i,
    midnight: /^түн орта/i,
    noon: /^күндіз/i,
    morning: /таң/i,
    afternoon: /түс/i,
    evening: /кеш/i,
    night: /түн/i
  }
}, VAe = {
  ordinalNumber: at({
    matchPattern: OAe,
    parsePattern: TAe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: RAe,
    defaultMatchWidth: "wide",
    parsePatterns: DAe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: NAe,
    defaultMatchWidth: "wide",
    parsePatterns: WAe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: jAe,
    defaultMatchWidth: "wide",
    parsePatterns: zAe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: LAe,
    defaultMatchWidth: "wide",
    parsePatterns: IAe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: FAe,
    defaultMatchWidth: "wide",
    parsePatterns: HAe,
    defaultParseWidth: "any"
  })
};
const BAe = VAe;
var UAe = {
  code: "kk",
  formatDistance: cAe,
  formatLong: pAe,
  formatRelative: wAe,
  localize: _Ae,
  match: BAe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const XAe = UAe;
var qAe = {
  lessThanXSeconds: "តិចជាង {{count}} វិនាទី",
  xSeconds: "{{count}} វិនាទី",
  halfAMinute: "កន្លះនាទី",
  lessThanXMinutes: "តិចជាង {{count}} នាទី",
  xMinutes: "{{count}} នាទី",
  aboutXHours: "ប្រហែល {{count}} ម៉ោង",
  xHours: "{{count}} ម៉ោង",
  xDays: "{{count}} ថ្ងៃ",
  aboutXWeeks: "ប្រហែល {{count}} សប្តាហ៍",
  xWeeks: "{{count}} សប្តាហ៍",
  aboutXMonths: "ប្រហែល {{count}} ខែ",
  xMonths: "{{count}} ខែ",
  aboutXYears: "ប្រហែល {{count}} ឆ្នាំ",
  xYears: "{{count}} ឆ្នាំ",
  overXYears: "ជាង {{count}} ឆ្នាំ",
  almostXYears: "ជិត {{count}} ឆ្នាំ"
}, YAe = function(e, t, n) {
  var r = qAe[e], s = r;
  return typeof t == "number" && (s = s.replace("{{count}}", t.toString())), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "ក្នុងរយៈពេល " + s : s + "មុន" : s;
};
const GAe = YAe;
var QAe = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, KAe = {
  full: "h:mm:ss a",
  long: "h:mm:ss a",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, JAe = {
  full: "{{date}} 'ម៉ោង' {{time}}",
  long: "{{date}} 'ម៉ោង' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ZAe = {
  date: Q({
    formats: QAe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: KAe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: JAe,
    defaultWidth: "full"
  })
};
const e_e = ZAe;
var t_e = {
  lastWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​មុនម៉ោង' p",
  yesterday: "'ម្សិលមិញនៅម៉ោង' p",
  today: "'ថ្ងៃនេះម៉ោង' p",
  tomorrow: "'ថ្ងៃស្អែកម៉ោង' p",
  nextWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​ក្រោយម៉ោង' p",
  other: "P"
}, n_e = function(e, t, n, r) {
  return t_e[e];
};
const r_e = n_e;
var a_e = {
  narrow: ["ម.គស", "គស"],
  abbreviated: ["មុនគ.ស", "គ.ស"],
  wide: ["មុនគ្រិស្តសករាជ", "នៃគ្រិស្តសករាជ"]
}, i_e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["ត្រីមាសទី 1", "ត្រីមាសទី 2", "ត្រីមាសទី 3", "ត្រីមាសទី 4"]
}, o_e = {
  narrow: ["ម.ក", "ក.ម", "មិ", "ម.ស", "ឧ.ស", "ម.ថ", "ក.ដ", "សី", "កញ", "តុ", "វិ", "ធ"],
  abbreviated: ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"],
  wide: ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"]
}, s_e = {
  narrow: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  short: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  abbreviated: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  wide: ["អាទិត្យ", "ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"]
}, l_e = {
  narrow: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  abbreviated: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  wide: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  }
}, u_e = {
  narrow: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  abbreviated: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  wide: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  }
}, c_e = function(e, t) {
  var n = Number(e);
  return n.toString();
}, d_e = {
  ordinalNumber: c_e,
  era: R({
    values: a_e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: i_e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: o_e,
    defaultWidth: "wide"
  }),
  day: R({
    values: s_e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: l_e,
    defaultWidth: "wide",
    formattingValues: u_e,
    defaultFormattingWidth: "wide"
  })
};
const f_e = d_e;
var m_e = /^(\d+)(th|st|nd|rd)?/i, h_e = /\d+/i, p_e = {
  narrow: /^(ម\.)?គស/i,
  abbreviated: /^(មុន)?គ\.ស/i,
  wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
}, v_e = {
  any: [/^(ម|មុន)គ\.?ស/i, /^(នៃ)?គ\.?ស/i]
}, g_e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
}, y_e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, b_e = {
  narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
  abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
  wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
}, w_e = {
  narrow: [/^ម\.ក/i, /^ក\.ម/i, /^មិ/i, /^ម\.ស/i, /^ឧ\.ស/i, /^ម\.ថ/i, /^ក\.ដ/i, /^សី/i, /^កញ/i, /^តុ/i, /^វិ/i, /^ធ/i],
  any: [/^មក/i, /^កុ/i, /^មីន/i, /^មេ/i, /^ឧស/i, /^មិថ/i, /^កក/i, /^សី/i, /^កញ/i, /^តុ/i, /^វិច/i, /^ធ/i]
}, P_e = {
  narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
}, k_e = {
  narrow: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^ស/i],
  any: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^សៅ/i]
}, $_e = {
  narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
  any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
}, S_e = {
  any: {
    am: /^ព្រឹក/i,
    pm: /^ល្ងាច/i,
    midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
    noon: /^ពេលថ្ងៃត្រង់/i,
    morning: /ពេលព្រឹក/i,
    afternoon: /ពេលរសៀល/i,
    evening: /ពេលល្ងាច/i,
    night: /ពេលយប់/i
  }
}, x_e = {
  ordinalNumber: at({
    matchPattern: m_e,
    parsePattern: h_e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: p_e,
    defaultMatchWidth: "wide",
    parsePatterns: v_e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: g_e,
    defaultMatchWidth: "wide",
    parsePatterns: y_e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: b_e,
    defaultMatchWidth: "wide",
    parsePatterns: w_e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: P_e,
    defaultMatchWidth: "wide",
    parsePatterns: k_e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: $_e,
    defaultMatchWidth: "any",
    parsePatterns: S_e,
    defaultParseWidth: "any"
  })
};
const C_e = x_e;
var M_e = {
  code: "km",
  formatDistance: GAe,
  formatLong: e_e,
  formatRelative: r_e,
  localize: f_e,
  match: C_e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const E_e = M_e;
var A_e = {
  lessThanXSeconds: {
    one: {
      default: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      future: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      past: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ"
    },
    other: {
      default: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      future: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      past: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ"
    }
  },
  xSeconds: {
    one: {
      default: "1 ಸೆಕೆಂಡ್",
      future: "1 ಸೆಕೆಂಡ್‌ನಲ್ಲಿ",
      past: "1 ಸೆಕೆಂಡ್ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ಸೆಕೆಂಡುಗಳು",
      future: "{{count}} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ",
      past: "{{count}} ಸೆಕೆಂಡ್ ಹಿಂದೆ"
    }
  },
  halfAMinute: {
    other: {
      default: "ಅರ್ಧ ನಿಮಿಷ",
      future: "ಅರ್ಧ ನಿಮಿಷದಲ್ಲಿ",
      past: "ಅರ್ಧ ನಿಮಿಷದ ಹಿಂದೆ"
    }
  },
  lessThanXMinutes: {
    one: {
      default: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      future: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      past: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
    },
    other: {
      default: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      future: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      past: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
    }
  },
  xMinutes: {
    one: {
      default: "1 ನಿಮಿಷ",
      future: "1 ನಿಮಿಷದಲ್ಲಿ",
      past: "1 ನಿಮಿಷದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ನಿಮಿಷಗಳು",
      future: "{{count}} ನಿಮಿಷಗಳಲ್ಲಿ",
      past: "{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ"
    }
  },
  aboutXHours: {
    one: {
      default: "ಸುಮಾರು 1 ಗಂಟೆ",
      future: "ಸುಮಾರು 1 ಗಂಟೆಯಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ಗಂಟೆ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳು",
      future: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳ ಹಿಂದೆ"
    }
  },
  xHours: {
    one: {
      default: "1 ಗಂಟೆ",
      future: "1 ಗಂಟೆಯಲ್ಲಿ",
      past: "1 ಗಂಟೆ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ಗಂಟೆಗಳು",
      future: "{{count}} ಗಂಟೆಗಳಲ್ಲಿ",
      past: "{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ"
    }
  },
  xDays: {
    one: {
      default: "1 ದಿನ",
      future: "1 ದಿನದಲ್ಲಿ",
      past: "1 ದಿನದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ದಿನಗಳು",
      future: "{{count}} ದಿನಗಳಲ್ಲಿ",
      past: "{{count}} ದಿನಗಳ ಹಿಂದೆ"
    }
  },
  aboutXMonths: {
    one: {
      default: "ಸುಮಾರು 1 ತಿಂಗಳು",
      future: "ಸುಮಾರು 1 ತಿಂಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ತಿಂಗಳ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ತಿಂಗಳು",
      future: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
    }
  },
  xMonths: {
    one: {
      default: "1 ತಿಂಗಳು",
      future: "1 ತಿಂಗಳಲ್ಲಿ",
      past: "1 ತಿಂಗಳ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ತಿಂಗಳು",
      future: "{{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
      past: "{{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
    }
  },
  aboutXYears: {
    one: {
      default: "ಸುಮಾರು 1 ವರ್ಷ",
      future: "ಸುಮಾರು 1 ವರ್ಷದಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ವರ್ಷದ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ವರ್ಷಗಳು",
      future: "ಸುಮಾರು {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ವರ್ಷಗಳ ಹಿಂದೆ"
    }
  },
  xYears: {
    one: {
      default: "1 ವರ್ಷ",
      future: "1 ವರ್ಷದಲ್ಲಿ",
      past: "1 ವರ್ಷದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ವರ್ಷಗಳು",
      future: "{{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "{{count}} ವರ್ಷಗಳ ಹಿಂದೆ"
    }
  },
  overXYears: {
    one: {
      default: "1 ವರ್ಷದ ಮೇಲೆ",
      future: "1 ವರ್ಷದ ಮೇಲೆ",
      past: "1 ವರ್ಷದ ಮೇಲೆ"
    },
    other: {
      default: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
      future: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
      past: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ"
    }
  },
  almostXYears: {
    one: {
      default: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
      future: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
      past: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ"
    },
    other: {
      default: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      future: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ"
    }
  }
};
function LO(e, t) {
  return t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? e.future : e.past : e.default;
}
var __e = function(e, t, n) {
  var r, s = A_e[e];
  return s.one && t === 1 ? r = LO(s.one, n) : r = LO(s.other, n), r.replace("{{count}}", String(t));
};
const O_e = __e;
var T_e = {
  full: "EEEE, MMMM d, y",
  long: "MMMM d, y",
  medium: "MMM d, y",
  short: "d/M/yy"
}, R_e = {
  full: "hh:mm:ss a zzzz",
  long: "hh:mm:ss a z",
  medium: "hh:mm:ss a",
  short: "hh:mm a"
}, D_e = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, N_e = {
  date: Q({
    formats: T_e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: R_e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: D_e,
    defaultWidth: "full"
  })
};
const W_e = N_e;
var j_e = {
  lastWeek: "'ಕಳೆದ' eeee p 'ಕ್ಕೆ'",
  yesterday: "'ನಿನ್ನೆ' p 'ಕ್ಕೆ'",
  today: "'ಇಂದು' p 'ಕ್ಕೆ'",
  tomorrow: "'ನಾಳೆ' p 'ಕ್ಕೆ'",
  nextWeek: "eeee p 'ಕ್ಕೆ'",
  other: "P"
}, z_e = function(e, t, n, r) {
  return j_e[e];
};
const L_e = z_e;
var I_e = {
  narrow: ["ಕ್ರಿ.ಪೂ", "ಕ್ರಿ.ಶ"],
  abbreviated: ["ಕ್ರಿ.ಪೂ", "ಕ್ರಿ.ಶ"],
  wide: ["ಕ್ರಿಸ್ತ ಪೂರ್ವ", "ಕ್ರಿಸ್ತ ಶಕ"]
}, F_e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ತ್ರೈ 1", "ತ್ರೈ 2", "ತ್ರೈ 3", "ತ್ರೈ 4"],
  wide: ["1ನೇ ತ್ರೈಮಾಸಿಕ", "2ನೇ ತ್ರೈಮಾಸಿಕ", "3ನೇ ತ್ರೈಮಾಸಿಕ", "4ನೇ ತ್ರೈಮಾಸಿಕ"]
}, H_e = {
  narrow: ["ಜ", "ಫೆ", "ಮಾ", "ಏ", "ಮೇ", "ಜೂ", "ಜು", "ಆ", "ಸೆ", "ಅ", "ನ", "ಡಿ"],
  abbreviated: ["ಜನ", "ಫೆಬ್ರ", "ಮಾರ್ಚ್", "ಏಪ್ರಿ", "ಮೇ", "ಜೂನ್", "ಜುಲೈ", "ಆಗ", "ಸೆಪ್ಟೆಂ", "ಅಕ್ಟೋ", "ನವೆಂ", "ಡಿಸೆಂ"],
  wide: ["ಜನವರಿ", "ಫೆಬ್ರವರಿ", "ಮಾರ್ಚ್", "ಏಪ್ರಿಲ್", "ಮೇ", "ಜೂನ್", "ಜುಲೈ", "ಆಗಸ್ಟ್", "ಸೆಪ್ಟೆಂಬರ್", "ಅಕ್ಟೋಬರ್", "ನವೆಂಬರ್", "ಡಿಸೆಂಬರ್"]
}, V_e = {
  narrow: ["ಭಾ", "ಸೋ", "ಮಂ", "ಬು", "ಗು", "ಶು", "ಶ"],
  short: ["ಭಾನು", "ಸೋಮ", "ಮಂಗಳ", "ಬುಧ", "ಗುರು", "ಶುಕ್ರ", "ಶನಿ"],
  abbreviated: ["ಭಾನು", "ಸೋಮ", "ಮಂಗಳ", "ಬುಧ", "ಗುರು", "ಶುಕ್ರ", "ಶನಿ"],
  wide: ["ಭಾನುವಾರ", "ಸೋಮವಾರ", "ಮಂಗಳವಾರ", "ಬುಧವಾರ", "ಗುರುವಾರ", "ಶುಕ್ರವಾರ", "ಶನಿವಾರ"]
}, B_e = {
  narrow: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾಹ್ನ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾಹ್ನ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  abbreviated: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  wide: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  }
}, U_e = {
  narrow: {
    am: "ಪೂ",
    pm: "ಅ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  abbreviated: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  wide: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  }
}, X_e = function(e, t) {
  var n = Number(e);
  return n + "ನೇ";
}, q_e = {
  ordinalNumber: X_e,
  era: R({
    values: I_e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: F_e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: H_e,
    defaultWidth: "wide"
  }),
  day: R({
    values: V_e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: B_e,
    defaultWidth: "wide",
    formattingValues: U_e,
    defaultFormattingWidth: "wide"
  })
};
const Y_e = q_e;
var G_e = /^(\d+)(ನೇ|ನೆ)?/i, Q_e = /\d+/i, K_e = {
  narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
  abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
  wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
}, J_e = {
  any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i]
}, Z_e = {
  narrow: /^[1234]/i,
  abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
  wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
}, e3e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, t3e = {
  narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
  abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
  wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
}, n3e = {
  narrow: [/^ಜ$/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂ/i, /^ಜು$/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i],
  any: [/^ಜನ/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂನ್/i, /^ಜುಲೈ/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i]
}, r3e = {
  narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
  short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
}, a3e = {
  narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
  any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i]
}, i3e = {
  narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
  any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
}, o3e = {
  any: {
    am: /^ಪೂ/i,
    pm: /^ಅ/i,
    midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
    noon: /ಮಧ್ಯಾನ್ಹ/i,
    morning: /ಬೆಳಗ್ಗೆ/i,
    afternoon: /ಮಧ್ಯಾನ್ಹ/i,
    evening: /ಸಂಜೆ/i,
    night: /ರಾತ್ರಿ/i
  }
}, s3e = {
  ordinalNumber: at({
    matchPattern: G_e,
    parsePattern: Q_e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: K_e,
    defaultMatchWidth: "wide",
    parsePatterns: J_e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Z_e,
    defaultMatchWidth: "wide",
    parsePatterns: e3e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: t3e,
    defaultMatchWidth: "wide",
    parsePatterns: n3e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: r3e,
    defaultMatchWidth: "wide",
    parsePatterns: a3e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: i3e,
    defaultMatchWidth: "any",
    parsePatterns: o3e,
    defaultParseWidth: "any"
  })
};
const l3e = s3e;
var u3e = {
  code: "kn",
  formatDistance: O_e,
  formatLong: W_e,
  formatRelative: L_e,
  localize: Y_e,
  match: l3e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const c3e = u3e;
var d3e = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만"
  },
  xSeconds: {
    one: "1초",
    other: "{{count}}초"
  },
  halfAMinute: "30초",
  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만"
  },
  xMinutes: {
    one: "1분",
    other: "{{count}}분"
  },
  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간"
  },
  xHours: {
    one: "1시간",
    other: "{{count}}시간"
  },
  xDays: {
    one: "1일",
    other: "{{count}}일"
  },
  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주"
  },
  xWeeks: {
    one: "1주",
    other: "{{count}}주"
  },
  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월"
  },
  xMonths: {
    one: "1개월",
    other: "{{count}}개월"
  },
  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년"
  },
  xYears: {
    one: "1년",
    other: "{{count}}년"
  },
  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상"
  },
  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년"
  }
}, f3e = function(e, t, n) {
  var r, s = d3e[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " 후" : r + " 전" : r;
};
const m3e = f3e;
var h3e = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd"
}, p3e = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, v3e = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, g3e = {
  date: Q({
    formats: h3e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: p3e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: v3e,
    defaultWidth: "full"
  })
};
const y3e = g3e;
var b3e = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P"
}, w3e = function(e, t, n, r) {
  return b3e[e];
};
const P3e = w3e;
var k3e = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"]
}, $3e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"]
}, S3e = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
  wide: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"]
}, x3e = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
}, C3e = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, M3e = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, E3e = function(e, t) {
  var n = Number(e), r = String(t == null ? void 0 : t.unit);
  switch (r) {
    case "minute":
    case "second":
      return String(n);
    case "date":
      return n + "일";
    default:
      return n + "번째";
  }
}, A3e = {
  ordinalNumber: E3e,
  era: R({
    values: k3e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: $3e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: S3e,
    defaultWidth: "wide"
  }),
  day: R({
    values: x3e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: C3e,
    defaultWidth: "wide",
    formattingValues: M3e,
    defaultFormattingWidth: "wide"
  })
};
const _3e = A3e;
var O3e = /^(\d+)(일|번째)?/i, T3e = /\d+/i, R3e = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
}, D3e = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
}, N3e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
}, W3e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, j3e = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
}, z3e = {
  any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
}, L3e = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
}, I3e = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
}, F3e = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
}, H3e = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
}, V3e = {
  ordinalNumber: at({
    matchPattern: O3e,
    parsePattern: T3e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: R3e,
    defaultMatchWidth: "wide",
    parsePatterns: D3e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: N3e,
    defaultMatchWidth: "wide",
    parsePatterns: W3e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: j3e,
    defaultMatchWidth: "wide",
    parsePatterns: z3e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: L3e,
    defaultMatchWidth: "wide",
    parsePatterns: I3e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: F3e,
    defaultMatchWidth: "any",
    parsePatterns: H3e,
    defaultParseWidth: "any"
  })
};
const B3e = V3e;
var U3e = {
  code: "ko",
  formatDistance: m3e,
  formatLong: y3e,
  formatRelative: P3e,
  localize: _3e,
  match: B3e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const X3e = U3e;
var q3e = {
  lessThanXSeconds: {
    standalone: {
      one: "manner wéi eng Sekonn",
      other: "manner wéi {{count}} Sekonnen"
    },
    withPreposition: {
      one: "manner wéi enger Sekonn",
      other: "manner wéi {{count}} Sekonnen"
    }
  },
  xSeconds: {
    standalone: {
      one: "eng Sekonn",
      other: "{{count}} Sekonnen"
    },
    withPreposition: {
      one: "enger Sekonn",
      other: "{{count}} Sekonnen"
    }
  },
  halfAMinute: {
    standalone: "eng hallef Minutt",
    withPreposition: "enger hallwer Minutt"
  },
  lessThanXMinutes: {
    standalone: {
      one: "manner wéi eng Minutt",
      other: "manner wéi {{count}} Minutten"
    },
    withPreposition: {
      one: "manner wéi enger Minutt",
      other: "manner wéi {{count}} Minutten"
    }
  },
  xMinutes: {
    standalone: {
      one: "eng Minutt",
      other: "{{count}} Minutten"
    },
    withPreposition: {
      one: "enger Minutt",
      other: "{{count}} Minutten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "ongeféier eng Stonn",
      other: "ongeféier {{count}} Stonnen"
    },
    withPreposition: {
      one: "ongeféier enger Stonn",
      other: "ongeféier {{count}} Stonnen"
    }
  },
  xHours: {
    standalone: {
      one: "eng Stonn",
      other: "{{count}} Stonnen"
    },
    withPreposition: {
      one: "enger Stonn",
      other: "{{count}} Stonnen"
    }
  },
  xDays: {
    standalone: {
      one: "een Dag",
      other: "{{count}} Deeg"
    },
    withPreposition: {
      one: "engem Dag",
      other: "{{count}} Deeg"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "ongeféier eng Woch",
      other: "ongeféier {{count}} Wochen"
    },
    withPreposition: {
      one: "ongeféier enger Woche",
      other: "ongeféier {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "eng Woch",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "enger Woch",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "ongeféier ee Mount",
      other: "ongeféier {{count}} Méint"
    },
    withPreposition: {
      one: "ongeféier engem Mount",
      other: "ongeféier {{count}} Méint"
    }
  },
  xMonths: {
    standalone: {
      one: "ee Mount",
      other: "{{count}} Méint"
    },
    withPreposition: {
      one: "engem Mount",
      other: "{{count}} Méint"
    }
  },
  aboutXYears: {
    standalone: {
      one: "ongeféier ee Joer",
      other: "ongeféier {{count}} Joer"
    },
    withPreposition: {
      one: "ongeféier engem Joer",
      other: "ongeféier {{count}} Joer"
    }
  },
  xYears: {
    standalone: {
      one: "ee Joer",
      other: "{{count}} Joer"
    },
    withPreposition: {
      one: "engem Joer",
      other: "{{count}} Joer"
    }
  },
  overXYears: {
    standalone: {
      one: "méi wéi ee Joer",
      other: "méi wéi {{count}} Joer"
    },
    withPreposition: {
      one: "méi wéi engem Joer",
      other: "méi wéi {{count}} Joer"
    }
  },
  almostXYears: {
    standalone: {
      one: "bal ee Joer",
      other: "bal {{count}} Joer"
    },
    withPreposition: {
      one: "bal engem Joer",
      other: "bal {{count}} Joer"
    }
  }
}, Y3e = ["d", "h", "n", "t", "z"], G3e = ["a,", "e", "i", "o", "u"], Q3e = [0, 1, 2, 3, 8, 9], K3e = [40, 50, 60, 70];
function IO(e) {
  var t = e.charAt(0).toLowerCase();
  if (G3e.indexOf(t) != -1 || Y3e.indexOf(t) != -1)
    return !0;
  var n = e.split(" ")[0], r = parseInt(n);
  return !isNaN(r) && Q3e.indexOf(r % 10) != -1 && K3e.indexOf(parseInt(n.substring(0, 2))) == -1;
}
var J3e = function(e, t, n) {
  var r, s = q3e[e], f = n != null && n.addSuffix ? s.withPreposition : s.standalone;
  return typeof f == "string" ? r = f : t === 1 ? r = f.one : r = f.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "a" + (IO(r) ? "n" : "") + " " + r : "viru" + (IO(r) ? "n" : "") + " " + r : r;
};
const Z3e = J3e;
var eOe = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.yy"
}, tOe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, nOe = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, rOe = {
  date: Q({
    formats: eOe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: tOe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: nOe,
    defaultWidth: "full"
  })
};
const aOe = rOe;
var iOe = {
  lastWeek: function(e) {
    var t = e.getUTCDay(), n = "'läschte";
    return (t === 2 || t === 4) && (n += "n"), n += "' eeee 'um' p", n;
  },
  yesterday: "'gëschter um' p",
  today: "'haut um' p",
  tomorrow: "'moien um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, oOe = function(e, t, n, r) {
  var s = iOe[e];
  return typeof s == "function" ? s(t) : s;
};
const sOe = oOe;
var lOe = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["viru Christus", "no Christus"]
}, uOe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, cOe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mäe", "Abr", "Mee", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "Mäerz", "Abrëll", "Mee", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, dOe = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mé", "Dë", "Më", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mé.", "Dë.", "Më.", "Do.", "Fr.", "Sa."],
  wide: ["Sonndeg", "Méindeg", "Dënschdeg", "Mëttwoch", "Donneschdeg", "Freideg", "Samschdeg"]
}, fOe = {
  narrow: {
    am: "mo.",
    pm: "nomë.",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht"
  },
  abbreviated: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht"
  },
  wide: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht"
  }
}, mOe = {
  narrow: {
    am: "mo.",
    pm: "nom.",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets"
  },
  abbreviated: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets"
  },
  wide: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets"
  }
}, hOe = function(e, t) {
  var n = Number(e);
  return n + ".";
}, pOe = {
  ordinalNumber: hOe,
  era: R({
    values: lOe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: uOe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: cOe,
    defaultWidth: "wide"
  }),
  day: R({
    values: dOe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: fOe,
    defaultWidth: "wide",
    formattingValues: mOe,
    defaultFormattingWidth: "wide"
  })
};
const vOe = pOe;
var gOe = /^(\d+)(\.)?/i, yOe = /\d+/i, bOe = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
}, wOe = {
  any: [/^v/i, /^n/i]
}, POe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, kOe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $Oe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
  wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
}, SOe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mä/i, /^ab/i, /^me/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, xOe = {
  narrow: /^[smdf]/i,
  short: /^(so|mé|dë|më|do|fr|sa)/i,
  abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
  wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
}, COe = {
  any: [/^so/i, /^mé/i, /^dë/i, /^më/i, /^do/i, /^f/i, /^sa/i]
}, MOe = {
  narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
  abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
  wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
}, EOe = {
  any: {
    am: /^m/i,
    pm: /^n/i,
    midnight: /^Mëtter/i,
    noon: /^mëttes/i,
    morning: /moies/i,
    afternoon: /nomëttes/i,
    evening: /owes/i,
    night: /nuets/i
  }
}, AOe = {
  ordinalNumber: at({
    matchPattern: gOe,
    parsePattern: yOe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: bOe,
    defaultMatchWidth: "wide",
    parsePatterns: wOe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: POe,
    defaultMatchWidth: "wide",
    parsePatterns: kOe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: $Oe,
    defaultMatchWidth: "wide",
    parsePatterns: SOe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: xOe,
    defaultMatchWidth: "wide",
    parsePatterns: COe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: MOe,
    defaultMatchWidth: "wide",
    parsePatterns: EOe,
    defaultParseWidth: "any"
  })
};
const _Oe = AOe;
var OOe = {
  code: "lb",
  formatDistance: Z3e,
  formatLong: aOe,
  formatRelative: sOe,
  localize: vOe,
  match: _Oe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const TOe = OOe;
var $W = {
  xseconds_other: "sekundė_sekundžių_sekundes",
  xminutes_one: "minutė_minutės_minutę",
  xminutes_other: "minutės_minučių_minutes",
  xhours_one: "valanda_valandos_valandą",
  xhours_other: "valandos_valandų_valandas",
  xdays_one: "diena_dienos_dieną",
  xdays_other: "dienos_dienų_dienas",
  xweeks_one: "savaitė_savaitės_savaitę",
  xweeks_other: "savaitės_savaičių_savaites",
  xmonths_one: "mėnuo_mėnesio_mėnesį",
  xmonths_other: "mėnesiai_mėnesių_mėnesius",
  xyears_one: "metai_metų_metus",
  xyears_other: "metai_metų_metus",
  about: "apie",
  over: "daugiau nei",
  almost: "beveik",
  lessthan: "mažiau nei"
}, FO = function(e, t, n, r) {
  return t ? r ? "kelių sekundžių" : "kelias sekundes" : "kelios sekundės";
}, jo = function(e, t, n, r) {
  return t ? r ? pd(n)[1] : pd(n)[2] : pd(n)[0];
}, fo = function(e, t, n, r) {
  var s = e + " ";
  return e === 1 ? s + jo(e, t, n, r) : t ? r ? s + pd(n)[1] : s + (HO(e) ? pd(n)[1] : pd(n)[2]) : s + (HO(e) ? pd(n)[1] : pd(n)[0]);
};
function HO(e) {
  return e % 10 === 0 || e > 10 && e < 20;
}
function pd(e) {
  return $W[e].split("_");
}
var ROe = {
  lessThanXSeconds: {
    one: FO,
    other: fo
  },
  xSeconds: {
    one: FO,
    other: fo
  },
  halfAMinute: "pusė minutės",
  lessThanXMinutes: {
    one: jo,
    other: fo
  },
  xMinutes: {
    one: jo,
    other: fo
  },
  aboutXHours: {
    one: jo,
    other: fo
  },
  xHours: {
    one: jo,
    other: fo
  },
  xDays: {
    one: jo,
    other: fo
  },
  aboutXWeeks: {
    one: jo,
    other: fo
  },
  xWeeks: {
    one: jo,
    other: fo
  },
  aboutXMonths: {
    one: jo,
    other: fo
  },
  xMonths: {
    one: jo,
    other: fo
  },
  aboutXYears: {
    one: jo,
    other: fo
  },
  xYears: {
    one: jo,
    other: fo
  },
  overXYears: {
    one: jo,
    other: fo
  },
  almostXYears: {
    one: jo,
    other: fo
  }
}, DOe = function(e, t, n) {
  var r = e.match(/about|over|almost|lessthan/i), s = r ? e.replace(r[0], "") : e, f = (n == null ? void 0 : n.comparison) !== void 0 && n.comparison > 0, m, p = ROe[e];
  if (typeof p == "string" ? m = p : t === 1 ? m = p.one(t, (n == null ? void 0 : n.addSuffix) === !0, s.toLowerCase() + "_one", f) : m = p.other(t, (n == null ? void 0 : n.addSuffix) === !0, s.toLowerCase() + "_other", f), r) {
    var v = r[0].toLowerCase();
    m = $W[v] + " " + m;
  }
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "po " + m : "prieš " + m : m;
};
const NOe = DOe;
var WOe = {
  full: "y 'm'. MMMM d 'd'., EEEE",
  long: "y 'm'. MMMM d 'd'.",
  medium: "y-MM-dd",
  short: "y-MM-dd"
}, jOe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, zOe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, LOe = {
  date: Q({
    formats: WOe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: jOe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: zOe,
    defaultWidth: "full"
  })
};
const IOe = LOe;
var FOe = {
  lastWeek: "'Praėjusį' eeee p",
  yesterday: "'Vakar' p",
  today: "'Šiandien' p",
  tomorrow: "'Rytoj' p",
  nextWeek: "eeee p",
  other: "P"
}, HOe = function(e, t, n, r) {
  return FOe[e];
};
const VOe = HOe;
var BOe = {
  narrow: ["pr. Kr.", "po Kr."],
  abbreviated: ["pr. Kr.", "po Kr."],
  wide: ["prieš Kristų", "po Kristaus"]
}, UOe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I ketv.", "II ketv.", "III ketv.", "IV ketv."],
  wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
}, XOe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I k.", "II k.", "III k.", "IV k."],
  wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
}, qOe = {
  narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
  abbreviated: ["saus.", "vas.", "kov.", "bal.", "geg.", "birž.", "liep.", "rugp.", "rugs.", "spal.", "lapkr.", "gruod."],
  wide: ["sausis", "vasaris", "kovas", "balandis", "gegužė", "birželis", "liepa", "rugpjūtis", "rugsėjis", "spalis", "lapkritis", "gruodis"]
}, YOe = {
  narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
  abbreviated: ["saus.", "vas.", "kov.", "bal.", "geg.", "birž.", "liep.", "rugp.", "rugs.", "spal.", "lapkr.", "gruod."],
  wide: ["sausio", "vasario", "kovo", "balandžio", "gegužės", "birželio", "liepos", "rugpjūčio", "rugsėjo", "spalio", "lapkričio", "gruodžio"]
}, GOe = {
  narrow: ["S", "P", "A", "T", "K", "P", "Š"],
  short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Št"],
  abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
  wide: ["sekmadienis", "pirmadienis", "antradienis", "trečiadienis", "ketvirtadienis", "penktadienis", "šeštadienis"]
}, QOe = {
  narrow: ["S", "P", "A", "T", "K", "P", "Š"],
  short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Št"],
  abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
  wide: ["sekmadienį", "pirmadienį", "antradienį", "trečiadienį", "ketvirtadienį", "penktadienį", "šeštadienį"]
}, KOe = {
  narrow: {
    am: "pr. p.",
    pm: "pop.",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  },
  abbreviated: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  },
  wide: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  }
}, JOe = {
  narrow: {
    am: "pr. p.",
    pm: "pop.",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  },
  abbreviated: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  },
  wide: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  }
}, ZOe = function(e, t) {
  var n = Number(e);
  return n + "-oji";
}, eTe = {
  ordinalNumber: ZOe,
  era: R({
    values: BOe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: UOe,
    defaultWidth: "wide",
    formattingValues: XOe,
    defaultFormattingWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: qOe,
    defaultWidth: "wide",
    formattingValues: YOe,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: GOe,
    defaultWidth: "wide",
    formattingValues: QOe,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: R({
    values: KOe,
    defaultWidth: "wide",
    formattingValues: JOe,
    defaultFormattingWidth: "wide"
  })
};
const tTe = eTe;
var nTe = /^(\d+)(-oji)?/i, rTe = /\d+/i, aTe = {
  narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
  abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
  wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
}, iTe = {
  wide: [/prieš/i, /(po|mūsų)/i],
  any: [/^pr/i, /^(po|m)/i]
}, oTe = {
  narrow: /^([1234])/i,
  abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
  wide: /^(I|II|III|IV)\s?ketvirtis/i
}, sTe = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/I$/i, /II$/i, /III/i, /IV/i]
}, lTe = {
  narrow: /^[svkbglr]/i,
  abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
  wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
}, uTe = {
  narrow: [/^s/i, /^v/i, /^k/i, /^b/i, /^g/i, /^b/i, /^l/i, /^r/i, /^r/i, /^s/i, /^l/i, /^g/i],
  any: [/^saus/i, /^vas/i, /^kov/i, /^bal/i, /^geg/i, /^birž/i, /^liep/i, /^rugp/i, /^rugs/i, /^spal/i, /^lapkr/i, /^gruod/i]
}, cTe = {
  narrow: /^[spatkš]/i,
  short: /^(sk|pr|an|tr|kt|pn|št)/i,
  abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
  wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
}, dTe = {
  narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
  wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
  any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i]
}, fTe = {
  narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
  any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
}, mTe = {
  narrow: {
    am: /^pr/i,
    pm: /^pop./i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i
  },
  any: {
    am: /^pr/i,
    pm: /^popiet$/i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i
  }
}, hTe = {
  ordinalNumber: at({
    matchPattern: nTe,
    parsePattern: rTe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: aTe,
    defaultMatchWidth: "wide",
    parsePatterns: iTe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: oTe,
    defaultMatchWidth: "wide",
    parsePatterns: sTe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: lTe,
    defaultMatchWidth: "wide",
    parsePatterns: uTe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: cTe,
    defaultMatchWidth: "wide",
    parsePatterns: dTe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: fTe,
    defaultMatchWidth: "any",
    parsePatterns: mTe,
    defaultParseWidth: "any"
  })
};
const pTe = hTe;
var vTe = {
  code: "lt",
  formatDistance: NOe,
  formatLong: IOe,
  formatRelative: VOe,
  localize: tTe,
  match: pTe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const gTe = vTe;
function mo(e) {
  return function(t, n) {
    if (t === 1)
      return n != null && n.addSuffix ? e.one[0].replace("{{time}}", e.one[2]) : e.one[0].replace("{{time}}", e.one[1]);
    var r = t % 10 === 1 && t % 100 !== 11;
    return n != null && n.addSuffix ? e.other[0].replace("{{time}}", r ? e.other[3] : e.other[4]).replace("{{count}}", String(t)) : e.other[0].replace("{{time}}", r ? e.other[1] : e.other[2]).replace("{{count}}", String(t));
  };
}
var yTe = {
  lessThanXSeconds: mo({
    one: ["mazāk par {{time}}", "sekundi", "sekundi"],
    other: ["mazāk nekā {{count}} {{time}}", "sekunde", "sekundes", "sekundes", "sekundēm"]
  }),
  xSeconds: mo({
    one: ["1 {{time}}", "sekunde", "sekundes"],
    other: ["{{count}} {{time}}", "sekunde", "sekundes", "sekundes", "sekundēm"]
  }),
  halfAMinute: function(e, t) {
    return t != null && t.addSuffix ? "pusminūtes" : "pusminūte";
  },
  lessThanXMinutes: mo({
    one: ["mazāk par {{time}}", "minūti", "minūti"],
    other: ["mazāk nekā {{count}} {{time}}", "minūte", "minūtes", "minūtes", "minūtēm"]
  }),
  xMinutes: mo({
    one: ["1 {{time}}", "minūte", "minūtes"],
    other: ["{{count}} {{time}}", "minūte", "minūtes", "minūtes", "minūtēm"]
  }),
  aboutXHours: mo({
    one: ["apmēram 1 {{time}}", "stunda", "stundas"],
    other: ["apmēram {{count}} {{time}}", "stunda", "stundas", "stundas", "stundām"]
  }),
  xHours: mo({
    one: ["1 {{time}}", "stunda", "stundas"],
    other: ["{{count}} {{time}}", "stunda", "stundas", "stundas", "stundām"]
  }),
  xDays: mo({
    one: ["1 {{time}}", "diena", "dienas"],
    other: ["{{count}} {{time}}", "diena", "dienas", "dienas", "dienām"]
  }),
  aboutXWeeks: mo({
    one: ["apmēram 1 {{time}}", "nedēļa", "nedēļas"],
    other: ["apmēram {{count}} {{time}}", "nedēļa", "nedēļu", "nedēļas", "nedēļām"]
  }),
  xWeeks: mo({
    one: ["1 {{time}}", "nedēļa", "nedēļas"],
    other: [
      "{{count}} {{time}}",
      "nedēļa",
      "nedēļu",
      "nedēļas",
      "nedēļām"
    ]
  }),
  aboutXMonths: mo({
    one: ["apmēram 1 {{time}}", "mēnesis", "mēneša"],
    other: ["apmēram {{count}} {{time}}", "mēnesis", "mēneši", "mēneša", "mēnešiem"]
  }),
  xMonths: mo({
    one: ["1 {{time}}", "mēnesis", "mēneša"],
    other: ["{{count}} {{time}}", "mēnesis", "mēneši", "mēneša", "mēnešiem"]
  }),
  aboutXYears: mo({
    one: ["apmēram 1 {{time}}", "gads", "gada"],
    other: ["apmēram {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  xYears: mo({
    one: ["1 {{time}}", "gads", "gada"],
    other: ["{{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  overXYears: mo({
    one: ["ilgāk par 1 {{time}}", "gadu", "gadu"],
    other: ["vairāk nekā {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  almostXYears: mo({
    one: ["gandrīz 1 {{time}}", "gads", "gada"],
    other: ["vairāk nekā {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  })
}, bTe = function(e, t, n) {
  var r = yTe[e](t, n);
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "pēc " + r : "pirms " + r : r;
};
const wTe = bTe;
var PTe = {
  full: "EEEE, y. 'gada' d. MMMM",
  long: "y. 'gada' d. MMMM",
  medium: "dd.MM.y.",
  short: "dd.MM.y."
}, kTe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, $Te = {
  full: "{{date}} 'plkst.' {{time}}",
  long: "{{date}} 'plkst.' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, STe = {
  date: Q({
    formats: PTe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: kTe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: $Te,
    defaultWidth: "full"
  })
};
const xTe = STe;
var VO = ["svētdienā", "pirmdienā", "otrdienā", "trešdienā", "ceturtdienā", "piektdienā", "sestdienā"], CTe = {
  lastWeek: function(e, t, n) {
    if (ca(e, t, n))
      return "eeee 'plkst.' p";
    var r = VO[e.getUTCDay()];
    return "'Pagājušā " + r + " plkst.' p";
  },
  yesterday: "'Vakar plkst.' p",
  today: "'Šodien plkst.' p",
  tomorrow: "'Rīt plkst.' p",
  nextWeek: function(e, t, n) {
    if (ca(e, t, n))
      return "eeee 'plkst.' p";
    var r = VO[e.getUTCDay()];
    return "'Nākamajā " + r + " plkst.' p";
  },
  other: "P"
}, MTe = function(e, t, n, r) {
  var s = CTe[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const ETe = MTe;
var ATe = {
  narrow: ["p.m.ē", "m.ē"],
  abbreviated: ["p. m. ē.", "m. ē."],
  wide: ["pirms mūsu ēras", "mūsu ērā"]
}, _Te = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
  wide: ["pirmais ceturksnis", "otrais ceturksnis", "trešais ceturksnis", "ceturtais ceturksnis"]
}, OTe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
  wide: ["pirmajā ceturksnī", "otrajā ceturksnī", "trešajā ceturksnī", "ceturtajā ceturksnī"]
}, TTe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "febr.", "marts", "apr.", "maijs", "jūn.", "jūl.", "aug.", "sept.", "okt.", "nov.", "dec."],
  wide: ["janvāris", "februāris", "marts", "aprīlis", "maijs", "jūnijs", "jūlijs", "augusts", "septembris", "oktobris", "novembris", "decembris"]
}, RTe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "febr.", "martā", "apr.", "maijs", "jūn.", "jūl.", "aug.", "sept.", "okt.", "nov.", "dec."],
  wide: ["janvārī", "februārī", "martā", "aprīlī", "maijā", "jūnijā", "jūlijā", "augustā", "septembrī", "oktobrī", "novembrī", "decembrī"]
}, DTe = {
  narrow: ["S", "P", "O", "T", "C", "P", "S"],
  short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
  abbreviated: ["svētd.", "pirmd.", "otrd.", "trešd.", "ceturtd.", "piektd.", "sestd."],
  wide: ["svētdiena", "pirmdiena", "otrdiena", "trešdiena", "ceturtdiena", "piektdiena", "sestdiena"]
}, NTe = {
  narrow: ["S", "P", "O", "T", "C", "P", "S"],
  short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
  abbreviated: ["svētd.", "pirmd.", "otrd.", "trešd.", "ceturtd.", "piektd.", "sestd."],
  wide: ["svētdienā", "pirmdienā", "otrdienā", "trešdienā", "ceturtdienā", "piektdienā", "sestdienā"]
}, WTe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rīts",
    afternoon: "diena",
    evening: "vakars",
    night: "nakts"
  },
  abbreviated: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rīts",
    afternoon: "pēcpusd.",
    evening: "vakars",
    night: "nakts"
  },
  wide: {
    am: "am",
    pm: "pm",
    midnight: "pusnakts",
    noon: "pusdienlaiks",
    morning: "rīts",
    afternoon: "pēcpusdiena",
    evening: "vakars",
    night: "nakts"
  }
}, jTe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rītā",
    afternoon: "dienā",
    evening: "vakarā",
    night: "naktī"
  },
  abbreviated: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rītā",
    afternoon: "pēcpusd.",
    evening: "vakarā",
    night: "naktī"
  },
  wide: {
    am: "am",
    pm: "pm",
    midnight: "pusnaktī",
    noon: "pusdienlaikā",
    morning: "rītā",
    afternoon: "pēcpusdienā",
    evening: "vakarā",
    night: "naktī"
  }
}, zTe = function(e, t) {
  var n = Number(e);
  return n + ".";
}, LTe = {
  ordinalNumber: zTe,
  era: R({
    values: ATe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: _Te,
    defaultWidth: "wide",
    formattingValues: OTe,
    defaultFormattingWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: TTe,
    defaultWidth: "wide",
    formattingValues: RTe,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: DTe,
    defaultWidth: "wide",
    formattingValues: NTe,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: R({
    values: WTe,
    defaultWidth: "wide",
    formattingValues: jTe,
    defaultFormattingWidth: "wide"
  })
};
const ITe = LTe;
var FTe = /^(\d+)\./i, HTe = /\d+/i, VTe = {
  narrow: /^(p\.m\.ē|m\.ē)/i,
  abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
  wide: /^(pirms mūsu ēras|mūsu ērā)/i
}, BTe = {
  any: [/^p/i, /^m/i]
}, UTe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](\. cet\.)/i,
  wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
}, XTe = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
  abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
  wide: [/^p/i, /^o/i, /^t/i, /^c/i]
}, qTe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
  wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
}, YTe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jūn/i, /^jūl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, GTe = {
  narrow: /^[spotc]/i,
  short: /^(sv|pi|o|t|c|pk|s)/i,
  abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
  wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
}, QTe = {
  narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
  any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i]
}, KTe = {
  narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
  abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
  wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
}, JTe = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^pusn/i,
    noon: /^pusd/i,
    morning: /^r/i,
    afternoon: /^(d|pēc)/i,
    evening: /^v/i,
    night: /^n/i
  }
}, ZTe = {
  ordinalNumber: at({
    matchPattern: FTe,
    parsePattern: HTe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: VTe,
    defaultMatchWidth: "wide",
    parsePatterns: BTe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: UTe,
    defaultMatchWidth: "wide",
    parsePatterns: XTe,
    defaultParseWidth: "wide",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: qTe,
    defaultMatchWidth: "wide",
    parsePatterns: YTe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: GTe,
    defaultMatchWidth: "wide",
    parsePatterns: QTe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: KTe,
    defaultMatchWidth: "wide",
    parsePatterns: JTe,
    defaultParseWidth: "any"
  })
};
const e4e = ZTe;
var t4e = {
  code: "lv",
  formatDistance: wTe,
  formatLong: xTe,
  formatRelative: ETe,
  localize: ITe,
  match: e4e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const n4e = t4e;
var r4e = {
  lessThanXSeconds: {
    one: "помалку од секунда",
    other: "помалку од {{count}} секунди"
  },
  xSeconds: {
    one: "1 секунда",
    other: "{{count}} секунди"
  },
  halfAMinute: "половина минута",
  lessThanXMinutes: {
    one: "помалку од минута",
    other: "помалку од {{count}} минути"
  },
  xMinutes: {
    one: "1 минута",
    other: "{{count}} минути"
  },
  aboutXHours: {
    one: "околу 1 час",
    other: "околу {{count}} часа"
  },
  xHours: {
    one: "1 час",
    other: "{{count}} часа"
  },
  xDays: {
    one: "1 ден",
    other: "{{count}} дена"
  },
  aboutXWeeks: {
    one: "околу 1 недела",
    other: "околу {{count}} месеци"
  },
  xWeeks: {
    one: "1 недела",
    other: "{{count}} недели"
  },
  aboutXMonths: {
    one: "околу 1 месец",
    other: "околу {{count}} недели"
  },
  xMonths: {
    one: "1 месец",
    other: "{{count}} месеци"
  },
  aboutXYears: {
    one: "околу 1 година",
    other: "околу {{count}} години"
  },
  xYears: {
    one: "1 година",
    other: "{{count}} години"
  },
  overXYears: {
    one: "повеќе од 1 година",
    other: "повеќе од {{count}} години"
  },
  almostXYears: {
    one: "безмалку 1 година",
    other: "безмалку {{count}} години"
  }
}, a4e = function(e, t, n) {
  var r, s = r4e[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "за " + r : "пред " + r : r;
};
const i4e = a4e;
var o4e = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy"
}, s4e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
}, l4e = {
  any: "{{date}} {{time}}"
}, u4e = {
  date: Q({
    formats: o4e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: s4e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: l4e,
    defaultWidth: "any"
  })
};
const c4e = u4e;
var gx = ["недела", "понеделник", "вторник", "среда", "четврток", "петок", "сабота"];
function d4e(e) {
  var t = gx[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'минатата " + t + " во' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'минатиот " + t + " во' p";
  }
}
function BO(e) {
  var t = gx[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'ова " + t + " вo' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'овој " + t + " вo' p";
  }
}
function f4e(e) {
  var t = gx[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'следната " + t + " вo' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'следниот " + t + " вo' p";
  }
}
var m4e = {
  lastWeek: function(e, t, n) {
    var r = e.getUTCDay();
    return ca(e, t, n) ? BO(r) : d4e(r);
  },
  yesterday: "'вчера во' p",
  today: "'денес во' p",
  tomorrow: "'утре во' p",
  nextWeek: function(e, t, n) {
    var r = e.getUTCDay();
    return ca(e, t, n) ? BO(r) : f4e(r);
  },
  other: "P"
}, h4e = function(e, t, n, r) {
  var s = m4e[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const p4e = h4e;
var v4e = {
  narrow: ["пр.н.е.", "н.е."],
  abbreviated: ["пред н. е.", "н. е."],
  wide: ["пред нашата ера", "нашата ера"]
}, g4e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ви кв.", "2-ри кв.", "3-ти кв.", "4-ти кв."],
  wide: ["1-ви квартал", "2-ри квартал", "3-ти квартал", "4-ти квартал"]
}, y4e = {
  abbreviated: ["јан", "фев", "мар", "апр", "мај", "јун", "јул", "авг", "септ", "окт", "ноем", "дек"],
  wide: ["јануари", "февруари", "март", "април", "мај", "јуни", "јули", "август", "септември", "октомври", "ноември", "декември"]
}, b4e = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["не", "по", "вт", "ср", "че", "пе", "са"],
  abbreviated: ["нед", "пон", "вто", "сре", "чет", "пет", "саб"],
  wide: ["недела", "понеделник", "вторник", "среда", "четврток", "петок", "сабота"]
}, w4e = {
  wide: {
    am: "претпладне",
    pm: "попладне",
    midnight: "полноќ",
    noon: "напладне",
    morning: "наутро",
    afternoon: "попладне",
    evening: "навечер",
    night: "ноќе"
  }
}, P4e = function(e, t) {
  var n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "-ви";
      case 2:
        return n + "-ри";
      case 7:
      case 8:
        return n + "-ми";
    }
  return n + "-ти";
}, k4e = {
  ordinalNumber: P4e,
  era: R({
    values: v4e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: g4e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: y4e,
    defaultWidth: "wide"
  }),
  day: R({
    values: b4e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: w4e,
    defaultWidth: "wide"
  })
};
const $4e = k4e;
var S4e = /^(\d+)(-?[врмт][и])?/i, x4e = /\d+/i, C4e = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(пред нашата ера|нашата ера)/i
}, M4e = {
  any: [/^п/i, /^н/i]
}, E4e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
  wide: /^[1234](-?[врт]?и?)? квартал/i
}, A4e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _4e = {
  narrow: /^[нпвсч]/i,
  short: /^(не|по|вт|ср|че|пе|са)/i,
  abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
  wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
}, O4e = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i]
}, T4e = {
  abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
  wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
}, R4e = {
  any: [/^ја/i, /^Ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
}, D4e = {
  any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
}, N4e = {
  any: {
    am: /претпладне/i,
    pm: /попладне/i,
    midnight: /полноќ/i,
    noon: /напладне/i,
    morning: /наутро/i,
    afternoon: /попладне/i,
    evening: /навечер/i,
    night: /ноќе/i
  }
}, W4e = {
  ordinalNumber: at({
    matchPattern: S4e,
    parsePattern: x4e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: C4e,
    defaultMatchWidth: "wide",
    parsePatterns: M4e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: E4e,
    defaultMatchWidth: "wide",
    parsePatterns: A4e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: T4e,
    defaultMatchWidth: "wide",
    parsePatterns: R4e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: _4e,
    defaultMatchWidth: "wide",
    parsePatterns: O4e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: D4e,
    defaultMatchWidth: "any",
    parsePatterns: N4e,
    defaultParseWidth: "any"
  })
};
const j4e = W4e;
var z4e = {
  code: "mk",
  formatDistance: i4e,
  formatLong: c4e,
  formatRelative: p4e,
  localize: $4e,
  match: j4e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const L4e = z4e;
var I4e = {
  lessThanXSeconds: {
    one: "секунд хүрэхгүй",
    other: "{{count}} секунд хүрэхгүй"
  },
  xSeconds: {
    one: "1 секунд",
    other: "{{count}} секунд"
  },
  halfAMinute: "хагас минут",
  lessThanXMinutes: {
    one: "минут хүрэхгүй",
    other: "{{count}} минут хүрэхгүй"
  },
  xMinutes: {
    one: "1 минут",
    other: "{{count}} минут"
  },
  aboutXHours: {
    one: "ойролцоогоор 1 цаг",
    other: "ойролцоогоор {{count}} цаг"
  },
  xHours: {
    one: "1 цаг",
    other: "{{count}} цаг"
  },
  xDays: {
    one: "1 өдөр",
    other: "{{count}} өдөр"
  },
  aboutXWeeks: {
    one: "ойролцоогоор 1 долоо хоног",
    other: "ойролцоогоор {{count}} долоо хоног"
  },
  xWeeks: {
    one: "1 долоо хоног",
    other: "{{count}} долоо хоног"
  },
  aboutXMonths: {
    one: "ойролцоогоор 1 сар",
    other: "ойролцоогоор {{count}} сар"
  },
  xMonths: {
    one: "1 сар",
    other: "{{count}} сар"
  },
  aboutXYears: {
    one: "ойролцоогоор 1 жил",
    other: "ойролцоогоор {{count}} жил"
  },
  xYears: {
    one: "1 жил",
    other: "{{count}} жил"
  },
  overXYears: {
    one: "1 жил гаран",
    other: "{{count}} жил гаран"
  },
  almostXYears: {
    one: "бараг 1 жил",
    other: "бараг {{count}} жил"
  }
}, F4e = function(e, t, n) {
  var r, s = I4e[e];
  if (typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix) {
    var f = r.split(" "), m = f.pop();
    switch (r = f.join(" "), m) {
      case "секунд":
        r += " секундийн";
        break;
      case "минут":
        r += " минутын";
        break;
      case "цаг":
        r += " цагийн";
        break;
      case "өдөр":
        r += " өдрийн";
        break;
      case "сар":
        r += " сарын";
        break;
      case "жил":
        r += " жилийн";
        break;
      case "хоног":
        r += " хоногийн";
        break;
      case "гаран":
        r += " гараны";
        break;
      case "хүрэхгүй":
        r += " хүрэхгүй хугацааны";
        break;
      default:
        r += m + "-н";
    }
    return n.comparison && n.comparison > 0 ? r + " дараа" : r + " өмнө";
  }
  return r;
};
const H4e = F4e;
var V4e = {
  full: "y 'оны' MMMM'ын' d, EEEE 'гараг'",
  long: "y 'оны' MMMM'ын' d",
  medium: "y 'оны' MMM'ын' d",
  short: "y.MM.dd"
}, B4e = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, U4e = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, X4e = {
  date: Q({
    formats: V4e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: B4e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: U4e,
    defaultWidth: "full"
  })
};
const q4e = X4e;
var Y4e = {
  lastWeek: "'өнгөрсөн' eeee 'гарагийн' p 'цагт'",
  yesterday: "'өчигдөр' p 'цагт'",
  today: "'өнөөдөр' p 'цагт'",
  tomorrow: "'маргааш' p 'цагт'",
  nextWeek: "'ирэх' eeee 'гарагийн' p 'цагт'",
  other: "P"
}, G4e = function(e, t, n, r) {
  return Y4e[e];
};
const Q4e = G4e;
var K4e = {
  narrow: ["НТӨ", "НТ"],
  abbreviated: ["НТӨ", "НТ"],
  wide: ["нийтийн тооллын өмнөх", "нийтийн тооллын"]
}, J4e = {
  narrow: ["I", "II", "III", "IV"],
  abbreviated: ["I улирал", "II улирал", "III улирал", "IV улирал"],
  wide: ["1-р улирал", "2-р улирал", "3-р улирал", "4-р улирал"]
}, Z4e = {
  narrow: ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"],
  abbreviated: ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"],
  wide: ["Нэгдүгээр сар", "Хоёрдугаар сар", "Гуравдугаар сар", "Дөрөвдүгээр сар", "Тавдугаар сар", "Зургаадугаар сар", "Долоодугаар сар", "Наймдугаар сар", "Есдүгээр сар", "Аравдугаар сар", "Арваннэгдүгээр сар", "Арван хоёрдугаар сар"]
}, eRe = {
  narrow: ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"],
  abbreviated: ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"],
  wide: ["нэгдүгээр сар", "хоёрдугаар сар", "гуравдугаар сар", "дөрөвдүгээр сар", "тавдугаар сар", "зургаадугаар сар", "долоодугаар сар", "наймдугаар сар", "есдүгээр сар", "аравдугаар сар", "арваннэгдүгээр сар", "арван хоёрдугаар сар"]
}, tRe = {
  narrow: ["Н", "Д", "М", "Л", "П", "Б", "Б"],
  short: ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"],
  abbreviated: ["Ням", "Дав", "Мяг", "Лха", "Пүр", "Баа", "Бям"],
  wide: ["Ням", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба"]
}, nRe = {
  narrow: ["Н", "Д", "М", "Л", "П", "Б", "Б"],
  short: ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"],
  abbreviated: ["Ням", "Дав", "Мяг", "Лха", "Пүр", "Баа", "Бям"],
  wide: ["ням", "даваа", "мягмар", "лхагва", "пүрэв", "баасан", "бямба"]
}, rRe = {
  narrow: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  },
  abbreviated: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  },
  wide: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  }
}, aRe = function(e, t) {
  return String(e);
}, iRe = {
  ordinalNumber: aRe,
  era: R({
    values: K4e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: J4e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Z4e,
    defaultWidth: "wide",
    formattingValues: eRe,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: tRe,
    defaultWidth: "wide",
    formattingValues: nRe,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: R({
    values: rRe,
    defaultWidth: "wide"
  })
};
const oRe = iRe;
var sRe = /\d+/i, lRe = /\d+/i, uRe = {
  narrow: /^(нтө|нт)/i,
  abbreviated: /^(нтө|нт)/i,
  wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
}, cRe = {
  any: [/^(нтө|нийтийн тооллын өмнө)/i, /^(нт|нийтийн тооллын)/i]
}, dRe = {
  narrow: /^(iv|iii|ii|i)/i,
  abbreviated: /^(iv|iii|ii|i) улирал/i,
  wide: /^[1-4]-р улирал/i
}, fRe = {
  any: [/^(i(\s|$)|1)/i, /^(ii(\s|$)|2)/i, /^(iii(\s|$)|3)/i, /^(iv(\s|$)|4)/i]
}, mRe = {
  narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
  abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
  wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
}, hRe = {
  narrow: [/^i$/i, /^ii$/i, /^iii$/i, /^iv$/i, /^v$/i, /^vi$/i, /^vii$/i, /^viii$/i, /^ix$/i, /^x$/i, /^xi$/i, /^xii$/i],
  any: [/^(1|нэгдүгээр)/i, /^(2|хоёрдугаар)/i, /^(3|гуравдугаар)/i, /^(4|дөрөвдүгээр)/i, /^(5|тавдугаар)/i, /^(6|зургаадугаар)/i, /^(7|долоодугаар)/i, /^(8|наймдугаар)/i, /^(9|есдүгээр)/i, /^(10|аравдугаар)/i, /^(11|арван нэгдүгээр)/i, /^(12|арван хоёрдугаар)/i]
}, pRe = {
  narrow: /^[ндмлпбб]/i,
  short: /^(ня|да|мя|лх|пү|ба|бя)/i,
  abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
  wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
}, vRe = {
  narrow: [/^н/i, /^д/i, /^м/i, /^л/i, /^п/i, /^б/i, /^б/i],
  any: [/^ня/i, /^да/i, /^мя/i, /^лх/i, /^пү/i, /^ба/i, /^бя/i]
}, gRe = {
  narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
  any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
}, yRe = {
  any: {
    am: /^ү\.ө\./i,
    pm: /^ү\.х\./i,
    midnight: /^шөнө дунд/i,
    noon: /^үд дунд/i,
    morning: /өглөө/i,
    afternoon: /өдөр/i,
    evening: /орой/i,
    night: /шөнө/i
  }
}, bRe = {
  ordinalNumber: at({
    matchPattern: sRe,
    parsePattern: lRe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: uRe,
    defaultMatchWidth: "wide",
    parsePatterns: cRe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: dRe,
    defaultMatchWidth: "wide",
    parsePatterns: fRe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: mRe,
    defaultMatchWidth: "wide",
    parsePatterns: hRe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: pRe,
    defaultMatchWidth: "wide",
    parsePatterns: vRe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: gRe,
    defaultMatchWidth: "any",
    parsePatterns: yRe,
    defaultParseWidth: "any"
  })
};
const wRe = bRe;
var PRe = {
  code: "mn",
  formatDistance: H4e,
  formatLong: q4e,
  formatRelative: Q4e,
  localize: oRe,
  match: wRe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const kRe = PRe;
var $Re = {
  lessThanXSeconds: {
    one: "kurang dari 1 saat",
    other: "kurang dari {{count}} saat"
  },
  xSeconds: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  halfAMinute: "setengah minit",
  lessThanXMinutes: {
    one: "kurang dari 1 minit",
    other: "kurang dari {{count}} minit"
  },
  xMinutes: {
    one: "1 minit",
    other: "{{count}} minit"
  },
  aboutXHours: {
    one: "sekitar 1 jam",
    other: "sekitar {{count}} jam"
  },
  xHours: {
    one: "1 jam",
    other: "{{count}} jam"
  },
  xDays: {
    one: "1 hari",
    other: "{{count}} hari"
  },
  aboutXWeeks: {
    one: "sekitar 1 minggu",
    other: "sekitar {{count}} minggu"
  },
  xWeeks: {
    one: "1 minggu",
    other: "{{count}} minggu"
  },
  aboutXMonths: {
    one: "sekitar 1 bulan",
    other: "sekitar {{count}} bulan"
  },
  xMonths: {
    one: "1 bulan",
    other: "{{count}} bulan"
  },
  aboutXYears: {
    one: "sekitar 1 tahun",
    other: "sekitar {{count}} tahun"
  },
  xYears: {
    one: "1 tahun",
    other: "{{count}} tahun"
  },
  overXYears: {
    one: "lebih dari 1 tahun",
    other: "lebih dari {{count}} tahun"
  },
  almostXYears: {
    one: "hampir 1 tahun",
    other: "hampir {{count}} tahun"
  }
}, SRe = function(e, t, n) {
  var r, s = $Re[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "dalam masa " + r : r + " yang lalu" : r;
};
const xRe = SRe;
var CRe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/M/yyyy"
}, MRe = {
  full: "HH.mm.ss",
  long: "HH.mm.ss",
  medium: "HH.mm",
  short: "HH.mm"
}, ERe = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ARe = {
  date: Q({
    formats: CRe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: MRe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: ERe,
    defaultWidth: "full"
  })
};
const _Re = ARe;
var ORe = {
  lastWeek: "eeee 'lepas pada jam' p",
  yesterday: "'Semalam pada jam' p",
  today: "'Hari ini pada jam' p",
  tomorrow: "'Esok pada jam' p",
  nextWeek: "eeee 'pada jam' p",
  other: "P"
}, TRe = function(e, t, n, r) {
  return ORe[e];
};
const RRe = TRe;
var DRe = {
  narrow: ["SM", "M"],
  abbreviated: ["SM", "M"],
  wide: ["Sebelum Masihi", "Masihi"]
}, NRe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["S1", "S2", "S3", "S4"],
  wide: ["Suku pertama", "Suku kedua", "Suku ketiga", "Suku keempat"]
}, WRe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mac", "Apr", "Mei", "Jun", "Jul", "Ogo", "Sep", "Okt", "Nov", "Dis"],
  wide: ["Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "September", "Oktober", "November", "Disember"]
}, jRe = {
  narrow: ["A", "I", "S", "R", "K", "J", "S"],
  short: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
  abbreviated: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
  wide: ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"]
}, zRe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "tgh malam",
    noon: "tgh hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  }
}, LRe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  }
}, IRe = function(e, t) {
  return "ke-" + Number(e);
}, FRe = {
  ordinalNumber: IRe,
  era: R({
    values: DRe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: NRe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: WRe,
    defaultWidth: "wide"
  }),
  day: R({
    values: jRe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: zRe,
    defaultWidth: "wide",
    formattingValues: LRe,
    defaultFormattingWidth: "wide"
  })
};
const HRe = FRe;
var VRe = /^ke-(\d+)?/i, BRe = /petama|\d+/i, URe = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
  wide: /^(sebelum masihi|masihi)/i
}, XRe = {
  any: [/^s/i, /^(m)/i]
}, qRe = {
  narrow: /^[1234]/i,
  abbreviated: /^S[1234]/i,
  wide: /Suku (pertama|kedua|ketiga|keempat)/i
}, YRe = {
  any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i]
}, GRe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
  wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
}, QRe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^og/i, /^s/i, /^ok/i, /^n/i, /^d/i]
}, KRe = {
  narrow: /^[aisrkj]/i,
  short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
}, JRe = {
  narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i]
}, ZRe = {
  narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
}, eDe = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pa/i,
    afternoon: /tengah h/i,
    evening: /pe/i,
    night: /m/i
  }
}, tDe = {
  ordinalNumber: at({
    matchPattern: VRe,
    parsePattern: BRe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: URe,
    defaultMatchWidth: "wide",
    parsePatterns: XRe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: qRe,
    defaultMatchWidth: "wide",
    parsePatterns: YRe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: GRe,
    defaultMatchWidth: "wide",
    parsePatterns: QRe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: KRe,
    defaultMatchWidth: "wide",
    parsePatterns: JRe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: ZRe,
    defaultMatchWidth: "any",
    parsePatterns: eDe,
    defaultParseWidth: "any"
  })
};
const nDe = tDe;
var rDe = {
  code: "ms",
  formatDistance: xRe,
  formatLong: _Re,
  formatRelative: RRe,
  localize: HRe,
  match: nDe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const aDe = rDe;
var iDe = {
  lessThanXSeconds: {
    one: "inqas minn sekonda",
    other: "inqas minn {{count}} sekondi"
  },
  xSeconds: {
    one: "sekonda",
    other: "{{count}} sekondi"
  },
  halfAMinute: "nofs minuta",
  lessThanXMinutes: {
    one: "inqas minn minuta",
    other: "inqas minn {{count}} minuti"
  },
  xMinutes: {
    one: "minuta",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "madwar siegħa",
    other: "madwar {{count}} siegħat"
  },
  xHours: {
    one: "siegħa",
    other: "{{count}} siegħat"
  },
  xDays: {
    one: "ġurnata",
    other: "{{count}} ġranet"
  },
  aboutXWeeks: {
    one: "madwar ġimgħa",
    other: "madwar {{count}} ġimgħat"
  },
  xWeeks: {
    one: "ġimgħa",
    other: "{{count}} ġimgħat"
  },
  aboutXMonths: {
    one: "madwar xahar",
    other: "madwar {{count}} xhur"
  },
  xMonths: {
    one: "xahar",
    other: "{{count}} xhur"
  },
  aboutXYears: {
    one: "madwar sena",
    two: "madwar sentejn",
    other: "madwar {{count}} snin"
  },
  xYears: {
    one: "sena",
    two: "sentejn",
    other: "{{count}} snin"
  },
  overXYears: {
    one: "aktar minn sena",
    two: "aktar minn sentejn",
    other: "aktar minn {{count}} snin"
  },
  almostXYears: {
    one: "kważi sena",
    two: "kważi sentejn",
    other: "kważi {{count}} snin"
  }
}, oDe = function(e, t, n) {
  var r, s = iDe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : t === 2 && s.two ? r = s.two : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "f'" + r : r + " ilu" : r;
};
const sDe = oDe;
var lDe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, uDe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, cDe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, dDe = {
  date: Q({
    formats: lDe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: uDe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: cDe,
    defaultWidth: "full"
  })
};
const fDe = dDe;
var mDe = {
  lastWeek: "eeee 'li għadda' 'fil-'p",
  yesterday: "'Il-bieraħ fil-'p",
  today: "'Illum fil-'p",
  tomorrow: "'Għada fil-'p",
  nextWeek: "eeee 'fil-'p",
  other: "P"
}, hDe = function(e, t, n, r) {
  return mDe[e];
};
const pDe = hDe;
var vDe = {
  narrow: ["Q", "W"],
  abbreviated: ["QK", "WK"],
  wide: ["qabel Kristu", "wara Kristu"]
}, gDe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kwart", "2. kwart", "3. kwart", "4. kwart"]
}, yDe = {
  narrow: ["J", "F", "M", "A", "M", "Ġ", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Fra", "Mar", "Apr", "Mej", "Ġun", "Lul", "Aww", "Set", "Ott", "Nov", "Diċ"],
  wide: ["Jannar", "Frar", "Marzu", "April", "Mejju", "Ġunju", "Lulju", "Awwissu", "Settembru", "Ottubru", "Novembru", "Diċembru"]
}, bDe = {
  narrow: ["Ħ", "T", "T", "E", "Ħ", "Ġ", "S"],
  short: ["Ħa", "Tn", "Tl", "Er", "Ħa", "Ġi", "Si"],
  abbreviated: ["Ħad", "Tne", "Tli", "Erb", "Ħam", "Ġim", "Sib"],
  wide: ["Il-Ħadd", "It-Tnejn", "It-Tlieta", "L-Erbgħa", "Il-Ħamis", "Il-Ġimgħa", "Is-Sibt"]
}, wDe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl"
  }
}, PDe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl"
  }
}, kDe = function(e, t) {
  var n = Number(e);
  return n + "º";
}, $De = {
  ordinalNumber: kDe,
  era: R({
    values: vDe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: gDe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: yDe,
    defaultWidth: "wide"
  }),
  day: R({
    values: bDe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: wDe,
    defaultWidth: "wide",
    formattingValues: PDe,
    defaultFormattingWidth: "wide"
  })
};
const SDe = $De;
var xDe = /^(\d+)(º)?/i, CDe = /\d+/i, MDe = {
  narrow: /^(q|w)/i,
  abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
  wide: /^(qabel kristu|before common era|wara kristu|common era)/i
}, EDe = {
  any: [/^(q|b)/i, /^(w|c)/i]
}, ADe = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](\.)? kwart/i
}, _De = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ODe = {
  narrow: /^[jfmaglsond]/i,
  abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
  wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
}, TDe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^ġ/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mej/i, /^ġ/i, /^l/i, /^aw/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, RDe = {
  narrow: /^[ħteġs]/i,
  short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
  abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
  wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
}, DDe = {
  narrow: [/^ħ/i, /^t/i, /^t/i, /^e/i, /^ħ/i, /^ġ/i, /^s/i],
  any: [/^(il-)?ħad/i, /^(it-)?tn/i, /^(it-)?tl/i, /^(l-)?er/i, /^(il-)?ham/i, /^(il-)?ġi/i, /^(is-)?si/i]
}, NDe = {
  narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
  any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
}, WDe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^f'nofsillejl/i,
    noon: /^f'nofsinhar/i,
    morning: /għodwa/i,
    afternoon: /wara(\s.*)nofsinhar/i,
    evening: /filgħaxija/i,
    night: /lejl/i
  }
}, jDe = {
  ordinalNumber: at({
    matchPattern: xDe,
    parsePattern: CDe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: MDe,
    defaultMatchWidth: "wide",
    parsePatterns: EDe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: ADe,
    defaultMatchWidth: "wide",
    parsePatterns: _De,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: ODe,
    defaultMatchWidth: "wide",
    parsePatterns: TDe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: RDe,
    defaultMatchWidth: "wide",
    parsePatterns: DDe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: NDe,
    defaultMatchWidth: "any",
    parsePatterns: WDe,
    defaultParseWidth: "any"
  })
};
const zDe = jDe;
var LDe = {
  code: "mt",
  formatDistance: sDe,
  formatLong: fDe,
  formatRelative: pDe,
  localize: SDe,
  match: zDe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const IDe = LDe;
var FDe = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder"
  },
  xMonths: {
    one: "en måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over ett år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år"
  }
}, HDe = function(e, t, n) {
  var r, s = FDe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "om " + r : r + " siden" : r;
};
const VDe = HDe;
var BDe = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, UDe = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, XDe = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, qDe = {
  date: Q({
    formats: BDe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: UDe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: XDe,
    defaultWidth: "full"
  })
};
const YDe = qDe;
var GDe = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, QDe = function(e, t, n, r) {
  return GDe[e];
};
const KDe = QDe;
var JDe = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, ZDe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, eNe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
}, tNe = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, nNe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten"
  }
}, rNe = function(e, t) {
  var n = Number(e);
  return n + ".";
}, aNe = {
  ordinalNumber: rNe,
  era: R({
    values: JDe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: ZDe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: eNe,
    defaultWidth: "wide"
  }),
  day: R({
    values: tNe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: nNe,
    defaultWidth: "wide"
  })
};
const iNe = aNe;
var oNe = /^(\d+)\.?/i, sNe = /\d+/i, lNe = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, uNe = {
  any: [/^f/i, /^e/i]
}, cNe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, dNe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, fNe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, mNe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, hNe = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, pNe = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, vNe = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, gNe = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, yNe = {
  ordinalNumber: at({
    matchPattern: oNe,
    parsePattern: sNe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: lNe,
    defaultMatchWidth: "wide",
    parsePatterns: uNe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: cNe,
    defaultMatchWidth: "wide",
    parsePatterns: dNe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: fNe,
    defaultMatchWidth: "wide",
    parsePatterns: mNe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: hNe,
    defaultMatchWidth: "wide",
    parsePatterns: pNe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: vNe,
    defaultMatchWidth: "any",
    parsePatterns: gNe,
    defaultParseWidth: "any"
  })
};
const bNe = yNe;
var wNe = {
  code: "nb",
  formatDistance: VDe,
  formatLong: YDe,
  formatRelative: KDe,
  localize: iNe,
  match: bNe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const PNe = wNe;
var kNe = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, $Ne = function(e, t, n) {
  var r, s = kNe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "over " + r : r + " geleden" : r;
};
const SNe = $Ne;
var xNe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, CNe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, MNe = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ENe = {
  date: Q({
    formats: xNe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: CNe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: MNe,
    defaultWidth: "full"
  })
};
const ANe = ENe;
var _Ne = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, ONe = function(e, t, n, r) {
  return _Ne[e];
};
const TNe = ONe;
var RNe = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, DNe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, NNe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
}, WNe = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
}, jNe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, zNe = function(e, t) {
  var n = Number(e);
  return n + "e";
}, LNe = {
  ordinalNumber: zNe,
  era: R({
    values: RNe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: DNe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: NNe,
    defaultWidth: "wide"
  }),
  day: R({
    values: WNe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: jNe,
    defaultWidth: "wide"
  })
};
const INe = LNe;
var FNe = /^(\d+)e?/i, HNe = /\d+/i, VNe = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, BNe = {
  any: [/^v/, /^n/]
}, UNe = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, XNe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, qNe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, YNe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
}, GNe = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, QNe = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, KNe = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, JNe = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, ZNe = {
  ordinalNumber: at({
    matchPattern: FNe,
    parsePattern: HNe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: VNe,
    defaultMatchWidth: "wide",
    parsePatterns: BNe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: UNe,
    defaultMatchWidth: "wide",
    parsePatterns: XNe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: qNe,
    defaultMatchWidth: "wide",
    parsePatterns: YNe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: GNe,
    defaultMatchWidth: "wide",
    parsePatterns: QNe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: KNe,
    defaultMatchWidth: "any",
    parsePatterns: JNe,
    defaultParseWidth: "any"
  })
};
const e5e = ZNe;
var t5e = {
  code: "nl",
  formatDistance: SNe,
  formatLong: ANe,
  formatRelative: TNe,
  localize: INe,
  match: e5e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const n5e = t5e;
var r5e = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, a5e = function(e, t, n) {
  var r, s = r5e[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "over " + r : r + " geleden" : r;
};
const i5e = a5e;
var o5e = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, s5e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, l5e = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, u5e = {
  date: Q({
    formats: o5e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: s5e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: l5e,
    defaultWidth: "full"
  })
};
const c5e = u5e;
var d5e = {
  lastWeek: "'vorige' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, f5e = function(e, t, n, r) {
  return d5e[e];
};
const m5e = f5e;
var h5e = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, p5e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, v5e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
}, g5e = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
}, y5e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, b5e = function(e, t) {
  var n = Number(e);
  return n + "e";
}, w5e = {
  ordinalNumber: b5e,
  era: R({
    values: h5e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: p5e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: v5e,
    defaultWidth: "wide"
  }),
  day: R({
    values: g5e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: y5e,
    defaultWidth: "wide"
  })
};
const P5e = w5e;
var k5e = /^(\d+)e?/i, $5e = /\d+/i, S5e = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, x5e = {
  any: [/^v/, /^n/]
}, C5e = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, M5e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, E5e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, A5e = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
}, _5e = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, O5e = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, T5e = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, R5e = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, D5e = {
  ordinalNumber: at({
    matchPattern: k5e,
    parsePattern: $5e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: S5e,
    defaultMatchWidth: "wide",
    parsePatterns: x5e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: C5e,
    defaultMatchWidth: "wide",
    parsePatterns: M5e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: E5e,
    defaultMatchWidth: "wide",
    parsePatterns: A5e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: _5e,
    defaultMatchWidth: "wide",
    parsePatterns: O5e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: T5e,
    defaultMatchWidth: "any",
    parsePatterns: R5e,
    defaultParseWidth: "any"
  })
};
const N5e = D5e;
var W5e = {
  code: "nl-BE",
  formatDistance: i5e,
  formatLong: c5e,
  formatRelative: m5e,
  localize: P5e,
  match: N5e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const j5e = W5e;
var z5e = {
  lessThanXSeconds: {
    one: "mindre enn eitt sekund",
    other: "mindre enn {{count}} sekund"
  },
  xSeconds: {
    one: "eitt sekund",
    other: "{{count}} sekund"
  },
  halfAMinute: "eit halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn eitt minutt",
    other: "mindre enn {{count}} minutt"
  },
  xMinutes: {
    one: "eitt minutt",
    other: "{{count}} minutt"
  },
  aboutXHours: {
    one: "omtrent ein time",
    other: "omtrent {{count}} timar"
  },
  xHours: {
    one: "ein time",
    other: "{{count}} timar"
  },
  xDays: {
    one: "ein dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "omtrent ei veke",
    other: "omtrent {{count}} veker"
  },
  xWeeks: {
    one: "ei veke",
    other: "{{count}} veker"
  },
  aboutXMonths: {
    one: "omtrent ein månad",
    other: "omtrent {{count}} månader"
  },
  xMonths: {
    one: "ein månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "omtrent eitt år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "eitt år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over eitt år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten eitt år",
    other: "nesten {{count}} år"
  }
}, L5e = ["null", "ein", "to", "tre", "fire", "fem", "seks", "sju", "åtte", "ni", "ti", "elleve", "tolv"], I5e = function(e, t, n) {
  var r, s = z5e[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : n && n.onlyNumeric ? r = s.other.replace("{{count}}", String(t)) : r = s.other.replace("{{count}}", t < 13 ? L5e[t] : String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "om " + r : r + " sidan" : r;
};
const F5e = I5e;
var H5e = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, V5e = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, B5e = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, U5e = {
  date: Q({
    formats: H5e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: V5e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: B5e,
    defaultWidth: "full"
  })
};
const X5e = U5e;
var q5e = {
  lastWeek: "'førre' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, Y5e = function(e, t, n, r) {
  return q5e[e];
};
const G5e = Y5e;
var Q5e = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, K5e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, J5e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
}, Z5e = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["su", "må", "ty", "on", "to", "fr", "lau"],
  abbreviated: ["sun", "mån", "tys", "ons", "tor", "fre", "laur"],
  wide: ["sundag", "måndag", "tysdag", "onsdag", "torsdag", "fredag", "laurdag"]
}, eWe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natta"
  }
}, tWe = function(e, t) {
  var n = Number(e);
  return n + ".";
}, nWe = {
  ordinalNumber: tWe,
  era: R({
    values: Q5e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: K5e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: J5e,
    defaultWidth: "wide"
  }),
  day: R({
    values: Z5e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: eWe,
    defaultWidth: "wide"
  })
};
const rWe = nWe;
var aWe = /^(\d+)\.?/i, iWe = /\d+/i, oWe = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, sWe = {
  any: [/^f/i, /^e/i]
}, lWe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, uWe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, cWe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, dWe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, fWe = {
  narrow: /^[smtofl]/i,
  short: /^(su|må|ty|on|to|fr|la)/i,
  abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
  wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
}, mWe = {
  any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, hWe = {
  narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
}, pWe = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, vWe = {
  ordinalNumber: at({
    matchPattern: aWe,
    parsePattern: iWe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: oWe,
    defaultMatchWidth: "wide",
    parsePatterns: sWe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: lWe,
    defaultMatchWidth: "wide",
    parsePatterns: uWe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: cWe,
    defaultMatchWidth: "wide",
    parsePatterns: dWe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: fWe,
    defaultMatchWidth: "wide",
    parsePatterns: mWe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: hWe,
    defaultMatchWidth: "any",
    parsePatterns: pWe,
    defaultParseWidth: "any"
  })
};
const gWe = vWe;
var yWe = {
  code: "nn",
  formatDistance: F5e,
  formatLong: X5e,
  formatRelative: G5e,
  localize: rWe,
  match: gWe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const bWe = yWe;
var wWe = {
  lessThanXSeconds: {
    one: "mens d’una segonda",
    other: "mens de {{count}} segondas"
  },
  xSeconds: {
    one: "1 segonda",
    other: "{{count}} segondas"
  },
  halfAMinute: "30 segondas",
  lessThanXMinutes: {
    one: "mens d’una minuta",
    other: "mens de {{count}} minutas"
  },
  xMinutes: {
    one: "1 minuta",
    other: "{{count}} minutas"
  },
  aboutXHours: {
    one: "environ 1 ora",
    other: "environ {{count}} oras"
  },
  xHours: {
    one: "1 ora",
    other: "{{count}} oras"
  },
  xDays: {
    one: "1 jorn",
    other: "{{count}} jorns"
  },
  aboutXWeeks: {
    one: "environ 1 setmana",
    other: "environ {{count}} setmanas"
  },
  xWeeks: {
    one: "1 setmana",
    other: "{{count}} setmanas"
  },
  aboutXMonths: {
    one: "environ 1 mes",
    other: "environ {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "mai d’un an",
    other: "mai de {{count}} ans"
  },
  almostXYears: {
    one: "gaireben un an",
    other: "gaireben {{count}} ans"
  }
}, PWe = function(e, t, n) {
  var r, s = wWe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "d’aquí " + r : "fa " + r : r;
};
const kWe = PWe;
var $We = {
  full: "EEEE d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, SWe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, xWe = {
  full: "{{date}} 'a' {{time}}",
  long: "{{date}} 'a' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, CWe = {
  date: Q({
    formats: $We,
    defaultWidth: "full"
  }),
  time: Q({
    formats: SWe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: xWe,
    defaultWidth: "full"
  })
};
const MWe = CWe;
var EWe = {
  lastWeek: "eeee 'passat a' p",
  yesterday: "'ièr a' p",
  today: "'uèi a' p",
  tomorrow: "'deman a' p",
  nextWeek: "eeee 'a' p",
  other: "P"
}, AWe = function(e, t, n, r) {
  return EWe[e];
};
const _We = AWe;
var OWe = {
  narrow: ["ab. J.C.", "apr. J.C."],
  abbreviated: ["ab. J.C.", "apr. J.C."],
  wide: ["abans Jèsus-Crist", "après Jèsus-Crist"]
}, TWe = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1èr trim.", "2nd trim.", "3en trim.", "4en trim."],
  wide: ["1èr trimèstre", "2nd trimèstre", "3en trimèstre", "4en trimèstre"]
}, RWe = {
  narrow: ["GN", "FB", "MÇ", "AB", "MA", "JN", "JL", "AG", "ST", "OC", "NV", "DC"],
  abbreviated: ["gen.", "febr.", "març", "abr.", "mai", "junh", "jul.", "ag.", "set.", "oct.", "nov.", "dec."],
  wide: ["genièr", "febrièr", "març", "abril", "mai", "junh", "julhet", "agost", "setembre", "octòbre", "novembre", "decembre"]
}, DWe = {
  narrow: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  short: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  abbreviated: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  wide: ["dimenge", "diluns", "dimars", "dimècres", "dijòus", "divendres", "dissabte"]
}, NWe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch"
  }
}, WWe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch"
  }
}, jWe = function(e, t) {
  var n = Number(e), r = t == null ? void 0 : t.unit, s;
  switch (n) {
    case 1:
      s = "èr";
      break;
    case 2:
      s = "nd";
      break;
    default:
      s = "en";
  }
  return (r === "year" || r === "week" || r === "hour" || r === "minute" || r === "second") && (s += "a"), n + s;
}, zWe = {
  ordinalNumber: jWe,
  era: R({
    values: OWe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: TWe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: RWe,
    defaultWidth: "wide"
  }),
  day: R({
    values: DWe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: NWe,
    defaultWidth: "wide",
    formattingValues: WWe,
    defaultFormattingWidth: "wide"
  })
};
const LWe = zWe;
var IWe = /^(\d+)(èr|nd|en)?[a]?/i, FWe = /\d+/i, HWe = {
  narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
  abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
}, VWe = {
  any: [/^ab/i, /^ap/i]
}, BWe = {
  narrow: /^T[1234]/i,
  abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
  wide: /^[1234](èr|nd|en)? trimèstre/i
}, UWe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, XWe = {
  narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
  abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
  wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
}, qWe = {
  any: [/^g/i, /^f/i, /^ma[r?]|MÇ/i, /^ab/i, /^ma[i?]/i, /^ju[n?]|JN/i, /^ju[l?]|JL/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, YWe = {
  narrow: /^d[glmcjvs]\.?/i,
  short: /^d[glmcjvs]\.?/i,
  abbreviated: /^d[glmcjvs]\.?/i,
  wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
}, GWe = {
  narrow: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  short: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  abbreviated: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  any: [/^dg|dime/i, /^dl|dil/i, /^dm|dima/i, /^dc|dimè/i, /^dj|dij/i, /^dv|div/i, /^ds|dis/i]
}, QWe = {
  any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
}, KWe = {
  any: {
    am: /(^a)|ante meridiem/i,
    pm: /(^p)|post meridiem/i,
    midnight: /^mièj/i,
    noon: /^mièg/i,
    morning: /matin/i,
    afternoon: /aprèp-miègjorn/i,
    evening: /vèspre|ser/i,
    night: /nuèch/i
  }
}, JWe = {
  ordinalNumber: at({
    matchPattern: IWe,
    parsePattern: FWe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: HWe,
    defaultMatchWidth: "wide",
    parsePatterns: VWe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: BWe,
    defaultMatchWidth: "wide",
    parsePatterns: UWe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: XWe,
    defaultMatchWidth: "wide",
    parsePatterns: qWe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: YWe,
    defaultMatchWidth: "wide",
    parsePatterns: GWe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: QWe,
    defaultMatchWidth: "any",
    parsePatterns: KWe,
    defaultParseWidth: "any"
  })
};
const ZWe = JWe;
var e6e = {
  code: "oc",
  formatDistance: kWe,
  formatLong: MWe,
  formatRelative: _We,
  localize: LWe,
  match: ZWe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const t6e = e6e;
var n6e = {
  lessThanXSeconds: {
    one: {
      regular: "mniej niż sekunda",
      past: "mniej niż sekundę",
      future: "mniej niż sekundę"
    },
    twoFour: "mniej niż {{count}} sekundy",
    other: "mniej niż {{count}} sekund"
  },
  xSeconds: {
    one: {
      regular: "sekunda",
      past: "sekundę",
      future: "sekundę"
    },
    twoFour: "{{count}} sekundy",
    other: "{{count}} sekund"
  },
  halfAMinute: {
    one: "pół minuty",
    twoFour: "pół minuty",
    other: "pół minuty"
  },
  lessThanXMinutes: {
    one: {
      regular: "mniej niż minuta",
      past: "mniej niż minutę",
      future: "mniej niż minutę"
    },
    twoFour: "mniej niż {{count}} minuty",
    other: "mniej niż {{count}} minut"
  },
  xMinutes: {
    one: {
      regular: "minuta",
      past: "minutę",
      future: "minutę"
    },
    twoFour: "{{count}} minuty",
    other: "{{count}} minut"
  },
  aboutXHours: {
    one: {
      regular: "około godziny",
      past: "około godziny",
      future: "około godzinę"
    },
    twoFour: "około {{count}} godziny",
    other: "około {{count}} godzin"
  },
  xHours: {
    one: {
      regular: "godzina",
      past: "godzinę",
      future: "godzinę"
    },
    twoFour: "{{count}} godziny",
    other: "{{count}} godzin"
  },
  xDays: {
    one: {
      regular: "dzień",
      past: "dzień",
      future: "1 dzień"
    },
    twoFour: "{{count}} dni",
    other: "{{count}} dni"
  },
  aboutXWeeks: {
    one: "około tygodnia",
    twoFour: "około {{count}} tygodni",
    other: "około {{count}} tygodni"
  },
  xWeeks: {
    one: "tydzień",
    twoFour: "{{count}} tygodnie",
    other: "{{count}} tygodni"
  },
  aboutXMonths: {
    one: "około miesiąc",
    twoFour: "około {{count}} miesiące",
    other: "około {{count}} miesięcy"
  },
  xMonths: {
    one: "miesiąc",
    twoFour: "{{count}} miesiące",
    other: "{{count}} miesięcy"
  },
  aboutXYears: {
    one: "około rok",
    twoFour: "około {{count}} lata",
    other: "około {{count}} lat"
  },
  xYears: {
    one: "rok",
    twoFour: "{{count}} lata",
    other: "{{count}} lat"
  },
  overXYears: {
    one: "ponad rok",
    twoFour: "ponad {{count}} lata",
    other: "ponad {{count}} lat"
  },
  almostXYears: {
    one: "prawie rok",
    twoFour: "prawie {{count}} lata",
    other: "prawie {{count}} lat"
  }
};
function r6e(e, t) {
  if (t === 1)
    return e.one;
  var n = t % 100;
  if (n <= 20 && n > 10)
    return e.other;
  var r = n % 10;
  return r >= 2 && r <= 4 ? e.twoFour : e.other;
}
function d$(e, t, n) {
  var r = r6e(e, t), s = typeof r == "string" ? r : r[n];
  return s.replace("{{count}}", String(t));
}
var a6e = function(e, t, n) {
  var r = n6e[e];
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "za " + d$(r, t, "future") : d$(r, t, "past") + " temu" : d$(r, t, "regular");
};
const i6e = a6e;
var o6e = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
}, s6e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, l6e = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, u6e = {
  date: Q({
    formats: o6e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: s6e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: l6e,
    defaultWidth: "full"
  })
};
const c6e = u6e;
var d6e = {
  masculine: "ostatni",
  feminine: "ostatnia"
}, f6e = {
  masculine: "ten",
  feminine: "ta"
}, m6e = {
  masculine: "następny",
  feminine: "następna"
}, h6e = {
  0: "feminine",
  1: "masculine",
  2: "masculine",
  3: "feminine",
  4: "masculine",
  5: "masculine",
  6: "feminine"
};
function UO(e, t, n, r) {
  var s;
  if (ca(t, n, r))
    s = f6e;
  else if (e === "lastWeek")
    s = d6e;
  else if (e === "nextWeek")
    s = m6e;
  else
    throw new Error("Cannot determine adjectives for token ".concat(e));
  var f = t.getUTCDay(), m = h6e[f], p = s[m];
  return "'".concat(p, "' eeee 'o' p");
}
var p6e = {
  lastWeek: UO,
  yesterday: "'wczoraj o' p",
  today: "'dzisiaj o' p",
  tomorrow: "'jutro o' p",
  nextWeek: UO,
  other: "P"
}, v6e = function(e, t, n, r) {
  var s = p6e[e];
  return typeof s == "function" ? s(e, t, n, r) : s;
};
const g6e = v6e;
var y6e = {
  narrow: ["p.n.e.", "n.e."],
  abbreviated: ["p.n.e.", "n.e."],
  wide: ["przed naszą erą", "naszej ery"]
}, b6e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I kw.", "II kw.", "III kw.", "IV kw."],
  wide: ["I kwartał", "II kwartał", "III kwartał", "IV kwartał"]
}, w6e = {
  narrow: ["S", "L", "M", "K", "M", "C", "L", "S", "W", "P", "L", "G"],
  abbreviated: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"],
  wide: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"]
}, P6e = {
  narrow: ["s", "l", "m", "k", "m", "c", "l", "s", "w", "p", "l", "g"],
  abbreviated: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"],
  wide: ["stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca", "lipca", "sierpnia", "września", "października", "listopada", "grudnia"]
}, k6e = {
  narrow: ["N", "P", "W", "Ś", "C", "P", "S"],
  short: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
  abbreviated: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
  wide: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"]
}, $6e = {
  narrow: ["n", "p", "w", "ś", "c", "p", "s"],
  short: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
  abbreviated: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
  wide: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"]
}, S6e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "półn.",
    noon: "poł",
    morning: "rano",
    afternoon: "popoł.",
    evening: "wiecz.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "północ",
    noon: "południe",
    morning: "rano",
    afternoon: "popołudnie",
    evening: "wieczór",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "północ",
    noon: "południe",
    morning: "rano",
    afternoon: "popołudnie",
    evening: "wieczór",
    night: "noc"
  }
}, x6e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "o półn.",
    noon: "w poł.",
    morning: "rano",
    afternoon: "po poł.",
    evening: "wiecz.",
    night: "w nocy"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o północy",
    noon: "w południe",
    morning: "rano",
    afternoon: "po południu",
    evening: "wieczorem",
    night: "w nocy"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o północy",
    noon: "w południe",
    morning: "rano",
    afternoon: "po południu",
    evening: "wieczorem",
    night: "w nocy"
  }
}, C6e = function(e, t) {
  return String(e);
}, M6e = {
  ordinalNumber: C6e,
  era: R({
    values: y6e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: b6e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: w6e,
    defaultWidth: "wide",
    formattingValues: P6e,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: k6e,
    defaultWidth: "wide",
    formattingValues: $6e,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: R({
    values: S6e,
    defaultWidth: "wide",
    formattingValues: x6e,
    defaultFormattingWidth: "wide"
  })
};
const E6e = M6e;
var A6e = /^(\d+)?/i, _6e = /\d+/i, O6e = {
  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
}, T6e = {
  any: [/^p/i, /^n/i]
}, R6e = {
  narrow: /^[1234]/i,
  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
}, D6e = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
}, N6e = {
  narrow: /^[slmkcwpg]/i,
  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
}, W6e = {
  narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
  any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
}, j6e = {
  narrow: /^[npwścs]/i,
  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
}, z6e = {
  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
}, L6e = {
  narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
}, I6e = {
  narrow: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  },
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  }
}, F6e = {
  ordinalNumber: at({
    matchPattern: A6e,
    parsePattern: _6e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: O6e,
    defaultMatchWidth: "wide",
    parsePatterns: T6e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: R6e,
    defaultMatchWidth: "wide",
    parsePatterns: D6e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: N6e,
    defaultMatchWidth: "wide",
    parsePatterns: W6e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: j6e,
    defaultMatchWidth: "wide",
    parsePatterns: z6e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: L6e,
    defaultMatchWidth: "any",
    parsePatterns: I6e,
    defaultParseWidth: "any"
  })
};
const H6e = F6e;
var V6e = {
  code: "pl",
  formatDistance: i6e,
  formatLong: c6e,
  formatRelative: g6e,
  localize: E6e,
  match: H6e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const B6e = V6e;
var U6e = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, X6e = function(e, t, n) {
  var r, s = U6e[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "daqui a " + r : "há " + r : r;
};
const q6e = X6e;
var Y6e = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, G6e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Q6e = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, K6e = {
  date: Q({
    formats: Y6e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: G6e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Q6e,
    defaultWidth: "full"
  })
};
const J6e = K6e;
var Z6e = {
  lastWeek: function(e) {
    var t = e.getUTCDay(), n = t === 0 || t === 6 ? "último" : "última";
    return "'" + n + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, eje = function(e, t, n, r) {
  var s = Z6e[e];
  return typeof s == "function" ? s(t) : s;
};
const tje = eje;
var nje = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, rje = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, aje = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
}, ije = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
}, oje = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, sje = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, lje = function(e, t) {
  var n = Number(e);
  return n + "º";
}, uje = {
  ordinalNumber: lje,
  era: R({
    values: nje,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: rje,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: aje,
    defaultWidth: "wide"
  }),
  day: R({
    values: ije,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: oje,
    defaultWidth: "wide",
    formattingValues: sje,
    defaultFormattingWidth: "wide"
  })
};
const cje = uje;
var dje = /^(\d+)(º|ª)?/i, fje = /\d+/i, mje = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, hje = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
}, pje = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, vje = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gje = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, yje = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, bje = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, wje = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, Pje = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, kje = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, $je = {
  ordinalNumber: at({
    matchPattern: dje,
    parsePattern: fje,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: mje,
    defaultMatchWidth: "wide",
    parsePatterns: hje,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: pje,
    defaultMatchWidth: "wide",
    parsePatterns: vje,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: gje,
    defaultMatchWidth: "wide",
    parsePatterns: yje,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: bje,
    defaultMatchWidth: "wide",
    parsePatterns: wje,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Pje,
    defaultMatchWidth: "any",
    parsePatterns: kje,
    defaultParseWidth: "any"
  })
};
const Sje = $je;
var xje = {
  code: "pt",
  formatDistance: q6e,
  formatLong: J6e,
  formatRelative: tje,
  localize: cje,
  match: Sje,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Cje = xje;
var Mje = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, Eje = function(e, t, n) {
  var r, s = Mje[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "em " + r : "há " + r : r;
};
const Aje = Eje;
var _je = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, Oje = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Tje = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Rje = {
  date: Q({
    formats: _je,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Oje,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Tje,
    defaultWidth: "full"
  })
};
const Dje = Rje;
var Nje = {
  lastWeek: function(e) {
    var t = e.getUTCDay(), n = t === 0 || t === 6 ? "último" : "última";
    return "'" + n + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, Wje = function(e, t, n, r) {
  var s = Nje[e];
  return typeof s == "function" ? s(t) : s;
};
const jje = Wje;
var zje = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, Lje = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Ije = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
}, Fje = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
  wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
}, Hje = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, Vje = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, Bje = function(e, t) {
  var n = Number(e);
  return (t == null ? void 0 : t.unit) === "week" ? n + "ª" : n + "º";
}, Uje = {
  ordinalNumber: Bje,
  era: R({
    values: zje,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Lje,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Ije,
    defaultWidth: "wide"
  }),
  day: R({
    values: Fje,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Hje,
    defaultWidth: "wide",
    formattingValues: Vje,
    defaultFormattingWidth: "wide"
  })
};
const Xje = Uje;
var qje = /^(\d+)[ºªo]?/i, Yje = /\d+/i, Gje = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, Qje = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, Kje = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Jje = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zje = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, eze = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
}, tze = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, nze = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, rze = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, aze = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, ize = {
  ordinalNumber: at({
    matchPattern: qje,
    parsePattern: Yje,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Gje,
    defaultMatchWidth: "wide",
    parsePatterns: Qje,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Kje,
    defaultMatchWidth: "wide",
    parsePatterns: Jje,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Zje,
    defaultMatchWidth: "wide",
    parsePatterns: eze,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: tze,
    defaultMatchWidth: "wide",
    parsePatterns: nze,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: rze,
    defaultMatchWidth: "any",
    parsePatterns: aze,
    defaultParseWidth: "any"
  })
};
const oze = ize;
var sze = {
  code: "pt-BR",
  formatDistance: Aje,
  formatLong: Dje,
  formatRelative: jje,
  localize: Xje,
  match: oze,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const lze = sze;
var uze = {
  lessThanXSeconds: {
    one: "mai puțin de o secundă",
    other: "mai puțin de {{count}} secunde"
  },
  xSeconds: {
    one: "1 secundă",
    other: "{{count}} secunde"
  },
  halfAMinute: "jumătate de minut",
  lessThanXMinutes: {
    one: "mai puțin de un minut",
    other: "mai puțin de {{count}} minute"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "circa 1 oră",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "1 oră",
    other: "{{count}} ore"
  },
  xDays: {
    one: "1 zi",
    other: "{{count}} zile"
  },
  aboutXWeeks: {
    one: "circa o săptămână",
    other: "circa {{count}} săptămâni"
  },
  xWeeks: {
    one: "1 săptămână",
    other: "{{count}} săptămâni"
  },
  aboutXMonths: {
    one: "circa 1 lună",
    other: "circa {{count}} luni"
  },
  xMonths: {
    one: "1 lună",
    other: "{{count}} luni"
  },
  aboutXYears: {
    one: "circa 1 an",
    other: "circa {{count}} ani"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ani"
  },
  overXYears: {
    one: "peste 1 an",
    other: "peste {{count}} ani"
  },
  almostXYears: {
    one: "aproape 1 an",
    other: "aproape {{count}} ani"
  }
}, cze = function(e, t, n) {
  var r, s = uze[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "în " + r : r + " în urmă" : r;
};
const dze = cze;
var fze = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy"
}, mze = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, hze = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, pze = {
  date: Q({
    formats: fze,
    defaultWidth: "full"
  }),
  time: Q({
    formats: mze,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: hze,
    defaultWidth: "full"
  })
};
const vze = pze;
var gze = {
  lastWeek: "eeee 'trecută la' p",
  yesterday: "'ieri la' p",
  today: "'astăzi la' p",
  tomorrow: "'mâine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: "P"
}, yze = function(e, t, n, r) {
  return gze[e];
};
const bze = yze;
var wze = {
  narrow: ["Î", "D"],
  abbreviated: ["Î.d.C.", "D.C."],
  wide: ["Înainte de Cristos", "După Cristos"]
}, Pze = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["primul trimestru", "al doilea trimestru", "al treilea trimestru", "al patrulea trimestru"]
}, kze = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: ["ian", "feb", "mar", "apr", "mai", "iun", "iul", "aug", "sep", "oct", "noi", "dec"],
  wide: ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"]
}, $ze = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "sâ"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "sâm"],
  wide: ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"]
}, Sze = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, xze = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, Cze = function(e, t) {
  return String(e);
}, Mze = {
  ordinalNumber: Cze,
  era: R({
    values: wze,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Pze,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: kze,
    defaultWidth: "wide"
  }),
  day: R({
    values: $ze,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Sze,
    defaultWidth: "wide",
    formattingValues: xze,
    defaultFormattingWidth: "wide"
  })
};
const Eze = Mze;
var Aze = /^(\d+)?/i, _ze = /\d+/i, Oze = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
}, Tze = {
  any: [/^ÎC/i, /^DC/i],
  wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
}, Rze = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
}, Dze = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nze = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
}, Wze = {
  narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, jze = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
}, zze = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
}, Lze = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
}, Ize = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
}, Fze = {
  ordinalNumber: at({
    matchPattern: Aze,
    parsePattern: _ze,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Oze,
    defaultMatchWidth: "wide",
    parsePatterns: Tze,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: Rze,
    defaultMatchWidth: "wide",
    parsePatterns: Dze,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Nze,
    defaultMatchWidth: "wide",
    parsePatterns: Wze,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: jze,
    defaultMatchWidth: "wide",
    parsePatterns: zze,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Lze,
    defaultMatchWidth: "any",
    parsePatterns: Ize,
    defaultParseWidth: "any"
  })
};
const Hze = Fze;
var Vze = {
  code: "ro",
  formatDistance: dze,
  formatLong: vze,
  formatRelative: bze,
  localize: Eze,
  match: Hze,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Bze = Vze;
function _v(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  var n = t % 10, r = t % 100;
  return n === 1 && r !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function ho(e) {
  return function(t, n) {
    return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? e.future ? _v(e.future, t) : "через " + _v(e.regular, t) : e.past ? _v(e.past, t) : _v(e.regular, t) + " назад" : _v(e.regular, t);
  };
}
var Uze = {
  lessThanXSeconds: ho({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: ho({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: function(e, t) {
    return t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты";
  },
  lessThanXMinutes: ho({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: ho({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: ho({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: ho({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: ho({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: ho({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: ho({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: ho({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: ho({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: ho({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: ho({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: ho({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: ho({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, Xze = function(e, t, n) {
  return Uze[e](t, n);
};
const qze = Xze;
var Yze = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, Gze = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Qze = {
  any: "{{date}}, {{time}}"
}, Kze = {
  date: Q({
    formats: Yze,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Gze,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Qze,
    defaultWidth: "any"
  })
};
const Jze = Kze;
var yx = ["воскресенье", "понедельник", "вторник", "среду", "четверг", "пятницу", "субботу"];
function Zze(e) {
  var t = yx[e];
  switch (e) {
    case 0:
      return "'в прошлое " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + t + " в' p";
  }
}
function XO(e) {
  var t = yx[e];
  return e === 2 ? "'во " + t + " в' p" : "'в " + t + " в' p";
}
function e7e(e) {
  var t = yx[e];
  switch (e) {
    case 0:
      return "'в следующее " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + t + " в' p";
  }
}
var t7e = {
  lastWeek: function(e, t, n) {
    var r = e.getUTCDay();
    return ca(e, t, n) ? XO(r) : Zze(r);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: function(e, t, n) {
    var r = e.getUTCDay();
    return ca(e, t, n) ? XO(r) : e7e(r);
  },
  other: "P"
}, n7e = function(e, t, n, r) {
  var s = t7e[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const r7e = n7e;
var a7e = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, i7e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, o7e = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв.", "фев.", "март", "апр.", "май", "июнь", "июль", "авг.", "сент.", "окт.", "нояб.", "дек."],
  wide: ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"]
}, s7e = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв.", "фев.", "мар.", "апр.", "мая", "июн.", "июл.", "авг.", "сент.", "окт.", "нояб.", "дек."],
  wide: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"]
}, l7e = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"]
}, u7e = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, c7e = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, d7e = function(e, t) {
  var n = Number(e), r = t == null ? void 0 : t.unit, s;
  return r === "date" ? s = "-е" : r === "week" || r === "minute" || r === "second" ? s = "-я" : s = "-й", n + s;
}, f7e = {
  ordinalNumber: d7e,
  era: R({
    values: a7e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: i7e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: o7e,
    defaultWidth: "wide",
    formattingValues: s7e,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: l7e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: u7e,
    defaultWidth: "any",
    formattingValues: c7e,
    defaultFormattingWidth: "wide"
  })
};
const m7e = f7e;
var h7e = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, p7e = /\d+/i, v7e = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, g7e = {
  any: [/^д/i, /^н/i]
}, y7e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, b7e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, w7e = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, P7e = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
}, k7e = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, $7e = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, S7e = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, x7e = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, C7e = {
  ordinalNumber: at({
    matchPattern: h7e,
    parsePattern: p7e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: v7e,
    defaultMatchWidth: "wide",
    parsePatterns: g7e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: y7e,
    defaultMatchWidth: "wide",
    parsePatterns: b7e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: w7e,
    defaultMatchWidth: "wide",
    parsePatterns: P7e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: k7e,
    defaultMatchWidth: "wide",
    parsePatterns: $7e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: S7e,
    defaultMatchWidth: "wide",
    parsePatterns: x7e,
    defaultParseWidth: "any"
  })
};
const M7e = C7e;
var E7e = {
  code: "ru",
  formatDistance: qze,
  formatLong: Jze,
  formatRelative: r7e,
  localize: m7e,
  match: M7e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const A7e = E7e;
function _7e(e, t) {
  return t === 1 && e.one ? e.one : t >= 2 && t <= 4 && e.twoFour ? e.twoFour : e.other;
}
function f$(e, t, n) {
  var r = _7e(e, t), s = r[n];
  return s.replace("{{count}}", String(t));
}
function O7e(e) {
  var t = ["lessThan", "about", "over", "almost"].filter(function(n) {
    return !!e.match(new RegExp("^" + n));
  });
  return t[0];
}
function m$(e) {
  var t = "";
  return e === "almost" && (t = "takmer"), e === "about" && (t = "približne"), t.length > 0 ? t + " " : "";
}
function h$(e) {
  var t = "";
  return e === "lessThan" && (t = "menej než"), e === "over" && (t = "viac než"), t.length > 0 ? t + " " : "";
}
function T7e(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
var R7e = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, D7e = function(e, t, n) {
  var r = O7e(e) || "", s = T7e(e.substring(r.length)), f = R7e[s];
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? m$(r) + "o " + h$(r) + f$(f, t, "future") : m$(r) + "pred " + h$(r) + f$(f, t, "past") : m$(r) + h$(r) + f$(f, t, "present");
};
const N7e = D7e;
var W7e = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, j7e = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, z7e = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, L7e = {
  date: Q({
    formats: W7e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: j7e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: z7e,
    defaultWidth: "full"
  })
};
const I7e = L7e;
var bx = ["nedeľu", "pondelok", "utorok", "stredu", "štvrtok", "piatok", "sobotu"];
function F7e(e) {
  var t = bx[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'minulú " + t + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function qO(e) {
  var t = bx[e];
  return e === 4 ? "'vo' eeee 'o' p" : "'v " + t + " o' p";
}
function H7e(e) {
  var t = bx[e];
  switch (e) {
    case 0:
    case 4:
    case 6:
      return "'budúcu " + t + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
var V7e = {
  lastWeek: function(e, t, n) {
    var r = e.getUTCDay();
    return ca(e, t, n) ? qO(r) : F7e(r);
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: function(e, t, n) {
    var r = e.getUTCDay();
    return ca(e, t, n) ? qO(r) : H7e(r);
  },
  other: "P"
}, B7e = function(e, t, n, r) {
  var s = V7e[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const U7e = B7e;
var X7e = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, q7e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
}, Y7e = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "feb", "mar", "apr", "máj", "jún", "júl", "aug", "sep", "okt", "nov", "dec"],
  wide: ["január", "február", "marec", "apríl", "máj", "jún", "júl", "august", "september", "október", "november", "december"]
}, G7e = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "feb", "mar", "apr", "máj", "jún", "júl", "aug", "sep", "okt", "nov", "dec"],
  wide: ["januára", "februára", "marca", "apríla", "mája", "júna", "júla", "augusta", "septembra", "októbra", "novembra", "decembra"]
}, Q7e = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: ["nedeľa", "pondelok", "utorok", "streda", "štvrtok", "piatok", "sobota"]
}, K7e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
}, J7e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
}, Z7e = function(e, t) {
  var n = Number(e);
  return n + ".";
}, e8e = {
  ordinalNumber: Z7e,
  era: R({
    values: X7e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: q7e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Y7e,
    defaultWidth: "wide",
    formattingValues: G7e,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: Q7e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: K7e,
    defaultWidth: "wide",
    formattingValues: J7e,
    defaultFormattingWidth: "wide"
  })
};
const t8e = e8e;
var n8e = /^(\d+)\.?/i, r8e = /\d+/i, a8e = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, i8e = {
  any: [/^pr/i, /^(po|n)/i]
}, o8e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, s8e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, l8e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, u8e = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^m[áa]j/i, /^j[úu]n/i, /^j[úu]l/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, c8e = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, d8e = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, f8e = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, m8e = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, h8e = {
  ordinalNumber: at({
    matchPattern: n8e,
    parsePattern: r8e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: a8e,
    defaultMatchWidth: "wide",
    parsePatterns: i8e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: o8e,
    defaultMatchWidth: "wide",
    parsePatterns: s8e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: l8e,
    defaultMatchWidth: "wide",
    parsePatterns: u8e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: c8e,
    defaultMatchWidth: "wide",
    parsePatterns: d8e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: f8e,
    defaultMatchWidth: "any",
    parsePatterns: m8e,
    defaultParseWidth: "any"
  })
};
const p8e = h8e;
var v8e = {
  code: "sk",
  formatDistance: N7e,
  formatLong: I7e,
  formatRelative: U7e,
  localize: t8e,
  match: p8e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const g8e = v8e;
function y8e(e) {
  return e.one !== void 0;
}
var b8e = {
  lessThanXSeconds: {
    present: {
      one: "manj kot {{count}} sekunda",
      two: "manj kot {{count}} sekundi",
      few: "manj kot {{count}} sekunde",
      other: "manj kot {{count}} sekund"
    },
    past: {
      one: "manj kot {{count}} sekundo",
      two: "manj kot {{count}} sekundama",
      few: "manj kot {{count}} sekundami",
      other: "manj kot {{count}} sekundami"
    },
    future: {
      one: "manj kot {{count}} sekundo",
      two: "manj kot {{count}} sekundi",
      few: "manj kot {{count}} sekunde",
      other: "manj kot {{count}} sekund"
    }
  },
  xSeconds: {
    present: {
      one: "{{count}} sekunda",
      two: "{{count}} sekundi",
      few: "{{count}} sekunde",
      other: "{{count}} sekund"
    },
    past: {
      one: "{{count}} sekundo",
      two: "{{count}} sekundama",
      few: "{{count}} sekundami",
      other: "{{count}} sekundami"
    },
    future: {
      one: "{{count}} sekundo",
      two: "{{count}} sekundi",
      few: "{{count}} sekunde",
      other: "{{count}} sekund"
    }
  },
  halfAMinute: "pol minute",
  lessThanXMinutes: {
    present: {
      one: "manj kot {{count}} minuta",
      two: "manj kot {{count}} minuti",
      few: "manj kot {{count}} minute",
      other: "manj kot {{count}} minut"
    },
    past: {
      one: "manj kot {{count}} minuto",
      two: "manj kot {{count}} minutama",
      few: "manj kot {{count}} minutami",
      other: "manj kot {{count}} minutami"
    },
    future: {
      one: "manj kot {{count}} minuto",
      two: "manj kot {{count}} minuti",
      few: "manj kot {{count}} minute",
      other: "manj kot {{count}} minut"
    }
  },
  xMinutes: {
    present: {
      one: "{{count}} minuta",
      two: "{{count}} minuti",
      few: "{{count}} minute",
      other: "{{count}} minut"
    },
    past: {
      one: "{{count}} minuto",
      two: "{{count}} minutama",
      few: "{{count}} minutami",
      other: "{{count}} minutami"
    },
    future: {
      one: "{{count}} minuto",
      two: "{{count}} minuti",
      few: "{{count}} minute",
      other: "{{count}} minut"
    }
  },
  aboutXHours: {
    present: {
      one: "približno {{count}} ura",
      two: "približno {{count}} uri",
      few: "približno {{count}} ure",
      other: "približno {{count}} ur"
    },
    past: {
      one: "približno {{count}} uro",
      two: "približno {{count}} urama",
      few: "približno {{count}} urami",
      other: "približno {{count}} urami"
    },
    future: {
      one: "približno {{count}} uro",
      two: "približno {{count}} uri",
      few: "približno {{count}} ure",
      other: "približno {{count}} ur"
    }
  },
  xHours: {
    present: {
      one: "{{count}} ura",
      two: "{{count}} uri",
      few: "{{count}} ure",
      other: "{{count}} ur"
    },
    past: {
      one: "{{count}} uro",
      two: "{{count}} urama",
      few: "{{count}} urami",
      other: "{{count}} urami"
    },
    future: {
      one: "{{count}} uro",
      two: "{{count}} uri",
      few: "{{count}} ure",
      other: "{{count}} ur"
    }
  },
  xDays: {
    present: {
      one: "{{count}} dan",
      two: "{{count}} dni",
      few: "{{count}} dni",
      other: "{{count}} dni"
    },
    past: {
      one: "{{count}} dnem",
      two: "{{count}} dnevoma",
      few: "{{count}} dnevi",
      other: "{{count}} dnevi"
    },
    future: {
      one: "{{count}} dan",
      two: "{{count}} dni",
      few: "{{count}} dni",
      other: "{{count}} dni"
    }
  },
  aboutXWeeks: {
    one: "približno {{count}} teden",
    two: "približno {{count}} tedna",
    few: "približno {{count}} tedne",
    other: "približno {{count}} tednov"
  },
  xWeeks: {
    one: "{{count}} teden",
    two: "{{count}} tedna",
    few: "{{count}} tedne",
    other: "{{count}} tednov"
  },
  aboutXMonths: {
    present: {
      one: "približno {{count}} mesec",
      two: "približno {{count}} meseca",
      few: "približno {{count}} mesece",
      other: "približno {{count}} mesecev"
    },
    past: {
      one: "približno {{count}} mesecem",
      two: "približno {{count}} mesecema",
      few: "približno {{count}} meseci",
      other: "približno {{count}} meseci"
    },
    future: {
      one: "približno {{count}} mesec",
      two: "približno {{count}} meseca",
      few: "približno {{count}} mesece",
      other: "približno {{count}} mesecev"
    }
  },
  xMonths: {
    present: {
      one: "{{count}} mesec",
      two: "{{count}} meseca",
      few: "{{count}} meseci",
      other: "{{count}} mesecev"
    },
    past: {
      one: "{{count}} mesecem",
      two: "{{count}} mesecema",
      few: "{{count}} meseci",
      other: "{{count}} meseci"
    },
    future: {
      one: "{{count}} mesec",
      two: "{{count}} meseca",
      few: "{{count}} mesece",
      other: "{{count}} mesecev"
    }
  },
  aboutXYears: {
    present: {
      one: "približno {{count}} leto",
      two: "približno {{count}} leti",
      few: "približno {{count}} leta",
      other: "približno {{count}} let"
    },
    past: {
      one: "približno {{count}} letom",
      two: "približno {{count}} letoma",
      few: "približno {{count}} leti",
      other: "približno {{count}} leti"
    },
    future: {
      one: "približno {{count}} leto",
      two: "približno {{count}} leti",
      few: "približno {{count}} leta",
      other: "približno {{count}} let"
    }
  },
  xYears: {
    present: {
      one: "{{count}} leto",
      two: "{{count}} leti",
      few: "{{count}} leta",
      other: "{{count}} let"
    },
    past: {
      one: "{{count}} letom",
      two: "{{count}} letoma",
      few: "{{count}} leti",
      other: "{{count}} leti"
    },
    future: {
      one: "{{count}} leto",
      two: "{{count}} leti",
      few: "{{count}} leta",
      other: "{{count}} let"
    }
  },
  overXYears: {
    present: {
      one: "več kot {{count}} leto",
      two: "več kot {{count}} leti",
      few: "več kot {{count}} leta",
      other: "več kot {{count}} let"
    },
    past: {
      one: "več kot {{count}} letom",
      two: "več kot {{count}} letoma",
      few: "več kot {{count}} leti",
      other: "več kot {{count}} leti"
    },
    future: {
      one: "več kot {{count}} leto",
      two: "več kot {{count}} leti",
      few: "več kot {{count}} leta",
      other: "več kot {{count}} let"
    }
  },
  almostXYears: {
    present: {
      one: "skoraj {{count}} leto",
      two: "skoraj {{count}} leti",
      few: "skoraj {{count}} leta",
      other: "skoraj {{count}} let"
    },
    past: {
      one: "skoraj {{count}} letom",
      two: "skoraj {{count}} letoma",
      few: "skoraj {{count}} leti",
      other: "skoraj {{count}} leti"
    },
    future: {
      one: "skoraj {{count}} leto",
      two: "skoraj {{count}} leti",
      few: "skoraj {{count}} leta",
      other: "skoraj {{count}} let"
    }
  }
};
function w8e(e) {
  switch (e % 100) {
    case 1:
      return "one";
    case 2:
      return "two";
    case 3:
    case 4:
      return "few";
    default:
      return "other";
  }
}
var P8e = function(e, t, n) {
  var r = "", s = "present";
  n != null && n.addSuffix && (n.comparison && n.comparison > 0 ? (s = "future", r = "čez ") : (s = "past", r = "pred "));
  var f = b8e[e];
  if (typeof f == "string")
    r += f;
  else {
    var m = w8e(t);
    y8e(f) ? r += f[m].replace("{{count}}", String(t)) : r += f[s][m].replace("{{count}}", String(t));
  }
  return r;
};
const k8e = P8e;
var $8e = {
  full: "EEEE, dd. MMMM y",
  long: "dd. MMMM y",
  medium: "d. MMM y",
  short: "d. MM. yy"
}, S8e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, x8e = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, C8e = {
  date: Q({
    formats: $8e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: S8e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: x8e,
    defaultWidth: "full"
  })
};
const M8e = C8e;
var E8e = {
  lastWeek: function(e) {
    var t = e.getUTCDay();
    switch (t) {
      case 0:
        return "'prejšnjo nedeljo ob' p";
      case 3:
        return "'prejšnjo sredo ob' p";
      case 6:
        return "'prejšnjo soboto ob' p";
      default:
        return "'prejšnji' EEEE 'ob' p";
    }
  },
  yesterday: "'včeraj ob' p",
  today: "'danes ob' p",
  tomorrow: "'jutri ob' p",
  nextWeek: function(e) {
    var t = e.getUTCDay();
    switch (t) {
      case 0:
        return "'naslednjo nedeljo ob' p";
      case 3:
        return "'naslednjo sredo ob' p";
      case 6:
        return "'naslednjo soboto ob' p";
      default:
        return "'naslednji' EEEE 'ob' p";
    }
  },
  other: "P"
}, A8e = function(e, t, n, r) {
  var s = E8e[e];
  return typeof s == "function" ? s(t) : s;
};
const _8e = A8e;
var O8e = {
  narrow: ["pr. n. št.", "po n. št."],
  abbreviated: ["pr. n. št.", "po n. št."],
  wide: ["pred našim štetjem", "po našem štetju"]
}, T8e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čet.", "2. čet.", "3. čet.", "4. čet."],
  wide: ["1. četrtletje", "2. četrtletje", "3. četrtletje", "4. četrtletje"]
}, R8e = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "avg.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marec", "april", "maj", "junij", "julij", "avgust", "september", "oktober", "november", "december"]
}, D8e = {
  narrow: ["n", "p", "t", "s", "č", "p", "s"],
  short: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],
  abbreviated: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],
  wide: ["nedelja", "ponedeljek", "torek", "sreda", "četrtek", "petek", "sobota"]
}, N8e = {
  narrow: {
    am: "d",
    pm: "p",
    midnight: "24.00",
    noon: "12.00",
    morning: "j",
    afternoon: "p",
    evening: "v",
    night: "n"
  },
  abbreviated: {
    am: "dop.",
    pm: "pop.",
    midnight: "poln.",
    noon: "pold.",
    morning: "jut.",
    afternoon: "pop.",
    evening: "več.",
    night: "noč"
  },
  wide: {
    am: "dop.",
    pm: "pop.",
    midnight: "polnoč",
    noon: "poldne",
    morning: "jutro",
    afternoon: "popoldne",
    evening: "večer",
    night: "noč"
  }
}, W8e = {
  narrow: {
    am: "d",
    pm: "p",
    midnight: "24.00",
    noon: "12.00",
    morning: "zj",
    afternoon: "p",
    evening: "zv",
    night: "po"
  },
  abbreviated: {
    am: "dop.",
    pm: "pop.",
    midnight: "opoln.",
    noon: "opold.",
    morning: "zjut.",
    afternoon: "pop.",
    evening: "zveč.",
    night: "ponoči"
  },
  wide: {
    am: "dop.",
    pm: "pop.",
    midnight: "opolnoči",
    noon: "opoldne",
    morning: "zjutraj",
    afternoon: "popoldan",
    evening: "zvečer",
    night: "ponoči"
  }
}, j8e = function(e, t) {
  var n = Number(e);
  return n + ".";
}, z8e = {
  ordinalNumber: j8e,
  era: R({
    values: O8e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: T8e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: R8e,
    defaultWidth: "wide"
  }),
  day: R({
    values: D8e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: N8e,
    defaultWidth: "wide",
    formattingValues: W8e,
    defaultFormattingWidth: "wide"
  })
};
const L8e = z8e;
var I8e = /^(\d+)\./i, F8e = /\d+/i, H8e = {
  abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
  wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
}, V8e = {
  any: [/^pr/i, /^(po|na[sš]em)/i]
}, B8e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?[čc]et\.?/i,
  wide: /^[1234]\. [čc]etrtletje/i
}, U8e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, X8e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
  wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
}, q8e = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  abbreviated: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i],
  wide: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Y8e = {
  narrow: /^[nptsčc]/i,
  short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
}, G8e = {
  narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i]
}, Q8e = {
  narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
  any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
}, K8e = {
  narrow: {
    am: /^d/i,
    pm: /^p/i,
    midnight: /^24/i,
    noon: /^12/i,
    morning: /^(z?j)/i,
    afternoon: /^p/i,
    evening: /^(z?v)/i,
    night: /^(n|po)/i
  },
  any: {
    am: /^dop\./i,
    pm: /^pop\./i,
    midnight: /^o?poln/i,
    noon: /^o?pold/i,
    morning: /j/i,
    afternoon: /^pop\./i,
    evening: /^z?ve/i,
    night: /(po)?no/i
  }
}, J8e = {
  ordinalNumber: at({
    matchPattern: I8e,
    parsePattern: F8e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: H8e,
    defaultMatchWidth: "wide",
    parsePatterns: V8e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: B8e,
    defaultMatchWidth: "wide",
    parsePatterns: U8e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: X8e,
    defaultMatchWidth: "wide",
    parsePatterns: q8e,
    defaultParseWidth: "wide"
  }),
  day: D({
    matchPatterns: Y8e,
    defaultMatchWidth: "wide",
    parsePatterns: G8e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: Q8e,
    defaultMatchWidth: "any",
    parsePatterns: K8e,
    defaultParseWidth: "any"
  })
};
const Z8e = J8e;
var e9e = {
  code: "sl",
  formatDistance: k8e,
  formatLong: M8e,
  formatRelative: _8e,
  localize: L8e,
  match: Z8e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const t9e = e9e;
var n9e = {
  lessThanXSeconds: {
    one: "më pak se një sekondë",
    other: "më pak se {{count}} sekonda"
  },
  xSeconds: {
    one: "1 sekondë",
    other: "{{count}} sekonda"
  },
  halfAMinute: "gjysëm minuti",
  lessThanXMinutes: {
    one: "më pak se një minute",
    other: "më pak se {{count}} minuta"
  },
  xMinutes: {
    one: "1 minutë",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: "rreth 1 orë",
    other: "rreth {{count}} orë"
  },
  xHours: {
    one: "1 orë",
    other: "{{count}} orë"
  },
  xDays: {
    one: "1 ditë",
    other: "{{count}} ditë"
  },
  aboutXWeeks: {
    one: "rreth 1 javë",
    other: "rreth {{count}} javë"
  },
  xWeeks: {
    one: "1 javë",
    other: "{{count}} javë"
  },
  aboutXMonths: {
    one: "rreth 1 muaj",
    other: "rreth {{count}} muaj"
  },
  xMonths: {
    one: "1 muaj",
    other: "{{count}} muaj"
  },
  aboutXYears: {
    one: "rreth 1 vit",
    other: "rreth {{count}} vite"
  },
  xYears: {
    one: "1 vit",
    other: "{{count}} vite"
  },
  overXYears: {
    one: "mbi 1 vit",
    other: "mbi {{count}} vite"
  },
  almostXYears: {
    one: "pothuajse 1 vit",
    other: "pothuajse {{count}} vite"
  }
}, r9e = function(e, t, n) {
  var r, s = n9e[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "në " + r : r + " më parë" : r;
};
const a9e = r9e;
var i9e = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, o9e = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, s9e = {
  full: "{{date}} 'në' {{time}}",
  long: "{{date}} 'në' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, l9e = {
  date: Q({
    formats: i9e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: o9e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: s9e,
    defaultWidth: "full"
  })
};
const u9e = l9e;
var c9e = {
  lastWeek: "'të' eeee 'e shkuar në' p",
  yesterday: "'dje në' p",
  today: "'sot në' p",
  tomorrow: "'nesër në' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, d9e = function(e, t, n, r) {
  return c9e[e];
};
const f9e = d9e;
var m9e = {
  narrow: ["P", "M"],
  abbreviated: ["PK", "MK"],
  wide: ["Para Krishtit", "Mbas Krishtit"]
}, h9e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["4-mujori I", "4-mujori II", "4-mujori III", "4-mujori IV"]
}, p9e = {
  narrow: ["J", "S", "M", "P", "M", "Q", "K", "G", "S", "T", "N", "D"],
  abbreviated: ["Jan", "Shk", "Mar", "Pri", "Maj", "Qer", "Kor", "Gus", "Sht", "Tet", "Nën", "Dhj"],
  wide: ["Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor", "Korrik", "Gusht", "Shtator", "Tetor", "Nëntor", "Dhjetor"]
}, v9e = {
  narrow: ["D", "H", "M", "M", "E", "P", "S"],
  short: ["Di", "Hë", "Ma", "Më", "En", "Pr", "Sh"],
  abbreviated: ["Die", "Hën", "Mar", "Mër", "Enj", "Pre", "Sht"],
  wide: ["Dielë", "Hënë", "Martë", "Mërkurë", "Enjte", "Premte", "Shtunë"]
}, g9e = {
  narrow: {
    am: "p",
    pm: "m",
    midnight: "m",
    noon: "d",
    morning: "mëngjes",
    afternoon: "dite",
    evening: "mbrëmje",
    night: "natë"
  },
  abbreviated: {
    am: "PD",
    pm: "MD",
    midnight: "mesnëtë",
    noon: "drek",
    morning: "mëngjes",
    afternoon: "mbasdite",
    evening: "mbrëmje",
    night: "natë"
  },
  wide: {
    am: "p.d.",
    pm: "m.d.",
    midnight: "mesnëtë",
    noon: "drek",
    morning: "mëngjes",
    afternoon: "mbasdite",
    evening: "mbrëmje",
    night: "natë"
  }
}, y9e = {
  narrow: {
    am: "p",
    pm: "m",
    midnight: "m",
    noon: "d",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë"
  },
  abbreviated: {
    am: "PD",
    pm: "MD",
    midnight: "mesnatë",
    noon: "drek",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë"
  },
  wide: {
    am: "p.d.",
    pm: "m.d.",
    midnight: "mesnatë",
    noon: "drek",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë"
  }
}, b9e = function(e, t) {
  var n = Number(e);
  return (t == null ? void 0 : t.unit) === "hour" ? String(n) : n === 1 ? n + "-rë" : n === 4 ? n + "t" : n + "-të";
}, w9e = {
  ordinalNumber: b9e,
  era: R({
    values: m9e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: h9e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: p9e,
    defaultWidth: "wide"
  }),
  day: R({
    values: v9e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: g9e,
    defaultWidth: "wide",
    formattingValues: y9e,
    defaultFormattingWidth: "wide"
  })
};
const P9e = w9e;
var k9e = /^(\d+)(-rë|-të|t|)?/i, $9e = /\d+/i, S9e = {
  narrow: /^(p|m)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(para krishtit|mbas krishtit)/i
}, x9e = {
  any: [/^b/i, /^(p|m)/i]
}, C9e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]-mujori (i{1,3}|iv)/i
}, M9e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, E9e = {
  narrow: /^[jsmpqkftnd]/i,
  abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
  wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
}, A9e = {
  narrow: [/^j/i, /^s/i, /^m/i, /^p/i, /^m/i, /^q/i, /^k/i, /^g/i, /^s/i, /^t/i, /^n/i, /^d/i],
  any: [/^ja/i, /^shk/i, /^mar/i, /^pri/i, /^maj/i, /^qer/i, /^kor/i, /^gu/i, /^sht/i, /^tet/i, /^n/i, /^d/i]
}, _9e = {
  narrow: /^[dhmeps]/i,
  short: /^(di|hë|ma|më|en|pr|sh)/i,
  abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
  wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
}, O9e = {
  narrow: [/^d/i, /^h/i, /^m/i, /^m/i, /^e/i, /^p/i, /^s/i],
  any: [/^d/i, /^h/i, /^ma/i, /^më/i, /^e/i, /^p/i, /^s/i]
}, T9e = {
  narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
  any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
}, R9e = {
  any: {
    am: /^p/i,
    pm: /^m/i,
    midnight: /^me/i,
    noon: /^dr/i,
    morning: /mëngjes/i,
    afternoon: /mbasdite/i,
    evening: /mbrëmje/i,
    night: /natë/i
  }
}, D9e = {
  ordinalNumber: at({
    matchPattern: k9e,
    parsePattern: $9e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: S9e,
    defaultMatchWidth: "wide",
    parsePatterns: x9e,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: C9e,
    defaultMatchWidth: "wide",
    parsePatterns: M9e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: E9e,
    defaultMatchWidth: "wide",
    parsePatterns: A9e,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: _9e,
    defaultMatchWidth: "wide",
    parsePatterns: O9e,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: T9e,
    defaultMatchWidth: "any",
    parsePatterns: R9e,
    defaultParseWidth: "any"
  })
};
const N9e = D9e;
var W9e = {
  code: "sq",
  formatDistance: a9e,
  formatLong: u9e,
  formatRelative: f9e,
  localize: P9e,
  match: N9e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const j9e = W9e;
var z9e = {
  lessThanXSeconds: {
    one: {
      standalone: "мање од 1 секунде",
      withPrepositionAgo: "мање од 1 секунде",
      withPrepositionIn: "мање од 1 секунду"
    },
    dual: "мање од {{count}} секунде",
    other: "мање од {{count}} секунди"
  },
  xSeconds: {
    one: {
      standalone: "1 секунда",
      withPrepositionAgo: "1 секунде",
      withPrepositionIn: "1 секунду"
    },
    dual: "{{count}} секунде",
    other: "{{count}} секунди"
  },
  halfAMinute: "пола минуте",
  lessThanXMinutes: {
    one: {
      standalone: "мање од 1 минуте",
      withPrepositionAgo: "мање од 1 минуте",
      withPrepositionIn: "мање од 1 минуту"
    },
    dual: "мање од {{count}} минуте",
    other: "мање од {{count}} минута"
  },
  xMinutes: {
    one: {
      standalone: "1 минута",
      withPrepositionAgo: "1 минуте",
      withPrepositionIn: "1 минуту"
    },
    dual: "{{count}} минуте",
    other: "{{count}} минута"
  },
  aboutXHours: {
    one: {
      standalone: "око 1 сат",
      withPrepositionAgo: "око 1 сат",
      withPrepositionIn: "око 1 сат"
    },
    dual: "око {{count}} сата",
    other: "око {{count}} сати"
  },
  xHours: {
    one: {
      standalone: "1 сат",
      withPrepositionAgo: "1 сат",
      withPrepositionIn: "1 сат"
    },
    dual: "{{count}} сата",
    other: "{{count}} сати"
  },
  xDays: {
    one: {
      standalone: "1 дан",
      withPrepositionAgo: "1 дан",
      withPrepositionIn: "1 дан"
    },
    dual: "{{count}} дана",
    other: "{{count}} дана"
  },
  aboutXWeeks: {
    one: {
      standalone: "око 1 недељу",
      withPrepositionAgo: "око 1 недељу",
      withPrepositionIn: "око 1 недељу"
    },
    dual: "око {{count}} недеље",
    other: "око {{count}} недеље"
  },
  xWeeks: {
    one: {
      standalone: "1 недељу",
      withPrepositionAgo: "1 недељу",
      withPrepositionIn: "1 недељу"
    },
    dual: "{{count}} недеље",
    other: "{{count}} недеље"
  },
  aboutXMonths: {
    one: {
      standalone: "око 1 месец",
      withPrepositionAgo: "око 1 месец",
      withPrepositionIn: "око 1 месец"
    },
    dual: "око {{count}} месеца",
    other: "око {{count}} месеци"
  },
  xMonths: {
    one: {
      standalone: "1 месец",
      withPrepositionAgo: "1 месец",
      withPrepositionIn: "1 месец"
    },
    dual: "{{count}} месеца",
    other: "{{count}} месеци"
  },
  aboutXYears: {
    one: {
      standalone: "око 1 годину",
      withPrepositionAgo: "око 1 годину",
      withPrepositionIn: "око 1 годину"
    },
    dual: "око {{count}} године",
    other: "око {{count}} година"
  },
  xYears: {
    one: {
      standalone: "1 година",
      withPrepositionAgo: "1 године",
      withPrepositionIn: "1 годину"
    },
    dual: "{{count}} године",
    other: "{{count}} година"
  },
  overXYears: {
    one: {
      standalone: "преко 1 годину",
      withPrepositionAgo: "преко 1 годину",
      withPrepositionIn: "преко 1 годину"
    },
    dual: "преко {{count}} године",
    other: "преко {{count}} година"
  },
  almostXYears: {
    one: {
      standalone: "готово 1 годину",
      withPrepositionAgo: "готово 1 годину",
      withPrepositionIn: "готово 1 годину"
    },
    dual: "готово {{count}} године",
    other: "готово {{count}} година"
  }
}, L9e = function(e, t, n) {
  var r, s = z9e[e];
  return typeof s == "string" ? r = s : t === 1 ? n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r = s.one.withPrepositionIn : r = s.one.withPrepositionAgo : r = s.one.standalone : t % 10 > 1 && t % 10 < 5 && String(t).substr(-2, 1) !== "1" ? r = s.dual.replace("{{count}}", String(t)) : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "за " + r : "пре " + r : r;
};
const I9e = L9e;
var F9e = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, H9e = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, V9e = {
  full: "{{date}} 'у' {{time}}",
  long: "{{date}} 'у' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, B9e = {
  date: Q({
    formats: F9e,
    defaultWidth: "full"
  }),
  time: Q({
    formats: H9e,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: V9e,
    defaultWidth: "full"
  })
};
const U9e = B9e;
var X9e = {
  lastWeek: function(e) {
    var t = e.getUTCDay();
    switch (t) {
      case 0:
        return "'прошле недеље у' p";
      case 3:
        return "'прошле среде у' p";
      case 6:
        return "'прошле суботе у' p";
      default:
        return "'прошли' EEEE 'у' p";
    }
  },
  yesterday: "'јуче у' p",
  today: "'данас у' p",
  tomorrow: "'сутра у' p",
  nextWeek: function(e) {
    var t = e.getUTCDay();
    switch (t) {
      case 0:
        return "'следеће недеље у' p";
      case 3:
        return "'следећу среду у' p";
      case 6:
        return "'следећу суботу у' p";
      default:
        return "'следећи' EEEE 'у' p";
    }
  },
  other: "P"
}, q9e = function(e, t, n, r) {
  var s = X9e[e];
  return typeof s == "function" ? s(t) : s;
};
const Y9e = q9e;
var G9e = {
  narrow: ["пр.н.е.", "АД"],
  abbreviated: ["пр. Хр.", "по. Хр."],
  wide: ["Пре Христа", "После Христа"]
}, Q9e = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. кв.", "2. кв.", "3. кв.", "4. кв."],
  wide: ["1. квартал", "2. квартал", "3. квартал", "4. квартал"]
}, K9e = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["јан", "феб", "мар", "апр", "мај", "јун", "јул", "авг", "сеп", "окт", "нов", "дец"],
  wide: ["јануар", "фебруар", "март", "април", "мај", "јун", "јул", "август", "септембар", "октобар", "новембар", "децембар"]
}, J9e = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["јан", "феб", "мар", "апр", "мај", "јун", "јул", "авг", "сеп", "окт", "нов", "дец"],
  wide: ["јануар", "фебруар", "март", "април", "мај", "јун", "јул", "август", "септембар", "октобар", "новембар", "децембар"]
}, Z9e = {
  narrow: ["Н", "П", "У", "С", "Ч", "П", "С"],
  short: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"],
  abbreviated: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"],
  wide: ["недеља", "понедељак", "уторак", "среда", "четвртак", "петак", "субота"]
}, eLe = {
  narrow: {
    am: "АМ",
    pm: "ПМ",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  abbreviated: {
    am: "АМ",
    pm: "ПМ",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "после подне",
    evening: "увече",
    night: "ноћу"
  }
}, tLe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "после подне",
    evening: "увече",
    night: "ноћу"
  }
}, nLe = function(e, t) {
  var n = Number(e);
  return n + ".";
}, rLe = {
  ordinalNumber: nLe,
  era: R({
    values: G9e,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Q9e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: K9e,
    defaultWidth: "wide",
    formattingValues: J9e,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: Z9e,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: tLe,
    defaultWidth: "wide",
    formattingValues: eLe,
    defaultFormattingWidth: "wide"
  })
};
const aLe = rLe;
var iLe = /^(\d+)\./i, oLe = /\d+/i, sLe = {
  narrow: /^(пр\.н\.е\.|АД)/i,
  abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
  wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
}, lLe = {
  any: [/^пр/i, /^(по|нова)/i]
}, uLe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?кв\.?/i,
  wide: /^[1234]\. квартал/i
}, cLe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, dLe = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
  wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
}, fLe = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ја/i, /^ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^авг/i, /^с/i, /^о/i, /^н/i, /^д/i]
}, mLe = {
  narrow: /^[пусчн]/i,
  short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
}, hLe = {
  narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^п/i, /^с/i, /^н/i],
  any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i]
}, pLe = {
  any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
}, vLe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^поно/i,
    noon: /^под/i,
    morning: /ујутру/i,
    afternoon: /(после\s|по)+подне/i,
    evening: /(увече)/i,
    night: /(ноћу)/i
  }
}, gLe = {
  ordinalNumber: at({
    matchPattern: iLe,
    parsePattern: oLe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: sLe,
    defaultMatchWidth: "wide",
    parsePatterns: lLe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: uLe,
    defaultMatchWidth: "wide",
    parsePatterns: cLe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: dLe,
    defaultMatchWidth: "wide",
    parsePatterns: fLe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: mLe,
    defaultMatchWidth: "wide",
    parsePatterns: hLe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: pLe,
    defaultMatchWidth: "any",
    parsePatterns: vLe,
    defaultParseWidth: "any"
  })
};
const yLe = gLe;
var bLe = {
  code: "sr",
  formatDistance: I9e,
  formatLong: U9e,
  formatRelative: Y9e,
  localize: aLe,
  match: yLe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const wLe = bLe;
var PLe = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 nedelju",
      withPrepositionAgo: "oko 1 nedelju",
      withPrepositionIn: "oko 1 nedelju"
    },
    dual: "oko {{count}} nedelje",
    other: "oko {{count}} nedelje"
  },
  xWeeks: {
    one: {
      standalone: "1 nedelju",
      withPrepositionAgo: "1 nedelju",
      withPrepositionIn: "1 nedelju"
    },
    dual: "{{count}} nedelje",
    other: "{{count}} nedelje"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mesec",
      withPrepositionAgo: "oko 1 mesec",
      withPrepositionIn: "oko 1 mesec"
    },
    dual: "oko {{count}} meseca",
    other: "oko {{count}} meseci"
  },
  xMonths: {
    one: {
      standalone: "1 mesec",
      withPrepositionAgo: "1 mesec",
      withPrepositionIn: "1 mesec"
    },
    dual: "{{count}} meseca",
    other: "{{count}} meseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, kLe = function(e, t, n) {
  var r, s = PLe[e];
  return typeof s == "string" ? r = s : t === 1 ? n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r = s.one.withPrepositionIn : r = s.one.withPrepositionAgo : r = s.one.standalone : t % 10 > 1 && t % 10 < 5 && String(t).substr(-2, 1) !== "1" ? r = s.dual.replace("{{count}}", String(t)) : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "za " + r : "pre " + r : r;
};
const $Le = kLe;
var SLe = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, xLe = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, CLe = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, MLe = {
  date: Q({
    formats: SLe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: xLe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: CLe,
    defaultWidth: "full"
  })
};
const ELe = MLe;
var ALe = {
  lastWeek: function(e) {
    switch (e.getUTCDay()) {
      case 0:
        return "'prošle nedelje u' p";
      case 3:
        return "'prošle srede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function(e) {
    switch (e.getUTCDay()) {
      case 0:
        return "'sledeće nedelje u' p";
      case 3:
        return "'sledeću sredu u' p";
      case 6:
        return "'sledeću subotu u' p";
      default:
        return "'sledeći' EEEE 'u' p";
    }
  },
  other: "P"
}, _Le = function(e, t, n, r) {
  var s = ALe[e];
  return typeof s == "function" ? s(t) : s;
};
const OLe = _Le;
var TLe = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Pre Hrista", "Posle Hrista"]
}, RLe = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, DLe = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
}, NLe = {
  narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
  abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
  wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
}, WLe = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: ["nedelja", "ponedeljak", "utorak", "sreda", "četvrtak", "petak", "subota"]
}, jLe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, zLe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, LLe = function(e, t) {
  var n = Number(e);
  return n + ".";
}, ILe = {
  ordinalNumber: LLe,
  era: R({
    values: TLe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: RLe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: DLe,
    defaultWidth: "wide",
    formattingValues: NLe,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: WLe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: zLe,
    defaultWidth: "wide",
    formattingValues: jLe,
    defaultFormattingWidth: "wide"
  })
};
const FLe = ILe;
var HLe = /^(\d+)\./i, VLe = /\d+/i, BLe = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
}, ULe = {
  any: [/^pr/i, /^(po|nova)/i]
}, XLe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, qLe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, YLe = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
}, GLe = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, QLe = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
}, KLe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, JLe = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
}, ZLe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
}, eIe = {
  ordinalNumber: at({
    matchPattern: HLe,
    parsePattern: VLe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: BLe,
    defaultMatchWidth: "wide",
    parsePatterns: ULe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: XLe,
    defaultMatchWidth: "wide",
    parsePatterns: qLe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: YLe,
    defaultMatchWidth: "wide",
    parsePatterns: GLe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: QLe,
    defaultMatchWidth: "wide",
    parsePatterns: KLe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: JLe,
    defaultMatchWidth: "any",
    parsePatterns: ZLe,
    defaultParseWidth: "any"
  })
};
const tIe = eIe;
var nIe = {
  code: "sr-Latn",
  formatDistance: $Le,
  formatLong: ELe,
  formatRelative: OLe,
  localize: FLe,
  match: tIe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const rIe = nIe;
var aIe = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, iIe = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], oIe = function(e, t, n) {
  var r, s = aIe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : n && n.onlyNumeric ? r = s.other.replace("{{count}}", String(t)) : r = s.other.replace("{{count}}", t < 13 ? iIe[t] : String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "om " + r : r + " sedan" : r;
};
const sIe = oIe;
var lIe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, uIe = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, cIe = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, dIe = {
  date: Q({
    formats: lIe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: uIe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: cIe,
    defaultWidth: "full"
  })
};
const fIe = dIe;
var mIe = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, hIe = function(e, t, n, r) {
  return mIe[e];
};
const pIe = hIe;
var vIe = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, gIe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, yIe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, bIe = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, wIe = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, PIe = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, kIe = function(e, t) {
  var n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
      case 2:
        return n + ":a";
    }
  return n + ":e";
}, $Ie = {
  ordinalNumber: kIe,
  era: R({
    values: vIe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: gIe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: yIe,
    defaultWidth: "wide"
  }),
  day: R({
    values: bIe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: wIe,
    defaultWidth: "wide",
    formattingValues: PIe,
    defaultFormattingWidth: "wide"
  })
};
const SIe = $Ie;
var xIe = /^(\d+)(:a|:e)?/i, CIe = /\d+/i, MIe = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, EIe = {
  any: [/^f/i, /^[ev]/i]
}, AIe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, _Ie = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, OIe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, TIe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, RIe = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, DIe = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, NIe = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, WIe = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, jIe = {
  ordinalNumber: at({
    matchPattern: xIe,
    parsePattern: CIe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: MIe,
    defaultMatchWidth: "wide",
    parsePatterns: EIe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: AIe,
    defaultMatchWidth: "wide",
    parsePatterns: _Ie,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: OIe,
    defaultMatchWidth: "wide",
    parsePatterns: TIe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: RIe,
    defaultMatchWidth: "wide",
    parsePatterns: DIe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: NIe,
    defaultMatchWidth: "any",
    parsePatterns: WIe,
    defaultParseWidth: "any"
  })
};
const zIe = jIe;
var LIe = {
  code: "sv",
  formatDistance: sIe,
  formatLong: fIe,
  formatRelative: pIe,
  localize: SIe,
  match: zIe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const IIe = LIe;
function FIe(e) {
  return e.one !== void 0;
}
var HIe = {
  lessThanXSeconds: {
    one: {
      default: "ஒரு வினாடிக்கு குறைவாக",
      in: "ஒரு வினாடிக்குள்",
      ago: "ஒரு வினாடிக்கு முன்பு"
    },
    other: {
      default: "{{count}} வினாடிகளுக்கு குறைவாக",
      in: "{{count}} வினாடிகளுக்குள்",
      ago: "{{count}} வினாடிகளுக்கு முன்பு"
    }
  },
  xSeconds: {
    one: {
      default: "1 வினாடி",
      in: "1 வினாடியில்",
      ago: "1 வினாடி முன்பு"
    },
    other: {
      default: "{{count}} விநாடிகள்",
      in: "{{count}} வினாடிகளில்",
      ago: "{{count}} விநாடிகளுக்கு முன்பு"
    }
  },
  halfAMinute: {
    default: "அரை நிமிடம்",
    in: "அரை நிமிடத்தில்",
    ago: "அரை நிமிடம் முன்பு"
  },
  lessThanXMinutes: {
    one: {
      default: "ஒரு நிமிடத்திற்கும் குறைவாக",
      in: "ஒரு நிமிடத்திற்குள்",
      ago: "ஒரு நிமிடத்திற்கு முன்பு"
    },
    other: {
      default: "{{count}} நிமிடங்களுக்கும் குறைவாக",
      in: "{{count}} நிமிடங்களுக்குள்",
      ago: "{{count}} நிமிடங்களுக்கு முன்பு"
    }
  },
  xMinutes: {
    one: {
      default: "1 நிமிடம்",
      in: "1 நிமிடத்தில்",
      ago: "1 நிமிடம் முன்பு"
    },
    other: {
      default: "{{count}} நிமிடங்கள்",
      in: "{{count}} நிமிடங்களில்",
      ago: "{{count}} நிமிடங்களுக்கு முன்பு"
    }
  },
  aboutXHours: {
    one: {
      default: "சுமார் 1 மணி நேரம்",
      in: "சுமார் 1 மணி நேரத்தில்",
      ago: "சுமார் 1 மணி நேரத்திற்கு முன்பு"
    },
    other: {
      default: "சுமார் {{count}} மணி நேரம்",
      in: "சுமார் {{count}} மணி நேரத்திற்கு முன்பு",
      ago: "சுமார் {{count}} மணி நேரத்தில்"
    }
  },
  xHours: {
    one: {
      default: "1 மணி நேரம்",
      in: "1 மணி நேரத்தில்",
      ago: "1 மணி நேரத்திற்கு முன்பு"
    },
    other: {
      default: "{{count}} மணி நேரம்",
      in: "{{count}} மணி நேரத்தில்",
      ago: "{{count}} மணி நேரத்திற்கு முன்பு"
    }
  },
  xDays: {
    one: {
      default: "1 நாள்",
      in: "1 நாளில்",
      ago: "1 நாள் முன்பு"
    },
    other: {
      default: "{{count}} நாட்கள்",
      in: "{{count}} நாட்களில்",
      ago: "{{count}} நாட்களுக்கு முன்பு"
    }
  },
  aboutXWeeks: {
    one: {
      default: "சுமார் 1 வாரம்",
      in: "சுமார் 1 வாரத்தில்",
      ago: "சுமார் 1 வாரம் முன்பு"
    },
    other: {
      default: "சுமார் {{count}} வாரங்கள்",
      in: "சுமார் {{count}} வாரங்களில்",
      ago: "சுமார் {{count}} வாரங்களுக்கு முன்பு"
    }
  },
  xWeeks: {
    one: {
      default: "1 வாரம்",
      in: "1 வாரத்தில்",
      ago: "1 வாரம் முன்பு"
    },
    other: {
      default: "{{count}} வாரங்கள்",
      in: "{{count}} வாரங்களில்",
      ago: "{{count}} வாரங்களுக்கு முன்பு"
    }
  },
  aboutXMonths: {
    one: {
      default: "சுமார் 1 மாதம்",
      in: "சுமார் 1 மாதத்தில்",
      ago: "சுமார் 1 மாதத்திற்கு முன்பு"
    },
    other: {
      default: "சுமார் {{count}} மாதங்கள்",
      in: "சுமார் {{count}} மாதங்களில்",
      ago: "சுமார் {{count}} மாதங்களுக்கு முன்பு"
    }
  },
  xMonths: {
    one: {
      default: "1 மாதம்",
      in: "1 மாதத்தில்",
      ago: "1 மாதம் முன்பு"
    },
    other: {
      default: "{{count}} மாதங்கள்",
      in: "{{count}} மாதங்களில்",
      ago: "{{count}} மாதங்களுக்கு முன்பு"
    }
  },
  aboutXYears: {
    one: {
      default: "சுமார் 1 வருடம்",
      in: "சுமார் 1 ஆண்டில்",
      ago: "சுமார் 1 வருடம் முன்பு"
    },
    other: {
      default: "சுமார் {{count}} ஆண்டுகள்",
      in: "சுமார் {{count}} ஆண்டுகளில்",
      ago: "சுமார் {{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  xYears: {
    one: {
      default: "1 வருடம்",
      in: "1 ஆண்டில்",
      ago: "1 வருடம் முன்பு"
    },
    other: {
      default: "{{count}} ஆண்டுகள்",
      in: "{{count}} ஆண்டுகளில்",
      ago: "{{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  overXYears: {
    one: {
      default: "1 வருடத்திற்கு மேல்",
      in: "1 வருடத்திற்கும் மேலாக",
      ago: "1 வருடம் முன்பு"
    },
    other: {
      default: "{{count}} ஆண்டுகளுக்கும் மேலாக",
      in: "{{count}} ஆண்டுகளில்",
      ago: "{{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  almostXYears: {
    one: {
      default: "கிட்டத்தட்ட 1 வருடம்",
      in: "கிட்டத்தட்ட 1 ஆண்டில்",
      ago: "கிட்டத்தட்ட 1 வருடம் முன்பு"
    },
    other: {
      default: "கிட்டத்தட்ட {{count}} ஆண்டுகள்",
      in: "கிட்டத்தட்ட {{count}} ஆண்டுகளில்",
      ago: "கிட்டத்தட்ட {{count}} ஆண்டுகளுக்கு முன்பு"
    }
  }
}, VIe = function(e, t, n) {
  var r = n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in" : "ago" : "default", s = HIe[e];
  return FIe(s) ? t === 1 ? s.one[r] : s.other[r].replace("{{count}}", String(t)) : s[r];
};
const BIe = VIe;
var UIe = {
  full: "EEEE, d MMMM, y",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "d/M/yy"
}, XIe = {
  full: "a h:mm:ss zzzz",
  long: "a h:mm:ss z",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, qIe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, YIe = {
  date: Q({
    formats: UIe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: XIe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: qIe,
    defaultWidth: "full"
  })
};
const GIe = YIe;
var QIe = {
  lastWeek: "'கடந்த' eeee p 'மணிக்கு'",
  yesterday: "'நேற்று ' p 'மணிக்கு'",
  today: "'இன்று ' p 'மணிக்கு'",
  tomorrow: "'நாளை ' p 'மணிக்கு'",
  nextWeek: "eeee p 'மணிக்கு'",
  other: "P"
}, KIe = function(e, t, n, r) {
  return QIe[e];
};
const JIe = KIe;
var ZIe = {
  narrow: ["கி.மு.", "கி.பி."],
  abbreviated: ["கி.மு.", "கி.பி."],
  wide: ["கிறிஸ்துவுக்கு முன்", "அன்னோ டோமினி"]
}, eFe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["காலா.1", "காலா.2", "காலா.3", "காலா.4"],
  wide: ["ஒன்றாம் காலாண்டு", "இரண்டாம் காலாண்டு", "மூன்றாம் காலாண்டு", "நான்காம் காலாண்டு"]
}, tFe = {
  narrow: ["ஜ", "பி", "மா", "ஏ", "மே", "ஜூ", "ஜூ", "ஆ", "செ", "அ", "ந", "டி"],
  abbreviated: ["ஜன.", "பிப்.", "மார்.", "ஏப்.", "மே", "ஜூன்", "ஜூலை", "ஆக.", "செப்.", "அக்.", "நவ.", "டிச."],
  wide: [
    "ஜனவரி",
    "பிப்ரவரி",
    "மார்ச்",
    "ஏப்ரல்",
    "மே",
    "ஜூன்",
    "ஜூலை",
    "ஆகஸ்ட்",
    "செப்டம்பர்",
    "அக்டோபர்",
    "நவம்பர்",
    "டிசம்பர்"
  ]
}, nFe = {
  narrow: ["ஞா", "தி", "செ", "பு", "வி", "வெ", "ச"],
  short: ["ஞா", "தி", "செ", "பு", "வி", "வெ", "ச"],
  abbreviated: ["ஞாயி.", "திங்.", "செவ்.", "புத.", "வியா.", "வெள்.", "சனி"],
  wide: [
    "ஞாயிறு",
    "திங்கள்",
    "செவ்வாய்",
    "புதன்",
    "வியாழன்",
    "வெள்ளி",
    "சனி"
  ]
}, rFe = {
  narrow: {
    am: "மு.ப",
    pm: "பி.ப",
    midnight: "நள்.",
    noon: "நண்.",
    morning: "கா.",
    afternoon: "மதி.",
    evening: "மா.",
    night: "இர."
  },
  abbreviated: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  },
  wide: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  }
}, aFe = {
  narrow: {
    am: "மு.ப",
    pm: "பி.ப",
    midnight: "நள்.",
    noon: "நண்.",
    morning: "கா.",
    afternoon: "மதி.",
    evening: "மா.",
    night: "இர."
  },
  abbreviated: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  },
  wide: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  }
}, iFe = function(e, t) {
  return String(e);
}, oFe = {
  ordinalNumber: iFe,
  era: R({
    values: ZIe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: eFe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: tFe,
    defaultWidth: "wide"
  }),
  day: R({
    values: nFe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: rFe,
    defaultWidth: "wide",
    formattingValues: aFe,
    defaultFormattingWidth: "wide"
  })
};
const sFe = oFe;
var lFe = /^(\d+)(வது)?/i, uFe = /\d+/i, cFe = {
  narrow: /^(கி.மு.|கி.பி.)/i,
  abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
  wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
}, dFe = {
  any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/]
}, fFe = {
  narrow: /^[1234]/i,
  abbreviated: /^காலா.[1234]/i,
  wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
}, mFe = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/(1|காலா.1|ஒன்றாம்)/i, /(2|காலா.2|இரண்டாம்)/i, /(3|காலா.3|மூன்றாம்)/i, /(4|காலா.4|நான்காம்)/i]
}, hFe = {
  narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
  abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
  wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
}, pFe = {
  narrow: [/^ஜ$/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூ/i, /^ஜூ/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i],
  any: [/^ஜன/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூன்/i, /^ஜூலை/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i]
}, vFe = {
  narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
  wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
}, gFe = {
  narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
  any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i]
}, yFe = {
  narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
  any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
}, bFe = {
  any: {
    am: /^மு/i,
    pm: /^பி/i,
    midnight: /^நள்/i,
    noon: /^நண்/i,
    morning: /காலை/i,
    afternoon: /மதியம்/i,
    evening: /மாலை/i,
    night: /இரவு/i
  }
}, wFe = {
  ordinalNumber: at({
    matchPattern: lFe,
    parsePattern: uFe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: cFe,
    defaultMatchWidth: "wide",
    parsePatterns: dFe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: fFe,
    defaultMatchWidth: "wide",
    parsePatterns: mFe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: hFe,
    defaultMatchWidth: "wide",
    parsePatterns: pFe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: vFe,
    defaultMatchWidth: "wide",
    parsePatterns: gFe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: yFe,
    defaultMatchWidth: "any",
    parsePatterns: bFe,
    defaultParseWidth: "any"
  })
};
const PFe = wFe;
var kFe = {
  code: "ta",
  formatDistance: BIe,
  formatLong: GIe,
  formatRelative: JIe,
  localize: sFe,
  match: PFe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const $Fe = kFe;
var YO = {
  lessThanXSeconds: {
    standalone: {
      one: "సెకను కన్నా తక్కువ",
      other: "{{count}} సెకన్ల కన్నా తక్కువ"
    },
    withPreposition: {
      one: "సెకను",
      other: "{{count}} సెకన్ల"
    }
  },
  xSeconds: {
    standalone: {
      one: "ఒక సెకను",
      other: "{{count}} సెకన్ల"
    },
    withPreposition: {
      one: "ఒక సెకను",
      other: "{{count}} సెకన్ల"
    }
  },
  halfAMinute: {
    standalone: "అర నిమిషం",
    withPreposition: "అర నిమిషం"
  },
  lessThanXMinutes: {
    standalone: {
      one: "ఒక నిమిషం కన్నా తక్కువ",
      other: "{{count}} నిమిషాల కన్నా తక్కువ"
    },
    withPreposition: {
      one: "ఒక నిమిషం",
      other: "{{count}} నిమిషాల"
    }
  },
  xMinutes: {
    standalone: {
      one: "ఒక నిమిషం",
      other: "{{count}} నిమిషాలు"
    },
    withPreposition: {
      one: "ఒక నిమిషం",
      other: "{{count}} నిమిషాల"
    }
  },
  aboutXHours: {
    standalone: {
      one: "సుమారు ఒక గంట",
      other: "సుమారు {{count}} గంటలు"
    },
    withPreposition: {
      one: "సుమారు ఒక గంట",
      other: "సుమారు {{count}} గంటల"
    }
  },
  xHours: {
    standalone: {
      one: "ఒక గంట",
      other: "{{count}} గంటలు"
    },
    withPreposition: {
      one: "ఒక గంట",
      other: "{{count}} గంటల"
    }
  },
  xDays: {
    standalone: {
      one: "ఒక రోజు",
      other: "{{count}} రోజులు"
    },
    withPreposition: {
      one: "ఒక రోజు",
      other: "{{count}} రోజుల"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "సుమారు ఒక వారం",
      other: "సుమారు {{count}} వారాలు"
    },
    withPreposition: {
      one: "సుమారు ఒక వారం",
      other: "సుమారు {{count}} వారాలల"
    }
  },
  xWeeks: {
    standalone: {
      one: "ఒక వారం",
      other: "{{count}} వారాలు"
    },
    withPreposition: {
      one: "ఒక వారం",
      other: "{{count}} వారాలల"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "సుమారు ఒక నెల",
      other: "సుమారు {{count}} నెలలు"
    },
    withPreposition: {
      one: "సుమారు ఒక నెల",
      other: "సుమారు {{count}} నెలల"
    }
  },
  xMonths: {
    standalone: {
      one: "ఒక నెల",
      other: "{{count}} నెలలు"
    },
    withPreposition: {
      one: "ఒక నెల",
      other: "{{count}} నెలల"
    }
  },
  aboutXYears: {
    standalone: {
      one: "సుమారు ఒక సంవత్సరం",
      other: "సుమారు {{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "సుమారు ఒక సంవత్సరం",
      other: "సుమారు {{count}} సంవత్సరాల"
    }
  },
  xYears: {
    standalone: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాల"
    }
  },
  overXYears: {
    standalone: {
      one: "ఒక సంవత్సరం పైగా",
      other: "{{count}} సంవత్సరాలకు పైగా"
    },
    withPreposition: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాల"
    }
  },
  almostXYears: {
    standalone: {
      one: "దాదాపు ఒక సంవత్సరం",
      other: "దాదాపు {{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "దాదాపు ఒక సంవత్సరం",
      other: "దాదాపు {{count}} సంవత్సరాల"
    }
  }
}, SFe = function(e, t, n) {
  var r, s = n != null && n.addSuffix ? YO[e].withPreposition : YO[e].standalone;
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + "లో" : r + " క్రితం" : r;
};
const xFe = SFe;
var CFe = {
  full: "d, MMMM y, EEEE",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "dd-MM-yy"
}, MFe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, EFe = {
  full: "{{date}} {{time}}'కి'",
  long: "{{date}} {{time}}'కి'",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, AFe = {
  date: Q({
    formats: CFe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: MFe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: EFe,
    defaultWidth: "full"
  })
};
const _Fe = AFe;
var OFe = {
  lastWeek: "'గత' eeee p",
  yesterday: "'నిన్న' p",
  today: "'ఈ రోజు' p",
  tomorrow: "'రేపు' p",
  nextWeek: "'తదుపరి' eeee p",
  other: "P"
}, TFe = function(e, t, n, r) {
  return OFe[e];
};
const RFe = TFe;
var DFe = {
  narrow: ["క్రీ.పూ.", "క్రీ.శ."],
  abbreviated: ["క్రీ.పూ.", "క్రీ.శ."],
  wide: ["క్రీస్తు పూర్వం", "క్రీస్తుశకం"]
}, NFe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["త్రై1", "త్రై2", "త్రై3", "త్రై4"],
  wide: ["1వ త్రైమాసికం", "2వ త్రైమాసికం", "3వ త్రైమాసికం", "4వ త్రైమాసికం"]
}, WFe = {
  narrow: ["జ", "ఫి", "మా", "ఏ", "మే", "జూ", "జు", "ఆ", "సె", "అ", "న", "డి"],
  abbreviated: ["జన", "ఫిబ్ర", "మార్చి", "ఏప్రి", "మే", "జూన్", "జులై", "ఆగ", "సెప్టెం", "అక్టో", "నవం", "డిసెం"],
  wide: ["జనవరి", "ఫిబ్రవరి", "మార్చి", "ఏప్రిల్", "మే", "జూన్", "జులై", "ఆగస్టు", "సెప్టెంబర్", "అక్టోబర్", "నవంబర్", "డిసెంబర్"]
}, jFe = {
  narrow: ["ఆ", "సో", "మ", "బు", "గు", "శు", "శ"],
  short: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
  abbreviated: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
  wide: ["ఆదివారం", "సోమవారం", "మంగళవారం", "బుధవారం", "గురువారం", "శుక్రవారం", "శనివారం"]
}, zFe = {
  narrow: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  abbreviated: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  wide: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  }
}, LFe = {
  narrow: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  abbreviated: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  wide: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  }
}, IFe = function(e, t) {
  var n = Number(e);
  return n + "వ";
}, FFe = {
  ordinalNumber: IFe,
  era: R({
    values: DFe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: NFe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: WFe,
    defaultWidth: "wide"
  }),
  day: R({
    values: jFe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: zFe,
    defaultWidth: "wide",
    formattingValues: LFe,
    defaultFormattingWidth: "wide"
  })
};
const HFe = FFe;
var VFe = /^(\d+)(వ)?/i, BFe = /\d+/i, UFe = {
  narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
  abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
  wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
}, XFe = {
  any: [/^(పూ|శ)/i, /^సా/i]
}, qFe = {
  narrow: /^[1234]/i,
  abbreviated: /^త్రై[1234]/i,
  wide: /^[1234](వ)? త్రైమాసికం/i
}, YFe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, GFe = {
  narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
  abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
  wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
}, QFe = {
  narrow: [/^జ/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూ/i, /^జు/i, /^ఆ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i],
  any: [/^జన/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూన్/i, /^జులై/i, /^ఆగ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i]
}, KFe = {
  narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
  short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
}, JFe = {
  narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
  any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i]
}, ZFe = {
  narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
  any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
}, eHe = {
  any: {
    am: /^పూర్వాహ్నం/i,
    pm: /^అపరాహ్నం/i,
    midnight: /^అర్ధ/i,
    noon: /^మిట్ట/i,
    morning: /ఉదయం/i,
    afternoon: /మధ్యాహ్నం/i,
    evening: /సాయంత్రం/i,
    night: /రాత్రి/i
  }
}, tHe = {
  ordinalNumber: at({
    matchPattern: VFe,
    parsePattern: BFe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: UFe,
    defaultMatchWidth: "wide",
    parsePatterns: XFe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: qFe,
    defaultMatchWidth: "wide",
    parsePatterns: YFe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: GFe,
    defaultMatchWidth: "wide",
    parsePatterns: QFe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: KFe,
    defaultMatchWidth: "wide",
    parsePatterns: JFe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: ZFe,
    defaultMatchWidth: "any",
    parsePatterns: eHe,
    defaultParseWidth: "any"
  })
};
const nHe = tHe;
var rHe = {
  code: "te",
  formatDistance: xFe,
  formatLong: _Fe,
  formatRelative: RFe,
  localize: HFe,
  match: nHe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const aHe = rHe;
var iHe = {
  lessThanXSeconds: {
    one: "น้อยกว่า 1 วินาที",
    other: "น้อยกว่า {{count}} วินาที"
  },
  xSeconds: {
    one: "1 วินาที",
    other: "{{count}} วินาที"
  },
  halfAMinute: "ครึ่งนาที",
  lessThanXMinutes: {
    one: "น้อยกว่า 1 นาที",
    other: "น้อยกว่า {{count}} นาที"
  },
  xMinutes: {
    one: "1 นาที",
    other: "{{count}} นาที"
  },
  aboutXHours: {
    one: "ประมาณ 1 ชั่วโมง",
    other: "ประมาณ {{count}} ชั่วโมง"
  },
  xHours: {
    one: "1 ชั่วโมง",
    other: "{{count}} ชั่วโมง"
  },
  xDays: {
    one: "1 วัน",
    other: "{{count}} วัน"
  },
  aboutXWeeks: {
    one: "ประมาณ 1 สัปดาห์",
    other: "ประมาณ {{count}} สัปดาห์"
  },
  xWeeks: {
    one: "1 สัปดาห์",
    other: "{{count}} สัปดาห์"
  },
  aboutXMonths: {
    one: "ประมาณ 1 เดือน",
    other: "ประมาณ {{count}} เดือน"
  },
  xMonths: {
    one: "1 เดือน",
    other: "{{count}} เดือน"
  },
  aboutXYears: {
    one: "ประมาณ 1 ปี",
    other: "ประมาณ {{count}} ปี"
  },
  xYears: {
    one: "1 ปี",
    other: "{{count}} ปี"
  },
  overXYears: {
    one: "มากกว่า 1 ปี",
    other: "มากกว่า {{count}} ปี"
  },
  almostXYears: {
    one: "เกือบ 1 ปี",
    other: "เกือบ {{count}} ปี"
  }
}, oHe = function(e, t, n) {
  var r, s = iHe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? e === "halfAMinute" ? "ใน" + r : "ใน " + r : r + "ที่ผ่านมา" : r;
};
const sHe = oHe;
var lHe = {
  full: "วันEEEEที่ do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, uHe = {
  full: "H:mm:ss น. zzzz",
  long: "H:mm:ss น. z",
  medium: "H:mm:ss น.",
  short: "H:mm น."
}, cHe = {
  full: "{{date}} 'เวลา' {{time}}",
  long: "{{date}} 'เวลา' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dHe = {
  date: Q({
    formats: lHe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: uHe,
    defaultWidth: "medium"
  }),
  dateTime: Q({
    formats: cHe,
    defaultWidth: "full"
  })
};
const fHe = dHe;
var mHe = {
  lastWeek: "eeee'ที่แล้วเวลา' p",
  yesterday: "'เมื่อวานนี้เวลา' p",
  today: "'วันนี้เวลา' p",
  tomorrow: "'พรุ่งนี้เวลา' p",
  nextWeek: "eeee 'เวลา' p",
  other: "P"
}, hHe = function(e, t, n, r) {
  return mHe[e];
};
const pHe = hHe;
var vHe = {
  narrow: ["B", "คศ"],
  abbreviated: ["BC", "ค.ศ."],
  wide: ["ปีก่อนคริสตกาล", "คริสต์ศักราช"]
}, gHe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["ไตรมาสแรก", "ไตรมาสที่สอง", "ไตรมาสที่สาม", "ไตรมาสที่สี่"]
}, yHe = {
  narrow: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  abbreviated: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  wide: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"]
}, bHe = {
  narrow: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
  abbreviated: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
  wide: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
}, wHe = {
  narrow: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  },
  abbreviated: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  },
  wide: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  }
}, PHe = {
  narrow: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  },
  abbreviated: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  },
  wide: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  }
}, kHe = function(e, t) {
  return String(e);
}, $He = {
  ordinalNumber: kHe,
  era: R({
    values: vHe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: gHe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: bHe,
    defaultWidth: "wide"
  }),
  day: R({
    values: yHe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: wHe,
    defaultWidth: "wide",
    formattingValues: PHe,
    defaultFormattingWidth: "wide"
  })
};
const SHe = $He;
var xHe = /^\d+/i, CHe = /\d+/i, MHe = {
  narrow: /^([bB]|[aA]|คศ)/i,
  abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
  wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
}, EHe = {
  any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
}, AHe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^ไตรมาส(ที่)? ?[1234]/i
}, _He = {
  any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
}, OHe = {
  narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
  abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
  wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
}, THe = {
  wide: [/^มก/i, /^กุม/i, /^มี/i, /^เม/i, /^พฤษ/i, /^มิ/i, /^กรก/i, /^ส/i, /^กัน/i, /^ต/i, /^พฤศ/i, /^ธ/i],
  any: [/^ม\.?ค\.?/i, /^ก\.?พ\.?/i, /^มี\.?ค\.?/i, /^เม\.?ย\.?/i, /^พ\.?ค\.?/i, /^มิ\.?ย\.?/i, /^ก\.?ค\.?/i, /^ส\.?ค\.?/i, /^ก\.?ย\.?/i, /^ต\.?ค\.?/i, /^พ\.?ย\.?/i, /^ธ\.?ค\.?/i]
}, RHe = {
  narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
}, DHe = {
  wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
  any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
}, NHe = {
  any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
}, WHe = {
  any: {
    am: /^ก่อนเที่ยง/i,
    pm: /^หลังเที่ยง/i,
    midnight: /^เที่ยงคืน/i,
    noon: /^เที่ยง/i,
    morning: /เช้า/i,
    afternoon: /บ่าย/i,
    evening: /เย็น/i,
    night: /กลางคืน/i
  }
}, jHe = {
  ordinalNumber: at({
    matchPattern: xHe,
    parsePattern: CHe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: MHe,
    defaultMatchWidth: "wide",
    parsePatterns: EHe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: AHe,
    defaultMatchWidth: "wide",
    parsePatterns: _He,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: OHe,
    defaultMatchWidth: "wide",
    parsePatterns: THe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: RHe,
    defaultMatchWidth: "wide",
    parsePatterns: DHe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: NHe,
    defaultMatchWidth: "any",
    parsePatterns: WHe,
    defaultParseWidth: "any"
  })
};
const zHe = jHe;
var LHe = {
  code: "th",
  formatDistance: sHe,
  formatLong: fHe,
  formatRelative: pHe,
  localize: SHe,
  match: zHe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const IHe = LHe;
var FHe = {
  lessThanXSeconds: {
    one: "bir saniyeden az",
    other: "{{count}} saniyeden az"
  },
  xSeconds: {
    one: "1 saniye",
    other: "{{count}} saniye"
  },
  halfAMinute: "yarım dakika",
  lessThanXMinutes: {
    one: "bir dakikadan az",
    other: "{{count}} dakikadan az"
  },
  xMinutes: {
    one: "1 dakika",
    other: "{{count}} dakika"
  },
  aboutXHours: {
    one: "yaklaşık 1 saat",
    other: "yaklaşık {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "yaklaşık 1 hafta",
    other: "yaklaşık {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "yaklaşık 1 ay",
    other: "yaklaşık {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "yaklaşık 1 yıl",
    other: "yaklaşık {{count}} yıl"
  },
  xYears: {
    one: "1 yıl",
    other: "{{count}} yıl"
  },
  overXYears: {
    one: "1 yıldan fazla",
    other: "{{count}} yıldan fazla"
  },
  almostXYears: {
    one: "neredeyse 1 yıl",
    other: "neredeyse {{count}} yıl"
  }
}, HHe = function(e, t, n) {
  var r, s = FHe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " sonra" : r + " önce" : r;
};
const VHe = HHe;
var BHe = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy"
}, UHe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, XHe = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, qHe = {
  date: Q({
    formats: BHe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: UHe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: XHe,
    defaultWidth: "full"
  })
};
const YHe = qHe;
var GHe = {
  lastWeek: "'geçen hafta' eeee 'saat' p",
  yesterday: "'dün saat' p",
  today: "'bugün saat' p",
  tomorrow: "'yarın saat' p",
  nextWeek: "eeee 'saat' p",
  other: "P"
}, QHe = function(e, t, n, r) {
  return GHe[e];
};
const KHe = QHe;
var JHe = {
  narrow: ["MÖ", "MS"],
  abbreviated: ["MÖ", "MS"],
  wide: ["Milattan Önce", "Milattan Sonra"]
}, ZHe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1Ç", "2Ç", "3Ç", "4Ç"],
  wide: ["İlk çeyrek", "İkinci Çeyrek", "Üçüncü çeyrek", "Son çeyrek"]
}, eVe = {
  narrow: ["O", "Ş", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
  wide: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"]
}, tVe = {
  narrow: ["P", "P", "S", "Ç", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cts"],
  wide: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"]
}, nVe = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  },
  wide: {
    am: "Ö.Ö.",
    pm: "Ö.S.",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  }
}, rVe = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  },
  wide: {
    am: "ö.ö.",
    pm: "ö.s.",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  }
}, aVe = function(e, t) {
  var n = Number(e);
  return n + ".";
}, iVe = {
  ordinalNumber: aVe,
  era: R({
    values: JHe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: ZHe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return Number(e) - 1;
    }
  }),
  month: R({
    values: eVe,
    defaultWidth: "wide"
  }),
  day: R({
    values: tVe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: nVe,
    defaultWidth: "wide",
    formattingValues: rVe,
    defaultFormattingWidth: "wide"
  })
};
const oVe = iVe;
var sVe = /^(\d+)(\.)?/i, lVe = /\d+/i, uVe = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
}, cVe = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
}, dVe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
}, fVe = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
}, mVe = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
}, hVe = {
  narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
  any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
}, pVe = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
}, vVe = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [/^pazar(?!tesi)/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma(?!rtesi)/i, /^cumartesi/i]
}, gVe = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
}, yVe = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
}, bVe = {
  ordinalNumber: at({
    matchPattern: sVe,
    parsePattern: lVe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: uVe,
    defaultMatchWidth: "wide",
    parsePatterns: cVe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: dVe,
    defaultMatchWidth: "wide",
    parsePatterns: fVe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: mVe,
    defaultMatchWidth: "wide",
    parsePatterns: hVe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: pVe,
    defaultMatchWidth: "wide",
    parsePatterns: vVe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: gVe,
    defaultMatchWidth: "any",
    parsePatterns: yVe,
    defaultParseWidth: "any"
  })
};
const wVe = bVe;
var PVe = {
  code: "tr",
  formatDistance: VHe,
  formatLong: YHe,
  formatRelative: KHe,
  localize: oVe,
  match: wVe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const kVe = PVe;
var $Ve = {
  lessThanXSeconds: {
    one: "بىر سىكۇنت ئىچىدە",
    other: "سىكۇنت ئىچىدە {{count}}"
  },
  xSeconds: {
    one: "بىر سىكۇنت",
    other: "سىكۇنت {{count}}"
  },
  halfAMinute: "يىرىم مىنۇت",
  lessThanXMinutes: {
    one: "بىر مىنۇت ئىچىدە",
    other: "مىنۇت ئىچىدە {{count}}"
  },
  xMinutes: {
    one: "بىر مىنۇت",
    other: "مىنۇت {{count}}"
  },
  aboutXHours: {
    one: "تەخمىنەن بىر سائەت",
    other: "سائەت {{count}} تەخمىنەن"
  },
  xHours: {
    one: "بىر سائەت",
    other: "سائەت {{count}}"
  },
  xDays: {
    one: "بىر كۈن",
    other: "كۈن {{count}}"
  },
  aboutXWeeks: {
    one: "تەخمىنەن بىرھەپتە",
    other: "ھەپتە {{count}} تەخمىنەن"
  },
  xWeeks: {
    one: "بىرھەپتە",
    other: "ھەپتە {{count}}"
  },
  aboutXMonths: {
    one: "تەخمىنەن بىر ئاي",
    other: "ئاي {{count}} تەخمىنەن"
  },
  xMonths: {
    one: "بىر ئاي",
    other: "ئاي {{count}}"
  },
  aboutXYears: {
    one: "تەخمىنەن بىر يىل",
    other: "يىل {{count}} تەخمىنەن"
  },
  xYears: {
    one: "بىر يىل",
    other: "يىل {{count}}"
  },
  overXYears: {
    one: "بىر يىلدىن ئارتۇق",
    other: "يىلدىن ئارتۇق {{count}}"
  },
  almostXYears: {
    one: "ئاساسەن بىر يىل",
    other: "يىل {{count}} ئاساسەن"
  }
}, SVe = function(e, t, n) {
  var r, s = $Ve[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r : r + " بولدى" : r;
};
const xVe = SVe;
var CVe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, MVe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, EVe = {
  full: "{{date}} 'دە' {{time}}",
  long: "{{date}} 'دە' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, AVe = {
  date: Q({
    formats: CVe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: MVe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: EVe,
    defaultWidth: "full"
  })
};
const _Ve = AVe;
var OVe = {
  lastWeek: "'ئ‍ۆتكەن' eeee 'دە' p",
  yesterday: "'تۈنۈگۈن دە' p",
  today: "'بۈگۈن دە' p",
  tomorrow: "'ئەتە دە' p",
  nextWeek: "eeee 'دە' p",
  other: "P"
}, TVe = function(e, t, n, r) {
  return OVe[e];
};
const RVe = TVe;
var DVe = {
  narrow: ["ب", "ك"],
  abbreviated: ["ب", "ك"],
  wide: ["مىيلادىدىن بۇرۇن", "مىيلادىدىن كىيىن"]
}, NVe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1", "2", "3", "4"],
  wide: ["بىرىنجى چارەك", "ئىككىنجى چارەك", "ئۈچىنجى چارەك", "تۆتىنجى چارەك"]
}, WVe = {
  narrow: ["ي", "ف", "م", "ا", "م", "ى", "ى", "ا", "س", "ۆ", "ن", "د"],
  abbreviated: ["يانۋار", "فېۋىرال", "مارت", "ئاپرىل", "ماي", "ئىيۇن", "ئىيول", "ئاۋغۇست", "سىنتەبىر", "ئۆكتەبىر", "نويابىر", "دىكابىر"],
  wide: ["يانۋار", "فېۋىرال", "مارت", "ئاپرىل", "ماي", "ئىيۇن", "ئىيول", "ئاۋغۇست", "سىنتەبىر", "ئۆكتەبىر", "نويابىر", "دىكابىر"]
}, jVe = {
  narrow: ["ي", "د", "س", "چ", "پ", "ج", "ش"],
  short: ["ي", "د", "س", "چ", "پ", "ج", "ش"],
  abbreviated: ["يەكشەنبە", "دۈشەنبە", "سەيشەنبە", "چارشەنبە", "پەيشەنبە", "جۈمە", "شەنبە"],
  wide: ["يەكشەنبە", "دۈشەنبە", "سەيشەنبە", "چارشەنبە", "پەيشەنبە", "جۈمە", "شەنبە"]
}, zVe = {
  narrow: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە"
  },
  abbreviated: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە"
  },
  wide: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە"
  }
}, LVe = {
  narrow: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە"
  },
  abbreviated: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە"
  },
  wide: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە"
  }
}, IVe = function(e, t) {
  return String(e);
}, FVe = {
  ordinalNumber: IVe,
  era: R({
    values: DVe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: NVe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: WVe,
    defaultWidth: "wide"
  }),
  day: R({
    values: jVe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: zVe,
    defaultWidth: "wide",
    formattingValues: LVe,
    defaultFormattingWidth: "wide"
  })
};
const HVe = FVe;
var VVe = /^(\d+)(th|st|nd|rd)?/i, BVe = /\d+/i, UVe = {
  narrow: /^(ب|ك)/i,
  wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
}, XVe = {
  any: [/^بۇرۇن/i, /^كىيىن/i]
}, qVe = {
  narrow: /^[1234]/i,
  abbreviated: /^چ[1234]/i,
  wide: /^چارەك [1234]/i
}, YVe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, GVe = {
  narrow: /^[يفمئامئ‍ئاسۆند]/i,
  abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
  wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
}, QVe = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^ا/i, /^م/i, /^ى‍/i, /^ى‍/i, /^ا‍/i, /^س/i, /^ۆ/i, /^ن/i, /^د/i],
  any: [/^يان/i, /^فېۋ/i, /^مار/i, /^ئاپ/i, /^ماي/i, /^ئىيۇن/i, /^ئىيول/i, /^ئاۋ/i, /^سىن/i, /^ئۆك/i, /^نوي/i, /^دىك/i]
}, KVe = {
  narrow: /^[دسچپجشي]/i,
  short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
  abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
  wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
}, JVe = {
  narrow: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i]
}, ZVe = {
  narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
  any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
}, eBe = {
  any: {
    am: /^ئە/i,
    pm: /^چ/i,
    midnight: /^ك/i,
    noon: /^چ/i,
    morning: /ئەتىگەن/i,
    afternoon: /چۈشتىن كىيىن/i,
    evening: /ئاخشىم/i,
    night: /كىچە/i
  }
}, tBe = {
  ordinalNumber: at({
    matchPattern: VVe,
    parsePattern: BVe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: UVe,
    defaultMatchWidth: "wide",
    parsePatterns: XVe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: qVe,
    defaultMatchWidth: "wide",
    parsePatterns: YVe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: GVe,
    defaultMatchWidth: "wide",
    parsePatterns: QVe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: KVe,
    defaultMatchWidth: "wide",
    parsePatterns: JVe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: ZVe,
    defaultMatchWidth: "any",
    parsePatterns: eBe,
    defaultParseWidth: "any"
  })
};
const nBe = tBe;
var rBe = {
  code: "ug",
  formatDistance: xVe,
  formatLong: _Ve,
  formatRelative: RVe,
  localize: HVe,
  match: nBe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const aBe = rBe;
function Ov(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  var n = t % 10, r = t % 100;
  return n === 1 && r !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function po(e) {
  return function(t, n) {
    return n && n.addSuffix ? n.comparison && n.comparison > 0 ? e.future ? Ov(e.future, t) : "за " + Ov(e.regular, t) : e.past ? Ov(e.past, t) : Ov(e.regular, t) + " тому" : Ov(e.regular, t);
  };
}
var iBe = function(e, t) {
  return t && t.addSuffix ? t.comparison && t.comparison > 0 ? "за півхвилини" : "півхвилини тому" : "півхвилини";
}, oBe = {
  lessThanXSeconds: po({
    regular: {
      one: "менше секунди",
      singularNominative: "менше {{count}} секунди",
      singularGenitive: "менше {{count}} секунд",
      pluralGenitive: "менше {{count}} секунд"
    },
    future: {
      one: "менше, ніж за секунду",
      singularNominative: "менше, ніж за {{count}} секунду",
      singularGenitive: "менше, ніж за {{count}} секунди",
      pluralGenitive: "менше, ніж за {{count}} секунд"
    }
  }),
  xSeconds: po({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунди",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду тому",
      singularGenitive: "{{count}} секунди тому",
      pluralGenitive: "{{count}} секунд тому"
    },
    future: {
      singularNominative: "за {{count}} секунду",
      singularGenitive: "за {{count}} секунди",
      pluralGenitive: "за {{count}} секунд"
    }
  }),
  halfAMinute: iBe,
  lessThanXMinutes: po({
    regular: {
      one: "менше хвилини",
      singularNominative: "менше {{count}} хвилини",
      singularGenitive: "менше {{count}} хвилин",
      pluralGenitive: "менше {{count}} хвилин"
    },
    future: {
      one: "менше, ніж за хвилину",
      singularNominative: "менше, ніж за {{count}} хвилину",
      singularGenitive: "менше, ніж за {{count}} хвилини",
      pluralGenitive: "менше, ніж за {{count}} хвилин"
    }
  }),
  xMinutes: po({
    regular: {
      singularNominative: "{{count}} хвилина",
      singularGenitive: "{{count}} хвилини",
      pluralGenitive: "{{count}} хвилин"
    },
    past: {
      singularNominative: "{{count}} хвилину тому",
      singularGenitive: "{{count}} хвилини тому",
      pluralGenitive: "{{count}} хвилин тому"
    },
    future: {
      singularNominative: "за {{count}} хвилину",
      singularGenitive: "за {{count}} хвилини",
      pluralGenitive: "за {{count}} хвилин"
    }
  }),
  aboutXHours: po({
    regular: {
      singularNominative: "близько {{count}} години",
      singularGenitive: "близько {{count}} годин",
      pluralGenitive: "близько {{count}} годин"
    },
    future: {
      singularNominative: "приблизно за {{count}} годину",
      singularGenitive: "приблизно за {{count}} години",
      pluralGenitive: "приблизно за {{count}} годин"
    }
  }),
  xHours: po({
    regular: {
      singularNominative: "{{count}} годину",
      singularGenitive: "{{count}} години",
      pluralGenitive: "{{count}} годин"
    }
  }),
  xDays: po({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} днів"
    }
  }),
  aboutXWeeks: po({
    regular: {
      singularNominative: "близько {{count}} тижня",
      singularGenitive: "близько {{count}} тижнів",
      pluralGenitive: "близько {{count}} тижнів"
    },
    future: {
      singularNominative: "приблизно за {{count}} тиждень",
      singularGenitive: "приблизно за {{count}} тижні",
      pluralGenitive: "приблизно за {{count}} тижні"
    }
  }),
  xWeeks: po({
    regular: {
      singularNominative: "{{count}} тиждень",
      singularGenitive: "{{count}} тижня",
      pluralGenitive: "{{count}} тижні"
    }
  }),
  aboutXMonths: po({
    regular: {
      singularNominative: "близько {{count}} місяця",
      singularGenitive: "близько {{count}} місяців",
      pluralGenitive: "близько {{count}} місяців"
    },
    future: {
      singularNominative: "приблизно за {{count}} місяць",
      singularGenitive: "приблизно за {{count}} місяця",
      pluralGenitive: "приблизно за {{count}} місяців"
    }
  }),
  xMonths: po({
    regular: {
      singularNominative: "{{count}} місяць",
      singularGenitive: "{{count}} місяця",
      pluralGenitive: "{{count}} місяців"
    }
  }),
  aboutXYears: po({
    regular: {
      singularNominative: "близько {{count}} року",
      singularGenitive: "близько {{count}} років",
      pluralGenitive: "близько {{count}} років"
    },
    future: {
      singularNominative: "приблизно за {{count}} рік",
      singularGenitive: "приблизно за {{count}} роки",
      pluralGenitive: "приблизно за {{count}} років"
    }
  }),
  xYears: po({
    regular: {
      singularNominative: "{{count}} рік",
      singularGenitive: "{{count}} роки",
      pluralGenitive: "{{count}} років"
    }
  }),
  overXYears: po({
    regular: {
      singularNominative: "більше {{count}} року",
      singularGenitive: "більше {{count}} років",
      pluralGenitive: "більше {{count}} років"
    },
    future: {
      singularNominative: "більше, ніж за {{count}} рік",
      singularGenitive: "більше, ніж за {{count}} роки",
      pluralGenitive: "більше, ніж за {{count}} років"
    }
  }),
  almostXYears: po({
    regular: {
      singularNominative: "майже {{count}} рік",
      singularGenitive: "майже {{count}} роки",
      pluralGenitive: "майже {{count}} років"
    },
    future: {
      singularNominative: "майже за {{count}} рік",
      singularGenitive: "майже за {{count}} роки",
      pluralGenitive: "майже за {{count}} років"
    }
  })
}, sBe = function(e, t, n) {
  return n = n || {}, oBe[e](t, n);
};
const lBe = sBe;
var uBe = {
  full: "EEEE, do MMMM y 'р.'",
  long: "do MMMM y 'р.'",
  medium: "d MMM y 'р.'",
  short: "dd.MM.y"
}, cBe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, dBe = {
  full: "{{date}} 'о' {{time}}",
  long: "{{date}} 'о' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, fBe = {
  date: Q({
    formats: uBe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: cBe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: dBe,
    defaultWidth: "full"
  })
};
const mBe = fBe;
var wx = ["неділю", "понеділок", "вівторок", "середу", "четвер", "п’ятницю", "суботу"];
function hBe(e) {
  var t = wx[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у минулу " + t + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у минулий " + t + " о' p";
  }
}
function SW(e) {
  var t = wx[e];
  return "'у " + t + " о' p";
}
function pBe(e) {
  var t = wx[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступну " + t + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у наступний " + t + " о' p";
  }
}
var vBe = function(e, t, n) {
  var r = Nr(e), s = r.getUTCDay();
  return ca(r, t, n) ? SW(s) : hBe(s);
}, gBe = function(e, t, n) {
  var r = Nr(e), s = r.getUTCDay();
  return ca(r, t, n) ? SW(s) : pBe(s);
}, yBe = {
  lastWeek: vBe,
  yesterday: "'вчора о' p",
  today: "'сьогодні о' p",
  tomorrow: "'завтра о' p",
  nextWeek: gBe,
  other: "P"
}, bBe = function(e, t, n, r) {
  var s = yBe[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const wBe = bBe;
var PBe = {
  narrow: ["до н.е.", "н.е."],
  abbreviated: ["до н. е.", "н. е."],
  wide: ["до нашої ери", "нашої ери"]
}, kBe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, $Be = {
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: ["січ.", "лют.", "берез.", "квіт.", "трав.", "черв.", "лип.", "серп.", "верес.", "жовт.", "листоп.", "груд."],
  wide: ["січень", "лютий", "березень", "квітень", "травень", "червень", "липень", "серпень", "вересень", "жовтень", "листопад", "грудень"]
}, SBe = {
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: ["січ.", "лют.", "берез.", "квіт.", "трав.", "черв.", "лип.", "серп.", "верес.", "жовт.", "листоп.", "груд."],
  wide: ["січня", "лютого", "березня", "квітня", "травня", "червня", "липня", "серпня", "вересня", "жовтня", "листопада", "грудня"]
}, xBe = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вів", "сер", "чтв", "птн", "суб"],
  wide: ["неділя", "понеділок", "вівторок", "середа", "четвер", "п’ятниця", "субота"]
}, CBe = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранок",
    afternoon: "день",
    evening: "вечір",
    night: "ніч"
  }
}, MBe = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  }
}, EBe = function(e, t) {
  var n = String(t == null ? void 0 : t.unit), r = Number(e), s;
  return n === "date" ? r === 3 || r === 23 ? s = "-є" : s = "-е" : n === "minute" || n === "second" || n === "hour" ? s = "-а" : s = "-й", r + s;
}, ABe = {
  ordinalNumber: EBe,
  era: R({
    values: PBe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: kBe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: $Be,
    defaultWidth: "wide",
    formattingValues: SBe,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: xBe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: CBe,
    defaultWidth: "any",
    formattingValues: MBe,
    defaultFormattingWidth: "wide"
  })
};
const _Be = ABe;
var OBe = /^(\d+)(-?(е|й|є|а|я))?/i, TBe = /\d+/i, RBe = {
  narrow: /^((до )?н\.?\s?е\.?)/i,
  abbreviated: /^((до )?н\.?\s?е\.?)/i,
  wide: /^(до нашої ери|нашої ери|наша ера)/i
}, DBe = {
  any: [/^д/i, /^н/i]
}, NBe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
  wide: /^[1234](-?[иі]?й?)? квартал/i
}, WBe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jBe = {
  narrow: /^[слбктчвжг]/i,
  abbreviated: /^(січ|лют|бер|берез|кві|трав?|чер|лип|сер|вер|жов|лис(топ)?|груд)\.?/i,
  wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопада?|грудень|грудня)/i
}, zBe = {
  narrow: [/^с/i, /^л/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^с/i, /^в/i, /^ж/i, /^л/i, /^г/i],
  any: [/^сі/i, /^лю/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^лип/i, /^се/i, /^в/i, /^ж/i, /^лис/i, /^г/i]
}, LBe = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
  abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
  wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
}, IBe = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
}, FBe = {
  narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
}, HBe = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^півн/i,
    noon: /^пол/i,
    morning: /^р/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, VBe = {
  ordinalNumber: at({
    matchPattern: OBe,
    parsePattern: TBe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: RBe,
    defaultMatchWidth: "wide",
    parsePatterns: DBe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: NBe,
    defaultMatchWidth: "wide",
    parsePatterns: WBe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: jBe,
    defaultMatchWidth: "wide",
    parsePatterns: zBe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: LBe,
    defaultMatchWidth: "wide",
    parsePatterns: IBe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: FBe,
    defaultMatchWidth: "wide",
    parsePatterns: HBe,
    defaultParseWidth: "any"
  })
};
const BBe = VBe;
var UBe = {
  code: "uk",
  formatDistance: lBe,
  formatLong: mBe,
  formatRelative: wBe,
  localize: _Be,
  match: BBe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const XBe = UBe;
var qBe = {
  lessThanXSeconds: {
    one: "sekunddan kam",
    other: "{{count}} sekunddan kam"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekund"
  },
  halfAMinute: "yarim minut",
  lessThanXMinutes: {
    one: "bir minutdan kam",
    other: "{{count}} minutdan kam"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minut"
  },
  aboutXHours: {
    one: "tahminan 1 soat",
    other: "tahminan {{count}} soat"
  },
  xHours: {
    one: "1 soat",
    other: "{{count}} soat"
  },
  xDays: {
    one: "1 kun",
    other: "{{count}} kun"
  },
  aboutXWeeks: {
    one: "tahminan 1 hafta",
    other: "tahminan {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "tahminan 1 oy",
    other: "tahminan {{count}} oy"
  },
  xMonths: {
    one: "1 oy",
    other: "{{count}} oy"
  },
  aboutXYears: {
    one: "tahminan 1 yil",
    other: "tahminan {{count}} yil"
  },
  xYears: {
    one: "1 yil",
    other: "{{count}} yil"
  },
  overXYears: {
    one: "1 yildan ko'p",
    other: "{{count}} yildan ko'p"
  },
  almostXYears: {
    one: "deyarli 1 yil",
    other: "deyarli {{count}} yil"
  }
}, YBe = function(e, t, n) {
  var r, s = qBe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " dan keyin" : r + " oldin" : r;
};
const GBe = YBe;
var QBe = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy"
}, KBe = {
  full: "h:mm:ss zzzz",
  long: "h:mm:ss z",
  medium: "h:mm:ss",
  short: "h:mm"
}, JBe = {
  any: "{{date}}, {{time}}"
}, ZBe = {
  date: Q({
    formats: QBe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: KBe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: JBe,
    defaultWidth: "any"
  })
};
const eUe = ZBe;
var tUe = {
  lastWeek: "'oldingi' eeee p 'da'",
  yesterday: "'kecha' p 'da'",
  today: "'bugun' p 'da'",
  tomorrow: "'ertaga' p 'da'",
  nextWeek: "eeee p 'da'",
  other: "P"
}, nUe = function(e, t, n, r) {
  return tUe[e];
};
const rUe = nUe;
var aUe = {
  narrow: ["M.A", "M."],
  abbreviated: ["M.A", "M."],
  wide: ["Miloddan Avvalgi", "Milodiy"]
}, iUe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["CH.1", "CH.2", "CH.3", "CH.4"],
  wide: ["1-chi chorak", "2-chi chorak", "3-chi chorak", "4-chi chorak"]
}, oUe = {
  narrow: ["Y", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: ["Yan", "Fev", "Mar", "Apr", "May", "Iyun", "Iyul", "Avg", "Sen", "Okt", "Noy", "Dek"],
  wide: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun", "Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr"]
}, sUe = {
  narrow: ["Y", "D", "S", "CH", "P", "J", "SH"],
  short: ["Ya", "Du", "Se", "Cho", "Pa", "Ju", "Sha"],
  abbreviated: ["Yak", "Dush", "Sesh", "Chor", "Pay", "Jum", "Shan"],
  wide: ["Yakshanba", "Dushanba", "Seshanba", "Chorshanba", "Payshanba", "Juma", "Shanba"]
}, lUe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "y.t",
    noon: "p.",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  }
}, uUe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "y.t",
    noon: "p.",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  }
}, cUe = function(e, t) {
  return String(e);
}, dUe = {
  ordinalNumber: cUe,
  era: R({
    values: aUe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: iUe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: oUe,
    defaultWidth: "wide"
  }),
  day: R({
    values: sUe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: lUe,
    defaultWidth: "wide",
    formattingValues: uUe,
    defaultFormattingWidth: "wide"
  })
};
const fUe = dUe;
var mUe = /^(\d+)(chi)?/i, hUe = /\d+/i, pUe = {
  narrow: /^(m\.a|m\.)/i,
  abbreviated: /^(m\.a\.?\s?m\.?)/i,
  wide: /^(miloddan avval|miloddan keyin)/i
}, vUe = {
  any: [/^b/i, /^(a|c)/i]
}, gUe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](chi)? chorak/i
}, yUe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, bUe = {
  narrow: /^[yfmasond]/i,
  abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
  wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
}, wUe = {
  narrow: [/^y/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ya/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^iyun/i, /^iyul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, PUe = {
  narrow: /^[ydschj]/i,
  short: /^(ya|du|se|cho|pa|ju|sha)/i,
  abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
  wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
}, kUe = {
  narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
  any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i]
}, $Ue = {
  narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
  any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
}, SUe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^y\.t/i,
    noon: /^pe/i,
    morning: /ertalab/i,
    afternoon: /tushdan keyin/i,
    evening: /kechqurun/i,
    night: /tun/i
  }
}, xUe = {
  ordinalNumber: at({
    matchPattern: mUe,
    parsePattern: hUe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: pUe,
    defaultMatchWidth: "wide",
    parsePatterns: vUe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: gUe,
    defaultMatchWidth: "wide",
    parsePatterns: yUe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: bUe,
    defaultMatchWidth: "wide",
    parsePatterns: wUe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: PUe,
    defaultMatchWidth: "wide",
    parsePatterns: kUe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: $Ue,
    defaultMatchWidth: "any",
    parsePatterns: SUe,
    defaultParseWidth: "any"
  })
};
const CUe = xUe;
var MUe = {
  code: "uz",
  formatDistance: GBe,
  formatLong: eUe,
  formatRelative: rUe,
  localize: fUe,
  match: CUe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const EUe = MUe;
var AUe = {
  lessThanXSeconds: {
    one: "1 сониядан кам",
    other: "{{count}} сониядан кам"
  },
  xSeconds: {
    one: "1 сония",
    other: "{{count}} сония"
  },
  halfAMinute: "ярим дақиқа",
  lessThanXMinutes: {
    one: "1 дақиқадан кам",
    other: "{{count}} дақиқадан кам"
  },
  xMinutes: {
    one: "1 дақиқа",
    other: "{{count}} дақиқа"
  },
  aboutXHours: {
    one: "тахминан 1 соат",
    other: "тахминан {{count}} соат"
  },
  xHours: {
    one: "1 соат",
    other: "{{count}} соат"
  },
  xDays: {
    one: "1 кун",
    other: "{{count}} кун"
  },
  aboutXWeeks: {
    one: "тахминан 1 хафта",
    other: "тахминан {{count}} хафта"
  },
  xWeeks: {
    one: "1 хафта",
    other: "{{count}} хафта"
  },
  aboutXMonths: {
    one: "тахминан 1 ой",
    other: "тахминан {{count}} ой"
  },
  xMonths: {
    one: "1 ой",
    other: "{{count}} ой"
  },
  aboutXYears: {
    one: "тахминан 1 йил",
    other: "тахминан {{count}} йил"
  },
  xYears: {
    one: "1 йил",
    other: "{{count}} йил"
  },
  overXYears: {
    one: "1 йилдан кўп",
    other: "{{count}} йилдан кўп"
  },
  almostXYears: {
    one: "деярли 1 йил",
    other: "деярли {{count}} йил"
  }
}, _Ue = function(e, t, n) {
  var r, s = AUe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + "дан кейин" : r + " олдин" : r;
};
const OUe = _Ue;
var TUe = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy"
}, RUe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, DUe = {
  any: "{{date}}, {{time}}"
}, NUe = {
  date: Q({
    formats: TUe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: RUe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: DUe,
    defaultWidth: "any"
  })
};
const WUe = NUe;
var jUe = {
  lastWeek: "'ўтган' eeee p 'да'",
  yesterday: "'кеча' p 'да'",
  today: "'бугун' p 'да'",
  tomorrow: "'эртага' p 'да'",
  nextWeek: "eeee p 'да'",
  other: "P"
}, zUe = function(e, t, n, r) {
  return jUe[e];
};
const LUe = zUe;
var IUe = {
  narrow: ["М.А", "М"],
  abbreviated: ["М.А", "М"],
  wide: ["Милоддан Аввалги", "Милодий"]
}, FUe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-чор.", "2-чор.", "3-чор.", "4-чор."],
  wide: ["1-чорак", "2-чорак", "3-чорак", "4-чорак"]
}, HUe = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"],
  wide: ["январ", "феврал", "март", "апрел", "май", "июн", "июл", "август", "сентабр", "октабр", "ноябр", "декабр"]
}, VUe = {
  narrow: ["Я", "Д", "С", "Ч", "П", "Ж", "Ш"],
  short: ["як", "ду", "се", "чо", "па", "жу", "ша"],
  abbreviated: ["якш", "душ", "сеш", "чор", "пай", "жум", "шан"],
  wide: ["якшанба", "душанба", "сешанба", "чоршанба", "пайшанба", "жума", "шанба"]
}, BUe = {
  any: {
    am: "П.О.",
    pm: "П.К.",
    midnight: "ярим тун",
    noon: "пешин",
    morning: "эрталаб",
    afternoon: "пешиндан кейин",
    evening: "кечаси",
    night: "тун"
  }
}, UUe = {
  any: {
    am: "П.О.",
    pm: "П.К.",
    midnight: "ярим тун",
    noon: "пешин",
    morning: "эрталаб",
    afternoon: "пешиндан кейин",
    evening: "кечаси",
    night: "тун"
  }
}, XUe = function(e, t) {
  return String(e);
}, qUe = {
  ordinalNumber: XUe,
  era: R({
    values: IUe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: FUe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: HUe,
    defaultWidth: "wide"
  }),
  day: R({
    values: VUe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: BUe,
    defaultWidth: "any",
    formattingValues: UUe,
    defaultFormattingWidth: "any"
  })
};
const YUe = qUe;
var GUe = /^(\d+)(чи)?/i, QUe = /\d+/i, KUe = {
  narrow: /^(м\.а|м\.)/i,
  abbreviated: /^(м\.а|м\.)/i,
  wide: /^(милоддан аввал|милоддан кейин)/i
}, JUe = {
  any: [/^м/i, /^а/i]
}, ZUe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-чор./i,
  wide: /^[1234]-чорак/i
}, eXe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, tXe = {
  narrow: /^[яфмамииасонд]/i,
  abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
  wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
}, nXe = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^д/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
}, rXe = {
  narrow: /^[ядсчпжш]/i,
  short: /^(як|ду|се|чо|па|жу|ша)/i,
  abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
  wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
}, aXe = {
  narrow: [/^я/i, /^д/i, /^с/i, /^ч/i, /^п/i, /^ж/i, /^ш/i],
  any: [/^як/i, /^ду/i, /^се/i, /^чор/i, /^пай/i, /^жу/i, /^шан/i]
}, iXe = {
  any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
}, oXe = {
  any: {
    am: /^п\.о\./i,
    pm: /^п\.к\./i,
    midnight: /^ярим тун/i,
    noon: /^пешиндан кейин/i,
    morning: /эрталаб/i,
    afternoon: /пешиндан кейин/i,
    evening: /кечаси/i,
    night: /тун/i
  }
}, sXe = {
  ordinalNumber: at({
    matchPattern: GUe,
    parsePattern: QUe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: KUe,
    defaultMatchWidth: "wide",
    parsePatterns: JUe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: ZUe,
    defaultMatchWidth: "wide",
    parsePatterns: eXe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: tXe,
    defaultMatchWidth: "wide",
    parsePatterns: nXe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: rXe,
    defaultMatchWidth: "wide",
    parsePatterns: aXe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: iXe,
    defaultMatchWidth: "any",
    parsePatterns: oXe,
    defaultParseWidth: "any"
  })
};
const lXe = sXe;
var uXe = {
  code: "uz-Cyrl",
  formatDistance: OUe,
  formatLong: WUe,
  formatRelative: LUe,
  localize: YUe,
  match: lXe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const cXe = uXe;
var dXe = {
  lessThanXSeconds: {
    one: "dưới 1 giây",
    other: "dưới {{count}} giây"
  },
  xSeconds: {
    one: "1 giây",
    other: "{{count}} giây"
  },
  halfAMinute: "nửa phút",
  lessThanXMinutes: {
    one: "dưới 1 phút",
    other: "dưới {{count}} phút"
  },
  xMinutes: {
    one: "1 phút",
    other: "{{count}} phút"
  },
  aboutXHours: {
    one: "khoảng 1 giờ",
    other: "khoảng {{count}} giờ"
  },
  xHours: {
    one: "1 giờ",
    other: "{{count}} giờ"
  },
  xDays: {
    one: "1 ngày",
    other: "{{count}} ngày"
  },
  aboutXWeeks: {
    one: "khoảng 1 tuần",
    other: "khoảng {{count}} tuần"
  },
  xWeeks: {
    one: "1 tuần",
    other: "{{count}} tuần"
  },
  aboutXMonths: {
    one: "khoảng 1 tháng",
    other: "khoảng {{count}} tháng"
  },
  xMonths: {
    one: "1 tháng",
    other: "{{count}} tháng"
  },
  aboutXYears: {
    one: "khoảng 1 năm",
    other: "khoảng {{count}} năm"
  },
  xYears: {
    one: "1 năm",
    other: "{{count}} năm"
  },
  overXYears: {
    one: "hơn 1 năm",
    other: "hơn {{count}} năm"
  },
  almostXYears: {
    one: "gần 1 năm",
    other: "gần {{count}} năm"
  }
}, fXe = function(e, t, n) {
  var r, s = dXe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " nữa" : r + " trước" : r;
};
const mXe = fXe;
var hXe = {
  full: "EEEE, 'ngày' d MMMM 'năm' y",
  long: "'ngày' d MMMM 'năm' y",
  medium: "d MMM 'năm' y",
  short: "dd/MM/y"
}, pXe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, vXe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, gXe = {
  date: Q({
    formats: hXe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: pXe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: vXe,
    defaultWidth: "full"
  })
};
const yXe = gXe;
var bXe = {
  lastWeek: "eeee 'tuần trước vào lúc' p",
  yesterday: "'hôm qua vào lúc' p",
  today: "'hôm nay vào lúc' p",
  tomorrow: "'ngày mai vào lúc' p",
  nextWeek: "eeee 'tới vào lúc' p",
  other: "P"
}, wXe = function(e, t, n, r) {
  return bXe[e];
};
const PXe = wXe;
var kXe = {
  narrow: ["TCN", "SCN"],
  abbreviated: ["trước CN", "sau CN"],
  wide: ["trước Công Nguyên", "sau Công Nguyên"]
}, $Xe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["Quý 1", "Quý 2", "Quý 3", "Quý 4"]
}, SXe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["quý I", "quý II", "quý III", "quý IV"]
}, xXe = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["Thg 1", "Thg 2", "Thg 3", "Thg 4", "Thg 5", "Thg 6", "Thg 7", "Thg 8", "Thg 9", "Thg 10", "Thg 11", "Thg 12"],
  wide: ["Tháng Một", "Tháng Hai", "Tháng Ba", "Tháng Tư", "Tháng Năm", "Tháng Sáu", "Tháng Bảy", "Tháng Tám", "Tháng Chín", "Tháng Mười", "Tháng Mười Một", "Tháng Mười Hai"]
}, CXe = {
  narrow: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
  abbreviated: ["thg 1", "thg 2", "thg 3", "thg 4", "thg 5", "thg 6", "thg 7", "thg 8", "thg 9", "thg 10", "thg 11", "thg 12"],
  wide: ["tháng 01", "tháng 02", "tháng 03", "tháng 04", "tháng 05", "tháng 06", "tháng 07", "tháng 08", "tháng 09", "tháng 10", "tháng 11", "tháng 12"]
}, MXe = {
  narrow: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  short: ["CN", "Th 2", "Th 3", "Th 4", "Th 5", "Th 6", "Th 7"],
  abbreviated: ["CN", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"],
  wide: ["Chủ Nhật", "Thứ Hai", "Thứ Ba", "Thứ Tư", "Thứ Năm", "Thứ Sáu", "Thứ Bảy"]
}, EXe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "nửa đêm",
    noon: "tr",
    morning: "sg",
    afternoon: "ch",
    evening: "tối",
    night: "đêm"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  },
  wide: {
    am: "SA",
    pm: "CH",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  }
}, AXe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "nửa đêm",
    noon: "tr",
    morning: "sg",
    afternoon: "ch",
    evening: "tối",
    night: "đêm"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  },
  wide: {
    am: "SA",
    pm: "CH",
    midnight: "nửa đêm",
    noon: "giữa trưa",
    morning: "vào buổi sáng",
    afternoon: "vào buổi chiều",
    evening: "vào buổi tối",
    night: "vào ban đêm"
  }
}, _Xe = function(e, t) {
  var n = Number(e), r = t == null ? void 0 : t.unit;
  if (r === "quarter")
    switch (n) {
      case 1:
        return "I";
      case 2:
        return "II";
      case 3:
        return "III";
      case 4:
        return "IV";
    }
  else if (r === "day")
    switch (n) {
      case 1:
        return "thứ 2";
      case 2:
        return "thứ 3";
      case 3:
        return "thứ 4";
      case 4:
        return "thứ 5";
      case 5:
        return "thứ 6";
      case 6:
        return "thứ 7";
      case 7:
        return "chủ nhật";
    }
  else {
    if (r === "week")
      return n === 1 ? "thứ nhất" : "thứ " + n;
    if (r === "dayOfYear")
      return n === 1 ? "đầu tiên" : "thứ " + n;
  }
  return String(n);
}, OXe = {
  ordinalNumber: _Xe,
  era: R({
    values: kXe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: $Xe,
    defaultWidth: "wide",
    formattingValues: SXe,
    defaultFormattingWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: xXe,
    defaultWidth: "wide",
    formattingValues: CXe,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: MXe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: EXe,
    defaultWidth: "wide",
    formattingValues: AXe,
    defaultFormattingWidth: "wide"
  })
};
const TXe = OXe;
var RXe = /^(\d+)/i, DXe = /\d+/i, NXe = {
  narrow: /^(tcn|scn)/i,
  abbreviated: /^(trước CN|sau CN)/i,
  wide: /^(trước Công Nguyên|sau Công Nguyên)/i
}, WXe = {
  any: [/^t/i, /^s/i]
}, jXe = {
  narrow: /^([1234]|i{1,3}v?)/i,
  abbreviated: /^q([1234]|i{1,3}v?)/i,
  wide: /^quý ([1234]|i{1,3}v?)/i
}, zXe = {
  any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
}, LXe = {
  narrow: /^(0?[2-9]|10|11|12|0?1)/i,
  abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
  wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
}, IXe = {
  narrow: [/0?1$/i, /0?2/i, /3/, /4/, /5/, /6/, /7/, /8/, /9/, /10/, /11/, /12/],
  abbreviated: [/^thg[ _]?0?1(?!\d)/i, /^thg[ _]?0?2/i, /^thg[ _]?0?3/i, /^thg[ _]?0?4/i, /^thg[ _]?0?5/i, /^thg[ _]?0?6/i, /^thg[ _]?0?7/i, /^thg[ _]?0?8/i, /^thg[ _]?0?9/i, /^thg[ _]?10/i, /^thg[ _]?11/i, /^thg[ _]?12/i],
  wide: [/^tháng ?(Một|0?1(?!\d))/i, /^tháng ?(Hai|0?2)/i, /^tháng ?(Ba|0?3)/i, /^tháng ?(Tư|0?4)/i, /^tháng ?(Năm|0?5)/i, /^tháng ?(Sáu|0?6)/i, /^tháng ?(Bảy|0?7)/i, /^tháng ?(Tám|0?8)/i, /^tháng ?(Chín|0?9)/i, /^tháng ?(Mười|10)/i, /^tháng ?(Mười ?Một|11)/i, /^tháng ?(Mười ?Hai|12)/i]
}, FXe = {
  narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
  short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
}, HXe = {
  narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
}, VXe = {
  narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
}, BXe = {
  any: {
    am: /^(a|sa)/i,
    pm: /^(p|ch[^i]*)/i,
    midnight: /nửa đêm/i,
    noon: /trưa/i,
    morning: /sáng/i,
    afternoon: /chiều/i,
    evening: /tối/i,
    night: /^đêm/i
  }
}, UXe = {
  ordinalNumber: at({
    matchPattern: RXe,
    parsePattern: DXe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: NXe,
    defaultMatchWidth: "wide",
    parsePatterns: WXe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: jXe,
    defaultMatchWidth: "wide",
    parsePatterns: zXe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: LXe,
    defaultMatchWidth: "wide",
    parsePatterns: IXe,
    defaultParseWidth: "wide"
  }),
  day: D({
    matchPatterns: FXe,
    defaultMatchWidth: "wide",
    parsePatterns: HXe,
    defaultParseWidth: "wide"
  }),
  dayPeriod: D({
    matchPatterns: VXe,
    defaultMatchWidth: "wide",
    parsePatterns: BXe,
    defaultParseWidth: "any"
  })
};
const XXe = UXe;
var qXe = {
  code: "vi",
  formatDistance: mXe,
  formatLong: yXe,
  formatRelative: PXe,
  localize: TXe,
  match: XXe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const YXe = qXe;
var GXe = {
  lessThanXSeconds: {
    one: "不到 1 秒",
    other: "不到 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分钟",
  lessThanXMinutes: {
    one: "不到 1 分钟",
    other: "不到 {{count}} 分钟"
  },
  xMinutes: {
    one: "1 分钟",
    other: "{{count}} 分钟"
  },
  xHours: {
    one: "1 小时",
    other: "{{count}} 小时"
  },
  aboutXHours: {
    one: "大约 1 小时",
    other: "大约 {{count}} 小时"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大约 1 个星期",
    other: "大约 {{count}} 个星期"
  },
  xWeeks: {
    one: "1 个星期",
    other: "{{count}} 个星期"
  },
  aboutXMonths: {
    one: "大约 1 个月",
    other: "大约 {{count}} 个月"
  },
  xMonths: {
    one: "1 个月",
    other: "{{count}} 个月"
  },
  aboutXYears: {
    one: "大约 1 年",
    other: "大约 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超过 1 年",
    other: "超过 {{count}} 年"
  },
  almostXYears: {
    one: "将近 1 年",
    other: "将近 {{count}} 年"
  }
}, QXe = function(e, t, n) {
  var r, s = GXe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + "内" : r + "前" : r;
};
const KXe = QXe;
var JXe = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, ZXe = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, eqe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, tqe = {
  date: Q({
    formats: JXe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: ZXe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: eqe,
    defaultWidth: "full"
  })
};
const nqe = tqe;
function GO(e, t, n) {
  var r = "eeee p";
  return ca(e, t, n) ? r : e.getTime() > t.getTime() ? "'下个'" + r : "'上个'" + r;
}
var rqe = {
  lastWeek: GO,
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: GO,
  other: "PP p"
}, aqe = function(e, t, n, r) {
  var s = rqe[e];
  return typeof s == "function" ? s(t, n, r) : s;
};
const iqe = aqe;
var oqe = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, sqe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"]
}, lqe = {
  narrow: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
  abbreviated: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  wide: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
}, uqe = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, cqe = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, dqe = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, fqe = function(e, t) {
  var n = Number(e);
  switch (t == null ? void 0 : t.unit) {
    case "date":
      return n.toString() + "日";
    case "hour":
      return n.toString() + "时";
    case "minute":
      return n.toString() + "分";
    case "second":
      return n.toString() + "秒";
    default:
      return "第 " + n.toString();
  }
}, mqe = {
  ordinalNumber: fqe,
  era: R({
    values: oqe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: sqe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: lqe,
    defaultWidth: "wide"
  }),
  day: R({
    values: uqe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: cqe,
    defaultWidth: "wide",
    formattingValues: dqe,
    defaultFormattingWidth: "wide"
  })
};
const hqe = mqe;
var pqe = /^(第\s*)?\d+(日|时|分|秒)?/i, vqe = /\d+/i, gqe = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, yqe = {
  any: [/^(前)/i, /^(公元)/i]
}, bqe = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻钟/i
}, wqe = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, Pqe = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, kqe = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
}, $qe = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^周[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, Sqe = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, xqe = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
}, Cqe = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, Mqe = {
  ordinalNumber: at({
    matchPattern: pqe,
    parsePattern: vqe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: gqe,
    defaultMatchWidth: "wide",
    parsePatterns: yqe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: bqe,
    defaultMatchWidth: "wide",
    parsePatterns: wqe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: Pqe,
    defaultMatchWidth: "wide",
    parsePatterns: kqe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: $qe,
    defaultMatchWidth: "wide",
    parsePatterns: Sqe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: xqe,
    defaultMatchWidth: "any",
    parsePatterns: Cqe,
    defaultParseWidth: "any"
  })
};
const Eqe = Mqe;
var Aqe = {
  code: "zh-CN",
  formatDistance: KXe,
  formatLong: nqe,
  formatRelative: iqe,
  localize: hqe,
  match: Eqe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const _qe = Aqe;
var Oqe = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分鐘",
  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘"
  },
  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘"
  },
  xHours: {
    one: "1 小時",
    other: "{{count}} 小時"
  },
  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期"
  },
  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期"
  },
  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月"
  },
  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月"
  },
  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年"
  },
  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年"
  }
}, Tqe = function(e, t, n) {
  var r, s = Oqe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + "內" : r + "前" : r;
};
const Rqe = Tqe;
var Dqe = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, Nqe = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, Wqe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, jqe = {
  date: Q({
    formats: Dqe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: Nqe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: Wqe,
    defaultWidth: "full"
  })
};
const zqe = jqe;
var Lqe = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
}, Iqe = function(e, t, n, r) {
  return Lqe[e];
};
const Fqe = Iqe;
var Hqe = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, Vqe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"]
}, Bqe = {
  narrow: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
  abbreviated: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  wide: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
}, Uqe = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, Xqe = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "午夜",
    noon: "晌",
    morning: "早",
    afternoon: "午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  }
}, qqe = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "午夜",
    noon: "晌",
    morning: "早",
    afternoon: "午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  }
}, Yqe = function(e, t) {
  var n = Number(e);
  switch (t == null ? void 0 : t.unit) {
    case "date":
      return n + "日";
    case "hour":
      return n + "時";
    case "minute":
      return n + "分";
    case "second":
      return n + "秒";
    default:
      return "第 " + n;
  }
}, Gqe = {
  ordinalNumber: Yqe,
  era: R({
    values: Hqe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Vqe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: Bqe,
    defaultWidth: "wide"
  }),
  day: R({
    values: Uqe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Xqe,
    defaultWidth: "wide",
    formattingValues: qqe,
    defaultFormattingWidth: "wide"
  })
};
const Qqe = Gqe;
var Kqe = /^(第\s*)?\d+(日|時|分|秒)?/i, Jqe = /\d+/i, Zqe = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, eYe = {
  any: [/^(前)/i, /^(公元)/i]
}, tYe = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]季/i,
  wide: /^第[一二三四]季度/i
}, nYe = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, rYe = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, aYe = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
}, iYe = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, oYe = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, sYe = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
}, lYe = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, uYe = {
  ordinalNumber: at({
    matchPattern: Kqe,
    parsePattern: Jqe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: Zqe,
    defaultMatchWidth: "wide",
    parsePatterns: eYe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: tYe,
    defaultMatchWidth: "wide",
    parsePatterns: nYe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: rYe,
    defaultMatchWidth: "wide",
    parsePatterns: aYe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: iYe,
    defaultMatchWidth: "wide",
    parsePatterns: oYe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: sYe,
    defaultMatchWidth: "any",
    parsePatterns: lYe,
    defaultParseWidth: "any"
  })
};
const cYe = uYe;
var dYe = {
  code: "zh-HK",
  formatDistance: Rqe,
  formatLong: zqe,
  formatRelative: Fqe,
  localize: Qqe,
  match: cYe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const fYe = dYe;
var mYe = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分鐘",
  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘"
  },
  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘"
  },
  xHours: {
    one: "1 小時",
    other: "{{count}} 小時"
  },
  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期"
  },
  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期"
  },
  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月"
  },
  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月"
  },
  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年"
  },
  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年"
  }
}, hYe = function(e, t, n) {
  var r, s = mYe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", String(t)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + "內" : r + "前" : r;
};
const pYe = hYe;
var vYe = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, gYe = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, yYe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, bYe = {
  date: Q({
    formats: vYe,
    defaultWidth: "full"
  }),
  time: Q({
    formats: gYe,
    defaultWidth: "full"
  }),
  dateTime: Q({
    formats: yYe,
    defaultWidth: "full"
  })
};
const wYe = bYe;
var PYe = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
}, kYe = function(e, t, n, r) {
  return PYe[e];
};
const $Ye = kYe;
var SYe = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, xYe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一刻", "第二刻", "第三刻", "第四刻"],
  wide: ["第一刻鐘", "第二刻鐘", "第三刻鐘", "第四刻鐘"]
}, CYe = {
  narrow: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
  abbreviated: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  wide: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
}, MYe = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, EYe = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, AYe = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, _Ye = function(e, t) {
  var n = Number(e);
  switch (t == null ? void 0 : t.unit) {
    case "date":
      return n + "日";
    case "hour":
      return n + "時";
    case "minute":
      return n + "分";
    case "second":
      return n + "秒";
    default:
      return "第 " + n;
  }
}, OYe = {
  ordinalNumber: _Ye,
  era: R({
    values: SYe,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: xYe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: R({
    values: CYe,
    defaultWidth: "wide"
  }),
  day: R({
    values: MYe,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: EYe,
    defaultWidth: "wide",
    formattingValues: AYe,
    defaultFormattingWidth: "wide"
  })
};
const TYe = OYe;
var RYe = /^(第\s*)?\d+(日|時|分|秒)?/i, DYe = /\d+/i, NYe = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, WYe = {
  any: [/^(前)/i, /^(公元)/i]
}, jYe = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻鐘/i
}, zYe = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, LYe = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, IYe = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
}, FYe = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, HYe = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, VYe = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
}, BYe = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, UYe = {
  ordinalNumber: at({
    matchPattern: RYe,
    parsePattern: DYe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: D({
    matchPatterns: NYe,
    defaultMatchWidth: "wide",
    parsePatterns: WYe,
    defaultParseWidth: "any"
  }),
  quarter: D({
    matchPatterns: jYe,
    defaultMatchWidth: "wide",
    parsePatterns: zYe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: D({
    matchPatterns: LYe,
    defaultMatchWidth: "wide",
    parsePatterns: IYe,
    defaultParseWidth: "any"
  }),
  day: D({
    matchPatterns: FYe,
    defaultMatchWidth: "wide",
    parsePatterns: HYe,
    defaultParseWidth: "any"
  }),
  dayPeriod: D({
    matchPatterns: VYe,
    defaultMatchWidth: "any",
    parsePatterns: BYe,
    defaultParseWidth: "any"
  })
};
const XYe = UYe;
var qYe = {
  code: "zh-TW",
  formatDistance: pYe,
  formatLong: wYe,
  formatRelative: $Ye,
  localize: TYe,
  match: XYe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const YYe = qYe, QO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  af: lne,
  ar: Bne,
  arDZ: Cre,
  arEG: lae,
  arMA: Bae,
  arSA: Cie,
  arTN: loe,
  az: Uoe,
  be: Cle,
  beTarask: hue,
  bg: tce,
  bn: Lce,
  bs: kde,
  ca: ife,
  cs: Vfe,
  cy: xme,
  da: she,
  de: zhe,
  deAT: Ghe,
  el: Ope,
  enAU: zpe,
  enCA: Ype,
  enGB: eve,
  enIE: nve,
  enIN: uve,
  enNZ: vve,
  enUS: lx,
  enZA: $ve,
  eo: age,
  es: Fge,
  et: wye,
  eu: rbe,
  faIR: Lbe,
  fi: P1e,
  fr: J1e,
  frCA: iwe,
  frCH: pwe,
  fy: Qwe,
  gd: T0e,
  gl: pPe,
  gu: KPe,
  he: Dke,
  hi: g$e,
  hr: eSe,
  ht: NSe,
  hu: wxe,
  hy: n2e,
  id: z2e,
  is: wCe,
  it: eMe,
  itCH: sMe,
  ja: VMe,
  jaHira: xEe,
  ka: sAe,
  kk: XAe,
  km: E_e,
  kn: c3e,
  ko: X3e,
  lb: TOe,
  lt: gTe,
  lv: n4e,
  mk: L4e,
  mn: kRe,
  ms: aDe,
  mt: IDe,
  nb: PNe,
  nl: n5e,
  nlBE: j5e,
  nn: bWe,
  oc: t6e,
  pl: B6e,
  pt: Cje,
  ptBR: lze,
  ro: Bze,
  ru: A7e,
  sk: g8e,
  sl: t9e,
  sq: j9e,
  sr: wLe,
  srLatn: rIe,
  sv: IIe,
  ta: $Fe,
  te: aHe,
  th: IHe,
  tr: kVe,
  ug: aBe,
  uk: XBe,
  uz: EUe,
  uzCyrl: cXe,
  vi: YXe,
  zhCN: _qe,
  zhHK: fYe,
  zhTW: YYe
}, Symbol.toStringTag, { value: "Module" }));
var tS = function(e, t) {
  return tS = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var s in r)
      r.hasOwnProperty(s) && (n[s] = r[s]);
  }, tS(e, t);
};
function GYe(e, t) {
  tS(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Vv = function() {
  return Vv = Object.assign || function(t) {
    for (var n, r = 1, s = arguments.length; r < s; r++) {
      n = arguments[r];
      for (var f in n)
        Object.prototype.hasOwnProperty.call(n, f) && (t[f] = n[f]);
    }
    return t;
  }, Vv.apply(this, arguments);
};
function QYe(e, t, n, r) {
  var s, f = !1, m = 0;
  function p() {
    s && clearTimeout(s);
  }
  function v() {
    p(), f = !0;
  }
  typeof t != "boolean" && (r = n, n = t, t = void 0);
  function y() {
    var w = this, P = Date.now() - m, x = arguments;
    if (f)
      return;
    function A() {
      m = Date.now(), n.apply(w, x);
    }
    function M() {
      s = void 0;
    }
    r && !s && A(), p(), r === void 0 && P > e ? A() : t !== !0 && (s = setTimeout(r ? M : A, r === void 0 ? e - P : e));
  }
  return y.cancel = v, y;
}
var Lh = {
  Pixel: "Pixel",
  Percent: "Percent"
}, KO = {
  unit: Lh.Percent,
  value: 0.8
};
function JO(e) {
  return typeof e == "number" ? {
    unit: Lh.Percent,
    value: e * 100
  } : typeof e == "string" ? e.match(/^(\d*(\.\d+)?)px$/) ? {
    unit: Lh.Pixel,
    value: parseFloat(e)
  } : e.match(/^(\d*(\.\d+)?)%$/) ? {
    unit: Lh.Percent,
    value: parseFloat(e)
  } : (console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...'), KO) : (console.warn("scrollThreshold should be string or number"), KO);
}
var KYe = function(e) {
  GYe(t, e);
  function t(n) {
    var r = e.call(this, n) || this;
    return r.lastScrollTop = 0, r.actionTriggered = !1, r.startY = 0, r.currentY = 0, r.dragging = !1, r.maxPullDownDistance = 0, r.getScrollableTarget = function() {
      return r.props.scrollableTarget instanceof HTMLElement ? r.props.scrollableTarget : typeof r.props.scrollableTarget == "string" ? document.getElementById(r.props.scrollableTarget) : (r.props.scrollableTarget === null && console.warn(`You are trying to pass scrollableTarget but it is null. This might
        happen because the element may not have been added to DOM yet.
        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.
      `), null);
    }, r.onStart = function(s) {
      r.lastScrollTop || (r.dragging = !0, s instanceof MouseEvent ? r.startY = s.pageY : s instanceof TouchEvent && (r.startY = s.touches[0].pageY), r.currentY = r.startY, r._infScroll && (r._infScroll.style.willChange = "transform", r._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)"));
    }, r.onMove = function(s) {
      r.dragging && (s instanceof MouseEvent ? r.currentY = s.pageY : s instanceof TouchEvent && (r.currentY = s.touches[0].pageY), !(r.currentY < r.startY) && (r.currentY - r.startY >= Number(r.props.pullDownToRefreshThreshold) && r.setState({
        pullToRefreshThresholdBreached: !0
      }), !(r.currentY - r.startY > r.maxPullDownDistance * 1.5) && r._infScroll && (r._infScroll.style.overflow = "visible", r._infScroll.style.transform = "translate3d(0px, " + (r.currentY - r.startY) + "px, 0px)")));
    }, r.onEnd = function() {
      r.startY = 0, r.currentY = 0, r.dragging = !1, r.state.pullToRefreshThresholdBreached && (r.props.refreshFunction && r.props.refreshFunction(), r.setState({
        pullToRefreshThresholdBreached: !1
      })), requestAnimationFrame(function() {
        r._infScroll && (r._infScroll.style.overflow = "auto", r._infScroll.style.transform = "none", r._infScroll.style.willChange = "unset");
      });
    }, r.onScrollListener = function(s) {
      typeof r.props.onScroll == "function" && setTimeout(function() {
        return r.props.onScroll && r.props.onScroll(s);
      }, 0);
      var f = r.props.height || r._scrollableNode ? s.target : document.documentElement.scrollTop ? document.documentElement : document.body;
      if (!r.actionTriggered) {
        var m = r.props.inverse ? r.isElementAtTop(f, r.props.scrollThreshold) : r.isElementAtBottom(f, r.props.scrollThreshold);
        m && r.props.hasMore && (r.actionTriggered = !0, r.setState({ showLoader: !0 }), r.props.next && r.props.next()), r.lastScrollTop = f.scrollTop;
      }
    }, r.state = {
      showLoader: !1,
      pullToRefreshThresholdBreached: !1,
      prevDataLength: n.dataLength
    }, r.throttledOnScrollListener = QYe(150, r.onScrollListener).bind(r), r.onStart = r.onStart.bind(r), r.onMove = r.onMove.bind(r), r.onEnd = r.onEnd.bind(r), r;
  }
  return t.prototype.componentDidMount = function() {
    if (typeof this.props.dataLength > "u")
      throw new Error('mandatory prop "dataLength" is missing. The prop is needed when loading more content. Check README.md for usage');
    if (this._scrollableNode = this.getScrollableTarget(), this.el = this.props.height ? this._infScroll : this._scrollableNode || window, this.el && this.el.addEventListener("scroll", this.throttledOnScrollListener), typeof this.props.initialScrollY == "number" && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY && this.el.scrollTo(0, this.props.initialScrollY), this.props.pullDownToRefresh && this.el && (this.el.addEventListener("touchstart", this.onStart), this.el.addEventListener("touchmove", this.onMove), this.el.addEventListener("touchend", this.onEnd), this.el.addEventListener("mousedown", this.onStart), this.el.addEventListener("mousemove", this.onMove), this.el.addEventListener("mouseup", this.onEnd), this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0, this.forceUpdate(), typeof this.props.refreshFunction != "function"))
      throw new Error(`Mandatory prop "refreshFunction" missing.
          Pull Down To Refresh functionality will not work
          as expected. Check README.md for usage'`);
  }, t.prototype.componentWillUnmount = function() {
    this.el && (this.el.removeEventListener("scroll", this.throttledOnScrollListener), this.props.pullDownToRefresh && (this.el.removeEventListener("touchstart", this.onStart), this.el.removeEventListener("touchmove", this.onMove), this.el.removeEventListener("touchend", this.onEnd), this.el.removeEventListener("mousedown", this.onStart), this.el.removeEventListener("mousemove", this.onMove), this.el.removeEventListener("mouseup", this.onEnd)));
  }, t.prototype.componentDidUpdate = function(n) {
    this.props.dataLength !== n.dataLength && (this.actionTriggered = !1, this.setState({
      showLoader: !1
    }));
  }, t.getDerivedStateFromProps = function(n, r) {
    var s = n.dataLength !== r.prevDataLength;
    return s ? Vv(Vv({}, r), { prevDataLength: n.dataLength }) : null;
  }, t.prototype.isElementAtTop = function(n, r) {
    r === void 0 && (r = 0.8);
    var s = n === document.body || n === document.documentElement ? window.screen.availHeight : n.clientHeight, f = JO(r);
    return f.unit === Lh.Pixel ? n.scrollTop <= f.value + s - n.scrollHeight + 1 : n.scrollTop <= f.value / 100 + s - n.scrollHeight + 1;
  }, t.prototype.isElementAtBottom = function(n, r) {
    r === void 0 && (r = 0.8);
    var s = n === document.body || n === document.documentElement ? window.screen.availHeight : n.clientHeight, f = JO(r);
    return f.unit === Lh.Pixel ? n.scrollTop + s >= n.scrollHeight - f.value : n.scrollTop + s >= f.value / 100 * n.scrollHeight;
  }, t.prototype.render = function() {
    var n = this, r = Vv({ height: this.props.height || "auto", overflow: "auto", WebkitOverflowScrolling: "touch" }, this.props.style), s = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length), f = this.props.pullDownToRefresh && this.props.height ? { overflow: "auto" } : {};
    return T.createElement(
      "div",
      { style: f, className: "infinite-scroll-component__outerdiv" },
      T.createElement(
        "div",
        { className: "infinite-scroll-component " + (this.props.className || ""), ref: function(m) {
          return n._infScroll = m;
        }, style: r },
        this.props.pullDownToRefresh && T.createElement(
          "div",
          { style: { position: "relative" }, ref: function(m) {
            return n._pullDown = m;
          } },
          T.createElement("div", { style: {
            position: "absolute",
            left: 0,
            right: 0,
            top: -1 * this.maxPullDownDistance
          } }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)
        ),
        this.props.children,
        !this.state.showLoader && !s && this.props.hasMore && this.props.loader,
        this.state.showLoader && this.props.hasMore && this.props.loader,
        !this.props.hasMore && this.props.endMessage
      )
    );
  }, t;
}(F.exports.Component), nS = { exports: {} };
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", s = 800, f = 16, m = 9007199254740991, p = "[object Arguments]", v = "[object Array]", y = "[object AsyncFunction]", w = "[object Boolean]", P = "[object Date]", x = "[object Error]", A = "[object Function]", M = "[object GeneratorFunction]", O = "[object Map]", j = "[object Number]", H = "[object Null]", J = "[object Object]", V = "[object Proxy]", X = "[object RegExp]", U = "[object Set]", K = "[object String]", ce = "[object Undefined]", ue = "[object WeakMap]", ye = "[object ArrayBuffer]", Oe = "[object DataView]", _e = "[object Float32Array]", Le = "[object Float64Array]", Ne = "[object Int8Array]", nt = "[object Int16Array]", Qe = "[object Int32Array]", qe = "[object Uint8Array]", ie = "[object Uint8ClampedArray]", xe = "[object Uint16Array]", Ye = "[object Uint32Array]", Be = /[\\^$.*+?()[\]{}|]/g, Ce = /^\[object .+?Constructor\]$/, Ie = /^(?:0|[1-9]\d*)$/, $e = {};
  $e[_e] = $e[Le] = $e[Ne] = $e[nt] = $e[Qe] = $e[qe] = $e[ie] = $e[xe] = $e[Ye] = !0, $e[p] = $e[v] = $e[ye] = $e[w] = $e[Oe] = $e[P] = $e[x] = $e[A] = $e[O] = $e[j] = $e[J] = $e[X] = $e[U] = $e[K] = $e[ue] = !1;
  var ot = typeof dc == "object" && dc && dc.Object === Object && dc, ht = typeof self == "object" && self && self.Object === Object && self, At = ot || ht || Function("return this")(), Sn = t && !t.nodeType && t, Gt = Sn && !0 && e && !e.nodeType && e, Bt = Gt && Gt.exports === Sn, Qn = Bt && ot.process, cn = function() {
    try {
      var N = Gt && Gt.require && Gt.require("util").types;
      return N || Qn && Qn.binding && Qn.binding("util");
    } catch {
    }
  }(), Ge = cn && cn.isTypedArray;
  function vr(N, Z, de) {
    switch (de.length) {
      case 0:
        return N.call(Z);
      case 1:
        return N.call(Z, de[0]);
      case 2:
        return N.call(Z, de[0], de[1]);
      case 3:
        return N.call(Z, de[0], de[1], de[2]);
    }
    return N.apply(Z, de);
  }
  function Fn(N, Z) {
    for (var de = -1, Ke = Array(N); ++de < N; )
      Ke[de] = Z(de);
    return Ke;
  }
  function en(N) {
    return function(Z) {
      return N(Z);
    };
  }
  function Gr(N, Z) {
    return N == null ? void 0 : N[Z];
  }
  function da(N, Z) {
    return function(de) {
      return N(Z(de));
    };
  }
  var gr = Array.prototype, qi = Function.prototype, Wr = Object.prototype, fa = At["__core-js_shared__"], xa = qi.toString, fr = Wr.hasOwnProperty, Xn = function() {
    var N = /[^.]+$/.exec(fa && fa.keys && fa.keys.IE_PROTO || "");
    return N ? "Symbol(src)_1." + N : "";
  }(), Hr = Wr.toString, Dn = xa.call(Object), Nn = RegExp(
    "^" + xa.call(fr).replace(Be, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Ca = Bt ? At.Buffer : void 0, Ia = At.Symbol, Fa = At.Uint8Array, et = Ca ? Ca.allocUnsafe : void 0, ft = da(Object.getPrototypeOf, Object), _t = Object.create, an = Wr.propertyIsEnumerable, ir = gr.splice, pn = Ia ? Ia.toStringTag : void 0, vn = function() {
    try {
      var N = wi(Object, "defineProperty");
      return N({}, "", {}), N;
    } catch {
    }
  }(), Kn = Ca ? Ca.isBuffer : void 0, Pn = Math.max, Vr = Date.now, pi = wi(At, "Map"), Ar = wi(Object, "create"), Oi = function() {
    function N() {
    }
    return function(Z) {
      if (!Qt(Z))
        return {};
      if (_t)
        return _t(Z);
      N.prototype = Z;
      var de = new N();
      return N.prototype = void 0, de;
    };
  }();
  function Qr(N) {
    var Z = -1, de = N == null ? 0 : N.length;
    for (this.clear(); ++Z < de; ) {
      var Ke = N[Z];
      this.set(Ke[0], Ke[1]);
    }
  }
  function Ha() {
    this.__data__ = Ar ? Ar(null) : {}, this.size = 0;
  }
  function ma(N) {
    var Z = this.has(N) && delete this.__data__[N];
    return this.size -= Z ? 1 : 0, Z;
  }
  function Kr(N) {
    var Z = this.__data__;
    if (Ar) {
      var de = Z[N];
      return de === r ? void 0 : de;
    }
    return fr.call(Z, N) ? Z[N] : void 0;
  }
  function Ka(N) {
    var Z = this.__data__;
    return Ar ? Z[N] !== void 0 : fr.call(Z, N);
  }
  function Jn(N, Z) {
    var de = this.__data__;
    return this.size += this.has(N) ? 0 : 1, de[N] = Ar && Z === void 0 ? r : Z, this;
  }
  Qr.prototype.clear = Ha, Qr.prototype.delete = ma, Qr.prototype.get = Kr, Qr.prototype.has = Ka, Qr.prototype.set = Jn;
  function or(N) {
    var Z = -1, de = N == null ? 0 : N.length;
    for (this.clear(); ++Z < de; ) {
      var Ke = N[Z];
      this.set(Ke[0], Ke[1]);
    }
  }
  function yo() {
    this.__data__ = [], this.size = 0;
  }
  function Ti(N) {
    var Z = this.__data__, de = Va(Z, N);
    if (de < 0)
      return !1;
    var Ke = Z.length - 1;
    return de == Ke ? Z.pop() : ir.call(Z, de, 1), --this.size, !0;
  }
  function Yi(N) {
    var Z = this.__data__, de = Va(Z, N);
    return de < 0 ? void 0 : Z[de][1];
  }
  function Gi(N) {
    return Va(this.__data__, N) > -1;
  }
  function Ma(N, Z) {
    var de = this.__data__, Ke = Va(de, N);
    return Ke < 0 ? (++this.size, de.push([N, Z])) : de[Ke][1] = Z, this;
  }
  or.prototype.clear = yo, or.prototype.delete = Ti, or.prototype.get = Yi, or.prototype.has = Gi, or.prototype.set = Ma;
  function Zt(N) {
    var Z = -1, de = N == null ? 0 : N.length;
    for (this.clear(); ++Z < de; ) {
      var Ke = N[Z];
      this.set(Ke[0], Ke[1]);
    }
  }
  function gi() {
    this.size = 0, this.__data__ = {
      hash: new Qr(),
      map: new (pi || or)(),
      string: new Qr()
    };
  }
  function qs(N) {
    var Z = _a(this, N).delete(N);
    return this.size -= Z ? 1 : 0, Z;
  }
  function Jr(N) {
    return _a(this, N).get(N);
  }
  function ha(N) {
    return _a(this, N).has(N);
  }
  function yi(N, Z) {
    var de = _a(this, N), Ke = de.size;
    return de.set(N, Z), this.size += de.size == Ke ? 0 : 1, this;
  }
  Zt.prototype.clear = gi, Zt.prototype.delete = qs, Zt.prototype.get = Jr, Zt.prototype.has = ha, Zt.prototype.set = yi;
  function Br(N) {
    var Z = this.__data__ = new or(N);
    this.size = Z.size;
  }
  function Ja() {
    this.__data__ = new or(), this.size = 0;
  }
  function Ri(N) {
    var Z = this.__data__, de = Z.delete(N);
    return this.size = Z.size, de;
  }
  function bi(N) {
    return this.__data__.get(N);
  }
  function Qi(N) {
    return this.__data__.has(N);
  }
  function bo(N, Z) {
    var de = this.__data__;
    if (de instanceof or) {
      var Ke = de.__data__;
      if (!pi || Ke.length < n - 1)
        return Ke.push([N, Z]), this.size = ++de.size, this;
      de = this.__data__ = new Zt(Ke);
    }
    return de.set(N, Z), this.size = de.size, this;
  }
  Br.prototype.clear = Ja, Br.prototype.delete = Ri, Br.prototype.get = bi, Br.prototype.has = Qi, Br.prototype.set = bo;
  function Za(N, Z) {
    var de = Ee(N), Ke = !de && be(N), Tt = !de && !Ke && wt(N), Nt = !de && !Ke && !Tt && Hn(N), Mn = de || Ke || Tt || Nt, Wt = Mn ? Fn(N.length, String) : [], yn = Wt.length;
    for (var jr in N)
      (Z || fr.call(N, jr)) && !(Mn && (jr == "length" || Tt && (jr == "offset" || jr == "parent") || Nt && (jr == "buffer" || jr == "byteLength" || jr == "byteOffset") || Or(jr, yn))) && Wt.push(jr);
    return Wt;
  }
  function Zr(N, Z, de) {
    (de !== void 0 && !oe(N[Z], de) || de === void 0 && !(Z in N)) && ei(N, Z, de);
  }
  function mr(N, Z, de) {
    var Ke = N[Z];
    (!(fr.call(N, Z) && oe(Ke, de)) || de === void 0 && !(Z in N)) && ei(N, Z, de);
  }
  function Va(N, Z) {
    for (var de = N.length; de--; )
      if (oe(N[de][0], Z))
        return de;
    return -1;
  }
  function ei(N, Z, de) {
    Z == "__proto__" && vn ? vn(N, Z, {
      configurable: !0,
      enumerable: !0,
      value: de,
      writable: !0
    }) : N[Z] = de;
  }
  var pa = ai();
  function Ba(N) {
    return N == null ? N === void 0 ? ce : H : pn && pn in Object(N) ? yr(N) : ii(N);
  }
  function Ea(N) {
    return dn(N) && Ba(N) == p;
  }
  function Ki(N) {
    if (!Qt(N) || lr(N))
      return !1;
    var Z = xt(N) ? Nn : Ce;
    return Z.test(L(N));
  }
  function ti(N) {
    return dn(N) && Pt(N.length) && !!$e[Ba(N)];
  }
  function Aa(N) {
    if (!Qt(N))
      return ta(N);
    var Z = wo(N), de = [];
    for (var Ke in N)
      Ke == "constructor" && (Z || !fr.call(N, Ke)) || de.push(Ke);
    return de;
  }
  function Ua(N, Z, de, Ke, Tt) {
    N !== Z && pa(Z, function(Nt, Mn) {
      if (Tt || (Tt = new Br()), Qt(Nt))
        va(N, Z, Mn, de, Ua, Ke, Tt);
      else {
        var Wt = Ke ? Ke(ko(N, Mn), Nt, Mn + "", N, Z, Tt) : void 0;
        Wt === void 0 && (Wt = Nt), Zr(N, Mn, Wt);
      }
    }, jn);
  }
  function va(N, Z, de, Ke, Tt, Nt, Mn) {
    var Wt = ko(N, de), yn = ko(Z, de), jr = Mn.get(yn);
    if (jr) {
      Zr(N, de, jr);
      return;
    }
    var sr = Nt ? Nt(Wt, yn, de + "", N, Z, Mn) : void 0, Pi = sr === void 0;
    if (Pi) {
      var ki = Ee(yn), Ys = !ki && wt(yn), So = !ki && !Ys && Hn(yn);
      sr = yn, ki || Ys || So ? Ee(Wt) ? sr = Wt : Et(Wt) ? sr = Je(Wt) : Ys ? (Pi = !1, sr = ea(yn, !0)) : So ? (Pi = !1, sr = Xr(yn, !0)) : sr = [] : Wn(yn) || be(yn) ? (sr = Wt, be(Wt) ? sr = wr(Wt) : (!Qt(Wt) || xt(Wt)) && (sr = qn(yn))) : Pi = !1;
    }
    Pi && (Mn.set(yn, sr), Tt(sr, yn, Ke, Nt, Mn), Mn.delete(yn)), Zr(N, de, sr);
  }
  function Ur(N, Z) {
    return $o(Po(N, Z, B), N + "");
  }
  var Xa = vn ? function(N, Z) {
    return vn(N, "toString", {
      configurable: !0,
      enumerable: !1,
      value: Di(Z),
      writable: !0
    });
  } : B;
  function ea(N, Z) {
    if (Z)
      return N.slice();
    var de = N.length, Ke = et ? et(de) : new N.constructor(de);
    return N.copy(Ke), Ke;
  }
  function ni(N) {
    var Z = new N.constructor(N.byteLength);
    return new Fa(Z).set(new Fa(N)), Z;
  }
  function Xr(N, Z) {
    var de = Z ? ni(N.buffer) : N.buffer;
    return new N.constructor(de, N.byteOffset, N.length);
  }
  function Je(N, Z) {
    var de = -1, Ke = N.length;
    for (Z || (Z = Array(Ke)); ++de < Ke; )
      Z[de] = N[de];
    return Z;
  }
  function ri(N, Z, de, Ke) {
    var Tt = !de;
    de || (de = {});
    for (var Nt = -1, Mn = Z.length; ++Nt < Mn; ) {
      var Wt = Z[Nt], yn = Ke ? Ke(de[Wt], N[Wt], Wt, de, N) : void 0;
      yn === void 0 && (yn = N[Wt]), Tt ? ei(de, Wt, yn) : mr(de, Wt, yn);
    }
    return de;
  }
  function _r(N) {
    return Ur(function(Z, de) {
      var Ke = -1, Tt = de.length, Nt = Tt > 1 ? de[Tt - 1] : void 0, Mn = Tt > 2 ? de[2] : void 0;
      for (Nt = N.length > 3 && typeof Nt == "function" ? (Tt--, Nt) : void 0, Mn && ms(de[0], de[1], Mn) && (Nt = Tt < 3 ? void 0 : Nt, Tt = 1), Z = Object(Z); ++Ke < Tt; ) {
        var Wt = de[Ke];
        Wt && N(Z, Wt, Ke, Nt);
      }
      return Z;
    });
  }
  function ai(N) {
    return function(Z, de, Ke) {
      for (var Tt = -1, Nt = Object(Z), Mn = Ke(Z), Wt = Mn.length; Wt--; ) {
        var yn = Mn[N ? Wt : ++Tt];
        if (de(Nt[yn], yn, Nt) === !1)
          break;
      }
      return Z;
    };
  }
  function _a(N, Z) {
    var de = N.__data__;
    return br(Z) ? de[typeof Z == "string" ? "string" : "hash"] : de.map;
  }
  function wi(N, Z) {
    var de = Gr(N, Z);
    return Ki(de) ? de : void 0;
  }
  function yr(N) {
    var Z = fr.call(N, pn), de = N[pn];
    try {
      N[pn] = void 0;
      var Ke = !0;
    } catch {
    }
    var Tt = Hr.call(N);
    return Ke && (Z ? N[pn] = de : delete N[pn]), Tt;
  }
  function qn(N) {
    return typeof N.constructor == "function" && !wo(N) ? Oi(ft(N)) : {};
  }
  function Or(N, Z) {
    var de = typeof N;
    return Z = Z ?? m, !!Z && (de == "number" || de != "symbol" && Ie.test(N)) && N > -1 && N % 1 == 0 && N < Z;
  }
  function ms(N, Z, de) {
    if (!Qt(de))
      return !1;
    var Ke = typeof Z;
    return (Ke == "number" ? Ze(de) && Or(Z, de.length) : Ke == "string" && Z in de) ? oe(de[Z], N) : !1;
  }
  function br(N) {
    var Z = typeof N;
    return Z == "string" || Z == "number" || Z == "symbol" || Z == "boolean" ? N !== "__proto__" : N === null;
  }
  function lr(N) {
    return !!Xn && Xn in N;
  }
  function wo(N) {
    var Z = N && N.constructor, de = typeof Z == "function" && Z.prototype || Wr;
    return N === de;
  }
  function ta(N) {
    var Z = [];
    if (N != null)
      for (var de in Object(N))
        Z.push(de);
    return Z;
  }
  function ii(N) {
    return Hr.call(N);
  }
  function Po(N, Z, de) {
    return Z = Pn(Z === void 0 ? N.length - 1 : Z, 0), function() {
      for (var Ke = arguments, Tt = -1, Nt = Pn(Ke.length - Z, 0), Mn = Array(Nt); ++Tt < Nt; )
        Mn[Tt] = Ke[Z + Tt];
      Tt = -1;
      for (var Wt = Array(Z + 1); ++Tt < Z; )
        Wt[Tt] = Ke[Tt];
      return Wt[Z] = de(Mn), vr(N, this, Wt);
    };
  }
  function ko(N, Z) {
    if (!(Z === "constructor" && typeof N[Z] == "function") && Z != "__proto__")
      return N[Z];
  }
  var $o = hs(Xa);
  function hs(N) {
    var Z = 0, de = 0;
    return function() {
      var Ke = Vr(), Tt = f - (Ke - de);
      if (de = Ke, Tt > 0) {
        if (++Z >= s)
          return arguments[0];
      } else
        Z = 0;
      return N.apply(void 0, arguments);
    };
  }
  function L(N) {
    if (N != null) {
      try {
        return xa.call(N);
      } catch {
      }
      try {
        return N + "";
      } catch {
      }
    }
    return "";
  }
  function oe(N, Z) {
    return N === Z || N !== N && Z !== Z;
  }
  var be = Ea(function() {
    return arguments;
  }()) ? Ea : function(N) {
    return dn(N) && fr.call(N, "callee") && !an.call(N, "callee");
  }, Ee = Array.isArray;
  function Ze(N) {
    return N != null && Pt(N.length) && !xt(N);
  }
  function Et(N) {
    return dn(N) && Ze(N);
  }
  var wt = Kn || ve;
  function xt(N) {
    if (!Qt(N))
      return !1;
    var Z = Ba(N);
    return Z == A || Z == M || Z == y || Z == V;
  }
  function Pt(N) {
    return typeof N == "number" && N > -1 && N % 1 == 0 && N <= m;
  }
  function Qt(N) {
    var Z = typeof N;
    return N != null && (Z == "object" || Z == "function");
  }
  function dn(N) {
    return N != null && typeof N == "object";
  }
  function Wn(N) {
    if (!dn(N) || Ba(N) != J)
      return !1;
    var Z = ft(N);
    if (Z === null)
      return !0;
    var de = fr.call(Z, "constructor") && Z.constructor;
    return typeof de == "function" && de instanceof de && xa.call(de) == Dn;
  }
  var Hn = Ge ? en(Ge) : ti;
  function wr(N) {
    return ri(N, jn(N));
  }
  function jn(N) {
    return Ze(N) ? Za(N, !0) : Aa(N);
  }
  var ga = _r(function(N, Z, de) {
    Ua(N, Z, de);
  });
  function Di(N) {
    return function() {
      return N;
    };
  }
  function B(N) {
    return N;
  }
  function ve() {
    return !1;
  }
  e.exports = ga;
})(nS, nS.exports);
const p$ = nS.exports;
var rS = { exports: {} };
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", s = 9007199254740991, f = "[object Arguments]", m = "[object Array]", p = "[object Boolean]", v = "[object Date]", y = "[object Error]", w = "[object Function]", P = "[object GeneratorFunction]", x = "[object Map]", A = "[object Number]", M = "[object Object]", O = "[object Promise]", j = "[object RegExp]", H = "[object Set]", J = "[object String]", V = "[object Symbol]", X = "[object WeakMap]", U = "[object ArrayBuffer]", K = "[object DataView]", ce = "[object Float32Array]", ue = "[object Float64Array]", ye = "[object Int8Array]", Oe = "[object Int16Array]", _e = "[object Int32Array]", Le = "[object Uint8Array]", Ne = "[object Uint8ClampedArray]", nt = "[object Uint16Array]", Qe = "[object Uint32Array]", qe = /[\\^$.*+?()[\]{}|]/g, ie = /\w*$/, xe = /^\[object .+?Constructor\]$/, Ye = /^(?:0|[1-9]\d*)$/, Be = {};
  Be[f] = Be[m] = Be[U] = Be[K] = Be[p] = Be[v] = Be[ce] = Be[ue] = Be[ye] = Be[Oe] = Be[_e] = Be[x] = Be[A] = Be[M] = Be[j] = Be[H] = Be[J] = Be[V] = Be[Le] = Be[Ne] = Be[nt] = Be[Qe] = !0, Be[y] = Be[w] = Be[X] = !1;
  var Ce = typeof dc == "object" && dc && dc.Object === Object && dc, Ie = typeof self == "object" && self && self.Object === Object && self, $e = Ce || Ie || Function("return this")(), ot = t && !t.nodeType && t, ht = ot && !0 && e && !e.nodeType && e, At = ht && ht.exports === ot;
  function Sn(B, ve) {
    return B.set(ve[0], ve[1]), B;
  }
  function Gt(B, ve) {
    return B.add(ve), B;
  }
  function Bt(B, ve) {
    for (var N = -1, Z = B ? B.length : 0; ++N < Z && ve(B[N], N, B) !== !1; )
      ;
    return B;
  }
  function Qn(B, ve) {
    for (var N = -1, Z = ve.length, de = B.length; ++N < Z; )
      B[de + N] = ve[N];
    return B;
  }
  function cn(B, ve, N, Z) {
    var de = -1, Ke = B ? B.length : 0;
    for (Z && Ke && (N = B[++de]); ++de < Ke; )
      N = ve(N, B[de], de, B);
    return N;
  }
  function Ge(B, ve) {
    for (var N = -1, Z = Array(B); ++N < B; )
      Z[N] = ve(N);
    return Z;
  }
  function vr(B, ve) {
    return B == null ? void 0 : B[ve];
  }
  function Fn(B) {
    var ve = !1;
    if (B != null && typeof B.toString != "function")
      try {
        ve = !!(B + "");
      } catch {
      }
    return ve;
  }
  function en(B) {
    var ve = -1, N = Array(B.size);
    return B.forEach(function(Z, de) {
      N[++ve] = [de, Z];
    }), N;
  }
  function Gr(B, ve) {
    return function(N) {
      return B(ve(N));
    };
  }
  function da(B) {
    var ve = -1, N = Array(B.size);
    return B.forEach(function(Z) {
      N[++ve] = Z;
    }), N;
  }
  var gr = Array.prototype, qi = Function.prototype, Wr = Object.prototype, fa = $e["__core-js_shared__"], xa = function() {
    var B = /[^.]+$/.exec(fa && fa.keys && fa.keys.IE_PROTO || "");
    return B ? "Symbol(src)_1." + B : "";
  }(), fr = qi.toString, Xn = Wr.hasOwnProperty, Hr = Wr.toString, Dn = RegExp(
    "^" + fr.call(Xn).replace(qe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Nn = At ? $e.Buffer : void 0, Ca = $e.Symbol, Ia = $e.Uint8Array, Fa = Gr(Object.getPrototypeOf, Object), et = Object.create, ft = Wr.propertyIsEnumerable, _t = gr.splice, an = Object.getOwnPropertySymbols, ir = Nn ? Nn.isBuffer : void 0, pn = Gr(Object.keys, Object), vn = lr($e, "DataView"), Kn = lr($e, "Map"), Pn = lr($e, "Promise"), Vr = lr($e, "Set"), pi = lr($e, "WeakMap"), Ar = lr(Object, "create"), Oi = be(vn), Qr = be(Kn), Ha = be(Pn), ma = be(Vr), Kr = be(pi), Ka = Ca ? Ca.prototype : void 0, Jn = Ka ? Ka.valueOf : void 0;
  function or(B) {
    var ve = -1, N = B ? B.length : 0;
    for (this.clear(); ++ve < N; ) {
      var Z = B[ve];
      this.set(Z[0], Z[1]);
    }
  }
  function yo() {
    this.__data__ = Ar ? Ar(null) : {};
  }
  function Ti(B) {
    return this.has(B) && delete this.__data__[B];
  }
  function Yi(B) {
    var ve = this.__data__;
    if (Ar) {
      var N = ve[B];
      return N === r ? void 0 : N;
    }
    return Xn.call(ve, B) ? ve[B] : void 0;
  }
  function Gi(B) {
    var ve = this.__data__;
    return Ar ? ve[B] !== void 0 : Xn.call(ve, B);
  }
  function Ma(B, ve) {
    var N = this.__data__;
    return N[B] = Ar && ve === void 0 ? r : ve, this;
  }
  or.prototype.clear = yo, or.prototype.delete = Ti, or.prototype.get = Yi, or.prototype.has = Gi, or.prototype.set = Ma;
  function Zt(B) {
    var ve = -1, N = B ? B.length : 0;
    for (this.clear(); ++ve < N; ) {
      var Z = B[ve];
      this.set(Z[0], Z[1]);
    }
  }
  function gi() {
    this.__data__ = [];
  }
  function qs(B) {
    var ve = this.__data__, N = Ki(ve, B);
    if (N < 0)
      return !1;
    var Z = ve.length - 1;
    return N == Z ? ve.pop() : _t.call(ve, N, 1), !0;
  }
  function Jr(B) {
    var ve = this.__data__, N = Ki(ve, B);
    return N < 0 ? void 0 : ve[N][1];
  }
  function ha(B) {
    return Ki(this.__data__, B) > -1;
  }
  function yi(B, ve) {
    var N = this.__data__, Z = Ki(N, B);
    return Z < 0 ? N.push([B, ve]) : N[Z][1] = ve, this;
  }
  Zt.prototype.clear = gi, Zt.prototype.delete = qs, Zt.prototype.get = Jr, Zt.prototype.has = ha, Zt.prototype.set = yi;
  function Br(B) {
    var ve = -1, N = B ? B.length : 0;
    for (this.clear(); ++ve < N; ) {
      var Z = B[ve];
      this.set(Z[0], Z[1]);
    }
  }
  function Ja() {
    this.__data__ = {
      hash: new or(),
      map: new (Kn || Zt)(),
      string: new or()
    };
  }
  function Ri(B) {
    return br(this, B).delete(B);
  }
  function bi(B) {
    return br(this, B).get(B);
  }
  function Qi(B) {
    return br(this, B).has(B);
  }
  function bo(B, ve) {
    return br(this, B).set(B, ve), this;
  }
  Br.prototype.clear = Ja, Br.prototype.delete = Ri, Br.prototype.get = bi, Br.prototype.has = Qi, Br.prototype.set = bo;
  function Za(B) {
    this.__data__ = new Zt(B);
  }
  function Zr() {
    this.__data__ = new Zt();
  }
  function mr(B) {
    return this.__data__.delete(B);
  }
  function Va(B) {
    return this.__data__.get(B);
  }
  function ei(B) {
    return this.__data__.has(B);
  }
  function pa(B, ve) {
    var N = this.__data__;
    if (N instanceof Zt) {
      var Z = N.__data__;
      if (!Kn || Z.length < n - 1)
        return Z.push([B, ve]), this;
      N = this.__data__ = new Br(Z);
    }
    return N.set(B, ve), this;
  }
  Za.prototype.clear = Zr, Za.prototype.delete = mr, Za.prototype.get = Va, Za.prototype.has = ei, Za.prototype.set = pa;
  function Ba(B, ve) {
    var N = wt(B) || Et(B) ? Ge(B.length, String) : [], Z = N.length, de = !!Z;
    for (var Ke in B)
      (ve || Xn.call(B, Ke)) && !(de && (Ke == "length" || $o(Ke, Z))) && N.push(Ke);
    return N;
  }
  function Ea(B, ve, N) {
    var Z = B[ve];
    (!(Xn.call(B, ve) && Ze(Z, N)) || N === void 0 && !(ve in B)) && (B[ve] = N);
  }
  function Ki(B, ve) {
    for (var N = B.length; N--; )
      if (Ze(B[N][0], ve))
        return N;
    return -1;
  }
  function ti(B, ve) {
    return B && qn(ve, jn(ve), B);
  }
  function Aa(B, ve, N, Z, de, Ke, Tt) {
    var Nt;
    if (Z && (Nt = Ke ? Z(B, de, Ke, Tt) : Z(B)), Nt !== void 0)
      return Nt;
    if (!Hn(B))
      return B;
    var Mn = wt(B);
    if (Mn) {
      if (Nt = ii(B), !ve)
        return yr(B, Nt);
    } else {
      var Wt = ta(B), yn = Wt == w || Wt == P;
      if (Qt(B))
        return ni(B, ve);
      if (Wt == M || Wt == f || yn && !Ke) {
        if (Fn(B))
          return Ke ? B : {};
        if (Nt = Po(yn ? {} : B), !ve)
          return Or(B, ti(Nt, B));
      } else {
        if (!Be[Wt])
          return Ke ? B : {};
        Nt = ko(B, Wt, Aa, ve);
      }
    }
    Tt || (Tt = new Za());
    var jr = Tt.get(B);
    if (jr)
      return jr;
    if (Tt.set(B, Nt), !Mn)
      var sr = N ? ms(B) : jn(B);
    return Bt(sr || B, function(Pi, ki) {
      sr && (ki = Pi, Pi = B[ki]), Ea(Nt, ki, Aa(Pi, ve, N, Z, ki, B, Tt));
    }), Nt;
  }
  function Ua(B) {
    return Hn(B) ? et(B) : {};
  }
  function va(B, ve, N) {
    var Z = ve(B);
    return wt(B) ? Z : Qn(Z, N(B));
  }
  function Ur(B) {
    return Hr.call(B);
  }
  function Xa(B) {
    if (!Hn(B) || L(B))
      return !1;
    var ve = dn(B) || Fn(B) ? Dn : xe;
    return ve.test(be(B));
  }
  function ea(B) {
    if (!oe(B))
      return pn(B);
    var ve = [];
    for (var N in Object(B))
      Xn.call(B, N) && N != "constructor" && ve.push(N);
    return ve;
  }
  function ni(B, ve) {
    if (ve)
      return B.slice();
    var N = new B.constructor(B.length);
    return B.copy(N), N;
  }
  function Xr(B) {
    var ve = new B.constructor(B.byteLength);
    return new Ia(ve).set(new Ia(B)), ve;
  }
  function Je(B, ve) {
    var N = ve ? Xr(B.buffer) : B.buffer;
    return new B.constructor(N, B.byteOffset, B.byteLength);
  }
  function ri(B, ve, N) {
    var Z = ve ? N(en(B), !0) : en(B);
    return cn(Z, Sn, new B.constructor());
  }
  function _r(B) {
    var ve = new B.constructor(B.source, ie.exec(B));
    return ve.lastIndex = B.lastIndex, ve;
  }
  function ai(B, ve, N) {
    var Z = ve ? N(da(B), !0) : da(B);
    return cn(Z, Gt, new B.constructor());
  }
  function _a(B) {
    return Jn ? Object(Jn.call(B)) : {};
  }
  function wi(B, ve) {
    var N = ve ? Xr(B.buffer) : B.buffer;
    return new B.constructor(N, B.byteOffset, B.length);
  }
  function yr(B, ve) {
    var N = -1, Z = B.length;
    for (ve || (ve = Array(Z)); ++N < Z; )
      ve[N] = B[N];
    return ve;
  }
  function qn(B, ve, N, Z) {
    N || (N = {});
    for (var de = -1, Ke = ve.length; ++de < Ke; ) {
      var Tt = ve[de], Nt = Z ? Z(N[Tt], B[Tt], Tt, N, B) : void 0;
      Ea(N, Tt, Nt === void 0 ? B[Tt] : Nt);
    }
    return N;
  }
  function Or(B, ve) {
    return qn(B, wo(B), ve);
  }
  function ms(B) {
    return va(B, jn, wo);
  }
  function br(B, ve) {
    var N = B.__data__;
    return hs(ve) ? N[typeof ve == "string" ? "string" : "hash"] : N.map;
  }
  function lr(B, ve) {
    var N = vr(B, ve);
    return Xa(N) ? N : void 0;
  }
  var wo = an ? Gr(an, Object) : ga, ta = Ur;
  (vn && ta(new vn(new ArrayBuffer(1))) != K || Kn && ta(new Kn()) != x || Pn && ta(Pn.resolve()) != O || Vr && ta(new Vr()) != H || pi && ta(new pi()) != X) && (ta = function(B) {
    var ve = Hr.call(B), N = ve == M ? B.constructor : void 0, Z = N ? be(N) : void 0;
    if (Z)
      switch (Z) {
        case Oi:
          return K;
        case Qr:
          return x;
        case Ha:
          return O;
        case ma:
          return H;
        case Kr:
          return X;
      }
    return ve;
  });
  function ii(B) {
    var ve = B.length, N = B.constructor(ve);
    return ve && typeof B[0] == "string" && Xn.call(B, "index") && (N.index = B.index, N.input = B.input), N;
  }
  function Po(B) {
    return typeof B.constructor == "function" && !oe(B) ? Ua(Fa(B)) : {};
  }
  function ko(B, ve, N, Z) {
    var de = B.constructor;
    switch (ve) {
      case U:
        return Xr(B);
      case p:
      case v:
        return new de(+B);
      case K:
        return Je(B, Z);
      case ce:
      case ue:
      case ye:
      case Oe:
      case _e:
      case Le:
      case Ne:
      case nt:
      case Qe:
        return wi(B, Z);
      case x:
        return ri(B, Z, N);
      case A:
      case J:
        return new de(B);
      case j:
        return _r(B);
      case H:
        return ai(B, Z, N);
      case V:
        return _a(B);
    }
  }
  function $o(B, ve) {
    return ve = ve ?? s, !!ve && (typeof B == "number" || Ye.test(B)) && B > -1 && B % 1 == 0 && B < ve;
  }
  function hs(B) {
    var ve = typeof B;
    return ve == "string" || ve == "number" || ve == "symbol" || ve == "boolean" ? B !== "__proto__" : B === null;
  }
  function L(B) {
    return !!xa && xa in B;
  }
  function oe(B) {
    var ve = B && B.constructor, N = typeof ve == "function" && ve.prototype || Wr;
    return B === N;
  }
  function be(B) {
    if (B != null) {
      try {
        return fr.call(B);
      } catch {
      }
      try {
        return B + "";
      } catch {
      }
    }
    return "";
  }
  function Ee(B) {
    return Aa(B, !0, !0);
  }
  function Ze(B, ve) {
    return B === ve || B !== B && ve !== ve;
  }
  function Et(B) {
    return Pt(B) && Xn.call(B, "callee") && (!ft.call(B, "callee") || Hr.call(B) == f);
  }
  var wt = Array.isArray;
  function xt(B) {
    return B != null && Wn(B.length) && !dn(B);
  }
  function Pt(B) {
    return wr(B) && xt(B);
  }
  var Qt = ir || Di;
  function dn(B) {
    var ve = Hn(B) ? Hr.call(B) : "";
    return ve == w || ve == P;
  }
  function Wn(B) {
    return typeof B == "number" && B > -1 && B % 1 == 0 && B <= s;
  }
  function Hn(B) {
    var ve = typeof B;
    return !!B && (ve == "object" || ve == "function");
  }
  function wr(B) {
    return !!B && typeof B == "object";
  }
  function jn(B) {
    return xt(B) ? Ba(B) : ea(B);
  }
  function ga() {
    return [];
  }
  function Di() {
    return !1;
  }
  e.exports = Ee;
})(rS, rS.exports);
const Jb = rS.exports;
var us = globalThis && globalThis.__awaiter || function(e, t, n, r) {
  function s(f) {
    return f instanceof n ? f : new n(function(m) {
      m(f);
    });
  }
  return new (n || (n = Promise))(function(f, m) {
    function p(w) {
      try {
        y(r.next(w));
      } catch (P) {
        m(P);
      }
    }
    function v(w) {
      try {
        y(r.throw(w));
      } catch (P) {
        m(P);
      }
    }
    function y(w) {
      w.done ? f(w.value) : s(w.value).then(p, v);
    }
    y((r = r.apply(e, t || [])).next());
  });
};
class JYe {
  constructor(t) {
    this.backendUrl = t, this.isAuthenticated = !1, this.httpClient = new wF(t);
  }
  setAuthorizationToken(t) {
    this.httpClient.setAuthorizationToken(t), this.isAuthenticated = !0;
  }
  disposeAuthorizationToken() {
    this.httpClient.disposeAuthorizationToken(), this.isAuthenticated = !1;
  }
  updateAction(t, n, r, s) {
    return us(this, void 0, void 0, function* () {
      return yield this.httpClient.post(`/widgets/messages/${t}/actions/${n}`, {
        executedType: n,
        status: r,
        payload: s
      });
    });
  }
  markMessageAsSeen(t) {
    return us(this, void 0, void 0, function* () {
      const n = t ? t.toString() : "";
      return yield this.httpClient.post(`/widgets/messages/${n}/seen`, {});
    });
  }
  markMessageAsRead(t) {
    return us(this, void 0, void 0, function* () {
      const n = t ? t.toString() : "";
      return yield this.httpClient.post(`/widgets/messages/${n}/read`, {});
    });
  }
  markMessageAs(t, n) {
    return us(this, void 0, void 0, function* () {
      const r = n.seen === void 0 && n.read === void 0 ? { seen: !0 } : n;
      return yield this.httpClient.post("/widgets/messages/markAs", {
        messageId: t,
        mark: r
      });
    });
  }
  removeMessage(t) {
    return us(this, void 0, void 0, function* () {
      return yield this.httpClient.delete(`/widgets/messages/${t}`, {});
    });
  }
  getNotificationsList(t, n = {}) {
    return us(this, void 0, void 0, function* () {
      return yield this.httpClient.getFullResponse("/widgets/notifications/feed", Object.assign({ page: t }, n));
    });
  }
  initializeSession(t, n, r = null) {
    return us(this, void 0, void 0, function* () {
      return yield this.httpClient.post("/widgets/session/initialize", {
        applicationIdentifier: t,
        subscriberId: n,
        hmacHash: r
      });
    });
  }
  postUsageLog(t, n) {
    return us(this, void 0, void 0, function* () {
      return yield this.httpClient.post("/widgets/usage/log", {
        name: `[Widget] - ${t}`,
        payload: n
      });
    });
  }
  getUnseenCount(t = {}) {
    return us(this, void 0, void 0, function* () {
      return yield this.httpClient.get("/widgets/notifications/unseen", t);
    });
  }
  getTabCount(t = {}) {
    return us(this, void 0, void 0, function* () {
      return yield this.httpClient.get("/widgets/notifications/count", t);
    });
  }
  getOrganization() {
    return us(this, void 0, void 0, function* () {
      return this.httpClient.get("/widgets/organization");
    });
  }
  getUserPreference() {
    return us(this, void 0, void 0, function* () {
      return this.httpClient.get("/widgets/preferences");
    });
  }
  updateSubscriberPreference(t, n, r) {
    return us(this, void 0, void 0, function* () {
      return yield this.httpClient.patch(`/widgets/preferences/${t}`, {
        channel: { type: n, enabled: r }
      });
    });
  }
}
const pu = /* @__PURE__ */ Object.create(null);
pu.open = "0";
pu.close = "1";
pu.ping = "2";
pu.pong = "3";
pu.message = "4";
pu.upgrade = "5";
pu.noop = "6";
const Zb = /* @__PURE__ */ Object.create(null);
Object.keys(pu).forEach((e) => {
  Zb[pu[e]] = e;
});
const ZYe = { type: "error", data: "parser error" }, eGe = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", tGe = typeof ArrayBuffer == "function", nGe = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, xW = ({ type: e, data: t }, n, r) => eGe && t instanceof Blob ? n ? r(t) : ZO(t, r) : tGe && (t instanceof ArrayBuffer || nGe(t)) ? n ? r(t) : ZO(new Blob([t]), r) : r(pu[e] + (t || "")), ZO = (e, t) => {
  const n = new FileReader();
  return n.onload = function() {
    const r = n.result.split(",")[1];
    t("b" + r);
  }, n.readAsDataURL(e);
};
var eT = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Dv = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Wb = 0; Wb < eT.length; Wb++)
  Dv[eT.charCodeAt(Wb)] = Wb;
var rGe = function(e) {
  var t = e.length * 0.75, n = e.length, r, s = 0, f, m, p, v;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  var y = new ArrayBuffer(t), w = new Uint8Array(y);
  for (r = 0; r < n; r += 4)
    f = Dv[e.charCodeAt(r)], m = Dv[e.charCodeAt(r + 1)], p = Dv[e.charCodeAt(r + 2)], v = Dv[e.charCodeAt(r + 3)], w[s++] = f << 2 | m >> 4, w[s++] = (m & 15) << 4 | p >> 2, w[s++] = (p & 3) << 6 | v & 63;
  return y;
};
const aGe = typeof ArrayBuffer == "function", CW = (e, t) => {
  if (typeof e != "string")
    return {
      type: "message",
      data: MW(e, t)
    };
  const n = e.charAt(0);
  return n === "b" ? {
    type: "message",
    data: iGe(e.substring(1), t)
  } : Zb[n] ? e.length > 1 ? {
    type: Zb[n],
    data: e.substring(1)
  } : {
    type: Zb[n]
  } : ZYe;
}, iGe = (e, t) => {
  if (aGe) {
    const n = rGe(e);
    return MW(n, t);
  } else
    return { base64: !0, data: e };
}, MW = (e, t) => {
  switch (t) {
    case "blob":
      return e instanceof ArrayBuffer ? new Blob([e]) : e;
    case "arraybuffer":
    default:
      return e;
  }
}, EW = String.fromCharCode(30), oGe = (e, t) => {
  const n = e.length, r = new Array(n);
  let s = 0;
  e.forEach((f, m) => {
    xW(f, !1, (p) => {
      r[m] = p, ++s === n && t(r.join(EW));
    });
  });
}, sGe = (e, t) => {
  const n = e.split(EW), r = [];
  for (let s = 0; s < n.length; s++) {
    const f = CW(n[s], t);
    if (r.push(f), f.type === "error")
      break;
  }
  return r;
}, AW = 4;
function La(e) {
  if (e)
    return lGe(e);
}
function lGe(e) {
  for (var t in La.prototype)
    e[t] = La.prototype[t];
  return e;
}
La.prototype.on = La.prototype.addEventListener = function(e, t) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
};
La.prototype.once = function(e, t) {
  function n() {
    this.off(e, n), t.apply(this, arguments);
  }
  return n.fn = t, this.on(e, n), this;
};
La.prototype.off = La.prototype.removeListener = La.prototype.removeAllListeners = La.prototype.removeEventListener = function(e, t) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var n = this._callbacks["$" + e];
  if (!n)
    return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + e], this;
  for (var r, s = 0; s < n.length; s++)
    if (r = n[s], r === t || r.fn === t) {
      n.splice(s, 1);
      break;
    }
  return n.length === 0 && delete this._callbacks["$" + e], this;
};
La.prototype.emit = function(e) {
  this._callbacks = this._callbacks || {};
  for (var t = new Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  if (n) {
    n = n.slice(0);
    for (var r = 0, s = n.length; r < s; ++r)
      n[r].apply(this, t);
  }
  return this;
};
La.prototype.emitReserved = La.prototype.emit;
La.prototype.listeners = function(e) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
};
La.prototype.hasListeners = function(e) {
  return !!this.listeners(e).length;
};
const gd = (() => typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")())();
function _W(e, ...t) {
  return t.reduce((n, r) => (e.hasOwnProperty(r) && (n[r] = e[r]), n), {});
}
const uGe = setTimeout, cGe = clearTimeout;
function Xw(e, t) {
  t.useNativeTimers ? (e.setTimeoutFn = uGe.bind(gd), e.clearTimeoutFn = cGe.bind(gd)) : (e.setTimeoutFn = setTimeout.bind(gd), e.clearTimeoutFn = clearTimeout.bind(gd));
}
const dGe = 1.33;
function fGe(e) {
  return typeof e == "string" ? mGe(e) : Math.ceil((e.byteLength || e.size) * dGe);
}
function mGe(e) {
  let t = 0, n = 0;
  for (let r = 0, s = e.length; r < s; r++)
    t = e.charCodeAt(r), t < 128 ? n += 1 : t < 2048 ? n += 2 : t < 55296 || t >= 57344 ? n += 3 : (r++, n += 4);
  return n;
}
class hGe extends Error {
  constructor(t, n, r) {
    super(t), this.description = n, this.context = r, this.type = "TransportError";
  }
}
class OW extends La {
  constructor(t) {
    super(), this.writable = !1, Xw(this, t), this.opts = t, this.query = t.query, this.readyState = "", this.socket = t.socket;
  }
  onError(t, n, r) {
    return super.emitReserved("error", new hGe(t, n, r)), this;
  }
  open() {
    return (this.readyState === "closed" || this.readyState === "") && (this.readyState = "opening", this.doOpen()), this;
  }
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  send(t) {
    this.readyState === "open" && this.write(t);
  }
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  onData(t) {
    const n = CW(t, this.socket.binaryType);
    this.onPacket(n);
  }
  onPacket(t) {
    super.emitReserved("packet", t);
  }
  onClose(t) {
    this.readyState = "closed", super.emitReserved("close", t);
  }
}
const TW = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), aS = 64, pGe = {};
let tT = 0, jb = 0, nT;
function rT(e) {
  let t = "";
  do
    t = TW[e % aS] + t, e = Math.floor(e / aS);
  while (e > 0);
  return t;
}
function RW() {
  const e = rT(+new Date());
  return e !== nT ? (tT = 0, nT = e) : e + "." + rT(tT++);
}
for (; jb < aS; jb++)
  pGe[TW[jb]] = jb;
function DW(e) {
  let t = "";
  for (let n in e)
    e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
  return t;
}
function vGe(e) {
  let t = {}, n = e.split("&");
  for (let r = 0, s = n.length; r < s; r++) {
    let f = n[r].split("=");
    t[decodeURIComponent(f[0])] = decodeURIComponent(f[1]);
  }
  return t;
}
let NW = !1;
try {
  NW = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const gGe = NW;
function WW(e) {
  const t = e.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!t || gGe))
      return new XMLHttpRequest();
  } catch {
  }
  if (!t)
    try {
      return new gd[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
function yGe() {
}
const bGe = function() {
  return new WW({
    xdomain: !1
  }).responseType != null;
}();
class wGe extends OW {
  constructor(t) {
    if (super(t), this.polling = !1, typeof location < "u") {
      const r = location.protocol === "https:";
      let s = location.port;
      s || (s = r ? "443" : "80"), this.xd = typeof location < "u" && t.hostname !== location.hostname || s !== t.port, this.xs = t.secure !== r;
    }
    const n = t && t.forceBase64;
    this.supportsBinary = bGe && !n;
  }
  get name() {
    return "polling";
  }
  doOpen() {
    this.poll();
  }
  pause(t) {
    this.readyState = "pausing";
    const n = () => {
      this.readyState = "paused", t();
    };
    if (this.polling || !this.writable) {
      let r = 0;
      this.polling && (r++, this.once("pollComplete", function() {
        --r || n();
      })), this.writable || (r++, this.once("drain", function() {
        --r || n();
      }));
    } else
      n();
  }
  poll() {
    this.polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  onData(t) {
    const n = (r) => {
      if (this.readyState === "opening" && r.type === "open" && this.onOpen(), r.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(r);
    };
    sGe(t, this.socket.binaryType).forEach(n), this.readyState !== "closed" && (this.polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this.poll());
  }
  doClose() {
    const t = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? t() : this.once("open", t);
  }
  write(t) {
    this.writable = !1, oGe(t, (n) => {
      this.doWrite(n, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  uri() {
    let t = this.query || {};
    const n = this.opts.secure ? "https" : "http";
    let r = "";
    this.opts.timestampRequests !== !1 && (t[this.opts.timestampParam] = RW()), !this.supportsBinary && !t.sid && (t.b64 = 1), this.opts.port && (n === "https" && Number(this.opts.port) !== 443 || n === "http" && Number(this.opts.port) !== 80) && (r = ":" + this.opts.port);
    const s = DW(t), f = this.opts.hostname.indexOf(":") !== -1;
    return n + "://" + (f ? "[" + this.opts.hostname + "]" : this.opts.hostname) + r + this.opts.path + (s.length ? "?" + s : "");
  }
  request(t = {}) {
    return Object.assign(t, { xd: this.xd, xs: this.xs }, this.opts), new hu(this.uri(), t);
  }
  doWrite(t, n) {
    const r = this.request({
      method: "POST",
      data: t
    });
    r.on("success", n), r.on("error", (s, f) => {
      this.onError("xhr post error", s, f);
    });
  }
  doPoll() {
    const t = this.request();
    t.on("data", this.onData.bind(this)), t.on("error", (n, r) => {
      this.onError("xhr poll error", n, r);
    }), this.pollXhr = t;
  }
}
class hu extends La {
  constructor(t, n) {
    super(), Xw(this, n), this.opts = n, this.method = n.method || "GET", this.uri = t, this.async = n.async !== !1, this.data = n.data !== void 0 ? n.data : null, this.create();
  }
  create() {
    const t = _W(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    t.xdomain = !!this.opts.xd, t.xscheme = !!this.opts.xs;
    const n = this.xhr = new WW(t);
    try {
      n.open(this.method, this.uri, this.async);
      try {
        if (this.opts.extraHeaders) {
          n.setDisableHeaderCheck && n.setDisableHeaderCheck(!0);
          for (let r in this.opts.extraHeaders)
            this.opts.extraHeaders.hasOwnProperty(r) && n.setRequestHeader(r, this.opts.extraHeaders[r]);
        }
      } catch {
      }
      if (this.method === "POST")
        try {
          n.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        n.setRequestHeader("Accept", "*/*");
      } catch {
      }
      "withCredentials" in n && (n.withCredentials = this.opts.withCredentials), this.opts.requestTimeout && (n.timeout = this.opts.requestTimeout), n.onreadystatechange = () => {
        n.readyState === 4 && (n.status === 200 || n.status === 1223 ? this.onLoad() : this.setTimeoutFn(() => {
          this.onError(typeof n.status == "number" ? n.status : 0);
        }, 0));
      }, n.send(this.data);
    } catch (r) {
      this.setTimeoutFn(() => {
        this.onError(r);
      }, 0);
      return;
    }
    typeof document < "u" && (this.index = hu.requestsCount++, hu.requests[this.index] = this);
  }
  onError(t) {
    this.emitReserved("error", t, this.xhr), this.cleanup(!0);
  }
  cleanup(t) {
    if (!(typeof this.xhr > "u" || this.xhr === null)) {
      if (this.xhr.onreadystatechange = yGe, t)
        try {
          this.xhr.abort();
        } catch {
        }
      typeof document < "u" && delete hu.requests[this.index], this.xhr = null;
    }
  }
  onLoad() {
    const t = this.xhr.responseText;
    t !== null && (this.emitReserved("data", t), this.emitReserved("success"), this.cleanup());
  }
  abort() {
    this.cleanup();
  }
}
hu.requestsCount = 0;
hu.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", aT);
  else if (typeof addEventListener == "function") {
    const e = "onpagehide" in gd ? "pagehide" : "unload";
    addEventListener(e, aT, !1);
  }
}
function aT() {
  for (let e in hu.requests)
    hu.requests.hasOwnProperty(e) && hu.requests[e].abort();
}
const jW = (() => typeof Promise == "function" && typeof Promise.resolve == "function" ? (t) => Promise.resolve().then(t) : (t, n) => n(t, 0))(), zb = gd.WebSocket || gd.MozWebSocket, iT = !0, PGe = "arraybuffer", oT = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class kGe extends OW {
  constructor(t) {
    super(t), this.supportsBinary = !t.forceBase64;
  }
  get name() {
    return "websocket";
  }
  doOpen() {
    if (!this.check())
      return;
    const t = this.uri(), n = this.opts.protocols, r = oT ? {} : _W(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (r.headers = this.opts.extraHeaders);
    try {
      this.ws = iT && !oT ? n ? new zb(t, n) : new zb(t) : new zb(t, n, r);
    } catch (s) {
      return this.emitReserved("error", s);
    }
    this.ws.binaryType = this.socket.binaryType || PGe, this.addEventListeners();
  }
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (t) => this.onClose({
      description: "websocket connection closed",
      context: t
    }), this.ws.onmessage = (t) => this.onData(t.data), this.ws.onerror = (t) => this.onError("websocket error", t);
  }
  write(t) {
    this.writable = !1;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], s = n === t.length - 1;
      xW(r, this.supportsBinary, (f) => {
        const m = {};
        try {
          iT && this.ws.send(f);
        } catch {
        }
        s && jW(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.close(), this.ws = null);
  }
  uri() {
    let t = this.query || {};
    const n = this.opts.secure ? "wss" : "ws";
    let r = "";
    this.opts.port && (n === "wss" && Number(this.opts.port) !== 443 || n === "ws" && Number(this.opts.port) !== 80) && (r = ":" + this.opts.port), this.opts.timestampRequests && (t[this.opts.timestampParam] = RW()), this.supportsBinary || (t.b64 = 1);
    const s = DW(t), f = this.opts.hostname.indexOf(":") !== -1;
    return n + "://" + (f ? "[" + this.opts.hostname + "]" : this.opts.hostname) + r + this.opts.path + (s.length ? "?" + s : "");
  }
  check() {
    return !!zb;
  }
}
const $Ge = {
  websocket: kGe,
  polling: wGe
}, SGe = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, xGe = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function iS(e) {
  const t = e, n = e.indexOf("["), r = e.indexOf("]");
  n != -1 && r != -1 && (e = e.substring(0, n) + e.substring(n, r).replace(/:/g, ";") + e.substring(r, e.length));
  let s = SGe.exec(e || ""), f = {}, m = 14;
  for (; m--; )
    f[xGe[m]] = s[m] || "";
  return n != -1 && r != -1 && (f.source = t, f.host = f.host.substring(1, f.host.length - 1).replace(/;/g, ":"), f.authority = f.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), f.ipv6uri = !0), f.pathNames = CGe(f, f.path), f.queryKey = MGe(f, f.query), f;
}
function CGe(e, t) {
  const n = /\/{2,9}/g, r = t.replace(n, "/").split("/");
  return (t.slice(0, 1) == "/" || t.length === 0) && r.splice(0, 1), t.slice(-1) == "/" && r.splice(r.length - 1, 1), r;
}
function MGe(e, t) {
  const n = {};
  return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(r, s, f) {
    s && (n[s] = f);
  }), n;
}
let zW = class Oh extends La {
  constructor(t, n = {}) {
    super(), t && typeof t == "object" && (n = t, t = null), t ? (t = iS(t), n.hostname = t.host, n.secure = t.protocol === "https" || t.protocol === "wss", n.port = t.port, t.query && (n.query = t.query)) : n.host && (n.hostname = iS(n.host).host), Xw(this, n), this.secure = n.secure != null ? n.secure : typeof location < "u" && location.protocol === "https:", n.hostname && !n.port && (n.port = this.secure ? "443" : "80"), this.hostname = n.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = n.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = n.transports || ["polling", "websocket"], this.readyState = "", this.writeBuffer = [], this.prevBufferLen = 0, this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !0
    }, n), this.opts.path = this.opts.path.replace(/\/$/, "") + "/", typeof this.opts.query == "string" && (this.opts.query = vGe(this.opts.query)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingTimeoutTimer = null, typeof addEventListener == "function" && (this.opts.closeOnBeforeunload && (this.beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this.beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this.offlineEventListener = () => {
      this.onClose("transport close", {
        description: "network connection lost"
      });
    }, addEventListener("offline", this.offlineEventListener, !1))), this.open();
  }
  createTransport(t) {
    const n = Object.assign({}, this.opts.query);
    n.EIO = AW, n.transport = t, this.id && (n.sid = this.id);
    const r = Object.assign({}, this.opts.transportOptions[t], this.opts, {
      query: n,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    });
    return new $Ge[t](r);
  }
  open() {
    let t;
    if (this.opts.rememberUpgrade && Oh.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1)
      t = "websocket";
    else if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    } else
      t = this.transports[0];
    this.readyState = "opening";
    try {
      t = this.createTransport(t);
    } catch {
      this.transports.shift(), this.open();
      return;
    }
    t.open(), this.setTransport(t);
  }
  setTransport(t) {
    this.transport && this.transport.removeAllListeners(), this.transport = t, t.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (n) => this.onClose("transport close", n));
  }
  probe(t) {
    let n = this.createTransport(t), r = !1;
    Oh.priorWebsocketSuccess = !1;
    const s = () => {
      r || (n.send([{ type: "ping", data: "probe" }]), n.once("packet", (P) => {
        if (!r)
          if (P.type === "pong" && P.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", n), !n)
              return;
            Oh.priorWebsocketSuccess = n.name === "websocket", this.transport.pause(() => {
              r || this.readyState !== "closed" && (w(), this.setTransport(n), n.send([{ type: "upgrade" }]), this.emitReserved("upgrade", n), n = null, this.upgrading = !1, this.flush());
            });
          } else {
            const x = new Error("probe error");
            x.transport = n.name, this.emitReserved("upgradeError", x);
          }
      }));
    };
    function f() {
      r || (r = !0, w(), n.close(), n = null);
    }
    const m = (P) => {
      const x = new Error("probe error: " + P);
      x.transport = n.name, f(), this.emitReserved("upgradeError", x);
    };
    function p() {
      m("transport closed");
    }
    function v() {
      m("socket closed");
    }
    function y(P) {
      n && P.name !== n.name && f();
    }
    const w = () => {
      n.removeListener("open", s), n.removeListener("error", m), n.removeListener("close", p), this.off("close", v), this.off("upgrading", y);
    };
    n.once("open", s), n.once("error", m), n.once("close", p), this.once("close", v), this.once("upgrading", y), n.open();
  }
  onOpen() {
    if (this.readyState = "open", Oh.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush(), this.readyState === "open" && this.opts.upgrade && this.transport.pause) {
      let t = 0;
      const n = this.upgrades.length;
      for (; t < n; t++)
        this.probe(this.upgrades[t]);
    }
  }
  onPacket(t) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", t), this.emitReserved("heartbeat"), t.type) {
        case "open":
          this.onHandshake(JSON.parse(t.data));
          break;
        case "ping":
          this.resetPingTimeout(), this.sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong");
          break;
        case "error":
          const n = new Error("server error");
          n.code = t.data, this.onError(n);
          break;
        case "message":
          this.emitReserved("data", t.data), this.emitReserved("message", t.data);
          break;
      }
  }
  onHandshake(t) {
    this.emitReserved("handshake", t), this.id = t.sid, this.transport.query.sid = t.sid, this.upgrades = this.filterUpgrades(t.upgrades), this.pingInterval = t.pingInterval, this.pingTimeout = t.pingTimeout, this.maxPayload = t.maxPayload, this.onOpen(), this.readyState !== "closed" && this.resetPingTimeout();
  }
  resetPingTimeout() {
    this.clearTimeoutFn(this.pingTimeoutTimer), this.pingTimeoutTimer = this.setTimeoutFn(() => {
      this.onClose("ping timeout");
    }, this.pingInterval + this.pingTimeout), this.opts.autoUnref && this.pingTimeoutTimer.unref();
  }
  onDrain() {
    this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const t = this.getWritablePackets();
      this.transport.send(t), this.prevBufferLen = t.length, this.emitReserved("flush");
    }
  }
  getWritablePackets() {
    if (!(this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let n = 1;
    for (let r = 0; r < this.writeBuffer.length; r++) {
      const s = this.writeBuffer[r].data;
      if (s && (n += fGe(s)), r > 0 && n > this.maxPayload)
        return this.writeBuffer.slice(0, r);
      n += 2;
    }
    return this.writeBuffer;
  }
  write(t, n, r) {
    return this.sendPacket("message", t, n, r), this;
  }
  send(t, n, r) {
    return this.sendPacket("message", t, n, r), this;
  }
  sendPacket(t, n, r, s) {
    if (typeof n == "function" && (s = n, n = void 0), typeof r == "function" && (s = r, r = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    r = r || {}, r.compress = r.compress !== !1;
    const f = {
      type: t,
      data: n,
      options: r
    };
    this.emitReserved("packetCreate", f), this.writeBuffer.push(f), s && this.once("flush", s), this.flush();
  }
  close() {
    const t = () => {
      this.onClose("forced close"), this.transport.close();
    }, n = () => {
      this.off("upgrade", n), this.off("upgradeError", n), t();
    }, r = () => {
      this.once("upgrade", n), this.once("upgradeError", n);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? r() : t();
    }) : this.upgrading ? r() : t()), this;
  }
  onError(t) {
    Oh.priorWebsocketSuccess = !1, this.emitReserved("error", t), this.onClose("transport error", t);
  }
  onClose(t, n) {
    (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") && (this.clearTimeoutFn(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), typeof removeEventListener == "function" && (removeEventListener("beforeunload", this.beforeunloadEventListener, !1), removeEventListener("offline", this.offlineEventListener, !1)), this.readyState = "closed", this.id = null, this.emitReserved("close", t, n), this.writeBuffer = [], this.prevBufferLen = 0);
  }
  filterUpgrades(t) {
    const n = [];
    let r = 0;
    const s = t.length;
    for (; r < s; r++)
      ~this.transports.indexOf(t[r]) && n.push(t[r]);
    return n;
  }
};
zW.protocol = AW;
function EGe(e, t = "", n) {
  let r = e;
  n = n || typeof location < "u" && location, e == null && (e = n.protocol + "//" + n.host), typeof e == "string" && (e.charAt(0) === "/" && (e.charAt(1) === "/" ? e = n.protocol + e : e = n.host + e), /^(https?|wss?):\/\//.test(e) || (typeof n < "u" ? e = n.protocol + "//" + e : e = "https://" + e), r = iS(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
  const f = r.host.indexOf(":") !== -1 ? "[" + r.host + "]" : r.host;
  return r.id = r.protocol + "://" + f + ":" + r.port + t, r.href = r.protocol + "://" + f + (n && n.port === r.port ? "" : ":" + r.port), r;
}
const AGe = typeof ArrayBuffer == "function", _Ge = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, LW = Object.prototype.toString, OGe = typeof Blob == "function" || typeof Blob < "u" && LW.call(Blob) === "[object BlobConstructor]", TGe = typeof File == "function" || typeof File < "u" && LW.call(File) === "[object FileConstructor]";
function Px(e) {
  return AGe && (e instanceof ArrayBuffer || _Ge(e)) || OGe && e instanceof Blob || TGe && e instanceof File;
}
function e1(e, t) {
  if (!e || typeof e != "object")
    return !1;
  if (Array.isArray(e)) {
    for (let n = 0, r = e.length; n < r; n++)
      if (e1(e[n]))
        return !0;
    return !1;
  }
  if (Px(e))
    return !0;
  if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1)
    return e1(e.toJSON(), !0);
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && e1(e[n]))
      return !0;
  return !1;
}
function RGe(e) {
  const t = [], n = e.data, r = e;
  return r.data = oS(n, t), r.attachments = t.length, { packet: r, buffers: t };
}
function oS(e, t) {
  if (!e)
    return e;
  if (Px(e)) {
    const n = { _placeholder: !0, num: t.length };
    return t.push(e), n;
  } else if (Array.isArray(e)) {
    const n = new Array(e.length);
    for (let r = 0; r < e.length; r++)
      n[r] = oS(e[r], t);
    return n;
  } else if (typeof e == "object" && !(e instanceof Date)) {
    const n = {};
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (n[r] = oS(e[r], t));
    return n;
  }
  return e;
}
function DGe(e, t) {
  return e.data = sS(e.data, t), e.attachments = void 0, e;
}
function sS(e, t) {
  if (!e)
    return e;
  if (e && e._placeholder === !0) {
    if (typeof e.num == "number" && e.num >= 0 && e.num < t.length)
      return t[e.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(e))
    for (let n = 0; n < e.length; n++)
      e[n] = sS(e[n], t);
  else if (typeof e == "object")
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (e[n] = sS(e[n], t));
  return e;
}
const NGe = 5;
var Rn;
(function(e) {
  e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})(Rn || (Rn = {}));
class WGe {
  constructor(t) {
    this.replacer = t;
  }
  encode(t) {
    return (t.type === Rn.EVENT || t.type === Rn.ACK) && e1(t) ? (t.type = t.type === Rn.EVENT ? Rn.BINARY_EVENT : Rn.BINARY_ACK, this.encodeAsBinary(t)) : [this.encodeAsString(t)];
  }
  encodeAsString(t) {
    let n = "" + t.type;
    return (t.type === Rn.BINARY_EVENT || t.type === Rn.BINARY_ACK) && (n += t.attachments + "-"), t.nsp && t.nsp !== "/" && (n += t.nsp + ","), t.id != null && (n += t.id), t.data != null && (n += JSON.stringify(t.data, this.replacer)), n;
  }
  encodeAsBinary(t) {
    const n = RGe(t), r = this.encodeAsString(n.packet), s = n.buffers;
    return s.unshift(r), s;
  }
}
class kx extends La {
  constructor(t) {
    super(), this.reviver = t;
  }
  add(t) {
    let n;
    if (typeof t == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      n = this.decodeString(t), n.type === Rn.BINARY_EVENT || n.type === Rn.BINARY_ACK ? (this.reconstructor = new jGe(n), n.attachments === 0 && super.emitReserved("decoded", n)) : super.emitReserved("decoded", n);
    } else if (Px(t) || t.base64)
      if (this.reconstructor)
        n = this.reconstructor.takeBinaryData(t), n && (this.reconstructor = null, super.emitReserved("decoded", n));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + t);
  }
  decodeString(t) {
    let n = 0;
    const r = {
      type: Number(t.charAt(0))
    };
    if (Rn[r.type] === void 0)
      throw new Error("unknown packet type " + r.type);
    if (r.type === Rn.BINARY_EVENT || r.type === Rn.BINARY_ACK) {
      const f = n + 1;
      for (; t.charAt(++n) !== "-" && n != t.length; )
        ;
      const m = t.substring(f, n);
      if (m != Number(m) || t.charAt(n) !== "-")
        throw new Error("Illegal attachments");
      r.attachments = Number(m);
    }
    if (t.charAt(n + 1) === "/") {
      const f = n + 1;
      for (; ++n && !(t.charAt(n) === "," || n === t.length); )
        ;
      r.nsp = t.substring(f, n);
    } else
      r.nsp = "/";
    const s = t.charAt(n + 1);
    if (s !== "" && Number(s) == s) {
      const f = n + 1;
      for (; ++n; ) {
        const m = t.charAt(n);
        if (m == null || Number(m) != m) {
          --n;
          break;
        }
        if (n === t.length)
          break;
      }
      r.id = Number(t.substring(f, n + 1));
    }
    if (t.charAt(++n)) {
      const f = this.tryParse(t.substr(n));
      if (kx.isPayloadValid(r.type, f))
        r.data = f;
      else
        throw new Error("invalid payload");
    }
    return r;
  }
  tryParse(t) {
    try {
      return JSON.parse(t, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(t, n) {
    switch (t) {
      case Rn.CONNECT:
        return typeof n == "object";
      case Rn.DISCONNECT:
        return n === void 0;
      case Rn.CONNECT_ERROR:
        return typeof n == "string" || typeof n == "object";
      case Rn.EVENT:
      case Rn.BINARY_EVENT:
        return Array.isArray(n) && n.length > 0;
      case Rn.ACK:
      case Rn.BINARY_ACK:
        return Array.isArray(n);
    }
  }
  destroy() {
    this.reconstructor && this.reconstructor.finishedReconstruction();
  }
}
class jGe {
  constructor(t) {
    this.packet = t, this.buffers = [], this.reconPack = t;
  }
  takeBinaryData(t) {
    if (this.buffers.push(t), this.buffers.length === this.reconPack.attachments) {
      const n = DGe(this.reconPack, this.buffers);
      return this.finishedReconstruction(), n;
    }
    return null;
  }
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const zGe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: kx,
  Encoder: WGe,
  get PacketType() {
    return Rn;
  },
  protocol: NGe
}, Symbol.toStringTag, { value: "Module" }));
function gl(e, t, n) {
  return e.on(t, n), function() {
    e.off(t, n);
  };
}
const LGe = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  newListener: 1,
  removeListener: 1
});
class IW extends La {
  constructor(t, n, r) {
    super(), this.connected = !1, this.receiveBuffer = [], this.sendBuffer = [], this.ids = 0, this.acks = {}, this.flags = {}, this.io = t, this.nsp = n, r && r.auth && (this.auth = r.auth), this.io._autoConnect && this.open();
  }
  get disconnected() {
    return !this.connected;
  }
  subEvents() {
    if (this.subs)
      return;
    const t = this.io;
    this.subs = [
      gl(t, "open", this.onopen.bind(this)),
      gl(t, "packet", this.onpacket.bind(this)),
      gl(t, "error", this.onerror.bind(this)),
      gl(t, "close", this.onclose.bind(this))
    ];
  }
  get active() {
    return !!this.subs;
  }
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  open() {
    return this.connect();
  }
  send(...t) {
    return t.unshift("message"), this.emit.apply(this, t), this;
  }
  emit(t, ...n) {
    if (LGe.hasOwnProperty(t))
      throw new Error('"' + t.toString() + '" is a reserved event name');
    n.unshift(t);
    const r = {
      type: Rn.EVENT,
      data: n
    };
    if (r.options = {}, r.options.compress = this.flags.compress !== !1, typeof n[n.length - 1] == "function") {
      const m = this.ids++, p = n.pop();
      this._registerAckCallback(m, p), r.id = m;
    }
    const s = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
    return this.flags.volatile && (!s || !this.connected) || (this.connected ? (this.notifyOutgoingListeners(r), this.packet(r)) : this.sendBuffer.push(r)), this.flags = {}, this;
  }
  _registerAckCallback(t, n) {
    const r = this.flags.timeout;
    if (r === void 0) {
      this.acks[t] = n;
      return;
    }
    const s = this.io.setTimeoutFn(() => {
      delete this.acks[t];
      for (let f = 0; f < this.sendBuffer.length; f++)
        this.sendBuffer[f].id === t && this.sendBuffer.splice(f, 1);
      n.call(this, new Error("operation has timed out"));
    }, r);
    this.acks[t] = (...f) => {
      this.io.clearTimeoutFn(s), n.apply(this, [null, ...f]);
    };
  }
  packet(t) {
    t.nsp = this.nsp, this.io._packet(t);
  }
  onopen() {
    typeof this.auth == "function" ? this.auth((t) => {
      this.packet({ type: Rn.CONNECT, data: t });
    }) : this.packet({ type: Rn.CONNECT, data: this.auth });
  }
  onerror(t) {
    this.connected || this.emitReserved("connect_error", t);
  }
  onclose(t, n) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", t, n);
  }
  onpacket(t) {
    if (t.nsp === this.nsp)
      switch (t.type) {
        case Rn.CONNECT:
          if (t.data && t.data.sid) {
            const s = t.data.sid;
            this.onconnect(s);
          } else
            this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case Rn.EVENT:
        case Rn.BINARY_EVENT:
          this.onevent(t);
          break;
        case Rn.ACK:
        case Rn.BINARY_ACK:
          this.onack(t);
          break;
        case Rn.DISCONNECT:
          this.ondisconnect();
          break;
        case Rn.CONNECT_ERROR:
          this.destroy();
          const r = new Error(t.data.message);
          r.data = t.data.data, this.emitReserved("connect_error", r);
          break;
      }
  }
  onevent(t) {
    const n = t.data || [];
    t.id != null && n.push(this.ack(t.id)), this.connected ? this.emitEvent(n) : this.receiveBuffer.push(Object.freeze(n));
  }
  emitEvent(t) {
    if (this._anyListeners && this._anyListeners.length) {
      const n = this._anyListeners.slice();
      for (const r of n)
        r.apply(this, t);
    }
    super.emit.apply(this, t);
  }
  ack(t) {
    const n = this;
    let r = !1;
    return function(...s) {
      r || (r = !0, n.packet({
        type: Rn.ACK,
        id: t,
        data: s
      }));
    };
  }
  onack(t) {
    const n = this.acks[t.id];
    typeof n == "function" && (n.apply(this, t.data), delete this.acks[t.id]);
  }
  onconnect(t) {
    this.id = t, this.connected = !0, this.emitBuffered(), this.emitReserved("connect");
  }
  emitBuffered() {
    this.receiveBuffer.forEach((t) => this.emitEvent(t)), this.receiveBuffer = [], this.sendBuffer.forEach((t) => {
      this.notifyOutgoingListeners(t), this.packet(t);
    }), this.sendBuffer = [];
  }
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  destroy() {
    this.subs && (this.subs.forEach((t) => t()), this.subs = void 0), this.io._destroy(this);
  }
  disconnect() {
    return this.connected && this.packet({ type: Rn.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  close() {
    return this.disconnect();
  }
  compress(t) {
    return this.flags.compress = t, this;
  }
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  timeout(t) {
    return this.flags.timeout = t, this;
  }
  onAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(t), this;
  }
  prependAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(t), this;
  }
  offAny(t) {
    if (!this._anyListeners)
      return this;
    if (t) {
      const n = this._anyListeners;
      for (let r = 0; r < n.length; r++)
        if (t === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  listenersAny() {
    return this._anyListeners || [];
  }
  onAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(t), this;
  }
  prependAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(t), this;
  }
  offAnyOutgoing(t) {
    if (!this._anyOutgoingListeners)
      return this;
    if (t) {
      const n = this._anyOutgoingListeners;
      for (let r = 0; r < n.length; r++)
        if (t === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  notifyOutgoingListeners(t) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const n = this._anyOutgoingListeners.slice();
      for (const r of n)
        r.apply(this, t.data);
    }
  }
}
function np(e) {
  e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
np.prototype.duration = function() {
  var e = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var t = Math.random(), n = Math.floor(t * this.jitter * e);
    e = Math.floor(t * 10) & 1 ? e + n : e - n;
  }
  return Math.min(e, this.max) | 0;
};
np.prototype.reset = function() {
  this.attempts = 0;
};
np.prototype.setMin = function(e) {
  this.ms = e;
};
np.prototype.setMax = function(e) {
  this.max = e;
};
np.prototype.setJitter = function(e) {
  this.jitter = e;
};
class lS extends La {
  constructor(t, n) {
    var r;
    super(), this.nsps = {}, this.subs = [], t && typeof t == "object" && (n = t, t = void 0), n = n || {}, n.path = n.path || "/socket.io", this.opts = n, Xw(this, n), this.reconnection(n.reconnection !== !1), this.reconnectionAttempts(n.reconnectionAttempts || 1 / 0), this.reconnectionDelay(n.reconnectionDelay || 1e3), this.reconnectionDelayMax(n.reconnectionDelayMax || 5e3), this.randomizationFactor((r = n.randomizationFactor) !== null && r !== void 0 ? r : 0.5), this.backoff = new np({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(n.timeout == null ? 2e4 : n.timeout), this._readyState = "closed", this.uri = t;
    const s = n.parser || zGe;
    this.encoder = new s.Encoder(), this.decoder = new s.Decoder(), this._autoConnect = n.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(t) {
    return arguments.length ? (this._reconnection = !!t, this) : this._reconnection;
  }
  reconnectionAttempts(t) {
    return t === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = t, this);
  }
  reconnectionDelay(t) {
    var n;
    return t === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = t, (n = this.backoff) === null || n === void 0 || n.setMin(t), this);
  }
  randomizationFactor(t) {
    var n;
    return t === void 0 ? this._randomizationFactor : (this._randomizationFactor = t, (n = this.backoff) === null || n === void 0 || n.setJitter(t), this);
  }
  reconnectionDelayMax(t) {
    var n;
    return t === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = t, (n = this.backoff) === null || n === void 0 || n.setMax(t), this);
  }
  timeout(t) {
    return arguments.length ? (this._timeout = t, this) : this._timeout;
  }
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  open(t) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new zW(this.uri, this.opts);
    const n = this.engine, r = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const s = gl(n, "open", function() {
      r.onopen(), t && t();
    }), f = gl(n, "error", (m) => {
      r.cleanup(), r._readyState = "closed", this.emitReserved("error", m), t ? t(m) : r.maybeReconnectOnOpen();
    });
    if (this._timeout !== !1) {
      const m = this._timeout;
      m === 0 && s();
      const p = this.setTimeoutFn(() => {
        s(), n.close(), n.emit("error", new Error("timeout"));
      }, m);
      this.opts.autoUnref && p.unref(), this.subs.push(function() {
        clearTimeout(p);
      });
    }
    return this.subs.push(s), this.subs.push(f), this;
  }
  connect(t) {
    return this.open(t);
  }
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const t = this.engine;
    this.subs.push(gl(t, "ping", this.onping.bind(this)), gl(t, "data", this.ondata.bind(this)), gl(t, "error", this.onerror.bind(this)), gl(t, "close", this.onclose.bind(this)), gl(this.decoder, "decoded", this.ondecoded.bind(this)));
  }
  onping() {
    this.emitReserved("ping");
  }
  ondata(t) {
    try {
      this.decoder.add(t);
    } catch (n) {
      this.onclose("parse error", n);
    }
  }
  ondecoded(t) {
    jW(() => {
      this.emitReserved("packet", t);
    }, this.setTimeoutFn);
  }
  onerror(t) {
    this.emitReserved("error", t);
  }
  socket(t, n) {
    let r = this.nsps[t];
    return r || (r = new IW(this, t, n), this.nsps[t] = r), r;
  }
  _destroy(t) {
    const n = Object.keys(this.nsps);
    for (const r of n)
      if (this.nsps[r].active)
        return;
    this._close();
  }
  _packet(t) {
    const n = this.encoder.encode(t);
    for (let r = 0; r < n.length; r++)
      this.engine.write(n[r], t.options);
  }
  cleanup() {
    this.subs.forEach((t) => t()), this.subs.length = 0, this.decoder.destroy();
  }
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close"), this.engine && this.engine.close();
  }
  disconnect() {
    return this._close();
  }
  onclose(t, n) {
    this.cleanup(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", t, n), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const t = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const n = this.backoff.duration();
      this._reconnecting = !0;
      const r = this.setTimeoutFn(() => {
        t.skipReconnect || (this.emitReserved("reconnect_attempt", t.backoff.attempts), !t.skipReconnect && t.open((s) => {
          s ? (t._reconnecting = !1, t.reconnect(), this.emitReserved("reconnect_error", s)) : t.onreconnect();
        }));
      }, n);
      this.opts.autoUnref && r.unref(), this.subs.push(function() {
        clearTimeout(r);
      });
    }
  }
  onreconnect() {
    const t = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", t);
  }
}
const Tv = {};
function t1(e, t) {
  typeof e == "object" && (t = e, e = void 0), t = t || {};
  const n = EGe(e, t.path || "/socket.io"), r = n.source, s = n.id, f = n.path, m = Tv[s] && f in Tv[s].nsps, p = t.forceNew || t["force new connection"] || t.multiplex === !1 || m;
  let v;
  return p ? v = new lS(r, t) : (Tv[s] || (Tv[s] = new lS(r, t)), v = Tv[s]), n.query && !t.query && (t.query = n.queryKey), v.socket(n.path, t);
}
Object.assign(t1, {
  Manager: lS,
  Socket: IW,
  io: t1,
  connect: t1
});
function FW(e) {
  return e.trim().split(/^(?:-\w+-)*linear-gradient\((?:.*?(top|bottom|left|right|deg)\s*,\s*)*/)[2].replace(/\s*\)\s*;*$/, "").replace(/\s*,\s*/g, ",").split(/,(?=\D)/).map(function(t) {
    return t.split(" ")[0];
  });
}
var HW = T.createContext(null);
function Xi() {
  return function(e) {
    if (e == null)
      throw new Error("Component must be wrapped within the NovuProvider before using hooks from @novu/notification-center");
    return e;
  }(F.exports.useContext(HW));
}
var IGe = ["session"], FGe = ["organization"], wg = ["infinite_notifications"], uS = ["user_preferences"], sT = ["unseen_count"], VW = ["feed_unseen_count"], lT = function(e) {
  document.dispatchEvent(new CustomEvent("novu:unseen_count_changed", { detail: e }));
}, HGe = function(e) {
  e === void 0 && (e = {});
  var t = e.onSuccess, n = Us(e, ["onSuccess"]), r = Xi(), s = r.apiService, f = r.socket, m = r.isSessionInitialized, p = r.fetchingStrategy, v = mm();
  return F.exports.useEffect(function() {
    return f ? (f.on("unseen_count_changed", function(y) {
      Number.isInteger(y == null ? void 0 : y.unseenCount) && (v.setQueryData(sT, function(w) {
        var P;
        return { count: (P = y == null ? void 0 : y.unseenCount) !== null && P !== void 0 ? P : w.count };
      }), v.refetchQueries(wg, { exact: !1 }), v.refetchQueries(VW, { exact: !1 }), lT(y.unseenCount));
    }), function() {
      f.off("unseen_count_changed");
    }) : function() {
    };
  }, [f, v]), bg(sT, function() {
    return s.getUnseenCount();
  }, bt(bt({}, n), { enabled: m && p.fetchUnseenCount, onSuccess: function(y) {
    lT(y.count), t == null || t(y);
  } }));
}, BW = T.createContext(null);
function xc() {
  return F.exports.useContext(BW);
}
var UW = T.createContext({ colorScheme: "light", theme: null, common: null });
function Fo() {
  var e = F.exports.useContext(UW);
  return { colorScheme: e.colorScheme, theme: e.theme, common: e.common };
}
var $x = T.createContext({ onUrlChange: function(e) {
}, onNotificationClick: function(e) {
}, onUnseenCountChanged: function(e) {
}, onActionClick: function(e, t, n) {
}, isLoading: !0, header: null, footer: null, emptyState: null, listItem: null, actionsResultBlock: null, tabs: [], showUserPreferences: !0, allowedNotificationActions: !0, onTabClick: function(e) {
} });
function rp() {
  var e = F.exports.useContext($x);
  return { onUrlChange: e.onUrlChange, onNotificationClick: e.onNotificationClick, onActionClick: e.onActionClick, isLoading: e.isLoading, header: e.header, footer: e.footer, emptyState: e.emptyState, listItem: e.listItem, actionsResultBlock: e.actionsResultBlock, tabs: e.tabs, showUserPreferences: e.showUserPreferences, allowedNotificationActions: e.allowedNotificationActions, onTabClick: e.onTabClick };
}
var XW = { af: { translations: { notifications: "Kennisgewings", markAllAsRead: "Merk alles as gelees", poweredBy: "Aangedryf deur", settings: "Instellings" }, lang: "af" }, am: { translations: { notifications: "ማሳወቂያዎች", markAllAsRead: "ሁሉንም እንደተነበቡ ምልክት ያድርጉበት", poweredBy: "የተጎላበተ በ", settings: "ቅንብሮች" }, lang: "am" }, ar: { translations: { notifications: "إشعارات", markAllAsRead: "اشر عليها بانها قرات", poweredBy: "مشغل بواسطة", settings: "الإعدادات" }, lang: "ar" }, as: { translations: { notifications: "জাননীসমূহ", markAllAsRead: "সকলো পঢ়া হিচাপে চিহ্নিত কৰক", poweredBy: "দ্বাৰা সমৰ্থিত", settings: "ছেটিংছ" }, lang: "as" }, az: { translations: { notifications: "Bildirişlər", markAllAsRead: "Hamısını oxunmuş olaraq işarələ", poweredBy: "tərəfindən təchiz edilmişdir", settings: "Qəbulu" }, lang: "az" }, be: { translations: { notifications: "Паведамленнi", markAllAsRead: "Пазначыць усе як прачытаныя", poweredBy: "Пры падтрымцы", settings: "Налады" }, lang: "be" }, bg: { translations: { notifications: "известия", markAllAsRead: "маркирай всички като прочетени", poweredBy: "задвижвани от", settings: "настройки" }, lang: "bg" }, bh: { translations: { notifications: "सूचनाएं", markAllAsRead: "सभी को पढ़ा हुआ चिन्हित करें", poweredBy: "द्वारा संचालित", settings: "सेटिंग्स" }, lang: "bh" }, bn: { translations: { notifications: "নোটিফিকেশন", markAllAsRead: "সবগুলো পড়া হয়েছে", poweredBy: "পাওয়ার্ড বাই", settings: "সেটিংস" }, lang: "bn" }, bs: { translations: { notifications: "Obavještenja", markAllAsRead: "Označi sve kao pročitano", poweredBy: "Pokreće", settings: "Postavke" }, lang: "bs" }, ca: { translations: { notifications: "Notificacions", markAllAsRead: "marcar tot com a llegit", poweredBy: "Amb la tecnologia de", settings: "Configuració" }, lang: "ca" }, cs: { translations: { notifications: "Oznámení", markAllAsRead: "Označit všechna jako přečtená", poweredBy: "Přináší", settings: "Nastavení" }, lang: "cs" }, da: { translations: { notifications: "Meddelelser", markAllAsRead: "Markér alle som læst", poweredBy: "Drevet af", settings: "Indstillinger" }, lang: "da" }, de: { translations: { notifications: "Benachrichtigungen", markAllAsRead: "Alle als gelesen markieren", poweredBy: "von", settings: "Einstellungen" }, lang: "de" }, el: { translations: { notifications: "ειδοποιήσεις", markAllAsRead: "επισημάνετε όλα ως αναγνωσμένα", poweredBy: "τροφοδοτείται από", settings: "Ρυθμίσεις" }, lang: "el" }, en: { translations: { notifications: "Notifications", markAllAsRead: "Mark all as read", poweredBy: "Powered By", settings: "Settings", removeMessage: "Remove Message", markAsRead: "Mark as Read", markAsUnRead: "Mark as Unread" }, lang: "en" }, es: { translations: { notifications: "Notificaciones", markAllAsRead: "marcar todo como leído", poweredBy: "Con tecnología de", settings: "Configuración" }, lang: "es" }, eu: { translations: { notifications: "Notificacionespenak", markAllAsRead: "Markatu guztiak irakurrita bezala", poweredBy: "Bultzatuta", settings: "Ezarpenak" }, lang: "eu" }, fa: { translations: { notifications: "اطلاعیه", markAllAsRead: "همه را به عنوان خوانده شده علامت بزن", poweredBy: "پشتیبانی شده توسط", settings: "تنظيمات" }, lang: "fa" }, fi: { translations: { notifications: "Ilmoitukset", markAllAsRead: "Merkkaa luetuksi", poweredBy: "Ilmoitukset mahdollistaa", settings: "Asetukset" }, lang: "fi" }, fr: { translations: { notifications: "Notifications", markAllAsRead: "Tout marquer comme lus", poweredBy: "Propulsé par", settings: "Paramètres" }, lang: "fr" }, ga: { translations: { notifications: "Fógraí", markAllAsRead: "Marcáil go léir mar a léitear", poweredBy: "Cumhachtaithe ag", settings: "Socruithe" }, lang: "ga" }, gl: { translations: { notifications: "Notificacións", markAllAsRead: "Marcar todo coma lido", poweredBy: "Coa tecnoloxía de", settings: "Axustes" }, lang: "gl" }, gu: { translations: { notifications: "સૂચના", markAllAsRead: "બધાને વાંચેલા તરીકે ચિહ્નિત કરો", poweredBy: "દ્વારા સંચાલિત", settings: "સેટિંગ્સ" }, lang: "gu" }, he: { translations: { notifications: "התראות", markAllAsRead: "סמן הכל כנקרא", poweredBy: "נתמך על ידי", settings: "הגדרות" }, lang: "he" }, hi: { translations: { notifications: "सूचनाएं", markAllAsRead: "सभी को पढ़ा हुआ चिन्हित करें", poweredBy: "द्वारा संचालित", settings: "सेटिंग्स" }, lang: "hi" }, hr: { translations: { notifications: "Obavijesti", markAllAsRead: "Označi sve kao pročitano", poweredBy: "Uz podršku", settings: "Postavke" }, lang: "hr" }, hu: { translations: { notifications: "értesítéseket", markAllAsRead: "összes megjelölése olvasottként", poweredBy: "támogatta", settings: "beállítások" }, lang: "hu" }, hy: { translations: { notifications: "ծանուցումներ", markAllAsRead: "նշել բոլորը որպես կարդացված", poweredBy: "աջակցվում է", settings: "կարգավորումներ" }, lang: "hy" }, id: { translations: { notifications: "Notifikasi", markAllAsRead: "Tandai semua sudah dibaca", poweredBy: "Dipersembahkan Oleh", settings: "Pengaturan" }, lang: "id" }, ig: { translations: { notifications: "Ngosi", markAllAsRead: "kaa ihe niile ka agụlaha", poweredBy: "kwadoro site na", settings: "Mwube gasị" }, lang: "ig" }, it: { translations: { notifications: "Notifiche", markAllAsRead: "Segna tutti come letti", poweredBy: "Offerto da", settings: "Impostazioni" }, lang: "it" }, ja: { translations: { notifications: "通知", markAllAsRead: "すべて既読にする", poweredBy: "搭載", settings: "設定" }, lang: "ja" }, ka: { translations: { notifications: "ಅಧಿಸೂಚನೆಗಳು", markAllAsRead: "ಎಲ್ಲವನ್ನು ಓದಲಾಗಿದೆ ಎಂದು ಗುರುತಿಸಿ", poweredBy: "ಮೂಲಕ ನಡೆಸಲ್ಪಡುತ್ತಿದೆ", settings: "ಸಂಯೋಜನೆಗಳು" }, lang: "ka" }, kk: { translations: { notifications: "Хабарландырулар", markAllAsRead: "барлығын оқылған деп белгілеңіз", poweredBy: "задвижвани от", settings: "көмегімен" }, lang: "kk" }, km: { translations: { notifications: "សារជូនដំណឹង", markAllAsRead: "បានអានទាំងអស់", poweredBy: "ដំណើរការដោយ", settings: "ការកំណត់" }, lang: "km" }, ko: { translations: { notifications: "알림", markAllAsRead: "모두 읽은 상태로 표시", poweredBy: "에 의해 구동", settings: "설정" }, lang: "ko" }, ku: { translations: { notifications: "ئاگادارکردنەوەکان", markAllAsRead: "هەموویان وەک خوێندراوێک نیشانە بکە", poweredBy: "بەهێزکراوە لەلایەن", settings: "دانانەوە" }, lang: "ku" }, lo: { translations: { notifications: "ການແຈ້ງເຕືອນ", markAllAsRead: "ໝາຍທັງໝົດວ່າອ່ານແລ້ວ", poweredBy: "ສະ​ຫນັບ​ສະ​ຫນູນ​ໂດຍ", settings: "ການຕັ້ງຄ່າ" }, lang: "lo" }, lt: { translations: { notifications: "Pranešimai", markAllAsRead: "Pažymėti visus kaip skaitytus", poweredBy: "Sukurta", settings: "Nustatymai" }, lang: "lt" }, lv: { translations: { notifications: "Paziņojumi", markAllAsRead: "Atzīmēt visus kā lasītus", poweredBy: "Izstrādāts", settings: "Iestatījumi" }, lang: "lv" }, ml: { translations: { notifications: "അറിയിപ്പുകൾ", markAllAsRead: "എല്ലാം വായിച്ചതായി അടയാളപ്പെടുത്തുക", poweredBy: "പ്രായോജകർ", settings: "ക്രമീകരണങ്ങൾ" }, lang: "ml" }, mr: { translations: { notifications: "अधिसूचना", markAllAsRead: "सर्व वाचलेले म्हणून चिन्हांकित करा", poweredBy: "द्वारे समर्थित", settings: "सेटिंग्ज" }, lang: "mr" }, ms: { translations: { notifications: "Pemberitahuan", markAllAsRead: "Tandakan semua sebagai telah dibaca", poweredBy: "Dikuasai oleh", settings: "Tetapan" }, lang: "ms" }, ne: { translations: { notifications: "सूचनाहरू", markAllAsRead: "सबै पढेको रूपमा चिन्ह लगाउनुहोस्", poweredBy: "द्वारा संचालित", settings: "सेटिङहरू" }, lang: "ne" }, nl: { translations: { notifications: "Notificaties", markAllAsRead: "Markeer alles als gelezen", poweredBy: "Aangedreven door", settings: "Instellingen" }, lang: "nl" }, nb: { translations: { notifications: "Varsler", markAllAsRead: "Marker alle som lest", poweredBy: "Drevet av", settings: "Innstillinger" }, lang: "nb" }, or: { translations: { notifications: "ବିଜ୍ଞପ୍ତି", markAllAsRead: "ସମସ୍ତଙ୍କୁ ପଢ଼ିଥିବା ପରି ଚିହ୍ନିତ କର", poweredBy: "ଦ୍ୱାରା ପରିଚାଳିତ", settings: "ସେଟିଂ" }, lang: "or" }, pa: { translations: { notifications: "ਸੂਚਨਾਵਾਂ", markAllAsRead: " ਸਭ ਨੂੰ ਪੜ੍ਹਿਆ ਹੋਇਆ ਮਾਰਕ ਕਰੋ", poweredBy: "ਦੁਆਰਾ ਸੰਚਾਲਿਤ", settings: "ਸੈਟਿੰਗਾਂ" }, lang: "pa" }, pl: { translations: { notifications: "Notyfikacje", markAllAsRead: "Oznacz wszystkie jako przeczytane", poweredBy: "Napędzany przez", settings: "Ustawienia" }, lang: "pl" }, pt: { translations: { notifications: "Notificações", markAllAsRead: "Marcar tudo como lido", poweredBy: "Desenvolvido por", settings: "Configurações" }, lang: "pt" }, ro: { translations: { notifications: "Notificări", markAllAsRead: "Marcheaza totul ca fiind citit", poweredBy: "Cu sprijinul", settings: "Setări" }, lang: "ro" }, ru: { translations: { notifications: "Уведомления", markAllAsRead: "Пометить все как прочитанные", poweredBy: "При поддержке", settings: "Настройки" }, lang: "ru" }, sa: { translations: { notifications: "अधिसूचनाः", markAllAsRead: "सर्वं पठितम् इति सूचनीयम्", poweredBy: "द्वारा संचालितः", settings: "संस्थापनम्" }, lang: "sa" }, sd: { translations: { notifications: "نوٽيفڪيشن", markAllAsRead: "سڀني کي پڙهيل طور نشان لڳايو", poweredBy: "پاران تيار ڪيل", settings: "سيٽنگون" }, lang: "sd" }, si: { translations: { notifications: "දැනුම්දීම්", markAllAsRead: "සියල්ල කියවූ ලෙස ලකුණු කරන්න", poweredBy: "බලගැන්වීම", settings: "සැකසුම්" }, lang: "si" }, sm: { translations: { notifications: "faasilasilaga", markAllAsRead: "faailoga Mea uma e pei ona Faitau", poweredBy: "fa amalosia ", settings: "faatulagaga" }, lang: "sm" }, sq: { translations: { notifications: "Njoftimet", markAllAsRead: "Shënoni të gjitha si të lexuara", poweredBy: "Mundësuar nga", settings: "Cilësimet" }, lang: "sq" }, sv: { translations: { notifications: "Meddelanden", markAllAsRead: "Markera alla som lästa", poweredBy: "Använder", settings: "Inställningar" }, lang: "sv" }, ta: { translations: { notifications: "அறிவிப்புகள்", markAllAsRead: "அனைத்தையும் வாசிக்கப்பட்டதாக அடையாளமிடு", poweredBy: "மூலம் இயக்கப்படுகிறது", settings: "செட்டிங்ஸ்" }, lang: "ta" }, te: { translations: { notifications: "నోటిఫికేషన్‌లు", markAllAsRead: "అన్నీచదివినట్లుగా సూచించు", poweredBy: "ద్వారా ఆధారితం", settings: "సెట్టింగ్‌లు" }, lang: "te" }, th: { translations: { notifications: "การแจ้งเตือน", markAllAsRead: "ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว", poweredBy: "ขับเคลื่อนโดย", settings: "การตั้งค่า" }, lang: "th" }, tl: { translations: { notifications: "Notipikasyon", markAllAsRead: "Markahan ang lahat bilang nabasa", poweredBy: "Pinagagana ng", settings: "Settings" }, lang: "tl" }, tr: { translations: { notifications: "Bildirimler", markAllAsRead: "Hepsini okundu olarak işaretle", poweredBy: "Tarafından desteklenmektedir", settings: "Ayarlar" }, lang: "tr" }, uk: { translations: { notifications: "Сповіщення", markAllAsRead: "Позначити все як прочитані", poweredBy: "На підтримці", settings: "Налаштування" }, lang: "uk" }, ur: { translations: { notifications: "اطلاع", markAllAsRead: "سب کو پڑھا ہوا شمار کریں", poweredBy: "طاقت کے ذریعے", settings: "ترتیبات" }, lang: "ur" }, uz: { translations: { notifications: "Bildirishnomalar", markAllAsRead: "Hammasini o'qing deb belgilang", poweredBy: "Tomonidan qo'llab-quvvatlanadi", settings: "Sozlamalar" }, lang: "uz" }, vi: { translations: { notifications: "Thông báo", markAllAsRead: "đánh dấu tất cả như đã đọc", poweredBy: "Được cung cấp bởi", settings: "Cài đặt" }, lang: "vi" }, zh: { translations: { notifications: "通知", markAllAsRead: "将所有标记为已读", poweredBy: "技术支持", settings: "设置" }, lang: "zh" }, zu: { translations: { notifications: "Izaziso", markAllAsRead: "Maka konke njengokufundiwe", poweredBy: "Inikezwe amandla yi", settings: "Izilungiselelo" }, lang: "zu" }, ba: { translations: { notifications: "Иҫкәрмәләр", markAllAsRead: "Барыһын да уҡылғанса тамғалағыҙ", poweredBy: "Эшләй", settings: "Көйләүҙәре" }, lang: "ba" } }, qW = T.createContext({ translations: { markAllAsRead: "", notifications: "", poweredBy: "", settings: "", removeMessage: "", markAsRead: "", markAsUnRead: "" }, lang: "" });
function VGe(e) {
  var t = e.i18n, n = t === void 0 ? "en" : t, r = Us(e, ["i18n"]), s = T.useMemo(function() {
    return typeof n == "string" ? { translations: XW[n].translations, lang: n } : n;
  }, [n]);
  return T.createElement(qW.Provider, bt({}, r, { value: s }));
}
function qw() {
  var e = F.exports.useContext(qW), t = e.translations, n = e.lang;
  return { lang: n, t: function(r) {
    return t[r] || XW.en.translations[r];
  }, dateFnsLocale: function() {
    return n in QO ? QO[n] : lx;
  } };
}
var BGe = function(e) {
  e === void 0 && (e = {});
  var t = e.onSuccess, n = e.onError, r = Us(e, ["onSuccess", "onError"]), s = mm(), f = Xi().apiService, m = F.exports.useCallback(function(P) {
    var x = P.templateId, A = P.checked, M = P.channelType;
    s.setQueryData(uS, function(O) {
      return O.map(function(j) {
        var H;
        return j.template._id === x ? bt(bt({}, j), { preference: bt(bt({}, j.preference), { channels: bt(bt({}, j.preference.channels), (H = {}, H[M] = A, H)) }) }) : j;
      });
    });
  }, [s]), p = Uw(function(P) {
    return f.updateSubscriberPreference(P.templateId, P.channelType, P.checked);
  }, bt(bt({}, r), { onSuccess: function(P, x, A) {
    s.setQueryData(uS, function(M) {
      return M.map(function(O) {
        return O.template._id === P.template._id ? P : O;
      });
    }), t == null || t(P, x, A);
  }, onError: function(P, x, A) {
    m({ templateId: x.templateId, checked: !x.checked, channelType: x.channelType }), n == null || n(P, x, A);
  } })), v = p.mutate, y = Us(p, ["mutate"]), w = F.exports.useCallback(function(P) {
    m(P), v(P);
  }, [m, v]);
  return bt(bt({}, y), { updateUserPreferences: w });
}, UGe = function(e) {
  e === void 0 && (e = {});
  var t = e.onSuccess, n = Us(e, ["onSuccess"]), r = mm(), s = Xi().apiService, f = Uw(function(v) {
    return s.updateAction(v.messageId, v.actionButtonType, v.status, v.payload);
  }, bt(bt({}, n), { onSuccess: function(v, y, w) {
    r.setQueriesData({ queryKey: wg, exact: !1 }, function(P) {
      var x = P.pages.map(function(A) {
        var M = A.data.map(function(O) {
          return O._id === y.messageId ? v : O;
        });
        return bt(bt({}, A), { data: M });
      });
      return { pageParams: P.pageParams, pages: x };
    }), t == null || t(v, y, w);
  } })), m = f.mutate, p = Us(f, ["mutate"]);
  return bt(bt({}, p), { updateAction: m });
}, XGe = function(e) {
  return (e.page + 1) * e.pageSize < e.totalCount ? e.page + 1 : void 0;
}, qGe = function(e, t) {
  var n = e.query;
  t === void 0 && (t = {});
  var r = Xi(), s = r.apiService, f = r.isSessionInitialized, m = r.fetchingStrategy, p = Ste(Bs(Bs([], Cn(wg), !1), [n], !1), function(v) {
    var y = v.pageParam, w = y === void 0 ? 0 : y;
    return s.getNotificationsList(w, n);
  }, bt(bt({}, t), { enabled: f && m.fetchNotifications, getNextPageParam: XGe }));
  return p;
}, YW = function(e) {
  e === void 0 && (e = {});
  var t = Xi(), n = t.apiService, r = t.isSessionInitialized, s = t.fetchingStrategy;
  return bg(FGe, function() {
    return n.getOrganization();
  }, bt(bt({}, e), { enabled: r && s.fetchOrganization }));
}, YGe = function(e, t) {
  var n = e.query;
  t === void 0 && (t = {});
  var r = Xi(), s = r.apiService, f = r.isSessionInitialized;
  return bg(Bs(Bs([], Cn(VW), !1), [n], !1), function() {
    return s.getTabCount(n);
  }, bt(bt({}, t), { enabled: f }));
}, GGe = function(e) {
  e === void 0 && (e = {});
  var t = Xi(), n = t.apiService, r = t.isSessionInitialized, s = t.fetchingStrategy;
  return bg(uS, function() {
    return n.getUserPreference();
  }, bt(bt({}, e), { enabled: r && s.fetchUserPreferences }));
}, QGe = function(e) {
  e === void 0 && (e = {});
  var t = e.onSuccess, n = Us(e, ["onSuccess"]), r = mm(), s = Xi().apiService, f = Uw(function(v) {
    var y = v.messageId, w = v.seen, P = v.read;
    return s.markMessageAs(y, { seen: w, read: P });
  }, bt(bt({}, n), { onSuccess: function(v, y, w) {
    r.setQueriesData({ queryKey: wg, exact: !1 }, function(P) {
      var x = P.pages.map(function(A) {
        var M = A.data.map(function(O) {
          var j = v.find(function(H) {
            return H._id === O._id;
          });
          return j || O;
        });
        return bt(bt({}, A), { data: M });
      });
      return { pageParams: P.pageParams, pages: x };
    }), t == null || t(v, y, w);
  } })), m = f.mutate, p = Us(f, ["mutate"]);
  return bt(bt({}, p), { markNotificationsAs: m });
}, KGe = function(e) {
  e === void 0 && (e = {});
  var t = e.onSuccess, n = Us(e, ["onSuccess"]), r = mm(), s = Xi().apiService, f = Uw(function(v) {
    var y = v.messageId;
    return s.removeMessage(y);
  }, bt(bt({}, n), { onSuccess: function(v, y, w) {
    r.refetchQueries(wg, { exact: !1 }), t == null || t(v, y, w);
  } })), m = f.mutate, p = Us(f, ["mutate"]);
  return bt(bt({}, p), { removeNotification: m });
}, Nh = function(e) {
  var t = e.styles, n = e.path, r = e.theme, s = e.common, f = e.colorScheme;
  if (t) {
    var m = function(p, v) {
      return v.split(".").reduce(function(y, w) {
        return y && y[w];
      }, p);
    }(t, n);
    return typeof m == "function" ? m({ theme: r, common: s, colorScheme: f }) : m;
  }
}, GW = F.exports.createContext(void 0), _i = function(e) {
  var t = F.exports.useContext(GW), n = Fo(), r = n.theme, s = n.colorScheme, f = n.common;
  if (!t)
    throw new Error("useStyles must be used within a StylesProvider");
  return Array.isArray(e) ? e.map(function(m) {
    return Nh({ styles: t.styles, path: m, theme: r, common: f, colorScheme: s });
  }) : [Nh({ styles: t.styles, path: e, theme: r, common: f, colorScheme: s })];
}, JGe = function(e) {
  var t = e.styles, n = e.children, r = F.exports.useMemo(function() {
    return { styles: t };
  }, [t]);
  return T.createElement(GW.Provider, { value: r }, n);
}, Yw = function(e) {
  var t = e.color, n = Fo().theme, r = Cn(_i(["loader.root"]), 1)[0], s = t || n.loaderColor;
  return T.createElement("div", { style: { textAlign: "center", minHeight: 300, display: "flex", alignItems: "center", justifyContent: "center" } }, T.createElement(mg, { className: hn("nc-loader", mt(r)), color: s.indexOf("gradient") === -1 ? s : F5.average(FW(s)) }));
};
function QW(e) {
  var t = e.colors.unseenBadgeColor, n = typeof t == "string";
  return T.createElement("svg", bt({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, e), T.createElement("rect", { x: "1.5", y: "1.5", width: "13", height: "13", rx: "6.5", fill: "url(#paint0_linear_1722_2699)", stroke: e.colors.unseenBadgeBackgroundColor, strokeWidth: "3" }), T.createElement("defs", null, T.createElement("linearGradient", { id: "paint0_linear_1722_2699", x1: "8", y1: "13", x2: "8", y2: "3", gradientUnits: "userSpaceOnUse" }, T.createElement("stop", { stopColor: n ? t : t.stopColor }), T.createElement("stop", { offset: "1", stopColor: n ? t : t.stopColorOffset }))));
}
function ZGe(e) {
  return T.createElement("svg", bt({ width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M20.625 15.5C20.625 16.5547 21.4453 17.375 22.5 17.375C23.5156 17.375 24.375 16.5547 24.375 15.5C24.375 14.4844 23.5156 13.625 22.5 13.625C21.4453 13.625 20.625 14.4844 20.625 15.5ZM9.375 15.5C9.375 14.4844 8.51562 13.625 7.5 13.625C6.44531 13.625 5.625 14.4844 5.625 15.5C5.625 16.5547 6.44531 17.375 7.5 17.375C8.51562 17.375 9.375 16.5547 9.375 15.5ZM16.875 15.5C16.875 14.4844 16.0156 13.625 15 13.625C13.9453 13.625 13.125 14.4844 13.125 15.5C13.125 16.5547 13.9453 17.375 15 17.375C16.0156 17.375 16.875 16.5547 16.875 15.5Z", fill: "currentColor" }));
}
function KW(e) {
  return T.createElement("svg", bt({ width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M21.6667 10.8C21.6667 8.99653 20.9643 7.26692 19.714 5.99167C18.4638 4.71643 16.7681 4 15 4C13.2319 4 11.5362 4.71643 10.286 5.99167C9.03571 7.26692 8.33333 8.99653 8.33333 10.8C8.33333 18.7333 5 21 5 21H25C25 21 21.6667 18.7333 21.6667 10.8Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }), T.createElement("path", { d: "M17.7295 24C17.4521 24.6072 17.0539 25.1113 16.5748 25.4617C16.0956 25.812 15.5524 25.9965 14.9995 25.9965C14.4466 25.9965 13.9034 25.812 13.4243 25.4617C12.9452 25.1113 12.547 24.6072 12.2695 24", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}
function eQe(e) {
  return T.createElement("svg", bt({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("g", { clipPath: "url(#clip0_2596_30864)" }, T.createElement("path", { d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }), T.createElement("path", { d: "M16.1663 12.4999C16.0554 12.7513 16.0223 13.0301 16.0713 13.3004C16.1204 13.5707 16.2492 13.8202 16.4413 14.0166L16.4913 14.0666C16.6463 14.2214 16.7692 14.4052 16.8531 14.6075C16.937 14.8098 16.9802 15.0267 16.9802 15.2458C16.9802 15.4648 16.937 15.6817 16.8531 15.884C16.7692 16.0863 16.6463 16.2701 16.4913 16.4249C16.3366 16.5799 16.1527 16.7028 15.9504 16.7867C15.7481 16.8706 15.5312 16.9137 15.3122 16.9137C15.0931 16.9137 14.8763 16.8706 14.6739 16.7867C14.4716 16.7028 14.2878 16.5799 14.133 16.4249L14.083 16.3749C13.8866 16.1828 13.6372 16.0539 13.3668 16.0049C13.0965 15.9559 12.8177 15.989 12.5663 16.0999C12.3199 16.2056 12.1097 16.381 11.9616 16.6045C11.8135 16.8281 11.7341 17.0901 11.733 17.3583V17.4999C11.733 17.9419 11.5574 18.3659 11.2449 18.6784C10.9323 18.991 10.5084 19.1666 10.0663 19.1666C9.62431 19.1666 9.20039 18.991 8.88783 18.6784C8.57527 18.3659 8.39967 17.9419 8.39967 17.4999V17.4249C8.39322 17.1491 8.30394 16.8816 8.14343 16.6572C7.98293 16.4328 7.75862 16.2618 7.49967 16.1666C7.24833 16.0557 6.96951 16.0226 6.69918 16.0716C6.42885 16.1206 6.17941 16.2495 5.98301 16.4416L5.93301 16.4916C5.77822 16.6465 5.5944 16.7695 5.39207 16.8533C5.18974 16.9372 4.97287 16.9804 4.75384 16.9804C4.53481 16.9804 4.31794 16.9372 4.11561 16.8533C3.91328 16.7695 3.72946 16.6465 3.57467 16.4916C3.41971 16.3368 3.29678 16.153 3.21291 15.9507C3.12903 15.7483 3.08586 15.5314 3.08586 15.3124C3.08586 15.0934 3.12903 14.8765 3.21291 14.6742C3.29678 14.4719 3.41971 14.288 3.57467 14.1332L3.62467 14.0833C3.81679 13.8869 3.94566 13.6374 3.99468 13.3671C4.04369 13.0967 4.0106 12.8179 3.89967 12.5666C3.79404 12.3201 3.61864 12.1099 3.39506 11.9618C3.17149 11.8138 2.9095 11.7343 2.64134 11.7333H2.49967C2.05765 11.7333 1.63372 11.5577 1.32116 11.2451C1.0086 10.9325 0.833008 10.5086 0.833008 10.0666C0.833008 9.62456 1.0086 9.20063 1.32116 8.88807C1.63372 8.57551 2.05765 8.39992 2.49967 8.39992H2.57467C2.8505 8.39347 3.11801 8.30418 3.34242 8.14368C3.56684 7.98317 3.73777 7.75886 3.83301 7.49992C3.94394 7.24857 3.97703 6.96976 3.92801 6.69943C3.879 6.4291 3.75012 6.17965 3.55801 5.98325L3.50801 5.93325C3.35305 5.77846 3.23012 5.59465 3.14624 5.39232C3.06237 5.18999 3.0192 4.97311 3.0192 4.75408C3.0192 4.53506 3.06237 4.31818 3.14624 4.11585C3.23012 3.91352 3.35305 3.72971 3.50801 3.57492C3.6628 3.41996 3.84661 3.29703 4.04894 3.21315C4.25127 3.12928 4.46815 3.08611 4.68717 3.08611C4.9062 3.08611 5.12308 3.12928 5.32541 3.21315C5.52774 3.29703 5.71155 3.41996 5.86634 3.57492L5.91634 3.62492C6.11274 3.81703 6.36219 3.94591 6.63252 3.99492C6.90285 4.04394 7.18166 4.01085 7.43301 3.89992H7.49967C7.74615 3.79428 7.95635 3.61888 8.10442 3.39531C8.25248 3.17173 8.33194 2.90974 8.33301 2.64159V2.49992C8.33301 2.05789 8.5086 1.63397 8.82116 1.32141C9.13372 1.00885 9.55765 0.833252 9.99967 0.833252C10.4417 0.833252 10.8656 1.00885 11.1782 1.32141C11.4907 1.63397 11.6663 2.05789 11.6663 2.49992V2.57492C11.6674 2.84307 11.7469 3.10506 11.8949 3.32864C12.043 3.55221 12.2532 3.72762 12.4997 3.83325C12.751 3.94418 13.0298 3.97727 13.3002 3.92826C13.5705 3.87924 13.8199 3.75037 14.0163 3.55825L14.0663 3.50825C14.2211 3.35329 14.4049 3.23036 14.6073 3.14649C14.8096 3.06261 15.0265 3.01944 15.2455 3.01944C15.4645 3.01944 15.6814 3.06261 15.8837 3.14649C16.0861 3.23036 16.2699 3.35329 16.4247 3.50825C16.5796 3.66304 16.7026 3.84685 16.7864 4.04918C16.8703 4.25151 16.9135 4.46839 16.9135 4.68742C16.9135 4.90644 16.8703 5.12332 16.7864 5.32565C16.7026 5.52798 16.5796 5.7118 16.4247 5.86658L16.3747 5.91658C16.1826 6.11298 16.0537 6.36243 16.0047 6.63276C15.9557 6.90309 15.9887 7.1819 16.0997 7.43325V7.49992C16.2053 7.74639 16.3807 7.9566 16.6043 8.10466C16.8279 8.25272 17.0899 8.33218 17.358 8.33325H17.4997C17.9417 8.33325 18.3656 8.50885 18.6782 8.82141C18.9907 9.13397 19.1663 9.55789 19.1663 9.99992C19.1663 10.4419 18.9907 10.8659 18.6782 11.1784C18.3656 11.491 17.9417 11.6666 17.4997 11.6666H17.4247C17.1565 11.6677 16.8945 11.7471 16.671 11.8952C16.4474 12.0432 16.272 12.2534 16.1663 12.4999V12.4999Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })), T.createElement("defs", null, T.createElement("clipPath", { id: "clip0_2596_30864" }, T.createElement("rect", { width: "20", height: "20", fill: "white" }))));
}
function tQe(e) {
  return T.createElement("svg", bt({ width: "10", height: "15", viewBox: "0 0 10 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M8.59375 0.875C8.09375 0.375 7.3125 0.40625 6.84375 0.90625L1.34375 6.65625C0.875 7.125 0.875 7.90625 1.34375 8.375L6.84375 14.125C7.0625 14.375 7.40625 14.5 7.75 14.5C8.03125 14.5 8.34375 14.4062 8.59375 14.1562C9.09375 13.6875 9.125 12.9062 8.625 12.4062L3.96875 7.53125L8.625 2.625C9.125 2.125 9.09375 1.34375 8.59375 0.875Z", fill: "currentColor" }));
}
function nQe(e) {
  return T.createElement("svg", bt({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M4.375 15.4375C4.375 16.1758 4.94922 16.75 5.6875 16.75H13.5625C14.2734 16.75 14.875 16.1758 14.875 15.4375V6.25H4.375V15.4375ZM11.8125 8.4375C11.8125 8.21875 12.0039 8 12.25 8C12.4688 8 12.6875 8.21875 12.6875 8.4375V14.5625C12.6875 14.8086 12.4688 15 12.25 15C12.0039 15 11.8125 14.8086 11.8125 14.5625V8.4375ZM9.1875 8.4375C9.1875 8.21875 9.37891 8 9.625 8C9.84375 8 10.0625 8.21875 10.0625 8.4375V14.5625C10.0625 14.8086 9.84375 15 9.625 15C9.37891 15 9.1875 14.8086 9.1875 14.5625V8.4375ZM6.5625 8.4375C6.5625 8.21875 6.75391 8 7 8C7.21875 8 7.4375 8.21875 7.4375 8.4375V14.5625C7.4375 14.8086 7.21875 15 7 15C6.75391 15 6.5625 14.8086 6.5625 14.5625V8.4375ZM15.3125 3.625H12.25L11.9219 2.99609C11.8398 2.85938 11.7031 2.75 11.5391 2.75H7.68359C7.51953 2.75 7.38281 2.85938 7.30078 2.99609L7 3.625H3.9375C3.69141 3.625 3.5 3.84375 3.5 4.0625V4.9375C3.5 5.18359 3.69141 5.375 3.9375 5.375H15.3125C15.5312 5.375 15.75 5.18359 15.75 4.9375V4.0625C15.75 3.84375 15.5312 3.625 15.3125 3.625Z", fill: "currentColor" }));
}
function rQe(e) {
  return T.createElement("svg", bt({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M14.9434 5.17969C14.2109 4.59375 13.625 4.125 10.1387 1.60547C9.64062 1.25391 8.67383 0.375 8 0.375V0.404297C7.9707 0.404297 7.9707 0.375 7.9707 0.375C7.29688 0.375 6.33008 1.25391 5.83203 1.60547C2.3457 4.125 1.75977 4.59375 1.02734 5.17969C0.675781 5.44336 0.5 5.85352 0.5 6.26367V13.9688C0.5 14.7598 1.11523 15.375 1.90625 15.375H14.0938C14.8555 15.375 15.5 14.7598 15.5 13.9688V6.26367C15.5 5.85352 15.2949 5.44336 14.9434 5.17969ZM9.37695 11.1562C8.9668 11.4785 8.46875 11.6543 8 11.6543C7.50195 11.6543 7.00391 11.4785 6.59375 11.1562L2.375 7.8457V6.49805C2.99023 6 3.72266 5.44336 6.94531 3.12891C7.0332 3.04102 7.15039 2.95312 7.26758 2.86523C7.41406 2.74805 7.73633 2.48438 8 2.33789C8.23438 2.48438 8.55664 2.74805 8.70312 2.86523C8.82031 2.95312 8.9375 3.04102 9.02539 3.12891C12.2188 5.44336 12.9805 6 13.625 6.49805V7.8457L9.37695 11.1562Z", fill: "currentColor" }));
}
function v$(e) {
  return T.createElement("svg", bt({ width: "14", height: "16", viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M7 8C9.1875 8 11 6.21875 11 4C11 1.8125 9.1875 0 7 0C4.78125 0 3 1.8125 3 4C3 6.21875 4.78125 8 7 8ZM8.5625 9.5H5.40625C2.40625 9.5 0 11.9375 0 14.9375C0 15.5312 0.46875 16 1.0625 16H12.9062C13.5 16 14 15.5312 14 14.9375C14 11.9375 11.5625 9.5 8.5625 9.5Z", fill: "currentColor" }));
}
function JW(e) {
  var t, n, r = e.unseenCount, s = Fo(), f = s.theme, m = s.common, p = Cn(_i("unseenBadge.root"), 1)[0];
  return r && r > 0 ? T.createElement(TK, { "data-test-id": "unseen-count-label", sx: { padding: 0, marginLeft: 10, width: 25, height: 20, pointerEvents: "none", border: "none", background: (t = f.header) === null || t === void 0 ? void 0 : t.badgeColor, fontFamily: m.fontFamily, lineHeight: "14px", color: (n = f.header) === null || n === void 0 ? void 0 : n.badgeTextColor, fontWeight: "bold", fontSize: "12px" }, radius: 10, className: hn("nc-unseen-badge", mt(p)) }, r) : null;
}
function aQe(e) {
  var t, n = e.onCogClick, r = Cn(F.exports.useState(!0), 2), s = r[0], f = r[1], m = xc(), p = m.markAllNotificationsAsRead, v = m.notifications, y = m.unseenCount, w = Fo().theme, P = F.exports.useContext($x), x = P.tabs, A = P.showUserPreferences, M = qw().t, O = Cn(_i(["header.root", "header.title", "header.markAsRead", "header.cog"]), 4), j = O[0], H = O[1], J = O[2], V = O[3];
  return F.exports.useEffect(function() {
    if (v) {
      var X = v.some(function(U) {
        return U.read === !1;
      });
      f(X);
    }
  }, [v]), T.createElement("div", { className: hn("nc-header", iQe, mt(j)) }, T.createElement("div", { style: { display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" } }, T.createElement("div", { className: hn("nc-header-title", lQe(w.header.fontColor), mt(H)), "data-test-id": "notifications-header-title" }, M("notifications")), !x && T.createElement(JW, { unseenCount: y })), T.createElement(oQe, null, T.createElement("div", { className: hn("nc-header-mark-as-read", uQe(!s, (t = w.header) === null || t === void 0 ? void 0 : t.markAllAsReadButtonColor), mt(J)), onClick: p, role: "button", tabIndex: 0 }, M("markAllAsRead")), T.createElement("div", { style: { display: A ? "inline-block" : "none" } }, T.createElement(zw, { "data-test-id": "user-preference-cog", variant: "transparent", onClick: n }, T.createElement(eQe, { className: hn("nc-header-cog", sQe(w), mt(V)) })))));
}
var uT, cT, dT, fT, mT, iQe = mt(uT || (uT = Yt([`
  padding: 5px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
`], [`
  padding: 5px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
`]))), oQe = Mr.div(cT || (cT = Yt([`
  display: flex;
  align-items: center;
`], [`
  display: flex;
  align-items: center;
`]))), sQe = function(e) {
  var t;
  return mt(dT || (dT = Yt([`
  color: `, `;
`], [`
  color: `, `;
`])), (t = e == null ? void 0 : e.userPreferences) === null || t === void 0 ? void 0 : t.settingsButtonColor);
}, lQe = function(e) {
  return mt(fT || (fT = Yt([`
  color: `, `;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
`], [`
  color: `, `;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
`])), e);
}, uQe = function(e, t) {
  return mt(mT || (mT = Yt([`
  margin-right: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  color: `, `;
  cursor: pointer;
  pointer-events: `, `;
  opacity: `, `;
`], [`
  margin-right: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  color: `, `;
  cursor: pointer;
  pointer-events: `, `;
  opacity: `, `;
`])), t, e ? "none" : "auto", e ? 0.5 : 1);
};
function cQe() {
  var e = Fo().theme, t = qw().t, n = Cn(_i(["footer.root", "footer.title"]), 2), r = n[0], s = n[1];
  return T.createElement("div", { className: hn("nc-footer", fQe, mt(r)) }, T.createElement("span", { className: hn(dQe(e), mt(s)) }, t("poweredBy"), " "), T.createElement("a", { rel: "noreferrer", target: "_blank", href: "https://novu.co?utm_source=in-app-widget", style: { display: "flex", color: e.footer.logoTextColor } }, T.createElement("svg", { width: "107", height: "16", viewBox: "0 0 1049 300", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, T.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M231 120.241C231 128.307 221.208 132.301 215.567 126.536L100.084 8.50548C115.699 2.9969 132.5 0 150 0C179.836 0 207.638 8.711 231 23.7285V120.241ZM273 64.1228V120.241C273 165.946 217.51 188.577 185.546 155.908L61.3582 28.9807C24.1534 56.2779 0 100.318 0 150C0 181.941 9.98339 211.55 27 235.877V180.059C27 134.354 82.4899 111.723 114.454 144.392L238.471 271.145C275.773 243.857 300 199.758 300 150C300 118.059 290.017 88.45 273 64.1228ZM84.433 173.764L199.697 291.571C184.144 297.031 167.419 300 150 300C120.164 300 92.3624 291.289 69 276.272V180.059C69 171.993 78.7923 167.999 84.433 173.764Z", fill: "url(#paint0_linear_1301_3067)" }), T.createElement("path", { d: "M487.303 223.326V140.944C487.303 126.727 483.892 115.918 477.07 108.517C470.248 101.116 459.527 97.4157 444.908 97.4157C434.967 97.4157 427.073 98.3895 421.225 100.337C415.378 102.09 411.674 103.356 410.115 104.135V223.326H380V84.8539C380.78 84.4644 382.924 83.588 386.432 82.2247C389.941 80.8614 394.619 79.4007 400.467 77.8427C406.314 76.2846 413.136 74.9213 420.933 73.7528C428.73 72.5843 437.306 72 446.662 72C457.383 72 467.129 73.4607 475.9 76.382C484.672 79.1086 492.079 83.1011 498.121 88.3596C504.359 93.618 509.134 99.9476 512.448 107.348C515.761 114.749 517.418 123.124 517.418 132.472V223.326H487.303Z", fill: "currentColor" }), T.createElement("path", { d: "M713.257 150C713.257 161.101 711.308 171.423 707.41 180.966C703.706 190.509 698.444 198.787 691.621 205.798C684.799 212.614 676.613 218.067 667.061 222.157C657.51 226.052 646.985 228 635.485 228C623.984 228 613.361 226.052 603.615 222.157C594.064 218.067 585.878 212.614 579.055 205.798C572.233 198.787 566.873 190.509 562.975 180.966C559.271 171.423 557.419 161.101 557.419 150C557.419 138.899 559.271 128.577 562.975 119.034C566.873 109.491 572.233 101.311 579.055 94.4944C585.878 87.4831 594.064 82.03 603.615 78.1348C613.361 74.0449 623.984 72 635.485 72C646.985 72 657.51 74.0449 667.061 78.1348C676.613 82.03 684.799 87.4831 691.621 94.4944C698.444 101.311 703.706 109.491 707.41 119.034C711.308 128.577 713.257 138.899 713.257 150ZM681.973 150C681.973 142.21 680.901 135.101 678.757 128.674C676.613 122.052 673.494 116.404 669.401 111.73C665.502 106.861 660.629 103.161 654.782 100.629C649.129 97.9026 642.697 96.5393 635.485 96.5393C628.078 96.5393 621.45 97.9026 615.603 100.629C609.95 103.161 605.077 106.861 600.984 111.73C597.085 116.404 594.064 122.052 591.92 128.674C589.776 135.101 588.704 142.21 588.704 150C588.704 157.79 589.776 164.996 591.92 171.618C594.064 178.045 597.085 183.693 600.984 188.562C605.077 193.236 609.95 196.936 615.603 199.663C621.45 202.195 628.078 203.461 635.485 203.461C642.697 203.461 649.129 202.195 654.782 199.663C660.629 196.936 665.502 193.236 669.401 188.562C673.494 183.693 676.613 178.045 678.757 171.618C680.901 164.996 681.973 157.79 681.973 150Z", fill: "currentColor" }), T.createElement("path", { d: "M888.255 83.1011C887.086 87.3858 885.039 93.1311 882.115 100.337C879.387 107.348 876.17 115.236 872.467 124C868.764 132.764 864.67 142.015 860.187 151.753C855.899 161.296 851.513 170.644 847.03 179.798C842.742 188.757 838.551 197.228 834.458 205.213C830.559 213.004 827.148 219.528 824.224 224.787H792.94C789.431 218.554 785.728 211.738 781.829 204.337C778.126 196.742 774.325 189.146 770.427 181.551C766.723 173.76 763.117 166.067 759.609 158.472C756.1 150.876 752.786 143.865 749.668 137.438C746.744 130.816 744.113 124.974 741.774 119.91C739.629 114.846 737.973 110.951 736.803 108.225C735.634 105.498 734.464 102.577 733.295 99.4607C732.125 96.3446 731.54 93.4232 731.54 90.6966C731.54 87.191 732.71 83.9775 735.049 81.0562C737.388 78.1348 741.384 76.6742 747.036 76.6742C750.935 76.6742 753.956 77.0637 756.1 77.8427C758.244 78.6217 759.414 79.1086 759.609 79.3034C762.922 88.4569 766.723 98.4869 771.011 109.393C775.495 120.3 779.978 131.109 784.461 141.82C789.139 152.337 793.622 162.464 797.91 172.202C802.199 181.745 805.999 189.828 809.313 196.449C811.652 191.97 814.673 185.64 818.377 177.461C822.275 169.086 826.271 159.933 830.364 150C834.653 140.067 838.941 129.843 843.229 119.326C847.517 108.809 851.318 99.1685 854.632 90.4045C856.191 86.1198 858.14 82.809 860.479 80.4719C862.818 77.9401 866.717 76.6742 872.175 76.6742C876.853 76.6742 880.556 77.5506 883.285 79.3034C886.209 81.0562 887.866 82.3221 888.255 83.1011Z", fill: "currentColor" }), T.createElement("path", { d: "M1018.88 90.4045C1018.88 85.7303 1020.25 82.3221 1022.98 80.1798C1025.71 77.8427 1029.61 76.6742 1034.67 76.6742C1037.99 76.6742 1040.91 77.0637 1043.44 77.8427C1046.17 78.6217 1048.03 79.206 1049 79.5955V223.326C1047.64 223.715 1045.2 224.105 1041.69 224.494C1038.38 224.884 1034.28 225.273 1029.41 225.663C1024.54 226.247 1019.18 226.637 1013.33 226.831C1007.48 227.221 1001.54 227.416 995.495 227.416C977.757 227.416 963.333 225.273 952.223 220.989C941.307 216.704 932.633 210.472 926.201 202.292C918.209 191.97 914.213 178.24 914.213 161.101V90.4045C914.213 85.7303 915.578 82.3221 918.307 80.1798C921.035 77.8427 924.934 76.6742 930.002 76.6742C933.315 76.6742 936.239 77.0637 938.773 77.8427C941.502 78.6217 943.354 79.206 944.328 79.5955V157.888C944.328 172.689 948.032 183.79 955.439 191.191C963.041 198.592 975.808 202.292 993.74 202.292C1000.56 202.292 1006.02 202.097 1010.11 201.708C1014.4 201.124 1017.33 200.637 1018.88 200.247V90.4045Z", fill: "currentColor" }), T.createElement("defs", null, T.createElement("linearGradient", { id: "paint0_linear_1301_3067", x1: "300", y1: "0", x2: "3.57628e-05", y2: "300", gradientUnits: "userSpaceOnUse" }, T.createElement("stop", { offset: "0.231667", stopColor: "#FF884D" }), T.createElement("stop", { offset: "0.801667", stopColor: "#E300BD" }))))));
}
var hT, pT, dQe = function(e) {
  return mt(hT || (hT = Yt([`
  color: `, `;
  font-size: 10px;
  font-weight: 400;
`], [`
  color: `, `;
  font-size: 10px;
  font-weight: 400;
`])), e.footer.logoPrefixFontColor);
}, fQe = mt(pT || (pT = Yt([`
  text-align: center;
  border-radius: 7px;
  margin-top: 10px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  direction: ltr;

  svg {
    margin-left: 10px;
    width: 60px;
    position: relative;
    top: -1px;
  }
`], [`
  text-align: center;
  border-radius: 7px;
  margin-top: 10px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  direction: ltr;

  svg {
    margin-left: 10px;
    width: 60px;
    position: relative;
    top: -1px;
  }
`])));
function mQe() {
  var e = rp().footer;
  return T.createElement(T.Fragment, null, e ? e() : T.createElement(cQe, null));
}
function hQe(e) {
  var t = e.onBackClick, n = Fo().theme, r = qw().t, s = Cn(_i(["header.root", "header.title", "header.backButton"]), 3), f = s[0], m = s[1], p = s[2];
  return T.createElement("div", { className: hn("nc-header", vQe, mt(f)) }, T.createElement(zw, { className: hn("nc-header-back-button", mt(vT || (vT = Yt([`
            color: `, `;
          `], [`
            color: `, `;
          `])), n.header.fontColor), mt(p)), "data-test-id": "go-back-btn", variant: "transparent", onClick: t }, T.createElement(tQe, { style: { marginLeft: "15px" } })), T.createElement("div", { className: hn("nc-header-title", pQe(n.header.fontColor), mt(m)) }, r("settings")));
}
var vT, gT, yT, bT, wT, PT, kT, pQe = function(e) {
  return mt(gT || (gT = Yt([`
  color: `, `;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
`], [`
  color: `, `;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
`])), e);
}, vQe = mt(yT || (yT = Yt([`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 55px;
  gap: 10px;
`], [`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 55px;
  gap: 10px;
`]))), vw = Mr.div(bT || (bT = Yt([`
  font-size: `, `;
  font-style: normal;
  align-items: center;
  font-weight: `, `;
  line-height: `, `;
  text-align: left;
`], [`
  font-size: `, `;
  font-style: normal;
  align-items: center;
  font-weight: `, `;
  line-height: `, `;
  text-align: left;
`])), function(e) {
  return e.size === "sm" ? "12px" : "14px";
}, function(e) {
  return e.size === "lg" ? "700" : "400";
}, function(e) {
  return e.size === "sm" ? "14.4px" : "16.8px";
}), gQe = Mr.div(wT || (wT = Yt([`
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 5px;
  align-items: flex-start;
`], [`
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 5px;
  align-items: flex-start;
`]))), yQe = function(e) {
  var t;
  return mt(PT || (PT = Yt([`
  color: `, `;
`], [`
  color: `, `;
`])), (t = e == null ? void 0 : e.accordion) === null || t === void 0 ? void 0 : t.fontColor);
}, bQe = function(e) {
  var t;
  return mt(kT || (kT = Yt([`
  color: `, `;
`], [`
  color: `, `;
`])), (t = e == null ? void 0 : e.accordion) === null || t === void 0 ? void 0 : t.secondaryFontColor);
}, wQe = function(e) {
  var t = e.theme, n = e.label, r = e.channels, s = Cn(_i(["preferences.item.title", "preferences.item.channels"]), 2), f = s[0], m = s[1];
  return T.createElement(gQe, null, T.createElement(vw, { size: "lg", className: hn("nc-preferences-item-title", yQe(t), mt(f)) }, n), T.createElement(vw, { "data-test-id": "workflow-active-channels", size: "sm", className: hn("nc-preferences-item-channels", bQe(t), mt(m)) }, r));
}, PQe = [{ type: "sms", label: "SMS", Icon: function(e) {
  return T.createElement("svg", bt({ width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M25 19.3333C25 19.8785 24.7659 20.4013 24.3491 20.7868C23.9324 21.1723 23.3671 21.3889 22.7778 21.3889H9.44444L5 25V9.05556C5 8.51039 5.23413 7.98755 5.65087 7.60206C6.06762 7.21657 6.63285 7 7.22222 7H22.7778C23.3671 7 23.9324 7.21657 24.3491 7.60206C24.7659 7.98755 25 8.51039 25 9.05556V19.3333Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}, description: "This is an sms" }, { type: "push", label: "Push", Icon: function(e) {
  return T.createElement("svg", bt({ width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M15 22.5H15.01M8.75 2.5H21.25C22.6307 2.5 23.75 3.61929 23.75 5V25C23.75 26.3807 22.6307 27.5 21.25 27.5H8.75C7.36929 27.5 6.25 26.3807 6.25 25V5C6.25 3.61929 7.36929 2.5 8.75 2.5Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}, description: "This is a push" }, { type: "email", label: "Email", Icon: function(e) {
  return T.createElement("svg", bt({ width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M24 8.5L15 15.25L6 8.5M7 7H23C24.1 7 25 7.9 25 9V21C25 22.1 24.1 23 23 23H7C5.9 23 5 22.1 5 21V9C5 7.9 5.9 7 7 7Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}, description: "This is a mail" }, { type: "in_app", label: "In App", Icon: KW, description: "This is an in app" }, { type: "chat", label: "Chat", Icon: function(e) {
  return T.createElement("svg", bt({ width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M21 1L10 12M21 1L14 21L10 12M21 1L1 8L10 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}, description: "This is a chat" }], ZW = function(e) {
  return PQe.find(function(t) {
    return t.type === e;
  });
};
function kQe(e) {
  return T.createElement("svg", bt({ width: "12", height: "13", viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), T.createElement("path", { d: "M6 0.875C2.88281 0.875 0.375 3.40625 0.375 6.5C0.375 9.61719 2.88281 12.125 6 12.125C9.09375 12.125 11.625 9.61719 11.625 6.5C11.625 3.40625 9.09375 0.875 6 0.875ZM8.69531 5.46875L5.69531 8.46875C5.57812 8.60938 5.41406 8.65625 5.25 8.65625C5.0625 8.65625 4.89844 8.60938 4.78125 8.46875L3.28125 6.96875C3.02344 6.71094 3.02344 6.3125 3.28125 6.05469C3.53906 5.79688 3.9375 5.79688 4.19531 6.05469L5.25 7.08594L7.78125 4.55469C8.03906 4.29688 8.4375 4.29688 8.69531 4.55469C8.95312 4.8125 8.95312 5.21094 8.69531 5.46875Z", fill: "#4D9980" }));
}
var tt = { white: "#FFFFFF", BGLight: "#EDF0F2", BGDark: "#13131A", B98: "#F5F8FA", B85: "#D5D5D9", B80: "#BEBECC", B70: "#A1A1B2", B60: "#828299", B40: "#525266", B30: "#3D3D4D", B20: "#292933", B15: "#1E1E26", B17: "#23232B", success: "#4D9980", error: "#E54545", vertical: "linear-gradient(0deg,#FF512F 0%,#DD2476 100%)", horizontal: "linear-gradient(99deg,#DD2476 0% 0%,#FF512F 100% 100%)" }, $Qe = function(e, t) {
  return mt($T || ($T = Yt([`
  color: `, `;
  width: 30px;
`], [`
  color: `, `;
  width: 30px;
`])), e ? t.active : t.inactive);
}, SQe = function(e, t) {
  return mt(ST || (ST = Yt([`
  color: `, `;
`], [`
  color: `, `;
`])), e ? t.active : t.inactive);
}, xQe = mt(xT || (xT = Yt([`
  color: `, `;
`], [`
  color: `, `;
`])), tt.success);
function CQe(e) {
  var t, n, r = this, s = e.type, f = e.active, m = e.disabled, p = e.handleUpdateChannelPreference, v = ZW(s), y = v.label, w = v.Icon, P = Fo().theme, x = Cn(F.exports.useState(!1), 2), A = x[0], M = x[1], O = Cn(F.exports.useState(!1), 2), j = O[0], H = O[1], J = P == null ? void 0 : P.userPreferences, V = (t = J == null ? void 0 : J.accordionItem) === null || t === void 0 ? void 0 : t.icon, X = (n = J == null ? void 0 : J.accordionItem) === null || n === void 0 ? void 0 : n.fontColor, U = Cn(_i(["switch.root", "switch.input", "switch.track", "switch.thumb", "preferences.item.content.icon", "preferences.item.content.channelLabel", "preferences.item.content.success"]), 7), K = U[0], ce = U[1], ue = U[2], ye = U[3], Oe = U[4], _e = U[5], Le = U[6], Ne = function(Qe) {
    var qe, ie, xe, Ye, Be, Ce, Ie, $e;
    return { root: { width: "100%", maxWidth: "70px", display: "flex", alignItems: "center" }, input: { background: (ie = (qe = Qe.accordionItem) === null || qe === void 0 ? void 0 : qe.switch) === null || ie === void 0 ? void 0 : ie.backgroundUnchecked, width: "1px", height: "1px", border: "transparent", cursor: "pointer", "&::before": { border: "transparent", width: "20px", height: "20px" }, "&:checked ~ label": { background: (Ye = (xe = Qe.accordionItem) === null || xe === void 0 ? void 0 : xe.switch) === null || Ye === void 0 ? void 0 : Ye.backgroundChecked }, "&:not(checked) ~ label": { background: (Ce = (Be = Qe.accordionItem) === null || Be === void 0 ? void 0 : Be.switch) === null || Ce === void 0 ? void 0 : Ce.backgroundUnchecked }, "&:disabled:not(:checked) ~ label": { background: ($e = (Ie = Qe.accordionItem) === null || Ie === void 0 ? void 0 : Ie.switch) === null || $e === void 0 ? void 0 : $e.backgroundUnchecked }, "&:disabled": { opacity: 0.3 } }, track: { width: "46px", height: "24px", border: "none" }, thumb: { border: "none" } };
  }(J), nt = { root: mt(K), input: mt(ce), track: mt(ue), thumb: mt(ye) };
  return T.createElement(MQe, { "data-test-id": "channel-preference-item" }, T.createElement(EQe, null, T.createElement(w, { className: hn("nc-preferences-item-icon", $Qe(f, V), mt(Oe)) }), T.createElement(vw, { size: "md", className: hn("nc-preferences-channel-label", SQe(f, X), mt(_e)) }, y)), T.createElement(AQe, null, j && T.createElement("div", { style: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "5px" } }, T.createElement(kQe, { color: tt.success }), T.createElement(vw, { size: "sm", className: hn("nc-preferences-item-success", xQe, mt(Le)) }, "Saved")), T.createElement(_Qe, null, T.createElement(r5, { visible: A, "data-test-id": "channel-preference-item-loader", loaderProps: { size: 15, color: P.loaderColor.indexOf("gradient") === -1 ? P.loaderColor : F5.average(FW(P.loaderColor)) }, overlayOpacity: 0.3, overlayColor: "transparent", sx: { justifyContent: f ? "right" : "left", marginLeft: "3px", marginRight: "1.5px", marginTop: "1px" } }), T.createElement(rx, { "data-test-id": "channel-preference-item-toggle", styles: Ne, classNames: nt, disabled: m && !A, checked: f, onChange: function(Qe) {
    return qe = Qe.target.checked, Qv(r, void 0, void 0, function() {
      return Kv(this, function(ie) {
        switch (ie.label) {
          case 0:
            return M(!0), [4, p(s, qe)];
          case 1:
            return ie.sent(), M(!1), H(!0), setTimeout(function() {
              H(!1);
            }, 1500), [2];
        }
      });
    });
    var qe;
  } }))));
}
var $T, ST, xT, CT, MT, ET, AT, MQe = Mr.div(CT || (CT = Yt([`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`], [`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`]))), EQe = Mr.div(MT || (MT = Yt([`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
`], [`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
`]))), AQe = Mr.div(ET || (ET = Yt([`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 13px;
`], [`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 13px;
`]))), _Qe = Mr.div(AT || (AT = Yt([`
  width: inherit;
  height: inherit;
  position: relative;

  svg circle {
    stroke-opacity: 0;
  }
`], [`
  width: inherit;
  height: inherit;
  position: relative;

  svg circle {
    stroke-opacity: 0;
  }
`]))), OQe = function(e) {
  var t;
  return mt(_T || (_T = Yt([`
  border-top-color: `, `;
`], [`
  border-top-color: `, `;
`])), (t = e == null ? void 0 : e.accordion) === null || t === void 0 ? void 0 : t.dividerColor);
}, TQe = Mr.div(OT || (OT = Yt([`
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 20px;
`], [`
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 20px;
`])));
function RQe(e) {
  return Object.keys(e).filter(function(t) {
    return e[t];
  }).map(function(t) {
    return ZW(t).label;
  }).join(", ");
}
var _T, OT, TT, DQe = function(e) {
  var t, n, r, s = e.preferenceSettings, f = Fo().theme, m = BGe(), p = m.isLoading, v = m.updateUserPreferences, y = Cn(_i(["preferences.item.divider"]), 1)[0], w = f == null ? void 0 : f.userPreferences, P = Object.keys((t = s == null ? void 0 : s.preference) === null || t === void 0 ? void 0 : t.channels), x = (n = s == null ? void 0 : s.preference) === null || n === void 0 ? void 0 : n.channels, A = function(M, O) {
    v({ templateId: s.template._id, channelType: M, checked: O });
  };
  return T.createElement(bd.Item, { value: s.template._id, "data-test-id": "workflow-list-item" }, T.createElement(bd.Control, null, T.createElement(wQe, { theme: w, label: (r = s.template) === null || r === void 0 ? void 0 : r.name, channels: RQe(x) })), T.createElement(bd.Panel, null, T.createElement(TQe, null, T.createElement(TD, { className: hn("nc-preferences-item-divider", OQe(w), mt(y)) }), P.map(function(M) {
    return T.createElement(CQe, { key: M, type: M, active: x[M], disabled: p, handleUpdateChannelPreference: A });
  }))));
}, NQe = mt(TT || (TT = Yt([`
  padding: 15px;
`], [`
  padding: 15px;
`])));
function WQe() {
  var e, t = Xi().setFetchingStrategy, n = Fo(), r = n.theme, s = n.common, f = GGe(), m = f.data, p = f.isLoading, v = Cn(_i(["preferences.root", "accordion.item", "accordion.content", "accordion.control", "accordion.chevron"]), 5), y = v[0], w = v[1], P = v[2], x = v[3], A = v[4], M = r == null ? void 0 : r.userPreferences, O = (e = m == null ? void 0 : m.filter(function(V) {
    return !V.template.critical;
  })) === null || e === void 0 ? void 0 : e.filter(function(V) {
    return Object.keys(V.preference.channels).length > 0;
  }), j = function(V, X) {
    var U;
    return { item: { borderBottom: "none", boxShadow: V.accordion.boxShadow, backgroundColor: V.accordion.background, marginBottom: "15px", borderRadius: "7px" }, content: { color: V.accordion.fontColor, fontFamily: X }, control: { fontFamily: X, height: "65px", "&:hover": { backgroundColor: V.accordion.background, borderRadius: "7px" } }, chevron: { color: (U = V.accordion) === null || U === void 0 ? void 0 : U.arrowColor } };
  }(M, s.fontFamily), H = { item: mt(w), content: mt(P), control: mt(x), chevron: mt(A) }, J = !p && (O == null ? void 0 : O.length) === 0;
  return F.exports.useLayoutEffect(function() {
    t({ fetchUserPreferences: !0 });
  }, [t]), p ? T.createElement(Yw, null) : T.createElement(T.Fragment, null, J ? T.createElement("div", { style: { textAlign: "center", minHeight: 400, display: "flex", alignItems: "center", justifyContent: "center" } }, T.createElement("img", { src: "data:image/png;base64,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", alt: "logo", style: { maxWidth: 300 } })) : T.createElement(gY, { style: { height: 400 } }, T.createElement("div", { className: hn("nc-preferences-root", NQe, mt(y)) }, T.createElement(bd, { chevronPosition: "right", styles: j, classNames: H }, O == null ? void 0 : O.map(function(V) {
    return T.createElement(DQe, { key: V.template._id, preferenceSettings: V });
  })))));
}
var jQe = "0px 5px 15px rgba(38, 68, 128, 0.05)", g$ = "0px 5px 15px rgba(122, 133, 153, 0.25)", n1 = "0px 5px 20px rgba(0, 0, 0, 0.2)", zQe = { layout: { background: tt.white, boxShadow: g$, wrapper: { secondaryFontColor: tt.B80 } }, header: { fontColor: tt.B40, badgeColor: tt.vertical, badgeTextColor: tt.white, markAllAsReadButtonColor: tt.B60 }, popover: { arrowColor: tt.white }, actionsMenu: { dropdownColor: tt.white, hoverColor: tt.B98, fontColor: tt.B40, dotsButtonColor: tt.B70 }, notificationItem: { read: { background: tt.B98, fontColor: tt.B60, timeMarkFontColor: tt.B80 }, unread: { background: tt.white, fontColor: tt.B40, boxShadow: g$, notificationItemBeforeBrandColor: tt.vertical, timeMarkFontColor: tt.B60 }, buttons: oI }, userPreferences: { settingsButtonColor: tt.B70, accordion: { background: tt.white, fontColor: tt.B40, secondaryFontColor: tt.B60, boxShadow: g$, arrowColor: tt.B60, dividerColor: tt.BGLight }, accordionItem: { fontColor: { active: tt.B40, inactive: tt.B80 }, icon: { active: tt.B40, inactive: tt.B80 }, switch: { backgroundChecked: tt.vertical, backgroundUnchecked: tt.B80 } } }, footer: { logoTextColor: "black", logoPrefixFontColor: tt.B70 }, loaderColor: tt.vertical }, LQe = { layout: { background: tt.B15, boxShadow: n1, wrapper: { secondaryFontColor: tt.B40 } }, header: { fontColor: tt.white, badgeColor: tt.vertical, badgeTextColor: tt.white, markAllAsReadButtonColor: tt.B60 }, popover: { arrowColor: tt.B15 }, actionsMenu: { dropdownColor: tt.B20, hoverColor: tt.B30, fontColor: tt.white, dotsButtonColor: tt.B40 }, notificationItem: { read: { background: tt.B17, fontColor: tt.white, timeMarkFontColor: tt.B40 }, unread: { background: tt.B20, fontColor: tt.white, boxShadow: n1, notificationItemBeforeBrandColor: tt.vertical, timeMarkFontColor: tt.B60 }, buttons: iI }, userPreferences: { settingsButtonColor: tt.B40, accordion: { background: tt.B20, fontColor: tt.white, secondaryFontColor: tt.B60, boxShadow: n1, arrowColor: tt.B60, dividerColor: tt.B30 }, accordionItem: { fontColor: { active: tt.white, inactive: tt.B60 }, icon: { active: tt.white, inactive: tt.B40 }, switch: { backgroundChecked: tt.vertical, backgroundUnchecked: tt.B30 } } }, footer: { logoTextColor: tt.white, logoPrefixFontColor: tt.B40 }, loaderColor: tt.vertical }, IQe = { fontFamily: "Lato" }, FQe = { unseenBadgeColor: { stopColor: "#FF512F", stopColorOffset: "#DD2476" }, unseenBadgeBackgroundColor: tt.white }, HQe = { unseenBadgeColor: { stopColor: "#FF512F", stopColorOffset: "#DD2476" }, unseenBadgeBackgroundColor: tt.B15 };
function Sx(e) {
  var t, n, r;
  return { theme: e.colorScheme === "light" ? p$(Jb(zQe), (t = e == null ? void 0 : e.theme) === null || t === void 0 ? void 0 : t.light) : p$(Jb(LQe), (n = e == null ? void 0 : e.theme) === null || n === void 0 ? void 0 : n.dark), common: p$(Jb(IQe), (r = e == null ? void 0 : e.theme) === null || r === void 0 ? void 0 : r.common) };
}
function xx(e) {
  var t = e != null && e.colorScheme ? e == null ? void 0 : e.colorScheme : "light";
  return { bellColors: bt(bt({}, Jb(t === "light" ? FQe : HQe)), { bellColors: e == null ? void 0 : e.bellColors }) };
}
function VQe(e) {
  var t = e.className, n = e.messageAction, r = e.buttonIndex, s = e.onActionClick, f = Fo().theme, m = n.buttons[r], p = f.notificationItem.buttons[m.type], v = m != null && m.content ? m.content : "";
  return T.createElement(T.Fragment, null, T.createElement(JK, { onClick: function(y) {
    return function(w) {
      w.stopPropagation(), s(m.type);
    }(y);
  }, className: hn(BQe(p), t), fullWidth: !0 }, v));
}
var RT, BQe = function(e) {
  return mt(RT || (RT = Yt([`
  background: `, `;
  color: `, `;
  font-family: `, `;
  box-shadow: none;
  display: flex;
  justify-content: center;
  margin-left: 5px;
  margin-right: 5px;
  height: 30px;
  font-weight: 700;
  font-size: 12px;
  border-radius: 7px;
  border: 0;

  &:hover {
    background: `, `;
  }
`], [`
  background: `, `;
  color: `, `;
  font-family: `, `;
  box-shadow: none;
  display: flex;
  justify-content: center;
  margin-left: 5px;
  margin-right: 5px;
  height: 30px;
  font-weight: 700;
  font-size: 12px;
  border-radius: 7px;
  border: 0;

  &:hover {
    background: `, `;
  }
`])), e.backGroundColor, e.fontColor, e.fontFamily, e.backGroundColor);
};
function UQe(e) {
  var t = e.action, n = e.onActionClick, r = t == null ? void 0 : t.status, s = t == null ? void 0 : t.buttons, f = Cn(_i(["notifications.listItem.buttons.root", "notifications.listItem.buttons.primary", "notifications.listItem.buttons.secondary"]), 3), m = f[0], p = f[1], v = f[2];
  return T.createElement(XQe, null, T.createElement(qQe, { className: hn("nc-notifications-list-item-buttons", mt(m)) }, r === qv.DONE ? null : s == null ? void 0 : s.map(function(y, w) {
    return T.createElement(VQe, { key: y.type, className: hn("nc-notifications-list-item-button", mt(y.type === Xv.PRIMARY ? p : v)), onActionClick: function(P) {
      return function(x) {
        n(x);
      }(P);
    }, messageAction: t, buttonIndex: w });
  })));
}
var DT, NT, XQe = Mr.div(DT || (DT = Yt([`
  margin-left: 10px;
  margin-right: 10px;
`], [`
  margin-left: 10px;
  margin-right: 10px;
`]))), qQe = Mr.div(NT || (NT = Yt([`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  max-height: 50px;
  margin-left: -15px;
  margin-right: -15px;
`], [`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  max-height: 50px;
  margin-left: -15px;
  margin-right: -15px;
`]))), YQe = function(e) {
  var t = e.truthy, n = e.children;
  return e.fallback, t ? n : null;
}, GQe = [{ icon: T.createElement(function(e) {
  return T.createElement("svg", bt({ xmlns: "http://www.w3.org/2000/svg", className: "icon", viewBox: "0 0 1024 1024", width: "40px", height: "40px", fill: "currentColor" }, e), T.createElement("path", { d: "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z" }));
}, null), type: dd.WARNING, iconColor: "#FFF000", containerBgColor: "#FFF00026" }, { icon: T.createElement(function(e) {
  return T.createElement("svg", bt({ xmlns: "http://www.w3.org/2000/svg", className: "icon", viewBox: "0 0 1024 1024", width: "40px", height: "40px", fill: "currentColor" }, e), T.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z" }));
}, null), type: dd.INFO, iconColor: "#0000FF", containerBgColor: "#0000FF26" }, { icon: T.createElement(function(e) {
  return T.createElement("svg", bt({ xmlns: "http://www.w3.org/2000/svg", className: "icon", viewBox: "0 0 1024 1024", width: "40px", height: "40px", fill: "currentColor" }, e), T.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" }));
}, null), type: dd.UP, iconColor: tt.B70, containerBgColor: "".concat(tt.B70, "26") }, { icon: T.createElement(function(e) {
  return T.createElement("svg", bt({ xmlns: "http://www.w3.org/2000/svg", className: "icon", viewBox: "0 0 1024 1024", width: "40px", height: "40px", fill: "currentColor" }, e), T.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z" }));
}, null), type: dd.QUESTION, iconColor: tt.B70, containerBgColor: "".concat(tt.B70, "26") }, { icon: T.createElement(function(e) {
  return T.createElement("svg", bt({ xmlns: "http://www.w3.org/2000/svg", className: "icon", viewBox: "0 0 1024 1024", fill: "currentColor" }, e), T.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" }));
}, null), type: dd.SUCCESS, iconColor: tt.success, containerBgColor: "".concat(tt.success, "26") }, { icon: T.createElement(function(e) {
  return T.createElement("svg", bt({ xmlns: "http://www.w3.org/2000/svg", className: "icon", viewBox: "0 0 1024 1024", width: "40px", height: "40px", fill: "currentColor" }, e), T.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" }));
}, null), type: dd.ERROR, iconColor: tt.error, containerBgColor: "".concat(tt.error, "26") }];
function QQe(e) {
  var t, n, r, s = e.notification, f = e.onClick, m = Fo(), p = m.theme, v = m.colorScheme, y = rp(), w = y.onActionClick, P = y.listItem, x = y.allowedNotificationActions, A = xc(), M = A.removeMessage, O = A.markNotificationAsRead, j = A.markNotificationAsUnRead, H = qw(), J = H.dateFnsLocale, V = H.t, X = HB(), U = X.hovered, K = X.ref, ce = WT(s) ? !s.read : !s.seen, ue = Cn(_i(["notifications.listItem.read", "notifications.listItem.unread", "notifications.listItem.layout", "notifications.listItem.contentLayout", "notifications.listItem.title", "notifications.listItem.timestamp", "notifications.listItem.dotsButton", "actionsMenu.dropdown", "actionsMenu.arrow", "actionsMenu.item"]), 10), ye = ue[0], Oe = ue[1], _e = ue[2], Le = ue[3], Ne = ue[4], nt = ue[5], Qe = ue[6], qe = ue[7], ie = ue[8], xe = ue[9], Ye = mKe({ novuTheme: p }).classes, Be = { arrow: hn(Ye.arrow, mt(ie)), dropdown: hn(Ye.dropdown, mt(qe)), item: hn(Ye.item, mt(xe)), itemIcon: Ye.itemIcon };
  function Ce() {
    f(s);
  }
  function Ie($e) {
    return Qv(this, void 0, void 0, function() {
      return Kv(this, function(ot) {
        return w(s.templateIdentifier, $e, s), [2];
      });
    });
  }
  return P ? P(s, Ie, Ce) : T.createElement("div", { className: hn("nc-notifications-list-item", oKe, ce ? aKe(p) : iKe(p), mt(ce ? Oe : ye)), onClick: function() {
    return Ce();
  }, "data-test-id": "notification-list-item", role: "button", tabIndex: 0, ref: K }, T.createElement(tKe, { className: hn("nc-notifications-list-item-layout", mt(_e)) }, T.createElement(lKe, null, s.actor && s.actor.type !== jh.NONE && T.createElement(uKe, null, T.createElement(eKe, { actor: s.actor })), T.createElement(cKe, { className: hn("nc-notifications-list-item-content-layout", mt(Le)) }, T.createElement(nKe, { className: hn("nc-notifications-list-item-title", mt(Ne)), "data-test-id": "notification-content", dangerouslySetInnerHTML: { __html: s.content } }), T.createElement("div", { className: hn("nc-notifications-list-item-timestamp", sKe(p, ce), mt(nt)) }, qse(new Date(s.createdAt), { addSuffix: !0, locale: J() })))), T.createElement(KQe, { templateIdentifier: s.templateIdentifier, actionStatus: (n = (t = s == null ? void 0 : s.cta) === null || t === void 0 ? void 0 : t.action) === null || n === void 0 ? void 0 : n.status, ctaAction: (r = s == null ? void 0 : s.cta) === null || r === void 0 ? void 0 : r.action, handleActionButtonClick: Ie })), T.createElement(rKe, { style: { display: x ? "block" : "none", opacity: U ? 1 : 0 }, novuTheme: p }, T.createElement(Pl, { radius: 7, shadow: v === "dark" ? n1 : jQe, withArrow: !0, classNames: Be }, T.createElement(Pl.Target, null, T.createElement(zw, { onClick: function($e) {
    return $e.stopPropagation();
  }, variant: "transparent" }, T.createElement(ZGe, { className: hn("nc-notifications-list-item-dots-button", fKe(p), mt(Qe)) }))), T.createElement(Pl.Dropdown, null, T.createElement(Pl.Item, { icon: T.createElement(rQe, null), onClick: function($e) {
    $e.stopPropagation(), ce ? O(s._id) : j(s._id);
  } }, V(ce ? "markAsRead" : "markAsUnRead")), T.createElement(Pl.Item, { icon: T.createElement(nQe, null), onClick: function($e) {
    $e.stopPropagation(), M(s._id);
  } }, V("removeMessage"))))), T.createElement(YQe, { truthy: WT(s) }, T.createElement("div", { style: { opacity: x && U ? 0 : 1 } }, !s.seen && T.createElement(ZQe, { colorScheme: v }))));
}
function KQe(e) {
  var t = e.actionStatus, n = e.templateIdentifier, r = e.ctaAction, s = e.handleActionButtonClick, f = rp().actionsResultBlock;
  return T.createElement(T.Fragment, null, f && t === qv.DONE ? f(n, r) : T.createElement(JQe, { handleActionButtonClick: s, action: r }));
}
var WT = function(e) {
  return (e == null ? void 0 : e.read) !== void 0;
};
function JQe(e) {
  var t = e.action, n = e.handleActionButtonClick;
  return T.createElement(T.Fragment, null, t ? T.createElement(UQe, { onActionClick: n, action: t }) : null);
}
function ZQe(e) {
  var t = xx({ colorScheme: e.colorScheme, bellColors: { unseenBadgeBackgroundColor: "transparent" } }).bellColors, n = Cn(_i("bellButton.dot"), 1)[0];
  return T.createElement(QW, { width: "10px", height: "10px", colors: t, className: hn("nc-bell-button-dot", mt(n)) });
}
function eKe(e) {
  var t = e.actor;
  if ([jh.USER, jh.SYSTEM_CUSTOM].includes(t.type) && t.data)
    return T.createElement(gK, { src: t.data, radius: "xl" }, T.createElement(v$, null));
  if (t.type === jh.SYSTEM_ICON) {
    var n = GQe.filter(function(r) {
      return r.type === t.data;
    });
    return n.length > 0 ? T.createElement(dKe, { iconColor: n[0].iconColor, containerBgColor: n[0].containerBgColor }, n[0].icon) : T.createElement(v$, null);
  }
  return T.createElement(v$, null);
}
var jT, zT, LT, IT, FT, HT, VT, BT, UT, XT, qT, YT, tKe = Mr.div(jT || (jT = Yt([`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: normal;
  width: 100%;
`], [`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: normal;
  width: 100%;
`]))), nKe = Mr.div(zT || (zT = Yt([`
  line-height: 16px;
  overflow-wrap: anywhere;
`], [`
  line-height: 16px;
  overflow-wrap: anywhere;
`]))), rKe = Mr.div(LT || (LT = Yt([`
  color: `, `;
`], [`
  color: `, `;
`])), function(e) {
  var t;
  return (t = e.novuTheme.layout) === null || t === void 0 ? void 0 : t.wrapper.secondaryFontColor;
}), aKe = function(e) {
  var t, n, r, s, f, m, p, v;
  return mt(IT || (IT = Yt([`
  background: `, `;
  box-shadow: `, `;
  color: `, `;
  font-weight: 700;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 5px;
    border-radius: 7px 0 0 7px;
    background: `, `;
  }
`], [`
  background: `, `;
  box-shadow: `, `;
  color: `, `;
  font-weight: 700;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 5px;
    border-radius: 7px 0 0 7px;
    background: `, `;
  }
`])), (n = (t = e == null ? void 0 : e.notificationItem) === null || t === void 0 ? void 0 : t.unread) === null || n === void 0 ? void 0 : n.background, (s = (r = e == null ? void 0 : e.notificationItem) === null || r === void 0 ? void 0 : r.unread) === null || s === void 0 ? void 0 : s.boxShadow, (m = (f = e == null ? void 0 : e.notificationItem) === null || f === void 0 ? void 0 : f.unread) === null || m === void 0 ? void 0 : m.fontColor, (v = (p = e == null ? void 0 : e.notificationItem) === null || p === void 0 ? void 0 : p.unread) === null || v === void 0 ? void 0 : v.notificationItemBeforeBrandColor);
}, iKe = function(e) {
  var t, n, r, s;
  return mt(FT || (FT = Yt([`
  color: `, `;
  background: `, `;
  font-weight: 400;
  font-size: 14px;
`], [`
  color: `, `;
  background: `, `;
  font-weight: 400;
  font-size: 14px;
`])), (n = (t = e == null ? void 0 : e.notificationItem) === null || t === void 0 ? void 0 : t.read) === null || n === void 0 ? void 0 : n.fontColor, (s = (r = e == null ? void 0 : e.notificationItem) === null || r === void 0 ? void 0 : r.read) === null || s === void 0 ? void 0 : s.background);
}, oKe = mt(HT || (HT = Yt([`
  padding: 15px;
  position: relative;
  display: flex;
  line-height: 20px;
  justify-content: space-between;
  align-items: center;
  border-radius: 7px;
  margin: 10px 15px;

  &:hover {
    cursor: pointer;
  }
`], [`
  padding: 15px;
  position: relative;
  display: flex;
  line-height: 20px;
  justify-content: space-between;
  align-items: center;
  border-radius: 7px;
  margin: 10px 15px;

  &:hover {
    cursor: pointer;
  }
`]))), sKe = function(e, t) {
  var n, r, s, f;
  return mt(VT || (VT = Yt([`
  min-width: 55px;
  font-size: 12px;
  font-weight: 400;
  opacity: 0.5;
  line-height: 14.4px;
  color: `, `;
`], [`
  min-width: 55px;
  font-size: 12px;
  font-weight: 400;
  opacity: 0.5;
  line-height: 14.4px;
  color: `, `;
`])), t ? (r = (n = e == null ? void 0 : e.notificationItem) === null || n === void 0 ? void 0 : n.unread) === null || r === void 0 ? void 0 : r.timeMarkFontColor : (f = (s = e == null ? void 0 : e.notificationItem) === null || s === void 0 ? void 0 : s.read) === null || f === void 0 ? void 0 : f.timeMarkFontColor);
}, lKe = Mr.div(BT || (BT = Yt([`
  display: flex;
  align-items: center;
  gap: 10px;
`], [`
  display: flex;
  align-items: center;
  gap: 10px;
`]))), uKe = Mr.div(UT || (UT = Yt([`
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  border: 1px solid `, `;
  overflow: hidden;
`], [`
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  border: 1px solid `, `;
  overflow: hidden;
`])), tt.B40), cKe = Mr.div(XT || (XT = Yt([`
  display: flex;
  flex-direction: column;
  gap: 5px;
`], [`
  display: flex;
  flex-direction: column;
  gap: 5px;
`]))), dKe = Mr.div(qT || (qT = Yt([`
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: `, `;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: `, `;

  & > svg {
    width: 20px;
    height: 20px;
  }
`], [`
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: `, `;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: `, `;

  & > svg {
    width: 20px;
    height: 20px;
  }
`])), function(e) {
  return e.containerBgColor;
}, function(e) {
  return e.iconColor;
}), fKe = function(e) {
  var t;
  return mt(YT || (YT = Yt([`
  color: `, `;
`], [`
  color: `, `;
`])), (t = e == null ? void 0 : e.actionsMenu) === null || t === void 0 ? void 0 : t.dotsButtonColor);
}, mKe = $n(function(e, t) {
  var n, r, s, f, m, p = t.novuTheme;
  return { dropdown: { backgroundColor: (n = p.actionsMenu) === null || n === void 0 ? void 0 : n.dropdownColor, border: "none" }, item: { borerRadius: "5px", color: (r = p.actionsMenu) === null || r === void 0 ? void 0 : r.fontColor, fontWeight: 400, fontSize: "14px", "&:hover": { background: (s = p.actionsMenu) === null || s === void 0 ? void 0 : s.hoverColor } }, arrow: { backgroundColor: (f = p.actionsMenu) === null || f === void 0 ? void 0 : f.dropdownColor, borderColor: (m = p.actionsMenu) === null || m === void 0 ? void 0 : m.dropdownColor }, itemIcon: { width: "20px", height: "20px" } };
});
function hKe(e) {
  var t = e.notifications, n = e.onFetch, r = e.hasNextPage, s = e.onNotificationClicked, f = t == null ? void 0 : t.length, m = Cn(_i("notifications.root"), 1)[0];
  return T.createElement(pKe, { className: hn("nc-notifications-list", mt(m)), "data-test-id": "notifications-scroll-area" }, T.createElement(KYe, { dataLength: f, next: n, hasMore: r, height: 400, loader: T.createElement(Yw, null), endMessage: !1 }, t.map(function(p) {
    return T.createElement(QQe, { key: p._id, notification: p, onClick: s });
  })));
}
var GT, pKe = Mr.div(GT || (GT = Yt([""], [""])));
function QT() {
  var e = Xi().apiService, t = rp(), n = t.onNotificationClick, r = t.onUrlChange, s = t.emptyState, f = xc(), m = f.notifications, p = f.isLoading, v = f.hasNextPage, y = f.markNotificationAsRead, w = f.fetchNextPage;
  return p ? T.createElement(Yw, null) : T.createElement(T.Fragment, null, p || (m == null ? void 0 : m.length) !== 0 ? T.createElement(hKe, { onNotificationClicked: function(P) {
    var x, A, M, O, j;
    return Qv(this, void 0, void 0, function() {
      var H;
      return Kv(this, function(J) {
        return y(P._id), n && n(P), H = ((x = P.cta) === null || x === void 0 ? void 0 : x.type) === M$.REDIRECT && ((M = (A = P.cta) === null || A === void 0 ? void 0 : A.data) === null || M === void 0 ? void 0 : M.url), e.postUsageLog("Notification Click", { notificationId: P._id, hasCta: H }), H && (!((j = (O = P.cta) === null || O === void 0 ? void 0 : O.data) === null || j === void 0) && j.url) && r && r(P.cta.data.url), [2];
      });
    });
  }, notifications: m || [], onFetch: function() {
    return Qv(this, void 0, void 0, function() {
      return Kv(this, function(P) {
        switch (P.label) {
          case 0:
            return [4, w()];
          case 1:
            return P.sent(), [2];
        }
      });
    });
  }, hasNextPage: v }) : T.createElement(T.Fragment, null, s || T.createElement("div", { style: { textAlign: "center", minHeight: 350, display: "flex", alignItems: "center", justifyContent: "center" } }, T.createElement("img", { src: "data:image/png;base64,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", alt: "logo", style: { maxWidth: 200 } }))));
}
var vKe = $n(function(e, t, n) {
  var r, s, f, m, p, v, y, w, P, x, A, M = t.novuTheme, O = t.common, j = t.colorScheme, H = n("tabLabel"), J = n("tabIcon");
  return { tabsList: { gap: "30px", padding: "15px", paddingBottom: 0, borderBottom: "1px solid ".concat(j === "dark" ? tt.B20 : tt.B98) }, tab: (r = { display: "block", cursor: "pointer", borderBottom: "none", marginBottom: "0", padding: "0px", height: "36px" }, r[".mantine-Badge-root"] = { background: "transparent", border: "1px solid ".concat(tt.B60), color: tt.B60 }, r["&:hover"] = (s = { background: "none" }, s["& .".concat(J)] = { color: (m = M.header) === null || m === void 0 ? void 0 : m.fontColor }, s["& .".concat(H)] = { color: (p = M.header) === null || p === void 0 ? void 0 : p.fontColor }, s), r["&[data-active]"] = (f = { width: "auto" }, f[".mantine-Badge-root"] = { background: (v = M.header) === null || v === void 0 ? void 0 : v.badgeColor, border: "none", color: (y = M.header) === null || y === void 0 ? void 0 : y.badgeTextColor }, f["& .".concat(H)] = { color: (w = M.header) === null || w === void 0 ? void 0 : w.fontColor, "&::after": { content: '""', display: "block", height: "2px", background: ((P = M == null ? void 0 : M.header) === null || P === void 0 ? void 0 : P.tabBorderColor) || ((x = M.header) === null || x === void 0 ? void 0 : x.badgeColor), borderRadius: "10px" } }, f["& .".concat(J)] = { color: "red", background: (A = M.header) === null || A === void 0 ? void 0 : A.badgeColor, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }, f), r), tabLabel: { ref: H, fontFamily: O.fontFamily, fontSize: "14px", fontWeight: 700, color: tt.B60, textAlign: "left" }, tabIcon: { ref: J, display: "block", fontSize: "26px", fontWeight: 700, marginBottom: "5px", color: tt.B60, textAlign: "left" } };
});
function gKe(e) {
  var t = e.children, n = e.onTabChange, r = e.value, s = Fo(), f = s.theme, m = s.common, p = s.colorScheme, v = vKe({ novuTheme: f, common: m, colorScheme: p }).classes, y = Cn(_i(["tabs.tabsList", "tabs.tab", "tabs.tabLabel", "tabs.tabIcon"]), 4), w = y[0], P = y[1], x = y[2], A = y[3], M = { tabsList: hn(v.tabsList, mt(w)), tab: hn(v.tab, mt(P)), tabLabel: hn(v.tabLabel, mt(x)), tabIcon: hn(v.tabIcon, mt(A)) };
  return T.createElement(wd, { onTabChange: n, defaultValue: r, keepMounted: !1, variant: "default", classNames: M }, t);
}
function yKe() {
  var e = rp(), t = e.tabs, n = e.onTabClick, r = xc(), s = r.storeId, f = r.setStore, m = r.markAllNotificationsAsSeen, p = Xi().setFetchingStrategy;
  return F.exports.useLayoutEffect(function() {
    p({ fetchNotifications: !0 });
  }, [p]), T.createElement(T.Fragment, null, t != null && t.length ? T.createElement(gKe, { value: s, onTabChange: function(v) {
    return Qv(this, void 0, void 0, function() {
      return Kv(this, function(y) {
        return m(), f(v), [2];
      });
    });
  } }, T.createElement(wd.List, null, t.map(function(v, y) {
    return T.createElement(wd.Tab, { onClick: function() {
      n(v);
    }, key: y, "data-test-id": "tab-".concat(v.storeId), value: v.storeId }, T.createElement(bKe, null, v.name, T.createElement(wKe, { storeId: v.storeId })));
  })), t.map(function(v, y) {
    return T.createElement(wd.Panel, { value: v.storeId, key: y }, T.createElement(QT, null));
  })) : T.createElement(QT, null));
}
var KT, am, bKe = Mr.div(KT || (KT = Yt([`
  margin-bottom: 13px;
  min-height: 22px;
  line-height: 19px;
`], [`
  margin-bottom: 13px;
  min-height: 22px;
  line-height: 19px;
`])));
function wKe(e) {
  var t, n = e.storeId, r = xc().stores, s = F.exports.useMemo(function() {
    var p, v = ((p = r == null ? void 0 : r.find(function(y) {
      return y.storeId === n;
    })) === null || p === void 0 ? void 0 : p.query) || {};
    return Object.assign({}, v, { seen: !1 });
  }, [r]), f = YGe({ query: s }).data, m = s.seen ? 0 : (t = f == null ? void 0 : f.count) !== null && t !== void 0 ? t : 0;
  return T.createElement(JW, { unseenCount: m });
}
function PKe() {
  var e = rp().header, t = Xi().isSessionInitialized, n = Fo().theme, r = Cn(_i(["layout.root"]), 1)[0], s = Cn(F.exports.useState(am.NOTIFICATIONS), 2), f = s[0], m = s[1];
  return T.createElement("div", { className: hn("nc-layout-wrapper", kKe(n), mt(r)), "data-test-id": "layout-wrapper" }, f === am.SETTINGS && T.createElement(T.Fragment, null, e ? e({ setScreen: m }) : T.createElement(hQe, { onBackClick: function() {
    return m(am.NOTIFICATIONS);
  } }), T.createElement(n4, null, T.createElement(WQe, null))), f === am.NOTIFICATIONS && T.createElement(T.Fragment, null, e ? e({ setScreen: m }) : T.createElement(aQe, { onCogClick: function() {
    return m(am.SETTINGS);
  } }), T.createElement(n4, null, t ? T.createElement($Ke, { "data-test-id": "main-wrapper" }, T.createElement(yKe, null)) : T.createElement(Yw, null))), T.createElement(mQe, null));
}
(function(e) {
  e.NOTIFICATIONS = "notifications", e.SETTINGS = "settings";
})(am || (am = {}));
var JT, ZT, e4, t4, n4 = Mr.div(JT || (JT = Yt([`
  overflow: auto;
  min-height: 400px;
`], [`
  overflow: auto;
  min-height: 400px;
`]))), kKe = function(e) {
  return mt(ZT || (ZT = Yt([`
  padding: 15px 0;
  height: auto;
  border-radius: 7px;
  box-shadow: `, `;
  background: `, `;
`], [`
  padding: 15px 0;
  height: auto;
  border-radius: 7px;
  box-shadow: `, `;
  background: `, `;
`])), e.layout.boxShadow, e.layout.background);
}, $Ke = Mr.div(e4 || (e4 = Yt([""], [""])));
function SKe() {
  var e, t, n, r, s = Fo(), f = s.theme, m = s.common, p = YW().data, v = (t = (e = p == null ? void 0 : p.branding) === null || e === void 0 ? void 0 : e.color) !== null && t !== void 0 ? t : f.loaderColor, y = m.fontFamily || ((n = p == null ? void 0 : p.branding) === null || n === void 0 ? void 0 : n.fontFamily), w = ((r = p == null ? void 0 : p.branding) === null || r === void 0 ? void 0 : r.direction) === "rtl" ? "rtl" : "ltr", P = { fontFamily: y, dir: w };
  return T.createElement(_R, { theme: P }, T.createElement("div", { className: xKe(v, y, w) }, T.createElement(PKe, null)));
}
Mr.div(t4 || (t4 = Yt([`
  text-align: center;
  margin: 10px 0;
  font-size: 10px;
  color: #b1b1b1;
`], [`
  text-align: center;
  margin: 10px 0;
  font-size: 10px;
  color: #b1b1b1;
`])));
var r4, xKe = function(e, t, n) {
  return mt(r4 || (r4 = Yt([`
  margin: 0;
  font-family: `, `, Helvetica, sans-serif;
  color: #333737;
  direction: `, `;
  width: 420px;
  z-index: 999;

  ::-moz-selection {
    background: `, `;
  }

  *::selection {
    background: `, `;
  }
`], [`
  margin: 0;
  font-family: `, `, Helvetica, sans-serif;
  color: #333737;
  direction: `, `;
  width: 420px;
  z-index: 999;

  ::-moz-selection {
    background: `, `;
  }

  *::selection {
    background: `, `;
  }
`])), t, n, e, e);
};
function CKe(e) {
  var t = Sx({ colorScheme: e.colorScheme, theme: e.theme }), n = t.theme, r = t.common;
  return T.createElement(UW.Provider, { value: { colorScheme: e.colorScheme, theme: bt({}, n), common: bt({}, r) } }, e.children);
}
function e6(e) {
  var t = e.onUnseenCountChanged, n = e.onUrlChange, r = e.onNotificationClick, s = e.onActionClick, f = e.header, m = e.footer, p = e.emptyState, v = e.listItem, y = e.actionsResultBlock, w = e.tabs, P = e.showUserPreferences, x = e.allowedNotificationActions, A = e.onTabClick, M = e.colorScheme, O = e.theme, j = Xi().applicationIdentifier, H = xc().unseenCount, J = F.exports.useRef(t);
  return J.current = t, F.exports.useEffect(function() {
    J.current && J.current(H);
  }, [H, window.parentIFrame, J]), T.createElement($x.Provider, { value: { onUrlChange: n, onNotificationClick: r, onActionClick: s, isLoading: !j, header: f, footer: m, emptyState: p, listItem: v, actionsResultBlock: y, tabs: w, showUserPreferences: P == null || P, allowedNotificationActions: x == null || x, onTabClick: A || function() {
  } } }, T.createElement(CKe, { colorScheme: M, theme: O }, T.createElement(SKe, null)));
}
var MKe = [{ storeId: "default_store" }];
function EKe(e) {
  var t, n = e.children, r = e.stores, s = r === void 0 ? MKe : r, f = s[0], m = Cn(F.exports.useState(function() {
    var qe;
    return (qe = f.query) !== null && qe !== void 0 ? qe : {};
  }), 2), p = m[0], v = m[1], y = Cn(F.exports.useState((t = f.storeId) !== null && t !== void 0 ? t : "default_store"), 2), w = y[0], P = y[1], x = F.exports.useCallback(function(qe) {
    var ie, xe = ((ie = s == null ? void 0 : s.find(function(Ye) {
      return Ye.storeId === qe;
    })) === null || ie === void 0 ? void 0 : ie.query) || {};
    P(qe), v(xe);
  }, [s, P, v]), A = qGe({ query: p }), M = A.data, O = A.hasNextPage, j = A.isLoading, H = A.isFetching, J = A.isFetchingNextPage, V = A.fetchNextPage, X = A.refetch, U = HGe().data, K = QGe().markNotificationsAs, ce = KGe().removeNotification, ue = F.exports.useCallback(function(qe) {
    return K({ messageId: qe, seen: !0, read: !0 });
  }, [K]), ye = F.exports.useCallback(function(qe) {
    return K({ messageId: qe, seen: !0, read: !1 });
  }, [K]), Oe = F.exports.useCallback(function(qe) {
    return ce({ messageId: qe });
  }, [ce]), _e = F.exports.useCallback(function(qe) {
    return K({ messageId: qe, seen: !0, read: !1 });
  }, [K]), Le = F.exports.useCallback(function() {
    if (M) {
      var qe = M.pages.reduce(function(ie, xe) {
        var Ye = xe.data.filter(function(Be) {
          return !Be.read;
        }).map(function(Be) {
          return Be._id;
        });
        return Bs(Bs([], Cn(ie), !1), Cn(Ye), !1);
      }, []);
      qe.length > 0 && K({ messageId: qe, seen: !0, read: !0 });
    }
  }, [K, M]), Ne = F.exports.useCallback(function() {
    if (M) {
      var qe = M.pages.reduce(function(ie, xe) {
        var Ye = xe.data.filter(function(Be) {
          return !Be.seen && !Be.read;
        }).map(function(Be) {
          return Be._id;
        });
        return Bs(Bs([], Cn(ie), !1), Cn(Ye), !1);
      }, []);
      qe.length > 0 && K({ messageId: qe, seen: !0, read: !1 });
    }
  }, [K, M]), nt = F.exports.useMemo(function() {
    return M == null ? void 0 : M.pages.reduce(function(qe, ie) {
      return Bs(Bs([], Cn(qe), !1), Cn(ie.data), !1);
    }, []);
  }, [M]), Qe = F.exports.useMemo(function() {
    var qe;
    return { storeId: w, stores: s, unseenCount: (qe = U == null ? void 0 : U.count) !== null && qe !== void 0 ? qe : 0, notifications: nt, hasNextPage: O, isLoading: j, isFetching: H, isFetchingNextPage: J, setStore: x, fetchNextPage: V, refetch: X, markNotificationAsSeen: _e, markNotificationAsRead: ue, markNotificationAsUnRead: ye, markAllNotificationsAsRead: Le, markAllNotificationsAsSeen: Ne, removeMessage: Oe };
  }, [w, s, U == null ? void 0 : U.count, nt, O, j, H, J, x, V, X, _e, ue, ye, Le, Ne, Oe]);
  return T.createElement(BW.Provider, { value: Qe }, n);
}
var cS = "widget_user_auth_token", dS = typeof window < "u", fS = function(e) {
  dS && localStorage.removeItem(cS), e.disposeAuthorizationToken();
}, a4 = function(e) {
  var t = e.token, n = t === void 0 ? dS ? localStorage.getItem(cS) : null : t, r = e.apiService;
  n ? (dS && localStorage.setItem(cS, n), r.setAuthorizationToken(n)) : fS(r);
}, i4 = new ite({ defaultOptions: { queries: { refetchOnMount: !1, refetchOnWindowFocus: !1 } } }), o4 = { fetchUnseenCount: !0, fetchOrganization: !0, fetchNotifications: !1, fetchUserPreferences: !1 };
function t6(e) {
  var t = e.backendUrl, n = e.socketUrl, r = e.applicationIdentifier, s = e.subscriberId, f = e.subscriberHash, m = e.stores, p = e.i18n, v = e.styles, y = e.initialFetchingStrategy, w = y === void 0 ? o4 : y, P = e.children, x = e.onLoad, A = t ?? "https://api.novu.co", M = n ?? "https://ws.novu.co", O = m ?? [{ storeId: "default_store" }], j = Cn(F.exports.useState(bt(bt({}, o4), w)), 2), H = j[0], J = j[1], V = Cn(F.exports.useState(!1), 2), X = V[0], U = V[1], K = F.exports.useMemo(function() {
    i4.clear();
    var Qe = new JYe(A);
    return a4({ apiService: Qe }), Qe;
  }, [A]), ce = function(Qe) {
    var qe = Qe.socketUrl, ie = F.exports.useRef(null), xe = F.exports.useCallback(function() {
      ie.current && (ie.current.disconnect(), ie.current = null);
    }, [ie]), Ye = F.exports.useCallback(function(Be) {
      var Ce = Be.token;
      ie.current && xe(), Ce && (ie.current = t1(qe, { reconnectionDelayMax: 1e4, transports: ["websocket"], auth: { token: "".concat(Ce) } }), ie.current.on("connect_error", function(Ie) {
        console.error(Ie.message);
      }));
    }, [ie, xe]);
    return { socket: ie.current, initializeSocket: Ye, disconnectSocket: xe };
  }({ socketUrl: M }), ue = ce.socket, ye = ce.initializeSocket, Oe = ce.disconnectSocket, _e = F.exports.useCallback(function(Qe) {
    a4({ apiService: K, token: Qe.token }), ye(Qe), U(!0);
  }, [K, U, ye]), Le = F.exports.useCallback(function(Qe) {
    return J(function(qe) {
      return bt(bt({}, qe), Qe);
    });
  }, [J]), Ne = F.exports.useCallback(function() {
    fS(K), Oe(), U(!1);
  }, [fS, Oe, K]), nt = F.exports.useMemo(function() {
    return { backendUrl: A, socketUrl: M, applicationIdentifier: r, subscriberId: s, subscriberHash: f, isSessionInitialized: X, apiService: K, socket: ue, fetchingStrategy: H, setFetchingStrategy: Le, onLoad: x, logout: Ne };
  }, [A, M, r, s, f, X, K, ue, H, Le, x, Ne]);
  return F.exports.useEffect(function() {
    return Oe;
  }, [Oe]), T.createElement(dte, { client: i4 }, T.createElement(HW.Provider, { value: nt }, T.createElement(AKe, { onSuccess: _e }, T.createElement(EKe, { stores: O }, T.createElement(VGe, { i18n: p }, T.createElement(JGe, { styles: v }, P))))));
}
var AKe = function(e) {
  var t = e.children, n = e.onSuccess, r = Xi().onLoad;
  return function(s) {
    var f = s.onSuccess, m = Xi(), p = m.apiService, v = m.applicationIdentifier, y = m.subscriberId, w = m.subscriberHash;
    bg(Bs(Bs([], Cn(IGe), !1), [v, y, w], !1), function() {
      return p.initializeSession(v, y, w);
    }, { enabled: !!v && !!y, cacheTime: 1 / 0, staleTime: 1 / 0, onSuccess: f, onError: function(P) {
      console.error("Failed to initialize the session", P.message);
    } });
  }({ onSuccess: n }), YW({ onSuccess: function(s) {
    r == null || r({ organization: s });
  } }), F.exports.useEffect(function() {
    "parentIFrame" in window && window.parentIFrame.autoResize(!0);
  }, []), t;
}, _Ke = { color: tt.B60, width: 30, height: 30 };
function OKe(e) {
  var t = xc().unseenCount, n = xx({ bellColors: { unseenBadgeColor: e == null ? void 0 : e.unseenBadgeColor, unseenBadgeBackgroundColor: e == null ? void 0 : e.unseenBadgeBackgroundColor }, colorScheme: e == null ? void 0 : e.colorScheme }).bellColors, r = Cn(_i(["bellButton.root", "bellButton.dot"]), 2), s = r[0], f = r[1];
  return T.createElement(zw, { variant: "transparent", className: hn("nc-bell-button", mt(s)), "data-test-id": "notification-bell" }, T.createElement(KW, bt({}, _Ke)), t > 0 ? T.createElement(RKe, { bellColors: n, className: hn("nc-bell-button-dot", mt(f)) }) : null);
}
function TKe(e) {
  var t = e.bellColors, n = Us(e, ["bellColors"]);
  return T.createElement(QW, bt({}, n, { colors: t }));
}
var s4, RKe = Mr(TKe)(s4 || (s4 = Yt([`
  position: absolute;
  top: -3%;
  right: 10%;
  width: 12px;
  height: 12px;
`], [`
  position: absolute;
  top: -3%;
  right: 10%;
  width: 12px;
  height: 12px;
`])));
function DKe(e) {
  var t, n = e.children, r = e.bell, s = e.theme, f = e.offset, m = f === void 0 ? 0 : f, p = e.position, v = p === void 0 ? "bottom-end" : p, y = Cn(F.exports.useState(!1), 2), w = y[0], P = y[1], x = WKe((t = s.popover) === null || t === void 0 ? void 0 : t.arrowColor), A = x.cx, M = x.classes, O = Cn(_i(["popover.arrow", "popover.dropdown"]), 2), j = O[0], H = O[1], J = { arrow: A(M.arrow, mt(j)), dropdown: A(M.dropdown, mt(H)) }, V = xc().markAllNotificationsAsSeen;
  return T.createElement(pc, { opened: w, onClose: function() {
    P(!1), V();
  }, position: v, withArrow: !0, classNames: J, offset: m }, T.createElement(pc.Target, null, T.createElement(NKe, { onClick: function() {
    w && V(), P(!w);
  } }, " ", r({}))), T.createElement(pc.Dropdown, null, " ", n));
}
var l4, NKe = Mr.span(l4 || (l4 = Yt([""], [""]))), WKe = $n(function(e, t) {
  return { dropdown: { padding: "0px", backgroundColor: "transparent", border: "none" }, arrow: { background: t, backgroundColor: t, borderColor: t } };
});
function jKe(e) {
  var t = e.children, n = Us(e, ["children"]), r = Sx({ colorScheme: n.colorScheme, theme: n.theme }).theme, s = xc().unseenCount;
  return T.createElement(DKe, { theme: r, bell: function(f) {
    return t(bt(bt({}, f), { unseenCount: s, theme: r }));
  }, position: n.position, offset: n.offset }, T.createElement(e6, { onNotificationClick: n.onNotificationClick, onUrlChange: n.onUrlChange, header: n.header, footer: n.footer, colorScheme: n.colorScheme, theme: n.theme, emptyState: n.emptyState, onActionClick: n.onActionClick, actionsResultBlock: n.actionsResultBlock, listItem: n.listItem, tabs: n.tabs, showUserPreferences: n.showUserPreferences, allowedNotificationActions: n.allowedNotificationActions, onTabClick: n.onTabClick, onUnseenCountChanged: n.onUnseenCountChanged }));
}
var gw = Symbol.for("r2wc.reactRender"), u4 = Symbol.for("r2wc.shouldRender"), Lb = Symbol.for("r2wc.root"), zKe = typeof window > "u";
function mS(e) {
  return Array.isArray(e) && e.length === 1 ? e[0] : e;
}
function n6(e) {
  if (e.nodeType === Node.TEXT_NODE)
    return e.textContent.toString();
  var t = Array.from(e.childNodes).map(function(n) {
    var r, s;
    if (n.nodeType === Node.TEXT_NODE)
      return n.textContent.toString();
    var f = n.nodeName.split("").every(function(P) {
      return P.toUpperCase() === P;
    }) ? n.nodeName.toLowerCase() : n.nodeName, m = mS(n6(n)), p = {};
    try {
      for (var v = $F(n.attributes), y = v.next(); !y.done; y = v.next()) {
        var w = y.value;
        p[w.name] = w.value;
      }
    } catch (P) {
      r = { error: P };
    } finally {
      try {
        y && !y.done && (s = v.return) && s.call(v);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return T.createElement(f, p, m);
  });
  return mS(t);
}
var y$ = null, hS = function(e) {
  y$ && clearTimeout(y$), y$ = setTimeout(e, 0);
}, LKe = function(e, t, n) {
  Object.defineProperty(e, t, { enumerable: !0, get: function() {
    return n;
  }, set: function(r) {
    var s = this;
    n = r, hS(function() {
      return s[gw]();
    });
  } }), hS(function() {
    return e[gw]();
  });
};
function r6(e, t) {
  if (t === void 0 && (t = {}), !zKe) {
    var n = {}, r = {}, s = {};
    t.props || (t.props = e.propTypes ? Object.keys(e.propTypes) : []);
    var f = Array.isArray(t.props) ? t.props.slice() : Object.keys(t.props), m = Array.isArray(t.props);
    f.forEach(function(x) {
      var A;
      n[x] = m ? String : t.props[x], r[x] = ((A = x) === void 0 && (A = ""), A.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase()), s[r[x]] = x;
    });
    var p = { isConnected: "isConnected" in HTMLElement.prototype }, v = !1, y = function() {
      for (var x = [], A = 0; A < arguments.length; A++)
        x[A] = arguments[A];
      var M = Reflect.construct(HTMLElement, x, this.constructor);
      return typeof t.shadow == "string" ? M.attachShadow({ mode: t.shadow }) : t.shadow && (console.warn('Specifying the "shadow" option as a boolean is deprecated and will be removed in a future version.'), M.attachShadow({ mode: "open" })), M;
    }, w = Object.create(HTMLElement.prototype);
    w.constructor = y;
    var P = new Proxy(w, { has: function(x, A) {
      return A in n || A in w;
    }, set: function(x, A, M, O) {
      return v && (p[A] = !0), typeof A == "symbol" || p[A] || A in x ? Reflect.set(x, A, M, O) : (LKe(O, A, M), !0);
    }, getOwnPropertyDescriptor: function(x, A) {
      var M = Reflect.getOwnPropertyDescriptor(x, A);
      return M || (A in n ? { configurable: !0, enumerable: !0, writable: !0, value: void 0 } : void 0);
    } });
    return y.prototype = P, w.connectedCallback = function() {
      var x = this;
      this[u4] = !0, hS(function() {
        return x[gw]();
      });
    }, w.disconnectedCallback = function() {
      typeof Sv.createRoot == "function" ? this[Lb].unmount() : Sv.unmountComponentAtNode(this);
    }, w[gw] = function() {
      if (this[u4] === !0) {
        var x = {};
        Object.keys(this).forEach(function(j) {
          p[j] !== !1 && (x[j] = this[j]);
        }, this), v = !0;
        var A = t.shadow ? this.shadowRoot : this, M = mS(n6(this)), O = T.createElement(e, x, M);
        typeof Sv.createRoot == "function" ? (this[Lb] || (this[Lb] = Sv.createRoot(A)), this[Lb].render(O)) : Sv.render(O, A), v = !1;
      }
    }, y.observedAttributes = Object.keys(s), w.attributeChangedCallback = function(x, A, M) {
      var O = s[x] || x;
      switch (n[O]) {
        case "ref":
        case Function:
          if (!M && n[O] === "ref") {
            M = T.createRef();
            break;
          }
          typeof window < "u" ? M = window[M] || M : typeof global < "u" && (M = global[M] || M), typeof M == "function" && (M = M.bind(this));
          break;
        case Number:
          M = parseFloat(M);
          break;
        case Boolean:
          M = /^[ty1-9]/i.test(M);
          break;
        case Object:
        case Array:
          M = JSON.parse(M);
      }
      this[O] = M;
    }, y;
  }
}
var IKe = ["backendUrl", "socketUrl", "subscriberId", "applicationIdentifier", "subscriberHash", "stores", "tabs", "showUserPreferences", "allowedNotificationActions", "popover", "theme", "styles", "colorScheme", "i18n", "onLoad", "sessionLoaded", "onNotificationClick", "notificationClicked", "onUnseenCountChanged", "unseenCountChanged", "onActionClick", "actionClicked", "onTabClick", "tabClicked"], FKe = function(e) {
  var t = e.backendUrl, n = e.socketUrl, r = e.subscriberId, s = e.applicationIdentifier, f = e.subscriberHash, m = e.stores, p = e.tabs, v = e.showUserPreferences, y = e.allowedNotificationActions, w = e.popover, P = e.theme, x = e.styles, A = e.colorScheme, M = A === void 0 ? "dark" : A, O = e.i18n, j = e.sessionLoaded, H = e.onLoad, J = H === void 0 ? j : H, V = e.notificationClicked, X = e.onNotificationClick, U = X === void 0 ? V : X, K = e.unseenCountChanged, ce = e.onUnseenCountChanged, ue = ce === void 0 ? K : ce, ye = e.actionClicked, Oe = e.onActionClick, _e = Oe === void 0 ? ye : Oe, Le = e.tabClicked, Ne = e.onTabClick, nt = Ne === void 0 ? Le : Ne;
  return T.createElement(t6, { onLoad: J, stores: m, backendUrl: t, socketUrl: n, subscriberId: r, applicationIdentifier: s, subscriberHash: f, styles: x, i18n: O }, T.createElement(HKe, { onNotificationClick: U, onUnseenCountChanged: ue, onActionClick: _e, onTabClick: nt, colorScheme: M, theme: P, tabs: p, showUserPreferences: v, allowedNotificationActions: y, popover: w }));
};
function HKe(e) {
  var t = e.onNotificationClick, n = e.onUnseenCountChanged, r = e.onActionClick, s = e.onTabClick, f = e.colorScheme, m = f === void 0 ? "dark" : f, p = e.theme, v = e.tabs, y = e.showUserPreferences, w = e.allowedNotificationActions, P = e.popover, x = e.unseenBadgeColor, A = e.unseenBadgeBackgroundColor, M = UGe().updateAction;
  return T.createElement(jKe, { onNotificationClick: t, onUnseenCountChanged: n, onActionClick: function(O, j, H) {
    M({ messageId: H._id, actionButtonType: j, status: qv.DONE }), r == null || r(O, j, H);
  }, onTabClick: s, colorScheme: m, theme: p, tabs: v, showUserPreferences: y, allowedNotificationActions: w, offset: P == null ? void 0 : P.offset, position: P == null ? void 0 : P.position }, function(O) {
    var j = O.unseenCount;
    return T.createElement(OKe, { colorScheme: m, unseenCount: j, unseenBadgeColor: x, unseenBadgeBackgroundColor: A });
  });
}
r6(FKe, { props: IKe });
var VKe = ["backendUrl", "socketUrl", "subscriberId", "applicationIdentifier", "subscriberHash", "stores", "tabs", "showUserPreferences", "allowedNotificationActions", "theme", "styles", "colorScheme", "i18n", "onLoad", "sessionLoaded", "onNotificationClick", "notificationClicked", "onUnseenCountChanged", "unseenCountChanged", "onActionClick", "actionClicked", "onTabClick", "tabClicked"], BKe = function(e) {
  var t = e.backendUrl, n = e.socketUrl, r = e.subscriberId, s = e.applicationIdentifier, f = e.subscriberHash, m = e.stores, p = e.tabs, v = e.showUserPreferences, y = e.allowedNotificationActions, w = e.theme, P = e.styles, x = e.colorScheme, A = x === void 0 ? "dark" : x, M = e.i18n, O = e.sessionLoaded, j = e.onLoad, H = j === void 0 ? O : j, J = e.notificationClicked, V = e.onNotificationClick, X = V === void 0 ? J : V, U = e.unseenCountChanged, K = e.onUnseenCountChanged, ce = K === void 0 ? U : K, ue = e.actionClicked, ye = e.onActionClick, Oe = ye === void 0 ? ue : ye, _e = e.tabClicked, Le = e.onTabClick, Ne = Le === void 0 ? _e : Le;
  return T.createElement(t6, { onLoad: H, stores: m, backendUrl: t, socketUrl: n, subscriberId: r, applicationIdentifier: s, subscriberHash: f, styles: P, i18n: M }, T.createElement(e6, { onNotificationClick: X, onUnseenCountChanged: ce, colorScheme: A, theme: w, onActionClick: Oe, tabs: p, showUserPreferences: v, allowedNotificationActions: y, onTabClick: Ne }));
}, UKe = r6(BKe, { props: VKe });
const XKe = ["color"], qKe = /* @__PURE__ */ go("path", {
  d: "M21.6667 10.8C21.6667 8.99653 20.9643 7.26692 19.714 5.99167C18.4638 4.71643 16.7681 4 15 4C13.2319 4 11.5362 4.71643 10.286 5.99167C9.03571 7.26692 8.33333 8.99653 8.33333 10.8C8.33333 18.7333 5 21 5 21H25C25 21 21.6667 18.7333 21.6667 10.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), YKe = /* @__PURE__ */ go("path", {
  d: "M17.7295 24C17.4521 24.6072 17.0539 25.1113 16.5748 25.4617C16.0956 25.812 15.5524 25.9965 14.9995 25.9965C14.4466 25.9965 13.9034 25.812 13.4243 25.4617C12.9452 25.1113 12.547 24.6072 12.2695 24",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GKe = [
  qKe,
  YKe
], QKe = ["stroke"], KKe = {
  id: "paint0_linear_1722_2699",
  x1: "8",
  y1: "13",
  x2: "8",
  y2: "3",
  gradientUnits: "userSpaceOnUse"
}, JKe = ["stop-color"], ZKe = ["stop-color"], eJe = /* @__PURE__ */ wc({
  __name: "BellButton",
  props: {
    unseenCount: null,
    bellButtonClass: null,
    gradientDotClass: null,
    colors: null
  },
  setup(e) {
    const t = e, { colors: n } = t, r = om(n.unseenBadgeColor), s = w$(() => typeof r.value == "string"), f = w$(() => ({
      stopColor: s.value ? r.value : r.value.stopColor,
      offsetStopColor: s.value ? r.value : r.value.stopColorOffset
    }));
    return (m, p) => (zo(), yd("button", {
      class: Fh(["nc-bell-button", e.bellButtonClass])
    }, [
      (zo(), yd("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: vd(tt).B60
      }, GKe, 8, XKe)),
      e.unseenCount && e.unseenCount > 0 ? (zo(), yd("svg", {
        key: 0,
        class: Fh(["nc-bell-button-dot", e.gradientDotClass]),
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
      }, [
        go("rect", {
          x: "1.5",
          y: "1.5",
          width: "13",
          height: "13",
          rx: "6.5",
          fill: "url(#paint0_linear_1722_2699)",
          stroke: vd(n).unseenBadgeBackgroundColor,
          "stroke-width": "3"
        }, null, 8, QKe),
        go("defs", null, [
          go("linearGradient", KKe, [
            go("stop", {
              "stop-color": vd(f).stopColor
            }, null, 8, JKe),
            go("stop", {
              offset: "1",
              "stop-color": vd(f).offsetStopColor
            }, null, 8, ZKe)
          ])
        ])
      ], 2)) : b$("", !0)
    ], 2));
  }
});
function c4(e, t) {
  if (e.inserted[t.name] === void 0)
    return e.insert("", t, e.sheet, !0);
}
function d4(e, t, n) {
  var r = [], s = cm(e, r, n);
  return r.length < 2 ? n : s + t(r);
}
var tJe = function(t) {
  var n = Rw(t);
  n.sheet.speedy = function(p) {
    if (process.env.NODE_ENV !== "production" && this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = p;
  }, n.compat = !0;
  var r = function() {
    for (var v = arguments.length, y = new Array(v), w = 0; w < v; w++)
      y[w] = arguments[w];
    var P = kl(y, n.registered, void 0);
    return Kh(n, P, !1), n.key + "-" + P.name;
  }, s = function() {
    for (var v = arguments.length, y = new Array(v), w = 0; w < v; w++)
      y[w] = arguments[w];
    var P = kl(y, n.registered), x = "animation-" + P.name;
    return c4(n, {
      name: P.name,
      styles: "@keyframes " + x + "{" + P.styles + "}"
    }), x;
  }, f = function() {
    for (var v = arguments.length, y = new Array(v), w = 0; w < v; w++)
      y[w] = arguments[w];
    var P = kl(y, n.registered);
    c4(n, P);
  }, m = function() {
    for (var v = arguments.length, y = new Array(v), w = 0; w < v; w++)
      y[w] = arguments[w];
    return d4(n.registered, r, nJe(y));
  };
  return {
    css: r,
    cx: m,
    injectGlobal: f,
    keyframes: s,
    hydrate: function(v) {
      v.forEach(function(y) {
        n.inserted[y] = !0;
      });
    },
    flush: function() {
      n.registered = {}, n.inserted = {}, n.sheet.flush();
    },
    sheet: n.sheet,
    cache: n,
    getRegisteredStyles: cm.bind(null, n.registered),
    merge: d4.bind(null, n.registered, r)
  };
}, nJe = function e(t) {
  for (var n = "", r = 0; r < t.length; r++) {
    var s = t[r];
    if (s != null) {
      var f = void 0;
      switch (typeof s) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(s))
            f = e(s);
          else {
            f = "";
            for (var m in s)
              s[m] && m && (f && (f += " "), f += m);
          }
          break;
        }
        default:
          f = s;
      }
      f && (n && (n += " "), n += f);
    }
  }
  return n;
}, rJe = tJe({
  key: "css"
}), Ib = rJe.css;
const aJe = ({
  styles: e,
  theme: t,
  colorScheme: n
}) => {
  const { theme: r, common: s } = Sx({
    colorScheme: n,
    theme: t
  }), { bellColors: f } = xx({
    colorScheme: n,
    bellColors: {}
  });
  return {
    popoverArrowClass: Ib(
      Nh({
        styles: e,
        path: "popover.arrow",
        theme: r,
        common: s,
        colorScheme: n
      })
    ),
    popoverDropdownClass: Ib(
      Nh({
        styles: e,
        path: "popover.dropdown",
        theme: r,
        common: s,
        colorScheme: n
      })
    ),
    bellButtonClass: Ib(
      Nh({
        styles: e,
        path: "bellButton.root",
        theme: r,
        common: s,
        colorScheme: n
      })
    ),
    gradientDotClass: Ib(
      Nh({
        styles: e,
        path: "bellButton.dot",
        theme: r,
        common: s,
        colorScheme: n
      })
    ),
    bellColors: f
  };
}, iJe = ["backendUrl", "socketUrl", "subscriberId", "applicationIdentifier", "subscriberHash", "stores", "tabs", "showUserPreferences", "allowedNotificationActions", "theme", "styles", "colorScheme", "i18n", "sessionLoaded", "notificationClicked", "unseenCountChanged", "actionClicked", "tabClicked"], oJe = /* @__PURE__ */ wc({
  __name: "NotificationCenterComponent",
  props: {
    backendUrl: null,
    socketUrl: null,
    subscriberId: null,
    applicationIdentifier: null,
    subscriberHash: null,
    stores: null,
    tabs: null,
    showUserPreferences: null,
    allowedNotificationActions: null,
    popover: null,
    theme: null,
    styles: null,
    colorScheme: { default: "dark" },
    i18n: null,
    sessionLoaded: null,
    notificationClicked: null,
    unseenCountChanged: null,
    actionClicked: null,
    tabClicked: null
  },
  setup(e) {
    const t = e, n = s9(), r = om(), s = om(void 0), f = om(!!n.default), m = w$(() => {
      const { popoverArrowClass: v, popoverDropdownClass: y, bellButtonClass: w, gradientDotClass: P, bellColors: x } = aJe({
        theme: t.theme,
        styles: t.styles,
        colorScheme: t.colorScheme
      });
      return {
        popoverArrowClass: v,
        popoverDropdownClass: y,
        bellButtonClass: w,
        gradientDotClass: P,
        bellColors: x
      };
    }), p = (v) => {
      const y = ["v-popper__arrow-outer", "v-popper__arrow-inner"];
      r.value.$refs.popper.$_arrowNode.childNodes.forEach((P, x) => {
        P.className = "", P.classList.add(y[x], v);
      });
    };
    return l9(() => {
      p(m.value.popoverArrowClass), document.addEventListener("novu:unseen_count_changed", (v) => {
        s.value = v.detail;
      });
    }), u9(m, (v) => {
      p(v.popoverArrowClass);
    }), (v, y) => {
      var P, x;
      const w = Hh("VDropdown");
      return zo(), Ih(w, {
        theme: e.colorScheme,
        popperClass: vd(m).popoverDropdownClass,
        placement: (P = e.popover) == null ? void 0 : P.position,
        distance: (x = e.popover) == null ? void 0 : x.offset,
        triggers: ["click", "touch"],
        "eager-mount": "",
        ref_key: "popper",
        ref: r
      }, {
        popper: Vh(() => [
          go("notification-center-content-component", {
            backendUrl: e.backendUrl,
            socketUrl: e.socketUrl,
            subscriberId: e.subscriberId,
            applicationIdentifier: e.applicationIdentifier,
            subscriberHash: e.subscriberHash,
            stores: e.stores,
            tabs: e.tabs,
            showUserPreferences: e.showUserPreferences,
            allowedNotificationActions: e.allowedNotificationActions,
            theme: e.theme,
            styles: e.styles,
            colorScheme: e.colorScheme,
            i18n: e.i18n,
            sessionLoaded: e.sessionLoaded,
            notificationClicked: e.notificationClicked,
            unseenCountChanged: e.unseenCountChanged,
            actionClicked: e.actionClicked,
            tabClicked: e.tabClicked
          }, null, 8, iJe)
        ]),
        default: Vh(() => [
          f.value ? Bv(v.$slots, "default", m4({ key: 0 }, s.value, { unseenCount: s.value })) : (zo(), Ih(eJe, {
            key: 1,
            bellButtonClass: vd(m).bellButtonClass,
            gradientDotClass: vd(m).gradientDotClass,
            unseenCount: s.value,
            colors: vd(m).bellColors
          }, null, 8, ["bellButtonClass", "gradientDotClass", "unseenCount", "colors"]))
        ]),
        _: 3
      }, 8, ["theme", "popperClass", "placement", "distance"]);
    };
  }
});
const sJe = 24 * 60 * 60 * 1e3, dJe = {
  install(e) {
    customElements.define("notification-center-content-component", UKe), e.use(_L, {
      disposeTimeout: sJe,
      themes: {
        dark: {
          $extend: "dropdown",
          distance: 10
        },
        light: {
          $extend: "dropdown",
          distance: 10
        }
      }
    }), e.component("NotificationCenterComponent", oJe);
  }
};
export {
  oJe as NotificationCenterComponent,
  dJe as default
};
